(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$extendImportMap(map) {
  Object.assign(parcelRequire.i ??= {}, map);
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$bundleURL;
function $parcel$resolve(url) {
  url = parcelRequire.i?.[url] || url;
  if (!$parcel$bundleURL) {
    try {
      throw new Error();
    } catch (err) {
      var matches = ('' + err.stack).match(
        /(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g,
      );
      if (matches) {
        $parcel$bundleURL = matches[0];
      } else {
        return $parcel$distDir + url;
      }
    }
  }
  return new URL($parcel$distDir + url, $parcel$bundleURL).toString();
}
var $parcel$distDir = "./";

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire130b"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire130b"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("dXF9p", function(module, exports) {

$parcel$export(module.exports, "createRoot", function () { return $a2a0b4ba09a5a00a$export$882461b6382ed46c; }, function (v) { return $a2a0b4ba09a5a00a$export$882461b6382ed46c = v; });
$parcel$export(module.exports, "hydrateRoot", function () { return $a2a0b4ba09a5a00a$export$757ceba2d55c277e; }, function (v) { return $a2a0b4ba09a5a00a$export$757ceba2d55c277e = v; });
$parcel$export(module.exports, "version", function () { return $a2a0b4ba09a5a00a$export$83d89fbfd8236492; }, function (v) { return $a2a0b4ba09a5a00a$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ 
var $2bfPH = parcelRequire("2bfPH");
var $a2a0b4ba09a5a00a$export$882461b6382ed46c;
var $a2a0b4ba09a5a00a$export$757ceba2d55c277e;
var $a2a0b4ba09a5a00a$export$83d89fbfd8236492;
"use strict";

var $5t8wa = parcelRequire("5t8wa");

var $eHaBZ = parcelRequire("eHaBZ");

var $bVPm2 = parcelRequire("bVPm2");
function $a2a0b4ba09a5a00a$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $a2a0b4ba09a5a00a$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $a2a0b4ba09a5a00a$var$getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for(; node.return;)node = node.return;
    else {
        fiber = node;
        do node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
}
function $a2a0b4ba09a5a00a$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$assertIsMounted(fiber) {
    if ($a2a0b4ba09a5a00a$var$getNearestMountedFiber(fiber) !== fiber) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(188));
}
function $a2a0b4ba09a5a00a$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $a2a0b4ba09a5a00a$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $a2a0b4ba09a5a00a$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $a2a0b4ba09a5a00a$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $a2a0b4ba09a5a00a$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $a2a0b4ba09a5a00a$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
var $a2a0b4ba09a5a00a$var$assign = Object.assign, $a2a0b4ba09a5a00a$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $a2a0b4ba09a5a00a$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $a2a0b4ba09a5a00a$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $a2a0b4ba09a5a00a$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $a2a0b4ba09a5a00a$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $a2a0b4ba09a5a00a$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $a2a0b4ba09a5a00a$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $a2a0b4ba09a5a00a$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity");
Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $a2a0b4ba09a5a00a$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel");
Symbol.for("react.view_transition");
var $a2a0b4ba09a5a00a$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $a2a0b4ba09a5a00a$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $2bfPH._)(maybeIterable))) return null;
    maybeIterable = $a2a0b4ba09a5a00a$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$a2a0b4ba09a5a00a$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $a2a0b4ba09a5a00a$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $a2a0b4ba09a5a00a$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $a2a0b4ba09a5a00a$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $a2a0b4ba09a5a00a$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $a2a0b4ba09a5a00a$var$REACT_ACTIVITY_TYPE:
            return "Activity";
    }
    if ("object" === (typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type))) switch(type.$$typeof){
        case $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $a2a0b4ba09a5a00a$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $a2a0b4ba09a5a00a$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $a2a0b4ba09a5a00a$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $a2a0b4ba09a5a00a$var$getComponentNameFromType(type.type) || "Memo";
        case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $a2a0b4ba09a5a00a$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $a2a0b4ba09a5a00a$var$isArrayImpl = Array.isArray, $a2a0b4ba09a5a00a$var$ReactSharedInternals = $eHaBZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals = $bVPm2.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $a2a0b4ba09a5a00a$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $a2a0b4ba09a5a00a$var$valueStack = [], $a2a0b4ba09a5a00a$var$index = -1;
function $a2a0b4ba09a5a00a$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $a2a0b4ba09a5a00a$var$pop(cursor) {
    0 > $a2a0b4ba09a5a00a$var$index || (cursor.current = $a2a0b4ba09a5a00a$var$valueStack[$a2a0b4ba09a5a00a$var$index], $a2a0b4ba09a5a00a$var$valueStack[$a2a0b4ba09a5a00a$var$index] = null, $a2a0b4ba09a5a00a$var$index--);
}
function $a2a0b4ba09a5a00a$var$push(cursor, value) {
    $a2a0b4ba09a5a00a$var$index++;
    $a2a0b4ba09a5a00a$var$valueStack[$a2a0b4ba09a5a00a$var$index] = cursor.current;
    cursor.current = value;
}
var $a2a0b4ba09a5a00a$var$contextStackCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$contextFiberStackCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$rootInstanceStackCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$hostTransitionProviderCursor = $a2a0b4ba09a5a00a$var$createCursor(null);
function $a2a0b4ba09a5a00a$var$pushHostContainer(fiber, nextRootInstance) {
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$rootInstanceStackCursor, nextRootInstance);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$contextFiberStackCursor, fiber);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $a2a0b4ba09a5a00a$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $a2a0b4ba09a5a00a$var$getOwnHostContext(nextRootInstance), fiber = $a2a0b4ba09a5a00a$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$contextStackCursor);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$contextStackCursor, fiber);
}
function $a2a0b4ba09a5a00a$var$popHostContainer() {
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$contextStackCursor);
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$contextFiberStackCursor);
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$rootInstanceStackCursor);
}
function $a2a0b4ba09a5a00a$var$pushHostContext(fiber) {
    null !== fiber.memoizedState && $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$hostTransitionProviderCursor, fiber);
    var context = $a2a0b4ba09a5a00a$var$contextStackCursor.current;
    var JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && ($a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$contextFiberStackCursor, fiber), $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$contextStackCursor, JSCompiler_inline_result));
}
function $a2a0b4ba09a5a00a$var$popHostContext(fiber) {
    $a2a0b4ba09a5a00a$var$contextFiberStackCursor.current === fiber && ($a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$contextStackCursor), $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$contextFiberStackCursor));
    $a2a0b4ba09a5a00a$var$hostTransitionProviderCursor.current === fiber && ($a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$hostTransitionProviderCursor), $a2a0b4ba09a5a00a$var$HostTransitionContext._currentValue = $a2a0b4ba09a5a00a$var$sharedNotPendingObject);
}
var $a2a0b4ba09a5a00a$var$prefix, $a2a0b4ba09a5a00a$var$suffix;
function $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $a2a0b4ba09a5a00a$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $a2a0b4ba09a5a00a$var$prefix = match && match[1] || "";
        $a2a0b4ba09a5a00a$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $a2a0b4ba09a5a00a$var$prefix + name + $a2a0b4ba09a5a00a$var$suffix;
}
var $a2a0b4ba09a5a00a$var$reentry = !1;
function $a2a0b4ba09a5a00a$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $a2a0b4ba09a5a00a$var$reentry) return "";
    $a2a0b4ba09a5a00a$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function DetermineComponentFrameRoot() {
                try {
                    if (construct) {
                        var Fake = function Fake() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function set() {
                                throw Error();
                            }
                        });
                        if ("object" === (typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            fn.call(Fake.prototype);
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $a2a0b4ba09a5a00a$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $a2a0b4ba09a5a00a$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame("Suspense Fallback") : $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $a2a0b4ba09a5a00a$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $a2a0b4ba09a5a00a$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $a2a0b4ba09a5a00a$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $a2a0b4ba09a5a00a$var$describeBuiltInComponentFrame("Activity");
        default:
            return "";
    }
}
function $a2a0b4ba09a5a00a$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $a2a0b4ba09a5a00a$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $a2a0b4ba09a5a00a$var$hasOwnProperty = Object.prototype.hasOwnProperty, $a2a0b4ba09a5a00a$var$scheduleCallback$3 = $5t8wa.unstable_scheduleCallback, $a2a0b4ba09a5a00a$var$cancelCallback$1 = $5t8wa.unstable_cancelCallback, $a2a0b4ba09a5a00a$var$shouldYield = $5t8wa.unstable_shouldYield, $a2a0b4ba09a5a00a$var$requestPaint = $5t8wa.unstable_requestPaint, $a2a0b4ba09a5a00a$var$now = $5t8wa.unstable_now, $a2a0b4ba09a5a00a$var$getCurrentPriorityLevel = $5t8wa.unstable_getCurrentPriorityLevel, $a2a0b4ba09a5a00a$var$ImmediatePriority = $5t8wa.unstable_ImmediatePriority, $a2a0b4ba09a5a00a$var$UserBlockingPriority = $5t8wa.unstable_UserBlockingPriority, $a2a0b4ba09a5a00a$var$NormalPriority$1 = $5t8wa.unstable_NormalPriority, $a2a0b4ba09a5a00a$var$LowPriority = $5t8wa.unstable_LowPriority, $a2a0b4ba09a5a00a$var$IdlePriority = $5t8wa.unstable_IdlePriority, $a2a0b4ba09a5a00a$var$log$1 = $5t8wa.log, $a2a0b4ba09a5a00a$var$unstable_setDisableYieldValue = $5t8wa.unstable_setDisableYieldValue, $a2a0b4ba09a5a00a$var$rendererID = null, $a2a0b4ba09a5a00a$var$injectedHook = null;
function $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $a2a0b4ba09a5a00a$var$log$1 && $a2a0b4ba09a5a00a$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($a2a0b4ba09a5a00a$var$injectedHook && "function" === typeof $a2a0b4ba09a5a00a$var$injectedHook.setStrictMode) try {
        $a2a0b4ba09a5a00a$var$injectedHook.setStrictMode($a2a0b4ba09a5a00a$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $a2a0b4ba09a5a00a$var$clz32 = Math.clz32 ? Math.clz32 : $a2a0b4ba09a5a00a$var$clz32Fallback, $a2a0b4ba09a5a00a$var$log = Math.log, $a2a0b4ba09a5a00a$var$LN2 = Math.LN2;
function $a2a0b4ba09a5a00a$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($a2a0b4ba09a5a00a$var$log(x) / $a2a0b4ba09a5a00a$var$LN2 | 0) | 0;
}
var $a2a0b4ba09a5a00a$var$nextTransitionUpdateLane = 256, $a2a0b4ba09a5a00a$var$nextTransitionDeferredLane = 262144, $a2a0b4ba09a5a00a$var$nextRetryLane = 4194304;
function $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $a2a0b4ba09a5a00a$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $a2a0b4ba09a5a00a$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $a2a0b4ba09a5a00a$var$claimNextRetryLane() {
    var lane = $a2a0b4ba09a5a00a$var$nextRetryLane;
    $a2a0b4ba09a5a00a$var$nextRetryLane <<= 1;
    0 === ($a2a0b4ba09a5a00a$var$nextRetryLane & 62914560) && ($a2a0b4ba09a5a00a$var$nextRetryLane = 4194304);
    return lane;
}
function $a2a0b4ba09a5a00a$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $a2a0b4ba09a5a00a$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $a2a0b4ba09a5a00a$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $a2a0b4ba09a5a00a$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $a2a0b4ba09a5a00a$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $a2a0b4ba09a5a00a$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $a2a0b4ba09a5a00a$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $a2a0b4ba09a5a00a$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $a2a0b4ba09a5a00a$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $a2a0b4ba09a5a00a$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $a2a0b4ba09a5a00a$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $a2a0b4ba09a5a00a$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $a2a0b4ba09a5a00a$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $a2a0b4ba09a5a00a$var$resolveUpdatePriority() {
    var updatePriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $a2a0b4ba09a5a00a$var$getEventPriority(updatePriority.type);
}
function $a2a0b4ba09a5a00a$var$runWithPriority(priority, fn) {
    var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    try {
        return $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $a2a0b4ba09a5a00a$var$randomKey = Math.random().toString(36).slice(2), $a2a0b4ba09a5a00a$var$internalInstanceKey = "__reactFiber$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalPropsKey = "__reactProps$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalContainerInstanceKey = "__reactContainer$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalEventHandlersKey = "__reactEvents$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalEventHandlerListenersKey = "__reactListeners$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalEventHandlesSetKey = "__reactHandles$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalRootNodeResourcesKey = "__reactResources$" + $a2a0b4ba09a5a00a$var$randomKey, $a2a0b4ba09a5a00a$var$internalHoistableMarker = "__reactMarker$" + $a2a0b4ba09a5a00a$var$randomKey;
function $a2a0b4ba09a5a00a$var$detachDeletedInstance(node) {
    delete node[$a2a0b4ba09a5a00a$var$internalInstanceKey];
    delete node[$a2a0b4ba09a5a00a$var$internalPropsKey];
    delete node[$a2a0b4ba09a5a00a$var$internalEventHandlersKey];
    delete node[$a2a0b4ba09a5a00a$var$internalEventHandlerListenersKey];
    delete node[$a2a0b4ba09a5a00a$var$internalEventHandlesSetKey];
}
function $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[$a2a0b4ba09a5a00a$var$internalInstanceKey];
    if (targetInst) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey] || parentNode[$a2a0b4ba09a5a00a$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $a2a0b4ba09a5a00a$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$a2a0b4ba09a5a00a$var$internalInstanceKey]) return parentNode;
                targetNode = $a2a0b4ba09a5a00a$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$getInstanceFromNode(node) {
    if (node = node[$a2a0b4ba09a5a00a$var$internalInstanceKey] || node[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(33));
}
function $a2a0b4ba09a5a00a$var$getResourcesFromRoot(root) {
    var resources = root[$a2a0b4ba09a5a00a$var$internalRootNodeResourcesKey];
    resources || (resources = root[$a2a0b4ba09a5a00a$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $a2a0b4ba09a5a00a$var$markNodeAsHoistable(node) {
    node[$a2a0b4ba09a5a00a$var$internalHoistableMarker] = !0;
}
var $a2a0b4ba09a5a00a$var$allNativeEvents = new Set(), $a2a0b4ba09a5a00a$var$registrationNameDependencies = {};
function $a2a0b4ba09a5a00a$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $a2a0b4ba09a5a00a$var$registerDirectEvent(registrationName, dependencies);
    $a2a0b4ba09a5a00a$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $a2a0b4ba09a5a00a$var$registerDirectEvent(registrationName, dependencies) {
    $a2a0b4ba09a5a00a$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$a2a0b4ba09a5a00a$var$allNativeEvents.add(dependencies[registrationName]);
}
var $a2a0b4ba09a5a00a$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $a2a0b4ba09a5a00a$var$illegalAttributeNameCache = {}, $a2a0b4ba09a5a00a$var$validatedAttributeNameCache = {};
function $a2a0b4ba09a5a00a$var$isAttributeNameSafe(attributeName) {
    if ($a2a0b4ba09a5a00a$var$hasOwnProperty.call($a2a0b4ba09a5a00a$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($a2a0b4ba09a5a00a$var$hasOwnProperty.call($a2a0b4ba09a5a00a$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($a2a0b4ba09a5a00a$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $a2a0b4ba09a5a00a$var$validatedAttributeNameCache[attributeName] = !0;
    $a2a0b4ba09a5a00a$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
function $a2a0b4ba09a5a00a$var$setValueForAttribute(node, name, value) {
    if ($a2a0b4ba09a5a00a$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, "" + value);
        }
    }
}
function $a2a0b4ba09a5a00a$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, "" + value);
    }
}
function $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, "" + value);
    }
}
function $a2a0b4ba09a5a00a$var$getToStringValue(value) {
    switch(typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $a2a0b4ba09a5a00a$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $a2a0b4ba09a5a00a$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function get1() {
                return get.call(this);
            },
            set: function set1(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function getValue() {
                return currentValue;
            },
            setValue: function setValue(value) {
                currentValue = "" + value;
            },
            stopTracking: function stopTracking() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $a2a0b4ba09a5a00a$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $a2a0b4ba09a5a00a$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $a2a0b4ba09a5a00a$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $a2a0b4ba09a5a00a$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $a2a0b4ba09a5a00a$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
function $a2a0b4ba09a5a00a$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e) {
        return doc.body;
    }
}
var $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $a2a0b4ba09a5a00a$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type)) && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $a2a0b4ba09a5a00a$var$getToStringValue(value);
        } else element.value !== "" + $a2a0b4ba09a5a00a$var$getToStringValue(value) && (element.value = "" + $a2a0b4ba09a5a00a$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? $a2a0b4ba09a5a00a$var$setDefaultValue(element, type, $a2a0b4ba09a5a00a$var$getToStringValue(value)) : null != defaultValue ? $a2a0b4ba09a5a00a$var$setDefaultValue(element, type, $a2a0b4ba09a5a00a$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $2bfPH._)(checked)));
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) && "boolean" !== typeof name ? element.name = "" + $a2a0b4ba09a5a00a$var$getToStringValue(name) : element.removeAttribute("name");
}
function $a2a0b4ba09a5a00a$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== (typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type)) && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $a2a0b4ba09a5a00a$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $a2a0b4ba09a5a00a$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $a2a0b4ba09a5a00a$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== (typeof checked === "undefined" ? "undefined" : (0, $2bfPH._)(checked)) && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== (typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) && "boolean" !== typeof name && (element.name = name);
    $a2a0b4ba09a5a00a$var$track(element);
}
function $a2a0b4ba09a5a00a$var$setDefaultValue(node, type, value) {
    "number" === type && $a2a0b4ba09a5a00a$var$getActiveElement(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
}
function $a2a0b4ba09a5a00a$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $a2a0b4ba09a5a00a$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $a2a0b4ba09a5a00a$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $a2a0b4ba09a5a00a$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $a2a0b4ba09a5a00a$var$getToStringValue(defaultValue) : "";
}
function $a2a0b4ba09a5a00a$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(92));
            if ($a2a0b4ba09a5a00a$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $a2a0b4ba09a5a00a$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $a2a0b4ba09a5a00a$var$track(element);
}
function $a2a0b4ba09a5a00a$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $a2a0b4ba09a5a00a$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $a2a0b4ba09a5a00a$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $a2a0b4ba09a5a00a$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $a2a0b4ba09a5a00a$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== (typeof styles === "undefined" ? "undefined" : (0, $2bfPH._)(styles))) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && $a2a0b4ba09a5a00a$var$setValueForStyle(node, styleName$16, styleName);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $a2a0b4ba09a5a00a$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $a2a0b4ba09a5a00a$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $a2a0b4ba09a5a00a$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $a2a0b4ba09a5a00a$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $a2a0b4ba09a5a00a$var$sanitizeURL(url) {
    return $a2a0b4ba09a5a00a$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $a2a0b4ba09a5a00a$var$noop$1() {}
var $a2a0b4ba09a5a00a$var$currentReplayingEvent = null;
function $a2a0b4ba09a5a00a$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $a2a0b4ba09a5a00a$var$restoreTarget = null, $a2a0b4ba09a5a00a$var$restoreQueue = null;
function $a2a0b4ba09a5a00a$var$restoreStateOfTarget(target) {
    var internalInstance = $a2a0b4ba09a5a00a$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$a2a0b4ba09a5a00a$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $a2a0b4ba09a5a00a$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$a2a0b4ba09a5a00a$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(90));
                            $a2a0b4ba09a5a00a$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $a2a0b4ba09a5a00a$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $a2a0b4ba09a5a00a$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $a2a0b4ba09a5a00a$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $a2a0b4ba09a5a00a$var$isInsideEventHandler = !1;
function $a2a0b4ba09a5a00a$var$batchedUpdates$1(fn, a, b) {
    if ($a2a0b4ba09a5a00a$var$isInsideEventHandler) return fn(a, b);
    $a2a0b4ba09a5a00a$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($a2a0b4ba09a5a00a$var$isInsideEventHandler = !1, null !== $a2a0b4ba09a5a00a$var$restoreTarget || null !== $a2a0b4ba09a5a00a$var$restoreQueue) {
            if ($a2a0b4ba09a5a00a$var$flushSyncWork$1(), $a2a0b4ba09a5a00a$var$restoreTarget && (a = $a2a0b4ba09a5a00a$var$restoreTarget, fn = $a2a0b4ba09a5a00a$var$restoreQueue, $a2a0b4ba09a5a00a$var$restoreQueue = $a2a0b4ba09a5a00a$var$restoreTarget = null, $a2a0b4ba09a5a00a$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$a2a0b4ba09a5a00a$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $a2a0b4ba09a5a00a$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$a2a0b4ba09a5a00a$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(231, registrationName, typeof stateNode === "undefined" ? "undefined" : (0, $2bfPH._)(stateNode)));
    return stateNode;
}
var $a2a0b4ba09a5a00a$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $a2a0b4ba09a5a00a$var$passiveBrowserEventsSupported = !1;
if ($a2a0b4ba09a5a00a$var$canUseDOM) try {
    var $a2a0b4ba09a5a00a$var$options = {};
    Object.defineProperty($a2a0b4ba09a5a00a$var$options, "passive", {
        get: function get() {
            $a2a0b4ba09a5a00a$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $a2a0b4ba09a5a00a$var$options, $a2a0b4ba09a5a00a$var$options);
    window.removeEventListener("test", $a2a0b4ba09a5a00a$var$options, $a2a0b4ba09a5a00a$var$options);
} catch (e) {
    $a2a0b4ba09a5a00a$var$passiveBrowserEventsSupported = !1;
}
var $a2a0b4ba09a5a00a$var$root = null, $a2a0b4ba09a5a00a$var$startText = null, $a2a0b4ba09a5a00a$var$fallbackText = null;
function $a2a0b4ba09a5a00a$var$getData() {
    if ($a2a0b4ba09a5a00a$var$fallbackText) return $a2a0b4ba09a5a00a$var$fallbackText;
    var start, startValue = $a2a0b4ba09a5a00a$var$startText, startLength = startValue.length, end, endValue = "value" in $a2a0b4ba09a5a00a$var$root ? $a2a0b4ba09a5a00a$var$root.value : $a2a0b4ba09a5a00a$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $a2a0b4ba09a5a00a$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $a2a0b4ba09a5a00a$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $a2a0b4ba09a5a00a$var$functionThatReturnsTrue() {
    return !0;
}
function $a2a0b4ba09a5a00a$var$functionThatReturnsFalse() {
    return !1;
}
function $a2a0b4ba09a5a00a$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $a2a0b4ba09a5a00a$var$functionThatReturnsTrue : $a2a0b4ba09a5a00a$var$functionThatReturnsFalse;
        this.isPropagationStopped = $a2a0b4ba09a5a00a$var$functionThatReturnsFalse;
        return this;
    }
    $a2a0b4ba09a5a00a$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function preventDefault() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== (0, $2bfPH._)(event.returnValue) && (event.returnValue = !1), this.isDefaultPrevented = $a2a0b4ba09a5a00a$var$functionThatReturnsTrue);
        },
        stopPropagation: function stopPropagation() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== (0, $2bfPH._)(event.cancelBubble) && (event.cancelBubble = !0), this.isPropagationStopped = $a2a0b4ba09a5a00a$var$functionThatReturnsTrue);
        },
        persist: function persist() {},
        isPersistent: $a2a0b4ba09a5a00a$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $a2a0b4ba09a5a00a$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function timeStamp(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $a2a0b4ba09a5a00a$var$SyntheticEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$EventInterface), $a2a0b4ba09a5a00a$var$UIEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    view: 0,
    detail: 0
}), $a2a0b4ba09a5a00a$var$SyntheticUIEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$UIEventInterface), $a2a0b4ba09a5a00a$var$lastMovementX, $a2a0b4ba09a5a00a$var$lastMovementY, $a2a0b4ba09a5a00a$var$lastMouseEvent, $a2a0b4ba09a5a00a$var$MouseEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $a2a0b4ba09a5a00a$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function relatedTarget(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function movementX(event) {
        if ("movementX" in event) return event.movementX;
        event !== $a2a0b4ba09a5a00a$var$lastMouseEvent && ($a2a0b4ba09a5a00a$var$lastMouseEvent && "mousemove" === event.type ? ($a2a0b4ba09a5a00a$var$lastMovementX = event.screenX - $a2a0b4ba09a5a00a$var$lastMouseEvent.screenX, $a2a0b4ba09a5a00a$var$lastMovementY = event.screenY - $a2a0b4ba09a5a00a$var$lastMouseEvent.screenY) : $a2a0b4ba09a5a00a$var$lastMovementY = $a2a0b4ba09a5a00a$var$lastMovementX = 0, $a2a0b4ba09a5a00a$var$lastMouseEvent = event);
        return $a2a0b4ba09a5a00a$var$lastMovementX;
    },
    movementY: function movementY(event) {
        return "movementY" in event ? event.movementY : $a2a0b4ba09a5a00a$var$lastMovementY;
    }
}), $a2a0b4ba09a5a00a$var$SyntheticMouseEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$MouseEventInterface), $a2a0b4ba09a5a00a$var$DragEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$MouseEventInterface, {
    dataTransfer: 0
}), $a2a0b4ba09a5a00a$var$SyntheticDragEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$DragEventInterface), $a2a0b4ba09a5a00a$var$FocusEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$UIEventInterface, {
    relatedTarget: 0
}), $a2a0b4ba09a5a00a$var$SyntheticFocusEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$FocusEventInterface), $a2a0b4ba09a5a00a$var$AnimationEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a2a0b4ba09a5a00a$var$SyntheticAnimationEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$AnimationEventInterface), $a2a0b4ba09a5a00a$var$ClipboardEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    clipboardData: function clipboardData(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $a2a0b4ba09a5a00a$var$SyntheticClipboardEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$ClipboardEventInterface), $a2a0b4ba09a5a00a$var$CompositionEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    data: 0
}), $a2a0b4ba09a5a00a$var$SyntheticCompositionEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$CompositionEventInterface), $a2a0b4ba09a5a00a$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $a2a0b4ba09a5a00a$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $a2a0b4ba09a5a00a$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $a2a0b4ba09a5a00a$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $a2a0b4ba09a5a00a$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $a2a0b4ba09a5a00a$var$getEventModifierState() {
    return $a2a0b4ba09a5a00a$var$modifierStateGetter;
}
var $a2a0b4ba09a5a00a$var$KeyboardEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$UIEventInterface, {
    key: function key(nativeEvent) {
        if (nativeEvent.key) {
            var key = $a2a0b4ba09a5a00a$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $a2a0b4ba09a5a00a$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $a2a0b4ba09a5a00a$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $a2a0b4ba09a5a00a$var$getEventModifierState,
    charCode: function charCode(event) {
        return "keypress" === event.type ? $a2a0b4ba09a5a00a$var$getEventCharCode(event) : 0;
    },
    keyCode: function keyCode(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function which(event) {
        return "keypress" === event.type ? $a2a0b4ba09a5a00a$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $a2a0b4ba09a5a00a$var$SyntheticKeyboardEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$KeyboardEventInterface), $a2a0b4ba09a5a00a$var$PointerEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $a2a0b4ba09a5a00a$var$SyntheticPointerEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$PointerEventInterface), $a2a0b4ba09a5a00a$var$TouchEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $a2a0b4ba09a5a00a$var$getEventModifierState
}), $a2a0b4ba09a5a00a$var$SyntheticTouchEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$TouchEventInterface), $a2a0b4ba09a5a00a$var$TransitionEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $a2a0b4ba09a5a00a$var$SyntheticTransitionEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$TransitionEventInterface), $a2a0b4ba09a5a00a$var$WheelEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$MouseEventInterface, {
    deltaX: function deltaX(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function deltaY(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $a2a0b4ba09a5a00a$var$SyntheticWheelEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$WheelEventInterface), $a2a0b4ba09a5a00a$var$ToggleEventInterface = $a2a0b4ba09a5a00a$var$assign({}, $a2a0b4ba09a5a00a$var$EventInterface, {
    newState: 0,
    oldState: 0
}), $a2a0b4ba09a5a00a$var$SyntheticToggleEvent = $a2a0b4ba09a5a00a$var$createSyntheticEvent($a2a0b4ba09a5a00a$var$ToggleEventInterface), $a2a0b4ba09a5a00a$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $a2a0b4ba09a5a00a$var$canUseCompositionEvent = $a2a0b4ba09a5a00a$var$canUseDOM && "CompositionEvent" in window, $a2a0b4ba09a5a00a$var$documentMode = null;
$a2a0b4ba09a5a00a$var$canUseDOM && "documentMode" in document && ($a2a0b4ba09a5a00a$var$documentMode = document.documentMode);
var $a2a0b4ba09a5a00a$var$canUseTextInputEvent = $a2a0b4ba09a5a00a$var$canUseDOM && "TextEvent" in window && !$a2a0b4ba09a5a00a$var$documentMode, $a2a0b4ba09a5a00a$var$useFallbackCompositionData = $a2a0b4ba09a5a00a$var$canUseDOM && (!$a2a0b4ba09a5a00a$var$canUseCompositionEvent || $a2a0b4ba09a5a00a$var$documentMode && 8 < $a2a0b4ba09a5a00a$var$documentMode && 11 >= $a2a0b4ba09a5a00a$var$documentMode), $a2a0b4ba09a5a00a$var$SPACEBAR_CHAR = String.fromCharCode(32), $a2a0b4ba09a5a00a$var$hasSpaceKeypress = !1;
function $a2a0b4ba09a5a00a$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $a2a0b4ba09a5a00a$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $a2a0b4ba09a5a00a$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === (typeof nativeEvent === "undefined" ? "undefined" : (0, $2bfPH._)(nativeEvent)) && "data" in nativeEvent ? nativeEvent.data : null;
}
var $a2a0b4ba09a5a00a$var$isComposing = !1;
function $a2a0b4ba09a5a00a$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $a2a0b4ba09a5a00a$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $a2a0b4ba09a5a00a$var$hasSpaceKeypress = !0;
            return $a2a0b4ba09a5a00a$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $a2a0b4ba09a5a00a$var$SPACEBAR_CHAR && $a2a0b4ba09a5a00a$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $a2a0b4ba09a5a00a$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($a2a0b4ba09a5a00a$var$isComposing) return "compositionend" === domEventName || !$a2a0b4ba09a5a00a$var$canUseCompositionEvent && $a2a0b4ba09a5a00a$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $a2a0b4ba09a5a00a$var$getData(), $a2a0b4ba09a5a00a$var$fallbackText = $a2a0b4ba09a5a00a$var$startText = $a2a0b4ba09a5a00a$var$root = null, $a2a0b4ba09a5a00a$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $a2a0b4ba09a5a00a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $a2a0b4ba09a5a00a$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $a2a0b4ba09a5a00a$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$a2a0b4ba09a5a00a$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $a2a0b4ba09a5a00a$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $a2a0b4ba09a5a00a$var$restoreTarget ? $a2a0b4ba09a5a00a$var$restoreQueue ? $a2a0b4ba09a5a00a$var$restoreQueue.push(target) : $a2a0b4ba09a5a00a$var$restoreQueue = [
        target
    ] : $a2a0b4ba09a5a00a$var$restoreTarget = target;
    inst = $a2a0b4ba09a5a00a$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $a2a0b4ba09a5a00a$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $a2a0b4ba09a5a00a$var$activeElement$1 = null, $a2a0b4ba09a5a00a$var$activeElementInst$1 = null;
function $a2a0b4ba09a5a00a$var$runEventInBatch(dispatchQueue) {
    $a2a0b4ba09a5a00a$var$processDispatchQueue(dispatchQueue, 0);
}
function $a2a0b4ba09a5a00a$var$getInstIfValueChanged(targetInst) {
    var targetNode = $a2a0b4ba09a5a00a$var$getNodeFromInstance(targetInst);
    if ($a2a0b4ba09a5a00a$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $a2a0b4ba09a5a00a$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $a2a0b4ba09a5a00a$var$isInputEventSupported = !1;
if ($a2a0b4ba09a5a00a$var$canUseDOM) {
    var $a2a0b4ba09a5a00a$var$JSCompiler_inline_result$jscomp$286;
    if ($a2a0b4ba09a5a00a$var$canUseDOM) {
        var $a2a0b4ba09a5a00a$var$isSupported$jscomp$inline_427 = "oninput" in document;
        if (!$a2a0b4ba09a5a00a$var$isSupported$jscomp$inline_427) {
            var $a2a0b4ba09a5a00a$var$element$jscomp$inline_428 = document.createElement("div");
            $a2a0b4ba09a5a00a$var$element$jscomp$inline_428.setAttribute("oninput", "return;");
            $a2a0b4ba09a5a00a$var$isSupported$jscomp$inline_427 = "function" === typeof $a2a0b4ba09a5a00a$var$element$jscomp$inline_428.oninput;
        }
        $a2a0b4ba09a5a00a$var$JSCompiler_inline_result$jscomp$286 = $a2a0b4ba09a5a00a$var$isSupported$jscomp$inline_427;
    } else $a2a0b4ba09a5a00a$var$JSCompiler_inline_result$jscomp$286 = !1;
    $a2a0b4ba09a5a00a$var$isInputEventSupported = $a2a0b4ba09a5a00a$var$JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
}
function $a2a0b4ba09a5a00a$var$stopWatchingForValueChange() {
    $a2a0b4ba09a5a00a$var$activeElement$1 && ($a2a0b4ba09a5a00a$var$activeElement$1.detachEvent("onpropertychange", $a2a0b4ba09a5a00a$var$handlePropertyChange), $a2a0b4ba09a5a00a$var$activeElementInst$1 = $a2a0b4ba09a5a00a$var$activeElement$1 = null);
}
function $a2a0b4ba09a5a00a$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $a2a0b4ba09a5a00a$var$getInstIfValueChanged($a2a0b4ba09a5a00a$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $a2a0b4ba09a5a00a$var$createAndAccumulateChangeEvent(dispatchQueue, $a2a0b4ba09a5a00a$var$activeElementInst$1, nativeEvent, $a2a0b4ba09a5a00a$var$getEventTarget(nativeEvent));
        $a2a0b4ba09a5a00a$var$batchedUpdates$1($a2a0b4ba09a5a00a$var$runEventInBatch, dispatchQueue);
    }
}
function $a2a0b4ba09a5a00a$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($a2a0b4ba09a5a00a$var$stopWatchingForValueChange(), $a2a0b4ba09a5a00a$var$activeElement$1 = target, $a2a0b4ba09a5a00a$var$activeElementInst$1 = targetInst, $a2a0b4ba09a5a00a$var$activeElement$1.attachEvent("onpropertychange", $a2a0b4ba09a5a00a$var$handlePropertyChange)) : "focusout" === domEventName && $a2a0b4ba09a5a00a$var$stopWatchingForValueChange();
}
function $a2a0b4ba09a5a00a$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $a2a0b4ba09a5a00a$var$getInstIfValueChanged($a2a0b4ba09a5a00a$var$activeElementInst$1);
}
function $a2a0b4ba09a5a00a$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $a2a0b4ba09a5a00a$var$getInstIfValueChanged(targetInst);
}
function $a2a0b4ba09a5a00a$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $a2a0b4ba09a5a00a$var$getInstIfValueChanged(targetInst);
}
function $a2a0b4ba09a5a00a$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $a2a0b4ba09a5a00a$var$objectIs = "function" === typeof Object.is ? Object.is : $a2a0b4ba09a5a00a$var$is;
function $a2a0b4ba09a5a00a$var$shallowEqual(objA, objB) {
    if ($a2a0b4ba09a5a00a$var$objectIs(objA, objB)) return !0;
    if ("object" !== (typeof objA === "undefined" ? "undefined" : (0, $2bfPH._)(objA)) || null === objA || "object" !== (typeof objB === "undefined" ? "undefined" : (0, $2bfPH._)(objB)) || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$a2a0b4ba09a5a00a$var$hasOwnProperty.call(objB, currentKey) || !$a2a0b4ba09a5a00a$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $a2a0b4ba09a5a00a$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $a2a0b4ba09a5a00a$var$getNodeForCharacterOffset(root, offset) {
    var node = $a2a0b4ba09a5a00a$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $a2a0b4ba09a5a00a$var$getLeafNode(node);
    }
}
function $a2a0b4ba09a5a00a$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $a2a0b4ba09a5a00a$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $a2a0b4ba09a5a00a$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $a2a0b4ba09a5a00a$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $a2a0b4ba09a5a00a$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $a2a0b4ba09a5a00a$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $a2a0b4ba09a5a00a$var$skipSelectionChangeEvent = $a2a0b4ba09a5a00a$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $a2a0b4ba09a5a00a$var$activeElement = null, $a2a0b4ba09a5a00a$var$activeElementInst = null, $a2a0b4ba09a5a00a$var$lastSelection = null, $a2a0b4ba09a5a00a$var$mouseDown = !1;
function $a2a0b4ba09a5a00a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $a2a0b4ba09a5a00a$var$mouseDown || null == $a2a0b4ba09a5a00a$var$activeElement || $a2a0b4ba09a5a00a$var$activeElement !== $a2a0b4ba09a5a00a$var$getActiveElement(doc) || (doc = $a2a0b4ba09a5a00a$var$activeElement, "selectionStart" in doc && $a2a0b4ba09a5a00a$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $a2a0b4ba09a5a00a$var$lastSelection && $a2a0b4ba09a5a00a$var$shallowEqual($a2a0b4ba09a5a00a$var$lastSelection, doc) || ($a2a0b4ba09a5a00a$var$lastSelection = doc, doc = $a2a0b4ba09a5a00a$var$accumulateTwoPhaseListeners($a2a0b4ba09a5a00a$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $a2a0b4ba09a5a00a$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $a2a0b4ba09a5a00a$var$activeElement)));
}
function $a2a0b4ba09a5a00a$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $a2a0b4ba09a5a00a$var$vendorPrefixes = {
    animationend: $a2a0b4ba09a5a00a$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $a2a0b4ba09a5a00a$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $a2a0b4ba09a5a00a$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $a2a0b4ba09a5a00a$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $a2a0b4ba09a5a00a$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $a2a0b4ba09a5a00a$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $a2a0b4ba09a5a00a$var$makePrefixMap("Transition", "TransitionEnd")
}, $a2a0b4ba09a5a00a$var$prefixedEventNames = {}, $a2a0b4ba09a5a00a$var$style = {};
$a2a0b4ba09a5a00a$var$canUseDOM && ($a2a0b4ba09a5a00a$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $a2a0b4ba09a5a00a$var$vendorPrefixes.animationend.animation, delete $a2a0b4ba09a5a00a$var$vendorPrefixes.animationiteration.animation, delete $a2a0b4ba09a5a00a$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $a2a0b4ba09a5a00a$var$vendorPrefixes.transitionend.transition);
function $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName(eventName) {
    if ($a2a0b4ba09a5a00a$var$prefixedEventNames[eventName]) return $a2a0b4ba09a5a00a$var$prefixedEventNames[eventName];
    if (!$a2a0b4ba09a5a00a$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $a2a0b4ba09a5a00a$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $a2a0b4ba09a5a00a$var$style) return $a2a0b4ba09a5a00a$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $a2a0b4ba09a5a00a$var$ANIMATION_END = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("animationend"), $a2a0b4ba09a5a00a$var$ANIMATION_ITERATION = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("animationiteration"), $a2a0b4ba09a5a00a$var$ANIMATION_START = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("animationstart"), $a2a0b4ba09a5a00a$var$TRANSITION_RUN = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("transitionrun"), $a2a0b4ba09a5a00a$var$TRANSITION_START = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("transitionstart"), $a2a0b4ba09a5a00a$var$TRANSITION_CANCEL = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("transitioncancel"), $a2a0b4ba09a5a00a$var$TRANSITION_END = $a2a0b4ba09a5a00a$var$getVendorPrefixedEventName("transitionend"), $a2a0b4ba09a5a00a$var$topLevelEventsToReactNames = new Map(), $a2a0b4ba09a5a00a$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$a2a0b4ba09a5a00a$var$simpleEventPluginEvents.push("scrollEnd");
function $a2a0b4ba09a5a00a$var$registerSimpleEvent(domEventName, reactName) {
    $a2a0b4ba09a5a00a$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $a2a0b4ba09a5a00a$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $a2a0b4ba09a5a00a$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $a2a0b4ba09a5a00a$var$concurrentQueues = [], $a2a0b4ba09a5a00a$var$concurrentQueuesIndex = 0, $a2a0b4ba09a5a00a$var$concurrentlyUpdatedLanes = 0;
function $a2a0b4ba09a5a00a$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $a2a0b4ba09a5a00a$var$concurrentQueuesIndex, i = $a2a0b4ba09a5a00a$var$concurrentlyUpdatedLanes = $a2a0b4ba09a5a00a$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $a2a0b4ba09a5a00a$var$concurrentQueues[i];
        $a2a0b4ba09a5a00a$var$concurrentQueues[i++] = null;
        var queue = $a2a0b4ba09a5a00a$var$concurrentQueues[i];
        $a2a0b4ba09a5a00a$var$concurrentQueues[i++] = null;
        var update = $a2a0b4ba09a5a00a$var$concurrentQueues[i];
        $a2a0b4ba09a5a00a$var$concurrentQueues[i++] = null;
        var lane = $a2a0b4ba09a5a00a$var$concurrentQueues[i];
        $a2a0b4ba09a5a00a$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $a2a0b4ba09a5a00a$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $a2a0b4ba09a5a00a$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $a2a0b4ba09a5a00a$var$concurrentQueues[$a2a0b4ba09a5a00a$var$concurrentQueuesIndex++] = fiber;
    $a2a0b4ba09a5a00a$var$concurrentQueues[$a2a0b4ba09a5a00a$var$concurrentQueuesIndex++] = queue;
    $a2a0b4ba09a5a00a$var$concurrentQueues[$a2a0b4ba09a5a00a$var$concurrentQueuesIndex++] = update;
    $a2a0b4ba09a5a00a$var$concurrentQueues[$a2a0b4ba09a5a00a$var$concurrentQueuesIndex++] = lane;
    $a2a0b4ba09a5a00a$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $a2a0b4ba09a5a00a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $a2a0b4ba09a5a00a$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $a2a0b4ba09a5a00a$var$getRootForUpdatedFiber(fiber);
}
function $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $a2a0b4ba09a5a00a$var$enqueueUpdate$1(fiber, null, null, lane);
    return $a2a0b4ba09a5a00a$var$getRootForUpdatedFiber(fiber);
}
function $a2a0b4ba09a5a00a$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $a2a0b4ba09a5a00a$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $a2a0b4ba09a5a00a$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $a2a0b4ba09a5a00a$var$nestedUpdateCount) throw $a2a0b4ba09a5a00a$var$nestedUpdateCount = 0, $a2a0b4ba09a5a00a$var$rootWithNestedUpdates = null, Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $a2a0b4ba09a5a00a$var$emptyContextObject = {};
function $a2a0b4ba09a5a00a$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $a2a0b4ba09a5a00a$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $a2a0b4ba09a5a00a$var$FiberNode(tag, pendingProps, key, mode);
}
function $a2a0b4ba09a5a00a$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $a2a0b4ba09a5a00a$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $a2a0b4ba09a5a00a$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 65011712;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $a2a0b4ba09a5a00a$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 65011714;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $a2a0b4ba09a5a00a$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) $a2a0b4ba09a5a00a$var$shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type) fiberTag = $a2a0b4ba09a5a00a$var$isHostHoistableType(type, pendingProps, $a2a0b4ba09a5a00a$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(type){
        case $a2a0b4ba09a5a00a$var$REACT_ACTIVITY_TYPE:
            return type = $a2a0b4ba09a5a00a$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $a2a0b4ba09a5a00a$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE:
            return $a2a0b4ba09a5a00a$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $a2a0b4ba09a5a00a$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $a2a0b4ba09a5a00a$var$REACT_PROFILER_TYPE:
            return type = $a2a0b4ba09a5a00a$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $a2a0b4ba09a5a00a$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_TYPE:
            return type = $a2a0b4ba09a5a00a$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $a2a0b4ba09a5a00a$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $a2a0b4ba09a5a00a$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
            if ("object" === (typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type)) && null !== type) switch(type.$$typeof){
                case $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $a2a0b4ba09a5a00a$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $a2a0b4ba09a5a00a$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $a2a0b4ba09a5a00a$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(130, null === type ? "null" : typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type), ""));
            owner = null;
    }
    key = $a2a0b4ba09a5a00a$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $a2a0b4ba09a5a00a$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $a2a0b4ba09a5a00a$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $a2a0b4ba09a5a00a$var$createFiberFromText(content, mode, lanes) {
    content = $a2a0b4ba09a5a00a$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $a2a0b4ba09a5a00a$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $a2a0b4ba09a5a00a$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $a2a0b4ba09a5a00a$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $a2a0b4ba09a5a00a$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $a2a0b4ba09a5a00a$var$CapturedStacks = new WeakMap();
function $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(value, source) {
    if ("object" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) && null !== value) {
        var existing = $a2a0b4ba09a5a00a$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $a2a0b4ba09a5a00a$var$getStackByFiberInDevAndProd(source)
        };
        $a2a0b4ba09a5a00a$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $a2a0b4ba09a5a00a$var$getStackByFiberInDevAndProd(source)
    };
}
var $a2a0b4ba09a5a00a$var$forkStack = [], $a2a0b4ba09a5a00a$var$forkStackIndex = 0, $a2a0b4ba09a5a00a$var$treeForkProvider = null, $a2a0b4ba09a5a00a$var$treeForkCount = 0, $a2a0b4ba09a5a00a$var$idStack = [], $a2a0b4ba09a5a00a$var$idStackIndex = 0, $a2a0b4ba09a5a00a$var$treeContextProvider = null, $a2a0b4ba09a5a00a$var$treeContextId = 1, $a2a0b4ba09a5a00a$var$treeContextOverflow = "";
function $a2a0b4ba09a5a00a$var$pushTreeFork(workInProgress, totalChildren) {
    $a2a0b4ba09a5a00a$var$forkStack[$a2a0b4ba09a5a00a$var$forkStackIndex++] = $a2a0b4ba09a5a00a$var$treeForkCount;
    $a2a0b4ba09a5a00a$var$forkStack[$a2a0b4ba09a5a00a$var$forkStackIndex++] = $a2a0b4ba09a5a00a$var$treeForkProvider;
    $a2a0b4ba09a5a00a$var$treeForkProvider = workInProgress;
    $a2a0b4ba09a5a00a$var$treeForkCount = totalChildren;
}
function $a2a0b4ba09a5a00a$var$pushTreeId(workInProgress, totalChildren, index) {
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextId;
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextOverflow;
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextProvider;
    $a2a0b4ba09a5a00a$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $a2a0b4ba09a5a00a$var$treeContextId;
    workInProgress = $a2a0b4ba09a5a00a$var$treeContextOverflow;
    var baseLength = 32 - $a2a0b4ba09a5a00a$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $a2a0b4ba09a5a00a$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $a2a0b4ba09a5a00a$var$treeContextId = 1 << 32 - $a2a0b4ba09a5a00a$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $a2a0b4ba09a5a00a$var$treeContextOverflow = length + workInProgress;
    } else $a2a0b4ba09a5a00a$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $a2a0b4ba09a5a00a$var$treeContextOverflow = workInProgress;
}
function $a2a0b4ba09a5a00a$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($a2a0b4ba09a5a00a$var$pushTreeFork(workInProgress, 1), $a2a0b4ba09a5a00a$var$pushTreeId(workInProgress, 1, 0));
}
function $a2a0b4ba09a5a00a$var$popTreeContext(workInProgress) {
    for(; workInProgress === $a2a0b4ba09a5a00a$var$treeForkProvider;)$a2a0b4ba09a5a00a$var$treeForkProvider = $a2a0b4ba09a5a00a$var$forkStack[--$a2a0b4ba09a5a00a$var$forkStackIndex], $a2a0b4ba09a5a00a$var$forkStack[$a2a0b4ba09a5a00a$var$forkStackIndex] = null, $a2a0b4ba09a5a00a$var$treeForkCount = $a2a0b4ba09a5a00a$var$forkStack[--$a2a0b4ba09a5a00a$var$forkStackIndex], $a2a0b4ba09a5a00a$var$forkStack[$a2a0b4ba09a5a00a$var$forkStackIndex] = null;
    for(; workInProgress === $a2a0b4ba09a5a00a$var$treeContextProvider;)$a2a0b4ba09a5a00a$var$treeContextProvider = $a2a0b4ba09a5a00a$var$idStack[--$a2a0b4ba09a5a00a$var$idStackIndex], $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex] = null, $a2a0b4ba09a5a00a$var$treeContextOverflow = $a2a0b4ba09a5a00a$var$idStack[--$a2a0b4ba09a5a00a$var$idStackIndex], $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex] = null, $a2a0b4ba09a5a00a$var$treeContextId = $a2a0b4ba09a5a00a$var$idStack[--$a2a0b4ba09a5a00a$var$idStackIndex], $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex] = null;
}
function $a2a0b4ba09a5a00a$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextId;
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextOverflow;
    $a2a0b4ba09a5a00a$var$idStack[$a2a0b4ba09a5a00a$var$idStackIndex++] = $a2a0b4ba09a5a00a$var$treeContextProvider;
    $a2a0b4ba09a5a00a$var$treeContextId = suspendedContext.id;
    $a2a0b4ba09a5a00a$var$treeContextOverflow = suspendedContext.overflow;
    $a2a0b4ba09a5a00a$var$treeContextProvider = workInProgress;
}
var $a2a0b4ba09a5a00a$var$hydrationParentFiber = null, $a2a0b4ba09a5a00a$var$nextHydratableInstance = null, $a2a0b4ba09a5a00a$var$isHydrating = !1, $a2a0b4ba09a5a00a$var$hydrationErrors = null, $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !1, $a2a0b4ba09a5a00a$var$HydrationMismatchException = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(519));
function $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(fiber) {
    var error = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $a2a0b4ba09a5a00a$var$queueHydrationError($a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(error, fiber));
    throw $a2a0b4ba09a5a00a$var$HydrationMismatchException;
}
function $a2a0b4ba09a5a00a$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$a2a0b4ba09a5a00a$var$internalInstanceKey] = fiber;
    instance[$a2a0b4ba09a5a00a$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("cancel", instance);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $a2a0b4ba09a5a00a$var$mediaEventTypes.length; type++)$a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent($a2a0b4ba09a5a00a$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("error", instance);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", instance);
            $a2a0b4ba09a5a00a$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", instance), $a2a0b4ba09a5a00a$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== (typeof type === "undefined" ? "undefined" : (0, $2bfPH._)(type)) || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $a2a0b4ba09a5a00a$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("beforetoggle", instance), $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $a2a0b4ba09a5a00a$var$noop$1), instance = !0) : instance = !1;
    instance || $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(fiber, !0);
}
function $a2a0b4ba09a5a00a$var$popToNextHostParent(fiber) {
    for($a2a0b4ba09a5a00a$var$hydrationParentFiber = fiber.return; $a2a0b4ba09a5a00a$var$hydrationParentFiber;)switch($a2a0b4ba09a5a00a$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !0;
            return;
        default:
            $a2a0b4ba09a5a00a$var$hydrationParentFiber = $a2a0b4ba09a5a00a$var$hydrationParentFiber.return;
    }
}
function $a2a0b4ba09a5a00a$var$popHydrationState(fiber) {
    if (fiber !== $a2a0b4ba09a5a00a$var$hydrationParentFiber) return !1;
    if (!$a2a0b4ba09a5a00a$var$isHydrating) return $a2a0b4ba09a5a00a$var$popToNextHostParent(fiber), $a2a0b4ba09a5a00a$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $a2a0b4ba09a5a00a$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $a2a0b4ba09a5a00a$var$nextHydratableInstance && $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(fiber);
    $a2a0b4ba09a5a00a$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(317));
        $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(317));
        $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $a2a0b4ba09a5a00a$var$nextHydratableInstance, $a2a0b4ba09a5a00a$var$isSingletonScope(fiber.type) ? (fiber = $a2a0b4ba09a5a00a$var$previousHydratableOnEnteringScopedSingleton, $a2a0b4ba09a5a00a$var$previousHydratableOnEnteringScopedSingleton = null, $a2a0b4ba09a5a00a$var$nextHydratableInstance = fiber) : $a2a0b4ba09a5a00a$var$nextHydratableInstance = tag) : $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$hydrationParentFiber ? $a2a0b4ba09a5a00a$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $a2a0b4ba09a5a00a$var$resetHydrationState() {
    $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$hydrationParentFiber = null;
    $a2a0b4ba09a5a00a$var$isHydrating = !1;
}
function $a2a0b4ba09a5a00a$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $a2a0b4ba09a5a00a$var$hydrationErrors;
    null !== queuedErrors && (null === $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors ? $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = queuedErrors : $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors.push.apply($a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors, queuedErrors), $a2a0b4ba09a5a00a$var$hydrationErrors = null);
    return queuedErrors;
}
function $a2a0b4ba09a5a00a$var$queueHydrationError(error) {
    null === $a2a0b4ba09a5a00a$var$hydrationErrors ? $a2a0b4ba09a5a00a$var$hydrationErrors = [
        error
    ] : $a2a0b4ba09a5a00a$var$hydrationErrors.push(error);
}
var $a2a0b4ba09a5a00a$var$valueCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = null, $a2a0b4ba09a5a00a$var$lastContextDependency = null;
function $a2a0b4ba09a5a00a$var$pushProvider(providerFiber, context, nextValue) {
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $a2a0b4ba09a5a00a$var$popProvider(context) {
    context._currentValue = $a2a0b4ba09a5a00a$var$valueCursor.current;
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$valueCursor);
}
function $a2a0b4ba09a5a00a$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $a2a0b4ba09a5a00a$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $a2a0b4ba09a5a00a$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $a2a0b4ba09a5a00a$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $a2a0b4ba09a5a00a$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $a2a0b4ba09a5a00a$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($a2a0b4ba09a5a00a$var$HostTransitionContext) : current = [
                $a2a0b4ba09a5a00a$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $a2a0b4ba09a5a00a$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
}
function $a2a0b4ba09a5a00a$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$a2a0b4ba09a5a00a$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress) {
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = workInProgress;
    $a2a0b4ba09a5a00a$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $a2a0b4ba09a5a00a$var$readContext(context) {
    return $a2a0b4ba09a5a00a$var$readContextForConsumer($a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1, context);
}
function $a2a0b4ba09a5a00a$var$readContextDuringReconciliation(consumer, context) {
    null === $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 && $a2a0b4ba09a5a00a$var$prepareToReadContext(consumer);
    return $a2a0b4ba09a5a00a$var$readContextForConsumer(consumer, context);
}
function $a2a0b4ba09a5a00a$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $a2a0b4ba09a5a00a$var$lastContextDependency) {
        if (null === consumer) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(308));
        $a2a0b4ba09a5a00a$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $a2a0b4ba09a5a00a$var$lastContextDependency = $a2a0b4ba09a5a00a$var$lastContextDependency.next = context;
    return value;
}
var $a2a0b4ba09a5a00a$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function AbortControllerLocal() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function addEventListener(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $a2a0b4ba09a5a00a$var$scheduleCallback$2 = $5t8wa.unstable_scheduleCallback, $a2a0b4ba09a5a00a$var$NormalPriority = $5t8wa.unstable_NormalPriority, $a2a0b4ba09a5a00a$var$CacheContext = {
    $$typeof: $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $a2a0b4ba09a5a00a$var$createCache() {
    return {
        controller: new $a2a0b4ba09a5a00a$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $a2a0b4ba09a5a00a$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $a2a0b4ba09a5a00a$var$scheduleCallback$2($a2a0b4ba09a5a00a$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
var $a2a0b4ba09a5a00a$var$currentEntangledListeners = null, $a2a0b4ba09a5a00a$var$currentEntangledPendingCount = 0, $a2a0b4ba09a5a00a$var$currentEntangledLane = 0, $a2a0b4ba09a5a00a$var$currentEntangledActionThenable = null;
function $a2a0b4ba09a5a00a$var$entangleAsyncAction(transition, thenable) {
    if (null === $a2a0b4ba09a5a00a$var$currentEntangledListeners) {
        var entangledListeners = $a2a0b4ba09a5a00a$var$currentEntangledListeners = [];
        $a2a0b4ba09a5a00a$var$currentEntangledPendingCount = 0;
        $a2a0b4ba09a5a00a$var$currentEntangledLane = $a2a0b4ba09a5a00a$var$requestTransitionLane();
        $a2a0b4ba09a5a00a$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function then(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $a2a0b4ba09a5a00a$var$currentEntangledPendingCount++;
    thenable.then($a2a0b4ba09a5a00a$var$pingEngtangledActionScope, $a2a0b4ba09a5a00a$var$pingEngtangledActionScope);
    return thenable;
}
function $a2a0b4ba09a5a00a$var$pingEngtangledActionScope() {
    if (0 === --$a2a0b4ba09a5a00a$var$currentEntangledPendingCount && null !== $a2a0b4ba09a5a00a$var$currentEntangledListeners) {
        null !== $a2a0b4ba09a5a00a$var$currentEntangledActionThenable && ($a2a0b4ba09a5a00a$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $a2a0b4ba09a5a00a$var$currentEntangledListeners;
        $a2a0b4ba09a5a00a$var$currentEntangledListeners = null;
        $a2a0b4ba09a5a00a$var$currentEntangledLane = 0;
        $a2a0b4ba09a5a00a$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $a2a0b4ba09a5a00a$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function then(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $a2a0b4ba09a5a00a$var$prevOnStartTransitionFinish = $a2a0b4ba09a5a00a$var$ReactSharedInternals.S;
$a2a0b4ba09a5a00a$var$ReactSharedInternals.S = function(transition, returnValue) {
    $a2a0b4ba09a5a00a$var$globalMostRecentTransitionTime = $a2a0b4ba09a5a00a$var$now();
    "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $2bfPH._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && $a2a0b4ba09a5a00a$var$entangleAsyncAction(transition, returnValue);
    null !== $a2a0b4ba09a5a00a$var$prevOnStartTransitionFinish && $a2a0b4ba09a5a00a$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $a2a0b4ba09a5a00a$var$resumedCache = $a2a0b4ba09a5a00a$var$createCursor(null);
function $a2a0b4ba09a5a00a$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $a2a0b4ba09a5a00a$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $a2a0b4ba09a5a00a$var$workInProgressRoot.pooledCache;
}
function $a2a0b4ba09a5a00a$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$resumedCache, $a2a0b4ba09a5a00a$var$resumedCache.current) : $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$resumedCache, prevCachePool.pool);
}
function $a2a0b4ba09a5a00a$var$getSuspendedCache() {
    var cacheFromPool = $a2a0b4ba09a5a00a$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $a2a0b4ba09a5a00a$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $a2a0b4ba09a5a00a$var$SuspenseException = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(460)), $a2a0b4ba09a5a00a$var$SuspenseyCommitException = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(474)), $a2a0b4ba09a5a00a$var$SuspenseActionException = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(542)), $a2a0b4ba09a5a00a$var$noopSuspenseyCommitThenable = {
    then: function then() {}
};
function $a2a0b4ba09a5a00a$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $a2a0b4ba09a5a00a$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($a2a0b4ba09a5a00a$var$noop$1, $a2a0b4ba09a5a00a$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenableState = thenable.reason, $a2a0b4ba09a5a00a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($a2a0b4ba09a5a00a$var$noop$1, $a2a0b4ba09a5a00a$var$noop$1);
            else {
                thenableState = $a2a0b4ba09a5a00a$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $a2a0b4ba09a5a00a$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $a2a0b4ba09a5a00a$var$suspendedThenable = thenable;
            throw $a2a0b4ba09a5a00a$var$SuspenseException;
    }
}
function $a2a0b4ba09a5a00a$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) && "function" === typeof x.then) throw $a2a0b4ba09a5a00a$var$suspendedThenable = x, $a2a0b4ba09a5a00a$var$SuspenseException;
        throw x;
    }
}
var $a2a0b4ba09a5a00a$var$suspendedThenable = null;
function $a2a0b4ba09a5a00a$var$getSuspendedThenable() {
    if (null === $a2a0b4ba09a5a00a$var$suspendedThenable) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(459));
    var thenable = $a2a0b4ba09a5a00a$var$suspendedThenable;
    $a2a0b4ba09a5a00a$var$suspendedThenable = null;
    return thenable;
}
function $a2a0b4ba09a5a00a$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $a2a0b4ba09a5a00a$var$SuspenseException || rejectedReason === $a2a0b4ba09a5a00a$var$SuspenseActionException) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(483));
}
var $a2a0b4ba09a5a00a$var$thenableState$1 = null, $a2a0b4ba09a5a00a$var$thenableIndexCounter$1 = 0;
function $a2a0b4ba09a5a00a$var$unwrapThenable(thenable) {
    var index = $a2a0b4ba09a5a00a$var$thenableIndexCounter$1;
    $a2a0b4ba09a5a00a$var$thenableIndexCounter$1 += 1;
    null === $a2a0b4ba09a5a00a$var$thenableState$1 && ($a2a0b4ba09a5a00a$var$thenableState$1 = []);
    return $a2a0b4ba09a5a00a$var$trackUsedThenable($a2a0b4ba09a5a00a$var$thenableState$1, thenable, index);
}
function $a2a0b4ba09a5a00a$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $a2a0b4ba09a5a00a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $a2a0b4ba09a5a00a$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $a2a0b4ba09a5a00a$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $a2a0b4ba09a5a00a$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $a2a0b4ba09a5a00a$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE) return updateFragment(returnFiber, current, element.props.children, lanes, element.key);
        if (null !== current && (current.elementType === elementType || "object" === (typeof elementType === "undefined" ? "undefined" : (0, $2bfPH._)(elementType)) && null !== elementType && elementType.$$typeof === $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE && $a2a0b4ba09a5a00a$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $a2a0b4ba09a5a00a$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $a2a0b4ba09a5a00a$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $a2a0b4ba09a5a00a$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $a2a0b4ba09a5a00a$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $a2a0b4ba09a5a00a$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild))) return newChild = $a2a0b4ba09a5a00a$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $a2a0b4ba09a5a00a$var$REACT_ELEMENT_TYPE:
                    return lanes = $a2a0b4ba09a5a00a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a2a0b4ba09a5a00a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE:
                    return newChild = $a2a0b4ba09a5a00a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
                    return newChild = $a2a0b4ba09a5a00a$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($a2a0b4ba09a5a00a$var$isArrayImpl(newChild) || $a2a0b4ba09a5a00a$var$getIteratorFn(newChild)) return newChild = $a2a0b4ba09a5a00a$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $a2a0b4ba09a5a00a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $a2a0b4ba09a5a00a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a2a0b4ba09a5a00a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild))) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $a2a0b4ba09a5a00a$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
                    return newChild = $a2a0b4ba09a5a00a$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($a2a0b4ba09a5a00a$var$isArrayImpl(newChild) || $a2a0b4ba09a5a00a$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $a2a0b4ba09a5a00a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $a2a0b4ba09a5a00a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a2a0b4ba09a5a00a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild))) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $a2a0b4ba09a5a00a$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
                    return newChild = $a2a0b4ba09a5a00a$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($a2a0b4ba09a5a00a$var$isArrayImpl(newChild) || $a2a0b4ba09a5a00a$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $a2a0b4ba09a5a00a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $a2a0b4ba09a5a00a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a2a0b4ba09a5a00a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) && null !== newChild && newChild.type === $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
        if ("object" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) && null !== newChild) {
            switch(newChild.$$typeof){
                case $a2a0b4ba09a5a00a$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === (typeof key === "undefined" ? "undefined" : (0, $2bfPH._)(key)) && null !== key && key.$$typeof === $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE && $a2a0b4ba09a5a00a$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $a2a0b4ba09a5a00a$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $a2a0b4ba09a5a00a$var$REACT_FRAGMENT_TYPE ? (lanes = $a2a0b4ba09a5a00a$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $a2a0b4ba09a5a00a$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $a2a0b4ba09a5a00a$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $a2a0b4ba09a5a00a$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $a2a0b4ba09a5a00a$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $a2a0b4ba09a5a00a$var$REACT_LAZY_TYPE:
                    return newChild = $a2a0b4ba09a5a00a$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($a2a0b4ba09a5a00a$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($a2a0b4ba09a5a00a$var$getIteratorFn(newChild)) {
                key = $a2a0b4ba09a5a00a$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a2a0b4ba09a5a00a$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $a2a0b4ba09a5a00a$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $a2a0b4ba09a5a00a$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === (typeof newChild === "undefined" ? "undefined" : (0, $2bfPH._)(newChild)) ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $a2a0b4ba09a5a00a$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $a2a0b4ba09a5a00a$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $a2a0b4ba09a5a00a$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $a2a0b4ba09a5a00a$var$SuspenseException || x === $a2a0b4ba09a5a00a$var$SuspenseActionException) throw x;
            var fiber = $a2a0b4ba09a5a00a$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $a2a0b4ba09a5a00a$var$reconcileChildFibers = $a2a0b4ba09a5a00a$var$createChildReconciler(!0), $a2a0b4ba09a5a00a$var$mountChildFibers = $a2a0b4ba09a5a00a$var$createChildReconciler(!1), $a2a0b4ba09a5a00a$var$hasForceUpdate = !1;
function $a2a0b4ba09a5a00a$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $a2a0b4ba09a5a00a$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $a2a0b4ba09a5a00a$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $a2a0b4ba09a5a00a$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $a2a0b4ba09a5a00a$var$getRootForUpdatedFiber(fiber);
        $a2a0b4ba09a5a00a$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $a2a0b4ba09a5a00a$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $a2a0b4ba09a5a00a$var$getRootForUpdatedFiber(fiber);
}
function $a2a0b4ba09a5a00a$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $a2a0b4ba09a5a00a$var$markRootEntangled(root, lane);
    }
}
function $a2a0b4ba09a5a00a$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $a2a0b4ba09a5a00a$var$didReadFromEntangledAsyncAction = !1;
function $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($a2a0b4ba09a5a00a$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $a2a0b4ba09a5a00a$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $a2a0b4ba09a5a00a$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $a2a0b4ba09a5a00a$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $a2a0b4ba09a5a00a$var$currentEntangledLane && ($a2a0b4ba09a5a00a$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $a2a0b4ba09a5a00a$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $a2a0b4ba09a5a00a$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $a2a0b4ba09a5a00a$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $a2a0b4ba09a5a00a$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$a2a0b4ba09a5a00a$var$callCallback(callbacks[updateQueue], context);
}
var $a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$prevEntangledRenderLanesCursor = $a2a0b4ba09a5a00a$var$createCursor(0);
function $a2a0b4ba09a5a00a$var$pushHiddenContext(fiber, context) {
    fiber = $a2a0b4ba09a5a00a$var$entangledRenderLanes;
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$prevEntangledRenderLanesCursor, fiber);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor, context);
    $a2a0b4ba09a5a00a$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $a2a0b4ba09a5a00a$var$reuseHiddenContextOnStack() {
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$prevEntangledRenderLanesCursor, $a2a0b4ba09a5a00a$var$entangledRenderLanes);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor, $a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor.current);
}
function $a2a0b4ba09a5a00a$var$popHiddenContext() {
    $a2a0b4ba09a5a00a$var$entangledRenderLanes = $a2a0b4ba09a5a00a$var$prevEntangledRenderLanesCursor.current;
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor);
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$prevEntangledRenderLanesCursor);
}
var $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor = $a2a0b4ba09a5a00a$var$createCursor(null), $a2a0b4ba09a5a00a$var$shellBoundary = null;
function $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current & 1);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor, handler);
    null === $a2a0b4ba09a5a00a$var$shellBoundary && (null === current || null !== $a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor.current ? $a2a0b4ba09a5a00a$var$shellBoundary = handler : null !== current.memoizedState && ($a2a0b4ba09a5a00a$var$shellBoundary = handler));
}
function $a2a0b4ba09a5a00a$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor, fiber);
    null === $a2a0b4ba09a5a00a$var$shellBoundary && ($a2a0b4ba09a5a00a$var$shellBoundary = fiber);
}
function $a2a0b4ba09a5a00a$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current), $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor, fiber), null === $a2a0b4ba09a5a00a$var$shellBoundary && ($a2a0b4ba09a5a00a$var$shellBoundary = fiber)) : $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(fiber);
}
function $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack() {
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current);
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor, $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current);
}
function $a2a0b4ba09a5a00a$var$popSuspenseHandler(fiber) {
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor);
    $a2a0b4ba09a5a00a$var$shellBoundary === fiber && ($a2a0b4ba09a5a00a$var$shellBoundary = null);
    $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$suspenseStackCursor);
}
var $a2a0b4ba09a5a00a$var$suspenseStackCursor = $a2a0b4ba09a5a00a$var$createCursor(0);
function $a2a0b4ba09a5a00a$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $a2a0b4ba09a5a00a$var$isSuspenseInstancePending(state) || $a2a0b4ba09a5a00a$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $a2a0b4ba09a5a00a$var$renderLanes = 0, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = null, $a2a0b4ba09a5a00a$var$currentHook = null, $a2a0b4ba09a5a00a$var$workInProgressHook = null, $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdate = !1, $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $a2a0b4ba09a5a00a$var$localIdCounter = 0, $a2a0b4ba09a5a00a$var$thenableIndexCounter = 0, $a2a0b4ba09a5a00a$var$thenableState = null, $a2a0b4ba09a5a00a$var$globalClientIdCounter = 0;
function $a2a0b4ba09a5a00a$var$throwInvalidHookError() {
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(321));
}
function $a2a0b4ba09a5a00a$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$a2a0b4ba09a5a00a$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $a2a0b4ba09a5a00a$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $a2a0b4ba09a5a00a$var$renderLanes = nextRenderLanes;
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $a2a0b4ba09a5a00a$var$HooksDispatcherOnMount : $a2a0b4ba09a5a00a$var$HooksDispatcherOnUpdate;
    $a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $a2a0b4ba09a5a00a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $a2a0b4ba09a5a00a$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $a2a0b4ba09a5a00a$var$finishRenderingHooks(current) {
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = $a2a0b4ba09a5a00a$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $a2a0b4ba09a5a00a$var$currentHook && null !== $a2a0b4ba09a5a00a$var$currentHook.next;
    $a2a0b4ba09a5a00a$var$renderLanes = 0;
    $a2a0b4ba09a5a00a$var$workInProgressHook = $a2a0b4ba09a5a00a$var$currentHook = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = null;
    $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdate = !1;
    $a2a0b4ba09a5a00a$var$thenableIndexCounter = 0;
    $a2a0b4ba09a5a00a$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(300));
    null === current || $a2a0b4ba09a5a00a$var$didReceiveUpdate || (current = current.dependencies, null !== current && $a2a0b4ba09a5a00a$var$checkIfContextChanged(current) && ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !0));
}
function $a2a0b4ba09a5a00a$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass && ($a2a0b4ba09a5a00a$var$thenableState = null);
        $a2a0b4ba09a5a00a$var$thenableIndexCounter = 0;
        $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $a2a0b4ba09a5a00a$var$workInProgressHook = $a2a0b4ba09a5a00a$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = $a2a0b4ba09a5a00a$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $a2a0b4ba09a5a00a$var$TransitionAwareHostComponent() {
    var dispatcher = $a2a0b4ba09a5a00a$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $a2a0b4ba09a5a00a$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $a2a0b4ba09a5a00a$var$currentHook ? $a2a0b4ba09a5a00a$var$currentHook.memoizedState : null) !== dispatcher && ($a2a0b4ba09a5a00a$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $a2a0b4ba09a5a00a$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $a2a0b4ba09a5a00a$var$localIdCounter;
    $a2a0b4ba09a5a00a$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $a2a0b4ba09a5a00a$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $a2a0b4ba09a5a00a$var$resetHooksOnUnwind(workInProgress) {
    if ($a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdate = !1;
    }
    $a2a0b4ba09a5a00a$var$renderLanes = 0;
    $a2a0b4ba09a5a00a$var$workInProgressHook = $a2a0b4ba09a5a00a$var$currentHook = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = null;
    $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $a2a0b4ba09a5a00a$var$thenableIndexCounter = $a2a0b4ba09a5a00a$var$localIdCounter = 0;
    $a2a0b4ba09a5a00a$var$thenableState = null;
}
function $a2a0b4ba09a5a00a$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $a2a0b4ba09a5a00a$var$workInProgressHook ? $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.memoizedState = $a2a0b4ba09a5a00a$var$workInProgressHook = hook : $a2a0b4ba09a5a00a$var$workInProgressHook = $a2a0b4ba09a5a00a$var$workInProgressHook.next = hook;
    return $a2a0b4ba09a5a00a$var$workInProgressHook;
}
function $a2a0b4ba09a5a00a$var$updateWorkInProgressHook() {
    if (null === $a2a0b4ba09a5a00a$var$currentHook) {
        var nextCurrentHook = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $a2a0b4ba09a5a00a$var$currentHook.next;
    var nextWorkInProgressHook = null === $a2a0b4ba09a5a00a$var$workInProgressHook ? $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.memoizedState : $a2a0b4ba09a5a00a$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $a2a0b4ba09a5a00a$var$workInProgressHook = nextWorkInProgressHook, $a2a0b4ba09a5a00a$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.alternate) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(467));
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(310));
        }
        $a2a0b4ba09a5a00a$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $a2a0b4ba09a5a00a$var$currentHook.memoizedState,
            baseState: $a2a0b4ba09a5a00a$var$currentHook.baseState,
            baseQueue: $a2a0b4ba09a5a00a$var$currentHook.baseQueue,
            queue: $a2a0b4ba09a5a00a$var$currentHook.queue,
            next: null
        };
        null === $a2a0b4ba09a5a00a$var$workInProgressHook ? $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.memoizedState = $a2a0b4ba09a5a00a$var$workInProgressHook = nextCurrentHook : $a2a0b4ba09a5a00a$var$workInProgressHook = $a2a0b4ba09a5a00a$var$workInProgressHook.next = nextCurrentHook;
    }
    return $a2a0b4ba09a5a00a$var$workInProgressHook;
}
function $a2a0b4ba09a5a00a$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $a2a0b4ba09a5a00a$var$useThenable(thenable) {
    var index = $a2a0b4ba09a5a00a$var$thenableIndexCounter;
    $a2a0b4ba09a5a00a$var$thenableIndexCounter += 1;
    null === $a2a0b4ba09a5a00a$var$thenableState && ($a2a0b4ba09a5a00a$var$thenableState = []);
    thenable = $a2a0b4ba09a5a00a$var$trackUsedThenable($a2a0b4ba09a5a00a$var$thenableState, thenable, index);
    index = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber;
    null === (null === $a2a0b4ba09a5a00a$var$workInProgressHook ? index.memoizedState : $a2a0b4ba09a5a00a$var$workInProgressHook.next) && (index = index.alternate, $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $a2a0b4ba09a5a00a$var$HooksDispatcherOnMount : $a2a0b4ba09a5a00a$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $a2a0b4ba09a5a00a$var$use(usable) {
    if (null !== usable && "object" === (typeof usable === "undefined" ? "undefined" : (0, $2bfPH._)(usable))) {
        if ("function" === typeof usable.then) return $a2a0b4ba09a5a00a$var$useThenable(usable);
        if (usable.$$typeof === $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE) return $a2a0b4ba09a5a00a$var$readContext(usable);
    }
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(438, String(usable)));
}
function $a2a0b4ba09a5a00a$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $a2a0b4ba09a5a00a$var$createFunctionComponentUpdateQueue(), $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $a2a0b4ba09a5a00a$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $a2a0b4ba09a5a00a$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $a2a0b4ba09a5a00a$var$updateReducer(reducer) {
    var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    return $a2a0b4ba09a5a00a$var$updateReducerImpl(hook, $a2a0b4ba09a5a00a$var$currentHook, reducer);
}
function $a2a0b4ba09a5a00a$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$60 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($a2a0b4ba09a5a00a$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $a2a0b4ba09a5a00a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                else if (($a2a0b4ba09a5a00a$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $a2a0b4ba09a5a00a$var$currentEntangledLane && (didReadFromEntangledAsyncAction$60 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.lanes |= revertLane, $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.lanes |= updateLane, $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$a2a0b4ba09a5a00a$var$objectIs(pendingQueue, hook.memoizedState) && ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$60 && (reducer = $a2a0b4ba09a5a00a$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $a2a0b4ba09a5a00a$var$rerenderReducer(reducer) {
    var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $a2a0b4ba09a5a00a$var$objectIs(newState, hook.memoizedState) || ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $a2a0b4ba09a5a00a$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $a2a0b4ba09a5a00a$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$a2a0b4ba09a5a00a$var$objectIs(($a2a0b4ba09a5a00a$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $a2a0b4ba09a5a00a$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $a2a0b4ba09a5a00a$var$updateEffect($a2a0b4ba09a5a00a$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $a2a0b4ba09a5a00a$var$workInProgressHook && $a2a0b4ba09a5a00a$var$workInProgressHook.memoizedState.tag & 1) {
        fiber.flags |= 2048;
        $a2a0b4ba09a5a00a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $a2a0b4ba09a5a00a$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
        if (null === $a2a0b4ba09a5a00a$var$workInProgressRoot) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($a2a0b4ba09a5a00a$var$renderLanes & 127) || $a2a0b4ba09a5a00a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $a2a0b4ba09a5a00a$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $a2a0b4ba09a5a00a$var$createFunctionComponentUpdateQueue(), $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $a2a0b4ba09a5a00a$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $a2a0b4ba09a5a00a$var$checkIfSnapshotChanged(inst) && $a2a0b4ba09a5a00a$var$forceStoreRerender(fiber);
}
function $a2a0b4ba09a5a00a$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $a2a0b4ba09a5a00a$var$checkIfSnapshotChanged(inst) && $a2a0b4ba09a5a00a$var$forceStoreRerender(fiber);
    });
}
function $a2a0b4ba09a5a00a$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$a2a0b4ba09a5a00a$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $a2a0b4ba09a5a00a$var$forceStoreRerender(fiber) {
    var root = $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $a2a0b4ba09a5a00a$var$mountStateImpl(initialState) {
    var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a2a0b4ba09a5a00a$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $a2a0b4ba09a5a00a$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $a2a0b4ba09a5a00a$var$updateReducerImpl(hook, $a2a0b4ba09a5a00a$var$currentHook, "function" === typeof reducer ? reducer : $a2a0b4ba09a5a00a$var$basicStateReducer);
}
function $a2a0b4ba09a5a00a$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($a2a0b4ba09a5a00a$var$isRenderPhaseUpdate(fiber)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function then(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $a2a0b4ba09a5a00a$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $a2a0b4ba09a5a00a$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $a2a0b4ba09a5a00a$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T, currentTransition = {};
        $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $a2a0b4ba09a5a00a$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $a2a0b4ba09a5a00a$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $a2a0b4ba09a5a00a$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $a2a0b4ba09a5a00a$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$66) {
        $a2a0b4ba09a5a00a$var$onActionError(actionQueue, node, error$66);
    }
}
function $a2a0b4ba09a5a00a$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $2bfPH._)(returnValue)) && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $a2a0b4ba09a5a00a$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $a2a0b4ba09a5a00a$var$onActionError(actionQueue, node, error);
    }) : $a2a0b4ba09a5a00a$var$onActionSuccess(actionQueue, node, returnValue);
}
function $a2a0b4ba09a5a00a$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $a2a0b4ba09a5a00a$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $a2a0b4ba09a5a00a$var$runActionStateAction(actionQueue, nextState)));
}
function $a2a0b4ba09a5a00a$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $a2a0b4ba09a5a00a$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $a2a0b4ba09a5a00a$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $a2a0b4ba09a5a00a$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $a2a0b4ba09a5a00a$var$mountActionState(action, initialStateProp) {
    if ($a2a0b4ba09a5a00a$var$isHydrating) {
        var ssrFormState = $a2a0b4ba09a5a00a$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber;
                if ($a2a0b4ba09a5a00a$var$isHydrating) {
                    if ($a2a0b4ba09a5a00a$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $a2a0b4ba09a5a00a$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $a2a0b4ba09a5a00a$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $a2a0b4ba09a5a00a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $a2a0b4ba09a5a00a$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $a2a0b4ba09a5a00a$var$dispatchSetState.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$mountStateImpl(!1);
    inRootOrSingleton = $a2a0b4ba09a5a00a$var$dispatchOptimisticSetState.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $a2a0b4ba09a5a00a$var$dispatchActionState.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $a2a0b4ba09a5a00a$var$updateActionState(action) {
    var stateHook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    return $a2a0b4ba09a5a00a$var$updateActionStateImpl(stateHook, $a2a0b4ba09a5a00a$var$currentHook, action);
}
function $a2a0b4ba09a5a00a$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $a2a0b4ba09a5a00a$var$updateReducerImpl(stateHook, currentStateHook, $a2a0b4ba09a5a00a$var$actionStateReducer)[0];
    stateHook = $a2a0b4ba09a5a00a$var$updateReducer($a2a0b4ba09a5a00a$var$basicStateReducer)[0];
    if ("object" === (typeof currentStateHook === "undefined" ? "undefined" : (0, $2bfPH._)(currentStateHook)) && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $a2a0b4ba09a5a00a$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $a2a0b4ba09a5a00a$var$SuspenseException) throw $a2a0b4ba09a5a00a$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($a2a0b4ba09a5a00a$var$currentlyRenderingFiber.flags |= 2048, $a2a0b4ba09a5a00a$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $a2a0b4ba09a5a00a$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $a2a0b4ba09a5a00a$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $a2a0b4ba09a5a00a$var$rerenderActionState(action) {
    var stateHook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook(), currentStateHook = $a2a0b4ba09a5a00a$var$currentHook;
    if (null !== currentStateHook) return $a2a0b4ba09a5a00a$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $a2a0b4ba09a5a00a$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $a2a0b4ba09a5a00a$var$createFunctionComponentUpdateQueue(), $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $a2a0b4ba09a5a00a$var$updateRef() {
    return $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
}
function $a2a0b4ba09a5a00a$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $a2a0b4ba09a5a00a$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $a2a0b4ba09a5a00a$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $a2a0b4ba09a5a00a$var$currentHook && null !== deps && $a2a0b4ba09a5a00a$var$areHookInputsEqual(deps, $a2a0b4ba09a5a00a$var$currentHook.memoizedState.deps) ? hook.memoizedState = $a2a0b4ba09a5a00a$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($a2a0b4ba09a5a00a$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $a2a0b4ba09a5a00a$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $a2a0b4ba09a5a00a$var$mountEffect(create, deps) {
    $a2a0b4ba09a5a00a$var$mountEffectImpl(8390656, 8, create, deps);
}
function $a2a0b4ba09a5a00a$var$updateEffect(create, deps) {
    $a2a0b4ba09a5a00a$var$updateEffectImpl(2048, 8, create, deps);
}
function $a2a0b4ba09a5a00a$var$useEffectEventImpl(payload) {
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $a2a0b4ba09a5a00a$var$createFunctionComponentUpdateQueue(), $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $a2a0b4ba09a5a00a$var$updateEvent(callback) {
    var ref = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
    $a2a0b4ba09a5a00a$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 2)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $a2a0b4ba09a5a00a$var$updateInsertionEffect(create, deps) {
    return $a2a0b4ba09a5a00a$var$updateEffectImpl(4, 2, create, deps);
}
function $a2a0b4ba09a5a00a$var$updateLayoutEffect(create, deps) {
    return $a2a0b4ba09a5a00a$var$updateEffectImpl(4, 4, create, deps);
}
function $a2a0b4ba09a5a00a$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $a2a0b4ba09a5a00a$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $a2a0b4ba09a5a00a$var$updateEffectImpl(4, 4, $a2a0b4ba09a5a00a$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $a2a0b4ba09a5a00a$var$mountDebugValue() {}
function $a2a0b4ba09a5a00a$var$updateCallback(callback, deps) {
    var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a2a0b4ba09a5a00a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $a2a0b4ba09a5a00a$var$updateMemo(nextCreate, deps) {
    var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $a2a0b4ba09a5a00a$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $a2a0b4ba09a5a00a$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($a2a0b4ba09a5a00a$var$renderLanes & 1073741824) && 0 === ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $a2a0b4ba09a5a00a$var$requestDeferredLane();
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.lanes |= hook;
    $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $a2a0b4ba09a5a00a$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($a2a0b4ba09a5a00a$var$objectIs(value, prevValue)) return value;
    if (null !== $a2a0b4ba09a5a00a$var$currentTreeHiddenStackCursor.current) return hook = $a2a0b4ba09a5a00a$var$mountDeferredValueImpl(hook, value, initialValue), $a2a0b4ba09a5a00a$var$objectIs(hook, prevValue) || ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !0), hook;
    if (0 === ($a2a0b4ba09a5a00a$var$renderLanes & 42) || 0 !== ($a2a0b4ba09a5a00a$var$renderLanes & 1073741824) && 0 === ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 261930)) return $a2a0b4ba09a5a00a$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $a2a0b4ba09a5a00a$var$requestDeferredLane();
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber.lanes |= hook;
    $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $a2a0b4ba09a5a00a$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T, currentTransition = {};
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = currentTransition;
    $a2a0b4ba09a5a00a$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $a2a0b4ba09a5a00a$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $2bfPH._)(returnValue)) && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $a2a0b4ba09a5a00a$var$chainThenableValue(returnValue, finishedState);
            $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $a2a0b4ba09a5a00a$var$requestUpdateLane(fiber));
        } else $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(fiber, queue, finishedState, $a2a0b4ba09a5a00a$var$requestUpdateLane(fiber));
    } catch (error) {
        $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(fiber, queue, {
            then: function then() {},
            status: "rejected",
            reason: error
        }, $a2a0b4ba09a5a00a$var$requestUpdateLane());
    } finally{
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a2a0b4ba09a5a00a$var$noop() {}
function $a2a0b4ba09a5a00a$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(476));
    var queue = $a2a0b4ba09a5a00a$var$ensureFormComponentIsStateful(formFiber).queue;
    $a2a0b4ba09a5a00a$var$startTransition(formFiber, queue, pendingState, $a2a0b4ba09a5a00a$var$sharedNotPendingObject, null === action ? $a2a0b4ba09a5a00a$var$noop : function() {
        $a2a0b4ba09a5a00a$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $a2a0b4ba09a5a00a$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $a2a0b4ba09a5a00a$var$sharedNotPendingObject,
        baseState: $a2a0b4ba09a5a00a$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a2a0b4ba09a5a00a$var$basicStateReducer,
            lastRenderedState: $a2a0b4ba09a5a00a$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $a2a0b4ba09a5a00a$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $a2a0b4ba09a5a00a$var$requestFormReset$1(formFiber) {
    var stateHook = $a2a0b4ba09a5a00a$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $a2a0b4ba09a5a00a$var$requestUpdateLane());
}
function $a2a0b4ba09a5a00a$var$useHostTransitionStatus() {
    return $a2a0b4ba09a5a00a$var$readContext($a2a0b4ba09a5a00a$var$HostTransitionContext);
}
function $a2a0b4ba09a5a00a$var$updateId() {
    return $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
}
function $a2a0b4ba09a5a00a$var$updateRefresh() {
    return $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
}
function $a2a0b4ba09a5a00a$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane();
                fiber = $a2a0b4ba09a5a00a$var$createUpdate(lane);
                var root$69 = $a2a0b4ba09a5a00a$var$enqueueUpdate(provider, fiber, lane);
                null !== root$69 && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root$69, provider, lane), $a2a0b4ba09a5a00a$var$entangleTransitions(root$69, provider, lane));
                provider = {
                    cache: $a2a0b4ba09a5a00a$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $a2a0b4ba09a5a00a$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $a2a0b4ba09a5a00a$var$isRenderPhaseUpdate(fiber) ? $a2a0b4ba09a5a00a$var$enqueueRenderPhaseUpdate(queue, action) : (action = $a2a0b4ba09a5a00a$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(action, fiber, lane), $a2a0b4ba09a5a00a$var$entangleTransitionUpdate(action, queue, lane)));
}
function $a2a0b4ba09a5a00a$var$dispatchSetState(fiber, queue, action) {
    var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane();
    $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $a2a0b4ba09a5a00a$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a2a0b4ba09a5a00a$var$isRenderPhaseUpdate(fiber)) $a2a0b4ba09a5a00a$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($a2a0b4ba09a5a00a$var$objectIs(eagerState, currentState)) return $a2a0b4ba09a5a00a$var$enqueueUpdate$1(fiber, queue, update, 0), null === $a2a0b4ba09a5a00a$var$workInProgressRoot && $a2a0b4ba09a5a00a$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $a2a0b4ba09a5a00a$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(action, fiber, lane), $a2a0b4ba09a5a00a$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $a2a0b4ba09a5a00a$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $a2a0b4ba09a5a00a$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($a2a0b4ba09a5a00a$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $a2a0b4ba09a5a00a$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $a2a0b4ba09a5a00a$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $a2a0b4ba09a5a00a$var$currentlyRenderingFiber || null !== alternate && alternate === $a2a0b4ba09a5a00a$var$currentlyRenderingFiber;
}
function $a2a0b4ba09a5a00a$var$enqueueRenderPhaseUpdate(queue, update) {
    $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdateDuringThisPass = $a2a0b4ba09a5a00a$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $a2a0b4ba09a5a00a$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $a2a0b4ba09a5a00a$var$markRootEntangled(root, lane);
    }
}
var $a2a0b4ba09a5a00a$var$ContextOnlyDispatcher = {
    readContext: $a2a0b4ba09a5a00a$var$readContext,
    use: $a2a0b4ba09a5a00a$var$use,
    useCallback: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useContext: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useEffect: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useImperativeHandle: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useLayoutEffect: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useInsertionEffect: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useMemo: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useReducer: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useRef: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useState: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useDebugValue: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useDeferredValue: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useTransition: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useSyncExternalStore: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useId: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useHostTransitionStatus: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useFormState: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useActionState: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useOptimistic: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useMemoCache: $a2a0b4ba09a5a00a$var$throwInvalidHookError,
    useCacheRefresh: $a2a0b4ba09a5a00a$var$throwInvalidHookError
};
$a2a0b4ba09a5a00a$var$ContextOnlyDispatcher.useEffectEvent = $a2a0b4ba09a5a00a$var$throwInvalidHookError;
var $a2a0b4ba09a5a00a$var$HooksDispatcherOnMount = {
    readContext: $a2a0b4ba09a5a00a$var$readContext,
    use: $a2a0b4ba09a5a00a$var$use,
    useCallback: function useCallback(callback, deps) {
        $a2a0b4ba09a5a00a$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $a2a0b4ba09a5a00a$var$readContext,
    useEffect: $a2a0b4ba09a5a00a$var$mountEffect,
    useImperativeHandle: function useImperativeHandle(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $a2a0b4ba09a5a00a$var$mountEffectImpl(4194308, 4, $a2a0b4ba09a5a00a$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function useLayoutEffect(create, deps) {
        return $a2a0b4ba09a5a00a$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function useInsertionEffect(create, deps) {
        $a2a0b4ba09a5a00a$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function useMemo(nextCreate, deps) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function useReducer(reducer, initialArg, init) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($a2a0b4ba09a5a00a$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $a2a0b4ba09a5a00a$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $a2a0b4ba09a5a00a$var$dispatchReducerAction.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function useRef(initialValue) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function useState(initialState) {
        initialState = $a2a0b4ba09a5a00a$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $a2a0b4ba09a5a00a$var$dispatchSetState.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $a2a0b4ba09a5a00a$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        return $a2a0b4ba09a5a00a$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function useTransition() {
        var stateHook = $a2a0b4ba09a5a00a$var$mountStateImpl(!1);
        stateHook = $a2a0b4ba09a5a00a$var$startTransition.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $a2a0b4ba09a5a00a$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        if ($a2a0b4ba09a5a00a$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $a2a0b4ba09a5a00a$var$workInProgressRoot) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(349));
            0 !== ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 127) || $a2a0b4ba09a5a00a$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $a2a0b4ba09a5a00a$var$mountEffect($a2a0b4ba09a5a00a$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $a2a0b4ba09a5a00a$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $a2a0b4ba09a5a00a$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function useId() {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook(), identifierPrefix = $a2a0b4ba09a5a00a$var$workInProgressRoot.identifierPrefix;
        if ($a2a0b4ba09a5a00a$var$isHydrating) {
            var JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$treeContextOverflow;
            var idWithLeadingBit = $a2a0b4ba09a5a00a$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $a2a0b4ba09a5a00a$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $a2a0b4ba09a5a00a$var$useHostTransitionStatus,
    useFormState: $a2a0b4ba09a5a00a$var$mountActionState,
    useActionState: $a2a0b4ba09a5a00a$var$mountActionState,
    useOptimistic: function useOptimistic(passthrough) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $a2a0b4ba09a5a00a$var$dispatchOptimisticSetState.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $a2a0b4ba09a5a00a$var$useMemoCache,
    useCacheRefresh: function useCacheRefresh() {
        return $a2a0b4ba09a5a00a$var$mountWorkInProgressHook().memoizedState = $a2a0b4ba09a5a00a$var$refreshCache.bind(null, $a2a0b4ba09a5a00a$var$currentlyRenderingFiber);
    },
    useEffectEvent: function useEffectEvent(callback) {
        var hook = $a2a0b4ba09a5a00a$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 2)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $a2a0b4ba09a5a00a$var$HooksDispatcherOnUpdate = {
    readContext: $a2a0b4ba09a5a00a$var$readContext,
    use: $a2a0b4ba09a5a00a$var$use,
    useCallback: $a2a0b4ba09a5a00a$var$updateCallback,
    useContext: $a2a0b4ba09a5a00a$var$readContext,
    useEffect: $a2a0b4ba09a5a00a$var$updateEffect,
    useImperativeHandle: $a2a0b4ba09a5a00a$var$updateImperativeHandle,
    useInsertionEffect: $a2a0b4ba09a5a00a$var$updateInsertionEffect,
    useLayoutEffect: $a2a0b4ba09a5a00a$var$updateLayoutEffect,
    useMemo: $a2a0b4ba09a5a00a$var$updateMemo,
    useReducer: $a2a0b4ba09a5a00a$var$updateReducer,
    useRef: $a2a0b4ba09a5a00a$var$updateRef,
    useState: function useState() {
        return $a2a0b4ba09a5a00a$var$updateReducer($a2a0b4ba09a5a00a$var$basicStateReducer);
    },
    useDebugValue: $a2a0b4ba09a5a00a$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
        return $a2a0b4ba09a5a00a$var$updateDeferredValueImpl(hook, $a2a0b4ba09a5a00a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $a2a0b4ba09a5a00a$var$updateReducer($a2a0b4ba09a5a00a$var$basicStateReducer)[0], start = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a2a0b4ba09a5a00a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a2a0b4ba09a5a00a$var$updateSyncExternalStore,
    useId: $a2a0b4ba09a5a00a$var$updateId,
    useHostTransitionStatus: $a2a0b4ba09a5a00a$var$useHostTransitionStatus,
    useFormState: $a2a0b4ba09a5a00a$var$updateActionState,
    useActionState: $a2a0b4ba09a5a00a$var$updateActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
        return $a2a0b4ba09a5a00a$var$updateOptimisticImpl(hook, $a2a0b4ba09a5a00a$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $a2a0b4ba09a5a00a$var$useMemoCache,
    useCacheRefresh: $a2a0b4ba09a5a00a$var$updateRefresh
};
$a2a0b4ba09a5a00a$var$HooksDispatcherOnUpdate.useEffectEvent = $a2a0b4ba09a5a00a$var$updateEvent;
var $a2a0b4ba09a5a00a$var$HooksDispatcherOnRerender = {
    readContext: $a2a0b4ba09a5a00a$var$readContext,
    use: $a2a0b4ba09a5a00a$var$use,
    useCallback: $a2a0b4ba09a5a00a$var$updateCallback,
    useContext: $a2a0b4ba09a5a00a$var$readContext,
    useEffect: $a2a0b4ba09a5a00a$var$updateEffect,
    useImperativeHandle: $a2a0b4ba09a5a00a$var$updateImperativeHandle,
    useInsertionEffect: $a2a0b4ba09a5a00a$var$updateInsertionEffect,
    useLayoutEffect: $a2a0b4ba09a5a00a$var$updateLayoutEffect,
    useMemo: $a2a0b4ba09a5a00a$var$updateMemo,
    useReducer: $a2a0b4ba09a5a00a$var$rerenderReducer,
    useRef: $a2a0b4ba09a5a00a$var$updateRef,
    useState: function useState() {
        return $a2a0b4ba09a5a00a$var$rerenderReducer($a2a0b4ba09a5a00a$var$basicStateReducer);
    },
    useDebugValue: $a2a0b4ba09a5a00a$var$mountDebugValue,
    useDeferredValue: function useDeferredValue(value, initialValue) {
        var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
        return null === $a2a0b4ba09a5a00a$var$currentHook ? $a2a0b4ba09a5a00a$var$mountDeferredValueImpl(hook, value, initialValue) : $a2a0b4ba09a5a00a$var$updateDeferredValueImpl(hook, $a2a0b4ba09a5a00a$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function useTransition() {
        var booleanOrThenable = $a2a0b4ba09a5a00a$var$rerenderReducer($a2a0b4ba09a5a00a$var$basicStateReducer)[0], start = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $a2a0b4ba09a5a00a$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $a2a0b4ba09a5a00a$var$updateSyncExternalStore,
    useId: $a2a0b4ba09a5a00a$var$updateId,
    useHostTransitionStatus: $a2a0b4ba09a5a00a$var$useHostTransitionStatus,
    useFormState: $a2a0b4ba09a5a00a$var$rerenderActionState,
    useActionState: $a2a0b4ba09a5a00a$var$rerenderActionState,
    useOptimistic: function useOptimistic(passthrough, reducer) {
        var hook = $a2a0b4ba09a5a00a$var$updateWorkInProgressHook();
        if (null !== $a2a0b4ba09a5a00a$var$currentHook) return $a2a0b4ba09a5a00a$var$updateOptimisticImpl(hook, $a2a0b4ba09a5a00a$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $a2a0b4ba09a5a00a$var$useMemoCache,
    useCacheRefresh: $a2a0b4ba09a5a00a$var$updateRefresh
};
$a2a0b4ba09a5a00a$var$HooksDispatcherOnRerender.useEffectEvent = $a2a0b4ba09a5a00a$var$updateEvent;
function $a2a0b4ba09a5a00a$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $a2a0b4ba09a5a00a$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $a2a0b4ba09a5a00a$var$classComponentUpdater = {
    enqueueSetState: function enqueueSetState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane(), update = $a2a0b4ba09a5a00a$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a2a0b4ba09a5a00a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(payload, inst, lane), $a2a0b4ba09a5a00a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function enqueueReplaceState(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane(), update = $a2a0b4ba09a5a00a$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $a2a0b4ba09a5a00a$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(payload, inst, lane), $a2a0b4ba09a5a00a$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function enqueueForceUpdate(inst, callback) {
        inst = inst._reactInternals;
        var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane(), update = $a2a0b4ba09a5a00a$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $a2a0b4ba09a5a00a$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(callback, inst, lane), $a2a0b4ba09a5a00a$var$entangleTransitions(callback, inst, lane));
    }
};
function $a2a0b4ba09a5a00a$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$a2a0b4ba09a5a00a$var$shallowEqual(oldProps, newProps) || !$a2a0b4ba09a5a00a$var$shallowEqual(oldState, newState) : !0;
}
function $a2a0b4ba09a5a00a$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $a2a0b4ba09a5a00a$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $a2a0b4ba09a5a00a$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $a2a0b4ba09a5a00a$var$assign({}, newProps));
        for(var propName$73 in Component)void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
}
function $a2a0b4ba09a5a00a$var$defaultOnUncaughtError(error) {
    $a2a0b4ba09a5a00a$var$reportGlobalError(error);
}
function $a2a0b4ba09a5a00a$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $a2a0b4ba09a5a00a$var$defaultOnRecoverableError(error) {
    $a2a0b4ba09a5a00a$var$reportGlobalError(error);
}
function $a2a0b4ba09a5a00a$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$74) {
        setTimeout(function() {
            throw e$74;
        });
    }
}
function $a2a0b4ba09a5a00a$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$75) {
        setTimeout(function() {
            throw e$75;
        });
    }
}
function $a2a0b4ba09a5a00a$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $a2a0b4ba09a5a00a$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $a2a0b4ba09a5a00a$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $a2a0b4ba09a5a00a$var$createClassErrorUpdate(lane) {
    lane = $a2a0b4ba09a5a00a$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $a2a0b4ba09a5a00a$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $a2a0b4ba09a5a00a$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $a2a0b4ba09a5a00a$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed ? $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $a2a0b4ba09a5a00a$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $a2a0b4ba09a5a00a$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                    return null === $a2a0b4ba09a5a00a$var$shellBoundary ? $a2a0b4ba09a5a00a$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && ($a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $a2a0b4ba09a5a00a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $a2a0b4ba09a5a00a$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $a2a0b4ba09a5a00a$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $a2a0b4ba09a5a00a$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $a2a0b4ba09a5a00a$var$attachPingListener(root, value, rootRenderLanes);
        $a2a0b4ba09a5a00a$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($a2a0b4ba09a5a00a$var$isHydrating) return returnFiber = $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $a2a0b4ba09a5a00a$var$HydrationMismatchException && (root = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(422), {
        cause: value
    }), $a2a0b4ba09a5a00a$var$queueHydrationError($a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $a2a0b4ba09a5a00a$var$HydrationMismatchException && (returnFiber = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(423), {
        cause: value
    }), $a2a0b4ba09a5a00a$var$queueHydrationError($a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $a2a0b4ba09a5a00a$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $a2a0b4ba09a5a00a$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && ($a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors ? $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && ($a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $a2a0b4ba09a5a00a$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $a2a0b4ba09a5a00a$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed || !$a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $a2a0b4ba09a5a00a$var$createClassErrorUpdate(rootRenderLanes), $a2a0b4ba09a5a00a$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $a2a0b4ba09a5a00a$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $a2a0b4ba09a5a00a$var$SelectiveHydrationException = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(461)), $a2a0b4ba09a5a00a$var$didReceiveUpdate = !1;
function $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $a2a0b4ba09a5a00a$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $a2a0b4ba09a5a00a$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress);
    nextProps = $a2a0b4ba09a5a00a$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $a2a0b4ba09a5a00a$var$checkDidRenderIdHook();
    if (null !== current && !$a2a0b4ba09a5a00a$var$didReceiveUpdate) return $a2a0b4ba09a5a00a$var$bailoutHooks(current, workInProgress, renderLanes), $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a2a0b4ba09a5a00a$var$isHydrating && key && $a2a0b4ba09a5a00a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$a2a0b4ba09a5a00a$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $a2a0b4ba09a5a00a$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $a2a0b4ba09a5a00a$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$a2a0b4ba09a5a00a$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $a2a0b4ba09a5a00a$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $a2a0b4ba09a5a00a$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $a2a0b4ba09a5a00a$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($a2a0b4ba09a5a00a$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $a2a0b4ba09a5a00a$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($a2a0b4ba09a5a00a$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $a2a0b4ba09a5a00a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $a2a0b4ba09a5a00a$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $a2a0b4ba09a5a00a$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $a2a0b4ba09a5a00a$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $a2a0b4ba09a5a00a$var$pushHiddenContext(workInProgress, prevState) : $a2a0b4ba09a5a00a$var$reuseHiddenContextOnStack(), $a2a0b4ba09a5a00a$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $a2a0b4ba09a5a00a$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($a2a0b4ba09a5a00a$var$pushTransition(workInProgress, prevState.cachePool), $a2a0b4ba09a5a00a$var$pushHiddenContext(workInProgress, prevState), $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.memoizedState = null) : (null !== current && $a2a0b4ba09a5a00a$var$pushTransition(workInProgress, null), $a2a0b4ba09a5a00a$var$reuseHiddenContextOnStack(), $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress));
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $a2a0b4ba09a5a00a$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $a2a0b4ba09a5a00a$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $a2a0b4ba09a5a00a$var$pushTransition(workInProgress, null);
    $a2a0b4ba09a5a00a$var$reuseHiddenContextOnStack();
    $a2a0b4ba09a5a00a$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $a2a0b4ba09a5a00a$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $a2a0b4ba09a5a00a$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $a2a0b4ba09a5a00a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $a2a0b4ba09a5a00a$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $a2a0b4ba09a5a00a$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($a2a0b4ba09a5a00a$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $a2a0b4ba09a5a00a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(null, current);
            $a2a0b4ba09a5a00a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $a2a0b4ba09a5a00a$var$nextHydratableInstance) ? (current = $a2a0b4ba09a5a00a$var$canHydrateHydrationBoundary(current, $a2a0b4ba09a5a00a$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $a2a0b4ba09a5a00a$var$treeContextProvider ? {
                    id: $a2a0b4ba09a5a00a$var$treeContextId,
                    overflow: $a2a0b4ba09a5a00a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $a2a0b4ba09a5a00a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $a2a0b4ba09a5a00a$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $a2a0b4ba09a5a00a$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $a2a0b4ba09a5a00a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(558));
        } else if ($a2a0b4ba09a5a00a$var$didReceiveUpdate || $a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $a2a0b4ba09a5a00a$var$didReceiveUpdate || didSuspend) {
            nextProps = $a2a0b4ba09a5a00a$var$workInProgressRoot;
            if (null !== nextProps && (dehydrated = $a2a0b4ba09a5a00a$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(current, dehydrated), $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $a2a0b4ba09a5a00a$var$SelectiveHydrationException;
            $a2a0b4ba09a5a00a$var$renderDidSuspendDelayIfPossible();
            workInProgress = $a2a0b4ba09a5a00a$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(dehydrated.nextSibling), $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$isHydrating = !0, $a2a0b4ba09a5a00a$var$hydrationErrors = null, $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !1, null !== current && $a2a0b4ba09a5a00a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $a2a0b4ba09a5a00a$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 4096;
        return workInProgress;
    }
    current = $a2a0b4ba09a5a00a$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $a2a0b4ba09a5a00a$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== (typeof ref === "undefined" ? "undefined" : (0, $2bfPH._)(ref))) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $a2a0b4ba09a5a00a$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress);
    Component = $a2a0b4ba09a5a00a$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $a2a0b4ba09a5a00a$var$checkDidRenderIdHook();
    if (null !== current && !$a2a0b4ba09a5a00a$var$didReceiveUpdate) return $a2a0b4ba09a5a00a$var$bailoutHooks(current, workInProgress, renderLanes), $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a2a0b4ba09a5a00a$var$isHydrating && nextProps && $a2a0b4ba09a5a00a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $a2a0b4ba09a5a00a$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $a2a0b4ba09a5a00a$var$finishRenderingHooks(current);
    Component = $a2a0b4ba09a5a00a$var$checkDidRenderIdHook();
    if (null !== current && !$a2a0b4ba09a5a00a$var$didReceiveUpdate) return $a2a0b4ba09a5a00a$var$bailoutHooks(current, workInProgress, renderLanes), $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $a2a0b4ba09a5a00a$var$isHydrating && Component && $a2a0b4ba09a5a00a$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $a2a0b4ba09a5a00a$var$emptyContextObject, contextType = Component.contextType;
        "object" === (typeof contextType === "undefined" ? "undefined" : (0, $2bfPH._)(contextType)) && null !== contextType && (context = $a2a0b4ba09a5a00a$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $a2a0b4ba09a5a00a$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $a2a0b4ba09a5a00a$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === (typeof contextType === "undefined" ? "undefined" : (0, $2bfPH._)(contextType)) && null !== contextType ? $a2a0b4ba09a5a00a$var$readContext(contextType) : $a2a0b4ba09a5a00a$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($a2a0b4ba09a5a00a$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $a2a0b4ba09a5a00a$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $a2a0b4ba09a5a00a$var$emptyContextObject;
        "object" === (typeof contextType$jscomp$0 === "undefined" ? "undefined" : (0, $2bfPH._)(contextType$jscomp$0)) && null !== contextType$jscomp$0 && (contextType = $a2a0b4ba09a5a00a$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $a2a0b4ba09a5a00a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $a2a0b4ba09a5a00a$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $a2a0b4ba09a5a00a$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($a2a0b4ba09a5a00a$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $a2a0b4ba09a5a00a$var$hasForceUpdate || $a2a0b4ba09a5a00a$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $a2a0b4ba09a5a00a$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $a2a0b4ba09a5a00a$var$emptyContextObject;
        "object" === (typeof oldContext === "undefined" ? "undefined" : (0, $2bfPH._)(oldContext)) && null !== oldContext && (oldProps = $a2a0b4ba09a5a00a$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $a2a0b4ba09a5a00a$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $a2a0b4ba09a5a00a$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $a2a0b4ba09a5a00a$var$hasForceUpdate || null !== current && null !== current.dependencies && $a2a0b4ba09a5a00a$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($a2a0b4ba09a5a00a$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $a2a0b4ba09a5a00a$var$hasForceUpdate || $a2a0b4ba09a5a00a$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $a2a0b4ba09a5a00a$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $a2a0b4ba09a5a00a$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $a2a0b4ba09a5a00a$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $a2a0b4ba09a5a00a$var$resetHydrationState();
    workInProgress.flags |= 256;
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $a2a0b4ba09a5a00a$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $a2a0b4ba09a5a00a$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $a2a0b4ba09a5a00a$var$getSuspendedCache()
    };
}
function $a2a0b4ba09a5a00a$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $a2a0b4ba09a5a00a$var$workInProgressDeferredLane);
    return current;
}
function $a2a0b4ba09a5a00a$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($a2a0b4ba09a5a00a$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($a2a0b4ba09a5a00a$var$isHydrating) {
            showFallback ? $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress);
            (current = $a2a0b4ba09a5a00a$var$nextHydratableInstance) ? (current = $a2a0b4ba09a5a00a$var$canHydrateHydrationBoundary(current, $a2a0b4ba09a5a00a$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $a2a0b4ba09a5a00a$var$treeContextProvider ? {
                    id: $a2a0b4ba09a5a00a$var$treeContextId,
                    overflow: $a2a0b4ba09a5a00a$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $a2a0b4ba09a5a00a$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(workInProgress);
            $a2a0b4ba09a5a00a$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        var nextPrimaryChildren = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress), showFallback = workInProgress.mode, nextPrimaryChildren = $a2a0b4ba09a5a00a$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: nextPrimaryChildren
        }, showFallback), nextProps = $a2a0b4ba09a5a00a$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextPrimaryChildren.sibling = nextProps, workInProgress.child = nextPrimaryChildren, nextProps = workInProgress.child, nextProps.memoizedState = $a2a0b4ba09a5a00a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $a2a0b4ba09a5a00a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a2a0b4ba09a5a00a$var$SUSPENDED_MARKER, $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(null, nextProps);
        $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $a2a0b4ba09a5a00a$var$mountSuspensePrimaryChildren(workInProgress, nextPrimaryChildren);
    }
    var prevState = current.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
        if (didSuspend) workInProgress.flags & 256 ? ($a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, workInProgress = $a2a0b4ba09a5a00a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes)) : null !== workInProgress.memoizedState ? ($a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress), workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null) : ($a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, nextProps = $a2a0b4ba09a5a00a$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, showFallback), nextPrimaryChildren = $a2a0b4ba09a5a00a$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress, nextPrimaryChildren.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), nextProps = workInProgress.child, nextProps.memoizedState = $a2a0b4ba09a5a00a$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $a2a0b4ba09a5a00a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a2a0b4ba09a5a00a$var$SUSPENDED_MARKER, workInProgress = $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(null, nextProps));
        else if ($a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress), $a2a0b4ba09a5a00a$var$isSuspenseInstanceFallback(nextPrimaryChildren)) {
            JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
            if (JSCompiler_temp) var digest = JSCompiler_temp.dgst;
            JSCompiler_temp = digest;
            nextProps = Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(419));
            nextProps.stack = "";
            nextProps.digest = JSCompiler_temp;
            $a2a0b4ba09a5a00a$var$queueHydrationError({
                value: nextProps,
                source: null,
                stack: null
            });
            workInProgress = $a2a0b4ba09a5a00a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else if ($a2a0b4ba09a5a00a$var$didReceiveUpdate || $a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), JSCompiler_temp = 0 !== (renderLanes & current.childLanes), $a2a0b4ba09a5a00a$var$didReceiveUpdate || JSCompiler_temp) {
            JSCompiler_temp = $a2a0b4ba09a5a00a$var$workInProgressRoot;
            if (null !== JSCompiler_temp && (nextProps = $a2a0b4ba09a5a00a$var$getBumpedLaneForHydration(JSCompiler_temp, renderLanes), 0 !== nextProps && nextProps !== prevState.retryLane)) throw prevState.retryLane = nextProps, $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(current, nextProps), $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(JSCompiler_temp, current, nextProps), $a2a0b4ba09a5a00a$var$SelectiveHydrationException;
            $a2a0b4ba09a5a00a$var$isSuspenseInstancePending(nextPrimaryChildren) || $a2a0b4ba09a5a00a$var$renderDidSuspendDelayIfPossible();
            workInProgress = $a2a0b4ba09a5a00a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else $a2a0b4ba09a5a00a$var$isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress.flags |= 192, workInProgress.child = current.child, workInProgress = null) : (current = prevState.treeContext, $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(nextPrimaryChildren.nextSibling), $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$isHydrating = !0, $a2a0b4ba09a5a00a$var$hydrationErrors = null, $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !1, null !== current && $a2a0b4ba09a5a00a$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $a2a0b4ba09a5a00a$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children), workInProgress.flags |= 4096);
        return workInProgress;
    }
    if (showFallback) return $a2a0b4ba09a5a00a$var$reuseSuspenseHandlerOnStack(workInProgress), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress.mode, prevState = current.child, digest = prevState.sibling, nextProps = $a2a0b4ba09a5a00a$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest ? nextPrimaryChildren = $a2a0b4ba09a5a00a$var$createWorkInProgress(digest, nextPrimaryChildren) : (nextPrimaryChildren = $a2a0b4ba09a5a00a$var$createFiberFromFragment(nextPrimaryChildren, showFallback, renderLanes, null), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = nextPrimaryChildren, workInProgress.child = nextProps, $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, nextPrimaryChildren = current.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = $a2a0b4ba09a5a00a$var$mountSuspenseOffscreenState(renderLanes) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = $a2a0b4ba09a5a00a$var$CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : showFallback) : showFallback = $a2a0b4ba09a5a00a$var$getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes,
        cachePool: showFallback
    }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = $a2a0b4ba09a5a00a$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $a2a0b4ba09a5a00a$var$SUSPENDED_MARKER, $a2a0b4ba09a5a00a$var$bailoutOffscreenComponent(current.child, nextProps);
    $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $a2a0b4ba09a5a00a$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $a2a0b4ba09a5a00a$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $a2a0b4ba09a5a00a$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $a2a0b4ba09a5a00a$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $a2a0b4ba09a5a00a$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $a2a0b4ba09a5a00a$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $a2a0b4ba09a5a00a$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $a2a0b4ba09a5a00a$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $a2a0b4ba09a5a00a$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $a2a0b4ba09a5a00a$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $a2a0b4ba09a5a00a$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $a2a0b4ba09a5a00a$var$suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, suspenseContext);
    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $a2a0b4ba09a5a00a$var$isHydrating ? $a2a0b4ba09a5a00a$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $a2a0b4ba09a5a00a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $a2a0b4ba09a5a00a$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "forwards":
            renderLanes = workInProgress.child;
            for(revealOrder = null; null !== renderLanes;)current = renderLanes.alternate, null !== current && null === $a2a0b4ba09a5a00a$var$findFirstSuspended(current) && (revealOrder = renderLanes), renderLanes = renderLanes.sibling;
            renderLanes = revealOrder;
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null);
            $a2a0b4ba09a5a00a$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
            break;
        case "backwards":
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $a2a0b4ba09a5a00a$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $a2a0b4ba09a5a00a$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $a2a0b4ba09a5a00a$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        default:
            workInProgress.memoizedState = null;
    }
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $a2a0b4ba09a5a00a$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $a2a0b4ba09a5a00a$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $a2a0b4ba09a5a00a$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $a2a0b4ba09a5a00a$var$checkIfContextChanged(current) ? !0 : !1;
}
function $a2a0b4ba09a5a00a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $a2a0b4ba09a5a00a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, current.memoizedState.cache);
            $a2a0b4ba09a5a00a$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $a2a0b4ba09a5a00a$var$pushHostContext(workInProgress);
            break;
        case 4:
            $a2a0b4ba09a5a00a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $a2a0b4ba09a5a00a$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$102 = workInProgress.memoizedState;
            if (null !== state$102) {
                if (null !== state$102.dehydrated) return $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                if (0 !== (renderLanes & workInProgress.child.childLanes)) return $a2a0b4ba09a5a00a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $a2a0b4ba09a5a00a$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            var didSuspendBefore = 0 !== (current.flags & 128);
            state$102 = 0 !== (renderLanes & workInProgress.childLanes);
            state$102 || ($a2a0b4ba09a5a00a$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$102 = 0 !== (renderLanes & workInProgress.childLanes));
            if (didSuspendBefore) {
                if (state$102) return $a2a0b4ba09a5a00a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            didSuspendBefore = workInProgress.memoizedState;
            null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
            $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current);
            if (state$102) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $a2a0b4ba09a5a00a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, current.memoizedState.cache);
    }
    return $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $a2a0b4ba09a5a00a$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $a2a0b4ba09a5a00a$var$didReceiveUpdate = !0;
        else {
            if (!$a2a0b4ba09a5a00a$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $a2a0b4ba09a5a00a$var$didReceiveUpdate = !1, $a2a0b4ba09a5a00a$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $a2a0b4ba09a5a00a$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $a2a0b4ba09a5a00a$var$didReceiveUpdate = !1, $a2a0b4ba09a5a00a$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $a2a0b4ba09a5a00a$var$pushTreeId(workInProgress, $a2a0b4ba09a5a00a$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $a2a0b4ba09a5a00a$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $a2a0b4ba09a5a00a$var$shouldConstruct(current) ? (props = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $a2a0b4ba09a5a00a$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $a2a0b4ba09a5a00a$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $a2a0b4ba09a5a00a$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $a2a0b4ba09a5a00a$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $a2a0b4ba09a5a00a$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $a2a0b4ba09a5a00a$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $a2a0b4ba09a5a00a$var$getComponentNameFromType(current) || current;
                    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $a2a0b4ba09a5a00a$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(props, workInProgress.pendingProps), $a2a0b4ba09a5a00a$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $a2a0b4ba09a5a00a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $a2a0b4ba09a5a00a$var$cloneUpdateQueue(current, workInProgress);
                $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, props);
                props !== prevState.cache && $a2a0b4ba09a5a00a$var$propagateContextChanges(workInProgress, [
                    $a2a0b4ba09a5a00a$var$CacheContext
                ], renderLanes, !0);
                $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $a2a0b4ba09a5a00a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(424)), workInProgress);
                        $a2a0b4ba09a5a00a$var$queueHydrationError($$typeof);
                        workInProgress = $a2a0b4ba09a5a00a$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(current.firstChild);
                        $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress;
                        $a2a0b4ba09a5a00a$var$isHydrating = !0;
                        $a2a0b4ba09a5a00a$var$hydrationErrors = null;
                        $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !0;
                        renderLanes = $a2a0b4ba09a5a00a$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 4096, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $a2a0b4ba09a5a00a$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $a2a0b4ba09a5a00a$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $a2a0b4ba09a5a00a$var$markRef(current, workInProgress), null === current ? (renderLanes = $a2a0b4ba09a5a00a$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $a2a0b4ba09a5a00a$var$isHydrating || (renderLanes = workInProgress.type, current = workInProgress.pendingProps, props = $a2a0b4ba09a5a00a$var$getOwnerDocumentFromRootContainer($a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current).createElement(renderLanes), props[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress, props[$a2a0b4ba09a5a00a$var$internalPropsKey] = current, $a2a0b4ba09a5a00a$var$setInitialProperties(props, renderLanes, current), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(props), workInProgress.stateNode = props) : workInProgress.memoizedState = $a2a0b4ba09a5a00a$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $a2a0b4ba09a5a00a$var$pushHostContext(workInProgress), null === current && $a2a0b4ba09a5a00a$var$isHydrating && (props = workInProgress.stateNode = $a2a0b4ba09a5a00a$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current), $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !0, $$typeof = $a2a0b4ba09a5a00a$var$nextHydratableInstance, $a2a0b4ba09a5a00a$var$isSingletonScope(workInProgress.type) ? ($a2a0b4ba09a5a00a$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(props.firstChild)) : $a2a0b4ba09a5a00a$var$nextHydratableInstance = $$typeof), $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $a2a0b4ba09a5a00a$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $a2a0b4ba09a5a00a$var$isHydrating) {
                if ($$typeof = props = $a2a0b4ba09a5a00a$var$nextHydratableInstance) props = $a2a0b4ba09a5a00a$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $a2a0b4ba09a5a00a$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$nextHydratableInstance = $a2a0b4ba09a5a00a$var$getNextHydratable(props.firstChild), $a2a0b4ba09a5a00a$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(workInProgress);
            }
            $a2a0b4ba09a5a00a$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $a2a0b4ba09a5a00a$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $a2a0b4ba09a5a00a$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $a2a0b4ba09a5a00a$var$renderWithHooks(current, workInProgress, $a2a0b4ba09a5a00a$var$TransitionAwareHostComponent, null, null, renderLanes), $a2a0b4ba09a5a00a$var$HostTransitionContext._currentValue = $$typeof);
            $a2a0b4ba09a5a00a$var$markRef(current, workInProgress);
            $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $a2a0b4ba09a5a00a$var$isHydrating) {
                if (current = renderLanes = $a2a0b4ba09a5a00a$var$nextHydratableInstance) renderLanes = $a2a0b4ba09a5a00a$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $a2a0b4ba09a5a00a$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $a2a0b4ba09a5a00a$var$hydrationParentFiber = workInProgress, $a2a0b4ba09a5a00a$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $a2a0b4ba09a5a00a$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $a2a0b4ba09a5a00a$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $a2a0b4ba09a5a00a$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $a2a0b4ba09a5a00a$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps, renderLanes), workInProgress.child;
        case 8:
            return $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return props = workInProgress.pendingProps, $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, workInProgress.type, props.value), $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress), $$typeof = $a2a0b4ba09a5a00a$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $a2a0b4ba09a5a00a$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $a2a0b4ba09a5a00a$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $a2a0b4ba09a5a00a$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $a2a0b4ba09a5a00a$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $a2a0b4ba09a5a00a$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $a2a0b4ba09a5a00a$var$prepareToReadContext(workInProgress), props = $a2a0b4ba09a5a00a$var$readContext($a2a0b4ba09a5a00a$var$CacheContext), null === current ? ($$typeof = $a2a0b4ba09a5a00a$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $a2a0b4ba09a5a00a$var$workInProgressRoot, prevState = $a2a0b4ba09a5a00a$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $a2a0b4ba09a5a00a$var$initializeUpdateQueue(workInProgress), $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($a2a0b4ba09a5a00a$var$cloneUpdateQueue(current, workInProgress), $a2a0b4ba09a5a00a$var$processUpdateQueue(workInProgress, null, null, renderLanes), $a2a0b4ba09a5a00a$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, props)) : (props = prevState.cache, $a2a0b4ba09a5a00a$var$pushProvider(workInProgress, $a2a0b4ba09a5a00a$var$CacheContext, props), props !== $$typeof.cache && $a2a0b4ba09a5a00a$var$propagateContextChanges(workInProgress, [
                $a2a0b4ba09a5a00a$var$CacheContext
            ], renderLanes, !0))), $a2a0b4ba09a5a00a$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a2a0b4ba09a5a00a$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $a2a0b4ba09a5a00a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    if (type = 0 !== (workInProgress.mode & 32)) type = !1;
    if (type) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($a2a0b4ba09a5a00a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $a2a0b4ba09a5a00a$var$suspendedThenable = $a2a0b4ba09a5a00a$var$noopSuspenseyCommitThenable, $a2a0b4ba09a5a00a$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $a2a0b4ba09a5a00a$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$a2a0b4ba09a5a00a$var$preloadResource(resource)) {
        if ($a2a0b4ba09a5a00a$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $a2a0b4ba09a5a00a$var$suspendedThenable = $a2a0b4ba09a5a00a$var$noopSuspenseyCommitThenable, $a2a0b4ba09a5a00a$var$SuspenseyCommitException;
    }
}
function $a2a0b4ba09a5a00a$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $a2a0b4ba09a5a00a$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$a2a0b4ba09a5a00a$var$isHydrating) switch(renderState.tailMode){
        case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for(var lastTailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
        case "collapsed":
            lastTailNode = renderState.tail;
            for(var lastTailNode$106 = null; null !== lastTailNode;)null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
    }
}
function $a2a0b4ba09a5a00a$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else for(child$107 = completedWork.child; null !== child$107;)newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $a2a0b4ba09a5a00a$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $a2a0b4ba09a5a00a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
        case 1:
            return $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext);
            $a2a0b4ba09a5a00a$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $a2a0b4ba09a5a00a$var$popHydrationState(workInProgress) ? $a2a0b4ba09a5a00a$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $a2a0b4ba09a5a00a$var$upgradeHydrationErrorsToRecoverable());
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($a2a0b4ba09a5a00a$var$markUpdate(workInProgress), null !== nextResource ? ($a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), $a2a0b4ba09a5a00a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), $a2a0b4ba09a5a00a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($a2a0b4ba09a5a00a$var$markUpdate(workInProgress), $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), $a2a0b4ba09a5a00a$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $a2a0b4ba09a5a00a$var$markUpdate(workInProgress), $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), $a2a0b4ba09a5a00a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $a2a0b4ba09a5a00a$var$popHostContext(workInProgress);
            renderLanes = $a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a2a0b4ba09a5a00a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(166));
                    $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
                    return null;
                }
                current = $a2a0b4ba09a5a00a$var$contextStackCursor.current;
                $a2a0b4ba09a5a00a$var$popHydrationState(workInProgress) ? $a2a0b4ba09a5a00a$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $a2a0b4ba09a5a00a$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $a2a0b4ba09a5a00a$var$markUpdate(workInProgress));
            }
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 5:
            $a2a0b4ba09a5a00a$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a2a0b4ba09a5a00a$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(166));
                    $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
                    return null;
                }
                nextResource = $a2a0b4ba09a5a00a$var$contextStackCursor.current;
                if ($a2a0b4ba09a5a00a$var$popHydrationState(workInProgress)) $a2a0b4ba09a5a00a$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $a2a0b4ba09a5a00a$var$getOwnerDocumentFromRootContainer($a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress;
                    nextResource[$a2a0b4ba09a5a00a$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($a2a0b4ba09a5a00a$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $a2a0b4ba09a5a00a$var$markUpdate(workInProgress);
                }
            }
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            $a2a0b4ba09a5a00a$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $a2a0b4ba09a5a00a$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(166));
                current = $a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current;
                if ($a2a0b4ba09a5a00a$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $a2a0b4ba09a5a00a$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $a2a0b4ba09a5a00a$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $a2a0b4ba09a5a00a$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $a2a0b4ba09a5a00a$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $a2a0b4ba09a5a00a$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(557));
                        current[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress;
                    } else $a2a0b4ba09a5a00a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $a2a0b4ba09a5a00a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(558));
            }
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $a2a0b4ba09a5a00a$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(317));
                        type[$a2a0b4ba09a5a00a$var$internalInstanceKey] = workInProgress;
                    } else $a2a0b4ba09a5a00a$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $a2a0b4ba09a5a00a$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress), workInProgress;
                    $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $a2a0b4ba09a5a00a$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $a2a0b4ba09a5a00a$var$popHostContainer(), null === current && $a2a0b4ba09a5a00a$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
        case 10:
            return $a2a0b4ba09a5a00a$var$popProvider(workInProgress.type), $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
        case 19:
            $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$suspenseStackCursor);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $a2a0b4ba09a5a00a$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $a2a0b4ba09a5a00a$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$a2a0b4ba09a5a00a$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, $a2a0b4ba09a5a00a$var$suspenseStackCursor.current & 1 | 2);
                            $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $a2a0b4ba09a5a00a$var$now() > $a2a0b4ba09a5a00a$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $a2a0b4ba09a5a00a$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $a2a0b4ba09a5a00a$var$scheduleRetryEffect(workInProgress, current), $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !$a2a0b4ba09a5a00a$var$isHydrating) return $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
                    } else 2 * $a2a0b4ba09a5a00a$var$now() - newProps.renderingStartTime > $a2a0b4ba09a5a00a$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $a2a0b4ba09a5a00a$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) return current = newProps.tail, newProps.rendering = current, newProps.tail = current.sibling, newProps.renderingStartTime = $a2a0b4ba09a5a00a$var$now(), current.sibling = null, renderLanes = $a2a0b4ba09a5a00a$var$suspenseStackCursor.current, $a2a0b4ba09a5a00a$var$push($a2a0b4ba09a5a00a$var$suspenseStackCursor, type ? renderLanes & 1 | 2 : renderLanes & 1), $a2a0b4ba09a5a00a$var$isHydrating && $a2a0b4ba09a5a00a$var$pushTreeFork(workInProgress, newProps.treeForkCount), current;
            $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress), $a2a0b4ba09a5a00a$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $a2a0b4ba09a5a00a$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext), $a2a0b4ba09a5a00a$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return null;
    }
    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $a2a0b4ba09a5a00a$var$unwindWork(current, workInProgress) {
    $a2a0b4ba09a5a00a$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext), $a2a0b4ba09a5a00a$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $a2a0b4ba09a5a00a$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(340));
                $a2a0b4ba09a5a00a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(340));
                $a2a0b4ba09a5a00a$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$suspenseStackCursor), null;
        case 4:
            return $a2a0b4ba09a5a00a$var$popHostContainer(), null;
        case 10:
            return $a2a0b4ba09a5a00a$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $a2a0b4ba09a5a00a$var$popSuspenseHandler(workInProgress), $a2a0b4ba09a5a00a$var$popHiddenContext(), null !== current && $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $a2a0b4ba09a5a00a$var$unwindInterruptedWork(current, interruptedWork) {
    $a2a0b4ba09a5a00a$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext);
            $a2a0b4ba09a5a00a$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $a2a0b4ba09a5a00a$var$popHostContext(interruptedWork);
            break;
        case 4:
            $a2a0b4ba09a5a00a$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $a2a0b4ba09a5a00a$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $a2a0b4ba09a5a00a$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$suspenseStackCursor);
            break;
        case 10:
            $a2a0b4ba09a5a00a$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $a2a0b4ba09a5a00a$var$popSuspenseHandler(interruptedWork);
            $a2a0b4ba09a5a00a$var$popHiddenContext();
            null !== current && $a2a0b4ba09a5a00a$var$pop($a2a0b4ba09a5a00a$var$resumedCache);
            break;
        case 24:
            $a2a0b4ba09a5a00a$var$popProvider($a2a0b4ba09a5a00a$var$CacheContext);
    }
}
function $a2a0b4ba09a5a00a$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a2a0b4ba09a5a00a$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $a2a0b4ba09a5a00a$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $a2a0b4ba09a5a00a$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a2a0b4ba09a5a00a$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $a2a0b4ba09a5a00a$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$140) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, nearestMountedAncestor, error$140);
        }
        else ref.current = null;
    }
}
function $a2a0b4ba09a5a00a$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a2a0b4ba09a5a00a$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $a2a0b4ba09a5a00a$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$a2a0b4ba09a5a00a$var$internalPropsKey] = newProps;
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a2a0b4ba09a5a00a$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $a2a0b4ba09a5a00a$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $a2a0b4ba09a5a00a$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $a2a0b4ba09a5a00a$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $a2a0b4ba09a5a00a$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $a2a0b4ba09a5a00a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $a2a0b4ba09a5a00a$var$noop$1));
    else if (4 !== tag && (27 === tag && $a2a0b4ba09a5a00a$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null), node = node.child, null !== node)) for($a2a0b4ba09a5a00a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling; null !== node;)$a2a0b4ba09a5a00a$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent), node = node.sibling;
}
function $a2a0b4ba09a5a00a$var$insertOrAppendPlacementNode(node, before, parent) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) node = node.stateNode, before ? parent.insertBefore(node, before) : parent.appendChild(node);
    else if (4 !== tag && (27 === tag && $a2a0b4ba09a5a00a$var$isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node)) for($a2a0b4ba09a5a00a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling; null !== node;)$a2a0b4ba09a5a00a$var$insertOrAppendPlacementNode(node, before, parent), node = node.sibling;
}
function $a2a0b4ba09a5a00a$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $a2a0b4ba09a5a00a$var$setInitialProperties(singleton, type, props);
        singleton[$a2a0b4ba09a5a00a$var$internalInstanceKey] = finishedWork;
        singleton[$a2a0b4ba09a5a00a$var$internalPropsKey] = props;
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden = !1, $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = !1, $a2a0b4ba09a5a00a$var$needsFormReset = !1, $a2a0b4ba09a5a00a$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $a2a0b4ba09a5a00a$var$nextEffect = null;
function $a2a0b4ba09a5a00a$var$commitBeforeMutationEffects(root, firstChild) {
    root = root.containerInfo;
    $a2a0b4ba09a5a00a$var$eventsEnabled = $a2a0b4ba09a5a00a$var$_enabled;
    root = $a2a0b4ba09a5a00a$var$getActiveElementDeep(root);
    if ($a2a0b4ba09a5a00a$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$20) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $a2a0b4ba09a5a00a$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $a2a0b4ba09a5a00a$var$_enabled = !1;
    for($a2a0b4ba09a5a00a$var$nextEffect = firstChild; null !== $a2a0b4ba09a5a00a$var$nextEffect;)if (firstChild = $a2a0b4ba09a5a00a$var$nextEffect, root = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root) root.return = firstChild, $a2a0b4ba09a5a00a$var$nextEffect = root;
    else for(; null !== $a2a0b4ba09a5a00a$var$nextEffect;){
        firstChild = $a2a0b4ba09a5a00a$var$nextEffect;
        focusNode = firstChild.alternate;
        root = firstChild.flags;
        switch(firstChild.tag){
            case 0:
                if (0 !== (root & 4) && (root = firstChild.updateQueue, root = null !== root ? root.events : null, null !== root)) for(JSCompiler_temp = 0; JSCompiler_temp < root.length; JSCompiler_temp++)anchorOffset = root[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (root & 1024) && null !== focusNode) {
                    root = void 0;
                    JSCompiler_temp = firstChild;
                    anchorOffset = focusNode.memoizedProps;
                    focusNode = focusNode.memoizedState;
                    selection = JSCompiler_temp.stateNode;
                    try {
                        var resolvedPrevProps = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(JSCompiler_temp.type, anchorOffset);
                        root = selection.getSnapshotBeforeUpdate(resolvedPrevProps, focusNode);
                        selection.__reactInternalSnapshotBeforeUpdate = root;
                    } catch (error) {
                        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(JSCompiler_temp, JSCompiler_temp.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (root & 1024)) {
                    if (root = firstChild.stateNode.containerInfo, JSCompiler_temp = root.nodeType, 9 === JSCompiler_temp) $a2a0b4ba09a5a00a$var$clearContainerSparingly(root);
                    else if (1 === JSCompiler_temp) switch(root.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $a2a0b4ba09a5a00a$var$clearContainerSparingly(root);
                            break;
                        default:
                            root.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            default:
                if (0 !== (root & 1024)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(163));
        }
        root = firstChild.sibling;
        if (null !== root) {
            root.return = firstChild.return;
            $a2a0b4ba09a5a00a$var$nextEffect = root;
            break;
        }
        $a2a0b4ba09a5a00a$var$nextEffect = firstChild.return;
    }
}
function $a2a0b4ba09a5a00a$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a2a0b4ba09a5a00a$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $a2a0b4ba09a5a00a$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$139) {
                        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$139);
                    }
                }
            }
            flags & 64 && $a2a0b4ba09a5a00a$var$commitClassCallbacks(finishedWork);
            flags & 512 && $a2a0b4ba09a5a00a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $a2a0b4ba09a5a00a$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $a2a0b4ba09a5a00a$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $a2a0b4ba09a5a00a$var$commitHostMount(finishedWork);
            flags & 512 && $a2a0b4ba09a5a00a$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a2a0b4ba09a5a00a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $a2a0b4ba09a5a00a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $a2a0b4ba09a5a00a$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $a2a0b4ba09a5a00a$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden;
            if (!flags) {
                current = null !== current && null !== current.memoizedState || $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden;
                prevProps = $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden;
                var prevOffscreenSubtreeWasHidden = $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden;
                $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden = flags;
                ($a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = current) && !prevOffscreenSubtreeWasHidden ? $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, 0 !== (finishedWork.subtreeFlags & 8772)) : $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden = prevProps;
                $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            }
            break;
        case 30:
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $a2a0b4ba09a5a00a$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $a2a0b4ba09a5a00a$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $a2a0b4ba09a5a00a$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $a2a0b4ba09a5a00a$var$hostParent = null, $a2a0b4ba09a5a00a$var$hostParentIsContainer = !1;
function $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$a2a0b4ba09a5a00a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $a2a0b4ba09a5a00a$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($a2a0b4ba09a5a00a$var$injectedHook && "function" === typeof $a2a0b4ba09a5a00a$var$injectedHook.onCommitFiberUnmount) try {
        $a2a0b4ba09a5a00a$var$injectedHook.onCommitFiberUnmount($a2a0b4ba09a5a00a$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || $a2a0b4ba09a5a00a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || $a2a0b4ba09a5a00a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            var prevHostParent = $a2a0b4ba09a5a00a$var$hostParent, prevHostParentIsContainer = $a2a0b4ba09a5a00a$var$hostParentIsContainer;
            $a2a0b4ba09a5a00a$var$isSingletonScope(deletedFiber.type) && ($a2a0b4ba09a5a00a$var$hostParent = deletedFiber.stateNode, $a2a0b4ba09a5a00a$var$hostParentIsContainer = !1);
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a2a0b4ba09a5a00a$var$releaseSingletonInstance(deletedFiber.stateNode);
            $a2a0b4ba09a5a00a$var$hostParent = prevHostParent;
            $a2a0b4ba09a5a00a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || $a2a0b4ba09a5a00a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
            prevHostParent = $a2a0b4ba09a5a00a$var$hostParent;
            prevHostParentIsContainer = $a2a0b4ba09a5a00a$var$hostParentIsContainer;
            $a2a0b4ba09a5a00a$var$hostParent = null;
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a2a0b4ba09a5a00a$var$hostParent = prevHostParent;
            $a2a0b4ba09a5a00a$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $a2a0b4ba09a5a00a$var$hostParent) {
                if ($a2a0b4ba09a5a00a$var$hostParentIsContainer) try {
                    (9 === $a2a0b4ba09a5a00a$var$hostParent.nodeType ? $a2a0b4ba09a5a00a$var$hostParent.body : "HTML" === $a2a0b4ba09a5a00a$var$hostParent.nodeName ? $a2a0b4ba09a5a00a$var$hostParent.ownerDocument.body : $a2a0b4ba09a5a00a$var$hostParent).removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $a2a0b4ba09a5a00a$var$hostParent.removeChild(deletedFiber.stateNode);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $a2a0b4ba09a5a00a$var$hostParent && ($a2a0b4ba09a5a00a$var$hostParentIsContainer ? (finishedRoot = $a2a0b4ba09a5a00a$var$hostParent, $a2a0b4ba09a5a00a$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $a2a0b4ba09a5a00a$var$retryIfBlockedOn(finishedRoot)) : $a2a0b4ba09a5a00a$var$clearHydrationBoundary($a2a0b4ba09a5a00a$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $a2a0b4ba09a5a00a$var$hostParent;
            prevHostParentIsContainer = $a2a0b4ba09a5a00a$var$hostParentIsContainer;
            $a2a0b4ba09a5a00a$var$hostParent = deletedFiber.stateNode.containerInfo;
            $a2a0b4ba09a5a00a$var$hostParentIsContainer = !0;
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a2a0b4ba09a5a00a$var$hostParent = prevHostParent;
            $a2a0b4ba09a5a00a$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || ($a2a0b4ba09a5a00a$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $a2a0b4ba09a5a00a$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = (prevHostParent = $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $a2a0b4ba09a5a00a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $a2a0b4ba09a5a00a$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $a2a0b4ba09a5a00a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $a2a0b4ba09a5a00a$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $a2a0b4ba09a5a00a$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $a2a0b4ba09a5a00a$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $a2a0b4ba09a5a00a$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $a2a0b4ba09a5a00a$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $a2a0b4ba09a5a00a$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $a2a0b4ba09a5a00a$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($a2a0b4ba09a5a00a$var$isSingletonScope(parent.type)) {
                        $a2a0b4ba09a5a00a$var$hostParent = parent.stateNode;
                        $a2a0b4ba09a5a00a$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $a2a0b4ba09a5a00a$var$hostParent = parent.stateNode;
                    $a2a0b4ba09a5a00a$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $a2a0b4ba09a5a00a$var$hostParent = parent.stateNode.containerInfo;
                    $a2a0b4ba09a5a00a$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $a2a0b4ba09a5a00a$var$hostParent) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(160));
        $a2a0b4ba09a5a00a$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $a2a0b4ba09a5a00a$var$hostParent = null;
        $a2a0b4ba09a5a00a$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$a2a0b4ba09a5a00a$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
}
var $a2a0b4ba09a5a00a$var$currentHoistableRoot = null;
function $a2a0b4ba09a5a00a$var$commitMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $a2a0b4ba09a5a00a$var$commitHookEffectListMount(3, finishedWork), $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || null === current || $a2a0b4ba09a5a00a$var$safelyDetachRef(current, current.return));
            flags & 64 && $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current ? flags : current.concat(flags))));
            break;
        case 26:
            var hoistableRoot = $a2a0b4ba09a5a00a$var$currentHoistableRoot;
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || null === current || $a2a0b4ba09a5a00a$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                var currentResource = null !== current ? current.memoizedState : null;
                flags = finishedWork.memoizedState;
                if (null === current) {
                    if (null === flags) {
                        if (null === finishedWork.stateNode) {
                            a: {
                                flags = finishedWork.type;
                                current = finishedWork.memoizedProps;
                                hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                                b: switch(flags){
                                    case "title":
                                        currentResource = hoistableRoot.getElementsByTagName("title")[0];
                                        if (!currentResource || currentResource[$a2a0b4ba09a5a00a$var$internalHoistableMarker] || currentResource[$a2a0b4ba09a5a00a$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop")) currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(currentResource, hoistableRoot.querySelector("head > title"));
                                        $a2a0b4ba09a5a00a$var$setInitialProperties(currentResource, flags, current);
                                        currentResource[$a2a0b4ba09a5a00a$var$internalInstanceKey] = finishedWork;
                                        $a2a0b4ba09a5a00a$var$markNodeAsHoistable(currentResource);
                                        flags = currentResource;
                                        break a;
                                    case "link":
                                        var maybeNodes = $a2a0b4ba09a5a00a$var$getHydratableHoistableCache("link", "href", hoistableRoot).get(flags + (current.href || ""));
                                        if (maybeNodes) {
                                            for(var i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("href") === (null == current.href || "" === current.href ? null : current.href) && currentResource.getAttribute("rel") === (null == current.rel ? null : current.rel) && currentResource.getAttribute("title") === (null == current.title ? null : current.title) && currentResource.getAttribute("crossorigin") === (null == current.crossOrigin ? null : current.crossOrigin)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a2a0b4ba09a5a00a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    case "meta":
                                        if (maybeNodes = $a2a0b4ba09a5a00a$var$getHydratableHoistableCache("meta", "content", hoistableRoot).get(flags + (current.content || ""))) {
                                            for(i = 0; i < maybeNodes.length; i++)if (currentResource = maybeNodes[i], currentResource.getAttribute("content") === (null == current.content ? null : "" + current.content) && currentResource.getAttribute("name") === (null == current.name ? null : current.name) && currentResource.getAttribute("property") === (null == current.property ? null : current.property) && currentResource.getAttribute("http-equiv") === (null == current.httpEquiv ? null : current.httpEquiv) && currentResource.getAttribute("charset") === (null == current.charSet ? null : current.charSet)) {
                                                maybeNodes.splice(i, 1);
                                                break b;
                                            }
                                        }
                                        currentResource = hoistableRoot.createElement(flags);
                                        $a2a0b4ba09a5a00a$var$setInitialProperties(currentResource, flags, current);
                                        hoistableRoot.head.appendChild(currentResource);
                                        break;
                                    default:
                                        throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(468, flags));
                                }
                                currentResource[$a2a0b4ba09a5a00a$var$internalInstanceKey] = finishedWork;
                                $a2a0b4ba09a5a00a$var$markNodeAsHoistable(currentResource);
                                flags = currentResource;
                            }
                            finishedWork.stateNode = flags;
                        } else $a2a0b4ba09a5a00a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $a2a0b4ba09a5a00a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps);
                } else currentResource !== flags ? (null === currentResource ? null !== current.stateNode && (current = current.stateNode, current.parentNode.removeChild(current)) : currentResource.count--, null === flags ? $a2a0b4ba09a5a00a$var$mountHoistable(hoistableRoot, finishedWork.type, finishedWork.stateNode) : $a2a0b4ba09a5a00a$var$acquireResource(hoistableRoot, flags, finishedWork.memoizedProps)) : null === flags && null !== finishedWork.stateNode && $a2a0b4ba09a5a00a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || null === current || $a2a0b4ba09a5a00a$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $a2a0b4ba09a5a00a$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || null === current || $a2a0b4ba09a5a00a$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                hoistableRoot = finishedWork.stateNode;
                try {
                    $a2a0b4ba09a5a00a$var$setTextContent(hoistableRoot, "");
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, $a2a0b4ba09a5a00a$var$commitHostUpdate(finishedWork, hoistableRoot, null !== current ? current.memoizedProps : hoistableRoot));
            flags & 1024 && ($a2a0b4ba09a5a00a$var$needsFormReset = !0);
            break;
        case 6:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(162));
                flags = finishedWork.memoizedProps;
                current = finishedWork.stateNode;
                try {
                    current.nodeValue = flags;
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $a2a0b4ba09a5a00a$var$tagCaches = null;
            hoistableRoot = $a2a0b4ba09a5a00a$var$currentHoistableRoot;
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = $a2a0b4ba09a5a00a$var$getHoistableRoot(root.containerInfo);
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = hoistableRoot;
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $a2a0b4ba09a5a00a$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $a2a0b4ba09a5a00a$var$needsFormReset && ($a2a0b4ba09a5a00a$var$needsFormReset = !1, $a2a0b4ba09a5a00a$var$recursivelyResetForms(finishedWork));
            break;
        case 4:
            flags = $a2a0b4ba09a5a00a$var$currentHoistableRoot;
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = $a2a0b4ba09a5a00a$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = flags;
            break;
        case 12:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a2a0b4ba09a5a00a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 13:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($a2a0b4ba09a5a00a$var$globalMostRecentFallbackTime = $a2a0b4ba09a5a00a$var$now());
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a2a0b4ba09a5a00a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 22:
            hoistableRoot = null !== finishedWork.memoizedState;
            var wasHidden = null !== current && null !== current.memoizedState, prevOffscreenSubtreeIsHidden = $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden;
            $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            if (flags & 8192) a: for(root = finishedWork.stateNode, root._visibility = hoistableRoot ? root._visibility & -2 : root._visibility | 1, hoistableRoot && (null === current || wasHidden || $a2a0b4ba09a5a00a$var$offscreenSubtreeIsHidden || $a2a0b4ba09a5a00a$var$offscreenSubtreeWasHidden || $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork)), current = null, root = finishedWork;;){
                if (5 === root.tag || 26 === root.tag) {
                    if (null === current) {
                        wasHidden = current = root;
                        try {
                            if (currentResource = wasHidden.stateNode, hoistableRoot) maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                            else {
                                i = wasHidden.stateNode;
                                var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                                i.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                            }
                        } catch (error) {
                            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (6 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                        } catch (error) {
                            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if (18 === root.tag) {
                    if (null === current) {
                        wasHidden = root;
                        try {
                            var instance = wasHidden.stateNode;
                            hoistableRoot ? $a2a0b4ba09a5a00a$var$hideOrUnhideDehydratedBoundary(instance, !0) : $a2a0b4ba09a5a00a$var$hideOrUnhideDehydratedBoundary(wasHidden.stateNode, !1);
                        } catch (error) {
                            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(wasHidden, wasHidden.return, error);
                        }
                    }
                } else if ((22 !== root.tag && 23 !== root.tag || null === root.memoizedState || root === finishedWork) && null !== root.child) {
                    root.child.return = root;
                    root = root.child;
                    continue;
                }
                if (root === finishedWork) break a;
                for(; null === root.sibling;){
                    if (null === root.return || root.return === finishedWork) break a;
                    current === root && (current = null);
                    root = root.return;
                }
                current === root && (current = null);
                root.sibling.return = root.return;
                root = root.sibling;
            }
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current = flags.retryQueue, null !== current && (flags.retryQueue = null, $a2a0b4ba09a5a00a$var$attachSuspenseRetryListeners(finishedWork, current))));
            break;
        case 19:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork);
            $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, $a2a0b4ba09a5a00a$var$attachSuspenseRetryListeners(finishedWork, flags)));
            break;
        case 30:
            break;
        case 21:
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyTraverseMutationEffects(root, finishedWork), $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork);
    }
}
function $a2a0b4ba09a5a00a$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($a2a0b4ba09a5a00a$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            if (null == hostParentFiber) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent = hostParentFiber.stateNode, before = $a2a0b4ba09a5a00a$var$getHostSibling(finishedWork);
                    $a2a0b4ba09a5a00a$var$insertOrAppendPlacementNode(finishedWork, before, parent);
                    break;
                case 5:
                    var parent$141 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($a2a0b4ba09a5a00a$var$setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
                    var before$142 = $a2a0b4ba09a5a00a$var$getHostSibling(finishedWork);
                    $a2a0b4ba09a5a00a$var$insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
                    break;
                case 3:
                case 4:
                    var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = $a2a0b4ba09a5a00a$var$getHostSibling(finishedWork);
                    $a2a0b4ba09a5a00a$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$144, parent$143);
                    break;
                default:
                    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $a2a0b4ba09a5a00a$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $a2a0b4ba09a5a00a$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$a2a0b4ba09a5a00a$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 1:
                $a2a0b4ba09a5a00a$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $a2a0b4ba09a5a00a$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 27:
                $a2a0b4ba09a5a00a$var$releaseSingletonInstance(finishedWork.stateNode);
            case 26:
            case 5:
                $a2a0b4ba09a5a00a$var$safelyDetachRef(finishedWork, finishedWork.return);
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            case 30:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
                break;
            default:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisappearLayoutEffects(finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a2a0b4ba09a5a00a$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$a2a0b4ba09a5a00a$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $a2a0b4ba09a5a00a$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $a2a0b4ba09a5a00a$var$commitClassCallbacks(finishedWork);
                $a2a0b4ba09a5a00a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                $a2a0b4ba09a5a00a$var$commitHostSingletonAcquisition(finishedWork);
            case 26:
            case 5:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && null === current && flags & 4 && $a2a0b4ba09a5a00a$var$commitHostMount(finishedWork);
                $a2a0b4ba09a5a00a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                break;
            case 31:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $a2a0b4ba09a5a00a$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 4 && $a2a0b4ba09a5a00a$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
                $a2a0b4ba09a5a00a$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                break;
            default:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a2a0b4ba09a5a00a$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $a2a0b4ba09a5a00a$var$releaseCache(previousCache));
}
function $a2a0b4ba09a5a00a$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $a2a0b4ba09a5a00a$var$releaseCache(current));
}
function $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a2a0b4ba09a5a00a$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
}
function $a2a0b4ba09a5a00a$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a2a0b4ba09a5a00a$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && $a2a0b4ba09a5a00a$var$releaseCache(finishedRoot)));
            break;
        case 12:
            if (flags & 2048) {
                $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                finishedRoot = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", finishedRoot.passiveEffectDuration, -0);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1));
            flags & 2048 && $a2a0b4ba09a5a00a$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $a2a0b4ba09a5a00a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $a2a0b4ba09a5a00a$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $a2a0b4ba09a5a00a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $a2a0b4ba09a5a00a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a2a0b4ba09a5a00a$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $a2a0b4ba09a5a00a$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $a2a0b4ba09a5a00a$var$suspenseyCommitFlag = 8192;
function $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $a2a0b4ba09a5a00a$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$a2a0b4ba09a5a00a$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $a2a0b4ba09a5a00a$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $a2a0b4ba09a5a00a$var$suspenseyCommitFlag && null !== fiber.memoizedState && $a2a0b4ba09a5a00a$var$suspendResource(suspendedState, $a2a0b4ba09a5a00a$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps);
            break;
        case 5:
            $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $a2a0b4ba09a5a00a$var$currentHoistableRoot;
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = $a2a0b4ba09a5a00a$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $a2a0b4ba09a5a00a$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $a2a0b4ba09a5a00a$var$suspenseyCommitFlag, $a2a0b4ba09a5a00a$var$suspenseyCommitFlag = 16777216, $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $a2a0b4ba09a5a00a$var$suspenseyCommitFlag = previousHoistableRoot) : $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $a2a0b4ba09a5a00a$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a2a0b4ba09a5a00a$var$nextEffect = childToDelete;
            $a2a0b4ba09a5a00a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a2a0b4ba09a5a00a$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$a2a0b4ba09a5a00a$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $a2a0b4ba09a5a00a$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $a2a0b4ba09a5a00a$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $a2a0b4ba09a5a00a$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $a2a0b4ba09a5a00a$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $a2a0b4ba09a5a00a$var$nextEffect = childToDelete;
            $a2a0b4ba09a5a00a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $a2a0b4ba09a5a00a$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $a2a0b4ba09a5a00a$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $a2a0b4ba09a5a00a$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $a2a0b4ba09a5a00a$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $a2a0b4ba09a5a00a$var$nextEffect;){
        var fiber = $a2a0b4ba09a5a00a$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $a2a0b4ba09a5a00a$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $a2a0b4ba09a5a00a$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $a2a0b4ba09a5a00a$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $a2a0b4ba09a5a00a$var$nextEffect;){
            cache = $a2a0b4ba09a5a00a$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $a2a0b4ba09a5a00a$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $a2a0b4ba09a5a00a$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $a2a0b4ba09a5a00a$var$nextEffect = sibling;
                break a;
            }
            $a2a0b4ba09a5a00a$var$nextEffect = returnFiber;
        }
    }
}
var $a2a0b4ba09a5a00a$var$DefaultAsyncDispatcher = {
    getCacheForType: function getCacheForType(resourceType) {
        var cache = $a2a0b4ba09a5a00a$var$readContext($a2a0b4ba09a5a00a$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function cacheSignal() {
        return $a2a0b4ba09a5a00a$var$readContext($a2a0b4ba09a5a00a$var$CacheContext).controller.signal;
    }
}, $a2a0b4ba09a5a00a$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $a2a0b4ba09a5a00a$var$executionContext = 0, $a2a0b4ba09a5a00a$var$workInProgressRoot = null, $a2a0b4ba09a5a00a$var$workInProgress = null, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0, $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null, $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings = !1, $a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering = !1, $a2a0b4ba09a5a00a$var$workInProgressRootDidAttachPingListener = !1, $a2a0b4ba09a5a00a$var$entangledRenderLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 0, $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressRootPingedLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane = 0, $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes = 0, $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors = null, $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = null, $a2a0b4ba09a5a00a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $a2a0b4ba09a5a00a$var$globalMostRecentFallbackTime = 0, $a2a0b4ba09a5a00a$var$globalMostRecentTransitionTime = 0, $a2a0b4ba09a5a00a$var$workInProgressRootRenderTargetTime = Infinity, $a2a0b4ba09a5a00a$var$workInProgressTransitions = null, $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed = null, $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0, $a2a0b4ba09a5a00a$var$pendingEffectsRoot = null, $a2a0b4ba09a5a00a$var$pendingFinishedWork = null, $a2a0b4ba09a5a00a$var$pendingEffectsLanes = 0, $a2a0b4ba09a5a00a$var$pendingEffectsRemainingLanes = 0, $a2a0b4ba09a5a00a$var$pendingPassiveTransitions = null, $a2a0b4ba09a5a00a$var$pendingRecoverableErrors = null, $a2a0b4ba09a5a00a$var$nestedUpdateCount = 0, $a2a0b4ba09a5a00a$var$rootWithNestedUpdates = null;
function $a2a0b4ba09a5a00a$var$requestUpdateLane() {
    return 0 !== ($a2a0b4ba09a5a00a$var$executionContext & 2) && 0 !== $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes ? $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & -$a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes : null !== $a2a0b4ba09a5a00a$var$ReactSharedInternals.T ? $a2a0b4ba09a5a00a$var$requestTransitionLane() : $a2a0b4ba09a5a00a$var$resolveUpdatePriority();
}
function $a2a0b4ba09a5a00a$var$requestDeferredLane() {
    if (0 === $a2a0b4ba09a5a00a$var$workInProgressDeferredLane) {
        if (0 === ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 536870912) || $a2a0b4ba09a5a00a$var$isHydrating) {
            var lane = $a2a0b4ba09a5a00a$var$nextTransitionDeferredLane;
            $a2a0b4ba09a5a00a$var$nextTransitionDeferredLane <<= 1;
            0 === ($a2a0b4ba09a5a00a$var$nextTransitionDeferredLane & 3932160) && ($a2a0b4ba09a5a00a$var$nextTransitionDeferredLane = 262144);
            $a2a0b4ba09a5a00a$var$workInProgressDeferredLane = lane;
        } else $a2a0b4ba09a5a00a$var$workInProgressDeferredLane = 536870912;
    }
    lane = $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $a2a0b4ba09a5a00a$var$workInProgressDeferredLane;
}
function $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $a2a0b4ba09a5a00a$var$workInProgressRoot && (2 === $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason || 9 === $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $a2a0b4ba09a5a00a$var$prepareFreshStack(root, 0), $a2a0b4ba09a5a00a$var$markRootSuspended(root, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, !1);
    $a2a0b4ba09a5a00a$var$markRootUpdated$1(root, lane);
    if (0 === ($a2a0b4ba09a5a00a$var$executionContext & 2) || root !== $a2a0b4ba09a5a00a$var$workInProgressRoot) root === $a2a0b4ba09a5a00a$var$workInProgressRoot && (0 === ($a2a0b4ba09a5a00a$var$executionContext & 2) && ($a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && $a2a0b4ba09a5a00a$var$markRootSuspended(root, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, !1)), $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root);
}
function $a2a0b4ba09a5a00a$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 6)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $a2a0b4ba09a5a00a$var$renderRootConcurrent(root$jscomp$0, lanes) : $a2a0b4ba09a5a00a$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $a2a0b4ba09a5a00a$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$a2a0b4ba09a5a00a$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $a2a0b4ba09a5a00a$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($a2a0b4ba09a5a00a$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result) {
                            if ($a2a0b4ba09a5a00a$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors;
                            $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors ? $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors.push.apply($a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $a2a0b4ba09a5a00a$var$prepareFreshStack(root$jscomp$0, 0);
                $a2a0b4ba09a5a00a$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes) break;
                    case 6:
                        $a2a0b4ba09a5a00a$var$markRootSuspended(shouldTimeSlice, lanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, !$a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $a2a0b4ba09a5a00a$var$globalMostRecentFallbackTime + 300 - $a2a0b4ba09a5a00a$var$now(), 10 < exitStatus)) {
                    $a2a0b4ba09a5a00a$var$markRootSuspended(shouldTimeSlice, lanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, !$a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $a2a0b4ba09a5a00a$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $a2a0b4ba09a5a00a$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $a2a0b4ba09a5a00a$var$scheduleTimeout($a2a0b4ba09a5a00a$var$commitRootWhenReady.bind(null, shouldTimeSlice, forceSync, $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors, $a2a0b4ba09a5a00a$var$workInProgressTransitions, $a2a0b4ba09a5a00a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, $a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes, $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes, $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $a2a0b4ba09a5a00a$var$commitRootWhenReady(shouldTimeSlice, forceSync, $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors, $a2a0b4ba09a5a00a$var$workInProgressTransitions, $a2a0b4ba09a5a00a$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, $a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes, $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes, $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root$jscomp$0);
}
function $a2a0b4ba09a5a00a$var$commitRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
        suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $a2a0b4ba09a5a00a$var$noop$1
        };
        $a2a0b4ba09a5a00a$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason);
        var timeoutOffset = (lanes & 62914560) === lanes ? $a2a0b4ba09a5a00a$var$globalMostRecentFallbackTime - $a2a0b4ba09a5a00a$var$now() : (lanes & 4194048) === lanes ? $a2a0b4ba09a5a00a$var$globalMostRecentTransitionTime - $a2a0b4ba09a5a00a$var$now() : 0;
        timeoutOffset = $a2a0b4ba09a5a00a$var$waitForCommitToBeReady(suspendedCommitReason, timeoutOffset);
        if (null !== timeoutOffset) {
            $a2a0b4ba09a5a00a$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = timeoutOffset($a2a0b4ba09a5a00a$var$commitRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $a2a0b4ba09a5a00a$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $a2a0b4ba09a5a00a$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
}
function $a2a0b4ba09a5a00a$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$a2a0b4ba09a5a00a$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $a2a0b4ba09a5a00a$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~$a2a0b4ba09a5a00a$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $a2a0b4ba09a5a00a$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $a2a0b4ba09a5a00a$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $a2a0b4ba09a5a00a$var$flushSyncWork$1() {
    return 0 === ($a2a0b4ba09a5a00a$var$executionContext & 6) ? ($a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $a2a0b4ba09a5a00a$var$resetWorkInProgressStack() {
    if (null !== $a2a0b4ba09a5a00a$var$workInProgress) {
        if (0 === $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason) var interruptedWork = $a2a0b4ba09a5a00a$var$workInProgress.return;
        else interruptedWork = $a2a0b4ba09a5a00a$var$workInProgress, $a2a0b4ba09a5a00a$var$lastContextDependency = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = null, $a2a0b4ba09a5a00a$var$resetHooksOnUnwind(interruptedWork), $a2a0b4ba09a5a00a$var$thenableState$1 = null, $a2a0b4ba09a5a00a$var$thenableIndexCounter$1 = 0, interruptedWork = $a2a0b4ba09a5a00a$var$workInProgress;
        for(; null !== interruptedWork;)$a2a0b4ba09a5a00a$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $a2a0b4ba09a5a00a$var$workInProgress = null;
    }
}
function $a2a0b4ba09a5a00a$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $a2a0b4ba09a5a00a$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $a2a0b4ba09a5a00a$var$pendingEffectsLanes = 0;
    $a2a0b4ba09a5a00a$var$resetWorkInProgressStack();
    $a2a0b4ba09a5a00a$var$workInProgressRoot = root;
    $a2a0b4ba09a5a00a$var$workInProgress = timeoutHandle = $a2a0b4ba09a5a00a$var$createWorkInProgress(root.current, null);
    $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes = lanes;
    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
    $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering = $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root, lanes);
    $a2a0b4ba09a5a00a$var$workInProgressRootDidAttachPingListener = !1;
    $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes = $a2a0b4ba09a5a00a$var$workInProgressDeferredLane = $a2a0b4ba09a5a00a$var$workInProgressRootPingedLanes = $a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes = $a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes = $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 0;
    $a2a0b4ba09a5a00a$var$workInProgressRootRecoverableErrors = $a2a0b4ba09a5a00a$var$workInProgressRootConcurrentErrors = null;
    $a2a0b4ba09a5a00a$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $a2a0b4ba09a5a00a$var$clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    $a2a0b4ba09a5a00a$var$entangledRenderLanes = lanes;
    $a2a0b4ba09a5a00a$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $a2a0b4ba09a5a00a$var$handleThrow(root, thrownValue) {
    $a2a0b4ba09a5a00a$var$currentlyRenderingFiber = null;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = $a2a0b4ba09a5a00a$var$ContextOnlyDispatcher;
    thrownValue === $a2a0b4ba09a5a00a$var$SuspenseException || thrownValue === $a2a0b4ba09a5a00a$var$SuspenseActionException ? (thrownValue = $a2a0b4ba09a5a00a$var$getSuspendedThenable(), $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 3) : thrownValue === $a2a0b4ba09a5a00a$var$SuspenseyCommitException ? (thrownValue = $a2a0b4ba09a5a00a$var$getSuspendedThenable(), $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 4) : $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = thrownValue === $a2a0b4ba09a5a00a$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === (typeof thrownValue === "undefined" ? "undefined" : (0, $2bfPH._)(thrownValue)) && "function" === typeof thrownValue.then ? 6 : 1;
    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = thrownValue;
    null === $a2a0b4ba09a5a00a$var$workInProgress && ($a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 1, $a2a0b4ba09a5a00a$var$logUncaughtError(root, $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $a2a0b4ba09a5a00a$var$shouldRemainOnPreviousScreen() {
    var handler = $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 4194048) === $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes ? null === $a2a0b4ba09a5a00a$var$shellBoundary ? !0 : !1 : ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 62914560) === $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes || 0 !== ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 536870912) ? handler === $a2a0b4ba09a5a00a$var$shellBoundary : !1;
}
function $a2a0b4ba09a5a00a$var$pushDispatcher() {
    var prevDispatcher = $a2a0b4ba09a5a00a$var$ReactSharedInternals.H;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = $a2a0b4ba09a5a00a$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $a2a0b4ba09a5a00a$var$ContextOnlyDispatcher : prevDispatcher;
}
function $a2a0b4ba09a5a00a$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $a2a0b4ba09a5a00a$var$ReactSharedInternals.A;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.A = $a2a0b4ba09a5a00a$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $a2a0b4ba09a5a00a$var$renderDidSuspendDelayIfPossible() {
    $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 4;
    $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings || ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 4194048) !== $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes && null !== $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current || ($a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering = !0);
    0 === ($a2a0b4ba09a5a00a$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($a2a0b4ba09a5a00a$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $a2a0b4ba09a5a00a$var$workInProgressRoot || $a2a0b4ba09a5a00a$var$markRootSuspended($a2a0b4ba09a5a00a$var$workInProgressRoot, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes, $a2a0b4ba09a5a00a$var$workInProgressDeferredLane, !1);
}
function $a2a0b4ba09a5a00a$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $a2a0b4ba09a5a00a$var$executionContext;
    $a2a0b4ba09a5a00a$var$executionContext |= 2;
    var prevDispatcher = $a2a0b4ba09a5a00a$var$pushDispatcher(), prevAsyncDispatcher = $a2a0b4ba09a5a00a$var$pushAsyncDispatcher();
    if ($a2a0b4ba09a5a00a$var$workInProgressRoot !== root || $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes !== lanes) $a2a0b4ba09a5a00a$var$workInProgressTransitions = null, $a2a0b4ba09a5a00a$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason && null !== $a2a0b4ba09a5a00a$var$workInProgress) {
            var unitOfWork = $a2a0b4ba09a5a00a$var$workInProgress, thrownValue = $a2a0b4ba09a5a00a$var$workInProgressThrownValue;
            switch($a2a0b4ba09a5a00a$var$workInProgressSuspendedReason){
                case 8:
                    $a2a0b4ba09a5a00a$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason;
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                    $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason, $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0, $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null, $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $a2a0b4ba09a5a00a$var$workLoopSync();
        exitStatus = $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$165) {
        $a2a0b4ba09a5a00a$var$handleThrow(root, thrownValue$165);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $a2a0b4ba09a5a00a$var$lastContextDependency = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = null;
    $a2a0b4ba09a5a00a$var$executionContext = prevExecutionContext;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = prevDispatcher;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $a2a0b4ba09a5a00a$var$workInProgress && ($a2a0b4ba09a5a00a$var$workInProgressRoot = null, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes = 0, $a2a0b4ba09a5a00a$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $a2a0b4ba09a5a00a$var$workLoopSync() {
    for(; null !== $a2a0b4ba09a5a00a$var$workInProgress;)$a2a0b4ba09a5a00a$var$performUnitOfWork($a2a0b4ba09a5a00a$var$workInProgress);
}
function $a2a0b4ba09a5a00a$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $a2a0b4ba09a5a00a$var$executionContext;
    $a2a0b4ba09a5a00a$var$executionContext |= 2;
    var prevDispatcher = $a2a0b4ba09a5a00a$var$pushDispatcher(), prevAsyncDispatcher = $a2a0b4ba09a5a00a$var$pushAsyncDispatcher();
    $a2a0b4ba09a5a00a$var$workInProgressRoot !== root || $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes !== lanes ? ($a2a0b4ba09a5a00a$var$workInProgressTransitions = null, $a2a0b4ba09a5a00a$var$workInProgressRootRenderTargetTime = $a2a0b4ba09a5a00a$var$now() + 500, $a2a0b4ba09a5a00a$var$prepareFreshStack(root, lanes)) : $a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering = $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason && null !== $a2a0b4ba09a5a00a$var$workInProgress) {
            lanes = $a2a0b4ba09a5a00a$var$workInProgress;
            var thrownValue = $a2a0b4ba09a5a00a$var$workInProgressThrownValue;
            b: switch($a2a0b4ba09a5a00a$var$workInProgressSuspendedReason){
                case 1:
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                    $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($a2a0b4ba09a5a00a$var$isThenableResolved(thrownValue)) {
                        $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                        $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                        $a2a0b4ba09a5a00a$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function lanes() {
                        2 !== $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason && 9 !== $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason || $a2a0b4ba09a5a00a$var$workInProgressRoot !== root || ($a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 7);
                        $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $a2a0b4ba09a5a00a$var$isThenableResolved(thrownValue) ? ($a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0, $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null, $a2a0b4ba09a5a00a$var$replaySuspendedUnitOfWork(lanes)) : ($a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0, $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null, $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($a2a0b4ba09a5a00a$var$workInProgress.tag){
                        case 26:
                            resource = $a2a0b4ba09a5a00a$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $a2a0b4ba09a5a00a$var$workInProgress;
                            if (resource ? $a2a0b4ba09a5a00a$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                                $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $a2a0b4ba09a5a00a$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($a2a0b4ba09a5a00a$var$workInProgress = returnFiber, $a2a0b4ba09a5a00a$var$completeUnitOfWork(returnFiber)) : $a2a0b4ba09a5a00a$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                    $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason = 0;
                    $a2a0b4ba09a5a00a$var$workInProgressThrownValue = null;
                    $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $a2a0b4ba09a5a00a$var$resetWorkInProgressStack();
                    $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(462));
            }
        }
        $a2a0b4ba09a5a00a$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$167) {
        $a2a0b4ba09a5a00a$var$handleThrow(root, thrownValue$167);
    }
    while (1);
    $a2a0b4ba09a5a00a$var$lastContextDependency = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = null;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.H = prevDispatcher;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $a2a0b4ba09a5a00a$var$executionContext = prevExecutionContext;
    if (null !== $a2a0b4ba09a5a00a$var$workInProgress) return 0;
    $a2a0b4ba09a5a00a$var$workInProgressRoot = null;
    $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes = 0;
    $a2a0b4ba09a5a00a$var$finishQueueingConcurrentUpdates();
    return $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus;
}
function $a2a0b4ba09a5a00a$var$workLoopConcurrentByScheduler() {
    for(; null !== $a2a0b4ba09a5a00a$var$workInProgress && !$a2a0b4ba09a5a00a$var$shouldYield();)$a2a0b4ba09a5a00a$var$performUnitOfWork($a2a0b4ba09a5a00a$var$workInProgress);
}
function $a2a0b4ba09a5a00a$var$performUnitOfWork(unitOfWork) {
    var next = $a2a0b4ba09a5a00a$var$beginWork(unitOfWork.alternate, unitOfWork, $a2a0b4ba09a5a00a$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a2a0b4ba09a5a00a$var$completeUnitOfWork(unitOfWork) : $a2a0b4ba09a5a00a$var$workInProgress = next;
}
function $a2a0b4ba09a5a00a$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $a2a0b4ba09a5a00a$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $a2a0b4ba09a5a00a$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $a2a0b4ba09a5a00a$var$resetHooksOnUnwind(next);
        default:
            $a2a0b4ba09a5a00a$var$unwindInterruptedWork(current, next), next = $a2a0b4ba09a5a00a$var$workInProgress = $a2a0b4ba09a5a00a$var$resetWorkInProgress(next, $a2a0b4ba09a5a00a$var$entangledRenderLanes), next = $a2a0b4ba09a5a00a$var$beginWork(current, next, $a2a0b4ba09a5a00a$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $a2a0b4ba09a5a00a$var$completeUnitOfWork(unitOfWork) : $a2a0b4ba09a5a00a$var$workInProgress = next;
}
function $a2a0b4ba09a5a00a$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $a2a0b4ba09a5a00a$var$lastContextDependency = $a2a0b4ba09a5a00a$var$currentlyRenderingFiber$1 = null;
    $a2a0b4ba09a5a00a$var$resetHooksOnUnwind(unitOfWork);
    $a2a0b4ba09a5a00a$var$thenableState$1 = null;
    $a2a0b4ba09a5a00a$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($a2a0b4ba09a5a00a$var$throwException(root, returnFiber, unitOfWork, thrownValue, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes)) {
            $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 1;
            $a2a0b4ba09a5a00a$var$logUncaughtError(root, $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(thrownValue, root.current));
            $a2a0b4ba09a5a00a$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $a2a0b4ba09a5a00a$var$workInProgress = returnFiber, error;
        $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 1;
        $a2a0b4ba09a5a00a$var$logUncaughtError(root, $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(thrownValue, root.current));
        $a2a0b4ba09a5a00a$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($a2a0b4ba09a5a00a$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($a2a0b4ba09a5a00a$var$workInProgressRootIsPrerendering || 0 !== ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $a2a0b4ba09a5a00a$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $a2a0b4ba09a5a00a$var$unwindUnitOfWork(unitOfWork, root);
    } else $a2a0b4ba09a5a00a$var$completeUnitOfWork(unitOfWork);
}
function $a2a0b4ba09a5a00a$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $a2a0b4ba09a5a00a$var$unwindUnitOfWork(completedWork, $a2a0b4ba09a5a00a$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $a2a0b4ba09a5a00a$var$completeWork(completedWork.alternate, completedWork, $a2a0b4ba09a5a00a$var$entangledRenderLanes);
        if (null !== next) {
            $a2a0b4ba09a5a00a$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $a2a0b4ba09a5a00a$var$workInProgress = completedWork;
            return;
        }
        $a2a0b4ba09a5a00a$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && ($a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 5);
}
function $a2a0b4ba09a5a00a$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $a2a0b4ba09a5a00a$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $a2a0b4ba09a5a00a$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $a2a0b4ba09a5a00a$var$workInProgress = unitOfWork;
            return;
        }
        $a2a0b4ba09a5a00a$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus = 6;
    $a2a0b4ba09a5a00a$var$workInProgress = null;
}
function $a2a0b4ba09a5a00a$var$commitRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root.cancelPendingCommit = null;
    do $a2a0b4ba09a5a00a$var$flushPendingEffects();
    while (0 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus);
    if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 6)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(177));
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= $a2a0b4ba09a5a00a$var$concurrentlyUpdatedLanes;
        $a2a0b4ba09a5a00a$var$markRootFinished(root, lanes, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes);
        root === $a2a0b4ba09a5a00a$var$workInProgressRoot && ($a2a0b4ba09a5a00a$var$workInProgress = $a2a0b4ba09a5a00a$var$workInProgressRoot = null, $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes = 0);
        $a2a0b4ba09a5a00a$var$pendingFinishedWork = finishedWork;
        $a2a0b4ba09a5a00a$var$pendingEffectsRoot = root;
        $a2a0b4ba09a5a00a$var$pendingEffectsLanes = lanes;
        $a2a0b4ba09a5a00a$var$pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        $a2a0b4ba09a5a00a$var$pendingPassiveTransitions = transitions;
        $a2a0b4ba09a5a00a$var$pendingRecoverableErrors = recoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root.callbackNode = null, root.callbackPriority = 0, $a2a0b4ba09a5a00a$var$scheduleCallback$1($a2a0b4ba09a5a00a$var$NormalPriority$1, function() {
            $a2a0b4ba09a5a00a$var$flushPassiveEffects();
            return null;
        })) : (root.callbackNode = null, root.callbackPriority = 0);
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
            recoverableErrors = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
            $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
            transitions = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
            $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 2;
            spawnedLane = $a2a0b4ba09a5a00a$var$executionContext;
            $a2a0b4ba09a5a00a$var$executionContext |= 4;
            try {
                $a2a0b4ba09a5a00a$var$commitBeforeMutationEffects(root, finishedWork, lanes);
            } finally{
                $a2a0b4ba09a5a00a$var$executionContext = spawnedLane, $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = transitions, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = recoverableErrors;
            }
        }
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 1;
        $a2a0b4ba09a5a00a$var$flushMutationEffects();
        $a2a0b4ba09a5a00a$var$flushLayoutEffects();
        $a2a0b4ba09a5a00a$var$flushSpawnedWork();
    }
}
function $a2a0b4ba09a5a00a$var$flushMutationEffects() {
    if (1 === $a2a0b4ba09a5a00a$var$pendingEffectsStatus) {
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0;
        var root = $a2a0b4ba09a5a00a$var$pendingEffectsRoot, finishedWork = $a2a0b4ba09a5a00a$var$pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
            $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
            var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
            $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a2a0b4ba09a5a00a$var$executionContext;
            $a2a0b4ba09a5a00a$var$executionContext |= 4;
            try {
                $a2a0b4ba09a5a00a$var$commitMutationEffectsOnFiber(finishedWork, root);
                var priorSelectionInformation = $a2a0b4ba09a5a00a$var$selectionInformation, curFocusedElem = $a2a0b4ba09a5a00a$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $a2a0b4ba09a5a00a$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $a2a0b4ba09a5a00a$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $a2a0b4ba09a5a00a$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $a2a0b4ba09a5a00a$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $a2a0b4ba09a5a00a$var$_enabled = !!$a2a0b4ba09a5a00a$var$eventsEnabled;
                $a2a0b4ba09a5a00a$var$selectionInformation = $a2a0b4ba09a5a00a$var$eventsEnabled = null;
            } finally{
                $a2a0b4ba09a5a00a$var$executionContext = prevExecutionContext, $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 2;
    }
}
function $a2a0b4ba09a5a00a$var$flushLayoutEffects() {
    if (2 === $a2a0b4ba09a5a00a$var$pendingEffectsStatus) {
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0;
        var root = $a2a0b4ba09a5a00a$var$pendingEffectsRoot, finishedWork = $a2a0b4ba09a5a00a$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
            $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
            var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
            $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $a2a0b4ba09a5a00a$var$executionContext;
            $a2a0b4ba09a5a00a$var$executionContext |= 4;
            try {
                $a2a0b4ba09a5a00a$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $a2a0b4ba09a5a00a$var$executionContext = prevExecutionContext, $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 3;
    }
}
function $a2a0b4ba09a5a00a$var$flushSpawnedWork() {
    if (4 === $a2a0b4ba09a5a00a$var$pendingEffectsStatus || 3 === $a2a0b4ba09a5a00a$var$pendingEffectsStatus) {
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0;
        $a2a0b4ba09a5a00a$var$requestPaint();
        var root = $a2a0b4ba09a5a00a$var$pendingEffectsRoot, finishedWork = $a2a0b4ba09a5a00a$var$pendingFinishedWork, lanes = $a2a0b4ba09a5a00a$var$pendingEffectsLanes, recoverableErrors = $a2a0b4ba09a5a00a$var$pendingRecoverableErrors;
        0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 5 : ($a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0, $a2a0b4ba09a5a00a$var$pendingFinishedWork = $a2a0b4ba09a5a00a$var$pendingEffectsRoot = null, $a2a0b4ba09a5a00a$var$releaseRootPooledCache(root, root.pendingLanes));
        var remainingLanes = root.pendingLanes;
        0 === remainingLanes && ($a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $a2a0b4ba09a5a00a$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($a2a0b4ba09a5a00a$var$injectedHook && "function" === typeof $a2a0b4ba09a5a00a$var$injectedHook.onCommitFiberRoot) try {
            $a2a0b4ba09a5a00a$var$injectedHook.onCommitFiberRoot($a2a0b4ba09a5a00a$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
            remainingLanes = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
            $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 2;
            $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = finishedWork, $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = remainingLanes;
            }
        }
        0 !== ($a2a0b4ba09a5a00a$var$pendingEffectsLanes & 3) && $a2a0b4ba09a5a00a$var$flushPendingEffects();
        $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root);
        remainingLanes = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root === $a2a0b4ba09a5a00a$var$rootWithNestedUpdates ? $a2a0b4ba09a5a00a$var$nestedUpdateCount++ : ($a2a0b4ba09a5a00a$var$nestedUpdateCount = 0, $a2a0b4ba09a5a00a$var$rootWithNestedUpdates = root) : $a2a0b4ba09a5a00a$var$nestedUpdateCount = 0;
        $a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $a2a0b4ba09a5a00a$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $a2a0b4ba09a5a00a$var$releaseCache(remainingLanes)));
}
function $a2a0b4ba09a5a00a$var$flushPendingEffects() {
    $a2a0b4ba09a5a00a$var$flushMutationEffects();
    $a2a0b4ba09a5a00a$var$flushLayoutEffects();
    $a2a0b4ba09a5a00a$var$flushSpawnedWork();
    return $a2a0b4ba09a5a00a$var$flushPassiveEffects();
}
function $a2a0b4ba09a5a00a$var$flushPassiveEffects() {
    if (5 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus) return !1;
    var root = $a2a0b4ba09a5a00a$var$pendingEffectsRoot, remainingLanes = $a2a0b4ba09a5a00a$var$pendingEffectsRemainingLanes;
    $a2a0b4ba09a5a00a$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $a2a0b4ba09a5a00a$var$lanesToEventPriority($a2a0b4ba09a5a00a$var$pendingEffectsLanes), prevTransition = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T, previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    try {
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
        renderPriority = $a2a0b4ba09a5a00a$var$pendingPassiveTransitions;
        $a2a0b4ba09a5a00a$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $a2a0b4ba09a5a00a$var$pendingEffectsRoot, lanes = $a2a0b4ba09a5a00a$var$pendingEffectsLanes;
        $a2a0b4ba09a5a00a$var$pendingEffectsStatus = 0;
        $a2a0b4ba09a5a00a$var$pendingFinishedWork = $a2a0b4ba09a5a00a$var$pendingEffectsRoot = null;
        $a2a0b4ba09a5a00a$var$pendingEffectsLanes = 0;
        if (0 !== ($a2a0b4ba09a5a00a$var$executionContext & 6)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(331));
        var prevExecutionContext = $a2a0b4ba09a5a00a$var$executionContext;
        $a2a0b4ba09a5a00a$var$executionContext |= 4;
        $a2a0b4ba09a5a00a$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $a2a0b4ba09a5a00a$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $a2a0b4ba09a5a00a$var$executionContext = prevExecutionContext;
        $a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($a2a0b4ba09a5a00a$var$injectedHook && "function" === typeof $a2a0b4ba09a5a00a$var$injectedHook.onPostCommitFiberRoot) try {
            $a2a0b4ba09a5a00a$var$injectedHook.onPostCommitFiberRoot($a2a0b4ba09a5a00a$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = prevTransition, $a2a0b4ba09a5a00a$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $a2a0b4ba09a5a00a$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $a2a0b4ba09a5a00a$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $a2a0b4ba09a5a00a$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($a2a0b4ba09a5a00a$var$markRootUpdated$1(rootFiber, 2), $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(rootFiber));
}
function $a2a0b4ba09a5a00a$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $a2a0b4ba09a5a00a$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $a2a0b4ba09a5a00a$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed || !$a2a0b4ba09a5a00a$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $a2a0b4ba09a5a00a$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $a2a0b4ba09a5a00a$var$createClassErrorUpdate(2);
                instance = $a2a0b4ba09a5a00a$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($a2a0b4ba09a5a00a$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $a2a0b4ba09a5a00a$var$markRootUpdated$1(instance, 2), $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $a2a0b4ba09a5a00a$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $a2a0b4ba09a5a00a$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($a2a0b4ba09a5a00a$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $a2a0b4ba09a5a00a$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $a2a0b4ba09a5a00a$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $a2a0b4ba09a5a00a$var$workInProgressRoot === root && ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus || 3 === $a2a0b4ba09a5a00a$var$workInProgressRootExitStatus && ($a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes & 62914560) === $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes && 300 > $a2a0b4ba09a5a00a$var$now() - $a2a0b4ba09a5a00a$var$globalMostRecentFallbackTime ? 0 === ($a2a0b4ba09a5a00a$var$executionContext & 2) && $a2a0b4ba09a5a00a$var$prepareFreshStack(root, 0) : $a2a0b4ba09a5a00a$var$workInProgressRootPingedLanes |= pingedLanes, $a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes === $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes && ($a2a0b4ba09a5a00a$var$workInProgressSuspendedRetryLanes = 0));
    $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root);
}
function $a2a0b4ba09a5a00a$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $a2a0b4ba09a5a00a$var$claimNextRetryLane());
    boundaryFiber = $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($a2a0b4ba09a5a00a$var$markRootUpdated$1(boundaryFiber, retryLane), $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(boundaryFiber));
}
function $a2a0b4ba09a5a00a$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $a2a0b4ba09a5a00a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a2a0b4ba09a5a00a$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $a2a0b4ba09a5a00a$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $a2a0b4ba09a5a00a$var$scheduleCallback$1(priorityLevel, callback) {
    return $a2a0b4ba09a5a00a$var$scheduleCallback$3(priorityLevel, callback);
}
var $a2a0b4ba09a5a00a$var$firstScheduledRoot = null, $a2a0b4ba09a5a00a$var$lastScheduledRoot = null, $a2a0b4ba09a5a00a$var$didScheduleMicrotask = !1, $a2a0b4ba09a5a00a$var$mightHavePendingSyncWork = !1, $a2a0b4ba09a5a00a$var$isFlushingWork = !1, $a2a0b4ba09a5a00a$var$currentEventTransitionLane = 0;
function $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(root) {
    root !== $a2a0b4ba09a5a00a$var$lastScheduledRoot && null === root.next && (null === $a2a0b4ba09a5a00a$var$lastScheduledRoot ? $a2a0b4ba09a5a00a$var$firstScheduledRoot = $a2a0b4ba09a5a00a$var$lastScheduledRoot = root : $a2a0b4ba09a5a00a$var$lastScheduledRoot = $a2a0b4ba09a5a00a$var$lastScheduledRoot.next = root);
    $a2a0b4ba09a5a00a$var$mightHavePendingSyncWork = !0;
    $a2a0b4ba09a5a00a$var$didScheduleMicrotask || ($a2a0b4ba09a5a00a$var$didScheduleMicrotask = !0, $a2a0b4ba09a5a00a$var$scheduleImmediateRootScheduleTask());
}
function $a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$a2a0b4ba09a5a00a$var$isFlushingWork && $a2a0b4ba09a5a00a$var$mightHavePendingSyncWork) {
        $a2a0b4ba09a5a00a$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$170 = $a2a0b4ba09a5a00a$var$firstScheduledRoot; null !== root$170;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$170.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $a2a0b4ba09a5a00a$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $a2a0b4ba09a5a00a$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$getNextLanes(root$170, root$170 === $a2a0b4ba09a5a00a$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = !0, $a2a0b4ba09a5a00a$var$performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
                }
                root$170 = root$170.next;
            }
        }while (didPerformSomeWork);
        $a2a0b4ba09a5a00a$var$isFlushingWork = !1;
    }
}
function $a2a0b4ba09a5a00a$var$processRootScheduleInImmediateTask() {
    $a2a0b4ba09a5a00a$var$processRootScheduleInMicrotask();
}
function $a2a0b4ba09a5a00a$var$processRootScheduleInMicrotask() {
    $a2a0b4ba09a5a00a$var$mightHavePendingSyncWork = $a2a0b4ba09a5a00a$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $a2a0b4ba09a5a00a$var$currentEventTransitionLane && $a2a0b4ba09a5a00a$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $a2a0b4ba09a5a00a$var$currentEventTransitionLane);
    for(var currentTime = $a2a0b4ba09a5a00a$var$now(), prev = null, root = $a2a0b4ba09a5a00a$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $a2a0b4ba09a5a00a$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $a2a0b4ba09a5a00a$var$firstScheduledRoot = next : prev.next = next, null === next && ($a2a0b4ba09a5a00a$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $a2a0b4ba09a5a00a$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus && 5 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus || $a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $a2a0b4ba09a5a00a$var$currentEventTransitionLane && ($a2a0b4ba09a5a00a$var$currentEventTransitionLane = 0);
}
function $a2a0b4ba09a5a00a$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $a2a0b4ba09a5a00a$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $a2a0b4ba09a5a00a$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $a2a0b4ba09a5a00a$var$workInProgressRoot;
    suspendedLanes = $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes;
    suspendedLanes = $a2a0b4ba09a5a00a$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason || 9 === $a2a0b4ba09a5a00a$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $a2a0b4ba09a5a00a$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $a2a0b4ba09a5a00a$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $a2a0b4ba09a5a00a$var$cancelCallback$1(pingedLanes);
        switch($a2a0b4ba09a5a00a$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $a2a0b4ba09a5a00a$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $a2a0b4ba09a5a00a$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $a2a0b4ba09a5a00a$var$IdlePriority;
                break;
            default:
                suspendedLanes = $a2a0b4ba09a5a00a$var$NormalPriority$1;
        }
        pingedLanes = $a2a0b4ba09a5a00a$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $a2a0b4ba09a5a00a$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $a2a0b4ba09a5a00a$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $a2a0b4ba09a5a00a$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus && 5 !== $a2a0b4ba09a5a00a$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($a2a0b4ba09a5a00a$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $a2a0b4ba09a5a00a$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $a2a0b4ba09a5a00a$var$getNextLanes(root, root === $a2a0b4ba09a5a00a$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $a2a0b4ba09a5a00a$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $a2a0b4ba09a5a00a$var$scheduleTaskForRootDuringMicrotask(root, $a2a0b4ba09a5a00a$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $a2a0b4ba09a5a00a$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $a2a0b4ba09a5a00a$var$performSyncWorkOnRoot(root, lanes) {
    if ($a2a0b4ba09a5a00a$var$flushPendingEffects()) return null;
    $a2a0b4ba09a5a00a$var$performWorkOnRoot(root, lanes, !0);
}
function $a2a0b4ba09a5a00a$var$scheduleImmediateRootScheduleTask() {
    $a2a0b4ba09a5a00a$var$scheduleMicrotask(function() {
        0 !== ($a2a0b4ba09a5a00a$var$executionContext & 6) ? $a2a0b4ba09a5a00a$var$scheduleCallback$3($a2a0b4ba09a5a00a$var$ImmediatePriority, $a2a0b4ba09a5a00a$var$processRootScheduleInImmediateTask) : $a2a0b4ba09a5a00a$var$processRootScheduleInMicrotask();
    });
}
function $a2a0b4ba09a5a00a$var$requestTransitionLane() {
    if (0 === $a2a0b4ba09a5a00a$var$currentEventTransitionLane) {
        var actionScopeLane = $a2a0b4ba09a5a00a$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $a2a0b4ba09a5a00a$var$nextTransitionUpdateLane, $a2a0b4ba09a5a00a$var$nextTransitionUpdateLane <<= 1, 0 === ($a2a0b4ba09a5a00a$var$nextTransitionUpdateLane & 261888) && ($a2a0b4ba09a5a00a$var$nextTransitionUpdateLane = 256));
        $a2a0b4ba09a5a00a$var$currentEventTransitionLane = actionScopeLane;
    }
    return $a2a0b4ba09a5a00a$var$currentEventTransitionLane;
}
function $a2a0b4ba09a5a00a$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === (typeof actionProp === "undefined" ? "undefined" : (0, $2bfPH._)(actionProp)) || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $a2a0b4ba09a5a00a$var$sanitizeURL("" + actionProp);
}
function $a2a0b4ba09a5a00a$var$createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
}
function $a2a0b4ba09a5a00a$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $a2a0b4ba09a5a00a$var$coerceFormActionProp((nativeEventTarget[$a2a0b4ba09a5a00a$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$a2a0b4ba09a5a00a$var$internalPropsKey] || null) ? $a2a0b4ba09a5a00a$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $a2a0b4ba09a5a00a$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function listener() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $a2a0b4ba09a5a00a$var$currentEventTransitionLane) {
                                var formData = submitter ? $a2a0b4ba09a5a00a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                                $a2a0b4ba09a5a00a$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = submitter ? $a2a0b4ba09a5a00a$var$createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), $a2a0b4ba09a5a00a$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $a2a0b4ba09a5a00a$var$i$jscomp$inline_1577 = 0; $a2a0b4ba09a5a00a$var$i$jscomp$inline_1577 < $a2a0b4ba09a5a00a$var$simpleEventPluginEvents.length; $a2a0b4ba09a5a00a$var$i$jscomp$inline_1577++){
    var $a2a0b4ba09a5a00a$var$eventName$jscomp$inline_1578 = $a2a0b4ba09a5a00a$var$simpleEventPluginEvents[$a2a0b4ba09a5a00a$var$i$jscomp$inline_1577], $a2a0b4ba09a5a00a$var$domEventName$jscomp$inline_1579 = $a2a0b4ba09a5a00a$var$eventName$jscomp$inline_1578.toLowerCase(), $a2a0b4ba09a5a00a$var$capitalizedEvent$jscomp$inline_1580 = $a2a0b4ba09a5a00a$var$eventName$jscomp$inline_1578[0].toUpperCase() + $a2a0b4ba09a5a00a$var$eventName$jscomp$inline_1578.slice(1);
    $a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$domEventName$jscomp$inline_1579, "on" + $a2a0b4ba09a5a00a$var$capitalizedEvent$jscomp$inline_1580);
}
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$ANIMATION_END, "onAnimationEnd");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$ANIMATION_ITERATION, "onAnimationIteration");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$ANIMATION_START, "onAnimationStart");
$a2a0b4ba09a5a00a$var$registerSimpleEvent("dblclick", "onDoubleClick");
$a2a0b4ba09a5a00a$var$registerSimpleEvent("focusin", "onFocus");
$a2a0b4ba09a5a00a$var$registerSimpleEvent("focusout", "onBlur");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$TRANSITION_RUN, "onTransitionRun");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$TRANSITION_START, "onTransitionStart");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$TRANSITION_CANCEL, "onTransitionCancel");
$a2a0b4ba09a5a00a$var$registerSimpleEvent($a2a0b4ba09a5a00a$var$TRANSITION_END, "onTransitionEnd");
$a2a0b4ba09a5a00a$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$a2a0b4ba09a5a00a$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$a2a0b4ba09a5a00a$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$a2a0b4ba09a5a00a$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$a2a0b4ba09a5a00a$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $a2a0b4ba09a5a00a$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $a2a0b4ba09a5a00a$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($a2a0b4ba09a5a00a$var$mediaEventTypes));
function $a2a0b4ba09a5a00a$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $a2a0b4ba09a5a00a$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$a2a0b4ba09a5a00a$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$a2a0b4ba09a5a00a$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($a2a0b4ba09a5a00a$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $a2a0b4ba09a5a00a$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $a2a0b4ba09a5a00a$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $a2a0b4ba09a5a00a$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $a2a0b4ba09a5a00a$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$a2a0b4ba09a5a00a$var$listeningMarker]) {
        rootContainerElement[$a2a0b4ba09a5a00a$var$listeningMarker] = !0;
        $a2a0b4ba09a5a00a$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($a2a0b4ba09a5a00a$var$nonDelegatedEvents.has(domEventName) || $a2a0b4ba09a5a00a$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $a2a0b4ba09a5a00a$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$a2a0b4ba09a5a00a$var$listeningMarker] || (ownerDocument[$a2a0b4ba09a5a00a$var$listeningMarker] = !0, $a2a0b4ba09a5a00a$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $a2a0b4ba09a5a00a$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($a2a0b4ba09a5a00a$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $a2a0b4ba09a5a00a$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $a2a0b4ba09a5a00a$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $a2a0b4ba09a5a00a$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$a2a0b4ba09a5a00a$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $a2a0b4ba09a5a00a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $a2a0b4ba09a5a00a$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $a2a0b4ba09a5a00a$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $a2a0b4ba09a5a00a$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $a2a0b4ba09a5a00a$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticTouchEvent;
                        break;
                    case $a2a0b4ba09a5a00a$var$ANIMATION_END:
                    case $a2a0b4ba09a5a00a$var$ANIMATION_ITERATION:
                    case $a2a0b4ba09a5a00a$var$ANIMATION_START:
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticAnimationEvent;
                        break;
                    case $a2a0b4ba09a5a00a$var$TRANSITION_END:
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticPointerEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $a2a0b4ba09a5a00a$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $a2a0b4ba09a5a00a$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($a2a0b4ba09a5a00a$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                reactName = "mouseover" === domEventName || "pointerover" === domEventName;
                SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
                if (reactName && nativeEvent !== $a2a0b4ba09a5a00a$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey])) break a;
                if (SyntheticEventCtor || reactName) {
                    reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
                    if (SyntheticEventCtor) {
                        if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = $a2a0b4ba09a5a00a$var$getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) reactEventType = null;
                    } else SyntheticEventCtor = null, reactEventType = targetInst;
                    if (SyntheticEventCtor !== reactEventType) {
                        inCapturePhase = $a2a0b4ba09a5a00a$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $a2a0b4ba09a5a00a$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == SyntheticEventCtor ? reactName : $a2a0b4ba09a5a00a$var$getNodeFromInstance(SyntheticEventCtor);
                        lastHostComponent = null == reactEventType ? reactName : $a2a0b4ba09a5a00a$var$getNodeFromInstance(reactEventType);
                        reactName = new inCapturePhase(_instance, instance + "leave", SyntheticEventCtor, nativeEvent, nativeEventTarget);
                        reactName.target = accumulateTargetOnly;
                        reactName.relatedTarget = lastHostComponent;
                        _instance = null;
                        $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", reactEventType, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        if (SyntheticEventCtor && reactEventType) b: {
                            inCapturePhase = $a2a0b4ba09a5a00a$var$getParent;
                            reactEventName = SyntheticEventCtor;
                            instance = reactEventType;
                            lastHostComponent = 0;
                            for(_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))lastHostComponent++;
                            _instance = 0;
                            for(var tempB = instance; tempB; tempB = inCapturePhase(tempB))_instance++;
                            for(; 0 < lastHostComponent - _instance;)reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                            for(; 0 < _instance - lastHostComponent;)instance = inCapturePhase(instance), _instance--;
                            for(; lastHostComponent--;){
                                if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                                    inCapturePhase = reactEventName;
                                    break b;
                                }
                                reactEventName = inCapturePhase(reactEventName);
                                instance = inCapturePhase(instance);
                            }
                            inCapturePhase = null;
                        }
                        else inCapturePhase = null;
                        null !== SyntheticEventCtor && $a2a0b4ba09a5a00a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactName, SyntheticEventCtor, inCapturePhase, !1);
                        null !== reactEventType && null !== accumulateTargetOnly && $a2a0b4ba09a5a00a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, reactEventType, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $a2a0b4ba09a5a00a$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $a2a0b4ba09a5a00a$var$getTargetInstForChangeEvent;
                else if ($a2a0b4ba09a5a00a$var$isTextInputElement(reactName)) {
                    if ($a2a0b4ba09a5a00a$var$isInputEventSupported) getTargetInstFunc = $a2a0b4ba09a5a00a$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $a2a0b4ba09a5a00a$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $a2a0b4ba09a5a00a$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $a2a0b4ba09a5a00a$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $a2a0b4ba09a5a00a$var$getTargetInstForChangeEvent) : getTargetInstFunc = $a2a0b4ba09a5a00a$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $a2a0b4ba09a5a00a$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
                "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && $a2a0b4ba09a5a00a$var$setDefaultValue(reactName, "number", reactName.value);
            }
            handleEventFunc = targetInst ? $a2a0b4ba09a5a00a$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($a2a0b4ba09a5a00a$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $a2a0b4ba09a5a00a$var$activeElement = handleEventFunc, $a2a0b4ba09a5a00a$var$activeElementInst = targetInst, $a2a0b4ba09a5a00a$var$lastSelection = null;
                    break;
                case "focusout":
                    $a2a0b4ba09a5a00a$var$lastSelection = $a2a0b4ba09a5a00a$var$activeElementInst = $a2a0b4ba09a5a00a$var$activeElement = null;
                    break;
                case "mousedown":
                    $a2a0b4ba09a5a00a$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $a2a0b4ba09a5a00a$var$mouseDown = !1;
                    $a2a0b4ba09a5a00a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($a2a0b4ba09a5a00a$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $a2a0b4ba09a5a00a$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($a2a0b4ba09a5a00a$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $a2a0b4ba09a5a00a$var$isComposing ? $a2a0b4ba09a5a00a$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($a2a0b4ba09a5a00a$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($a2a0b4ba09a5a00a$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $a2a0b4ba09a5a00a$var$isComposing && (fallbackData = $a2a0b4ba09a5a00a$var$getData()) : ($a2a0b4ba09a5a00a$var$root = nativeEventTarget, $a2a0b4ba09a5a00a$var$startText = "value" in $a2a0b4ba09a5a00a$var$root ? $a2a0b4ba09a5a00a$var$root.value : $a2a0b4ba09a5a00a$var$root.textContent, $a2a0b4ba09a5a00a$var$isComposing = !0)), handleEventFunc = $a2a0b4ba09a5a00a$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $a2a0b4ba09a5a00a$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $a2a0b4ba09a5a00a$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $a2a0b4ba09a5a00a$var$canUseTextInputEvent ? $a2a0b4ba09a5a00a$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $a2a0b4ba09a5a00a$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $a2a0b4ba09a5a00a$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $a2a0b4ba09a5a00a$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $a2a0b4ba09a5a00a$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $a2a0b4ba09a5a00a$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $a2a0b4ba09a5a00a$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $a2a0b4ba09a5a00a$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $a2a0b4ba09a5a00a$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($a2a0b4ba09a5a00a$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $a2a0b4ba09a5a00a$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($a2a0b4ba09a5a00a$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $a2a0b4ba09a5a00a$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $a2a0b4ba09a5a00a$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $a2a0b4ba09a5a00a$var$getListener(target, registrationName), null != stateNode && listeners.unshift($a2a0b4ba09a5a00a$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $a2a0b4ba09a5a00a$var$getListener(target, registrationName), null != stateNode && listeners.push($a2a0b4ba09a5a00a$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $a2a0b4ba09a5a00a$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $a2a0b4ba09a5a00a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $a2a0b4ba09a5a00a$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($a2a0b4ba09a5a00a$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($a2a0b4ba09a5a00a$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $a2a0b4ba09a5a00a$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $a2a0b4ba09a5a00a$var$normalizeMarkupForTextOrAttribute(clientText);
    return $a2a0b4ba09a5a00a$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $a2a0b4ba09a5a00a$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            "string" === typeof value ? "body" === tag || "textarea" === tag && "" === value || $a2a0b4ba09a5a00a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value))) && "body" !== tag && $a2a0b4ba09a5a00a$var$setTextContent(domElement, "" + value);
            break;
        case "className":
            $a2a0b4ba09a5a00a$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $a2a0b4ba09a5a00a$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $a2a0b4ba09a5a00a$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $a2a0b4ba09a5a00a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "data":
            if ("object" !== tag) {
                $a2a0b4ba09a5a00a$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a2a0b4ba09a5a00a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "name", props.name, props, null), $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($a2a0b4ba09a5a00a$var$setProp(domElement, tag, "encType", props.encType, props, null), $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "method", props.method, props, null), $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $a2a0b4ba09a5a00a$var$sanitizeURL("" + value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a2a0b4ba09a5a00a$var$noop$1);
            break;
        case "onScroll":
            null != value && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) || !("__html" in value)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value));
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value));
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value))) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $a2a0b4ba09a5a00a$var$sanitizeURL("" + value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("toggle", domElement);
            $a2a0b4ba09a5a00a$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $a2a0b4ba09a5a00a$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $a2a0b4ba09a5a00a$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $a2a0b4ba09a5a00a$var$aliases.get(key) || key, $a2a0b4ba09a5a00a$var$setValueForAttribute(domElement, key, value);
    }
}
function $a2a0b4ba09a5a00a$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $a2a0b4ba09a5a00a$var$setValueForStyles(domElement, value, prevValue);
            break;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) || !("__html" in value)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(60));
                    domElement.innerHTML = key;
                }
            }
            break;
        case "children":
            "string" === typeof value ? $a2a0b4ba09a5a00a$var$setTextContent(domElement, value) : ("number" === typeof value || "bigint" === (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value))) && $a2a0b4ba09a5a00a$var$setTextContent(domElement, "" + value);
            break;
        case "onScroll":
            null != value && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scroll", domElement);
            break;
        case "onScrollEnd":
            null != value && $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("scrollend", domElement);
            break;
        case "onClick":
            null != value && (domElement.onclick = $a2a0b4ba09a5a00a$var$noop$1);
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            break;
        case "innerText":
        case "textContent":
            break;
        default:
            if (!$a2a0b4ba09a5a00a$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), tag = key.slice(2, props ? key.length - 7 : void 0), prevValue = domElement[$a2a0b4ba09a5a00a$var$internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag, prevValue, props), "function" === typeof value)) {
                    "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(tag, value, props);
                    break a;
                }
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $a2a0b4ba09a5a00a$var$setValueForAttribute(domElement, key, value);
            }
    }
}
function $a2a0b4ba09a5a00a$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("error", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(137, tag));
                    default:
                        $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$184 = props[hasSrc];
                if (null != propValue$184) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$184;
                        break;
                    case "type":
                        propValue = propValue$184;
                        break;
                    case "checked":
                        checked = propValue$184;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$184;
                        break;
                    case "value":
                        propKey = propValue$184;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$184;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$184) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $a2a0b4ba09a5a00a$var$setProp(domElement, tag, hasSrc, propValue$184, props, null);
                }
            }
            $a2a0b4ba09a5a00a$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $a2a0b4ba09a5a00a$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $a2a0b4ba09a5a00a$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(91));
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $a2a0b4ba09a5a00a$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== (typeof hasSrc === "undefined" ? "undefined" : (0, $2bfPH._)(hasSrc));
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("toggle", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("cancel", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $a2a0b4ba09a5a00a$var$mediaEventTypes.length; hasSrc++)$a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent($a2a0b4ba09a5a00a$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("error", domElement);
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("error", domElement), $a2a0b4ba09a5a00a$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(137, tag));
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($a2a0b4ba09a5a00a$var$isCustomElement(tag)) {
                for(propValue$184 in props)props.hasOwnProperty(propValue$184) && (hasSrc = props[propValue$184], void 0 !== hasSrc && $a2a0b4ba09a5a00a$var$setPropOnCustomElement(domElement, tag, propValue$184, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
function $a2a0b4ba09a5a00a$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$201 in nextProps){
                var propKey = nextProps[propKey$201];
                lastProp = lastProps[propKey$201];
                if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp)) switch(propKey$201){
                    case "type":
                        type = propKey;
                        break;
                    case "name":
                        name = propKey;
                        break;
                    case "checked":
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        defaultChecked = propKey;
                        break;
                    case "value":
                        value = propKey;
                        break;
                    case "defaultValue":
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey$201, propKey, nextProps, lastProp);
                }
            }
            $a2a0b4ba09a5a00a$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$201 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $a2a0b4ba09a5a00a$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    propKey$201 = type;
                    break;
                case "defaultValue":
                    defaultValue = type;
                    break;
                case "multiple":
                    value = type;
                default:
                    type !== lastDefaultValue && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$201 ? $a2a0b4ba09a5a00a$var$updateOptions(domElement, !!lastProps, propKey$201, !1) : !!nextProps !== !!lastProps && (null != tag ? $a2a0b4ba09a5a00a$var$updateOptions(domElement, !!lastProps, tag, !0) : $a2a0b4ba09a5a00a$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$201 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    propKey$201 = name;
                    break;
                case "defaultValue":
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $a2a0b4ba09a5a00a$var$updateTextarea(domElement, propKey$201, propKey);
            return;
        case "option":
            for(var propKey$217 in lastProps)if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217)) switch(propKey$217){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey$217, null, nextProps, propKey$201);
            }
            for(lastDefaultValue in nextProps)if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== (typeof propKey$201 === "undefined" ? "undefined" : (0, $2bfPH._)(propKey$201));
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, lastDefaultValue, propKey$201, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$222 in lastProps)propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey$222, null, nextProps, propKey$201);
            for(checked in nextProps)if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$201) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $a2a0b4ba09a5a00a$var$setProp(domElement, tag, checked, propKey$201, nextProps, propKey);
            }
            return;
        default:
            if ($a2a0b4ba09a5a00a$var$isCustomElement(tag)) {
                for(var propKey$227 in lastProps)propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && $a2a0b4ba09a5a00a$var$setPropOnCustomElement(domElement, tag, propKey$227, void 0, nextProps, propKey$201);
                for(defaultChecked in nextProps)propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || $a2a0b4ba09a5a00a$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$201, nextProps, propKey);
                return;
            }
    }
    for(var propKey$232 in lastProps)propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && $a2a0b4ba09a5a00a$var$setProp(domElement, tag, propKey$232, null, nextProps, propKey$201);
    for(lastProp in nextProps)propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || $a2a0b4ba09a5a00a$var$setProp(domElement, tag, lastProp, propKey$201, nextProps, propKey);
}
function $a2a0b4ba09a5a00a$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $a2a0b4ba09a5a00a$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $a2a0b4ba09a5a00a$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $a2a0b4ba09a5a00a$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $a2a0b4ba09a5a00a$var$eventsEnabled = null, $a2a0b4ba09a5a00a$var$selectionInformation = null;
function $a2a0b4ba09a5a00a$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $a2a0b4ba09a5a00a$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $a2a0b4ba09a5a00a$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $a2a0b4ba09a5a00a$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === (0, $2bfPH._)(props.children) || "object" === (0, $2bfPH._)(props.dangerouslySetInnerHTML) && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $a2a0b4ba09a5a00a$var$currentPopstateTransitionEvent = null;
function $a2a0b4ba09a5a00a$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $a2a0b4ba09a5a00a$var$currentPopstateTransitionEvent) return !1;
        $a2a0b4ba09a5a00a$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $a2a0b4ba09a5a00a$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $a2a0b4ba09a5a00a$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $a2a0b4ba09a5a00a$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $a2a0b4ba09a5a00a$var$localPromise = "function" === typeof Promise ? Promise : void 0, $a2a0b4ba09a5a00a$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $a2a0b4ba09a5a00a$var$localPromise ? function scheduleMicrotask(callback) {
    return $a2a0b4ba09a5a00a$var$localPromise.resolve(null).then(callback).catch($a2a0b4ba09a5a00a$var$handleErrorInNextTick);
} : $a2a0b4ba09a5a00a$var$scheduleTimeout;
function $a2a0b4ba09a5a00a$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $a2a0b4ba09a5a00a$var$isSingletonScope(type) {
    return "head" === type;
}
function $a2a0b4ba09a5a00a$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $a2a0b4ba09a5a00a$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $a2a0b4ba09a5a00a$var$releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $a2a0b4ba09a5a00a$var$releaseSingletonInstance(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$a2a0b4ba09a5a00a$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $a2a0b4ba09a5a00a$var$releaseSingletonInstance(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $a2a0b4ba09a5a00a$var$retryIfBlockedOn(hydrationInstance);
}
function $a2a0b4ba09a5a00a$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $a2a0b4ba09a5a00a$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $a2a0b4ba09a5a00a$var$clearContainerSparingly(node);
                $a2a0b4ba09a5a00a$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $a2a0b4ba09a5a00a$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$a2a0b4ba09a5a00a$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $a2a0b4ba09a5a00a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $a2a0b4ba09a5a00a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $a2a0b4ba09a5a00a$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $a2a0b4ba09a5a00a$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $a2a0b4ba09a5a00a$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $a2a0b4ba09a5a00a$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $a2a0b4ba09a5a00a$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function listener1() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $a2a0b4ba09a5a00a$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $a2a0b4ba09a5a00a$var$previousHydratableOnEnteringScopedSingleton = null;
function $a2a0b4ba09a5a00a$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $a2a0b4ba09a5a00a$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $a2a0b4ba09a5a00a$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $a2a0b4ba09a5a00a$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(451));
    }
}
function $a2a0b4ba09a5a00a$var$releaseSingletonInstance(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $a2a0b4ba09a5a00a$var$detachDeletedInstance(instance);
}
var $a2a0b4ba09a5a00a$var$preloadPropsMap = new Map(), $a2a0b4ba09a5a00a$var$preconnectsSet = new Set();
function $a2a0b4ba09a5a00a$var$getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
}
var $a2a0b4ba09a5a00a$var$previousDispatcher = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.d;
$a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.d = {
    f: $a2a0b4ba09a5a00a$var$flushSyncWork,
    r: $a2a0b4ba09a5a00a$var$requestFormReset,
    D: $a2a0b4ba09a5a00a$var$prefetchDNS,
    C: $a2a0b4ba09a5a00a$var$preconnect,
    L: $a2a0b4ba09a5a00a$var$preload,
    m: $a2a0b4ba09a5a00a$var$preloadModule,
    X: $a2a0b4ba09a5a00a$var$preinitScript,
    S: $a2a0b4ba09a5a00a$var$preinitStyle,
    M: $a2a0b4ba09a5a00a$var$preinitModuleScript
};
function $a2a0b4ba09a5a00a$var$flushSyncWork() {
    var previousWasRendering = $a2a0b4ba09a5a00a$var$previousDispatcher.f(), wasRendering = $a2a0b4ba09a5a00a$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $a2a0b4ba09a5a00a$var$requestFormReset(form) {
    var formInst = $a2a0b4ba09a5a00a$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $a2a0b4ba09a5a00a$var$requestFormReset$1(formInst) : $a2a0b4ba09a5a00a$var$previousDispatcher.r(form);
}
var $a2a0b4ba09a5a00a$var$globalDocument = "undefined" === typeof document ? null : document;
function $a2a0b4ba09a5a00a$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $a2a0b4ba09a5a00a$var$preconnectsSet.has(limitedEscapedHref) || ($a2a0b4ba09a5a00a$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $a2a0b4ba09a5a00a$var$setInitialProperties(href, "link", rel), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $a2a0b4ba09a5a00a$var$prefetchDNS(href) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.D(href);
    $a2a0b4ba09a5a00a$var$preconnectAs("dns-prefetch", href, null);
}
function $a2a0b4ba09a5a00a$var$preconnect(href, crossOrigin) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.C(href, crossOrigin);
    $a2a0b4ba09a5a00a$var$preconnectAs("preconnect", href, crossOrigin);
}
function $a2a0b4ba09a5a00a$var$preload(href, as, options) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $a2a0b4ba09a5a00a$var$getStyleKey(href);
                break;
            case "script":
                key = $a2a0b4ba09a5a00a$var$getScriptKey(href);
        }
        $a2a0b4ba09a5a00a$var$preloadPropsMap.has(key) || (href = $a2a0b4ba09a5a00a$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $a2a0b4ba09a5a00a$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), $a2a0b4ba09a5a00a$var$setInitialProperties(as, "link", href), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
}
function $a2a0b4ba09a5a00a$var$preloadModule(href, options) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.m(href, options);
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $a2a0b4ba09a5a00a$var$getScriptKey(href);
        }
        if (!$a2a0b4ba09a5a00a$var$preloadPropsMap.has(key) && (href = $a2a0b4ba09a5a00a$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $a2a0b4ba09a5a00a$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $a2a0b4ba09a5a00a$var$setInitialProperties(as, "link", href);
            $a2a0b4ba09a5a00a$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $a2a0b4ba09a5a00a$var$preinitStyle(href, precedence, options) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $a2a0b4ba09a5a00a$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $a2a0b4ba09a5a00a$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(key)) && $a2a0b4ba09a5a00a$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $a2a0b4ba09a5a00a$var$markNodeAsHoistable(link);
                $a2a0b4ba09a5a00a$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $a2a0b4ba09a5a00a$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $a2a0b4ba09a5a00a$var$preinitScript(src, options) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.X(src, options);
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a2a0b4ba09a5a00a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(key)), resource || (src = $a2a0b4ba09a5a00a$var$assign({
            src: src,
            async: !0
        }, options), (options = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(key)) && $a2a0b4ba09a5a00a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(resource), $a2a0b4ba09a5a00a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a2a0b4ba09a5a00a$var$preinitModuleScript(src, options) {
    $a2a0b4ba09a5a00a$var$previousDispatcher.M(src, options);
    var ownerDocument = $a2a0b4ba09a5a00a$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $a2a0b4ba09a5a00a$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(key)), resource || (src = $a2a0b4ba09a5a00a$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(key)) && $a2a0b4ba09a5a00a$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(resource), $a2a0b4ba09a5a00a$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $a2a0b4ba09a5a00a$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $a2a0b4ba09a5a00a$var$rootInstanceStackCursor.current) ? $a2a0b4ba09a5a00a$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = $a2a0b4ba09a5a00a$var$getStyleKey(pendingProps.href), pendingProps = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $a2a0b4ba09a5a00a$var$getStyleKey(pendingProps.href);
                var styles$243 = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$244 = styles$243.get(type);
                resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector($a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(type))) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), $a2a0b4ba09a5a00a$var$preloadPropsMap.has(type) || (pendingProps = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $a2a0b4ba09a5a00a$var$preloadPropsMap.set(type, pendingProps), styles$243 || $a2a0b4ba09a5a00a$var$preloadStylesheet(JSCompiler_inline_result, type, pendingProps, resource$244.state)));
                if (currentProps && null === currentResource) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(528, ""));
                return resource$244;
            }
            if (currentProps && null !== currentResource) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== (typeof currentProps === "undefined" ? "undefined" : (0, $2bfPH._)(currentProps)) ? (currentProps = $a2a0b4ba09a5a00a$var$getScriptKey(pendingProps), pendingProps = $a2a0b4ba09a5a00a$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, pendingProps.set(currentProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(444, type));
    }
}
function $a2a0b4ba09a5a00a$var$getStyleKey(href) {
    return 'href="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $a2a0b4ba09a5a00a$var$stylesheetPropsFromRawProps(rawProps) {
    return $a2a0b4ba09a5a00a$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $a2a0b4ba09a5a00a$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= 1;
    }), key.addEventListener("error", function() {
        return state.loading |= 2;
    }), $a2a0b4ba09a5a00a$var$setInitialProperties(key, "link", preloadProps), $a2a0b4ba09a5a00a$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
}
function $a2a0b4ba09a5a00a$var$getScriptKey(src) {
    return '[src="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $a2a0b4ba09a5a00a$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $a2a0b4ba09a5a00a$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance), instance;
            var styleProps = $a2a0b4ba09a5a00a$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance);
            $a2a0b4ba09a5a00a$var$setInitialProperties(instance, "style", styleProps);
            $a2a0b4ba09a5a00a$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $a2a0b4ba09a5a00a$var$getStyleKey(props.href);
            var instance$249 = hoistableRoot.querySelector($a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$249) return resource.state.loading |= 4, resource.instance = instance$249, $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance$249), instance$249;
            instance = $a2a0b4ba09a5a00a$var$stylesheetPropsFromRawProps(props);
            (styleProps = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(styleProps)) && $a2a0b4ba09a5a00a$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance$249);
            var linkInstance = instance$249;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a2a0b4ba09a5a00a$var$setInitialProperties(instance$249, "link", instance);
            resource.state.loading |= 4;
            $a2a0b4ba09a5a00a$var$insertStylesheet(instance$249, props.precedence, hoistableRoot);
            return resource.instance = instance$249;
        case "script":
            instance$249 = $a2a0b4ba09a5a00a$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($a2a0b4ba09a5a00a$var$getScriptSelectorFromKey(instance$249))) return resource.instance = styleProps, $a2a0b4ba09a5a00a$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(instance$249)) instance = $a2a0b4ba09a5a00a$var$assign({}, props), $a2a0b4ba09a5a00a$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $a2a0b4ba09a5a00a$var$markNodeAsHoistable(styleProps);
            $a2a0b4ba09a5a00a$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $a2a0b4ba09a5a00a$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $a2a0b4ba09a5a00a$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $a2a0b4ba09a5a00a$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $a2a0b4ba09a5a00a$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $a2a0b4ba09a5a00a$var$tagCaches = null;
function $a2a0b4ba09a5a00a$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $a2a0b4ba09a5a00a$var$tagCaches) {
        var cache = new Map();
        var caches = $a2a0b4ba09a5a00a$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $a2a0b4ba09a5a00a$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$a2a0b4ba09a5a00a$var$internalHoistableMarker] || node[$a2a0b4ba09a5a00a$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $a2a0b4ba09a5a00a$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $a2a0b4ba09a5a00a$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== (0, $2bfPH._)(props.async) && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $a2a0b4ba09a5a00a$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $a2a0b4ba09a5a00a$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $a2a0b4ba09a5a00a$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($a2a0b4ba09a5a00a$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === (typeof hoistableRoot === "undefined" ? "undefined" : (0, $2bfPH._)(hoistableRoot)) && "function" === typeof hoistableRoot.then && (state.count++, state = $a2a0b4ba09a5a00a$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $a2a0b4ba09a5a00a$var$stylesheetPropsFromRawProps(props);
            (key = $a2a0b4ba09a5a00a$var$preloadPropsMap.get(key)) && $a2a0b4ba09a5a00a$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $a2a0b4ba09a5a00a$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $a2a0b4ba09a5a00a$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $a2a0b4ba09a5a00a$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $a2a0b4ba09a5a00a$var$estimatedBytesWithinLimit = 0;
function $a2a0b4ba09a5a00a$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $a2a0b4ba09a5a00a$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $a2a0b4ba09a5a00a$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $a2a0b4ba09a5a00a$var$estimatedBytesWithinLimit && ($a2a0b4ba09a5a00a$var$estimatedBytesWithinLimit = 62500 * $a2a0b4ba09a5a00a$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $a2a0b4ba09a5a00a$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $a2a0b4ba09a5a00a$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $a2a0b4ba09a5a00a$var$onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets) $a2a0b4ba09a5a00a$var$insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
            var unsuspend = this.unsuspend;
            this.unsuspend = null;
            unsuspend();
        }
    }
}
var $a2a0b4ba09a5a00a$var$precedencesByRoot = null;
function $a2a0b4ba09a5a00a$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $a2a0b4ba09a5a00a$var$precedencesByRoot = new Map(), resources.forEach($a2a0b4ba09a5a00a$var$insertStylesheetIntoRoot, state), $a2a0b4ba09a5a00a$var$precedencesByRoot = null, $a2a0b4ba09a5a00a$var$onUnsuspend.call(state));
}
function $a2a0b4ba09a5a00a$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $a2a0b4ba09a5a00a$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $a2a0b4ba09a5a00a$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $a2a0b4ba09a5a00a$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $a2a0b4ba09a5a00a$var$HostTransitionContext = {
    $$typeof: $a2a0b4ba09a5a00a$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $a2a0b4ba09a5a00a$var$sharedNotPendingObject,
    _currentValue2: $a2a0b4ba09a5a00a$var$sharedNotPendingObject,
    _threadCount: 0
};
function $a2a0b4ba09a5a00a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $a2a0b4ba09a5a00a$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $a2a0b4ba09a5a00a$var$createLaneMap(0);
    this.hiddenUpdates = $a2a0b4ba09a5a00a$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = new Map();
}
function $a2a0b4ba09a5a00a$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $a2a0b4ba09a5a00a$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $a2a0b4ba09a5a00a$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $a2a0b4ba09a5a00a$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $a2a0b4ba09a5a00a$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $a2a0b4ba09a5a00a$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $a2a0b4ba09a5a00a$var$emptyContextObject;
    parentComponent = $a2a0b4ba09a5a00a$var$emptyContextObject;
    return parentComponent;
}
function $a2a0b4ba09a5a00a$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $a2a0b4ba09a5a00a$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $a2a0b4ba09a5a00a$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $a2a0b4ba09a5a00a$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(element, rootFiber, lane), $a2a0b4ba09a5a00a$var$entangleTransitions(element, rootFiber, lane));
}
function $a2a0b4ba09a5a00a$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $a2a0b4ba09a5a00a$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $a2a0b4ba09a5a00a$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $a2a0b4ba09a5a00a$var$markRetryLaneImpl(fiber, retryLane);
}
function $a2a0b4ba09a5a00a$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $a2a0b4ba09a5a00a$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $a2a0b4ba09a5a00a$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $a2a0b4ba09a5a00a$var$requestUpdateLane();
        lane = $a2a0b4ba09a5a00a$var$getBumpedLaneForHydrationByLane(lane);
        var root = $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root, fiber, lane);
        $a2a0b4ba09a5a00a$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $a2a0b4ba09a5a00a$var$_enabled = !0;
function $a2a0b4ba09a5a00a$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
    var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    try {
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 2, $a2a0b4ba09a5a00a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a2a0b4ba09a5a00a$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $a2a0b4ba09a5a00a$var$ReactSharedInternals.T;
    $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = null;
    var previousPriority = $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p;
    try {
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = 8, $a2a0b4ba09a5a00a$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.p = previousPriority, $a2a0b4ba09a5a00a$var$ReactSharedInternals.T = prevTransition;
    }
}
function $a2a0b4ba09a5a00a$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($a2a0b4ba09a5a00a$var$_enabled) {
        var blockedOn = $a2a0b4ba09a5a00a$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $a2a0b4ba09a5a00a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a2a0b4ba09a5a00a$var$return_targetInst, targetContainer), $a2a0b4ba09a5a00a$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($a2a0b4ba09a5a00a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($a2a0b4ba09a5a00a$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $a2a0b4ba09a5a00a$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $a2a0b4ba09a5a00a$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $a2a0b4ba09a5a00a$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $a2a0b4ba09a5a00a$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(fiber);
                                0 === ($a2a0b4ba09a5a00a$var$executionContext & 6) && ($a2a0b4ba09a5a00a$var$workInProgressRootRenderTargetTime = $a2a0b4ba09a5a00a$var$now() + 500, $a2a0b4ba09a5a00a$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $a2a0b4ba09a5a00a$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $a2a0b4ba09a5a00a$var$scheduleUpdateOnFiber(root, fiber, 2), $a2a0b4ba09a5a00a$var$flushSyncWork$1(), $a2a0b4ba09a5a00a$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $a2a0b4ba09a5a00a$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $a2a0b4ba09a5a00a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $a2a0b4ba09a5a00a$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $a2a0b4ba09a5a00a$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $a2a0b4ba09a5a00a$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $a2a0b4ba09a5a00a$var$getEventTarget(nativeEvent);
    return $a2a0b4ba09a5a00a$var$findInstanceBlockingTarget(nativeEvent);
}
var $a2a0b4ba09a5a00a$var$return_targetInst = null;
function $a2a0b4ba09a5a00a$var$findInstanceBlockingTarget(targetNode) {
    $a2a0b4ba09a5a00a$var$return_targetInst = null;
    targetNode = $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $a2a0b4ba09a5a00a$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $a2a0b4ba09a5a00a$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $a2a0b4ba09a5a00a$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $a2a0b4ba09a5a00a$var$return_targetInst = targetNode;
    return null;
}
function $a2a0b4ba09a5a00a$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($a2a0b4ba09a5a00a$var$getCurrentPriorityLevel()){
                case $a2a0b4ba09a5a00a$var$ImmediatePriority:
                    return 2;
                case $a2a0b4ba09a5a00a$var$UserBlockingPriority:
                    return 8;
                case $a2a0b4ba09a5a00a$var$NormalPriority$1:
                case $a2a0b4ba09a5a00a$var$LowPriority:
                    return 32;
                case $a2a0b4ba09a5a00a$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $a2a0b4ba09a5a00a$var$hasScheduledReplayAttempt = !1, $a2a0b4ba09a5a00a$var$queuedFocus = null, $a2a0b4ba09a5a00a$var$queuedDrag = null, $a2a0b4ba09a5a00a$var$queuedMouse = null, $a2a0b4ba09a5a00a$var$queuedPointers = new Map(), $a2a0b4ba09a5a00a$var$queuedPointerCaptures = new Map(), $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets = [], $a2a0b4ba09a5a00a$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $a2a0b4ba09a5a00a$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $a2a0b4ba09a5a00a$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $a2a0b4ba09a5a00a$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $a2a0b4ba09a5a00a$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $a2a0b4ba09a5a00a$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $a2a0b4ba09a5a00a$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $a2a0b4ba09a5a00a$var$getInstanceFromNode(blockedOn), null !== blockedOn && $a2a0b4ba09a5a00a$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $a2a0b4ba09a5a00a$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $a2a0b4ba09a5a00a$var$queuedFocus = $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent($a2a0b4ba09a5a00a$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $a2a0b4ba09a5a00a$var$queuedDrag = $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent($a2a0b4ba09a5a00a$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $a2a0b4ba09a5a00a$var$queuedMouse = $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent($a2a0b4ba09a5a00a$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $a2a0b4ba09a5a00a$var$queuedPointers.set(pointerId, $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent($a2a0b4ba09a5a00a$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $a2a0b4ba09a5a00a$var$queuedPointerCaptures.set(pointerId, $a2a0b4ba09a5a00a$var$accumulateOrCreateContinuousQueuedReplayableEvent($a2a0b4ba09a5a00a$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $a2a0b4ba09a5a00a$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $a2a0b4ba09a5a00a$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $a2a0b4ba09a5a00a$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $a2a0b4ba09a5a00a$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $a2a0b4ba09a5a00a$var$runWithPriority(queuedTarget.priority, function() {
                        $a2a0b4ba09a5a00a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $a2a0b4ba09a5a00a$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $a2a0b4ba09a5a00a$var$runWithPriority(queuedTarget.priority, function() {
                        $a2a0b4ba09a5a00a$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $a2a0b4ba09a5a00a$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $a2a0b4ba09a5a00a$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $a2a0b4ba09a5a00a$var$currentReplayingEvent = null;
        } else return targetContainers = $a2a0b4ba09a5a00a$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $a2a0b4ba09a5a00a$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $a2a0b4ba09a5a00a$var$replayUnblockedEvents() {
    $a2a0b4ba09a5a00a$var$hasScheduledReplayAttempt = !1;
    null !== $a2a0b4ba09a5a00a$var$queuedFocus && $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEvent($a2a0b4ba09a5a00a$var$queuedFocus) && ($a2a0b4ba09a5a00a$var$queuedFocus = null);
    null !== $a2a0b4ba09a5a00a$var$queuedDrag && $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEvent($a2a0b4ba09a5a00a$var$queuedDrag) && ($a2a0b4ba09a5a00a$var$queuedDrag = null);
    null !== $a2a0b4ba09a5a00a$var$queuedMouse && $a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEvent($a2a0b4ba09a5a00a$var$queuedMouse) && ($a2a0b4ba09a5a00a$var$queuedMouse = null);
    $a2a0b4ba09a5a00a$var$queuedPointers.forEach($a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEventInMap);
    $a2a0b4ba09a5a00a$var$queuedPointerCaptures.forEach($a2a0b4ba09a5a00a$var$attemptReplayContinuousQueuedEventInMap);
}
function $a2a0b4ba09a5a00a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $a2a0b4ba09a5a00a$var$hasScheduledReplayAttempt || ($a2a0b4ba09a5a00a$var$hasScheduledReplayAttempt = !0, $5t8wa.unstable_scheduleCallback($5t8wa.unstable_NormalPriority, $a2a0b4ba09a5a00a$var$replayUnblockedEvents)));
}
var $a2a0b4ba09a5a00a$var$lastScheduledReplayQueue = null;
function $a2a0b4ba09a5a00a$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $a2a0b4ba09a5a00a$var$lastScheduledReplayQueue !== formReplayingQueue && ($a2a0b4ba09a5a00a$var$lastScheduledReplayQueue = formReplayingQueue, $5t8wa.unstable_scheduleCallback($5t8wa.unstable_NormalPriority, function() {
        $a2a0b4ba09a5a00a$var$lastScheduledReplayQueue === formReplayingQueue && ($a2a0b4ba09a5a00a$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $a2a0b4ba09a5a00a$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $a2a0b4ba09a5a00a$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $a2a0b4ba09a5a00a$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $a2a0b4ba09a5a00a$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $a2a0b4ba09a5a00a$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $a2a0b4ba09a5a00a$var$queuedFocus && $a2a0b4ba09a5a00a$var$scheduleCallbackIfUnblocked($a2a0b4ba09a5a00a$var$queuedFocus, unblocked);
    null !== $a2a0b4ba09a5a00a$var$queuedDrag && $a2a0b4ba09a5a00a$var$scheduleCallbackIfUnblocked($a2a0b4ba09a5a00a$var$queuedDrag, unblocked);
    null !== $a2a0b4ba09a5a00a$var$queuedMouse && $a2a0b4ba09a5a00a$var$scheduleCallbackIfUnblocked($a2a0b4ba09a5a00a$var$queuedMouse, unblocked);
    $a2a0b4ba09a5a00a$var$queuedPointers.forEach(unblock);
    $a2a0b4ba09a5a00a$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets.length && (i = $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$a2a0b4ba09a5a00a$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$a2a0b4ba09a5a00a$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $a2a0b4ba09a5a00a$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$a2a0b4ba09a5a00a$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $a2a0b4ba09a5a00a$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $a2a0b4ba09a5a00a$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $a2a0b4ba09a5a00a$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function handler() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === (typeof navigation === "undefined" ? "undefined" : (0, $2bfPH._)(navigation))) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $a2a0b4ba09a5a00a$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a2a0b4ba09a5a00a$var$ReactDOMHydrationRoot.prototype.render = $a2a0b4ba09a5a00a$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(409));
    var current = root.current, lane = $a2a0b4ba09a5a00a$var$requestUpdateLane();
    $a2a0b4ba09a5a00a$var$updateContainerImpl(current, lane, children, root, null, null);
};
$a2a0b4ba09a5a00a$var$ReactDOMHydrationRoot.prototype.unmount = $a2a0b4ba09a5a00a$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $a2a0b4ba09a5a00a$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $a2a0b4ba09a5a00a$var$flushSyncWork$1();
        container[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey] = null;
    }
};
function $a2a0b4ba09a5a00a$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$a2a0b4ba09a5a00a$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $a2a0b4ba09a5a00a$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets[i].priority; i++);
        $a2a0b4ba09a5a00a$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $a2a0b4ba09a5a00a$var$attemptExplicitHydrationTarget(target);
    }
};
var $a2a0b4ba09a5a00a$var$isomorphicReactPackageVersion$jscomp$inline_1840 = $eHaBZ.version;
if ("19.2.8" !== $a2a0b4ba09a5a00a$var$isomorphicReactPackageVersion$jscomp$inline_1840) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(527, $a2a0b4ba09a5a00a$var$isomorphicReactPackageVersion$jscomp$inline_1840, "19.2.8"));
$a2a0b4ba09a5a00a$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $a2a0b4ba09a5a00a$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $a2a0b4ba09a5a00a$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $a2a0b4ba09a5a00a$var$internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.8",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $a2a0b4ba09a5a00a$var$ReactSharedInternals,
    reconcilerVersion: "19.2.8"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $a2a0b4ba09a5a00a$var$hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$a2a0b4ba09a5a00a$var$hook$jscomp$inline_2348.isDisabled && $a2a0b4ba09a5a00a$var$hook$jscomp$inline_2348.supportsFiber) try {
        $a2a0b4ba09a5a00a$var$rendererID = $a2a0b4ba09a5a00a$var$hook$jscomp$inline_2348.inject($a2a0b4ba09a5a00a$var$internals$jscomp$inline_2347), $a2a0b4ba09a5a00a$var$injectedHook = $a2a0b4ba09a5a00a$var$hook$jscomp$inline_2348;
    } catch (err) {}
}
$a2a0b4ba09a5a00a$export$882461b6382ed46c = function(container, options) {
    if (!$a2a0b4ba09a5a00a$var$isValidContainer(container)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a2a0b4ba09a5a00a$var$defaultOnUncaughtError, onCaughtError = $a2a0b4ba09a5a00a$var$defaultOnCaughtError, onRecoverableError = $a2a0b4ba09a5a00a$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $a2a0b4ba09a5a00a$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $a2a0b4ba09a5a00a$var$defaultOnDefaultTransitionIndicator);
    container[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey] = options.current;
    $a2a0b4ba09a5a00a$var$listenToAllSupportedEvents(container);
    return new $a2a0b4ba09a5a00a$var$ReactDOMRoot(options);
};
$a2a0b4ba09a5a00a$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$a2a0b4ba09a5a00a$var$isValidContainer(container)) throw Error($a2a0b4ba09a5a00a$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $a2a0b4ba09a5a00a$var$defaultOnUncaughtError, onCaughtError = $a2a0b4ba09a5a00a$var$defaultOnCaughtError, onRecoverableError = $a2a0b4ba09a5a00a$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $a2a0b4ba09a5a00a$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $a2a0b4ba09a5a00a$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $a2a0b4ba09a5a00a$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $a2a0b4ba09a5a00a$var$requestUpdateLane();
    isStrictMode = $a2a0b4ba09a5a00a$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $a2a0b4ba09a5a00a$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $a2a0b4ba09a5a00a$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $a2a0b4ba09a5a00a$var$markRootUpdated$1(initialChildren, options);
    $a2a0b4ba09a5a00a$var$ensureRootIsScheduled(initialChildren);
    container[$a2a0b4ba09a5a00a$var$internalContainerInstanceKey] = initialChildren.current;
    $a2a0b4ba09a5a00a$var$listenToAllSupportedEvents(container);
    return new $a2a0b4ba09a5a00a$var$ReactDOMHydrationRoot(initialChildren);
};
$a2a0b4ba09a5a00a$export$83d89fbfd8236492 = "19.2.8";

});
parcelRegister("2bfPH", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1968e3edfc5cfc11$export$71511d61b312f219; });
function $1968e3edfc5cfc11$export$71511d61b312f219(obj) {
    "@swc/helpers - typeof";
    return obj && typeof Symbol !== "undefined" && obj.constructor === Symbol ? "symbol" : typeof obj;
}

});

parcelRegister("5t8wa", function(module, exports) {
'use strict';

module.exports = (parcelRequire("6UejZ"));

});
parcelRegister("6UejZ", function(module, exports) {

$parcel$export(module.exports, "unstable_now", function () { return $507314f798cee1b0$export$c4744153514ff05d; }, function (v) { return $507314f798cee1b0$export$c4744153514ff05d = v; });
$parcel$export(module.exports, "unstable_IdlePriority", function () { return $507314f798cee1b0$export$3e506c1ccc9cc1a7; }, function (v) { return $507314f798cee1b0$export$3e506c1ccc9cc1a7 = v; });
$parcel$export(module.exports, "unstable_ImmediatePriority", function () { return $507314f798cee1b0$export$e26fe2ed2fa76875; }, function (v) { return $507314f798cee1b0$export$e26fe2ed2fa76875 = v; });
$parcel$export(module.exports, "unstable_LowPriority", function () { return $507314f798cee1b0$export$502329bbf4b505b1; }, function (v) { return $507314f798cee1b0$export$502329bbf4b505b1 = v; });
$parcel$export(module.exports, "unstable_NormalPriority", function () { return $507314f798cee1b0$export$6e3807111c4874c4; }, function (v) { return $507314f798cee1b0$export$6e3807111c4874c4 = v; });
$parcel$export(module.exports, "unstable_Profiling", function () { return $507314f798cee1b0$export$c27134553091fb3a; }, function (v) { return $507314f798cee1b0$export$c27134553091fb3a = v; });
$parcel$export(module.exports, "unstable_UserBlockingPriority", function () { return $507314f798cee1b0$export$33ee1acdc04fd2a2; }, function (v) { return $507314f798cee1b0$export$33ee1acdc04fd2a2 = v; });
$parcel$export(module.exports, "unstable_cancelCallback", function () { return $507314f798cee1b0$export$b00a404bbd5edef2; }, function (v) { return $507314f798cee1b0$export$b00a404bbd5edef2 = v; });
$parcel$export(module.exports, "unstable_forceFrameRate", function () { return $507314f798cee1b0$export$d66a1c1c77bd778b; }, function (v) { return $507314f798cee1b0$export$d66a1c1c77bd778b = v; });
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", function () { return $507314f798cee1b0$export$d3dfb8e4810cb555; }, function (v) { return $507314f798cee1b0$export$d3dfb8e4810cb555 = v; });
$parcel$export(module.exports, "unstable_next", function () { return $507314f798cee1b0$export$72fdf0e06517287b; }, function (v) { return $507314f798cee1b0$export$72fdf0e06517287b = v; });
$parcel$export(module.exports, "unstable_requestPaint", function () { return $507314f798cee1b0$export$816d2913ae6b83b1; }, function (v) { return $507314f798cee1b0$export$816d2913ae6b83b1 = v; });
$parcel$export(module.exports, "unstable_runWithPriority", function () { return $507314f798cee1b0$export$61bcfe829111a1d0; }, function (v) { return $507314f798cee1b0$export$61bcfe829111a1d0 = v; });
$parcel$export(module.exports, "unstable_scheduleCallback", function () { return $507314f798cee1b0$export$7ee8c9beb337bc3f; }, function (v) { return $507314f798cee1b0$export$7ee8c9beb337bc3f = v; });
$parcel$export(module.exports, "unstable_shouldYield", function () { return $507314f798cee1b0$export$b5836b71941fa3ed; }, function (v) { return $507314f798cee1b0$export$b5836b71941fa3ed = v; });
$parcel$export(module.exports, "unstable_wrapCallback", function () { return $507314f798cee1b0$export$cf845f2c119da08a; }, function (v) { return $507314f798cee1b0$export$cf845f2c119da08a = v; });
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $507314f798cee1b0$export$c4744153514ff05d;
var $507314f798cee1b0$export$3e506c1ccc9cc1a7;
var $507314f798cee1b0$export$e26fe2ed2fa76875;
var $507314f798cee1b0$export$502329bbf4b505b1;
var $507314f798cee1b0$export$6e3807111c4874c4;
var $507314f798cee1b0$export$c27134553091fb3a;
var $507314f798cee1b0$export$33ee1acdc04fd2a2;
var $507314f798cee1b0$export$b00a404bbd5edef2;
var $507314f798cee1b0$export$d66a1c1c77bd778b;
var $507314f798cee1b0$export$d3dfb8e4810cb555;
var $507314f798cee1b0$export$72fdf0e06517287b;
var $507314f798cee1b0$export$816d2913ae6b83b1;
var $507314f798cee1b0$export$61bcfe829111a1d0;
var $507314f798cee1b0$export$7ee8c9beb337bc3f;
var $507314f798cee1b0$export$b5836b71941fa3ed;
var $507314f798cee1b0$export$cf845f2c119da08a;
"use strict";
function $507314f798cee1b0$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $507314f798cee1b0$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $507314f798cee1b0$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $507314f798cee1b0$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $507314f798cee1b0$var$compare(left, last)) rightIndex < length && 0 > $507314f798cee1b0$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $507314f798cee1b0$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $507314f798cee1b0$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$507314f798cee1b0$export$c4744153514ff05d = void 0;
if ("object" === (typeof performance === "undefined" ? "undefined" : (0, $2bfPH._)(performance)) && "function" === typeof performance.now) {
    var $507314f798cee1b0$var$localPerformance = performance;
    $507314f798cee1b0$export$c4744153514ff05d = function() {
        return $507314f798cee1b0$var$localPerformance.now();
    };
} else {
    var $507314f798cee1b0$var$localDate = Date, $507314f798cee1b0$var$initialTime = $507314f798cee1b0$var$localDate.now();
    $507314f798cee1b0$export$c4744153514ff05d = function() {
        return $507314f798cee1b0$var$localDate.now() - $507314f798cee1b0$var$initialTime;
    };
}
var $507314f798cee1b0$var$taskQueue = [], $507314f798cee1b0$var$timerQueue = [], $507314f798cee1b0$var$taskIdCounter = 1, $507314f798cee1b0$var$currentTask = null, $507314f798cee1b0$var$currentPriorityLevel = 3, $507314f798cee1b0$var$isPerformingWork = !1, $507314f798cee1b0$var$isHostCallbackScheduled = !1, $507314f798cee1b0$var$isHostTimeoutScheduled = !1, $507314f798cee1b0$var$needsPaint = !1, $507314f798cee1b0$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $507314f798cee1b0$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $507314f798cee1b0$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $507314f798cee1b0$var$advanceTimers(currentTime) {
    for(var timer = $507314f798cee1b0$var$peek($507314f798cee1b0$var$timerQueue); null !== timer;){
        if (null === timer.callback) $507314f798cee1b0$var$pop($507314f798cee1b0$var$timerQueue);
        else if (timer.startTime <= currentTime) $507314f798cee1b0$var$pop($507314f798cee1b0$var$timerQueue), timer.sortIndex = timer.expirationTime, $507314f798cee1b0$var$push($507314f798cee1b0$var$taskQueue, timer);
        else break;
        timer = $507314f798cee1b0$var$peek($507314f798cee1b0$var$timerQueue);
    }
}
function $507314f798cee1b0$var$handleTimeout(currentTime) {
    $507314f798cee1b0$var$isHostTimeoutScheduled = !1;
    $507314f798cee1b0$var$advanceTimers(currentTime);
    if (!$507314f798cee1b0$var$isHostCallbackScheduled) {
        if (null !== $507314f798cee1b0$var$peek($507314f798cee1b0$var$taskQueue)) $507314f798cee1b0$var$isHostCallbackScheduled = !0, $507314f798cee1b0$var$isMessageLoopRunning || ($507314f798cee1b0$var$isMessageLoopRunning = !0, $507314f798cee1b0$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $507314f798cee1b0$var$peek($507314f798cee1b0$var$timerQueue);
            null !== firstTimer && $507314f798cee1b0$var$requestHostTimeout($507314f798cee1b0$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $507314f798cee1b0$var$isMessageLoopRunning = !1, $507314f798cee1b0$var$taskTimeoutID = -1, $507314f798cee1b0$var$frameInterval = 5, $507314f798cee1b0$var$startTime = -1;
function $507314f798cee1b0$var$shouldYieldToHost() {
    return $507314f798cee1b0$var$needsPaint ? !0 : $507314f798cee1b0$export$c4744153514ff05d() - $507314f798cee1b0$var$startTime < $507314f798cee1b0$var$frameInterval ? !1 : !0;
}
function $507314f798cee1b0$var$performWorkUntilDeadline() {
    $507314f798cee1b0$var$needsPaint = !1;
    if ($507314f798cee1b0$var$isMessageLoopRunning) {
        var currentTime = $507314f798cee1b0$export$c4744153514ff05d();
        $507314f798cee1b0$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $507314f798cee1b0$var$isHostCallbackScheduled = !1;
                $507314f798cee1b0$var$isHostTimeoutScheduled && ($507314f798cee1b0$var$isHostTimeoutScheduled = !1, $507314f798cee1b0$var$localClearTimeout($507314f798cee1b0$var$taskTimeoutID), $507314f798cee1b0$var$taskTimeoutID = -1);
                $507314f798cee1b0$var$isPerformingWork = !0;
                var previousPriorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
                try {
                    b: {
                        $507314f798cee1b0$var$advanceTimers(currentTime);
                        for($507314f798cee1b0$var$currentTask = $507314f798cee1b0$var$peek($507314f798cee1b0$var$taskQueue); null !== $507314f798cee1b0$var$currentTask && !($507314f798cee1b0$var$currentTask.expirationTime > currentTime && $507314f798cee1b0$var$shouldYieldToHost());){
                            var callback = $507314f798cee1b0$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $507314f798cee1b0$var$currentTask.callback = null;
                                $507314f798cee1b0$var$currentPriorityLevel = $507314f798cee1b0$var$currentTask.priorityLevel;
                                var continuationCallback = callback($507314f798cee1b0$var$currentTask.expirationTime <= currentTime);
                                currentTime = $507314f798cee1b0$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $507314f798cee1b0$var$currentTask.callback = continuationCallback;
                                    $507314f798cee1b0$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $507314f798cee1b0$var$currentTask === $507314f798cee1b0$var$peek($507314f798cee1b0$var$taskQueue) && $507314f798cee1b0$var$pop($507314f798cee1b0$var$taskQueue);
                                $507314f798cee1b0$var$advanceTimers(currentTime);
                            } else $507314f798cee1b0$var$pop($507314f798cee1b0$var$taskQueue);
                            $507314f798cee1b0$var$currentTask = $507314f798cee1b0$var$peek($507314f798cee1b0$var$taskQueue);
                        }
                        if (null !== $507314f798cee1b0$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $507314f798cee1b0$var$peek($507314f798cee1b0$var$timerQueue);
                            null !== firstTimer && $507314f798cee1b0$var$requestHostTimeout($507314f798cee1b0$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $507314f798cee1b0$var$currentTask = null, $507314f798cee1b0$var$currentPriorityLevel = previousPriorityLevel, $507314f798cee1b0$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $507314f798cee1b0$var$schedulePerformWorkUntilDeadline() : $507314f798cee1b0$var$isMessageLoopRunning = !1;
        }
    }
}
var $507314f798cee1b0$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $507314f798cee1b0$var$localSetImmediate) $507314f798cee1b0$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $507314f798cee1b0$var$localSetImmediate($507314f798cee1b0$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $507314f798cee1b0$var$channel = new MessageChannel(), $507314f798cee1b0$var$port = $507314f798cee1b0$var$channel.port2;
    $507314f798cee1b0$var$channel.port1.onmessage = $507314f798cee1b0$var$performWorkUntilDeadline;
    $507314f798cee1b0$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
        $507314f798cee1b0$var$port.postMessage(null);
    };
} else $507314f798cee1b0$var$schedulePerformWorkUntilDeadline = function schedulePerformWorkUntilDeadline() {
    $507314f798cee1b0$var$localSetTimeout($507314f798cee1b0$var$performWorkUntilDeadline, 0);
};
function $507314f798cee1b0$var$requestHostTimeout(callback, ms) {
    $507314f798cee1b0$var$taskTimeoutID = $507314f798cee1b0$var$localSetTimeout(function() {
        callback($507314f798cee1b0$export$c4744153514ff05d());
    }, ms);
}
$507314f798cee1b0$export$3e506c1ccc9cc1a7 = 5;
$507314f798cee1b0$export$e26fe2ed2fa76875 = 1;
$507314f798cee1b0$export$502329bbf4b505b1 = 4;
$507314f798cee1b0$export$6e3807111c4874c4 = 3;
$507314f798cee1b0$export$c27134553091fb3a = null;
$507314f798cee1b0$export$33ee1acdc04fd2a2 = 2;
$507314f798cee1b0$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$507314f798cee1b0$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $507314f798cee1b0$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$507314f798cee1b0$export$d3dfb8e4810cb555 = function() {
    return $507314f798cee1b0$var$currentPriorityLevel;
};
$507314f798cee1b0$export$72fdf0e06517287b = function(eventHandler) {
    switch($507314f798cee1b0$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
    $507314f798cee1b0$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $507314f798cee1b0$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$507314f798cee1b0$export$816d2913ae6b83b1 = function() {
    $507314f798cee1b0$var$needsPaint = !0;
};
$507314f798cee1b0$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
    $507314f798cee1b0$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $507314f798cee1b0$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$507314f798cee1b0$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $507314f798cee1b0$export$c4744153514ff05d();
    "object" === (typeof options === "undefined" ? "undefined" : (0, $2bfPH._)(options)) && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $507314f798cee1b0$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $507314f798cee1b0$var$push($507314f798cee1b0$var$timerQueue, priorityLevel), null === $507314f798cee1b0$var$peek($507314f798cee1b0$var$taskQueue) && priorityLevel === $507314f798cee1b0$var$peek($507314f798cee1b0$var$timerQueue) && ($507314f798cee1b0$var$isHostTimeoutScheduled ? ($507314f798cee1b0$var$localClearTimeout($507314f798cee1b0$var$taskTimeoutID), $507314f798cee1b0$var$taskTimeoutID = -1) : $507314f798cee1b0$var$isHostTimeoutScheduled = !0, $507314f798cee1b0$var$requestHostTimeout($507314f798cee1b0$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $507314f798cee1b0$var$push($507314f798cee1b0$var$taskQueue, priorityLevel), $507314f798cee1b0$var$isHostCallbackScheduled || $507314f798cee1b0$var$isPerformingWork || ($507314f798cee1b0$var$isHostCallbackScheduled = !0, $507314f798cee1b0$var$isMessageLoopRunning || ($507314f798cee1b0$var$isMessageLoopRunning = !0, $507314f798cee1b0$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$507314f798cee1b0$export$b5836b71941fa3ed = $507314f798cee1b0$var$shouldYieldToHost;
$507314f798cee1b0$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $507314f798cee1b0$var$currentPriorityLevel;
        $507314f798cee1b0$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $507314f798cee1b0$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("eHaBZ", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1ESfI"));

});
parcelRegister("1ESfI", function(module, exports) {

$parcel$export(module.exports, "Activity", function () { return $13539c46a3dde5d9$export$9c16c1426311996d; }, function (v) { return $13539c46a3dde5d9$export$9c16c1426311996d = v; });
$parcel$export(module.exports, "Children", function () { return $13539c46a3dde5d9$export$dca3b0875bd9a954; }, function (v) { return $13539c46a3dde5d9$export$dca3b0875bd9a954 = v; });
$parcel$export(module.exports, "Component", function () { return $13539c46a3dde5d9$export$16fa2f45be04daa8; }, function (v) { return $13539c46a3dde5d9$export$16fa2f45be04daa8 = v; });
$parcel$export(module.exports, "Fragment", function () { return $13539c46a3dde5d9$export$ffb0004e005737fa; }, function (v) { return $13539c46a3dde5d9$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "Profiler", function () { return $13539c46a3dde5d9$export$e2c29f18771995cb; }, function (v) { return $13539c46a3dde5d9$export$e2c29f18771995cb = v; });
$parcel$export(module.exports, "PureComponent", function () { return $13539c46a3dde5d9$export$221d75b3f55bb0bd; }, function (v) { return $13539c46a3dde5d9$export$221d75b3f55bb0bd = v; });
$parcel$export(module.exports, "StrictMode", function () { return $13539c46a3dde5d9$export$5f8d39834fd61797; }, function (v) { return $13539c46a3dde5d9$export$5f8d39834fd61797 = v; });
$parcel$export(module.exports, "Suspense", function () { return $13539c46a3dde5d9$export$74bf444e3cd11ea5; }, function (v) { return $13539c46a3dde5d9$export$74bf444e3cd11ea5 = v; });
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $13539c46a3dde5d9$export$1ced07cd6b1985ce; }, function (v) { return $13539c46a3dde5d9$export$1ced07cd6b1985ce = v; });
$parcel$export(module.exports, "__COMPILER_RUNTIME", function () { return $13539c46a3dde5d9$export$abd8e32b826d7ea7; }, function (v) { return $13539c46a3dde5d9$export$abd8e32b826d7ea7 = v; });
$parcel$export(module.exports, "cache", function () { return $13539c46a3dde5d9$export$69a3209f1a06c04d; }, function (v) { return $13539c46a3dde5d9$export$69a3209f1a06c04d = v; });
$parcel$export(module.exports, "cacheSignal", function () { return $13539c46a3dde5d9$export$8c538325882c7eec; }, function (v) { return $13539c46a3dde5d9$export$8c538325882c7eec = v; });
$parcel$export(module.exports, "cloneElement", function () { return $13539c46a3dde5d9$export$e530037191fcd5d7; }, function (v) { return $13539c46a3dde5d9$export$e530037191fcd5d7 = v; });
$parcel$export(module.exports, "createContext", function () { return $13539c46a3dde5d9$export$fd42f52fd3ae1109; }, function (v) { return $13539c46a3dde5d9$export$fd42f52fd3ae1109 = v; });
$parcel$export(module.exports, "createElement", function () { return $13539c46a3dde5d9$export$c8a8987d4410bf2d; }, function (v) { return $13539c46a3dde5d9$export$c8a8987d4410bf2d = v; });
$parcel$export(module.exports, "createRef", function () { return $13539c46a3dde5d9$export$7d1e3a5e95ceca43; }, function (v) { return $13539c46a3dde5d9$export$7d1e3a5e95ceca43 = v; });
$parcel$export(module.exports, "forwardRef", function () { return $13539c46a3dde5d9$export$257a8862b851cb5b; }, function (v) { return $13539c46a3dde5d9$export$257a8862b851cb5b = v; });
$parcel$export(module.exports, "isValidElement", function () { return $13539c46a3dde5d9$export$a8257692ac88316c; }, function (v) { return $13539c46a3dde5d9$export$a8257692ac88316c = v; });
$parcel$export(module.exports, "lazy", function () { return $13539c46a3dde5d9$export$488013bae63b21da; }, function (v) { return $13539c46a3dde5d9$export$488013bae63b21da = v; });
$parcel$export(module.exports, "memo", function () { return $13539c46a3dde5d9$export$7c73462e0d25e514; }, function (v) { return $13539c46a3dde5d9$export$7c73462e0d25e514 = v; });
$parcel$export(module.exports, "startTransition", function () { return $13539c46a3dde5d9$export$7568632d0d33d16d; }, function (v) { return $13539c46a3dde5d9$export$7568632d0d33d16d = v; });
$parcel$export(module.exports, "unstable_useCacheRefresh", function () { return $13539c46a3dde5d9$export$f93f40ac0ca7e3a8; }, function (v) { return $13539c46a3dde5d9$export$f93f40ac0ca7e3a8 = v; });
$parcel$export(module.exports, "use", function () { return $13539c46a3dde5d9$export$1f96ae73734a86cc; }, function (v) { return $13539c46a3dde5d9$export$1f96ae73734a86cc = v; });
$parcel$export(module.exports, "useActionState", function () { return $13539c46a3dde5d9$export$9a47ced3238df325; }, function (v) { return $13539c46a3dde5d9$export$9a47ced3238df325 = v; });
$parcel$export(module.exports, "useCallback", function () { return $13539c46a3dde5d9$export$35808ee640e87ca7; }, function (v) { return $13539c46a3dde5d9$export$35808ee640e87ca7 = v; });
$parcel$export(module.exports, "useContext", function () { return $13539c46a3dde5d9$export$fae74005e78b1a27; }, function (v) { return $13539c46a3dde5d9$export$fae74005e78b1a27 = v; });
$parcel$export(module.exports, "useDebugValue", function () { return $13539c46a3dde5d9$export$dc8fbce3eb94dc1e; }, function (v) { return $13539c46a3dde5d9$export$dc8fbce3eb94dc1e = v; });
$parcel$export(module.exports, "useDeferredValue", function () { return $13539c46a3dde5d9$export$6a7bc4e911dc01cf; }, function (v) { return $13539c46a3dde5d9$export$6a7bc4e911dc01cf = v; });
$parcel$export(module.exports, "useEffect", function () { return $13539c46a3dde5d9$export$6d9c69b0de29b591; }, function (v) { return $13539c46a3dde5d9$export$6d9c69b0de29b591 = v; });
$parcel$export(module.exports, "useEffectEvent", function () { return $13539c46a3dde5d9$export$7f54fc3180508a52; }, function (v) { return $13539c46a3dde5d9$export$7f54fc3180508a52 = v; });
$parcel$export(module.exports, "useId", function () { return $13539c46a3dde5d9$export$f680877a34711e37; }, function (v) { return $13539c46a3dde5d9$export$f680877a34711e37 = v; });
$parcel$export(module.exports, "useImperativeHandle", function () { return $13539c46a3dde5d9$export$d5a552a76deda3c2; }, function (v) { return $13539c46a3dde5d9$export$d5a552a76deda3c2 = v; });
$parcel$export(module.exports, "useInsertionEffect", function () { return $13539c46a3dde5d9$export$aaabe4eda9ed9969; }, function (v) { return $13539c46a3dde5d9$export$aaabe4eda9ed9969 = v; });
$parcel$export(module.exports, "useLayoutEffect", function () { return $13539c46a3dde5d9$export$e5c5a5f917a5871c; }, function (v) { return $13539c46a3dde5d9$export$e5c5a5f917a5871c = v; });
$parcel$export(module.exports, "useMemo", function () { return $13539c46a3dde5d9$export$1538c33de8887b59; }, function (v) { return $13539c46a3dde5d9$export$1538c33de8887b59 = v; });
$parcel$export(module.exports, "useOptimistic", function () { return $13539c46a3dde5d9$export$fca7f784ae7a249a; }, function (v) { return $13539c46a3dde5d9$export$fca7f784ae7a249a = v; });
$parcel$export(module.exports, "useReducer", function () { return $13539c46a3dde5d9$export$13e3392192263954; }, function (v) { return $13539c46a3dde5d9$export$13e3392192263954 = v; });
$parcel$export(module.exports, "useRef", function () { return $13539c46a3dde5d9$export$b8f5890fc79d6aca; }, function (v) { return $13539c46a3dde5d9$export$b8f5890fc79d6aca = v; });
$parcel$export(module.exports, "useState", function () { return $13539c46a3dde5d9$export$60241385465d0a34; }, function (v) { return $13539c46a3dde5d9$export$60241385465d0a34 = v; });
$parcel$export(module.exports, "useSyncExternalStore", function () { return $13539c46a3dde5d9$export$306c0aa65ff9ec16; }, function (v) { return $13539c46a3dde5d9$export$306c0aa65ff9ec16 = v; });
$parcel$export(module.exports, "useTransition", function () { return $13539c46a3dde5d9$export$7b286972b8d8ccbf; }, function (v) { return $13539c46a3dde5d9$export$7b286972b8d8ccbf = v; });
$parcel$export(module.exports, "version", function () { return $13539c46a3dde5d9$export$83d89fbfd8236492; }, function (v) { return $13539c46a3dde5d9$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $13539c46a3dde5d9$export$9c16c1426311996d;
var $13539c46a3dde5d9$export$dca3b0875bd9a954;
var $13539c46a3dde5d9$export$16fa2f45be04daa8;
var $13539c46a3dde5d9$export$ffb0004e005737fa;
var $13539c46a3dde5d9$export$e2c29f18771995cb;
var $13539c46a3dde5d9$export$221d75b3f55bb0bd;
var $13539c46a3dde5d9$export$5f8d39834fd61797;
var $13539c46a3dde5d9$export$74bf444e3cd11ea5;
var $13539c46a3dde5d9$export$1ced07cd6b1985ce;
var $13539c46a3dde5d9$export$abd8e32b826d7ea7;
var $13539c46a3dde5d9$export$69a3209f1a06c04d;
var $13539c46a3dde5d9$export$8c538325882c7eec;
var $13539c46a3dde5d9$export$e530037191fcd5d7;
var $13539c46a3dde5d9$export$fd42f52fd3ae1109;
var $13539c46a3dde5d9$export$c8a8987d4410bf2d;
var $13539c46a3dde5d9$export$7d1e3a5e95ceca43;
var $13539c46a3dde5d9$export$257a8862b851cb5b;
var $13539c46a3dde5d9$export$a8257692ac88316c;
var $13539c46a3dde5d9$export$488013bae63b21da;
var $13539c46a3dde5d9$export$7c73462e0d25e514;
var $13539c46a3dde5d9$export$7568632d0d33d16d;
var $13539c46a3dde5d9$export$f93f40ac0ca7e3a8;
var $13539c46a3dde5d9$export$1f96ae73734a86cc;
var $13539c46a3dde5d9$export$9a47ced3238df325;
var $13539c46a3dde5d9$export$35808ee640e87ca7;
var $13539c46a3dde5d9$export$fae74005e78b1a27;
var $13539c46a3dde5d9$export$dc8fbce3eb94dc1e;
var $13539c46a3dde5d9$export$6a7bc4e911dc01cf;
var $13539c46a3dde5d9$export$6d9c69b0de29b591;
var $13539c46a3dde5d9$export$7f54fc3180508a52;
var $13539c46a3dde5d9$export$f680877a34711e37;
var $13539c46a3dde5d9$export$d5a552a76deda3c2;
var $13539c46a3dde5d9$export$aaabe4eda9ed9969;
var $13539c46a3dde5d9$export$e5c5a5f917a5871c;
var $13539c46a3dde5d9$export$1538c33de8887b59;
var $13539c46a3dde5d9$export$fca7f784ae7a249a;
var $13539c46a3dde5d9$export$13e3392192263954;
var $13539c46a3dde5d9$export$b8f5890fc79d6aca;
var $13539c46a3dde5d9$export$60241385465d0a34;
var $13539c46a3dde5d9$export$306c0aa65ff9ec16;
var $13539c46a3dde5d9$export$7b286972b8d8ccbf;
var $13539c46a3dde5d9$export$83d89fbfd8236492;
"use strict";
var $13539c46a3dde5d9$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $13539c46a3dde5d9$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $13539c46a3dde5d9$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $13539c46a3dde5d9$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $13539c46a3dde5d9$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $13539c46a3dde5d9$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $13539c46a3dde5d9$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $13539c46a3dde5d9$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $13539c46a3dde5d9$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $13539c46a3dde5d9$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $13539c46a3dde5d9$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $13539c46a3dde5d9$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $13539c46a3dde5d9$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $13539c46a3dde5d9$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== (typeof maybeIterable === "undefined" ? "undefined" : (0, $2bfPH._)(maybeIterable))) return null;
    maybeIterable = $13539c46a3dde5d9$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$13539c46a3dde5d9$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $13539c46a3dde5d9$var$ReactNoopUpdateQueue = {
    isMounted: function isMounted() {
        return !1;
    },
    enqueueForceUpdate: function enqueueForceUpdate() {},
    enqueueReplaceState: function enqueueReplaceState() {},
    enqueueSetState: function enqueueSetState() {}
}, $13539c46a3dde5d9$var$assign = Object.assign, $13539c46a3dde5d9$var$emptyObject = {};
function $13539c46a3dde5d9$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $13539c46a3dde5d9$var$emptyObject;
    this.updater = updater || $13539c46a3dde5d9$var$ReactNoopUpdateQueue;
}
$13539c46a3dde5d9$var$Component.prototype.isReactComponent = {};
$13539c46a3dde5d9$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== (typeof partialState === "undefined" ? "undefined" : (0, $2bfPH._)(partialState)) && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$13539c46a3dde5d9$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $13539c46a3dde5d9$var$ComponentDummy() {}
$13539c46a3dde5d9$var$ComponentDummy.prototype = $13539c46a3dde5d9$var$Component.prototype;
function $13539c46a3dde5d9$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $13539c46a3dde5d9$var$emptyObject;
    this.updater = updater || $13539c46a3dde5d9$var$ReactNoopUpdateQueue;
}
var $13539c46a3dde5d9$var$pureComponentPrototype = $13539c46a3dde5d9$var$PureComponent.prototype = new $13539c46a3dde5d9$var$ComponentDummy();
$13539c46a3dde5d9$var$pureComponentPrototype.constructor = $13539c46a3dde5d9$var$PureComponent;
$13539c46a3dde5d9$var$assign($13539c46a3dde5d9$var$pureComponentPrototype, $13539c46a3dde5d9$var$Component.prototype);
$13539c46a3dde5d9$var$pureComponentPrototype.isPureReactComponent = !0;
var $13539c46a3dde5d9$var$isArrayImpl = Array.isArray;
function $13539c46a3dde5d9$var$noop() {}
var $13539c46a3dde5d9$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $13539c46a3dde5d9$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $13539c46a3dde5d9$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $13539c46a3dde5d9$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $13539c46a3dde5d9$var$cloneAndReplaceKey(oldElement, newKey) {
    return $13539c46a3dde5d9$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $13539c46a3dde5d9$var$isValidElement(object) {
    return "object" === (typeof object === "undefined" ? "undefined" : (0, $2bfPH._)(object)) && null !== object && object.$$typeof === $13539c46a3dde5d9$var$REACT_ELEMENT_TYPE;
}
function $13539c46a3dde5d9$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $13539c46a3dde5d9$var$userProvidedKeyEscapeRegex = /\/+/g;
function $13539c46a3dde5d9$var$getElementKey(element, index) {
    return "object" === (typeof element === "undefined" ? "undefined" : (0, $2bfPH._)(element)) && null !== element && null != element.key ? $13539c46a3dde5d9$var$escape("" + element.key) : index.toString(36);
}
function $13539c46a3dde5d9$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($13539c46a3dde5d9$var$noop, $13539c46a3dde5d9$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $13539c46a3dde5d9$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children === "undefined" ? "undefined" : (0, $2bfPH._)(children);
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $13539c46a3dde5d9$var$REACT_ELEMENT_TYPE:
                case $13539c46a3dde5d9$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $13539c46a3dde5d9$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $13539c46a3dde5d9$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $13539c46a3dde5d9$var$getElementKey(children, 0) : nameSoFar, $13539c46a3dde5d9$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($13539c46a3dde5d9$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $13539c46a3dde5d9$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($13539c46a3dde5d9$var$isValidElement(callback) && (callback = $13539c46a3dde5d9$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($13539c46a3dde5d9$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($13539c46a3dde5d9$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $13539c46a3dde5d9$var$getElementKey(nameSoFar, i), invokeCallback += $13539c46a3dde5d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $13539c46a3dde5d9$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $13539c46a3dde5d9$var$getElementKey(nameSoFar, i++), invokeCallback += $13539c46a3dde5d9$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $13539c46a3dde5d9$var$mapIntoArray($13539c46a3dde5d9$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $13539c46a3dde5d9$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $13539c46a3dde5d9$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $13539c46a3dde5d9$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result;
        ctor = ctor();
        ctor.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject;
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error;
        });
        -1 === payload._status && (payload._status = 0, payload._result = ctor);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $13539c46a3dde5d9$var$reportGlobalError = "function" === typeof reportError ? reportError : function reportGlobalError(error) {
    if ("object" === (typeof window === "undefined" ? "undefined" : (0, $2bfPH._)(window)) && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $13539c46a3dde5d9$var$Children = {
    map: $13539c46a3dde5d9$var$mapChildren,
    forEach: function forEach(children, forEachFunc, forEachContext) {
        $13539c46a3dde5d9$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function count(children) {
        var n = 0;
        $13539c46a3dde5d9$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function toArray(children) {
        return $13539c46a3dde5d9$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function only(children) {
        if (!$13539c46a3dde5d9$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$13539c46a3dde5d9$export$9c16c1426311996d = $13539c46a3dde5d9$var$REACT_ACTIVITY_TYPE;
$13539c46a3dde5d9$export$dca3b0875bd9a954 = $13539c46a3dde5d9$var$Children;
$13539c46a3dde5d9$export$16fa2f45be04daa8 = $13539c46a3dde5d9$var$Component;
$13539c46a3dde5d9$export$ffb0004e005737fa = $13539c46a3dde5d9$var$REACT_FRAGMENT_TYPE;
$13539c46a3dde5d9$export$e2c29f18771995cb = $13539c46a3dde5d9$var$REACT_PROFILER_TYPE;
$13539c46a3dde5d9$export$221d75b3f55bb0bd = $13539c46a3dde5d9$var$PureComponent;
$13539c46a3dde5d9$export$5f8d39834fd61797 = $13539c46a3dde5d9$var$REACT_STRICT_MODE_TYPE;
$13539c46a3dde5d9$export$74bf444e3cd11ea5 = $13539c46a3dde5d9$var$REACT_SUSPENSE_TYPE;
$13539c46a3dde5d9$export$1ced07cd6b1985ce = $13539c46a3dde5d9$var$ReactSharedInternals;
$13539c46a3dde5d9$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function c(size) {
        return $13539c46a3dde5d9$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$13539c46a3dde5d9$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$13539c46a3dde5d9$export$8c538325882c7eec = function() {
    return null;
};
$13539c46a3dde5d9$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $13539c46a3dde5d9$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$13539c46a3dde5d9$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $13539c46a3dde5d9$var$ReactElement(element.type, key, props);
};
$13539c46a3dde5d9$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $13539c46a3dde5d9$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $13539c46a3dde5d9$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$13539c46a3dde5d9$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$13539c46a3dde5d9$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $13539c46a3dde5d9$var$ReactElement(type, key, props);
};
$13539c46a3dde5d9$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$13539c46a3dde5d9$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $13539c46a3dde5d9$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$13539c46a3dde5d9$export$a8257692ac88316c = $13539c46a3dde5d9$var$isValidElement;
$13539c46a3dde5d9$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $13539c46a3dde5d9$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $13539c46a3dde5d9$var$lazyInitializer
    };
};
$13539c46a3dde5d9$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $13539c46a3dde5d9$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$13539c46a3dde5d9$export$7568632d0d33d16d = function(scope) {
    var prevTransition = $13539c46a3dde5d9$var$ReactSharedInternals.T, currentTransition = {};
    $13539c46a3dde5d9$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $13539c46a3dde5d9$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === (typeof returnValue === "undefined" ? "undefined" : (0, $2bfPH._)(returnValue)) && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($13539c46a3dde5d9$var$noop, $13539c46a3dde5d9$var$reportGlobalError);
    } catch (error) {
        $13539c46a3dde5d9$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $13539c46a3dde5d9$var$ReactSharedInternals.T = prevTransition;
    }
};
$13539c46a3dde5d9$export$f93f40ac0ca7e3a8 = function() {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useCacheRefresh();
};
$13539c46a3dde5d9$export$1f96ae73734a86cc = function(usable) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.use(usable);
};
$13539c46a3dde5d9$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$13539c46a3dde5d9$export$35808ee640e87ca7 = function(callback, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$13539c46a3dde5d9$export$fae74005e78b1a27 = function(Context) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useContext(Context);
};
$13539c46a3dde5d9$export$dc8fbce3eb94dc1e = function() {};
$13539c46a3dde5d9$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$13539c46a3dde5d9$export$6d9c69b0de29b591 = function(create, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useEffect(create, deps);
};
$13539c46a3dde5d9$export$7f54fc3180508a52 = function(callback) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$13539c46a3dde5d9$export$f680877a34711e37 = function() {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useId();
};
$13539c46a3dde5d9$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$13539c46a3dde5d9$export$aaabe4eda9ed9969 = function(create, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$13539c46a3dde5d9$export$e5c5a5f917a5871c = function(create, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$13539c46a3dde5d9$export$1538c33de8887b59 = function(create, deps) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useMemo(create, deps);
};
$13539c46a3dde5d9$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$13539c46a3dde5d9$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$13539c46a3dde5d9$export$b8f5890fc79d6aca = function(initialValue) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useRef(initialValue);
};
$13539c46a3dde5d9$export$60241385465d0a34 = function(initialState) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useState(initialState);
};
$13539c46a3dde5d9$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$13539c46a3dde5d9$export$7b286972b8d8ccbf = function() {
    return $13539c46a3dde5d9$var$ReactSharedInternals.H.useTransition();
};
$13539c46a3dde5d9$export$83d89fbfd8236492 = "19.2.8";

});


parcelRegister("bVPm2", function(module, exports) {
'use strict';
function $8afcda7f6e55ccf7$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($8afcda7f6e55ccf7$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$8afcda7f6e55ccf7$var$checkDCE();

module.exports = (parcelRequire("abkFI"));

});
parcelRegister("abkFI", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", function () { return $769af772618cc5e2$export$69ce8ef3fe5cead0; }, function (v) { return $769af772618cc5e2$export$69ce8ef3fe5cead0 = v; });
$parcel$export(module.exports, "createPortal", function () { return $769af772618cc5e2$export$d39a5bbd09211389; }, function (v) { return $769af772618cc5e2$export$d39a5bbd09211389 = v; });
$parcel$export(module.exports, "flushSync", function () { return $769af772618cc5e2$export$cd75ccfd720a3cd4; }, function (v) { return $769af772618cc5e2$export$cd75ccfd720a3cd4 = v; });
$parcel$export(module.exports, "preconnect", function () { return $769af772618cc5e2$export$a0816fa17a9e79be; }, function (v) { return $769af772618cc5e2$export$a0816fa17a9e79be = v; });
$parcel$export(module.exports, "prefetchDNS", function () { return $769af772618cc5e2$export$7292efcadded39f3; }, function (v) { return $769af772618cc5e2$export$7292efcadded39f3 = v; });
$parcel$export(module.exports, "preinit", function () { return $769af772618cc5e2$export$da407abadb9b8f86; }, function (v) { return $769af772618cc5e2$export$da407abadb9b8f86 = v; });
$parcel$export(module.exports, "preinitModule", function () { return $769af772618cc5e2$export$314cfea32580671c; }, function (v) { return $769af772618cc5e2$export$314cfea32580671c = v; });
$parcel$export(module.exports, "preload", function () { return $769af772618cc5e2$export$513ccb98c53b8039; }, function (v) { return $769af772618cc5e2$export$513ccb98c53b8039 = v; });
$parcel$export(module.exports, "preloadModule", function () { return $769af772618cc5e2$export$dbca993bc2d264a; }, function (v) { return $769af772618cc5e2$export$dbca993bc2d264a = v; });
$parcel$export(module.exports, "requestFormReset", function () { return $769af772618cc5e2$export$4797a8006f0655d0; }, function (v) { return $769af772618cc5e2$export$4797a8006f0655d0 = v; });
$parcel$export(module.exports, "unstable_batchedUpdates", function () { return $769af772618cc5e2$export$c78a37762a8d58e1; }, function (v) { return $769af772618cc5e2$export$c78a37762a8d58e1 = v; });
$parcel$export(module.exports, "useFormState", function () { return $769af772618cc5e2$export$606f11b2eb45ecc6; }, function (v) { return $769af772618cc5e2$export$606f11b2eb45ecc6 = v; });
$parcel$export(module.exports, "useFormStatus", function () { return $769af772618cc5e2$export$f7e8a0bf92324b1e; }, function (v) { return $769af772618cc5e2$export$f7e8a0bf92324b1e = v; });
$parcel$export(module.exports, "version", function () { return $769af772618cc5e2$export$83d89fbfd8236492; }, function (v) { return $769af772618cc5e2$export$83d89fbfd8236492 = v; });
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $769af772618cc5e2$export$69ce8ef3fe5cead0;
var $769af772618cc5e2$export$d39a5bbd09211389;
var $769af772618cc5e2$export$cd75ccfd720a3cd4;
var $769af772618cc5e2$export$a0816fa17a9e79be;
var $769af772618cc5e2$export$7292efcadded39f3;
var $769af772618cc5e2$export$da407abadb9b8f86;
var $769af772618cc5e2$export$314cfea32580671c;
var $769af772618cc5e2$export$513ccb98c53b8039;
var $769af772618cc5e2$export$dbca993bc2d264a;
var $769af772618cc5e2$export$4797a8006f0655d0;
var $769af772618cc5e2$export$c78a37762a8d58e1;
var $769af772618cc5e2$export$606f11b2eb45ecc6;
var $769af772618cc5e2$export$f7e8a0bf92324b1e;
var $769af772618cc5e2$export$83d89fbfd8236492;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");
function $769af772618cc5e2$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $769af772618cc5e2$var$noop() {}
var $769af772618cc5e2$var$Internals = {
    d: {
        f: $769af772618cc5e2$var$noop,
        r: function r() {
            throw Error($769af772618cc5e2$var$formatProdErrorMessage(522));
        },
        D: $769af772618cc5e2$var$noop,
        C: $769af772618cc5e2$var$noop,
        L: $769af772618cc5e2$var$noop,
        m: $769af772618cc5e2$var$noop,
        X: $769af772618cc5e2$var$noop,
        S: $769af772618cc5e2$var$noop,
        M: $769af772618cc5e2$var$noop
    },
    p: 0,
    findDOMNode: null
}, $769af772618cc5e2$var$REACT_PORTAL_TYPE = Symbol.for("react.portal");
function $769af772618cc5e2$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $769af772618cc5e2$var$REACT_PORTAL_TYPE,
        key: null == key ? null : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $769af772618cc5e2$var$ReactSharedInternals = $eHaBZ.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $769af772618cc5e2$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$769af772618cc5e2$export$69ce8ef3fe5cead0 = $769af772618cc5e2$var$Internals;
$769af772618cc5e2$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($769af772618cc5e2$var$formatProdErrorMessage(299));
    return $769af772618cc5e2$var$createPortal$1(children, container, null, key);
};
$769af772618cc5e2$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $769af772618cc5e2$var$ReactSharedInternals.T, previousUpdatePriority = $769af772618cc5e2$var$Internals.p;
    try {
        if ($769af772618cc5e2$var$ReactSharedInternals.T = null, $769af772618cc5e2$var$Internals.p = 2, fn) return fn();
    } finally{
        $769af772618cc5e2$var$ReactSharedInternals.T = previousTransition, $769af772618cc5e2$var$Internals.p = previousUpdatePriority, $769af772618cc5e2$var$Internals.d.f();
    }
};
$769af772618cc5e2$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $769af772618cc5e2$var$Internals.d.C(href, options));
};
$769af772618cc5e2$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $769af772618cc5e2$var$Internals.d.D(href);
};
$769af772618cc5e2$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $769af772618cc5e2$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $769af772618cc5e2$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $769af772618cc5e2$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$769af772618cc5e2$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === (typeof options === "undefined" ? "undefined" : (0, $2bfPH._)(options)) && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $769af772618cc5e2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $769af772618cc5e2$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0
                });
            }
        } else null == options && $769af772618cc5e2$var$Internals.d.M(href);
    }
};
$769af772618cc5e2$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === (typeof options === "undefined" ? "undefined" : (0, $2bfPH._)(options)) && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $769af772618cc5e2$var$getCrossOriginStringAs(as, options.crossOrigin);
        $769af772618cc5e2$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$769af772618cc5e2$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $769af772618cc5e2$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $769af772618cc5e2$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0
            });
        } else $769af772618cc5e2$var$Internals.d.m(href);
    }
};
$769af772618cc5e2$export$4797a8006f0655d0 = function(form) {
    $769af772618cc5e2$var$Internals.d.r(form);
};
$769af772618cc5e2$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$769af772618cc5e2$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $769af772618cc5e2$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$769af772618cc5e2$export$f7e8a0bf92324b1e = function() {
    return $769af772618cc5e2$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$769af772618cc5e2$export$83d89fbfd8236492 = "19.2.8";

});



parcelRegister("ceFNn", function(module, exports) {

$parcel$export(module.exports, "Fragment", function () { return $8e8736889c711618$export$ffb0004e005737fa; }, function (v) { return $8e8736889c711618$export$ffb0004e005737fa = v; });
$parcel$export(module.exports, "jsx", function () { return $8e8736889c711618$export$34b9dba7ce09269b; }, function (v) { return $8e8736889c711618$export$34b9dba7ce09269b = v; });
$parcel$export(module.exports, "jsxs", function () { return $8e8736889c711618$export$25062201e9e25d76; }, function (v) { return $8e8736889c711618$export$25062201e9e25d76 = v; });
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8e8736889c711618$export$ffb0004e005737fa;
var $8e8736889c711618$export$34b9dba7ce09269b;
var $8e8736889c711618$export$25062201e9e25d76;
"use strict";
var $8e8736889c711618$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8e8736889c711618$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $8e8736889c711618$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $8e8736889c711618$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$8e8736889c711618$export$ffb0004e005737fa = $8e8736889c711618$var$REACT_FRAGMENT_TYPE;
$8e8736889c711618$export$34b9dba7ce09269b = $8e8736889c711618$var$jsxProd;
$8e8736889c711618$export$25062201e9e25d76 = $8e8736889c711618$var$jsxProd;

});

parcelRegister("daRwM", function(module, exports) {

$parcel$export(module.exports, "createContext", function () { return createContext; });
$parcel$export(module.exports, "RouterContextProvider", function () { return RouterContextProvider; });
$parcel$export(module.exports, "isUnsupportedLazyRouteObjectKey", function () { return isUnsupportedLazyRouteObjectKey; });
$parcel$export(module.exports, "isUnsupportedLazyRouteFunctionKey", function () { return isUnsupportedLazyRouteFunctionKey; });
$parcel$export(module.exports, "defaultMapRouteProperties", function () { return defaultMapRouteProperties; });
$parcel$export(module.exports, "convertRoutesToDataRoutes", function () { return convertRoutesToDataRoutes; });
$parcel$export(module.exports, "matchRoutes", function () { return matchRoutes; });
$parcel$export(module.exports, "matchRoutesImpl", function () { return matchRoutesImpl; });
$parcel$export(module.exports, "stripBasename", function () { return stripBasename; });
$parcel$export(module.exports, "flattenAndRankRoutes", function () { return flattenAndRankRoutes; });
$parcel$export(module.exports, "decodePath", function () { return decodePath; });
$parcel$export(module.exports, "convertRouteMatchToUiMatch", function () { return convertRouteMatchToUiMatch; });
$parcel$export(module.exports, "joinPaths", function () { return joinPaths; });
$parcel$export(module.exports, "compilePath", function () { return compilePath; });
$parcel$export(module.exports, "matchPath", function () { return matchPath; });
$parcel$export(module.exports, "prependBasename", function () { return prependBasename; });
$parcel$export(module.exports, "isAbsoluteUrl", function () { return isAbsoluteUrl; });
$parcel$export(module.exports, "removeDoubleSlashes", function () { return removeDoubleSlashes; });
$parcel$export(module.exports, "getPathContributingMatches", function () { return getPathContributingMatches; });
$parcel$export(module.exports, "getResolveToMatches", function () { return getResolveToMatches; });
$parcel$export(module.exports, "resolveTo", function () { return resolveTo; });
$parcel$export(module.exports, "data", function () { return data; });
$parcel$export(module.exports, "redirect", function () { return redirect; });
$parcel$export(module.exports, "SUPPORTED_ERROR_TYPES", function () { return SUPPORTED_ERROR_TYPES; });
$parcel$export(module.exports, "ErrorResponseImpl", function () { return ErrorResponseImpl; });
$parcel$export(module.exports, "isRouteErrorResponse", function () { return isRouteErrorResponse; });
$parcel$export(module.exports, "getRoutePattern", function () { return getRoutePattern; });
$parcel$export(module.exports, "createDataFunctionUrl", function () { return createDataFunctionUrl; });
$parcel$export(module.exports, "isBrowser", function () { return isBrowser; });
$parcel$export(module.exports, "parseToInfo", function () { return parseToInfo; });
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $gd0sY = parcelRequire("gd0sY");

var $bSRDS = parcelRequire("bSRDS");

var $6wbrO = parcelRequire("6wbrO");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $8onil = parcelRequire("8onil");

var $iKEZU = parcelRequire("iKEZU");

var $eHaBZ = parcelRequire("eHaBZ");
var _map;
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function createContext(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var RouterContextProvider = (_map = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    "use strict";
    function _class(init) {
        (0, $gd0sY._)(this, _class);
        (0, $6wbrO._)(this, _map, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (init) try {
            for(var _iterator = init[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), context = _step_value[0], value = _step_value[1];
                this.set(context, value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    (0, $7cSld._)(_class, [
        {
            /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ key: "get",
            value: function get(context) {
                if ((0, $bSRDS._)(this, _map).has(context)) return (0, $bSRDS._)(this, _map).get(context);
                if (context.defaultValue !== void 0) return context.defaultValue;
                throw new Error("No value found for context");
            }
        },
        {
            /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ key: "set",
            value: function set(context, value) {
                (0, $bSRDS._)(this, _map).set(context, value);
            }
        }
    ]);
    return _class;
}());
var unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children"
]);
function isUnsupportedLazyRouteObjectKey(key) {
    return unsupportedLazyRouteObjectKeys.has(key);
}
var unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children"
]);
function isUnsupportedLazyRouteFunctionKey(key) {
    return unsupportedLazyRouteFunctionKeys.has(key);
}
function isIndexRoute(route) {
    return route.index === true;
}
function defaultMapRouteProperties(route) {
    var updates = {};
    if (route.Component) Object.assign(updates, {
        element: $eHaBZ.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $eHaBZ.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $eHaBZ.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function convertRoutesToDataRoutes(routes) {
    var mapRouteProperties = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : defaultMapRouteProperties, parentPath = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], manifest = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, allowInPlaceMutations = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    return routes.map(function(route, index) {
        var treePath = (0, $6zk1M._)(parentPath).concat([
            String(index)
        ]);
        var id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $iKEZU.invariant)(route.index !== true || !route.children, "Cannot specify children on an index route");
        (0, $iKEZU.invariant)(allowInPlaceMutations || !manifest[id], 'Found a route id collision on id "'.concat(id, "\".  Route id's must be globally unique within Data Router usages"));
        if (isIndexRoute(route)) {
            var indexRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, route), {
                id: id
            });
            manifest[id] = mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            var pathOrLayoutRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, route), {
                id: id,
                children: void 0
            });
            manifest[id] = mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = convertRoutesToDataRoutes(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function mergeRouteUpdates(route, updates) {
    return Object.assign(route, (0, $lvTkn._)({}, updates, (0, $2bfPH._)(updates.lazy) === "object" && updates.lazy != null ? {
        lazy: (0, $lvTkn._)({}, route.lazy, updates.lazy)
    } : {}));
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function matchRoutes(routes, locationArg) {
    var basename = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "/";
    return matchRoutesImpl(routes, locationArg, basename, false);
}
function matchRoutesImpl(routes, locationArg, basename, allowPartial, precomputedBranches) {
    var pathname = stripBasename((typeof locationArg === "string" ? (0, $iKEZU.parsePath)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    var branches = precomputedBranches !== null && precomputedBranches !== void 0 ? precomputedBranches : flattenAndRankRoutes(routes);
    var matches = null;
    var decoded = decodePath(pathname);
    for(var i = 0; matches == null && i < branches.length; ++i)matches = matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function convertRouteMatchToUiMatch(match, loaderData) {
    var route = match.route, pathname = match.pathname, params = match.params;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function flattenAndRankRoutes(routes) {
    var branches = flattenRoutes(routes);
    rankRouteBranches(branches);
    return branches;
}
function flattenRoutes(routes) {
    var branches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], parentsMeta = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [], parentPath = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : "", _hasParentOptionalSegments = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var flattenRoute = function(route, index) {
        var hasParentOptionalSegments = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : _hasParentOptionalSegments, relativePath = arguments.length > 3 ? arguments[3] : void 0;
        var meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $iKEZU.invariant)(meta.relativePath.startsWith(parentPath), 'Absolute route path "'.concat(meta.relativePath, '" nested under path "').concat(parentPath, '" is not valid. An absolute child route path must start with the combined path of all its parent routes.'));
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        var path = joinPaths([
            parentPath,
            meta.relativePath
        ]);
        var routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $iKEZU.invariant)(route.index !== true, 'Index routes must not have child routes. Please remove all child routes from route path "'.concat(path, '".'));
            flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: computeScore(path, route.index),
            routesMeta: routesMeta.map(function(meta, i) {
                var _compilePath = (0, $21h22._)(compilePath(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1), 2), matcher = _compilePath[0], params = _compilePath[1];
                return (0, $9Jpjh._)((0, $lvTkn._)({}, meta), {
                    matcher: matcher,
                    compiledParams: params
                });
            })
        });
    };
    routes.forEach(function(route, index) {
        var _route_path;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (route.path === "" || !((_route_path = route.path) === null || _route_path === void 0 ? void 0 : _route_path.includes("?"))) flattenRoute(route, index);
        else try {
            for(var _iterator = explodeOptionalSegments(route.path)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var exploded = _step.value;
                flattenRoute(route, index, true, exploded);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    });
    return branches;
}
function explodeOptionalSegments(path) {
    var _result, _result1;
    var segments = path.split("/");
    if (segments.length === 0) return [];
    var _segments = (0, $ggKxj._)(segments), first = _segments[0], rest = _segments.slice(1);
    var isOptional = first.endsWith("?");
    var required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    var restExploded = explodeOptionalSegments(rest.join("/"));
    var result = [];
    (_result = result).push.apply(_result, (0, $6zk1M._)(restExploded.map(function(subpath) {
        return subpath === "" ? required : [
            required,
            subpath
        ].join("/");
    })));
    if (isOptional) (_result1 = result).push.apply(_result1, (0, $6zk1M._)(restExploded));
    return result.map(function(exploded) {
        return path.startsWith("/") && exploded === "" ? "/" : exploded;
    });
}
function rankRouteBranches(branches) {
    branches.sort(function(a, b) {
        return a.score !== b.score ? b.score - a.score : compareIndexes(a.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }), b.routesMeta.map(function(meta) {
            return meta.childrenIndex;
        }));
    });
}
var paramRe = /^:[\w-]+$/;
var partialParamRe = /^:[\w-]+/;
var partialDynamicSegmentValue = 3.5;
var dynamicSegmentValue = 3;
var indexRouteValue = 2;
var emptySegmentValue = 1;
var staticSegmentValue = 10;
var splatPenalty = -2;
var isSplat = function(s) {
    return s === "*";
};
function computeScore(path, index) {
    var segments = path.split("/");
    var initialScore = segments.length;
    if (segments.some(isSplat)) initialScore += splatPenalty;
    if (index) initialScore += indexRouteValue;
    return segments.filter(function(s) {
        return !isSplat(s);
    }).reduce(function(score, segment) {
        return score + (paramRe.test(segment) ? dynamicSegmentValue : partialParamRe.test(segment) ? partialDynamicSegmentValue : segment === "" ? emptySegmentValue : staticSegmentValue);
    }, initialScore);
}
function compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every(function(n, i) {
        return n === b[i];
    }) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function matchRouteBranch(branch, pathname) {
    var allowPartial = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var routesMeta = branch.routesMeta;
    var matchedParams = {};
    var matchedPathname = "/";
    var matches = [];
    for(var i = 0; i < routesMeta.length; ++i){
        var meta = routesMeta[i];
        var end = i === routesMeta.length - 1;
        var remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        var pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        var match = meta.matcher && meta.compiledParams ? matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : matchPath(pattern, remainingPathname);
        var route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = matchPath({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: joinPaths([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: normalizePathname(joinPaths([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = joinPaths([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ var PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function encodePathParam(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, function(match) {
        return PATH_PARAM_OVERESCAPED[match];
    });
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function generatePath(originalPath) {
    var params = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $iKEZU.warning)(false, 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
        path = path.replace(/\*$/, "/*");
    }
    var prefix = path.startsWith("/") ? "/" : "";
    var stringify = function(p) {
        return p == null ? "" : typeof p === "string" ? p : String(p);
    };
    return prefix + path.split(/\/+/).map(function(segment, index, array) {
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        var keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            var _keyMatch = (0, $21h22._)(keyMatch, 4), key = _keyMatch[1], optional = _keyMatch[2], suffix = _keyMatch[3];
            var param = params[key];
            (0, $iKEZU.invariant)(optional === "?" || param != null, 'Missing ":'.concat(key, '" param'));
            return encodePathParam(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter(function(segment) {
        return !!segment;
    }).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function matchPath(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    var _compilePath = (0, $21h22._)(compilePath(pattern.path, pattern.caseSensitive, pattern.end), 2), matcher = _compilePath[0], compiledParams = _compilePath[1];
    return matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function matchPathImpl(pattern, pathname, matcher, compiledParams) {
    var match = pathname.match(matcher);
    if (!match) return null;
    var matchedPathname = match[0];
    var pathnameBase = removeTrailingSlash(matchedPathname, 1);
    var captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce(function(memo, param, index) {
            var paramName = param.paramName, isOptional = param.isOptional;
            if (paramName === "*") {
                var splatValue = captureGroups[index] || "";
                pathnameBase = removeTrailingSlash(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            var value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function compilePath(path) {
    var caseSensitive = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, end = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    (0, $iKEZU.warning)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), 'Route path "'.concat(path, '" will be treated as if it were "').concat(path.replace(/\*$/, "/*"), '" because the `*` character must always follow a `/` in the pattern. To get rid of this warning, please change the route path to "').concat(path.replace(/\*$/, "/*"), '".'));
    var params = [];
    var regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, function(match, paramName, isOptional, index, str) {
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            var nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function decodePath(value) {
    try {
        return value.split("/").map(function(v) {
            return decodeURIComponent(v).replace(/\//g, "%2F");
        }).join("/");
    } catch (error) {
        (0, $iKEZU.warning)(false, 'The URL path "'.concat(value, '" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (').concat(error, ")."));
        return value;
    }
}
function stripBasename(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    var startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    var nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function prependBasename(param) {
    var basename = param.basename, pathname = param.pathname;
    return pathname === "/" ? basename : joinPaths([
        basename,
        pathname
    ]);
}
var isAbsoluteUrl = function(url) {
    return (0, $8onil.ABSOLUTE_URL_REGEX).test(url);
};
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function resolvePath(to) {
    var fromPathname = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : "/";
    var _ref = typeof to === "string" ? (0, $iKEZU.parsePath)(to) : to, toPathname = _ref.pathname, _ref_search = _ref.search, search = _ref_search === void 0 ? "" : _ref_search, _ref_hash = _ref.hash, hash = _ref_hash === void 0 ? "" : _ref_hash;
    var pathname;
    if (toPathname) {
        toPathname = removeDoubleSlashes(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = resolvePathname(toPathname.substring(1), "/");
        else pathname = resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: normalizeSearch(search),
        hash: normalizeHash(hash)
    };
}
function resolvePathname(relativePath, fromPathname) {
    var segments = removeTrailingSlash(fromPathname).split("/");
    relativePath.split("/").forEach(function(segment) {
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function getInvalidPathError(char, field, dest, path) {
    return "Cannot include a '".concat(char, "' character in a manually specified `to.").concat(field, "` field [").concat(JSON.stringify(path), "].  Please separate it out to the `to.").concat(dest, '` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.');
}
function getPathContributingMatches(matches) {
    return matches.filter(function(match, index) {
        return index === 0 || match.route.path && match.route.path.length > 0;
    });
}
function getResolveToMatches(matches) {
    var pathMatches = getPathContributingMatches(matches);
    return pathMatches.map(function(match, idx) {
        return idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase;
    });
}
function resolveTo(toArg, routePathnames, locationPathname) {
    var isPathRelative = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var to;
    if (typeof toArg === "string") to = (0, $iKEZU.parsePath)(toArg);
    else {
        to = (0, $lvTkn._)({}, toArg);
        (0, $iKEZU.invariant)(!to.pathname || !to.pathname.includes("?"), getInvalidPathError("?", "pathname", "search", to));
        (0, $iKEZU.invariant)(!to.pathname || !to.pathname.includes("#"), getInvalidPathError("#", "pathname", "hash", to));
        (0, $iKEZU.invariant)(!to.search || !to.search.includes("#"), getInvalidPathError("#", "search", "hash", to));
    }
    var isEmptyPath = toArg === "" || to.pathname === "";
    var toPathname = isEmptyPath ? "/" : to.pathname;
    var from;
    if (toPathname == null) from = locationPathname;
    else {
        var routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            var toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    var path = resolvePath(to, from);
    var hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    var hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
var removeDoubleSlashes = function(path) {
    return path.replace(/[\\/]{2,}/g, "/");
};
var joinPaths = function(paths) {
    return removeDoubleSlashes(paths.join("/"));
};
function removeTrailingSlash(path) {
    var minLength = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
var normalizePathname = function(pathname) {
    return removeTrailingSlash(pathname).replace(/^\/*/, "/");
};
var normalizeSearch = function(search) {
    return !search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
};
var normalizeHash = function(hash) {
    return !hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
};
var DataWithResponseInit = function DataWithResponseInit(data, init) {
    "use strict";
    (0, $gd0sY._)(this, DataWithResponseInit);
    (0, $khBmn._)(this, "type", "DataWithResponseInit");
    (0, $khBmn._)(this, "data", void 0);
    (0, $khBmn._)(this, "init", void 0);
    this.data = data;
    this.init = init || null;
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function data(data, init) {
    return new DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ var redirect = function(url) {
    var init = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 302;
    var responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    var headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, (0, $9Jpjh._)((0, $lvTkn._)({}, responseInit), {
        headers: headers
    }));
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ var redirectDocument = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ var replace = function(url, init) {
    var response = redirect(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
var SUPPORTED_ERROR_TYPES = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var ErrorResponseImpl = function ErrorResponseImpl(status, statusText, data) {
    "use strict";
    var internal = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    (0, $gd0sY._)(this, ErrorResponseImpl);
    (0, $khBmn._)(this, "status", void 0);
    (0, $khBmn._)(this, "statusText", void 0);
    (0, $khBmn._)(this, "data", void 0);
    (0, $khBmn._)(this, "error", void 0);
    (0, $khBmn._)(this, "internal", void 0);
    this.status = status;
    this.statusText = statusText || "";
    this.internal = internal;
    if (data instanceof Error) {
        this.data = data.toString();
        this.error = data;
    } else this.data = data;
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function isRouteErrorResponse(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function getRoutePattern(matches) {
    return joinPaths(matches.map(function(m) {
        return m.route.path;
    }).filter(Boolean)) || "/";
}
function createDataFunctionUrl(request, path) {
    var url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    var parsed = typeof path === "string" ? (0, $iKEZU.parsePath)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        var searchParams = new URLSearchParams(parsed.search);
        var indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = indexValues.filter(Boolean)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var value = _step.value;
                searchParams.append("index", value);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        var search = searchParams.toString();
        url.search = search ? "?".concat(search) : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
var isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function parseToInfo(_to, basename) {
    var to = _to;
    if (typeof to !== "string" || !(0, $8onil.ABSOLUTE_URL_REGEX).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    var absoluteURL = to;
    var isExternal = false;
    if (isBrowser) try {
        var currentUrl = new URL(window.location.href);
        var targetUrl = (0, $8onil.PROTOCOL_RELATIVE_URL_REGEX).test(to) ? new URL((0, $8onil.normalizeProtocolRelativeUrl)(to, currentUrl.protocol)) : new URL(to);
        var path = stripBasename(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch (e) {
        (0, $iKEZU.warning)(false, '<Link to="'.concat(to, '"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.'));
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}

});
parcelRegister("gd0sY", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bcce38db0d2b4516$export$71511d61b312f219; });
function $bcce38db0d2b4516$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

});

parcelRegister("bSRDS", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $8a6e590c6397f9f9$export$71511d61b312f219; });

var $iPdmD = parcelRequire("iPdmD");

var $5a6Ff = parcelRequire("5a6Ff");
function $8a6e590c6397f9f9$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $5a6Ff._)(receiver, privateMap, "get");
    return (0, $iPdmD._)(receiver, descriptor);
}

});
parcelRegister("iPdmD", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $db475b3dfcc3516f$export$71511d61b312f219; });
function $db475b3dfcc3516f$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}

});

parcelRegister("5a6Ff", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $3c230e533a2da257$export$71511d61b312f219; });
function $3c230e533a2da257$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}

});


parcelRegister("6wbrO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4bee9c7ba705d98d$export$71511d61b312f219; });

var $9Fdx8 = parcelRequire("9Fdx8");
function $4bee9c7ba705d98d$export$71511d61b312f219(obj, privateMap, value) {
    (0, $9Fdx8._)(obj, privateMap);
    privateMap.set(obj, value);
}

});
parcelRegister("9Fdx8", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $709270e016e9c0bb$export$71511d61b312f219; });
function $709270e016e9c0bb$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}

});


parcelRegister("7cSld", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $53f3ce6e74f6aaad$export$71511d61b312f219; });
function $53f3ce6e74f6aaad$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $53f3ce6e74f6aaad$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $53f3ce6e74f6aaad$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}

});

parcelRegister("khBmn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $ec426015f75d7738$export$71511d61b312f219; });
function $ec426015f75d7738$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}

});

parcelRegister("lvTkn", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $fa9769297b8a68c8$export$71511d61b312f219; });

var $khBmn = parcelRequire("khBmn");
function $fa9769297b8a68c8$export$71511d61b312f219(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
            return Object.getOwnPropertyDescriptor(source, sym).enumerable;
        }));
        ownKeys.forEach(function(key) {
            (0, $khBmn._)(target, key, source[key]);
        });
    }
    return target;
}

});

parcelRegister("9Jpjh", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $715bf31211e65705$export$71511d61b312f219; });
function $715bf31211e65705$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        });
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function $715bf31211e65705$export$71511d61b312f219(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    else $715bf31211e65705$var$ownKeys(Object(source)).forEach(function(key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
    return target;
}

});

parcelRegister("21h22", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $1788e2ed61915b1e$export$71511d61b312f219; });

var $cMcR0 = parcelRequire("cMcR0");

var $dSjL4 = parcelRequire("dSjL4");

var $3HRhO = parcelRequire("3HRhO");

var $isiou = parcelRequire("isiou");
function $1788e2ed61915b1e$export$71511d61b312f219(arr, i) {
    return (0, $cMcR0._)(arr) || (0, $dSjL4._)(arr, i) || (0, $isiou._)(arr, i) || (0, $3HRhO._)();
}

});
parcelRegister("cMcR0", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $94d3f045916e0583$export$71511d61b312f219; });
function $94d3f045916e0583$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}

});

parcelRegister("dSjL4", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $a19fa517098223d7$export$71511d61b312f219; });
function $a19fa517098223d7$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}

});

parcelRegister("3HRhO", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $2b2eb8ca3633154b$export$71511d61b312f219; });
function $2b2eb8ca3633154b$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});

parcelRegister("isiou", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $d6f91c356a8197fd$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $d6f91c356a8197fd$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $azbvf._)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $azbvf._)(o, minLen);
}

});
parcelRegister("azbvf", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $7b161889ca248e24$export$71511d61b312f219; });
function $7b161889ca248e24$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}

});



parcelRegister("ggKxj", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $bd823d1c24941985$export$71511d61b312f219; });

var $cMcR0 = parcelRequire("cMcR0");

var $faXM9 = parcelRequire("faXM9");

var $3HRhO = parcelRequire("3HRhO");

var $isiou = parcelRequire("isiou");
function $bd823d1c24941985$export$71511d61b312f219(arr) {
    return (0, $cMcR0._)(arr) || (0, $faXM9._)(arr) || (0, $isiou._)(arr) || (0, $3HRhO._)();
}

});
parcelRegister("faXM9", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $b0c62864eda90b51$export$71511d61b312f219; });
function $b0c62864eda90b51$export$71511d61b312f219(iter) {
    if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}

});


parcelRegister("6zk1M", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $4c858c0d999a5b9b$export$71511d61b312f219; });

var $lltIQ = parcelRequire("lltIQ");

var $faXM9 = parcelRequire("faXM9");

var $hMl05 = parcelRequire("hMl05");

var $isiou = parcelRequire("isiou");
function $4c858c0d999a5b9b$export$71511d61b312f219(arr) {
    return (0, $lltIQ._)(arr) || (0, $faXM9._)(arr) || (0, $isiou._)(arr) || (0, $hMl05._)();
}

});
parcelRegister("lltIQ", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $f8a29d58f287cd3d$export$71511d61b312f219; });

var $azbvf = parcelRequire("azbvf");
function $f8a29d58f287cd3d$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return (0, $azbvf._)(arr);
}

});

parcelRegister("hMl05", function(module, exports) {

$parcel$export(module.exports, "_", function () { return $cf17359bdd687909$export$71511d61b312f219; });
function $cf17359bdd687909$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

});


parcelRegister("8onil", function(module, exports) {

$parcel$export(module.exports, "ABSOLUTE_URL_REGEX", function () { return $61c2a284e86a7fbc$export$6c52c2011d568bd0; });
$parcel$export(module.exports, "PROTOCOL_RELATIVE_URL_REGEX", function () { return $61c2a284e86a7fbc$export$825a82322d91916e; });
$parcel$export(module.exports, "normalizeProtocolRelativeUrl", function () { return $61c2a284e86a7fbc$export$977999b735cd4f26; });
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
var $61c2a284e86a7fbc$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
var $61c2a284e86a7fbc$export$825a82322d91916e = /^[\\/]{2}/;
function $61c2a284e86a7fbc$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}

});

parcelRegister("iKEZU", function(module, exports) {

$parcel$export(module.exports, "createMemoryHistory", function () { return $da6c532163255563$export$2b76ad033c6e6d08; });
$parcel$export(module.exports, "createLocation", function () { return $da6c532163255563$export$90c043f1c57770b8; });
$parcel$export(module.exports, "warning", function () { return $da6c532163255563$export$491112666e282270; });
$parcel$export(module.exports, "createPath", function () { return $da6c532163255563$export$fe53371bee54353d; });
$parcel$export(module.exports, "parsePath", function () { return $da6c532163255563$export$8ccf933b0513f8d0; });
$parcel$export(module.exports, "createBrowserHistory", function () { return $da6c532163255563$export$719fc203c4e16dee; });
$parcel$export(module.exports, "createHashHistory", function () { return $da6c532163255563$export$b71fdd3798280242; });
$parcel$export(module.exports, "invariant", function () { return $da6c532163255563$export$f5708dca728d7177; });
$parcel$export(module.exports, "createBrowserURLImpl", function () { return $da6c532163255563$export$e2450fce17852bf2; });
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $2bfPH = parcelRequire("2bfPH");

var $8onil = parcelRequire("8onil");
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ var $da6c532163255563$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
var $da6c532163255563$var$PopStateEventType = "popstate";
function $da6c532163255563$var$isLocation(obj) {
    return (typeof obj === "undefined" ? "undefined" : (0, $2bfPH._)(obj)) === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $da6c532163255563$export$2b76ad033c6e6d08() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_initialEntries = options.initialEntries, initialEntries = _options_initialEntries === void 0 ? [
        "/"
    ] : _options_initialEntries, initialIndex = options.initialIndex, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var entries;
    entries = initialEntries.map(function(entry, index) {
        return createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask);
    });
    var index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    var action = "POP";
    var listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to) {
        var state = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : null, key = arguments.length > 2 ? arguments[2] : void 0, mask = arguments.length > 3 ? arguments[3] : void 0;
        var location = $da6c532163255563$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $da6c532163255563$export$491112666e282270(location.pathname.charAt(0) === "/", "relative pathnames are not supported in memory history: ".concat(JSON.stringify(to)));
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $da6c532163255563$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL: function(to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation: function(to) {
            var path = typeof to === "string" ? $da6c532163255563$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push: function(to, state) {
            action = "PUSH";
            var nextLocation = $da6c532163255563$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace: function(to, state) {
            action = "REPLACE";
            var nextLocation = $da6c532163255563$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go: function(delta) {
            action = "POP";
            var nextIndex = clampIndex(index + delta);
            var nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen: function(fn) {
            listener = fn;
            return function() {
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $da6c532163255563$export$719fc203c4e16dee() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createBrowserLocation(window, globalHistory) {
        var _globalHistory_state;
        var maskedLocation = (_globalHistory_state = globalHistory.state) === null || _globalHistory_state === void 0 ? void 0 : _globalHistory_state.masked;
        var _ref = maskedLocation || window.location, pathname = _ref.pathname, search = _ref.search, hash = _ref.hash;
        return $da6c532163255563$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $da6c532163255563$export$fe53371bee54353d(to);
    }
    return $da6c532163255563$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $da6c532163255563$export$b71fdd3798280242() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    function createHashLocation(window, globalHistory) {
        var _parsePath = $da6c532163255563$export$8ccf933b0513f8d0(window.location.hash.substring(1)), _parsePath_pathname = _parsePath.pathname, pathname = _parsePath_pathname === void 0 ? "/" : _parsePath_pathname, _parsePath_search = _parsePath.search, search = _parsePath_search === void 0 ? "" : _parsePath_search, _parsePath_hash = _parsePath.hash, hash = _parsePath_hash === void 0 ? "" : _parsePath_hash;
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $da6c532163255563$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        var base = window.document.querySelector("base");
        var href = "";
        if (base && base.getAttribute("href")) {
            var url = window.location.href;
            var hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $da6c532163255563$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $da6c532163255563$export$491112666e282270(location.pathname.charAt(0) === "/", "relative pathnames are not supported in hash history.push(".concat(JSON.stringify(to), ")"));
    }
    return $da6c532163255563$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $da6c532163255563$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $da6c532163255563$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch (e) {}
    }
}
function $da6c532163255563$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $da6c532163255563$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $da6c532163255563$export$90c043f1c57770b8(current, to) {
    var state = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : null, key = arguments.length > 3 ? arguments[3] : void 0, mask = arguments.length > 4 ? arguments[4] : void 0;
    return (0, $9Jpjh._)((0, $lvTkn._)({
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: ""
    }, typeof to === "string" ? $da6c532163255563$export$8ccf933b0513f8d0(to) : to), {
        state: state,
        key: to && to.key || key || $da6c532163255563$var$createKey(),
        mask: mask
    });
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $da6c532163255563$export$fe53371bee54353d(param) {
    var _param_pathname = param.pathname, pathname = _param_pathname === void 0 ? "/" : _param_pathname, _param_search = param.search, search = _param_search === void 0 ? "" : _param_search, _param_hash = param.hash, hash = _param_hash === void 0 ? "" : _param_hash;
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $da6c532163255563$export$8ccf933b0513f8d0(path) {
    var parsedPath = {};
    if (path) {
        var hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        var searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $da6c532163255563$var$getUrlBasedHistory(getLocation, createHref, validateLocation) {
    var options = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
    var _options_window = options.window, window = _options_window === void 0 ? document.defaultView : _options_window, _options_v5Compat = options.v5Compat, v5Compat = _options_v5Compat === void 0 ? false : _options_v5Compat;
    var globalHistory = window.history;
    var action = "POP";
    var listener = null;
    var index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState((0, $9Jpjh._)((0, $lvTkn._)({}, globalHistory.state), {
            idx: index
        }), "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        var nextIndex = getIndex();
        var delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        var location = $da6c532163255563$var$isLocation(to) ? to : $da6c532163255563$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        var historyState = $da6c532163255563$var$getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        var location = $da6c532163255563$var$isLocation(to) ? to : $da6c532163255563$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        var historyState = $da6c532163255563$var$getHistoryState(location, index);
        var url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $da6c532163255563$export$e2450fce17852bf2(window, to);
    }
    var history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen: function(fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($da6c532163255563$var$PopStateEventType, handlePop);
            listener = fn;
            return function() {
                window.removeEventListener($da6c532163255563$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref: function(to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation: function(to) {
            var url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go: function(n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $da6c532163255563$export$e2450fce17852bf2(windowImpl, to) {
    var isAbsolute = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $da6c532163255563$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    var href = typeof to === "string" ? to : $da6c532163255563$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $8onil.PROTOCOL_RELATIVE_URL_REGEX).test(href)) href = base + href;
    return new URL(href, base);
}

});


parcelRegister("7XifO", function(module, exports) {

$parcel$export(module.exports, "useSyncExternalStore", function () { return $5cac33f39ab217c5$export$306c0aa65ff9ec16; }, function (v) { return $5cac33f39ab217c5$export$306c0aa65ff9ec16 = v; });
/**
 * @license React
 * use-sync-external-store-shim.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $5cac33f39ab217c5$export$306c0aa65ff9ec16;
"use strict";

var $eHaBZ = parcelRequire("eHaBZ");
function $5cac33f39ab217c5$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5cac33f39ab217c5$var$objectIs = "function" === typeof Object.is ? Object.is : $5cac33f39ab217c5$var$is, $5cac33f39ab217c5$var$useState = $eHaBZ.useState, $5cac33f39ab217c5$var$useEffect = $eHaBZ.useEffect, $5cac33f39ab217c5$var$useLayoutEffect = $eHaBZ.useLayoutEffect, $5cac33f39ab217c5$var$useDebugValue = $eHaBZ.useDebugValue;
function $5cac33f39ab217c5$var$useSyncExternalStore$2(subscribe, getSnapshot) {
    var value = getSnapshot(), _useState = $5cac33f39ab217c5$var$useState({
        inst: {
            value: value,
            getSnapshot: getSnapshot
        }
    }), inst = _useState[0].inst, forceUpdate = _useState[1];
    $5cac33f39ab217c5$var$useLayoutEffect(function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
    }, [
        subscribe,
        value,
        getSnapshot
    ]);
    $5cac33f39ab217c5$var$useEffect(function() {
        $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
            inst: inst
        });
        return subscribe(function() {
            $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) && forceUpdate({
                inst: inst
            });
        });
    }, [
        subscribe
    ]);
    $5cac33f39ab217c5$var$useDebugValue(value);
    return value;
}
function $5cac33f39ab217c5$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$5cac33f39ab217c5$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $5cac33f39ab217c5$var$useSyncExternalStore$1(subscribe, getSnapshot) {
    return getSnapshot();
}
var $5cac33f39ab217c5$var$shim = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? $5cac33f39ab217c5$var$useSyncExternalStore$1 : $5cac33f39ab217c5$var$useSyncExternalStore$2;
$5cac33f39ab217c5$export$306c0aa65ff9ec16 = void 0 !== $eHaBZ.useSyncExternalStore ? $eHaBZ.useSyncExternalStore : $5cac33f39ab217c5$var$shim;

});

var $2e1ea95958ac9c1d$exports = {};
$parcel$extendImportMap({
    "inoyv": "selfoss-sw-offline.js"
});

var $61e8f293f375c170$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 
var $2bfPH = parcelRequire("2bfPH");
var $61e8f293f375c170$var$runtime = function(exports) {
    "use strict";
    var Op = Object.prototype;
    var hasOwn = Op.hasOwnProperty;
    var defineProperty = Object.defineProperty || function(obj, key, desc) {
        obj[key] = desc.value;
    };
    var undefined; // More compressible than void 0.
    var $Symbol = typeof Symbol === "function" ? Symbol : {};
    var iteratorSymbol = $Symbol.iterator || "@@iterator";
    var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
    var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
    function define(obj, key, value) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
        return obj[key];
    }
    try {
        // IE 8 has a broken Object.defineProperty that only works on DOM objects.
        define({}, "");
    } catch (err) {
        define = function define(obj, key, value) {
            return obj[key] = value;
        };
    }
    function wrap(innerFn, outerFn, self, tryLocsList) {
        // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
        var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
        var generator = Object.create(protoGenerator.prototype);
        var context = new Context(tryLocsList || []);
        // The ._invoke method unifies the implementations of the .next,
        // .throw, and .return methods.
        defineProperty(generator, "_invoke", {
            value: makeInvokeMethod(innerFn, self, context)
        });
        return generator;
    }
    exports.wrap = wrap;
    // Try/catch helper to minimize deoptimizations. Returns a completion
    // record like context.tryEntries[i].completion. This interface could
    // have been (and was previously) designed to take a closure to be
    // invoked without arguments, but in all the cases we care about we
    // already have an existing method we want to call, so there's no need
    // to create a new function object. We can even get away with assuming
    // the method takes exactly one argument, since that happens to be true
    // in every case, so we don't have to touch the arguments object. The
    // only additional allocation required is the completion record, which
    // has a stable shape and so hopefully should be cheap to allocate.
    function tryCatch(fn, obj, arg) {
        try {
            return {
                type: "normal",
                arg: fn.call(obj, arg)
            };
        } catch (err) {
            return {
                type: "throw",
                arg: err
            };
        }
    }
    var GenStateSuspendedStart = "suspendedStart";
    var GenStateSuspendedYield = "suspendedYield";
    var GenStateExecuting = "executing";
    var GenStateCompleted = "completed";
    // Returning this object from the innerFn has the same effect as
    // breaking out of the dispatch switch statement.
    var ContinueSentinel = {};
    // Dummy constructor functions that we use as the .constructor and
    // .constructor.prototype properties for functions that return Generator
    // objects. For full spec compliance, you may wish to configure your
    // minifier not to mangle the names of these two functions.
    function Generator() {}
    function GeneratorFunction() {}
    function GeneratorFunctionPrototype() {}
    // This is a polyfill for %IteratorPrototype% for environments that
    // don't natively support it.
    var IteratorPrototype = {};
    define(IteratorPrototype, iteratorSymbol, function() {
        return this;
    });
    var getProto = Object.getPrototypeOf;
    var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
    if (NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
    var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
    GeneratorFunction.prototype = GeneratorFunctionPrototype;
    defineProperty(Gp, "constructor", {
        value: GeneratorFunctionPrototype,
        configurable: true
    });
    defineProperty(GeneratorFunctionPrototype, "constructor", {
        value: GeneratorFunction,
        configurable: true
    });
    GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction");
    // Helper for defining the .next, .throw, and .return methods of the
    // Iterator interface in terms of a single ._invoke method.
    function defineIteratorMethods(prototype) {
        [
            "next",
            "throw",
            "return"
        ].forEach(function(method) {
            define(prototype, method, function(arg) {
                return this._invoke(method, arg);
            });
        });
    }
    exports.isGeneratorFunction = function(genFun) {
        var ctor = typeof genFun === "function" && genFun.constructor;
        return ctor ? ctor === GeneratorFunction || // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction" : false;
    };
    exports.mark = function(genFun) {
        if (Object.setPrototypeOf) Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
        else {
            genFun.__proto__ = GeneratorFunctionPrototype;
            define(genFun, toStringTagSymbol, "GeneratorFunction");
        }
        genFun.prototype = Object.create(Gp);
        return genFun;
    };
    // Within the body of any async function, `await x` is transformed to
    // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
    // `hasOwn.call(value, "__await")` to determine if the yielded value is
    // meant to be awaited.
    exports.awrap = function(arg) {
        return {
            __await: arg
        };
    };
    function AsyncIterator(generator, PromiseImpl) {
        function invoke(method, arg, resolve, reject) {
            var record = tryCatch(generator[method], generator, arg);
            if (record.type === "throw") reject(record.arg);
            else {
                var result = record.arg;
                var value = result.value;
                if (value && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && hasOwn.call(value, "__await")) return PromiseImpl.resolve(value.__await).then(function(value) {
                    invoke("next", value, resolve, reject);
                }, function(err) {
                    invoke("throw", err, resolve, reject);
                });
                return PromiseImpl.resolve(value).then(function(unwrapped) {
                    // When a yielded Promise is resolved, its final value becomes
                    // the .value of the Promise<{value,done}> result for the
                    // current iteration.
                    result.value = unwrapped;
                    resolve(result);
                }, function(error) {
                    // If a rejected Promise was yielded, throw the rejection back
                    // into the async generator function so it can be handled there.
                    return invoke("throw", error, resolve, reject);
                });
            }
        }
        var previousPromise;
        function enqueue(method, arg) {
            function callInvokeWithMethodAndArg() {
                return new PromiseImpl(function(resolve, reject) {
                    invoke(method, arg, resolve, reject);
                });
            }
            return previousPromise = // If enqueue has been called before, then we want to wait until
            // all previous Promises have been resolved before calling invoke,
            // so that results are always delivered in the correct order. If
            // enqueue has not been called before, then it is important to
            // call invoke immediately, without waiting on a callback to fire,
            // so that the async generator function has the opportunity to do
            // any necessary setup in a predictable way. This predictability
            // is why the Promise constructor synchronously invokes its
            // executor callback, and why async functions synchronously
            // execute code before the first await. Since we implement simple
            // async functions in terms of async generators, it is especially
            // important to get this right, even though it requires care.
            previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, // Avoid propagating failures to Promises returned by later
            // invocations of the iterator.
            callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
        }
        // Define the unified helper method that is used to implement .next,
        // .throw, and .return (see defineIteratorMethods).
        defineProperty(this, "_invoke", {
            value: enqueue
        });
    }
    defineIteratorMethods(AsyncIterator.prototype);
    define(AsyncIterator.prototype, asyncIteratorSymbol, function() {
        return this;
    });
    exports.AsyncIterator = AsyncIterator;
    // Note that simple async functions are implemented on top of
    // AsyncIterator objects; they just return a Promise for the value of
    // the final result produced by the iterator.
    exports.async = function(innerFn, outerFn, self, tryLocsList, PromiseImpl) {
        if (PromiseImpl === void 0) PromiseImpl = Promise;
        var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
        return exports.isGeneratorFunction(outerFn) ? iter // If outerFn is a generator, return the full iterator.
         : iter.next().then(function(result) {
            return result.done ? result.value : iter.next();
        });
    };
    function makeInvokeMethod(innerFn, self, context) {
        var state = GenStateSuspendedStart;
        return function invoke(method, arg) {
            if (state === GenStateExecuting) throw new Error("Generator is already running");
            if (state === GenStateCompleted) {
                if (method === "throw") throw arg;
                // Be forgiving, per GeneratorResume behavior specified since ES2015:
                // ES2015 spec, step 3: https://262.ecma-international.org/6.0/#sec-generatorresume
                // Latest spec, step 2: https://tc39.es/ecma262/#sec-generatorresume
                return doneResult();
            }
            context.method = method;
            context.arg = arg;
            while(true){
                var delegate = context.delegate;
                if (delegate) {
                    var delegateResult = maybeInvokeDelegate(delegate, context);
                    if (delegateResult) {
                        if (delegateResult === ContinueSentinel) continue;
                        return delegateResult;
                    }
                }
                if (context.method === "next") // Setting context._sent for legacy support of Babel's
                // function.sent implementation.
                context.sent = context._sent = context.arg;
                else if (context.method === "throw") {
                    if (state === GenStateSuspendedStart) {
                        state = GenStateCompleted;
                        throw context.arg;
                    }
                    context.dispatchException(context.arg);
                } else if (context.method === "return") context.abrupt("return", context.arg);
                state = GenStateExecuting;
                var record = tryCatch(innerFn, self, context);
                if (record.type === "normal") {
                    // If an exception is thrown from innerFn, we leave state ===
                    // GenStateExecuting and loop back for another invocation.
                    state = context.done ? GenStateCompleted : GenStateSuspendedYield;
                    if (record.arg === ContinueSentinel) continue;
                    return {
                        value: record.arg,
                        done: context.done
                    };
                } else if (record.type === "throw") {
                    state = GenStateCompleted;
                    // Dispatch the exception by looping back around to the
                    // context.dispatchException(context.arg) call above.
                    context.method = "throw";
                    context.arg = record.arg;
                }
            }
        };
    }
    // Call delegate.iterator[context.method](context.arg) and handle the
    // result, either by returning a { value, done } result from the
    // delegate iterator, or by modifying context.method and context.arg,
    // setting context.delegate to null, and returning the ContinueSentinel.
    function maybeInvokeDelegate(delegate, context) {
        var methodName = context.method;
        var method = delegate.iterator[methodName];
        if (method === undefined) {
            // A .throw or .return when the delegate iterator has no .throw
            // method, or a missing .next method, always terminate the
            // yield* loop.
            context.delegate = null;
            // Note: ["return"] must be used for ES3 parsing compatibility.
            if (methodName === "throw" && delegate.iterator["return"]) {
                // If the delegate iterator has a return method, give it a
                // chance to clean up.
                context.method = "return";
                context.arg = undefined;
                maybeInvokeDelegate(delegate, context);
                if (context.method === "throw") // If maybeInvokeDelegate(context) changed context.method from
                // "return" to "throw", let that override the TypeError below.
                return ContinueSentinel;
            }
            if (methodName !== "return") {
                context.method = "throw";
                context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method");
            }
            return ContinueSentinel;
        }
        var record = tryCatch(method, delegate.iterator, context.arg);
        if (record.type === "throw") {
            context.method = "throw";
            context.arg = record.arg;
            context.delegate = null;
            return ContinueSentinel;
        }
        var info = record.arg;
        if (!info) {
            context.method = "throw";
            context.arg = new TypeError("iterator result is not an object");
            context.delegate = null;
            return ContinueSentinel;
        }
        if (info.done) {
            // Assign the result of the finished delegate to the temporary
            // variable specified by delegate.resultName (see delegateYield).
            context[delegate.resultName] = info.value;
            // Resume execution at the desired location (see delegateYield).
            context.next = delegate.nextLoc;
            // If context.method was "throw" but the delegate handled the
            // exception, let the outer generator proceed normally. If
            // context.method was "next", forget context.arg since it has been
            // "consumed" by the delegate iterator. If context.method was
            // "return", allow the original .return call to continue in the
            // outer generator.
            if (context.method !== "return") {
                context.method = "next";
                context.arg = undefined;
            }
        } else // Re-yield the result returned by the delegate method.
        return info;
        // The delegate iterator is finished, so forget it and continue with
        // the outer generator.
        context.delegate = null;
        return ContinueSentinel;
    }
    // Define Generator.prototype.{next,throw,return} in terms of the
    // unified ._invoke helper method.
    defineIteratorMethods(Gp);
    define(Gp, toStringTagSymbol, "Generator");
    // A Generator should always return itself as the iterator object when the
    // @@iterator function is called on it. Some browsers' implementations of the
    // iterator prototype chain incorrectly implement this, causing the Generator
    // object to not be returned from this call. This ensures that doesn't happen.
    // See https://github.com/facebook/regenerator/issues/274 for more details.
    define(Gp, iteratorSymbol, function() {
        return this;
    });
    define(Gp, "toString", function() {
        return "[object Generator]";
    });
    function pushTryEntry(locs) {
        var entry = {
            tryLoc: locs[0]
        };
        if (1 in locs) entry.catchLoc = locs[1];
        if (2 in locs) {
            entry.finallyLoc = locs[2];
            entry.afterLoc = locs[3];
        }
        this.tryEntries.push(entry);
    }
    function resetTryEntry(entry) {
        var record = entry.completion || {};
        record.type = "normal";
        delete record.arg;
        entry.completion = record;
    }
    function Context(tryLocsList) {
        // The root entry object (effectively a try statement without a catch
        // or a finally block) gives us a place to store values thrown from
        // locations where there is no enclosing try statement.
        this.tryEntries = [
            {
                tryLoc: "root"
            }
        ];
        tryLocsList.forEach(pushTryEntry, this);
        this.reset(true);
    }
    exports.keys = function(val) {
        var object = Object(val);
        var keys = [];
        for(var key in object)keys.push(key);
        keys.reverse();
        // Rather than returning an object with a next method, we keep
        // things simple and return the next function itself.
        return function next() {
            while(keys.length){
                var key = keys.pop();
                if (key in object) {
                    next.value = key;
                    next.done = false;
                    return next;
                }
            }
            // To avoid creating an additional object, we just hang the .value
            // and .done properties off the next function object itself. This
            // also ensures that the minifier will not anonymize the function.
            next.done = true;
            return next;
        };
    };
    function values(iterable) {
        if (iterable != null) {
            var iteratorMethod = iterable[iteratorSymbol];
            if (iteratorMethod) return iteratorMethod.call(iterable);
            if (typeof iterable.next === "function") return iterable;
            if (!isNaN(iterable.length)) {
                var i = -1, next = function next() {
                    while(++i < iterable.length)if (hasOwn.call(iterable, i)) {
                        next.value = iterable[i];
                        next.done = false;
                        return next;
                    }
                    next.value = undefined;
                    next.done = true;
                    return next;
                };
                return next.next = next;
            }
        }
        throw new TypeError((typeof iterable === "undefined" ? "undefined" : (0, $2bfPH._)(iterable)) + " is not iterable");
    }
    exports.values = values;
    function doneResult() {
        return {
            value: undefined,
            done: true
        };
    }
    Context.prototype = {
        constructor: Context,
        reset: function reset(skipTempReset) {
            this.prev = 0;
            this.next = 0;
            // Resetting context._sent for legacy support of Babel's
            // function.sent implementation.
            this.sent = this._sent = undefined;
            this.done = false;
            this.delegate = null;
            this.method = "next";
            this.arg = undefined;
            this.tryEntries.forEach(resetTryEntry);
            if (!skipTempReset) {
                for(var name in this)// Not sure about the optimal order of these conditions:
                if (name.charAt(0) === "t" && hasOwn.call(this, name) && !isNaN(+name.slice(1))) this[name] = undefined;
            }
        },
        stop: function stop() {
            this.done = true;
            var rootEntry = this.tryEntries[0];
            var rootRecord = rootEntry.completion;
            if (rootRecord.type === "throw") throw rootRecord.arg;
            return this.rval;
        },
        dispatchException: function dispatchException(exception) {
            if (this.done) throw exception;
            var context = this;
            function handle(loc, caught) {
                record.type = "throw";
                record.arg = exception;
                context.next = loc;
                if (caught) {
                    // If the dispatched exception was caught by a catch block,
                    // then let that catch block handle the exception normally.
                    context.method = "next";
                    context.arg = undefined;
                }
                return !!caught;
            }
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                var record = entry.completion;
                if (entry.tryLoc === "root") // Exception thrown outside of any try block that could handle
                // it, so set the completion value of the entire function to
                // throw the exception.
                return handle("end");
                if (entry.tryLoc <= this.prev) {
                    var hasCatch = hasOwn.call(entry, "catchLoc");
                    var hasFinally = hasOwn.call(entry, "finallyLoc");
                    if (hasCatch && hasFinally) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                        else if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else if (hasCatch) {
                        if (this.prev < entry.catchLoc) return handle(entry.catchLoc, true);
                    } else if (hasFinally) {
                        if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
                    } else throw new Error("try statement without catch or finally");
                }
            }
        },
        abrupt: function abrupt(type, arg) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
                    var finallyEntry = entry;
                    break;
                }
            }
            if (finallyEntry && (type === "break" || type === "continue") && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc) // Ignore the finally entry if control is not jumping to a
            // location outside the try/catch block.
            finallyEntry = null;
            var record = finallyEntry ? finallyEntry.completion : {};
            record.type = type;
            record.arg = arg;
            if (finallyEntry) {
                this.method = "next";
                this.next = finallyEntry.finallyLoc;
                return ContinueSentinel;
            }
            return this.complete(record);
        },
        complete: function complete(record, afterLoc) {
            if (record.type === "throw") throw record.arg;
            if (record.type === "break" || record.type === "continue") this.next = record.arg;
            else if (record.type === "return") {
                this.rval = this.arg = record.arg;
                this.method = "return";
                this.next = "end";
            } else if (record.type === "normal" && afterLoc) this.next = afterLoc;
            return ContinueSentinel;
        },
        finish: function finish(finallyLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.finallyLoc === finallyLoc) {
                    this.complete(entry.completion, entry.afterLoc);
                    resetTryEntry(entry);
                    return ContinueSentinel;
                }
            }
        },
        "catch": function(tryLoc) {
            for(var i = this.tryEntries.length - 1; i >= 0; --i){
                var entry = this.tryEntries[i];
                if (entry.tryLoc === tryLoc) {
                    var record = entry.completion;
                    if (record.type === "throw") {
                        var thrown = record.arg;
                        resetTryEntry(entry);
                    }
                    return thrown;
                }
            }
            // The context.catch method must only be called with a location
            // argument that corresponds to a known catch block.
            throw new Error("illegal catch attempt");
        },
        delegateYield: function delegateYield(iterable, resultName, nextLoc) {
            this.delegate = {
                iterator: values(iterable),
                resultName: resultName,
                nextLoc: nextLoc
            };
            if (this.method === "next") // Deliberately forget the last sent value so that we don't
            // accidentally pass it on to the delegate.
            this.arg = undefined;
            return ContinueSentinel;
        }
    };
    // Regardless of whether this script is executing as a CommonJS module
    // or not, return the runtime object so that we can declare the variable
    // regeneratorRuntime in the outer scope, which allows this module to be
    // injected easily by `bin/regenerator --include-runtime script.js`.
    return exports;
}(// If this script is executing as a CommonJS module, use module.exports
// as the regeneratorRuntime namespace. Otherwise create a new empty
// object. Either way, the resulting object will be used to initialize
// the regeneratorRuntime variable at the top of this file.
(0, $61e8f293f375c170$exports));
try {
    regeneratorRuntime = $61e8f293f375c170$var$runtime;
} catch (accidentalStrictMode) {
    // This module should not be running in strict mode, so the above
    // assignment should always work unless something is misconfigured. Just
    // in case runtime.js accidentally runs in strict mode, in modern engines
    // we can explicitly access globalThis. In older engines we can escape
    // strict mode using a global Function call. This could conceivably fail
    // if a Content Security Policy forbids using Function, but in that case
    // the proper solution is to fix the accidental strict mode problem. If
    // you've misconfigured your bundler to force strict mode and applied a
    // CSP to forbid Function, and you're not willing to fix either of those
    // problems, please detail your unique predicament in a GitHub issue.
    if ((typeof globalThis === "undefined" ? "undefined" : (0, $2bfPH._)(globalThis)) === "object") globalThis.regeneratorRuntime = $61e8f293f375c170$var$runtime;
    else Function("r", "regeneratorRuntime = r")($61e8f293f375c170$var$runtime);
}


function $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) resolve(value);
    else Promise.resolve(value).then(_next, _throw);
}
function $14c571840e589f0e$export$71511d61b312f219(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                $14c571840e589f0e$var$asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}



var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");
function $daac50d2f5864f61$export$71511d61b312f219(thisArg, body) {
    var f, y, t, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype), d = Object.defineProperty;
    return d(g, "next", {
        value: verb(0)
    }), d(g, "throw", {
        value: verb(1)
    }), d(g, "return", {
        value: verb(2)
    }), typeof Symbol === "function" && d(g, Symbol.iterator, {
        value: function() {
            return this;
        }
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}


var $59e7dcc9c52865c1$exports = {};
'use strict';
function $59e7dcc9c52865c1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($59e7dcc9c52865c1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$59e7dcc9c52865c1$var$checkDCE();

$59e7dcc9c52865c1$exports = (parcelRequire("dXF9p"));


function $5982ea1ba8b4c6e7$export$71511d61b312f219(o) {
    $5982ea1ba8b4c6e7$export$71511d61b312f219 = Object.setPrototypeOf ? Object.getPrototypeOf : function getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $5982ea1ba8b4c6e7$export$71511d61b312f219(o);
}


function $e0202b2b0021476d$export$71511d61b312f219() {
    // Since Reflect.construct can't be properly polyfilled, some
    // implementations (e.g. core-js@2) don't set the correct internal slots.
    // Those polyfills don't allow us to subclass built-ins, so we need to
    // use our fallback implementation.
    try {
        // If the internal slots aren't set, this throws an error similar to
        //   TypeError: this is not a Boolean object.
        var result = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
    } catch (_) {}
    return ($e0202b2b0021476d$export$71511d61b312f219 = function() {
        return !!result;
    })();
}


function $ee29917471fa094f$export$71511d61b312f219(self) {
    if (self === void 0) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
    return self;
}



var $2bfPH = parcelRequire("2bfPH");
function $95d08371c2c4ef4e$export$71511d61b312f219(self, call) {
    if (call && ((0, $2bfPH._)(call) === "object" || typeof call === "function")) return call;
    return (0, $ee29917471fa094f$export$71511d61b312f219)(self);
}


function $638732d3362fdd56$export$71511d61b312f219(_this, derived, args) {
    // Super
    derived = (0, $5982ea1ba8b4c6e7$export$71511d61b312f219)(derived);
    return (0, $95d08371c2c4ef4e$export$71511d61b312f219)(_this, (0, $e0202b2b0021476d$export$71511d61b312f219)() ? Reflect.construct(derived, args || [], (0, $5982ea1ba8b4c6e7$export$71511d61b312f219)(_this).constructor) : derived.apply(_this, args));
}



var $gd0sY = parcelRequire("gd0sY");
function $6b55e905aa672e6c$export$71511d61b312f219(o, p) {
    $6b55e905aa672e6c$export$71511d61b312f219 = Object.setPrototypeOf || function setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $6b55e905aa672e6c$export$71511d61b312f219(o, p);
}


function $0951870dac564cbc$export$71511d61b312f219(subClass, superClass) {
    if (typeof superClass !== "function" && superClass !== null) throw new TypeError("Super expression must either be null or a function");
    subClass.prototype = Object.create(superClass && superClass.prototype, {
        constructor: {
            value: subClass,
            writable: true,
            configurable: true
        }
    });
    if (superClass) (0, $6b55e905aa672e6c$export$71511d61b312f219)(subClass, superClass);
}




function $d2535f9282d6afd9$export$71511d61b312f219(Parent, args, Class) {
    if ((0, $e0202b2b0021476d$export$71511d61b312f219)()) $d2535f9282d6afd9$export$71511d61b312f219 = Reflect.construct;
    else $d2535f9282d6afd9$export$71511d61b312f219 = function construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) (0, $6b55e905aa672e6c$export$71511d61b312f219)(instance, Class.prototype);
        return instance;
    };
    return $d2535f9282d6afd9$export$71511d61b312f219.apply(null, arguments);
}



function $070a8cede0f67609$export$71511d61b312f219(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}



function $9f87b386401b733e$export$71511d61b312f219(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $9f87b386401b733e$export$71511d61b312f219 = function(Class) {
        if (Class === null || !(0, $070a8cede0f67609$export$71511d61b312f219)(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return (0, $d2535f9282d6afd9$export$71511d61b312f219)(Class, arguments, (0, $5982ea1ba8b4c6e7$export$71511d61b312f219)(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return (0, $6b55e905aa672e6c$export$71511d61b312f219)(Wrapper, Class);
    };
    return $9f87b386401b733e$export$71511d61b312f219(Class);
}




var $gd0sY = parcelRequire("gd0sY");


var $d78024f502d9a257$export$1871035840b7f83a = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(OfflineStorageNotAvailableError, Error1);
    function OfflineStorageNotAvailableError() {
        var message = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 'Offline storage is not available';
        (0, $gd0sY._)(this, OfflineStorageNotAvailableError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, OfflineStorageNotAvailableError, [
            message
        ]);
        _this.name = 'OfflineStorageNotAvailableError';
        return _this;
    }
    return OfflineStorageNotAvailableError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
var $d78024f502d9a257$export$66d311bf29d5c89c = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(TimeoutError, Error1);
    function TimeoutError(message) {
        (0, $gd0sY._)(this, TimeoutError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, TimeoutError, [
            message
        ]);
        _this.name = 'TimeoutError';
        return _this;
    }
    return TimeoutError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
var $d78024f502d9a257$export$65bd6083489bd8bb = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(HttpError, Error1);
    function HttpError(message) {
        (0, $gd0sY._)(this, HttpError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, HttpError, [
            message
        ]);
        _this.name = 'HttpError';
        return _this;
    }
    return HttpError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
var $d78024f502d9a257$export$5e64a9683d127ef6 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(LoginError, Error1);
    function LoginError(message) {
        (0, $gd0sY._)(this, LoginError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, LoginError, [
            message
        ]);
        _this.name = 'LoginError';
        return _this;
    }
    return LoginError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
var $d78024f502d9a257$export$4511c7da58e2d9c2 = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(UnexpectedStateError, Error1);
    function UnexpectedStateError(message) {
        (0, $gd0sY._)(this, UnexpectedStateError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, UnexpectedStateError, [
            message
        ]);
        _this.name = 'UnexpectedStateError';
        return _this;
    }
    return UnexpectedStateError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));


var $8b420386626a2c2e$exports = {};

$parcel$export($8b420386626a2c2e$exports, "rejectUnless", function () { return $8b420386626a2c2e$export$8d90b058a02656d9; });
$parcel$export($8b420386626a2c2e$exports, "rejectIfNotOkay", function () { return $8b420386626a2c2e$export$3a2f576a374b4dda; });
$parcel$export($8b420386626a2c2e$exports, "options", function () { return $8b420386626a2c2e$export$41c562ebe57d11e2; });
$parcel$export($8b420386626a2c2e$exports, "option", function () { return $8b420386626a2c2e$export$a75d1723e6bda2ec; });
$parcel$export($8b420386626a2c2e$exports, "headers", function () { return $8b420386626a2c2e$export$838e2a576d4d6ff6; });
$parcel$export($8b420386626a2c2e$exports, "header", function () { return $8b420386626a2c2e$export$38e42c68cf43b5d4; });
$parcel$export($8b420386626a2c2e$exports, "liftToPromiseField", function () { return $8b420386626a2c2e$export$e39d76e25ce37988; });
$parcel$export($8b420386626a2c2e$exports, "makeAbortableFetch", function () { return $8b420386626a2c2e$export$9c77439751b4390b; });
$parcel$export($8b420386626a2c2e$exports, "makeFetchWithTimeout", function () { return $8b420386626a2c2e$export$e9a8372937ef7f1; });
$parcel$export($8b420386626a2c2e$exports, "makeFetchFailOnHttpErrors", function () { return $8b420386626a2c2e$export$fe633c745f42b5cd; });
$parcel$export($8b420386626a2c2e$exports, "makeFetchSupportGetBody", function () { return $8b420386626a2c2e$export$f4ba43f659d5549c; });
$parcel$export($8b420386626a2c2e$exports, "fetch", function () { return $8b420386626a2c2e$export$e7aa7bc5c1b3cfb3; });
$parcel$export($8b420386626a2c2e$exports, "get", function () { return $8b420386626a2c2e$export$3988ae62b71be9a3; });
$parcel$export($8b420386626a2c2e$exports, "post", function () { return $8b420386626a2c2e$export$299ba2dee77727e9; });
$parcel$export($8b420386626a2c2e$exports, "delete_", function () { return $8b420386626a2c2e$export$38dab5a9fea42f39; });
$parcel$export($8b420386626a2c2e$exports, "makeSearchParams", function () { return $8b420386626a2c2e$export$92871f7982deaf9f; });

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");
function $c19975616f0f5e3a$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys = Object.getOwnPropertyNames(source), key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
        target[key] = source[key];
    }
    return target;
}


function $7e86f5813bbb0f77$export$71511d61b312f219(source, excluded) {
    if (source == null) return {};
    var target = {}, sourceKeys, key, i;
    if (typeof Reflect !== "undefined" && Reflect.ownKeys) {
        sourceKeys = Reflect.ownKeys(Object(source));
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
        return target;
    }
    target = (0, $c19975616f0f5e3a$export$71511d61b312f219)(source, excluded);
    if (Object.getOwnPropertySymbols) {
        sourceKeys = Object.getOwnPropertySymbols(source);
        for(i = 0; i < sourceKeys.length; i++){
            key = sourceKeys[i];
            if (excluded.indexOf(key) >= 0) continue;
            if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
            target[key] = source[key];
        }
    }
    return target;
}



var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");
var $570199f307e44dfb$export$2e2bcd8739ae039 = function(data) {
    var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var sorted = opts.sorted, ignorenull = opts.ignorenull, ignoreEmptyArray = opts.ignoreEmptyArray, useDot = opts.useDot, skipIndex = opts.skipIndex, skipBracket = opts.skipBracket, _opts_whitespace = opts.whitespace, whitespace = _opts_whitespace === void 0 ? '+' : _opts_whitespace;
    var encode = function(value) {
        return String(value).replace(RegExp("[^ !'()~*]", "gu"), encodeURIComponent).replace(/ /g, whitespace).replace(/[!'()~*]/g, function(ch) {
            return "%".concat(ch.charCodeAt().toString(16).slice(-2).toUpperCase());
        });
    };
    var keys = function(obj) {
        var keyarr = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : Object.keys(obj);
        return sorted ? keyarr.sort() : keyarr;
    };
    var filterjoin = function(arr) {
        return arr.filter(function(e) {
            return e;
        }).join('&');
    };
    var objnest = function(name, obj) {
        return filterjoin(keys(obj).map(function(key) {
            return useDot ? nest("".concat(name, ".").concat(key), obj[key]) : nest("".concat(name, "[").concat(key, "]"), obj[key]);
        }));
    };
    var arrnest = function(name, arr) {
        var brackets = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : skipBracket ? '' : '[]';
        return arr.length ? filterjoin(arr.map(function(elem, index) {
            return skipIndex ? nest(name + brackets, elem) : nest(name + '[' + index + ']', elem);
        })) : ignoreEmptyArray ? null : encode(name + brackets);
    };
    var setnest = function(name, set) {
        return filterjoin(Array.from(set).map(function(elem) {
            return nest(name, elem);
        }));
    };
    var nest = function(name, value) {
        var type = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value), f = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : null;
        if (value === f) f = ignorenull ? f : encode(name) + '=' + f;
        else if (/string|number|boolean/.test(type)) f = encode(name) + '=' + encode(value);
        else if (Array.isArray(value)) f = arrnest(name, value);
        else if (value instanceof Set) f = setnest(name, value);
        else if (type === 'object') f = objnest(name, value);
        return f;
    };
    return data && filterjoin(keys(data).map(function(key) {
        return nest(key, data[key]);
    }));
};


var $c41432d844932dcf$exports = {};
var $16cdbc498258dabf$exports = {};
var $7e9ffa7fa815703c$exports = {};
var $f6709ecef4b253a2$exports = {};

var $2bfPH = parcelRequire("2bfPH");
function $f6709ecef4b253a2$var$_isPlaceholder(a) {
    return a != null && (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) === 'object' && a['@@functional/placeholder'] === true;
}
$f6709ecef4b253a2$exports = $f6709ecef4b253a2$var$_isPlaceholder;


/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $7e9ffa7fa815703c$var$_curry1(fn) {
    return function f1(a) {
        if (arguments.length === 0 || $f6709ecef4b253a2$exports(a)) return f1;
        else return fn.apply(this, arguments);
    };
}
$7e9ffa7fa815703c$exports = $7e9ffa7fa815703c$var$_curry1;



/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $16cdbc498258dabf$var$_curry2(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f2 : $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f2 : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}
$16cdbc498258dabf$exports = $16cdbc498258dabf$var$_curry2;


var $c1dff8cdd11e90ef$exports = {};
var $80cb0262fd5157fd$exports = {};



/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $80cb0262fd5157fd$var$_curry3(fn) {
    return function f3(a, b, c) {
        switch(arguments.length){
            case 0:
                return f3;
            case 1:
                return $f6709ecef4b253a2$exports(a) ? f3 : $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                });
            case 2:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? f3 : $f6709ecef4b253a2$exports(a) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                });
            default:
                return $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? f3 : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(b) ? $16cdbc498258dabf$exports(function(_a, _b) {
                    return fn(_a, _b, c);
                }) : $f6709ecef4b253a2$exports(a) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_a, _c) {
                    return fn(_a, b, _c);
                }) : $f6709ecef4b253a2$exports(b) && $f6709ecef4b253a2$exports(c) ? $16cdbc498258dabf$exports(function(_b, _c) {
                    return fn(a, _b, _c);
                }) : $f6709ecef4b253a2$exports(a) ? $7e9ffa7fa815703c$exports(function(_a) {
                    return fn(_a, b, c);
                }) : $f6709ecef4b253a2$exports(b) ? $7e9ffa7fa815703c$exports(function(_b) {
                    return fn(a, _b, c);
                }) : $f6709ecef4b253a2$exports(c) ? $7e9ffa7fa815703c$exports(function(_c) {
                    return fn(a, b, _c);
                }) : fn(a, b, c);
        }
    };
}
$80cb0262fd5157fd$exports = $80cb0262fd5157fd$var$_curry3;


var $db378aa7becbce1c$exports = {};
function $db378aa7becbce1c$var$_isObject(x) {
    return Object.prototype.toString.call(x) === '[object Object]';
}
$db378aa7becbce1c$exports = $db378aa7becbce1c$var$_isObject;


var $5b93c9afa1b3d914$exports = {};

var $8659c368bdbba7be$exports = {};
function $8659c368bdbba7be$var$_has(prop, obj) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
$8659c368bdbba7be$exports = $8659c368bdbba7be$var$_has;


/**
 * Creates a new object with the own properties of the two provided objects. If
 * a key exists in both objects, the provided function is applied to the key
 * and the values associated with the key in each object, with the result being
 * used as the value associated with the key in the returned object.
 *
 * @func
 * @memberOf R
 * @since v0.19.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} l
 * @param {Object} r
 * @return {Object}
 * @see R.mergeDeepWithKey, R.mergeWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeWithKey(concatValues,
 *                     { a: true, thing: 'foo', values: [10, 20] },
 *                     { b: true, thing: 'bar', values: [15, 35] });
 *      //=> { a: true, b: true, thing: 'bar', values: [10, 20, 15, 35] }
 * @symb R.mergeWithKey(f, { x: 1, y: 2 }, { y: 5, z: 3 }) = { x: 1, y: f('y', 2, 5), z: 3 }
 */ var $5b93c9afa1b3d914$var$mergeWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeWithKey(fn, l, r) {
    var result = {};
    var k;
    l = l || {};
    r = r || {};
    for(k in l)if ($8659c368bdbba7be$exports(k, l)) result[k] = $8659c368bdbba7be$exports(k, r) ? fn(k, l[k], r[k]) : l[k];
    for(k in r)if ($8659c368bdbba7be$exports(k, r) && !$8659c368bdbba7be$exports(k, result)) result[k] = r[k];
    return result;
});
$5b93c9afa1b3d914$exports = $5b93c9afa1b3d914$var$mergeWithKey;


/**
 * Creates a new object with the own properties of the two provided objects.
 * If a key exists in both objects:
 * - and both associated values are also objects then the values will be
 *   recursively merged.
 * - otherwise the provided function is applied to the key and associated values
 *   using the resulting value as the new value associated with the key.
 * If a key only exists in one object, the value will be associated with the key
 * of the resulting object.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig ((String, a, a) -> a) -> {a} -> {a} -> {a}
 * @param {Function} fn
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeWithKey, R.mergeDeepWith
 * @example
 *
 *      let concatValues = (k, l, r) => k == 'values' ? R.concat(l, r) : r
 *      R.mergeDeepWithKey(concatValues,
 *                         { a: true, c: { thing: 'foo', values: [10, 20] }},
 *                         { b: true, c: { thing: 'bar', values: [15, 35] }});
 *      //=> { a: true, b: true, c: { thing: 'bar', values: [10, 20, 15, 35] }}
 */ var $c1dff8cdd11e90ef$var$mergeDeepWithKey = /*#__PURE__*/ $80cb0262fd5157fd$exports(function mergeDeepWithKey(fn, lObj, rObj) {
    return $5b93c9afa1b3d914$exports(function(k, lVal, rVal) {
        if ($db378aa7becbce1c$exports(lVal) && $db378aa7becbce1c$exports(rVal)) return mergeDeepWithKey(fn, lVal, rVal);
        else return fn(k, lVal, rVal);
    }, lObj, rObj);
});
$c1dff8cdd11e90ef$exports = $c1dff8cdd11e90ef$var$mergeDeepWithKey;


/**
 * Creates a new object with the own properties of the first object merged with
 * the own properties of the second object. If a key exists in both objects:
 * - and both values are objects, the two values will be recursively merged
 * - otherwise the value from the first object will be used.
 *
 * @func
 * @memberOf R
 * @since v0.24.0
 * @category Object
 * @sig {a} -> {a} -> {a}
 * @param {Object} lObj
 * @param {Object} rObj
 * @return {Object}
 * @see R.mergeDeepRight, R.mergeDeepWith, R.mergeDeepWithKey
 * @example
 *
 *      R.mergeDeepLeft({ name: 'fred', age: 10, contact: { email: 'moo@example.com' }},
 *                      { age: 40, contact: { email: 'baa@example.com' }});
 *      //=> { name: 'fred', age: 10, contact: { email: 'moo@example.com' }}
 */ var $c41432d844932dcf$var$mergeDeepLeft = /*#__PURE__*/ $16cdbc498258dabf$exports(function mergeDeepLeft(lObj, rObj) {
    return $c1dff8cdd11e90ef$exports(function(k, lVal, rVal) {
        return lVal;
    }, lObj, rObj);
});
$c41432d844932dcf$exports = $c41432d844932dcf$var$mergeDeepLeft;


var $d260ff7ca3ce6993$exports = {};
var $7629ad89266bbe6b$exports = {};
function $7629ad89266bbe6b$var$_arity(n, fn) {
    /* eslint-disable no-unused-vars */ switch(n){
        case 0:
            return function() {
                return fn.apply(this, arguments);
            };
        case 1:
            return function(a0) {
                return fn.apply(this, arguments);
            };
        case 2:
            return function(a0, a1) {
                return fn.apply(this, arguments);
            };
        case 3:
            return function(a0, a1, a2) {
                return fn.apply(this, arguments);
            };
        case 4:
            return function(a0, a1, a2, a3) {
                return fn.apply(this, arguments);
            };
        case 5:
            return function(a0, a1, a2, a3, a4) {
                return fn.apply(this, arguments);
            };
        case 6:
            return function(a0, a1, a2, a3, a4, a5) {
                return fn.apply(this, arguments);
            };
        case 7:
            return function(a0, a1, a2, a3, a4, a5, a6) {
                return fn.apply(this, arguments);
            };
        case 8:
            return function(a0, a1, a2, a3, a4, a5, a6, a7) {
                return fn.apply(this, arguments);
            };
        case 9:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8) {
                return fn.apply(this, arguments);
            };
        case 10:
            return function(a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
                return fn.apply(this, arguments);
            };
        default:
            throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
    }
}
$7629ad89266bbe6b$exports = $7629ad89266bbe6b$var$_arity;


var $b5790e78e290f7f4$exports = {};
function $b5790e78e290f7f4$var$_pipe(f, g) {
    return function() {
        return g.call(this, f.apply(this, arguments));
    };
}
$b5790e78e290f7f4$exports = $b5790e78e290f7f4$var$_pipe;


var $c4fccbe08b9f0fad$exports = {};

var $bdafe3f0d791dda7$exports = {};
var $f02a59ea5dc135be$exports = {};
var $67c81c8b457540e6$exports = {};

var $2bfPH = parcelRequire("2bfPH");

var $73fb5ea04d9dead1$exports = {};
/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ $73fb5ea04d9dead1$exports = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


var $04e2efa5ca25c0f3$exports = {};
function $04e2efa5ca25c0f3$var$_isString(x) {
    return Object.prototype.toString.call(x) === '[object String]';
}
$04e2efa5ca25c0f3$exports = $04e2efa5ca25c0f3$var$_isString;


/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */ var $67c81c8b457540e6$var$_isArrayLike = /*#__PURE__*/ $7e9ffa7fa815703c$exports(function isArrayLike(x) {
    if ($73fb5ea04d9dead1$exports(x)) return true;
    if (!x) return false;
    if ((typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) !== 'object') return false;
    if ($04e2efa5ca25c0f3$exports(x)) return false;
    if (x.length === 0) return true;
    if (x.length > 0) return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
    return false;
});
$67c81c8b457540e6$exports = $67c81c8b457540e6$var$_isArrayLike;


var $f02a59ea5dc135be$var$symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function $f02a59ea5dc135be$var$_createReduce(arrayReduce, methodReduce, iterableReduce) {
    return function _reduce(xf, acc, list) {
        if ($67c81c8b457540e6$exports(list)) return arrayReduce(xf, acc, list);
        if (list == null) return acc;
        if (typeof list['fantasy-land/reduce'] === 'function') return methodReduce(xf, acc, list, 'fantasy-land/reduce');
        if (list[$f02a59ea5dc135be$var$symIterator] != null) return iterableReduce(xf, acc, list[$f02a59ea5dc135be$var$symIterator]());
        if (typeof list.next === 'function') return iterableReduce(xf, acc, list);
        if (typeof list.reduce === 'function') return methodReduce(xf, acc, list, 'reduce');
        throw new TypeError('reduce: list must be array or iterable');
    };
}
$f02a59ea5dc135be$exports = $f02a59ea5dc135be$var$_createReduce;


var $4b2ec1de5112b3cd$exports = {};
function $4b2ec1de5112b3cd$var$_xArrayReduce(xf, acc, list) {
    var idx = 0;
    var len = list.length;
    while(idx < len){
        acc = xf['@@transducer/step'](acc, list[idx]);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        idx += 1;
    }
    return xf['@@transducer/result'](acc);
}
$4b2ec1de5112b3cd$exports = $4b2ec1de5112b3cd$var$_xArrayReduce;


var $367e3100760e4974$exports = {};


/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */ var $367e3100760e4974$var$bind = /*#__PURE__*/ $16cdbc498258dabf$exports(function bind(fn, thisObj) {
    return $7629ad89266bbe6b$exports(fn.length, function() {
        return fn.apply(thisObj, arguments);
    });
});
$367e3100760e4974$exports = $367e3100760e4974$var$bind;


function $bdafe3f0d791dda7$var$_xIterableReduce(xf, acc, iter) {
    var step = iter.next();
    while(!step.done){
        acc = xf['@@transducer/step'](acc, step.value);
        if (acc && acc['@@transducer/reduced']) {
            acc = acc['@@transducer/value'];
            break;
        }
        step = iter.next();
    }
    return xf['@@transducer/result'](acc);
}
function $bdafe3f0d791dda7$var$_xMethodReduce(xf, acc, obj, methodName) {
    return xf['@@transducer/result'](obj[methodName]($367e3100760e4974$exports(xf['@@transducer/step'], xf), acc));
}
var $bdafe3f0d791dda7$var$_xReduce = /*#__PURE__*/ $f02a59ea5dc135be$exports($4b2ec1de5112b3cd$exports, $bdafe3f0d791dda7$var$_xMethodReduce, $bdafe3f0d791dda7$var$_xIterableReduce);
$bdafe3f0d791dda7$exports = $bdafe3f0d791dda7$var$_xReduce;


var $fcc04a1cf53b4b80$exports = {};
var $fcc04a1cf53b4b80$var$XWrap = /*#__PURE__*/ function() {
    function XWrap(fn) {
        this.f = fn;
    }
    XWrap.prototype['@@transducer/init'] = function() {
        throw new Error('init not implemented on XWrap');
    };
    XWrap.prototype['@@transducer/result'] = function(acc) {
        return acc;
    };
    XWrap.prototype['@@transducer/step'] = function(acc, x) {
        return this.f(acc, x);
    };
    return XWrap;
}();
function $fcc04a1cf53b4b80$var$_xwrap(fn) {
    return new $fcc04a1cf53b4b80$var$XWrap(fn);
}
$fcc04a1cf53b4b80$exports = $fcc04a1cf53b4b80$var$_xwrap;


/**
 * Returns a single item by iterating through the list, successively calling
 * the iterator function and passing it an accumulator value and the current
 * value from the array, and then passing the result to the next call.
 *
 * The iterator function receives two values: *(acc, value)*. It may use
 * [`R.reduced`](#reduced) to shortcut the iteration.
 *
 * The arguments' order of [`reduceRight`](#reduceRight)'s iterator function
 * is *(value, acc)*.
 *
 * Note: `R.reduce` does not skip deleted or unassigned indices (sparse
 * arrays), unlike the native `Array.prototype.reduce` method. For more details
 * on this behavior, see:
 * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/reduce#Description
 *
 * Be cautious of mutating and returning the accumulator. If you reuse it across
 * invocations, it will continue to accumulate onto the same value. The general
 * recommendation is to always return a new value. If you can't do so for
 * performance reasons, then be sure to reinitialize the accumulator on each
 * invocation.
 *
 * Dispatches to the `reduce` method of the third argument, if present. When
 * doing so, it is up to the user to handle the [`R.reduced`](#reduced)
 * shortcuting, as this is not implemented by `reduce`.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig ((a, b) -> a) -> a -> [b] -> a
 * @param {Function} fn The iterator function. Receives two values, the accumulator and the
 *        current element from the array.
 * @param {*} acc The accumulator value.
 * @param {Array} list The list to iterate over.
 * @return {*} The final, accumulated value.
 * @see R.reduced, R.addIndex, R.reduceRight
 * @example
 *
 *      R.reduce(R.subtract, 0, [1, 2, 3, 4]) // => ((((0 - 1) - 2) - 3) - 4) = -10
 *      //          -               -10
 *      //         / \              / \
 *      //        -   4           -6   4
 *      //       / \              / \
 *      //      -   3   ==>     -3   3
 *      //     / \              / \
 *      //    -   2           -1   2
 *      //   / \              / \
 *      //  0   1            0   1
 *
 * @symb R.reduce(f, a, [b, c, d]) = f(f(f(a, b), c), d)
 */ var $c4fccbe08b9f0fad$var$reduce = /*#__PURE__*/ $80cb0262fd5157fd$exports(function(xf, acc, list) {
    return $bdafe3f0d791dda7$exports(typeof xf === 'function' ? $fcc04a1cf53b4b80$exports(xf) : xf, acc, list);
});
$c4fccbe08b9f0fad$exports = $c4fccbe08b9f0fad$var$reduce;


var $9b7ae0ca44597272$exports = {};
var $9c866f84cc2fbcff$exports = {};

/**
 * This checks whether a function has a [methodname] function. If it isn't an
 * array it will execute that function otherwise it will default to the ramda
 * implementation.
 *
 * @private
 * @param {Function} fn ramda implementation
 * @param {String} methodname property to check for a custom implementation
 * @return {Object} Whatever the return value of the method is.
 */ function $9c866f84cc2fbcff$var$_checkForMethod(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return $73fb5ea04d9dead1$exports(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}
$9c866f84cc2fbcff$exports = $9c866f84cc2fbcff$var$_checkForMethod;



var $b62da072c6a6f6e5$exports = {};


/**
 * Returns the elements of the given list or string (or object with a `slice`
 * method) from `fromIndex` (inclusive) to `toIndex` (exclusive).
 *
 * Dispatches to the `slice` method of the third argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.4
 * @category List
 * @sig Number -> Number -> [a] -> [a]
 * @sig Number -> Number -> String -> String
 * @param {Number} fromIndex The start index (inclusive).
 * @param {Number} toIndex The end index (exclusive).
 * @param {*} list
 * @return {*}
 * @example
 *
 *      R.slice(1, 3, ['a', 'b', 'c', 'd']);        //=> ['b', 'c']
 *      R.slice(1, Infinity, ['a', 'b', 'c', 'd']); //=> ['b', 'c', 'd']
 *      R.slice(0, -1, ['a', 'b', 'c', 'd']);       //=> ['a', 'b', 'c']
 *      R.slice(-3, -1, ['a', 'b', 'c', 'd']);      //=> ['b', 'c']
 *      R.slice(0, 3, 'ramda');                     //=> 'ram'
 */ var $b62da072c6a6f6e5$var$slice = /*#__PURE__*/ $80cb0262fd5157fd$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports('slice', function slice(fromIndex, toIndex, list) {
    return Array.prototype.slice.call(list, fromIndex, toIndex);
}));
$b62da072c6a6f6e5$exports = $b62da072c6a6f6e5$var$slice;


/**
 * Returns all but the first element of the given list or string (or object
 * with a `tail` method).
 *
 * Dispatches to the `slice` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig [a] -> [a]
 * @sig String -> String
 * @param {*} list
 * @return {*}
 * @see R.head, R.init, R.last
 * @example
 *
 *      R.tail([1, 2, 3]);  //=> [2, 3]
 *      R.tail([1, 2]);     //=> [2]
 *      R.tail([1]);        //=> []
 *      R.tail([]);         //=> []
 *
 *      R.tail('abc');  //=> 'bc'
 *      R.tail('ab');   //=> 'b'
 *      R.tail('a');    //=> ''
 *      R.tail('');     //=> ''
 */ var $9b7ae0ca44597272$var$tail = /*#__PURE__*/ $7e9ffa7fa815703c$exports(/*#__PURE__*/ $9c866f84cc2fbcff$exports('tail', /*#__PURE__*/ $b62da072c6a6f6e5$exports(1, Infinity)));
$9b7ae0ca44597272$exports = $9b7ae0ca44597272$var$tail;


/**
 * Performs left-to-right function composition. The first argument may have
 * any arity; the remaining arguments must be unary.
 *
 * In some libraries this function is named `sequence`.
 *
 * **Note:** The result of pipe is not automatically curried.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (((a, b, ..., n) -> o), (o -> p), ..., (x -> y), (y -> z)) -> ((a, b, ..., n) -> z)
 * @param {...Function} functions
 * @return {Function}
 * @see R.compose
 * @example
 *
 *      const f = R.pipe(Math.pow, R.negate, R.inc);
 *
 *      f(3, 4); // -(3^4) + 1
 * @symb R.pipe(f, g, h)(a, b) = h(g(f(a, b)))
 * @symb R.pipe(f, g, h)(a)(b) = h(g(f(a)))(b)
 */ function $d260ff7ca3ce6993$var$pipe() {
    if (arguments.length === 0) throw new Error('pipe requires at least one argument');
    return $7629ad89266bbe6b$exports(arguments[0].length, $c4fccbe08b9f0fad$exports($b5790e78e290f7f4$exports, arguments[0], $9b7ae0ca44597272$exports(arguments)));
}
$d260ff7ca3ce6993$exports = $d260ff7ca3ce6993$var$pipe;



var $8b420386626a2c2e$var$_this = undefined;
function $8b420386626a2c2e$export$8d90b058a02656d9(pred) {
    return function(response) {
        if (pred(response)) return response;
        else {
            var err = new (0, $d78024f502d9a257$export$65bd6083489bd8bb)(response.statusText);
            err.response = response;
            throw err;
        }
    };
}
function $8b420386626a2c2e$export$3a2f576a374b4dda(response) {
    return $8b420386626a2c2e$export$8d90b058a02656d9(function(response) {
        return response.ok;
    })(response);
}
var $8b420386626a2c2e$export$41c562ebe57d11e2 = function(newOpts) {
    return function(fetch) {
        return function(url) {
            var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
            return fetch(url, (0, (/*@__PURE__*/$parcel$interopDefault($c41432d844932dcf$exports)))(opts, newOpts));
        };
    };
};
var $8b420386626a2c2e$export$a75d1723e6bda2ec = function(name, value) {
    return $8b420386626a2c2e$export$41c562ebe57d11e2((0, $khBmn._)({}, name, value));
};
var $8b420386626a2c2e$export$838e2a576d4d6ff6 = function(value) {
    return $8b420386626a2c2e$export$a75d1723e6bda2ec('headers', value);
};
var $8b420386626a2c2e$export$38e42c68cf43b5d4 = function(name, value) {
    return $8b420386626a2c2e$export$838e2a576d4d6ff6((0, $khBmn._)({}, name, value));
};
var $8b420386626a2c2e$export$e39d76e25ce37988 = function(wrapper) {
    return function(f) {
        var _this1 = $8b420386626a2c2e$var$_this;
        return function() {
            for(var _len = arguments.length, params = new Array(_len), _key = 0; _key < _len; _key++){
                params[_key] = arguments[_key];
            }
            var rest;
            var promise = wrapper(function() {
                for(var _len = arguments.length, innerParams = new Array(_len), _key = 0; _key < _len; _key++){
                    innerParams[_key] = arguments[_key];
                }
                var _f = f.apply(void 0, (0, $6zk1M._)(innerParams)), promise = _f.promise, innerRest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_f, [
                    "promise"
                ]);
                rest = innerRest;
                return promise;
            }).apply(_this1, (0, $6zk1M._)(params));
            return (0, $lvTkn._)({
                promise: promise
            }, rest);
        };
    };
};
function $8b420386626a2c2e$export$9c77439751b4390b(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var controller = opts.abortController || new AbortController();
        var promise = fetch(url, (0, $lvTkn._)({
            signal: controller.signal
        }, opts));
        return {
            controller: controller,
            promise: promise
        };
    };
}
function $8b420386626a2c2e$export$e9a8372937ef7f1(abortableFetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        // offline db consistency requires ajax calls to fail reliably,
        // so we enforce a default timeout on ajax calls
        var _opts_timeout = opts.timeout, timeout = _opts_timeout === void 0 ? 60000 : _opts_timeout, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(opts, [
            "timeout"
        ]);
        var _abortableFetch = abortableFetch(url, rest), controller = _abortableFetch.controller, promise = _abortableFetch.promise;
        if (timeout !== 0) {
            var newPromise = promise.catch(function(error) {
                // Change error name in case of time out so that we can
                // distinguish it from explicit abort.
                if (error.name === 'AbortError' && 'timedOut' in promise) error = new (0, $d78024f502d9a257$export$66d311bf29d5c89c)("Request timed out after ".concat(timeout / 1000, " seconds"));
                throw error;
            });
            setTimeout(function() {
                promise.timedOut = true;
                controller.abort();
            }, timeout);
            return {
                controller: controller,
                promise: newPromise
            };
        }
        return {
            controller: controller,
            promise: promise
        };
    };
}
function $8b420386626a2c2e$export$fe633c745f42b5cd(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var _opts_failOnHttpErrors = opts.failOnHttpErrors, failOnHttpErrors = _opts_failOnHttpErrors === void 0 ? true : _opts_failOnHttpErrors, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(opts, [
            "failOnHttpErrors"
        ]);
        var promise = fetch(url, rest);
        if (failOnHttpErrors) return promise.then($8b420386626a2c2e$export$3a2f576a374b4dda);
        return promise;
    };
}
function $8b420386626a2c2e$export$f4ba43f659d5549c(fetch) {
    return function(url) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        var body = opts.body, method = opts.method, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(opts, [
            "body",
            "method"
        ]);
        var newUrl = url;
        var newOpts = opts;
        if (Object.keys(opts).includes('method') && Object.keys(opts).includes('body') && method.toUpperCase() === 'GET' && body instanceof URLSearchParams) {
            var _newUrl_split = (0, $ggKxj._)(newUrl.split('#')), main = _newUrl_split[0], fragments = _newUrl_split.slice(1);
            var separator = main.includes('?') ? '&' : '?';
            // append the body to the query string
            newUrl = "".concat(main).concat(separator).concat(body.toString(), "#").concat(fragments.join('#'));
            // remove the body since it has been moved to URL
            newOpts = (0, $lvTkn._)({
                method: method
            }, rest);
        }
        return fetch(newUrl, newOpts);
    };
}
var $8b420386626a2c2e$export$e7aa7bc5c1b3cfb3 = (0, (/*@__PURE__*/$parcel$interopDefault($d260ff7ca3ce6993$exports)))(// Same as jQuery.ajax
$8b420386626a2c2e$export$a75d1723e6bda2ec('credentials', 'same-origin'), $8b420386626a2c2e$export$38e42c68cf43b5d4('X-Requested-With', 'XMLHttpRequest'), $8b420386626a2c2e$export$fe633c745f42b5cd, $8b420386626a2c2e$export$f4ba43f659d5549c, $8b420386626a2c2e$export$9c77439751b4390b, $8b420386626a2c2e$export$e9a8372937ef7f1)(window.fetch);
var $8b420386626a2c2e$export$3988ae62b71be9a3 = $8b420386626a2c2e$export$e39d76e25ce37988($8b420386626a2c2e$export$a75d1723e6bda2ec('method', 'GET'))($8b420386626a2c2e$export$e7aa7bc5c1b3cfb3);
var $8b420386626a2c2e$export$299ba2dee77727e9 = $8b420386626a2c2e$export$e39d76e25ce37988($8b420386626a2c2e$export$a75d1723e6bda2ec('method', 'POST'))($8b420386626a2c2e$export$e7aa7bc5c1b3cfb3);
var $8b420386626a2c2e$export$38dab5a9fea42f39 = $8b420386626a2c2e$export$e39d76e25ce37988($8b420386626a2c2e$export$a75d1723e6bda2ec('method', 'DELETE'))($8b420386626a2c2e$export$e7aa7bc5c1b3cfb3);
function $8b420386626a2c2e$export$92871f7982deaf9f(data) {
    return new URLSearchParams((0, $570199f307e44dfb$export$2e2bcd8739ae039)(data, {
        ignorenull: true
    }));
}


var $4f5da2ef0a8f061c$export$1a748576aa07f99b = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(PasswordHashingError, Error1);
    function PasswordHashingError(message) {
        (0, $gd0sY._)(this, PasswordHashingError);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, PasswordHashingError, [
            message
        ]);
        _this.name = 'PasswordHashingError';
        return _this;
    }
    return PasswordHashingError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
function $4f5da2ef0a8f061c$export$1d2e6bc0307ffd89() {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('api/about', {
        // we want fresh configuration each time
        cache: 'no-store'
    }).promise.then(function(response) {
        return response.json();
    });
}
function $4f5da2ef0a8f061c$export$596d806903d1f59e(credentials) {
    return $8b420386626a2c2e$export$299ba2dee77727e9('login', {
        body: new URLSearchParams(credentials)
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve();
        else return Promise.reject(new (0, $d78024f502d9a257$export$5e64a9683d127ef6)(data.error));
    });
}
function $4f5da2ef0a8f061c$export$708be5cd94908894(password) {
    return $8b420386626a2c2e$export$299ba2dee77727e9('api/private/hash-password', {
        body: new URLSearchParams({
            password: password
        })
    }).promise.then(function(response) {
        return response.json();
    }).then(function(data) {
        if (data.success) return Promise.resolve(data.hash);
        else return Promise.reject(new $4f5da2ef0a8f061c$export$1a748576aa07f99b(data.error));
    });
}
function $4f5da2ef0a8f061c$export$b3b4cde15a96b715(file) {
    var data = new FormData();
    data.append('opml', file);
    return $8b420386626a2c2e$export$299ba2dee77727e9('opml', {
        body: data,
        failOnHttpErrors: false
    }).promise.then($8b420386626a2c2e$export$8d90b058a02656d9(function(response) {
        return response.status === 200 || response.status === 202 || response.status === 400;
    })).then(function(response) {
        return response.json().then(function(data) {
            return {
                response: response,
                data: data
            };
        });
    });
}
function $4f5da2ef0a8f061c$export$a0973bcfe11b05c9() {
    return $8b420386626a2c2e$export$38dab5a9fea42f39('api/session/current').promise;
}



function $133470f46785be8b$export$c36f611d5eb39a7() {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('tags').promise.then(function(response) {
        return response.json();
    });
}
function $133470f46785be8b$export$6f3c7c74c4b252bb(tag, color) {
    return $8b420386626a2c2e$export$299ba2dee77727e9('tags/color', {
        body: $8b420386626a2c2e$export$92871f7982deaf9f({
            tag: tag,
            color: color
        })
    }).promise;
}





var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");


var $3b90563ec4c37361$export$5521c47db270880f = /*#__PURE__*/ function(Event1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(ValueChangeEvent, Event1);
    function ValueChangeEvent(value) {
        (0, $gd0sY._)(this, ValueChangeEvent);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, ValueChangeEvent, [
            'change'
        ]);
        _this.value = value;
        return _this;
    }
    return ValueChangeEvent;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Event));
var $3b90563ec4c37361$export$8fa6ce44b7b131e9 = /*#__PURE__*/ function(EventTarget1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(ValueListenable, EventTarget1);
    function ValueListenable(value) {
        (0, $gd0sY._)(this, ValueListenable);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, ValueListenable);
        _this.value = value;
        return _this;
    }
    (0, $7cSld._)(ValueListenable, [
        {
            key: "update",
            value: function update(value) {
                if (this.value !== value) {
                    this.value = value;
                    var event = new $3b90563ec4c37361$export$5521c47db270880f(value);
                    this.dispatchEvent(event);
                }
            }
        }
    ]);
    return ValueListenable;
}((0, $9f87b386401b733e$export$71511d61b312f219)(EventTarget));



/**
 * Object describing what state a request is in.
 */ var $51c68a66a52c2555$export$62aa48085237e36f = /*#__PURE__*/ function(LoadingState) {
    LoadingState["INITIAL"] = "initial";
    LoadingState["LOADING"] = "loading";
    LoadingState["SUCCESS"] = "success";
    LoadingState["FAILURE"] = "failure";
    return LoadingState;
}({});




var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");
var $f171543c027e46e7$exports = {};
'use strict';

$f171543c027e46e7$exports = (parcelRequire("ceFNn"));



var $eHaBZ = parcelRequire("eHaBZ");
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");


var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
var $5598f6732b3f5c7d$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $5598f6732b3f5c7d$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $5598f6732b3f5c7d$var$DEFAULT_NAVIGATION_URL);
    } catch (e) {
        return $5598f6732b3f5c7d$var$DEFAULT_NAVIGATION_URL;
    }
}
function $5598f6732b3f5c7d$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $5598f6732b3f5c7d$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    var protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $5598f6732b3f5c7d$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    var originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch (e) {}
    var resolvedUrl = new URL(resolved, currentUrl);
    var originalIsExternal = originalUrl != null && !$5598f6732b3f5c7d$var$isSameOrigin(originalUrl, currentUrl);
    var resolvedIsExternal = !$5598f6732b3f5c7d$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$5598f6732b3f5c7d$var$isExplicitUrl(original, originalUrl) || !$5598f6732b3f5c7d$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $gd0sY = parcelRequire("gd0sY");

var $bSRDS = parcelRequire("bSRDS");

var $6wbrO = parcelRequire("6wbrO");
function $c29103a2b56064cf$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



var $5a6Ff = parcelRequire("5a6Ff");
function $f700c7478cae7af0$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $5a6Ff._)(receiver, privateMap, "set");
    (0, $c29103a2b56064cf$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}



var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ 
var $2bfPH = parcelRequire("2bfPH");
var $72417d7cbfd779fc$var$extendStatics = function extendStatics1(d, b) {
    $72417d7cbfd779fc$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $72417d7cbfd779fc$var$extendStatics(d, b);
};
function $72417d7cbfd779fc$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $72417d7cbfd779fc$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $72417d7cbfd779fc$export$18ce0697a983be9b = function __assign1() {
    $72417d7cbfd779fc$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $72417d7cbfd779fc$export$18ce0697a983be9b.apply(this, arguments);
};
function $72417d7cbfd779fc$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $72417d7cbfd779fc$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $72417d7cbfd779fc$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $72417d7cbfd779fc$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $72417d7cbfd779fc$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $72417d7cbfd779fc$export$6a2a36740a146cb8(x) {
    return (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x)) === "symbol" ? x : "".concat(x);
}
function $72417d7cbfd779fc$export$d1a06452d3489bc7(f, name, prefix) {
    if ((typeof name === "undefined" ? "undefined" : (0, $2bfPH._)(name)) === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $72417d7cbfd779fc$export$f1db080c865becb9(metadataKey, metadataValue) {
    if ((typeof Reflect === "undefined" ? "undefined" : (0, $2bfPH._)(Reflect)) === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $72417d7cbfd779fc$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $72417d7cbfd779fc$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function sent() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $72417d7cbfd779fc$export$45d3717a4c69092e = Object.create ? function __createBinding(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function get() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $72417d7cbfd779fc$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $72417d7cbfd779fc$export$45d3717a4c69092e(o, m, p);
}
function $72417d7cbfd779fc$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function next() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $72417d7cbfd779fc$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $72417d7cbfd779fc$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($72417d7cbfd779fc$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $72417d7cbfd779fc$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $72417d7cbfd779fc$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $72417d7cbfd779fc$export$10c90e4f7922046c(v) {
    return this instanceof $72417d7cbfd779fc$export$10c90e4f7922046c ? (this.v = v, this) : new $72417d7cbfd779fc$export$10c90e4f7922046c(v);
}
function $72417d7cbfd779fc$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $72417d7cbfd779fc$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $72417d7cbfd779fc$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $72417d7cbfd779fc$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $72417d7cbfd779fc$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $72417d7cbfd779fc$export$19a8beecd37a4c45 === "function" ? $72417d7cbfd779fc$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $72417d7cbfd779fc$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $72417d7cbfd779fc$var$__setModuleDefault = Object.create ? function __setModuleDefault(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
var $72417d7cbfd779fc$var$ownKeys = function ownKeys1(o) {
    $72417d7cbfd779fc$var$ownKeys = Object.getOwnPropertyNames || function(o) {
        var ar = [];
        for(var k in o)if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
        return ar;
    };
    return $72417d7cbfd779fc$var$ownKeys(o);
};
function $72417d7cbfd779fc$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k = $72417d7cbfd779fc$var$ownKeys(mod), i = 0; i < k.length; i++)if (k[i] !== "default") $72417d7cbfd779fc$export$45d3717a4c69092e(result, mod, k[i]);
    }
    $72417d7cbfd779fc$var$__setModuleDefault(result, mod);
    return result;
}
function $72417d7cbfd779fc$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $72417d7cbfd779fc$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $72417d7cbfd779fc$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $72417d7cbfd779fc$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || (typeof receiver === "undefined" ? "undefined" : (0, $2bfPH._)(receiver)) !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $72417d7cbfd779fc$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if ((typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function dispose() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $72417d7cbfd779fc$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function _SuppressedError(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $72417d7cbfd779fc$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $72417d7cbfd779fc$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $72417d7cbfd779fc$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $72417d7cbfd779fc$export$2e2bcd8739ae039 = {
    __extends: $72417d7cbfd779fc$export$a8ba968b8961cb8a,
    __assign: $72417d7cbfd779fc$export$18ce0697a983be9b,
    __rest: $72417d7cbfd779fc$export$3c9a16f847548506,
    __decorate: $72417d7cbfd779fc$export$29e00dfd3077644b,
    __param: $72417d7cbfd779fc$export$d5ad3fd78186038f,
    __esDecorate: $72417d7cbfd779fc$export$3a84e1ae4e97e9b0,
    __runInitializers: $72417d7cbfd779fc$export$d831c04e792af3d,
    __propKey: $72417d7cbfd779fc$export$6a2a36740a146cb8,
    __setFunctionName: $72417d7cbfd779fc$export$d1a06452d3489bc7,
    __metadata: $72417d7cbfd779fc$export$f1db080c865becb9,
    __awaiter: $72417d7cbfd779fc$export$1050f835b63b671e,
    __generator: $72417d7cbfd779fc$export$67ebef60e6f28a6,
    __createBinding: $72417d7cbfd779fc$export$45d3717a4c69092e,
    __exportStar: $72417d7cbfd779fc$export$f33643c0debef087,
    __values: $72417d7cbfd779fc$export$19a8beecd37a4c45,
    __read: $72417d7cbfd779fc$export$8d051b38c9118094,
    __spread: $72417d7cbfd779fc$export$afc72e2116322959,
    __spreadArrays: $72417d7cbfd779fc$export$6388937ca91ccae8,
    __spreadArray: $72417d7cbfd779fc$export$1216008129fb82ed,
    __await: $72417d7cbfd779fc$export$10c90e4f7922046c,
    __asyncGenerator: $72417d7cbfd779fc$export$e427f37a30a4de9b,
    __asyncDelegator: $72417d7cbfd779fc$export$bbd80228419bb833,
    __asyncValues: $72417d7cbfd779fc$export$e3b29a3d6162315f,
    __makeTemplateObject: $72417d7cbfd779fc$export$4fb47efe1390b86f,
    __importStar: $72417d7cbfd779fc$export$c21735bcef00d192,
    __importDefault: $72417d7cbfd779fc$export$da59b14a69baef04,
    __classPrivateFieldGet: $72417d7cbfd779fc$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $72417d7cbfd779fc$export$d40a35129aaff81f,
    __classPrivateFieldIn: $72417d7cbfd779fc$export$81fdc39f203e4e04,
    __addDisposableResource: $72417d7cbfd779fc$export$88ac25d8e944e405,
    __disposeResources: $72417d7cbfd779fc$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $72417d7cbfd779fc$export$889dfb5d17574b0b
};



var $8onil = parcelRequire("8onil");

var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");


var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");
//#region lib/router/instrumentation.ts
var $78c285b50d937cfe$var$UninstrumentedSymbol = Symbol("Uninstrumented");
var $78c285b50d937cfe$export$b1aab28b8e9d7d25 = (0, $daRwM.createContext)();
var $78c285b50d937cfe$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $78c285b50d937cfe$export$3cb8f5f9ecc770ef(fns, route) {
    var aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach(function(fn) {
        return fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument: function(i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        });
    });
    var updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        var lazy = route.lazy;
        updates.lazy = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.lazy, void 0, function() {
                                    return lazy.apply(void 0, (0, $6zk1M._)(args));
                                }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
    }
    if ((0, $2bfPH._)(route.lazy) === "object") {
        var lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            var middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        $78c285b50d937cfe$var$recurseRight(aggregated["lazy.middleware"], void 0, function() {
                                            return middleware.apply(void 0, (0, $6zk1M._)(args));
                                        }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                            }
                        });
                    })();
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            var loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        $78c285b50d937cfe$var$recurseRight(aggregated["lazy.loader"], void 0, function() {
                                            return loader.apply(void 0, (0, $6zk1M._)(args));
                                        }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                            }
                        });
                    })();
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            var action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: function() {
                    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                        args[_key] = arguments[_key];
                    }
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        $78c285b50d937cfe$var$recurseRight(aggregated["lazy.action"], void 0, function() {
                                            return action.apply(void 0, (0, $6zk1M._)(args));
                                        }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                                    ];
                                case 1:
                                    return [
                                        2,
                                        $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                            _state.sent()
                                        ])
                                    ];
                            }
                        });
                    })();
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        var original = $78c285b50d937cfe$var$getUninstrumentedHandler(route.loader);
        var instrumented = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.loader, $78c285b50d937cfe$var$getHandlerInfo(args[0]), function() {
                                    return original.apply(void 0, (0, $6zk1M._)(args));
                                }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $78c285b50d937cfe$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        var original1 = $78c285b50d937cfe$var$getUninstrumentedHandler(route.action);
        var instrumented1 = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.action, $78c285b50d937cfe$var$getHandlerInfo(args[0]), function() {
                                    return original1.apply(void 0, (0, $6zk1M._)(args));
                                }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
        $78c285b50d937cfe$var$setUninstrumentedHandler(instrumented1, original1);
        updates.action = instrumented1;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map(function(middleware) {
        var original = $78c285b50d937cfe$var$getUninstrumentedHandler(middleware);
        var instrumented = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.middleware, $78c285b50d937cfe$var$getHandlerInfo(args[0]), function() {
                                    return original.apply(void 0, (0, $6zk1M._)(args));
                                }, $78c285b50d937cfe$var$getInstrumentationInnerResult)
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
        $78c285b50d937cfe$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $78c285b50d937cfe$export$ac4df491f31cbbfc(router, fns) {
    var aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        });
    });
    if (aggregated.navigate.length > 0) {
        var navigate = $78c285b50d937cfe$var$getUninstrumentedHandler(router.navigate);
        var instrumentedNavigate = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var _args, to, opts, meta, info;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _args = (0, $21h22._)(args, 2), to = _args[0], opts = _args[1];
                            info = (0, $lvTkn._)({
                                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $iKEZU.createPath)(to) : "."
                            }, $78c285b50d937cfe$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {}));
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.navigate, info, function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                        var cleanup;
                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(typeof to === "number")) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        navigate.apply(void 0, (0, $6zk1M._)(args))
                                                    ];
                                                case 1:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 2:
                                                    cleanup = $78c285b50d937cfe$var$setInstrumentationClientResultMetaReceiver(router, function(value) {
                                                        meta = value;
                                                    });
                                                    _state.label = 3;
                                                case 3:
                                                    _state.trys.push([
                                                        3,
                                                        ,
                                                        5,
                                                        6
                                                    ]);
                                                    return [
                                                        4,
                                                        navigate.apply(void 0, (0, $6zk1M._)(args))
                                                    ];
                                                case 4:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 5:
                                                    cleanup();
                                                    return [
                                                        7
                                                    ];
                                                case 6:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }, function(result) {
                                    return (0, $9Jpjh._)((0, $lvTkn._)({}, $78c285b50d937cfe$var$getInstrumentationInnerResult(result)), {
                                        meta: meta
                                    });
                                })
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
        $78c285b50d937cfe$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        var fetch = $78c285b50d937cfe$var$getUninstrumentedHandler(router.fetch);
        var instrumentedFetch = function() {
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                args[_key] = arguments[_key];
            }
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var _args, key, _, href, opts, meta;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _args = (0, $21h22._)(args, 4), key = _args[0], _ = _args[1], href = _args[2], opts = _args[3];
                            return [
                                4,
                                $78c285b50d937cfe$var$recurseRight(aggregated.fetch, (0, $lvTkn._)({
                                    href: href !== null && href !== void 0 ? href : ".",
                                    fetcherKey: key
                                }, $78c285b50d937cfe$var$getRouterInfo(router, opts !== null && opts !== void 0 ? opts : {})), function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                        var cleanup;
                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    cleanup = $78c285b50d937cfe$var$setInstrumentationClientResultMetaReceiver(router, function(value) {
                                                        meta = value;
                                                    });
                                                    _state.label = 1;
                                                case 1:
                                                    _state.trys.push([
                                                        1,
                                                        ,
                                                        3,
                                                        4
                                                    ]);
                                                    return [
                                                        4,
                                                        fetch.apply(void 0, (0, $6zk1M._)(args))
                                                    ];
                                                case 2:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                                case 3:
                                                    cleanup();
                                                    return [
                                                        7
                                                    ];
                                                case 4:
                                                    return [
                                                        2
                                                    ];
                                            }
                                        });
                                    })();
                                }, function(result) {
                                    return (0, $9Jpjh._)((0, $lvTkn._)({}, $78c285b50d937cfe$var$getInstrumentationInnerResult(result)), {
                                        meta: meta
                                    });
                                })
                            ];
                        case 1:
                            return [
                                2,
                                $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                    _state.sent()
                                ])
                            ];
                    }
                });
            })();
        };
        $78c285b50d937cfe$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $78c285b50d937cfe$export$8f7a8e481272777(handler, fns) {
    var aggregated = {
        request: []
    };
    fns.forEach(function(fn) {
        return fn({
            instrument: function(i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        });
    });
    var instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _args, request, context, instrumentationContext;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _args = (0, $21h22._)(args, 2), request = _args[0], context = _args[1];
                        instrumentationContext = context !== null && context !== void 0 ? context : new (0, $daRwM.RouterContextProvider)();
                        return [
                            4,
                            $78c285b50d937cfe$var$recurseRight(aggregated.request, {
                                request: $78c285b50d937cfe$var$getReadonlyRequest(request),
                                context: $78c285b50d937cfe$var$getReadonlyContext(instrumentationContext)
                            }, function() {
                                return handler(request, instrumentationContext);
                            }, function(result, info) {
                                var meta;
                                try {
                                    var _info_context;
                                    meta = (_info_context = info.context) === null || _info_context === void 0 ? void 0 : _info_context.get($78c285b50d937cfe$export$b1aab28b8e9d7d25);
                                } catch (e) {}
                                (0, $iKEZU.invariant)(result.value instanceof Response, "Expected a Response from the request handler");
                                return (0, $9Jpjh._)((0, $lvTkn._)({}, $78c285b50d937cfe$var$getInstrumentationInnerResult(result)), {
                                    statusCode: result.value.status,
                                    meta: meta
                                });
                            })
                        ];
                    case 1:
                        return [
                            2,
                            $78c285b50d937cfe$var$throwOrReturnResult.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        })();
    };
    return instrumentedHandler;
}
function $78c285b50d937cfe$var$getUninstrumentedHandler(handler) {
    var _handler_UninstrumentedSymbol;
    return (_handler_UninstrumentedSymbol = handler[$78c285b50d937cfe$var$UninstrumentedSymbol]) !== null && _handler_UninstrumentedSymbol !== void 0 ? _handler_UninstrumentedSymbol : handler;
}
function $78c285b50d937cfe$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$78c285b50d937cfe$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $78c285b50d937cfe$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $78c285b50d937cfe$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return function() {
        if ($78c285b50d937cfe$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $78c285b50d937cfe$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $78c285b50d937cfe$export$5579798e35f5560e(router) {
    var receiver = $78c285b50d937cfe$var$instrumentationClientResultMetaReceivers.get(router);
    $78c285b50d937cfe$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $78c285b50d937cfe$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
function $78c285b50d937cfe$var$recurseRight(_0, _1, _2, _3) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(impls, info, handler, getInnerResult) {
        var state, index, impl, _tmp, e, handlerPromise, callHandler, e1;
        var _arguments = arguments;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    state = _arguments.length > 4 && _arguments[4] !== void 0 ? _arguments[4] : {
                        result: null,
                        innerResult: null
                    }, index = _arguments.length > 5 && _arguments[5] !== void 0 ? _arguments[5] : impls.length - 1;
                    impl = impls[index];
                    if (!!impl) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    _tmp = {
                        type: "success"
                    };
                    return [
                        4,
                        handler()
                    ];
                case 2:
                    state.result = (_tmp.value = _state.sent(), _tmp);
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    state.result = {
                        type: "error",
                        value: e
                    };
                    return [
                        3,
                        4
                    ];
                case 4:
                    state.innerResult = getInnerResult(state.result, info);
                    return [
                        3,
                        13
                    ];
                case 5:
                    handlerPromise = void 0;
                    callHandler = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
                                        else handlerPromise = $78c285b50d937cfe$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
                                        return [
                                            4,
                                            handlerPromise
                                        ];
                                    case 1:
                                        _state.sent();
                                        (0, $iKEZU.invariant)(state.innerResult, "Expected an inner result");
                                        return [
                                            2,
                                            state.innerResult
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 6;
                case 6:
                    _state.trys.push([
                        6,
                        8,
                        ,
                        9
                    ]);
                    return [
                        4,
                        impl(callHandler, info)
                    ];
                case 7:
                    _state.sent();
                    return [
                        3,
                        9
                    ];
                case 8:
                    e1 = _state.sent();
                    console.error("An instrumentation function threw an error:", e1);
                    return [
                        3,
                        9
                    ];
                case 9:
                    if (!!handlerPromise) return [
                        3,
                        11
                    ];
                    return [
                        4,
                        callHandler()
                    ];
                case 10:
                    _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        4,
                        handlerPromise
                    ];
                case 12:
                    _state.sent();
                    _state.label = 13;
                case 13:
                    if (state.result) return [
                        2,
                        state.result
                    ];
                    state.result = {
                        type: "error",
                        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
                    };
                    state.innerResult = getInnerResult(state.result, info);
                    return [
                        2,
                        state.result
                    ];
            }
        });
    }).apply(this, arguments);
}
function $78c285b50d937cfe$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $78c285b50d937cfe$var$getHandlerInfo(args) {
    var request = args.request, context = args.context, params = args.params;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, args), {
        request: $78c285b50d937cfe$var$getReadonlyRequest(request),
        params: (0, $lvTkn._)({}, params),
        context: $78c285b50d937cfe$var$getReadonlyContext(context)
    });
}
function $78c285b50d937cfe$var$getRouterInfo(router, opts) {
    return (0, $lvTkn._)({
        currentUrl: (0, $iKEZU.createPath)(router.state.location)
    }, "formMethod" in opts ? {
        formMethod: opts.formMethod
    } : {}, "formEncType" in opts ? {
        formEncType: opts.formEncType
    } : {}, "formData" in opts ? {
        formData: opts.formData
    } : {}, "body" in opts ? {
        body: opts.body
    } : {});
}
function $78c285b50d937cfe$var$getReadonlyRequest(request) {
    var _request_headers;
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: function() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                return (_request_headers = request.headers).get.apply(_request_headers, (0, $6zk1M._)(args));
            }
        }
    };
}
function $78c285b50d937cfe$var$getReadonlyContext(context) {
    return {
        get: function(ctx) {
            return context.get(ctx);
        }
    };
}



var $d8c8e9691ac1f69a$var$_routes, $d8c8e9691ac1f69a$var$_branches, $d8c8e9691ac1f69a$var$_hmrRoutes, $d8c8e9691ac1f69a$var$_hmrBranches;
//#region lib/router/router.ts
var $d8c8e9691ac1f69a$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
var $d8c8e9691ac1f69a$var$validMutationMethods = new Set($d8c8e9691ac1f69a$var$validMutationMethodsArr);
var $d8c8e9691ac1f69a$var$validRequestMethodsArr = [
    "GET"
].concat((0, $6zk1M._)($d8c8e9691ac1f69a$var$validMutationMethodsArr));
var $d8c8e9691ac1f69a$var$validRequestMethods = new Set($d8c8e9691ac1f69a$var$validRequestMethodsArr);
var $d8c8e9691ac1f69a$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
var $d8c8e9691ac1f69a$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
var $d8c8e9691ac1f69a$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d8c8e9691ac1f69a$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
var $d8c8e9691ac1f69a$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
var $d8c8e9691ac1f69a$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
var $d8c8e9691ac1f69a$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $d8c8e9691ac1f69a$var$DataRoutes = ($d8c8e9691ac1f69a$var$_routes = /*#__PURE__*/ new WeakMap(), $d8c8e9691ac1f69a$var$_branches = /*#__PURE__*/ new WeakMap(), $d8c8e9691ac1f69a$var$_hmrRoutes = /*#__PURE__*/ new WeakMap(), $d8c8e9691ac1f69a$var$_hmrBranches = /*#__PURE__*/ new WeakMap(), /*#__PURE__*/ function() {
    "use strict";
    function _class(routes) {
        (0, $gd0sY._)(this, _class);
        (0, $6wbrO._)(this, $d8c8e9691ac1f69a$var$_routes, {
            writable: true,
            value: void 0
        });
        (0, $6wbrO._)(this, $d8c8e9691ac1f69a$var$_branches, {
            writable: true,
            value: void 0
        });
        (0, $6wbrO._)(this, $d8c8e9691ac1f69a$var$_hmrRoutes, {
            writable: true,
            value: void 0
        });
        (0, $6wbrO._)(this, $d8c8e9691ac1f69a$var$_hmrBranches, {
            writable: true,
            value: void 0
        });
        (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_routes, routes);
        (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_branches, (0, $daRwM.flattenAndRankRoutes)(routes));
    }
    (0, $7cSld._)(_class, [
        {
            key: "stableRoutes",
            get: /** The stable route tree */ function get() {
                return (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_routes);
            }
        },
        {
            key: "activeRoutes",
            get: /** The in-flight route tree if one is active, otherwise the stable tree */ function get() {
                var _$_class_private_field_get;
                return (_$_class_private_field_get = (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrRoutes)) !== null && _$_class_private_field_get !== void 0 ? _$_class_private_field_get : (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_routes);
            }
        },
        {
            key: "branches",
            get: /** Pre-computed branches */ function get() {
                var _$_class_private_field_get;
                return (_$_class_private_field_get = (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrBranches)) !== null && _$_class_private_field_get !== void 0 ? _$_class_private_field_get : (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_branches);
            }
        },
        {
            key: "hasHMRRoutes",
            get: function get() {
                return (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrRoutes) != null;
            }
        },
        {
            /** Replace the stable route tree and recompute its branches */ key: "setRoutes",
            value: function setRoutes(routes) {
                (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_routes, routes);
                (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_branches, (0, $daRwM.flattenAndRankRoutes)(routes));
            }
        },
        {
            /** Set a new in-flight route tree and recompute its branches */ key: "setHmrRoutes",
            value: function setHmrRoutes(routes) {
                (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_hmrRoutes, routes);
                (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_hmrBranches, (0, $daRwM.flattenAndRankRoutes)(routes));
            }
        },
        {
            /** Commit in-flight routes/branches to the stable slot and clear in-flight */ key: "commitHmrRoutes",
            value: function commitHmrRoutes() {
                if ((0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrRoutes)) {
                    (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_routes, (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrRoutes));
                    (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_branches, (0, $bSRDS._)(this, $d8c8e9691ac1f69a$var$_hmrBranches));
                    (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_hmrRoutes, void 0);
                    (0, $f700c7478cae7af0$export$71511d61b312f219)(this, $d8c8e9691ac1f69a$var$_hmrBranches, void 0);
                }
            }
        }
    ]);
    return _class;
}());
/**
* Create a router and listen to history POP navigations
*/ function $d8c8e9691ac1f69a$export$baddd0131ee8c05b(init) {
    var routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    var isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $iKEZU.invariant)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    var hydrationRouteProperties = init.hydrationRouteProperties || [];
    var _mapRouteProperties = init.mapRouteProperties;
    var mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : function() {
        return {};
    };
    if (init.instrumentations) {
        var instrumentations = init.instrumentations;
        mapRouteProperties = function(route) {
            return (0, $lvTkn._)({}, _mapRouteProperties === null || _mapRouteProperties === void 0 ? void 0 : _mapRouteProperties(route), (0, $78c285b50d937cfe$export$3cb8f5f9ecc770ef)(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var manifest = {};
    var dataRoutes = new $d8c8e9691ac1f69a$var$DataRoutes((0, $daRwM.convertRoutesToDataRoutes)(init.routes, mapRouteProperties, void 0, manifest));
    var basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = "/".concat(basename);
    var dataStrategyImpl = init.dataStrategy || $d8c8e9691ac1f69a$var$defaultDataStrategyWithMiddleware;
    var future = (0, $lvTkn._)({}, init.future);
    var unlistenHistory = null;
    var subscribers = /* @__PURE__ */ new Set();
    var bufferedInitialStateUpdate = null;
    var savedScrollPositions = null;
    var getScrollRestorationKey = null;
    var getScrollPosition = null;
    var initialScrollRestored = init.hydrationData != null;
    var initialMatches = (0, $daRwM.matchRoutesImpl)(dataRoutes.activeRoutes, init.history.location, basename, false, dataRoutes.branches);
    var initialMatchesIsFOW = false;
    var initialErrors = null;
    var initialized;
    var renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        var error = $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        var _getShortCircuitMatches = $d8c8e9691ac1f69a$var$getShortCircuitMatches(dataRoutes.activeRoutes), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = (0, $khBmn._)({}, route.id, error);
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, dataRoutes.activeRoutes, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            var fogOfWar = checkFogOfWar(null, dataRoutes.activeRoutes, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some(function(m) {
            return m.route.lazy;
        })) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some(function(m) {
            return $d8c8e9691ac1f69a$var$routeHasLoaderOrMiddleware(m.route);
        })) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            var loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            var errors = init.hydrationData ? init.hydrationData.errors : null;
            var relevantMatches = initialMatches;
            if (errors) {
                var idx = initialMatches.findIndex(function(m) {
                    return errors[m.route.id] !== void 0;
                });
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach(function(m) {
                var status = $d8c8e9691ac1f69a$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    var router;
    var state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $d8c8e9691ac1f69a$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    var pendingAction = "POP";
    var pendingPopstateNavigationDfd = null;
    var pendingPreventScrollReset = false;
    var pendingNavigationController;
    var pendingViewTransitionEnabled = false;
    var appliedViewTransitions = /* @__PURE__ */ new Map();
    var removePageHideEventListener = null;
    var isUninterruptedRevalidation = false;
    var isRevalidationRequired = false;
    var cancelledFetcherLoads = /* @__PURE__ */ new Set();
    var fetchControllers = /* @__PURE__ */ new Map();
    var incrementingLoadId = 0;
    var pendingNavigationLoadId = -1;
    var fetchReloadIds = /* @__PURE__ */ new Map();
    var fetchRedirectIds = /* @__PURE__ */ new Set();
    var fetchLoadMatches = /* @__PURE__ */ new Map();
    var activeFetchers = /* @__PURE__ */ new Map();
    var fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    var blockerFunctions = /* @__PURE__ */ new Map();
    var unblockBlockerHistoryUpdate = void 0;
    var pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(function(param) {
            var historyAction = param.action, location = param.location, delta = param.delta;
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $iKEZU.warning)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            var blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                var nextHistoryUpdatePromise = new Promise(function(resolve) {
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed: function() {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(function() {
                            return init.history.go(delta);
                        });
                    },
                    reset: function() {
                        var blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $d8c8e9691ac1f69a$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $d8c8e9691ac1f69a$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            var _saveAppliedTransitions = function() {
                return $d8c8e9691ac1f69a$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            };
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = function() {
                return routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
            };
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach(function(_, key) {
            return deleteFetcher(state.fetchers, key);
        });
        state.blockers.forEach(function(_, key) {
            return deleteBlocker(key);
        });
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            var newErrors = bufferedInitialStateUpdate.newErrors;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return function() {
            return subscribers.delete(fn);
        };
    }
    function updateState(newState) {
        var opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        if (newState.matches) newState.matches = newState.matches.map(function(m) {
            var route = manifest[m.route.id];
            var matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return (0, $9Jpjh._)((0, $lvTkn._)({}, m), {
                route: route
            });
            return m;
        });
        state = (0, $lvTkn._)({}, state, newState);
        var unmountedFetchers = [];
        var mountedFetchers = [];
        state.fetchers.forEach(function(fetcher, key) {
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach(function(key) {
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        var _newState_errors;
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null
        };
        (0, $6zk1M._)(subscribers).forEach(function(subscriber) {
            var _newState_errors;
            return subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: (_newState_errors = newState.errors) !== null && _newState_errors !== void 0 ? _newState_errors : null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            });
        });
        unmountedFetchers.forEach(function(key) {
            return deleteFetcher(state.fetchers, key);
        });
        mountedFetchers.forEach(function(key) {
            return state.fetchers.delete(key);
        });
    }
    function completeNavigation(location, newState) {
        var flushSync = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).flushSync;
        var _location_state, _location_state1;
        var isActionReload = state.actionData != null && state.navigation.formMethod != null && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && ((_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state._isRedirect) !== true;
        var actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        var loaderData = newState.loaderData ? $d8c8e9691ac1f69a$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        var blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach(function(_, k) {
                return blockers.set(k, $d8c8e9691ac1f69a$export$386d57f03f0b2883);
            });
        }
        var restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        var preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(state.navigation.formMethod) && ((_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1._isRedirect) !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        var viewTransitionOpts;
        if (pendingAction === "POP") {
            var priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            var toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState((0, $9Jpjh._)((0, $lvTkn._)({}, newState), {
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $d8c8e9691ac1f69a$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }), {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd === null || pendingRevalidationDfd === void 0 ? void 0 : pendingRevalidationDfd.resolve();
        pendingRevalidationDfd = null;
    }
    function navigate(to, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var promise, instrumentationNavigateMetaReceiver, _normalizeNavigateOptions, path, submission, error, maskPath, partialPath, _partialPath_pathname, _partialPath_search, _partialPath_hash, currentLocation, nextLocation, userReplace, historyAction, preventScrollReset, flushSync, blockerKey;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                        pendingPopstateNavigationDfd = null;
                        if (typeof to === "number") {
                            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $d8c8e9691ac1f69a$var$createDeferred();
                            promise = pendingPopstateNavigationDfd.promise;
                            init.history.go(to);
                            return [
                                2,
                                promise
                            ];
                        }
                        instrumentationNavigateMetaReceiver = (0, $78c285b50d937cfe$export$5579798e35f5560e)(router);
                        _normalizeNavigateOptions = $d8c8e9691ac1f69a$var$normalizeNavigateOptions(false, $d8c8e9691ac1f69a$var$normalizeTo(state.location, state.matches, basename, to, opts === null || opts === void 0 ? void 0 : opts.fromRouteId, opts === null || opts === void 0 ? void 0 : opts.relative), opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (opts === null || opts === void 0 ? void 0 : opts.mask) {
                            partialPath = typeof opts.mask === "string" ? (0, $iKEZU.parsePath)(opts.mask) : (0, $lvTkn._)({}, state.location.mask, opts.mask);
                            ;
                            maskPath = {
                                pathname: (_partialPath_pathname = partialPath.pathname) !== null && _partialPath_pathname !== void 0 ? _partialPath_pathname : "",
                                search: (_partialPath_search = partialPath.search) !== null && _partialPath_search !== void 0 ? _partialPath_search : "",
                                hash: (_partialPath_hash = partialPath.hash) !== null && _partialPath_hash !== void 0 ? _partialPath_hash : ""
                            };
                            if ((0, $8onil.PROTOCOL_RELATIVE_URL_REGEX).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
                            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
                            (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $iKEZU.createPath)(opts.mask), (0, $iKEZU.createPath)(maskPath), init.history.createURL("/"), "reject");
                        }
                        currentLocation = state.location;
                        nextLocation = (0, $iKEZU.createLocation)(currentLocation, path, opts && opts.state, void 0, maskPath);
                        nextLocation = (0, $lvTkn._)({}, nextLocation, init.history.encodeLocation(nextLocation));
                        (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $iKEZU.createPath)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
                        userReplace = opts && opts.replace != null ? opts.replace : void 0;
                        historyAction = "PUSH";
                        if (userReplace === true) historyAction = "REPLACE";
                        else if (userReplace === false) ;
                        else if (submission != null && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
                        preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
                        flushSync = (opts && opts.flushSync) === true;
                        blockerKey = shouldBlockNavigation({
                            currentLocation: currentLocation,
                            nextLocation: nextLocation,
                            historyAction: historyAction
                        });
                        if (blockerKey) {
                            updateBlocker(blockerKey, {
                                state: "blocked",
                                location: nextLocation,
                                proceed: function() {
                                    updateBlocker(blockerKey, {
                                        state: "proceeding",
                                        proceed: void 0,
                                        reset: void 0,
                                        location: nextLocation
                                    });
                                    navigate(to, opts);
                                },
                                reset: function() {
                                    var blockers = new Map(state.blockers);
                                    blockers.set(blockerKey, $d8c8e9691ac1f69a$export$386d57f03f0b2883);
                                    updateState({
                                        blockers: blockers
                                    });
                                }
                            });
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            startNavigation(historyAction, nextLocation, {
                                submission: submission,
                                pendingError: error,
                                preventScrollReset: preventScrollReset,
                                replace: opts && opts.replace,
                                enableViewTransition: opts && opts.viewTransition,
                                flushSync: flushSync,
                                callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
                                instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $d8c8e9691ac1f69a$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        var promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    function startNavigation(historyAction, location, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var routesToUse, matches, flushSync, fogOfWar, meta, _handleNavigational404, error, notFoundMatches, route, loadingNavigation, request, scopedContext, _tmp, pendingActionResult, actionResult, _actionResult_pendingActionResult, routeId, result, _ref, shortCircuited, updatedMatches, loaderData, errors, workingFetchers;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        pendingNavigationController && pendingNavigationController.abort();
                        pendingNavigationController = null;
                        pendingAction = historyAction;
                        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
                        saveScrollPosition(state.location, state.matches);
                        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
                        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
                        routesToUse = dataRoutes.activeRoutes;
                        matches = (opts === null || opts === void 0 ? void 0 : opts.initialHydration) && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : (0, $daRwM.matchRoutesImpl)(routesToUse, location, basename, false, dataRoutes.branches);
                        flushSync = (opts && opts.flushSync) === true;
                        if (matches && state.initialized && !isRevalidationRequired && $d8c8e9691ac1f69a$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(opts.submission.formMethod))) {
                            completeNavigation(location, {
                                matches: matches
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fogOfWar = checkFogOfWar(matches, routesToUse, location.pathname);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (opts === null || opts === void 0 ? void 0 : opts.instrumentationNavigateMetaReceiver) {
                            meta = $d8c8e9691ac1f69a$var$getInstrumentationNavigateMeta(init.history, location, matches);
                            opts.instrumentationNavigateMetaReceiver(meta);
                        }
                        if (!matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route = _handleNavigational404.route;
                            completeNavigation(location, {
                                matches: notFoundMatches,
                                loaderData: {},
                                errors: (0, $khBmn._)({}, route.id, error)
                            }, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        loadingNavigation = opts && opts.overrideNavigation ? (0, $9Jpjh._)((0, $lvTkn._)({}, opts.overrideNavigation), {
                            matches: matches,
                            historyAction: historyAction
                        }) : void 0;
                        pendingNavigationController = new AbortController();
                        request = $d8c8e9691ac1f69a$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new (0, $daRwM.RouterContextProvider)();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        if (!(opts && opts.pendingError)) return [
                            3,
                            4
                        ];
                        pendingActionResult = [
                            $d8c8e9691ac1f69a$var$findNearestBoundary(matches).route.id,
                            {
                                type: "error",
                                error: opts.pendingError
                            }
                        ];
                        return [
                            3,
                            6
                        ];
                    case 4:
                        if (!(opts && opts.submission && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(opts.submission.formMethod))) return [
                            3,
                            6
                        ];
                        return [
                            4,
                            handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                                replace: opts.replace,
                                flushSync: flushSync
                            })
                        ];
                    case 5:
                        actionResult = _state.sent();
                        if (actionResult.shortCircuited) return [
                            2
                        ];
                        if (actionResult.pendingActionResult) {
                            _actionResult_pendingActionResult = (0, $21h22._)(actionResult.pendingActionResult, 2), routeId = _actionResult_pendingActionResult[0], result = _actionResult_pendingActionResult[1];
                            if ($d8c8e9691ac1f69a$var$isErrorResult(result) && (0, $daRwM.isRouteErrorResponse)(result.error) && result.error.status === 404) {
                                pendingNavigationController = null;
                                completeNavigation(location, {
                                    matches: actionResult.matches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, routeId, result.error)
                                });
                                return [
                                    2
                                ];
                            }
                        }
                        matches = actionResult.matches || matches;
                        pendingActionResult = actionResult.pendingActionResult;
                        loadingNavigation = $d8c8e9691ac1f69a$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
                        flushSync = false;
                        fogOfWar.active = false;
                        request = $d8c8e9691ac1f69a$var$createClientSideRequest(init.history, request.url, request.signal);
                        _state.label = 6;
                    case 6:
                        return [
                            4,
                            handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate)
                        ];
                    case 7:
                        _ref = _state.sent(), shortCircuited = _ref.shortCircuited, updatedMatches = _ref.matches, loaderData = _ref.loaderData, errors = _ref.errors, workingFetchers = _ref.workingFetchers;
                        if (shortCircuited) return [
                            2
                        ];
                        pendingNavigationController = null;
                        completeNavigation(location, (0, $lvTkn._)((0, $9Jpjh._)((0, $lvTkn._)({
                            matches: updatedMatches || matches
                        }, $d8c8e9691ac1f69a$var$getActionDataForCommit(pendingActionResult)), {
                            loaderData: loaderData,
                            errors: errors
                        }), workingFetchers ? {
                            fetchers: workingFetchers
                        } : {}));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleAction(_0, _1, _2, _3, _4, _5, _6, _7) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration) {
            var opts, discoverResult, _getShortCircuitMatches, _$matches, route, boundaryId, _handleNavigational404, notFoundMatches, error, route1, result, actionMatch, results, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, replace, boundaryMatch;
            var _arguments = arguments;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        opts = _arguments.length > 8 && _arguments[8] !== void 0 ? _arguments[8] : {};
                        interruptActiveLoads();
                        updateState({
                            navigation: $d8c8e9691ac1f69a$var$getSubmittingNavigation(location, matches, historyAction, submission)
                        }, {
                            flushSync: opts.flushSync === true
                        });
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = $d8c8e9691ac1f69a$var$getShortCircuitMatches(dataRoutes.activeRoutes), _$matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: _$matches,
                                        pendingActionResult: [
                                            route.id,
                                            {
                                                type: "error",
                                                error: discoverResult.error
                                            }
                                        ]
                                    }
                                ];
                            }
                            boundaryId = $d8c8e9691ac1f69a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    pendingActionResult: [
                                        boundaryId,
                                        {
                                            type: "error",
                                            error: discoverResult.error
                                        }
                                    ]
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), notFoundMatches = _handleNavigational404.notFoundMatches, error = _handleNavigational404.error, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    pendingActionResult: [
                                        route1.id,
                                        {
                                            type: "error",
                                            error: error
                                        }
                                    ]
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        actionMatch = $d8c8e9691ac1f69a$var$getTargetMatch(matches, location);
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            3
                        ];
                        result = {
                            type: "error",
                            error: $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                                method: request.method,
                                pathname: location.pathname,
                                routeId: actionMatch.route.id
                            })
                        };
                        return [
                            3,
                            5
                        ];
                    case 3:
                        return [
                            4,
                            callDataStrategy(request, location, $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null)
                        ];
                    case 4:
                        results = _state.sent();
                        result = results[actionMatch.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match = _step.value;
                                    if (results[match.route.id]) {
                                        result = results[match.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        _state.label = 5;
                    case 5:
                        if (!$d8c8e9691ac1f69a$var$isRedirectResult(result)) return [
                            3,
                            7
                        ];
                        if (opts && opts.replace != null) replace = opts.replace;
                        else replace = $d8c8e9691ac1f69a$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
                        return [
                            4,
                            startRedirectNavigation(request, result, true, {
                                submission: submission,
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        if ($d8c8e9691ac1f69a$var$isErrorResult(result)) {
                            boundaryMatch = $d8c8e9691ac1f69a$var$findNearestBoundary(matches, actionMatch.route.id);
                            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
                            return [
                                2,
                                {
                                    matches: matches,
                                    pendingActionResult: [
                                        boundaryMatch.route.id,
                                        result,
                                        actionMatch.route.id
                                    ]
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                matches: matches,
                                pendingActionResult: [
                                    actionMatch.route.id,
                                    result
                                ]
                            }
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var loadingNavigation, activeSubmission, shouldUpdateNavigationState, actionData, discoverResult, _getShortCircuitMatches, _$matches, route, boundaryId, _handleNavigational404, error, notFoundMatches, route1, routesToUse, _getMatchesToLoad, dsMatches, revalidatingFetchers, workingFetchers, didUpdateFetcherRedirects, updates, actionData1, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, redirect, workingFetchers1, _processLoaderData, loaderData, errors, didUpdateFetcherRedirects1, didAbortFetchLoads, shouldUpdateFetchers;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loadingNavigation = overrideNavigation || $d8c8e9691ac1f69a$var$getLoadingNavigation(location, matches, historyAction, submission);
                        activeSubmission = submission || fetcherSubmission || $d8c8e9691ac1f69a$var$getSubmissionFromNavigation(loadingNavigation);
                        shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        if (shouldUpdateNavigationState) {
                            actionData = getUpdatedActionData(pendingActionResult);
                            updateState((0, $lvTkn._)({
                                navigation: loadingNavigation
                            }, actionData !== void 0 ? {
                                actionData: actionData
                            } : {}), {
                                flushSync: flushSync
                            });
                        }
                        return [
                            4,
                            discoverRoutes(matches, location.pathname, request.signal)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        else if (discoverResult.type === "error") {
                            if (discoverResult.partialMatches.length === 0) {
                                _getShortCircuitMatches = $d8c8e9691ac1f69a$var$getShortCircuitMatches(dataRoutes.activeRoutes), _$matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                                return [
                                    2,
                                    {
                                        matches: _$matches,
                                        loaderData: {},
                                        errors: (0, $khBmn._)({}, route.id, discoverResult.error)
                                    }
                                ];
                            }
                            boundaryId = $d8c8e9691ac1f69a$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                            return [
                                2,
                                {
                                    matches: discoverResult.partialMatches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, boundaryId, discoverResult.error)
                                }
                            ];
                        } else if (!discoverResult.matches) {
                            _handleNavigational404 = handleNavigational404(location.pathname), error = _handleNavigational404.error, notFoundMatches = _handleNavigational404.notFoundMatches, route1 = _handleNavigational404.route;
                            return [
                                2,
                                {
                                    matches: notFoundMatches,
                                    loaderData: {},
                                    errors: (0, $khBmn._)({}, route1.id, error)
                                }
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        routesToUse = dataRoutes.activeRoutes;
                        _getMatchesToLoad = $d8c8e9691ac1f69a$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, pendingActionResult, callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        pendingNavigationLoadId = ++incrementingLoadId;
                        if (!init.dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        }) && !dsMatches.some(function(m) {
                            return m.route.middleware && m.route.middleware.length > 0;
                        }) && revalidatingFetchers.length === 0) {
                            workingFetchers = new Map(state.fetchers);
                            didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
                            completeNavigation(location, (0, $lvTkn._)({
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].error) : null
                            }, $d8c8e9691ac1f69a$var$getActionDataForCommit(pendingActionResult), didUpdateFetcherRedirects ? {
                                fetchers: workingFetchers
                            } : {}), {
                                flushSync: flushSync
                            });
                            return [
                                2,
                                {
                                    shortCircuited: true
                                }
                            ];
                        }
                        if (shouldUpdateNavigationState) {
                            updates = {};
                            if (!isFogOfWar) {
                                updates.navigation = loadingNavigation;
                                actionData1 = getUpdatedActionData(pendingActionResult);
                                if (actionData1 !== void 0) updates.actionData = actionData1;
                            }
                            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
                            updateState(updates, {
                                flushSync: flushSync
                            });
                        }
                        revalidatingFetchers.forEach(function(rf) {
                            abortFetcher(rf.key);
                            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(f) {
                                return abortFetcher(f.key);
                            });
                        };
                        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext)
                        ];
                    case 3:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (request.signal.aborted) return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        revalidatingFetchers.forEach(function(rf) {
                            return fetchControllers.delete(rf.key);
                        });
                        redirect = $d8c8e9691ac1f69a$var$findRedirect(loaderResults);
                        if (!redirect) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 5:
                        redirect = $d8c8e9691ac1f69a$var$findRedirect(fetcherResults);
                        if (!redirect) return [
                            3,
                            7
                        ];
                        fetchRedirectIds.add(redirect.key);
                        return [
                            4,
                            startRedirectNavigation(request, redirect.result, true, {
                                replace: replace
                            })
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2,
                            {
                                shortCircuited: true
                            }
                        ];
                    case 7:
                        workingFetchers1 = new Map(state.fetchers);
                        _processLoaderData = $d8c8e9691ac1f69a$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers1), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        if (initialHydration && state.errors) errors = (0, $lvTkn._)({}, state.errors, errors);
                        didUpdateFetcherRedirects1 = markFetchRedirectsDone(workingFetchers1);
                        didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers1);
                        shouldUpdateFetchers = didUpdateFetcherRedirects1 || didAbortFetchLoads || revalidatingFetchers.length > 0;
                        return [
                            2,
                            (0, $lvTkn._)({
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors
                            }, shouldUpdateFetchers ? {
                                workingFetchers: workingFetchers1
                            } : {})
                        ];
                }
            });
        })();
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1])) return (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].data);
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        var workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach(function(rf) {
            var fetcher = workingFetchers.get(rf.key);
            var revalidatingFetcher = $d8c8e9691ac1f69a$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    function fetch(key, routeId, href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var flushSync, instrumentationResultMetaReceiver, routesToUse, normalizedPath, matches, fogOfWar, _normalizeNavigateOptions, path, submission, error, scopedContext, _tmp, preventScrollReset;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        abortFetcher(key);
                        flushSync = (opts && opts.flushSync) === true;
                        instrumentationResultMetaReceiver = (0, $78c285b50d937cfe$export$5579798e35f5560e)(router);
                        routesToUse = dataRoutes.activeRoutes;
                        normalizedPath = $d8c8e9691ac1f69a$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts === null || opts === void 0 ? void 0 : opts.relative);
                        matches = (0, $daRwM.matchRoutesImpl)(routesToUse, normalizedPath, basename, false, dataRoutes.branches);
                        fogOfWar = checkFogOfWar(matches, routesToUse, normalizedPath);
                        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
                        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($d8c8e9691ac1f69a$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
                        if (!matches) {
                            setFetcherError(key, routeId, $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                                pathname: normalizedPath
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        _normalizeNavigateOptions = $d8c8e9691ac1f69a$var$normalizeNavigateOptions(true, normalizedPath, opts), path = _normalizeNavigateOptions.path, submission = _normalizeNavigateOptions.submission, error = _normalizeNavigateOptions.error;
                        if (error) {
                            setFetcherError(key, routeId, error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        if (!init.getContext) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            init.getContext()
                        ];
                    case 1:
                        _tmp = _state.sent();
                        return [
                            3,
                            3
                        ];
                    case 2:
                        _tmp = new (0, $daRwM.RouterContextProvider)();
                        _state.label = 3;
                    case 3:
                        scopedContext = _tmp;
                        preventScrollReset = (opts && opts.preventScrollReset) === true;
                        if (!(submission && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(submission.formMethod))) return [
                            3,
                            5
                        ];
                        return [
                            4,
                            handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate)
                        ];
                    case 4:
                        _state.sent();
                        return [
                            2
                        ];
                    case 5:
                        fetchLoadMatches.set(key, {
                            routeId: routeId,
                            path: path
                        });
                        return [
                            4,
                            handleFetcherLoader(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission)
                        ];
                    case 6:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var abortController, fetchRequest, discoverResult, match, originatingLoadId, fetchMatches, actionResults, actionResult, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match1, nextLocation, revalidationRequest, routesToUse, matches, loadId, _getMatchesToLoad, dsMatches, revalidatingFetchers, loadFetcher, workingFetchers, abortPendingFetchRevalidations, _ref, loaderResults, fetcherResults, fetcherIsMounted, getRedirectStateWithDoneFetcher, redirect, finalFetchers, _processLoaderData, loaderData, errors;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        interruptActiveLoads();
                        fetchLoadMatches.delete(key);
                        updateFetcherState(key, $d8c8e9691ac1f69a$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $d8c8e9691ac1f69a$var$createClientSideRequest(init.history, path, abortController.signal, submission);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else requestMatches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = $d8c8e9691ac1f69a$var$getTargetMatch(requestMatches, path);
                        if (!match.route.action && !match.route.lazy) {
                            setFetcherError(key, routeId, $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                                method: submission.formMethod,
                                pathname: path,
                                routeId: routeId
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        }
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        fetchMatches = $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key)
                        ];
                    case 3:
                        actionResults = _state.sent();
                        actionResult = actionResults[match.route.id];
                        if (!actionResult) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = fetchMatches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match1 = _step.value;
                                    if (actionResults[match1.route.id]) {
                                        actionResult = actionResults[match1.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchRequest.signal.aborted) {
                            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                            return [
                                2
                            ];
                        }
                        if (fetchersQueuedForDeletion.has(key)) {
                            if ($d8c8e9691ac1f69a$var$isRedirectResult(actionResult) || $d8c8e9691ac1f69a$var$isErrorResult(actionResult)) {
                                updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(void 0));
                                return [
                                    2
                                ];
                            }
                        } else {
                            if ($d8c8e9691ac1f69a$var$isRedirectResult(actionResult)) {
                                fetchControllers.delete(key);
                                if (pendingNavigationLoadId > originatingLoadId) {
                                    updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(void 0));
                                    return [
                                        2
                                    ];
                                } else {
                                    fetchRedirectIds.add(key);
                                    updateFetcherState(key, $d8c8e9691ac1f69a$var$getLoadingFetcher(submission));
                                    return [
                                        2,
                                        startRedirectNavigation(fetchRequest, actionResult, false, {
                                            fetcherSubmission: submission,
                                            preventScrollReset: preventScrollReset
                                        })
                                    ];
                                }
                            }
                            if ($d8c8e9691ac1f69a$var$isErrorResult(actionResult)) {
                                setFetcherError(key, routeId, actionResult.error);
                                return [
                                    2
                                ];
                            }
                        }
                        nextLocation = state.navigation.location || state.location;
                        revalidationRequest = $d8c8e9691ac1f69a$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
                        routesToUse = dataRoutes.activeRoutes;
                        matches = state.navigation.state !== "idle" ? (0, $daRwM.matchRoutesImpl)(routesToUse, state.navigation.location, basename, false, dataRoutes.branches) : state.matches;
                        (0, $iKEZU.invariant)(matches, "Didn't find any matches after fetcher action");
                        loadId = ++incrementingLoadId;
                        fetchReloadIds.set(key, loadId);
                        _getMatchesToLoad = $d8c8e9691ac1f69a$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, init.patchRoutesOnNavigation != null, dataRoutes.branches, [
                            match.route.id,
                            actionResult
                        ], callSiteDefaultShouldRevalidate), dsMatches = _getMatchesToLoad.dsMatches, revalidatingFetchers = _getMatchesToLoad.revalidatingFetchers;
                        loadFetcher = $d8c8e9691ac1f69a$var$getLoadingFetcher(submission, actionResult.data);
                        workingFetchers = new Map(state.fetchers);
                        workingFetchers.set(key, loadFetcher);
                        revalidatingFetchers.filter(function(rf) {
                            return rf.key !== key;
                        }).forEach(function(rf) {
                            var staleKey = rf.key;
                            var existingFetcher = workingFetchers.get(staleKey);
                            var revalidatingFetcher = $d8c8e9691ac1f69a$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
                            workingFetchers.set(staleKey, revalidatingFetcher);
                            abortFetcher(staleKey);
                            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
                        });
                        updateState({
                            fetchers: workingFetchers
                        });
                        abortPendingFetchRevalidations = function() {
                            return revalidatingFetchers.forEach(function(rf) {
                                return abortFetcher(rf.key);
                            });
                        };
                        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
                        return [
                            4,
                            callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext)
                        ];
                    case 4:
                        _ref = _state.sent(), loaderResults = _ref.loaderResults, fetcherResults = _ref.fetcherResults;
                        if (abortController.signal.aborted) {
                            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
                            return [
                                2
                            ];
                        }
                        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
                        fetchReloadIds.delete(key);
                        fetchControllers.delete(key);
                        revalidatingFetchers.forEach(function(r) {
                            return fetchControllers.delete(r.key);
                        });
                        fetcherIsMounted = state.fetchers.has(key);
                        getRedirectStateWithDoneFetcher = function(s) {
                            if (!fetcherIsMounted) return s;
                            var workingFetchers = new Map(s.fetchers);
                            workingFetchers.set(key, $d8c8e9691ac1f69a$var$getDoneFetcher(actionResult.data));
                            return (0, $9Jpjh._)((0, $lvTkn._)({}, s), {
                                fetchers: workingFetchers
                            });
                        };
                        redirect = $d8c8e9691ac1f69a$var$findRedirect(loaderResults);
                        if (redirect) {
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        redirect = $d8c8e9691ac1f69a$var$findRedirect(fetcherResults);
                        if (redirect) {
                            fetchRedirectIds.add(redirect.key);
                            state = getRedirectStateWithDoneFetcher(state);
                            return [
                                2,
                                startRedirectNavigation(revalidationRequest, redirect.result, false, {
                                    preventScrollReset: preventScrollReset
                                })
                            ];
                        }
                        finalFetchers = new Map(state.fetchers);
                        if (fetcherIsMounted) finalFetchers.set(key, $d8c8e9691ac1f69a$var$getDoneFetcher(actionResult.data));
                        _processLoaderData = $d8c8e9691ac1f69a$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers), loaderData = _processLoaderData.loaderData, errors = _processLoaderData.errors;
                        abortStaleFetchLoads(loadId, finalFetchers);
                        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
                            (0, $iKEZU.invariant)(pendingAction, "Expected pending action");
                            pendingNavigationController && pendingNavigationController.abort();
                            completeNavigation(state.navigation.location, {
                                matches: matches,
                                loaderData: loaderData,
                                errors: errors,
                                fetchers: finalFetchers
                            });
                        } else {
                            updateState({
                                errors: errors,
                                loaderData: $d8c8e9691ac1f69a$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                                fetchers: finalFetchers
                            });
                            isRevalidationRequired = false;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function handleFetcherLoader(key, routeId, path, matches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var existingFetcher, abortController, fetchRequest, discoverResult, match, originatingLoadId, results, result, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match1;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        existingFetcher = state.fetchers.get(key);
                        updateFetcherState(key, $d8c8e9691ac1f69a$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
                            flushSync: flushSync
                        });
                        abortController = new AbortController();
                        fetchRequest = $d8c8e9691ac1f69a$var$createClientSideRequest(init.history, path, abortController.signal);
                        if (!isFogOfWar) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key)
                        ];
                    case 1:
                        discoverResult = _state.sent();
                        if (discoverResult.type === "aborted") return [
                            2
                        ];
                        else if (discoverResult.type === "error") {
                            setFetcherError(key, routeId, discoverResult.error, {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else if (!discoverResult.matches) {
                            setFetcherError(key, routeId, $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                                pathname: path
                            }), {
                                flushSync: flushSync
                            });
                            return [
                                2
                            ];
                        } else matches = discoverResult.matches;
                        _state.label = 2;
                    case 2:
                        match = $d8c8e9691ac1f69a$var$getTargetMatch(matches, path);
                        fetchControllers.set(key, abortController);
                        originatingLoadId = incrementingLoadId;
                        return [
                            4,
                            callDataStrategy(fetchRequest, path, $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key)
                        ];
                    case 3:
                        results = _state.sent();
                        result = results[match.route.id];
                        if (!result) {
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                    match1 = _step.value;
                                    if (results[match1.route.id]) {
                                        result = results[match1.route.id];
                                        break;
                                    }
                                }
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                        }
                        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
                        if (fetchRequest.signal.aborted) return [
                            2
                        ];
                        if (fetchersQueuedForDeletion.has(key)) {
                            updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(void 0));
                            return [
                                2
                            ];
                        }
                        if (!$d8c8e9691ac1f69a$var$isRedirectResult(result)) return [
                            3,
                            6
                        ];
                        if (!(pendingNavigationLoadId > originatingLoadId)) return [
                            3,
                            4
                        ];
                        updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(void 0));
                        return [
                            2
                        ];
                    case 4:
                        fetchRedirectIds.add(key);
                        return [
                            4,
                            startRedirectNavigation(fetchRequest, result, false, {
                                preventScrollReset: preventScrollReset
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            2
                        ];
                    case 6:
                        if ($d8c8e9691ac1f69a$var$isErrorResult(result)) {
                            setFetcherError(key, routeId, result.error);
                            return [
                                2
                            ];
                        }
                        updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(result.data));
                        return [
                            2
                        ];
                }
            });
        })();
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ function startRedirectNavigation(_0, _1, _2) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(request, redirect, isNavigation) {
            var _ref, submission, fetcherSubmission, preventScrollReset, replace, location, originalLocation, currentUrl, redirectLocation, isDocumentReload, url, redirectNavigationType, _state_navigation, formMethod, formAction, formEncType, activeSubmission;
            var _arguments = arguments;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : {}, submission = _ref.submission, fetcherSubmission = _ref.fetcherSubmission, preventScrollReset = _ref.preventScrollReset, replace = _ref.replace;
                        if (!isNavigation) {
                            pendingPopstateNavigationDfd === null || pendingPopstateNavigationDfd === void 0 ? void 0 : pendingPopstateNavigationDfd.resolve();
                            pendingPopstateNavigationDfd = null;
                        }
                        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
                        location = redirect.response.headers.get("Location");
                        (0, $iKEZU.invariant)(location, "Expected a Location header on the redirect Response");
                        originalLocation = location;
                        currentUrl = new URL(request.url);
                        location = $d8c8e9691ac1f69a$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
                        (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
                        redirectLocation = (0, $iKEZU.createLocation)(state.location, location, {
                            _isRedirect: true
                        });
                        if (isBrowser) {
                            isDocumentReload = false;
                            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
                            else if ((0, $daRwM.isAbsoluteUrl)(location)) {
                                url = (0, $iKEZU.createBrowserURLImpl)(routerWindow, location, true);
                                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $daRwM.stripBasename)(url.pathname, basename) == null;
                            }
                            if (isDocumentReload) {
                                if (replace) routerWindow.location.replace(location);
                                else routerWindow.location.assign(location);
                                return [
                                    2
                                ];
                            }
                        }
                        pendingNavigationController = null;
                        redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
                        _state_navigation = state.navigation, formMethod = _state_navigation.formMethod, formAction = _state_navigation.formAction, formEncType = _state_navigation.formEncType;
                        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $d8c8e9691ac1f69a$var$getSubmissionFromNavigation(state.navigation);
                        activeSubmission = submission || fetcherSubmission;
                        if (!($d8c8e9691ac1f69a$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(activeSubmission.formMethod))) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                submission: (0, $9Jpjh._)((0, $lvTkn._)({}, activeSubmission), {
                                    formAction: location
                                }),
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            startNavigation(redirectNavigationType, redirectLocation, {
                                overrideNavigation: $d8c8e9691ac1f69a$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
                                fetcherSubmission: fetcherSubmission,
                                preventScrollReset: preventScrollReset || pendingPreventScrollReset,
                                enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var results, dataResults, e, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, _results_match_route_id, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, _step_value, routeId, result, response, err;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        dataResults = {};
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false)
                        ];
                    case 2:
                        results = _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        e = _state.sent();
                        matches.filter(function(m) {
                            return m.shouldLoad;
                        }).forEach(function(m) {
                            dataResults[m.route.id] = {
                                type: "error",
                                error: e
                            };
                        });
                        return [
                            2,
                            dataResults
                        ];
                    case 4:
                        if (request.signal.aborted) return [
                            2,
                            dataResults
                        ];
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        if (!$d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method)) try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                ;
                                if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.type) === "error") break;
                                if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                                    type: "error",
                                    result: /* @__PURE__ */ new Error("No result returned from dataStrategy for route ".concat(match.route.id))
                                };
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                        _state.label = 5;
                    case 5:
                        _state.trys.push([
                            5,
                            11,
                            12,
                            13
                        ]);
                        _iterator1 = Object.entries(results)[Symbol.iterator]();
                        _state.label = 6;
                    case 6:
                        if (!!(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done)) return [
                            3,
                            10
                        ];
                        _step_value = (0, $21h22._)(_step1.value, 2), routeId = _step_value[0], result = _step_value[1];
                        if (!$d8c8e9691ac1f69a$var$isRedirectDataStrategyResult(result)) return [
                            3,
                            7
                        ];
                        response = result.result;
                        dataResults[routeId] = {
                            type: "redirect",
                            response: $d8c8e9691ac1f69a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
                        };
                        return [
                            3,
                            9
                        ];
                    case 7:
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$convertDataStrategyResultToDataResult(result)
                        ];
                    case 8:
                        dataResults[routeId] = _state.sent();
                        _state.label = 9;
                    case 9:
                        _iteratorNormalCompletion1 = true;
                        return [
                            3,
                            6
                        ];
                    case 10:
                        return [
                            3,
                            13
                        ];
                    case 11:
                        err = _state.sent();
                        _didIteratorError1 = true;
                        _iteratorError1 = err;
                        return [
                            3,
                            13
                        ];
                    case 12:
                        try {
                            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                _iterator1.return();
                            }
                        } finally{
                            if (_didIteratorError1) {
                                throw _iteratorError1;
                            }
                        }
                        return [
                            7
                        ];
                    case 13:
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var loaderResultsPromise, fetcherResultsPromise, _tmp;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
                        fetcherResultsPromise = Promise.all(fetchersToLoad.map(function(f) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                var result;
                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            if (!(f.matches && f.match && f.request && f.controller)) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key)
                                            ];
                                        case 1:
                                            result = _state.sent()[f.match.route.id];
                                            return [
                                                2,
                                                (0, $khBmn._)({}, f.key, result)
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                Promise.resolve((0, $khBmn._)({}, f.key, {
                                                    type: "error",
                                                    error: $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                                                        pathname: f.path
                                                    })
                                                }))
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }));
                        _tmp = {};
                        return [
                            4,
                            loaderResultsPromise
                        ];
                    case 1:
                        _tmp.loaderResults = _state.sent();
                        return [
                            4,
                            fetcherResultsPromise
                        ];
                    case 2:
                        return [
                            2,
                            (_tmp.fetcherResults = _state.sent().reduce(function(acc, r) {
                                return Object.assign(acc, r);
                            }, {}), _tmp)
                        ];
                }
            });
        })();
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach(function(_, key) {
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher) {
        var opts = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
        var workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error) {
        var opts = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {};
        var boundaryMatch = $d8c8e9691ac1f69a$var$findNearestBoundary(state.matches, routeId);
        var workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: (0, $khBmn._)({}, boundaryMatch.route.id, error),
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $d8c8e9691ac1f69a$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts === null || opts === void 0 ? void 0 : opts.reason);
        updateFetcherState(key, $d8c8e9691ac1f69a$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        var fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        var count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        var controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                (0, $iKEZU.invariant)(fetcher, "Expected fetcher: ".concat(key));
                var doneFetcher = $d8c8e9691ac1f69a$var$getDoneFetcher(fetcher.data);
                fetchers.set(key, doneFetcher);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }
    function markFetchRedirectsDone(fetchers) {
        var doneKeys = [];
        var didUpdateFetchers = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchRedirectIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var key = _step.value;
                var fetcher = fetchers.get(key);
                (0, $iKEZU.invariant)(fetcher, "Expected fetcher: ".concat(key));
                if (fetcher.state === "loading") {
                    fetchRedirectIds.delete(key);
                    doneKeys.push(key);
                    didUpdateFetchers = true;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        var yeetedKeys = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = fetchReloadIds[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], id = _step_value[1];
                if (id < landedId) {
                    var fetcher = fetchers.get(key);
                    (0, $iKEZU.invariant)(fetcher, "Expected fetcher: ".concat(key));
                    if (fetcher.state === "loading") {
                        abortFetcher(key);
                        fetchReloadIds.delete(key);
                        yeetedKeys.push(key);
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        var blocker = state.blockers.get(key) || $d8c8e9691ac1f69a$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        var blocker = state.blockers.get(key) || $d8c8e9691ac1f69a$export$386d57f03f0b2883;
        (0, $iKEZU.invariant)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", "Invalid blocker state transition: ".concat(blocker.state, " -> ").concat(newBlocker.state));
        var blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation(param) {
        var currentLocation = param.currentLocation, nextLocation = param.nextLocation, historyAction = param.historyAction;
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $iKEZU.warning)(false, "A router only supports one blocker at a time");
        var entries = Array.from(blockerFunctions.entries());
        var _entries_ = (0, $21h22._)(entries[entries.length - 1], 2), blockerKey = _entries_[0], blockerFunction = _entries_[1];
        var blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        var error = $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
            pathname: pathname
        });
        var routesToUse = dataRoutes.activeRoutes;
        var _getShortCircuitMatches = $d8c8e9691ac1f69a$var$getShortCircuitMatches(routesToUse), matches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $d8c8e9691ac1f69a$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            var y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return function() {
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map(function(m) {
            return (0, $daRwM.convertRouteMatchToUiMatch)(m, state.loaderData);
        })) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            var key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            var key = getScrollKey(location, matches);
            var y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, routesToUse, pathname) {
        if (init.patchRoutesOnNavigation) {
            var activeBranches = dataRoutes.branches;
            if (!matches) return {
                active: true,
                matches: (0, $daRwM.matchRoutesImpl)(routesToUse, pathname, basename, true, activeBranches) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: (0, $daRwM.matchRoutesImpl)(routesToUse, pathname, basename, true, activeBranches)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    function discoverRoutes(matches, pathname, signal, fetcherKey) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _loop, partialMatches, _ret;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _loop = function() {
                            var localManifest, e, activeBranches, newMatches, newPartialMatches;
                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        localManifest = manifest;
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            4
                                        ]);
                                        return [
                                            4,
                                            init.patchRoutesOnNavigation({
                                                signal: signal,
                                                path: pathname,
                                                matches: partialMatches,
                                                fetcherKey: fetcherKey,
                                                patch: function(routeId, children) {
                                                    if (signal.aborted) return;
                                                    $d8c8e9691ac1f69a$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                                                }
                                            })
                                        ];
                                    case 2:
                                        _state.sent();
                                        return [
                                            3,
                                            4
                                        ];
                                    case 3:
                                        e = _state.sent();
                                        return [
                                            2,
                                            {
                                                v: {
                                                    type: "error",
                                                    error: e,
                                                    partialMatches: partialMatches
                                                }
                                            }
                                        ];
                                    case 4:
                                        if (signal.aborted) return [
                                            2,
                                            {
                                                v: {
                                                    type: "aborted"
                                                }
                                            }
                                        ];
                                        activeBranches = dataRoutes.branches;
                                        newMatches = (0, $daRwM.matchRoutesImpl)(dataRoutes.activeRoutes, pathname, basename, false, activeBranches);
                                        newPartialMatches = null;
                                        if (newMatches) {
                                            if (Object.keys(newMatches[0].params).length === 0) return [
                                                2,
                                                {
                                                    v: {
                                                        type: "success",
                                                        matches: newMatches
                                                    }
                                                }
                                            ];
                                            else {
                                                newPartialMatches = (0, $daRwM.matchRoutesImpl)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                                if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return [
                                                    2,
                                                    {
                                                        v: {
                                                            type: "success",
                                                            matches: newMatches
                                                        }
                                                    }
                                                ];
                                            }
                                        }
                                        if (!newPartialMatches) newPartialMatches = (0, $daRwM.matchRoutesImpl)(dataRoutes.activeRoutes, pathname, basename, true, activeBranches);
                                        if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return [
                                            2,
                                            {
                                                v: {
                                                    type: "success",
                                                    matches: null
                                                }
                                            }
                                        ];
                                        partialMatches = newPartialMatches;
                                        return [
                                            2
                                        ];
                                }
                            });
                        };
                        if (!init.patchRoutesOnNavigation) return [
                            2,
                            {
                                type: "success",
                                matches: matches
                            }
                        ];
                        partialMatches = matches;
                        _state.label = 1;
                    case 1:
                        if (!true) return [
                            3,
                            3
                        ];
                        return [
                            5,
                            (0, $72417d7cbfd779fc$export$19a8beecd37a4c45)(_loop())
                        ];
                    case 2:
                        _ret = _state.sent();
                        if ((0, $2bfPH._)(_ret) === "object") return [
                            2,
                            _ret.v
                        ];
                        return [
                            3,
                            1
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every(function(m, i) {
            return m.route.id === b[i].route.id;
        });
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $daRwM.convertRoutesToDataRoutes)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children) {
        var unstable_allowElementMutations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
        $d8c8e9691ac1f69a$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        get branches () {
            return dataRoutes.branches;
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: function(to) {
            return init.history.createHref(to);
        },
        createURL: function(to) {
            return init.history.createURL(to);
        },
        encodeLocation: function(to) {
            return init.history.encodeLocation(to);
        },
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp: function(newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $78c285b50d937cfe$export$ac4df491f31cbbfc)(router, init.instrumentations.map(function(i) {
        return i.router;
    }).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $d8c8e9691ac1f69a$export$3336b097a6fbc59a(routes, opts) {
    (0, $iKEZU.invariant)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    var manifest = {};
    var basename = (opts ? opts.basename : null) || "/";
    var _mapRouteProperties = opts === null || opts === void 0 ? void 0 : opts.mapRouteProperties;
    var mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : function() {
        return {};
    };
    (0, $lvTkn._)({}, opts === null || opts === void 0 ? void 0 : opts.future);
    if (opts === null || opts === void 0 ? void 0 : opts.instrumentations) {
        var instrumentations = opts.instrumentations;
        mapRouteProperties = function(route) {
            return (0, $lvTkn._)({}, _mapRouteProperties === null || _mapRouteProperties === void 0 ? void 0 : _mapRouteProperties(route), (0, $78c285b50d937cfe$export$3cb8f5f9ecc770ef)(instrumentations.map(function(i) {
                return i.route;
            }).filter(Boolean), route));
        };
    }
    var dataRoutes = (0, $daRwM.convertRoutesToDataRoutes)(routes, mapRouteProperties, void 0, manifest);
    var routeBranches = (0, $daRwM.flattenAndRankRoutes)(dataRoutes);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ function query(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(request) {
            var _ref, requestContext, filterMatchesToLoad, skipLoaderErrorBubbling, skipRevalidation, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, error, _getShortCircuitMatches, methodNotAllowedMatches, route, staticContext, error1, _getShortCircuitMatches1, notFoundMatches, route1, staticContext1, renderedStaticContext, response, e, result;
            var _arguments = arguments;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, requestContext = _ref.requestContext, filterMatchesToLoad = _ref.filterMatchesToLoad, skipLoaderErrorBubbling = _ref.skipLoaderErrorBubbling, skipRevalidation = _ref.skipRevalidation, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || $d8c8e9691ac1f69a$var$defaultNormalizePath;
                        method = request.method;
                        location = (0, $iKEZU.createLocation)("", normalizePathImpl(request), null, "default");
                        matches = (0, $daRwM.matchRoutesImpl)(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new (0, $daRwM.RouterContextProvider)();
                        if (!$d8c8e9691ac1f69a$var$isValidMethod(method) && method !== "HEAD") {
                            error = $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                                method: method
                            });
                            _getShortCircuitMatches = $d8c8e9691ac1f69a$var$getShortCircuitMatches(dataRoutes), methodNotAllowedMatches = _getShortCircuitMatches.matches, route = _getShortCircuitMatches.route;
                            staticContext = {
                                basename: basename,
                                location: location,
                                matches: methodNotAllowedMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $khBmn._)({}, route.id, error),
                                statusCode: error.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext);
                                }) : staticContext
                            ];
                        } else if (!matches) {
                            error1 = $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                                pathname: location.pathname
                            });
                            _getShortCircuitMatches1 = $d8c8e9691ac1f69a$var$getShortCircuitMatches(dataRoutes), notFoundMatches = _getShortCircuitMatches1.matches, route1 = _getShortCircuitMatches1.route;
                            staticContext1 = {
                                basename: basename,
                                location: location,
                                matches: notFoundMatches,
                                loaderData: {},
                                actionData: null,
                                errors: (0, $khBmn._)({}, route1.id, error1),
                                statusCode: error1.status,
                                loaderHeaders: {},
                                actionHeaders: {}
                            };
                            return [
                                2,
                                generateMiddlewareResponse ? generateMiddlewareResponse(function() {
                                    return Promise.resolve(staticContext1);
                                }) : staticContext1
                            ];
                        }
                        if (!generateMiddlewareResponse) return [
                            3,
                            5
                        ];
                        (0, $iKEZU.invariant)(requestContext instanceof (0, $daRwM.RouterContextProvider), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$runServerMiddlewarePipeline({
                                request: request,
                                url: (0, $daRwM.createDataFunctionUrl)(request, location),
                                pattern: (0, $daRwM.getRoutePattern)(matches),
                                matches: matches,
                                params: matches[0].params,
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(revalidationRequest) {
                                                        var _$opts = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                            var _opts_filterMatchesToLoad, result;
                                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in _$opts ? (_opts_filterMatchesToLoad = _$opts.filterMatchesToLoad) !== null && _opts_filterMatchesToLoad !== void 0 ? _opts_filterMatchesToLoad : null : filterMatchesToLoad !== null && filterMatchesToLoad !== void 0 ? filterMatchesToLoad : null, skipRevalidation === true)
                                                                        ];
                                                                    case 1:
                                                                        result = _state.sent();
                                                                        if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result)) return [
                                                                            2,
                                                                            result
                                                                        ];
                                                                        renderedStaticContext = (0, $lvTkn._)({
                                                                            location: location,
                                                                            basename: basename
                                                                        }, result);
                                                                        return [
                                                                            2,
                                                                            renderedStaticContext
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })();
                            }, function(error, routeId) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    var _, _tmp, e, staticContext, _matches_find, staticContext1;
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if ($d8c8e9691ac1f69a$export$6e80290866a84dd4(error)) return [
                                                    2,
                                                    error
                                                ];
                                                if (!$d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(error)) return [
                                                    3,
                                                    4
                                                ];
                                                _state.label = 1;
                                            case 1:
                                                _state.trys.push([
                                                    1,
                                                    3,
                                                    ,
                                                    4
                                                ]);
                                                _ = (0, $daRwM.ErrorResponseImpl).bind;
                                                _tmp = [
                                                    void 0,
                                                    error.status,
                                                    error.statusText
                                                ];
                                                return [
                                                    4,
                                                    $d8c8e9691ac1f69a$var$parseResponseBody(error)
                                                ];
                                            case 2:
                                                error = new (_.apply((0, $daRwM.ErrorResponseImpl), _tmp.concat([
                                                    _state.sent()
                                                ])));
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 3:
                                                e = _state.sent();
                                                error = e;
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 4:
                                                if ($d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(error)) error = $d8c8e9691ac1f69a$var$dataWithResponseInitToErrorResponse(error);
                                                if (renderedStaticContext) {
                                                    if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                                                    staticContext = $d8c8e9691ac1f69a$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $d8c8e9691ac1f69a$var$findNearestBoundary(matches, routeId).route.id);
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext);
                                                        })
                                                    ];
                                                } else {
                                                    ;
                                                    staticContext1 = {
                                                        matches: matches,
                                                        location: location,
                                                        basename: basename,
                                                        loaderData: {},
                                                        actionData: null,
                                                        errors: (0, $khBmn._)({}, skipLoaderErrorBubbling ? routeId : $d8c8e9691ac1f69a$var$findNearestBoundary(matches, ((_matches_find = matches.find(function(m) {
                                                            return m.route.id === routeId || m.route.loader;
                                                        })) === null || _matches_find === void 0 ? void 0 : _matches_find.route.id) || routeId).route.id, error),
                                                        statusCode: (0, $daRwM.isRouteErrorResponse)(error) ? error.status : 500,
                                                        actionHeaders: {},
                                                        loaderHeaders: {}
                                                    };
                                                    return [
                                                        2,
                                                        generateMiddlewareResponse(function() {
                                                            return Promise.resolve(staticContext1);
                                                        })
                                                    ];
                                                }
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 3:
                        response = _state.sent();
                        (0, $iKEZU.invariant)($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                        return [
                            2,
                            response
                        ];
                    case 4:
                        e = _state.sent();
                        if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 5:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true)
                        ];
                    case 6:
                        result = _state.sent();
                        if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result)) return [
                            2,
                            result
                        ];
                        return [
                            2,
                            (0, $lvTkn._)({
                                location: location,
                                basename: basename
                            }, result)
                        ];
                }
            });
        }).apply(this, arguments);
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ function queryRoute(_0) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(request) {
            var _ref, routeId, requestContext, dataStrategy, generateMiddlewareResponse, normalizePath, normalizePathImpl, method, location, matches, match;
            var _arguments = arguments;
            function handleQueryResult(result) {
                if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result)) return result;
                var error = result.errors ? Object.values(result.errors)[0] : void 0;
                if (error !== void 0) throw error;
                if (result.actionData) return Object.values(result.actionData)[0];
                if (result.loaderData) return Object.values(result.loaderData)[0];
            }
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _ref = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, routeId = _ref.routeId, requestContext = _ref.requestContext, dataStrategy = _ref.dataStrategy, generateMiddlewareResponse = _ref.generateMiddlewareResponse, normalizePath = _ref.normalizePath;
                        normalizePathImpl = normalizePath || $d8c8e9691ac1f69a$var$defaultNormalizePath;
                        method = request.method;
                        location = (0, $iKEZU.createLocation)("", normalizePathImpl(request), null, "default");
                        matches = (0, $daRwM.matchRoutesImpl)(dataRoutes, location, basename, false, routeBranches);
                        requestContext = requestContext != null ? requestContext : new (0, $daRwM.RouterContextProvider)();
                        if (!$d8c8e9691ac1f69a$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                            method: method
                        });
                        else if (!matches) throw $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        match = routeId ? matches.find(function(m) {
                            return m.route.id === routeId;
                        }) : $d8c8e9691ac1f69a$var$getTargetMatch(matches, location);
                        if (routeId && !match) throw $d8c8e9691ac1f69a$var$getInternalRouterError(403, {
                            pathname: location.pathname,
                            routeId: routeId
                        });
                        else if (!match) throw $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                            pathname: location.pathname
                        });
                        if (!generateMiddlewareResponse) return [
                            3,
                            3
                        ];
                        (0, $iKEZU.invariant)(requestContext instanceof (0, $daRwM.RouterContextProvider), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$runServerMiddlewarePipeline({
                                request: request,
                                url: (0, $daRwM.createDataFunctionUrl)(request, location),
                                pattern: (0, $daRwM.getRoutePattern)(matches),
                                matches: matches,
                                params: matches[0].params,
                                context: requestContext
                            }, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                return [
                                                    4,
                                                    generateMiddlewareResponse(function(innerRequest) {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                            var processed;
                                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                                                                        ];
                                                                    case 1:
                                                                        processed = handleQueryResult.apply(void 0, [
                                                                            _state.sent()
                                                                        ]);
                                                                        return [
                                                                            2,
                                                                            $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                        }
                                    });
                                })();
                            }, function(error) {
                                if ($d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($d8c8e9691ac1f69a$var$dataWithResponseInitToResponse(error));
                                if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                                throw error;
                            })
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        return [
                            4,
                            queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false)
                        ];
                    case 4:
                        return [
                            2,
                            handleQueryResult.apply(void 0, [
                                _state.sent()
                            ])
                        ];
                }
            });
        }).apply(this, arguments);
    }
    function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var result, e;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $iKEZU.invariant)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            5,
                            ,
                            6
                        ]);
                        if (!$d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method)) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            submit(request, location, matches, routeMatch || $d8c8e9691ac1f69a$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation)
                        ];
                    case 2:
                        return [
                            2,
                            _state.sent()
                        ];
                    case 3:
                        return [
                            4,
                            loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad)
                        ];
                    case 4:
                        result = _state.sent();
                        return [
                            2,
                            $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result) ? result : (0, $9Jpjh._)((0, $lvTkn._)({}, result), {
                                actionData: null,
                                actionHeaders: {}
                            })
                        ];
                    case 5:
                        e = _state.sent();
                        if ($d8c8e9691ac1f69a$var$isDataStrategyResult(e) && $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(e.result)) {
                            if (e.type === "error") throw e.result;
                            return [
                                2,
                                e.result
                            ];
                        }
                        if ($d8c8e9691ac1f69a$export$6e80290866a84dd4(e)) return [
                            2,
                            e
                        ];
                        throw e;
                    case 6:
                        return [
                            2
                        ];
                }
            });
        })();
    }
    function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var result, error, boundaryMatch, loaderRequest, _tmp, _tmp1;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!(!actionMatch.route.action && !actionMatch.route.lazy)) return [
                            3,
                            1
                        ];
                        error = $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: actionMatch.route.id
                        });
                        if (isRouteRequest) throw error;
                        result = {
                            type: "error",
                            error: error
                        };
                        return [
                            3,
                            3
                        ];
                    case 1:
                        return [
                            4,
                            callDataStrategy(request, location, $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 2:
                        result = _state.sent()[actionMatch.route.id];
                        if (request.signal.aborted) $d8c8e9691ac1f69a$var$throwStaticHandlerAbortedError(request, isRouteRequest);
                        _state.label = 3;
                    case 3:
                        if ($d8c8e9691ac1f69a$var$isRedirectResult(result)) throw new Response(null, {
                            status: result.response.status,
                            headers: {
                                Location: result.response.headers.get("Location")
                            }
                        });
                        if (isRouteRequest) {
                            if ($d8c8e9691ac1f69a$var$isErrorResult(result)) throw result.error;
                            return [
                                2,
                                {
                                    matches: [
                                        actionMatch
                                    ],
                                    loaderData: {},
                                    actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data),
                                    errors: null,
                                    statusCode: 200,
                                    loaderHeaders: {},
                                    actionHeaders: {}
                                }
                            ];
                        }
                        if (skipRevalidation) {
                            if ($d8c8e9691ac1f69a$var$isErrorResult(result)) {
                                boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $d8c8e9691ac1f69a$var$findNearestBoundary(matches, actionMatch.route.id);
                                return [
                                    2,
                                    {
                                        statusCode: (0, $daRwM.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                        actionData: null,
                                        actionHeaders: (0, $lvTkn._)({}, result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {}),
                                        matches: matches,
                                        loaderData: {},
                                        errors: (0, $khBmn._)({}, boundaryMatch.route.id, result.error),
                                        loaderHeaders: {}
                                    }
                                ];
                            } else return [
                                2,
                                {
                                    actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data),
                                    actionHeaders: result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {},
                                    matches: matches,
                                    loaderData: {},
                                    errors: null,
                                    statusCode: result.statusCode || 200,
                                    loaderHeaders: {}
                                }
                            ];
                        }
                        loaderRequest = new Request(request.url, {
                            headers: request.headers,
                            redirect: request.redirect,
                            signal: request.signal
                        });
                        if (!$d8c8e9691ac1f69a$var$isErrorResult(result)) return [
                            3,
                            5
                        ];
                        _tmp = [
                            {}
                        ];
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                                (skipLoaderErrorBubbling ? actionMatch : $d8c8e9691ac1f69a$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                                result
                            ])
                        ];
                    case 4:
                        return [
                            2,
                            (0, $9Jpjh._).apply(void 0, [
                                (0, $lvTkn._).apply(void 0, _tmp.concat([
                                    _state.sent()
                                ])),
                                {
                                    statusCode: (0, $daRwM.isRouteErrorResponse)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                                    actionData: null,
                                    actionHeaders: (0, $lvTkn._)({}, result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {})
                                }
                            ])
                        ];
                    case 5:
                        _tmp1 = [
                            {}
                        ];
                        return [
                            4,
                            loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad)
                        ];
                    case 6:
                        return [
                            2,
                            (0, $9Jpjh._).apply(void 0, [
                                (0, $lvTkn._).apply(void 0, [
                                    (0, $9Jpjh._).apply(void 0, [
                                        (0, $lvTkn._).apply(void 0, _tmp1.concat([
                                            _state.sent()
                                        ])),
                                        {
                                            actionData: (0, $khBmn._)({}, actionMatch.route.id, result.data)
                                        }
                                    ]),
                                    result.statusCode ? {
                                        statusCode: result.statusCode
                                    } : {}
                                ]),
                                {
                                    actionHeaders: result.headers ? (0, $khBmn._)({}, actionMatch.route.id, result.headers) : {}
                                }
                            ])
                        ];
                }
            });
        })();
    }
    function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var isRouteRequest, dsMatches, maxIdx, pattern, results;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isRouteRequest = routeMatch != null;
                        if (isRouteRequest && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.loader) && !(routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.lazy)) throw $d8c8e9691ac1f69a$var$getInternalRouterError(400, {
                            method: request.method,
                            pathname: new URL(request.url).pathname,
                            routeId: routeMatch === null || routeMatch === void 0 ? void 0 : routeMatch.route.id
                        });
                        if (routeMatch) dsMatches = $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
                        else {
                            maxIdx = pendingActionResult && $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex(function(m) {
                                return m.route.id === pendingActionResult[0];
                            }) - 1 : void 0;
                            pattern = (0, $daRwM.getRoutePattern)(matches);
                            dsMatches = matches.map(function(match, index) {
                                if (maxIdx != null && index > maxIdx) return $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                                return $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
                            });
                        }
                        if (!dataStrategy && !dsMatches.some(function(m) {
                            return m.shouldLoad;
                        })) return [
                            2,
                            {
                                matches: matches,
                                loaderData: {},
                                errors: pendingActionResult && $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].error) : null,
                                statusCode: 200,
                                loaderHeaders: {}
                            }
                        ];
                        return [
                            4,
                            callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy)
                        ];
                    case 1:
                        results = _state.sent();
                        if (request.signal.aborted) $d8c8e9691ac1f69a$var$throwStaticHandlerAbortedError(request, isRouteRequest);
                        return [
                            2,
                            (0, $9Jpjh._)((0, $lvTkn._)({}, $d8c8e9691ac1f69a$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling)), {
                                matches: matches
                            })
                        ];
                }
            });
        })();
    }
    function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var results, dataResults;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $d8c8e9691ac1f69a$var$callDataStrategyImpl(dataStrategy || $d8c8e9691ac1f69a$var$defaultDataStrategy, request, location, matches, null, requestContext, true)
                        ];
                    case 1:
                        results = _state.sent();
                        dataResults = {};
                        return [
                            4,
                            Promise.all(matches.map(function(match) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    var result, response, _;
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                if (!(match.route.id in results)) return [
                                                    2
                                                ];
                                                result = results[match.route.id];
                                                if ($d8c8e9691ac1f69a$var$isRedirectDataStrategyResult(result)) {
                                                    response = result.result;
                                                    throw $d8c8e9691ac1f69a$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
                                                }
                                                if (isRouteRequest) {
                                                    if ($d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result.result)) throw result;
                                                    else if ($d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(result.result)) throw $d8c8e9691ac1f69a$var$dataWithResponseInitToResponse(result.result);
                                                }
                                                _ = match.route.id;
                                                return [
                                                    4,
                                                    $d8c8e9691ac1f69a$var$convertDataStrategyResultToDataResult(result)
                                                ];
                                            case 1:
                                                dataResults[_] = _state.sent();
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            }))
                        ];
                    case 2:
                        _state.sent();
                        return [
                            2,
                            dataResults
                        ];
                }
            });
        })();
    }
    return {
        dataRoutes: dataRoutes,
        _internalRouteBranches: routeBranches,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $d8c8e9691ac1f69a$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    var errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, handlerContext), {
        statusCode: (0, $daRwM.isRouteErrorResponse)(error) ? error.status : 500,
        errors: (0, $khBmn._)({}, errorBoundaryId, error)
    });
}
function $d8c8e9691ac1f69a$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error("".concat(isRouteRequest ? "queryRoute" : "query", "() call aborted without an `AbortSignal.reason`: ").concat(request.method, " ").concat(request.url));
}
function $d8c8e9691ac1f69a$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $d8c8e9691ac1f69a$var$defaultNormalizePath(request) {
    var url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $d8c8e9691ac1f69a$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    var contextualMatches;
    var activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                contextualMatches.push(match);
                if (match.route.id === fromRouteId) {
                    activeRouteMatch = match;
                    break;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    var path = (0, $daRwM.resolveTo)(to ? to : ".", (0, $daRwM.getResolveToMatches)(contextualMatches), (0, $daRwM.stripBasename)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        var nakedIndex = $d8c8e9691ac1f69a$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            var params = new URLSearchParams(path.search);
            var indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $daRwM.prependBasename)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $iKEZU.createPath)(path);
}
function $d8c8e9691ac1f69a$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$d8c8e9691ac1f69a$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$d8c8e9691ac1f69a$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    var getInvalidBodyError = function() {
        return {
            path: path,
            error: $d8c8e9691ac1f69a$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        };
    };
    var formMethod = (opts.formMethod || "get").toUpperCase();
    var formAction = $d8c8e9691ac1f69a$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$d8c8e9691ac1f69a$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            var text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce(function(acc, param) {
                var _param = (0, $21h22._)(param, 2), name = _param[0], value = _param[1];
                return "".concat(acc).concat(name, "=").concat(value, "\n");
            }, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$d8c8e9691ac1f69a$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                var json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch (e) {
                return getInvalidBodyError();
            }
        }
    }
    (0, $iKEZU.invariant)(typeof FormData === "function", "FormData is not available in this environment");
    var searchParams;
    var formData;
    if (opts.formData) {
        searchParams = $d8c8e9691ac1f69a$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $d8c8e9691ac1f69a$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $d8c8e9691ac1f69a$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $d8c8e9691ac1f69a$var$convertSearchParamsToFormData(searchParams);
    } catch (e) {
        return getInvalidBodyError();
    }
    var submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($d8c8e9691ac1f69a$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    var parsedPath = (0, $iKEZU.parsePath)(path);
    if (isFetcher && parsedPath.search && $d8c8e9691ac1f69a$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = "?".concat(searchParams);
    return {
        path: (0, $iKEZU.createPath)(parsedPath),
        submission: submission
    };
}
function $d8c8e9691ac1f69a$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, routesToUse, basename, hasPatchRoutesOnNavigation, branches, pendingActionResult, callSiteDefaultShouldRevalidate) {
    var _state_matches_;
    var actionResult = pendingActionResult ? $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    var currentUrl = history.createURL(state.location);
    var nextUrl = history.createURL(location);
    var maxIdx;
    if (initialHydration && state.errors) {
        var boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId;
        });
    } else if (pendingActionResult && $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1])) {
        var boundaryId1 = pendingActionResult[0];
        maxIdx = matches.findIndex(function(m) {
            return m.route.id === boundaryId1;
        }) - 1;
    }
    var actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    var shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    var baseShouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({
        currentUrl: currentUrl,
        currentParams: ((_state_matches_ = state.matches[0]) === null || _state_matches_ === void 0 ? void 0 : _state_matches_.params) || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params
    }, submission), {
        actionResult: actionResult,
        actionStatus: actionStatus
    });
    var pattern = (0, $daRwM.getRoutePattern)(matches);
    var dsMatches = matches.map(function(match, index) {
        var route = match.route;
        var forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$d8c8e9691ac1f69a$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            var shouldLoad = $d8c8e9691ac1f69a$var$getRouteHydrationStatus(route, state.loaderData, state.errors).shouldLoad;
            forceShouldLoad = shouldLoad;
        } else if ($d8c8e9691ac1f69a$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        var defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($d8c8e9691ac1f69a$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        var shouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({}, baseShouldRevalidateArgs), {
            defaultShouldRevalidate: defaultShouldRevalidate
        });
        return $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $d8c8e9691ac1f69a$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    var revalidatingFetchers = [];
    fetchLoadMatches.forEach(function(f, key) {
        if (initialHydration || !matches.some(function(m) {
            return m.route.id === f.routeId;
        }) || fetchersQueuedForDeletion.has(key)) return;
        var fetcher = state.fetchers.get(key);
        var isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        var fetcherMatches = (0, $daRwM.matchRoutesImpl)(routesToUse, f.path, basename !== null && basename !== void 0 ? basename : "/", false, branches);
        if (!fetcherMatches) {
            if (hasPatchRoutesOnNavigation && isMidInitialLoad) return;
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        var fetcherMatch = $d8c8e9691ac1f69a$var$getTargetMatch(fetcherMatches, f.path);
        var fetchController = new AbortController();
        var fetchRequest = $d8c8e9691ac1f69a$var$createClientSideRequest(history, f.path, fetchController.signal);
        var fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            var defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            var shouldRevalidateArgs = (0, $9Jpjh._)((0, $lvTkn._)({}, baseShouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            if ($d8c8e9691ac1f69a$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $d8c8e9691ac1f69a$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $d8c8e9691ac1f69a$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$d8c8e9691ac1f69a$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    var hasData = loaderData != null && route.id in loaderData;
    var hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    var shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $d8c8e9691ac1f69a$var$isNewLoader(currentLoaderData, currentMatch, match) {
    var isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    var isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $d8c8e9691ac1f69a$var$isNewRouteInstance(currentMatch, match) {
    var currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $d8c8e9691ac1f69a$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        var routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $d8c8e9691ac1f69a$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    var childrenToPatch;
    if (routeId) {
        var route = manifest[routeId];
        (0, $iKEZU.invariant)(route, "No route found to patch children into: routeId = ".concat(routeId));
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    var uniqueChildren = [];
    var existingChildren = [];
    children.forEach(function(newRoute) {
        var existingRoute = childrenToPatch.find(function(existingRoute) {
            return $d8c8e9691ac1f69a$var$isSameRoute(newRoute, existingRoute);
        });
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        var _childrenToPatch;
        var newRoutes = (0, $daRwM.convertRoutesToDataRoutes)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String((childrenToPatch === null || childrenToPatch === void 0 ? void 0 : childrenToPatch.length) || "0")
        ], manifest);
        (_childrenToPatch = childrenToPatch).push.apply(_childrenToPatch, (0, $6zk1M._)(newRoutes));
    }
    if (allowElementMutations && existingChildren.length > 0) for(var i = 0; i < existingChildren.length; i++){
        var _existingChildren_i = existingChildren[i], existingRoute = _existingChildren_i.existingRoute, newRoute = _existingChildren_i.newRoute;
        var existingRouteTyped = existingRoute;
        var _convertRoutesToDataRoutes = (0, $21h22._)((0, $daRwM.convertRoutesToDataRoutes)([
            newRoute
        ], mapRouteProperties, [], {}, true), 1), newRouteTyped = _convertRoutesToDataRoutes[0];
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes((0, $6zk1M._)(dataRoutes.activeRoutes));
}
function $d8c8e9691ac1f69a$var$isSameRoute(newRoute, existingRoute) {
    var _newRoute_children;
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    var _newRoute_children_every;
    return (_newRoute_children_every = (_newRoute_children = newRoute.children) === null || _newRoute_children === void 0 ? void 0 : _newRoute_children.every(function(aChild, i) {
        var _existingRoute_children;
        return (_existingRoute_children = existingRoute.children) === null || _existingRoute_children === void 0 ? void 0 : _existingRoute_children.some(function(bChild) {
            return $d8c8e9691ac1f69a$var$isSameRoute(aChild, bChild);
        });
    })) !== null && _newRoute_children_every !== void 0 ? _newRoute_children_every : false;
}
var $d8c8e9691ac1f69a$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
var $d8c8e9691ac1f69a$var$loadLazyRouteProperty = function(param) {
    var key = param.key, route = param.route, manifest = param.manifest, mapRouteProperties = param.mapRouteProperties;
    var routeToUpdate = manifest[route.id];
    (0, $iKEZU.invariant)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || (0, $2bfPH._)(routeToUpdate.lazy) !== "object") return;
    var lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    var cache = $d8c8e9691ac1f69a$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $d8c8e9691ac1f69a$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    var cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    var propertyPromise = function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var isUnsupported, isStaticallyDefined, value;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        isUnsupported = (0, $daRwM.isUnsupportedLazyRouteObjectKey)(key);
                        isStaticallyDefined = routeToUpdate[key] !== void 0;
                        if (!isUnsupported) return [
                            3,
                            1
                        ];
                        (0, $iKEZU.warning)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
                        cache[key] = Promise.resolve();
                        return [
                            3,
                            4
                        ];
                    case 1:
                        if (!isStaticallyDefined) return [
                            3,
                            2
                        ];
                        (0, $iKEZU.warning)(false, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(key, '" defined. The lazy property will be ignored.'));
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            lazyFn()
                        ];
                    case 3:
                        value = _state.sent();
                        if (value != null) {
                            Object.assign(routeToUpdate, (0, $khBmn._)({}, key, value));
                            Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
                        }
                        _state.label = 4;
                    case 4:
                        if ((0, $2bfPH._)(routeToUpdate.lazy) === "object") {
                            routeToUpdate.lazy[key] = void 0;
                            if (Object.values(routeToUpdate.lazy).every(function(value) {
                                return value === void 0;
                            })) routeToUpdate.lazy = void 0;
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    }();
    cache[key] = propertyPromise;
    return propertyPromise;
};
var $d8c8e9691ac1f69a$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $d8c8e9691ac1f69a$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    var routeToUpdate = manifest[route.id];
    (0, $iKEZU.invariant)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        var cachedPromise = $d8c8e9691ac1f69a$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        var lazyRoutePromise = function() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var lazyRoute, routeUpdates, lazyRouteProperty, lazyValue, isUnsupported, isStaticallyDefined;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            (0, $iKEZU.invariant)(typeof route.lazy === "function", "No lazy route function found");
                            return [
                                4,
                                route.lazy()
                            ];
                        case 1:
                            lazyRoute = _state.sent();
                            routeUpdates = {};
                            for(var lazyRouteProperty in lazyRoute){
                                lazyValue = lazyRoute[lazyRouteProperty];
                                if (lazyValue === void 0) continue;
                                isUnsupported = (0, $daRwM.isUnsupportedLazyRouteFunctionKey)(lazyRouteProperty);
                                isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                                if (isUnsupported) (0, $iKEZU.warning)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                                else if (isStaticallyDefined) (0, $iKEZU.warning)(!isStaticallyDefined, 'Route "'.concat(routeToUpdate.id, '" has a static property "').concat(lazyRouteProperty, '" defined but its lazy function is also returning a value for this property. The lazy route property "').concat(lazyRouteProperty, '" will be ignored.'));
                                else routeUpdates[lazyRouteProperty] = lazyValue;
                            }
                            Object.assign(routeToUpdate, routeUpdates);
                            Object.assign(routeToUpdate, (0, $9Jpjh._)((0, $lvTkn._)({}, mapRouteProperties(routeToUpdate)), {
                                lazy: void 0
                            }));
                            return [
                                2
                            ];
                    }
                });
            })();
        }();
        $d8c8e9691ac1f69a$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(function() {});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    var lazyKeys = Object.keys(route.lazy);
    var lazyPropertyPromises = [];
    var lazyHandlerPromise = void 0;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = lazyKeys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
            var promise = $d8c8e9691ac1f69a$var$loadLazyRouteProperty({
                key: key,
                route: route,
                manifest: manifest,
                mapRouteProperties: mapRouteProperties
            });
            if (promise) {
                lazyPropertyPromises.push(promise);
                if (key === type) lazyHandlerPromise = promise;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var lazyRoutePromise1 = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(function() {}) : void 0;
    lazyRoutePromise1 === null || lazyRoutePromise1 === void 0 ? void 0 : lazyRoutePromise1.catch(function() {});
    lazyHandlerPromise === null || lazyHandlerPromise === void 0 ? void 0 : lazyHandlerPromise.catch(function() {});
    return {
        lazyRoutePromise: lazyRoutePromise1,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $d8c8e9691ac1f69a$var$isNonNullable(value) {
    return value !== void 0;
}
function $d8c8e9691ac1f69a$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    var promises = matches.map(function(param) {
        var route = param.route;
        if ((0, $2bfPH._)(route.lazy) !== "object" || !route.lazy.middleware) return;
        return $d8c8e9691ac1f69a$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($d8c8e9691ac1f69a$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
function $d8c8e9691ac1f69a$var$defaultDataStrategy(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var matchesToLoad, keyedResults;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldLoad;
                    });
                    keyedResults = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve();
                        }))
                    ];
                case 1:
                    _state.sent().forEach(function(result, i) {
                        keyedResults[matchesToLoad[i].route.id] = result;
                    });
                    return [
                        2,
                        keyedResults
                    ];
            }
        });
    })();
}
function $d8c8e9691ac1f69a$var$defaultDataStrategyWithMiddleware(args) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            if (!args.matches.some(function(m) {
                return m.route.middleware;
            })) return [
                2,
                $d8c8e9691ac1f69a$var$defaultDataStrategy(args)
            ];
            return [
                2,
                $d8c8e9691ac1f69a$var$runClientMiddlewarePipeline(args, function() {
                    return $d8c8e9691ac1f69a$var$defaultDataStrategy(args);
                })
            ];
        });
    })();
}
function $d8c8e9691ac1f69a$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $d8c8e9691ac1f69a$var$runMiddlewarePipeline(args, handler, processResult, $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(result) ? $d8c8e9691ac1f69a$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $d8c8e9691ac1f69a$var$runClientMiddlewarePipeline(args, handler) {
    return $d8c8e9691ac1f69a$var$runMiddlewarePipeline(args, handler, function(r) {
        if ($d8c8e9691ac1f69a$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $d8c8e9691ac1f69a$var$isDataStrategyResults, errorHandler);
    function errorHandler(error, routeId, nextResult) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var matches, maxBoundaryIdx, deepestRouteId, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, _match__lazyPromises, e, err;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!nextResult) return [
                            3,
                            1
                        ];
                        return [
                            2,
                            Object.assign(nextResult.value, (0, $khBmn._)({}, routeId, {
                                type: "error",
                                result: error
                            }))
                        ];
                    case 1:
                        matches = args.matches;
                        maxBoundaryIdx = Math.min(Math.max(matches.findIndex(function(m) {
                            return m.route.id === routeId;
                        }), 0), Math.max(matches.findIndex(function(m) {
                            return m.shouldCallHandler();
                        }), 0));
                        deepestRouteId = matches[maxBoundaryIdx].route.id;
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        _state.label = 2;
                    case 2:
                        _state.trys.push([
                            2,
                            9,
                            10,
                            11
                        ]);
                        _iterator = matches.slice(0, maxBoundaryIdx + 1)[Symbol.iterator]();
                        _state.label = 3;
                    case 3:
                        if (!!(_iteratorNormalCompletion = (_step = _iterator.next()).done)) return [
                            3,
                            8
                        ];
                        match = _step.value;
                        _state.label = 4;
                    case 4:
                        _state.trys.push([
                            4,
                            6,
                            ,
                            7
                        ]);
                        return [
                            4,
                            (_match__lazyPromises = match._lazyPromises) === null || _match__lazyPromises === void 0 ? void 0 : _match__lazyPromises.route
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        e = _state.sent();
                        deepestRouteId = match.route.id;
                        return [
                            3,
                            8
                        ];
                    case 7:
                        _iteratorNormalCompletion = true;
                        return [
                            3,
                            3
                        ];
                    case 8:
                        return [
                            3,
                            11
                        ];
                    case 9:
                        err = _state.sent();
                        _didIteratorError = true;
                        _iteratorError = err;
                        return [
                            3,
                            11
                        ];
                    case 10:
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                        return [
                            7
                        ];
                    case 11:
                        return [
                            2,
                            (0, $khBmn._)({}, $d8c8e9691ac1f69a$var$findNearestBoundary(matches, deepestRouteId).route.id, {
                                type: "error",
                                result: error
                            })
                        ];
                    case 12:
                        return [
                            2
                        ];
                }
            });
        })();
    }
}
function $d8c8e9691ac1f69a$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var matches, dataFnArgs;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matches = args.matches, dataFnArgs = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(args, [
                        "matches"
                    ]);
                    return [
                        4,
                        $d8c8e9691ac1f69a$var$callRouteMiddleware(dataFnArgs, matches.flatMap(function(m) {
                            return m.route.middleware ? m.route.middleware.map(function(fn) {
                                return [
                                    m.route.id,
                                    fn
                                ];
                            }) : [];
                        }), handler, processResult, isResult, errorHandler)
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    })();
}
function $d8c8e9691ac1f69a$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler) {
    var idx = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : 0;
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var request, _request_signal_reason, tuple, _tuple, routeId, middleware, nextResult, next, value, result, _tmp, error;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    if (request.signal.aborted) throw (_request_signal_reason = request.signal.reason) !== null && _request_signal_reason !== void 0 ? _request_signal_reason : /* @__PURE__ */ new Error("Request aborted: ".concat(request.method, " ").concat(request.url));
                    tuple = middlewares[idx];
                    if (!!tuple) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        handler()
                    ];
                case 1:
                    return [
                        2,
                        _state.sent()
                    ];
                case 2:
                    _tuple = (0, $21h22._)(tuple, 2), routeId = _tuple[0], middleware = _tuple[1];
                    next = function() {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                            var _tmp, error, _tmp1;
                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        if (nextResult) throw new Error("You may only call `next()` once per middleware");
                                        _state.label = 1;
                                    case 1:
                                        _state.trys.push([
                                            1,
                                            3,
                                            ,
                                            5
                                        ]);
                                        _tmp = {};
                                        return [
                                            4,
                                            $d8c8e9691ac1f69a$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
                                        ];
                                    case 2:
                                        nextResult = (_tmp.value = _state.sent(), _tmp);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 3:
                                        error = _state.sent();
                                        _tmp1 = {};
                                        return [
                                            4,
                                            errorHandler(error, routeId, nextResult)
                                        ];
                                    case 4:
                                        nextResult = (_tmp1.value = _state.sent(), _tmp1);
                                        return [
                                            2,
                                            nextResult.value
                                        ];
                                    case 5:
                                        return [
                                            2
                                        ];
                                }
                            });
                        })();
                    };
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        9,
                        ,
                        11
                    ]);
                    return [
                        4,
                        middleware(args, next)
                    ];
                case 4:
                    value = _state.sent();
                    result = value != null ? processResult(value) : void 0;
                    if (!isResult(result)) return [
                        3,
                        5
                    ];
                    return [
                        2,
                        result
                    ];
                case 5:
                    if (!nextResult) return [
                        3,
                        6
                    ];
                    return [
                        2,
                        result !== null && result !== void 0 ? result : nextResult.value
                    ];
                case 6:
                    _tmp = {};
                    return [
                        4,
                        next()
                    ];
                case 7:
                    nextResult = (_tmp.value = _state.sent(), _tmp);
                    return [
                        2,
                        nextResult.value
                    ];
                case 8:
                    return [
                        3,
                        11
                    ];
                case 9:
                    error = _state.sent();
                    return [
                        4,
                        errorHandler(error, routeId, nextResult)
                    ];
                case 10:
                    return [
                        2,
                        _state.sent()
                    ];
                case 11:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $d8c8e9691ac1f69a$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    var lazyMiddlewarePromise = $d8c8e9691ac1f69a$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    var lazyRoutePromises = $d8c8e9691ac1f69a$var$loadLazyRoute(match.route, $d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad) {
    var shouldRevalidateArgs = arguments.length > 9 && arguments[9] !== void 0 ? arguments[9] : null, callSiteDefaultShouldRevalidate = arguments.length > 10 ? arguments[10] : void 0;
    var isUsingNewApi = false;
    var _lazyPromises = $d8c8e9691ac1f69a$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return (0, $9Jpjh._)((0, $lvTkn._)({}, match), {
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler: function(defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $d8c8e9691ac1f69a$var$shouldRevalidateLoader(match, (0, $9Jpjh._)((0, $lvTkn._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            }));
            if (typeof defaultShouldRevalidate === "boolean") return $d8c8e9691ac1f69a$var$shouldRevalidateLoader(match, (0, $9Jpjh._)((0, $lvTkn._)({}, shouldRevalidateArgs), {
                defaultShouldRevalidate: defaultShouldRevalidate
            }));
            return $d8c8e9691ac1f69a$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve: function(handlerOverride) {
            var _match_route = match.route, lazy = _match_route.lazy, loader = _match_route.loader, middleware = _match_route.middleware;
            var callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            var isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $d8c8e9691ac1f69a$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.handler,
                lazyRoutePromise: _lazyPromises === null || _lazyPromises === void 0 ? void 0 : _lazyPromises.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    });
}
function $d8c8e9691ac1f69a$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext) {
    var shouldRevalidateArgs = arguments.length > 8 && arguments[8] !== void 0 ? arguments[8] : null;
    return matches.map(function(match) {
        if (match.route.id !== targetMatch.route.id) return (0, $9Jpjh._)((0, $lvTkn._)({}, match), {
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: function() {
                return false;
            },
            _lazyPromises: $d8c8e9691ac1f69a$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: function() {
                return Promise.resolve({
                    type: "data",
                    result: void 0
                });
            }
        });
        return $d8c8e9691ac1f69a$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $daRwM.getRoutePattern)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
function $d8c8e9691ac1f69a$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var dataStrategyArgs, runClientMiddleware, results, e;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!matches.some(function(m) {
                        var _m__lazyPromises;
                        return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                    })) return [
                        3,
                        2
                    ];
                    return [
                        4,
                        Promise.all(matches.map(function(m) {
                            var _m__lazyPromises;
                            return (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.middleware;
                        }))
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    dataStrategyArgs = {
                        request: request,
                        url: (0, $daRwM.createDataFunctionUrl)(request, path),
                        pattern: (0, $daRwM.getRoutePattern)(matches),
                        params: matches[0].params,
                        context: scopedContext,
                        matches: matches
                    };
                    runClientMiddleware = isStaticHandler ? function() {
                        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
                    } : function(cb) {
                        var typedDataStrategyArgs = dataStrategyArgs;
                        return $d8c8e9691ac1f69a$var$runClientMiddlewarePipeline(typedDataStrategyArgs, function() {
                            return cb((0, $9Jpjh._)((0, $lvTkn._)({}, typedDataStrategyArgs), {
                                fetcherKey: fetcherKey,
                                runClientMiddleware: function() {
                                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                                }
                            }));
                        });
                    };
                    return [
                        4,
                        dataStrategyImpl((0, $9Jpjh._)((0, $lvTkn._)({}, dataStrategyArgs), {
                            fetcherKey: fetcherKey,
                            runClientMiddleware: runClientMiddleware
                        }))
                    ];
                case 3:
                    results = _state.sent();
                    _state.label = 4;
                case 4:
                    _state.trys.push([
                        4,
                        6,
                        ,
                        7
                    ]);
                    return [
                        4,
                        Promise.all(matches.flatMap(function(m) {
                            var _m__lazyPromises, _m__lazyPromises1;
                            return [
                                (_m__lazyPromises = m._lazyPromises) === null || _m__lazyPromises === void 0 ? void 0 : _m__lazyPromises.handler,
                                (_m__lazyPromises1 = m._lazyPromises) === null || _m__lazyPromises1 === void 0 ? void 0 : _m__lazyPromises1.route
                            ];
                        }))
                    ];
                case 5:
                    _state.sent();
                    return [
                        3,
                        7
                    ];
                case 6:
                    e = _state.sent();
                    return [
                        3,
                        7
                    ];
                case 7:
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function $d8c8e9691ac1f69a$var$callLoaderOrAction(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(param) {
        var request, path, pattern, match, lazyHandlerPromise, lazyRoutePromise, handlerOverride, scopedContext, result, onReject, isAction, type, runHandler, handler, handlerError, _ref, value, handler1, ref, url, pathname, url1, e;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = param.request, path = param.path, pattern = param.pattern, match = param.match, lazyHandlerPromise = param.lazyHandlerPromise, lazyRoutePromise = param.lazyRoutePromise, handlerOverride = param.handlerOverride, scopedContext = param.scopedContext;
                    isAction = $d8c8e9691ac1f69a$export$cbae47800eb95bc3(request.method);
                    type = isAction ? "action" : "loader";
                    runHandler = function(handler) {
                        var reject;
                        var abortPromise = new Promise(function(_, r) {
                            return reject = r;
                        });
                        onReject = function() {
                            return reject();
                        };
                        request.signal.addEventListener("abort", onReject);
                        var actualHandler = function(ctx) {
                            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error('You cannot call the handler for a route which defines a boolean "'.concat(type, '" [routeId: ').concat(match.route.id, "]")));
                            return handler.apply(void 0, [
                                {
                                    request: request,
                                    url: (0, $daRwM.createDataFunctionUrl)(request, path),
                                    pattern: pattern,
                                    params: match.params,
                                    context: scopedContext
                                }
                            ].concat((0, $6zk1M._)(ctx !== void 0 ? [
                                ctx
                            ] : [])));
                        };
                        var handlerPromise = function() {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                var _tmp, e;
                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            _state.trys.push([
                                                0,
                                                2,
                                                ,
                                                3
                                            ]);
                                            _tmp = {
                                                type: "data"
                                            };
                                            return [
                                                4,
                                                handlerOverride ? handlerOverride(function(ctx) {
                                                    return actualHandler(ctx);
                                                }) : actualHandler()
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                (_tmp.result = _state.sent(), _tmp)
                                            ];
                                        case 2:
                                            e = _state.sent();
                                            return [
                                                2,
                                                {
                                                    type: "error",
                                                    result: e
                                                }
                                            ];
                                        case 3:
                                            return [
                                                2
                                            ];
                                    }
                                });
                            })();
                        }();
                        return Promise.race([
                            handlerPromise,
                            abortPromise
                        ]);
                    };
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        12,
                        13,
                        14
                    ]);
                    handler = isAction ? match.route.action : match.route.loader;
                    if (!(lazyHandlerPromise || lazyRoutePromise)) return [
                        3,
                        8
                    ];
                    if (!handler) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler).catch(function(e) {
                                handlerError = e;
                            }),
                            lazyHandlerPromise,
                            lazyRoutePromise
                        ])
                    ];
                case 2:
                    _ref = (0, $21h22._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), value = _ref[0];
                    if (handlerError !== void 0) throw handlerError;
                    result = value;
                    return [
                        3,
                        7
                    ];
                case 3:
                    return [
                        4,
                        lazyHandlerPromise
                    ];
                case 4:
                    _state.sent();
                    handler1 = isAction ? match.route.action : match.route.loader;
                    if (!handler1) return [
                        3,
                        6
                    ];
                    return [
                        4,
                        Promise.all([
                            runHandler(handler1),
                            lazyRoutePromise
                        ])
                    ];
                case 5:
                    ref = (0, $21h22._).apply(void 0, [
                        _state.sent(),
                        1
                    ]), result = ref[0], ref;
                    return [
                        3,
                        7
                    ];
                case 6:
                    if (type === "action") {
                        url = new URL(request.url);
                        pathname = url.pathname + url.search;
                        throw $d8c8e9691ac1f69a$var$getInternalRouterError(405, {
                            method: request.method,
                            pathname: pathname,
                            routeId: match.route.id
                        });
                    } else return [
                        2,
                        {
                            type: "data",
                            result: void 0
                        }
                    ];
                    _state.label = 7;
                case 7:
                    return [
                        3,
                        11
                    ];
                case 8:
                    if (!!handler) return [
                        3,
                        9
                    ];
                    url1 = new URL(request.url);
                    throw $d8c8e9691ac1f69a$var$getInternalRouterError(404, {
                        pathname: url1.pathname + url1.search
                    });
                case 9:
                    return [
                        4,
                        runHandler(handler)
                    ];
                case 10:
                    result = _state.sent();
                    _state.label = 11;
                case 11:
                    return [
                        3,
                        14
                    ];
                case 12:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error",
                            result: e
                        }
                    ];
                case 13:
                    if (onReject) request.signal.removeEventListener("abort", onReject);
                    return [
                        7
                    ];
                case 14:
                    return [
                        2,
                        result
                    ];
            }
        });
    }).apply(this, arguments);
}
function $d8c8e9691ac1f69a$var$parseResponseBody(response) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var contentType;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            contentType = response.headers.get("Content-Type");
            if (contentType && /\bapplication\/json\b/.test(contentType)) return [
                2,
                response.body == null ? null : response.json()
            ];
            return [
                2,
                response.text()
            ];
        });
    })();
}
function $d8c8e9691ac1f69a$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _result_init, _result_init1, result, type, data, e, _result_init2, _result_init3, _result_init4;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    result = dataStrategyResult.result, type = dataStrategyResult.type;
                    if (!$d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result)) return [
                        3,
                        5
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        $d8c8e9691ac1f69a$var$parseResponseBody(result)
                    ];
                case 2:
                    data = _state.sent();
                    return [
                        3,
                        4
                    ];
                case 3:
                    e = _state.sent();
                    return [
                        2,
                        {
                            type: "error",
                            error: e
                        }
                    ];
                case 4:
                    if (type === "error") return [
                        2,
                        {
                            type: "error",
                            error: new (0, $daRwM.ErrorResponseImpl)(result.status, result.statusText, data),
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data",
                            data: data,
                            statusCode: result.status,
                            headers: result.headers
                        }
                    ];
                case 5:
                    if (type === "error") {
                        if ($d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(result)) {
                            ;
                            if (result.data instanceof Error) return [
                                2,
                                {
                                    type: "error",
                                    error: result.data,
                                    statusCode: (_result_init2 = result.init) === null || _result_init2 === void 0 ? void 0 : _result_init2.status,
                                    headers: ((_result_init3 = result.init) === null || _result_init3 === void 0 ? void 0 : _result_init3.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                            return [
                                2,
                                {
                                    type: "error",
                                    error: $d8c8e9691ac1f69a$var$dataWithResponseInitToErrorResponse(result),
                                    statusCode: (0, $daRwM.isRouteErrorResponse)(result) ? result.status : void 0,
                                    headers: ((_result_init4 = result.init) === null || _result_init4 === void 0 ? void 0 : _result_init4.headers) ? new Headers(result.init.headers) : void 0
                                }
                            ];
                        }
                        return [
                            2,
                            {
                                type: "error",
                                error: result,
                                statusCode: (0, $daRwM.isRouteErrorResponse)(result) ? result.status : void 0
                            }
                        ];
                    }
                    if ($d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(result)) return [
                        2,
                        {
                            type: "data",
                            data: result.data,
                            statusCode: (_result_init = result.init) === null || _result_init === void 0 ? void 0 : _result_init.status,
                            headers: ((_result_init1 = result.init) === null || _result_init1 === void 0 ? void 0 : _result_init1.headers) ? new Headers(result.init.headers) : void 0
                        }
                    ];
                    return [
                        2,
                        {
                            type: "data",
                            data: result
                        }
                    ];
            }
        });
    })();
}
function $d8c8e9691ac1f69a$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    var location = response.headers.get("Location");
    (0, $iKEZU.invariant)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $daRwM.isAbsoluteUrl)(location)) {
        var trimmedMatches = matches.slice(0, matches.findIndex(function(m) {
            return m.route.id === routeId;
        }) + 1);
        location = $d8c8e9691ac1f69a$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
var $d8c8e9691ac1f69a$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $d8c8e9691ac1f69a$export$961a3ef7a4da3a39(location) {
    try {
        return $d8c8e9691ac1f69a$var$invalidProtocols.includes(new URL(location).protocol);
    } catch (e) {
        return false;
    }
}
function $d8c8e9691ac1f69a$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $daRwM.isAbsoluteUrl)(location)) {
        var normalizedLocation = location;
        var url = (0, $8onil.PROTOCOL_RELATIVE_URL_REGEX).test(normalizedLocation) ? new URL((0, $8onil.normalizeProtocolRelativeUrl)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($d8c8e9691ac1f69a$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        var isSameBasename = (0, $daRwM.stripBasename)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $daRwM.removeDoubleSlashes)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($d8c8e9691ac1f69a$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch (e) {}
    return location;
}
function $d8c8e9691ac1f69a$var$createClientSideRequest(history, location, signal, submission) {
    var url = history.createURL($d8c8e9691ac1f69a$var$stripHashFromPath(location)).toString();
    var init = {
        signal: signal
    };
    if (submission && $d8c8e9691ac1f69a$export$cbae47800eb95bc3(submission.formMethod)) {
        var formMethod = submission.formMethod, formEncType = submission.formEncType;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $d8c8e9691ac1f69a$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $d8c8e9691ac1f69a$var$convertFormDataToSearchParams(formData) {
    var searchParams = new URLSearchParams();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = formData.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            searchParams.append(key, typeof value === "string" ? value : value.name);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return searchParams;
}
function $d8c8e9691ac1f69a$var$convertSearchParamsToFormData(searchParams) {
    var formData = new FormData();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = searchParams.entries()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], value = _step_value[1];
            formData.append(key, value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return formData;
}
function $d8c8e9691ac1f69a$var$processRouteLoaderData(matches, results, pendingActionResult) {
    var isStaticHandler = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false, skipLoaderErrorBubbling = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : false;
    var loaderData = {};
    var errors = null;
    var statusCode;
    var foundError = false;
    var loaderHeaders = {};
    var pendingError = pendingActionResult && $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach(function(match) {
        if (!(match.route.id in results)) return;
        var id = match.route.id;
        var result = results[id];
        (0, $iKEZU.invariant)(!$d8c8e9691ac1f69a$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($d8c8e9691ac1f69a$var$isErrorResult(result)) {
            var error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                var boundaryMatch = $d8c8e9691ac1f69a$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $d8c8e9691ac1f69a$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $daRwM.isRouteErrorResponse)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = (0, $khBmn._)({}, pendingActionResult[0], pendingError);
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $d8c8e9691ac1f69a$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    var _processRouteLoaderData = $d8c8e9691ac1f69a$var$processRouteLoaderData(matches, results, pendingActionResult), loaderData = _processRouteLoaderData.loaderData, errors = _processRouteLoaderData.errors;
    revalidatingFetchers.filter(function(f) {
        return !f.matches || f.matches.some(function(m) {
            return m.shouldLoad;
        });
    }).forEach(function(rf) {
        var key = rf.key, match = rf.match, controller = rf.controller;
        if (controller && controller.signal.aborted) return;
        var result = fetcherResults[key];
        (0, $iKEZU.invariant)(result, "Did not find corresponding fetcher result");
        if ($d8c8e9691ac1f69a$var$isErrorResult(result)) {
            var boundaryMatch = $d8c8e9691ac1f69a$var$findNearestBoundary(state.matches, match === null || match === void 0 ? void 0 : match.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = (0, $9Jpjh._)((0, $lvTkn._)({}, errors), (0, $khBmn._)({}, boundaryMatch.route.id, result.error));
            workingFetchers.delete(key);
        } else if ($d8c8e9691ac1f69a$var$isRedirectResult(result)) (0, $iKEZU.invariant)(false, "Unhandled fetcher revalidation redirect");
        else {
            var doneFetcher = $d8c8e9691ac1f69a$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $d8c8e9691ac1f69a$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    var mergedLoaderData = Object.entries(newLoaderData).filter(function(param) {
        var _param = (0, $21h22._)(param, 2), v = _param[1];
        return v !== $d8c8e9691ac1f69a$var$ResetLoaderDataSymbol;
    }).reduce(function(merged, param) {
        var _param = (0, $21h22._)(param, 2), k = _param[0], v = _param[1];
        merged[k] = v;
        return merged;
    }, {});
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = matches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var match = _step.value;
            var id = match.route.id;
            if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) mergedLoaderData[id] = loaderData[id];
            if (errors && errors.hasOwnProperty(id)) break;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return mergedLoaderData;
}
function $d8c8e9691ac1f69a$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $d8c8e9691ac1f69a$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: (0, $khBmn._)({}, pendingActionResult[0], pendingActionResult[1].data)
    };
}
function $d8c8e9691ac1f69a$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex(function(m) {
        return m.route.id === routeId;
    }) + 1) : (0, $6zk1M._)(matches)).reverse().find(function(m) {
        return m.route.ErrorBoundary != null || m.route.errorElement != null;
    }) || matches[0];
}
function $d8c8e9691ac1f69a$var$getShortCircuitMatches(routes) {
    var route = routes.length === 1 ? routes[0] : routes.find(function(r) {
        return r.index || !r.path || r.path === "/";
    }) || {
        id: "__shim-error-route__"
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $d8c8e9691ac1f69a$var$getInternalRouterError(status) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, pathname = _ref.pathname, routeId = _ref.routeId, method = _ref.method, type = _ref.type, message = _ref.message;
    var statusText = "Unknown Server Error";
    var errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method, ' request to "').concat(pathname, '" but did not provide a `loader` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = 'Route "'.concat(routeId, '" does not match URL "').concat(pathname, '"');
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = 'No route matches URL "'.concat(pathname, '"');
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = "You made a ".concat(method.toUpperCase(), ' request to "').concat(pathname, '" but did not provide an `action` for route "').concat(routeId, '", so there is no way to handle the request.');
        else if (method) errorMessage = 'Invalid request method "'.concat(method.toUpperCase(), '"');
    }
    return new (0, $daRwM.ErrorResponseImpl)(status || 500, statusText, new Error(errorMessage), true);
}
function $d8c8e9691ac1f69a$var$findRedirect(results) {
    var entries = Object.entries(results);
    for(var i = entries.length - 1; i >= 0; i--){
        var _entries_i = (0, $21h22._)(entries[i], 2), key = _entries_i[0], result = _entries_i[1];
        if ($d8c8e9691ac1f69a$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $d8c8e9691ac1f69a$var$stripHashFromPath(path) {
    return (0, $iKEZU.createPath)((0, $9Jpjh._)((0, $lvTkn._)({}, typeof path === "string" ? (0, $iKEZU.parsePath)(path) : path), {
        hash: ""
    }));
}
function $d8c8e9691ac1f69a$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $d8c8e9691ac1f69a$var$dataWithResponseInitToResponse(data) {
    var _data_init;
    return Response.json(data.data, (_data_init = data.init) !== null && _data_init !== void 0 ? _data_init : void 0);
}
function $d8c8e9691ac1f69a$var$dataWithResponseInitToErrorResponse(data) {
    var _data_init, _data_init1;
    var _data_init_status, _data_init_statusText;
    return new (0, $daRwM.ErrorResponseImpl)((_data_init_status = (_data_init = data.init) === null || _data_init === void 0 ? void 0 : _data_init.status) !== null && _data_init_status !== void 0 ? _data_init_status : 500, (_data_init_statusText = (_data_init1 = data.init) === null || _data_init1 === void 0 ? void 0 : _data_init1.statusText) !== null && _data_init_statusText !== void 0 ? _data_init_statusText : "Internal Server Error", data.data);
}
function $d8c8e9691ac1f69a$var$isDataStrategyResults(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) === "object" && Object.entries(result).every(function(param) {
        var _param = (0, $21h22._)(param, 2), key = _param[0], value = _param[1];
        return typeof key === "string" && $d8c8e9691ac1f69a$var$isDataStrategyResult(value);
    });
}
function $d8c8e9691ac1f69a$var$isDataStrategyResult(result) {
    return result != null && (typeof result === "undefined" ? "undefined" : (0, $2bfPH._)(result)) === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $d8c8e9691ac1f69a$var$isRedirectDataStrategyResult(result) {
    return $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result.result) && $d8c8e9691ac1f69a$var$redirectStatusCodes.has(result.result.status);
}
function $d8c8e9691ac1f69a$var$isErrorResult(result) {
    return result.type === "error";
}
function $d8c8e9691ac1f69a$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && (0, $2bfPH._)(value.headers) === "object" && typeof value.body !== "undefined";
}
function $d8c8e9691ac1f69a$export$794b2760043cf8cd(statusCode) {
    return $d8c8e9691ac1f69a$var$redirectStatusCodes.has(statusCode);
}
function $d8c8e9691ac1f69a$export$6e80290866a84dd4(result) {
    return $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27(result) && $d8c8e9691ac1f69a$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $d8c8e9691ac1f69a$var$isValidMethod(method) {
    return $d8c8e9691ac1f69a$var$validRequestMethods.has(method.toUpperCase());
}
function $d8c8e9691ac1f69a$export$cbae47800eb95bc3(method) {
    return $d8c8e9691ac1f69a$var$validMutationMethods.has(method.toUpperCase());
}
function $d8c8e9691ac1f69a$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some(function(v) {
        return v === "";
    });
}
function $d8c8e9691ac1f69a$var$getTargetMatch(matches, location) {
    var search = typeof location === "string" ? (0, $iKEZU.parsePath)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $d8c8e9691ac1f69a$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    var pathMatches = (0, $daRwM.getPathContributingMatches)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $d8c8e9691ac1f69a$var$getInstrumentationNavigateMeta(history, location, matches) {
    var _matches_;
    return {
        url: (0, $daRwM.createDataFunctionUrl)(history.createURL(location), location),
        pattern: matches ? (0, $daRwM.getRoutePattern)(matches) : "",
        params: (matches === null || matches === void 0 ? void 0 : (_matches_ = matches[0]) === null || _matches_ === void 0 ? void 0 : _matches_.params) ? (0, $lvTkn._)({}, matches[0].params) : {}
    };
}
function $d8c8e9691ac1f69a$var$getSubmissionFromNavigation(navigation) {
    var formMethod = navigation.formMethod, formAction = navigation.formAction, formEncType = navigation.formEncType, text = navigation.text, formData = navigation.formData, json = navigation.json;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $d8c8e9691ac1f69a$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $d8c8e9691ac1f69a$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $d8c8e9691ac1f69a$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $d8c8e9691ac1f69a$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $d8c8e9691ac1f69a$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $d8c8e9691ac1f69a$var$restoreAppliedTransitions(_window, transitions) {
    try {
        var sessionPositions = _window.sessionStorage.getItem($d8c8e9691ac1f69a$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            var json = JSON.parse(sessionPositions);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.entries(json || {})[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var _step_value = (0, $21h22._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                    if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        }
    } catch (e) {}
}
function $d8c8e9691ac1f69a$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        var json = {};
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = transitions[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 2), k = _step_value[0], v = _step_value[1];
                json[k] = (0, $6zk1M._)(v);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        try {
            _window.sessionStorage.setItem($d8c8e9691ac1f69a$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $iKEZU.warning)(false, "Failed to save applied view transitions in sessionStorage (".concat(error, ")."));
        }
    }
}
function $d8c8e9691ac1f69a$var$createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var e;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var e;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/context.ts
var $333deedcba464643$export$2eeee58951ff3c1c = $eHaBZ.createContext(null);
$333deedcba464643$export$2eeee58951ff3c1c.displayName = "DataRouter";
var $333deedcba464643$export$315e3ffb01f217 = $eHaBZ.createContext(null);
$333deedcba464643$export$315e3ffb01f217.displayName = "DataRouterState";
var $333deedcba464643$export$717f757c655223f1 = $eHaBZ.createContext(false);
function $333deedcba464643$export$6e1eeb090b3ec35b() {
    return $eHaBZ.useContext($333deedcba464643$export$717f757c655223f1);
}
var $333deedcba464643$export$3681f408decb40d1 = $eHaBZ.createContext({
    isTransitioning: false
});
$333deedcba464643$export$3681f408decb40d1.displayName = "ViewTransition";
var $333deedcba464643$export$cb3f1df1bef00a39 = $eHaBZ.createContext(/* @__PURE__ */ new Map());
$333deedcba464643$export$cb3f1df1bef00a39.displayName = "Fetchers";
var $333deedcba464643$export$804c460aade54ac8 = $eHaBZ.createContext(null);
$333deedcba464643$export$804c460aade54ac8.displayName = "Await";
var $333deedcba464643$export$2666c20e15407622 = function(props) {
    return $eHaBZ.createElement($333deedcba464643$export$804c460aade54ac8.Provider, props);
};
var $333deedcba464643$export$3044ab7fdabeaee6 = $eHaBZ.createContext(null);
$333deedcba464643$export$3044ab7fdabeaee6.displayName = "Navigation";
var $333deedcba464643$export$e6a44b110a0c44d3 = $eHaBZ.createContext(null);
$333deedcba464643$export$e6a44b110a0c44d3.displayName = "Location";
var $333deedcba464643$export$aac280ed165a4397 = $eHaBZ.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$333deedcba464643$export$aac280ed165a4397.displayName = "Route";
var $333deedcba464643$export$af8bd2647fea9c11 = $eHaBZ.createContext(null);
$333deedcba464643$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $2bfPH = parcelRequire("2bfPH");

var $daRwM = parcelRequire("daRwM");
//#region lib/errors.ts
var $28653a8371cf992b$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
var $28653a8371cf992b$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
var $28653a8371cf992b$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $28653a8371cf992b$export$30db792b333fd2ee(digest) {
    if (digest.startsWith("".concat($28653a8371cf992b$var$ERROR_DIGEST_BASE, ":").concat($28653a8371cf992b$var$ERROR_DIGEST_REDIRECT, ":{"))) try {
        var parsed = JSON.parse(digest.slice(28));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $2bfPH._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch (e) {}
}
function $28653a8371cf992b$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith("".concat($28653a8371cf992b$var$ERROR_DIGEST_BASE, ":").concat($28653a8371cf992b$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE, ":{"))) try {
        var parsed = JSON.parse(digest.slice(40));
        if ((typeof parsed === "undefined" ? "undefined" : (0, $2bfPH._)(parsed)) === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $daRwM.ErrorResponseImpl)(parsed.status, parsed.statusText, parsed.data);
    } catch (e) {}
}



var $eHaBZ = parcelRequire("eHaBZ");
var $0386ffc241ff4f20$var$_React$1_Component, $0386ffc241ff4f20$var$_class;
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $0386ffc241ff4f20$export$b66bb29c5006f12f(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    (0, $iKEZU.invariant)($0386ffc241ff4f20$export$9c954a9d03d32f4a(), "useHref() may be used only in the context of a <Router> component.");
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), basename = _React$1_useContext.basename, navigator = _React$1_useContext.navigator;
    var _useResolvedPath = $0386ffc241ff4f20$export$e75d2a2d1b3c245b(to, {
        relative: relative
    }), hash = _useResolvedPath.hash, pathname = _useResolvedPath.pathname, search = _useResolvedPath.search;
    var joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $daRwM.joinPaths)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $0386ffc241ff4f20$export$9c954a9d03d32f4a() {
    return $eHaBZ.useContext((0, $333deedcba464643$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $0386ffc241ff4f20$export$45d76561a5302f2b() {
    (0, $iKEZU.invariant)($0386ffc241ff4f20$export$9c954a9d03d32f4a(), "useLocation() may be used only in the context of a <Router> component.");
    return $eHaBZ.useContext((0, $333deedcba464643$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $0386ffc241ff4f20$export$1b3f31771c5d07c() {
    return $eHaBZ.useContext((0, $333deedcba464643$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $0386ffc241ff4f20$export$6c330e8992e8a295(pattern) {
    (0, $iKEZU.invariant)($0386ffc241ff4f20$export$9c954a9d03d32f4a(), "useMatch() may be used only in the context of a <Router> component.");
    var pathname = $0386ffc241ff4f20$export$45d76561a5302f2b().pathname;
    return $eHaBZ.useMemo(function() {
        return (0, $daRwM.matchPath)(pattern, (0, $daRwM.decodePath)(pathname));
    }, [
        pathname,
        pattern
    ]);
}
var $0386ffc241ff4f20$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $0386ffc241ff4f20$export$9770f232ac06a008() {
    var isDataRoute = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).isDataRoute;
    return isDataRoute ? $0386ffc241ff4f20$var$useNavigateStable() : $0386ffc241ff4f20$var$useNavigateUnstable();
}
function $0386ffc241ff4f20$var$useNavigateUnstable() {
    (0, $iKEZU.invariant)($0386ffc241ff4f20$export$9c954a9d03d32f4a(), "useNavigate() may be used only in the context of a <Router> component.");
    var dataRouterContext = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), basename = _React$1_useContext.basename, navigator = _React$1_useContext.navigator;
    var matches = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).matches;
    var _useLocation = $0386ffc241ff4f20$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $daRwM.getResolveToMatches)(matches));
    var activeRef = $eHaBZ.useRef(false);
    $eHaBZ.useLayoutEffect(function() {
        activeRef.current = true;
    });
    return $eHaBZ.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        (0, $iKEZU.warning)(activeRef.current, $0386ffc241ff4f20$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        var path = (0, $daRwM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $daRwM.joinPaths)([
            basename,
            path.pathname
        ]);
        (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $iKEZU.createPath)(to), navigator.createHref(path), (0, $5598f6732b3f5c7d$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
var $0386ffc241ff4f20$var$OutletContext = $eHaBZ.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $0386ffc241ff4f20$export$4138103a3ae699cc() {
    return $eHaBZ.useContext($0386ffc241ff4f20$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $0386ffc241ff4f20$export$a3be3530d8e40d0b(context) {
    var outlet = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).outlet;
    return $eHaBZ.useMemo(function() {
        return outlet && /* @__PURE__ */ $eHaBZ.createElement($0386ffc241ff4f20$var$OutletContext.Provider, {
            value: context
        }, outlet);
    }, [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $0386ffc241ff4f20$export$99eaa27ddbbb95ef() {
    var _matches_;
    var matches = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).matches;
    var _matches__params;
    return (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $0386ffc241ff4f20$export$e75d2a2d1b3c245b(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var matches = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).matches;
    var _useLocation = $0386ffc241ff4f20$export$45d76561a5302f2b(), locationPathname = _useLocation.pathname;
    var routePathnamesJson = JSON.stringify((0, $daRwM.getResolveToMatches)(matches));
    return $eHaBZ.useMemo(function() {
        return (0, $daRwM.resolveTo)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path");
    }, [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $0386ffc241ff4f20$export$5d3fca4a98652595(routes, locationArg) {
    return $0386ffc241ff4f20$export$f7ce0646a48561fb(routes, locationArg);
}
function $0386ffc241ff4f20$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $iKEZU.invariant)($0386ffc241ff4f20$export$9c954a9d03d32f4a(), "useRoutes() may be used only in the context of a <Router> component.");
    var navigator = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).navigator;
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)), parentMatches = _React$1_useContext.matches;
    var routeMatch = parentMatches[parentMatches.length - 1];
    var parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    var parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    var locationFromContext = $0386ffc241ff4f20$export$45d76561a5302f2b();
    var location;
    if (locationArg) {
        var _parsedLocationArg_pathname;
        var parsedLocationArg = typeof locationArg === "string" ? (0, $iKEZU.parsePath)(locationArg) : locationArg;
        (0, $iKEZU.invariant)(parentPathnameBase === "/" || ((_parsedLocationArg_pathname = parsedLocationArg.pathname) === null || _parsedLocationArg_pathname === void 0 ? void 0 : _parsedLocationArg_pathname.startsWith(parentPathnameBase)), 'When overriding the location using `<Routes location>` or `useRoutes(routes, location)`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "'.concat(parentPathnameBase, '" but pathname "').concat(parsedLocationArg.pathname, '" was given in the `location` prop.'));
        location = parsedLocationArg;
    } else location = locationFromContext;
    var pathname = location.pathname || "/";
    var remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        var parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    var matches = dataRouterOpts && dataRouterOpts.state.matches.length ? dataRouterOpts.state.matches.map(function(m) {
        return Object.assign(m, {
            route: dataRouterOpts.manifest[m.route.id] || m.route
        });
    }) : (0, $daRwM.matchRoutes)(routes, {
        pathname: remainingPathname
    });
    var renderedMatches = $0386ffc241ff4f20$export$569816e95a012c39(matches && matches.map(function(match) {
        return Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $daRwM.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $daRwM.joinPaths)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        });
    }), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: (0, $lvTkn._)({
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0
            }, location),
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $0386ffc241ff4f20$var$DefaultErrorComponent() {
    var error = $0386ffc241ff4f20$export$ed527bf60f6e05f2();
    var message = (0, $daRwM.isRouteErrorResponse)(error) ? "".concat(error.status, " ").concat(error.statusText) : error instanceof Error ? error.message : JSON.stringify(error);
    var stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $eHaBZ.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $eHaBZ.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
var $0386ffc241ff4f20$var$defaultErrorElement = /* @__PURE__ */ $eHaBZ.createElement($0386ffc241ff4f20$var$DefaultErrorComponent, null);
var $0386ffc241ff4f20$var$RenderErrorBoundary = ($0386ffc241ff4f20$var$_class = /*#__PURE__*/ function(_superClass) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(_class, _superClass);
    function _class(props) {
        (0, $gd0sY._)(this, _class);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, _class, [
            props
        ]);
        _this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
        return _this;
    }
    (0, $7cSld._)(_class, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("React Router caught the following error during render", error);
            }
        },
        {
            key: "render",
            value: function render() {
                var error = this.state.error;
                if (this.context && (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
                    var decoded = (0, $28653a8371cf992b$export$2b5950305b3e7eaf)(error.digest);
                    if (decoded) error = decoded;
                }
                var result = error !== void 0 ? /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$aac280ed165a4397).Provider, {
                    value: this.props.routeContext
                }, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$af8bd2647fea9c11).Provider, {
                    value: error,
                    children: this.props.component
                })) : this.props.children;
                if (this.context) return /* @__PURE__ */ $eHaBZ.createElement($0386ffc241ff4f20$var$RSCErrorHandler, {
                    error: error
                }, result);
                return result;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
                    error: props.error,
                    location: props.location,
                    revalidation: props.revalidation
                };
                return {
                    error: props.error !== void 0 ? props.error : state.error,
                    location: state.location,
                    revalidation: props.revalidation || state.revalidation
                };
            }
        }
    ]);
    return _class;
}($0386ffc241ff4f20$var$_React$1_Component = $eHaBZ.Component), (0, $khBmn._)($0386ffc241ff4f20$var$_class, "contextType", (0, $333deedcba464643$export$717f757c655223f1)), $0386ffc241ff4f20$var$_class);
var $0386ffc241ff4f20$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $0386ffc241ff4f20$var$RSCErrorHandler(param) {
    var children = param.children, error = param.error;
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), basename = _React$1_useContext.basename, navigator = _React$1_useContext.navigator;
    if ((typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && error && "digest" in error && typeof error.digest === "string") {
        var redirect = (0, $28653a8371cf992b$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            var existingRedirect = $0386ffc241ff4f20$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            var parsed = (0, $daRwM.parseToInfo)(redirect.location, basename);
            var target = parsed.absoluteURL || parsed.to;
            (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(redirect.location, target, (0, $5598f6732b3f5c7d$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $d8c8e9691ac1f69a$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $daRwM.isBrowser) && !$0386ffc241ff4f20$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    var redirectPromise = Promise.resolve().then(function() {
                        return window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        });
                    });
                    $0386ffc241ff4f20$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $eHaBZ.createElement("meta", {
                httpEquiv: "refresh",
                content: "0;url=".concat(target)
            });
        }
    }
    return children;
}
function $0386ffc241ff4f20$var$RenderedRoute(param) {
    var routeContext = param.routeContext, match = param.match, children = param.children;
    var dataRouterContext = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, children);
}
function $0386ffc241ff4f20$export$569816e95a012c39(matches) {
    var parentMatches = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], dataRouterOpts = arguments.length > 2 ? arguments[2] : void 0;
    var dataRouterState = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    var renderedMatches = matches;
    var errors = dataRouterState === null || dataRouterState === void 0 ? void 0 : dataRouterState.errors;
    if (errors != null) {
        var errorIndex = renderedMatches.findIndex(function(m) {
            return m.route.id && (errors === null || errors === void 0 ? void 0 : errors[m.route.id]) !== void 0;
        });
        (0, $iKEZU.invariant)(errorIndex >= 0, "Could not find a matching route for errors on route IDs: ".concat(Object.keys(errors).join(",")));
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    var renderFallback = false;
    var fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(var i = 0; i < renderedMatches.length; i++){
            var match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                var loaderData = dataRouterState.loaderData, errors1 = dataRouterState.errors;
                var needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors1 || errors1[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    var onErrorHandler = dataRouterOpts === null || dataRouterOpts === void 0 ? void 0 : dataRouterOpts.onError;
    var onError = dataRouterState && onErrorHandler ? function(error, errorInfo) {
        var _dataRouterState_matches_, _dataRouterState_matches;
        var _dataRouterState_matches__params;
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: (_dataRouterState_matches__params = (_dataRouterState_matches = dataRouterState.matches) === null || _dataRouterState_matches === void 0 ? void 0 : (_dataRouterState_matches_ = _dataRouterState_matches[0]) === null || _dataRouterState_matches_ === void 0 ? void 0 : _dataRouterState_matches_.params) !== null && _dataRouterState_matches__params !== void 0 ? _dataRouterState_matches__params : {},
            pattern: (0, $daRwM.getRoutePattern)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight(function(outlet, match, index) {
        var error;
        var shouldRenderHydrateFallback = false;
        var errorElement = null;
        var hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $0386ffc241ff4f20$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $0386ffc241ff4f20$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        var _$matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        var getChildren = function() {
            var children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $eHaBZ.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $eHaBZ.createElement($0386ffc241ff4f20$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: _$matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $eHaBZ.createElement($0386ffc241ff4f20$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: _$matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $0386ffc241ff4f20$var$getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function $0386ffc241ff4f20$var$useDataRouterContext(hookName) {
    var ctx = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    (0, $iKEZU.invariant)(ctx, $0386ffc241ff4f20$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $0386ffc241ff4f20$var$useDataRouterState(hookName) {
    var state = $eHaBZ.useContext((0, $333deedcba464643$export$315e3ffb01f217));
    (0, $iKEZU.invariant)(state, $0386ffc241ff4f20$var$getDataRouterConsoleError(hookName));
    return state;
}
function $0386ffc241ff4f20$var$useRouteContext(hookName) {
    var route = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397));
    (0, $iKEZU.invariant)(route, $0386ffc241ff4f20$var$getDataRouterConsoleError(hookName));
    return route;
}
function $0386ffc241ff4f20$var$useCurrentRouteId(hookName) {
    var route = $0386ffc241ff4f20$var$useRouteContext(hookName);
    var thisRoute = route.matches[route.matches.length - 1];
    (0, $iKEZU.invariant)(thisRoute.route.id, "".concat(hookName, ' can only be used on routes that contain a unique "id"'));
    return thisRoute.route.id;
}
/**
* Returns the ID for the nearest contextual route
*
* @category Hooks
* @returns The ID of the nearest contextual route
*/ function $0386ffc241ff4f20$export$4200b254756b08af() {
    return $0386ffc241ff4f20$var$useCurrentRouteId("useRouteId");
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $0386ffc241ff4f20$export$d0fd4b7106de2769() {
    var state = $0386ffc241ff4f20$var$useDataRouterState("useNavigation");
    return $eHaBZ.useMemo(function() {
        var _state_navigation = state.navigation, matches = _state_navigation.matches, historyAction = _state_navigation.historyAction, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_state_navigation, [
            "matches",
            "historyAction"
        ]);
        return rest;
    }, [
        state.navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $0386ffc241ff4f20$export$600dc272ed516c15() {
    var dataRouterContext = $0386ffc241ff4f20$var$useDataRouterContext("useRevalidator");
    var state = $0386ffc241ff4f20$var$useDataRouterState("useRevalidator");
    var revalidate = $eHaBZ.useCallback(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            dataRouterContext.router.revalidate()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        dataRouterContext.router
    ]);
    return $eHaBZ.useMemo(function() {
        return {
            revalidate: revalidate,
            state: state.revalidation
        };
    }, [
        revalidate,
        state.revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $0386ffc241ff4f20$export$2378eb7f5ff86053() {
    var _useDataRouterState = $0386ffc241ff4f20$var$useDataRouterState("useMatches"), matches = _useDataRouterState.matches, loaderData = _useDataRouterState.loaderData;
    return $eHaBZ.useMemo(function() {
        return matches.map(function(m) {
            return (0, $daRwM.convertRouteMatchToUiMatch)(m, loaderData);
        });
    }, [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $0386ffc241ff4f20$export$1448a5050d252c4d() {
    var state = $0386ffc241ff4f20$var$useDataRouterState("useLoaderData");
    var routeId = $0386ffc241ff4f20$var$useCurrentRouteId("useLoaderData");
    return state.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $0386ffc241ff4f20$export$fd5d37484eab868d(routeId) {
    return $0386ffc241ff4f20$var$useDataRouterState("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $0386ffc241ff4f20$export$fdc00f3f26066d5e() {
    var state = $0386ffc241ff4f20$var$useDataRouterState("useActionData");
    var routeId = $0386ffc241ff4f20$var$useCurrentRouteId("useLoaderData");
    return state.actionData ? state.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $0386ffc241ff4f20$export$ed527bf60f6e05f2() {
    var _state_errors;
    var error = $eHaBZ.useContext((0, $333deedcba464643$export$af8bd2647fea9c11));
    var state = $0386ffc241ff4f20$var$useDataRouterState("useRouteError");
    var routeId = $0386ffc241ff4f20$var$useCurrentRouteId("useRouteError");
    if (error !== void 0) return error;
    return (_state_errors = state.errors) === null || _state_errors === void 0 ? void 0 : _state_errors[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $0386ffc241ff4f20$export$78a72ddb39bdd145() {
    var _React$1_useContext;
    return (_React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$804c460aade54ac8))) === null || _React$1_useContext === void 0 ? void 0 : _React$1_useContext._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $0386ffc241ff4f20$export$17f53340677d5831() {
    var _React$1_useContext;
    return (_React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$804c460aade54ac8))) === null || _React$1_useContext === void 0 ? void 0 : _React$1_useContext._error;
}
var $0386ffc241ff4f20$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $0386ffc241ff4f20$export$b273b3273281a049(shouldBlock) {
    var _useDataRouterContext = $0386ffc241ff4f20$var$useDataRouterContext("useBlocker"), router = _useDataRouterContext.router, basename = _useDataRouterContext.basename;
    var state = $0386ffc241ff4f20$var$useDataRouterState("useBlocker");
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState(""), 2), blockerKey = _React$1_useState[0], setBlockerKey = _React$1_useState[1];
    var blockerFunction = $eHaBZ.useCallback(function(arg) {
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        var currentLocation = arg.currentLocation, nextLocation = arg.nextLocation, historyAction = arg.historyAction;
        return shouldBlock({
            currentLocation: (0, $9Jpjh._)((0, $lvTkn._)({}, currentLocation), {
                pathname: (0, $daRwM.stripBasename)(currentLocation.pathname, basename) || currentLocation.pathname
            }),
            nextLocation: (0, $9Jpjh._)((0, $lvTkn._)({}, nextLocation), {
                pathname: (0, $daRwM.stripBasename)(nextLocation.pathname, basename) || nextLocation.pathname
            }),
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $eHaBZ.useEffect(function() {
        var key = String(++$0386ffc241ff4f20$var$blockerId);
        setBlockerKey(key);
        return function() {
            return router.deleteBlocker(key);
        };
    }, [
        router
    ]);
    $eHaBZ.useEffect(function() {
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $d8c8e9691ac1f69a$export$386d57f03f0b2883);
}
function $0386ffc241ff4f20$var$useNavigateStable() {
    var router = $0386ffc241ff4f20$var$useDataRouterContext("useNavigate").router;
    var id = $0386ffc241ff4f20$var$useCurrentRouteId("useNavigate");
    var activeRef = $eHaBZ.useRef(false);
    $eHaBZ.useLayoutEffect(function() {
        activeRef.current = true;
    });
    return $eHaBZ.useCallback(function(to) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $iKEZU.warning)(activeRef.current, $0386ffc241ff4f20$var$navigateEffectWarning);
                        if (!activeRef.current) return [
                            2
                        ];
                        if (!(typeof to === "number")) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            router.navigate(to)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            router.navigate(to, (0, $lvTkn._)({
                                fromRouteId: id
                            }, options))
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        router,
        id
    ]);
}
var $0386ffc241ff4f20$var$alreadyWarned = {};
function $0386ffc241ff4f20$var$warningOnce(key, cond, message) {
    if (!cond && !$0386ffc241ff4f20$var$alreadyWarned[key]) {
        $0386ffc241ff4f20$var$alreadyWarned[key] = true;
        (0, $iKEZU.warning)(false, message);
    }
}
function $0386ffc241ff4f20$export$3f79f0b98112cf57() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
        args[_key] = arguments[_key];
    }
    var _state_actionData;
    var currentRouteId = $0386ffc241ff4f20$var$useCurrentRouteId("useRoute");
    var _args_;
    var id = (_args_ = args[0]) !== null && _args_ !== void 0 ? _args_ : currentRouteId;
    var state = $0386ffc241ff4f20$var$useDataRouterState("useRoute");
    var route = state.matches.find(function(param) {
        var route = param.route;
        return route.id === id;
    });
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: state.loaderData[id],
        actionData: (_state_actionData = state.actionData) === null || _state_actionData === void 0 ? void 0 : _state_actionData[id]
    };
}
function $0386ffc241ff4f20$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $0386ffc241ff4f20$export$dbb5ccc270afbbb4() {
    var _useDataRouterState = $0386ffc241ff4f20$var$useDataRouterState("unstable_useRouterState"), location = _useDataRouterState.location, type = _useDataRouterState.historyAction, matches = _useDataRouterState.matches, navigation = _useDataRouterState.navigation;
    var active = $eHaBZ.useMemo(function() {
        var _matches_;
        var _matches__params;
        return {
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: (_matches__params = (_matches_ = matches[matches.length - 1]) === null || _matches_ === void 0 ? void 0 : _matches_.params) !== null && _matches__params !== void 0 ? _matches__params : {},
            matches: matches.map(function(m) {
                return $0386ffc241ff4f20$var$toRouterStateMatch(m);
            })
        };
    }, [
        location,
        matches,
        type
    ]);
    var pending = $eHaBZ.useMemo(function() {
        var _navigation_matches_;
        if (navigation.state === "idle") return null;
        var _navigation_matches__params;
        var shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: (_navigation_matches__params = (_navigation_matches_ = navigation.matches[navigation.matches.length - 1]) === null || _navigation_matches_ === void 0 ? void 0 : _navigation_matches_.params) !== null && _navigation_matches__params !== void 0 ? _navigation_matches__params : {},
            matches: navigation.matches.map(function(m) {
                return $0386ffc241ff4f20$var$toRouterStateMatch(m);
            })
        };
        return navigation.state === "loading" ? (0, $9Jpjh._)((0, $lvTkn._)({}, shared), {
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        }) : (0, $9Jpjh._)((0, $lvTkn._)({}, shared), {
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        });
    }, [
        navigation
    ]);
    return $eHaBZ.useMemo(function() {
        return {
            active: active,
            pending: pending
        };
    }, [
        active,
        pending
    ]);
}

/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");


var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");




/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
var $52b8a13ef796e487$var$alreadyWarned = {};
function $52b8a13ef796e487$export$5b28268982f175ba(condition, message) {
    if (!condition && !$52b8a13ef796e487$var$alreadyWarned[message]) {
        $52b8a13ef796e487$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/components.tsx
var $d6e338e05ac94550$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $d6e338e05ac94550$export$f30f7e456d254e83(routes, opts) {
    return (0, $d8c8e9691ac1f69a$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $iKEZU.createMemoryHistory)({
            initialEntries: opts === null || opts === void 0 ? void 0 : opts.initialEntries,
            initialIndex: opts === null || opts === void 0 ? void 0 : opts.initialIndex
        }),
        hydrationData: opts === null || opts === void 0 ? void 0 : opts.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $daRwM.defaultMapRouteProperties),
        hydrationRouteProperties: $d6e338e05ac94550$export$e2fd2c03906469db,
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
var $d6e338e05ac94550$var$Deferred = function Deferred() {
    "use strict";
    var _this = this;
    (0, $gd0sY._)(this, Deferred);
    (0, $khBmn._)(this, "status", "pending");
    (0, $khBmn._)(this, "promise", void 0);
    (0, $khBmn._)(this, "resolve", void 0);
    (0, $khBmn._)(this, "reject", void 0);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = function(value) {
            if (_this.status === "pending") {
                _this.status = "resolved";
                resolve(value);
            }
        };
        _this.reject = function(reason) {
            if (_this.status === "pending") {
                _this.status = "rejected";
                reject(reason);
            }
        };
    });
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $d6e338e05ac94550$export$323e4fc2fa4753fb(param) {
    var router = param.router, reactDomFlushSyncImpl = param.flushSync, onError = param.onError, useTransitions = param.useTransitions;
    useTransitions = (0, $333deedcba464643$export$6e1eeb090b3ec35b)() || useTransitions;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState(router.state), 2), _state = _React$1_useState[0], setStateImpl = _React$1_useState[1];
    var _useOptimistic = (0, $21h22._)((0, $eHaBZ.useOptimistic)(_state), 2), state = _useOptimistic[0], setOptimisticState = _useOptimistic[1];
    var _React$1_useState1 = (0, $21h22._)($eHaBZ.useState(), 2), pendingState = _React$1_useState1[0], setPendingState = _React$1_useState1[1];
    var _React$1_useState2 = (0, $21h22._)($eHaBZ.useState({
        isTransitioning: false
    }), 2), vtContext = _React$1_useState2[0], setVtContext = _React$1_useState2[1];
    var _React$1_useState3 = (0, $21h22._)($eHaBZ.useState(), 2), renderDfd = _React$1_useState3[0], setRenderDfd = _React$1_useState3[1];
    var _React$1_useState4 = (0, $21h22._)($eHaBZ.useState(), 2), transition = _React$1_useState4[0], setTransition = _React$1_useState4[1];
    var _React$1_useState5 = (0, $21h22._)($eHaBZ.useState(), 2), interruption = _React$1_useState5[0], setInterruption = _React$1_useState5[1];
    var fetcherData = $eHaBZ.useRef(/* @__PURE__ */ new Map());
    var setState = $eHaBZ.useCallback(function(newState, param) {
        var deletedFetchers = param.deletedFetchers, newErrors = param.newErrors, flushSync = param.flushSync, viewTransitionOpts = param.viewTransitionOpts;
        if (newErrors && onError) Object.values(newErrors).forEach(function(error) {
            var _newState_matches_;
            var _newState_matches__params;
            return onError(error, {
                location: newState.location,
                params: (_newState_matches__params = (_newState_matches_ = newState.matches[0]) === null || _newState_matches_ === void 0 ? void 0 : _newState_matches_.params) !== null && _newState_matches__params !== void 0 ? _newState_matches__params : {},
                pattern: (0, $daRwM.getRoutePattern)(newState.matches)
            });
        });
        newState.fetchers.forEach(function(fetcher, key) {
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach(function(key) {
            return fetcherData.current.delete(key);
        });
        (0, $52b8a13ef796e487$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        var isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $52b8a13ef796e487$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(function() {
                return setStateImpl(newState);
            });
            else if (useTransitions === false) setStateImpl(newState);
            else $eHaBZ.startTransition(function() {
                if (useTransitions === true) setOptimisticState(function(s) {
                    return $d6e338e05ac94550$var$getOptimisticRouterState(s, newState);
                });
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(function() {
                if (transition) {
                    renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            var t = router.window.document.startViewTransition(function() {
                reactDomFlushSyncImpl(function() {
                    return setStateImpl(newState);
                });
            });
            t.finished.finally(function() {
                reactDomFlushSyncImpl(function() {
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(function() {
                return setTransition(t);
            });
            return;
        }
        if (transition) {
            renderDfd === null || renderDfd === void 0 ? void 0 : renderDfd.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return router.subscribe(setState);
    }, [
        router,
        setState
    ]);
    $eHaBZ.useEffect(function() {
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $d6e338e05ac94550$var$Deferred());
    }, [
        vtContext
    ]);
    $eHaBZ.useEffect(function() {
        if (renderDfd && pendingState && router.window) {
            var newState = pendingState;
            var renderPromise = renderDfd.promise;
            var transition = router.window.document.startViewTransition(function() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (useTransitions === false) setStateImpl(newState);
                                else $eHaBZ.startTransition(function() {
                                    if (useTransitions === true) setOptimisticState(function(s) {
                                        return $d6e338e05ac94550$var$getOptimisticRouterState(s, newState);
                                    });
                                    setStateImpl(newState);
                                });
                                return [
                                    4,
                                    renderPromise
                                ];
                            case 1:
                                _state.sent();
                                return [
                                    2
                                ];
                        }
                    });
                })();
            });
            transition.finished.finally(function() {
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $eHaBZ.useEffect(function() {
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $eHaBZ.useEffect(function() {
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    var navigator = $eHaBZ.useMemo(function() {
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: function(n) {
                return router.navigate(n);
            },
            push: function(to, state, opts) {
                return router.navigate(to, {
                    state: state,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            },
            replace: function(to, state, opts) {
                return router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts === null || opts === void 0 ? void 0 : opts.preventScrollReset
                });
            }
        };
    }, [
        router
    ]);
    var basename = router.basename || "/";
    var dataRouterContext = $eHaBZ.useMemo(function() {
        return {
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        };
    }, [
        router,
        navigator,
        basename,
        onError
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$315e3ffb01f217).Provider, {
        value: state
    }, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$cb3f1df1bef00a39).Provider, {
        value: fetcherData.current
    }, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $eHaBZ.createElement($d6e338e05ac94550$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $eHaBZ.createElement($d6e338e05ac94550$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        future: router.future,
        state: state,
        isStatic: false,
        onError: onError
    })))))), null);
}
function $d6e338e05ac94550$var$getOptimisticRouterState(currentState, newState) {
    return (0, $9Jpjh._)((0, $lvTkn._)({}, currentState), {
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    });
}
var $d6e338e05ac94550$var$MemoizedDataRoutes = $eHaBZ.memo($d6e338e05ac94550$export$699f06c8afb533c9);
function $d6e338e05ac94550$export$699f06c8afb533c9(param) {
    var routes = param.routes, manifest = param.manifest, future = param.future, state = param.state, isStatic = param.isStatic, onError = param.onError;
    return (0, $0386ffc241ff4f20$export$f7ce0646a48561fb)(routes, void 0, {
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError,
        future: future
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $d6e338e05ac94550$export$ae46f04cfaffe093(param) {
    var basename = param.basename, children = param.children, initialEntries = param.initialEntries, initialIndex = param.initialIndex, useTransitions = param.useTransitions;
    var historyRef = $eHaBZ.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $iKEZU.createMemoryHistory)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React$1_useState[0], setStateImpl = _React$1_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($d6e338e05ac94550$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $d6e338e05ac94550$export$444b3ab0cb9aec40(param) {
    var to = param.to, replace = param.replace, state = param.state, relative = param.relative;
    (0, $iKEZU.invariant)((0, $0386ffc241ff4f20$export$9c954a9d03d32f4a)(), "<Navigate> may be used only in the context of a <Router> component.");
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), isStatic = _React$1_useContext.static, navigator = _React$1_useContext.navigator;
    (0, $iKEZU.warning)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    var matches = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397)).matches;
    var _useLocation = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)(), locationPathname = _useLocation.pathname;
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var path = (0, $daRwM.resolveTo)(to, (0, $daRwM.getResolveToMatches)(matches), locationPathname, relative === "path");
    (0, $5598f6732b3f5c7d$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $iKEZU.createPath)(to), navigator.createHref(path), (0, $5598f6732b3f5c7d$export$1da545bc000055cf)(navigator), "reject");
    var jsonPath = JSON.stringify(path);
    $eHaBZ.useEffect(function() {
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $d6e338e05ac94550$export$910ae8079b2c2852(props) {
    return (0, $0386ffc241ff4f20$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $d6e338e05ac94550$export$e7b0ac011bb776c6(props) {
    (0, $iKEZU.invariant)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $d6e338e05ac94550$export$55185c17a0fcbe46(param) {
    var tmp = param.basename, basenameProp = tmp === void 0 ? "/" : tmp, _param_children = param.children, children = _param_children === void 0 ? null : _param_children, locationProp = param.location, _param_navigationType = param.navigationType, navigationType = _param_navigationType === void 0 ? "POP" : _param_navigationType, navigator = param.navigator, tmp1 = param.static, staticProp = tmp1 === void 0 ? false : tmp1, useTransitions = param.useTransitions;
    (0, $iKEZU.invariant)(!(0, $0386ffc241ff4f20$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    var basename = basenameProp.replace(/^\/*/, "/");
    var navigationContext = $eHaBZ.useMemo(function() {
        return {
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        };
    }, [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $iKEZU.parsePath)(locationProp);
    var _locationProp_pathname = locationProp.pathname, pathname = _locationProp_pathname === void 0 ? "/" : _locationProp_pathname, _locationProp_search = locationProp.search, search = _locationProp_search === void 0 ? "" : _locationProp_search, _locationProp_hash = locationProp.hash, hash = _locationProp_hash === void 0 ? "" : _locationProp_hash, _locationProp_state = locationProp.state, state = _locationProp_state === void 0 ? null : _locationProp_state, _locationProp_key = locationProp.key, key = _locationProp_key === void 0 ? "default" : _locationProp_key, mask = locationProp.mask;
    var locationContext = $eHaBZ.useMemo(function() {
        var trailingPathname = (0, $daRwM.stripBasename)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $iKEZU.warning)(locationContext != null, '<Router basename="'.concat(basename, '"> is not able to match the URL "').concat(pathname).concat(search).concat(hash, "\" because it does not start with the basename, so the <Router> won't render anything."));
    if (locationContext == null) return null;
    return /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $d6e338e05ac94550$export$3565eb3d00ca5a74(param) {
    var children = param.children, location = param.location;
    return (0, $0386ffc241ff4f20$export$5d3fca4a98652595)($d6e338e05ac94550$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $d6e338e05ac94550$export$6ddabde395c8c576(param) {
    var children = param.children, errorElement = param.errorElement, resolve = param.resolve;
    var dataRouterContext = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    var dataRouterStateContext = $eHaBZ.useContext((0, $333deedcba464643$export$315e3ffb01f217));
    var onError = $eHaBZ.useCallback(function(error, errorInfo) {
        var _dataRouterStateContext_matches_;
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: ((_dataRouterStateContext_matches_ = dataRouterStateContext.matches[0]) === null || _dataRouterStateContext_matches_ === void 0 ? void 0 : _dataRouterStateContext_matches_.params) || {},
            pattern: (0, $daRwM.getRoutePattern)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($d6e338e05ac94550$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $eHaBZ.createElement($d6e338e05ac94550$var$ResolveAwait, null, children));
}
var $d6e338e05ac94550$var$AwaitErrorBoundary = /*#__PURE__*/ function(_React$1_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(AwaitErrorBoundary, _React$1_Component);
    function AwaitErrorBoundary(props) {
        (0, $gd0sY._)(this, AwaitErrorBoundary);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, AwaitErrorBoundary, [
            props
        ]);
        _this.state = {
            error: null
        };
        return _this;
    }
    (0, $7cSld._)(AwaitErrorBoundary, [
        {
            key: "componentDidCatch",
            value: function componentDidCatch(error, errorInfo) {
                if (this.props.onError) this.props.onError(error, errorInfo);
                else console.error("<Await> caught the following error during render", error, errorInfo);
            }
        },
        {
            key: "render",
            value: function render() {
                var _this = this;
                var _this_props = this.props, children = _this_props.children, errorElement = _this_props.errorElement, resolve = _this_props.resolve;
                var promise = null;
                var status = 0;
                if (!(resolve instanceof Promise)) {
                    status = 1;
                    promise = Promise.resolve();
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_data", {
                        get: function() {
                            return resolve;
                        }
                    });
                } else if (this.state.error) {
                    status = 2;
                    var renderError = this.state.error;
                    promise = Promise.reject().catch(function() {});
                    Object.defineProperty(promise, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    Object.defineProperty(promise, "_error", {
                        get: function() {
                            return renderError;
                        }
                    });
                } else if (resolve._tracked) {
                    promise = resolve;
                    status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
                } else {
                    status = 0;
                    Object.defineProperty(resolve, "_tracked", {
                        get: function() {
                            return true;
                        }
                    });
                    promise = resolve.then(function(data) {
                        return Object.defineProperty(resolve, "_data", {
                            get: function() {
                                return data;
                            }
                        });
                    }, function(error) {
                        var _this_props_onError, _this_props;
                        (_this_props_onError = (_this_props = _this.props).onError) === null || _this_props_onError === void 0 ? void 0 : _this_props_onError.call(_this_props, error);
                        Object.defineProperty(resolve, "_error", {
                            get: function() {
                                return error;
                            }
                        });
                    });
                }
                if (status === 2 && !errorElement) throw promise._error;
                if (status === 2) return /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$804c460aade54ac8).Provider, {
                    value: promise,
                    children: errorElement
                });
                if (status === 1) return /* @__PURE__ */ $eHaBZ.createElement((0, $333deedcba464643$export$804c460aade54ac8).Provider, {
                    value: promise,
                    children: children
                });
                throw promise;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        }
    ]);
    return AwaitErrorBoundary;
}($eHaBZ.Component);
function $d6e338e05ac94550$var$ResolveAwait(param) {
    var children = param.children;
    var data = (0, $0386ffc241ff4f20$export$78a72ddb39bdd145)();
    var toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $d6e338e05ac94550$export$16da398f5434bdec(children) {
    var parentPath = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var routes = [];
    $eHaBZ.Children.forEach(children, function(element, index) {
        if (!$eHaBZ.isValidElement(element)) return;
        var treePath = (0, $6zk1M._)(parentPath).concat([
            index
        ]);
        if (element.type === $eHaBZ.Fragment) {
            routes.push.apply(routes, $d6e338e05ac94550$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $iKEZU.invariant)(element.type === $d6e338e05ac94550$export$e7b0ac011bb776c6, "[".concat(typeof element.type === "string" ? element.type : element.type.name, "] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>"));
        var props = element.props;
        (0, $iKEZU.invariant)(!props.index || !props.children, "An index route cannot have child routes.");
        var route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $d6e338e05ac94550$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ var $d6e338e05ac94550$export$9b5b6d122dea0c88 = $d6e338e05ac94550$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $d6e338e05ac94550$export$daf73786167a7f72(matches) {
    return (0, $0386ffc241ff4f20$export$569816e95a012c39)(matches);
}
function $d6e338e05ac94550$var$useRouteComponentProps() {
    return {
        params: (0, $0386ffc241ff4f20$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $0386ffc241ff4f20$export$1448a5050d252c4d)(),
        actionData: (0, $0386ffc241ff4f20$export$fdc00f3f26066d5e)(),
        matches: (0, $0386ffc241ff4f20$export$2378eb7f5ff86053)()
    };
}
function $d6e338e05ac94550$export$6c4f3826290c37af(param) {
    var children = param.children;
    var props = $d6e338e05ac94550$var$useRouteComponentProps();
    return $eHaBZ.cloneElement(children, props);
}
function $d6e338e05ac94550$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        var props = $d6e338e05ac94550$var$useRouteComponentProps();
        return $eHaBZ.createElement(Component, props);
    };
}
function $d6e338e05ac94550$var$useHydrateFallbackProps() {
    return {
        params: (0, $0386ffc241ff4f20$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $0386ffc241ff4f20$export$1448a5050d252c4d)(),
        actionData: (0, $0386ffc241ff4f20$export$fdc00f3f26066d5e)()
    };
}
function $d6e338e05ac94550$export$f8cff34f39c1932a(param) {
    var children = param.children;
    var props = $d6e338e05ac94550$var$useHydrateFallbackProps();
    return $eHaBZ.cloneElement(children, props);
}
function $d6e338e05ac94550$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        var props = $d6e338e05ac94550$var$useHydrateFallbackProps();
        return $eHaBZ.createElement(HydrateFallback, props);
    };
}
function $d6e338e05ac94550$var$useErrorBoundaryProps() {
    return {
        params: (0, $0386ffc241ff4f20$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $0386ffc241ff4f20$export$1448a5050d252c4d)(),
        actionData: (0, $0386ffc241ff4f20$export$fdc00f3f26066d5e)(),
        error: (0, $0386ffc241ff4f20$export$ed527bf60f6e05f2)()
    };
}
function $d6e338e05ac94550$export$e5afde5c4b6d747b(param) {
    var children = param.children;
    var props = $d6e338e05ac94550$var$useErrorBoundaryProps();
    return $eHaBZ.cloneElement(children, props);
}
function $d6e338e05ac94550$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        var props = $d6e338e05ac94550$var$useErrorBoundaryProps();
        return $eHaBZ.createElement(ErrorBoundary, props);
    };
}

/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");


var $8onil = parcelRequire("8onil");

var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");




/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");
var $7e52a79e98d59ecf$var$defaultEncType = "application/x-www-form-urlencoded";
function $7e52a79e98d59ecf$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $7e52a79e98d59ecf$var$isButtonElement(object) {
    return $7e52a79e98d59ecf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $7e52a79e98d59ecf$var$isFormElement(object) {
    return $7e52a79e98d59ecf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $7e52a79e98d59ecf$var$isInputElement(object) {
    return $7e52a79e98d59ecf$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $7e52a79e98d59ecf$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $7e52a79e98d59ecf$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$7e52a79e98d59ecf$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $7e52a79e98d59ecf$export$a2e4e2dcc7b1f22f() {
    var init = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce(function(memo, key) {
        var value = init[key];
        return memo.concat(Array.isArray(value) ? value.map(function(v) {
            return [
                key,
                v
            ];
        }) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $7e52a79e98d59ecf$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    var searchParams = $7e52a79e98d59ecf$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach(function(_, key) {
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach(function(value) {
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
var $7e52a79e98d59ecf$var$_formDataSupportsSubmitter = null;
function $7e52a79e98d59ecf$var$isFormDataSubmitterSupported() {
    if ($7e52a79e98d59ecf$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $7e52a79e98d59ecf$var$_formDataSupportsSubmitter = false;
    } catch (e) {
        $7e52a79e98d59ecf$var$_formDataSupportsSubmitter = true;
    }
    return $7e52a79e98d59ecf$var$_formDataSupportsSubmitter;
}
var $7e52a79e98d59ecf$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $7e52a79e98d59ecf$var$getFormEncType(encType) {
    if (encType != null && !$7e52a79e98d59ecf$var$supportedFormEncTypes.has(encType)) {
        (0, $iKEZU.warning)(false, '"'.concat(encType, '" is not a valid `encType` for `<Form>`/`<fetcher.Form>` and will default to "').concat($7e52a79e98d59ecf$var$defaultEncType, '"'));
        return null;
    }
    return encType;
}
function $7e52a79e98d59ecf$export$80917616746b9ab4(target, basename) {
    var method;
    var action;
    var encType;
    var formData;
    var body;
    if ($7e52a79e98d59ecf$var$isFormElement(target)) {
        var attr = target.getAttribute("action");
        action = attr ? (0, $daRwM.stripBasename)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $7e52a79e98d59ecf$var$getFormEncType(target.getAttribute("enctype")) || $7e52a79e98d59ecf$var$defaultEncType;
        formData = new FormData(target);
    } else if ($7e52a79e98d59ecf$var$isButtonElement(target) || $7e52a79e98d59ecf$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        var form = target.form;
        if (form == null) throw new Error('Cannot submit a <button> or <input type="submit"> without a <form>');
        var attr1 = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr1 ? (0, $daRwM.stripBasename)(attr1, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $7e52a79e98d59ecf$var$getFormEncType(target.getAttribute("formenctype")) || $7e52a79e98d59ecf$var$getFormEncType(form.getAttribute("enctype")) || $7e52a79e98d59ecf$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$7e52a79e98d59ecf$var$isFormDataSubmitterSupported()) {
            var name = target.name, type = target.type, value = target.value;
            if (type === "image") {
                var prefix = name ? "".concat(name, ".") : "";
                formData.append("".concat(prefix, "x"), "0");
                formData.append("".concat(prefix, "y"), "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($7e52a79e98d59ecf$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $7e52a79e98d59ecf$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
var $77cc0322f8b62577$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
var $77cc0322f8b62577$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $77cc0322f8b62577$export$4cf11838cdc2a8a8(html) {
    return html.replace($77cc0322f8b62577$var$ESCAPE_REGEX, function(match) {
        return $77cc0322f8b62577$var$ESCAPE_LOOKUP[match];
    });
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $daRwM = parcelRequire("daRwM");



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $dfb15cab4dfa9334$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $6zk1M = parcelRequire("6zk1M");

/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts


var $c57a0e6aab2808e0$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
function $c57a0e6aab2808e0$export$d9c4a4e8105733a6(route, routeModulesCache) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var routeModule, error;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (route.id in routeModulesCache) return [
                        2,
                        routeModulesCache[route.id]
                    ];
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.module)
                    ];
                case 2:
                    routeModule = _state.sent();
                    routeModulesCache[route.id] = routeModule;
                    return [
                        2,
                        routeModule
                    ];
                case 3:
                    error = _state.sent();
                    console.error("Error loading route module `".concat(route.module, "`, reloading page..."));
                    console.error(error);
                    if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $c57a0e6aab2808e0$import_meta.hot) throw error;
                    window.location.reload();
                    return [
                        2,
                        new Promise(function() {})
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    })();
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $6b3610dc4425b9a6$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $6b3610dc4425b9a6$var$dedupeLinkDescriptors(matches.map(function(match) {
        var _module_links;
        var module = routeModules[match.route.id];
        var route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map(function(href) {
                return {
                    rel: "stylesheet",
                    href: href
                };
            }) : [],
            (module === null || module === void 0 ? void 0 : (_module_links = module.links) === null || _module_links === void 0 ? void 0 : _module_links.call(module)) || []
        ];
    }).flat(2), $6b3610dc4425b9a6$export$442b9e023f41af00(matches, manifest));
}
function $6b3610dc4425b9a6$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map(function(href) {
        return {
            rel: "stylesheet",
            href: href
        };
    });
}
function $6b3610dc4425b9a6$export$2ee8f5601ba37b41(route) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var descriptors;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css) return [
                        2
                    ];
                    descriptors = $6b3610dc4425b9a6$var$getRouteCssDescriptors(route);
                    return [
                        4,
                        Promise.all(descriptors.map($6b3610dc4425b9a6$var$prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $6b3610dc4425b9a6$export$26f28bc6dfd6cfc6(route, routeModule) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _descriptors, _descriptors1, descriptors, styleLinks, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, descriptor;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!route.css && !routeModule.links || !$6b3610dc4425b9a6$var$isPreloadSupported()) return [
                        2
                    ];
                    descriptors = [];
                    if (route.css) (_descriptors = descriptors).push.apply(_descriptors, (0, $6zk1M._)($6b3610dc4425b9a6$var$getRouteCssDescriptors(route)));
                    if (routeModule.links) (_descriptors1 = descriptors).push.apply(_descriptors1, (0, $6zk1M._)(routeModule.links()));
                    if (descriptors.length === 0) return [
                        2
                    ];
                    styleLinks = [];
                    _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(_iterator = descriptors[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            descriptor = _step.value;
                            if (!$6b3610dc4425b9a6$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push((0, $9Jpjh._)((0, $lvTkn._)({}, descriptor), {
                                rel: "preload",
                                as: "style"
                            }));
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return [
                        4,
                        Promise.all(styleLinks.map($6b3610dc4425b9a6$var$prefetchStyleLink))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2
                    ];
            }
        });
    })();
}
function $6b3610dc4425b9a6$var$prefetchStyleLink(descriptor) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    var removeLink = function removeLink() {
                        if (document.head.contains(link)) document.head.removeChild(link);
                    };
                    if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector('link[rel="stylesheet"][href="'.concat(descriptor.href, '"]'))) return resolve();
                    var link = document.createElement("link");
                    Object.assign(link, descriptor);
                    link.onload = function() {
                        removeLink();
                        resolve();
                    };
                    link.onerror = function() {
                        removeLink();
                        resolve();
                    };
                    document.head.appendChild(link);
                })
            ];
        });
    })();
}
function $6b3610dc4425b9a6$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $6b3610dc4425b9a6$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
function $6b3610dc4425b9a6$export$98f31d7a23772264(matches, manifest, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        Promise.all(matches.map(function(match) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                var route, mod;
                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            route = manifest.routes[match.route.id];
                                            if (!route) return [
                                                3,
                                                2
                                            ];
                                            return [
                                                4,
                                                (0, $c57a0e6aab2808e0$export$d9c4a4e8105733a6)(route, routeModules)
                                            ];
                                        case 1:
                                            mod = _state.sent();
                                            return [
                                                2,
                                                mod.links ? mod.links() : []
                                            ];
                                        case 2:
                                            return [
                                                2,
                                                []
                                            ];
                                    }
                                });
                            })();
                        }))
                    ];
                case 1:
                    return [
                        2,
                        $6b3610dc4425b9a6$var$dedupeLinkDescriptors.apply(void 0, [
                            _state.sent().flat(1).filter($6b3610dc4425b9a6$var$isHtmlLinkDescriptor).filter(function(link) {
                                return link.rel === "stylesheet" || link.rel === "preload";
                            }).map(function(link) {
                                return link.rel === "stylesheet" ? (0, $9Jpjh._)((0, $lvTkn._)({}, link), {
                                    rel: "prefetch",
                                    as: "style"
                                }) : (0, $9Jpjh._)((0, $lvTkn._)({}, link), {
                                    rel: "prefetch"
                                });
                            })
                        ])
                    ];
            }
        });
    })();
}
function $6b3610dc4425b9a6$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    var isNew = function(match, index) {
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    var matchPathChanged = function(match, index) {
        var _currentMatches_index_route_path;
        return currentMatches[index].pathname !== match.pathname || ((_currentMatches_index_route_path = currentMatches[index].route.path) === null || _currentMatches_index_route_path === void 0 ? void 0 : _currentMatches_index_route_path.endsWith("*")) && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter(function(match, index) {
        return isNew(match, index) || matchPathChanged(match, index);
    });
    if (mode === "data") return nextMatches.filter(function(match, index) {
        var manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            var _currentMatches_;
            var routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: ((_currentMatches_ = currentMatches[0]) === null || _currentMatches_ === void 0 ? void 0 : _currentMatches_.params) || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $6b3610dc4425b9a6$export$442b9e023f41af00(matches, manifest) {
    var includeHydrateFallback = (arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}).includeHydrateFallback;
    return $6b3610dc4425b9a6$var$dedupeHrefs(matches.map(function(match) {
        var route = manifest.routes[match.route.id];
        if (!route) return [];
        var hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $6b3610dc4425b9a6$var$dedupeHrefs(hrefs) {
    return (0, $6zk1M._)(new Set(hrefs));
}
function $6b3610dc4425b9a6$var$sortKeys(obj) {
    var sorted = {};
    var keys = Object.keys(obj).sort();
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            sorted[key] = obj[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return sorted;
}
function $6b3610dc4425b9a6$var$dedupeLinkDescriptors(descriptors, preloads) {
    var set = /* @__PURE__ */ new Set();
    var preloadsSet = new Set(preloads);
    return descriptors.reduce(function(deduped, descriptor) {
        if (preloads && !$6b3610dc4425b9a6$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        var key = JSON.stringify($6b3610dc4425b9a6$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
var $6b3610dc4425b9a6$var$_isPreloadSupported;
function $6b3610dc4425b9a6$var$isPreloadSupported() {
    if ($6b3610dc4425b9a6$var$_isPreloadSupported !== void 0) return $6b3610dc4425b9a6$var$_isPreloadSupported;
    var el = document.createElement("link");
    $6b3610dc4425b9a6$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $6b3610dc4425b9a6$var$_isPreloadSupported;
}



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $gd0sY = parcelRequire("gd0sY");

var $khBmn = parcelRequire("khBmn");


var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");



var $daRwM = parcelRequire("daRwM");



/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts

var $gd0sY = parcelRequire("gd0sY");

var $khBmn = parcelRequire("khBmn");
var $298e207a265b7b64$export$85f6557964517f1a = function Deferred() {
    "use strict";
    var _this = this;
    (0, $gd0sY._)(this, Deferred);
    (0, $khBmn._)(this, "promise", void 0);
    (0, $khBmn._)(this, "resolve", void 0);
    (0, $khBmn._)(this, "reject", void 0);
    this.promise = new Promise(function(resolve, reject) {
        _this.resolve = resolve;
        _this.reject = reject;
    });
};
function $298e207a265b7b64$export$4786a9f20844482d() {
    var decoder = new TextDecoder();
    var leftover = "";
    return new TransformStream({
        transform: function(chunk, controller) {
            var str = decoder.decode(chunk, {
                stream: true
            });
            var parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var part = _step.value;
                    controller.enqueue(part);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        },
        flush: function(controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts


var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $0d581330596ecb05$var$TIME_LIMIT_MS = 1;
var $0d581330596ecb05$var$getNow = function() {
    return Date.now();
};
var $0d581330596ecb05$var$yieldToMain = function() {
    return new Promise(function(resolve) {
        return setTimeout(resolve, 0);
    });
};
function $0d581330596ecb05$export$bffa455ba8c619a6(input) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var indices, existing, index, stack;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    indices = this.indices;
                    existing = indices.get(input);
                    if (existing) return [
                        2,
                        [
                            existing
                        ]
                    ];
                    if (input === void 0) return [
                        2,
                        -7
                    ];
                    if (input === null) return [
                        2,
                        -5
                    ];
                    if (Number.isNaN(input)) return [
                        2,
                        -2
                    ];
                    if (input === Number.POSITIVE_INFINITY) return [
                        2,
                        -6
                    ];
                    if (input === Number.NEGATIVE_INFINITY) return [
                        2,
                        -3
                    ];
                    if (input === 0 && 1 / input < 0) return [
                        2,
                        -4
                    ];
                    index = this.index++;
                    indices.set(input, index);
                    stack = [
                        [
                            input,
                            index
                        ]
                    ];
                    return [
                        4,
                        $0d581330596ecb05$var$stringify.call(this, stack)
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        index
                    ];
            }
        });
    }).call(this);
}
function $0d581330596ecb05$var$stringify(stack) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var _this, _this1, deferred, indices, plugins, postPlugins, str, lastYieldTime, flattenValue, i, now, _stack_pop, input, index, partsForObj, error, keyFor, isArray, pluginHandled, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, plugin, pluginResult, _pluginResult, pluginIdentifier, rest, result, i1, dateTime, isArray1, pluginHandled1, _iteratorNormalCompletion1, _didIteratorError1, _iteratorError1, _iterator1, _step1, plugin1, pluginResult1, _pluginResult1, pluginIdentifier1, rest1, pluginHandled2, _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, plugin2, pluginResult2, _pluginResult2, pluginIdentifier2, rest2;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _this = this;
                    _this1 = this, deferred = _this1.deferred, indices = _this1.indices, plugins = _this1.plugins, postPlugins = _this1.postPlugins;
                    str = this.stringified;
                    lastYieldTime = $0d581330596ecb05$var$getNow();
                    flattenValue = function(value) {
                        var existing = indices.get(value);
                        if (existing) return [
                            existing
                        ];
                        if (value === void 0) return -7;
                        if (value === null) return -5;
                        if (Number.isNaN(value)) return -2;
                        if (value === Number.POSITIVE_INFINITY) return -6;
                        if (value === Number.NEGATIVE_INFINITY) return -3;
                        if (value === 0 && 1 / value < 0) return -4;
                        var index = _this.index++;
                        indices.set(value, index);
                        stack.push([
                            value,
                            index
                        ]);
                        return index;
                    };
                    i = 0;
                    _state.label = 1;
                case 1:
                    if (!(stack.length > 0)) return [
                        3,
                        4
                    ];
                    now = $0d581330596ecb05$var$getNow();
                    if (!(++i % 6e3 === 0 && now - lastYieldTime >= $0d581330596ecb05$var$TIME_LIMIT_MS)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        $0d581330596ecb05$var$yieldToMain()
                    ];
                case 2:
                    _state.sent();
                    lastYieldTime = $0d581330596ecb05$var$getNow();
                    _state.label = 3;
                case 3:
                    _stack_pop = (0, $21h22._)(stack.pop(), 2), input = _stack_pop[0], index = _stack_pop[1];
                    partsForObj = function(obj) {
                        return Object.keys(obj).map(function(k) {
                            return '"_'.concat(flattenValue(k), '":').concat(flattenValue(obj[k]));
                        }).join(",");
                    };
                    error = null;
                    switch(typeof input === "undefined" ? "undefined" : (0, $2bfPH._)(input)){
                        case "boolean":
                        case "number":
                        case "string":
                            str[index] = JSON.stringify(input);
                            break;
                        case "bigint":
                            str[index] = '["B","'.concat(input, '"]');
                            break;
                        case "symbol":
                            {
                                keyFor = Symbol.keyFor(input);
                                if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                                else str[index] = '["Y",'.concat(JSON.stringify(keyFor), "]");
                                break;
                            }
                        case "object":
                            {
                                if (!input) {
                                    str[index] = "-5";
                                    break;
                                }
                                isArray = Array.isArray(input);
                                pluginHandled = false;
                                _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                if (!isArray && plugins) try {
                                    for(_iterator = plugins[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        plugin = _step.value;
                                        pluginResult = plugin(input);
                                        if (Array.isArray(pluginResult)) {
                                            pluginHandled = true;
                                            _pluginResult = (0, $ggKxj._)(pluginResult), pluginIdentifier = _pluginResult[0], rest = _pluginResult.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier));
                                            if (rest.length > 0) str[index] += ",".concat(rest.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                if (!pluginHandled) {
                                    result = isArray ? "[" : "{";
                                    if (isArray) {
                                        for(i1 = 0; i1 < input.length; i1++)result += (i1 ? "," : "") + (i1 in input ? flattenValue(input[i1]) : -1);
                                        str[index] = "".concat(result, "]");
                                    } else if (input instanceof Date) {
                                        dateTime = input.getTime();
                                        str[index] = '["D",'.concat(Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime, "]");
                                    } else if (input instanceof URL) str[index] = '["U",'.concat(JSON.stringify(input.href), "]");
                                    else if (input instanceof RegExp) str[index] = '["R",'.concat(JSON.stringify(input.source), ",").concat(JSON.stringify(input.flags), "]");
                                    else if (input instanceof Set) {
                                        if (input.size > 0) str[index] = '["S",'.concat((0, $6zk1M._)(input).map(function(val) {
                                            return flattenValue(val);
                                        }).join(","), "]");
                                        else str[index] = '["S"]';
                                    } else if (input instanceof Map) {
                                        if (input.size > 0) str[index] = '["M",'.concat((0, $6zk1M._)(input).flatMap(function(param) {
                                            var _param = (0, $21h22._)(param, 2), k = _param[0], v = _param[1];
                                            return [
                                                flattenValue(k),
                                                flattenValue(v)
                                            ];
                                        }).join(","), "]");
                                        else str[index] = '["M"]';
                                    } else if (input instanceof Promise) {
                                        str[index] = '["P",'.concat(index, "]");
                                        deferred[index] = input;
                                    } else if (input instanceof Error) {
                                        str[index] = '["E",'.concat(JSON.stringify(input.message));
                                        if (input.name !== "Error") str[index] += ",".concat(JSON.stringify(input.name));
                                        str[index] += "]";
                                    } else if (Object.getPrototypeOf(input) === null) str[index] = '["N",{'.concat(partsForObj(input), "}]");
                                    else if ($0d581330596ecb05$var$isPlainObject(input)) str[index] = "{".concat(partsForObj(input), "}");
                                    else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                                }
                                break;
                            }
                        default:
                            {
                                isArray1 = Array.isArray(input);
                                pluginHandled1 = false;
                                _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                                if (!isArray1 && plugins) try {
                                    for(_iterator1 = plugins[Symbol.iterator](); !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                                        plugin1 = _step1.value;
                                        pluginResult1 = plugin1(input);
                                        if (Array.isArray(pluginResult1)) {
                                            pluginHandled1 = true;
                                            _pluginResult1 = (0, $ggKxj._)(pluginResult1), pluginIdentifier1 = _pluginResult1[0], rest1 = _pluginResult1.slice(1);
                                            str[index] = "[".concat(JSON.stringify(pluginIdentifier1));
                                            if (rest1.length > 0) str[index] += ",".concat(rest1.map(function(v) {
                                                return flattenValue(v);
                                            }).join(","));
                                            str[index] += "]";
                                            break;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError1 = true;
                                    _iteratorError1 = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                                            _iterator1.return();
                                        }
                                    } finally{
                                        if (_didIteratorError1) {
                                            throw _iteratorError1;
                                        }
                                    }
                                }
                                if (!pluginHandled1) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                            }
                    }
                    if (error) {
                        pluginHandled2 = false;
                        _iteratorNormalCompletion2 = true, _didIteratorError2 = false, _iteratorError2 = undefined;
                        if (postPlugins) try {
                            for(_iterator2 = postPlugins[Symbol.iterator](); !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true){
                                plugin2 = _step2.value;
                                pluginResult2 = plugin2(input);
                                if (Array.isArray(pluginResult2)) {
                                    pluginHandled2 = true;
                                    _pluginResult2 = (0, $ggKxj._)(pluginResult2), pluginIdentifier2 = _pluginResult2[0], rest2 = _pluginResult2.slice(1);
                                    str[index] = "[".concat(JSON.stringify(pluginIdentifier2));
                                    if (rest2.length > 0) str[index] += ",".concat(rest2.map(function(v) {
                                        return flattenValue(v);
                                    }).join(","));
                                    str[index] += "]";
                                    break;
                                }
                            }
                        } catch (err) {
                            _didIteratorError2 = true;
                            _iteratorError2 = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion2 && _iterator2.return != null) {
                                    _iterator2.return();
                                }
                            } finally{
                                if (_didIteratorError2) {
                                    throw _iteratorError2;
                                }
                            }
                        }
                        if (!pluginHandled2) throw error;
                    }
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
var $0d581330596ecb05$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $0d581330596ecb05$var$isPlainObject(thing) {
    var proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $0d581330596ecb05$var$objectProtoNames;
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $daRwM = parcelRequire("daRwM");

//#region vendor/turbo-stream-v2/unflatten.ts
var $cbb80786eeb3070b$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $cbb80786eeb3070b$export$4315a2af848d75d7(parsed) {
    var _this = this, hydrated = _this.hydrated, values = _this.values;
    if (typeof parsed === "number") return $cbb80786eeb3070b$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    var startIndex = values.length;
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = parsed[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var value = _step.value;
            values.push(value);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    hydrated.length = values.length;
    return $cbb80786eeb3070b$var$hydrate.call(this, startIndex);
}
function $cbb80786eeb3070b$var$hydrate(index) {
    var _loop = function() {
        var _stack_pop = (0, $21h22._)(stack.pop(), 2), _$index = _stack_pop[0], set = _stack_pop[1];
        switch(_$index){
            case -7:
                set(void 0);
                return "continue";
            case -5:
                set(null);
                return "continue";
            case -2:
                set(NaN);
                return "continue";
            case -6:
                set(Infinity);
                return "continue";
            case -3:
                set(-Infinity);
                return "continue";
            case -4:
                set(-0);
                return "continue";
        }
        if (hydrated[_$index]) {
            set(hydrated[_$index]);
            return "continue";
        }
        var value = values[_$index];
        if (!value || (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) !== "object") {
            hydrated[_$index] = value;
            set(value);
            return "continue";
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                var _value = (0, $21h22._)(value, 3), type = _value[0], b = _value[1], c = _value[2];
                switch(type){
                    case "D":
                        set(hydrated[_$index] = new Date(b));
                        return "continue";
                    case "U":
                        set(hydrated[_$index] = new URL(b));
                        return "continue";
                    case "B":
                        set(hydrated[_$index] = BigInt(b));
                        return "continue";
                    case "R":
                        set(hydrated[_$index] = new RegExp(b, c));
                        return "continue";
                    case "Y":
                        set(hydrated[_$index] = Symbol.for(b));
                        return "continue";
                    case "S":
                        var newSet = /* @__PURE__ */ new Set();
                        hydrated[_$index] = newSet;
                        for(var i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            function(v) {
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        return "continue";
                    case "M":
                        var _loop = function(i1) {
                            var r = [];
                            stack.push([
                                value[i1 + 1],
                                function(v) {
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i1],
                                function(k) {
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(function() {
                                map.set(r[0], r[1]);
                            });
                        };
                        var map = /* @__PURE__ */ new Map();
                        hydrated[_$index] = map;
                        for(var i1 = value.length - 2; i1 > 0; i1 -= 2)_loop(i1);
                        set(map);
                        return "continue";
                    case "N":
                        var obj = Object.create(null);
                        hydrated[_$index] = obj;
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            var _loop1 = function() {
                                var key = _step.value;
                                var r = [];
                                stack.push([
                                    b[key],
                                    function(v) {
                                        r[1] = v;
                                    }
                                ]);
                                stack.push([
                                    Number(key.slice(1)),
                                    function(k) {
                                        r[0] = k;
                                    }
                                ]);
                                postRun.push(function() {
                                    obj[r[0]] = r[1];
                                });
                            };
                            for(var _iterator = Object.keys(b).reverse()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop1();
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        set(obj);
                        return "continue";
                    case "P":
                        if (hydrated[b]) set(hydrated[_$index] = hydrated[b]);
                        else {
                            var d = new (0, $298e207a265b7b64$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[_$index] = d.promise);
                        }
                        return "continue";
                    case "E":
                        var _value1 = (0, $21h22._)(value, 3), message = _value1[1], errorType = _value1[2];
                        var error = errorType && $cbb80786eeb3070b$var$globalObj && (0, $daRwM.SUPPORTED_ERROR_TYPES).includes(errorType) && errorType in $cbb80786eeb3070b$var$globalObj && typeof $cbb80786eeb3070b$var$globalObj[errorType] === "function" ? new $cbb80786eeb3070b$var$globalObj[errorType](message) : new Error(message);
                        hydrated[_$index] = error;
                        set(error);
                        return "continue";
                    case "Z":
                        set(hydrated[_$index] = hydrated[b]);
                        return "continue";
                    default:
                        if (Array.isArray(plugins)) {
                            var _loop2 = function(i2) {
                                var v = vals[i2];
                                stack.push([
                                    v,
                                    function(v) {
                                        r[i2] = v;
                                    }
                                ]);
                            };
                            var r = [];
                            var vals = value.slice(1);
                            for(var i2 = 0; i2 < vals.length; i2++)_loop2(i2);
                            postRun.push(function() {
                                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                                try {
                                    for(var _iterator = plugins[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                        var plugin = _step.value;
                                        var result = plugin.apply(void 0, [
                                            value[0]
                                        ].concat((0, $6zk1M._)(r)));
                                        if (result) {
                                            set(hydrated[_$index] = result.value);
                                            return;
                                        }
                                    }
                                } catch (err) {
                                    _didIteratorError = true;
                                    _iteratorError = err;
                                } finally{
                                    try {
                                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                                            _iterator.return();
                                        }
                                    } finally{
                                        if (_didIteratorError) {
                                            throw _iteratorError;
                                        }
                                    }
                                }
                                throw new SyntaxError();
                            });
                            return "continue";
                        }
                        throw new SyntaxError();
                }
            } else {
                var _loop3 = function(i3) {
                    var n = value[i3];
                    if (n !== -1) stack.push([
                        n,
                        function(v) {
                            array[i3] = v;
                        }
                    ]);
                };
                var array = [];
                hydrated[_$index] = array;
                for(var i3 = 0; i3 < value.length; i3++)_loop3(i3);
                set(array);
                return "continue";
            }
        } else {
            var object = {};
            hydrated[_$index] = object;
            var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
            try {
                var _loop4 = function() {
                    var key = _step1.value;
                    var r = [];
                    stack.push([
                        value[key],
                        function(v) {
                            r[1] = v;
                        }
                    ]);
                    stack.push([
                        Number(key.slice(1)),
                        function(k) {
                            r[0] = k;
                        }
                    ]);
                    postRun.push(function() {
                        object[r[0]] = r[1];
                    });
                };
                for(var _iterator1 = Object.keys(value).reverse()[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true)_loop4();
            } catch (err) {
                _didIteratorError1 = true;
                _iteratorError1 = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                        _iterator1.return();
                    }
                } finally{
                    if (_didIteratorError1) {
                        throw _iteratorError1;
                    }
                }
            }
            set(object);
            return "continue";
        }
    };
    var _this = this, hydrated = _this.hydrated, values = _this.values, deferred = _this.deferred, plugins = _this.plugins;
    var result;
    var stack = [
        [
            index,
            function(v) {
                result = v;
            }
        ]
    ];
    var postRun = [];
    while(stack.length > 0)_loop();
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
function $1cb9a9303aa06f52$export$2f872c0f2117be69(readable, options) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var plugins, done, reader, decoder, decoded, donePromise;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    plugins = (options !== null && options !== void 0 ? options : {}).plugins;
                    done = new (0, $298e207a265b7b64$export$85f6557964517f1a)();
                    reader = readable.pipeThrough((0, $298e207a265b7b64$export$4786a9f20844482d)()).getReader();
                    decoder = {
                        values: [],
                        hydrated: [],
                        deferred: {},
                        plugins: plugins
                    };
                    return [
                        4,
                        $1cb9a9303aa06f52$var$decodeInitial.call(decoder, reader)
                    ];
                case 1:
                    decoded = _state.sent();
                    donePromise = done.promise;
                    if (decoded.done) done.resolve();
                    else donePromise = $1cb9a9303aa06f52$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch(function(reason) {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = Object.values(decoder.deferred)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var deferred = _step.value;
                                deferred.reject(reason);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                        done.reject(reason);
                    });
                    return [
                        2,
                        {
                            done: donePromise.then(function() {
                                return reader.closed;
                            }),
                            value: decoded.value
                        }
                    ];
            }
        });
    })();
}
function $1cb9a9303aa06f52$var$decodeInitial(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var read, line;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    if (!read.value) throw new SyntaxError();
                    try {
                        line = JSON.parse(read.value);
                    } catch (e) {
                        throw new SyntaxError();
                    }
                    return [
                        2,
                        {
                            done: read.done,
                            value: (0, $cbb80786eeb3070b$export$4315a2af848d75d7).call(this, line)
                        }
                    ];
            }
        });
    }).call(this);
}
function $1cb9a9303aa06f52$var$decodeDeferred(reader) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var read, line, colonIndex, deferredId, deferred, lineData, jsonLine, value, colonIndex1, deferredId1, deferred1, lineData1, jsonLine1, value1;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        reader.read()
                    ];
                case 1:
                    read = _state.sent();
                    _state.label = 2;
                case 2:
                    if (!!read.done) return [
                        3,
                        4
                    ];
                    if (!read.value) return [
                        3,
                        2
                    ];
                    line = read.value;
                    switch(line[0]){
                        case "P":
                            {
                                colonIndex = line.indexOf(":");
                                deferredId = Number(line.slice(1, colonIndex));
                                deferred = this.deferred[deferredId];
                                if (!deferred) throw new Error("Deferred ID ".concat(deferredId, " not found in stream"));
                                lineData = line.slice(colonIndex + 1);
                                jsonLine = void 0;
                                try {
                                    jsonLine = JSON.parse(lineData);
                                } catch (e) {
                                    throw new SyntaxError();
                                }
                                value = (0, $cbb80786eeb3070b$export$4315a2af848d75d7).call(this, jsonLine);
                                deferred.resolve(value);
                                break;
                            }
                        case "E":
                            {
                                colonIndex1 = line.indexOf(":");
                                deferredId1 = Number(line.slice(1, colonIndex1));
                                deferred1 = this.deferred[deferredId1];
                                if (!deferred1) throw new Error("Deferred ID ".concat(deferredId1, " not found in stream"));
                                lineData1 = line.slice(colonIndex1 + 1);
                                jsonLine1 = void 0;
                                try {
                                    jsonLine1 = JSON.parse(lineData1);
                                } catch (e) {
                                    throw new SyntaxError();
                                }
                                value1 = (0, $cbb80786eeb3070b$export$4315a2af848d75d7).call(this, jsonLine1);
                                deferred1.reject(value1);
                                break;
                            }
                        default:
                            throw new SyntaxError();
                    }
                    return [
                        4,
                        reader.read()
                    ];
                case 3:
                    read = _state.sent();
                    return [
                        3,
                        2
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).call(this);
}
function $1cb9a9303aa06f52$export$c564cdbbe6da493(input, options) {
    var _ref = options !== null && options !== void 0 ? options : {}, onComplete = _ref.onComplete, plugins = _ref.plugins, postPlugins = _ref.postPlugins, signal = _ref.signal;
    var encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    var textEncoder = new TextEncoder();
    var lastSentIndex = 0;
    return new ReadableStream({
        start: function(controller) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var id, seenPromises, processingChain, raceDone, racePromise, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _loop, _iterator, _step;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                4,
                                (0, $0d581330596ecb05$export$bffa455ba8c619a6).call(encoder, input)
                            ];
                        case 1:
                            id = _state.sent();
                            if (Array.isArray(id)) throw new Error("This should never happen");
                            if (id < 0) controller.enqueue(textEncoder.encode("".concat(id, "\n")));
                            else {
                                controller.enqueue(textEncoder.encode("[".concat(encoder.stringified.join(","), "]\n")));
                                lastSentIndex = encoder.stringified.length - 1;
                            }
                            seenPromises = /* @__PURE__ */ new WeakSet();
                            processingChain = Promise.resolve();
                            if (!Object.keys(encoder.deferred).length) return [
                                3,
                                5
                            ];
                            racePromise = new Promise(function(resolve, reject) {
                                raceDone = resolve;
                                if (signal) {
                                    var rejectPromise = function() {
                                        return reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                                    };
                                    if (signal.aborted) rejectPromise();
                                    else signal.addEventListener("abort", function(event) {
                                        rejectPromise();
                                    });
                                }
                            });
                            _state.label = 2;
                        case 2:
                            if (!(Object.keys(encoder.deferred).length > 0)) return [
                                3,
                                4
                            ];
                            _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                            try {
                                _loop = function() {
                                    var _step_value = (0, $21h22._)(_step.value, 2), deferredId = _step_value[0], deferred = _step_value[1];
                                    if (seenPromises.has(deferred)) return "continue";
                                    seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                                        racePromise,
                                        deferred
                                    ]).then(function(resolved) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                var id, values;
                                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                (0, $0d581330596ecb05$export$bffa455ba8c619a6).call(encoder, resolved)
                                                            ];
                                                        case 1:
                                                            id = _state.sent();
                                                            if (Array.isArray(id)) {
                                                                controller.enqueue(textEncoder.encode("P".concat(deferredId, ':[["Z",').concat(id[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id < 0) controller.enqueue(textEncoder.encode("P".concat(deferredId, ":").concat(id, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("P".concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }, function(reason) {
                                        processingChain = processingChain.then(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                var id, values;
                                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            if (!reason || (typeof reason === "undefined" ? "undefined" : (0, $2bfPH._)(reason)) !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                                            return [
                                                                4,
                                                                (0, $0d581330596ecb05$export$bffa455ba8c619a6).call(encoder, reason)
                                                            ];
                                                        case 1:
                                                            id = _state.sent();
                                                            if (Array.isArray(id)) {
                                                                controller.enqueue(textEncoder.encode("E".concat(deferredId, ':[["Z",').concat(id[0], "]]\n")));
                                                                encoder.index++;
                                                                lastSentIndex++;
                                                            } else if (id < 0) controller.enqueue(textEncoder.encode("E".concat(deferredId, ":").concat(id, "\n")));
                                                            else {
                                                                values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                                                controller.enqueue(textEncoder.encode("E".concat(deferredId, ":[").concat(values, "]\n")));
                                                                lastSentIndex = encoder.stringified.length - 1;
                                                            }
                                                            return [
                                                                2
                                                            ];
                                                    }
                                                });
                                            })();
                                        });
                                        return processingChain;
                                    }).finally(function() {
                                        delete encoder.deferred[Number(deferredId)];
                                    }));
                                };
                                for(_iterator = Object.entries(encoder.deferred)[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                            } catch (err) {
                                _didIteratorError = true;
                                _iteratorError = err;
                            } finally{
                                try {
                                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                                        _iterator.return();
                                    }
                                } finally{
                                    if (_didIteratorError) {
                                        throw _iteratorError;
                                    }
                                }
                            }
                            return [
                                4,
                                Promise.race(Object.values(encoder.deferred))
                            ];
                        case 3:
                            _state.sent();
                            return [
                                3,
                                2
                            ];
                        case 4:
                            raceDone();
                            _state.label = 5;
                        case 5:
                            return [
                                4,
                                Promise.all(Object.values(encoder.deferred))
                            ];
                        case 6:
                            _state.sent();
                            return [
                                4,
                                processingChain
                            ];
                        case 7:
                            _state.sent();
                            controller.close();
                            onComplete === null || onComplete === void 0 ? void 0 : onComplete();
                            return [
                                2
                            ];
                    }
                });
            })();
        }
    });
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts


function $2667c4daa679c91b$export$a30aa2a0fce6c468(request) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var init, contentType, _, _1;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    init = {
                        signal: request.signal
                    };
                    if (!(request.method !== "GET")) return [
                        3,
                        8
                    ];
                    init.method = request.method;
                    contentType = request.headers.get("Content-Type");
                    if (!(contentType && /\bapplication\/json\b/.test(contentType))) return [
                        3,
                        2
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    _ = JSON.stringify;
                    return [
                        4,
                        request.json()
                    ];
                case 1:
                    init.body = _.apply(JSON, [
                        _state.sent()
                    ]);
                    return [
                        3,
                        8
                    ];
                case 2:
                    if (!(contentType && /\btext\/plain\b/.test(contentType))) return [
                        3,
                        4
                    ];
                    init.headers = {
                        "Content-Type": contentType
                    };
                    return [
                        4,
                        request.text()
                    ];
                case 3:
                    init.body = _state.sent();
                    return [
                        3,
                        8
                    ];
                case 4:
                    if (!(contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType))) return [
                        3,
                        6
                    ];
                    _1 = URLSearchParams.bind;
                    return [
                        4,
                        request.text()
                    ];
                case 5:
                    init.body = new (_1.apply(URLSearchParams, [
                        void 0,
                        _state.sent()
                    ]));
                    return [
                        3,
                        8
                    ];
                case 6:
                    return [
                        4,
                        request.formData()
                    ];
                case 7:
                    init.body = _state.sent();
                    _state.label = 8;
                case 8:
                    return [
                        2,
                        init
                    ];
            }
        });
    })();
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/single-fetch.tsx
var $0150e526bd929793$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $0150e526bd929793$var$SingleFetchNoResultError = /*#__PURE__*/ function(Error1) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(SingleFetchNoResultError, Error1);
    function SingleFetchNoResultError() {
        (0, $gd0sY._)(this, SingleFetchNoResultError);
        return (0, $638732d3362fdd56$export$71511d61b312f219)(this, SingleFetchNoResultError, arguments);
    }
    return SingleFetchNoResultError;
}((0, $9f87b386401b733e$export$71511d61b312f219)(Error));
var $0150e526bd929793$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $0150e526bd929793$export$2b0b5f24fd77a79f(param) {
    var context = param.context, identifier = param.identifier, reader = param.reader, textDecoder = param.textDecoder, nonce = param.nonce;
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    var streamCache = context.renderMeta.streamCache;
    var promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then(function(result) {
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch(function(e) {
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    var _promise_result = promise.result, done = _promise_result.done, value = _promise_result.value;
    var scriptTag = value ? /* @__PURE__ */ $eHaBZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.enqueue(".concat((0, $77cc0322f8b62577$export$4cf11838cdc2a8a8)(JSON.stringify(value)), ");")
        }
    }) : null;
    if (done) return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, scriptTag, /* @__PURE__ */ $eHaBZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: "window.__reactRouterContext.streamController.close();"
        }
    }));
    else return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, scriptTag, /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Suspense, null, /* @__PURE__ */ $eHaBZ.createElement($0150e526bd929793$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $0150e526bd929793$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    var dataStrategy = $0150e526bd929793$export$7144ac7f1a8613d3(getRouter, function(match) {
        var manifestRoute = manifest.routes[match.route.id];
        (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $0150e526bd929793$var$fetchAndDecodeViaTurboStream, ssr);
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                return [
                    2,
                    args.runClientMiddleware(dataStrategy)
                ];
            });
        })();
    };
}
function $0150e526bd929793$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr) {
    var shouldAllowOptOut = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : function() {
        return true;
    };
    return function(args) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var request, matches, fetcherKey, router, foundRevalidatingServerLoader;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                request = args.request, matches = args.matches, fetcherKey = args.fetcherKey;
                router = getRouter();
                if (request.method !== "GET") return [
                    2,
                    $0150e526bd929793$var$singleFetchActionStrategy(args, fetchAndDecode)
                ];
                foundRevalidatingServerLoader = matches.some(function(m) {
                    var _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                    return m.shouldCallHandler() && hasLoader && !hasClientLoader;
                });
                if (!ssr && !foundRevalidatingServerLoader) return [
                    2,
                    $0150e526bd929793$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode)
                ];
                if (fetcherKey) return [
                    2,
                    $0150e526bd929793$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode)
                ];
                return [
                    2,
                    $0150e526bd929793$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut)
                ];
            });
        })();
    };
}
function $0150e526bd929793$var$singleFetchActionStrategy(args, fetchAndDecode) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var actionMatch, actionStatus, result;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    actionMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(actionMatch, "No action match found");
                    actionStatus = void 0;
                    return [
                        4,
                        actionMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                    switch(_state.label){
                                        case 0:
                                            return [
                                                4,
                                                handler(function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                        var _ref, _$data, status;
                                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                            switch(_state.label){
                                                                case 0:
                                                                    return [
                                                                        4,
                                                                        fetchAndDecode(args, [
                                                                            actionMatch.route.id
                                                                        ])
                                                                    ];
                                                                case 1:
                                                                    _ref = _state.sent(), _$data = _ref.data, status = _ref.status;
                                                                    actionStatus = status;
                                                                    return [
                                                                        2,
                                                                        $0150e526bd929793$var$unwrapSingleFetchResult(_$data, actionMatch.route.id)
                                                                    ];
                                                            }
                                                        });
                                                    })();
                                                })
                                            ];
                                        case 1:
                                            return [
                                                2,
                                                _state.sent()
                                            ];
                                    }
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    if ((0, $d8c8e9691ac1f69a$export$3f1eb41d9a6a6a27)(result.result) || (0, $daRwM.isRouteErrorResponse)(result.result) || (0, $d8c8e9691ac1f69a$export$e0163cfdf7bc9cfa)(result.result)) return [
                        2,
                        (0, $khBmn._)({}, actionMatch.route.id, result)
                    ];
                    return [
                        2,
                        (0, $khBmn._)({}, actionMatch.route.id, {
                            type: result.type,
                            result: (0, $daRwM.data)(result.result, actionStatus)
                        })
                    ];
            }
        });
    })();
}
function $0150e526bd929793$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var matchesToLoad, results;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    matchesToLoad = args.matches.filter(function(m) {
                        return m.shouldCallHandler();
                    });
                    results = {};
                    return [
                        4,
                        Promise.all(matchesToLoad.map(function(m) {
                            return m.resolve(function(handler) {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    var hasClientLoader, routeId, result, _tmp, e;
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    5,
                                                    ,
                                                    6
                                                ]);
                                                hasClientLoader = getRouteInfo(m).hasClientLoader;
                                                routeId = m.route.id;
                                                if (!hasClientLoader) return [
                                                    3,
                                                    2
                                                ];
                                                return [
                                                    4,
                                                    handler(function() {
                                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                            var data;
                                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                switch(_state.label){
                                                                    case 0:
                                                                        return [
                                                                            4,
                                                                            fetchAndDecode(args, [
                                                                                routeId
                                                                            ])
                                                                        ];
                                                                    case 1:
                                                                        data = _state.sent().data;
                                                                        return [
                                                                            2,
                                                                            $0150e526bd929793$var$unwrapSingleFetchResult(data, routeId)
                                                                        ];
                                                                }
                                                            });
                                                        })();
                                                    })
                                                ];
                                            case 1:
                                                _tmp = _state.sent();
                                                return [
                                                    3,
                                                    4
                                                ];
                                            case 2:
                                                return [
                                                    4,
                                                    handler()
                                                ];
                                            case 3:
                                                _tmp = _state.sent();
                                                _state.label = 4;
                                            case 4:
                                                result = _tmp;
                                                results[m.route.id] = {
                                                    type: "data",
                                                    result: result
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 5:
                                                e = _state.sent();
                                                results[m.route.id] = {
                                                    type: "error",
                                                    result: e
                                                };
                                                return [
                                                    3,
                                                    6
                                                ];
                                            case 6:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            });
                        }))
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function $0150e526bd929793$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr) {
    var shouldAllowOptOut = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : function() {
        return true;
    };
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var routesParams, foundOptOutRoute, routeDfds, singleFetchDfd, results, resolvePromise, targetRoutes, data, e;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routesParams = /* @__PURE__ */ new Set();
                    foundOptOutRoute = false;
                    routeDfds = args.matches.map(function() {
                        return $0150e526bd929793$var$createDeferred();
                    });
                    singleFetchDfd = $0150e526bd929793$var$createDeferred();
                    results = {};
                    resolvePromise = Promise.all(args.matches.map(function(m, i) {
                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                return [
                                    2,
                                    m.resolve(function(handler) {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                            var routeId, _getRouteInfo, hasLoader, hasClientLoader, defaultShouldRevalidate, _tmp, e, _tmp1, e1;
                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                switch(_state.label){
                                                    case 0:
                                                        routeDfds[i].resolve();
                                                        routeId = m.route.id;
                                                        _getRouteInfo = getRouteInfo(m), hasLoader = _getRouteInfo.hasLoader, hasClientLoader = _getRouteInfo.hasClientLoader;
                                                        defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
                                                        if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                                                            foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && hasLoader);
                                                            return [
                                                                2
                                                            ];
                                                        }
                                                        if (!(shouldAllowOptOut(m) && hasClientLoader)) return [
                                                            3,
                                                            5
                                                        ];
                                                        if (hasLoader) foundOptOutRoute = true;
                                                        _state.label = 1;
                                                    case 1:
                                                        _state.trys.push([
                                                            1,
                                                            3,
                                                            ,
                                                            4
                                                        ]);
                                                        _tmp = {
                                                            type: "data"
                                                        };
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                                    var data;
                                                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    fetchAndDecode(args, [
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                            case 1:
                                                                                data = _state.sent().data;
                                                                                return [
                                                                                    2,
                                                                                    $0150e526bd929793$var$unwrapSingleFetchResult(data, routeId)
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 2:
                                                        results[routeId] = (_tmp.result = _state.sent(), _tmp);
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 3:
                                                        e = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e
                                                        };
                                                        return [
                                                            3,
                                                            4
                                                        ];
                                                    case 4:
                                                        return [
                                                            2
                                                        ];
                                                    case 5:
                                                        if (hasLoader) routesParams.add(routeId);
                                                        _state.label = 6;
                                                    case 6:
                                                        _state.trys.push([
                                                            6,
                                                            8,
                                                            ,
                                                            9
                                                        ]);
                                                        _tmp1 = {
                                                            type: "data"
                                                        };
                                                        return [
                                                            4,
                                                            handler(function() {
                                                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                        switch(_state.label){
                                                                            case 0:
                                                                                return [
                                                                                    4,
                                                                                    singleFetchDfd.promise
                                                                                ];
                                                                            case 1:
                                                                                return [
                                                                                    2,
                                                                                    $0150e526bd929793$var$unwrapSingleFetchResult.apply(void 0, [
                                                                                        _state.sent(),
                                                                                        routeId
                                                                                    ])
                                                                                ];
                                                                        }
                                                                    });
                                                                })();
                                                            })
                                                        ];
                                                    case 7:
                                                        results[routeId] = (_tmp1.result = _state.sent(), _tmp1);
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 8:
                                                        e1 = _state.sent();
                                                        results[routeId] = {
                                                            type: "error",
                                                            result: e1
                                                        };
                                                        return [
                                                            3,
                                                            9
                                                        ];
                                                    case 9:
                                                        return [
                                                            2
                                                        ];
                                                }
                                            });
                                        })();
                                    })
                                ];
                            });
                        })();
                    }));
                    return [
                        4,
                        Promise.all(routeDfds.map(function(d) {
                            return d.promise;
                        }))
                    ];
                case 1:
                    _state.sent();
                    if (!((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive)) return [
                        3,
                        2
                    ];
                    singleFetchDfd.resolve({
                        routes: {}
                    });
                    return [
                        3,
                        6
                    ];
                case 2:
                    targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? (0, $6zk1M._)(routesParams.keys()) : void 0;
                    _state.label = 3;
                case 3:
                    _state.trys.push([
                        3,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetchAndDecode(args, targetRoutes)
                    ];
                case 4:
                    data = _state.sent();
                    singleFetchDfd.resolve(data.data);
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    singleFetchDfd.reject(e);
                    return [
                        3,
                        6
                    ];
                case 6:
                    return [
                        4,
                        resolvePromise
                    ];
                case 7:
                    _state.sent();
                    return [
                        4,
                        $0150e526bd929793$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results)
                    ];
                case 8:
                    _state.sent();
                    return [
                        2,
                        results
                    ];
            }
        });
    })();
}
function $0150e526bd929793$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var middlewareError, fetchedData, _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, match, routeResult, _results_match_route_id, e;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        singleFetchPromise
                    ];
                case 1:
                    fetchedData = _state.sent();
                    if ("routes" in fetchedData) {
                        _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(_iterator = matches[Symbol.iterator](); !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                match = _step.value;
                                if (match.route.id in fetchedData.routes) {
                                    routeResult = fetchedData.routes[match.route.id];
                                    if ("error" in routeResult) {
                                        ;
                                        middlewareError = routeResult.error;
                                        if (((_results_match_route_id = results[match.route.id]) === null || _results_match_route_id === void 0 ? void 0 : _results_match_route_id.result) == null) results[match.route.id] = {
                                            type: "error",
                                            result: middlewareError
                                        };
                                        break;
                                    }
                                }
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    }
                    if (middlewareError !== void 0) Array.from(routesParams.values()).forEach(function(routeId) {
                        if (results[routeId].result instanceof $0150e526bd929793$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
                    });
                    return [
                        3,
                        3
                    ];
                case 2:
                    e = _state.sent();
                    return [
                        3,
                        3
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0150e526bd929793$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var fetcherMatch, routeId, result;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    fetcherMatch = args.matches.find(function(m) {
                        return m.shouldCallHandler();
                    });
                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
                    routeId = fetcherMatch.route.id;
                    return [
                        4,
                        fetcherMatch.resolve(function(handler) {
                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                    return [
                                        2,
                                        handler(function() {
                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                var data;
                                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                    switch(_state.label){
                                                        case 0:
                                                            return [
                                                                4,
                                                                fetchAndDecode(args, [
                                                                    routeId
                                                                ])
                                                            ];
                                                        case 1:
                                                            data = _state.sent().data;
                                                            return [
                                                                2,
                                                                $0150e526bd929793$var$unwrapSingleFetchResult(data, routeId)
                                                            ];
                                                    }
                                                });
                                            })();
                                        })
                                    ];
                                });
                            })();
                        })
                    ];
                case 1:
                    result = _state.sent();
                    return [
                        2,
                        (0, $khBmn._)({}, fetcherMatch.route.id, result)
                    ];
            }
        });
    })();
}
function $0150e526bd929793$export$425969b7f98e2c9c(url) {
    var indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    var indexValuesToKeep = [];
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = indexValues[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var indexValue = _step.value;
            if (indexValue) indexValuesToKeep.push(indexValue);
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
    try {
        for(var _iterator1 = indexValuesToKeep[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
            var toKeep = _step1.value;
            url.searchParams.append("index", toKeep);
        }
    } catch (err) {
        _didIteratorError1 = true;
        _iteratorError1 = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                _iterator1.return();
            }
        } finally{
            if (_didIteratorError1) {
                throw _iteratorError1;
            }
        }
    }
    return url;
}
function $0150e526bd929793$export$7b977381851b2c(reqUrl, extension) {
    var url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = "".concat(url.pathname, "_.").concat(extension);
    else url.pathname = "".concat(url.pathname, ".").concat(extension);
    return url;
}
function $0150e526bd929793$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var request, url, res, _tmp, _, _tmp1, routes, decoded, data, typed, typed1, routeId, e;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    request = args.request;
                    url = $0150e526bd929793$export$7b977381851b2c(request.url, "data");
                    if (request.method === "GET") {
                        url = $0150e526bd929793$export$425969b7f98e2c9c(url);
                        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
                    }
                    _tmp = [
                        url
                    ];
                    return [
                        4,
                        (0, $2667c4daa679c91b$export$a30aa2a0fce6c468)(request)
                    ];
                case 1:
                    return [
                        4,
                        fetch.apply(void 0, _tmp.concat([
                            _state.sent()
                        ]))
                    ];
                case 2:
                    res = _state.sent();
                    if (!(res.status >= 400 && !res.headers.has("X-Remix-Response"))) return [
                        3,
                        4
                    ];
                    _ = (0, $daRwM.ErrorResponseImpl).bind;
                    _tmp1 = [
                        void 0,
                        res.status,
                        res.statusText
                    ];
                    return [
                        4,
                        res.text()
                    ];
                case 3:
                    throw new (_.apply((0, $daRwM.ErrorResponseImpl), _tmp1.concat([
                        _state.sent()
                    ])));
                case 4:
                    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return [
                        2,
                        {
                            status: 202,
                            data: {
                                redirect: {
                                    redirect: res.headers.get("X-Remix-Redirect"),
                                    status: Number(res.headers.get("X-Remix-Status") || "302"),
                                    revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                                    reload: res.headers.get("X-Remix-Reload-Document") === "true",
                                    replace: res.headers.get("X-Remix-Replace") === "true"
                                }
                            }
                        }
                    ];
                    if ($0150e526bd929793$export$e35ccdcde387134d.has(res.status)) {
                        routes = {};
                        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
                            data: void 0
                        };
                        return [
                            2,
                            {
                                status: res.status,
                                data: {
                                    routes: routes
                                }
                            }
                        ];
                    }
                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(res.body, "No response body to decode");
                    _state.label = 5;
                case 5:
                    _state.trys.push([
                        5,
                        7,
                        ,
                        8
                    ]);
                    return [
                        4,
                        $0150e526bd929793$export$4023ad4ecd4126a2(res.body, window)
                    ];
                case 6:
                    decoded = _state.sent();
                    if (request.method === "GET") {
                        typed = decoded.value;
                        if ($0150e526bd929793$export$60644022b8b46aaa in typed) data = {
                            redirect: typed[$0150e526bd929793$export$60644022b8b46aaa]
                        };
                        else data = {
                            routes: typed
                        };
                    } else {
                        typed1 = decoded.value;
                        routeId = targetRoutes === null || targetRoutes === void 0 ? void 0 : targetRoutes[0];
                        (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
                        if ("redirect" in typed1) data = {
                            redirect: typed1
                        };
                        else data = {
                            routes: (0, $khBmn._)({}, routeId, typed1)
                        };
                    }
                    return [
                        2,
                        {
                            status: res.status,
                            data: data
                        }
                    ];
                case 7:
                    e = _state.sent();
                    throw new Error("Unable to decode turbo-stream response");
                case 8:
                    return [
                        2
                    ];
            }
        });
    })();
}
function $0150e526bd929793$export$4023ad4ecd4126a2(body, global) {
    return (0, $1cb9a9303aa06f52$export$2f872c0f2117be69)(body, {
        plugins: [
            function(type) {
                for(var _len = arguments.length, rest = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
                    rest[_key - 1] = arguments[_key];
                }
                if (type === "SanitizedError") {
                    var _rest = (0, $21h22._)(rest, 3), name = _rest[0], message = _rest[1], stack = _rest[2];
                    var Constructor = Error;
                    if (name && (0, $daRwM.SUPPORTED_ERROR_TYPES).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    var error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    var _rest1 = (0, $21h22._)(rest, 3), data = _rest1[0], status = _rest1[1], statusText = _rest1[2];
                    return {
                        value: new (0, $daRwM.ErrorResponseImpl)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: (0, $khBmn._)({}, $0150e526bd929793$export$60644022b8b46aaa, rest[0])
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $0150e526bd929793$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        var _result_redirect = result.redirect, location = _result_redirect.redirect, revalidate = _result_redirect.revalidate, reload = _result_redirect.reload, replace = _result_redirect.replace, status = _result_redirect.status;
        throw (0, $daRwM.redirect)(location, {
            status: status,
            headers: (0, $lvTkn._)({}, revalidate ? {
                "X-Remix-Revalidate": "yes"
            } : null, reload ? {
                "X-Remix-Reload-Document": "yes"
            } : null, replace ? {
                "X-Remix-Replace": "yes"
            } : null)
        });
    }
    var routeResult = result.routes[routeId];
    if (routeResult == null) throw new $0150e526bd929793$var$SingleFetchNoResultError('No result found for routeId "'.concat(routeId, '"'));
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error('Invalid response found for routeId "'.concat(routeId, '"'));
}
function $0150e526bd929793$var$createDeferred() {
    var resolve;
    var reject;
    var promise = new Promise(function(res, rej) {
        resolve = function(val) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var e;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            res(val);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        reject = function(error) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var e;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            rej(error);
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                promise
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $6zk1M = parcelRequire("6zk1M");


var $iKEZU = parcelRequire("iKEZU");

var $daRwM = parcelRequire("daRwM");
/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $2bfPH = parcelRequire("2bfPH");


var $daRwM = parcelRequire("daRwM");




/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");


var $2bfPH = parcelRequire("2bfPH");

var $daRwM = parcelRequire("daRwM");


var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/errorBoundaries.tsx
var $e861671fbadb2761$export$32e57f52df4b6e34 = /*#__PURE__*/ function(_React$1_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(RemixErrorBoundary, _React$1_Component);
    function RemixErrorBoundary(props) {
        (0, $gd0sY._)(this, RemixErrorBoundary);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, RemixErrorBoundary, [
            props
        ]);
        _this.state = {
            error: props.error || null,
            location: props.location
        };
        return _this;
    }
    (0, $7cSld._)(RemixErrorBoundary, [
        {
            key: "render",
            value: function render() {
                if (this.state.error) return /* @__PURE__ */ $eHaBZ.createElement($e861671fbadb2761$export$20b33acd14692c9, {
                    error: this.state.error,
                    isOutsideRemixApp: true
                });
                else return this.props.children;
            }
        }
    ], [
        {
            key: "getDerivedStateFromError",
            value: function getDerivedStateFromError(error) {
                return {
                    error: error
                };
            }
        },
        {
            key: "getDerivedStateFromProps",
            value: function getDerivedStateFromProps(props, state) {
                if (state.location !== props.location) return {
                    error: props.error || null,
                    location: props.location
                };
                return {
                    error: props.error || state.error,
                    location: state.location
                };
            }
        }
    ]);
    return RemixErrorBoundary;
}($eHaBZ.Component);
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $e861671fbadb2761$export$20b33acd14692c9(param) {
    var error = param.error, isOutsideRemixApp = param.isOutsideRemixApp;
    var nonce = (0, $a7135b0dc50a6f56$export$17134ff624fc6bc2)().nonce;
    console.error(error);
    var heyDeveloper = /* @__PURE__ */ $eHaBZ.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: '\n        console.log(\n          "\uD83D\uDCBF Hey developer \uD83D\uDC4B. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."\n        );\n      '
        }
    });
    if ((0, $daRwM.isRouteErrorResponse)(error)) return /* @__PURE__ */ $eHaBZ.createElement($e861671fbadb2761$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $eHaBZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    var errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        var errorString = error == null ? "Unknown Error" : (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $eHaBZ.createElement($e861671fbadb2761$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $eHaBZ.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $eHaBZ.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $e861671fbadb2761$export$cf8626ebc6a4ba63(param) {
    var title = param.title, renderScripts = param.renderScripts, isOutsideRemixApp = param.isOutsideRemixApp, children = param.children;
    var _routeModules_root;
    var routeModules = (0, $a7135b0dc50a6f56$export$17134ff624fc6bc2)().routeModules;
    if (((_routeModules_root = routeModules.root) === null || _routeModules_root === void 0 ? void 0 : _routeModules_root.Layout) && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $eHaBZ.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $eHaBZ.createElement("head", null, /* @__PURE__ */ $eHaBZ.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $eHaBZ.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $eHaBZ.createElement("title", null, title)), /* @__PURE__ */ $eHaBZ.createElement("body", null, /* @__PURE__ */ $eHaBZ.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $eHaBZ.createElement((0, $a7135b0dc50a6f56$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.3.1
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/fallback.tsx
function $1e102d3616521057$export$7e8143a7b6df36d9() {
    var nonce = (0, $a7135b0dc50a6f56$export$17134ff624fc6bc2)().nonce;
    return /* @__PURE__ */ $eHaBZ.createElement((0, $e861671fbadb2761$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/routes.tsx
function $b652ce0f0be2c94b$var$groupRoutesByParentId(manifest) {
    var routes = {};
    Object.values(manifest).forEach(function(route) {
        if (route) {
            var parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $b652ce0f0be2c94b$var$getRouteComponents(route, routeModule, isSpaMode) {
    var Component = $b652ce0f0be2c94b$var$getRouteModuleComponent(routeModule);
    var HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $1e102d3616521057$export$7e8143a7b6df36d9) : void 0;
    var ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? function() {
        return /* @__PURE__ */ $eHaBZ.createElement((0, $e861671fbadb2761$export$20b33acd14692c9), {
            error: (0, $0386ffc241ff4f20$export$ed527bf60f6e05f2)()
        });
    } : void 0;
    if (route.id === "root" && routeModule.Layout) return (0, $lvTkn._)({}, Component ? {
        element: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(Component, null))
    } : {
        Component: Component
    }, ErrorBoundary ? {
        errorElement: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(ErrorBoundary, null))
    } : {
        ErrorBoundary: ErrorBoundary
    }, HydrateFallback ? {
        hydrateFallbackElement: /* @__PURE__ */ $eHaBZ.createElement(routeModule.Layout, null, /* @__PURE__ */ $eHaBZ.createElement(HydrateFallback, null))
    } : {
        HydrateFallback: HydrateFallback
    });
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $b652ce0f0be2c94b$export$5be2318464878170(manifest, routeModules, future, isSpaMode) {
    var parentId = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : "", routesByParentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : $b652ce0f0be2c94b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : Promise.resolve({
        Component: function() {
            return null;
        }
    });
    return (routesByParentId[parentId] || []).map(function(route) {
        var routeModule = routeModules[route.id];
        (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        var dataRoute = (0, $9Jpjh._)((0, $lvTkn._)({}, $b652ce0f0be2c94b$var$getRouteComponents(route, routeModule, isSpaMode)), {
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? function() {
                return spaModeLazyPromise;
            } : void 0,
            loader: route.hasLoader || route.hasClientLoader ? function() {
                return null;
            } : void 0
        });
        var children = $b652ce0f0be2c94b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b652ce0f0be2c94b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $b652ce0f0be2c94b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $b652ce0f0be2c94b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $b652ce0f0be2c94b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        var msg = "You are trying to call ".concat(type === "action" ? "serverAction()" : "serverLoader()", " on a route that does not have a server ").concat(type, ' (routeId: "').concat(route.id, '")');
        console.error(msg);
        throw new (0, $daRwM.ErrorResponseImpl)(400, "Bad Request", new Error(msg), true);
    }
}
function $b652ce0f0be2c94b$export$2754e84c8e66e57d(type, routeId) {
    var article = type === "clientAction" ? "a" : "an";
    var msg = 'Route "'.concat(routeId, '" does not have ').concat(article, " ").concat(type, ", but you are trying to submit to it. To fix this, please add ").concat(article, " `").concat(type, "` function to the route");
    console.error(msg);
    throw new (0, $daRwM.ErrorResponseImpl)(405, "Method Not Allowed", new Error(msg), true);
}
function $b652ce0f0be2c94b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    var parentId = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : "", routesByParentId = arguments.length > 6 && arguments[6] !== void 0 ? arguments[6] : $b652ce0f0be2c94b$var$groupRoutesByParentId(manifest), needsRevalidation = arguments.length > 7 ? arguments[7] : void 0;
    return (routesByParentId[parentId] || []).map(function(route) {
        var fetchServerHandler = function fetchServerHandler(singleFetch) {
            (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        };
        var fetchServerLoader = function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        };
        var fetchServerAction = function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $b652ce0f0be2c94b$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        };
        var prefetchModule = function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        };
        var prefetchRouteModuleChunks = function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        };
        var prefetchStylesAndCallHandler = function prefetchStylesAndCallHandler(handler) {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var cachedModule, linkPrefetchPromise;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            cachedModule = routeModulesCache[route.id];
                            linkPrefetchPromise = cachedModule ? (0, $6b3610dc4425b9a6$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                ,
                                2,
                                4
                            ]);
                            return [
                                2,
                                handler()
                            ];
                        case 2:
                            return [
                                4,
                                linkPrefetchPromise
                            ];
                        case 3:
                            _state.sent();
                            return [
                                7
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var routeModule = routeModulesCache[route.id];
        var dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            var _initialState_loaderData, _initialState_errors, _routeModule_clientLoader;
            Object.assign(dataRoute, (0, $9Jpjh._)((0, $lvTkn._)({}, dataRoute, $b652ce0f0be2c94b$var$getRouteComponents(route, routeModule, isSpaMode)), {
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $b652ce0f0be2c94b$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            }));
            var hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            var initialData = hasInitialData ? initialState === null || initialState === void 0 ? void 0 : (_initialState_loaderData = initialState.loaderData) === null || _initialState_loaderData === void 0 ? void 0 : _initialState_loaderData[route.id] : void 0;
            var hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            var initialError = hasInitialError ? initialState === null || initialState === void 0 ? void 0 : (_initialState_errors = initialState.errors) === null || _initialState_errors === void 0 ? void 0 : _initialState_errors[route.id] : void 0;
            var isHydrationRequest = needsRevalidation == null && (((_routeModule_clientLoader = routeModule.clientLoader) === null || _routeModule_clientLoader === void 0 ? void 0 : _routeModule_clientLoader.hydrate) === true || !route.hasLoader);
            dataRoute.loader = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var _isHydrationRequest;
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                _isHydrationRequest = isHydrationRequest;
                                isHydrationRequest = false;
                                return [
                                    4,
                                    prefetchStylesAndCallHandler(function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                                                if (!routeModule.clientLoader) return [
                                                    2,
                                                    fetchServerLoader(singleFetch)
                                                ];
                                                return [
                                                    2,
                                                    routeModule.clientLoader({
                                                        request: request,
                                                        params: params,
                                                        context: context,
                                                        pattern: pattern,
                                                        url: url,
                                                        serverLoader: function() {
                                                            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                                    $b652ce0f0be2c94b$var$preventInvalidServerHandlerCall("loader", route);
                                                                    if (_isHydrationRequest) {
                                                                        if (hasInitialData) return [
                                                                            2,
                                                                            initialData
                                                                        ];
                                                                        if (hasInitialError) throw initialError;
                                                                    }
                                                                    return [
                                                                        2,
                                                                        fetchServerLoader(singleFetch)
                                                                    ];
                                                                });
                                                            })();
                                                        }
                                                    })
                                                ];
                                            });
                                        })();
                                    })
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            };
            dataRoute.loader.hydrate = $b652ce0f0be2c94b$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = function(param, singleFetch) {
                var request = param.request, params = param.params, context = param.context, pattern = param.pattern, url = param.url;
                return prefetchStylesAndCallHandler(function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                            if (!routeModule.clientAction) {
                                if (isSpaMode) throw $b652ce0f0be2c94b$export$2754e84c8e66e57d("clientAction", route.id);
                                return [
                                    2,
                                    fetchServerAction(singleFetch)
                                ];
                            }
                            return [
                                2,
                                routeModule.clientAction({
                                    request: request,
                                    params: params,
                                    context: context,
                                    pattern: pattern,
                                    url: url,
                                    serverAction: function() {
                                        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                $b652ce0f0be2c94b$var$preventInvalidServerHandlerCall("action", route);
                                                return [
                                                    2,
                                                    fetchServerAction(singleFetch)
                                                ];
                                            });
                                        })();
                                    }
                                })
                            ];
                        });
                    })();
                });
            };
        } else {
            var getLazyRoute = function getLazyRoute() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                if (!lazyRoutePromise) return [
                                    3,
                                    2
                                ];
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 1:
                                return [
                                    2,
                                    _state.sent()
                                ];
                            case 2:
                                lazyRoutePromise = function() {
                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                        var routeModulePromise;
                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                            switch(_state.label){
                                                case 0:
                                                    if (!(route.clientLoaderModule || route.clientActionModule)) return [
                                                        3,
                                                        2
                                                    ];
                                                    return [
                                                        4,
                                                        new Promise(function(resolve) {
                                                            return setTimeout(resolve, 0);
                                                        })
                                                    ];
                                                case 1:
                                                    _state.sent();
                                                    _state.label = 2;
                                                case 2:
                                                    routeModulePromise = $b652ce0f0be2c94b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                                                    prefetchRouteModuleChunks(route);
                                                    return [
                                                        4,
                                                        routeModulePromise
                                                    ];
                                                case 3:
                                                    return [
                                                        2,
                                                        _state.sent()
                                                    ];
                                            }
                                        });
                                    })();
                                }();
                                return [
                                    4,
                                    lazyRoutePromise
                                ];
                            case 3:
                                return [
                                    2,
                                    _state.sent()
                                ];
                        }
                    });
                })();
            };
            if (!route.hasClientLoader) dataRoute.loader = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    return fetchServerLoader(singleFetch);
                });
            };
            if (!route.hasClientAction) dataRoute.action = function(_, singleFetch) {
                return prefetchStylesAndCallHandler(function() {
                    if (isSpaMode) throw $b652ce0f0be2c94b$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            };
            var lazyRoutePromise;
            dataRoute.lazy = {
                loader: route.hasClientLoader ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        var clientLoader, _tmp;
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientLoaderModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientLoader = _tmp.clientLoader;
                                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientLoader((0, $9Jpjh._)((0, $lvTkn._)({}, args), {
                                                serverLoader: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                            $b652ce0f0be2c94b$var$preventInvalidServerHandlerCall("loader", route);
                                                            return [
                                                                2,
                                                                fetchServerLoader(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                action: route.hasClientAction ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        var clientActionPromise, clientAction;
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                                    prefetchRouteModuleChunks(route);
                                    return [
                                        4,
                                        clientActionPromise
                                    ];
                                case 1:
                                    clientAction = _state.sent().clientAction;
                                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                                    return [
                                        2,
                                        function(args, singleFetch) {
                                            return clientAction((0, $9Jpjh._)((0, $lvTkn._)({}, args), {
                                                serverAction: function() {
                                                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                                            $b652ce0f0be2c94b$var$preventInvalidServerHandlerCall("action", route);
                                                            return [
                                                                2,
                                                                fetchServerAction(singleFetch)
                                                            ];
                                                        });
                                                    })();
                                                }
                                            }));
                                        }
                                    ];
                            }
                        });
                    })();
                } : void 0,
                middleware: route.hasClientMiddleware ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        var clientMiddleware, _tmp;
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    if (!route.clientMiddlewareModule) return [
                                        3,
                                        2
                                    ];
                                    return [
                                        4,
                                        import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule)
                                    ];
                                case 1:
                                    _tmp = _state.sent();
                                    return [
                                        3,
                                        4
                                    ];
                                case 2:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 3:
                                    _tmp = _state.sent();
                                    _state.label = 4;
                                case 4:
                                    clientMiddleware = _tmp.clientMiddleware;
                                    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                                    return [
                                        2,
                                        clientMiddleware
                                    ];
                            }
                        });
                    })();
                } : void 0,
                shouldRevalidate: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        var lazyRoute;
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    lazyRoute = _state.sent();
                                    return [
                                        2,
                                        $b652ce0f0be2c94b$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation)
                                    ];
                            }
                        });
                    })();
                },
                handle: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().handle
                                    ];
                            }
                        });
                    })();
                },
                Component: function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().Component
                                    ];
                            }
                        });
                    })();
                },
                ErrorBoundary: route.hasErrorBoundary ? function() {
                    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                            switch(_state.label){
                                case 0:
                                    return [
                                        4,
                                        getLazyRoute()
                                    ];
                                case 1:
                                    return [
                                        2,
                                        _state.sent().ErrorBoundary
                                    ];
                            }
                        });
                    })();
                } : void 0
            };
        }
        var children = $b652ce0f0be2c94b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $b652ce0f0be2c94b$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $b652ce0f0be2c94b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        var myParams = path ? (0, $daRwM.compilePath)(path)[1].map(function(p) {
            return p.paramName;
        }) : [];
        var didParamsChange = function(opts) {
            return myParams.some(function(p) {
                return opts.currentParams[p] !== opts.nextParams[p];
            });
        };
        if (route.shouldRevalidate) {
            var fn = route.shouldRevalidate;
            return function(opts) {
                return fn((0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
                    defaultShouldRevalidate: didParamsChange(opts)
                }));
            };
        } else return function(opts) {
            return didParamsChange(opts);
        };
    }
    return route.shouldRevalidate;
}
function $b652ce0f0be2c94b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    var handledRevalidation = false;
    return function(arg) {
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
function $b652ce0f0be2c94b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var routeModulePromise, prefetchRouteCssPromise, routeModule;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    routeModulePromise = (0, $c57a0e6aab2808e0$export$d9c4a4e8105733a6)(route, routeModules);
                    prefetchRouteCssPromise = (0, $6b3610dc4425b9a6$export$2ee8f5601ba37b41)(route);
                    return [
                        4,
                        routeModulePromise
                    ];
                case 1:
                    routeModule = _state.sent();
                    return [
                        4,
                        Promise.all([
                            prefetchRouteCssPromise,
                            (0, $6b3610dc4425b9a6$export$26f28bc6dfd6cfc6)(route, routeModule)
                        ])
                    ];
                case 2:
                    _state.sent();
                    return [
                        2,
                        {
                            Component: $b652ce0f0be2c94b$var$getRouteModuleComponent(routeModule),
                            ErrorBoundary: routeModule.ErrorBoundary,
                            clientMiddleware: routeModule.clientMiddleware,
                            clientAction: routeModule.clientAction,
                            clientLoader: routeModule.clientLoader,
                            handle: routeModule.handle,
                            links: routeModule.links,
                            meta: routeModule.meta,
                            shouldRevalidate: routeModule.shouldRevalidate
                        }
                    ];
            }
        });
    })();
}
function $b652ce0f0be2c94b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!((0, $2bfPH._)(routeModule.default) === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $b652ce0f0be2c94b$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/fog-of-war.ts
var $8fb3cc033c2c3b65$var$nextPaths = /* @__PURE__ */ new Set();
var $8fb3cc033c2c3b65$var$discoveredPathsMaxSize = 1e3;
var $8fb3cc033c2c3b65$var$discoveredPaths = /* @__PURE__ */ new Set();
var $8fb3cc033c2c3b65$export$b5915cf27fa06b9f = 7680;
function $8fb3cc033c2c3b65$export$791cac19ae57137a(paths) {
    var result = /* @__PURE__ */ new Set();
    paths.forEach(function(path) {
        if (!path.startsWith("/")) path = "/".concat(path);
        for(var i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $8fb3cc033c2c3b65$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $8fb3cc033c2c3b65$export$ae5150779dbcc11a(_param, router) {
    var sri = _param.sri, manifest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "sri"
    ]);
    var routeIds = new Set(router.state.matches.map(function(m) {
        return m.route.id;
    }));
    var segments = router.state.location.pathname.split("/").filter(Boolean);
    var paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push("/".concat(segments.join("/")));
        segments.pop();
    }
    paths.forEach(function(path) {
        var matches = (0, $daRwM.matchRoutesImpl)(router.routes, path, router.basename || "/", false, router.branches);
        if (matches) matches.forEach(function(m) {
            return routeIds.add(m.route.id);
        });
    });
    var initialRoutes = (0, $6zk1M._)(routeIds).reduce(function(acc, id) {
        return Object.assign(acc, (0, $khBmn._)({}, id, manifest.routes[id]));
    }, {});
    return (0, $9Jpjh._)((0, $lvTkn._)({}, manifest), {
        routes: initialRoutes,
        sri: sri ? true : void 0
    });
}
function $8fb3cc033c2c3b65$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$8fb3cc033c2c3b65$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return function(param) {
        var path = param.path, patch = param.patch, signal = param.signal, fetcherKey = param.fetcherKey;
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var state;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if ($8fb3cc033c2c3b65$var$discoveredPaths.has(path)) return [
                            2
                        ];
                        state = getRouter().state;
                        return [
                            4,
                            $8fb3cc033c2c3b65$var$fetchAndApplyManifestPatches([
                                path
                            ], fetcherKey ? window.location.href : (0, $iKEZU.createPath)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
}
function $8fb3cc033c2c3b65$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $eHaBZ.useEffect(function() {
        var registerElement = function registerElement(el) {
            var path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            var pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$8fb3cc033c2c3b65$var$discoveredPaths.has(pathname)) $8fb3cc033c2c3b65$var$nextPaths.add(pathname);
        };
        var fetchPatches = function fetchPatches() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var lazyPaths, e;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
                            lazyPaths = Array.from($8fb3cc033c2c3b65$var$nextPaths.keys()).filter(function(path) {
                                if ($8fb3cc033c2c3b65$var$discoveredPaths.has(path)) {
                                    $8fb3cc033c2c3b65$var$nextPaths.delete(path);
                                    return false;
                                }
                                return true;
                            });
                            if (lazyPaths.length === 0) return [
                                2
                            ];
                            _state.label = 1;
                        case 1:
                            _state.trys.push([
                                1,
                                3,
                                ,
                                4
                            ]);
                            return [
                                4,
                                $8fb3cc033c2c3b65$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes)
                            ];
                        case 2:
                            _state.sent();
                            return [
                                3,
                                4
                            ];
                        case 3:
                            e = _state.sent();
                            console.error("Failed to fetch manifest patches", e);
                            return [
                                3,
                                4
                            ];
                        case 4:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var _window_navigator_connection, _window_navigator;
        if (!$8fb3cc033c2c3b65$export$741d98b28dbfd(routeDiscovery, ssr) || ((_window_navigator = window.navigator) === null || _window_navigator === void 0 ? void 0 : (_window_navigator_connection = _window_navigator.connection) === null || _window_navigator_connection === void 0 ? void 0 : _window_navigator_connection.saveData) === true) return;
        var debouncedFetchPatches = $8fb3cc033c2c3b65$var$debounce(fetchPatches, 100);
        fetchPatches();
        var observer = new MutationObserver(function() {
            return debouncedFetchPatches();
        });
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return function() {
            return observer.disconnect();
        };
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $8fb3cc033c2c3b65$export$bcb79c3deff01d56(_manifestPath, basename) {
    var manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $daRwM.joinPaths)([
        basename,
        manifestPath
    ]);
}
var $8fb3cc033c2c3b65$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
function $8fb3cc033c2c3b65$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!needsReload) {
                        try {
                            sessionStorage.removeItem($8fb3cc033c2c3b65$var$MANIFEST_VERSION_STORAGE_KEY);
                        } catch (e) {}
                        return [
                            2,
                            false
                        ];
                    }
                    if (!errorReloadPath) {
                        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
                        return [
                            2,
                            true
                        ];
                    }
                    try {
                        if (sessionStorage.getItem($8fb3cc033c2c3b65$var$MANIFEST_VERSION_STORAGE_KEY) === version) {
                            console.error("Unable to discover routes due to manifest version mismatch.");
                            return [
                                2,
                                true
                            ];
                        }
                        sessionStorage.setItem($8fb3cc033c2c3b65$var$MANIFEST_VERSION_STORAGE_KEY, version);
                    } catch (e) {}
                    window.location.href = errorReloadPath;
                    console.warn("Detected manifest version mismatch, reloading...");
                    return [
                        4,
                        new Promise(function() {})
                    ];
                case 1:
                    _state.sent();
                    return [
                        2,
                        true
                    ];
            }
        });
    })();
}
function $8fb3cc033c2c3b65$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
        var searchParams, url, serverPatches, res, e, knownRoutes, patches, parentIds;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    paths = $8fb3cc033c2c3b65$export$791cac19ae57137a(paths);
                    searchParams = new URLSearchParams();
                    searchParams.set("paths", paths.sort().join(","));
                    searchParams.set("version", manifest.version);
                    url = new URL($8fb3cc033c2c3b65$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
                    url.search = searchParams.toString();
                    if (url.toString().length > 7680) {
                        $8fb3cc033c2c3b65$var$nextPaths.clear();
                        return [
                            2
                        ];
                    }
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        5,
                        ,
                        6
                    ]);
                    return [
                        4,
                        fetch(url, {
                            signal: signal
                        })
                    ];
                case 2:
                    res = _state.sent();
                    if (!res.ok) throw new Error("".concat(res.status, " ").concat(res.statusText));
                    return [
                        4,
                        $8fb3cc033c2c3b65$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)
                    ];
                case 3:
                    if (_state.sent()) return [
                        2
                    ];
                    return [
                        4,
                        res.json()
                    ];
                case 4:
                    serverPatches = _state.sent();
                    return [
                        3,
                        6
                    ];
                case 5:
                    e = _state.sent();
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    throw e;
                case 6:
                    if (signal === null || signal === void 0 ? void 0 : signal.aborted) return [
                        2
                    ];
                    knownRoutes = new Set(Object.keys(manifest.routes));
                    patches = Object.values(serverPatches).reduce(function(acc, route) {
                        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
                        return acc;
                    }, {});
                    Object.assign(manifest.routes, patches);
                    paths.forEach(function(p) {
                        return $8fb3cc033c2c3b65$var$addToFifoQueue(p, $8fb3cc033c2c3b65$var$discoveredPaths);
                    });
                    parentIds = /* @__PURE__ */ new Set();
                    Object.values(patches).forEach(function(patch) {
                        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
                    });
                    parentIds.forEach(function(parentId) {
                        return patchRoutes(parentId || null, (0, $b652ce0f0be2c94b$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId));
                    });
                    return [
                        2
                    ];
            }
        });
    })();
}
function $8fb3cc033c2c3b65$var$addToFifoQueue(path, queue) {
    if (queue.size >= $8fb3cc033c2c3b65$var$discoveredPathsMaxSize) {
        var first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $8fb3cc033c2c3b65$var$debounce(callback, wait) {
    var timeoutId;
    return function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(function() {
            return callback.apply(void 0, (0, $6zk1M._)(args));
        }, wait);
    };
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/ssr/components.tsx
function $a7135b0dc50a6f56$var$useDataRouterContext() {
    var context = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterContext.Provider> element");
    return context;
}
function $a7135b0dc50a6f56$var$useDataRouterStateContext() {
    var context = $eHaBZ.useContext((0, $333deedcba464643$export$315e3ffb01f217));
    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(context, "You must render this element inside a <DataRouterStateContext.Provider> element");
    return context;
}
var $a7135b0dc50a6f56$export$208d6a3bc3aa62bd = $eHaBZ.createContext(void 0);
$a7135b0dc50a6f56$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $a7135b0dc50a6f56$export$17134ff624fc6bc2() {
    var context = $eHaBZ.useContext($a7135b0dc50a6f56$export$208d6a3bc3aa62bd);
    (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $a7135b0dc50a6f56$export$6eb91431f5da407c(prefetch, theirElementProps) {
    var frameworkContext = $eHaBZ.useContext($a7135b0dc50a6f56$export$208d6a3bc3aa62bd);
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState(false), 2), maybePrefetch = _React$1_useState[0], setMaybePrefetch = _React$1_useState[1];
    var _React$1_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), shouldPrefetch = _React$1_useState1[0], setShouldPrefetch = _React$1_useState1[1];
    var onFocus = theirElementProps.onFocus, onBlur = theirElementProps.onBlur, onMouseEnter = theirElementProps.onMouseEnter, onMouseLeave = theirElementProps.onMouseLeave, onTouchStart = theirElementProps.onTouchStart;
    var ref = $eHaBZ.useRef(null);
    $eHaBZ.useEffect(function() {
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            var callback = function(entries) {
                entries.forEach(function(entry) {
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            var observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return function() {
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $eHaBZ.useEffect(function() {
        if (maybePrefetch) {
            var id = setTimeout(function() {
                setShouldPrefetch(true);
            }, 100);
            return function() {
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    var setIntent = function() {
        setMaybePrefetch(true);
    };
    var cancelIntent = function() {
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $a7135b0dc50a6f56$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $a7135b0dc50a6f56$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $a7135b0dc50a6f56$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $a7135b0dc50a6f56$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $a7135b0dc50a6f56$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $a7135b0dc50a6f56$var$composeEventHandlers(theirHandler, ourHandler) {
    return function(event) {
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $a7135b0dc50a6f56$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$a7135b0dc50a6f56$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        var errorIdx = matches.findIndex(function(m) {
            return errors[m.route.id] !== void 0;
        });
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
var $a7135b0dc50a6f56$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $a7135b0dc50a6f56$export$b2e089eb3692b073(param) {
    var nonce = param.nonce, crossOrigin = param.crossOrigin;
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), isSpaMode = _useFrameworkContext.isSpaMode, manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules, criticalCss = _useFrameworkContext.criticalCss, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterStateContext = $a7135b0dc50a6f56$var$useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches;
    var matches = $a7135b0dc50a6f56$var$getActiveMatches(routerMatches, errors, isSpaMode);
    var keyedLinks = $eHaBZ.useMemo(function() {
        return (0, $6b3610dc4425b9a6$export$c43eb07eab2c950a)(matches, routeModules, manifest);
    }, [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    var _obj, _obj1;
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $eHaBZ.createElement("style", (_obj = {}, (0, $khBmn._)(_obj, $a7135b0dc50a6f56$export$7e4ed4715c00dab0, ""), (0, $khBmn._)(_obj, "nonce", nonce), (0, $khBmn._)(_obj, "dangerouslySetInnerHTML", {
        __html: criticalCss
    }), _obj)) : null, (typeof criticalCss === "undefined" ? "undefined" : (0, $2bfPH._)(criticalCss)) === "object" ? /* @__PURE__ */ $eHaBZ.createElement("link", (_obj1 = {}, (0, $khBmn._)(_obj1, $a7135b0dc50a6f56$export$7e4ed4715c00dab0, ""), (0, $khBmn._)(_obj1, "rel", "stylesheet"), (0, $khBmn._)(_obj1, "href", criticalCss.href), (0, $khBmn._)(_obj1, "nonce", nonce), (0, $khBmn._)(_obj1, "crossOrigin", crossOrigin), _obj1)) : null, keyedLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin, _link_crossOrigin1;
        return (0, $6b3610dc4425b9a6$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $eHaBZ.createElement($a7135b0dc50a6f56$export$60dcec93e67386bd, (0, $9Jpjh._)((0, $lvTkn._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : crossOrigin
        })) : /* @__PURE__ */ $eHaBZ.createElement("link", (0, $9Jpjh._)((0, $lvTkn._)({
            key: key,
            nonce: nonce
        }, link), {
            crossOrigin: (_link_crossOrigin1 = link.crossOrigin) !== null && _link_crossOrigin1 !== void 0 ? _link_crossOrigin1 : crossOrigin
        }));
    }));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $a7135b0dc50a6f56$export$60dcec93e67386bd(_param) {
    var page = _param.page, linkProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "page"
    ]);
    var rsc = (0, $333deedcba464643$export$6e1eeb090b3ec35b)();
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), contextNonce = _useFrameworkContext.nonce;
    var router = $a7135b0dc50a6f56$var$useDataRouterContext().router;
    var matches = $eHaBZ.useMemo(function() {
        return (0, $daRwM.matchRoutes)(router.routes, page, router.basename);
    }, [
        router.routes,
        page,
        router.basename
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = (0, $9Jpjh._)((0, $lvTkn._)({}, linkProps), {
        nonce: contextNonce
    });
    if (rsc) return /* @__PURE__ */ $eHaBZ.createElement($a7135b0dc50a6f56$var$RSCPrefetchPageLinksImpl, (0, $lvTkn._)({
        page: page,
        matches: matches
    }, linkProps));
    return /* @__PURE__ */ $eHaBZ.createElement($a7135b0dc50a6f56$var$PrefetchPageLinksImpl, (0, $lvTkn._)({
        page: page,
        matches: matches
    }, linkProps));
}
function $a7135b0dc50a6f56$var$useKeyedPrefetchLinks(matches) {
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState([]), 2), keyedPrefetchLinks = _React$1_useState[0], setKeyedPrefetchLinks = _React$1_useState[1];
    $eHaBZ.useEffect(function() {
        var interrupted = false;
        (0, $6b3610dc4425b9a6$export$98f31d7a23772264)(matches, manifest, routeModules).then(function(links) {
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return function() {
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $a7135b0dc50a6f56$var$RSCPrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "page",
        "matches"
    ]);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var dataHrefs = $eHaBZ.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var url = (0, $0150e526bd929793$export$7b977381851b2c)(page, "rsc");
        var hasSomeRoutesWithShouldRevalidate = false;
        var targetRoutes = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = nextMatches[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var match = _step.value;
                if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
                else targetRoutes.push(match.route.id);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }));
}
function $a7135b0dc50a6f56$var$PrefetchPageLinksImpl(_param) {
    var page = _param.page, nextMatches = _param.matches, linkProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "page",
        "matches"
    ]);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), manifest = _useFrameworkContext.manifest, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = $a7135b0dc50a6f56$var$useDataRouterStateContext(), loaderData = _useDataRouterStateContext.loaderData, matches = _useDataRouterStateContext.matches;
    var newMatchesForData = $eHaBZ.useMemo(function() {
        return (0, $6b3610dc4425b9a6$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var newMatchesForAssets = $eHaBZ.useMemo(function() {
        return (0, $6b3610dc4425b9a6$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets");
    }, [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    var dataHrefs = $eHaBZ.useMemo(function() {
        if (page === location.pathname + location.search + location.hash) return [];
        var routesParams = /* @__PURE__ */ new Set();
        var foundOptOutRoute = false;
        nextMatches.forEach(function(m) {
            var _routeModules_m_route_id;
            var manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some(function(m2) {
                return m2.route.id === m.route.id;
            }) && m.route.id in loaderData && ((_routeModules_m_route_id = routeModules[m.route.id]) === null || _routeModules_m_route_id === void 0 ? void 0 : _routeModules_m_route_id.shouldRevalidate)) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        var url = (0, $0150e526bd929793$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter(function(m) {
            return routesParams.has(m.route.id);
        }).map(function(m) {
            return m.route.id;
        }).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    var moduleHrefs = $eHaBZ.useMemo(function() {
        return (0, $6b3610dc4425b9a6$export$442b9e023f41af00)(newMatchesForAssets, manifest);
    }, [
        newMatchesForAssets,
        manifest
    ]);
    var keyedPrefetchLinks = $a7135b0dc50a6f56$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, dataHrefs.map(function(href) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href
        }, linkProps));
    }), moduleHrefs.map(function(href) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $lvTkn._)({
            key: href,
            rel: "modulepreload",
            href: href
        }, linkProps));
    }), keyedPrefetchLinks.map(function(param) {
        var key = param.key, link = param.link;
        var _link_crossOrigin;
        return /* @__PURE__ */ $eHaBZ.createElement("link", (0, $9Jpjh._)((0, $lvTkn._)({
            key: key,
            nonce: linkProps.nonce
        }, link), {
            crossOrigin: (_link_crossOrigin = link.crossOrigin) !== null && _link_crossOrigin !== void 0 ? _link_crossOrigin : linkProps.crossOrigin
        }));
    }));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $a7135b0dc50a6f56$export$b08a9033b36413fb() {
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), isSpaMode = _useFrameworkContext.isSpaMode, routeModules = _useFrameworkContext.routeModules;
    var _useDataRouterStateContext = $a7135b0dc50a6f56$var$useDataRouterStateContext(), errors = _useDataRouterStateContext.errors, routerMatches = _useDataRouterStateContext.matches, loaderData = _useDataRouterStateContext.loaderData;
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var _matches = $a7135b0dc50a6f56$var$getActiveMatches(routerMatches, errors, isSpaMode);
    var error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    var meta = [];
    var leafMeta = null;
    var matches = [];
    for(var i = 0; i < _matches.length; i++){
        var _match = _matches[i];
        var routeId = _match.route.id;
        var data = loaderData[routeId];
        var params = _match.params;
        var routeModule = routeModules[routeId];
        var routeMeta = [];
        var match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule === null || routeModule === void 0 ? void 0 : routeModule.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? (0, $6zk1M._)(routeModule.meta) : routeModule.meta;
        else if (leafMeta) routeMeta = (0, $6zk1M._)(leafMeta);
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = (0, $6zk1M._)(routeMeta);
        leafMeta = meta;
    }
    return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, meta.flat().map(function(metaProps) {
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            var tagName = metaProps.tagName, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(metaProps, [
                "tagName"
            ]);
            if (!$a7135b0dc50a6f56$var$isValidMetaTag(tagName)) {
                console.warn("A meta object uses an invalid tagName: ".concat(tagName, ". Expected either 'link' or 'meta'"));
                return null;
            }
            var Comp = tagName;
            return /* @__PURE__ */ $eHaBZ.createElement(Comp, (0, $lvTkn._)({
                key: JSON.stringify(rest)
            }, rest));
        }
        if ("title" in metaProps) return /* @__PURE__ */ $eHaBZ.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps;
            var _charSet;
            (_charSet = (_metaProps = metaProps).charSet) !== null && _charSet !== void 0 ? _charSet : _metaProps.charSet = metaProps.charset;
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $eHaBZ.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            var json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $eHaBZ.createElement("script", {
                key: "script:ld+json:".concat(json),
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $77cc0322f8b62577$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch (e) {
            return null;
        }
        return /* @__PURE__ */ $eHaBZ.createElement("meta", (0, $lvTkn._)({
            key: JSON.stringify(metaProps)
        }, metaProps));
    }));
}
function $a7135b0dc50a6f56$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ var $a7135b0dc50a6f56$var$isHydrated = false;
function $a7135b0dc50a6f56$export$3be068dde909e563() {
    $a7135b0dc50a6f56$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $a7135b0dc50a6f56$export$ff0bf87698939488(scriptProps) {
    var _useFrameworkContext = $a7135b0dc50a6f56$export$17134ff624fc6bc2(), manifest = _useFrameworkContext.manifest, serverHandoffString = _useFrameworkContext.serverHandoffString, isSpaMode = _useFrameworkContext.isSpaMode, renderMeta = _useFrameworkContext.renderMeta, routeDiscovery = _useFrameworkContext.routeDiscovery, ssr = _useFrameworkContext.ssr, contextNonce = _useFrameworkContext.nonce;
    var _useDataRouterContext = $a7135b0dc50a6f56$var$useDataRouterContext(), router = _useDataRouterContext.router, isStatic = _useDataRouterContext.static, staticContext = _useDataRouterContext.staticContext;
    var _useDataRouterStateContext = $a7135b0dc50a6f56$var$useDataRouterStateContext(), routerMatches = _useDataRouterStateContext.matches;
    var isRSCRouterContext = (0, $333deedcba464643$export$6e1eeb090b3ec35b)();
    var enableFogOfWar = (0, $8fb3cc033c2c3b65$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
        nonce: contextNonce
    });
    if (renderMeta) renderMeta.didRenderScripts = true;
    var matches = $a7135b0dc50a6f56$var$getActiveMatches(routerMatches, null, isSpaMode);
    $eHaBZ.useEffect(function() {
        $a7135b0dc50a6f56$export$3be068dde909e563();
    }, []);
    var initialScripts = $eHaBZ.useMemo(function() {
        var _manifest_hmr;
        if (isRSCRouterContext) return null;
        var contextScript = staticContext ? "window.__reactRouterContext = ".concat(serverHandoffString, ";window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());") : " ";
        var routeModulesScript = !isStatic ? " " : "".concat(((_manifest_hmr = manifest.hmr) === null || _manifest_hmr === void 0 ? void 0 : _manifest_hmr.runtime) ? "import ".concat(JSON.stringify(manifest.hmr.runtime), ";") : "").concat(!enableFogOfWar ? "import ".concat(JSON.stringify(manifest.url)) : "", ";\n").concat(matches.map(function(match, routeIndex) {
            var routeVarName = "route".concat(routeIndex);
            var manifestEntry = manifest.routes[match.route.id];
            (0, $dfb15cab4dfa9334$export$2e2bcd8739ae039)(manifestEntry, "Route ".concat(match.route.id, " not found in manifest"));
            var clientActionModule = manifestEntry.clientActionModule, clientLoaderModule = manifestEntry.clientLoaderModule, clientMiddlewareModule = manifestEntry.clientMiddlewareModule, hydrateFallbackModule = manifestEntry.hydrateFallbackModule, module = manifestEntry.module;
            var chunks = (0, $6zk1M._)(clientActionModule ? [
                {
                    module: clientActionModule,
                    varName: "".concat(routeVarName, "_clientAction")
                }
            ] : []).concat((0, $6zk1M._)(clientLoaderModule ? [
                {
                    module: clientLoaderModule,
                    varName: "".concat(routeVarName, "_clientLoader")
                }
            ] : []), (0, $6zk1M._)(clientMiddlewareModule ? [
                {
                    module: clientMiddlewareModule,
                    varName: "".concat(routeVarName, "_clientMiddleware")
                }
            ] : []), (0, $6zk1M._)(hydrateFallbackModule ? [
                {
                    module: hydrateFallbackModule,
                    varName: "".concat(routeVarName, "_HydrateFallback")
                }
            ] : []), [
                {
                    module: module,
                    varName: "".concat(routeVarName, "_main")
                }
            ]);
            if (chunks.length === 1) return "import * as ".concat(routeVarName, " from ").concat(JSON.stringify(module), ";");
            return [
                chunks.map(function(chunk) {
                    return "import * as ".concat(chunk.varName, ' from "').concat(chunk.module, '";');
                }).join("\n"),
                "const ".concat(routeVarName, " = {").concat(chunks.map(function(chunk) {
                    return "...".concat(chunk.varName);
                }).join(","), "};")
            ].join("\n");
        }).join("\n"), "\n  ").concat(enableFogOfWar ? "window.__reactRouterManifest = ".concat(JSON.stringify((0, $8fb3cc033c2c3b65$export$ae5150779dbcc11a)(manifest, router), null, 2), ";") : "", "\n  window.__reactRouterRouteModules = {").concat(matches.map(function(match, index) {
            return "".concat(JSON.stringify(match.route.id), ":route").concat(index);
        }).join(","), "};\n\nimport(").concat(JSON.stringify(manifest.entry.module), ");");
        return /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        })), /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        })));
    }, []);
    var preloads = $a7135b0dc50a6f56$var$isHydrated || isRSCRouterContext ? [] : (0, $6zk1M._)(new Set(manifest.entry.imports.concat((0, $6b3610dc4425b9a6$export$442b9e023f41af00)(matches, manifest, {
        includeHydrateFallback: true
    }))));
    var sri = (0, $2bfPH._)(manifest.sri) === "object" ? manifest.sri : {};
    (0, $52b8a13ef796e487$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $a7135b0dc50a6f56$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, (0, $2bfPH._)(manifest.sri) === "object" ? /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, scriptProps), {
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    })) : null, !enableFogOfWar ? /* @__PURE__ */ $eHaBZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $eHaBZ.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map(function(path) {
        return /* @__PURE__ */ $eHaBZ.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        });
    }), initialScripts);
}
function $a7135b0dc50a6f56$export$c9058316764c140e() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return function(value) {
        refs.forEach(function(ref) {
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $eHaBZ = parcelRequire("eHaBZ");
//#region lib/dom/lib.tsx
var $e19387da9012a331$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($e19387da9012a331$var$isBrowser) window.__reactRouterVersion = "8";
} catch (e) {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $e19387da9012a331$export$1f3f55432a00e06d(routes, opts) {
    return (0, $d8c8e9691ac1f69a$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $iKEZU.createBrowserHistory)({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $e19387da9012a331$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $daRwM.defaultMapRouteProperties),
        hydrationRouteProperties: (0, $d6e338e05ac94550$export$e2fd2c03906469db),
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $e19387da9012a331$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $d8c8e9691ac1f69a$export$baddd0131ee8c05b)({
        basename: opts === null || opts === void 0 ? void 0 : opts.basename,
        getContext: opts === null || opts === void 0 ? void 0 : opts.getContext,
        future: opts === null || opts === void 0 ? void 0 : opts.future,
        history: (0, $iKEZU.createHashHistory)({
            window: opts === null || opts === void 0 ? void 0 : opts.window
        }),
        hydrationData: (opts === null || opts === void 0 ? void 0 : opts.hydrationData) || $e19387da9012a331$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $daRwM.defaultMapRouteProperties),
        hydrationRouteProperties: (0, $d6e338e05ac94550$export$e2fd2c03906469db),
        dataStrategy: opts === null || opts === void 0 ? void 0 : opts.dataStrategy,
        patchRoutesOnNavigation: opts === null || opts === void 0 ? void 0 : opts.patchRoutesOnNavigation,
        window: opts === null || opts === void 0 ? void 0 : opts.window,
        instrumentations: opts === null || opts === void 0 ? void 0 : opts.instrumentations
    }).initialize();
}
function $e19387da9012a331$var$parseHydrationData() {
    var _window;
    var state = (_window = window) === null || _window === void 0 ? void 0 : _window.__staticRouterHydrationData;
    if (state && state.errors) state = (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
        errors: $e19387da9012a331$var$deserializeErrors(state.errors)
    });
    return state;
}
function $e19387da9012a331$var$deserializeErrors(errors) {
    if (!errors) return null;
    var entries = Object.entries(errors);
    var serialized = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $daRwM.ErrorResponseImpl)(val.status, val.statusText, val.data, val.internal === true);
            else if (val && val.__type === "Error") {
                if (typeof val.__subType === "string" && (0, $daRwM.SUPPORTED_ERROR_TYPES).includes(val.__subType)) {
                    var ErrorConstructor = window[val.__subType];
                    if (typeof ErrorConstructor === "function") try {
                        var error = new ErrorConstructor(val.message);
                        error.stack = "";
                        serialized[key] = error;
                    } catch (e) {}
                }
                if (serialized[key] == null) {
                    var error1 = new Error(val.message);
                    error1.stack = "";
                    serialized[key] = error1;
                }
            } else serialized[key] = val;
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $e19387da9012a331$export$9ba4e89fdfa1fc54(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, _$window = param.window;
    var historyRef = $eHaBZ.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $iKEZU.createBrowserHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React$1_useState[0], setStateImpl = _React$1_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement((0, $d6e338e05ac94550$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $e19387da9012a331$export$7221d69dcfc8e36b(param) {
    var basename = param.basename, children = param.children, useTransitions = param.useTransitions, _$window = param.window;
    var historyRef = $eHaBZ.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $iKEZU.createHashHistory)({
        window: _$window,
        v5Compat: true
    });
    var history = historyRef.current;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React$1_useState[0], setStateImpl = _React$1_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement((0, $d6e338e05ac94550$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $e19387da9012a331$export$de73885c9336221c(param) {
    var basename = param.basename, children = param.children, history = param.history, useTransitions = param.useTransitions;
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState({
        action: history.action,
        location: history.location
    }), 2), state = _React$1_useState[0], setStateImpl = _React$1_useState[1];
    var setState = $eHaBZ.useCallback(function(newState) {
        if (useTransitions === false) setStateImpl(newState);
        else $eHaBZ.startTransition(function() {
            return setStateImpl(newState);
        });
    }, [
        useTransitions
    ]);
    $eHaBZ.useLayoutEffect(function() {
        return history.listen(setState);
    }, [
        history,
        setState
    ]);
    return /* @__PURE__ */ $eHaBZ.createElement((0, $d6e338e05ac94550$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$e19387da9012a331$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ var $e19387da9012a331$export$a6c7ac8248d6e38a = $eHaBZ.forwardRef(function LinkWithRef(_param, forwardedRef) {
    var onClick = _param.onClick, _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, _param_prefetch = _param.prefetch, prefetch = _param_prefetch === void 0 ? "none" : _param_prefetch, relative = _param.relative, reloadDocument = _param.reloadDocument, replace = _param.replace, mask = _param.mask, state = _param.state, target = _param.target, to = _param.to, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "onClick",
        "discover",
        "prefetch",
        "relative",
        "reloadDocument",
        "replace",
        "mask",
        "state",
        "target",
        "to",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), basename = _React$1_useContext.basename, navigator = _React$1_useContext.navigator, useTransitions = _React$1_useContext.useTransitions;
    var isAbsolute = typeof to === "string" && (0, $8onil.ABSOLUTE_URL_REGEX).test(to);
    var parsed = (0, $daRwM.parseToInfo)(to, basename);
    to = parsed.to;
    var href = (0, $0386ffc241ff4f20$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var maskedHref = null;
    if (mask) {
        var resolved = (0, $daRwM.resolveTo)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $daRwM.joinPaths)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    var _usePrefetchBehavior = (0, $21h22._)((0, $a7135b0dc50a6f56$export$6eb91431f5da407c)(prefetch, rest), 3), shouldPrefetch = _usePrefetchBehavior[0], prefetchRef = _usePrefetchBehavior[1], prefetchHandlers = _usePrefetchBehavior[2];
    var internalOnClick = $e19387da9012a331$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    var isSpaLink = !(parsed.isExternal || reloadDocument);
    var link = /* @__PURE__ */ $eHaBZ.createElement("a", (0, $9Jpjh._)((0, $lvTkn._)({}, rest, prefetchHandlers), {
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $a7135b0dc50a6f56$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $eHaBZ.createElement($eHaBZ.Fragment, null, link, /* @__PURE__ */ $eHaBZ.createElement((0, $a7135b0dc50a6f56$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$e19387da9012a331$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ var $e19387da9012a331$export$b0d92dbee9b5b60d = $eHaBZ.forwardRef(function NavLinkWithRef(_param, ref) {
    var tmp = _param["aria-current"], ariaCurrentProp = tmp === void 0 ? "page" : tmp, _param_caseSensitive = _param.caseSensitive, caseSensitive = _param_caseSensitive === void 0 ? false : _param_caseSensitive, tmp1 = _param.className, classNameProp = tmp1 === void 0 ? "" : tmp1, _param_end = _param.end, end = _param_end === void 0 ? false : _param_end, styleProp = _param.style, to = _param.to, viewTransition = _param.viewTransition, children = _param.children, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "aria-current",
        "caseSensitive",
        "className",
        "end",
        "style",
        "to",
        "viewTransition",
        "children"
    ]);
    var path = (0, $0386ffc241ff4f20$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var routerState = $eHaBZ.useContext((0, $333deedcba464643$export$315e3ffb01f217));
    var _React$1_useContext = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)), navigator = _React$1_useContext.navigator, basename = _React$1_useContext.basename;
    var isTransitioning = routerState != null && $e19387da9012a331$export$e262bd1977bea848(path) && viewTransition === true;
    var toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    var locationPathname = location.pathname;
    var nextLocationPathname = routerState && routerState.navigation && routerState.navigation.location ? routerState.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $daRwM.stripBasename)(nextLocationPathname, basename) || nextLocationPathname;
    var endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    var isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    var isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    var renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    var ariaCurrent = isActive ? ariaCurrentProp : void 0;
    var className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    var style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $eHaBZ.createElement($e19387da9012a331$export$a6c7ac8248d6e38a, (0, $9Jpjh._)((0, $lvTkn._)({}, rest), {
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }), typeof children === "function" ? children(renderProps) : children);
});
$e19387da9012a331$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ var $e19387da9012a331$export$a7fed597f4b8afd8 = $eHaBZ.forwardRef(function(_param, forwardedRef) {
    var _param_discover = _param.discover, discover = _param_discover === void 0 ? "render" : _param_discover, fetcherKey = _param.fetcherKey, navigate = _param.navigate, reloadDocument = _param.reloadDocument, replace = _param.replace, state = _param.state, _param_method = _param.method, method = _param_method === void 0 ? "get" : _param_method, action = _param.action, onSubmit = _param.onSubmit, relative = _param.relative, preventScrollReset = _param.preventScrollReset, viewTransition = _param.viewTransition, defaultShouldRevalidate = _param.defaultShouldRevalidate, props = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "discover",
        "fetcherKey",
        "navigate",
        "reloadDocument",
        "replace",
        "state",
        "method",
        "action",
        "onSubmit",
        "relative",
        "preventScrollReset",
        "viewTransition",
        "defaultShouldRevalidate"
    ]);
    var useTransitions = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).useTransitions;
    var submit = $e19387da9012a331$export$47c85c6e3a081d3();
    var formAction = $e19387da9012a331$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    var formMethod = method.toLowerCase() === "get" ? "get" : "post";
    var isAbsolute = typeof action === "string" && (0, $8onil.ABSOLUTE_URL_REGEX).test(action);
    var submitHandler = function(event) {
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        var submitter = event.nativeEvent.submitter;
        var submitMethod = (submitter === null || submitter === void 0 ? void 0 : submitter.getAttribute("formmethod")) || method;
        var doSubmit = function() {
            return submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        };
        if (useTransitions && navigate !== false) $eHaBZ.startTransition(function() {
            return doSubmit();
        });
        else doSubmit();
    };
    return /* @__PURE__ */ $eHaBZ.createElement("form", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler
    }, props), {
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    }));
});
$e19387da9012a331$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $e19387da9012a331$export$11aac1aab828f1fa(_param) {
    var getKey = _param.getKey, storageKey = _param.storageKey, props = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "getKey",
        "storageKey"
    ]);
    var remixContext = $eHaBZ.useContext((0, $a7135b0dc50a6f56$export$208d6a3bc3aa62bd));
    var basename = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).basename;
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var matches = (0, $0386ffc241ff4f20$export$2378eb7f5ff86053)();
    $e19387da9012a331$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    var ssrKey = $eHaBZ.useMemo(function() {
        if (!remixContext || !getKey) return null;
        var userKey = $e19387da9012a331$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    var restoreScroll = (function(storageKey, restoreKey) {
        if (!window.history.state || !window.history.state.key) {
            var key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            var storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && (remixContext === null || remixContext === void 0 ? void 0 : remixContext.nonce)) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $eHaBZ.createElement("script", (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: "(".concat(restoreScroll, ")(").concat((0, $77cc0322f8b62577$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $e19387da9012a331$var$SCROLL_RESTORATION_STORAGE_KEY)), ", ").concat((0, $77cc0322f8b62577$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey)), ")")
        }
    }));
}
$e19387da9012a331$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
function $e19387da9012a331$var$getDataRouterConsoleError(hookName) {
    return "".concat(hookName, " must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.");
}
function $e19387da9012a331$var$useDataRouterContext(hookName) {
    var ctx = $eHaBZ.useContext((0, $333deedcba464643$export$2eeee58951ff3c1c));
    (0, $iKEZU.invariant)(ctx, $e19387da9012a331$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $e19387da9012a331$var$useDataRouterState(hookName) {
    var state = $eHaBZ.useContext((0, $333deedcba464643$export$315e3ffb01f217));
    (0, $iKEZU.invariant)(state, $e19387da9012a331$var$getDataRouterConsoleError(hookName));
    return state;
}
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $e19387da9012a331$export$67621102c14d847(to) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, target = _ref.target, replaceProp = _ref.replace, mask = _ref.mask, state = _ref.state, preventScrollReset = _ref.preventScrollReset, relative = _ref.relative, viewTransition = _ref.viewTransition, defaultShouldRevalidate = _ref.defaultShouldRevalidate, useTransitions = _ref.useTransitions;
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var path = (0, $0386ffc241ff4f20$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $eHaBZ.useCallback(function(event) {
        if ((0, $7e52a79e98d59ecf$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            var replace = replaceProp !== void 0 ? replaceProp : (0, $iKEZU.createPath)(location) === (0, $iKEZU.createPath)(path);
            var doNavigate = function() {
                return navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            };
            if (useTransitions) $eHaBZ.startTransition(function() {
                return doNavigate();
            });
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $e19387da9012a331$export$f1a78c17382fe22a(defaultInit) {
    (0, $iKEZU.warning)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    var defaultSearchParamsRef = $eHaBZ.useRef((0, $7e52a79e98d59ecf$export$a2e4e2dcc7b1f22f)(defaultInit));
    var hasSetSearchParamsRef = $eHaBZ.useRef(false);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var searchParams = $eHaBZ.useMemo(function() {
        return (0, $7e52a79e98d59ecf$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current);
    }, [
        location.search
    ]);
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    return [
        searchParams,
        $eHaBZ.useCallback(function(nextInit, navigateOptions) {
            var newSearchParams = (0, $7e52a79e98d59ecf$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
var $e19387da9012a331$var$fetcherId = 0;
var $e19387da9012a331$var$getUniqueFetcherId = function() {
    return "__".concat(String(++$e19387da9012a331$var$fetcherId), "__");
};
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $e19387da9012a331$export$47c85c6e3a081d3() {
    var router = $e19387da9012a331$var$useDataRouterContext("useSubmit").router;
    var basename = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).basename;
    var currentRouteId = (0, $0386ffc241ff4f20$export$4200b254756b08af)();
    var routerFetch = router.fetch;
    var routerNavigate = router.navigate;
    return $eHaBZ.useCallback(function(target) {
        var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _getFormSubmissionInfo, action, method, encType, formData, body;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _getFormSubmissionInfo = (0, $7e52a79e98d59ecf$export$80917616746b9ab4)(target, basename), action = _getFormSubmissionInfo.action, method = _getFormSubmissionInfo.method, encType = _getFormSubmissionInfo.encType, formData = _getFormSubmissionInfo.formData, body = _getFormSubmissionInfo.body;
                        if (!(options.navigate === false)) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            routerFetch(options.fetcherKey || $e19387da9012a331$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                relative: options.relative,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                flushSync: options.flushSync
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            routerNavigate(options.action || action, {
                                defaultShouldRevalidate: options.defaultShouldRevalidate,
                                preventScrollReset: options.preventScrollReset,
                                relative: options.relative,
                                formData: formData,
                                body: body,
                                formMethod: options.method || method,
                                formEncType: options.encType || encType,
                                replace: options.replace,
                                state: options.state,
                                fromRouteId: currentRouteId,
                                flushSync: options.flushSync,
                                viewTransition: options.viewTransition
                            })
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $e19387da9012a331$export$89a6bd6db0d97c56(action) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var basename = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).basename;
    var routeContext = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397));
    (0, $iKEZU.invariant)(routeContext, "useFormAction must be used inside a RouteContext");
    var _routeContext_matches_slice = (0, $21h22._)(routeContext.matches.slice(-1), 1), match = _routeContext_matches_slice[0];
    var path = (0, $lvTkn._)({}, (0, $0386ffc241ff4f20$export$e75d2a2d1b3c245b)(action ? action : ".", {
        relative: relative
    }));
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        var params = new URLSearchParams(path.search);
        var indexValues = params.getAll("index");
        if (indexValues.some(function(v) {
            return v === "";
        })) {
            params.delete("index");
            indexValues.filter(function(v) {
                return v;
            }).forEach(function(v) {
                return params.append("index", v);
            });
            var qs = params.toString();
            path.search = qs ? "?".concat(qs) : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $daRwM.joinPaths)([
        basename,
        path.pathname
    ]);
    return (0, $iKEZU.createPath)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $e19387da9012a331$export$5b0d2d9a9921565a() {
    var key = (arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}).key;
    var _route_matches_;
    var router = $e19387da9012a331$var$useDataRouterContext("useFetcher").router;
    var state = $e19387da9012a331$var$useDataRouterState("useFetcher");
    var fetcherData = $eHaBZ.useContext((0, $333deedcba464643$export$cb3f1df1bef00a39));
    var route = $eHaBZ.useContext((0, $333deedcba464643$export$aac280ed165a4397));
    var routeId = (_route_matches_ = route.matches[route.matches.length - 1]) === null || _route_matches_ === void 0 ? void 0 : _route_matches_.route.id;
    (0, $iKEZU.invariant)(fetcherData, "useFetcher must be used inside a FetchersContext");
    (0, $iKEZU.invariant)(route, "useFetcher must be used inside a RouteContext");
    (0, $iKEZU.invariant)(routeId != null, 'useFetcher can only be used on routes that contain a unique "id"');
    var defaultKey = $eHaBZ.useId();
    var _React$1_useState = (0, $21h22._)($eHaBZ.useState(key || defaultKey), 2), fetcherKey = _React$1_useState[0], setFetcherKey = _React$1_useState[1];
    if (key && key !== fetcherKey) setFetcherKey(key);
    var deleteFetcher = router.deleteFetcher, getFetcher = router.getFetcher, resetFetcher = router.resetFetcher, routerFetch = router.fetch;
    $eHaBZ.useEffect(function() {
        getFetcher(fetcherKey);
        return function() {
            return deleteFetcher(fetcherKey);
        };
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    var load = $eHaBZ.useCallback(function(href, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        (0, $iKEZU.invariant)(routeId, "No routeId available for fetcher.load()");
                        return [
                            4,
                            routerFetch(fetcherKey, routeId, href, opts)
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    var submitImpl = $e19387da9012a331$export$47c85c6e3a081d3();
    var submit = $eHaBZ.useCallback(function(target, opts) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            submitImpl(target, (0, $9Jpjh._)((0, $lvTkn._)({}, opts), {
                                navigate: false,
                                fetcherKey: fetcherKey
                            }))
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        fetcherKey,
        submitImpl
    ]);
    var reset = $eHaBZ.useCallback(function(opts) {
        return resetFetcher(fetcherKey, opts);
    }, [
        resetFetcher,
        fetcherKey
    ]);
    var FetcherForm = $eHaBZ.useMemo(function() {
        var FetcherForm = $eHaBZ.forwardRef(function(props, ref) {
            return /* @__PURE__ */ $eHaBZ.createElement($e19387da9012a331$export$a7fed597f4b8afd8, (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            }));
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    var fetcher = state.fetchers.get(fetcherKey) || (0, $d8c8e9691ac1f69a$export$52eace9c284d3585);
    var data = fetcherData.get(fetcherKey);
    return $eHaBZ.useMemo(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset
        }, fetcher), {
            data: data
        });
    }, [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $e19387da9012a331$export$fa996778a3a31087() {
    var state = $e19387da9012a331$var$useDataRouterState("useFetchers");
    return $eHaBZ.useMemo(function() {
        return Array.from(state.fetchers.entries()).map(function(param) {
            var _param = (0, $21h22._)(param, 2), key = _param[0], fetcher = _param[1];
            return (0, $9Jpjh._)((0, $lvTkn._)({}, fetcher), {
                key: key
            });
        });
    }, [
        state.fetchers
    ]);
}
var $e19387da9012a331$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
var $e19387da9012a331$var$savedScrollPositions = {};
function $e19387da9012a331$var$getScrollRestorationKey(location, matches, basename, getKey) {
    var key = null;
    if (getKey) {
        if (basename !== "/") key = getKey((0, $9Jpjh._)((0, $lvTkn._)({}, location), {
            pathname: (0, $daRwM.stripBasename)(location.pathname, basename) || location.pathname
        }), matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $e19387da9012a331$export$c4ffdfe23dd48040() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, getKey = _ref.getKey, storageKey = _ref.storageKey;
    var router = $e19387da9012a331$var$useDataRouterContext("useScrollRestoration").router;
    var _useDataRouterState = $e19387da9012a331$var$useDataRouterState("useScrollRestoration"), restoreScrollPosition = _useDataRouterState.restoreScrollPosition, preventScrollReset = _useDataRouterState.preventScrollReset;
    var basename = $eHaBZ.useContext((0, $333deedcba464643$export$3044ab7fdabeaee6)).basename;
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var matches = (0, $0386ffc241ff4f20$export$2378eb7f5ff86053)();
    var navigation = (0, $0386ffc241ff4f20$export$d0fd4b7106de2769)();
    $eHaBZ.useEffect(function() {
        window.history.scrollRestoration = "manual";
        return function() {
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $e19387da9012a331$var$usePageShow($eHaBZ.useCallback(function(event) {
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $e19387da9012a331$var$usePageHide($eHaBZ.useCallback(function() {
        if (navigation.state === "idle") {
            var key = $e19387da9012a331$var$getScrollRestorationKey(location, matches, basename, getKey);
            $e19387da9012a331$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $e19387da9012a331$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($e19387da9012a331$var$savedScrollPositions));
        } catch (error) {
            (0, $iKEZU.warning)(false, "Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (".concat(error, ")."));
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $eHaBZ.useLayoutEffect(function() {
            try {
                var sessionPositions = sessionStorage.getItem(storageKey || $e19387da9012a331$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $e19387da9012a331$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch (e) {}
        }, [
            storageKey
        ]);
        $eHaBZ.useLayoutEffect(function() {
            var disableScrollRestoration = router === null || router === void 0 ? void 0 : router.enableScrollRestoration($e19387da9012a331$var$savedScrollPositions, function() {
                return window.scrollY;
            }, getKey ? function(location, matches) {
                return $e19387da9012a331$var$getScrollRestorationKey(location, matches, basename, getKey);
            } : void 0);
            return function() {
                return disableScrollRestoration && disableScrollRestoration();
            };
        }, [
            router,
            basename,
            getKey
        ]);
        $eHaBZ.useLayoutEffect(function() {
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    var el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch (e) {
                (0, $iKEZU.warning)(false, '"'.concat(location.hash.slice(1), '" is not a decodable element ID. The view will not scroll to it.'));
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $e19387da9012a331$export$c0a586b329cae57d(callback, options) {
    var capture = (options || {}).capture;
    $eHaBZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return function() {
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $e19387da9012a331$var$usePageHide(callback, options) {
    var capture = (options || {}).capture;
    $eHaBZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return function() {
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $e19387da9012a331$var$usePageShow(callback, options) {
    var capture = (options || {}).capture;
    $eHaBZ.useEffect(function() {
        var opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return function() {
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $e19387da9012a331$export$fc7731b33eb53a93(param) {
    var when = param.when, message = param.message;
    var blocker = (0, $0386ffc241ff4f20$export$b273b3273281a049)(when);
    $eHaBZ.useEffect(function() {
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $eHaBZ.useEffect(function() {
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $e19387da9012a331$export$e262bd1977bea848(to) {
    var relative = (arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}).relative;
    var vtContext = $eHaBZ.useContext((0, $333deedcba464643$export$3681f408decb40d1));
    (0, $iKEZU.invariant)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    var basename = $e19387da9012a331$var$useDataRouterContext("useViewTransitionState").basename;
    var path = (0, $0386ffc241ff4f20$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    var currentPath = (0, $daRwM.stripBasename)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    var nextPath = (0, $daRwM.stripBasename)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $daRwM.matchPath)(path.pathname, nextPath) != null || (0, $daRwM.matchPath)(path.pathname, currentPath) != null;
}




var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");
function $2017c4963e549b4b$export$71511d61b312f219(strings, raw) {
    if (!raw) raw = strings.slice(0);
    return Object.freeze(Object.defineProperties(strings, {
        raw: {
            value: Object.freeze(raw)
        }
    }));
}



var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

var $eHaBZ = parcelRequire("eHaBZ");
/*!
 * Font Awesome Free 7.3.1 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2026 Fonticons, Inc.
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $39c5346b7e5f0f6d$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
function $39c5346b7e5f0f6d$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(r);
}
function $39c5346b7e5f0f6d$var$_classCallCheck(a, n) {
    if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}
function $39c5346b7e5f0f6d$var$_defineProperties(e, r) {
    for(var t = 0; t < r.length; t++){
        var o = r[t];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, $39c5346b7e5f0f6d$var$_toPropertyKey(o.key), o);
    }
}
function $39c5346b7e5f0f6d$var$_createClass(e, r, t) {
    return r && $39c5346b7e5f0f6d$var$_defineProperties(e.prototype, r), t && $39c5346b7e5f0f6d$var$_defineProperties(e, t), Object.defineProperty(e, "prototype", {
        writable: !1
    }), e;
}
function $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
            t && (r = t);
            var n = 0, F = function F() {};
            return {
                s: F,
                n: function n1() {
                    return n >= r.length ? {
                        done: !0
                    } : {
                        done: !1,
                        value: r[n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = !0, u = !1;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = !0, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $39c5346b7e5f0f6d$var$_defineProperty(e, r, t) {
    return (r = $39c5346b7e5f0f6d$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $39c5346b7e5f0f6d$var$_inherits(t, e) {
    if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
        constructor: {
            value: t,
            writable: !0,
            configurable: !0
        }
    }), Object.defineProperty(t, "prototype", {
        writable: !1
    }), e && $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e);
}
function $39c5346b7e5f0f6d$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $39c5346b7e5f0f6d$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $39c5346b7e5f0f6d$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39c5346b7e5f0f6d$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $39c5346b7e5f0f6d$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $39c5346b7e5f0f6d$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $39c5346b7e5f0f6d$var$ownKeys(Object(t), !0).forEach(function(r) {
            $39c5346b7e5f0f6d$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $39c5346b7e5f0f6d$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e) {
    return $39c5346b7e5f0f6d$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(t, e) {
        return t.__proto__ = e, t;
    }, $39c5346b7e5f0f6d$var$_setPrototypeOf(t, e);
}
function $39c5346b7e5f0f6d$var$_slicedToArray(r, e) {
    return $39c5346b7e5f0f6d$var$_arrayWithHoles(r) || $39c5346b7e5f0f6d$var$_iterableToArrayLimit(r, e) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r, e) || $39c5346b7e5f0f6d$var$_nonIterableRest();
}
function $39c5346b7e5f0f6d$var$_toConsumableArray(r) {
    return $39c5346b7e5f0f6d$var$_arrayWithoutHoles(r) || $39c5346b7e5f0f6d$var$_iterableToArray(r) || $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r) || $39c5346b7e5f0f6d$var$_nonIterableSpread();
}
function $39c5346b7e5f0f6d$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $39c5346b7e5f0f6d$var$_toPropertyKey(t) {
    var i = $39c5346b7e5f0f6d$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) ? i : i + "";
}
function $39c5346b7e5f0f6d$var$_typeof(o) {
    "@babel/helpers - typeof";
    return $39c5346b7e5f0f6d$var$_typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function _typeof(o) {
        return typeof o;
    } : function(o) {
        return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
    }, $39c5346b7e5f0f6d$var$_typeof(o);
}
function $39c5346b7e5f0f6d$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $39c5346b7e5f0f6d$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $39c5346b7e5f0f6d$var$_wrapRegExp() {
    $39c5346b7e5f0f6d$var$_wrapRegExp = function _wrapRegExp(e, r) {
        return new BabelRegExp(e, void 0, r);
    };
    var e = RegExp.prototype, r = new WeakMap();
    function BabelRegExp(e, t, p) {
        var o = RegExp(e, t);
        return r.set(o, p || r.get(e)), $39c5346b7e5f0f6d$var$_setPrototypeOf(o, BabelRegExp.prototype);
    }
    function buildGroups(e, t) {
        var p = r.get(t);
        return Object.keys(p).reduce(function(r, t) {
            var o = p[t];
            if ("number" == typeof o) r[t] = e[o];
            else {
                for(var i = 0; void 0 === e[o[i]] && i + 1 < o.length;)i++;
                r[t] = e[o[i]];
            }
            return r;
        }, Object.create(null));
    }
    return $39c5346b7e5f0f6d$var$_inherits(BabelRegExp, RegExp), BabelRegExp.prototype.exec = function(r) {
        var t = e.exec.call(this, r);
        if (t) {
            t.groups = buildGroups(t, this);
            var p = t.indices;
            p && (p.groups = buildGroups(p, this));
        }
        return t;
    }, BabelRegExp.prototype[Symbol.replace] = function(t, p) {
        if ("string" == typeof p) {
            var o = r.get(this);
            return e[Symbol.replace].call(this, t, p.replace(/\$<([^>]+)(>|$)/g, function(e, r, t) {
                if ("" === t) return e;
                var _$p = o[r];
                return Array.isArray(_$p) ? "$" + _$p.join("$") : "number" == typeof _$p ? "$" + _$p : "";
            }));
        }
        if ("function" == typeof p) {
            var i = this;
            return e[Symbol.replace].call(this, t, function() {
                var e = arguments;
                return "object" != (0, $2bfPH._)(e[e.length - 1]) && (e = [].slice.call(e)).push(buildGroups(e, i)), p.apply(this, e);
            });
        }
        return e[Symbol.replace].call(this, t, p);
    }, $39c5346b7e5f0f6d$var$_wrapRegExp.apply(this, arguments);
}
var $39c5346b7e5f0f6d$var$noop = function noop() {};
var $39c5346b7e5f0f6d$var$_WINDOW = {};
var $39c5346b7e5f0f6d$var$_DOCUMENT = {};
var $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = null;
var $39c5346b7e5f0f6d$var$_PERFORMANCE = {
    mark: $39c5346b7e5f0f6d$var$noop,
    measure: $39c5346b7e5f0f6d$var$noop
};
try {
    if (typeof window !== 'undefined') $39c5346b7e5f0f6d$var$_WINDOW = window;
    if (typeof document !== 'undefined') $39c5346b7e5f0f6d$var$_DOCUMENT = document;
    if (typeof MutationObserver !== 'undefined') $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER = MutationObserver;
    if (typeof performance !== 'undefined') $39c5346b7e5f0f6d$var$_PERFORMANCE = performance;
} catch (e) {} // eslint-disable-line no-empty
var $39c5346b7e5f0f6d$var$_ref = $39c5346b7e5f0f6d$var$_WINDOW.navigator || {}, $39c5346b7e5f0f6d$var$_ref$userAgent = $39c5346b7e5f0f6d$var$_ref.userAgent, $39c5346b7e5f0f6d$var$userAgent = $39c5346b7e5f0f6d$var$_ref$userAgent === void 0 ? '' : $39c5346b7e5f0f6d$var$_ref$userAgent;
var $39c5346b7e5f0f6d$var$WINDOW = $39c5346b7e5f0f6d$var$_WINDOW;
var $39c5346b7e5f0f6d$var$DOCUMENT = $39c5346b7e5f0f6d$var$_DOCUMENT;
var $39c5346b7e5f0f6d$var$MUTATION_OBSERVER = $39c5346b7e5f0f6d$var$_MUTATION_OBSERVER;
var $39c5346b7e5f0f6d$var$PERFORMANCE = $39c5346b7e5f0f6d$var$_PERFORMANCE;
var $39c5346b7e5f0f6d$var$IS_BROWSER = !!$39c5346b7e5f0f6d$var$WINDOW.document;
var $39c5346b7e5f0f6d$var$IS_DOM = !!$39c5346b7e5f0f6d$var$DOCUMENT.documentElement && !!$39c5346b7e5f0f6d$var$DOCUMENT.head && typeof $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener === 'function' && typeof $39c5346b7e5f0f6d$var$DOCUMENT.createElement === 'function';
var $39c5346b7e5f0f6d$var$IS_IE = ~$39c5346b7e5f0f6d$var$userAgent.indexOf('MSIE') || ~$39c5346b7e5f0f6d$var$userAgent.indexOf('Trident/');
var $39c5346b7e5f0f6d$var$_cl;
var $39c5346b7e5f0f6d$var$Z = /fa(k|kd|s|r|l|t|d|dr|dl|dt|b|slr|slpr|wsb|tl|ns|nds|es|gt|jr|jfr|jdr|usb|ufsb|udsb|cr|ss|sr|sl|st|sds|sdr|sdl|sdt|sldr|slpdr|pr|ms|vs)?[\-\ ]/, $39c5346b7e5f0f6d$var$$ = /Font ?Awesome ?([567 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit|Notdog Duo|Notdog|Chisel|Etch|Graphite|Thumbprint|Jelly Fill|Jelly Duo|Jelly|Utility|Utility Fill|Utility Duo|Slab Press|Slab|Slab Duo|Slab Press Duo|Pixel|Mosaic|Vellum|Whiteboard)?.*/i;
var $39c5346b7e5f0f6d$var$rl = {
    classic: {
        fa: "solid",
        fas: "solid",
        "fa-solid": "solid",
        far: "regular",
        "fa-regular": "regular",
        fal: "light",
        "fa-light": "light",
        fat: "thin",
        "fa-thin": "thin",
        fab: "brands",
        "fa-brands": "brands"
    },
    duotone: {
        fa: "solid",
        fad: "solid",
        "fa-solid": "solid",
        "fa-duotone": "solid",
        fadr: "regular",
        "fa-regular": "regular",
        fadl: "light",
        "fa-light": "light",
        fadt: "thin",
        "fa-thin": "thin"
    },
    sharp: {
        fa: "solid",
        fass: "solid",
        "fa-solid": "solid",
        fasr: "regular",
        "fa-regular": "regular",
        fasl: "light",
        "fa-light": "light",
        fast: "thin",
        "fa-thin": "thin"
    },
    "sharp-duotone": {
        fa: "solid",
        fasds: "solid",
        "fa-solid": "solid",
        fasdr: "regular",
        "fa-regular": "regular",
        fasdl: "light",
        "fa-light": "light",
        fasdt: "thin",
        "fa-thin": "thin"
    },
    slab: {
        "fa-regular": "regular",
        faslr: "regular"
    },
    "slab-press": {
        "fa-regular": "regular",
        faslpr: "regular"
    },
    "slab-duo": {
        "fa-regular": "regular",
        fasldr: "regular"
    },
    "slab-press-duo": {
        "fa-regular": "regular",
        faslpdr: "regular"
    },
    thumbprint: {
        "fa-light": "light",
        fatl: "light"
    },
    vellum: {
        "fa-solid": "solid",
        favs: "solid"
    },
    pixel: {
        "fa-regular": "regular",
        fapr: "regular"
    },
    mosaic: {
        "fa-solid": "solid",
        fams: "solid"
    },
    whiteboard: {
        "fa-semibold": "semibold",
        fawsb: "semibold"
    },
    notdog: {
        "fa-solid": "solid",
        fans: "solid"
    },
    "notdog-duo": {
        "fa-solid": "solid",
        fands: "solid"
    },
    etch: {
        "fa-solid": "solid",
        faes: "solid"
    },
    graphite: {
        "fa-thin": "thin",
        fagt: "thin"
    },
    jelly: {
        "fa-regular": "regular",
        fajr: "regular"
    },
    "jelly-fill": {
        "fa-regular": "regular",
        fajfr: "regular"
    },
    "jelly-duo": {
        "fa-regular": "regular",
        fajdr: "regular"
    },
    chisel: {
        "fa-regular": "regular",
        facr: "regular"
    },
    utility: {
        "fa-semibold": "semibold",
        fausb: "semibold"
    },
    "utility-duo": {
        "fa-semibold": "semibold",
        faudsb: "semibold"
    },
    "utility-fill": {
        "fa-semibold": "semibold",
        faufsb: "semibold"
    }
}, $39c5346b7e5f0f6d$var$il = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $39c5346b7e5f0f6d$var$dl = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-graphite",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-slab-press-duo",
    "fa-slab-duo",
    "fa-mosaic",
    "fa-pixel",
    "fa-vellum",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $39c5346b7e5f0f6d$var$u = "classic", $39c5346b7e5f0f6d$var$l = "duotone", $39c5346b7e5f0f6d$var$h = "sharp", $39c5346b7e5f0f6d$var$t = "sharp-duotone", $39c5346b7e5f0f6d$var$g = "chisel", $39c5346b7e5f0f6d$var$n = "etch", $39c5346b7e5f0f6d$var$m = "graphite", $39c5346b7e5f0f6d$var$p = "jelly", $39c5346b7e5f0f6d$var$s = "jelly-duo", $39c5346b7e5f0f6d$var$y = "jelly-fill", $39c5346b7e5f0f6d$var$w = "mosaic", $39c5346b7e5f0f6d$var$x = "notdog", $39c5346b7e5f0f6d$var$e = "notdog-duo", $39c5346b7e5f0f6d$var$b = "pixel", $39c5346b7e5f0f6d$var$c = "slab", $39c5346b7e5f0f6d$var$o = "slab-duo", $39c5346b7e5f0f6d$var$I = "slab-press", $39c5346b7e5f0f6d$var$a = "slab-press-duo", $39c5346b7e5f0f6d$var$r = "thumbprint", $39c5346b7e5f0f6d$var$v = "utility", $39c5346b7e5f0f6d$var$i = "utility-duo", $39c5346b7e5f0f6d$var$F = "utility-fill", $39c5346b7e5f0f6d$var$d = "vellum", $39c5346b7e5f0f6d$var$S = "whiteboard", $39c5346b7e5f0f6d$var$A = "Classic", $39c5346b7e5f0f6d$var$P = "Duotone", $39c5346b7e5f0f6d$var$j = "Sharp", $39c5346b7e5f0f6d$var$B = "Sharp Duotone", $39c5346b7e5f0f6d$var$N = "Chisel", $39c5346b7e5f0f6d$var$D = "Etch", $39c5346b7e5f0f6d$var$k = "Graphite", $39c5346b7e5f0f6d$var$T = "Jelly", $39c5346b7e5f0f6d$var$C = "Jelly Duo", $39c5346b7e5f0f6d$var$W = "Jelly Fill", $39c5346b7e5f0f6d$var$R = "Mosaic", $39c5346b7e5f0f6d$var$K = "Notdog", $39c5346b7e5f0f6d$var$L = "Notdog Duo", $39c5346b7e5f0f6d$var$U = "Pixel", $39c5346b7e5f0f6d$var$J = "Slab", $39c5346b7e5f0f6d$var$_ = "Slab Duo", $39c5346b7e5f0f6d$var$M = "Slab Press", $39c5346b7e5f0f6d$var$E = "Slab Press Duo", $39c5346b7e5f0f6d$var$G = "Thumbprint", $39c5346b7e5f0f6d$var$V = "Utility", $39c5346b7e5f0f6d$var$z = "Utility Duo", $39c5346b7e5f0f6d$var$O = "Utility Fill", $39c5346b7e5f0f6d$var$Y = "Vellum", $39c5346b7e5f0f6d$var$q = "Whiteboard", $39c5346b7e5f0f6d$var$xl = [
    $39c5346b7e5f0f6d$var$u,
    $39c5346b7e5f0f6d$var$l,
    $39c5346b7e5f0f6d$var$h,
    $39c5346b7e5f0f6d$var$t,
    $39c5346b7e5f0f6d$var$g,
    $39c5346b7e5f0f6d$var$n,
    $39c5346b7e5f0f6d$var$m,
    $39c5346b7e5f0f6d$var$p,
    $39c5346b7e5f0f6d$var$s,
    $39c5346b7e5f0f6d$var$y,
    $39c5346b7e5f0f6d$var$w,
    $39c5346b7e5f0f6d$var$x,
    $39c5346b7e5f0f6d$var$e,
    $39c5346b7e5f0f6d$var$b,
    $39c5346b7e5f0f6d$var$c,
    $39c5346b7e5f0f6d$var$o,
    $39c5346b7e5f0f6d$var$I,
    $39c5346b7e5f0f6d$var$a,
    $39c5346b7e5f0f6d$var$r,
    $39c5346b7e5f0f6d$var$v,
    $39c5346b7e5f0f6d$var$i,
    $39c5346b7e5f0f6d$var$F,
    $39c5346b7e5f0f6d$var$d,
    $39c5346b7e5f0f6d$var$S
], $39c5346b7e5f0f6d$var$cl = ($39c5346b7e5f0f6d$var$_cl = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_cl, $39c5346b7e5f0f6d$var$u, $39c5346b7e5f0f6d$var$A), $39c5346b7e5f0f6d$var$l, $39c5346b7e5f0f6d$var$P), $39c5346b7e5f0f6d$var$h, $39c5346b7e5f0f6d$var$j), $39c5346b7e5f0f6d$var$t, $39c5346b7e5f0f6d$var$B), $39c5346b7e5f0f6d$var$g, $39c5346b7e5f0f6d$var$N), $39c5346b7e5f0f6d$var$n, $39c5346b7e5f0f6d$var$D), $39c5346b7e5f0f6d$var$m, $39c5346b7e5f0f6d$var$k), $39c5346b7e5f0f6d$var$p, $39c5346b7e5f0f6d$var$T), $39c5346b7e5f0f6d$var$s, $39c5346b7e5f0f6d$var$C), $39c5346b7e5f0f6d$var$y, $39c5346b7e5f0f6d$var$W), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_cl, $39c5346b7e5f0f6d$var$w, $39c5346b7e5f0f6d$var$R), $39c5346b7e5f0f6d$var$x, $39c5346b7e5f0f6d$var$K), $39c5346b7e5f0f6d$var$e, $39c5346b7e5f0f6d$var$L), $39c5346b7e5f0f6d$var$b, $39c5346b7e5f0f6d$var$U), $39c5346b7e5f0f6d$var$c, $39c5346b7e5f0f6d$var$J), $39c5346b7e5f0f6d$var$o, $39c5346b7e5f0f6d$var$_), $39c5346b7e5f0f6d$var$I, $39c5346b7e5f0f6d$var$M), $39c5346b7e5f0f6d$var$a, $39c5346b7e5f0f6d$var$E), $39c5346b7e5f0f6d$var$r, $39c5346b7e5f0f6d$var$G), $39c5346b7e5f0f6d$var$v, $39c5346b7e5f0f6d$var$V), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_cl, $39c5346b7e5f0f6d$var$i, $39c5346b7e5f0f6d$var$z), $39c5346b7e5f0f6d$var$F, $39c5346b7e5f0f6d$var$O), $39c5346b7e5f0f6d$var$d, $39c5346b7e5f0f6d$var$Y), $39c5346b7e5f0f6d$var$S, $39c5346b7e5f0f6d$var$q));
var $39c5346b7e5f0f6d$var$Al = {
    classic: {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    duotone: {
        900: "fad",
        400: "fadr",
        300: "fadl",
        100: "fadt"
    },
    sharp: {
        900: "fass",
        400: "fasr",
        300: "fasl",
        100: "fast"
    },
    "sharp-duotone": {
        900: "fasds",
        400: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    slab: {
        400: "faslr"
    },
    "slab-press": {
        400: "faslpr"
    },
    "slab-duo": {
        400: "fasldr"
    },
    "slab-press-duo": {
        400: "faslpdr"
    },
    vellum: {
        900: "favs"
    },
    mosaic: {
        900: "fams"
    },
    pixel: {
        400: "fapr"
    },
    whiteboard: {
        600: "fawsb"
    },
    thumbprint: {
        300: "fatl"
    },
    notdog: {
        900: "fans"
    },
    "notdog-duo": {
        900: "fands"
    },
    etch: {
        900: "faes"
    },
    graphite: {
        100: "fagt"
    },
    chisel: {
        400: "facr"
    },
    jelly: {
        400: "fajr"
    },
    "jelly-fill": {
        400: "fajfr"
    },
    "jelly-duo": {
        400: "fajdr"
    },
    utility: {
        600: "fausb"
    },
    "utility-duo": {
        600: "faudsb"
    },
    "utility-fill": {
        600: "faufsb"
    }
};
var $39c5346b7e5f0f6d$var$zl = {
    "Font Awesome 7 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 7 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal",
        100: "fat"
    },
    "Font Awesome 7 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 7 Duotone": {
        900: "fad",
        400: "fadr",
        normal: "fadr",
        300: "fadl",
        100: "fadt"
    },
    "Font Awesome 7 Sharp": {
        900: "fass",
        400: "fasr",
        normal: "fasr",
        300: "fasl",
        100: "fast"
    },
    "Font Awesome 7 Sharp Duotone": {
        900: "fasds",
        400: "fasdr",
        normal: "fasdr",
        300: "fasdl",
        100: "fasdt"
    },
    "Font Awesome 7 Jelly": {
        400: "fajr",
        normal: "fajr"
    },
    "Font Awesome 7 Jelly Fill": {
        400: "fajfr",
        normal: "fajfr"
    },
    "Font Awesome 7 Jelly Duo": {
        400: "fajdr",
        normal: "fajdr"
    },
    "Font Awesome 7 Slab": {
        400: "faslr",
        normal: "faslr"
    },
    "Font Awesome 7 Slab Press": {
        400: "faslpr",
        normal: "faslpr"
    },
    "Font Awesome 7 Slab Duo": {
        400: "fasldr",
        normal: "fasldr"
    },
    "Font Awesome 7 Slab Press Duo": {
        400: "faslpdr",
        normal: "faslpdr"
    },
    "Font Awesome 7 Pixel": {
        400: "fapr",
        normal: "fapr"
    },
    "Font Awesome 7 Mosaic": {
        900: "fams",
        normal: "fams"
    },
    "Font Awesome 7 Vellum": {
        900: "favs",
        normal: "favs"
    },
    "Font Awesome 7 Thumbprint": {
        300: "fatl",
        normal: "fatl"
    },
    "Font Awesome 7 Notdog": {
        900: "fans",
        normal: "fans"
    },
    "Font Awesome 7 Notdog Duo": {
        900: "fands",
        normal: "fands"
    },
    "Font Awesome 7 Etch": {
        900: "faes",
        normal: "faes"
    },
    "Font Awesome 7 Graphite": {
        100: "fagt",
        normal: "fagt"
    },
    "Font Awesome 7 Chisel": {
        400: "facr",
        normal: "facr"
    },
    "Font Awesome 7 Whiteboard": {
        600: "fawsb",
        normal: "fawsb"
    },
    "Font Awesome 7 Utility": {
        600: "fausb",
        normal: "fausb"
    },
    "Font Awesome 7 Utility Duo": {
        600: "faudsb",
        normal: "faudsb"
    },
    "Font Awesome 7 Utility Fill": {
        600: "faufsb",
        normal: "faufsb"
    }
};
var $39c5346b7e5f0f6d$var$Ql = new Map([
    [
        "classic",
        {
            defaultShortPrefixId: "fas",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin",
                "brands"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "duotone",
        {
            defaultShortPrefixId: "fad",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp",
        {
            defaultShortPrefixId: "fass",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "sharp-duotone",
        {
            defaultShortPrefixId: "fasds",
            defaultStyleId: "solid",
            styleIds: [
                "solid",
                "regular",
                "light",
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "chisel",
        {
            defaultShortPrefixId: "facr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "etch",
        {
            defaultShortPrefixId: "faes",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "graphite",
        {
            defaultShortPrefixId: "fagt",
            defaultStyleId: "thin",
            styleIds: [
                "thin"
            ],
            futureStyleIds: [],
            defaultFontWeight: 100
        }
    ],
    [
        "jelly",
        {
            defaultShortPrefixId: "fajr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-duo",
        {
            defaultShortPrefixId: "fajdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "jelly-fill",
        {
            defaultShortPrefixId: "fajfr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "mosaic",
        {
            defaultShortPrefixId: "fams",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog",
        {
            defaultShortPrefixId: "fans",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "notdog-duo",
        {
            defaultShortPrefixId: "fands",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "pixel",
        {
            defaultShortPrefixId: "fapr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab",
        {
            defaultShortPrefixId: "faslr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-duo",
        {
            defaultShortPrefixId: "fasldr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press",
        {
            defaultShortPrefixId: "faslpr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "slab-press-duo",
        {
            defaultShortPrefixId: "faslpdr",
            defaultStyleId: "regular",
            styleIds: [
                "regular"
            ],
            futureStyleIds: [],
            defaultFontWeight: 400
        }
    ],
    [
        "thumbprint",
        {
            defaultShortPrefixId: "fatl",
            defaultStyleId: "light",
            styleIds: [
                "light"
            ],
            futureStyleIds: [],
            defaultFontWeight: 300
        }
    ],
    [
        "utility",
        {
            defaultShortPrefixId: "fausb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-duo",
        {
            defaultShortPrefixId: "faudsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "utility-fill",
        {
            defaultShortPrefixId: "faufsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ],
    [
        "vellum",
        {
            defaultShortPrefixId: "favs",
            defaultStyleId: "solid",
            styleIds: [
                "solid"
            ],
            futureStyleIds: [],
            defaultFontWeight: 900
        }
    ],
    [
        "whiteboard",
        {
            defaultShortPrefixId: "fawsb",
            defaultStyleId: "semibold",
            styleIds: [
                "semibold"
            ],
            futureStyleIds: [],
            defaultFontWeight: 600
        }
    ]
]), $39c5346b7e5f0f6d$var$$l = {
    chisel: {
        regular: "facr"
    },
    classic: {
        brands: "fab",
        light: "fal",
        regular: "far",
        solid: "fas",
        thin: "fat"
    },
    duotone: {
        light: "fadl",
        regular: "fadr",
        solid: "fad",
        thin: "fadt"
    },
    etch: {
        solid: "faes"
    },
    graphite: {
        thin: "fagt"
    },
    jelly: {
        regular: "fajr"
    },
    "jelly-duo": {
        regular: "fajdr"
    },
    "jelly-fill": {
        regular: "fajfr"
    },
    mosaic: {
        solid: "fams"
    },
    notdog: {
        solid: "fans"
    },
    "notdog-duo": {
        solid: "fands"
    },
    pixel: {
        regular: "fapr"
    },
    sharp: {
        light: "fasl",
        regular: "fasr",
        solid: "fass",
        thin: "fast"
    },
    "sharp-duotone": {
        light: "fasdl",
        regular: "fasdr",
        solid: "fasds",
        thin: "fasdt"
    },
    slab: {
        regular: "faslr"
    },
    "slab-duo": {
        regular: "fasldr"
    },
    "slab-press": {
        regular: "faslpr"
    },
    "slab-press-duo": {
        regular: "faslpdr"
    },
    thumbprint: {
        light: "fatl"
    },
    utility: {
        semibold: "fausb"
    },
    "utility-duo": {
        semibold: "faudsb"
    },
    "utility-fill": {
        semibold: "faufsb"
    },
    vellum: {
        solid: "favs"
    },
    whiteboard: {
        semibold: "fawsb"
    }
};
var $39c5346b7e5f0f6d$var$at = [
    "fak",
    "fa-kit",
    "fakd",
    "fa-kit-duotone"
], $39c5346b7e5f0f6d$var$rt = {
    kit: {
        fak: "kit",
        "fa-kit": "kit"
    },
    "kit-duotone": {
        fakd: "kit-duotone",
        "fa-kit-duotone": "kit-duotone"
    }
}, $39c5346b7e5f0f6d$var$it = [
    "kit"
];
var $39c5346b7e5f0f6d$var$H = "kit", $39c5346b7e5f0f6d$var$f = "kit-duotone", $39c5346b7e5f0f6d$var$Q = "Kit", $39c5346b7e5f0f6d$var$X = "Kit Duotone", $39c5346b7e5f0f6d$var$ht = $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty({}, $39c5346b7e5f0f6d$var$H, $39c5346b7e5f0f6d$var$Q), $39c5346b7e5f0f6d$var$f, $39c5346b7e5f0f6d$var$X);
var $39c5346b7e5f0f6d$var$mt = {
    kit: {
        "fa-kit": "fak"
    },
    "kit-duotone": {
        "fa-kit-duotone": "fakd"
    }
};
var $39c5346b7e5f0f6d$var$ct = {
    "Font Awesome Kit": {
        400: "fak",
        normal: "fak"
    },
    "Font Awesome Kit Duotone": {
        400: "fakd",
        normal: "fakd"
    }
}, $39c5346b7e5f0f6d$var$It = {
    kit: {
        fak: "fa-kit"
    },
    "kit-duotone": {
        fakd: "fa-kit-duotone"
    }
};
var $39c5346b7e5f0f6d$var$St = {
    kit: {
        kit: "fak"
    },
    "kit-duotone": {
        "kit-duotone": "fakd"
    }
};
var $39c5346b7e5f0f6d$var$_jl;
var $39c5346b7e5f0f6d$var$l$1 = {
    GROUP: "duotone-group",
    SWAP_OPACITY: "swap-opacity",
    PRIMARY: "primary",
    SECONDARY: "secondary"
}, $39c5346b7e5f0f6d$var$n$1 = [
    "fa-classic",
    "fa-duotone",
    "fa-sharp",
    "fa-sharp-duotone",
    "fa-thumbprint",
    "fa-whiteboard",
    "fa-notdog",
    "fa-notdog-duo",
    "fa-chisel",
    "fa-etch",
    "fa-graphite",
    "fa-jelly",
    "fa-jelly-fill",
    "fa-jelly-duo",
    "fa-slab",
    "fa-slab-press",
    "fa-slab-press-duo",
    "fa-slab-duo",
    "fa-mosaic",
    "fa-pixel",
    "fa-vellum",
    "fa-utility",
    "fa-utility-duo",
    "fa-utility-fill"
];
var $39c5346b7e5f0f6d$var$g$1 = "classic", $39c5346b7e5f0f6d$var$a$1 = "duotone", $39c5346b7e5f0f6d$var$m$1 = "sharp", $39c5346b7e5f0f6d$var$t$1 = "sharp-duotone", $39c5346b7e5f0f6d$var$p$1 = "chisel", $39c5346b7e5f0f6d$var$y$1 = "etch", $39c5346b7e5f0f6d$var$b$1 = "graphite", $39c5346b7e5f0f6d$var$w$1 = "jelly", $39c5346b7e5f0f6d$var$e$1 = "jelly-duo", $39c5346b7e5f0f6d$var$x$1 = "jelly-fill", $39c5346b7e5f0f6d$var$c$1 = "mosaic", $39c5346b7e5f0f6d$var$I$1 = "notdog", $39c5346b7e5f0f6d$var$o$1 = "notdog-duo", $39c5346b7e5f0f6d$var$v$1 = "pixel", $39c5346b7e5f0f6d$var$F$1 = "slab", $39c5346b7e5f0f6d$var$r$1 = "slab-duo", $39c5346b7e5f0f6d$var$S$1 = "slab-press", $39c5346b7e5f0f6d$var$i$1 = "slab-press-duo", $39c5346b7e5f0f6d$var$d$1 = "thumbprint", $39c5346b7e5f0f6d$var$A$1 = "utility", $39c5346b7e5f0f6d$var$f$1 = "utility-duo", $39c5346b7e5f0f6d$var$P$1 = "utility-fill", $39c5346b7e5f0f6d$var$u$1 = "vellum", $39c5346b7e5f0f6d$var$j$1 = "whiteboard", $39c5346b7e5f0f6d$var$B$1 = "Classic", $39c5346b7e5f0f6d$var$N$1 = "Duotone", $39c5346b7e5f0f6d$var$D$1 = "Sharp", $39c5346b7e5f0f6d$var$k$1 = "Sharp Duotone", $39c5346b7e5f0f6d$var$C$1 = "Chisel", $39c5346b7e5f0f6d$var$T$1 = "Etch", $39c5346b7e5f0f6d$var$L$1 = "Graphite", $39c5346b7e5f0f6d$var$W$1 = "Jelly", $39c5346b7e5f0f6d$var$R$1 = "Jelly Duo", $39c5346b7e5f0f6d$var$K$1 = "Jelly Fill", $39c5346b7e5f0f6d$var$U$1 = "Mosaic", $39c5346b7e5f0f6d$var$J$1 = "Notdog", $39c5346b7e5f0f6d$var$_$1 = "Notdog Duo", $39c5346b7e5f0f6d$var$M$1 = "Pixel", $39c5346b7e5f0f6d$var$E$1 = "Slab", $39c5346b7e5f0f6d$var$G$1 = "Slab Duo", $39c5346b7e5f0f6d$var$O$1 = "Slab Press", $39c5346b7e5f0f6d$var$V$1 = "Slab Press Duo", $39c5346b7e5f0f6d$var$z$1 = "Thumbprint", $39c5346b7e5f0f6d$var$Y$1 = "Utility", $39c5346b7e5f0f6d$var$$$1 = "Utility Duo", $39c5346b7e5f0f6d$var$q$1 = "Utility Fill", $39c5346b7e5f0f6d$var$H$1 = "Vellum", $39c5346b7e5f0f6d$var$Q$1 = "Whiteboard", $39c5346b7e5f0f6d$var$jl$1 = ($39c5346b7e5f0f6d$var$_jl = {}, $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_jl, $39c5346b7e5f0f6d$var$g$1, $39c5346b7e5f0f6d$var$B$1), $39c5346b7e5f0f6d$var$a$1, $39c5346b7e5f0f6d$var$N$1), $39c5346b7e5f0f6d$var$m$1, $39c5346b7e5f0f6d$var$D$1), $39c5346b7e5f0f6d$var$t$1, $39c5346b7e5f0f6d$var$k$1), $39c5346b7e5f0f6d$var$p$1, $39c5346b7e5f0f6d$var$C$1), $39c5346b7e5f0f6d$var$y$1, $39c5346b7e5f0f6d$var$T$1), $39c5346b7e5f0f6d$var$b$1, $39c5346b7e5f0f6d$var$L$1), $39c5346b7e5f0f6d$var$w$1, $39c5346b7e5f0f6d$var$W$1), $39c5346b7e5f0f6d$var$e$1, $39c5346b7e5f0f6d$var$R$1), $39c5346b7e5f0f6d$var$x$1, $39c5346b7e5f0f6d$var$K$1), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_jl, $39c5346b7e5f0f6d$var$c$1, $39c5346b7e5f0f6d$var$U$1), $39c5346b7e5f0f6d$var$I$1, $39c5346b7e5f0f6d$var$J$1), $39c5346b7e5f0f6d$var$o$1, $39c5346b7e5f0f6d$var$_$1), $39c5346b7e5f0f6d$var$v$1, $39c5346b7e5f0f6d$var$M$1), $39c5346b7e5f0f6d$var$F$1, $39c5346b7e5f0f6d$var$E$1), $39c5346b7e5f0f6d$var$r$1, $39c5346b7e5f0f6d$var$G$1), $39c5346b7e5f0f6d$var$S$1, $39c5346b7e5f0f6d$var$O$1), $39c5346b7e5f0f6d$var$i$1, $39c5346b7e5f0f6d$var$V$1), $39c5346b7e5f0f6d$var$d$1, $39c5346b7e5f0f6d$var$z$1), $39c5346b7e5f0f6d$var$A$1, $39c5346b7e5f0f6d$var$Y$1), $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_jl, $39c5346b7e5f0f6d$var$f$1, $39c5346b7e5f0f6d$var$$$1), $39c5346b7e5f0f6d$var$P$1, $39c5346b7e5f0f6d$var$q$1), $39c5346b7e5f0f6d$var$u$1, $39c5346b7e5f0f6d$var$H$1), $39c5346b7e5f0f6d$var$j$1, $39c5346b7e5f0f6d$var$Q$1));
var $39c5346b7e5f0f6d$var$X$1 = "kit", $39c5346b7e5f0f6d$var$h$1 = "kit-duotone", $39c5346b7e5f0f6d$var$Z$1 = "Kit", $39c5346b7e5f0f6d$var$ll$1 = "Kit Duotone", $39c5346b7e5f0f6d$var$ws = $39c5346b7e5f0f6d$var$_defineProperty($39c5346b7e5f0f6d$var$_defineProperty({}, $39c5346b7e5f0f6d$var$X$1, $39c5346b7e5f0f6d$var$Z$1), $39c5346b7e5f0f6d$var$h$1, $39c5346b7e5f0f6d$var$ll$1);
var $39c5346b7e5f0f6d$var$ra = {
    classic: {
        "fa-brands": "fab",
        "fa-duotone": "fad",
        "fa-light": "fal",
        "fa-regular": "far",
        "fa-solid": "fas",
        "fa-thin": "fat"
    },
    duotone: {
        "fa-regular": "fadr",
        "fa-light": "fadl",
        "fa-thin": "fadt"
    },
    sharp: {
        "fa-solid": "fass",
        "fa-regular": "fasr",
        "fa-light": "fasl",
        "fa-thin": "fast"
    },
    "sharp-duotone": {
        "fa-solid": "fasds",
        "fa-regular": "fasdr",
        "fa-light": "fasdl",
        "fa-thin": "fasdt"
    },
    slab: {
        "fa-regular": "faslr"
    },
    "slab-press": {
        "fa-regular": "faslpr"
    },
    "slab-duo": {
        "fa-regular": "fasldr"
    },
    "slab-press-duo": {
        "fa-regular": "faslpdr"
    },
    pixel: {
        "fa-regular": "fapr"
    },
    mosaic: {
        "fa-solid": "fams"
    },
    vellum: {
        "fa-solid": "favs"
    },
    whiteboard: {
        "fa-semibold": "fawsb"
    },
    thumbprint: {
        "fa-light": "fatl"
    },
    notdog: {
        "fa-solid": "fans"
    },
    "notdog-duo": {
        "fa-solid": "fands"
    },
    etch: {
        "fa-solid": "faes"
    },
    graphite: {
        "fa-thin": "fagt"
    },
    jelly: {
        "fa-regular": "fajr"
    },
    "jelly-fill": {
        "fa-regular": "fajfr"
    },
    "jelly-duo": {
        "fa-regular": "fajdr"
    },
    chisel: {
        "fa-regular": "facr"
    },
    utility: {
        "fa-semibold": "fausb"
    },
    "utility-duo": {
        "fa-semibold": "faudsb"
    },
    "utility-fill": {
        "fa-semibold": "faufsb"
    }
}, $39c5346b7e5f0f6d$var$al$1 = {
    classic: [
        "fas",
        "far",
        "fal",
        "fat",
        "fad"
    ],
    duotone: [
        "fadr",
        "fadl",
        "fadt"
    ],
    sharp: [
        "fass",
        "fasr",
        "fasl",
        "fast"
    ],
    "sharp-duotone": [
        "fasds",
        "fasdr",
        "fasdl",
        "fasdt"
    ],
    slab: [
        "faslr"
    ],
    "slab-press": [
        "faslpr"
    ],
    "slab-duo": [
        "fasldr"
    ],
    "slab-press-duo": [
        "faslpdr"
    ],
    pixel: [
        "fapr"
    ],
    mosaic: [
        "fams"
    ],
    vellum: [
        "favs"
    ],
    whiteboard: [
        "fawsb"
    ],
    thumbprint: [
        "fatl"
    ],
    notdog: [
        "fans"
    ],
    "notdog-duo": [
        "fands"
    ],
    etch: [
        "faes"
    ],
    graphite: [
        "fagt"
    ],
    jelly: [
        "fajr"
    ],
    "jelly-fill": [
        "fajfr"
    ],
    "jelly-duo": [
        "fajdr"
    ],
    chisel: [
        "facr"
    ],
    utility: [
        "fausb"
    ],
    "utility-duo": [
        "faudsb"
    ],
    "utility-fill": [
        "faufsb"
    ]
}, $39c5346b7e5f0f6d$var$da = {
    classic: {
        fab: "fa-brands",
        fad: "fa-duotone",
        fal: "fa-light",
        far: "fa-regular",
        fas: "fa-solid",
        fat: "fa-thin"
    },
    duotone: {
        fadr: "fa-regular",
        fadl: "fa-light",
        fadt: "fa-thin"
    },
    sharp: {
        fass: "fa-solid",
        fasr: "fa-regular",
        fasl: "fa-light",
        fast: "fa-thin"
    },
    "sharp-duotone": {
        fasds: "fa-solid",
        fasdr: "fa-regular",
        fasdl: "fa-light",
        fasdt: "fa-thin"
    },
    slab: {
        faslr: "fa-regular"
    },
    "slab-press": {
        faslpr: "fa-regular"
    },
    "slab-duo": {
        fasldr: "fa-regular"
    },
    "slab-press-duo": {
        faslpdr: "fa-regular"
    },
    pixel: {
        fapr: "fa-regular"
    },
    mosaic: {
        fams: "fa-solid"
    },
    vellum: {
        favs: "fa-solid"
    },
    whiteboard: {
        fawsb: "fa-semibold"
    },
    thumbprint: {
        fatl: "fa-light"
    },
    notdog: {
        fans: "fa-solid"
    },
    "notdog-duo": {
        fands: "fa-solid"
    },
    etch: {
        faes: "fa-solid"
    },
    graphite: {
        fagt: "fa-thin"
    },
    jelly: {
        fajr: "fa-regular"
    },
    "jelly-fill": {
        fajfr: "fa-regular"
    },
    "jelly-duo": {
        fajdr: "fa-regular"
    },
    chisel: {
        facr: "fa-regular"
    },
    utility: {
        fausb: "fa-semibold"
    },
    "utility-duo": {
        faudsb: "fa-semibold"
    },
    "utility-fill": {
        faufsb: "fa-semibold"
    }
}, $39c5346b7e5f0f6d$var$tl = [
    "fa-solid",
    "fa-regular",
    "fa-light",
    "fa-thin",
    "fa-duotone",
    "fa-brands",
    "fa-semibold"
], $39c5346b7e5f0f6d$var$ha = [
    "fa",
    "fas",
    "far",
    "fal",
    "fat",
    "fad",
    "fadr",
    "fadl",
    "fadt",
    "fab",
    "fass",
    "fasr",
    "fasl",
    "fast",
    "fasds",
    "fasdr",
    "fasdl",
    "fasdt",
    "faslr",
    "faslpr",
    "fasldr",
    "faslpdr",
    "fapr",
    "fams",
    "favs",
    "fawsb",
    "fatl",
    "fans",
    "fands",
    "faes",
    "fagt",
    "fajr",
    "fajfr",
    "fajdr",
    "facr",
    "fausb",
    "faudsb",
    "faufsb"
].concat($39c5346b7e5f0f6d$var$n$1, $39c5346b7e5f0f6d$var$tl), $39c5346b7e5f0f6d$var$el$1 = [
    "solid",
    "regular",
    "light",
    "thin",
    "duotone",
    "brands",
    "semibold"
], $39c5346b7e5f0f6d$var$sl$1 = [
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10
], $39c5346b7e5f0f6d$var$ol$1 = $39c5346b7e5f0f6d$var$sl$1.concat([
    11,
    12,
    13,
    14,
    15,
    16,
    17,
    18,
    19,
    20
]), $39c5346b7e5f0f6d$var$rl$1 = [
    "aw",
    "fw",
    "pull-left",
    "pull-right"
], $39c5346b7e5f0f6d$var$ga = [].concat($39c5346b7e5f0f6d$var$_toConsumableArray(Object.keys($39c5346b7e5f0f6d$var$al$1)), $39c5346b7e5f0f6d$var$el$1, $39c5346b7e5f0f6d$var$rl$1, [
    "2xs",
    "xs",
    "sm",
    "lg",
    "xl",
    "2xl",
    "beat",
    "beat-fade",
    "border",
    "bounce",
    "buzz",
    "canvas-square",
    "canvas-roomy",
    "fade",
    "flip-360",
    "flip-both",
    "flip-horizontal",
    "flip-vertical",
    "flip",
    "float",
    "inverse",
    "jello",
    "layers",
    "layers-bottom-left",
    "layers-bottom-right",
    "layers-counter",
    "layers-text",
    "layers-top-left",
    "layers-top-right",
    "li",
    "pull-end",
    "pull-start",
    "pulse",
    "rotate-180",
    "rotate-270",
    "rotate-90",
    "rotate-by",
    "shake",
    "spin-pulse",
    "spin-reverse",
    "spin",
    "spin-snap",
    "spin-snap-4",
    "spin-snap-8",
    "stack-1x",
    "stack-2x",
    "stack",
    "swing",
    "ul",
    "wag",
    "width-auto",
    "width-fixed",
    $39c5346b7e5f0f6d$var$l$1.GROUP,
    $39c5346b7e5f0f6d$var$l$1.SWAP_OPACITY,
    $39c5346b7e5f0f6d$var$l$1.PRIMARY,
    $39c5346b7e5f0f6d$var$l$1.SECONDARY
]).concat($39c5346b7e5f0f6d$var$sl$1.map(function(s) {
    return "".concat(s, "x");
})).concat($39c5346b7e5f0f6d$var$ol$1.map(function(s) {
    return "w-".concat(s);
}));
var $39c5346b7e5f0f6d$var$wa = {
    "Font Awesome 5 Free": {
        900: "fas",
        400: "far"
    },
    "Font Awesome 5 Pro": {
        900: "fas",
        400: "far",
        normal: "far",
        300: "fal"
    },
    "Font Awesome 5 Brands": {
        400: "fab",
        normal: "fab"
    },
    "Font Awesome 5 Duotone": {
        900: "fad"
    }
};
var $39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER = '___FONT_AWESOME___';
var $39c5346b7e5f0f6d$var$UNITS_IN_GRID = 16;
var $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX = 'fa';
var $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS = 'svg-inline--fa';
var $39c5346b7e5f0f6d$var$DATA_FA_I2SVG = 'data-fa-i2svg';
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT = 'data-fa-pseudo-element';
var $39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING = 'data-fa-pseudo-element-pending';
var $39c5346b7e5f0f6d$var$DATA_PREFIX = 'data-prefix';
var $39c5346b7e5f0f6d$var$DATA_ICON = 'data-icon';
var $39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS = 'fontawesome-i2svg';
var $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC = 'async';
var $39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS = [
    'HTML',
    'HEAD',
    'STYLE',
    'SCRIPT'
];
var $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS = [
    '::before',
    '::after',
    ':before',
    ':after'
];
var $39c5346b7e5f0f6d$var$PRODUCTION = function() {
    try {
        return true;
    } catch (e$$1) {
        return false;
    }
}();
function $39c5346b7e5f0f6d$var$familyProxy(obj) {
    // Defaults to the classic family if family is not available
    return new Proxy(obj, {
        get: function get(target, prop) {
            return prop in target ? target[prop] : target[$39c5346b7e5f0f6d$var$u];
        }
    });
}
var $39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$rl);
// We changed FACSSClassesToStyleId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _PREFIX_TO_STYLE below, so we are manually adding
// {'fa-duotone': 'duotone'}
$39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE[$39c5346b7e5f0f6d$var$u] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    'fa-duotone': 'duotone'
}), $39c5346b7e5f0f6d$var$rl[$39c5346b7e5f0f6d$var$u]), $39c5346b7e5f0f6d$var$rt['kit']), $39c5346b7e5f0f6d$var$rt['kit-duotone']);
var $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_PREFIX_TO_STYLE);
var $39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$$l);
// We changed FAStyleIdToShortPrefixId in the icons repo to be canonical and as such, "classic" family does not have any
// duotone styles.  But we do still need duotone in _STYLE_TO_PREFIX below, so we are manually adding {duotone: 'fad'}
$39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$u] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    duotone: 'fad'
}), $39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$u]), $39c5346b7e5f0f6d$var$St['kit']), $39c5346b7e5f0f6d$var$St['kit-duotone']);
var $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_STYLE_TO_PREFIX);
var $39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$da);
$39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$u] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$u]), $39c5346b7e5f0f6d$var$It['kit']);
var $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_PREFIX_TO_LONG_STYLE);
var $39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ra);
$39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$u] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX[$39c5346b7e5f0f6d$var$u]), $39c5346b7e5f0f6d$var$mt['kit']);
var $39c5346b7e5f0f6d$var$LONG_STYLE_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_LONG_STYLE_TO_PREFIX);
var $39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN = $39c5346b7e5f0f6d$var$Z;
var $39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME = 'fa-layers-text';
var $39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN = $39c5346b7e5f0f6d$var$$;
var $39c5346b7e5f0f6d$var$_FONT_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$Al);
var $39c5346b7e5f0f6d$var$FONT_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$familyProxy($39c5346b7e5f0f6d$var$_FONT_WEIGHT_TO_PREFIX);
var $39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION = [
    'class',
    'data-prefix',
    'data-icon',
    'data-fa-transform',
    'data-fa-mask'
];
var $39c5346b7e5f0f6d$var$DUOTONE_CLASSES = $39c5346b7e5f0f6d$var$il;
var $39c5346b7e5f0f6d$var$RESERVED_CLASSES = [].concat($39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$it), $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$ga));
var $39c5346b7e5f0f6d$var$initial = $39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig || {};
function $39c5346b7e5f0f6d$var$getAttrConfig(attr) {
    var element = $39c5346b7e5f0f6d$var$DOCUMENT.querySelector('script[' + attr + ']');
    if (element) return element.getAttribute(attr);
}
function $39c5346b7e5f0f6d$var$coerce(val) {
    // Getting an empty string will occur if the attribute is set on the HTML tag but without a value
    // We'll assume that this is an indication that it should be toggled to true
    if (val === '') return true;
    if (val === 'false') return false;
    if (val === 'true') return true;
    return val;
}
if ($39c5346b7e5f0f6d$var$DOCUMENT && typeof $39c5346b7e5f0f6d$var$DOCUMENT.querySelector === 'function') {
    var $39c5346b7e5f0f6d$var$attrs = [
        [
            'data-family-prefix',
            'familyPrefix'
        ],
        [
            'data-css-prefix',
            'cssPrefix'
        ],
        [
            'data-family-default',
            'familyDefault'
        ],
        [
            'data-style-default',
            'styleDefault'
        ],
        [
            'data-replacement-class',
            'replacementClass'
        ],
        [
            'data-auto-replace-svg',
            'autoReplaceSvg'
        ],
        [
            'data-auto-add-css',
            'autoAddCss'
        ],
        [
            'data-search-pseudo-elements',
            'searchPseudoElements'
        ],
        [
            'data-search-pseudo-elements-warnings',
            'searchPseudoElementsWarnings'
        ],
        [
            'data-search-pseudo-elements-full-scan',
            'searchPseudoElementsFullScan'
        ],
        [
            'data-observe-mutations',
            'observeMutations'
        ],
        [
            'data-mutate-approach',
            'mutateApproach'
        ],
        [
            'data-keep-original-source',
            'keepOriginalSource'
        ],
        [
            'data-measure-performance',
            'measurePerformance'
        ],
        [
            'data-show-missing-icons',
            'showMissingIcons'
        ]
    ];
    $39c5346b7e5f0f6d$var$attrs.forEach(function(_ref) {
        var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), attr = _ref2[0], key = _ref2[1];
        var val = $39c5346b7e5f0f6d$var$coerce($39c5346b7e5f0f6d$var$getAttrConfig(attr));
        if (val !== undefined && val !== null) $39c5346b7e5f0f6d$var$initial[key] = val;
    });
}
var $39c5346b7e5f0f6d$var$_default = {
    styleDefault: 'solid',
    familyDefault: $39c5346b7e5f0f6d$var$u,
    cssPrefix: $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX,
    replacementClass: $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS,
    autoReplaceSvg: true,
    autoAddCss: true,
    searchPseudoElements: false,
    searchPseudoElementsWarnings: true,
    searchPseudoElementsFullScan: false,
    observeMutations: true,
    mutateApproach: 'async',
    keepOriginalSource: true,
    measurePerformance: false,
    showMissingIcons: true
};
// familyPrefix is deprecated but we must still support it if present
if ($39c5346b7e5f0f6d$var$initial.familyPrefix) $39c5346b7e5f0f6d$var$initial.cssPrefix = $39c5346b7e5f0f6d$var$initial.familyPrefix;
var $39c5346b7e5f0f6d$var$_config = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$_default), $39c5346b7e5f0f6d$var$initial);
if (!$39c5346b7e5f0f6d$var$_config.autoReplaceSvg) $39c5346b7e5f0f6d$var$_config.observeMutations = false;
var $39c5346b7e5f0f6d$var$config = {};
Object.keys($39c5346b7e5f0f6d$var$_default).forEach(function(key) {
    Object.defineProperty($39c5346b7e5f0f6d$var$config, key, {
        enumerable: true,
        set: function set(val) {
            $39c5346b7e5f0f6d$var$_config[key] = val;
            $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
                return cb($39c5346b7e5f0f6d$var$config);
            });
        },
        get: function get() {
            return $39c5346b7e5f0f6d$var$_config[key];
        }
    });
});
// familyPrefix is deprecated as of 6.2.0 and should be removed in 7.0.0
Object.defineProperty($39c5346b7e5f0f6d$var$config, 'familyPrefix', {
    enumerable: true,
    set: function set(val) {
        $39c5346b7e5f0f6d$var$_config.cssPrefix = val;
        $39c5346b7e5f0f6d$var$_onChangeCb.forEach(function(cb) {
            return cb($39c5346b7e5f0f6d$var$config);
        });
    },
    get: function get() {
        return $39c5346b7e5f0f6d$var$_config.cssPrefix;
    }
});
$39c5346b7e5f0f6d$var$WINDOW.FontAwesomeConfig = $39c5346b7e5f0f6d$var$config;
var $39c5346b7e5f0f6d$var$_onChangeCb = [];
function $39c5346b7e5f0f6d$var$onChange(cb) {
    $39c5346b7e5f0f6d$var$_onChangeCb.push(cb);
    return function() {
        $39c5346b7e5f0f6d$var$_onChangeCb.splice($39c5346b7e5f0f6d$var$_onChangeCb.indexOf(cb), 1);
    };
}
var $39c5346b7e5f0f6d$var$d$2 = $39c5346b7e5f0f6d$var$UNITS_IN_GRID;
var $39c5346b7e5f0f6d$var$meaninglessTransform = {
    size: 16,
    x: 0,
    y: 0,
    rotate: 0,
    flipX: false,
    flipY: false
};
function $39c5346b7e5f0f6d$var$insertCss(css) {
    if (!css || !$39c5346b7e5f0f6d$var$IS_DOM) return;
    var style = $39c5346b7e5f0f6d$var$DOCUMENT.createElement('style');
    style.setAttribute('type', 'text/css');
    style.innerHTML = css;
    var headChildren = $39c5346b7e5f0f6d$var$DOCUMENT.head.childNodes;
    var beforeChild = null;
    for(var i = headChildren.length - 1; i > -1; i--){
        var child = headChildren[i];
        var tagName = (child.tagName || '').toUpperCase();
        if ([
            'STYLE',
            'LINK'
        ].indexOf(tagName) > -1) beforeChild = child;
    }
    $39c5346b7e5f0f6d$var$DOCUMENT.head.insertBefore(style, beforeChild);
    return css;
}
var $39c5346b7e5f0f6d$var$idPool = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
function $39c5346b7e5f0f6d$var$nextUniqueId() {
    var size = 12;
    var id = '';
    while(size-- > 0)id += $39c5346b7e5f0f6d$var$idPool[Math.random() * 62 | 0];
    return id;
}
function $39c5346b7e5f0f6d$var$toArray(obj) {
    var array = [];
    for(var i = (obj || []).length >>> 0; i--;)array[i] = obj[i];
    return array;
}
function $39c5346b7e5f0f6d$var$classArray(node) {
    if (node.classList) return $39c5346b7e5f0f6d$var$toArray(node.classList);
    else return (node.getAttribute('class') || '').split(' ').filter(function(i) {
        return i;
    });
}
function $39c5346b7e5f0f6d$var$htmlEscape(str) {
    return "".concat(str).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/'/g, '&#39;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
}
function $39c5346b7e5f0f6d$var$joinAttributes(attributes) {
    return Object.keys(attributes || {}).reduce(function(acc, attributeName) {
        return acc + "".concat(attributeName, "=\"").concat($39c5346b7e5f0f6d$var$htmlEscape(attributes[attributeName]), "\" ");
    }, '').trim();
}
function $39c5346b7e5f0f6d$var$joinStyles(styles) {
    return Object.keys(styles || {}).reduce(function(acc, styleName) {
        return acc + "".concat(styleName, ": ").concat(styles[styleName].trim(), ";");
    }, '');
}
function $39c5346b7e5f0f6d$var$transformIsMeaningful(transform) {
    return transform.size !== $39c5346b7e5f0f6d$var$meaninglessTransform.size || transform.x !== $39c5346b7e5f0f6d$var$meaninglessTransform.x || transform.y !== $39c5346b7e5f0f6d$var$meaninglessTransform.y || transform.rotate !== $39c5346b7e5f0f6d$var$meaninglessTransform.rotate || transform.flipX || transform.flipY;
}
function $39c5346b7e5f0f6d$var$transformForSvg(_ref) {
    var transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
    var outer = {
        transform: "translate(".concat(containerWidth / 2, " 256)")
    };
    var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
    var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
    var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
    var inner = {
        transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
    };
    var path = {
        transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
    };
    return {
        outer: outer,
        inner: inner,
        path: path
    };
}
function $39c5346b7e5f0f6d$var$transformForCss(_ref2) {
    var transform = _ref2.transform, _ref2$width = _ref2.width, width = _ref2$width === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$width, _ref2$height = _ref2.height, height = _ref2$height === void 0 ? $39c5346b7e5f0f6d$var$UNITS_IN_GRID : _ref2$height, _ref2$startCentered = _ref2.startCentered, startCentered = _ref2$startCentered === void 0 ? false : _ref2$startCentered;
    var val = '';
    if (startCentered && $39c5346b7e5f0f6d$var$IS_IE) val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d$2 - width / 2, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2 - height / 2, "em) ");
    else if (startCentered) val += "translate(calc(-50% + ".concat(transform.x / $39c5346b7e5f0f6d$var$d$2, "em), calc(-50% + ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2, "em)) ");
    else val += "translate(".concat(transform.x / $39c5346b7e5f0f6d$var$d$2, "em, ").concat(transform.y / $39c5346b7e5f0f6d$var$d$2, "em) ");
    val += "scale(".concat(transform.size / $39c5346b7e5f0f6d$var$d$2 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / $39c5346b7e5f0f6d$var$d$2 * (transform.flipY ? -1 : 1), ") ");
    val += "rotate(".concat(transform.rotate, "deg) ");
    return val;
}
var $39c5346b7e5f0f6d$var$baseStyles = ":root, :host {\n  --fa-font-solid: normal 900 1em/1 'Font Awesome 7 Free';\n  --fa-font-regular: normal 400 1em/1 'Font Awesome 7 Free';\n  --fa-font-light: normal 300 1em/1 'Font Awesome 7 Pro';\n  --fa-font-thin: normal 100 1em/1 'Font Awesome 7 Pro';\n  --fa-font-duotone: normal 900 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-regular: normal 400 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-light: normal 300 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-duotone-thin: normal 100 1em/1 'Font Awesome 7 Duotone';\n  --fa-font-brands: normal 400 1em/1 'Font Awesome 7 Brands';\n  --fa-font-sharp-solid: normal 900 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-regular: normal 400 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-light: normal 300 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-thin: normal 100 1em/1 'Font Awesome 7 Sharp';\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-light: normal 300 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 'Font Awesome 7 Sharp Duotone';\n  --fa-font-slab-regular: normal 400 1em/1 'Font Awesome 7 Slab';\n  --fa-font-slab-press-regular: normal 400 1em/1 'Font Awesome 7 Slab Press';\n  --fa-font-slab-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Duo';\n  --fa-font-slab-press-duo-regular: normal 400 1em/1 'Font Awesome 7 Slab Press Duo';\n  --fa-font-pixel-regular: normal 400 1em/1 'Font Awesome 7 Pixel';\n  --fa-font-mosaic-solid: normal 900 1em/1 'Font Awesome 7 Mosaic';\n  --fa-font-vellum-solid: normal 900 1em/1 'Font Awesome 7 Vellum';\n  --fa-font-whiteboard-semibold: normal 600 1em/1 'Font Awesome 7 Whiteboard';\n  --fa-font-thumbprint-light: normal 300 1em/1 'Font Awesome 7 Thumbprint';\n  --fa-font-notdog-solid: normal 900 1em/1 'Font Awesome 7 Notdog';\n  --fa-font-notdog-duo-solid: normal 900 1em/1 'Font Awesome 7 Notdog Duo';\n  --fa-font-etch-solid: normal 900 1em/1 'Font Awesome 7 Etch';\n  --fa-font-graphite-thin: normal 100 1em/1 'Font Awesome 7 Graphite';\n  --fa-font-jelly-regular: normal 400 1em/1 'Font Awesome 7 Jelly';\n  --fa-font-jelly-fill-regular: normal 400 1em/1 'Font Awesome 7 Jelly Fill';\n  --fa-font-jelly-duo-regular: normal 400 1em/1 'Font Awesome 7 Jelly Duo';\n  --fa-font-chisel-regular: normal 400 1em/1 'Font Awesome 7 Chisel';\n  --fa-font-utility-semibold: normal 600 1em/1 'Font Awesome 7 Utility';\n  --fa-font-utility-duo-semibold: normal 600 1em/1 'Font Awesome 7 Utility Duo';\n  --fa-font-utility-fill-semibold: normal 600 1em/1 'Font Awesome 7 Utility Fill';\n}\n\n.svg-inline--fa {\n  box-sizing: content-box;\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285714em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left,\n.svg-inline--fa .fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-pull-right,\n.svg-inline--fa .fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  inset-block-start: 0.25em; /* syncing vertical alignment with Web Font rendering */\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: var(--fa-width, 1.25em);\n}\n.fa-layers .svg-inline--fa {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: calc(10 / 16 * 1em); /* converts a 10px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 10 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 10 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xs {\n  font-size: calc(12 / 16 * 1em); /* converts a 12px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 12 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 12 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-sm {\n  font-size: calc(14 / 16 * 1em); /* converts a 14px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 14 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 14 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-lg {\n  font-size: calc(20 / 16 * 1em); /* converts a 20px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 20 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 20 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-xl {\n  font-size: calc(24 / 16 * 1em); /* converts a 24px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 24 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 24 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-2xl {\n  font-size: calc(32 / 16 * 1em); /* converts a 32px size into an em-based value that's relative to the scale's 16px base */\n  line-height: calc(1 / 32 * 1em); /* sets the line-height of the icon back to that of it's parent */\n  vertical-align: calc((6 / 32 - 0.375) * 1em); /* vertically centers the icon taking into account the surrounding text's descender */\n}\n\n.fa-width-auto {\n  --fa-width: auto;\n}\n\n.fa-fw,\n.fa-width-fixed {\n  --fa-width: 1.25em;\n}\n\n.fa-canvas-square {\n  padding-block: 0.125em;\n  margin-block-end: -0.125em;\n}\n\n.fa-canvas-roomy {\n  padding-block: 0.25em;\n  padding-inline: 0.125em;\n  margin-block-end: -0.25em;\n  box-sizing: content-box;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-inline-start: var(--fa-li-margin, 2.5em);\n  padding-inline-start: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  inset-inline-start: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n/* Heads Up: Bordered Icons will not be supported in the future!\n  - This feature will be deprecated in the next major release of Font Awesome (v8)!\n  - You may continue to use it in this version *v7), but it will not be supported in Font Awesome v8.\n*/\n/* Notes:\n* --@{v.$css-prefix}-border-width = 1/16 by default (to render as ~1px based on a 16px default font-size)\n* --@{v.$css-prefix}-border-padding =\n  ** 3/16 for vertical padding (to give ~2px of vertical whitespace around an icon considering it's vertical alignment)\n  ** 4/16 for horizontal padding (to give ~4px of horizontal whitespace around an icon)\n*/\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.0625em);\n  box-sizing: var(--fa-border-box-sizing, content-box);\n  padding: var(--fa-border-padding, 0.1875em 0.25em);\n}\n\n.fa-pull-left,\n.fa-pull-start {\n  float: inline-start;\n  margin-inline-end: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right,\n.fa-pull-end {\n  float: inline-end;\n  margin-inline-start: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1.5s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-flip-360 {\n  animation-name: fa-flip-360;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.75s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n.fa-spin-snap {\n  animation-name: fa-spin-snap;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 3s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-snap-4 {\n  animation-name: fa-spin-snap-4;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2.4s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-snap-8 {\n  animation-name: fa-spin-snap-8;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 4s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-buzz {\n  animation-name: fa-buzz;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.6s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-wag {\n  animation-name: fa-wag;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.9s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n  transform-origin: bottom center;\n}\n\n.fa-float {\n  animation-name: fa-float;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 3s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n  will-change: transform;\n}\n\n.fa-swing {\n  animation-name: fa-swing;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1.2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n  transform-origin: top center;\n}\n\n.fa-jello {\n  animation-name: fa-jello;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 0.9s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-out);\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n  .fa-bounce,\n  .fa-fade,\n  .fa-beat-fade,\n  .fa-flip,\n  .fa-flip-360,\n  .fa-pulse,\n  .fa-shake,\n  .fa-spin,\n  .fa-spin-pulse,\n  .fa-buzz,\n  .fa-float,\n  .fa-jello,\n  .fa-spin-snap,\n  .fa-spin-snap-4,\n  .fa-spin-snap-8,\n  .fa-swing,\n  .fa-wag {\n    animation: none !important;\n    transition: none !important;\n  }\n}\n@keyframes fa-beat {\n  0% {\n    transform: scale(1);\n  }\n  25% {\n    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));\n  }\n  45% {\n    transform: scale(calc(1.22 * var(--fa-beat-scale, 1.22)));\n  }\n  65% {\n    transform: scale(calc(1.25 * var(--fa-beat-scale, 1.25)));\n  }\n  90% {\n    transform: scale(1);\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n    animation-timing-function: var(--fa-animation-timing);\n  }\n  14% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.06), var(--fa-bounce-start-scale-y, 0.94)) translateY(var(--fa-bounce-anticipation, 3px));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  32% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.94), var(--fa-bounce-jump-scale-y, 1.12)) translateY(calc(-1 * var(--fa-bounce-height, 0.5em)));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  52% {\n    transform: scale(1, 1) translateY(calc(-1 * var(--fa-bounce-height, 0.5em) * 1.1));\n    animation-timing-function: cubic-bezier(0.5, 0, 1, 0.5);\n  }\n  70% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.06), var(--fa-bounce-land-scale-y, 0.92)) translateY(0);\n    animation-timing-function: cubic-bezier(0.33, 0.33, 0.66, 1);\n  }\n  85% {\n    transform: scale(0.98, 1.04) translateY(calc(-2px * var(--fa-bounce-rebound, 1)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  0% {\n    opacity: 1;\n    transform: scale(1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  40% {\n    opacity: var(--fa-fade-opacity, 0.4);\n    transform: scale(0.98);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  100% {\n    opacity: 1;\n    transform: scale(1);\n  }\n}\n@keyframes fa-beat-fade {\n  0% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  25% {\n    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);\n    transform: scale(var(--fa-beat-fade-scale, 1.28));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  45% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.25));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  65% {\n    opacity: calc(var(--fa-beat-fade-opacity, 0.4) + 0.4);\n    transform: scale(var(--fa-beat-fade-scale, 1.28));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n}\n@keyframes fa-flip {\n  0% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  8% {\n    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  35% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));\n    animation-timing-function: linear;\n  }\n  65% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.5));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  92% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));\n  }\n}\n@keyframes fa-flip-360 {\n  0% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.4, 1);\n  }\n  8% {\n    transform: perspective(2em) scale(var(--fa-flip-anticipation-scale, 0.95)) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), 0deg);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  50% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * 0.6));\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  80% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), calc(var(--fa-flip-angle, -360deg) * var(--fa-flip-overshoot, 1.04)));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: perspective(2em) scale(1) rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -360deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  8% {\n    transform: rotate(35deg) translateX(1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  20% {\n    transform: rotate(-22deg) translateX(-1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  35% {\n    transform: rotate(15deg) translateX(1px);\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  50% {\n    transform: rotate(-9deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  65% {\n    transform: rotate(5deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  78% {\n    transform: rotate(-3deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  90% {\n    transform: rotate(1deg);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  12% {\n    transform: rotate(60deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  16.67% {\n    transform: rotate(60deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  28.67% {\n    transform: rotate(120deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  33.33% {\n    transform: rotate(120deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  45.33% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  62% {\n    transform: rotate(240deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  66.67% {\n    transform: rotate(240deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  78.67% {\n    transform: rotate(300deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  83.33% {\n    transform: rotate(300deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  95.33% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap-4 {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  15% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  25% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  40% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  65% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  75% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  90% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-spin-snap-8 {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  9% {\n    transform: rotate(45deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  12.5% {\n    transform: rotate(45deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  21.5% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  25% {\n    transform: rotate(90deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  34% {\n    transform: rotate(135deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  37.5% {\n    transform: rotate(135deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  46.5% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  50% {\n    transform: rotate(180deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  59% {\n    transform: rotate(225deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  62.5% {\n    transform: rotate(225deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  71.5% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  75% {\n    transform: rotate(270deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  84% {\n    transform: rotate(315deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  87.5% {\n    transform: rotate(315deg);\n    animation-timing-function: cubic-bezier(0, 0, 0.2, 1);\n  }\n  96.5% {\n    transform: rotate(360deg);\n    animation-timing-function: cubic-bezier(0.8, 0, 1, 1);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n@keyframes fa-buzz {\n  0% {\n    transform: translateX(0) rotate(0deg);\n    animation-timing-function: cubic-bezier(0.1, 0, 0.9, 1);\n  }\n  5% {\n    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.5deg);\n  }\n  10% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.5deg);\n  }\n  15% {\n    transform: translateX(var(--fa-buzz-distance, 4px)) rotate(0.3deg);\n  }\n  20% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px))) rotate(-0.3deg);\n  }\n  25% {\n    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.7)) rotate(0.2deg);\n  }\n  30% {\n    transform: translateX(calc(-1 * var(--fa-buzz-distance, 4px) * 0.7)) rotate(-0.2deg);\n  }\n  35% {\n    transform: translateX(calc(var(--fa-buzz-distance, 4px) * 0.4)) rotate(0.1deg);\n  }\n  40% {\n    transform: translateX(0) rotate(0deg);\n  }\n  100% {\n    transform: translateX(0) rotate(0deg);\n  }\n}\n@keyframes fa-wag {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  12% {\n    transform: rotate(var(--fa-wag-angle, 12deg));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  24% {\n    transform: rotate(2deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  36% {\n    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.85));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  48% {\n    transform: rotate(1deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.6, 1);\n  }\n  58% {\n    transform: rotate(calc(var(--fa-wag-angle, 12deg) * 0.6));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  68% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-float {\n  0% {\n    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  15% {\n    transform: translateY(calc(-0.4 * var(--fa-float-height, 6px))) translateX(var(--fa-float-drift, 1px)) rotate(var(--fa-float-tilt, 1deg)) scale(1, 1);\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  35% {\n    transform: translateY(calc(-1 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-stretch-x, 0.98), var(--fa-float-stretch-y, 1.03));\n    animation-timing-function: cubic-bezier(0.5, 0, 0.5, 0);\n  }\n  50% {\n    transform: translateY(calc(-0.92 * var(--fa-float-height, 6px))) translateX(calc(-0.5 * var(--fa-float-drift, 1px))) rotate(calc(-0.5 * var(--fa-float-tilt, 1deg))) scale(0.995, 1.01);\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 0.33);\n  }\n  70% {\n    transform: translateY(calc(-0.3 * var(--fa-float-height, 6px))) translateX(calc(-1 * var(--fa-float-drift, 1px))) rotate(calc(-1 * var(--fa-float-tilt, 1deg))) scale(1, 1);\n    animation-timing-function: cubic-bezier(0.33, 0.66, 0.66, 1);\n  }\n  90% {\n    transform: translateY(calc(0.05 * var(--fa-float-height, 6px))) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n    animation-timing-function: cubic-bezier(0.33, 0, 0.66, 1);\n  }\n  100% {\n    transform: translateY(0) translateX(0) rotate(0deg) scale(var(--fa-float-squash-x, 1.02), var(--fa-float-squash-y, 0.98));\n  }\n}\n@keyframes fa-swing {\n  0% {\n    transform: rotate(0deg);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  8% {\n    transform: rotate(var(--fa-swing-angle, 22deg));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  18% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.85));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  28% {\n    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.65));\n    animation-timing-function: cubic-bezier(0.35, 0, 0.65, 1);\n  }\n  38% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.45));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  48% {\n    transform: rotate(calc(var(--fa-swing-angle, 22deg) * 0.25));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  56% {\n    transform: rotate(calc(-1 * var(--fa-swing-angle, 22deg) * 0.1));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  64% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-jello {\n  0% {\n    transform: scale(1, 1);\n    animation-timing-function: cubic-bezier(0.2, 0, 0.8, 1);\n  }\n  12% {\n    transform: scale(var(--fa-jello-scale-x, 1.15), calc(2 - var(--fa-jello-scale-x, 1.15)));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  24% {\n    transform: scale(calc(2 - var(--fa-jello-scale-y, 1.12)), var(--fa-jello-scale-y, 1.12));\n    animation-timing-function: cubic-bezier(0.3, 0, 0.7, 1);\n  }\n  36% {\n    transform: scale(calc(1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5), calc(2 - (1 + (var(--fa-jello-scale-x, 1.15) - 1) * 0.5)));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  48% {\n    transform: scale(calc(2 - (1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3)), calc(1 + (var(--fa-jello-scale-y, 1.12) - 1) * 0.3));\n    animation-timing-function: cubic-bezier(0.4, 0, 0.6, 1);\n  }\n  58% {\n    transform: scale(1.02, 0.98);\n    animation-timing-function: cubic-bezier(0.4, 0, 0.2, 1);\n  }\n  68% {\n    transform: scale(1, 1);\n  }\n  100% {\n    transform: scale(1, 1);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}\n\n.svg-inline--fa.fa-inverse {\n  fill: var(--fa-inverse, #fff);\n}\n\n.fa-stack {\n  display: inline-block;\n  height: 2em;\n  line-height: 2em;\n  position: relative;\n  vertical-align: middle;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  --fa-width: 1.25em;\n  height: 1em;\n  width: var(--fa-width);\n}\n.svg-inline--fa.fa-stack-2x {\n  --fa-width: 2.5em;\n  height: 2em;\n  width: var(--fa-width);\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  inset: 0;\n  margin: auto;\n  position: absolute;\n  z-index: var(--fa-stack-z-index, auto);\n}";
function $39c5346b7e5f0f6d$var$css() {
    var dcp = $39c5346b7e5f0f6d$var$DEFAULT_CSS_PREFIX;
    var drc = $39c5346b7e5f0f6d$var$DEFAULT_REPLACEMENT_CLASS;
    var fp = $39c5346b7e5f0f6d$var$config.cssPrefix;
    var rc = $39c5346b7e5f0f6d$var$config.replacementClass;
    var s = $39c5346b7e5f0f6d$var$baseStyles;
    if (fp !== dcp || rc !== drc) {
        var dPatt = new RegExp("\\.".concat(dcp, "\\-"), 'g');
        var customPropPatt = new RegExp("\\--".concat(dcp, "\\-"), 'g');
        var rPatt = new RegExp("\\.".concat(drc), 'g');
        s = s.replace(dPatt, ".".concat(fp, "-")).replace(customPropPatt, "--".concat(fp, "-")).replace(rPatt, ".".concat(rc));
    }
    return s;
}
var $39c5346b7e5f0f6d$var$_cssInserted = false;
function $39c5346b7e5f0f6d$var$ensureCss() {
    if ($39c5346b7e5f0f6d$var$config.autoAddCss && !$39c5346b7e5f0f6d$var$_cssInserted) {
        $39c5346b7e5f0f6d$var$insertCss($39c5346b7e5f0f6d$var$css());
        $39c5346b7e5f0f6d$var$_cssInserted = true;
    }
}
var $39c5346b7e5f0f6d$var$InjectCSS = {
    mixout: function mixout() {
        return {
            dom: {
                css: $39c5346b7e5f0f6d$var$css,
                insertCss: $39c5346b7e5f0f6d$var$ensureCss
            }
        };
    },
    hooks: function hooks() {
        return {
            beforeDOMElementCreation: function beforeDOMElementCreation() {
                $39c5346b7e5f0f6d$var$ensureCss();
            },
            beforeI2svg: function beforeI2svg() {
                $39c5346b7e5f0f6d$var$ensureCss();
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$w$2 = $39c5346b7e5f0f6d$var$WINDOW || {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER]) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER] = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].styles = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].hooks = {};
if (!$39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims) $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER].shims = [];
var $39c5346b7e5f0f6d$var$namespace = $39c5346b7e5f0f6d$var$w$2[$39c5346b7e5f0f6d$var$NAMESPACE_IDENTIFIER];
var $39c5346b7e5f0f6d$var$functions = [];
var $39c5346b7e5f0f6d$var$_listener = function listener() {
    $39c5346b7e5f0f6d$var$DOCUMENT.removeEventListener('DOMContentLoaded', $39c5346b7e5f0f6d$var$_listener);
    $39c5346b7e5f0f6d$var$loaded = 1;
    $39c5346b7e5f0f6d$var$functions.map(function(fn) {
        return fn();
    });
};
var $39c5346b7e5f0f6d$var$loaded = false;
if ($39c5346b7e5f0f6d$var$IS_DOM) {
    $39c5346b7e5f0f6d$var$loaded = ($39c5346b7e5f0f6d$var$DOCUMENT.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test($39c5346b7e5f0f6d$var$DOCUMENT.readyState);
    if (!$39c5346b7e5f0f6d$var$loaded) $39c5346b7e5f0f6d$var$DOCUMENT.addEventListener('DOMContentLoaded', $39c5346b7e5f0f6d$var$_listener);
}
function $39c5346b7e5f0f6d$var$domready(fn) {
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$loaded ? setTimeout(fn, 0) : $39c5346b7e5f0f6d$var$functions.push(fn);
}
function $39c5346b7e5f0f6d$var$toHtml(abstractNodes) {
    var tag = abstractNodes.tag, _abstractNodes$attrib = abstractNodes.attributes, attributes = _abstractNodes$attrib === void 0 ? {} : _abstractNodes$attrib, _abstractNodes$childr = abstractNodes.children, children = _abstractNodes$childr === void 0 ? [] : _abstractNodes$childr;
    if (typeof abstractNodes === 'string') return $39c5346b7e5f0f6d$var$htmlEscape(abstractNodes);
    else return "<".concat(tag, " ").concat($39c5346b7e5f0f6d$var$joinAttributes(attributes), ">").concat(children.map($39c5346b7e5f0f6d$var$toHtml).join(''), "</").concat(tag, ">");
}
function $39c5346b7e5f0f6d$var$iconFromMapping(mapping, prefix, iconName) {
    if (mapping && mapping[prefix] && mapping[prefix][iconName]) return {
        prefix: prefix,
        iconName: iconName,
        icon: mapping[prefix][iconName]
    };
}
/**
 * Internal helper to bind a function known to have 4 arguments
 * to a given context.
 */ var $39c5346b7e5f0f6d$var$bindInternal4 = function bindInternal4(func, thisContext) {
    return function(a, b, c, d) {
        return func.call(thisContext, a, b, c, d);
    };
};
/**
 * # Reduce
 *
 * A fast object `.reduce()` implementation.
 *
 * @param  {Object}   subject      The object to reduce over.
 * @param  {Function} fn           The reducer function.
 * @param  {mixed}    initialValue The initial value for the reducer, defaults to subject[0].
 * @param  {Object}   thisContext  The context for the reducer.
 * @return {mixed}                 The final result.
 */ var $39c5346b7e5f0f6d$var$reduce = function fastReduceObject(subject, fn, initialValue, thisContext) {
    var keys = Object.keys(subject), length = keys.length, iterator = thisContext !== undefined ? $39c5346b7e5f0f6d$var$bindInternal4(fn, thisContext) : fn, i, key, result;
    if (initialValue === undefined) {
        i = 1;
        result = subject[keys[0]];
    } else {
        i = 0;
        result = initialValue;
    }
    for(; i < length; i++){
        key = keys[i];
        result = iterator(result, subject[key], key, subject);
    }
    return result;
};
/**
 * Return hexadecimal string for a unicode character
 * Returns `null` when more than one character (not bytes!) are passed
 * For example: 'K' → '7B'
 */ function $39c5346b7e5f0f6d$var$toHex(unicode) {
    if ($39c5346b7e5f0f6d$var$_toConsumableArray(unicode).length !== 1) return null;
    return unicode.codePointAt(0).toString(16);
}
function $39c5346b7e5f0f6d$var$normalizeIcons(icons) {
    return Object.keys(icons).reduce(function(acc, iconName) {
        var icon = icons[iconName];
        var expanded = !!icon.icon;
        if (expanded) acc[icon.iconName] = icon.icon;
        else acc[iconName] = icon;
        return acc;
    }, {});
}
function $39c5346b7e5f0f6d$var$defineIcons(prefix, icons) {
    var params = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    var _params$skipHooks = params.skipHooks, skipHooks = _params$skipHooks === void 0 ? false : _params$skipHooks;
    var normalized = $39c5346b7e5f0f6d$var$normalizeIcons(icons);
    if (typeof $39c5346b7e5f0f6d$var$namespace.hooks.addPack === 'function' && !skipHooks) $39c5346b7e5f0f6d$var$namespace.hooks.addPack(prefix, $39c5346b7e5f0f6d$var$normalizeIcons(icons));
    else $39c5346b7e5f0f6d$var$namespace.styles[prefix] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$namespace.styles[prefix] || {}), normalized);
    /**
   * Font Awesome 4 used the prefix of `fa` for all icons. With the introduction
   * of new styles we needed to differentiate between them. Prefix `fa` is now an alias
   * for `fas` so we'll ease the upgrade process for our users by automatically defining
   * this as well.
   */ if (prefix === 'fas') $39c5346b7e5f0f6d$var$defineIcons('fa', icons);
}
var $39c5346b7e5f0f6d$var$MONO = 0x1;
var $39c5346b7e5f0f6d$var$DUO = 0x2;
// New v7 compatible matchers using the style attribute to determine layer membership
var $39c5346b7e5f0f6d$var$modernMatches = [
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)".*path.*d="([^"]*)"/, {
            d2: 2,
            d1: 3
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path opacity="([^"]*)".*d="([^"]*)"/, {
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path fill="currentColor".*d="([^"]+)"/, {
            d1: 1
        })
    ]
];
// Old <= v6 matchers, these should rarely get used.
//
// Why are there so many? Over the lifecycle of version 5 and 6 we modified the
// syntax for our source SVG files several times. These patterns match the
// historical record and attempt to handle backwards-compatibility in rare edge
// cases (loading version 6 SVG source files using the version 7 SVG parser)
var $39c5346b7e5f0f6d$var$legacyMatches = [
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)".*path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2,
            attr1: 3,
            d1: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)".*path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2,
            attr2: 3,
            d2: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*primary[^"]*)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path class="([^"]*secondary[^"]*)".*d="([^"]+)"/, {
            attr2: 1,
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)".*path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d2: 1,
            attr2: 2,
            d1: 3,
            attr1: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)".*path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d1: 1,
            attr1: 2,
            d2: 3,
            attr2: 4
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*primary[^"]*)"/, {
            d1: 1,
            attr1: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*class="([^"]*secondary[^"]*)"/, {
            d2: 1,
            attr2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$DUO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)".*path d="([^"]+)"/, {
            d1: 1,
            d2: 2
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path d="([^"]+)"/, {
            d1: 1
        })
    ],
    [
        $39c5346b7e5f0f6d$var$MONO,
        /*#__PURE__*/ $39c5346b7e5f0f6d$var$_wrapRegExp(/path style="([^"]+)".*d="([^"]+)"/, {
            attr1: 1,
            d1: 2
        })
    ]
];
var $39c5346b7e5f0f6d$var$styles = $39c5346b7e5f0f6d$var$namespace.styles, $39c5346b7e5f0f6d$var$shims = $39c5346b7e5f0f6d$var$namespace.shims;
var $39c5346b7e5f0f6d$var$FAMILY_NAMES = Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE);
var $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY = $39c5346b7e5f0f6d$var$FAMILY_NAMES.reduce(function(acc, familyId) {
    acc[familyId] = Object.keys($39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[familyId]);
    return acc;
}, {});
var $39c5346b7e5f0f6d$var$_defaultUsablePrefix = null;
var $39c5346b7e5f0f6d$var$_byUnicode = {};
var $39c5346b7e5f0f6d$var$_byLigature = {};
var $39c5346b7e5f0f6d$var$_byOldName = {};
var $39c5346b7e5f0f6d$var$_byOldUnicode = {};
var $39c5346b7e5f0f6d$var$_byAlias = {};
function $39c5346b7e5f0f6d$var$isReserved(name) {
    return ~$39c5346b7e5f0f6d$var$RESERVED_CLASSES.indexOf(name);
}
function $39c5346b7e5f0f6d$var$getIconName(cssPrefix, cls) {
    var parts = cls.split('-');
    var prefix = parts[0];
    var iconName = parts.slice(1).join('-');
    if (prefix === cssPrefix && iconName !== '' && !$39c5346b7e5f0f6d$var$isReserved(iconName)) return iconName;
    else return null;
}
var $39c5346b7e5f0f6d$var$build = function build() {
    var lookup = function lookup(reducer) {
        return $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$styles, function(o$$1, style, prefix) {
            o$$1[prefix] = $39c5346b7e5f0f6d$var$reduce(style, reducer, {});
            return o$$1;
        }, {});
    };
    $39c5346b7e5f0f6d$var$_byUnicode = lookup(function(acc, icon, iconName) {
        if (icon[3]) acc[icon[3]] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'number';
            });
            aliases.forEach(function(alias) {
                acc[alias.toString(16)] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byLigature = lookup(function(acc, icon, iconName) {
        acc[iconName] = iconName;
        if (icon[2]) {
            var aliases = icon[2].filter(function(a$$1) {
                return typeof a$$1 === 'string';
            });
            aliases.forEach(function(alias) {
                acc[alias] = iconName;
            });
        }
        return acc;
    });
    $39c5346b7e5f0f6d$var$_byAlias = lookup(function(acc, icon, iconName) {
        var aliases = icon[2];
        acc[iconName] = iconName;
        aliases.forEach(function(alias) {
            acc[alias] = iconName;
        });
        return acc;
    });
    // If we have a Kit, we can't determine if regular is available since we
    // could be auto-fetching it. We'll have to assume that it is available.
    var hasRegular = 'far' in $39c5346b7e5f0f6d$var$styles || $39c5346b7e5f0f6d$var$config.autoFetchSvg;
    var shimLookups = $39c5346b7e5f0f6d$var$reduce($39c5346b7e5f0f6d$var$shims, function(acc, shim) {
        var maybeNameMaybeUnicode = shim[0];
        var prefix = shim[1];
        var iconName = shim[2];
        if (prefix === 'far' && !hasRegular) prefix = 'fas';
        if (typeof maybeNameMaybeUnicode === 'string') acc.names[maybeNameMaybeUnicode] = {
            prefix: prefix,
            iconName: iconName
        };
        if (typeof maybeNameMaybeUnicode === 'number') acc.unicodes[maybeNameMaybeUnicode.toString(16)] = {
            prefix: prefix,
            iconName: iconName
        };
        return acc;
    }, {
        names: {},
        unicodes: {}
    });
    $39c5346b7e5f0f6d$var$_byOldName = shimLookups.names;
    $39c5346b7e5f0f6d$var$_byOldUnicode = shimLookups.unicodes;
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix($39c5346b7e5f0f6d$var$config.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
};
$39c5346b7e5f0f6d$var$onChange(function(c$$1) {
    $39c5346b7e5f0f6d$var$_defaultUsablePrefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(c$$1.styleDefault, {
        family: $39c5346b7e5f0f6d$var$config.familyDefault
    });
});
$39c5346b7e5f0f6d$var$build();
function $39c5346b7e5f0f6d$var$byUnicode(prefix, unicode) {
    return ($39c5346b7e5f0f6d$var$_byUnicode[prefix] || {})[unicode];
}
function $39c5346b7e5f0f6d$var$byLigature(prefix, ligature) {
    return ($39c5346b7e5f0f6d$var$_byLigature[prefix] || {})[ligature];
}
function $39c5346b7e5f0f6d$var$byAlias(prefix, alias) {
    return ($39c5346b7e5f0f6d$var$_byAlias[prefix] || {})[alias];
}
function $39c5346b7e5f0f6d$var$byOldName(name) {
    return $39c5346b7e5f0f6d$var$_byOldName[name] || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$byOldUnicode(unicode) {
    var oldUnicode = $39c5346b7e5f0f6d$var$_byOldUnicode[unicode];
    var newUnicode = $39c5346b7e5f0f6d$var$byUnicode('fas', unicode);
    return oldUnicode || (newUnicode ? {
        prefix: 'fas',
        iconName: newUnicode
    } : null) || {
        prefix: null,
        iconName: null
    };
}
function $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() {
    return $39c5346b7e5f0f6d$var$_defaultUsablePrefix;
}
var $39c5346b7e5f0f6d$var$emptyCanonicalIcon = function emptyCanonicalIcon() {
    return {
        prefix: null,
        iconName: null,
        rest: []
    };
};
function $39c5346b7e5f0f6d$var$getFamilyId(values) {
    var family = $39c5346b7e5f0f6d$var$u;
    var famProps = $39c5346b7e5f0f6d$var$FAMILY_NAMES.reduce(function(acc, familyId) {
        acc[familyId] = "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(familyId);
        return acc;
    }, {});
    $39c5346b7e5f0f6d$var$xl.forEach(function(familyId) {
        if (values.includes(famProps[familyId]) || values.some(function(v$$1) {
            return $39c5346b7e5f0f6d$var$PREFIXES_FOR_FAMILY[familyId].includes(v$$1);
        })) family = familyId;
    });
    return family;
}
function $39c5346b7e5f0f6d$var$getCanonicalPrefix(styleOrPrefix) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$family = params.family, family = _params$family === void 0 ? $39c5346b7e5f0f6d$var$u : _params$family;
    var style = $39c5346b7e5f0f6d$var$PREFIX_TO_STYLE[family][styleOrPrefix];
    // handles the exception of passing in only a family of 'duotone' with no style
    if (family === $39c5346b7e5f0f6d$var$l && !styleOrPrefix) return 'fad';
    var prefix = $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][styleOrPrefix] || $39c5346b7e5f0f6d$var$STYLE_TO_PREFIX[family][style];
    var defined = styleOrPrefix in $39c5346b7e5f0f6d$var$namespace.styles ? styleOrPrefix : null;
    var result = prefix || defined || null;
    return result;
}
function $39c5346b7e5f0f6d$var$moveNonFaClassesToRest(classNames) {
    var rest = [];
    var iconName = null;
    classNames.forEach(function(cls) {
        var result = $39c5346b7e5f0f6d$var$getIconName($39c5346b7e5f0f6d$var$config.cssPrefix, cls);
        if (result) iconName = result;
        else if (cls) rest.push(cls);
    });
    return {
        iconName: iconName,
        rest: rest
    };
}
function $39c5346b7e5f0f6d$var$sortedUniqueValues(arr) {
    return arr.sort().filter(function(value, index, arr) {
        return arr.indexOf(value) === index;
    });
}
var $39c5346b7e5f0f6d$var$_faCombinedClasses = $39c5346b7e5f0f6d$var$ha.concat($39c5346b7e5f0f6d$var$at);
function $39c5346b7e5f0f6d$var$getCanonicalIcon(values) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$skipLookups = params.skipLookups, skipLookups = _params$skipLookups === void 0 ? false : _params$skipLookups;
    var givenPrefix = null;
    var faStyleOrFamilyClasses = $39c5346b7e5f0f6d$var$sortedUniqueValues(values.filter(function(cls) {
        return $39c5346b7e5f0f6d$var$_faCombinedClasses.includes(cls);
    }));
    var nonStyleOrFamilyClasses = $39c5346b7e5f0f6d$var$sortedUniqueValues(values.filter(function(cls) {
        return !$39c5346b7e5f0f6d$var$_faCombinedClasses.includes(cls);
    }));
    var faStyles = faStyleOrFamilyClasses.filter(function(cls) {
        givenPrefix = cls;
        return !$39c5346b7e5f0f6d$var$dl.includes(cls);
    });
    var _faStyles = $39c5346b7e5f0f6d$var$_slicedToArray(faStyles, 1), _faStyles$ = _faStyles[0], styleFromValues = _faStyles$ === void 0 ? null : _faStyles$;
    var family = $39c5346b7e5f0f6d$var$getFamilyId(faStyleOrFamilyClasses);
    var canonical = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$moveNonFaClassesToRest(nonStyleOrFamilyClasses)), {}, {
        prefix: $39c5346b7e5f0f6d$var$getCanonicalPrefix(styleFromValues, {
            family: family
        })
    });
    return $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, canonical), $39c5346b7e5f0f6d$var$getDefaultCanonicalPrefix({
        values: values,
        family: family,
        styles: $39c5346b7e5f0f6d$var$styles,
        config: $39c5346b7e5f0f6d$var$config,
        canonical: canonical,
        givenPrefix: givenPrefix
    })), $39c5346b7e5f0f6d$var$applyShimAndAlias(skipLookups, givenPrefix, canonical));
}
function $39c5346b7e5f0f6d$var$applyShimAndAlias(skipLookups, givenPrefix, canonical) {
    var prefix = canonical.prefix, iconName = canonical.iconName;
    if (skipLookups || !prefix || !iconName) return {
        prefix: prefix,
        iconName: iconName
    };
    var shim = givenPrefix === 'fa' ? $39c5346b7e5f0f6d$var$byOldName(iconName) : {};
    var aliasIconName = $39c5346b7e5f0f6d$var$byAlias(prefix, iconName);
    iconName = shim.iconName || aliasIconName || iconName;
    prefix = shim.prefix || prefix;
    if (prefix === 'far' && !$39c5346b7e5f0f6d$var$styles['far'] && $39c5346b7e5f0f6d$var$styles['fas'] && !$39c5346b7e5f0f6d$var$config.autoFetchSvg) // Allow a fallback from the regular style to solid if regular is not available
    // but only if we aren't auto-fetching SVGs
    prefix = 'fas';
    return {
        prefix: prefix,
        iconName: iconName
    };
}
var $39c5346b7e5f0f6d$var$newCanonicalFamilies = $39c5346b7e5f0f6d$var$xl.filter(function(familyId) {
    return familyId !== $39c5346b7e5f0f6d$var$u || familyId !== $39c5346b7e5f0f6d$var$l;
});
var $39c5346b7e5f0f6d$var$newCanonicalStyles = Object.keys($39c5346b7e5f0f6d$var$da).filter(function(key) {
    return key !== $39c5346b7e5f0f6d$var$u;
}).map(function(key) {
    return Object.keys($39c5346b7e5f0f6d$var$da[key]);
}).flat();
function $39c5346b7e5f0f6d$var$getDefaultCanonicalPrefix(prefixOptions) {
    var values = prefixOptions.values, family = prefixOptions.family, canonical = prefixOptions.canonical, _prefixOptions$givenP = prefixOptions.givenPrefix, givenPrefix = _prefixOptions$givenP === void 0 ? '' : _prefixOptions$givenP, _prefixOptions$styles = prefixOptions.styles, styles = _prefixOptions$styles === void 0 ? {} : _prefixOptions$styles, _prefixOptions$config = prefixOptions.config, config$$1 = _prefixOptions$config === void 0 ? {} : _prefixOptions$config;
    var isDuotoneFamily = family === $39c5346b7e5f0f6d$var$l;
    var valuesHasDuotone = values.includes('fa-duotone') || values.includes('fad');
    var defaultFamilyIsDuotone = config$$1.familyDefault === 'duotone';
    var canonicalPrefixIsDuotone = canonical.prefix === 'fad' || canonical.prefix === 'fa-duotone';
    if (!isDuotoneFamily && (valuesHasDuotone || defaultFamilyIsDuotone || canonicalPrefixIsDuotone)) canonical.prefix = 'fad';
    if (values.includes('fa-brands') || values.includes('fab')) canonical.prefix = 'fab';
    if (!canonical.prefix && $39c5346b7e5f0f6d$var$newCanonicalFamilies.includes(family)) {
        var validPrefix = Object.keys(styles).find(function(key) {
            return $39c5346b7e5f0f6d$var$newCanonicalStyles.includes(key);
        });
        if (validPrefix || config$$1.autoFetchSvg) {
            var defaultPrefix = $39c5346b7e5f0f6d$var$Ql.get(family).defaultShortPrefixId;
            canonical.prefix = defaultPrefix;
            canonical.iconName = $39c5346b7e5f0f6d$var$byAlias(canonical.prefix, canonical.iconName) || canonical.iconName;
        }
    }
    if (canonical.prefix === 'fa' || givenPrefix === 'fa') // The fa prefix is not canonical. So if it has made it through until this point
    // we will shift it to the correct prefix.
    canonical.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix() || 'fas';
    return canonical;
}
var $39c5346b7e5f0f6d$var$Library = /*#__PURE__*/ function() {
    function Library() {
        $39c5346b7e5f0f6d$var$_classCallCheck(this, Library);
        this.definitions = {};
    }
    return $39c5346b7e5f0f6d$var$_createClass(Library, [
        {
            key: "add",
            value: function add() {
                var _this = this;
                for(var _len = arguments.length, definitions = new Array(_len), _key = 0; _key < _len; _key++)definitions[_key] = arguments[_key];
                var additions = definitions.reduce(this._pullDefinitions, {});
                Object.keys(additions).forEach(function(key) {
                    _this.definitions[key] = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, _this.definitions[key] || {}), additions[key]);
                    $39c5346b7e5f0f6d$var$defineIcons(key, additions[key]);
                    // To keep support for older Classic styles, also add longer prefixes
                    var longPrefix = $39c5346b7e5f0f6d$var$PREFIX_TO_LONG_STYLE[$39c5346b7e5f0f6d$var$u][key];
                    if (longPrefix) $39c5346b7e5f0f6d$var$defineIcons(longPrefix, additions[key]);
                    $39c5346b7e5f0f6d$var$build();
                });
            }
        },
        {
            key: "reset",
            value: function reset() {
                this.definitions = {};
            }
        },
        {
            key: "_pullDefinitions",
            value: function _pullDefinitions(additions, definition) {
                var normalized = definition.prefix && definition.iconName && definition.icon ? {
                    0: definition
                } : definition;
                Object.keys(normalized).map(function(key) {
                    var _normalized$key = normalized[key], prefix = _normalized$key.prefix, iconName = _normalized$key.iconName, icon = _normalized$key.icon;
                    var aliases = icon[2];
                    if (!additions[prefix]) additions[prefix] = {};
                    if (aliases.length > 0) aliases.forEach(function(alias) {
                        if (typeof alias === 'string') additions[prefix][alias] = icon;
                    });
                    additions[prefix][iconName] = icon;
                });
                return additions;
            }
        }
    ]);
}();
var $39c5346b7e5f0f6d$var$_plugins = [];
var $39c5346b7e5f0f6d$var$_hooks = {};
var $39c5346b7e5f0f6d$var$providers = {};
var $39c5346b7e5f0f6d$var$defaultProviderKeys = Object.keys($39c5346b7e5f0f6d$var$providers);
function $39c5346b7e5f0f6d$var$registerPlugins(nextPlugins, _ref) {
    var obj = _ref.mixoutsTo;
    $39c5346b7e5f0f6d$var$_plugins = nextPlugins;
    $39c5346b7e5f0f6d$var$_hooks = {};
    Object.keys($39c5346b7e5f0f6d$var$providers).forEach(function(k) {
        if ($39c5346b7e5f0f6d$var$defaultProviderKeys.indexOf(k) === -1) delete $39c5346b7e5f0f6d$var$providers[k];
    });
    $39c5346b7e5f0f6d$var$_plugins.forEach(function(plugin) {
        var mixout = plugin.mixout ? plugin.mixout() : {};
        Object.keys(mixout).forEach(function(tk) {
            if (typeof mixout[tk] === 'function') obj[tk] = mixout[tk];
            if ($39c5346b7e5f0f6d$var$_typeof(mixout[tk]) === 'object') Object.keys(mixout[tk]).forEach(function(sk) {
                if (!obj[tk]) obj[tk] = {};
                obj[tk][sk] = mixout[tk][sk];
            });
        });
        if (plugin.hooks) {
            var hooks = plugin.hooks();
            Object.keys(hooks).forEach(function(hook) {
                if (!$39c5346b7e5f0f6d$var$_hooks[hook]) $39c5346b7e5f0f6d$var$_hooks[hook] = [];
                $39c5346b7e5f0f6d$var$_hooks[hook].push(hooks[hook]);
            });
        }
        if (plugin.provides) plugin.provides($39c5346b7e5f0f6d$var$providers);
    });
    return obj;
}
function $39c5346b7e5f0f6d$var$chainHooks(hook, accumulator) {
    for(var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++)args[_key - 2] = arguments[_key];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        accumulator = hookFn.apply(null, [
            accumulator
        ].concat(args));
    });
    return accumulator;
}
function $39c5346b7e5f0f6d$var$callHooks(hook) {
    for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
    var hookFns = $39c5346b7e5f0f6d$var$_hooks[hook] || [];
    hookFns.forEach(function(hookFn) {
        hookFn.apply(null, args);
    });
    return undefined;
}
function $39c5346b7e5f0f6d$var$callProvided() {
    var hook = arguments[0];
    var args = Array.prototype.slice.call(arguments, 1);
    return $39c5346b7e5f0f6d$var$providers[hook] ? $39c5346b7e5f0f6d$var$providers[hook].apply(null, args) : undefined;
}
function $39c5346b7e5f0f6d$var$findIconDefinition(iconLookup) {
    if (iconLookup.prefix === 'fa') iconLookup.prefix = 'fas';
    var iconName = iconLookup.iconName;
    var prefix = iconLookup.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (!iconName) return;
    iconName = $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName;
    return $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$library.definitions, prefix, iconName) || $39c5346b7e5f0f6d$var$iconFromMapping($39c5346b7e5f0f6d$var$namespace.styles, prefix, iconName);
}
var $39c5346b7e5f0f6d$var$library = new $39c5346b7e5f0f6d$var$Library();
var $39c5346b7e5f0f6d$var$noAuto = function noAuto() {
    $39c5346b7e5f0f6d$var$config.autoReplaceSvg = false;
    $39c5346b7e5f0f6d$var$config.observeMutations = false;
    $39c5346b7e5f0f6d$var$callHooks('noAuto');
};
var $39c5346b7e5f0f6d$var$dom = {
    i2svg: function i2svg() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        if ($39c5346b7e5f0f6d$var$IS_DOM) {
            $39c5346b7e5f0f6d$var$callHooks('beforeI2svg', params);
            $39c5346b7e5f0f6d$var$callProvided('pseudoElements2svg', params);
            return $39c5346b7e5f0f6d$var$callProvided('i2svg', params);
        } else return Promise.reject(new Error('Operation requires a DOM of some kind.'));
    },
    watch: function watch() {
        var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
        var autoReplaceSvgRoot = params.autoReplaceSvgRoot;
        if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === false) $39c5346b7e5f0f6d$var$config.autoReplaceSvg = true;
        $39c5346b7e5f0f6d$var$config.observeMutations = true;
        $39c5346b7e5f0f6d$var$domready(function() {
            $39c5346b7e5f0f6d$var$autoReplace({
                autoReplaceSvgRoot: autoReplaceSvgRoot
            });
            $39c5346b7e5f0f6d$var$callHooks('watch', params);
        });
    }
};
var $39c5346b7e5f0f6d$var$parse = {
    icon: function icon(_icon) {
        if (_icon === null) return null;
        if ($39c5346b7e5f0f6d$var$_typeof(_icon) === 'object' && _icon.prefix && _icon.iconName) return {
            prefix: _icon.prefix,
            iconName: $39c5346b7e5f0f6d$var$byAlias(_icon.prefix, _icon.iconName) || _icon.iconName
        };
        if (Array.isArray(_icon) && _icon.length === 2) {
            var iconName = _icon[1].indexOf('fa-') === 0 ? _icon[1].slice(3) : _icon[1];
            var prefix = $39c5346b7e5f0f6d$var$getCanonicalPrefix(_icon[0]);
            return {
                prefix: prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(prefix, iconName) || iconName
            };
        }
        if (typeof _icon === 'string' && (_icon.indexOf("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-")) > -1 || _icon.match($39c5346b7e5f0f6d$var$ICON_SELECTION_SYNTAX_PATTERN))) {
            var canonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon(_icon.split(' '), {
                skipLookups: true
            });
            return {
                prefix: canonicalIcon.prefix || $39c5346b7e5f0f6d$var$getDefaultUsablePrefix(),
                iconName: $39c5346b7e5f0f6d$var$byAlias(canonicalIcon.prefix, canonicalIcon.iconName) || canonicalIcon.iconName
            };
        }
        if (typeof _icon === 'string') {
            var _prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
            return {
                prefix: _prefix,
                iconName: $39c5346b7e5f0f6d$var$byAlias(_prefix, _icon) || _icon
            };
        }
    }
};
var $39c5346b7e5f0f6d$export$644d8ea042df96a6 = {
    noAuto: $39c5346b7e5f0f6d$var$noAuto,
    config: $39c5346b7e5f0f6d$var$config,
    dom: $39c5346b7e5f0f6d$var$dom,
    parse: $39c5346b7e5f0f6d$var$parse,
    library: $39c5346b7e5f0f6d$var$library,
    findIconDefinition: $39c5346b7e5f0f6d$var$findIconDefinition,
    toHtml: $39c5346b7e5f0f6d$var$toHtml
};
var $39c5346b7e5f0f6d$var$autoReplace = function autoReplace() {
    var params = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    var _params$autoReplaceSv = params.autoReplaceSvgRoot, autoReplaceSvgRoot = _params$autoReplaceSv === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$autoReplaceSv;
    if ((Object.keys($39c5346b7e5f0f6d$var$namespace.styles).length > 0 || $39c5346b7e5f0f6d$var$config.autoFetchSvg) && $39c5346b7e5f0f6d$var$IS_DOM && $39c5346b7e5f0f6d$var$config.autoReplaceSvg) $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom.i2svg({
        node: autoReplaceSvgRoot
    });
};
function $39c5346b7e5f0f6d$var$domVariants(val, abstractCreator) {
    Object.defineProperty(val, 'abstract', {
        get: abstractCreator
    });
    Object.defineProperty(val, 'html', {
        get: function get() {
            return val.abstract.map(function(a) {
                return $39c5346b7e5f0f6d$var$toHtml(a);
            });
        }
    });
    Object.defineProperty(val, 'node', {
        get: function get() {
            if (!$39c5346b7e5f0f6d$var$IS_DOM) return undefined;
            var container = $39c5346b7e5f0f6d$var$DOCUMENT.createElement('div');
            container.innerHTML = val.html;
            return container.children;
        }
    });
    return val;
}
function $39c5346b7e5f0f6d$var$asIcon(_ref) {
    var children = _ref.children, main = _ref.main, mask = _ref.mask, attributes = _ref.attributes, styles = _ref.styles, transform = _ref.transform;
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform) && main.found && !mask.found) {
        var width = main.width, height = main.height;
        var offset = {
            x: width / height / 2,
            y: 0.5
        };
        attributes['style'] = $39c5346b7e5f0f6d$var$joinStyles($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, styles), {}, {
            'transform-origin': "".concat(offset.x + transform.x / 16, "em ").concat(offset.y + transform.y / 16, "em")
        }));
    }
    return [
        {
            tag: 'svg',
            attributes: attributes,
            children: children
        }
    ];
}
function $39c5346b7e5f0f6d$var$asSymbol(_ref) {
    var prefix = _ref.prefix, iconName = _ref.iconName, children = _ref.children, attributes = _ref.attributes, symbol = _ref.symbol;
    var id = symbol === true ? "".concat(prefix, "-").concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : symbol;
    return [
        {
            tag: 'svg',
            attributes: {
                style: 'display: none;'
            },
            children: [
                {
                    tag: 'symbol',
                    attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, attributes), {}, {
                        id: id
                    }),
                    children: children
                }
            ]
        }
    ];
}
// If any of these attributes are present, don't assume the icon is decorative
function $39c5346b7e5f0f6d$var$isLabeled(attributes) {
    var labels = [
        'aria-label',
        'aria-labelledby',
        'title',
        'role'
    ];
    return labels.some(function(label) {
        return label in attributes;
    });
}
function $39c5346b7e5f0f6d$var$makeInlineSvgAbstract(params) {
    var _params$icons = params.icons, main = _params$icons.main, mask = _params$icons.mask, prefix = params.prefix, iconName = params.iconName, transform = params.transform, symbol = params.symbol, maskId = params.maskId, extra = params.extra, _params$watchable = params.watchable, watchable = _params$watchable === void 0 ? false : _params$watchable;
    var _ref = mask.found ? mask : main, width = _ref.width, height = _ref.height;
    var attrClass = [
        $39c5346b7e5f0f6d$var$config.replacementClass,
        iconName ? "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat(iconName) : ''
    ].filter(function(c) {
        return extra.classes.indexOf(c) === -1;
    }).filter(function(c) {
        return c !== '' || !!c;
    }).concat(extra.classes).join(' ');
    var content = {
        children: [],
        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
            'data-prefix': prefix,
            'data-icon': iconName,
            'class': attrClass,
            'role': extra.attributes.role || 'img',
            'viewBox': "0 0 ".concat(width, " ").concat(height)
        })
    };
    if (!$39c5346b7e5f0f6d$var$isLabeled(extra.attributes) && !extra.attributes['aria-hidden']) content.attributes['aria-hidden'] = 'true';
    if (watchable) content.attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = '';
    var args = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, content), {}, {
        prefix: prefix,
        iconName: iconName,
        main: main,
        mask: mask,
        maskId: maskId,
        transform: transform,
        symbol: symbol,
        styles: $39c5346b7e5f0f6d$var$_objectSpread2({}, extra.styles)
    });
    var _ref2 = mask.found && main.found ? $39c5346b7e5f0f6d$var$callProvided('generateAbstractMask', args) || {
        children: [],
        attributes: {}
    } : $39c5346b7e5f0f6d$var$callProvided('generateAbstractIcon', args) || {
        children: [],
        attributes: {}
    }, children = _ref2.children, attributes = _ref2.attributes;
    args.children = children;
    args.attributes = attributes;
    if (symbol) return $39c5346b7e5f0f6d$var$asSymbol(args);
    else return $39c5346b7e5f0f6d$var$asIcon(args);
}
function $39c5346b7e5f0f6d$var$makeLayersTextAbstract(params) {
    var content = params.content, width = params.width, height = params.height, transform = params.transform, extra = params.extra, _params$watchable2 = params.watchable, watchable = _params$watchable2 === void 0 ? false : _params$watchable2;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    if (watchable) attributes[$39c5346b7e5f0f6d$var$DATA_FA_I2SVG] = '';
    var styles = $39c5346b7e5f0f6d$var$_objectSpread2({}, extra.styles);
    if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) {
        styles['transform'] = $39c5346b7e5f0f6d$var$transformForCss({
            transform: transform,
            startCentered: true,
            width: width,
            height: height
        });
        styles['-webkit-transform'] = styles['transform'];
    }
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
function $39c5346b7e5f0f6d$var$makeLayersCounterAbstract(params) {
    var content = params.content, extra = params.extra;
    var attributes = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, extra.attributes), {}, {
        class: extra.classes.join(' ')
    });
    var styleString = $39c5346b7e5f0f6d$var$joinStyles(extra.styles);
    if (styleString.length > 0) attributes['style'] = styleString;
    var val = [];
    val.push({
        tag: 'span',
        attributes: attributes,
        children: [
            content
        ]
    });
    return val;
}
var $39c5346b7e5f0f6d$var$styles$1 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$asFoundIcon(icon) {
    var width = icon[0];
    var height = icon[1];
    var _icon$slice = icon.slice(4), _icon$slice2 = $39c5346b7e5f0f6d$var$_slicedToArray(_icon$slice, 1), vectorData = _icon$slice2[0];
    var element = null;
    if (Array.isArray(vectorData)) element = {
        tag: 'g',
        attributes: {
            class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.GROUP)
        },
        children: [
            {
                tag: 'path',
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.SECONDARY),
                    fill: 'currentColor',
                    d: vectorData[0]
                }
            },
            {
                tag: 'path',
                attributes: {
                    class: "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-").concat($39c5346b7e5f0f6d$var$DUOTONE_CLASSES.PRIMARY),
                    fill: 'currentColor',
                    d: vectorData[1]
                }
            }
        ]
    };
    else element = {
        tag: 'path',
        attributes: {
            fill: 'currentColor',
            d: vectorData
        }
    };
    return {
        found: true,
        width: width,
        height: height,
        icon: element
    };
}
var $39c5346b7e5f0f6d$var$missingIconResolutionMixin = {
    found: false,
    width: 512,
    height: 512
};
function $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix) {
    if (!$39c5346b7e5f0f6d$var$PRODUCTION && !$39c5346b7e5f0f6d$var$config.showMissingIcons && iconName) console.error("Icon with name \"".concat(iconName, "\" and prefix \"").concat(prefix, "\" is missing."));
}
function $39c5346b7e5f0f6d$var$findIcon(iconName, prefix) {
    var givenPrefix = prefix;
    if (prefix === 'fa' && $39c5346b7e5f0f6d$var$config.styleDefault !== null) prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    return new Promise(function(resolve, reject) {
        if (givenPrefix === 'fa') {
            var shim = $39c5346b7e5f0f6d$var$byOldName(iconName) || {};
            iconName = shim.iconName || iconName;
            prefix = shim.prefix || prefix;
        }
        if (iconName && prefix && $39c5346b7e5f0f6d$var$styles$1[prefix] && $39c5346b7e5f0f6d$var$styles$1[prefix][iconName]) {
            var icon = $39c5346b7e5f0f6d$var$styles$1[prefix][iconName];
            return resolve($39c5346b7e5f0f6d$var$asFoundIcon(icon));
        }
        $39c5346b7e5f0f6d$var$maybeNotifyMissing(iconName, prefix);
        resolve($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$missingIconResolutionMixin), {}, {
            icon: $39c5346b7e5f0f6d$var$config.showMissingIcons && iconName ? $39c5346b7e5f0f6d$var$callProvided('missingIconAbstract') || {} : {}
        }));
    });
}
var $39c5346b7e5f0f6d$var$noop$1 = function noop() {};
var $39c5346b7e5f0f6d$var$p$2 = $39c5346b7e5f0f6d$var$config.measurePerformance && $39c5346b7e5f0f6d$var$PERFORMANCE && $39c5346b7e5f0f6d$var$PERFORMANCE.mark && $39c5346b7e5f0f6d$var$PERFORMANCE.measure ? $39c5346b7e5f0f6d$var$PERFORMANCE : {
    mark: $39c5346b7e5f0f6d$var$noop$1,
    measure: $39c5346b7e5f0f6d$var$noop$1
};
var $39c5346b7e5f0f6d$var$preamble = "FA \"7.3.1\"";
var $39c5346b7e5f0f6d$var$begin = function begin(name) {
    $39c5346b7e5f0f6d$var$p$2.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"));
    return function() {
        return $39c5346b7e5f0f6d$var$end(name);
    };
};
var $39c5346b7e5f0f6d$var$end = function end(name) {
    $39c5346b7e5f0f6d$var$p$2.mark("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
    $39c5346b7e5f0f6d$var$p$2.measure("".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " begins"), "".concat($39c5346b7e5f0f6d$var$preamble, " ").concat(name, " ends"));
};
var $39c5346b7e5f0f6d$var$perf = {
    begin: $39c5346b7e5f0f6d$var$begin,
    end: $39c5346b7e5f0f6d$var$end
};
var $39c5346b7e5f0f6d$var$noop$2 = function noop() {};
function $39c5346b7e5f0f6d$var$isWatched(node) {
    var i2svg = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) : null;
    return typeof i2svg === 'string';
}
function $39c5346b7e5f0f6d$var$hasPrefixAndIcon(node) {
    var prefix = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) : null;
    var icon = node.getAttribute ? node.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) : null;
    return prefix && icon;
}
function $39c5346b7e5f0f6d$var$hasBeenReplaced(node) {
    return node && node.classList && node.classList.contains && node.classList.contains($39c5346b7e5f0f6d$var$config.replacementClass);
}
function $39c5346b7e5f0f6d$var$getMutator() {
    if ($39c5346b7e5f0f6d$var$config.autoReplaceSvg === true) return $39c5346b7e5f0f6d$var$mutators.replace;
    var mutator = $39c5346b7e5f0f6d$var$mutators[$39c5346b7e5f0f6d$var$config.autoReplaceSvg];
    return mutator || $39c5346b7e5f0f6d$var$mutators.replace;
}
function $39c5346b7e5f0f6d$var$createElementNS(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', tag);
}
function $39c5346b7e5f0f6d$var$createElement(tag) {
    return $39c5346b7e5f0f6d$var$DOCUMENT.createElement(tag);
}
function $39c5346b7e5f0f6d$var$convertSVG(abstractObj) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$ceFn = params.ceFn, ceFn = _params$ceFn === void 0 ? abstractObj.tag === 'svg' ? $39c5346b7e5f0f6d$var$createElementNS : $39c5346b7e5f0f6d$var$createElement : _params$ceFn;
    if (typeof abstractObj === 'string') return $39c5346b7e5f0f6d$var$DOCUMENT.createTextNode(abstractObj);
    var tag = ceFn(abstractObj.tag);
    Object.keys(abstractObj.attributes || []).forEach(function(key) {
        tag.setAttribute(key, abstractObj.attributes[key]);
    });
    var children = abstractObj.children || [];
    children.forEach(function(child) {
        tag.appendChild($39c5346b7e5f0f6d$var$convertSVG(child, {
            ceFn: ceFn
        }));
    });
    return tag;
}
function $39c5346b7e5f0f6d$var$nodeAsComment(node) {
    var comment = " ".concat(node.outerHTML, " ");
    /* BEGIN.ATTRIBUTION */ comment = "".concat(comment, "Font Awesome fontawesome.com ");
    /* END.ATTRIBUTION */ return comment;
}
var $39c5346b7e5f0f6d$var$mutators = {
    replace: function replace(mutation) {
        var node = mutation[0];
        if (node.parentNode) {
            mutation[1].forEach(function(abstract) {
                node.parentNode.insertBefore($39c5346b7e5f0f6d$var$convertSVG(abstract), node);
            });
            if (node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG) === null && $39c5346b7e5f0f6d$var$config.keepOriginalSource) {
                var comment = $39c5346b7e5f0f6d$var$DOCUMENT.createComment($39c5346b7e5f0f6d$var$nodeAsComment(node));
                node.parentNode.replaceChild(comment, node);
            } else node.remove();
        }
    },
    nest: function nest(mutation) {
        var node = mutation[0];
        var abstract = mutation[1];
        // If we already have a replaced node we do not want to continue nesting within it.
        // Short-circuit to the standard replacement
        if (~$39c5346b7e5f0f6d$var$classArray(node).indexOf($39c5346b7e5f0f6d$var$config.replacementClass)) return $39c5346b7e5f0f6d$var$mutators.replace(mutation);
        var forSvg = new RegExp("".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-.*"));
        delete abstract[0].attributes.id;
        if (abstract[0].attributes.class) {
            var splitClasses = abstract[0].attributes.class.split(' ').reduce(function(acc, cls) {
                if (cls === $39c5346b7e5f0f6d$var$config.replacementClass || cls.match(forSvg)) acc.toSvg.push(cls);
                else acc.toNode.push(cls);
                return acc;
            }, {
                toNode: [],
                toSvg: []
            });
            abstract[0].attributes.class = splitClasses.toSvg.join(' ');
            if (splitClasses.toNode.length === 0) node.removeAttribute('class');
            else node.setAttribute('class', splitClasses.toNode.join(' '));
        }
        var newInnerHTML = abstract.map(function(a) {
            return $39c5346b7e5f0f6d$var$toHtml(a);
        }).join('\n');
        node.setAttribute($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, '');
        node.innerHTML = newInnerHTML;
    }
};
function $39c5346b7e5f0f6d$var$performOperationSync(op) {
    op();
}
function $39c5346b7e5f0f6d$var$perform(mutations, callback) {
    var callbackFunction = typeof callback === 'function' ? callback : $39c5346b7e5f0f6d$var$noop$2;
    if (mutations.length === 0) callbackFunction();
    else {
        var frame = $39c5346b7e5f0f6d$var$performOperationSync;
        if ($39c5346b7e5f0f6d$var$config.mutateApproach === $39c5346b7e5f0f6d$var$MUTATION_APPROACH_ASYNC) frame = $39c5346b7e5f0f6d$var$WINDOW.requestAnimationFrame || $39c5346b7e5f0f6d$var$performOperationSync;
        frame(function() {
            var mutator = $39c5346b7e5f0f6d$var$getMutator();
            var mark = $39c5346b7e5f0f6d$var$perf.begin('mutate');
            mutations.map(mutator);
            mark();
            callbackFunction();
        });
    }
}
var $39c5346b7e5f0f6d$var$disabled = false;
function $39c5346b7e5f0f6d$var$disableObservation() {
    $39c5346b7e5f0f6d$var$disabled = true;
}
function $39c5346b7e5f0f6d$var$enableObservation() {
    $39c5346b7e5f0f6d$var$disabled = false;
}
var $39c5346b7e5f0f6d$var$mo = null;
function $39c5346b7e5f0f6d$var$observe(options) {
    if (!$39c5346b7e5f0f6d$var$MUTATION_OBSERVER) return;
    if (!$39c5346b7e5f0f6d$var$config.observeMutations) return;
    var _options$treeCallback = options.treeCallback, treeCallback = _options$treeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$treeCallback, _options$nodeCallback = options.nodeCallback, nodeCallback = _options$nodeCallback === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$nodeCallback, _options$pseudoElemen = options.pseudoElementsCallback, pseudoElementsCallback = _options$pseudoElemen === void 0 ? $39c5346b7e5f0f6d$var$noop$2 : _options$pseudoElemen, _options$observeMutat = options.observeMutationsRoot, observeMutationsRoot = _options$observeMutat === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _options$observeMutat;
    $39c5346b7e5f0f6d$var$mo = new $39c5346b7e5f0f6d$var$MUTATION_OBSERVER(function(objects) {
        if ($39c5346b7e5f0f6d$var$disabled) return;
        var defaultPrefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
        $39c5346b7e5f0f6d$var$toArray(objects).forEach(function(mutationRecord) {
            if (mutationRecord.type === 'childList' && mutationRecord.addedNodes.length > 0 && !$39c5346b7e5f0f6d$var$isWatched(mutationRecord.addedNodes[0])) {
                if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback(mutationRecord.target);
                treeCallback(mutationRecord.target);
            }
            if (mutationRecord.type === 'attributes' && mutationRecord.target.parentNode && $39c5346b7e5f0f6d$var$config.searchPseudoElements) pseudoElementsCallback([
                mutationRecord.target
            ], true);
            if (mutationRecord.type === 'attributes' && $39c5346b7e5f0f6d$var$isWatched(mutationRecord.target) && ~$39c5346b7e5f0f6d$var$ATTRIBUTES_WATCHED_FOR_MUTATION.indexOf(mutationRecord.attributeName)) {
                if (mutationRecord.attributeName === 'class' && $39c5346b7e5f0f6d$var$hasPrefixAndIcon(mutationRecord.target)) {
                    var _getCanonicalIcon = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(mutationRecord.target)), prefix = _getCanonicalIcon.prefix, iconName = _getCanonicalIcon.iconName;
                    mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX, prefix || defaultPrefix);
                    if (iconName) mutationRecord.target.setAttribute($39c5346b7e5f0f6d$var$DATA_ICON, iconName);
                } else if ($39c5346b7e5f0f6d$var$hasBeenReplaced(mutationRecord.target)) nodeCallback(mutationRecord.target);
            }
        });
    });
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    $39c5346b7e5f0f6d$var$mo.observe(observeMutationsRoot, {
        childList: true,
        attributes: true,
        characterData: true,
        subtree: true
    });
}
function $39c5346b7e5f0f6d$var$disconnect() {
    if (!$39c5346b7e5f0f6d$var$mo) return;
    $39c5346b7e5f0f6d$var$mo.disconnect();
}
function $39c5346b7e5f0f6d$var$styleParser(node) {
    var style = node.getAttribute('style');
    var val = [];
    if (style) val = style.split(';').reduce(function(acc, style) {
        var styles = style.split(':');
        var prop = styles[0];
        var value = styles.slice(1);
        if (prop && value.length > 0) acc[prop] = value.join(':').trim();
        return acc;
    }, {});
    return val;
}
function $39c5346b7e5f0f6d$var$classParser(node) {
    var existingPrefix = node.getAttribute('data-prefix');
    var existingIconName = node.getAttribute('data-icon');
    var innerText = node.innerText !== undefined ? node.innerText.trim() : '';
    var val = $39c5346b7e5f0f6d$var$getCanonicalIcon($39c5346b7e5f0f6d$var$classArray(node));
    if (!val.prefix) val.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
    if (existingPrefix && existingIconName) {
        val.prefix = existingPrefix;
        val.iconName = existingIconName;
    }
    if (val.iconName && val.prefix) return val;
    if (val.prefix && innerText.length > 0) val.iconName = $39c5346b7e5f0f6d$var$byLigature(val.prefix, node.innerText) || $39c5346b7e5f0f6d$var$byUnicode(val.prefix, $39c5346b7e5f0f6d$var$toHex(node.innerText));
    if (!val.iconName && $39c5346b7e5f0f6d$var$config.autoFetchSvg && node.firstChild && node.firstChild.nodeType === Node.TEXT_NODE) val.iconName = node.firstChild.data;
    return val;
}
function $39c5346b7e5f0f6d$var$attributesParser(node) {
    var extraAttributes = $39c5346b7e5f0f6d$var$toArray(node.attributes).reduce(function(acc, attr) {
        if (acc.name !== 'class' && acc.name !== 'style') acc[attr.name] = attr.value;
        return acc;
    }, {});
    return extraAttributes;
}
function $39c5346b7e5f0f6d$var$blankMeta() {
    return {
        iconName: null,
        prefix: null,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        symbol: false,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        extra: {
            classes: [],
            styles: {},
            attributes: {}
        }
    };
}
function $39c5346b7e5f0f6d$var$parseMeta(node) {
    var parser = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
        styleParser: true
    };
    var _classParser = $39c5346b7e5f0f6d$var$classParser(node), iconName = _classParser.iconName, prefix = _classParser.prefix, extraClasses = _classParser.rest;
    var extraAttributes = $39c5346b7e5f0f6d$var$attributesParser(node);
    var pluginMeta = $39c5346b7e5f0f6d$var$chainHooks('parseNodeAttributes', {}, node);
    var extraStyles = parser.styleParser ? $39c5346b7e5f0f6d$var$styleParser(node) : [];
    return $39c5346b7e5f0f6d$var$_objectSpread2({
        iconName: iconName,
        prefix: prefix,
        transform: $39c5346b7e5f0f6d$var$meaninglessTransform,
        mask: {
            iconName: null,
            prefix: null,
            rest: []
        },
        maskId: null,
        symbol: false,
        extra: {
            classes: extraClasses,
            styles: extraStyles,
            attributes: extraAttributes
        }
    }, pluginMeta);
}
var $39c5346b7e5f0f6d$var$styles$2 = $39c5346b7e5f0f6d$var$namespace.styles;
function $39c5346b7e5f0f6d$var$generateMutation(node) {
    var nodeMeta = $39c5346b7e5f0f6d$var$config.autoReplaceSvg === 'nest' ? $39c5346b7e5f0f6d$var$parseMeta(node, {
        styleParser: false
    }) : $39c5346b7e5f0f6d$var$parseMeta(node);
    if (~nodeMeta.extra.classes.indexOf($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME)) return $39c5346b7e5f0f6d$var$callProvided('generateLayersText', node, nodeMeta);
    else return $39c5346b7e5f0f6d$var$callProvided('generateSvgReplacementMutation', node, nodeMeta);
}
function $39c5346b7e5f0f6d$var$getKnownPrefixes() {
    return [].concat($39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$at), $39c5346b7e5f0f6d$var$_toConsumableArray($39c5346b7e5f0f6d$var$ha));
}
function $39c5346b7e5f0f6d$var$onTree(root) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return Promise.resolve();
    var htmlClassList = $39c5346b7e5f0f6d$var$DOCUMENT.documentElement.classList;
    var hclAdd = function hclAdd(suffix) {
        return htmlClassList.add("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var hclRemove = function hclRemove(suffix) {
        return htmlClassList.remove("".concat($39c5346b7e5f0f6d$var$HTML_CLASS_I2SVG_BASE_CLASS, "-").concat(suffix));
    };
    var prefixes = $39c5346b7e5f0f6d$var$config.autoFetchSvg ? $39c5346b7e5f0f6d$var$getKnownPrefixes() : $39c5346b7e5f0f6d$var$dl.concat(Object.keys($39c5346b7e5f0f6d$var$styles$2));
    if (!prefixes.includes('fa')) prefixes.push('fa');
    var prefixesDomQuery = [
        ".".concat($39c5346b7e5f0f6d$var$LAYERS_TEXT_CLASSNAME, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])")
    ].concat(prefixes.map(function(p$$1) {
        return ".".concat(p$$1, ":not([").concat($39c5346b7e5f0f6d$var$DATA_FA_I2SVG, "])");
    })).join(', ');
    if (prefixesDomQuery.length === 0) return Promise.resolve();
    var candidates = [];
    try {
        candidates = $39c5346b7e5f0f6d$var$toArray(root.querySelectorAll(prefixesDomQuery));
    } catch (e$$1) {
    // noop
    }
    if (candidates.length > 0) {
        hclAdd('pending');
        hclRemove('complete');
    } else return Promise.resolve();
    var mark = $39c5346b7e5f0f6d$var$perf.begin('onTree');
    var mutations = candidates.reduce(function(acc, node) {
        try {
            var mutation = $39c5346b7e5f0f6d$var$generateMutation(node);
            if (mutation) acc.push(mutation);
        } catch (e$$1) {
            if (!$39c5346b7e5f0f6d$var$PRODUCTION) {
                if (e$$1.name === 'MissingIcon') console.error(e$$1);
            }
        }
        return acc;
    }, []);
    return new Promise(function(resolve, reject) {
        Promise.all(mutations).then(function(resolvedMutations) {
            $39c5346b7e5f0f6d$var$perform(resolvedMutations, function() {
                hclAdd('active');
                hclAdd('complete');
                hclRemove('pending');
                if (typeof callback === 'function') callback();
                mark();
                resolve();
            });
        }).catch(function(e$$1) {
            mark();
            reject(e$$1);
        });
    });
}
function $39c5346b7e5f0f6d$var$onNode(node) {
    var callback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    $39c5346b7e5f0f6d$var$generateMutation(node).then(function(mutation) {
        if (mutation) $39c5346b7e5f0f6d$var$perform([
            mutation
        ], callback);
    });
}
function $39c5346b7e5f0f6d$var$resolveIcons(next) {
    return function(maybeIconDefinition) {
        var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        var iconDefinition = (maybeIconDefinition || {}).icon ? maybeIconDefinition : $39c5346b7e5f0f6d$var$findIconDefinition(maybeIconDefinition || {});
        var mask = params.mask;
        if (mask) mask = (mask || {}).icon ? mask : $39c5346b7e5f0f6d$var$findIconDefinition(mask || {});
        return next(iconDefinition, $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, params), {}, {
            mask: mask
        }));
    };
}
var $39c5346b7e5f0f6d$var$render = function render(iconDefinition) {
    var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$symbol = params.symbol, symbol = _params$symbol === void 0 ? false : _params$symbol, _params$mask = params.mask, mask = _params$mask === void 0 ? null : _params$mask, _params$maskId = params.maskId, maskId = _params$maskId === void 0 ? null : _params$maskId, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
    if (!iconDefinition) return;
    var prefix = iconDefinition.prefix, iconName = iconDefinition.iconName, icon = iconDefinition.icon;
    return $39c5346b7e5f0f6d$var$domVariants($39c5346b7e5f0f6d$var$_objectSpread2({
        type: 'icon'
    }, iconDefinition), function() {
        $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
            iconDefinition: iconDefinition,
            params: params
        });
        return $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
            icons: {
                main: $39c5346b7e5f0f6d$var$asFoundIcon(icon),
                mask: mask ? $39c5346b7e5f0f6d$var$asFoundIcon(mask.icon) : {
                    found: false,
                    width: null,
                    height: null,
                    icon: {}
                }
            },
            prefix: prefix,
            iconName: iconName,
            transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
            symbol: symbol,
            maskId: maskId,
            extra: {
                attributes: attributes,
                styles: styles,
                classes: classes
            }
        });
    });
};
var $39c5346b7e5f0f6d$var$ReplaceElements = {
    mixout: function mixout() {
        return {
            icon: $39c5346b7e5f0f6d$var$resolveIcons($39c5346b7e5f0f6d$var$render)
        };
    },
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.treeCallback = $39c5346b7e5f0f6d$var$onTree;
                accumulator.nodeCallback = $39c5346b7e5f0f6d$var$onNode;
                return accumulator;
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.i2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node, _params$callback = params.callback, callback = _params$callback === void 0 ? function callback() {} : _params$callback;
            return $39c5346b7e5f0f6d$var$onTree(node, callback);
        };
        providers$$1.generateSvgReplacementMutation = function(node, nodeMeta) {
            var iconName = nodeMeta.iconName, prefix = nodeMeta.prefix, transform = nodeMeta.transform, symbol = nodeMeta.symbol, mask = nodeMeta.mask, maskId = nodeMeta.maskId, extra = nodeMeta.extra;
            return new Promise(function(resolve, reject) {
                Promise.all([
                    $39c5346b7e5f0f6d$var$findIcon(iconName, prefix),
                    mask.iconName ? $39c5346b7e5f0f6d$var$findIcon(mask.iconName, mask.prefix) : Promise.resolve({
                        found: false,
                        width: 512,
                        height: 512,
                        icon: {}
                    })
                ]).then(function(_ref) {
                    var _ref2 = $39c5346b7e5f0f6d$var$_slicedToArray(_ref, 2), main = _ref2[0], mask = _ref2[1];
                    resolve([
                        node,
                        $39c5346b7e5f0f6d$var$makeInlineSvgAbstract({
                            icons: {
                                main: main,
                                mask: mask
                            },
                            prefix: prefix,
                            iconName: iconName,
                            transform: transform,
                            symbol: symbol,
                            maskId: maskId,
                            extra: extra,
                            watchable: true
                        })
                    ]);
                }).catch(reject);
            });
        };
        providers$$1.generateAbstractIcon = function(_ref3) {
            var children = _ref3.children, attributes = _ref3.attributes, main = _ref3.main, transform = _ref3.transform, styles = _ref3.styles;
            var styleString = $39c5346b7e5f0f6d$var$joinStyles(styles);
            if (styleString.length > 0) attributes['style'] = styleString;
            var nextChild;
            if ($39c5346b7e5f0f6d$var$transformIsMeaningful(transform)) nextChild = $39c5346b7e5f0f6d$var$callProvided('generateAbstractTransformGrouping', {
                main: main,
                transform: transform,
                containerWidth: main.width,
                iconWidth: main.width
            });
            children.push(nextChild || main.icon);
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$Layers = {
    mixout: function mixout() {
        return {
            layer: function layer(assembler) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'layer'
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        assembler: assembler,
                        params: params
                    });
                    var children = [];
                    assembler(function(args) {
                        Array.isArray(args) ? args.map(function(a) {
                            children = children.concat(a.abstract);
                        }) : children = children.concat(args.abstract);
                    });
                    return [
                        {
                            tag: 'span',
                            attributes: {
                                class: [
                                    "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers")
                                ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes)).join(' ')
                            },
                            children: children
                        }
                    ];
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersCounter = {
    mixout: function mixout() {
        return {
            counter: function counter(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$title = params.title, title = _params$title === void 0 ? null : _params$title, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'counter',
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersCounterAbstract({
                        content: content.toString(),
                        title: title,
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-counter")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$LayersText = {
    mixout: function mixout() {
        return {
            text: function text(content) {
                var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
                var _params$transform = params.transform, transform = _params$transform === void 0 ? $39c5346b7e5f0f6d$var$meaninglessTransform : _params$transform, _params$classes = params.classes, classes = _params$classes === void 0 ? [] : _params$classes, _params$attributes = params.attributes, attributes = _params$attributes === void 0 ? {} : _params$attributes, _params$styles = params.styles, styles = _params$styles === void 0 ? {} : _params$styles;
                return $39c5346b7e5f0f6d$var$domVariants({
                    type: 'text',
                    content: content
                }, function() {
                    $39c5346b7e5f0f6d$var$callHooks('beforeDOMElementCreation', {
                        content: content,
                        params: params
                    });
                    return $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                        content: content,
                        transform: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$meaninglessTransform), transform),
                        extra: {
                            attributes: attributes,
                            styles: styles,
                            classes: [
                                "".concat($39c5346b7e5f0f6d$var$config.cssPrefix, "-layers-text")
                            ].concat($39c5346b7e5f0f6d$var$_toConsumableArray(classes))
                        }
                    });
                });
            }
        };
    },
    provides: function provides(providers$$1) {
        providers$$1.generateLayersText = function(node, nodeMeta) {
            var transform = nodeMeta.transform, extra = nodeMeta.extra;
            var width = null;
            var height = null;
            if ($39c5346b7e5f0f6d$var$IS_IE) {
                var computedFontSize = parseInt(getComputedStyle(node).fontSize, 10);
                var boundingClientRect = node.getBoundingClientRect();
                width = boundingClientRect.width / computedFontSize;
                height = boundingClientRect.height / computedFontSize;
            }
            return Promise.resolve([
                node,
                $39c5346b7e5f0f6d$var$makeLayersTextAbstract({
                    content: node.innerHTML,
                    width: width,
                    height: height,
                    transform: transform,
                    extra: extra,
                    watchable: true
                })
            ]);
        };
    }
};
var $39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN = new RegExp("\"", 'ug');
var $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE = [
    1105920,
    1112319
];
var $39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, {
    FontAwesome: {
        normal: 'fas',
        400: 'fas'
    }
}), $39c5346b7e5f0f6d$var$zl), $39c5346b7e5f0f6d$var$wa), $39c5346b7e5f0f6d$var$ct);
var $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX = Object.keys($39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, key) {
    acc[key.toLowerCase()] = $39c5346b7e5f0f6d$var$_FONT_FAMILY_WEIGHT_TO_PREFIX[key];
    return acc;
}, {});
var $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_FALLBACK = Object.keys($39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX).reduce(function(acc, fontFamily) {
    var weights = $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamily];
    acc[fontFamily] = weights[900] || $39c5346b7e5f0f6d$var$_toConsumableArray(Object.entries(weights))[0][1];
    return acc;
}, {});
// Return hex value of *first* character in `content`
function $39c5346b7e5f0f6d$var$hexValueFromContent(content) {
    var cleaned = content.replace($39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN, '');
    return $39c5346b7e5f0f6d$var$toHex($39c5346b7e5f0f6d$var$_toConsumableArray(cleaned)[0] || '');
}
// Check if it's a secondary Duotone layer, by checking if:
// - Unicode value in `content` is repeated
// - Unicode value in `content` is above 0x10000
// - The "ss01" font feature is enabled on the `content`
function $39c5346b7e5f0f6d$var$isSecondaryLayer(styles) {
    var hasStylisticSet = styles.getPropertyValue('font-feature-settings').includes('ss01');
    var content = styles.getPropertyValue('content');
    var cleaned = content.replace($39c5346b7e5f0f6d$var$CLEAN_CONTENT_PATTERN, '');
    var codePoint = cleaned.codePointAt(0);
    var isPrependTen = codePoint >= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[0] && codePoint <= $39c5346b7e5f0f6d$var$SECONDARY_UNICODE_RANGE[1];
    var isDoubled = cleaned.length === 2 ? cleaned[0] === cleaned[1] : false;
    return isPrependTen || isDoubled || hasStylisticSet;
}
function $39c5346b7e5f0f6d$var$getPrefix(fontFamily, fontWeight) {
    var fontFamilySanitized = fontFamily.replace(/^['"]|['"]$/g, '').toLowerCase();
    var fontWeightInteger = parseInt(fontWeight);
    var fontWeightSanitized = isNaN(fontWeightInteger) ? 'normal' : fontWeightInteger;
    return ($39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_TO_PREFIX[fontFamilySanitized] || {})[fontWeightSanitized] || $39c5346b7e5f0f6d$var$FONT_FAMILY_WEIGHT_FALLBACK[fontFamilySanitized];
}
function $39c5346b7e5f0f6d$var$replaceForPosition(node, position) {
    var pendingAttribute = "".concat($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT_PENDING).concat(position.replace(':', '-'));
    return new Promise(function(resolve, reject) {
        if (node.getAttribute(pendingAttribute) !== null) // This node is already being processed
        return resolve();
        var children = $39c5346b7e5f0f6d$var$toArray(node.children);
        var alreadyProcessedPseudoElement = children.filter(function(c$$1) {
            return c$$1.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) === position;
        })[0];
        var styles = $39c5346b7e5f0f6d$var$WINDOW.getComputedStyle(node, position);
        var fontFamily = styles.getPropertyValue('font-family');
        var fontFamilyMatch = fontFamily.match($39c5346b7e5f0f6d$var$FONT_FAMILY_PATTERN);
        var fontWeight = styles.getPropertyValue('font-weight');
        var content = styles.getPropertyValue('content');
        if (alreadyProcessedPseudoElement && !fontFamilyMatch) {
            // If we've already processed it but the current computed style does not result in a font-family,
            // that probably means that a class name that was previously present to make the icon has been
            // removed. So we now should delete the icon.
            node.removeChild(alreadyProcessedPseudoElement);
            return resolve();
        } else if (fontFamilyMatch && content !== 'none' && content !== '') {
            var _content = styles.getPropertyValue('content');
            var prefix = $39c5346b7e5f0f6d$var$getPrefix(fontFamily, fontWeight);
            var hexValue = $39c5346b7e5f0f6d$var$hexValueFromContent(_content);
            var isV4 = fontFamilyMatch[0].startsWith('FontAwesome');
            var isSecondary = $39c5346b7e5f0f6d$var$isSecondaryLayer(styles);
            var iconName = $39c5346b7e5f0f6d$var$byUnicode(prefix, hexValue);
            var iconIdentifier = iconName;
            if (isV4) {
                var iconName4 = $39c5346b7e5f0f6d$var$byOldUnicode(hexValue);
                if (iconName4.iconName && iconName4.prefix) {
                    iconName = iconName4.iconName;
                    prefix = iconName4.prefix;
                }
            }
            // Only convert the pseudo element in this ::before/::after position into an icon if we haven't
            // already done so with the same prefix and iconName
            if (iconName && !isSecondary && (!alreadyProcessedPseudoElement || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_PREFIX) !== prefix || alreadyProcessedPseudoElement.getAttribute($39c5346b7e5f0f6d$var$DATA_ICON) !== iconIdentifier)) {
                node.setAttribute(pendingAttribute, iconIdentifier);
                if (alreadyProcessedPseudoElement) // Delete the old one, since we're replacing it with a new one
                node.removeChild(alreadyProcessedPseudoElement);
                var meta = $39c5346b7e5f0f6d$var$blankMeta();
                var extra = meta.extra;
                extra.attributes[$39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT] = position;
                $39c5346b7e5f0f6d$var$findIcon(iconName, prefix).then(function(main) {
                    var abstract = $39c5346b7e5f0f6d$var$makeInlineSvgAbstract($39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, meta), {}, {
                        icons: {
                            main: main,
                            mask: $39c5346b7e5f0f6d$var$emptyCanonicalIcon()
                        },
                        prefix: prefix,
                        iconName: iconIdentifier,
                        extra: extra,
                        watchable: true
                    }));
                    var element = $39c5346b7e5f0f6d$var$DOCUMENT.createElementNS('http://www.w3.org/2000/svg', 'svg');
                    if (position === '::before') node.insertBefore(element, node.firstChild);
                    else node.appendChild(element);
                    element.outerHTML = abstract.map(function(a$$1) {
                        return $39c5346b7e5f0f6d$var$toHtml(a$$1);
                    }).join('\n');
                    node.removeAttribute(pendingAttribute);
                    resolve();
                }).catch(reject);
            } else resolve();
        } else resolve();
    });
}
function $39c5346b7e5f0f6d$var$replace(node) {
    return Promise.all([
        $39c5346b7e5f0f6d$var$replaceForPosition(node, '::before'),
        $39c5346b7e5f0f6d$var$replaceForPosition(node, '::after')
    ]);
}
function $39c5346b7e5f0f6d$var$processable(node) {
    return node.parentNode !== document.head && !~$39c5346b7e5f0f6d$var$TAGNAMES_TO_SKIP_FOR_PSEUDOELEMENTS.indexOf(node.tagName.toUpperCase()) && !node.getAttribute($39c5346b7e5f0f6d$var$DATA_FA_PSEUDO_ELEMENT) && (!node.parentNode || node.parentNode.tagName !== 'svg');
}
var $39c5346b7e5f0f6d$var$hasPseudoElement = function hasPseudoElement(selector) {
    return !!selector && $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS.some(function(pseudoSelector) {
        return selector.includes(pseudoSelector);
    });
};
// Return selectors from all available stylesheets that have
// pseudo-elements defined.
var $39c5346b7e5f0f6d$var$parseCSSRuleForPseudos = function parseCSSRuleForPseudos(selectorText) {
    if (!selectorText) return [];
    var selectorSet = new Set();
    var selectors = selectorText.split(/,(?![^()]*\))/).map(function(s$$1) {
        return s$$1.trim();
    });
    selectors = selectors.flatMap(function(selector) {
        return selector.includes('(') ? selector : selector.split(',').map(function(s$$1) {
            return s$$1.trim();
        });
    });
    var _iterator = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(selectors), _step;
    try {
        for(_iterator.s(); !(_step = _iterator.n()).done;){
            var selector = _step.value;
            if ($39c5346b7e5f0f6d$var$hasPseudoElement(selector)) {
                // Remove pseudo-elements from the selector
                var selectorWithoutPseudo = $39c5346b7e5f0f6d$var$PSEUDO_ELEMENTS.reduce(function(acc, pseudoSelector) {
                    return acc.replace(pseudoSelector, '');
                }, selector);
                if (selectorWithoutPseudo !== '' && selectorWithoutPseudo !== '*') selectorSet.add(selectorWithoutPseudo);
            }
        }
    } catch (err) {
        _iterator.e(err);
    } finally{
        _iterator.f();
    }
    return selectorSet;
};
function $39c5346b7e5f0f6d$var$searchPseudoElements(root) {
    var useAsNodeList = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    if (!$39c5346b7e5f0f6d$var$IS_DOM) return;
    var nodeList;
    if (useAsNodeList) nodeList = root;
    else if ($39c5346b7e5f0f6d$var$config.searchPseudoElementsFullScan) nodeList = root.querySelectorAll('*');
    else {
        // Get elements that have pseudo elements defined in the CSS
        var selectorSet = new Set();
        var _iterator2 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(document.styleSheets), _step2;
        try {
            for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                var stylesheet = _step2.value;
                try {
                    var _iterator3 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(stylesheet.cssRules), _step3;
                    try {
                        for(_iterator3.s(); !(_step3 = _iterator3.n()).done;){
                            var rule = _step3.value;
                            var parsedSelectors = $39c5346b7e5f0f6d$var$parseCSSRuleForPseudos(rule.selectorText);
                            var _iterator4 = $39c5346b7e5f0f6d$var$_createForOfIteratorHelper(parsedSelectors), _step4;
                            try {
                                for(_iterator4.s(); !(_step4 = _iterator4.n()).done;){
                                    var selector = _step4.value;
                                    selectorSet.add(selector);
                                }
                            } catch (err) {
                                _iterator4.e(err);
                            } finally{
                                _iterator4.f();
                            }
                        }
                    } catch (err) {
                        _iterator3.e(err);
                    } finally{
                        _iterator3.f();
                    }
                } catch (e$$1) {
                    if ($39c5346b7e5f0f6d$var$config.searchPseudoElementsWarnings) console.warn("Font Awesome: cannot parse stylesheet: ".concat(stylesheet.href, " (").concat(e$$1.message, ")\nIf it declares any Font Awesome CSS pseudo-elements, they will not be rendered as SVG icons. Add crossorigin=\"anonymous\" to the <link>, enable searchPseudoElementsFullScan for slower but more thorough DOM parsing, or suppress this warning by setting searchPseudoElementsWarnings to false."));
                }
            }
        } catch (err) {
            _iterator2.e(err);
        } finally{
            _iterator2.f();
        }
        if (!selectorSet.size) return;
        var cleanSelectors = Array.from(selectorSet).join(', ');
        try {
            nodeList = root.querySelectorAll(cleanSelectors);
        } catch (_unused) {} // eslint-disable-line no-empty
    }
    return new Promise(function(resolve, reject) {
        var operations = $39c5346b7e5f0f6d$var$toArray(nodeList).filter($39c5346b7e5f0f6d$var$processable).map($39c5346b7e5f0f6d$var$replace);
        var end = $39c5346b7e5f0f6d$var$perf.begin('searchPseudoElements');
        $39c5346b7e5f0f6d$var$disableObservation();
        Promise.all(operations).then(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            resolve();
        }).catch(function() {
            end();
            $39c5346b7e5f0f6d$var$enableObservation();
            reject();
        });
    });
}
var $39c5346b7e5f0f6d$var$PseudoElements = {
    hooks: function hooks() {
        return {
            mutationObserverCallbacks: function mutationObserverCallbacks(accumulator) {
                accumulator.pseudoElementsCallback = $39c5346b7e5f0f6d$var$searchPseudoElements;
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.pseudoElements2svg = function(params) {
            var _params$node = params.node, node = _params$node === void 0 ? $39c5346b7e5f0f6d$var$DOCUMENT : _params$node;
            if ($39c5346b7e5f0f6d$var$config.searchPseudoElements) $39c5346b7e5f0f6d$var$searchPseudoElements(node);
        };
    }
};
var $39c5346b7e5f0f6d$var$_unwatched = false;
var $39c5346b7e5f0f6d$var$MutationObserver$1 = {
    mixout: function mixout() {
        return {
            dom: {
                unwatch: function unwatch() {
                    $39c5346b7e5f0f6d$var$disableObservation();
                    $39c5346b7e5f0f6d$var$_unwatched = true;
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            bootstrap: function bootstrap() {
                $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks('mutationObserverCallbacks', {}));
            },
            noAuto: function noAuto() {
                $39c5346b7e5f0f6d$var$disconnect();
            },
            watch: function watch(params) {
                var observeMutationsRoot = params.observeMutationsRoot;
                if ($39c5346b7e5f0f6d$var$_unwatched) $39c5346b7e5f0f6d$var$enableObservation();
                else $39c5346b7e5f0f6d$var$observe($39c5346b7e5f0f6d$var$chainHooks('mutationObserverCallbacks', {
                    observeMutationsRoot: observeMutationsRoot
                }));
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$parseTransformString = function parseTransformString(transformString) {
    var transform = {
        size: 16,
        x: 0,
        y: 0,
        flipX: false,
        flipY: false,
        rotate: 0
    };
    return transformString.toLowerCase().split(' ').reduce(function(acc, n) {
        var parts = n.toLowerCase().split('-');
        var first = parts[0];
        var rest = parts.slice(1).join('-');
        if (first && rest === 'h') {
            acc.flipX = true;
            return acc;
        }
        if (first && rest === 'v') {
            acc.flipY = true;
            return acc;
        }
        rest = parseFloat(rest);
        if (isNaN(rest)) return acc;
        switch(first){
            case 'grow':
                acc.size = acc.size + rest;
                break;
            case 'shrink':
                acc.size = acc.size - rest;
                break;
            case 'left':
                acc.x = acc.x - rest;
                break;
            case 'right':
                acc.x = acc.x + rest;
                break;
            case 'up':
                acc.y = acc.y - rest;
                break;
            case 'down':
                acc.y = acc.y + rest;
                break;
            case 'rotate':
                acc.rotate = acc.rotate + rest;
                break;
        }
        return acc;
    }, transform);
};
var $39c5346b7e5f0f6d$var$PowerTransforms = {
    mixout: function mixout() {
        return {
            parse: {
                transform: function transform(transformString) {
                    return $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                }
            }
        };
    },
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var transformString = node.getAttribute('data-fa-transform');
                if (transformString) accumulator.transform = $39c5346b7e5f0f6d$var$parseTransformString(transformString);
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractTransformGrouping = function(_ref) {
            var main = _ref.main, transform = _ref.transform, containerWidth = _ref.containerWidth, iconWidth = _ref.iconWidth;
            var outer = {
                transform: "translate(".concat(containerWidth / 2, " 256)")
            };
            var innerTranslate = "translate(".concat(transform.x * 32, ", ").concat(transform.y * 32, ") ");
            var innerScale = "scale(".concat(transform.size / 16 * (transform.flipX ? -1 : 1), ", ").concat(transform.size / 16 * (transform.flipY ? -1 : 1), ") ");
            var innerRotate = "rotate(".concat(transform.rotate, " 0 0)");
            var inner = {
                transform: "".concat(innerTranslate, " ").concat(innerScale, " ").concat(innerRotate)
            };
            var path = {
                transform: "translate(".concat(iconWidth / 2 * -1, " -256)")
            };
            var operations = {
                outer: outer,
                inner: inner,
                path: path
            };
            return {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.outer),
                children: [
                    {
                        tag: 'g',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, operations.inner),
                        children: [
                            {
                                tag: main.icon.tag,
                                children: main.icon.children,
                                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, main.icon.attributes), operations.path)
                            }
                        ]
                    }
                ]
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$ALL_SPACE = {
    x: 0,
    y: 0,
    width: '100%',
    height: '100%'
};
function $39c5346b7e5f0f6d$var$fillBlack(abstract) {
    var force = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
    if (abstract.attributes && (abstract.attributes.fill || force)) abstract.attributes.fill = 'black';
    return abstract;
}
function $39c5346b7e5f0f6d$var$deGroup(abstract) {
    if (abstract.tag === 'g') return abstract.children;
    else return [
        abstract
    ];
}
var $39c5346b7e5f0f6d$var$Masks = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var maskData = node.getAttribute('data-fa-mask');
                var mask = !maskData ? $39c5346b7e5f0f6d$var$emptyCanonicalIcon() : $39c5346b7e5f0f6d$var$getCanonicalIcon(maskData.split(' ').map(function(i) {
                    return i.trim();
                }));
                if (!mask.prefix) mask.prefix = $39c5346b7e5f0f6d$var$getDefaultUsablePrefix();
                accumulator.mask = mask;
                accumulator.maskId = node.getAttribute('data-fa-mask-id');
                return accumulator;
            }
        };
    },
    provides: function provides(providers) {
        providers.generateAbstractMask = function(_ref) {
            var children = _ref.children, attributes = _ref.attributes, main = _ref.main, mask = _ref.mask, explicitMaskId = _ref.maskId, transform = _ref.transform;
            var mainWidth = main.width, mainPath = main.icon;
            var maskWidth = mask.width, maskPath = mask.icon;
            var trans = $39c5346b7e5f0f6d$var$transformForSvg({
                transform: transform,
                containerWidth: maskWidth,
                iconWidth: mainWidth
            });
            var maskRect = {
                tag: 'rect',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    fill: 'white'
                })
            };
            var maskInnerGroupChildrenMixin = mainPath.children ? {
                children: mainPath.children.map($39c5346b7e5f0f6d$var$fillBlack)
            } : {};
            var maskInnerGroup = {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.inner),
                children: [
                    $39c5346b7e5f0f6d$var$fillBlack($39c5346b7e5f0f6d$var$_objectSpread2({
                        tag: mainPath.tag,
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, mainPath.attributes), trans.path)
                    }, maskInnerGroupChildrenMixin))
                ]
            };
            var maskOuterGroup = {
                tag: 'g',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({}, trans.outer),
                children: [
                    maskInnerGroup
                ]
            };
            var maskId = "mask-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var clipId = "clip-".concat(explicitMaskId || $39c5346b7e5f0f6d$var$nextUniqueId());
            var maskTag = {
                tag: 'mask',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, $39c5346b7e5f0f6d$var$ALL_SPACE), {}, {
                    id: maskId,
                    maskUnits: 'userSpaceOnUse',
                    maskContentUnits: 'userSpaceOnUse'
                }),
                children: [
                    maskRect,
                    maskOuterGroup
                ]
            };
            var defs = {
                tag: 'defs',
                children: [
                    {
                        tag: 'clipPath',
                        attributes: {
                            id: clipId
                        },
                        children: $39c5346b7e5f0f6d$var$deGroup(maskPath)
                    },
                    maskTag
                ]
            };
            children.push(defs, {
                tag: 'rect',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2({
                    'fill': 'currentColor',
                    'clip-path': "url(#".concat(clipId, ")"),
                    'mask': "url(#".concat(maskId, ")")
                }, $39c5346b7e5f0f6d$var$ALL_SPACE)
            });
            return {
                children: children,
                attributes: attributes
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$MissingIconIndicator = {
    provides: function provides(providers) {
        var reduceMotion = false;
        if ($39c5346b7e5f0f6d$var$WINDOW.matchMedia) reduceMotion = $39c5346b7e5f0f6d$var$WINDOW.matchMedia('(prefers-reduced-motion: reduce)').matches;
        providers.missingIconAbstract = function() {
            var gChildren = [];
            var FILL = {
                fill: 'currentColor'
            };
            var ANIMATION_BASE = {
                attributeType: 'XML',
                repeatCount: 'indefinite',
                dur: '2s'
            };
            // Ring
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    d: 'M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z'
                })
            });
            var OPACITY_ANIMATE = $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                attributeName: 'opacity'
            });
            var dot = {
                tag: 'circle',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    cx: '256',
                    cy: '364',
                    r: '28'
                }),
                children: []
            };
            if (!reduceMotion) dot.children.push({
                tag: 'animate',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, ANIMATION_BASE), {}, {
                    attributeName: 'r',
                    values: '28;14;28;28;14;28;'
                })
            }, {
                tag: 'animate',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                    values: '1;0;1;1;0;1;'
                })
            });
            gChildren.push(dot);
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: '1',
                    d: 'M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z'
                }),
                children: reduceMotion ? [] : [
                    {
                        tag: 'animate',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '1;0;0;0;0;1;'
                        })
                    }
                ]
            });
            if (!reduceMotion) // Exclamation
            gChildren.push({
                tag: 'path',
                attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, FILL), {}, {
                    opacity: '0',
                    d: 'M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z'
                }),
                children: [
                    {
                        tag: 'animate',
                        attributes: $39c5346b7e5f0f6d$var$_objectSpread2($39c5346b7e5f0f6d$var$_objectSpread2({}, OPACITY_ANIMATE), {}, {
                            values: '0;0;1;1;0;0;'
                        })
                    }
                ]
            });
            return {
                tag: 'g',
                attributes: {
                    class: 'missing'
                },
                children: gChildren
            };
        };
    }
};
var $39c5346b7e5f0f6d$var$SvgSymbols = {
    hooks: function hooks() {
        return {
            parseNodeAttributes: function parseNodeAttributes(accumulator, node) {
                var symbolData = node.getAttribute('data-fa-symbol');
                var symbol = symbolData === null ? false : symbolData === '' ? true : symbolData;
                accumulator['symbol'] = symbol;
                return accumulator;
            }
        };
    }
};
var $39c5346b7e5f0f6d$var$plugins = [
    $39c5346b7e5f0f6d$var$InjectCSS,
    $39c5346b7e5f0f6d$var$ReplaceElements,
    $39c5346b7e5f0f6d$var$Layers,
    $39c5346b7e5f0f6d$var$LayersCounter,
    $39c5346b7e5f0f6d$var$LayersText,
    $39c5346b7e5f0f6d$var$PseudoElements,
    $39c5346b7e5f0f6d$var$MutationObserver$1,
    $39c5346b7e5f0f6d$var$PowerTransforms,
    $39c5346b7e5f0f6d$var$Masks,
    $39c5346b7e5f0f6d$var$MissingIconIndicator,
    $39c5346b7e5f0f6d$var$SvgSymbols
];
$39c5346b7e5f0f6d$var$registerPlugins($39c5346b7e5f0f6d$var$plugins, {
    mixoutsTo: $39c5346b7e5f0f6d$export$644d8ea042df96a6
});
var $39c5346b7e5f0f6d$export$4f8e844b2782642c = $39c5346b7e5f0f6d$export$644d8ea042df96a6.noAuto;
var $39c5346b7e5f0f6d$export$e506a1d27d1eaa20 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.config;
var $39c5346b7e5f0f6d$export$b839f963c7dc0e34 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.library;
var $39c5346b7e5f0f6d$export$df3a06d6289f983e = $39c5346b7e5f0f6d$export$644d8ea042df96a6.dom;
var $39c5346b7e5f0f6d$export$98e6a39c04603d36 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.parse;
var $39c5346b7e5f0f6d$export$221fed4a47f597a5 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.findIconDefinition;
var $39c5346b7e5f0f6d$export$a10125c086a4df16 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.toHtml;
var $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.icon;
var $39c5346b7e5f0f6d$export$50a222d9023da98b = $39c5346b7e5f0f6d$export$644d8ea042df96a6.layer;
var $39c5346b7e5f0f6d$export$6f093cfa640b7166 = $39c5346b7e5f0f6d$export$644d8ea042df96a6.text;
var $39c5346b7e5f0f6d$export$e575061ef2a070eb = $39c5346b7e5f0f6d$export$644d8ea042df96a6.counter;



function $a50446a11289d212$var$_templateObject() {
    var data = (0, $2017c4963e549b4b$export$71511d61b312f219)([
        "(?<=^|s)",
        "-"
    ], [
        "(?<=^|\\s)",
        "-"
    ]);
    $a50446a11289d212$var$_templateObject = function _templateObject() {
        return data;
    };
    return data;
}
// src/components/FontAwesomeIcon.tsx
// src/utils/camelize.ts
function $a50446a11289d212$var$_isNumerical(object) {
    object = object - 0;
    return object === object;
}
function $a50446a11289d212$var$camelize(string) {
    if ($a50446a11289d212$var$_isNumerical(string)) return string;
    string = string.replace(/[_-]+(.)?/g, function(_, chr) {
        return chr ? chr.toUpperCase() : "";
    });
    return string.charAt(0).toLowerCase() + string.slice(1);
}
var $a50446a11289d212$var$createGradientStops = function(stop, index) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement("stop", (0, $lvTkn._)({
        key: "".concat(index, "-").concat(stop.offset),
        offset: stop.offset,
        stopColor: stop.color
    }, stop.opacity !== void 0 && {
        stopOpacity: stop.opacity
    }));
};
// src/converter.ts
function $a50446a11289d212$var$capitalize(val) {
    return val.charAt(0).toUpperCase() + val.slice(1);
}
var $a50446a11289d212$var$styleCache = /* @__PURE__ */ new Map();
var $a50446a11289d212$var$STYLE_CACHE_LIMIT = 1e3;
function $a50446a11289d212$var$styleToObject(style) {
    if ($a50446a11289d212$var$styleCache.has(style)) return $a50446a11289d212$var$styleCache.get(style);
    var result = {};
    var start = 0;
    var len = style.length;
    while(start < len){
        var semicolonIndex = style.indexOf(";", start);
        var end = semicolonIndex === -1 ? len : semicolonIndex;
        var pair = style.slice(start, end).trim();
        if (pair) {
            var colonIndex = pair.indexOf(":");
            if (colonIndex > 0) {
                var rawProp = pair.slice(0, colonIndex).trim();
                var value = pair.slice(colonIndex + 1).trim();
                if (rawProp && value) {
                    var prop = $a50446a11289d212$var$camelize(rawProp);
                    result[prop.startsWith("webkit") ? $a50446a11289d212$var$capitalize(prop) : prop] = value;
                }
            }
        }
        start = end + 1;
    }
    if ($a50446a11289d212$var$styleCache.size === $a50446a11289d212$var$STYLE_CACHE_LIMIT) {
        var oldestKey = $a50446a11289d212$var$styleCache.keys().next().value;
        if (oldestKey) $a50446a11289d212$var$styleCache.delete(oldestKey);
    }
    $a50446a11289d212$var$styleCache.set(style, result);
    return result;
}
function $a50446a11289d212$var$convert(createElement, element) {
    var extraProps = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    if (typeof element === "string") return element;
    var children = (element.children || []).map(function(child) {
        var element2 = child;
        if (("fill" in extraProps || extraProps.gradientFill) && child.tag === "path" && "fill" in child.attributes) element2 = (0, $9Jpjh._)((0, $lvTkn._)({}, child), {
            attributes: (0, $9Jpjh._)((0, $lvTkn._)({}, child.attributes), {
                fill: void 0
            })
        });
        return $a50446a11289d212$var$convert(createElement, element2);
    });
    var elementAttributes = element.attributes || {};
    var attrs = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = Object.entries(elementAttributes)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var _step_value = (0, $21h22._)(_step.value, 2), key = _step_value[0], val = _step_value[1];
            switch(true){
                case key === "class":
                    attrs.className = val;
                    break;
                case key === "style":
                    attrs.style = $a50446a11289d212$var$styleToObject(String(val));
                    break;
                case key.startsWith("aria-"):
                case key.startsWith("data-"):
                    attrs[key.toLowerCase()] = val;
                    break;
                default:
                    attrs[$a50446a11289d212$var$camelize(key)] = val;
            }
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    var existingStyle = extraProps.style, existingRole = extraProps.role, ariaLabel = extraProps["aria-label"], gradientFill = extraProps.gradientFill, remaining = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(extraProps, [
        "style",
        "role",
        "aria-label",
        "gradientFill"
    ]);
    if (existingStyle) attrs.style = attrs.style ? (0, $lvTkn._)({}, attrs.style, existingStyle) : existingStyle;
    if (existingRole) attrs.role = existingRole;
    if (ariaLabel) {
        attrs["aria-label"] = ariaLabel;
        attrs["aria-hidden"] = "false";
    }
    if (gradientFill) {
        attrs.fill = "url(#".concat(gradientFill.id, ")");
        var gradientType = gradientFill.type, tmp = gradientFill.stops, gradientStops = tmp === void 0 ? [] : tmp, gradientProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(gradientFill, [
            "type",
            "stops"
        ]);
        children.unshift(createElement(gradientType === "linear" ? "linearGradient" : "radialGradient", (0, $9Jpjh._)((0, $lvTkn._)({}, gradientProps), {
            id: gradientFill.id
        }), gradientStops.map($a50446a11289d212$var$createGradientStops)));
    }
    return createElement.apply(void 0, [
        element.tag,
        (0, $lvTkn._)({}, attrs, remaining)
    ].concat((0, $6zk1M._)(children)));
}
var $a50446a11289d212$var$makeReactConverter = $a50446a11289d212$var$convert.bind(null, (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createElement);
var $a50446a11289d212$var$useAccessibilityId = function(id, hasAccessibleProps) {
    var generatedId = (0, $eHaBZ.useId)();
    return id || (hasAccessibleProps ? generatedId : void 0);
};
// src/logger.ts
var $a50446a11289d212$var$Logger = /*#__PURE__*/ function() {
    "use strict";
    function Logger() {
        var scope = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "react-fontawesome";
        (0, $gd0sY._)(this, Logger);
        this.enabled = false;
        var IS_DEV = false;
        try {
            IS_DEV = false;
        } catch (e) {}
        this.scope = scope;
        this.enabled = IS_DEV;
    }
    (0, $7cSld._)(Logger, [
        {
            /**
   * Logs messages to the console if not in production.
   * @param args - The message and/or data to log.
   */ key: "log",
            value: function log() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (!this.enabled) return;
                (_console = console).log.apply(_console, [
                    "[".concat(this.scope, "]")
                ].concat((0, $6zk1M._)(args)));
            }
        },
        {
            /**
   * Logs warnings to the console if not in production.
   * @param args - The warning message and/or data to log.
   */ key: "warn",
            value: function warn() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (!this.enabled) return;
                (_console = console).warn.apply(_console, [
                    "[".concat(this.scope, "]")
                ].concat((0, $6zk1M._)(args)));
            }
        },
        {
            /**
   * Logs errors to the console if not in production.
   * @param args - The error message and/or data to log.
   */ key: "error",
            value: function error() {
                for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
                    args[_key] = arguments[_key];
                }
                var _console;
                if (!this.enabled) return;
                (_console = console).error.apply(_console, [
                    "[".concat(this.scope, "]")
                ].concat((0, $6zk1M._)(args)));
            }
        }
    ]);
    return Logger;
}();
"7.0.0";
var $a50446a11289d212$var$SVG_CORE_VERSION = // @ts-expect-error TS2872 - Expression is always truthy - This is true when v7 of SVGCore is used, but not when v6 is used.
// This is the point of this check - if the property exists on config, we have v7, otherwise we have v6.
// TS is checking this against the dev dependencies which uses v7, so it reports a false error here.
"searchPseudoElementsFullScan" in (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20) && typeof (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20).searchPseudoElementsFullScan === "boolean" ? "7.0.0" : "6.0.0";
var $a50446a11289d212$var$IS_VERSION_7_OR_LATER = Number.parseInt($a50446a11289d212$var$SVG_CORE_VERSION) >= 7;
var $a50446a11289d212$var$getIsVersion7OrLater = function() {
    return $a50446a11289d212$var$IS_VERSION_7_OR_LATER;
};
var $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX = "fa";
var $a50446a11289d212$var$ANIMATION_CLASSES = {
    beat: "fa-beat",
    fade: "fa-fade",
    beatFade: "fa-beat-fade",
    bounce: "fa-bounce",
    shake: "fa-shake",
    spin: "fa-spin",
    spinPulse: "fa-spin-pulse",
    spinReverse: "fa-spin-reverse",
    pulse: "fa-pulse",
    // the following animations are only supported in version 7.3.0 and later
    flip360: "fa-flip-360",
    buzz: "fa-buzz",
    float: "fa-float",
    jello: "fa-jello",
    spinSnap: "fa-spin-snap",
    spinSnap4: "fa-spin-snap-4",
    spinSnap8: "fa-spin-snap-8",
    swing: "fa-swing",
    wag: "fa-wag"
};
var $a50446a11289d212$var$PULL_CLASSES = {
    left: "fa-pull-left",
    right: "fa-pull-right"
};
var $a50446a11289d212$var$ROTATE_CLASSES = {
    "90": "fa-rotate-90",
    "180": "fa-rotate-180",
    "270": "fa-rotate-270"
};
var $a50446a11289d212$var$SIZE_CLASSES = {
    "2xs": "fa-2xs",
    xs: "fa-xs",
    sm: "fa-sm",
    lg: "fa-lg",
    xl: "fa-xl",
    "2xl": "fa-2xl",
    "1x": "fa-1x",
    "2x": "fa-2x",
    "3x": "fa-3x",
    "4x": "fa-4x",
    "5x": "fa-5x",
    "6x": "fa-6x",
    "7x": "fa-7x",
    "8x": "fa-8x",
    "9x": "fa-9x",
    "10x": "fa-10x"
};
var $a50446a11289d212$var$STYLE_CLASSES = {
    border: "fa-border",
    /** @deprecated */ fixedWidth: "fa-fw",
    flip: "fa-flip",
    flipHorizontal: "fa-flip-horizontal",
    flipVertical: "fa-flip-vertical",
    inverse: "fa-inverse",
    rotateBy: "fa-rotate-by",
    swapOpacity: "fa-swap-opacity",
    widthAuto: "fa-width-auto",
    // the following style classes are only supported in version 7.3.0 and later
    canvasSquare: "fa-canvas-square",
    canvasRoomy: "fa-canvas-roomy"
};
var $a50446a11289d212$var$LAYER_CLASSES = {
    default: "fa-layers"
};
// src/utils/get-class-list-from-props.ts
function $a50446a11289d212$var$withPrefix(cls) {
    var prefix = (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20).cssPrefix || (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20).familyPrefix || $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX;
    return prefix === $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX ? cls : cls.replace(new RegExp(String.raw($a50446a11289d212$var$_templateObject(), $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX), "g"), "".concat(prefix, "-"));
}
function $a50446a11289d212$var$getClassListFromProps(props) {
    var _result;
    var beat = props.beat, fade = props.fade, beatFade = props.beatFade, bounce = props.bounce, shake = props.shake, spin = props.spin, spinPulse = props.spinPulse, spinReverse = props.spinReverse, pulse = props.pulse, fixedWidth = props.fixedWidth, inverse = props.inverse, border = props.border, flip = props.flip, size = props.size, rotation = props.rotation, pull = props.pull, swapOpacity = props.swapOpacity, rotateBy = props.rotateBy, widthAuto = props.widthAuto, canvasSquare = props.canvasSquare, canvasRoomy = props.canvasRoomy, flip360 = props.flip360, buzz = props.buzz, float = props.float, jello = props.jello, spinSnap = props.spinSnap, spinSnap4 = props.spinSnap4, spinSnap8 = props.spinSnap8, swing = props.swing, wag = props.wag, className = props.className;
    var result = [];
    if (className) (_result = result).push.apply(_result, (0, $6zk1M._)(className.split(" ")));
    if (beat) result.push($a50446a11289d212$var$ANIMATION_CLASSES.beat);
    if (fade) result.push($a50446a11289d212$var$ANIMATION_CLASSES.fade);
    if (beatFade) result.push($a50446a11289d212$var$ANIMATION_CLASSES.beatFade);
    if (bounce) result.push($a50446a11289d212$var$ANIMATION_CLASSES.bounce);
    if (shake) result.push($a50446a11289d212$var$ANIMATION_CLASSES.shake);
    if (spin) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spin);
    if (spinReverse) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spinReverse);
    if (spinPulse) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spinPulse);
    if (pulse) result.push($a50446a11289d212$var$ANIMATION_CLASSES.pulse);
    if (fixedWidth) result.push($a50446a11289d212$var$STYLE_CLASSES.fixedWidth);
    if (inverse) result.push($a50446a11289d212$var$STYLE_CLASSES.inverse);
    if (border) result.push($a50446a11289d212$var$STYLE_CLASSES.border);
    if (flip === true) result.push($a50446a11289d212$var$STYLE_CLASSES.flip);
    if (flip === "horizontal" || flip === "both") result.push($a50446a11289d212$var$STYLE_CLASSES.flipHorizontal);
    if (flip === "vertical" || flip === "both") result.push($a50446a11289d212$var$STYLE_CLASSES.flipVertical);
    if (size !== void 0 && size !== null) result.push($a50446a11289d212$var$SIZE_CLASSES[size]);
    if (rotation !== void 0 && rotation !== null && rotation !== 0) result.push($a50446a11289d212$var$ROTATE_CLASSES[rotation]);
    if (pull !== void 0 && pull !== null) result.push($a50446a11289d212$var$PULL_CLASSES[pull]);
    if (swapOpacity) result.push($a50446a11289d212$var$STYLE_CLASSES.swapOpacity);
    if (!$a50446a11289d212$var$getIsVersion7OrLater()) return result;
    if (rotateBy) result.push($a50446a11289d212$var$STYLE_CLASSES.rotateBy);
    if (widthAuto) result.push($a50446a11289d212$var$STYLE_CLASSES.widthAuto);
    if (canvasSquare) result.push($a50446a11289d212$var$STYLE_CLASSES.canvasSquare);
    if (canvasRoomy) result.push($a50446a11289d212$var$STYLE_CLASSES.canvasRoomy);
    if (flip360) result.push($a50446a11289d212$var$ANIMATION_CLASSES.flip360);
    if (buzz) result.push($a50446a11289d212$var$ANIMATION_CLASSES.buzz);
    if (float) result.push($a50446a11289d212$var$ANIMATION_CLASSES.float);
    if (jello) result.push($a50446a11289d212$var$ANIMATION_CLASSES.jello);
    if (spinSnap) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spinSnap);
    if (spinSnap4) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spinSnap4);
    if (spinSnap8) result.push($a50446a11289d212$var$ANIMATION_CLASSES.spinSnap8);
    if (swing) result.push($a50446a11289d212$var$ANIMATION_CLASSES.swing);
    if (wag) result.push($a50446a11289d212$var$ANIMATION_CLASSES.wag);
    var prefix = (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20).cssPrefix || (0, $39c5346b7e5f0f6d$export$e506a1d27d1eaa20).familyPrefix || $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX;
    return prefix === $a50446a11289d212$var$DEFAULT_CLASSNAME_PREFIX ? result : // TODO: see if we can achieve custom prefix support without iterating
    // eslint-disable-next-line unicorn/no-array-callback-reference
    result.map($a50446a11289d212$var$withPrefix);
}
var $a50446a11289d212$var$isIconDefinition = function(icon) {
    return (typeof icon === "undefined" ? "undefined" : (0, $2bfPH._)(icon)) === "object" && "icon" in icon && !!icon.icon;
};
function $a50446a11289d212$var$normalizeIconArgs(icon) {
    if (!icon) return void 0;
    if ($a50446a11289d212$var$isIconDefinition(icon)) return icon;
    return (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).icon(icon);
}
// src/utils/typed-object-keys.ts
function $a50446a11289d212$var$typedObjectKeys(obj) {
    return Object.keys(obj);
}
// src/components/FontAwesomeIcon.tsx
var $a50446a11289d212$var$logger = new $a50446a11289d212$var$Logger("FontAwesomeIcon");
var $a50446a11289d212$var$DEFAULT_PROPS = {
    border: false,
    className: "",
    mask: void 0,
    maskId: void 0,
    fixedWidth: false,
    inverse: false,
    flip: false,
    icon: void 0,
    listItem: false,
    pull: void 0,
    pulse: false,
    rotation: void 0,
    rotateBy: false,
    size: void 0,
    spin: false,
    spinPulse: false,
    spinReverse: false,
    beat: false,
    fade: false,
    beatFade: false,
    bounce: false,
    shake: false,
    symbol: false,
    title: "",
    titleId: void 0,
    transform: void 0,
    swapOpacity: false,
    widthAuto: false,
    canvasSquare: false,
    canvasRoomy: false,
    flip360: false,
    buzz: false,
    float: false,
    jello: false,
    spinSnap: false,
    spinSnap4: false,
    spinSnap8: false,
    swing: false,
    wag: false
};
var $a50446a11289d212$var$DEFAULT_PROP_KEYS = new Set(Object.keys($a50446a11289d212$var$DEFAULT_PROPS));
var $a50446a11289d212$export$2b9260d4a45c8710 = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).forwardRef(function(props, ref) {
    var allProps = (0, $lvTkn._)({}, $a50446a11289d212$var$DEFAULT_PROPS, props);
    var iconArgs = allProps.icon, maskArgs = allProps.mask, symbol = allProps.symbol, title = allProps.title, titleIdFromProps = allProps.titleId, maskIdFromProps = allProps.maskId, transform = allProps.transform;
    var maskId = $a50446a11289d212$var$useAccessibilityId(maskIdFromProps, Boolean(maskArgs));
    var titleId = $a50446a11289d212$var$useAccessibilityId(titleIdFromProps, Boolean(title));
    var iconLookup = $a50446a11289d212$var$normalizeIconArgs(iconArgs);
    if (!iconLookup) {
        $a50446a11289d212$var$logger.error("Icon lookup is undefined", iconArgs);
        return null;
    }
    var classList = $a50446a11289d212$var$getClassListFromProps(allProps);
    var transformProps = typeof transform === "string" ? (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).transform(transform) : transform;
    var normalizedMaskArgs = $a50446a11289d212$var$normalizeIconArgs(maskArgs);
    var renderedIcon = (0, $39c5346b7e5f0f6d$export$1ca1ec8b29a4ce27)(iconLookup, (0, $9Jpjh._)((0, $lvTkn._)({}, classList.length > 0 && {
        classes: classList
    }, transformProps && {
        transform: transformProps
    }, normalizedMaskArgs && {
        mask: normalizedMaskArgs
    }), {
        symbol: symbol,
        title: title,
        titleId: titleId,
        maskId: maskId
    }));
    if (!renderedIcon) {
        $a50446a11289d212$var$logger.error("Could not find icon", iconLookup);
        return null;
    }
    var abstract = renderedIcon.abstract;
    var extraProps = {
        ref: ref
    };
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        for(var _iterator = $a50446a11289d212$var$typedObjectKeys(allProps)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
            var key = _step.value;
            if ($a50446a11289d212$var$DEFAULT_PROP_KEYS.has(key)) continue;
            extraProps[key] = allProps[key];
        }
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return $a50446a11289d212$var$makeReactConverter(abstract[0], extraProps);
});
$a50446a11289d212$export$2b9260d4a45c8710.displayName = "FontAwesomeIcon";
var $a50446a11289d212$var$DEFAULT_CLASSNAMES = "".concat($a50446a11289d212$var$LAYER_CLASSES.default, " ").concat($a50446a11289d212$var$STYLE_CLASSES.fixedWidth);
var $a50446a11289d212$export$9ef6be9fed098e07 = function(_param) {
    var children = _param.children, className = _param.className, size = _param.size, attributes = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "children",
        "className",
        "size"
    ]);
    var prefixedDefaultClasses = $a50446a11289d212$var$withPrefix($a50446a11289d212$var$DEFAULT_CLASSNAMES);
    var classes = className ? "".concat(prefixedDefaultClasses, " ").concat(className) : prefixedDefaultClasses;
    var element = /* @__PURE__ */ (0, $f171543c027e46e7$exports.jsx)("span", (0, $9Jpjh._)((0, $lvTkn._)({}, attributes), {
        className: classes,
        children: children
    }));
    if (size) return /* @__PURE__ */ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: $a50446a11289d212$var$withPrefix("fa-".concat(size)),
        children: element
    });
    return element;
};
var $a50446a11289d212$export$1ff69b5f8cc6202a = function(_param) {
    var text$1 = _param.text, className = _param.className, inverse = _param.inverse, transform = _param.transform, style = _param.style, attributes = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "text",
        "className",
        "inverse",
        "transform",
        "style"
    ]);
    var textAbstractElement = (0, $eHaBZ.useMemo)(function() {
        var textObject = (0, $39c5346b7e5f0f6d$export$6f093cfa640b7166)(text$1, {
            classes: (0, $6zk1M._)((className === null || className === void 0 ? void 0 : className.split(" ")) || []).concat((0, $6zk1M._)(inverse ? [
                $a50446a11289d212$var$STYLE_CLASSES.inverse
            ] : [])),
            transform: typeof transform === "string" ? (0, $39c5346b7e5f0f6d$export$98e6a39c04603d36).transform(transform) : transform
        });
        return textObject.abstract[0];
    }, [
        text$1,
        transform,
        className,
        inverse
    ]);
    return $a50446a11289d212$var$makeReactConverter(textAbstractElement, (0, $9Jpjh._)((0, $lvTkn._)({}, attributes), {
        style: style
    }));
};
var $a50446a11289d212$export$aa94eec7b7fb6e02 = function(_param) {
    var count = _param.count, className = _param.className, style = _param.style, attributes = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "count",
        "className",
        "style"
    ]);
    var counterAbstractElement = (0, $eHaBZ.useMemo)(function() {
        return (0, $39c5346b7e5f0f6d$export$e575061ef2a070eb)(count, {
            classes: className === null || className === void 0 ? void 0 : className.split(" ")
        }).abstract[0];
    }, [
        count,
        className
    ]);
    return $a50446a11289d212$var$makeReactConverter(counterAbstractElement, (0, $9Jpjh._)((0, $lvTkn._)({}, attributes), {
        style: style
    }));
};



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");
var $8929b96d30942b2d$var$w = "collapsed", $8929b96d30942b2d$var$p = "collapsing", $8929b96d30942b2d$var$r = "expanding", $8929b96d30942b2d$var$a = "expanded", $8929b96d30942b2d$var$K = "collapse-css-transition", $8929b96d30942b2d$var$M = "div", $8929b96d30942b2d$var$Q = "0px";
function $8929b96d30942b2d$var$N(o) {
    requestAnimationFrame(function() {
        requestAnimationFrame(o);
    });
}
var $8929b96d30942b2d$export$78768a9af065a7b = function(_param) {
    var C = function C() {
        i.current && (e.collapse = $8929b96d30942b2d$var$w, e.style = {
            height: s,
            visibility: m()
        }, u(), setTimeout(function() {
            return l(Date.now);
        }, 0));
    };
    var $ = function $() {
        if (i.current) {
            if (h) return C();
            e.collapse = $8929b96d30942b2d$var$p, e.style = {
                height: x(),
                visibility: void 0
            }, u(), $8929b96d30942b2d$var$N(function() {
                i.current && e.collapse === $8929b96d30942b2d$var$p && (e.style = {
                    height: s,
                    visibility: void 0
                }, l(Date.now));
            });
        }
    };
    var q = function q() {
        if (i.current) {
            if (h) return E();
            e.collapse = $8929b96d30942b2d$var$r, $8929b96d30942b2d$var$N(function() {
                i.current && e.collapse === $8929b96d30942b2d$var$r && (e.style = {
                    height: x(),
                    visibility: void 0
                }, l(Date.now));
            });
        }
    };
    var E = function E() {
        i.current && (e.collapse = $8929b96d30942b2d$var$a, e.style = {
            height: void 0,
            visibility: void 0
        }, u(), setTimeout(function() {
            return l(Date.now);
        }, 0));
    };
    var x = function x() {
        return "".concat(i.current.scrollHeight, "px");
    };
    var G = function G(param) {
        var t = param.target, f = param.propertyName;
        if (t === i.current && f === "height") {
            var c = t.style.height;
            switch(e.collapse){
                case $8929b96d30942b2d$var$r:
                    c === void 0 || c === s || E();
                    break;
                case $8929b96d30942b2d$var$p:
                    c === void 0 || c !== s || C();
                    break;
            }
        }
    };
    var o = _param.children, T = _param.transition, A = _param.style, d = _param.render, tmp = _param.elementType, y = tmp === void 0 ? $8929b96d30942b2d$var$M : tmp, n = _param.isOpen, tmp1 = _param.collapseHeight, s = tmp1 === void 0 ? $8929b96d30942b2d$var$Q : tmp1, L = _param.onInit, P = _param.onChange, tmp2 = _param.className, v = tmp2 === void 0 ? $8929b96d30942b2d$var$K : tmp2, R = _param.addState, h = _param.noAnim, S = _param.overflowOnExpanded, F = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "children",
        "transition",
        "style",
        "render",
        "elementType",
        "isOpen",
        "collapseHeight",
        "onInit",
        "onChange",
        "className",
        "addState",
        "noAnim",
        "overflowOnExpanded"
    ]);
    var m = function() {
        return s === "0px" ? "hidden" : void 0;
    }, _$_ = (0, $21h22._)((0, $eHaBZ.useReducer)(function(t) {
        return t + 1;
    }, 0), 2), W = _$_[0], u = _$_[1], i = (0, $eHaBZ.useRef)(), _z = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), b = _z[0], l = _z[1], e = (0, $eHaBZ.useRef)({
        collapse: n ? $8929b96d30942b2d$var$a : $8929b96d30942b2d$var$w,
        style: {
            height: n ? void 0 : s,
            visibility: n ? void 0 : m()
        }
    }).current;
    (0, $eHaBZ.useEffect)(function() {
        b && g(P);
    }, [
        b
    ]);
    var g = function(t) {
        var f = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
        t && t((0, $lvTkn._)({
            state: e.collapse,
            style: e.style
        }, f));
    };
    var k = e.collapse === $8929b96d30942b2d$var$a || e.collapse === $8929b96d30942b2d$var$r;
    !k && n && q(), k && !n && $();
    var I = (0, $lvTkn._)({
        overflow: e.collapse === $8929b96d30942b2d$var$a && S ? void 0 : "hidden",
        transition: T
    }, A, e.style), X = y, j = (0, $eHaBZ.useCallback)(function(t) {
        t && (i.current = t, g(L, {
            node: t
        }));
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        y
    ]), U = R ? "".concat(v, " --c-").concat(e.collapse) : v;
    return(// @ts-ignore
    /* @__PURE__ */ (0, $f171543c027e46e7$exports.jsx)(X, (0, $9Jpjh._)((0, $lvTkn._)({
        ref: j,
        style: I,
        onTransitionEnd: G,
        className: U
    }, F), {
        children: typeof o == "function" ? o(e.collapse) : typeof d == "function" ? d(e.collapse) : o
    })));
};


var $c31009cc66f4e9b8$exports = {};

var $2bfPH = parcelRequire("2bfPH");
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if ((typeof arg === "undefined" ? "undefined" : (0, $2bfPH._)(arg)) !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($c31009cc66f4e9b8$exports) {
        classNames.default = classNames;
        $c31009cc66f4e9b8$exports = classNames;
    } else if (typeof define === 'function' && (0, $2bfPH._)(define.amd) === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();





var $21h22 = parcelRequire("21h22");



var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");


var $3cd9a930e9e44820$export$5300a9e19ff2767e = /*#__PURE__*/ function() {
    "use strict";
    function TypedFormData(initElement) {
        (0, $gd0sY._)(this, TypedFormData);
        this.formData = new FormData();
        if (!initElement) return;
        if (initElement instanceof FormData) {
            this.formData = initElement;
            return;
        }
        this.formData = new FormData(initElement);
    }
    (0, $7cSld._)(TypedFormData, [
        {
            key: "get",
            value: function get(key) {
                return this.formData.get(key);
            }
        },
        {
            key: "getAll",
            value: function getAll(key) {
                return this.formData.getAll(key);
            }
        },
        {
            /**
     * Executes a provided function once for each key/value pair in the FormData object.
     * @deprecated This method is deprecated and is not advised to be used. Use entries() or for...of loop instead.
     * @param callbackfn A function that is called for each key/value pair in the FormData object.
     * @param thisArg An object to which the this keyword can refer in the callbackfn function. If thisArg is omitted, undefined is used as the this value.
     */ key: "forEach",
            value: function forEach(callbackfn, // eslint-disable-next-line @typescript-eslint/no-explicit-any
            thisArg) {
                this.formData.forEach(callbackfn, thisArg);
            }
        },
        {
            key: "getFormData",
            value: function getFormData() {
                return this.formData;
            }
        },
        {
            key: "getObject",
            value: function getObject() {
                return Object.fromEntries(this.entries());
            }
        },
        {
            key: "entries",
            value: function entries() {
                return this.formData.entries();
            }
        },
        {
            key: "typedEntries",
            value: function typedEntries() {
                return this.entries();
            }
        },
        {
            key: "keys",
            value: function keys() {
                return this.formData.keys();
            }
        },
        {
            key: "values",
            value: function values() {
                return this.formData.values();
            }
        },
        {
            key: "set",
            value: function set(key, value, filename) {
                if (typeof value === "string") this.formData.set(key, value);
                else this.formData.set(key, value, filename);
            }
        },
        {
            key: "append",
            value: function append(key, value, filename) {
                if (typeof value === "string") this.formData.append(key, value);
                else this.formData.append(key, value, filename);
            }
        },
        {
            key: "has",
            value: function has(key) {
                return this.formData.has(key);
            }
        },
        {
            key: "delete",
            value: function _delete(key) {
                this.formData.delete(key);
            }
        },
        {
            key: Symbol.iterator,
            value: function value() {
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            return [
                                5,
                                (0, $72417d7cbfd779fc$export$19a8beecd37a4c45)(this.entries())
                            ];
                        case 1:
                            _state.sent();
                            return [
                                2
                            ];
                    }
                });
            }
        }
    ]);
    return TypedFormData;
}();




var $a19a4c792383bb34$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $a19a4c792383bb34$export$bd735ad4938c7be8(request) {
    return $a19a4c792383bb34$var$__awaiter(this, void 0, void 0, function() {
        var formData;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        request.formData()
                    ];
                case 1:
                    formData = _state.sent();
                    return [
                        2,
                        new (0, $3cd9a930e9e44820$export$5300a9e19ff2767e)(formData)
                    ];
            }
        });
    });
}
function $a19a4c792383bb34$export$ae2b2db16f8c0171(formData) {
    return new (0, $3cd9a930e9e44820$export$5300a9e19ff2767e)(formData);
}





var $eHaBZ = parcelRequire("eHaBZ");



function $8c215e0b3d175d5e$export$2e2bcd8739ae039(props) {
    var setTitle = props.setTitle;
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var _useActionState = (0, $21h22._)((0, $eHaBZ.useActionState)(function(_previousState, formData) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var password, hashedPassword, error;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        _state.trys.push([
                            0,
                            2,
                            ,
                            3
                        ]);
                        password = formData.get('password').trim();
                        return [
                            4,
                            (0, $4f5da2ef0a8f061c$export$708be5cd94908894)(password)
                        ];
                    case 1:
                        hashedPassword = _state.sent();
                        return [
                            2,
                            {
                                hashedPassword: hashedPassword
                            }
                        ];
                    case 2:
                        error = _state.sent();
                        if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                            navigate('/sign/in', {
                                state: {
                                    error: "Generating a new password hash requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                                    returnLocation: '/password'
                                }
                            });
                            return [
                                2,
                                {}
                            ];
                        }
                        return [
                            2,
                            {
                                error: error
                            }
                        ];
                    case 3:
                        return [
                            2
                        ];
                }
            });
        })();
    }, {}), 3), state = _useActionState[0], submitAction = _useActionState[1], isPending = _useActionState[2];
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        // Unlike `action` prop, `onSubmit` avoids clearing the form on submit.
        // https://github.com/facebook/react/issues/29034#issuecomment-2143595195
        event.preventDefault();
        var formData = new (0, $3cd9a930e9e44820$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $eHaBZ.startTransition)(function() {
            return submitAction(formData);
        });
    }, [
        submitAction
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle('selfoss password hash generator');
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var message = isPending ? null : 'hashedPassword' in state ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        className: "error",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
            children: [
                "Generated Password (insert this into config.ini):",
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                    type: "text",
                    value: state.hashedPassword,
                    readOnly: true
                })
            ]
        })
    }) : 'error' in state ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
        className: "error",
        children: [
            "Unexpected happened.",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("pre", {
                    children: [
                        "$",
                        JSON.stringify(state.error)
                    ]
                })
            })
        ]
    }) : null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "login",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "hash generator"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "password",
                            children: "Password:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "password",
                            name: "password",
                            autoComplete: "new-password",
                            accessKey: "p"
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: message
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            className: "button",
                            type: "submit",
                            value: isPending ? "Hashing password\u2026" : 'Compute hash',
                            accessKey: "g",
                            disabled: isPending
                        })
                    ]
                })
            ]
        })
    });
}




var $21h22 = parcelRequire("21h22");




var $eHaBZ = parcelRequire("eHaBZ");


var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $6zk1M = parcelRequire("6zk1M");

var $2bfPH = parcelRequire("2bfPH");

// src/hooks/useIsomorphicEffect.ts

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");

var $eHaBZ = parcelRequire("eHaBZ");
var $e146ef819c676a18$export$363c9f3eb56bbdbe = typeof window === "undefined" ? (0, $eHaBZ.useEffect) : (0, $eHaBZ.useLayoutEffect);
function $e146ef819c676a18$export$38e1734badfda8d9(value) {
    var preferLayoutEffect = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var useEffectToUse = preferLayoutEffect ? $e146ef819c676a18$export$363c9f3eb56bbdbe : (0, $eHaBZ.useEffect);
    var ref = (0, $eHaBZ.useRef)(value);
    useEffectToUse(function() {
        ref.current = value;
    });
    return ref;
}
function $e146ef819c676a18$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $e146ef819c676a18$export$ebc1e1560c2dffa5(refA, refB) {
    return (0, $eHaBZ.useMemo)(function() {
        if (refA === null && refB === null) return null;
        return function(refValue) {
            $e146ef819c676a18$var$setRef(refA, refValue);
            $e146ef819c676a18$var$setRef(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $e146ef819c676a18$var$isEventLike(error) {
    return error instanceof Event || error instanceof Error;
}
function $e146ef819c676a18$export$e38c76da774a8077(channelName, options) {
    var _ref = options || {}, onMessage = _ref.onMessage, onError = _ref.onError;
    var isSupported = (0, $eHaBZ.useMemo)(function() {
        return typeof window !== "undefined" && typeof BroadcastChannel !== "undefined";
    }, []);
    var channelRef = (0, $eHaBZ.useRef)(null);
    var stableOnMessage = (0, $eHaBZ.useCallback)(function(event) {
        if (onMessage) onMessage(event.data);
    }, [
        onMessage
    ]);
    var stableOnError = (0, $eHaBZ.useCallback)(function(event) {
        if (onError) onError(event);
    }, [
        onError
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isSupported) return;
        try {
            var channel = new BroadcastChannel(channelName);
            channelRef.current = channel;
            channel.addEventListener("message", stableOnMessage);
            channel.addEventListener("messageerror", stableOnError);
            return function() {
                channel.removeEventListener("message", stableOnMessage);
                channel.removeEventListener("messageerror", stableOnError);
                channel.close();
                channelRef.current = null;
            };
        } catch (error) {
            if (onError && $e146ef819c676a18$var$isEventLike(error)) onError(error);
        }
    }, [
        channelName,
        isSupported,
        stableOnMessage,
        stableOnError,
        onError
    ]);
    var postMessage = (0, $eHaBZ.useCallback)(function(data) {
        if (!isSupported) {
            console.warn("useBroadcastChannel: BroadcastChannel API is not supported");
            return;
        }
        if (!channelRef.current) {
            console.warn("useBroadcastChannel: Channel is not initialized");
            return;
        }
        try {
            channelRef.current.postMessage(data);
        } catch (error) {
            console.error("useBroadcastChannel: Failed to post message", error);
            if (onError && $e146ef819c676a18$var$isEventLike(error)) onError(error);
        }
    }, [
        isSupported,
        onError
    ]);
    var close = (0, $eHaBZ.useCallback)(function() {
        if (channelRef.current) {
            channelRef.current.close();
            channelRef.current = null;
        }
    }, []);
    return {
        postMessage: postMessage,
        close: close,
        isSupported: isSupported
    };
}
// src/utils/eventTarget.ts
function $e146ef819c676a18$var$isRefObject(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) === "object" && value !== null && "current" in value && !("addEventListener" in value);
}
function $e146ef819c676a18$export$e83fa2d056381696(target) {
    if (!target) return null;
    if ($e146ef819c676a18$var$isRefObject(target)) return target.current;
    return target;
}
// src/hooks/useEventListener.ts
function $e146ef819c676a18$export$7080b3e976bc91ab(eventName, callback, options) {
    var target = options.target, _options_listenerOptions = options.listenerOptions, listenerOptions = _options_listenerOptions === void 0 ? {} : _options_listenerOptions, _options_when = options.when, when = _options_when === void 0 ? true : _options_when, _options_isLayoutEffect = options.isLayoutEffect, isLayoutEffect = _options_isLayoutEffect === void 0 ? false : _options_isLayoutEffect;
    var callbackRef = $e146ef819c676a18$export$38e1734badfda8d9(callback, true);
    var subscriptionRef = (0, $eHaBZ.useRef)(null);
    var capture = typeof listenerOptions === "boolean" ? listenerOptions : listenerOptions.capture;
    var once = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.once;
    var passive = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.passive;
    var signal = typeof listenerOptions === "boolean" ? void 0 : listenerOptions.signal;
    var listener = (0, $eHaBZ.useCallback)(function(event) {
        callbackRef.current(event);
    }, [
        callbackRef
    ]);
    var detach = (0, $eHaBZ.useCallback)(function() {
        var subscription = subscriptionRef.current;
        if (!subscription) return;
        subscription.target.removeEventListener(subscription.eventName, subscription.listener, subscription.listenerOptions);
        subscriptionRef.current = null;
    }, []);
    var synchronize = function() {
        var resolvedTarget = $e146ef819c676a18$export$e83fa2d056381696(target);
        var subscription = subscriptionRef.current;
        var isCurrent = (subscription === null || subscription === void 0 ? void 0 : subscription.target) === resolvedTarget && subscription.eventName === eventName && subscription.listener === listener && subscription.capture === capture && subscription.once === once && subscription.passive === passive && subscription.signal === signal && subscription.isLayoutEffect === isLayoutEffect;
        if (!when || !resolvedTarget) {
            detach();
            return;
        }
        if (isCurrent) return;
        detach();
        resolvedTarget.addEventListener(eventName, listener, listenerOptions);
        subscriptionRef.current = {
            target: resolvedTarget,
            eventName: eventName,
            listener: listener,
            listenerOptions: listenerOptions,
            capture: capture,
            once: once,
            passive: passive,
            signal: signal,
            isLayoutEffect: isLayoutEffect
        };
    };
    $e146ef819c676a18$export$363c9f3eb56bbdbe(function() {
        if (isLayoutEffect) synchronize();
    });
    (0, $eHaBZ.useEffect)(function() {
        if (!isLayoutEffect) synchronize();
    });
    $e146ef819c676a18$export$363c9f3eb56bbdbe(function() {
        return function() {
            detach();
        };
    }, [
        detach
    ]);
}
function $e146ef819c676a18$export$231305e360fbdfeb() {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), refElement = _useState[0], setRefElement = _useState[1];
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        setRefElement(element);
    }, []);
    return [
        ref,
        refElement
    ];
}
// src/utils/noop.ts
var $e146ef819c676a18$export$8793edee2d425525 = function() {};
// src/utils/doesIdentifierMatchKeyboardEvent.ts
var $e146ef819c676a18$export$8f5885e0a893ee67 = function(error, identifier) {
    if (error.key === identifier || error.code === identifier || error.keyCode === identifier || error.which === identifier || error.charCode === identifier) return true;
    return false;
};



var $eHaBZ = parcelRequire("eHaBZ");
var $cce1e94b03780a93$exports = {};
var $d93c1fbfc9073e05$exports = {};
// Generated by CoffeeScript 1.12.2
(function() {
    var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;
    if (typeof performance !== "undefined" && performance !== null && performance.now) $d93c1fbfc9073e05$exports = function() {
        return performance.now();
    };
    else if (Date.now) {
        $d93c1fbfc9073e05$exports = function() {
            return Date.now() - loadTime;
        };
        loadTime = Date.now();
    } else {
        $d93c1fbfc9073e05$exports = function() {
            return new Date().getTime() - loadTime;
        };
        loadTime = new Date().getTime();
    }
}).call($d93c1fbfc9073e05$exports);


var $cce1e94b03780a93$var$root = typeof window === 'undefined' ? $parcel$global : window, $cce1e94b03780a93$var$vendors = [
    'moz',
    'webkit'
], $cce1e94b03780a93$var$suffix = 'AnimationFrame', $cce1e94b03780a93$var$raf = $cce1e94b03780a93$var$root['request' + $cce1e94b03780a93$var$suffix], $cce1e94b03780a93$var$caf = $cce1e94b03780a93$var$root['cancel' + $cce1e94b03780a93$var$suffix] || $cce1e94b03780a93$var$root['cancelRequest' + $cce1e94b03780a93$var$suffix];
for(var $cce1e94b03780a93$var$i = 0; !$cce1e94b03780a93$var$raf && $cce1e94b03780a93$var$i < $cce1e94b03780a93$var$vendors.length; $cce1e94b03780a93$var$i++){
    $cce1e94b03780a93$var$raf = $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'Request' + $cce1e94b03780a93$var$suffix];
    $cce1e94b03780a93$var$caf = $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'Cancel' + $cce1e94b03780a93$var$suffix] || $cce1e94b03780a93$var$root[$cce1e94b03780a93$var$vendors[$cce1e94b03780a93$var$i] + 'CancelRequest' + $cce1e94b03780a93$var$suffix];
}
// Some versions of FF have rAF but not cAF
if (!$cce1e94b03780a93$var$raf || !$cce1e94b03780a93$var$caf) {
    var $cce1e94b03780a93$var$last = 0, $cce1e94b03780a93$var$id = 0, $cce1e94b03780a93$var$queue = [], $cce1e94b03780a93$var$frameDuration = 1000 / 60;
    $cce1e94b03780a93$var$raf = function raf(callback) {
        if ($cce1e94b03780a93$var$queue.length === 0) {
            var _now = $d93c1fbfc9073e05$exports(), next = Math.max(0, $cce1e94b03780a93$var$frameDuration - (_now - $cce1e94b03780a93$var$last));
            $cce1e94b03780a93$var$last = next + _now;
            setTimeout(function() {
                var cp = $cce1e94b03780a93$var$queue.slice(0);
                // Clear queue here to prevent
                // callbacks from appending listeners
                // to the current frame's queue
                $cce1e94b03780a93$var$queue.length = 0;
                for(var i = 0; i < cp.length; i++){
                    if (!cp[i].cancelled) try {
                        cp[i].callback($cce1e94b03780a93$var$last);
                    } catch (e) {
                        setTimeout(function() {
                            throw e;
                        }, 0);
                    }
                }
            }, Math.round(next));
        }
        $cce1e94b03780a93$var$queue.push({
            handle: ++$cce1e94b03780a93$var$id,
            callback: callback,
            cancelled: false
        });
        return $cce1e94b03780a93$var$id;
    };
    $cce1e94b03780a93$var$caf = function caf(handle) {
        for(var i = 0; i < $cce1e94b03780a93$var$queue.length; i++)if ($cce1e94b03780a93$var$queue[i].handle === handle) $cce1e94b03780a93$var$queue[i].cancelled = true;
    };
}
$cce1e94b03780a93$exports = function(fn) {
    // Wrap in a new function to prevent
    // `cancel` potentially being assigned
    // to the native rAF function
    return $cce1e94b03780a93$var$raf.call($cce1e94b03780a93$var$root, fn);
};
$cce1e94b03780a93$exports.cancel = function() {
    $cce1e94b03780a93$var$caf.apply($cce1e94b03780a93$var$root, arguments);
};
$cce1e94b03780a93$exports.polyfill = function(object) {
    if (!object) object = $cce1e94b03780a93$var$root;
    object.requestAnimationFrame = $cce1e94b03780a93$var$raf;
    object.cancelAnimationFrame = $cce1e94b03780a93$var$caf;
};


var $2ba76da8a3028b95$exports = {};
/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */ /** Used as the `TypeError` message for "Functions" methods. */ 
var $2bfPH = parcelRequire("2bfPH");
var $2ba76da8a3028b95$var$FUNC_ERROR_TEXT = 'Expected a function';
/** Used as references for various `Number` constants. */ var $2ba76da8a3028b95$var$NAN = 0 / 0;
/** `Object#toString` result references. */ var $2ba76da8a3028b95$var$symbolTag = '[object Symbol]';
/** Used to match leading and trailing whitespace. */ var $2ba76da8a3028b95$var$reTrim = /^\s+|\s+$/g;
/** Used to detect bad signed hexadecimal string values. */ var $2ba76da8a3028b95$var$reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
/** Used to detect binary string values. */ var $2ba76da8a3028b95$var$reIsBinary = /^0b[01]+$/i;
/** Used to detect octal string values. */ var $2ba76da8a3028b95$var$reIsOctal = /^0o[0-7]+$/i;
/** Built-in method references without a dependency on `root`. */ var $2ba76da8a3028b95$var$freeParseInt = parseInt;
/** Detect free variable `global` from Node.js. */ var $2ba76da8a3028b95$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
/** Detect free variable `self`. */ var $2ba76da8a3028b95$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $2ba76da8a3028b95$var$root = $2ba76da8a3028b95$var$freeGlobal || $2ba76da8a3028b95$var$freeSelf || Function('return this')();
/** Used for built-in method references. */ var $2ba76da8a3028b95$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $2ba76da8a3028b95$var$objectToString = $2ba76da8a3028b95$var$objectProto.toString;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $2ba76da8a3028b95$var$nativeMax = Math.max, $2ba76da8a3028b95$var$nativeMin = Math.min;
/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */ var $2ba76da8a3028b95$var$now = function now() {
    return $2ba76da8a3028b95$var$root.Date.now();
};
/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */ function $2ba76da8a3028b95$var$debounce(func, wait, options) {
    var lastArgs, lastThis, maxWait, result, timerId, lastCallTime, lastInvokeTime = 0, leading = false, maxing = false, trailing = true;
    if (typeof func != 'function') throw new TypeError($2ba76da8a3028b95$var$FUNC_ERROR_TEXT);
    wait = $2ba76da8a3028b95$var$toNumber(wait) || 0;
    if ($2ba76da8a3028b95$var$isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? $2ba76da8a3028b95$var$nativeMax($2ba76da8a3028b95$var$toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
    }
    function invokeFunc(time) {
        var args = lastArgs, thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
    }
    function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
    }
    function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime, result = wait - timeSinceLastCall;
        return maxing ? $2ba76da8a3028b95$var$nativeMin(result, maxWait - timeSinceLastInvoke) : result;
    }
    function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime, timeSinceLastInvoke = time - lastInvokeTime;
        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
    }
    function timerExpired() {
        var time = $2ba76da8a3028b95$var$now();
        if (shouldInvoke(time)) return trailingEdge(time);
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
    }
    function trailingEdge(time) {
        timerId = undefined;
        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) return invokeFunc(time);
        lastArgs = lastThis = undefined;
        return result;
    }
    function cancel() {
        if (timerId !== undefined) clearTimeout(timerId);
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
    }
    function flush() {
        return timerId === undefined ? result : trailingEdge($2ba76da8a3028b95$var$now());
    }
    function debounced() {
        var time = $2ba76da8a3028b95$var$now(), isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
            if (timerId === undefined) return leadingEdge(lastCallTime);
            if (maxing) {
                // Handle invocations in a tight loop.
                timerId = setTimeout(timerExpired, wait);
                return invokeFunc(lastCallTime);
            }
        }
        if (timerId === undefined) timerId = setTimeout(timerExpired, wait);
        return result;
    }
    debounced.cancel = cancel;
    debounced.flush = flush;
    return debounced;
}
/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ function $2ba76da8a3028b95$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return !!value && (type == 'object' || type == 'function');
}
/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ function $2ba76da8a3028b95$var$isObjectLike(value) {
    return !!value && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'object';
}
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $2ba76da8a3028b95$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'symbol' || $2ba76da8a3028b95$var$isObjectLike(value) && $2ba76da8a3028b95$var$objectToString.call(value) == $2ba76da8a3028b95$var$symbolTag;
}
/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */ function $2ba76da8a3028b95$var$toNumber(value) {
    if (typeof value == 'number') return value;
    if ($2ba76da8a3028b95$var$isSymbol(value)) return $2ba76da8a3028b95$var$NAN;
    if ($2ba76da8a3028b95$var$isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = $2ba76da8a3028b95$var$isObject(other) ? other + '' : other;
    }
    if (typeof value != 'string') return value === 0 ? value : +value;
    value = value.replace($2ba76da8a3028b95$var$reTrim, '');
    var isBinary = $2ba76da8a3028b95$var$reIsBinary.test(value);
    return isBinary || $2ba76da8a3028b95$var$reIsOctal.test(value) ? $2ba76da8a3028b95$var$freeParseInt(value.slice(2), isBinary ? 2 : 8) : $2ba76da8a3028b95$var$reIsBadHex.test(value) ? $2ba76da8a3028b95$var$NAN : +value;
}
$2ba76da8a3028b95$exports = $2ba76da8a3028b95$var$debounce;


var $20cb340d6b373ba4$exports = {};

var $2bfPH = parcelRequire("2bfPH");
'use strict';
// do not edit .js files directly - edit src/index.jst
$20cb340d6b373ba4$exports = function equal(a, b) {
    if (a === b) return true;
    if (a && b && (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) == 'object' && (typeof b === "undefined" ? "undefined" : (0, $2bfPH._)(b)) == 'object') {
        if (a.constructor !== b.constructor) return false;
        var length, i, keys;
        if (Array.isArray(a)) {
            length = a.length;
            if (length != b.length) return false;
            for(i = length; i-- !== 0;)if (!equal(a[i], b[i])) return false;
            return true;
        }
        if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
        if (a.valueOf !== Object.prototype.valueOf) return a.valueOf() === b.valueOf();
        if (a.toString !== Object.prototype.toString) return a.toString() === b.toString();
        keys = Object.keys(a);
        length = keys.length;
        if (length !== Object.keys(b).length) return false;
        for(i = length; i-- !== 0;)if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
        for(i = length; i-- !== 0;){
            var key = keys[i];
            if (!equal(a[key], b[key])) return false;
        }
        return true;
    }
    // true if both NaN, false otherwise
    return a !== a && b !== b;
};


var $2065ab085cb8cea8$exports = {};
'use strict';

$2065ab085cb8cea8$exports = (parcelRequire("7XifO"));


function $c020e53fc27b31fb$export$b3553245f2c17524(callback) {
    var freshRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(callback);
    var tick = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshRef;
        return (_freshRef = freshRef).current.apply(_freshRef, (0, $6zk1M._)(args));
    }, [
        freshRef
    ]);
    return tick;
}
function $c020e53fc27b31fb$export$6d974d04a2e6dd6e(callback) {
    var timeoutDelayMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, key = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            var internalCallback2 = function internalCallback2() {
                freshCallback();
            };
            var internalCallback = internalCallback2;
            if (typeof window !== "undefined") {
                var timeout = window.setTimeout(internalCallback2, timeoutDelayMs);
                return function() {
                    window.clearTimeout(timeout);
                };
            } else console.warn("useTimeoutWhen: window is undefined.");
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        timeoutDelayMs,
        when,
        key,
        freshCallback
    ]);
}
// src/hooks/useOnLongHover.ts
var $c020e53fc27b31fb$export$fb63347121d3339d = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState[0], setTargetNode = _useState[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isHovering = _useState1[0], setIsHovering = _useState1[1];
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        freshCallback();
    }, duration, isHovering);
    var start = (0, $eHaBZ.useCallback)(function() {
        setIsHovering(true);
    }, []);
    var handleOnMouseLeave = (0, $eHaBZ.useCallback)(function(_) {
        setIsHovering(false);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("mouseenter", start);
            targetNode.addEventListener("mouseleave", handleOnMouseLeave);
        }
        return function() {
            if (targetNode) {
                targetNode.removeEventListener("mouseenter", start);
                targetNode.removeEventListener("mouseleave", handleOnMouseLeave);
            }
        };
    }, [
        start,
        handleOnMouseLeave,
        targetNode
    ]);
    return ref;
};
var $c020e53fc27b31fb$var$defaultOnClick = function() {};
var $c020e53fc27b31fb$export$2efba5bd220821d1 = function(callback) {
    var _ref = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, onClick = _ref.onClick, _ref_duration = _ref.duration, duration = _ref_duration === void 0 ? 300 : _ref_duration;
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState2[0], setTargetNode = _useState2[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState21 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPressing = _useState21[0], setIsPressing = _useState21[1];
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(callback);
    var freshClick = $c020e53fc27b31fb$export$b3553245f2c17524(onClick !== null && onClick !== void 0 ? onClick : $c020e53fc27b31fb$var$defaultOnClick);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(freshCallback, duration, isPressing);
    var start = (0, $eHaBZ.useCallback)(function(_) {
        setIsPressing(true);
    }, []);
    var handleOnClick = (0, $eHaBZ.useCallback)(function(event) {
        setIsPressing(false);
        freshClick(event);
    }, [
        freshClick
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("mousedown", start);
            targetNode.addEventListener("mouseup", handleOnClick);
            targetNode.addEventListener("mouseleave", handleOnClick);
            targetNode.addEventListener("touchstart", start);
            targetNode.addEventListener("touchend", handleOnClick);
            targetNode.addEventListener("touchcancel", handleOnClick);
        }
        return function() {
            if (targetNode) {
                targetNode.removeEventListener("mousedown", start);
                targetNode.removeEventListener("mouseup", handleOnClick);
                targetNode.removeEventListener("mouseleave", handleOnClick);
                targetNode.removeEventListener("touchstart", start);
                targetNode.removeEventListener("touchend", handleOnClick);
                targetNode.removeEventListener("touchcancel", handleOnClick);
            }
        };
    }, [
        start,
        handleOnClick,
        targetNode
    ]);
    return ref;
};
function $c020e53fc27b31fb$export$a1e544cd5fbfa31(initialValue) {
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), map = _useState3[0], setMap = _useState3[1];
    var set = (0, $eHaBZ.useCallback)(function(key, value) {
        setMap(function(currentMap) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, currentMap), (0, $khBmn._)({}, key, value));
        });
    }, []);
    var has = (0, $eHaBZ.useCallback)(function(key) {
        return typeof map[key] !== "undefined";
    }, [
        map
    ]);
    var setMultiple = (0, $eHaBZ.useCallback)(function(nextMap) {
        setMap(function(currentMap) {
            return (0, $lvTkn._)({}, currentMap, nextMap);
        });
    }, []);
    var removeMultiple = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, keys = new Array(_len), _key = 0; _key < _len; _key++){
            keys[_key] = arguments[_key];
        }
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = keys[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    delete nextMap[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return nextMap;
        });
    }, [
        setMap
    ]);
    var remove = (0, $eHaBZ.useCallback)(function(key) {
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            delete nextMap[key];
            return nextMap;
        });
    }, [
        setMap
    ]);
    var removeAll = (0, $eHaBZ.useCallback)(function() {
        setMap(function(currentMap) {
            var nextMap = (0, $lvTkn._)({}, currentMap);
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = Object.keys(nextMap)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var key = _step.value;
                    delete nextMap[key];
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return nextMap;
        });
    }, [
        setMap
    ]);
    return [
        map,
        {
            has: has,
            remove: remove,
            removeAll: removeAll,
            removeMultiple: removeMultiple,
            set: set,
            setMultiple: setMultiple
        }
    ];
}
function $c020e53fc27b31fb$export$3d0be2420b17e328(callback, isActive) {
    var savedCallback = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        savedCallback.current = callback;
    }, [
        callback
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var tick = function tick() {
            var _savedCallback_current;
            var timeElapsed = Date.now() - startTime;
            startTime = Date.now();
            loop();
            (_savedCallback_current = savedCallback.current) === null || _savedCallback_current === void 0 ? void 0 : _savedCallback_current.call(savedCallback, timeElapsed);
        };
        var loop = function loop() {
            animationFrame = (0, (/*@__PURE__*/$parcel$interopDefault($cce1e94b03780a93$exports)))(tick);
        };
        var animationFrame;
        var startTime = Date.now();
        if (isActive) {
            startTime = Date.now();
            loop();
            return function() {
                if (animationFrame) (0, (/*@__PURE__*/$parcel$interopDefault($cce1e94b03780a93$exports))).cancel(animationFrame);
            };
        } else return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        isActive
    ]);
}
// src/hooks/useAnimation.ts
var $c020e53fc27b31fb$var$hasWarnedDeprecation = false;
function $c020e53fc27b31fb$export$9e2608686d4ad846(options) {
    var duration = options.duration, _options_easing = options.easing, easing = _options_easing === void 0 ? function(t) {
        return t;
    } : _options_easing, _options_delay = options.delay, delay = _options_delay === void 0 ? 0 : _options_delay, _options_loop = options.loop, loop = _options_loop === void 0 ? false : _options_loop;
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), value = _useState4[0], setValue = _useState4[1];
    var startTimeRef = (0, $eHaBZ.useRef)(null);
    var delayRef = (0, $eHaBZ.useRef)(delay);
    $c020e53fc27b31fb$export$3d0be2420b17e328(function() {
        if (startTimeRef.current === null) startTimeRef.current = performance.now();
        var elapsed = performance.now() - startTimeRef.current;
        if (elapsed < delayRef.current) return true;
        var timeSinceStart = elapsed - delayRef.current;
        var progress = Math.min(timeSinceStart / duration, 1);
        var easedProgress = easing(progress);
        setValue(easedProgress);
        if (progress < 1) return true;
        if (loop) {
            startTimeRef.current = performance.now();
            delayRef.current = 0;
            return true;
        }
        return false;
    }, true);
    (0, $eHaBZ.useEffect)(function() {
        startTimeRef.current = null;
        delayRef.current = delay;
    }, [
        duration,
        easing,
        delay,
        loop
    ]);
    return value;
}
function $c020e53fc27b31fb$export$959143d64510bf04(initial) {
    var _useState5 = (0, $21h22._)((0, $eHaBZ.useState)(initial !== null && initial !== void 0 ? initial : []), 2), array = _useState5[0], setArray = _useState5[1];
    var push = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
            values[_key] = arguments[_key];
        }
        setArray(function(currentArray) {
            return (0, $6zk1M._)(currentArray).concat((0, $6zk1M._)(values));
        });
    }, []);
    var pop = (0, $eHaBZ.useCallback)(function() {
        setArray(function(currentArray) {
            return currentArray.slice(0, -1);
        });
    }, []);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setArray([]);
    }, []);
    var unshift = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, values = new Array(_len), _key = 0; _key < _len; _key++){
            values[_key] = arguments[_key];
        }
        setArray(function(currentArray) {
            return (0, $6zk1M._)(values).concat((0, $6zk1M._)(currentArray));
        });
    }, []);
    var shift = (0, $eHaBZ.useCallback)(function() {
        setArray(function(currentArray) {
            return currentArray.slice(1);
        });
    }, []);
    var reverse = (0, $eHaBZ.useCallback)(function() {
        setArray(function(currentArray) {
            return (0, $6zk1M._)(currentArray).reverse();
        });
    }, []);
    var concat = (0, $eHaBZ.useCallback)(function(value) {
        setArray(function(currentArray) {
            return (0, $6zk1M._)(currentArray).concat((0, $6zk1M._)(value));
        });
    }, []);
    var fill = (0, $eHaBZ.useCallback)(function(value, start, end) {
        setArray(function(currentArray) {
            return (0, $6zk1M._)(currentArray).fill(value, start, end);
        });
    }, []);
    var updateItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray[index] = value;
            return newArray;
        });
    }, [
        setArray
    ]);
    var splice = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setArray(function(prevArray) {
            var _newArray;
            var newArray = (0, $6zk1M._)(prevArray);
            (_newArray = newArray).splice.apply(_newArray, (0, $6zk1M._)(args));
            return newArray;
        });
    }, [
        setArray
    ]);
    var removeItemAtIndex = (0, $eHaBZ.useCallback)(function(index) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 1);
            return newArray;
        });
    }, [
        setArray
    ]);
    var replaceItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 1, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    var insertItemAtIndex = (0, $eHaBZ.useCallback)(function(index, value) {
        setArray(function(prevArray) {
            var newArray = (0, $6zk1M._)(prevArray);
            newArray.splice(index, 0, value);
            return newArray;
        });
    }, [
        setArray
    ]);
    var sort = (0, $eHaBZ.useCallback)(function(compareFn) {
        setArray(function(currentArray) {
            return (0, $6zk1M._)(currentArray).sort(compareFn);
        });
    }, []);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            push: push,
            pop: pop,
            clear: clear,
            unshift: unshift,
            shift: shift,
            reverse: reverse,
            concat: concat,
            fill: fill,
            updateItemAtIndex: updateItemAtIndex,
            setArray: setArray,
            splice: splice,
            removeItemAtIndex: removeItemAtIndex,
            replaceItemAtIndex: replaceItemAtIndex,
            insertItemAtIndex: insertItemAtIndex,
            sort: sort
        };
    }, [
        push,
        pop,
        clear,
        unshift,
        shift,
        reverse,
        concat,
        fill,
        updateItemAtIndex,
        setArray,
        splice,
        removeItemAtIndex,
        replaceItemAtIndex,
        insertItemAtIndex,
        sort
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            array,
            controls
        ];
    }, [
        array,
        controls
    ]);
    return returnValue;
}
var $c020e53fc27b31fb$export$7aa0022395cd4c49 = function() {
    var isMountedRef = (0, $eHaBZ.useRef)(false);
    var get = (0, $eHaBZ.useCallback)(function() {
        return isMountedRef.current;
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        isMountedRef.current = true;
        return function() {
            isMountedRef.current = false;
        };
    }, []);
    return get;
};
// src/hooks/useAsyncEffect.ts
function $c020e53fc27b31fb$export$6875e16a8bdc9a91(effect, deps, cleanup) {
    var lastCallId = (0, $eHaBZ.useRef)(0);
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    var effectRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(effect);
    var cleanupCallback = $c020e53fc27b31fb$export$b3553245f2c17524(function(result) {
        cleanup === null || cleanup === void 0 ? void 0 : cleanup(result);
    });
    var callback = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var callId, shouldContinueEffect;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        callId = ++lastCallId.current;
                        shouldContinueEffect = function() {
                            return getIsMounted() && callId === lastCallId.current;
                        };
                        return [
                            4,
                            effectRef.current(shouldContinueEffect)
                        ];
                    case 1:
                        return [
                            2,
                            _state.sent()
                        ];
                }
            });
        })();
    }, [
        getIsMounted
    ].concat((0, $6zk1M._)(deps)));
    (0, $eHaBZ.useEffect)(function() {
        var result;
        callback().then(function(value) {
            result = value;
        });
        return function() {
            cleanupCallback(result);
        };
    }, [
        callback,
        cleanupCallback
    ]);
}
var $c020e53fc27b31fb$var$noop2 = function() {};
function $c020e53fc27b31fb$export$91047320af7bf70b() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_autoPlay = options.autoPlay, autoPlay = _options_autoPlay === void 0 ? false : _options_autoPlay, tmp = options.isMuted, initialIsMuted = tmp === void 0 ? false : tmp, tmp1 = options.volume, initialVolume = tmp1 === void 0 ? 1 : tmp1, tmp2 = options.playbackRate, initialPlaybackRate = tmp2 === void 0 ? 1 : tmp2, tmp3 = options.loop, initialLoop = tmp3 === void 0 ? false : tmp3, _options_preload = options.preload, preload = _options_preload === void 0 ? "metadata" : _options_preload;
    var _useState6 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), audioNode = _useState6[0], setAudioNode = _useState6[1];
    var _useState61 = (0, $21h22._)((0, $eHaBZ.useState)({
        isPlaying: false,
        isMuted: initialIsMuted,
        volume: initialVolume,
        currentTime: 0,
        duration: 0,
        playbackRate: initialPlaybackRate,
        isLoading: false,
        isBuffering: false,
        loop: initialLoop,
        hasError: false
    }), 2), state = _useState61[0], setState = _useState61[1];
    var _callbacks_onPlay;
    var onPlay = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onPlay = callbacks.onPlay) !== null && _callbacks_onPlay !== void 0 ? _callbacks_onPlay : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onPause;
    var onPause = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onPause = callbacks.onPause) !== null && _callbacks_onPause !== void 0 ? _callbacks_onPause : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onEnded;
    var onEnded = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onEnded = callbacks.onEnded) !== null && _callbacks_onEnded !== void 0 ? _callbacks_onEnded : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onMute;
    var onMute = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onMute = callbacks.onMute) !== null && _callbacks_onMute !== void 0 ? _callbacks_onMute : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onUnmute;
    var onUnmute = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onUnmute = callbacks.onUnmute) !== null && _callbacks_onUnmute !== void 0 ? _callbacks_onUnmute : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onLoadedMetadata;
    var onLoadedMetadata = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onLoadedMetadata = callbacks.onLoadedMetadata) !== null && _callbacks_onLoadedMetadata !== void 0 ? _callbacks_onLoadedMetadata : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onTimeUpdate;
    var onTimeUpdate = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onTimeUpdate = callbacks.onTimeUpdate) !== null && _callbacks_onTimeUpdate !== void 0 ? _callbacks_onTimeUpdate : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onDurationChange;
    var onDurationChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onDurationChange = callbacks.onDurationChange) !== null && _callbacks_onDurationChange !== void 0 ? _callbacks_onDurationChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onVolumeChange;
    var onVolumeChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onVolumeChange = callbacks.onVolumeChange) !== null && _callbacks_onVolumeChange !== void 0 ? _callbacks_onVolumeChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onRateChange;
    var onRateChange = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onRateChange = callbacks.onRateChange) !== null && _callbacks_onRateChange !== void 0 ? _callbacks_onRateChange : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onError;
    var onError = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onError = callbacks.onError) !== null && _callbacks_onError !== void 0 ? _callbacks_onError : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onLoadStart;
    var onLoadStart = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onLoadStart = callbacks.onLoadStart) !== null && _callbacks_onLoadStart !== void 0 ? _callbacks_onLoadStart : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onCanPlay;
    var onCanPlay = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onCanPlay = callbacks.onCanPlay) !== null && _callbacks_onCanPlay !== void 0 ? _callbacks_onCanPlay : $c020e53fc27b31fb$var$noop2);
    var _callbacks_onWaiting;
    var onWaiting = $c020e53fc27b31fb$export$b3553245f2c17524((_callbacks_onWaiting = callbacks.onWaiting) !== null && _callbacks_onWaiting !== void 0 ? _callbacks_onWaiting : $c020e53fc27b31fb$var$noop2);
    var audioCallbackRef = function(node) {
        if (node !== null) setAudioNode(node);
    };
    (0, $eHaBZ.useEffect)(function() {
        if (!audioNode) return;
        audioNode.muted = state.isMuted;
        audioNode.volume = state.volume;
        audioNode.playbackRate = state.playbackRate;
        audioNode.loop = state.loop;
        audioNode.preload = preload;
        if (autoPlay) audioNode.autoplay = true;
    }, [
        audioNode,
        autoPlay,
        preload
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!audioNode) return;
        var handleLoadStart = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isLoading: true,
                    hasError: false
                });
            });
            onLoadStart();
        };
        var handleLoadedMetadata = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    duration: audioNode.duration,
                    isLoading: false,
                    hasError: false
                });
            });
            onLoadedMetadata();
            onDurationChange(audioNode.duration);
        };
        var handleCanPlay = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isBuffering: false,
                    hasError: false
                });
            });
            onCanPlay();
        };
        var handleWaiting = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isBuffering: true
                });
            });
            onWaiting();
        };
        var handlePlay = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: true,
                    hasError: false
                });
            });
            onPlay();
        };
        var handlePause = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: false
                });
            });
            onPause();
        };
        var handleEnded = function() {
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    isPlaying: false
                });
            });
            onEnded();
        };
        var handleTimeUpdate = function() {
            var currentTime = audioNode.currentTime;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    currentTime: currentTime
                });
            });
            onTimeUpdate(currentTime);
        };
        var handleDurationChange = function() {
            var duration = audioNode.duration;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    duration: duration
                });
            });
            onDurationChange(duration);
        };
        var handleVolumeChange = function() {
            var volume = audioNode.volume;
            var isMuted = audioNode.muted;
            setState(function(prev) {
                var newState = (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    volume: volume,
                    isMuted: isMuted
                });
                if (isMuted !== prev.isMuted) {
                    if (isMuted) onMute();
                    else onUnmute();
                }
                return newState;
            });
            onVolumeChange(volume);
        };
        var handleRateChange = function() {
            var playbackRate = audioNode.playbackRate;
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    playbackRate: playbackRate
                });
            });
            onRateChange(playbackRate);
        };
        var handleError = function() {
            var error = audioNode.error;
            var errorMessage = error ? "Audio error (".concat(error.code, "): ").concat(error.message) : "Unknown audio error occurred";
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    hasError: true,
                    error: errorMessage,
                    isLoading: false,
                    isBuffering: false,
                    isPlaying: false
                });
            });
            onError(errorMessage);
        };
        audioNode.addEventListener("loadstart", handleLoadStart);
        audioNode.addEventListener("loadedmetadata", handleLoadedMetadata);
        audioNode.addEventListener("canplay", handleCanPlay);
        audioNode.addEventListener("waiting", handleWaiting);
        audioNode.addEventListener("play", handlePlay);
        audioNode.addEventListener("pause", handlePause);
        audioNode.addEventListener("ended", handleEnded);
        audioNode.addEventListener("timeupdate", handleTimeUpdate);
        audioNode.addEventListener("durationchange", handleDurationChange);
        audioNode.addEventListener("volumechange", handleVolumeChange);
        audioNode.addEventListener("ratechange", handleRateChange);
        audioNode.addEventListener("error", handleError);
        return function() {
            audioNode.removeEventListener("loadstart", handleLoadStart);
            audioNode.removeEventListener("loadedmetadata", handleLoadedMetadata);
            audioNode.removeEventListener("canplay", handleCanPlay);
            audioNode.removeEventListener("waiting", handleWaiting);
            audioNode.removeEventListener("play", handlePlay);
            audioNode.removeEventListener("pause", handlePause);
            audioNode.removeEventListener("ended", handleEnded);
            audioNode.removeEventListener("timeupdate", handleTimeUpdate);
            audioNode.removeEventListener("durationchange", handleDurationChange);
            audioNode.removeEventListener("volumechange", handleVolumeChange);
            audioNode.removeEventListener("ratechange", handleRateChange);
            audioNode.removeEventListener("error", handleError);
        };
    }, [
        audioNode,
        onLoadStart,
        onLoadedMetadata,
        onCanPlay,
        onWaiting,
        onPlay,
        onPause,
        onEnded,
        onTimeUpdate,
        onDurationChange,
        onVolumeChange,
        onRateChange,
        onError,
        onMute,
        onUnmute
    ]);
    var play = function() {
        if (!audioNode) return;
        audioNode.play().catch(function(error) {
            var errorMessage = error instanceof Error ? error.message : "Failed to play audio";
            setState(function(prev) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                    hasError: true,
                    error: errorMessage,
                    isPlaying: false
                });
            });
            onError(errorMessage);
        });
    };
    var pause = function() {
        if (!audioNode) return;
        audioNode.pause();
    };
    var togglePlay = function() {
        if (state.isPlaying) pause();
        else play();
    };
    var mute = function() {
        if (!audioNode) return;
        audioNode.muted = true;
    };
    var unmute = function() {
        if (!audioNode) return;
        audioNode.muted = false;
    };
    var toggleMute = function() {
        if (state.isMuted) unmute();
        else mute();
    };
    var setVolume = function(volume) {
        if (!audioNode) return;
        var clampedVolume = Math.max(0, Math.min(1, volume));
        audioNode.volume = clampedVolume;
    };
    var setCurrentTime = function(time) {
        if (!audioNode) return;
        var clampedTime = Math.max(0, Math.min(state.duration || 0, time));
        audioNode.currentTime = clampedTime;
    };
    var setPlaybackRate = function(rate) {
        if (!audioNode) return;
        var clampedRate = Math.max(0.25, Math.min(4, rate));
        audioNode.playbackRate = clampedRate;
    };
    var seek = function(seconds) {
        setCurrentTime(state.currentTime + seconds);
    };
    var fastForward = function() {
        var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
        seek(seconds);
    };
    var rewind = function() {
        var seconds = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 10;
        seek(-seconds);
    };
    var setLoop = function(loop) {
        if (!audioNode) return;
        audioNode.loop = loop;
        setState(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), {
                loop: loop
            });
        });
    };
    var controls = {
        play: play,
        pause: pause,
        togglePlay: togglePlay,
        mute: mute,
        unmute: unmute,
        toggleMute: toggleMute,
        setVolume: setVolume,
        setCurrentTime: setCurrentTime,
        setPlaybackRate: setPlaybackRate,
        seek: seek,
        fastForward: fastForward,
        rewind: rewind,
        setLoop: setLoop
    };
    return [
        audioCallbackRef,
        state,
        controls
    ];
}
function $c020e53fc27b31fb$export$4984640464733c64(callback) {
    (0, $eHaBZ.useEffect)(function() {
        if (typeof callback === "function") callback();
    }, []);
}
var $c020e53fc27b31fb$var$config = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $c020e53fc27b31fb$export$8ecdcf3bb089e9cd(ref, callback) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : $c020e53fc27b31fb$var$config;
    (0, $eHaBZ.useEffect)(function() {
        if (ref.current) {
            var observer = new MutationObserver(callback);
            observer.observe(ref.current, options);
            return function() {
                observer.disconnect();
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        callback,
        options,
        ref
    ]);
}
// src/hooks/useBoundingclientrect.ts
function $c020e53fc27b31fb$var$getBoundingClientRect(element) {
    return element.getBoundingClientRect();
}
function $c020e53fc27b31fb$export$b95e3d4f036ffdbe(ref) {
    var _useState7 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), domRect = _useState7[0], setDomRect = _useState7[1];
    var update = (0, $eHaBZ.useCallback)(function() {
        setDomRect(ref.current ? $c020e53fc27b31fb$var$getBoundingClientRect(ref.current) : null);
    }, [
        ref
    ]);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        update();
    });
    $c020e53fc27b31fb$export$8ecdcf3bb089e9cd(ref, update);
    return domRect;
}
var $c020e53fc27b31fb$var$config2 = {
    attributes: true,
    characterData: true,
    childList: true,
    subtree: true
};
function $c020e53fc27b31fb$export$cdfcc5138d0e9570(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config2;
    var _useState8 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState8[0], setNode = _useState8[1];
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new MutationObserver(callback);
            observer.observe(node, options);
            return function() {
                observer.disconnect();
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        node,
        callback,
        options
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
// src/hooks/useBoundingclientrectRef.ts
function $c020e53fc27b31fb$var$getBoundingClientRect2(element) {
    return element.getBoundingClientRect();
}
function $c020e53fc27b31fb$export$e44360762afe9191() {
    var _useState9 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), domRect = _useState9[0], setDomRect = _useState9[1];
    var _useState91 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState91[0], setNode = _useState91[1];
    var update = (0, $eHaBZ.useCallback)(function() {
        setDomRect(node ? $c020e53fc27b31fb$var$getBoundingClientRect2(node) : null);
    }, [
        node
    ]);
    (0, $eHaBZ.useEffect)(function() {
        update();
    }, [
        update
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    var _useMutationObserverRef = (0, $21h22._)($c020e53fc27b31fb$export$cdfcc5138d0e9570(update), 1), mutationObserverRef = _useMutationObserverRef[0];
    var forkedRef = (0, $e146ef819c676a18$export$ebc1e1560c2dffa5)(ref, mutationObserverRef);
    return [
        forkedRef,
        domRect,
        update
    ];
}
function $c020e53fc27b31fb$export$d41d1c6c7d9f02aa(initialValue) {
    var _useState10 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), checked = _useState10[0], setInternalChecked = _useState10[1];
    var setChecked = (0, $eHaBZ.useCallback)(function(newChecked) {
        setInternalChecked(newChecked);
    }, []);
    var toggle = (0, $eHaBZ.useCallback)(function() {
        setInternalChecked(function(prev) {
            return !prev;
        });
    }, []);
    var handleChange = (0, $eHaBZ.useCallback)(function(event) {
        setInternalChecked(event.target.checked);
    }, []);
    var inputProps = (0, $eHaBZ.useMemo)(function() {
        return {
            checked: checked,
            onChange: handleChange
        };
    }, [
        checked,
        handleChange
    ]);
    return {
        checked: checked,
        toggle: toggle,
        setChecked: setChecked,
        inputProps: inputProps
    };
}
function $c020e53fc27b31fb$export$2314ca2a3e892862() {
    var _useState11 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), text = _useState11[0], setText = _useState11[1];
    var _useState111 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState111[0], setError = _useState111[1];
    var isSupported = typeof window !== "undefined" && typeof navigator !== "undefined" && "clipboard" in navigator;
    var copy = (0, $eHaBZ.useCallback)(function(value) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _$err, err, error2;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Clipboard API is not supported");
                            setError(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.writeText(value)
                        ];
                    case 2:
                        _state.sent();
                        setText(value);
                        setError(null);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Failed to copy to clipboard");
                        setError(error2);
                        throw error2;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    var paste = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _$err, clipboardText, err, error2;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Clipboard API is not supported");
                            setError(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.clipboard.readText()
                        ];
                    case 2:
                        clipboardText = _state.sent();
                        setText(clipboardText);
                        setError(null);
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Failed to read from clipboard");
                        setError(error2);
                        throw error2;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    return {
        text: text,
        copy: copy,
        paste: paste,
        isSupported: isSupported,
        error: error
    };
}
function $c020e53fc27b31fb$export$88af857a8946da7e(callback) {
    var intervalDurationMs = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true, startImmediate = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var savedRefCallback = (0, $eHaBZ.useRef)(void 0);
    (0, $eHaBZ.useEffect)(function() {
        savedRefCallback.current = callback;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            var internalCallback2 = function internalCallback2() {
                var _savedRefCallback_current;
                (_savedRefCallback_current = savedRefCallback.current) === null || _savedRefCallback_current === void 0 ? void 0 : _savedRefCallback_current.call(savedRefCallback);
            };
            var internalCallback = internalCallback2;
            if (startImmediate) internalCallback2();
            var interval = window.setInterval(internalCallback2, intervalDurationMs);
            return function() {
                window.clearInterval(interval);
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        when,
        intervalDurationMs,
        startImmediate
    ]);
}
// src/hooks/useCountdown.ts
function $c020e53fc27b31fb$export$8103f7eb37e19f7b(endTime) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_interval = options.interval, interval = _options_interval === void 0 ? 1e3 : _options_interval, onDown = options.onDown, onEnd = options.onEnd;
    var _useState12 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return /* @__PURE__ */ new Date();
    }), 2), time = _useState12[0], setTime = _useState12[1];
    var endTimeMs = endTime.getTime();
    var restTime = endTimeMs - time.getTime();
    var count = restTime > 0 ? Math.ceil(restTime / interval) : 0;
    var endedAtRef = (0, $eHaBZ.useRef)(null);
    var onEndRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(onEnd);
    $c020e53fc27b31fb$export$88af857a8946da7e(onTick, interval, count > 0, true);
    (0, $eHaBZ.useEffect)(function() {
        if (Number.isFinite(endTimeMs) && endTimeMs <= Date.now() && endedAtRef.current !== endTimeMs) {
            var _onEndRef_current;
            endedAtRef.current = endTimeMs;
            (_onEndRef_current = onEndRef.current) === null || _onEndRef_current === void 0 ? void 0 : _onEndRef_current.call(onEndRef, /* @__PURE__ */ new Date());
        }
    }, [
        endTimeMs,
        onEndRef
    ]);
    return count;
    function onTick() {
        var newTime = /* @__PURE__ */ new Date();
        var newRestTime = endTimeMs - newTime.getTime();
        if (newRestTime <= 0) {
            if (endedAtRef.current !== endTimeMs) {
                endedAtRef.current = endTimeMs;
                onEnd === null || onEnd === void 0 ? void 0 : onEnd(newTime);
            }
            setTime(endTime);
            return;
        }
        if (onDown) onDown(newRestTime, newTime);
        setTime(newTime);
    }
}
function $c020e53fc27b31fb$export$70c4067197c60e2d(initialValue) {
    var _useState13 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), counter = _useState13[0], setCounter = _useState13[1];
    var incrementBy = (0, $eHaBZ.useCallback)(function(incrAmount) {
        setCounter(function(currentCounter) {
            return currentCounter + incrAmount;
        });
    }, []);
    var decrementBy = (0, $eHaBZ.useCallback)(function(decrAmount) {
        incrementBy(-decrAmount);
    }, [
        incrementBy
    ]);
    var increment = (0, $eHaBZ.useCallback)(function() {
        incrementBy(1);
    }, [
        incrementBy
    ]);
    var decrement = (0, $eHaBZ.useCallback)(function() {
        incrementBy(-1);
    }, [
        incrementBy
    ]);
    var reset = (0, $eHaBZ.useCallback)(function() {
        setCounter(initialValue);
    }, [
        initialValue
    ]);
    return {
        decrement: decrement,
        decrementBy: decrementBy,
        increment: increment,
        incrementBy: incrementBy,
        reset: reset,
        value: counter
    };
}
function $c020e53fc27b31fb$export$328d69a66df243d8(callback) {
    (0, $eHaBZ.useEffect)(function() {
        return callback;
    }, []);
}
// src/hooks/useDebounce.ts
function $c020e53fc27b31fb$export$21805fee57372823(callback, wait, options) {
    var createDebouncedCallback = (0, $eHaBZ.useCallback)(function(function_) {
        return (0, (/*@__PURE__*/$parcel$interopDefault($2ba76da8a3028b95$exports)))(function_, wait, options);
    }, [
        wait,
        options
    ]);
    var freshCallback = (0, $e146ef819c676a18$export$38e1734badfda8d9)(callback);
    function tick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshCallback_current;
        var _freshCallback_current1;
        (_freshCallback_current1 = freshCallback.current) === null || _freshCallback_current1 === void 0 ? void 0 : (_freshCallback_current = _freshCallback_current1).call.apply(_freshCallback_current, [
            freshCallback
        ].concat((0, $6zk1M._)(args)));
    }
    var debouncedCallbackRef = (0, $eHaBZ.useRef)(createDebouncedCallback(tick));
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        var _debouncedCallbackRef_current;
        (_debouncedCallbackRef_current = debouncedCallbackRef.current) === null || _debouncedCallbackRef_current === void 0 ? void 0 : _debouncedCallbackRef_current.cancel();
    });
    return debouncedCallbackRef.current;
}
function $c020e53fc27b31fb$export$ddf8f1aa96b8ea88(func, delay) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {
        leading: false,
        trailing: true
    };
    var leading = options.leading, trailing = options.trailing, maxWait = options.maxWait;
    if (!leading && !trailing) throw new Error("leading and trailing cannot both be false");
    else if (typeof maxWait !== "undefined" && maxWait < delay) throw new Error("maxWait cannot be less than delay");
    var funcRef = $c020e53fc27b31fb$export$b3553245f2c17524(func);
    var _useState14 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isTimeoutEnabled = _useState14[0], setIsTimeoutEnabled = _useState14[1];
    var _useState141 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), key = _useState141[0], setKey = _useState141[1];
    var lastExecutionTimeRef = (0, $eHaBZ.useRef)(0);
    var argsRef = (0, $eHaBZ.useRef)(void 0);
    var debouncedFn = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        argsRef.current = args;
        var overrideTimeout = typeof maxWait !== "undefined" && lastExecutionTimeRef.current && Date.now() - lastExecutionTimeRef.current > maxWait;
        if (leading) {
            if (isTimeoutEnabled && overrideTimeout) {
                setKey(function(prevKey) {
                    return prevKey + 1;
                });
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            } else if (overrideTimeout && !isTimeoutEnabled) {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            } else if (isTimeoutEnabled && !overrideTimeout) ;
            else {
                setIsTimeoutEnabled(true);
                lastExecutionTimeRef.current = Date.now();
                try {
                    funcRef.apply(void 0, (0, $6zk1M._)(args));
                } catch (error) {
                    console.warn(error);
                }
            }
        }
        if (trailing) {
            if (isTimeoutEnabled) setKey(function(prevKey) {
                return prevKey + 1;
            });
            else setIsTimeoutEnabled(true);
        }
    }, [
        maxWait,
        isTimeoutEnabled,
        leading,
        trailing,
        funcRef
    ]);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        if (typeof maxWait !== "undefined" && trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef.apply(void 0, (0, $6zk1M._)(argsRef.current));
            } catch (error) {
                console.warn(error);
            }
        }
    }, maxWait !== null && maxWait !== void 0 ? maxWait : Infinity, isTimeoutEnabled && typeof maxWait !== "undefined" && trailing, key);
    $c020e53fc27b31fb$export$6d974d04a2e6dd6e(function() {
        if (trailing) {
            if (!argsRef.current) return;
            lastExecutionTimeRef.current = Date.now();
            try {
                funcRef.apply(void 0, (0, $6zk1M._)(argsRef.current));
            } catch (error) {
                console.warn(error);
            }
        }
        setIsTimeoutEnabled(false);
    }, delay, isTimeoutEnabled && trailing, key);
    var freshDebouncedFn = $c020e53fc27b31fb$export$b3553245f2c17524(debouncedFn);
    return [
        freshDebouncedFn,
        isTimeoutEnabled
    ];
}
function $c020e53fc27b31fb$export$f61003a1bfad2e1d(effect, deps) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 500, cleanup = arguments.length > 3 ? arguments[3] : void 0, options = arguments.length > 4 ? arguments[4] : void 0;
    var lastCallId = (0, $eHaBZ.useRef)(0);
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    var effectRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(effect);
    var resultRef = (0, $eHaBZ.useRef)(void 0);
    var asyncCallback = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var callId, shouldContinueEffect, result, error;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        callId = ++lastCallId.current;
                        shouldContinueEffect = function() {
                            return getIsMounted() && callId === lastCallId.current;
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            effectRef.current(shouldContinueEffect)
                        ];
                    case 2:
                        result = _state.sent();
                        if (shouldContinueEffect()) resultRef.current = result;
                        return [
                            2,
                            result
                        ];
                    case 3:
                        error = _state.sent();
                        if (shouldContinueEffect()) throw error;
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getIsMounted,
        effectRef
    ]);
    var debouncedAsyncCallback = $c020e53fc27b31fb$export$21805fee57372823(asyncCallback, delay, options);
    var cleanupRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(cleanup);
    (0, $eHaBZ.useEffect)(function() {
        debouncedAsyncCallback();
        var currentCleanup = cleanupRef.current;
        return function() {
            lastCallId.current += 1;
            debouncedAsyncCallback.cancel();
            var result = resultRef.current;
            resultRef.current = void 0;
            currentCleanup === null || currentCleanup === void 0 ? void 0 : currentCleanup(result);
        };
    }, deps);
}
function $c020e53fc27b31fb$export$44b55d93c84df466(effect, deps) {
    var delay = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 500, options = arguments.length > 3 ? arguments[3] : void 0;
    var cleanupRef = (0, $eHaBZ.useRef)(void 0);
    var wrappedEffect = function() {
        if (typeof cleanupRef.current === "function") cleanupRef.current();
        cleanupRef.current = effect();
    };
    var debouncedEffect = $c020e53fc27b31fb$export$21805fee57372823(wrappedEffect, delay, options);
    (0, $eHaBZ.useEffect)(function() {
        debouncedEffect();
        return function() {
            debouncedEffect.cancel();
            if (typeof cleanupRef.current === "function") {
                cleanupRef.current();
                cleanupRef.current = void 0;
            }
        };
    }, deps);
}
function $c020e53fc27b31fb$export$e34ed88fef4dc107(callback, conditions) {
    var hasMountedRef = (0, $eHaBZ.useRef)(false);
    var internalConditions = (0, $eHaBZ.useMemo)(function() {
        if (typeof conditions !== "undefined" && !Array.isArray(conditions)) return [
            conditions
        ];
        else if (Array.isArray(conditions) && conditions.length === 0) console.warn("Using [] as the second argument makes useDidUpdate a noop. The second argument should either be `undefined` or an array of length greater than 0.");
        return conditions;
    }, [
        conditions
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (hasMountedRef.current) callback();
    }, internalConditions);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        hasMountedRef.current = true;
    });
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        hasMountedRef.current = false;
    });
}
// src/hooks/useDebouncedValue.ts
var $c020e53fc27b31fb$var$defaultUseDebounceValueOptions = {
    initializeWithNull: false
};
var $c020e53fc27b31fb$export$5ab4fa7caa249e6e = function(value, timeout) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var initializeWithNull = Object.assign({}, $c020e53fc27b31fb$var$defaultUseDebounceValueOptions, options).initializeWithNull;
    var _useState15 = (0, $21h22._)((0, $eHaBZ.useState)(initializeWithNull ? null : value), 2), updatedValue = _useState15[0], setUpdatedValue = _useState15[1];
    var debouncedSetUpdatedValue = $c020e53fc27b31fb$export$21805fee57372823(setUpdatedValue, timeout);
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        if (initializeWithNull) debouncedSetUpdatedValue(value);
    });
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        debouncedSetUpdatedValue(value);
    }, [
        value
    ]);
    return [
        updatedValue,
        setUpdatedValue
    ];
};
// src/hooks/warning.ts
var $c020e53fc27b31fb$var$isDevelopmentEnvironment = false;
var $c020e53fc27b31fb$var$warning = function() {};
if ($c020e53fc27b31fb$var$isDevelopmentEnvironment) {
    var $c020e53fc27b31fb$var$printWarning = function(actualMessage) {
        var message = "Warning: ".concat(actualMessage);
        if (typeof console !== "undefined") console.error(message);
        try {
            throw new Error(message);
        } catch (e) {}
    };
    $c020e53fc27b31fb$var$warning = function warning(condition, actualMessage) {
        if (!condition) $c020e53fc27b31fb$var$printWarning(actualMessage);
    };
}
// src/hooks/useDeepCompareEffect.ts
function $c020e53fc27b31fb$var$isPrimitive(value) {
    var valueType = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return valueType === "string" || valueType === "number" || valueType === "bigint" || valueType === "boolean" || valueType === "undefined" || valueType === "symbol";
}
function $c020e53fc27b31fb$export$db77f469fe79526e(callback, dependencies) {
    var previousDeps = (0, $eHaBZ.useRef)(dependencies);
    if (!Array.isArray(dependencies)) throw new Error("useDeepCompareEffect should be used with an array of dependencies");
    var hasPrimitives = dependencies.every($c020e53fc27b31fb$var$isPrimitive);
    $c020e53fc27b31fb$var$warning(!hasPrimitives, "useDeepCompareEffect should not be used with primitive values as dependencies");
    if (!(0, (/*@__PURE__*/$parcel$interopDefault($20cb340d6b373ba4$exports)))(previousDeps.current, dependencies)) previousDeps.current = dependencies;
    (0, $eHaBZ.useEffect)(callback, previousDeps.current);
}
function $c020e53fc27b31fb$var$useGlobalObjectEventListener(globalObject, eventName, callback) {
    var listenerOptions = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, when = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, isLayoutEffect = arguments.length > 5 && arguments[5] !== void 0 ? arguments[5] : false;
    (0, $eHaBZ.useEffect)(function() {
        $c020e53fc27b31fb$var$warning(typeof window === "undefined" || typeof globalObject !== "undefined", "[useGlobalObjectEventListener]: Cannot attach event handlers to undefined.");
    }, [
        globalObject
    ]);
    (0, $e146ef819c676a18$export$7080b3e976bc91ab)(eventName, callback, {
        target: globalObject,
        listenerOptions: listenerOptions,
        when: when,
        isLayoutEffect: isLayoutEffect
    });
}
// src/hooks/useOnWindowResize.ts
function $c020e53fc27b31fb$export$61171a90a6148cf5(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isLayoutEffect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, "resize", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useOnWindowScroll.ts
function $c020e53fc27b31fb$export$f2fb712044277d5e(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, isLayoutEffect = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, "scroll", callback, {
        passive: true
    }, when, isLayoutEffect);
}
// src/hooks/useDimensionsRef.ts
var $c020e53fc27b31fb$var$getDimensionObject = function(node) {
    var rect = node.getBoundingClientRect();
    return {
        bottom: rect.bottom,
        height: rect.height,
        left: rect.left,
        right: rect.right,
        top: rect.top,
        width: rect.width,
        x: rect.left,
        y: rect.top
    };
};
var $c020e53fc27b31fb$var$noWindowReturnValue = [
    void 0,
    null,
    null
];
var $c020e53fc27b31fb$export$b5cb37376a215039 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_updateOnScroll = _ref.updateOnScroll, updateOnScroll = _ref_updateOnScroll === void 0 ? true : _ref_updateOnScroll, _ref_updateOnResize = _ref.updateOnResize, updateOnResize = _ref_updateOnResize === void 0 ? true : _ref_updateOnResize;
    var _useState16 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), dimensions = _useState16[0], setDimensions = _useState16[1];
    var _useState161 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState161[0], setNode = _useState161[1];
    var ref = (0, $eHaBZ.useCallback)(function(nodeFromCallback) {
        setNode(nodeFromCallback);
    }, []);
    var measure = (0, $eHaBZ.useCallback)(function() {
        window.requestAnimationFrame(function() {
            if (node) setDimensions($c020e53fc27b31fb$var$getDimensionObject(node));
        });
    }, [
        node
    ]);
    (0, $eHaBZ.useLayoutEffect)(function() {
        measure();
    }, [
        measure
    ]);
    $c020e53fc27b31fb$export$61171a90a6148cf5(function() {
        measure();
    }, updateOnResize, true);
    $c020e53fc27b31fb$export$f2fb712044277d5e(function() {
        measure();
    }, updateOnScroll, true);
    if (typeof window === "undefined") {
        console.warn("useDimensionsRef: window is undefined.");
        return $c020e53fc27b31fb$var$noWindowReturnValue;
    }
    return [
        ref,
        dimensions,
        node
    ];
};
// src/hooks/useDocumentEventListener.ts
function $c020e53fc27b31fb$export$3d17299e951a5198(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener(typeof document !== "undefined" ? document : void 0, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $c020e53fc27b31fb$export$4b208edda918084f(title) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var isBrowser = typeof window !== "undefined";
    var prevTitleRef = (0, $eHaBZ.useRef)(isBrowser ? document.title : "");
    var _options_resetOnUnmount = options.resetOnUnmount, resetOnUnmount = _options_resetOnUnmount === void 0 ? false : _options_resetOnUnmount;
    (0, $eHaBZ.useEffect)(function() {
        if (isBrowser) {
            document.title = title;
            var lastTitle = prevTitleRef.current;
            if (resetOnUnmount) return function() {
                document.title = lastTitle;
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        title,
        isBrowser,
        resetOnUnmount
    ]);
}
var $c020e53fc27b31fb$export$cea96571ebbff9dd = {
    linear: function(t) {
        return t;
    },
    easeInQuad: function(t) {
        return t * t;
    },
    easeOutQuad: function(t) {
        return t * (2 - t);
    },
    easeInOutQuad: function(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function(t) {
        return t * t * t;
    },
    easeOutCubic: function(t) {
        return --t * t * t + 1;
    },
    easeInOutCubic: function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
};
function $c020e53fc27b31fb$export$c27926f3509c2cc6(duration) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_easing = options.easing, easing = _options_easing === void 0 ? $c020e53fc27b31fb$export$cea96571ebbff9dd.linear : _options_easing, _options_autoStart = options.autoStart, autoStart = _options_autoStart === void 0 ? true : _options_autoStart, _options_loop = options.loop, loop = _options_loop === void 0 ? false : _options_loop, _options_alternate = options.alternate, alternate = _options_alternate === void 0 ? false : _options_alternate, _options_delay = options.delay, delay = _options_delay === void 0 ? 0 : _options_delay, onEnd = options.onEnd;
    var _useState17 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), progress = _useState17[0], setProgress = _useState17[1];
    var _useState171 = (0, $21h22._)((0, $eHaBZ.useState)(autoStart ? "running" : "idle"), 2), state = _useState171[0], setState = _useState171[1];
    var _useState172 = (0, $21h22._)((0, $eHaBZ.useState)("forward"), 2), direction = _useState172[0], setDirection = _useState172[1];
    var _useState173 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), endCount = _useState173[0], setEndCount = _useState173[1];
    var startTimeRef = (0, $eHaBZ.useRef)(null);
    var pausedRawProgressRef = (0, $eHaBZ.useRef)(0);
    var delayRemainingRef = (0, $eHaBZ.useRef)(delay);
    var isFirstRunRef = (0, $eHaBZ.useRef)(true);
    var hasCompletedRef = (0, $eHaBZ.useRef)(false);
    var currentRawProgressRef = (0, $eHaBZ.useRef)(0);
    var onEndRef = (0, $eHaBZ.useRef)(onEnd);
    onEndRef.current = onEnd;
    var directionRef = (0, $eHaBZ.useRef)(direction);
    directionRef.current = direction;
    var start = (0, $eHaBZ.useCallback)(function() {
        if (state === "running") return;
        startTimeRef.current = null;
        hasCompletedRef.current = false;
        setState("running");
    }, [
        state
    ]);
    var stop = (0, $eHaBZ.useCallback)(function() {
        if (state === "idle") return;
        pausedRawProgressRef.current = currentRawProgressRef.current;
        setState("idle");
    }, [
        state
    ]);
    var reset = (0, $eHaBZ.useCallback)(function() {
        setState("idle");
        setProgress(0);
        setDirection("forward");
        setEndCount(0);
        startTimeRef.current = null;
        pausedRawProgressRef.current = 0;
        currentRawProgressRef.current = 0;
        delayRemainingRef.current = delay;
        isFirstRunRef.current = true;
        hasCompletedRef.current = false;
        directionRef.current = "forward";
    }, [
        delay
    ]);
    var restart = (0, $eHaBZ.useCallback)(function() {
        reset();
        setTimeout(function() {
            setState("running");
        }, 0);
    }, [
        reset
    ]);
    $c020e53fc27b31fb$export$3d0be2420b17e328(function() {
        if (startTimeRef.current === null) {
            var resumeOffset = pausedRawProgressRef.current * duration;
            startTimeRef.current = performance.now() - resumeOffset;
        }
        var elapsed = performance.now() - startTimeRef.current;
        if (isFirstRunRef.current && delayRemainingRef.current > 0) {
            if (elapsed < delayRemainingRef.current) return;
            startTimeRef.current = performance.now() - (elapsed - delayRemainingRef.current);
            delayRemainingRef.current = 0;
            isFirstRunRef.current = false;
        }
        var adjustedElapsed = performance.now() - startTimeRef.current;
        var rawProgress = Math.min(adjustedElapsed / duration, 1);
        currentRawProgressRef.current = rawProgress;
        var directionalProgress = directionRef.current === "forward" ? rawProgress : 1 - rawProgress;
        var easedProgress = easing(directionalProgress);
        setProgress(easedProgress);
        if (rawProgress >= 1 && !hasCompletedRef.current) {
            var _onEndRef_current;
            hasCompletedRef.current = true;
            setEndCount(function(prev) {
                return prev + 1;
            });
            (_onEndRef_current = onEndRef.current) === null || _onEndRef_current === void 0 ? void 0 : _onEndRef_current.call(onEndRef);
            if (loop) {
                startTimeRef.current = performance.now();
                hasCompletedRef.current = false;
                if (alternate) {
                    var newDirection = directionRef.current === "forward" ? "backward" : "forward";
                    directionRef.current = newDirection;
                    setDirection(newDirection);
                }
            } else setState("idle");
        }
    }, state === "running");
    (0, $eHaBZ.useEffect)(function() {
        if (autoStart) setState("running");
    }, []);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            start: start,
            stop: stop,
            reset: reset,
            restart: restart,
            state: state,
            direction: direction,
            endCount: endCount
        };
    }, [
        start,
        stop,
        reset,
        restart,
        state,
        direction,
        endCount
    ]);
    return [
        progress,
        controls
    ];
}
function $c020e53fc27b31fb$var$getVisibilityStateSnapshot() {
    if (typeof document !== "undefined") return document.visibilityState;
    else return null;
}
function $c020e53fc27b31fb$var$getVisibilityStateSubscription(callback) {
    if (typeof document !== "undefined") {
        document.addEventListener("visibilitychange", callback);
        return function() {
            document.removeEventListener("visibilitychange", callback);
        };
    }
    return function() {};
}
function $c020e53fc27b31fb$var$getVisibilityStateServerSnapshot() {
    return null;
}
function $c020e53fc27b31fb$export$84b371b406ccb709() {
    return (0, $eHaBZ.useSyncExternalStore)($c020e53fc27b31fb$var$getVisibilityStateSubscription, $c020e53fc27b31fb$var$getVisibilityStateSnapshot, $c020e53fc27b31fb$var$getVisibilityStateServerSnapshot);
}
function $c020e53fc27b31fb$export$7a4c3f7300df51d9(callback) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var hasRunOnceRef = (0, $eHaBZ.useRef)(false);
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when && !hasRunOnceRef.current) {
            callbackRef.current();
            hasRunOnceRef.current = true;
        }
    }, [
        when
    ]);
}
// src/hooks/useEventListenerRef.ts
function $c020e53fc27b31fb$export$f2a41a0f37ebea17(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    var _useRefElement = (0, $21h22._)((0, $e146ef819c676a18$export$231305e360fbdfeb)(), 2), ref = _useRefElement[0], element = _useRefElement[1];
    (0, $e146ef819c676a18$export$7080b3e976bc91ab)(eventName, callback, {
        target: element,
        listenerOptions: listenerOptions,
        isLayoutEffect: isLayoutEffect
    });
    return ref;
}
function $c020e53fc27b31fb$export$7066775237fab396() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, callbacks = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var accept = options.accept, maxFileSize = options.maxFileSize, maxFiles = options.maxFiles;
    var _callbacks_onDrop = callbacks.onDrop, onDrop = _callbacks_onDrop === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _callbacks_onDrop, _callbacks_onFileAccepted = callbacks.onFileAccepted, onFileAccepted = _callbacks_onFileAccepted === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _callbacks_onFileAccepted, _callbacks_onFileRejected = callbacks.onFileRejected, onFileRejected = _callbacks_onFileRejected === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _callbacks_onFileRejected, _callbacks_onDragEnter = callbacks.onDragEnter, onDragEnter = _callbacks_onDragEnter === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _callbacks_onDragEnter, _callbacks_onDragLeave = callbacks.onDragLeave, onDragLeave = _callbacks_onDragLeave === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _callbacks_onDragLeave;
    var _useState18 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState18[0], setTargetNode = _useState18[1];
    var freshOnDrop = $c020e53fc27b31fb$export$b3553245f2c17524(onDrop);
    var freshOnFileAccepted = $c020e53fc27b31fb$export$b3553245f2c17524(onFileAccepted);
    var freshOnFileRejected = $c020e53fc27b31fb$export$b3553245f2c17524(onFileRejected);
    var freshOnDragEnter = $c020e53fc27b31fb$export$b3553245f2c17524(onDragEnter);
    var freshOnDragLeave = $c020e53fc27b31fb$export$b3553245f2c17524(onDragLeave);
    var fileIsValid = (0, $eHaBZ.useCallback)(function(file) {
        if (accept && !accept.includes(file.type)) return {
            valid: false,
            reason: "File type not allowed"
        };
        if (maxFileSize !== void 0 && file.size > maxFileSize) return {
            valid: false,
            reason: "File size exceeds the limit"
        };
        return {
            valid: true
        };
    }, [
        accept,
        maxFileSize
    ]);
    var handleDrop = (0, $eHaBZ.useCallback)(function(event) {
        var _event_dataTransfer;
        event.preventDefault();
        var files = Array.from(((_event_dataTransfer = event.dataTransfer) === null || _event_dataTransfer === void 0 ? void 0 : _event_dataTransfer.files) || []);
        var acceptedFiles = [];
        var rejectedFiles = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        if (maxFiles !== void 0 && files.length > maxFiles) try {
            for(var _iterator = files[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var file = _step.value;
                rejectedFiles.push(file);
                freshOnFileRejected(file, "Exceeded maximum number of files");
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        else files.forEach(function(file) {
            var validationResult = fileIsValid(file);
            if (validationResult.valid) {
                acceptedFiles.push(file);
                freshOnFileAccepted(file);
            } else {
                rejectedFiles.push(file);
                freshOnFileRejected(file, validationResult.reason || "Unknown reason");
            }
        });
        freshOnDrop(acceptedFiles, rejectedFiles);
    }, [
        fileIsValid,
        freshOnFileAccepted,
        freshOnFileRejected,
        maxFiles,
        freshOnDrop
    ]);
    var handleDragOver = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (targetNode) {
            targetNode.addEventListener("drop", handleDrop);
            targetNode.addEventListener("dragover", handleDragOver);
            targetNode.addEventListener("dragenter", freshOnDragEnter);
            targetNode.addEventListener("dragleave", freshOnDragLeave);
            return function() {
                targetNode.removeEventListener("drop", handleDrop);
                targetNode.removeEventListener("dragover", handleDragOver);
                targetNode.removeEventListener("dragenter", freshOnDragEnter);
                targetNode.removeEventListener("dragleave", freshOnDragLeave);
            };
        } else return function() {};
    }, [
        targetNode,
        handleDrop,
        handleDragOver,
        freshOnDragEnter,
        freshOnDragLeave
    ]);
    return (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
}
// src/hooks/useFreshTick.ts
function $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback) {
    var freshRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(callback);
    function tick() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _freshRef;
        if (typeof freshRef.current === "function") (_freshRef = freshRef).current.apply(_freshRef, (0, $6zk1M._)(args));
    }
    return tick;
}
var $c020e53fc27b31fb$var$FullscreenApi = {
    DOM_UNAVAILABLE_ERROR: "DOM is unavailable server-side. Please use this method client-side only.",
    FULLSCREEN_UNSUPPORTED_ERROR: "Your browser does not support Fullscreen API.",
    getEventsNames: function() {
        if (typeof document === "undefined") return null;
        var _document = document;
        if ("exitFullscreen" in _document) return [
            "fullscreenchange",
            "fullscreenerror"
        ];
        if ("webkitExitFullscreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("webkitCancelFullScreen" in _document) return [
            "webkitfullscreenchange",
            "webkitfullscreenerror"
        ];
        if ("mozCancelFullScreen" in _document) return [
            "mozfullscreenchange",
            "mozfullscreenerror"
        ];
        if ("msExitFullscreen" in _document) return [
            "MSFullscreenChange",
            "MSFullscreenError"
        ];
        return null;
    },
    getEventName: function(eventType) {
        var eventsNames = this.getEventsNames();
        if (!eventsNames) return null;
        if (eventType === "change") return eventsNames[0];
        return eventsNames[1];
    },
    get fullscreenEnabled () {
        if (typeof document === "undefined") return false;
        var _document = document;
        return _document.fullscreenEnabled || _document.webkitFullscreenEnabled || !!_document.webkitCancelFullScreen || _document.mozFullScreenEnabled || _document.msFullscreenEnabled || false;
    },
    get fullscreenElement () {
        if (typeof document === "undefined") return null;
        var _document1 = document;
        return _document1.fullscreenElement || _document1.webkitFullscreenElement || _document1.webkitCurrentFullScreenElement || _document1.mozFullScreenElement || _document1.msFullscreenElement || null;
    },
    requestFullscreen: function(element, options) {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        var target = element !== null && element !== void 0 ? element : document.documentElement;
        var method = target.requestFullscreen || target.webkitRequestFullscreen || target.webkitRequestFullScreen || target.mozRequestFullScreen || target.msRequestFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(target, options);
    },
    exitFullscreen: function() {
        if (typeof document === "undefined") throw new Error(this.DOM_UNAVAILABLE_ERROR);
        var _document = document;
        var method = _document.exitFullscreen || _document.webkitExitFullscreen || _document.webkitCancelFullScreen || _document.mozCancelFullScreen || _document.msExitFullscreen;
        if (!method) throw new Error(this.FULLSCREEN_UNSUPPORTED_ERROR);
        return method.call(_document);
    },
    on: function(eventType, callback) {
        var eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.addEventListener(eventName, callback);
    },
    off: function(eventType, callback) {
        var eventName = this.getEventName(eventType);
        if (!eventName) return;
        document.removeEventListener(eventName, callback);
    }
};
function $c020e53fc27b31fb$export$873ff9d3a24fe223() {
    var props = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var target = props.target, onChange = props.onChange, onError = props.onError, requestFullScreenOptions = props.requestFullScreenOptions;
    var _useState19 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isFullscreenAvailable = _useState19[0], setIsFullscreenAvailable = _useState19[1];
    var _useState191 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), fullscreenElement = _useState191[0], setFullscreenElement = _useState191[1];
    var _useState192 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isFullscreenEnabled = _useState192[0], setIsFullscreenEnabled = _useState192[1];
    var enableFullscreen = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$FullscreenApi.requestFullscreen((target === null || target === void 0 ? void 0 : target.current) || null, requestFullScreenOptions);
    }, [
        target,
        requestFullScreenOptions
    ]);
    var disableFullscreen = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$FullscreenApi.exitFullscreen();
    }, []);
    var toggleFullscreen = (0, $eHaBZ.useCallback)(function() {
        if ($c020e53fc27b31fb$var$FullscreenApi.fullscreenElement) return disableFullscreen();
        return enableFullscreen();
    }, [
        enableFullscreen,
        disableFullscreen
    ]);
    var onChangeHandler = (0, $eHaBZ.useCallback)(function(event) {
        var fullscreenElement2 = $c020e53fc27b31fb$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onChange === null || onChange === void 0 ? void 0 : onChange(event);
    }, [
        onChange
    ]);
    var onErrorHandler = (0, $eHaBZ.useCallback)(function(event) {
        var fullscreenElement2 = $c020e53fc27b31fb$var$FullscreenApi.fullscreenElement;
        setFullscreenElement(fullscreenElement2);
        setIsFullscreenEnabled(!!fullscreenElement2);
        onError === null || onError === void 0 ? void 0 : onError(event);
    }, [
        onError
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setIsFullscreenAvailable($c020e53fc27b31fb$var$FullscreenApi.fullscreenEnabled);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        $c020e53fc27b31fb$var$FullscreenApi.on("change", onChangeHandler);
        $c020e53fc27b31fb$var$FullscreenApi.on("error", onErrorHandler);
        return function() {
            $c020e53fc27b31fb$var$FullscreenApi.off("change", onChangeHandler);
            $c020e53fc27b31fb$var$FullscreenApi.off("error", onErrorHandler);
        };
    }, [
        onChangeHandler,
        onErrorHandler
    ]);
    return {
        isFullscreenAvailable: isFullscreenAvailable,
        fullscreenElement: fullscreenElement,
        isFullscreenEnabled: isFullscreenEnabled,
        enableFullscreen: enableFullscreen,
        disableFullscreen: disableFullscreen,
        toggleFullscreen: toggleFullscreen
    };
}
var $c020e53fc27b31fb$export$f8168d8dd8fd66e6 = function(props) {
    var propsOnBlur = props.onBlur, propsOnFocus = props.onFocus, propsOnFocusChange = props.onFocusChange;
    var onBlur = (0, $eHaBZ.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (propsOnBlur) propsOnBlur(e);
            if (propsOnFocusChange) propsOnFocusChange(false);
        }
    }, [
        propsOnBlur,
        propsOnFocusChange
    ]);
    var onFocus = (0, $eHaBZ.useCallback)(function(e) {
        if (e.target === e.currentTarget) {
            if (propsOnFocus) propsOnFocus(e);
            if (propsOnFocusChange) propsOnFocusChange(true);
        }
    }, [
        propsOnFocusChange,
        propsOnFocus
    ]);
    return {
        focusProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
var $c020e53fc27b31fb$export$420e68273165f4ec = function(props) {
    var onBlurWithin = props.onBlurWithin, onFocusWithin = props.onFocusWithin, onFocusWithinChange = props.onFocusWithinChange;
    var state = (0, $eHaBZ.useRef)({
        isFocusWithin: false
    });
    var onBlur = (0, $eHaBZ.useCallback)(function(e) {
        var isFocusMovingWithin = e.relatedTarget instanceof Node && e.currentTarget.contains(e.relatedTarget);
        if (state.current.isFocusWithin && !isFocusMovingWithin) {
            state.current.isFocusWithin = false;
            if (onBlurWithin) onBlurWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(false);
        }
    }, [
        onBlurWithin,
        onFocusWithinChange
    ]);
    var onFocus = (0, $eHaBZ.useCallback)(function(e) {
        if (!state.current.isFocusWithin) {
            if (onFocusWithin) onFocusWithin(e);
            if (onFocusWithinChange) onFocusWithinChange(true);
            state.current.isFocusWithin = true;
        }
    }, [
        onFocusWithin,
        onFocusWithinChange
    ]);
    return {
        focusWithinProps: {
            onFocus: onFocus,
            onBlur: onBlur
        }
    };
};
function $c020e53fc27b31fb$export$606f11b2eb45ecc6(param) {
    var initialValues = param.initialValues, validate = param.validate, onSubmit = param.onSubmit;
    var _useState20 = (0, $21h22._)((0, $eHaBZ.useState)(initialValues), 2), values = _useState20[0], setValues = _useState20[1];
    var _useState201 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), errors = _useState201[0], setErrors = _useState201[1];
    var _useState202 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), touched = _useState202[0], setTouched = _useState202[1];
    var _useState203 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isSubmitting = _useState203[0], setIsSubmitting = _useState203[1];
    var validateField = (0, $eHaBZ.useCallback)(function(name, value) {
        if (validate) return validate(name, value, values);
        return void 0;
    }, [
        validate,
        values
    ]);
    var validateForm = (0, $eHaBZ.useCallback)(function() {
        if (!validate) return true;
        var newErrors = {};
        var isValid2 = true;
        for(var key in values){
            var error = validate(key, values[key], values);
            if (error) {
                newErrors[key] = error;
                isValid2 = false;
            }
        }
        setErrors(newErrors);
        return isValid2;
    }, [
        validate,
        values
    ]);
    var isValid = Object.keys(errors).length === 0;
    var handleChange = (0, $eHaBZ.useCallback)(function(event) {
        var _event_target = event.target, name = _event_target.name, value = _event_target.value, type = _event_target.type;
        var fieldName = name;
        var fieldValue = type === "checkbox" ? event.target.checked : value;
        setValues(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), (0, $khBmn._)({}, fieldName, fieldValue));
        });
        setTouched(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), (0, $khBmn._)({}, fieldName, true));
        });
        var error = validateField(fieldName, fieldValue);
        setErrors(function(prev) {
            var newErrors = (0, $lvTkn._)({}, prev);
            if (error) newErrors[fieldName] = error;
            else delete newErrors[fieldName];
            return newErrors;
        });
    }, [
        validateField
    ]);
    var handleSubmit = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        var allTouched = {};
        for(var key in values)allTouched[key] = true;
        setTouched(allTouched);
        var formIsValid = validateForm();
        if (formIsValid && onSubmit) {
            setIsSubmitting(true);
            Promise.resolve(onSubmit(values)).finally(function() {
                setIsSubmitting(false);
            });
        }
    }, [
        values,
        validateForm,
        onSubmit
    ]);
    var setFieldValue = (0, $eHaBZ.useCallback)(function(name, value) {
        setValues(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), (0, $khBmn._)({}, name, value));
        });
    }, []);
    var setFieldError = (0, $eHaBZ.useCallback)(function(name, error) {
        setErrors(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), (0, $khBmn._)({}, name, error));
        });
    }, []);
    var setFieldTouched = (0, $eHaBZ.useCallback)(function(name, isTouched) {
        setTouched(function(prev) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, prev), (0, $khBmn._)({}, name, isTouched));
        });
    }, []);
    var reset = (0, $eHaBZ.useCallback)(function() {
        setValues(initialValues);
        setErrors({});
        setTouched({});
        setIsSubmitting(false);
    }, [
        initialValues
    ]);
    return {
        values: values,
        errors: errors,
        touched: touched,
        isSubmitting: isSubmitting,
        isValid: isValid,
        handleChange: handleChange,
        handleSubmit: handleSubmit,
        setFieldValue: setFieldValue,
        setFieldError: setFieldError,
        setFieldTouched: setFieldTouched,
        reset: reset
    };
}
function $c020e53fc27b31fb$var$getGeoLocation(options) {
    return new Promise(function(resolve, reject) {
        if (navigator.geolocation) navigator.geolocation.getCurrentPosition(function(position) {
            var coords = position.coords;
            var latitude = coords.latitude, longitude = coords.longitude;
            resolve({
                isError: false,
                lat: latitude,
                lng: longitude,
                message: ""
            });
        }, function(error) {
            resolve({
                isError: true,
                message: error && (typeof error === "undefined" ? "undefined" : (0, $2bfPH._)(error)) === "object" && "message" in error ? error.message : "Geolocation error"
            });
        }, options);
        else resolve({
            isError: true,
            message: "Geolocation is not supported for this Browser/OS."
        });
    });
}
var $c020e53fc27b31fb$var$defaultGeoLocationOptions = {
    enableHighAccuracy: false,
    maximumAge: 0,
    timeout: Number.POSITIVE_INFINITY,
    when: true
};
var $c020e53fc27b31fb$export$8c959c84e890409a = function() {
    var geoLocationOptions = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : $c020e53fc27b31fb$var$defaultGeoLocationOptions;
    var _useState21 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), geoObject = _useState21[0], setGeoObject = _useState21[1];
    var when = geoLocationOptions.when, enableHighAccuracy = geoLocationOptions.enableHighAccuracy, timeout = geoLocationOptions.timeout, maximumAge = geoLocationOptions.maximumAge;
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    (0, $eHaBZ.useEffect)(function() {
        var getGeoCode = function getGeoCode() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var value, error;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                $c020e53fc27b31fb$var$getGeoLocation({
                                    enableHighAccuracy: enableHighAccuracy,
                                    maximumAge: maximumAge,
                                    timeout: timeout,
                                    when: when
                                })
                            ];
                        case 1:
                            value = _state.sent();
                            if (getIsMounted()) setGeoObject(value);
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (getIsMounted()) setGeoObject({
                                isError: true,
                                message: error instanceof Error ? error.message : String(error)
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        if (when) getGeoCode();
    }, [
        when,
        enableHighAccuracy,
        timeout,
        maximumAge,
        getIsMounted
    ]);
    return geoObject;
};
var $c020e53fc27b31fb$var$IdlePolyfill = /*#__PURE__*/ function() {
    "use strict";
    function IdlePolyfill(threshold) {
        var _this = this;
        (0, $gd0sY._)(this, IdlePolyfill);
        (0, $khBmn._)(this, "threshold", void 0);
        (0, $khBmn._)(this, "isIdle", false);
        (0, $khBmn._)(this, "_userState", "active");
        (0, $khBmn._)(this, "_screenState", "unlocked");
        (0, $khBmn._)(this, "listeners", []);
        (0, $khBmn._)(this, "timeoutId", null);
        (0, $khBmn._)(this, "started", false);
        (0, $khBmn._)(this, "handleUserActivity", function() {
            if (_this.isIdle) {
                _this.isIdle = false;
                _this._userState = "active";
                _this.notifyListeners();
            }
            _this.resetIdleTimer();
        });
        (0, $khBmn._)(this, "handleVisibilityChange", function() {
            _this._screenState = document.hidden ? "locked" : "unlocked";
            _this.notifyListeners();
        });
        this.threshold = Math.max(threshold, 6e4);
    }
    (0, $7cSld._)(IdlePolyfill, [
        {
            key: "resetIdleTimer",
            value: function resetIdleTimer() {
                var _this = this;
                if (this.timeoutId) clearTimeout(this.timeoutId);
                this.timeoutId = window.setTimeout(function() {
                    _this.isIdle = true;
                    _this._userState = "idle";
                    _this.notifyListeners();
                }, this.threshold);
            }
        },
        {
            key: "notifyListeners",
            value: function notifyListeners() {
                this.listeners.forEach(function(listener) {
                    return listener();
                });
            }
        },
        {
            key: "userState",
            get: function get() {
                return this._userState;
            }
        },
        {
            key: "screenState",
            get: function get() {
                return this._screenState;
            }
        },
        {
            key: "isIdleState",
            get: function get() {
                return this.isIdle;
            }
        },
        {
            key: "addEventListener",
            value: function addEventListener(event, listener) {
                if (event === "change") this.listeners.push(listener);
            }
        },
        {
            key: "removeEventListener",
            value: function removeEventListener(event, listener) {
                if (event === "change") {
                    var index = this.listeners.indexOf(listener);
                    if (index > -1) this.listeners.splice(index, 1);
                }
            }
        },
        {
            key: "start",
            value: function start() {
                var _this = this;
                if (this.started) return;
                this.started = true;
                var events = [
                    "mousemove",
                    "keydown",
                    "click",
                    "scroll",
                    "touchstart"
                ];
                events.forEach(function(event) {
                    document.addEventListener(event, _this.handleUserActivity, true);
                });
                document.addEventListener("visibilitychange", this.handleVisibilityChange);
                this.resetIdleTimer();
            }
        },
        {
            key: "stop",
            value: function stop() {
                var _this = this;
                if (!this.started) return;
                this.started = false;
                var events = [
                    "mousemove",
                    "keydown",
                    "click",
                    "scroll",
                    "touchstart"
                ];
                events.forEach(function(event) {
                    document.removeEventListener(event, _this.handleUserActivity, true);
                });
                document.removeEventListener("visibilitychange", this.handleVisibilityChange);
                if (this.timeoutId) {
                    clearTimeout(this.timeoutId);
                    this.timeoutId = null;
                }
                this.isIdle = false;
                this._userState = "active";
                this._screenState = "unlocked";
            }
        }
    ]);
    return IdlePolyfill;
}();
function $c020e53fc27b31fb$export$8c23cdf9de53b14f() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_threshold = options.threshold, threshold = _options_threshold === void 0 ? 6e4 : _options_threshold, _options_autoStart = options.// Default 60 seconds
    autoStart, autoStart = _options_autoStart === void 0 ? false : _options_autoStart, _options_requestPermission = options.requestPermission, requestPermission = _options_requestPermission === void 0 ? false : _options_requestPermission, onIdleChange = options.onIdleChange, onError = options.onError;
    var _useState22 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isIdle = _useState22[0], setIsIdle = _useState22[1];
    var _useState221 = (0, $21h22._)((0, $eHaBZ.useState)("active"), 2), userState = _useState221[0], setUserState = _useState221[1];
    var _useState222 = (0, $21h22._)((0, $eHaBZ.useState)("unlocked"), 2), screenState = _useState222[0], setScreenState = _useState222[1];
    var _useState223 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPermissionGranted = _useState223[0], setIsPermissionGranted = _useState223[1];
    var detectorRef = (0, $eHaBZ.useRef)(null);
    var polyfillRef = (0, $eHaBZ.useRef)(null);
    var startedRef = (0, $eHaBZ.useRef)(false);
    var isSupported = typeof window !== "undefined" && "IdleDetector" in window;
    var actualThreshold = Math.max(threshold, 6e4);
    var handleChange = (0, $eHaBZ.useCallback)(function() {
        var detector = detectorRef.current;
        var polyfill = polyfillRef.current;
        var newIsIdle = false;
        var newUserState = "active";
        var newScreenState = "unlocked";
        if (detector && detector.userState && detector.screenState) {
            newIsIdle = detector.userState === "idle";
            newUserState = detector.userState;
            newScreenState = detector.screenState;
        } else if (polyfill) {
            newIsIdle = polyfill.isIdleState;
            newUserState = polyfill.userState;
            newScreenState = polyfill.screenState;
        }
        setIsIdle(newIsIdle);
        setUserState(newUserState);
        setScreenState(newScreenState);
        onIdleChange === null || onIdleChange === void 0 ? void 0 : onIdleChange({
            isIdle: newIsIdle,
            userState: newUserState,
            screenState: newScreenState
        });
    }, [
        onIdleChange
    ]);
    var start = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var detector, permission, polyfill, error;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (startedRef.current) return [
                            2
                        ];
                        startedRef.current = true;
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            8,
                            ,
                            9
                        ]);
                        if (!(isSupported && window.IdleDetector)) return [
                            3,
                            6
                        ];
                        detector = new window.IdleDetector();
                        detectorRef.current = detector;
                        if (!requestPermission) return [
                            3,
                            3
                        ];
                        return [
                            4,
                            window.IdleDetector.requestPermission()
                        ];
                    case 2:
                        permission = _state.sent();
                        setIsPermissionGranted(permission === "granted");
                        if (permission === "denied") {
                            onError === null || onError === void 0 ? void 0 : onError(new Error("Permission denied"));
                            return [
                                2
                            ];
                        }
                        return [
                            3,
                            4
                        ];
                    case 3:
                        setIsPermissionGranted(true);
                        _state.label = 4;
                    case 4:
                        detector.addEventListener("change", handleChange);
                        return [
                            4,
                            detector.start({
                                threshold: actualThreshold
                            })
                        ];
                    case 5:
                        _state.sent();
                        return [
                            3,
                            7
                        ];
                    case 6:
                        polyfill = new $c020e53fc27b31fb$var$IdlePolyfill(actualThreshold);
                        polyfillRef.current = polyfill;
                        polyfill.addEventListener("change", handleChange);
                        polyfill.start();
                        setIsPermissionGranted(true);
                        _state.label = 7;
                    case 7:
                        return [
                            3,
                            9
                        ];
                    case 8:
                        error = _state.sent();
                        onError === null || onError === void 0 ? void 0 : onError(error instanceof Error ? error : new Error("Failed to start idle detection"));
                        return [
                            3,
                            9
                        ];
                    case 9:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        requestPermission,
        actualThreshold,
        handleChange,
        onError
    ]);
    var stop = (0, $eHaBZ.useCallback)(function() {
        if (!startedRef.current) return;
        startedRef.current = false;
        if (detectorRef.current) {
            detectorRef.current.removeEventListener("change", handleChange);
            detectorRef.current = null;
        }
        if (polyfillRef.current) {
            polyfillRef.current.removeEventListener("change", handleChange);
            polyfillRef.current.stop();
            polyfillRef.current = null;
        }
        setIsIdle(false);
        setUserState("active");
        setScreenState("unlocked");
    }, [
        handleChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (autoStart && !startedRef.current) start();
    }, [
        autoStart,
        start
    ]);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            stop();
        };
    }, [
        stop
    ]);
    return {
        isIdle: isIdle,
        userState: userState,
        screenState: screenState,
        isSupported: isSupported,
        isPermissionGranted: isPermissionGranted,
        start: start,
        stop: stop
    };
}
var $c020e53fc27b31fb$var$defaultOptions = {};
function $c020e53fc27b31fb$export$1e36b9f257eee5fa() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "", options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$defaultOptions;
    var _useState23 = (0, $21h22._)((0, $eHaBZ.useState)(initialValue), 2), value = _useState23[0], setValue = _useState23[1];
    var onChange = (0, $eHaBZ.useCallback)(function(event) {
        var newValue = event.target.value;
        var shouldUpdate = true;
        if (typeof options.validate === "function") shouldUpdate = options.validate(newValue, value);
        if (shouldUpdate) setValue(newValue);
    }, [
        options,
        value
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setValue(initialValue);
    }, [
        initialValue
    ]);
    var handler = {
        onChange: onChange,
        value: value
    };
    return handler;
}
var $c020e53fc27b31fb$var$defaultMeasurements = {
    innerWidth: 0,
    innerHeight: 0,
    innerScrollWidth: 0,
    innerScrollHeight: 0,
    outerWidth: 0,
    outerHeight: 0,
    outerScrollWidth: 0,
    outerScrollHeight: 0
};
function $c020e53fc27b31fb$var$getMeasurements(element) {
    return {
        innerWidth: element.clientWidth,
        innerHeight: element.clientHeight,
        innerScrollWidth: element.scrollWidth,
        innerScrollHeight: element.scrollHeight,
        outerWidth: element.offsetWidth,
        outerHeight: element.offsetHeight,
        outerScrollWidth: element.scrollWidth,
        outerScrollHeight: element.scrollHeight
    };
}
function $c020e53fc27b31fb$export$e295b0c537d32d7d() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var tmp = options.debounce, debounce2 = tmp === void 0 ? 0 : tmp, _options_disabled = options.disabled, disabled = _options_disabled === void 0 ? false : _options_disabled, onMeasure = options.onMeasure;
    var _useState24 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState24[0], setNode = _useState24[1];
    var _useState241 = (0, $21h22._)((0, $eHaBZ.useState)($c020e53fc27b31fb$var$defaultMeasurements), 2), measurements = _useState241[0], setMeasurements = _useState241[1];
    var onMeasureRef = (0, $eHaBZ.useRef)(onMeasure);
    var resizeObserverRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        onMeasureRef.current = onMeasure;
    });
    var measure = (0, $eHaBZ.useCallback)(function() {
        if (!node || disabled) return;
        var newMeasurements = $c020e53fc27b31fb$var$getMeasurements(node);
        setMeasurements(newMeasurements);
        if (onMeasureRef.current) onMeasureRef.current(newMeasurements);
    }, [
        node,
        disabled
    ]);
    var _useDebounceFn = (0, $21h22._)($c020e53fc27b31fb$export$ddf8f1aa96b8ea88(measure, debounce2, {
        leading: false,
        trailing: true
    }), 1), debouncedMeasure = _useDebounceFn[0];
    var measureFunction = debounce2 > 0 ? debouncedMeasure : measure;
    var handleResizeObserver = (0, $eHaBZ.useCallback)(function() {
        measureFunction();
    }, [
        measureFunction
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!node || disabled) {
            if (resizeObserverRef.current) {
                resizeObserverRef.current.disconnect();
                resizeObserverRef.current = null;
            }
            return 0, $e146ef819c676a18$export$8793edee2d425525;
        }
        if (typeof ResizeObserver === "undefined") {
            console.warn("useMeasure: ResizeObserver is not available in this environment");
            return 0, $e146ef819c676a18$export$8793edee2d425525;
        }
        var observer = new ResizeObserver(handleResizeObserver);
        resizeObserverRef.current = observer;
        observer.observe(node, {
            box: "content-box"
        });
        measureFunction();
        return function() {
            observer.disconnect();
            resizeObserverRef.current = null;
        };
    }, [
        node,
        disabled,
        handleResizeObserver,
        measureFunction
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        setNode(element);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window === "undefined") console.warn("useMeasure: window is undefined (SSR environment)");
    }, []);
    return [
        ref,
        measurements
    ];
}
var $c020e53fc27b31fb$var$config3 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $c020e53fc27b31fb$export$44b5bb7485b3d5ca(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config3;
    var _options_root = options.root, root = _options_root === void 0 ? null : _options_root, rootMargin = options.rootMargin, threshold = options.threshold;
    var _useState25 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState25[0], setNode = _useState25[1];
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handleIntersectionObserver = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _callbackRef_current;
        var _callbackRef_current1;
        return (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
            callbackRef
        ].concat((0, $6zk1M._)(args)));
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new IntersectionObserver(handleIntersectionObserver, {
                root: root,
                rootMargin: rootMargin,
                threshold: threshold
            });
            observer.observe(node);
            return function() {
                observer.disconnect();
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        node,
        handleIntersectionObserver,
        root,
        rootMargin,
        threshold
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref
    ];
}
var $c020e53fc27b31fb$var$config4 = {
    root: null,
    rootMargin: "0px 0px 0px 0px",
    threshold: [
        0,
        1
    ]
};
function $c020e53fc27b31fb$export$14734974288d5830(callbackOrOptions, options) {
    var callback = typeof callbackOrOptions === "function" ? callbackOrOptions : (0, $e146ef819c676a18$export$8793edee2d425525);
    var opts = (typeof callbackOrOptions === "undefined" ? "undefined" : (0, $2bfPH._)(callbackOrOptions)) === "object" ? callbackOrOptions : options || $c020e53fc27b31fb$var$config4;
    var _opts_root = opts.root, root = _opts_root === void 0 ? null : _opts_root, rootMargin = opts.rootMargin, threshold = opts.threshold;
    var _useState26 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState26[0], setNode = _useState26[1];
    var _useState261 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), inView = _useState261[0], setInView = _useState261[1];
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new IntersectionObserver(function(entries, observerRef) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = entries[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var isIntersecting = _step.value.isIntersecting;
                        setInView(isIntersecting);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                callback(entries, observerRef);
            }, opts);
            observer.observe(node);
            return function() {
                observer.disconnect();
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        node,
        callback,
        root,
        rootMargin,
        threshold,
        opts
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    return [
        ref,
        inView
    ];
}
function $c020e53fc27b31fb$export$a70fb0bde1aaaf0d() {
    var isTargetWindow = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
    var _useState27 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState27[0], setTargetNode = _useState27[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var _useState271 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isDroppingFiles = _useState271[0], setIsDroppingFiles = _useState271[1];
    var handleDragEnter = (0, $eHaBZ.useCallback)(function(e) {
        var _e_dataTransfer;
        e.preventDefault();
        if ((_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    var handleDragOver = (0, $eHaBZ.useCallback)(function(e) {
        var _e_dataTransfer;
        e.preventDefault();
        if ((_e_dataTransfer = e.dataTransfer) === null || _e_dataTransfer === void 0 ? void 0 : _e_dataTransfer.types.includes("Files")) {
            if (!isDroppingFiles) setIsDroppingFiles(true);
        } else setIsDroppingFiles(false);
    }, [
        isDroppingFiles
    ]);
    var handleDragLeave = (0, $eHaBZ.useCallback)(function(e) {
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    var handleDrop = (0, $eHaBZ.useCallback)(function(e) {
        e.preventDefault();
        setIsDroppingFiles(false);
    }, []);
    var freshHandleDragEnter = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragEnter);
    var freshHandleDragOver = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragOver);
    var freshHandleDragLeave = $c020e53fc27b31fb$export$b3553245f2c17524(handleDragLeave);
    var freshHandleDrop = $c020e53fc27b31fb$export$b3553245f2c17524(handleDrop);
    (0, $eHaBZ.useEffect)(function() {
        var target = isTargetWindow ? window : targetNode;
        if (target) {
            target.addEventListener("dragenter", freshHandleDragEnter);
            target.addEventListener("dragover", freshHandleDragOver);
            target.addEventListener("dragleave", freshHandleDragLeave);
            target.addEventListener("drop", freshHandleDrop);
        }
        return function() {
            if (target) {
                target.removeEventListener("dragenter", freshHandleDragEnter);
                target.removeEventListener("dragover", freshHandleDragOver);
                target.removeEventListener("dragleave", freshHandleDragLeave);
                target.removeEventListener("drop", freshHandleDrop);
            }
        };
    }, [
        freshHandleDragEnter,
        freshHandleDragLeave,
        freshHandleDragOver,
        freshHandleDrop,
        isDroppingFiles,
        isTargetWindow,
        targetNode
    ]);
    if (isTargetWindow) return isDroppingFiles;
    return [
        ref,
        isDroppingFiles
    ];
}
var $c020e53fc27b31fb$var$defaultOptions2 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $c020e53fc27b31fb$export$a41bc8a5485cb6b(keys, callback, options) {
    var keyList = (0, $eHaBZ.useMemo)(function() {
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    var internalOptions = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions2, options);
    }, [
        options
    ]);
    var when = internalOptions.when, eventTypes = internalOptions.eventTypes;
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    var target = internalOptions.target;
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $eHaBZ.useCallback)(function(event) {
        if (keyList.some(function(identifier) {
            return (0, $e146ef819c676a18$export$8f5885e0a893ee67)(event, identifier);
        })) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            if (target) {
                var targetNode = target.current;
                if (targetNode) {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var eventType = _step.value;
                            targetNode.addEventListener(eventType, handle);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                    return function() {
                        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                        try {
                            for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                                var eventType = _step.value;
                                targetNode.removeEventListener(eventType, handle);
                            }
                        } catch (err) {
                            _didIteratorError = true;
                            _iteratorError = err;
                        } finally{
                            try {
                                if (!_iteratorNormalCompletion && _iterator.return != null) {
                                    _iterator.return();
                                }
                            } finally{
                                if (_didIteratorError) {
                                    throw _iteratorError;
                                }
                            }
                        }
                    };
                }
            } else {
                var _iteratorNormalCompletion1 = true, _didIteratorError1 = false, _iteratorError1 = undefined;
                try {
                    for(var _iterator1 = eventTypes[Symbol.iterator](), _step1; !(_iteratorNormalCompletion1 = (_step1 = _iterator1.next()).done); _iteratorNormalCompletion1 = true){
                        var eventType1 = _step1.value;
                        window.addEventListener(eventType1, handle);
                    }
                } catch (err) {
                    _didIteratorError1 = true;
                    _iteratorError1 = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion1 && _iterator1.return != null) {
                            _iterator1.return();
                        }
                    } finally{
                        if (_didIteratorError1) {
                            throw _iteratorError1;
                        }
                    }
                }
                return function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var eventType = _step.value;
                            window.removeEventListener(eventType, handle);
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                };
            }
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        when,
        eventTypes,
        keyList,
        target,
        callback,
        handle
    ]);
}
// src/hooks/useKeyBindings.ts
var $c020e53fc27b31fb$export$40f9c496c4444fe4 = function(keyBindings, options) {
    for(var key in keyBindings){
        var handler = keyBindings[key];
        if (handler) $c020e53fc27b31fb$export$a41bc8a5485cb6b(key, handler, options);
    }
};
var $c020e53fc27b31fb$var$defaultOptions3 = {
    eventTypes: [
        "keydown"
    ],
    when: true
};
function $c020e53fc27b31fb$export$26675181ca12477d(keys, callback, options) {
    var _useState28 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), targetNode = _useState28[0], setTargetNode = _useState28[1];
    var ref = (0, $eHaBZ.useCallback)(function(node) {
        setTargetNode(node);
    }, []);
    var keyList = (0, $eHaBZ.useMemo)(function() {
        if (Array.isArray(keys)) return keys;
        else return [
            keys
        ];
    }, [
        keys
    ]);
    var internalOptions = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions3, options);
    }, [
        options
    ]);
    var when = internalOptions.when, eventTypes = internalOptions.eventTypes;
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handle = (0, $eHaBZ.useCallback)(function(event) {
        if (keyList.some(function(identifier) {
            return (0, $e146ef819c676a18$export$8f5885e0a893ee67)(event, identifier);
        })) callbackRef.current(event);
    }, [
        keyList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && targetNode) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var eventType = _step.value;
                    targetNode.addEventListener(eventType, handle);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            return function() {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = eventTypes[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var eventType = _step.value;
                        targetNode.removeEventListener(eventType, handle);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        targetNode,
        when,
        eventTypes,
        keyList,
        handle
    ]);
    return ref;
}
var $c020e53fc27b31fb$var$defaultOptions4 = {
    continuous: false,
    when: true
};
function $c020e53fc27b31fb$export$2006064841430665(keysList, callback, options) {
    var internalOptions = (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions4, options);
    var target = internalOptions.target, when = internalOptions.when, continuous = internalOptions.continuous, preventLostKeyup = internalOptions.preventLostKeyup;
    var savedCallback = (0, $eHaBZ.useRef)(callback);
    var pressedKeyMappingRef = (0, $eHaBZ.useRef)({});
    var PressedKeyMapping = pressedKeyMappingRef.current;
    (0, $eHaBZ.useEffect)(function() {
        savedCallback.current = callback;
    });
    var handleKeyDown = (0, $eHaBZ.useCallback)(function(event) {
        var pressedKeyIdentifier = null;
        var areAllKeysFromListPressed = false;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var identifier = _step.value;
                if ((0, $e146ef819c676a18$export$8f5885e0a893ee67)(event, identifier)) {
                    PressedKeyMapping[identifier] = true;
                    pressedKeyIdentifier = identifier;
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (keysList.every(function(identifier) {
            return Boolean(PressedKeyMapping[identifier]);
        })) areAllKeysFromListPressed = true;
        if (areAllKeysFromListPressed) {
            savedCallback.current(event);
            if (!continuous && pressedKeyIdentifier !== null) PressedKeyMapping[pressedKeyIdentifier] = false;
        }
    }, [
        keysList,
        PressedKeyMapping,
        continuous
    ]);
    var handleKeyUp = (0, $eHaBZ.useCallback)(function(event) {
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var identifier = _step.value;
                if ((0, $e146ef819c676a18$export$8f5885e0a893ee67)(event, identifier)) PressedKeyMapping[identifier] = void 0;
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    }, [
        PressedKeyMapping,
        keysList
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (when && typeof window !== "undefined") {
            var targetNode = (target === null || target === void 0 ? void 0 : target.current) ? target.current : document;
            targetNode.addEventListener("keydown", handleKeyDown);
            targetNode.addEventListener("keyup", handleKeyUp);
            return function() {
                targetNode.removeEventListener("keydown", handleKeyDown);
                targetNode.removeEventListener("keyup", handleKeyUp);
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        when,
        target,
        keysList,
        handleKeyDown,
        handleKeyUp
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (preventLostKeyup !== true) return 0, $e146ef819c676a18$export$8793edee2d425525;
        if (typeof window !== "undefined") {
            var originalAlert = window.alert;
            window.alert = function(message) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalAlert(message);
            };
            var originalConfirm = window.confirm;
            window.confirm = function(message) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalConfirm(message);
            };
            var originalPrompt = window.prompt;
            window.prompt = function(message, _default) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = keysList[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var identifier = _step.value;
                        PressedKeyMapping[identifier] = void 0;
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
                return originalPrompt(message, _default);
            };
            return function() {
                window.alert = originalAlert;
                window.confirm = originalConfirm;
                window.prompt = originalPrompt;
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        PressedKeyMapping,
        keysList,
        preventLostKeyup
    ]);
}
// src/hooks/useLifecycleLogger.ts
var $c020e53fc27b31fb$export$88d6c78aac91ea11 = function() {
    var componentName = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "Component";
    for(var _len = arguments.length, otherArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++){
        otherArgs[_key - 1] = arguments[_key];
    }
    $c020e53fc27b31fb$export$4984640464733c64(function() {
        var _console;
        (_console = console).log.apply(_console, [
            "".concat(componentName, " mounted")
        ].concat((0, $6zk1M._)(otherArgs)));
        return function() {
            return console.log("".concat(componentName, " unmounted"));
        };
    });
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        var _console;
        (_console = console).log.apply(_console, [
            "".concat(componentName, " updated")
        ].concat((0, $6zk1M._)(otherArgs)));
    });
    $c020e53fc27b31fb$export$328d69a66df243d8(function() {
        console.log("".concat(componentName, " unmounted"));
    });
};
function $c020e53fc27b31fb$export$bd4ec12442706c3d(isLocked) {
    (0, $eHaBZ.useEffect)(function() {
        if (isLocked) {
            var originalOverflow = window.getComputedStyle(document.body).overflow;
            document.body.style.overflow = "hidden";
            return function() {
                document.body.style.overflow = originalOverflow;
            };
        } else return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        isLocked
    ]);
}
function $c020e53fc27b31fb$var$getValueFromLocalStorage(key) {
    try {
        if (typeof localStorage === "undefined") return null;
        var _localStorage_getItem;
        var storedValue = (_localStorage_getItem = localStorage.getItem(key)) !== null && _localStorage_getItem !== void 0 ? _localStorage_getItem : "null";
        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error(error);
            return storedValue;
        }
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $c020e53fc27b31fb$var$saveValueToLocalStorage(key, value) {
    try {
        if (typeof localStorage === "undefined") return null;
        if (value === void 0) return localStorage.removeItem(key);
        return localStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $c020e53fc27b31fb$var$initialize(key, initialState) {
    var valueLoadedFromLocalStorage = $c020e53fc27b31fb$var$getValueFromLocalStorage(key);
    if (valueLoadedFromLocalStorage === null) return typeof initialState === "function" ? initialState() : initialState;
    else return valueLoadedFromLocalStorage;
}
function $c020e53fc27b31fb$export$1ad8e86cf52f97f1(key, initialState) {
    var _useState29 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return $c020e53fc27b31fb$var$initialize(key, initialState);
    }), 2), value = _useState29[0], setValue = _useState29[1];
    var _useState291 = (0, $21h22._)((0, $eHaBZ.useState)(key), 2), stateKey = _useState291[0], setStateKey = _useState291[1];
    var currentValueRef = (0, $eHaBZ.useRef)(value);
    var currentKeyRef = (0, $eHaBZ.useRef)(key);
    (0, $eHaBZ.useInsertionEffect)(function() {
        currentValueRef.current = value;
        currentKeyRef.current = key;
    }, [
        key,
        value
    ]);
    if (stateKey !== key) {
        setStateKey(key);
        setValue($c020e53fc27b31fb$var$initialize(key, initialState));
    }
    var isUpdateFromCrossDocumentListener = (0, $eHaBZ.useRef)(false);
    var isUpdateFromWithinDocumentListener = (0, $eHaBZ.useRef)(false);
    var updateSourceKeyRef = (0, $eHaBZ.useRef)(null);
    var customEventTypeName = (0, $eHaBZ.useMemo)(function() {
        return "rooks-".concat(key, "-localstorage-update");
    }, [
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var cameFromSynchronizedUpdate = (isUpdateFromCrossDocumentListener.current || isUpdateFromWithinDocumentListener.current) && updateSourceKeyRef.current === key;
        if (!cameFromSynchronizedUpdate) $c020e53fc27b31fb$var$saveValueToLocalStorage(key, value);
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        updateSourceKeyRef.current = null;
    }, [
        key,
        value
    ]);
    var listenToCrossDocumentStorageEvents = (0, $eHaBZ.useCallback)(function(event) {
        try {
            if (event.storageArea === localStorage && event.key === key) {
                var _event_newValue;
                var newValue = JSON.parse((_event_newValue = event.newValue) !== null && _event_newValue !== void 0 ? _event_newValue : "null");
                isUpdateFromCrossDocumentListener.current = true;
                updateSourceKeyRef.current = key;
                currentValueRef.current = newValue;
                setValue(function(currentValue) {
                    return Object.is(currentValue, newValue) ? currentValue : newValue;
                });
            }
        } catch (error) {
            isUpdateFromCrossDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return function() {
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("useLocalstorageState: window is undefined.");
            return function() {};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    var listenToCustomEventWithinDocument = (0, $eHaBZ.useCallback)(function(event) {
        try {
            var newValue = event.detail.newValue;
            isUpdateFromWithinDocumentListener.current = true;
            updateSourceKeyRef.current = key;
            currentValueRef.current = newValue;
            setValue(function(currentValue) {
                return Object.is(currentValue, newValue) ? currentValue : newValue;
            });
        } catch (error) {
            isUpdateFromWithinDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return function() {
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useLocalstorageState] document is undefined.");
            return function() {};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    var broadcastValueWithinDocument = (0, $eHaBZ.useCallback)(function(storageKey, newValue) {
        if (typeof document !== "undefined") {
            var event = new CustomEvent("rooks-".concat(storageKey, "-localstorage-update"), {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useLocalstorageState] document is undefined.");
    }, []);
    var set = (0, $eHaBZ.useCallback)(function(newValue) {
        var resolvedNewValue = typeof newValue === "function" ? newValue(currentValueRef.current) : newValue;
        var storageKey = currentKeyRef.current;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = true;
        updateSourceKeyRef.current = storageKey;
        currentValueRef.current = resolvedNewValue;
        $c020e53fc27b31fb$var$saveValueToLocalStorage(storageKey, resolvedNewValue);
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(storageKey, resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        currentKeyRef,
        currentValueRef
    ]);
    var remove = (0, $eHaBZ.useCallback)(function() {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error(error);
        }
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $c020e53fc27b31fb$export$1c18f7df404570ad(initialMapState) {
    var _useState30 = (0, $21h22._)((0, $eHaBZ.useState)(initialMapState || /* @__PURE__ */ new Map()), 2), map = _useState30[0], setMap = _useState30[1];
    var set = (0, $eHaBZ.useCallback)(function(key, value) {
        setMap(function(prevMap) {
            return new Map(prevMap.set(key, value));
        });
    }, []);
    var setMultiple = (0, $eHaBZ.useCallback)(function(entries) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            entries.forEach(function(param) {
                var _param = (0, $21h22._)(param, 2), key = _param[0], value = _param[1];
                newMap.set(key, value);
            });
            return newMap;
        });
    }, []);
    var remove = (0, $eHaBZ.useCallback)(function(key) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            newMap.delete(key);
            return newMap;
        });
    }, []);
    var removeMultiple = (0, $eHaBZ.useCallback)(function(keys) {
        setMap(function(prevMap) {
            var newMap = new Map(prevMap);
            keys.forEach(function(key) {
                newMap.delete(key);
            });
            return newMap;
        });
    }, []);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setMap(/* @__PURE__ */ new Map());
    }, []);
    var has = (0, $eHaBZ.useCallback)(function(key) {
        return map.has(key);
    }, [
        map
    ]);
    var hasSome = (0, $eHaBZ.useCallback)(function(keys) {
        return keys.some(function(key) {
            return map.has(key);
        });
    }, [
        map
    ]);
    var hasEvery = (0, $eHaBZ.useCallback)(function(keys) {
        return keys.every(function(key) {
            return map.has(key);
        });
    }, [
        map
    ]);
    var get = (0, $eHaBZ.useCallback)(function(key) {
        return map.get(key);
    }, [
        map
    ]);
    var size = (0, $eHaBZ.useCallback)(function() {
        return map.size;
    }, [
        map
    ]);
    var controls = {
        set: set,
        remove: remove,
        clear: clear,
        has: has,
        get: get,
        size: size,
        setMultiple: setMultiple,
        removeMultiple: removeMultiple,
        hasSome: hasSome,
        hasEvery: hasEvery
    };
    return [
        map,
        controls
    ];
}
function $c020e53fc27b31fb$export$b1eecdc553bff745(query) {
    var defaultServerRenderedValue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        var mediaQueryList = window.matchMedia(query);
        mediaQueryList.addEventListener("change", onStoreChange);
        return function() {
            return mediaQueryList.removeEventListener("change", onStoreChange);
        };
    }, [
        query
    ]);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return window.matchMedia(query).matches;
    }, [
        query
    ]);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return defaultServerRenderedValue;
    }, [
        defaultServerRenderedValue
    ]);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $c020e53fc27b31fb$export$75af6b43202b4fc9(stream) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState31 = (0, $21h22._)((0, $eHaBZ.useState)("idle"), 2), recordingState = _useState31[0], setRecordingState = _useState31[1];
    var _useState311 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), data = _useState311[0], setData = _useState311[1];
    var _useState312 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), dataUrl = _useState312[0], setDataUrl = _useState312[1];
    var _useState313 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState313[0], setError = _useState313[1];
    var mediaRecorderRef = (0, $eHaBZ.useRef)(null);
    var chunksRef = (0, $eHaBZ.useRef)([]);
    var isSupported = typeof window !== "undefined" && "MediaRecorder" in window;
    var stableOptions = (0, $eHaBZ.useMemo)(function() {
        return options;
    }, [
        JSON.stringify(options)
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isSupported || !stream) return;
        try {
            var mediaRecorder = new MediaRecorder(stream, stableOptions);
            mediaRecorderRef.current = mediaRecorder;
            mediaRecorder.ondataavailable = function(event) {
                if (event.data.size > 0) chunksRef.current.push(event.data);
            };
            mediaRecorder.onstop = function() {
                var blob = new Blob(chunksRef.current, {
                    type: options.mimeType || "video/webm"
                });
                setData(blob);
                setDataUrl(URL.createObjectURL(blob));
                setRecordingState("stopped");
                chunksRef.current = [];
            };
            mediaRecorder.onerror = function(event) {
                var _event_error;
                var _$err = new Error("MediaRecorder error: ".concat(((_event_error = event.error) === null || _event_error === void 0 ? void 0 : _event_error.message) || "Unknown error"));
                setError(_$err);
                setRecordingState("idle");
            };
            return function() {
                if (mediaRecorder.state !== "inactive") mediaRecorder.stop();
            };
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to create MediaRecorder");
            setError(error2);
        }
    }, [
        stream,
        stableOptions,
        isSupported
    ]);
    var startRecording = (0, $eHaBZ.useCallback)(function() {
        if (!isSupported) {
            var _$err = new Error("MediaRecorder is not supported");
            setError(_$err);
            return;
        }
        if (!mediaRecorderRef.current) {
            var _$err1 = new Error("MediaRecorder not initialized");
            setError(_$err1);
            return;
        }
        try {
            chunksRef.current = [];
            setData(null);
            setDataUrl(null);
            setError(null);
            mediaRecorderRef.current.start();
            setRecordingState("recording");
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to start recording");
            setError(error2);
        }
    }, [
        isSupported
    ]);
    var stopRecording = (0, $eHaBZ.useCallback)(function() {
        if (mediaRecorderRef.current && recordingState !== "idle") try {
            mediaRecorderRef.current.stop();
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to stop recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    var pauseRecording = (0, $eHaBZ.useCallback)(function() {
        if (mediaRecorderRef.current && recordingState === "recording") try {
            mediaRecorderRef.current.pause();
            setRecordingState("paused");
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to pause recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    var resumeRecording = (0, $eHaBZ.useCallback)(function() {
        if (mediaRecorderRef.current && recordingState === "paused") try {
            mediaRecorderRef.current.resume();
            setRecordingState("recording");
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to resume recording");
            setError(error2);
        }
    }, [
        recordingState
    ]);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            if (dataUrl) URL.revokeObjectURL(dataUrl);
        };
    }, [
        dataUrl
    ]);
    return {
        startRecording: startRecording,
        stopRecording: stopRecording,
        pauseRecording: pauseRecording,
        resumeRecording: resumeRecording,
        recordingState: recordingState,
        data: data,
        dataUrl: dataUrl,
        error: error,
        isSupported: isSupported
    };
}
function $c020e53fc27b31fb$var$setRef(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref !== null && ref !== void 0) ref.current = value;
}
function $c020e53fc27b31fb$export$74665b213cb5c4cf() {
    for(var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++){
        refs[_key] = arguments[_key];
    }
    return (0, $eHaBZ.useMemo)(function() {
        if (refs.every(function(ref) {
            return ref === null;
        })) return null;
        return function(refValue) {
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = refs[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var ref = _step.value;
                    $c020e53fc27b31fb$var$setRef(ref, refValue);
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
        };
    }, [
        refs
    ]);
}
var $c020e53fc27b31fb$var$initialMouseState = {
    clientX: null,
    clientY: null,
    movementX: null,
    movementY: null,
    offsetX: null,
    offsetY: null,
    pageX: null,
    pageY: null,
    screenX: null,
    screenY: null,
    x: null,
    y: null
};
function $c020e53fc27b31fb$var$getMousePositionFromEvent(event) {
    var screenX = event.screenX, screenY = event.screenY, movementX = event.movementX, movementY = event.movementY, pageX = event.pageX, pageY = event.pageY, clientX = event.clientX, clientY = event.clientY, offsetX = event.offsetX, offsetY = event.offsetY;
    return {
        clientX: clientX,
        clientY: clientY,
        movementX: movementX,
        movementY: movementY,
        offsetX: offsetX,
        offsetY: offsetY,
        pageX: pageX,
        pageY: pageY,
        screenX: screenX,
        screenY: screenY,
        x: screenX,
        y: screenY
    };
}
function $c020e53fc27b31fb$export$70811b4970b0f258() {
    var cacheRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$initialMouseState);
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        var handleMouseMove = function(event) {
            cacheRef.current = $c020e53fc27b31fb$var$getMousePositionFromEvent(event);
            onStoreChange();
        };
        document.addEventListener("mousemove", handleMouseMove);
        return function() {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return cacheRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$initialMouseState;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
var $c020e53fc27b31fb$var$initialReturnValue = {
    deltaX: 0,
    deltaY: 0,
    velocityX: 0,
    velocityY: 0
};
function $c020e53fc27b31fb$export$7b61ea4399b4754c() {
    var stateRef = (0, $eHaBZ.useRef)({
        deltaX: 0,
        deltaY: 0,
        clientX: null,
        clientY: null,
        velocityX: 0,
        velocityY: 0,
        timeStamp: Date.now()
    });
    var returnValueRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$initialReturnValue);
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        var handleMouseMove = function(event) {
            var currentTimestamp = event.timeStamp;
            var lastState = stateRef.current;
            if (lastState.clientX !== null && lastState.clientY !== null) {
                var deltaX = event.clientX - lastState.clientX;
                var deltaY = event.clientY - lastState.clientY;
                var timeDelta = currentTimestamp - lastState.timeStamp;
                var velocityX = timeDelta === 0 ? 0 : deltaX / timeDelta;
                var velocityY = timeDelta === 0 ? 0 : deltaY / timeDelta;
                stateRef.current = {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    velocityX: velocityX,
                    velocityY: velocityY,
                    timeStamp: currentTimestamp
                };
                returnValueRef.current = {
                    deltaX: deltaX,
                    deltaY: deltaY,
                    velocityX: velocityX,
                    velocityY: velocityY
                };
            } else {
                stateRef.current = {
                    deltaX: 0,
                    deltaY: 0,
                    clientX: event.clientX,
                    clientY: event.clientY,
                    velocityX: 0,
                    velocityY: 0,
                    timeStamp: event.timeStamp
                };
                returnValueRef.current = {
                    deltaX: 0,
                    deltaY: 0,
                    velocityX: 0,
                    velocityY: 0
                };
            }
            onStoreChange();
        };
        document.addEventListener("mousemove", handleMouseMove, {
            passive: true
        });
        return function() {
            document.removeEventListener("mousemove", handleMouseMove);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return returnValueRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$initialReturnValue;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
var $c020e53fc27b31fb$var$initialReturnValue2 = {
    delta: 0,
    velocity: 0
};
function $c020e53fc27b31fb$export$145b759060b8fae5() {
    var stateRef = (0, $eHaBZ.useRef)(null);
    var returnValueRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$initialReturnValue2);
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        var handleWheel = function(event) {
            var currentTimestamp = event.timeStamp;
            var lastState = stateRef.current;
            if (lastState !== null) {
                var delta = event.deltaY;
                var timeDelta = currentTimestamp - lastState.timeStamp;
                var velocity = timeDelta === 0 ? 0 : delta / timeDelta;
                stateRef.current = {
                    delta: delta,
                    velocity: velocity,
                    timeStamp: currentTimestamp
                };
                returnValueRef.current = {
                    delta: delta,
                    velocity: velocity
                };
            } else {
                stateRef.current = {
                    delta: event.deltaY,
                    velocity: 0,
                    timeStamp: event.timeStamp
                };
                returnValueRef.current = {
                    delta: event.deltaY,
                    velocity: 0
                };
            }
            onStoreChange();
        };
        document.addEventListener("wheel", handleWheel);
        return function() {
            document.removeEventListener("wheel", handleWheel);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return returnValueRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$initialReturnValue2;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided(functionName, object) {
    if (Object.values(object).every(function(value) {
        return typeof value !== "undefined";
    })) console.warn("".concat(functionName, ". Expected either ").concat(Object.keys(object).join(" or "), " to be provided. However all were provided"));
    else if (Object.values(object).every(function(value) {
        return typeof value === "undefined";
    })) console.warn("".concat(functionName, ". ").concat(Object.keys(object).join(" , "), " are all undefined."));
}
function $c020e53fc27b31fb$export$a7f42c7977b517c0() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], initialSelectIndices = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [
        0
    ], allowUnselected = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useState32 = (0, $21h22._)((0, $eHaBZ.useState)(initialSelectIndices), 2), currentIndices = _useState32[0], setCurrentIndices = _useState32[1];
    var currentValues = currentIndices.map(function(index) {
        return list[index];
    }).filter(function(value) {
        return value !== void 0;
    });
    var selection = [
        currentIndices,
        currentValues
    ];
    var updateSelections = function(param) {
        var indices = param.indices, values = param.values;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("updateSelections", {
                indices: indices,
                values: values
            });
            if (typeof indices !== "undefined") {
                if (!allowUnselected && indices.length === 0) {
                    console.warn("updateSelections failed. indices is an empty list.");
                    return;
                }
                setCurrentIndices(indices);
            } else if (typeof values !== "undefined") {
                var valueIndices = list.reduce(function(accumulator, current, index) {
                    if (values.includes(current)) {
                        var array = (0, $6zk1M._)(accumulator).concat([
                            index
                        ]);
                        return array;
                    }
                    return accumulator;
                }, []);
                if (valueIndices.length > 0) setCurrentIndices(valueIndices);
                else if (allowUnselected) setCurrentIndices(valueIndices);
                else console.warn("updateSelections failed. Do the values exist in the list?");
            }
        };
    };
    var toggleSelectionByIndex = (0, $eHaBZ.useCallback)(function(index) {
        var newIndices;
        if (!currentIndices.includes(index)) newIndices = (0, $6zk1M._)(currentIndices).concat([
            index
        ]);
        else {
            newIndices = (0, $6zk1M._)(currentIndices);
            var indexOfIndex = currentIndices.indexOf(index);
            if (indexOfIndex !== -1) newIndices.splice(indexOfIndex, 1);
        }
        if (newIndices.length > 0) setCurrentIndices(newIndices);
        else if (allowUnselected) setCurrentIndices(newIndices);
        else console.warn("toggleSelection failed. Do the values exist in the list?");
    }, [
        allowUnselected,
        currentIndices
    ]);
    var toggleSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") toggleSelectionByIndex(index);
            else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) toggleSelectionByIndex(valueIndex);
            }
        };
    }, [
        list,
        toggleSelectionByIndex
    ]);
    var matchSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return currentIndices.includes(index);
        else if (typeof value !== "undefined") return currentValues.includes(value);
        return false;
    }, [
        currentIndices,
        currentValues
    ]);
    var controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelections: updateSelections
    };
    return [
        selection,
        controls
    ];
}
function $c020e53fc27b31fb$var$getLanguageSnapshot() {
    if (typeof navigator !== "undefined") return navigator.language;
    else return null;
}
function $c020e53fc27b31fb$var$getLanguageSubscription(callback) {
    if (typeof window !== "undefined") {
        window.addEventListener("languagechange", callback);
        return function() {
            window.removeEventListener("languagechange", callback);
        };
    }
    return function() {};
}
function $c020e53fc27b31fb$var$getLanguageServerSnapshot() {
    return null;
}
function $c020e53fc27b31fb$export$64fd3a716d6bb70f() {
    return (0, $eHaBZ.useSyncExternalStore)($c020e53fc27b31fb$var$getLanguageSubscription, $c020e53fc27b31fb$var$getLanguageSnapshot, $c020e53fc27b31fb$var$getLanguageServerSnapshot);
}
function $c020e53fc27b31fb$var$getConnection() {
    if (typeof navigator === "undefined") return null;
    var nav = navigator;
    return nav.connection || nav.mozConnection || nav.webkitConnection || null;
}
function $c020e53fc27b31fb$var$getNetworkInfo() {
    var connection = $c020e53fc27b31fb$var$getConnection();
    if (!connection) return {
        type: null,
        effectiveType: null,
        downlink: null,
        downlinkMax: null,
        rtt: null,
        saveData: false
    };
    var _connection_downlink, _connection_downlinkMax, _connection_rtt, _connection_saveData;
    return {
        type: connection.type || null,
        effectiveType: connection.effectiveType || null,
        downlink: (_connection_downlink = connection.downlink) !== null && _connection_downlink !== void 0 ? _connection_downlink : null,
        downlinkMax: (_connection_downlinkMax = connection.downlinkMax) !== null && _connection_downlinkMax !== void 0 ? _connection_downlinkMax : null,
        rtt: (_connection_rtt = connection.rtt) !== null && _connection_rtt !== void 0 ? _connection_rtt : null,
        saveData: (_connection_saveData = connection.saveData) !== null && _connection_saveData !== void 0 ? _connection_saveData : false
    };
}
var $c020e53fc27b31fb$var$defaultNetworkInfo = {
    type: null,
    effectiveType: null,
    downlink: null,
    downlinkMax: null,
    rtt: null,
    saveData: false,
    isSupported: false
};
function $c020e53fc27b31fb$export$c4fda957ffe4f2ef() {
    var cacheRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$defaultNetworkInfo);
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        var connection = $c020e53fc27b31fb$var$getConnection();
        if (!connection) return function() {};
        connection.addEventListener("change", onStoreChange);
        return function() {
            connection.removeEventListener("change", onStoreChange);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        var networkInfo = $c020e53fc27b31fb$var$getNetworkInfo();
        var isSupported = $c020e53fc27b31fb$var$getConnection() !== null;
        if (cacheRef.current.type !== networkInfo.type || cacheRef.current.effectiveType !== networkInfo.effectiveType || cacheRef.current.downlink !== networkInfo.downlink || cacheRef.current.downlinkMax !== networkInfo.downlinkMax || cacheRef.current.rtt !== networkInfo.rtt || cacheRef.current.saveData !== networkInfo.saveData || cacheRef.current.isSupported !== isSupported) cacheRef.current = (0, $9Jpjh._)((0, $lvTkn._)({}, networkInfo), {
            isSupported: isSupported
        });
        return cacheRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$defaultNetworkInfo;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $c020e53fc27b31fb$export$9949bd9c713ba425() {
    var isSupported = typeof window !== "undefined" && "Notification" in window;
    var _useState33 = (0, $21h22._)((0, $eHaBZ.useState)(isSupported ? Notification.permission : "default"), 2), permission = _useState33[0], setPermission = _useState33[1];
    (0, $eHaBZ.useEffect)(function() {
        if (isSupported) setPermission(Notification.permission);
    }, [
        isSupported
    ]);
    var requestPermission = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var result, permissionState, error;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            console.warn("Notification API is not supported");
                            return [
                                2,
                                "denied"
                            ];
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            Notification.requestPermission()
                        ];
                    case 2:
                        result = _state.sent();
                        permissionState = result;
                        setPermission(permissionState);
                        return [
                            2,
                            permissionState
                        ];
                    case 3:
                        error = _state.sent();
                        console.error("Error requesting notification permission:", error);
                        return [
                            2,
                            "denied"
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    var show = (0, $eHaBZ.useCallback)(function(title, options) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var notification;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                if (!isSupported) {
                    console.warn("Notification API is not supported");
                    return [
                        2,
                        null
                    ];
                }
                if (permission !== "granted") {
                    console.warn("Notification permission not granted. Current permission:", permission);
                    return [
                        2,
                        null
                    ];
                }
                try {
                    notification = new Notification(title, options);
                    return [
                        2,
                        notification
                    ];
                } catch (error) {
                    console.error("Error showing notification:", error);
                    return [
                        2,
                        null
                    ];
                }
                return [
                    2
                ];
            });
        })();
    }, [
        isSupported,
        permission
    ]);
    return {
        show: show,
        permission: permission,
        requestPermission: requestPermission,
        isSupported: isSupported
    };
}
function $c020e53fc27b31fb$export$1d0625984c38ae85(onClick) {
    var _useState34 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState34[0], setNode = _useState34[1];
    var handleEvent = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        onClick();
    }, [
        onClick
    ]);
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleEvent);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            node.addEventListener("click", freshCallback);
            node.addEventListener("touchend", freshCallback);
            return function() {
                node.removeEventListener("click", freshCallback);
                node.removeEventListener("touchend", freshCallback);
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        node,
        freshCallback
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(element) {
        if (element) setNode(element);
    }, []);
    return ref;
}
function $c020e53fc27b31fb$export$a95d525b9d8df060(onMouseEnter, onMouseLeave) {
    var _useState35 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState35[0], setNode = _useState35[1];
    var handleMouseEnter = (0, $eHaBZ.useCallback)(function(e) {
        onMouseEnter === null || onMouseEnter === void 0 ? void 0 : onMouseEnter(e);
    }, [
        onMouseEnter
    ]);
    var handleMouseLeave = (0, $eHaBZ.useCallback)(function(e) {
        onMouseLeave === null || onMouseLeave === void 0 ? void 0 : onMouseLeave(e);
    }, [
        onMouseLeave
    ]);
    var mouseEnterCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleMouseEnter);
    var mouseLeaveCallback = $c020e53fc27b31fb$export$b3553245f2c17524(handleMouseLeave);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            node.addEventListener("mouseenter", mouseEnterCallback);
            node.addEventListener("mouseleave", mouseLeaveCallback);
            return function() {
                node.removeEventListener("mouseenter", mouseEnterCallback);
                node.removeEventListener("mouseleave", mouseLeaveCallback);
            };
        } else return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        mouseEnterCallback,
        mouseLeaveCallback,
        node
    ]);
    var ref = function(el) {
        setNode(el);
    };
    return ref;
}
function $c020e53fc27b31fb$var$getSnapshot() {
    if (typeof window === "undefined") return null;
    return navigator.onLine;
}
function $c020e53fc27b31fb$var$subscribe(onStoreChange) {
    if (typeof window !== "undefined") {
        window.addEventListener("online", onStoreChange);
        window.addEventListener("offline", onStoreChange);
        return function() {
            window.removeEventListener("online", onStoreChange);
            window.removeEventListener("offline", onStoreChange);
        };
    } else {
        console.warn("useOnline: window is undefined.");
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }
}
function $c020e53fc27b31fb$export$6feb6ada280bcdab() {
    var isOnline = (0, $2065ab085cb8cea8$exports.useSyncExternalStore)($c020e53fc27b31fb$var$subscribe, $c020e53fc27b31fb$var$getSnapshot, function() {
        return null;
    });
    return isOnline;
}
var $c020e53fc27b31fb$export$550084c67147f6c4 = function() {
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        window.screen.orientation.addEventListener("change", onStoreChange);
        return function() {
            window.screen.orientation.removeEventListener("change", onStoreChange);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return window.screen.orientation;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return null;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
};
function $c020e53fc27b31fb$export$6bd1f37e929013e5(onPageLeave) {
    var freshCallback = $c020e53fc27b31fb$export$b3553245f2c17524(onPageLeave);
    var isLeavingRef = (0, $eHaBZ.useRef)(false);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window === "undefined") return;
        var handleBeforeUnload = function(event) {
            isLeavingRef.current = true;
            var result = freshCallback();
            if (typeof result === "string") {
                event.preventDefault();
                event.returnValue = result;
                return result;
            }
        };
        var handleVisibilityChange = function() {
            if (document.visibilityState === "hidden" && !isLeavingRef.current) freshCallback();
        };
        var handlePageHide = function() {
            if (!isLeavingRef.current) freshCallback();
        };
        window.addEventListener("beforeunload", handleBeforeUnload);
        document.addEventListener("visibilitychange", handleVisibilityChange);
        window.addEventListener("pagehide", handlePageHide);
        return function() {
            window.removeEventListener("beforeunload", handleBeforeUnload);
            document.removeEventListener("visibilitychange", handleVisibilityChange);
            window.removeEventListener("pagehide", handlePageHide);
            isLeavingRef.current = false;
        };
    }, [
        freshCallback
    ]);
}
function $c020e53fc27b31fb$export$246005d45236a985(videoRef) {
    var _useState36 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPiPActive = _useState36[0], setIsPiPActive = _useState36[1];
    var _useState361 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isSupported = _useState361[0], setIsSupported = _useState361[1];
    var _useState362 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState362[0], setError = _useState362[1];
    var _useState363 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), pipWindow = _useState363[0], setPipWindow = _useState363[1];
    var attachedVideoRef = (0, $eHaBZ.useRef)(null);
    var getIsSupported = (0, $eHaBZ.useCallback)(function() {
        if (!videoRef.current) return false;
        if (!document.pictureInPictureEnabled) return false;
        if (!videoRef.current.requestPictureInPicture) return false;
        if (videoRef.current.disablePictureInPicture) return false;
        return true;
    }, [
        videoRef
    ]);
    var checkPiPActive = (0, $eHaBZ.useCallback)(function() {
        return document.pictureInPictureElement === videoRef.current;
    }, [
        videoRef
    ]);
    var updatePiPState = (0, $eHaBZ.useCallback)(function() {
        setIsPiPActive(checkPiPActive());
    }, [
        checkPiPActive
    ]);
    var enterPiP = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var err;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!getIsSupported() || !videoRef.current) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setError(null);
                        return [
                            4,
                            videoRef.current.requestPictureInPicture()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err instanceof Error ? err : new Error(String(err)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        getIsSupported,
        videoRef
    ]);
    var exitPiP = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var err;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!document.pictureInPictureElement) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        setError(null);
                        return [
                            4,
                            document.exitPictureInPicture()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        setError(err instanceof Error ? err : new Error(String(err)));
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, []);
    var toggle = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!checkPiPActive()) return [
                            3,
                            2
                        ];
                        return [
                            4,
                            exitPiP()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 2:
                        return [
                            4,
                            enterPiP()
                        ];
                    case 3:
                        _state.sent();
                        _state.label = 4;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        checkPiPActive,
        exitPiP,
        enterPiP
    ]);
    var handleEnterPiP = (0, $eHaBZ.useCallback)(function(event) {
        var pipEvent = event;
        setPipWindow(pipEvent.pictureInPictureWindow);
        setIsPiPActive(true);
    }, []);
    var handleLeavePiP = (0, $eHaBZ.useCallback)(function() {
        setPipWindow(null);
        setIsPiPActive(false);
    }, []);
    (0, $e146ef819c676a18$export$363c9f3eb56bbdbe)(function() {
        var _attachedVideoRef_current, _attachedVideoRef_current1;
        var video = videoRef.current;
        var nextIsSupported = getIsSupported();
        setIsSupported(function(current) {
            return current === nextIsSupported ? current : nextIsSupported;
        });
        if (attachedVideoRef.current === video) return;
        (_attachedVideoRef_current = attachedVideoRef.current) === null || _attachedVideoRef_current === void 0 ? void 0 : _attachedVideoRef_current.removeEventListener("enterpictureinpicture", handleEnterPiP);
        (_attachedVideoRef_current1 = attachedVideoRef.current) === null || _attachedVideoRef_current1 === void 0 ? void 0 : _attachedVideoRef_current1.removeEventListener("leavepictureinpicture", handleLeavePiP);
        attachedVideoRef.current = video;
        if (video) {
            video.addEventListener("enterpictureinpicture", handleEnterPiP);
            video.addEventListener("leavepictureinpicture", handleLeavePiP);
            updatePiPState();
        }
    });
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            var _attachedVideoRef_current, _attachedVideoRef_current1;
            (_attachedVideoRef_current = attachedVideoRef.current) === null || _attachedVideoRef_current === void 0 ? void 0 : _attachedVideoRef_current.removeEventListener("enterpictureinpicture", handleEnterPiP);
            (_attachedVideoRef_current1 = attachedVideoRef.current) === null || _attachedVideoRef_current1 === void 0 ? void 0 : _attachedVideoRef_current1.removeEventListener("leavepictureinpicture", handleLeavePiP);
            attachedVideoRef.current = null;
        };
    }, [
        handleEnterPiP,
        handleLeavePiP
    ]);
    return {
        isPiPActive: isPiPActive,
        isSupported: isSupported,
        error: error,
        pipWindow: pipWindow,
        enterPiP: enterPiP,
        exitPiP: exitPiP,
        toggle: toggle
    };
}
function $c020e53fc27b31fb$var$getColorScheme() {
    if (typeof window === "undefined") return null;
    if (window.matchMedia("(prefers-color-scheme: dark)").matches) return "dark";
    if (window.matchMedia("(prefers-color-scheme: light)").matches) return "light";
    return "no-preference";
}
function $c020e53fc27b31fb$var$subscribe2(onStoreChange) {
    if (typeof window === "undefined") {
        console.warn("usePreferredColorScheme: window is undefined.");
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }
    var darkModeQuery = window.matchMedia("(prefers-color-scheme: dark)");
    var lightModeQuery = window.matchMedia("(prefers-color-scheme: light)");
    if (darkModeQuery.addEventListener) {
        darkModeQuery.addEventListener("change", onStoreChange);
        lightModeQuery.addEventListener("change", onStoreChange);
        return function() {
            darkModeQuery.removeEventListener("change", onStoreChange);
            lightModeQuery.removeEventListener("change", onStoreChange);
        };
    } else {
        var legacyDarkModeQuery = darkModeQuery;
        var legacyLightModeQuery = lightModeQuery;
        legacyDarkModeQuery.addListener(onStoreChange);
        legacyLightModeQuery.addListener(onStoreChange);
        return function() {
            legacyDarkModeQuery.removeListener(onStoreChange);
            legacyLightModeQuery.removeListener(onStoreChange);
        };
    }
}
function $c020e53fc27b31fb$export$7c3b8f854ca5e941() {
    var colorScheme = (0, $2065ab085cb8cea8$exports.useSyncExternalStore)($c020e53fc27b31fb$var$subscribe2, $c020e53fc27b31fb$var$getColorScheme, function() {
        return null;
    });
    return {
        colorScheme: colorScheme,
        isDark: colorScheme === "dark",
        isLight: colorScheme === "light"
    };
}
function $c020e53fc27b31fb$export$71b2224f1ce5e08e(ref, handler) {
    var when = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var savedHandler = (0, $eHaBZ.useRef)(handler);
    var memoizedCallback = (0, $eHaBZ.useCallback)(function(event) {
        if (ref.current && !ref.current.contains(event.target)) savedHandler.current(event);
    }, [
        ref
    ]);
    (0, $eHaBZ.useEffect)(function() {
        savedHandler.current = handler;
    });
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        ref,
        handler,
        when,
        memoizedCallback
    ]);
}
function $c020e53fc27b31fb$export$c5f9bba475faecdf(handler) {
    var when = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    var _useState37 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState37[0], setNode = _useState37[1];
    var savedHandler = (0, $eHaBZ.useRef)(handler);
    var memoizedCallback = (0, $eHaBZ.useCallback)(function(event) {
        if (node && !node.contains(event.target)) savedHandler.current(event);
    }, [
        node
    ]);
    (0, $eHaBZ.useEffect)(function() {
        savedHandler.current = handler;
    });
    var ref = (0, $eHaBZ.useCallback)(function(nodeElement) {
        setNode(nodeElement);
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (when) {
            document.addEventListener("click", memoizedCallback, true);
            document.addEventListener("touchstart", memoizedCallback, true);
            return function() {
                document.removeEventListener("click", memoizedCallback, true);
                document.removeEventListener("touchstart", memoizedCallback, true);
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        when,
        memoizedCallback
    ]);
    return [
        ref
    ];
}
// src/hooks/usePrefersReducedMotion.ts
function $c020e53fc27b31fb$export$c170580b40c8999d() {
    return $c020e53fc27b31fb$export$b1eecdc553bff745("(prefers-reduced-motion: reduce)");
}
function $c020e53fc27b31fb$export$c3eac79c5e1cdf4e(currentValue) {
    var previousRef = (0, $eHaBZ.useRef)(null);
    var previousRef2 = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        previousRef2.current = previousRef.current;
        previousRef.current = currentValue;
    }, [
        currentValue
    ]);
    return currentValue === previousRef.current ? previousRef2.current : previousRef.current;
}
function $c020e53fc27b31fb$export$f6f3f74729fdd0b7(currentValue) {
    var previousRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        previousRef.current = currentValue;
    });
    return previousRef.current;
}
function $c020e53fc27b31fb$export$dd6b79aaabe7bc37(asyncFunction) {
    var deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    var _useState38 = (0, $21h22._)((0, $eHaBZ.useState)({
        data: null,
        loading: true,
        error: null
    }), 2), state = _useState38[0], setState = _useState38[1];
    var freshAsyncCallback = $c020e53fc27b31fb$export$b3553245f2c17524(asyncFunction);
    (0, $eHaBZ.useEffect)(function() {
        var fetchData = function fetchData() {
            return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                var data, error;
                return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                    switch(_state.label){
                        case 0:
                            _state.trys.push([
                                0,
                                2,
                                ,
                                3
                            ]);
                            return [
                                4,
                                freshAsyncCallback()
                            ];
                        case 1:
                            data = _state.sent();
                            if (isMounted) setState({
                                data: data,
                                loading: false,
                                error: null
                            });
                            return [
                                3,
                                3
                            ];
                        case 2:
                            error = _state.sent();
                            if (isMounted) setState({
                                data: null,
                                loading: false,
                                error: error instanceof Error ? error : new Error(String(error))
                            });
                            return [
                                3,
                                3
                            ];
                        case 3:
                            return [
                                2
                            ];
                    }
                });
            })();
        };
        var isMounted = true;
        fetchData();
        return function() {
            isMounted = false;
        };
    }, [
        freshAsyncCallback
    ].concat((0, $6zk1M._)(deps)));
    return state;
}
function $c020e53fc27b31fb$export$4d9119e556c12833(initialList) {
    var _useState39 = (0, $21h22._)((0, $eHaBZ.useState)((0, $6zk1M._)(initialList)), 2), list = _useState39[0], setList = _useState39[1];
    var enqueue = (0, $eHaBZ.useCallback)(function(item) {
        var newList = (0, $6zk1M._)(list).concat([
            item
        ]);
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    var dequeue = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) {
            var firstItem = list[0];
            setList((0, $6zk1M._)(list.slice(1)));
            return firstItem;
        }
        return void 0;
    }, [
        list
    ]);
    var peek = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) return list[0];
        return void 0;
    }, [
        list
    ]);
    var controls = {
        dequeue: dequeue,
        enqueue: enqueue,
        length: list.length,
        peek: peek
    };
    return [
        list,
        controls
    ];
}
function $c020e53fc27b31fb$export$4d5d35ff55b6d811(initialState) {
    var _useState40 = (0, $21h22._)((0, $eHaBZ.useState)(initialState), 2), state = _useState40[0], setState = _useState40[1];
    var rafIdRef = (0, $eHaBZ.useRef)(null);
    var pendingRef = (0, $eHaBZ.useRef)(null);
    (0, $eHaBZ.useEffect)(function() {
        return function() {
            if (rafIdRef.current !== null) {
                cancelAnimationFrame(rafIdRef.current);
                rafIdRef.current = null;
            }
        };
    }, []);
    var rafSetState = (0, $eHaBZ.useCallback)(function(action) {
        if (typeof requestAnimationFrame === "undefined") {
            setState(action);
            return;
        }
        pendingRef.current = {
            action: action
        };
        if (rafIdRef.current !== null) return;
        rafIdRef.current = requestAnimationFrame(function() {
            rafIdRef.current = null;
            if (pendingRef.current !== null) {
                setState(pendingRef.current.action);
                pendingRef.current = null;
            }
        });
    }, []);
    return [
        state,
        rafSetState
    ];
}
var $c020e53fc27b31fb$var$config5 = {
    box: "content-box"
};
function $c020e53fc27b31fb$export$1e496cef3ab4aa33(callback) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$config5;
    var box = options.box;
    var _useState41 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), node = _useState41[0], setNode = _useState41[1];
    var callbackRef = (0, $eHaBZ.useRef)(callback);
    (0, $eHaBZ.useEffect)(function() {
        callbackRef.current = callback;
    });
    var handleResizeObserver = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _callbackRef_current;
        var _callbackRef_current1;
        (_callbackRef_current1 = callbackRef.current) === null || _callbackRef_current1 === void 0 ? void 0 : (_callbackRef_current = _callbackRef_current1).call.apply(_callbackRef_current, [
            callbackRef
        ].concat((0, $6zk1M._)(args)));
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (node) {
            var observer = new ResizeObserver(handleResizeObserver);
            observer.observe(node, {
                box: box
            });
            return function() {
                observer.disconnect();
            };
        }
        return 0, $e146ef819c676a18$export$8793edee2d425525;
    }, [
        node,
        handleResizeObserver,
        box
    ]);
    var ref = (0, $eHaBZ.useCallback)(function(node2) {
        setNode(node2);
    }, []);
    return [
        ref
    ];
}
function $c020e53fc27b31fb$export$894a34a32cdbdc06() {
    return ++(0, $eHaBZ.useRef)(0).current;
}
function $c020e53fc27b31fb$export$73e242da76f85109(initialState) {
    var _useState42 = (0, $21h22._)((0, $eHaBZ.useState)(initialState), 2), state = _useState42[0], setState = _useState42[1];
    var getIsMounted = $c020e53fc27b31fb$export$7aa0022395cd4c49();
    var safeSetState = (0, $eHaBZ.useCallback)(function(newState) {
        if (getIsMounted()) setState(newState);
    }, [
        getIsMounted
    ]);
    return [
        state,
        safeSetState
    ];
}
function $c020e53fc27b31fb$export$ab808b17bf61ae66() {
    var options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    var _options_requestOnMount = options.requestOnMount, requestOnMount = _options_requestOnMount === void 0 ? false : _options_requestOnMount, _options_autoRefresh = options.autoRefresh, autoRefresh = _options_autoRefresh === void 0 ? true : _options_autoRefresh;
    var _useState43 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), screens = _useState43[0], setScreens = _useState43[1];
    var _useState431 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), currentScreen = _useState431[0], setCurrentScreen = _useState431[1];
    var _useState432 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isLoading = _useState432[0], setIsLoading = _useState432[1];
    var _useState433 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), hasPermission = _useState433[0], setHasPermission = _useState433[1];
    var _useState434 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState434[0], setError = _useState434[1];
    var screenDetailsRef = (0, $eHaBZ.useRef)(null);
    var permissionStatusRef = (0, $eHaBZ.useRef)(null);
    var isSupported = (0, $eHaBZ.useMemo)(function() {
        if (typeof window === "undefined") return false;
        var screenDetailsWindow = window;
        return typeof screenDetailsWindow.getScreenDetails === "function";
    }, []);
    var primaryScreen = (0, $eHaBZ.useMemo)(function() {
        return screens.find(function(screen) {
            return screen.isPrimary;
        }) || null;
    }, [
        screens
    ]);
    var externalScreens = (0, $eHaBZ.useMemo)(function() {
        return screens.filter(function(screen) {
            return !screen.isPrimary;
        });
    }, [
        screens
    ]);
    var fetchScreenDetails = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _screenDetailsWindow_getScreenDetails, screenDetailsWindow, screenDetails, err, errorMessage;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) return [
                            2
                        ];
                        setIsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        screenDetailsWindow = window;
                        return [
                            4,
                            (_screenDetailsWindow_getScreenDetails = screenDetailsWindow.getScreenDetails) === null || _screenDetailsWindow_getScreenDetails === void 0 ? void 0 : _screenDetailsWindow_getScreenDetails.call(screenDetailsWindow)
                        ];
                    case 2:
                        screenDetails = _state.sent();
                        if (!screenDetails) throw new Error("Screen Details API is not supported");
                        screenDetailsRef.current = screenDetails;
                        setScreens(screenDetails.screens);
                        setCurrentScreen(screenDetails.currentScreen);
                        setHasPermission(true);
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        setHasPermission(false);
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    var requestPermission = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var permissionStatus, err, errorMessage;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            setError("Screen Details API is not supported");
                            return [
                                2
                            ];
                        }
                        setIsLoading(true);
                        setError(null);
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            4,
                            ,
                            5
                        ]);
                        return [
                            4,
                            navigator.permissions.query({
                                name: "window-management"
                            })
                        ];
                    case 2:
                        permissionStatus = _state.sent();
                        permissionStatusRef.current = permissionStatus;
                        if (permissionStatus.state === "denied") {
                            setError("Permission denied for window-management");
                            setHasPermission(false);
                            setIsLoading(false);
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            fetchScreenDetails()
                        ];
                    case 3:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 4:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        setHasPermission(false);
                        setIsLoading(false);
                        return [
                            3,
                            5
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        fetchScreenDetails
    ]);
    var refresh = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var err, errorMessage;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!hasPermission) return [
                            2
                        ];
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            fetchScreenDetails()
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            4
                        ];
                    case 3:
                        err = _state.sent();
                        errorMessage = err instanceof Error ? err.message : String(err);
                        setError(errorMessage);
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        hasPermission,
        fetchScreenDetails
    ]);
    var handleScreensChange = (0, $eHaBZ.useCallback)(function() {
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    var handleCurrentScreenChange = (0, $eHaBZ.useCallback)(function() {
        if (autoRefresh) refresh();
    }, [
        autoRefresh,
        refresh
    ]);
    var handlePermissionChange = (0, $eHaBZ.useCallback)(function() {
        if (permissionStatusRef.current) {
            var newState = permissionStatusRef.current.state;
            if (newState === "denied") {
                setHasPermission(false);
                setScreens([]);
                setCurrentScreen(null);
                setError("Permission denied for window-management");
            } else if (newState === "granted") {
                setHasPermission(true);
                setError(null);
                if (autoRefresh) refresh();
            }
        }
    }, [
        autoRefresh,
        refresh
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!screenDetailsRef.current) return;
        var screenDetails = screenDetailsRef.current;
        screenDetails.addEventListener("screenschange", handleScreensChange);
        screenDetails.addEventListener("currentscreenchange", handleCurrentScreenChange);
        return function() {
            screenDetails.removeEventListener("screenschange", handleScreensChange);
            screenDetails.removeEventListener("currentscreenchange", handleCurrentScreenChange);
        };
    }, [
        handleScreensChange,
        handleCurrentScreenChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!permissionStatusRef.current) return;
        var permissionStatus = permissionStatusRef.current;
        permissionStatus.addEventListener("change", handlePermissionChange);
        return function() {
            permissionStatus.removeEventListener("change", handlePermissionChange);
        };
    }, [
        handlePermissionChange
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (requestOnMount && isSupported) requestPermission();
    }, [
        requestOnMount,
        isSupported,
        requestPermission
    ]);
    return {
        screens: screens,
        currentScreen: currentScreen,
        primaryScreen: primaryScreen,
        externalScreens: externalScreens,
        isSupported: isSupported,
        isLoading: isLoading,
        hasPermission: hasPermission,
        error: error,
        requestPermission: requestPermission,
        refresh: refresh
    };
}
function $c020e53fc27b31fb$export$e64b2f635402ca43(list) {
    var initialIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var _useState44 = (0, $21h22._)((0, $eHaBZ.useState)(initialIndex), 2), selectedIndex = _useState44[0], setSelectedIndex = _useState44[1];
    var setItem = (0, $eHaBZ.useCallback)(function(item) {
        setSelectedIndex(list.indexOf(item));
    }, [
        list
    ]);
    return {
        index: selectedIndex,
        item: list[selectedIndex],
        setIndex: setSelectedIndex,
        setItem: setItem
    };
}
function $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2(functionName, object) {
    if (Object.values(object).every(function(value) {
        return typeof value !== "undefined";
    })) console.warn("".concat(functionName, ". Expected either ").concat(Object.keys(object).join(" or "), " to be provided. However all were provided"));
    else if (Object.values(object).every(function(value) {
        return typeof value === "undefined";
    })) console.warn("".concat(functionName, ". ").concat(Object.keys(object).join(" , "), " are all undefined."));
}
function $c020e53fc27b31fb$export$b95089534ab7c1fd() {
    var list = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], initialIndex = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, allowUnselected = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
    var _useState45 = (0, $21h22._)((0, $eHaBZ.useState)(initialIndex), 2), currentIndex = _useState45[0], setCurrentIndex = _useState45[1];
    var currentValue = list[currentIndex];
    var selection = [
        currentIndex,
        currentValue
    ];
    var updateSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("updateSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") setCurrentIndex(index);
            else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) setCurrentIndex(valueIndex);
                else console.warn("updateSelection failed. Does the value ".concat(value, " exist in the list?"));
            }
        };
    }, [
        list
    ]);
    var toggleSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        return function() {
            $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("toggleSelection", {
                index: index,
                value: value
            });
            if (typeof index !== "undefined") {
                if (currentIndex === index) {
                    if (allowUnselected) setCurrentIndex(-1);
                    else console.warn("allowUnselected is false. Cannot unselect item");
                } else setCurrentIndex(index);
            } else if (typeof value !== "undefined") {
                var valueIndex = list.indexOf(value);
                if (valueIndex > -1) {
                    if (currentIndex === valueIndex) {
                        if (allowUnselected) setCurrentIndex(-1);
                        else console.warn("allowUnselected is false. Cannot unselect item");
                    } else setCurrentIndex(valueIndex);
                } else console.warn("toggleSelection failed. Does the value ".concat(value, " exist in the list?"));
            }
        };
    }, [
        allowUnselected,
        currentIndex,
        list
    ]);
    var matchSelection = (0, $eHaBZ.useCallback)(function(param) {
        var index = param.index, value = param.value;
        $c020e53fc27b31fb$var$warnIfBothValueAndIndexAreProvided2("matchSelection", {
            index: index,
            value: value
        });
        if (typeof index !== "undefined") return index === currentIndex;
        else return value === currentValue;
    }, [
        currentIndex,
        currentValue
    ]);
    var controls = {
        matchSelection: matchSelection,
        toggleSelection: toggleSelection,
        updateSelection: updateSelection
    };
    return [
        selection,
        controls
    ];
}
function $c020e53fc27b31fb$var$getValueFromSessionStorage(key) {
    try {
        if (typeof sessionStorage === "undefined") return null;
        var _sessionStorage_getItem;
        var storedValue = (_sessionStorage_getItem = sessionStorage.getItem(key)) !== null && _sessionStorage_getItem !== void 0 ? _sessionStorage_getItem : "null";
        try {
            return JSON.parse(storedValue);
        } catch (error) {
            console.error(error);
            return storedValue;
        }
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $c020e53fc27b31fb$var$saveValueToSessionStorage(key, value) {
    try {
        if (typeof sessionStorage === "undefined") return null;
        if (value === void 0) return sessionStorage.removeItem(key);
        return sessionStorage.setItem(key, JSON.stringify(value));
    } catch (error) {
        console.error(error);
        return null;
    }
}
function $c020e53fc27b31fb$var$initialize2(key, initialState) {
    var valueLoadedFromSessionStorage = $c020e53fc27b31fb$var$getValueFromSessionStorage(key);
    if (valueLoadedFromSessionStorage === null) return typeof initialState === "function" ? initialState() : initialState;
    else return valueLoadedFromSessionStorage;
}
function $c020e53fc27b31fb$export$ab5dd7ac86ae2916(key, initialState) {
    var _useState46 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return $c020e53fc27b31fb$var$initialize2(key, initialState);
    }), 2), value = _useState46[0], setValue = _useState46[1];
    var _useState461 = (0, $21h22._)((0, $eHaBZ.useState)(key), 2), stateKey = _useState461[0], setStateKey = _useState461[1];
    var currentValueRef = (0, $eHaBZ.useRef)(value);
    var currentKeyRef = (0, $eHaBZ.useRef)(key);
    (0, $eHaBZ.useInsertionEffect)(function() {
        currentValueRef.current = value;
        currentKeyRef.current = key;
    }, [
        key,
        value
    ]);
    if (stateKey !== key) {
        setStateKey(key);
        setValue($c020e53fc27b31fb$var$initialize2(key, initialState));
    }
    var isUpdateFromCrossDocumentListener = (0, $eHaBZ.useRef)(false);
    var isUpdateFromWithinDocumentListener = (0, $eHaBZ.useRef)(false);
    var updateSourceKeyRef = (0, $eHaBZ.useRef)(null);
    var customEventTypeName = (0, $eHaBZ.useMemo)(function() {
        return "rooks-".concat(key, "-sessionstorage-update");
    }, [
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var cameFromSynchronizedUpdate = (isUpdateFromCrossDocumentListener.current || isUpdateFromWithinDocumentListener.current) && updateSourceKeyRef.current === key;
        if (!cameFromSynchronizedUpdate) $c020e53fc27b31fb$var$saveValueToSessionStorage(key, value);
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = false;
        updateSourceKeyRef.current = null;
    }, [
        key,
        value
    ]);
    var listenToCrossDocumentStorageEvents = (0, $eHaBZ.useCallback)(function(event) {
        try {
            if (event.storageArea === sessionStorage && event.key === key) {
                var _event_newValue;
                var newValue = JSON.parse((_event_newValue = event.newValue) !== null && _event_newValue !== void 0 ? _event_newValue : "null");
                isUpdateFromCrossDocumentListener.current = true;
                updateSourceKeyRef.current = key;
                currentValueRef.current = newValue;
                setValue(function(currentValue) {
                    return Object.is(currentValue, newValue) ? currentValue : newValue;
                });
            }
        } catch (error) {
            isUpdateFromCrossDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof window !== "undefined") {
            window.addEventListener("storage", listenToCrossDocumentStorageEvents);
            return function() {
                window.removeEventListener("storage", listenToCrossDocumentStorageEvents);
            };
        } else {
            console.warn("[useSessionstorageState] window is undefined.");
            return function() {};
        }
    }, [
        listenToCrossDocumentStorageEvents
    ]);
    var listenToCustomEventWithinDocument = (0, $eHaBZ.useCallback)(function(event) {
        try {
            var newValue = event.detail.newValue;
            isUpdateFromWithinDocumentListener.current = true;
            updateSourceKeyRef.current = key;
            currentValueRef.current = newValue;
            setValue(function(currentValue) {
                return Object.is(currentValue, newValue) ? currentValue : newValue;
            });
        } catch (error) {
            isUpdateFromWithinDocumentListener.current = false;
            updateSourceKeyRef.current = null;
            console.log(error);
        }
    }, [
        currentValueRef,
        key
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (typeof document !== "undefined") {
            document.addEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            return function() {
                document.removeEventListener(customEventTypeName, listenToCustomEventWithinDocument);
            };
        } else {
            console.warn("[useSessionstorageState] document is undefined.");
            return function() {};
        }
    }, [
        customEventTypeName,
        listenToCustomEventWithinDocument
    ]);
    var broadcastValueWithinDocument = (0, $eHaBZ.useCallback)(function(storageKey, newValue) {
        if (typeof document !== "undefined") {
            var event = new CustomEvent("rooks-".concat(storageKey, "-sessionstorage-update"), {
                detail: {
                    newValue: newValue
                }
            });
            document.dispatchEvent(event);
        } else console.warn("[useSessionstorageState] document is undefined.");
    }, []);
    var set = (0, $eHaBZ.useCallback)(function(newValue) {
        var resolvedNewValue = typeof newValue === "function" ? newValue(currentValueRef.current) : newValue;
        var storageKey = currentKeyRef.current;
        isUpdateFromCrossDocumentListener.current = false;
        isUpdateFromWithinDocumentListener.current = true;
        updateSourceKeyRef.current = storageKey;
        currentValueRef.current = resolvedNewValue;
        $c020e53fc27b31fb$var$saveValueToSessionStorage(storageKey, resolvedNewValue);
        setValue(resolvedNewValue);
        broadcastValueWithinDocument(storageKey, resolvedNewValue);
    }, [
        broadcastValueWithinDocument,
        currentKeyRef,
        currentValueRef
    ]);
    var remove = (0, $eHaBZ.useCallback)(function() {
        try {
            sessionStorage.removeItem(key);
        } catch (error) {
            console.error(error);
        }
    }, [
        key
    ]);
    return [
        value,
        set,
        remove
    ];
}
function $c020e53fc27b31fb$export$96a35531d1008427() {
    var _useState47 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState47[0], setError = _useState47[1];
    var _useState471 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isSharing = _useState471[0], setIsSharing = _useState471[1];
    var isSupported = typeof window !== "undefined" && typeof navigator !== "undefined" && "share" in navigator;
    var share = (0, $eHaBZ.useCallback)(function(data) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _$err, err, error2;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Web Share API is not supported");
                            setError(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsSharing(true);
                        setError(null);
                        return [
                            4,
                            navigator.share(data)
                        ];
                    case 2:
                        _state.sent();
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        if (err instanceof Error && err.name === "AbortError") setError(null);
                        else {
                            error2 = err instanceof Error ? err : new Error("Failed to share");
                            setError(error2);
                            throw error2;
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        setIsSharing(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported
    ]);
    return {
        share: share,
        isSupported: isSupported,
        error: error,
        isSharing: isSharing
    };
}
function $c020e53fc27b31fb$export$89c35abda4d6d7ba(initialSetValue) {
    var _useState48 = (0, $21h22._)((0, $eHaBZ.useState)(new Set(initialSetValue)), 2), setValue = _useState48[0], setSetValue = _useState48[1];
    var add = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setSetValue(function(currentSet) {
            var _nextSet;
            var nextSet = new Set(currentSet);
            (_nextSet = nextSet).add.apply(_nextSet, (0, $6zk1M._)(args));
            return nextSet;
        });
    }, []);
    var deleteValue = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        setSetValue(function(currentSet) {
            var _nextSet;
            var nextSet = new Set(currentSet);
            (_nextSet = nextSet).delete.apply(_nextSet, (0, $6zk1M._)(args));
            return nextSet;
        });
    }, []);
    var clear = (0, $eHaBZ.useCallback)(function() {
        setSetValue(/* @__PURE__ */ new Set());
    }, []);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            add: add,
            delete: deleteValue,
            clear: clear
        };
    }, [
        add,
        deleteValue,
        clear
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            setValue,
            controls
        ];
    }, [
        setValue,
        controls
    ]);
    return returnValue;
}
function $c020e53fc27b31fb$export$c4af9125706c4d30(targetValue) {
    var config6 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _config6_stiffness = config6.stiffness, stiffness = _config6_stiffness === void 0 ? 170 : _config6_stiffness, _config6_damping = config6.damping, damping = _config6_damping === void 0 ? 26 : _config6_damping, _config6_mass = config6.mass, mass = _config6_mass === void 0 ? 1 : _config6_mass, _config6_precision = config6.precision, precision = _config6_precision === void 0 ? 0.01 : _config6_precision;
    var _useState49 = (0, $21h22._)((0, $eHaBZ.useState)(targetValue), 2), value = _useState49[0], setValue = _useState49[1];
    var velocityRef = (0, $eHaBZ.useRef)(0);
    var valueRef = (0, $eHaBZ.useRef)(targetValue);
    var targetRef = (0, $eHaBZ.useRef)(targetValue);
    (0, $eHaBZ.useEffect)(function() {
        targetRef.current = targetValue;
    }, [
        targetValue
    ]);
    $c020e53fc27b31fb$export$3d0be2420b17e328(function() {
        var distance = targetRef.current - valueRef.current;
        var force = distance * stiffness;
        var acceleration = force / mass;
        var friction = -velocityRef.current * damping;
        velocityRef.current += (acceleration + friction) * (1 / 60);
        valueRef.current += velocityRef.current * (1 / 60);
        setValue(valueRef.current);
        if (Math.abs(distance) < precision && Math.abs(velocityRef.current) < precision) {
            if (valueRef.current !== targetRef.current) {
                valueRef.current = targetRef.current;
                setValue(targetRef.current);
            }
            return false;
        }
        return true;
    }, true);
    return value;
}
function $c020e53fc27b31fb$export$d924c858c6da95fa(initialList) {
    var _useState50 = (0, $21h22._)((0, $eHaBZ.useState)((0, $6zk1M._)(initialList)), 2), list = _useState50[0], setList = _useState50[1];
    var length = list.length;
    var listInReverse = (0, $eHaBZ.useMemo)(function() {
        var reverseList = (0, $6zk1M._)(list);
        reverseList.reverse();
        return reverseList;
    }, [
        list
    ]);
    var push = (0, $eHaBZ.useCallback)(function(item) {
        var newList = (0, $6zk1M._)(list).concat([
            item
        ]);
        setList(newList);
        return newList.length;
    }, [
        list
    ]);
    var pop = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) {
            var lastItem = list[list.length - 1];
            setList((0, $6zk1M._)(list.slice(0, list.length - 1)));
            return lastItem;
        }
        return void 0;
    }, [
        list
    ]);
    var peek = (0, $eHaBZ.useCallback)(function() {
        if (list.length > 0) return list[list.length - 1];
        return void 0;
    }, [
        list
    ]);
    var clear = function() {
        return setList([]);
    };
    var isEmpty = (0, $eHaBZ.useCallback)(function() {
        return list.length === 0;
    }, [
        list
    ]);
    var controls = {
        clear: clear,
        isEmpty: isEmpty,
        length: length,
        peek: peek,
        pop: pop,
        push: push
    };
    return [
        list,
        controls,
        listInReverse
    ];
}
function $c020e53fc27b31fb$export$57e792e009c800a0(options) {
    var text = options.text, _options_language = options.language, language = _options_language === void 0 ? "en-US" : _options_language, voiceURI = options.voiceURI, _options_onEnd = options.onEnd, onEnd = _options_onEnd === void 0 ? (0, $e146ef819c676a18$export$8793edee2d425525) : _options_onEnd, _options_volume = options.volume, volume = _options_volume === void 0 ? 1 : _options_volume, _options_pitch = options.pitch, pitch = _options_pitch === void 0 ? 1 : _options_pitch, _options_rate = options.rate, rate = _options_rate === void 0 ? 1 : _options_rate;
    var freshOnEnd = $c020e53fc27b31fb$export$b3553245f2c17524(onEnd);
    var speechRef = (0, $eHaBZ.useRef)(null);
    var _useState51 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isPlaying = _useState51[0], setIsPlaying = _useState51[1];
    (0, $eHaBZ.useEffect)(function() {
        if (speechRef.current && isPlaying) {
            speechRef.current.text = text;
            speechRef.current.lang = language;
            speechRef.current.volume = volume;
            speechRef.current.pitch = pitch;
            speechRef.current.rate = rate;
            if (voiceURI) {
                var voices = window.speechSynthesis.getVoices();
                var selectedVoice = voices.find(function(voice) {
                    return voice.voiceURI === voiceURI;
                });
                if (selectedVoice) speechRef.current.voice = selectedVoice;
            }
        }
    }, [
        text,
        isPlaying,
        language,
        voiceURI,
        volume,
        pitch,
        rate
    ]);
    var start = (0, $eHaBZ.useCallback)(function() {
        if (!("speechSynthesis" in window)) {
            console.error("Web Speech API is not supported in your browser.");
            return;
        }
        if (speechRef.current) window.speechSynthesis.cancel();
        speechRef.current = new SpeechSynthesisUtterance(text);
        speechRef.current.lang = language;
        speechRef.current.volume = volume;
        speechRef.current.pitch = pitch;
        speechRef.current.rate = rate;
        if (voiceURI) {
            var voices = window.speechSynthesis.getVoices();
            var selectedVoice = voices.find(function(voice) {
                return voice.voiceURI === voiceURI;
            });
            if (selectedVoice) speechRef.current.voice = selectedVoice;
        }
        speechRef.current.onstart = function() {
            return setIsPlaying(true);
        };
        speechRef.current.onend = function() {
            setIsPlaying(false);
            freshOnEnd();
        };
        speechRef.current.onerror = function() {
            return setIsPlaying(false);
        };
        window.speechSynthesis.speak(speechRef.current);
    }, [
        text,
        language,
        volume,
        pitch,
        rate,
        voiceURI,
        freshOnEnd
    ]);
    var pause = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis && isPlaying) {
            window.speechSynthesis.pause();
            setIsPlaying(false);
        }
    }, [
        isPlaying
    ]);
    var resume = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis && !isPlaying) {
            window.speechSynthesis.resume();
            setIsPlaying(true);
        }
    }, [
        isPlaying
    ]);
    var stop = (0, $eHaBZ.useCallback)(function() {
        if (window.speechSynthesis) {
            window.speechSynthesis.cancel();
            setIsPlaying(false);
        }
    }, []);
    return {
        start: start,
        pause: pause,
        resume: resume,
        stop: stop,
        isPlaying: isPlaying
    };
}
// src/utils/utils.ts
var $c020e53fc27b31fb$var$isFunction = function(value) {
    return typeof value === "function";
};
var $c020e53fc27b31fb$var$isNumber = function(value) {
    return typeof value === "number";
};
var $c020e53fc27b31fb$var$getSplitIndex = function(step, arr) {
    var index = step > 0 ? step - 1 : arr.length + step;
    if (index >= arr.length - 1) index = arr.length - 1;
    if (index < 0) index = 0;
    return index;
};
var $c020e53fc27b31fb$var$split = function(step, targetArr) {
    var index = $c020e53fc27b31fb$var$getSplitIndex(step, targetArr);
    return {
        _current: targetArr[index],
        _before: targetArr.slice(0, index),
        _after: targetArr.slice(index + 1)
    };
};
function $c020e53fc27b31fb$export$cb9753ee02b19404(initialValue) {
    var _useState52 = (0, $21h22._)((0, $eHaBZ.useState)({
        present: initialValue,
        past: [],
        future: []
    }), 2), history = _useState52[0], setHistory = _useState52[1];
    var present = history.present, past = history.past, future = history.future;
    var initialValueRef = (0, $eHaBZ.useRef)(initialValue);
    var reset = (0, $eHaBZ.useCallback)(function(resetInitialValue) {
        var newInitialValue = resetInitialValue !== null && resetInitialValue !== void 0 ? resetInitialValue : initialValueRef.current;
        initialValueRef.current = newInitialValue;
        setHistory({
            present: newInitialValue,
            future: [],
            past: []
        });
    }, [
        initialValueRef,
        setHistory
    ]);
    var updateValue = (0, $eHaBZ.useCallback)(function(val, options) {
        setHistory(function(currentHistory) {
            var past2 = currentHistory.past, present2 = currentHistory.present;
            var _ref = options || {}, _ref_overwriteLastEntry = _ref.overwriteLastEntry, overwriteLastEntry = _ref_overwriteLastEntry === void 0 ? false : _ref_overwriteLastEntry;
            var newValue = void 0;
            if ($c020e53fc27b31fb$var$isFunction(val)) newValue = val(present2);
            else newValue = val;
            if (overwriteLastEntry) return {
                present: newValue,
                past: past2,
                future: []
            };
            else return {
                present: newValue,
                future: [],
                past: (0, $6zk1M._)(past2).concat([
                    present2
                ])
            };
        });
    }, []);
    var goForwardInternal = (0, $eHaBZ.useCallback)(function() {
        var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1;
        setHistory(function(currentHistory) {
            var future2 = currentHistory.future, past2 = currentHistory.past, present2 = currentHistory.present;
            if (future2.length === 0) return currentHistory;
            var _split = $c020e53fc27b31fb$var$split(step, future2), _before = _split._before, _current = _split._current, _after = _split._after;
            return {
                past: (0, $6zk1M._)(past2).concat([
                    present2
                ], (0, $6zk1M._)(_before)),
                present: _current,
                future: _after
            };
        });
    }, []);
    var goBackwardInternal = (0, $eHaBZ.useCallback)(function() {
        var step = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : -1;
        setHistory(function(currentHistory) {
            var future2 = currentHistory.future, past2 = currentHistory.past, present2 = currentHistory.present;
            if (past2.length === 0) return currentHistory;
            var _split = $c020e53fc27b31fb$var$split(step, past2), _before = _split._before, _current = _split._current, _after = _split._after;
            return {
                past: _before,
                present: _current,
                future: (0, $6zk1M._)(_after).concat([
                    present2
                ], (0, $6zk1M._)(future2))
            };
        });
    }, []);
    var go = (0, $eHaBZ.useCallback)(function(step) {
        var stepNum = $c020e53fc27b31fb$var$isNumber(step) ? step : Number(step);
        if (stepNum === 0) return;
        if (stepNum > 0) return goForwardInternal(stepNum);
        goBackwardInternal(stepNum);
    }, [
        goBackwardInternal,
        goForwardInternal
    ]);
    var back = (0, $eHaBZ.useCallback)(function() {
        go(-1);
    }, [
        go
    ]);
    var forward = (0, $eHaBZ.useCallback)(function() {
        go(1);
    }, [
        go
    ]);
    var canUndo = (0, $eHaBZ.useMemo)(function() {
        return past.length > 0;
    }, [
        past.length
    ]);
    var canRedo = (0, $eHaBZ.useMemo)(function() {
        return future.length > 0;
    }, [
        future.length
    ]);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            backLength: past.length,
            forwardLength: future.length,
            go: go,
            back: back,
            forward: forward,
            reset: reset,
            undo: back,
            redo: forward,
            canUndo: canUndo,
            canRedo: canRedo
        };
    }, [
        back,
        canRedo,
        canUndo,
        forward,
        future.length,
        go,
        past.length,
        reset
    ]);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            present,
            updateValue,
            controls
        ];
    }, [
        controls,
        present,
        updateValue
    ]);
    return returnValue;
}
function $c020e53fc27b31fb$var$createFetchPromise(_0, _1) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(url) {
        var options, signal, requestOptions, response, errorMessage, httpError;
        var _arguments = arguments;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    options = _arguments.length > 1 && _arguments[1] !== void 0 ? _arguments[1] : {}, signal = _arguments.length > 2 ? _arguments[2] : void 0;
                    requestOptions = (0, $lvTkn._)({}, options);
                    delete requestOptions.onSuccess;
                    delete requestOptions.onError;
                    delete requestOptions.onFetch;
                    return [
                        4,
                        fetch(url, (0, $9Jpjh._)((0, $lvTkn._)({}, requestOptions), {
                            signal: signal
                        }))
                    ];
                case 1:
                    response = _state.sent();
                    if (!response.ok) {
                        errorMessage = "HTTP ".concat(response.status, ": ").concat(response.statusText);
                        httpError = new Error(errorMessage);
                        httpError.status = response.status;
                        httpError.statusText = response.statusText;
                        throw httpError;
                    }
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    return [
                        2,
                        _state.sent()
                    ];
            }
        });
    }).apply(this, arguments);
}
function $c020e53fc27b31fb$export$d852f5f778460fa4(url) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _useState53 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), data = _useState53[0], setData = _useState53[1];
    var _useState531 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), loading = _useState531[0], setLoading = _useState531[1];
    var _useState532 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState532[0], setError = _useState532[1];
    var mountedRef = (0, $eHaBZ.useRef)(true);
    var mountGenerationRef = (0, $eHaBZ.useRef)(0);
    var abortControllersRef = (0, $eHaBZ.useRef)(/* @__PURE__ */ new Set());
    var fetchData = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _options_onFetch, mountGeneration, abortController, canCommitResult, result, _options_onSuccess, err, fetchError, _options_onError;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!mountedRef.current) return [
                            2
                        ];
                        mountGeneration = mountGenerationRef.current;
                        setLoading(true);
                        setError(null);
                        (_options_onFetch = options.onFetch) === null || _options_onFetch === void 0 ? void 0 : _options_onFetch.call(options);
                        if (!mountedRef.current || mountGeneration !== mountGenerationRef.current) return [
                            2
                        ];
                        abortController = null;
                        canCommitResult = function() {
                            return mountedRef.current && mountGeneration === mountGenerationRef.current && !(abortController === null || abortController === void 0 ? void 0 : abortController.signal.aborted);
                        };
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        abortController = new AbortController();
                        abortControllersRef.current.add(abortController);
                        return [
                            4,
                            $c020e53fc27b31fb$var$createFetchPromise(url, options, abortController.signal)
                        ];
                    case 2:
                        result = _state.sent();
                        if (canCommitResult()) {
                            ;
                            setData(result);
                            (_options_onSuccess = options.onSuccess) === null || _options_onSuccess === void 0 ? void 0 : _options_onSuccess.call(options, result);
                        }
                        return [
                            3,
                            5
                        ];
                    case 3:
                        err = _state.sent();
                        fetchError = err instanceof Error ? err : new Error(String(err));
                        if (canCommitResult()) {
                            ;
                            setError(fetchError);
                            (_options_onError = options.onError) === null || _options_onError === void 0 ? void 0 : _options_onError.call(options, fetchError);
                        }
                        return [
                            3,
                            5
                        ];
                    case 4:
                        if (abortController) abortControllersRef.current.delete(abortController);
                        if (canCommitResult()) setLoading(false);
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        options,
        url
    ]);
    (0, $eHaBZ.useEffect)(function() {
        mountedRef.current = true;
        var abortControllers = abortControllersRef.current;
        return function() {
            mountedRef.current = false;
            mountGenerationRef.current += 1;
            var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
            try {
                for(var _iterator = abortControllers[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                    var abortController = _step.value;
                    abortController.abort();
                }
            } catch (err) {
                _didIteratorError = true;
                _iteratorError = err;
            } finally{
                try {
                    if (!_iteratorNormalCompletion && _iterator.return != null) {
                        _iterator.return();
                    }
                } finally{
                    if (_didIteratorError) {
                        throw _iteratorError;
                    }
                }
            }
            abortControllers.clear();
        };
    }, []);
    return {
        data: data,
        loading: loading,
        error: error,
        startFetch: fetchData
    };
}
function $c020e53fc27b31fb$export$8b7b9481d6186f21(callback) {
    var timeout = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 300;
    var _useState54 = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), ready = _useState54[0], setReady = _useState54[1];
    var readyRef = (0, $eHaBZ.useRef)(true);
    var timerRef = (0, $eHaBZ.useRef)(void 0);
    var callbackRef = (0, $e146ef819c676a18$export$38e1734badfda8d9)(callback, true);
    var throttledFunction = (0, $eHaBZ.useCallback)(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _callbackRef;
        if (!readyRef.current) return;
        readyRef.current = false;
        setReady(false);
        (_callbackRef = callbackRef).current.apply(_callbackRef, (0, $6zk1M._)(args));
    }, [
        callbackRef
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (ready) {
            readyRef.current = true;
            return 0, $e146ef819c676a18$export$8793edee2d425525;
        }
        timerRef.current = window.setTimeout(function() {
            setReady(true);
        }, timeout);
        return function() {
            return window.clearTimeout(timerRef.current);
        };
    }, [
        ready,
        timeout
    ]);
    return [
        throttledFunction,
        ready
    ];
}
var $c020e53fc27b31fb$var$initialSelectionState = {
    text: "",
    rect: null,
    startOffset: 0,
    endOffset: 0,
    anchorNode: null,
    focusNode: null
};
function $c020e53fc27b31fb$var$readSelectionState(targetElement) {
    if (typeof window === "undefined" || !window.getSelection) return $c020e53fc27b31fb$var$initialSelectionState;
    var selection = window.getSelection();
    if (!selection || selection.isCollapsed) return $c020e53fc27b31fb$var$initialSelectionState;
    var text = selection.toString();
    if (!text) return $c020e53fc27b31fb$var$initialSelectionState;
    if (targetElement) {
        var anchorNode = selection.anchorNode, focusNode = selection.focusNode;
        if (!anchorNode || !focusNode || !targetElement.contains(anchorNode) || !targetElement.contains(focusNode)) return $c020e53fc27b31fb$var$initialSelectionState;
    }
    var rect = null;
    if (selection.rangeCount > 0) try {
        rect = selection.getRangeAt(0).getBoundingClientRect();
    } catch (e) {}
    return {
        text: text,
        rect: rect,
        startOffset: selection.anchorOffset,
        endOffset: selection.focusOffset,
        anchorNode: selection.anchorNode,
        focusNode: selection.focusNode
    };
}
function $c020e53fc27b31fb$export$9c9cf404b65a1c0a(target) {
    var cacheRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$initialSelectionState);
    var targetRef = (0, $eHaBZ.useRef)(target);
    targetRef.current = target;
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        if (typeof document === "undefined") return function() {};
        var handleSelectionChange = function() {
            var _targetRef_current;
            var _targetRef_current_current;
            cacheRef.current = $c020e53fc27b31fb$var$readSelectionState((_targetRef_current_current = (_targetRef_current = targetRef.current) === null || _targetRef_current === void 0 ? void 0 : _targetRef_current.current) !== null && _targetRef_current_current !== void 0 ? _targetRef_current_current : null);
            onStoreChange();
        };
        var handleMouseDown = function(event) {
            var _targetRef_current;
            var targetElement = (_targetRef_current = targetRef.current) === null || _targetRef_current === void 0 ? void 0 : _targetRef_current.current;
            if (targetElement && !targetElement.contains(event.target) && cacheRef.current.text !== "") {
                cacheRef.current = $c020e53fc27b31fb$var$initialSelectionState;
                onStoreChange();
            }
        };
        document.addEventListener("selectionchange", handleSelectionChange);
        document.addEventListener("mousedown", handleMouseDown);
        return function() {
            document.removeEventListener("selectionchange", handleSelectionChange);
            document.removeEventListener("mousedown", handleMouseDown);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        return cacheRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$initialSelectionState;
    }, []);
    var selectionState = (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
    return [
        selectionState
    ];
}
var $c020e53fc27b31fb$var$defaultToggleFunction = function(value) {
    return !value;
};
function $c020e53fc27b31fb$export$cbe85ee05b554577() {
    var initialValue = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false, toggleFunction = arguments.length > 1 ? arguments[1] : void 0;
    if (toggleFunction) return (0, $eHaBZ.useReducer)(toggleFunction, initialValue);
    return (0, $eHaBZ.useReducer)($c020e53fc27b31fb$var$defaultToggleFunction, initialValue);
}
var $c020e53fc27b31fb$var$defaultOptions5 = {
    maxSize: 100
};
var $c020e53fc27b31fb$export$99d290bffb3da24d = function(defaultValue, options) {
    var maxSize = (0, $eHaBZ.useMemo)(function() {
        return (0, $lvTkn._)({}, $c020e53fc27b31fb$var$defaultOptions5, options);
    }, [
        options
    ]).maxSize;
    var _useState55 = (0, $21h22._)((0, $eHaBZ.useState)([
        defaultValue
    ]), 2), value = _useState55[0], setValue = _useState55[1];
    var push = (0, $eHaBZ.useCallback)(function(argument) {
        return setValue(function(current) {
            var restValues = current.length >= maxSize ? current.slice(0, maxSize) : current;
            if (typeof argument === "function") return [
                argument(current[0])
            ].concat((0, $6zk1M._)(restValues));
            else return [
                argument
            ].concat((0, $6zk1M._)(restValues));
        });
    }, [
        maxSize
    ]);
    var undo = (0, $eHaBZ.useCallback)(function() {
        setValue(function(current) {
            if (current.length === 1) return current;
            var _current = (0, $ggKxj._)(current), values = _current.slice(1);
            return values;
        });
    }, []);
    var returnValue = (0, $eHaBZ.useMemo)(function() {
        return [
            value[0],
            push,
            undo
        ];
    }, [
        push,
        undo,
        value
    ]);
    return returnValue;
};
var $c020e53fc27b31fb$var$Easing2 = {
    linear: function(t) {
        return t;
    },
    easeInQuad: function(t) {
        return t * t;
    },
    easeOutQuad: function(t) {
        return t * (2 - t);
    },
    easeInOutQuad: function(t) {
        return t < 0.5 ? 2 * t * t : -1 + (4 - 2 * t) * t;
    },
    easeInCubic: function(t) {
        return t * t * t;
    },
    easeOutCubic: function(t) {
        return --t * t * t + 1;
    },
    easeInOutCubic: function(t) {
        return t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1;
    }
};
function $c020e53fc27b31fb$export$b543325d5f654b02() {
    var duration = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 200, easing = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : $c020e53fc27b31fb$var$Easing2.linear;
    var _useState56 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), value = _useState56[0], setValue = _useState56[1];
    var startTimeRef = (0, $eHaBZ.useRef)(null);
    var raf2 = $c020e53fc27b31fb$export$3d0be2420b17e328(function() {
        if (startTimeRef.current === null) startTimeRef.current = performance.now();
        var elapsed = performance.now() - startTimeRef.current;
        var progress = Math.min(elapsed / duration, 1);
        var easedProgress = easing(progress);
        setValue(easedProgress);
        if (progress < 1) return true;
        return false;
    }, true);
    (0, $eHaBZ.useEffect)(function() {
        startTimeRef.current = null;
    }, [
        duration,
        easing
    ]);
    return value;
}
function $c020e53fc27b31fb$var$isFunctionInitializer(functionToCheck) {
    return typeof functionToCheck === "function";
}
function $c020e53fc27b31fb$export$35dec198dbda4c09(initialState, options) {
    var _useState57 = (0, $21h22._)((0, $eHaBZ.useState)(initialState), 2), state = _useState57[0], _setState = _useState57[1];
    var _useState571 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), past = _useState571[0], setPast = _useState571[1];
    var _useState572 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), future = _useState572[0], setFuture = _useState572[1];
    var _options_maxDepth;
    var maxDepth = (_options_maxDepth = options === null || options === void 0 ? void 0 : options.maxDepth) !== null && _options_maxDepth !== void 0 ? _options_maxDepth : 100;
    var undo = (0, $eHaBZ.useCallback)(function() {
        setPast(function(pastStates) {
            var newPast = (0, $6zk1M._)(pastStates);
            var previousState = newPast.pop();
            if (typeof previousState !== "undefined") {
                setFuture(function(futureStates) {
                    return [
                        state
                    ].concat((0, $6zk1M._)(futureStates));
                });
                _setState(previousState);
            }
            return newPast;
        });
    }, [
        state
    ]);
    var redo = (0, $eHaBZ.useCallback)(function() {
        setFuture(function(futureStates) {
            var newFuture = (0, $6zk1M._)(futureStates);
            var nextState = newFuture.shift();
            if (typeof nextState !== "undefined") {
                setPast(function(pastStates) {
                    return (0, $6zk1M._)(pastStates).concat([
                        state
                    ]);
                });
                _setState(nextState);
            }
            return newFuture;
        });
    }, [
        state
    ]);
    var canUndo = (0, $eHaBZ.useCallback)(function() {
        return past.length > 0;
    }, [
        past
    ]);
    var canRedo = (0, $eHaBZ.useCallback)(function() {
        return future.length > 0;
    }, [
        future
    ]);
    var isUndoPossible = (0, $eHaBZ.useMemo)(function() {
        return past.length > 0;
    }, [
        past
    ]);
    var isRedoPossible = (0, $eHaBZ.useMemo)(function() {
        return future.length > 0;
    }, [
        future
    ]);
    var setState = (0, $eHaBZ.useCallback)(function(value) {
        _setState(function(prevState) {
            var nextState = $c020e53fc27b31fb$var$isFunctionInitializer(value) ? value(prevState) : value;
            setPast(function(pastStates) {
                var newPast = (0, $6zk1M._)(pastStates).concat([
                    prevState
                ]);
                if (newPast.length > maxDepth) newPast.shift();
                return newPast;
            });
            setFuture([]);
            return nextState;
        });
    }, [
        maxDepth
    ]);
    var clearUndoStack = (0, $eHaBZ.useCallback)(function() {
        setPast([]);
    }, []);
    var clearRedoStack = (0, $eHaBZ.useCallback)(function() {
        setFuture([]);
    }, []);
    var clearAll = (0, $eHaBZ.useCallback)(function() {
        setPast([]);
        setFuture([]);
    }, []);
    var controls = (0, $eHaBZ.useMemo)(function() {
        return {
            undo: undo,
            redo: redo,
            canUndo: canUndo,
            canRedo: canRedo,
            clearUndoStack: clearUndoStack,
            clearRedoStack: clearRedoStack,
            clearAll: clearAll,
            isUndoPossible: isUndoPossible,
            isRedoPossible: isRedoPossible
        };
    }, [
        undo,
        redo,
        canUndo,
        canRedo,
        clearUndoStack,
        clearRedoStack,
        clearAll,
        isUndoPossible,
        isRedoPossible
    ]);
    return [
        state,
        setState,
        controls
    ];
}
function $c020e53fc27b31fb$export$165ce7a5158a386d(param) {
    var isEnabled = param.isEnabled, pattern = param.pattern;
    (0, $eHaBZ.useEffect)(function() {
        if (!("vibrate" in navigator) || typeof navigator.vibrate !== "function") {
            console.warn("Vibration API not supported by the current browser");
            return;
        }
        if (isEnabled) navigator.vibrate(pattern);
        else navigator.vibrate(0);
        return function() {
            navigator.vibrate(0);
        };
    }, [
        isEnabled,
        pattern
    ]);
}
var $c020e53fc27b31fb$export$5269023cd97c8c79 = function() {
    var videoRef = (0, $eHaBZ.useRef)(null);
    var _useState58 = (0, $21h22._)((0, $eHaBZ.useState)({
        currentTime: 0,
        duration: 0,
        isPaused: true,
        isMuted: false,
        volume: 1
    }), 2), state = _useState58[0], setState = _useState58[1];
    var controls = {
        play: function() {
            if (videoRef.current) {
                videoRef.current.play();
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isPaused: false
                }));
            }
        },
        pause: function() {
            if (videoRef.current) {
                videoRef.current.pause();
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isPaused: true
                }));
            }
        },
        toggleMute: function() {
            if (videoRef.current) {
                videoRef.current.muted = !videoRef.current.muted;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    isMuted: videoRef.current.muted
                }));
            }
        },
        setVolume: function(volume) {
            if (videoRef.current) {
                videoRef.current.volume = volume;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    volume: volume
                }));
            }
        },
        setCurrentTime: function(time) {
            if (videoRef.current) {
                videoRef.current.currentTime = time;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: time
                }));
            }
        },
        fastForward: function(seconds) {
            if (videoRef.current) {
                videoRef.current.currentTime += seconds;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: videoRef.current.currentTime
                }));
            }
        },
        rewind: function(seconds) {
            if (videoRef.current) {
                videoRef.current.currentTime -= seconds;
                setState((0, $9Jpjh._)((0, $lvTkn._)({}, state), {
                    currentTime: videoRef.current.currentTime
                }));
            }
        },
        toggleFullScreen: function() {
            if (videoRef.current) {
                if (document.fullscreenElement) document.exitFullscreen();
                else videoRef.current.requestFullscreen();
            }
        }
    };
    (0, $eHaBZ.useEffect)(function() {
        var video = videoRef.current;
        var handleTimeUpdate = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    currentTime: video.currentTime
                });
            });
        };
        var handleDurationChange = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    duration: video.duration
                });
            });
        };
        var handlePause = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    isPaused: true
                });
            });
        };
        var handlePlay = function() {
            setState(function(prevState) {
                return (0, $9Jpjh._)((0, $lvTkn._)({}, prevState), {
                    isPaused: false
                });
            });
        };
        if (video) {
            video.addEventListener("timeupdate", handleTimeUpdate);
            video.addEventListener("durationchange", handleDurationChange);
            video.addEventListener("pause", handlePause);
            video.addEventListener("play", handlePlay);
        }
        return function() {
            if (video) {
                video.removeEventListener("timeupdate", handleTimeUpdate);
                video.removeEventListener("durationchange", handleDurationChange);
                video.removeEventListener("pause", handlePause);
                video.removeEventListener("play", handlePlay);
            }
        };
    }, [
        videoRef
    ]);
    return [
        videoRef,
        state,
        controls
    ];
};
function $c020e53fc27b31fb$export$cb3ad10de185e7a8(resourceName) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (typeof resourceName !== "string") throw new Error("Resource name must be a string");
    var _options_periodicCheck = options.periodicCheck, periodicCheck = _options_periodicCheck === void 0 ? false : _options_periodicCheck, _options_checkInterval = options.checkInterval, checkInterval = _options_checkInterval === void 0 ? 1e3 : _options_checkInterval;
    var isSupported = (0, $eHaBZ.useMemo)(function() {
        return typeof navigator !== "undefined" && navigator.locks !== void 0 && typeof navigator.locks.request === "function";
    }, []);
    var _useState59 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), isLocked = _useState59[0], setIsLocked = _useState59[1];
    var _useState591 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), waitingCount = _useState591[0], setWaitingCount = _useState591[1];
    var _useState592 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState592[0], setError = _useState592[1];
    var abortControllerRef = (0, $eHaBZ.useRef)(null);
    var periodicCheckTimeoutRef = (0, $eHaBZ.useRef)(void 0);
    var setErrorState = (0, $eHaBZ.useCallback)(function(err) {
        setError(err);
    }, []);
    var clearError = (0, $eHaBZ.useCallback)(function() {
        setError(null);
    }, []);
    var query = (0, $eHaBZ.useCallback)(function() {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _$err, _result_held, _result_pending, result, resourceLocks, pendingLocks, err, error2;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Web Locks API is not supported");
                            setErrorState(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            navigator.locks.query()
                        ];
                    case 2:
                        result = _state.sent();
                        resourceLocks = ((_result_held = result.held) === null || _result_held === void 0 ? void 0 : _result_held.filter(function(lock) {
                            return lock.name === resourceName;
                        })) || [];
                        pendingLocks = ((_result_pending = result.pending) === null || _result_pending === void 0 ? void 0 : _result_pending.filter(function(lock) {
                            return lock.name === resourceName;
                        })) || [];
                        setIsLocked(resourceLocks.length > 0);
                        setWaitingCount(pendingLocks.length);
                        clearError();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Query failed");
                        setErrorState(error2);
                        throw error2;
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    var acquire = (0, $eHaBZ.useCallback)(function(callback, lockOptions) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var _$err, controller, finalOptions, result, err, error2;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!isSupported) {
                            _$err = new Error("Web Locks API is not supported");
                            setErrorState(_$err);
                            throw _$err;
                        }
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            4,
                            5
                        ]);
                        setIsLocked(true);
                        clearError();
                        controller = null;
                        if (!(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) && !(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.ifAvailable)) {
                            controller = new AbortController();
                            abortControllerRef.current = controller;
                        }
                        finalOptions = (0, $lvTkn._)({}, lockOptions);
                        if (!(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.ifAvailable) && !(lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) && controller) finalOptions.signal = controller.signal;
                        else if (lockOptions === null || lockOptions === void 0 ? void 0 : lockOptions.signal) finalOptions.signal = lockOptions.signal;
                        return [
                            4,
                            navigator.locks.request(resourceName, finalOptions, function() {
                                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                                    var err, error2;
                                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                                        switch(_state.label){
                                            case 0:
                                                _state.trys.push([
                                                    0,
                                                    2,
                                                    ,
                                                    3
                                                ]);
                                                return [
                                                    4,
                                                    callback()
                                                ];
                                            case 1:
                                                return [
                                                    2,
                                                    _state.sent()
                                                ];
                                            case 2:
                                                err = _state.sent();
                                                error2 = err instanceof Error ? err : new Error("Callback failed");
                                                setErrorState(error2);
                                                throw error2;
                                            case 3:
                                                return [
                                                    2
                                                ];
                                        }
                                    });
                                })();
                            })
                        ];
                    case 2:
                        result = _state.sent();
                        return [
                            2,
                            result
                        ];
                    case 3:
                        err = _state.sent();
                        error2 = err instanceof Error ? err : new Error("Lock acquisition failed");
                        setErrorState(error2);
                        throw error2;
                    case 4:
                        setIsLocked(false);
                        abortControllerRef.current = null;
                        return [
                            7
                        ];
                    case 5:
                        return [
                            2
                        ];
                }
            });
        })();
    }, [
        isSupported,
        resourceName,
        setErrorState,
        clearError
    ]);
    var release = (0, $eHaBZ.useCallback)(function() {
        if (abortControllerRef.current) {
            abortControllerRef.current.abort();
            abortControllerRef.current = null;
        }
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        if (!isSupported) return;
        query().catch(function() {});
        if (periodicCheck) {
            var setupPeriodicCheck = function() {
                periodicCheckTimeoutRef.current = window.setTimeout(function() {
                    query().catch(function() {}).finally(function() {
                        setupPeriodicCheck();
                    });
                }, checkInterval);
            };
            setupPeriodicCheck();
        }
        return function() {
            if (periodicCheckTimeoutRef.current) {
                window.clearTimeout(periodicCheckTimeoutRef.current);
                periodicCheckTimeoutRef.current = void 0;
            }
            if (abortControllerRef.current) {
                abortControllerRef.current.abort();
                abortControllerRef.current = null;
            }
        };
    }, [
        isSupported,
        resourceName,
        periodicCheck,
        checkInterval,
        query
    ]);
    return {
        isSupported: isSupported,
        isLocked: isLocked,
        waitingCount: waitingCount,
        error: error,
        resourceName: resourceName,
        acquire: acquire,
        release: release,
        query: query
    };
}
function $c020e53fc27b31fb$export$44bc62d25eb3a976(workerUrl) {
    var _useState60 = (0, $21h22._)((0, $eHaBZ.useState)("idle"), 2), status = _useState60[0], setStatus = _useState60[1];
    var _useState601 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), data = _useState601[0], setData = _useState601[1];
    var _useState602 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), error = _useState602[0], setError = _useState602[1];
    var workerRef = (0, $eHaBZ.useRef)(null);
    var isSupported = typeof window !== "undefined" && "Worker" in window;
    (0, $eHaBZ.useEffect)(function() {
        if (!isSupported || !workerUrl) return;
        try {
            var worker = new Worker(workerUrl);
            workerRef.current = worker;
            worker.onmessage = function(event) {
                setData(event.data);
                setStatus("success");
                setError(null);
            };
            worker.onerror = function(event) {
                var _$err = new Error(event.message || "Worker error");
                setError(_$err);
                setStatus("error");
            };
            return function() {
                worker.terminate();
                workerRef.current = null;
            };
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to create worker");
            setError(error2);
            setStatus("error");
        }
    }, [
        workerUrl,
        isSupported
    ]);
    var postMessage = (0, $eHaBZ.useCallback)(function(message) {
        if (!isSupported) {
            console.warn("Web Workers are not supported");
            return;
        }
        if (!workerRef.current) {
            console.warn("Worker not initialized");
            return;
        }
        if (status === "terminated") {
            console.warn("Cannot post message to terminated worker");
            return;
        }
        try {
            setStatus("running");
            setError(null);
            workerRef.current.postMessage(message);
        } catch (err) {
            var error2 = err instanceof Error ? err : new Error("Failed to post message");
            setError(error2);
            setStatus("error");
        }
    }, [
        isSupported,
        status
    ]);
    var terminate = (0, $eHaBZ.useCallback)(function() {
        if (workerRef.current) {
            workerRef.current.terminate();
            workerRef.current = null;
            setStatus("terminated");
        }
    }, []);
    return {
        postMessage: postMessage,
        terminate: terminate,
        status: status,
        data: data,
        error: error,
        isSupported: isSupported
    };
}
function $c020e53fc27b31fb$export$d610da56a90dcd8d(componentName, currentProps) {
    var enableLogging = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
    var previousProps = (0, $eHaBZ.useRef)({});
    $c020e53fc27b31fb$export$e34ed88fef4dc107(function() {
        if (previousProps.current && enableLogging) {
            var combinedKeys = Object.keys((0, $lvTkn._)({}, previousProps.current, currentProps));
            var changedProps = {};
            combinedKeys.forEach(function(key) {
                if (!Object.is(previousProps.current[key], currentProps[key])) changedProps[key] = {
                    from: previousProps.current[key],
                    to: currentProps[key]
                };
            });
            if (Object.keys(changedProps).length) console.log("[why-did-you-update]", componentName, changedProps);
        }
    }, [
        currentProps,
        componentName,
        enableLogging
    ]);
    (0, $eHaBZ.useEffect)(function() {
        previousProps.current = currentProps;
    });
}
// src/hooks/useWindowEventListener.ts
function $c020e53fc27b31fb$export$8efa3c5b6bec5fbd(eventName, callback) {
    var listenerOptions = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, isLayoutEffect = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : false;
    $c020e53fc27b31fb$var$useGlobalObjectEventListener(typeof window !== "undefined" ? window : void 0, eventName, callback, listenerOptions, true, isLayoutEffect);
}
function $c020e53fc27b31fb$var$computeScrollPosition() {
    if (typeof window === "undefined") return {
        scrollX: 0,
        scrollY: 0
    };
    else return {
        scrollX: window.scrollX || window.pageXOffset,
        scrollY: window.scrollY || window.pageYOffset
    };
}
function $c020e53fc27b31fb$export$46be7d46e2475cd6() {
    var _useState61 = (0, $21h22._)((0, $eHaBZ.useState)($c020e53fc27b31fb$var$computeScrollPosition), 2), scrollPosition = _useState61[0], setScrollPosition = _useState61[1];
    $c020e53fc27b31fb$export$f2fb712044277d5e(function() {
        setScrollPosition($c020e53fc27b31fb$var$computeScrollPosition());
    }, true, true);
    $c020e53fc27b31fb$export$61171a90a6148cf5(function() {
        setScrollPosition($c020e53fc27b31fb$var$computeScrollPosition());
    }, true, true);
    return scrollPosition;
}
var $c020e53fc27b31fb$var$nullDimensions = {
    innerHeight: null,
    innerWidth: null,
    outerHeight: null,
    outerWidth: null
};
function $c020e53fc27b31fb$var$getDimensions() {
    return {
        innerHeight: window.innerHeight,
        innerWidth: window.innerWidth,
        outerHeight: window.outerHeight,
        outerWidth: window.outerWidth
    };
}
function $c020e53fc27b31fb$export$42c02f33970a2afa() {
    var cacheRef = (0, $eHaBZ.useRef)($c020e53fc27b31fb$var$nullDimensions);
    var subscribe3 = (0, $eHaBZ.useCallback)(function(onStoreChange) {
        window.addEventListener("resize", onStoreChange);
        return function() {
            window.removeEventListener("resize", onStoreChange);
        };
    }, []);
    var getSnapshot2 = (0, $eHaBZ.useCallback)(function() {
        var newDimensions = $c020e53fc27b31fb$var$getDimensions();
        if (cacheRef.current.innerHeight !== newDimensions.innerHeight || cacheRef.current.innerWidth !== newDimensions.innerWidth || cacheRef.current.outerHeight !== newDimensions.outerHeight || cacheRef.current.outerWidth !== newDimensions.outerWidth) cacheRef.current = newDimensions;
        return cacheRef.current;
    }, []);
    var getServerSnapshot = (0, $eHaBZ.useCallback)(function() {
        return $c020e53fc27b31fb$var$nullDimensions;
    }, []);
    return (0, $eHaBZ.useSyncExternalStore)(subscribe3, getSnapshot2, getServerSnapshot);
}
function $c020e53fc27b31fb$var$isFocusedElementEditable() {
    var activeElement = document.activeElement, body = document.body;
    if (!activeElement) return false;
    if (activeElement === body) return false;
    var tag = activeElement.tagName;
    if (tag === "INPUT" || tag === "TEXTAREA") return true;
    return activeElement.hasAttribute("contenteditable");
}
function $c020e53fc27b31fb$var$isAllowedKey(event, options) {
    if (event.metaKey || event.ctrlKey || event.altKey) return false;
    var key = event.key;
    if (options.includeAZ && /^[a-zA-Z]$/.test(key)) return true;
    if (options.includeNumbers && /^[0-9]$/.test(key)) return true;
    return false;
}
function $c020e53fc27b31fb$export$906b9e7f6c564e10(callback, options) {
    var opts = (0, $lvTkn._)({
        includeAZ: true,
        includeNumbers: false
    }, options);
    var freshCallback = $c020e53fc27b31fb$export$699327ecb1dd6b0d(callback);
    var handler = (0, $eHaBZ.useCallback)(function(event) {
        if (!$c020e53fc27b31fb$var$isFocusedElementEditable() && $c020e53fc27b31fb$var$isAllowedKey(event, opts)) freshCallback(event);
    }, [
        freshCallback,
        opts.includeAZ,
        opts.includeNumbers
    ]);
    (0, $e146ef819c676a18$export$363c9f3eb56bbdbe)(function() {
        document.addEventListener("keydown", handler);
        return function() {
            document.removeEventListener("keydown", handler);
        };
    }, [
        handler
    ]);
}





function $78e4b177702c1375$export$2e2bcd8739ae039(props) {
    var setTitle = props.setTitle;
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var _useActionState = (0, $21h22._)((0, $eHaBZ.useActionState)(function(_previousState, formData) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var file, _ref, response, data, messages, error;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        file = formData.get('opml');
                        _state.label = 1;
                    case 1:
                        _state.trys.push([
                            1,
                            3,
                            ,
                            4
                        ]);
                        return [
                            4,
                            (0, $4f5da2ef0a8f061c$export$b3b4cde15a96b715)(file)
                        ];
                    case 2:
                        _ref = _state.sent(), response = _ref.response, data = _ref.data;
                        messages = data.messages;
                        if (response.status === 200) return [
                            2,
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                                className: "msg success",
                                children: [
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                        children: messages.map(function(msg, i) {
                                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                                children: msg
                                            }, i);
                                        })
                                    }),
                                    "You might want to ",
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                                        href: "update",
                                        children: "update now"
                                    }),
                                    " or",
                                    ' ',
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                                        to: "/",
                                        children: "view your feeds"
                                    }),
                                    "."
                                ]
                            })
                        ];
                        else if (response.status === 202) return [
                            2,
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                                className: "msg error",
                                children: [
                                    "The following feeds could not be imported:",
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                        children: messages.map(function(msg, i) {
                                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                                children: msg
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ];
                        else if (response.status === 400) return [
                            2,
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
                                className: "msg error",
                                children: [
                                    "There was a problem importing your OPML file:",
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("br", {}),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                        children: messages.map(function(msg, i) {
                                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                                children: msg
                                            }, i);
                                        })
                                    })
                                ]
                            })
                        ];
                        else throw new (0, $d78024f502d9a257$export$4511c7da58e2d9c2)("OPML import handler received status ".concat(response.status, ". This should not happen."));
                        return [
                            3,
                            4
                        ];
                    case 3:
                        error = _state.sent();
                        if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                            navigate('/sign/in', {
                                state: {
                                    error: "Importing OPML file requires being logged in or not setting \u201Cpassword\u201D in selfoss configuration.",
                                    returnLocation: '/opml'
                                }
                            });
                            return [
                                2,
                                null
                            ];
                        } else return [
                            2,
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                className: "msg error",
                                children: [
                                    "Unexpected error occurred.",
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("details", {
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("pre", {
                                            children: error.message
                                        })
                                    })
                                ]
                            })
                        ];
                        return [
                            3,
                            4
                        ];
                    case 4:
                        return [
                            2
                        ];
                }
            });
        })();
    }, null), 3), message = _useActionState[0], submitAction = _useActionState[1], isPending = _useActionState[2];
    var submit = (0, $eHaBZ.useCallback)(function(event) {
        // We cannot use `action` prop with `enctype`.
        event.preventDefault();
        var formData = new (0, $3cd9a930e9e44820$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $eHaBZ.startTransition)(function() {
            return submitAction(formData);
        });
    }, [
        submitAction
    ]);
    (0, $eHaBZ.useEffect)(function() {
        setTitle('selfoss OPML importer');
        return function() {
            setTitle(null);
        };
    }, [
        setTitle
    ]);
    var isOnline = (0, $c020e53fc27b31fb$export$6feb6ada280bcdab)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        action: "",
        method: "post",
        encType: "multipart/form-data",
        onSubmit: submit,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            id: "opml",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h1", {
                        children: "Upload an OPML File"
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: "Coming from a different RSS Reader? Export your subscriptions to an OPML file and upload it here. OPML export is usually located somewhere in settings, consult the reader\u2019s manual."
                    })
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "message-container",
                    "aria-live": "assertive",
                    children: [
                        !isOnline && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "msg error",
                            children: "OPML import requires an internet connection. Please reconnect before proceeding."
                        }),
                        !isPending && message
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "center",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "opml",
                            children: "Opml.xml:"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "file",
                            name: "opml",
                            accessKey: "f",
                            id: "opml",
                            required: true
                        })
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "button",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            children: "\xa0"
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            type: "submit",
                            value: isPending ? "Importing\u2026" : 'Deliver my OPML!',
                            accessKey: "d",
                            disabled: !isOnline || isPending
                        })
                    ]
                })
            ]
        })
    });
}




var $21h22 = parcelRequire("21h22");




var $eHaBZ = parcelRequire("eHaBZ");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $ggKxj = parcelRequire("ggKxj");

/**
 * Object describing how feed items are filtered in the view.
 */ var $6ccbaa1864c958ec$export$c67e46de1ec7dfa6 = /*#__PURE__*/ function(FilterType) {
    FilterType["NEWEST"] = "newest";
    FilterType["UNREAD"] = "unread";
    FilterType["STARRED"] = "starred";
    return FilterType;
}({});


function $3d1fd3a25027abce$export$45d76561a5302f2b() {
    return (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
}
function $3d1fd3a25027abce$export$46e843a62e9cebcc(type) {
    if (type == 'newest') return (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).NEWEST;
    else if (type == 'unread') return (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD;
    else if (type == 'starred') return (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED;
    else throw new Error("Invalid filter type: \u201C".concat(type, "\u201D"));
}
function $3d1fd3a25027abce$export$63b3966ca4cc85d9(type) {
    if (type == (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).NEWEST) return 'newest';
    else if (type == (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD) return 'unread';
    else if (type == (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED) return 'starred';
    else throw new Error("Invalid filter type: \u201C".concat(type, "\u201D"));
}
function $3d1fd3a25027abce$var$generatePath(param) {
    var filter = param.filter, category = param.category, id = param.id;
    return "/".concat(filter, "/").concat(category).concat(id ? "/".concat(id) : '');
}
function $3d1fd3a25027abce$export$216385125ee84ae7() {
    var match = (0, $0386ffc241ff4f20$export$6c330e8992e8a295)(':filter/:category/:id?');
    if (match === null) return null;
    var params = match.params;
    if (!params.filter || !params.category) // Note: it isn't possible to reach this part of the code
    //       This is to keep the TypeScript compiler happy
    return null;
    var filterValid = /^(newest|unread|starred)$/.test(params.filter);
    var categoryValid = /^(all|tag-.+|source-[0-9]+)$/.test(params.category);
    var idValid = params.id === undefined || /^\d+$/.test(params.id);
    if (!filterValid || !idValid || !categoryValid) return null;
    return {
        filter: $3d1fd3a25027abce$export$46e843a62e9cebcc(params.filter),
        category: params.category,
        id: params.id === undefined ? null : parseInt(params.id, 10)
    };
}
function $3d1fd3a25027abce$export$d0bb2ab5375d1521(location, param) {
    var filter = param.filter, category = param.category, id = param.id, search = param.search;
    var queryString = new URLSearchParams(location.search);
    var path;
    if (location.pathname.match(/^\/(newest|unread|starred)\//) !== null) {
        var _location_pathname_split = (0, $ggKxj._)(location.pathname.split('/')), segments = _location_pathname_split.slice(1);
        path = $3d1fd3a25027abce$var$generatePath({
            filter: filter !== null && filter !== void 0 ? filter : segments[0],
            category: category !== null && category !== void 0 ? category : segments[1],
            id: typeof id !== 'undefined' ? id : segments[2]
        });
    } else path = $3d1fd3a25027abce$var$generatePath({
        // TODO: change default from config
        filter: filter !== null && filter !== void 0 ? filter : 'unread',
        category: category !== null && category !== void 0 ? category : 'all',
        id: id
    });
    if (typeof search !== 'undefined') {
        if (search) queryString.set('search', search);
        else queryString.delete('search');
    }
    return {
        pathname: path,
        search: queryString.toString()
    };
}
function $3d1fd3a25027abce$export$7f0beea2aa79e4fa(location, params) {
    var _makeEntriesLinkLocation = $3d1fd3a25027abce$export$d0bb2ab5375d1521(location, params), pathname = _makeEntriesLinkLocation.pathname, search = _makeEntriesLinkLocation.search;
    return pathname + (search !== '' ? "?".concat(search) : '');
}
function $3d1fd3a25027abce$export$e64cf1b9b4b3aa56(location) {
    var _location_state;
    var state = (_location_state = location.state) !== null && _location_state !== void 0 ? _location_state : {};
    var _state_forceReload;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
        forceReload: ((_state_forceReload = state.forceReload) !== null && _state_forceReload !== void 0 ? _state_forceReload : 0) + 1
    });
}
function $3d1fd3a25027abce$export$6bccca1b7088ecd7() {
    var location = $3d1fd3a25027abce$export$45d76561a5302f2b();
    return $3d1fd3a25027abce$export$e64cf1b9b4b3aa56(location);
}




parcelRequire("eHaBZ");

var $8216ee54ed5c099f$exports = {};
'use strict';
Object.defineProperty($8216ee54ed5c099f$exports, '__esModule', {
    value: true
});
var $8216ee54ed5c099f$var$prefix = 'fab';
var $8216ee54ed5c099f$var$iconName = 'diaspora';
var $8216ee54ed5c099f$var$width = 448;
var $8216ee54ed5c099f$var$height = 512;
var $8216ee54ed5c099f$var$aliases = [];
var $8216ee54ed5c099f$var$unicode = 'f791';
var $8216ee54ed5c099f$var$svgPathData = 'M219.7 354.6c-1.4 0-88 119.9-88.7 119.9S44.4 414 44 413.3 130.6 287.5 130.6 285.8c0-2.2-129.6-44-137.6-47.1-1.3-.5 31.4-101.8 31.7-102.1 .6-.7 144.4 47 145.5 47 .4 0 .9-.6 1-1.3 .4-2 1-148.6 1.7-149.6 .8-1.2 104.5-.7 105.1-.3 1.5 1 3.5 156.1 6.1 156.1 1.4 0 138.7-47 139.3-46.3 .8 .9 31.9 102.2 31.5 102.6-.9 .9-140.2 47.1-140.6 48.8-.3 1.4 82.8 122.1 82.5 122.9s-85.5 63.5-86.3 63.5c-1-.2-89-125.5-90.9-125.5l0 0z';
$8216ee54ed5c099f$exports.definition = {
    prefix: $8216ee54ed5c099f$var$prefix,
    iconName: $8216ee54ed5c099f$var$iconName,
    icon: [
        $8216ee54ed5c099f$var$width,
        $8216ee54ed5c099f$var$height,
        $8216ee54ed5c099f$var$aliases,
        $8216ee54ed5c099f$var$unicode,
        $8216ee54ed5c099f$var$svgPathData
    ]
};
$8216ee54ed5c099f$exports.faDiaspora = $8216ee54ed5c099f$exports.definition;
$8216ee54ed5c099f$exports.prefix = $8216ee54ed5c099f$var$prefix;
$8216ee54ed5c099f$exports.iconName = $8216ee54ed5c099f$var$iconName;
$8216ee54ed5c099f$exports.width = $8216ee54ed5c099f$var$width;
$8216ee54ed5c099f$exports.height = $8216ee54ed5c099f$var$height;
$8216ee54ed5c099f$exports.ligatures = $8216ee54ed5c099f$var$aliases;
$8216ee54ed5c099f$exports.unicode = $8216ee54ed5c099f$var$unicode;
$8216ee54ed5c099f$exports.svgPathData = $8216ee54ed5c099f$var$svgPathData;
$8216ee54ed5c099f$exports.aliases = $8216ee54ed5c099f$var$aliases;


var $a5565bc5d7aa9135$exports = {};
'use strict';
Object.defineProperty($a5565bc5d7aa9135$exports, '__esModule', {
    value: true
});
var $79ac955092d93bd6$exports = {};
'use strict';
Object.defineProperty($79ac955092d93bd6$exports, '__esModule', {
    value: true
});
var $79ac955092d93bd6$var$prefix = 'fab';
var $79ac955092d93bd6$var$iconName = 'square-facebook';
var $79ac955092d93bd6$var$width = 448;
var $79ac955092d93bd6$var$height = 512;
var $79ac955092d93bd6$var$aliases = [
    "facebook-square"
];
var $79ac955092d93bd6$var$unicode = 'f082';
var $79ac955092d93bd6$var$svgPathData = 'M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l98.2 0 0-145.8-52.8 0 0-78.2 52.8 0 0-33.7c0-87.1 39.4-127.5 125-127.5 16.2 0 44.2 3.2 55.7 6.4l0 70.8c-6-.6-16.5-1-29.6-1-42 0-58.2 15.9-58.2 57.2l0 27.8 83.6 0-14.4 78.2-69.3 0 0 145.8 129 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32z';
$79ac955092d93bd6$exports.definition = {
    prefix: $79ac955092d93bd6$var$prefix,
    iconName: $79ac955092d93bd6$var$iconName,
    icon: [
        $79ac955092d93bd6$var$width,
        $79ac955092d93bd6$var$height,
        $79ac955092d93bd6$var$aliases,
        $79ac955092d93bd6$var$unicode,
        $79ac955092d93bd6$var$svgPathData
    ]
};
$79ac955092d93bd6$exports.faSquareFacebook = $79ac955092d93bd6$exports.definition;
$79ac955092d93bd6$exports.prefix = $79ac955092d93bd6$var$prefix;
$79ac955092d93bd6$exports.iconName = $79ac955092d93bd6$var$iconName;
$79ac955092d93bd6$exports.width = $79ac955092d93bd6$var$width;
$79ac955092d93bd6$exports.height = $79ac955092d93bd6$var$height;
$79ac955092d93bd6$exports.ligatures = $79ac955092d93bd6$var$aliases;
$79ac955092d93bd6$exports.unicode = $79ac955092d93bd6$var$unicode;
$79ac955092d93bd6$exports.svgPathData = $79ac955092d93bd6$var$svgPathData;
$79ac955092d93bd6$exports.aliases = $79ac955092d93bd6$var$aliases;


$a5565bc5d7aa9135$exports.definition = {
    prefix: $79ac955092d93bd6$exports.prefix,
    iconName: $79ac955092d93bd6$exports.iconName,
    icon: [
        $79ac955092d93bd6$exports.width,
        $79ac955092d93bd6$exports.height,
        $79ac955092d93bd6$exports.aliases,
        $79ac955092d93bd6$exports.unicode,
        $79ac955092d93bd6$exports.svgPathData
    ]
};
$a5565bc5d7aa9135$exports.faFacebookSquare = $a5565bc5d7aa9135$exports.definition;
$a5565bc5d7aa9135$exports.prefix = $79ac955092d93bd6$exports.prefix;
$a5565bc5d7aa9135$exports.iconName = $79ac955092d93bd6$exports.iconName;
$a5565bc5d7aa9135$exports.width = $79ac955092d93bd6$exports.width;
$a5565bc5d7aa9135$exports.height = $79ac955092d93bd6$exports.height;
$a5565bc5d7aa9135$exports.ligatures = $79ac955092d93bd6$exports.aliases;
$a5565bc5d7aa9135$exports.unicode = $79ac955092d93bd6$exports.unicode;
$a5565bc5d7aa9135$exports.svgPathData = $79ac955092d93bd6$exports.svgPathData;
$a5565bc5d7aa9135$exports.aliases = $79ac955092d93bd6$exports.aliases;


var $acd52ab24d9744ba$exports = {};
'use strict';
Object.defineProperty($acd52ab24d9744ba$exports, '__esModule', {
    value: true
});
var $acd52ab24d9744ba$var$prefix = 'fab';
var $acd52ab24d9744ba$var$iconName = 'get-pocket';
var $acd52ab24d9744ba$var$width = 448;
var $acd52ab24d9744ba$var$height = 512;
var $acd52ab24d9744ba$var$aliases = [];
var $acd52ab24d9744ba$var$unicode = 'f265';
var $acd52ab24d9744ba$var$svgPathData = 'M407.6 64l-367 0C18.5 64 0 82.5 0 104.6L0 239.8C0 364.5 99.7 464 224.2 464 348.2 464 448 364.5 448 239.8l0-135.2C448 82.2 430.3 64 407.6 64zm-162 268.5c-12.4 11.8-31.4 11.1-42.4 0-113.7-108.9-114.9-105.1-114.9-123.2 0-16.9 13.8-30.7 30.7-30.7 17 0 16.1 3.8 105.2 89.3 90.6-86.9 88.6-89.3 105.5-89.3s30.7 13.8 30.7 30.7c0 17.8-2.9 15.7-114.8 123.2z';
$acd52ab24d9744ba$exports.definition = {
    prefix: $acd52ab24d9744ba$var$prefix,
    iconName: $acd52ab24d9744ba$var$iconName,
    icon: [
        $acd52ab24d9744ba$var$width,
        $acd52ab24d9744ba$var$height,
        $acd52ab24d9744ba$var$aliases,
        $acd52ab24d9744ba$var$unicode,
        $acd52ab24d9744ba$var$svgPathData
    ]
};
$acd52ab24d9744ba$exports.faGetPocket = $acd52ab24d9744ba$exports.definition;
$acd52ab24d9744ba$exports.prefix = $acd52ab24d9744ba$var$prefix;
$acd52ab24d9744ba$exports.iconName = $acd52ab24d9744ba$var$iconName;
$acd52ab24d9744ba$exports.width = $acd52ab24d9744ba$var$width;
$acd52ab24d9744ba$exports.height = $acd52ab24d9744ba$var$height;
$acd52ab24d9744ba$exports.ligatures = $acd52ab24d9744ba$var$aliases;
$acd52ab24d9744ba$exports.unicode = $acd52ab24d9744ba$var$unicode;
$acd52ab24d9744ba$exports.svgPathData = $acd52ab24d9744ba$var$svgPathData;
$acd52ab24d9744ba$exports.aliases = $acd52ab24d9744ba$var$aliases;


var $11826e5bf54ad532$exports = {};
'use strict';
Object.defineProperty($11826e5bf54ad532$exports, '__esModule', {
    value: true
});
var $11826e5bf54ad532$var$prefix = 'fab';
var $11826e5bf54ad532$var$iconName = 'twitter';
var $11826e5bf54ad532$var$width = 512;
var $11826e5bf54ad532$var$height = 512;
var $11826e5bf54ad532$var$aliases = [];
var $11826e5bf54ad532$var$unicode = 'f099';
var $11826e5bf54ad532$var$svgPathData = 'M459.4 151.7c.3 4.5 .3 9.1 .3 13.6 0 138.7-105.6 298.6-298.6 298.6-59.5 0-114.7-17.2-161.1-47.1 8.4 1 16.6 1.3 25.3 1.3 49.1 0 94.2-16.6 130.3-44.8-46.1-1-84.8-31.2-98.1-72.8 6.5 1 13 1.6 19.8 1.6 9.4 0 18.8-1.3 27.6-3.6-48.1-9.7-84.1-52-84.1-103l0-1.3c14 7.8 30.2 12.7 47.4 13.3-28.3-18.8-46.8-51-46.8-87.4 0-19.5 5.2-37.4 14.3-53 51.7 63.7 129.3 105.3 216.4 109.8-1.6-7.8-2.6-15.9-2.6-24 0-57.8 46.8-104.9 104.9-104.9 30.2 0 57.5 12.7 76.7 33.1 23.7-4.5 46.5-13.3 66.6-25.3-7.8 24.4-24.4 44.8-46.1 57.8 21.1-2.3 41.6-8.1 60.4-16.2-14.3 20.8-32.2 39.3-52.6 54.3z';
$11826e5bf54ad532$exports.definition = {
    prefix: $11826e5bf54ad532$var$prefix,
    iconName: $11826e5bf54ad532$var$iconName,
    icon: [
        $11826e5bf54ad532$var$width,
        $11826e5bf54ad532$var$height,
        $11826e5bf54ad532$var$aliases,
        $11826e5bf54ad532$var$unicode,
        $11826e5bf54ad532$var$svgPathData
    ]
};
$11826e5bf54ad532$exports.faTwitter = $11826e5bf54ad532$exports.definition;
$11826e5bf54ad532$exports.prefix = $11826e5bf54ad532$var$prefix;
$11826e5bf54ad532$exports.iconName = $11826e5bf54ad532$var$iconName;
$11826e5bf54ad532$exports.width = $11826e5bf54ad532$var$width;
$11826e5bf54ad532$exports.height = $11826e5bf54ad532$var$height;
$11826e5bf54ad532$exports.ligatures = $11826e5bf54ad532$var$aliases;
$11826e5bf54ad532$exports.unicode = $11826e5bf54ad532$var$unicode;
$11826e5bf54ad532$exports.svgPathData = $11826e5bf54ad532$var$svgPathData;
$11826e5bf54ad532$exports.aliases = $11826e5bf54ad532$var$aliases;


var $8ebe08a4e3d0a860$exports = {};
'use strict';
Object.defineProperty($8ebe08a4e3d0a860$exports, '__esModule', {
    value: true
});
var $8ebe08a4e3d0a860$var$prefix = 'fab';
var $8ebe08a4e3d0a860$var$iconName = 'wordpress-simple';
var $8ebe08a4e3d0a860$var$width = 512;
var $8ebe08a4e3d0a860$var$height = 512;
var $8ebe08a4e3d0a860$var$aliases = [];
var $8ebe08a4e3d0a860$var$unicode = 'f411';
var $8ebe08a4e3d0a860$var$svgPathData = 'M256 8a248 248 0 1 0 0 496 248 248 0 1 0 0-496zM33 256c0-32.3 6.9-63 19.3-90.7L158.7 456.7C84.3 420.5 33 344.2 33 256zM256 479c-21.9 0-43-3.2-63-9.1l66.9-194.4 68.5 187.8c.5 1.1 1 2.1 1.6 3.1-23.1 8.1-48 12.6-74 12.6zm30.7-327.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-21.9 0-58.7-2.8-58.7-2.8-12-.7-13.4 17.7-1.4 18.4 0 0 11.4 1.4 23.4 2.1l34.7 95.2-48.8 146.3-81.2-241.5c13.4-.7 25.5-2.1 25.5-2.1 12-1.4 10.6-19.1-1.4-18.4 0 0-36.1 2.8-59.4 2.8-4.2 0-9.1-.1-14.4-.3 39.9-60.5 108.4-100.5 186.3-100.5 58 0 110.9 22.2 150.6 58.5-1-.1-1.9-.2-2.9-.2-21.9 0-37.4 19.1-37.4 39.6 0 18.4 10.6 33.9 21.9 52.3 8.5 14.8 18.4 33.9 18.4 61.5 0 19.1-7.3 41.2-17 72.1l-22.2 74.3-80.7-239.6zm81.4 297.2l68.1-196.9c12.7-31.8 17-57.2 17-79.9 0-8.2-.5-15.8-1.5-22.9 17.4 31.8 27.3 68.2 27.3 107 0 82.3-44.6 154.1-110.9 192.7z';
$8ebe08a4e3d0a860$exports.definition = {
    prefix: $8ebe08a4e3d0a860$var$prefix,
    iconName: $8ebe08a4e3d0a860$var$iconName,
    icon: [
        $8ebe08a4e3d0a860$var$width,
        $8ebe08a4e3d0a860$var$height,
        $8ebe08a4e3d0a860$var$aliases,
        $8ebe08a4e3d0a860$var$unicode,
        $8ebe08a4e3d0a860$var$svgPathData
    ]
};
$8ebe08a4e3d0a860$exports.faWordpressSimple = $8ebe08a4e3d0a860$exports.definition;
$8ebe08a4e3d0a860$exports.prefix = $8ebe08a4e3d0a860$var$prefix;
$8ebe08a4e3d0a860$exports.iconName = $8ebe08a4e3d0a860$var$iconName;
$8ebe08a4e3d0a860$exports.width = $8ebe08a4e3d0a860$var$width;
$8ebe08a4e3d0a860$exports.height = $8ebe08a4e3d0a860$var$height;
$8ebe08a4e3d0a860$exports.ligatures = $8ebe08a4e3d0a860$var$aliases;
$8ebe08a4e3d0a860$exports.unicode = $8ebe08a4e3d0a860$var$unicode;
$8ebe08a4e3d0a860$exports.svgPathData = $8ebe08a4e3d0a860$var$svgPathData;
$8ebe08a4e3d0a860$exports.aliases = $8ebe08a4e3d0a860$var$aliases;


var $b92068b2b2ac161b$exports = {};
'use strict';
Object.defineProperty($b92068b2b2ac161b$exports, '__esModule', {
    value: true
});
var $b92068b2b2ac161b$var$prefix = 'fab';
var $b92068b2b2ac161b$var$iconName = 'mastodon';
var $b92068b2b2ac161b$var$width = 448;
var $b92068b2b2ac161b$var$height = 512;
var $b92068b2b2ac161b$var$aliases = [];
var $b92068b2b2ac161b$var$unicode = 'f4f6';
var $b92068b2b2ac161b$var$svgPathData = 'M433 179.1c0-97.2-63.7-125.7-63.7-125.7-62.5-28.7-228.6-28.4-290.5 0 0 0-63.7 28.5-63.7 125.7 0 115.7-6.6 259.4 105.6 289.1 40.5 10.7 75.3 13 103.3 11.4 50.8-2.8 79.3-18.1 79.3-18.1l-1.7-36.9s-36.3 11.4-77.1 10.1c-40.4-1.4-83-4.4-89.6-54-.6-4.6-.9-9.3-.9-13.9 85.6 20.9 158.7 9.1 178.7 6.7 56.1-6.7 105-41.3 111.2-72.9 9.8-49.8 9-121.5 9-121.5zM357.9 304.3l-46.6 0 0-114.2c0-49.7-64-51.6-64 6.9l0 62.5-46.3 0 0-62.5c0-58.5-64-56.6-64-6.9l0 114.2-46.7 0c0-122.1-5.2-147.9 18.4-175 25.9-28.9 79.8-30.8 103.8 6.1l11.6 19.5 11.6-19.5c24.1-37.1 78.1-34.8 103.8-6.1 23.7 27.3 18.4 53 18.4 175l0 0z';
$b92068b2b2ac161b$exports.definition = {
    prefix: $b92068b2b2ac161b$var$prefix,
    iconName: $b92068b2b2ac161b$var$iconName,
    icon: [
        $b92068b2b2ac161b$var$width,
        $b92068b2b2ac161b$var$height,
        $b92068b2b2ac161b$var$aliases,
        $b92068b2b2ac161b$var$unicode,
        $b92068b2b2ac161b$var$svgPathData
    ]
};
$b92068b2b2ac161b$exports.faMastodon = $b92068b2b2ac161b$exports.definition;
$b92068b2b2ac161b$exports.prefix = $b92068b2b2ac161b$var$prefix;
$b92068b2b2ac161b$exports.iconName = $b92068b2b2ac161b$var$iconName;
$b92068b2b2ac161b$exports.width = $b92068b2b2ac161b$var$width;
$b92068b2b2ac161b$exports.height = $b92068b2b2ac161b$var$height;
$b92068b2b2ac161b$exports.ligatures = $b92068b2b2ac161b$var$aliases;
$b92068b2b2ac161b$exports.unicode = $b92068b2b2ac161b$var$unicode;
$b92068b2b2ac161b$exports.svgPathData = $b92068b2b2ac161b$var$svgPathData;
$b92068b2b2ac161b$exports.aliases = $b92068b2b2ac161b$var$aliases;


var $60c3775e24ebf896$exports = {};
'use strict';
Object.defineProperty($60c3775e24ebf896$exports, '__esModule', {
    value: true
});
var $7e27b77be2aec1a1$exports = {};
'use strict';
Object.defineProperty($7e27b77be2aec1a1$exports, '__esModule', {
    value: true
});
var $7e27b77be2aec1a1$var$prefix = 'far';
var $7e27b77be2aec1a1$var$iconName = 'circle-check';
var $7e27b77be2aec1a1$var$width = 512;
var $7e27b77be2aec1a1$var$height = 512;
var $7e27b77be2aec1a1$var$aliases = [
    61533,
    "check-circle"
];
var $7e27b77be2aec1a1$var$unicode = 'f058';
var $7e27b77be2aec1a1$var$svgPathData = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zm0-464a208 208 0 1 0 0 416 208 208 0 1 0 0-416zm70.7 121.9c7.8-10.7 22.8-13.1 33.5-5.3 10.7 7.8 13.1 22.8 5.3 33.5L243.4 366.1c-4.1 5.7-10.5 9.3-17.5 9.8-7 .5-13.9-2-18.8-6.9l-55.9-55.9c-9.4-9.4-9.4-24.6 0-33.9s24.6-9.4 33.9 0l36 36 105.6-145.2z';
$7e27b77be2aec1a1$exports.definition = {
    prefix: $7e27b77be2aec1a1$var$prefix,
    iconName: $7e27b77be2aec1a1$var$iconName,
    icon: [
        $7e27b77be2aec1a1$var$width,
        $7e27b77be2aec1a1$var$height,
        $7e27b77be2aec1a1$var$aliases,
        $7e27b77be2aec1a1$var$unicode,
        $7e27b77be2aec1a1$var$svgPathData
    ]
};
$7e27b77be2aec1a1$exports.faCircleCheck = $7e27b77be2aec1a1$exports.definition;
$7e27b77be2aec1a1$exports.prefix = $7e27b77be2aec1a1$var$prefix;
$7e27b77be2aec1a1$exports.iconName = $7e27b77be2aec1a1$var$iconName;
$7e27b77be2aec1a1$exports.width = $7e27b77be2aec1a1$var$width;
$7e27b77be2aec1a1$exports.height = $7e27b77be2aec1a1$var$height;
$7e27b77be2aec1a1$exports.ligatures = $7e27b77be2aec1a1$var$aliases;
$7e27b77be2aec1a1$exports.unicode = $7e27b77be2aec1a1$var$unicode;
$7e27b77be2aec1a1$exports.svgPathData = $7e27b77be2aec1a1$var$svgPathData;
$7e27b77be2aec1a1$exports.aliases = $7e27b77be2aec1a1$var$aliases;


$60c3775e24ebf896$exports.definition = {
    prefix: $7e27b77be2aec1a1$exports.prefix,
    iconName: $7e27b77be2aec1a1$exports.iconName,
    icon: [
        $7e27b77be2aec1a1$exports.width,
        $7e27b77be2aec1a1$exports.height,
        $7e27b77be2aec1a1$exports.aliases,
        $7e27b77be2aec1a1$exports.unicode,
        $7e27b77be2aec1a1$exports.svgPathData
    ]
};
$60c3775e24ebf896$exports.faCheckCircle = $60c3775e24ebf896$exports.definition;
$60c3775e24ebf896$exports.prefix = $7e27b77be2aec1a1$exports.prefix;
$60c3775e24ebf896$exports.iconName = $7e27b77be2aec1a1$exports.iconName;
$60c3775e24ebf896$exports.width = $7e27b77be2aec1a1$exports.width;
$60c3775e24ebf896$exports.height = $7e27b77be2aec1a1$exports.height;
$60c3775e24ebf896$exports.ligatures = $7e27b77be2aec1a1$exports.aliases;
$60c3775e24ebf896$exports.unicode = $7e27b77be2aec1a1$exports.unicode;
$60c3775e24ebf896$exports.svgPathData = $7e27b77be2aec1a1$exports.svgPathData;
$60c3775e24ebf896$exports.aliases = $7e27b77be2aec1a1$exports.aliases;


var $de3818063bbfedbe$exports = {};
'use strict';
Object.defineProperty($de3818063bbfedbe$exports, '__esModule', {
    value: true
});
var $de3818063bbfedbe$var$prefix = 'far';
var $de3818063bbfedbe$var$iconName = 'star';
var $de3818063bbfedbe$var$width = 576;
var $de3818063bbfedbe$var$height = 512;
var $de3818063bbfedbe$var$aliases = [
    11088,
    61446
];
var $de3818063bbfedbe$var$unicode = 'f005';
var $de3818063bbfedbe$var$svgPathData = 'M288.1-32c9 0 17.3 5.1 21.4 13.1L383 125.3 542.9 150.7c8.9 1.4 16.3 7.7 19.1 16.3s.5 18-5.8 24.4L441.7 305.9 467 465.8c1.4 8.9-2.3 17.9-9.6 23.2s-17 6.1-25 2L288.1 417.6 143.8 491c-8 4.1-17.7 3.3-25-2s-11-14.2-9.6-23.2L134.4 305.9 20 191.4c-6.4-6.4-8.6-15.8-5.8-24.4s10.1-14.9 19.1-16.3l159.9-25.4 73.6-144.2c4.1-8 12.4-13.1 21.4-13.1zm0 76.8L230.3 158c-3.5 6.8-10 11.6-17.6 12.8l-125.5 20 89.8 89.9c5.4 5.4 7.9 13.1 6.7 20.7l-19.8 125.5 113.3-57.6c6.8-3.5 14.9-3.5 21.8 0l113.3 57.6-19.8-125.5c-1.2-7.6 1.3-15.3 6.7-20.7l89.8-89.9-125.5-20c-7.6-1.2-14.1-6-17.6-12.8L288.1 44.8z';
$de3818063bbfedbe$exports.definition = {
    prefix: $de3818063bbfedbe$var$prefix,
    iconName: $de3818063bbfedbe$var$iconName,
    icon: [
        $de3818063bbfedbe$var$width,
        $de3818063bbfedbe$var$height,
        $de3818063bbfedbe$var$aliases,
        $de3818063bbfedbe$var$unicode,
        $de3818063bbfedbe$var$svgPathData
    ]
};
$de3818063bbfedbe$exports.faStar = $de3818063bbfedbe$exports.definition;
$de3818063bbfedbe$exports.prefix = $de3818063bbfedbe$var$prefix;
$de3818063bbfedbe$exports.iconName = $de3818063bbfedbe$var$iconName;
$de3818063bbfedbe$exports.width = $de3818063bbfedbe$var$width;
$de3818063bbfedbe$exports.height = $de3818063bbfedbe$var$height;
$de3818063bbfedbe$exports.ligatures = $de3818063bbfedbe$var$aliases;
$de3818063bbfedbe$exports.unicode = $de3818063bbfedbe$var$unicode;
$de3818063bbfedbe$exports.svgPathData = $de3818063bbfedbe$var$svgPathData;
$de3818063bbfedbe$exports.aliases = $de3818063bbfedbe$var$aliases;


var $ea95ad8a568dd277$exports = {};
'use strict';
Object.defineProperty($ea95ad8a568dd277$exports, '__esModule', {
    value: true
});
var $404c2ac019d45a68$exports = {};
'use strict';
Object.defineProperty($404c2ac019d45a68$exports, '__esModule', {
    value: true
});
var $404c2ac019d45a68$var$prefix = 'far';
var $404c2ac019d45a68$var$iconName = 'circle-xmark';
var $404c2ac019d45a68$var$width = 512;
var $404c2ac019d45a68$var$height = 512;
var $404c2ac019d45a68$var$aliases = [
    61532,
    "times-circle",
    "xmark-circle"
];
var $404c2ac019d45a68$var$unicode = 'f057';
var $404c2ac019d45a68$var$svgPathData = 'M256 48a208 208 0 1 1 0 416 208 208 0 1 1 0-416zm0 464a256 256 0 1 0 0-512 256 256 0 1 0 0 512zM167 167c-9.4 9.4-9.4 24.6 0 33.9l55 55-55 55c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l55-55 55 55c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-55-55 55-55c9.4-9.4 9.4-24.6 0-33.9s-24.6-9.4-33.9 0l-55 55-55-55c-9.4-9.4-24.6-9.4-33.9 0z';
$404c2ac019d45a68$exports.definition = {
    prefix: $404c2ac019d45a68$var$prefix,
    iconName: $404c2ac019d45a68$var$iconName,
    icon: [
        $404c2ac019d45a68$var$width,
        $404c2ac019d45a68$var$height,
        $404c2ac019d45a68$var$aliases,
        $404c2ac019d45a68$var$unicode,
        $404c2ac019d45a68$var$svgPathData
    ]
};
$404c2ac019d45a68$exports.faCircleXmark = $404c2ac019d45a68$exports.definition;
$404c2ac019d45a68$exports.prefix = $404c2ac019d45a68$var$prefix;
$404c2ac019d45a68$exports.iconName = $404c2ac019d45a68$var$iconName;
$404c2ac019d45a68$exports.width = $404c2ac019d45a68$var$width;
$404c2ac019d45a68$exports.height = $404c2ac019d45a68$var$height;
$404c2ac019d45a68$exports.ligatures = $404c2ac019d45a68$var$aliases;
$404c2ac019d45a68$exports.unicode = $404c2ac019d45a68$var$unicode;
$404c2ac019d45a68$exports.svgPathData = $404c2ac019d45a68$var$svgPathData;
$404c2ac019d45a68$exports.aliases = $404c2ac019d45a68$var$aliases;


$ea95ad8a568dd277$exports.definition = {
    prefix: $404c2ac019d45a68$exports.prefix,
    iconName: $404c2ac019d45a68$exports.iconName,
    icon: [
        $404c2ac019d45a68$exports.width,
        $404c2ac019d45a68$exports.height,
        $404c2ac019d45a68$exports.aliases,
        $404c2ac019d45a68$exports.unicode,
        $404c2ac019d45a68$exports.svgPathData
    ]
};
$ea95ad8a568dd277$exports.faTimesCircle = $ea95ad8a568dd277$exports.definition;
$ea95ad8a568dd277$exports.prefix = $404c2ac019d45a68$exports.prefix;
$ea95ad8a568dd277$exports.iconName = $404c2ac019d45a68$exports.iconName;
$ea95ad8a568dd277$exports.width = $404c2ac019d45a68$exports.width;
$ea95ad8a568dd277$exports.height = $404c2ac019d45a68$exports.height;
$ea95ad8a568dd277$exports.ligatures = $404c2ac019d45a68$exports.aliases;
$ea95ad8a568dd277$exports.unicode = $404c2ac019d45a68$exports.unicode;
$ea95ad8a568dd277$exports.svgPathData = $404c2ac019d45a68$exports.svgPathData;
$ea95ad8a568dd277$exports.aliases = $404c2ac019d45a68$exports.aliases;


var $7417e626c64fb3c5$exports = {};
'use strict';
Object.defineProperty($7417e626c64fb3c5$exports, '__esModule', {
    value: true
});
var $76a0fa091acb188e$exports = {};
'use strict';
Object.defineProperty($76a0fa091acb188e$exports, '__esModule', {
    value: true
});
var $76a0fa091acb188e$var$prefix = 'fas';
var $76a0fa091acb188e$var$iconName = 'circle-down';
var $76a0fa091acb188e$var$width = 512;
var $76a0fa091acb188e$var$height = 512;
var $76a0fa091acb188e$var$aliases = [
    61466,
    "arrow-alt-circle-down"
];
var $76a0fa091acb188e$var$unicode = 'f358';
var $76a0fa091acb188e$var$svgPathData = 'M256 0a256 256 0 1 0 0 512 256 256 0 1 0 0-512zM244.7 387.3l-104-104c-4.6-4.6-5.9-11.5-3.5-17.4s8.3-9.9 14.8-9.9l56 0 0-96c0-17.7 14.3-32 32-32l32 0c17.7 0 32 14.3 32 32l0 96 56 0c6.5 0 12.3 3.9 14.8 9.9s1.1 12.9-3.5 17.4l-104 104c-6.2 6.2-16.4 6.2-22.6 0z';
$76a0fa091acb188e$exports.definition = {
    prefix: $76a0fa091acb188e$var$prefix,
    iconName: $76a0fa091acb188e$var$iconName,
    icon: [
        $76a0fa091acb188e$var$width,
        $76a0fa091acb188e$var$height,
        $76a0fa091acb188e$var$aliases,
        $76a0fa091acb188e$var$unicode,
        $76a0fa091acb188e$var$svgPathData
    ]
};
$76a0fa091acb188e$exports.faCircleDown = $76a0fa091acb188e$exports.definition;
$76a0fa091acb188e$exports.prefix = $76a0fa091acb188e$var$prefix;
$76a0fa091acb188e$exports.iconName = $76a0fa091acb188e$var$iconName;
$76a0fa091acb188e$exports.width = $76a0fa091acb188e$var$width;
$76a0fa091acb188e$exports.height = $76a0fa091acb188e$var$height;
$76a0fa091acb188e$exports.ligatures = $76a0fa091acb188e$var$aliases;
$76a0fa091acb188e$exports.unicode = $76a0fa091acb188e$var$unicode;
$76a0fa091acb188e$exports.svgPathData = $76a0fa091acb188e$var$svgPathData;
$76a0fa091acb188e$exports.aliases = $76a0fa091acb188e$var$aliases;


$7417e626c64fb3c5$exports.definition = {
    prefix: $76a0fa091acb188e$exports.prefix,
    iconName: $76a0fa091acb188e$exports.iconName,
    icon: [
        $76a0fa091acb188e$exports.width,
        $76a0fa091acb188e$exports.height,
        $76a0fa091acb188e$exports.aliases,
        $76a0fa091acb188e$exports.unicode,
        $76a0fa091acb188e$exports.svgPathData
    ]
};
$7417e626c64fb3c5$exports.faArrowAltCircleDown = $7417e626c64fb3c5$exports.definition;
$7417e626c64fb3c5$exports.prefix = $76a0fa091acb188e$exports.prefix;
$7417e626c64fb3c5$exports.iconName = $76a0fa091acb188e$exports.iconName;
$7417e626c64fb3c5$exports.width = $76a0fa091acb188e$exports.width;
$7417e626c64fb3c5$exports.height = $76a0fa091acb188e$exports.height;
$7417e626c64fb3c5$exports.ligatures = $76a0fa091acb188e$exports.aliases;
$7417e626c64fb3c5$exports.unicode = $76a0fa091acb188e$exports.unicode;
$7417e626c64fb3c5$exports.svgPathData = $76a0fa091acb188e$exports.svgPathData;
$7417e626c64fb3c5$exports.aliases = $76a0fa091acb188e$exports.aliases;


var $67e9658d0f6c3ae3$exports = {};
'use strict';
Object.defineProperty($67e9658d0f6c3ae3$exports, '__esModule', {
    value: true
});
var $67e9658d0f6c3ae3$var$prefix = 'fas';
var $67e9658d0f6c3ae3$var$iconName = 'arrow-right';
var $67e9658d0f6c3ae3$var$width = 512;
var $67e9658d0f6c3ae3$var$height = 512;
var $67e9658d0f6c3ae3$var$aliases = [
    8594
];
var $67e9658d0f6c3ae3$var$unicode = 'f061';
var $67e9658d0f6c3ae3$var$svgPathData = 'M502.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L402.7 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l370.7 0-105.4 105.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z';
$67e9658d0f6c3ae3$exports.definition = {
    prefix: $67e9658d0f6c3ae3$var$prefix,
    iconName: $67e9658d0f6c3ae3$var$iconName,
    icon: [
        $67e9658d0f6c3ae3$var$width,
        $67e9658d0f6c3ae3$var$height,
        $67e9658d0f6c3ae3$var$aliases,
        $67e9658d0f6c3ae3$var$unicode,
        $67e9658d0f6c3ae3$var$svgPathData
    ]
};
$67e9658d0f6c3ae3$exports.faArrowRight = $67e9658d0f6c3ae3$exports.definition;
$67e9658d0f6c3ae3$exports.prefix = $67e9658d0f6c3ae3$var$prefix;
$67e9658d0f6c3ae3$exports.iconName = $67e9658d0f6c3ae3$var$iconName;
$67e9658d0f6c3ae3$exports.width = $67e9658d0f6c3ae3$var$width;
$67e9658d0f6c3ae3$exports.height = $67e9658d0f6c3ae3$var$height;
$67e9658d0f6c3ae3$exports.ligatures = $67e9658d0f6c3ae3$var$aliases;
$67e9658d0f6c3ae3$exports.unicode = $67e9658d0f6c3ae3$var$unicode;
$67e9658d0f6c3ae3$exports.svgPathData = $67e9658d0f6c3ae3$var$svgPathData;
$67e9658d0f6c3ae3$exports.aliases = $67e9658d0f6c3ae3$var$aliases;


var $0c96aa001209cff1$exports = {};
'use strict';
Object.defineProperty($0c96aa001209cff1$exports, '__esModule', {
    value: true
});
var $0c96aa001209cff1$var$prefix = 'fas';
var $0c96aa001209cff1$var$iconName = 'check';
var $0c96aa001209cff1$var$width = 448;
var $0c96aa001209cff1$var$height = 512;
var $0c96aa001209cff1$var$aliases = [
    10003,
    10004
];
var $0c96aa001209cff1$var$unicode = 'f00c';
var $0c96aa001209cff1$var$svgPathData = 'M434.8 70.1c14.3 10.4 17.5 30.4 7.1 44.7l-256 352c-5.5 7.6-14 12.3-23.4 13.1s-18.5-2.7-25.1-9.3l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l101.5 101.5 234-321.7c10.4-14.3 30.4-17.5 44.7-7.1z';
$0c96aa001209cff1$exports.definition = {
    prefix: $0c96aa001209cff1$var$prefix,
    iconName: $0c96aa001209cff1$var$iconName,
    icon: [
        $0c96aa001209cff1$var$width,
        $0c96aa001209cff1$var$height,
        $0c96aa001209cff1$var$aliases,
        $0c96aa001209cff1$var$unicode,
        $0c96aa001209cff1$var$svgPathData
    ]
};
$0c96aa001209cff1$exports.faCheck = $0c96aa001209cff1$exports.definition;
$0c96aa001209cff1$exports.prefix = $0c96aa001209cff1$var$prefix;
$0c96aa001209cff1$exports.iconName = $0c96aa001209cff1$var$iconName;
$0c96aa001209cff1$exports.width = $0c96aa001209cff1$var$width;
$0c96aa001209cff1$exports.height = $0c96aa001209cff1$var$height;
$0c96aa001209cff1$exports.ligatures = $0c96aa001209cff1$var$aliases;
$0c96aa001209cff1$exports.unicode = $0c96aa001209cff1$var$unicode;
$0c96aa001209cff1$exports.svgPathData = $0c96aa001209cff1$var$svgPathData;
$0c96aa001209cff1$exports.aliases = $0c96aa001209cff1$var$aliases;


var $7214b407105f2291$exports = {};
'use strict';
Object.defineProperty($7214b407105f2291$exports, '__esModule', {
    value: true
});
var $02c0b80d7cc7c21e$exports = {};
'use strict';
Object.defineProperty($02c0b80d7cc7c21e$exports, '__esModule', {
    value: true
});
var $02c0b80d7cc7c21e$var$prefix = 'fas';
var $02c0b80d7cc7c21e$var$iconName = 'circle-check';
var $02c0b80d7cc7c21e$var$width = 512;
var $02c0b80d7cc7c21e$var$height = 512;
var $02c0b80d7cc7c21e$var$aliases = [
    61533,
    "check-circle"
];
var $02c0b80d7cc7c21e$var$unicode = 'f058';
var $02c0b80d7cc7c21e$var$svgPathData = 'M256 512a256 256 0 1 1 0-512 256 256 0 1 1 0 512zM374 145.7c-10.7-7.8-25.7-5.4-33.5 5.3L221.1 315.2 169 263.1c-9.4-9.4-24.6-9.4-33.9 0s-9.4 24.6 0 33.9l72 72c5 5 11.8 7.5 18.8 7s13.4-4.1 17.5-9.8L379.3 179.2c7.8-10.7 5.4-25.7-5.3-33.5z';
$02c0b80d7cc7c21e$exports.definition = {
    prefix: $02c0b80d7cc7c21e$var$prefix,
    iconName: $02c0b80d7cc7c21e$var$iconName,
    icon: [
        $02c0b80d7cc7c21e$var$width,
        $02c0b80d7cc7c21e$var$height,
        $02c0b80d7cc7c21e$var$aliases,
        $02c0b80d7cc7c21e$var$unicode,
        $02c0b80d7cc7c21e$var$svgPathData
    ]
};
$02c0b80d7cc7c21e$exports.faCircleCheck = $02c0b80d7cc7c21e$exports.definition;
$02c0b80d7cc7c21e$exports.prefix = $02c0b80d7cc7c21e$var$prefix;
$02c0b80d7cc7c21e$exports.iconName = $02c0b80d7cc7c21e$var$iconName;
$02c0b80d7cc7c21e$exports.width = $02c0b80d7cc7c21e$var$width;
$02c0b80d7cc7c21e$exports.height = $02c0b80d7cc7c21e$var$height;
$02c0b80d7cc7c21e$exports.ligatures = $02c0b80d7cc7c21e$var$aliases;
$02c0b80d7cc7c21e$exports.unicode = $02c0b80d7cc7c21e$var$unicode;
$02c0b80d7cc7c21e$exports.svgPathData = $02c0b80d7cc7c21e$var$svgPathData;
$02c0b80d7cc7c21e$exports.aliases = $02c0b80d7cc7c21e$var$aliases;


$7214b407105f2291$exports.definition = {
    prefix: $02c0b80d7cc7c21e$exports.prefix,
    iconName: $02c0b80d7cc7c21e$exports.iconName,
    icon: [
        $02c0b80d7cc7c21e$exports.width,
        $02c0b80d7cc7c21e$exports.height,
        $02c0b80d7cc7c21e$exports.aliases,
        $02c0b80d7cc7c21e$exports.unicode,
        $02c0b80d7cc7c21e$exports.svgPathData
    ]
};
$7214b407105f2291$exports.faCheckCircle = $7214b407105f2291$exports.definition;
$7214b407105f2291$exports.prefix = $02c0b80d7cc7c21e$exports.prefix;
$7214b407105f2291$exports.iconName = $02c0b80d7cc7c21e$exports.iconName;
$7214b407105f2291$exports.width = $02c0b80d7cc7c21e$exports.width;
$7214b407105f2291$exports.height = $02c0b80d7cc7c21e$exports.height;
$7214b407105f2291$exports.ligatures = $02c0b80d7cc7c21e$exports.aliases;
$7214b407105f2291$exports.unicode = $02c0b80d7cc7c21e$exports.unicode;
$7214b407105f2291$exports.svgPathData = $02c0b80d7cc7c21e$exports.svgPathData;
$7214b407105f2291$exports.aliases = $02c0b80d7cc7c21e$exports.aliases;


var $843ec70749747e2a$exports = {};
'use strict';
Object.defineProperty($843ec70749747e2a$exports, '__esModule', {
    value: true
});
var $843ec70749747e2a$var$prefix = 'fas';
var $843ec70749747e2a$var$iconName = 'caret-down';
var $843ec70749747e2a$var$width = 320;
var $843ec70749747e2a$var$height = 512;
var $843ec70749747e2a$var$aliases = [];
var $843ec70749747e2a$var$unicode = 'f0d7';
var $843ec70749747e2a$var$svgPathData = 'M140.3 376.8c12.6 10.2 31.1 9.5 42.8-2.2l128-128c9.2-9.2 11.9-22.9 6.9-34.9S301.4 192 288.5 192l-256 0c-12.9 0-24.6 7.8-29.6 19.8S.7 237.5 9.9 246.6l128 128 2.4 2.2z';
$843ec70749747e2a$exports.definition = {
    prefix: $843ec70749747e2a$var$prefix,
    iconName: $843ec70749747e2a$var$iconName,
    icon: [
        $843ec70749747e2a$var$width,
        $843ec70749747e2a$var$height,
        $843ec70749747e2a$var$aliases,
        $843ec70749747e2a$var$unicode,
        $843ec70749747e2a$var$svgPathData
    ]
};
$843ec70749747e2a$exports.faCaretDown = $843ec70749747e2a$exports.definition;
$843ec70749747e2a$exports.prefix = $843ec70749747e2a$var$prefix;
$843ec70749747e2a$exports.iconName = $843ec70749747e2a$var$iconName;
$843ec70749747e2a$exports.width = $843ec70749747e2a$var$width;
$843ec70749747e2a$exports.height = $843ec70749747e2a$var$height;
$843ec70749747e2a$exports.ligatures = $843ec70749747e2a$var$aliases;
$843ec70749747e2a$exports.unicode = $843ec70749747e2a$var$unicode;
$843ec70749747e2a$exports.svgPathData = $843ec70749747e2a$var$svgPathData;
$843ec70749747e2a$exports.aliases = $843ec70749747e2a$var$aliases;


var $809575f3b9653d01$exports = {};
'use strict';
Object.defineProperty($809575f3b9653d01$exports, '__esModule', {
    value: true
});
var $809575f3b9653d01$var$prefix = 'fas';
var $809575f3b9653d01$var$iconName = 'caret-right';
var $809575f3b9653d01$var$width = 256;
var $809575f3b9653d01$var$height = 512;
var $809575f3b9653d01$var$aliases = [];
var $809575f3b9653d01$var$unicode = 'f0da';
var $809575f3b9653d01$var$svgPathData = 'M249.3 235.8c10.2 12.6 9.5 31.1-2.2 42.8l-128 128c-9.2 9.2-22.9 11.9-34.9 6.9S64.5 396.9 64.5 384l0-256c0-12.9 7.8-24.6 19.8-29.6s25.7-2.2 34.9 6.9l128 128 2.2 2.4z';
$809575f3b9653d01$exports.definition = {
    prefix: $809575f3b9653d01$var$prefix,
    iconName: $809575f3b9653d01$var$iconName,
    icon: [
        $809575f3b9653d01$var$width,
        $809575f3b9653d01$var$height,
        $809575f3b9653d01$var$aliases,
        $809575f3b9653d01$var$unicode,
        $809575f3b9653d01$var$svgPathData
    ]
};
$809575f3b9653d01$exports.faCaretRight = $809575f3b9653d01$exports.definition;
$809575f3b9653d01$exports.prefix = $809575f3b9653d01$var$prefix;
$809575f3b9653d01$exports.iconName = $809575f3b9653d01$var$iconName;
$809575f3b9653d01$exports.width = $809575f3b9653d01$var$width;
$809575f3b9653d01$exports.height = $809575f3b9653d01$var$height;
$809575f3b9653d01$exports.ligatures = $809575f3b9653d01$var$aliases;
$809575f3b9653d01$exports.unicode = $809575f3b9653d01$var$unicode;
$809575f3b9653d01$exports.svgPathData = $809575f3b9653d01$var$svgPathData;
$809575f3b9653d01$exports.aliases = $809575f3b9653d01$var$aliases;


var $78546ca20d789f8c$exports = {};
'use strict';
Object.defineProperty($78546ca20d789f8c$exports, '__esModule', {
    value: true
});
var $b125f469bd48e450$exports = {};
'use strict';
Object.defineProperty($b125f469bd48e450$exports, '__esModule', {
    value: true
});
var $b125f469bd48e450$var$prefix = 'fas';
var $b125f469bd48e450$var$iconName = 'cloud-arrow-up';
var $b125f469bd48e450$var$width = 576;
var $b125f469bd48e450$var$height = 512;
var $b125f469bd48e450$var$aliases = [
    62338,
    "cloud-upload",
    "cloud-upload-alt"
];
var $b125f469bd48e450$var$unicode = 'f0ee';
var $b125f469bd48e450$var$svgPathData = 'M144 480c-79.5 0-144-64.5-144-144 0-63.4 41-117.2 97.9-136.5-1.3-7.7-1.9-15.5-1.9-23.5 0-79.5 64.5-144 144-144 55.4 0 103.5 31.3 127.6 77.1 14.2-8.3 30.8-13.1 48.4-13.1 53 0 96 43 96 96 0 15.7-3.8 30.6-10.5 43.7 44 20.3 74.5 64.7 74.5 116.3 0 70.7-57.3 128-128 128l-304 0zM305 191c-9.4-9.4-24.6-9.4-33.9 0l-72 72c-9.4 9.4-9.4 24.6 0 33.9s24.6 9.4 33.9 0l31-31 0 102.1c0 13.3 10.7 24 24 24s24-10.7 24-24l0-102.1 31 31c9.4 9.4 24.6 9.4 33.9 0s9.4-24.6 0-33.9l-72-72z';
$b125f469bd48e450$exports.definition = {
    prefix: $b125f469bd48e450$var$prefix,
    iconName: $b125f469bd48e450$var$iconName,
    icon: [
        $b125f469bd48e450$var$width,
        $b125f469bd48e450$var$height,
        $b125f469bd48e450$var$aliases,
        $b125f469bd48e450$var$unicode,
        $b125f469bd48e450$var$svgPathData
    ]
};
$b125f469bd48e450$exports.faCloudArrowUp = $b125f469bd48e450$exports.definition;
$b125f469bd48e450$exports.prefix = $b125f469bd48e450$var$prefix;
$b125f469bd48e450$exports.iconName = $b125f469bd48e450$var$iconName;
$b125f469bd48e450$exports.width = $b125f469bd48e450$var$width;
$b125f469bd48e450$exports.height = $b125f469bd48e450$var$height;
$b125f469bd48e450$exports.ligatures = $b125f469bd48e450$var$aliases;
$b125f469bd48e450$exports.unicode = $b125f469bd48e450$var$unicode;
$b125f469bd48e450$exports.svgPathData = $b125f469bd48e450$var$svgPathData;
$b125f469bd48e450$exports.aliases = $b125f469bd48e450$var$aliases;


$78546ca20d789f8c$exports.definition = {
    prefix: $b125f469bd48e450$exports.prefix,
    iconName: $b125f469bd48e450$exports.iconName,
    icon: [
        $b125f469bd48e450$exports.width,
        $b125f469bd48e450$exports.height,
        $b125f469bd48e450$exports.aliases,
        $b125f469bd48e450$exports.unicode,
        $b125f469bd48e450$exports.svgPathData
    ]
};
$78546ca20d789f8c$exports.faCloudUploadAlt = $78546ca20d789f8c$exports.definition;
$78546ca20d789f8c$exports.prefix = $b125f469bd48e450$exports.prefix;
$78546ca20d789f8c$exports.iconName = $b125f469bd48e450$exports.iconName;
$78546ca20d789f8c$exports.width = $b125f469bd48e450$exports.width;
$78546ca20d789f8c$exports.height = $b125f469bd48e450$exports.height;
$78546ca20d789f8c$exports.ligatures = $b125f469bd48e450$exports.aliases;
$78546ca20d789f8c$exports.unicode = $b125f469bd48e450$exports.unicode;
$78546ca20d789f8c$exports.svgPathData = $b125f469bd48e450$exports.svgPathData;
$78546ca20d789f8c$exports.aliases = $b125f469bd48e450$exports.aliases;


var $18f640b80ac26745$exports = {};
'use strict';
Object.defineProperty($18f640b80ac26745$exports, '__esModule', {
    value: true
});
var $2a47a982851253e1$exports = {};
'use strict';
Object.defineProperty($2a47a982851253e1$exports, '__esModule', {
    value: true
});
var $2a47a982851253e1$var$prefix = 'fas';
var $2a47a982851253e1$var$iconName = 'gear';
var $2a47a982851253e1$var$width = 512;
var $2a47a982851253e1$var$height = 512;
var $2a47a982851253e1$var$aliases = [
    9881,
    "cog"
];
var $2a47a982851253e1$var$unicode = 'f013';
var $2a47a982851253e1$var$svgPathData = 'M195.1 9.5C198.1-5.3 211.2-16 226.4-16l59.8 0c15.2 0 28.3 10.7 31.3 25.5L332 79.5c14.1 6 27.3 13.7 39.3 22.8l67.8-22.5c14.4-4.8 30.2 1.2 37.8 14.4l29.9 51.8c7.6 13.2 4.9 29.8-6.5 39.9L447 233.3c.9 7.4 1.3 15 1.3 22.7s-.5 15.3-1.3 22.7l53.4 47.5c11.4 10.1 14 26.8 6.5 39.9l-29.9 51.8c-7.6 13.1-23.4 19.2-37.8 14.4l-67.8-22.5c-12.1 9.1-25.3 16.7-39.3 22.8l-14.4 69.9c-3.1 14.9-16.2 25.5-31.3 25.5l-59.8 0c-15.2 0-28.3-10.7-31.3-25.5l-14.4-69.9c-14.1-6-27.2-13.7-39.3-22.8L73.5 432.3c-14.4 4.8-30.2-1.2-37.8-14.4L5.8 366.1c-7.6-13.2-4.9-29.8 6.5-39.9l53.4-47.5c-.9-7.4-1.3-15-1.3-22.7s.5-15.3 1.3-22.7L12.3 185.8c-11.4-10.1-14-26.8-6.5-39.9L35.7 94.1c7.6-13.2 23.4-19.2 37.8-14.4l67.8 22.5c12.1-9.1 25.3-16.7 39.3-22.8L195.1 9.5zM256.3 336a80 80 0 1 0 -.6-160 80 80 0 1 0 .6 160z';
$2a47a982851253e1$exports.definition = {
    prefix: $2a47a982851253e1$var$prefix,
    iconName: $2a47a982851253e1$var$iconName,
    icon: [
        $2a47a982851253e1$var$width,
        $2a47a982851253e1$var$height,
        $2a47a982851253e1$var$aliases,
        $2a47a982851253e1$var$unicode,
        $2a47a982851253e1$var$svgPathData
    ]
};
$2a47a982851253e1$exports.faGear = $2a47a982851253e1$exports.definition;
$2a47a982851253e1$exports.prefix = $2a47a982851253e1$var$prefix;
$2a47a982851253e1$exports.iconName = $2a47a982851253e1$var$iconName;
$2a47a982851253e1$exports.width = $2a47a982851253e1$var$width;
$2a47a982851253e1$exports.height = $2a47a982851253e1$var$height;
$2a47a982851253e1$exports.ligatures = $2a47a982851253e1$var$aliases;
$2a47a982851253e1$exports.unicode = $2a47a982851253e1$var$unicode;
$2a47a982851253e1$exports.svgPathData = $2a47a982851253e1$var$svgPathData;
$2a47a982851253e1$exports.aliases = $2a47a982851253e1$var$aliases;


$18f640b80ac26745$exports.definition = {
    prefix: $2a47a982851253e1$exports.prefix,
    iconName: $2a47a982851253e1$exports.iconName,
    icon: [
        $2a47a982851253e1$exports.width,
        $2a47a982851253e1$exports.height,
        $2a47a982851253e1$exports.aliases,
        $2a47a982851253e1$exports.unicode,
        $2a47a982851253e1$exports.svgPathData
    ]
};
$18f640b80ac26745$exports.faCog = $18f640b80ac26745$exports.definition;
$18f640b80ac26745$exports.prefix = $2a47a982851253e1$exports.prefix;
$18f640b80ac26745$exports.iconName = $2a47a982851253e1$exports.iconName;
$18f640b80ac26745$exports.width = $2a47a982851253e1$exports.width;
$18f640b80ac26745$exports.height = $2a47a982851253e1$exports.height;
$18f640b80ac26745$exports.ligatures = $2a47a982851253e1$exports.aliases;
$18f640b80ac26745$exports.unicode = $2a47a982851253e1$exports.unicode;
$18f640b80ac26745$exports.svgPathData = $2a47a982851253e1$exports.svgPathData;
$18f640b80ac26745$exports.aliases = $2a47a982851253e1$exports.aliases;


var $7f79cc0a934ae117$exports = {};
'use strict';
Object.defineProperty($7f79cc0a934ae117$exports, '__esModule', {
    value: true
});
var $7f79cc0a934ae117$var$prefix = 'fas';
var $7f79cc0a934ae117$var$iconName = 'copy';
var $7f79cc0a934ae117$var$width = 448;
var $7f79cc0a934ae117$var$height = 512;
var $7f79cc0a934ae117$var$aliases = [];
var $7f79cc0a934ae117$var$unicode = 'f0c5';
var $7f79cc0a934ae117$var$svgPathData = 'M192 0c-35.3 0-64 28.7-64 64l0 256c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-200.6c0-17.4-7.1-34.1-19.7-46.2L370.6 17.8C358.7 6.4 342.8 0 326.3 0L192 0zM64 128c-35.3 0-64 28.7-64 64L0 448c0 35.3 28.7 64 64 64l192 0c35.3 0 64-28.7 64-64l0-16-64 0 0 16-192 0 0-256 16 0 0-64-16 0z';
$7f79cc0a934ae117$exports.definition = {
    prefix: $7f79cc0a934ae117$var$prefix,
    iconName: $7f79cc0a934ae117$var$iconName,
    icon: [
        $7f79cc0a934ae117$var$width,
        $7f79cc0a934ae117$var$height,
        $7f79cc0a934ae117$var$aliases,
        $7f79cc0a934ae117$var$unicode,
        $7f79cc0a934ae117$var$svgPathData
    ]
};
$7f79cc0a934ae117$exports.faCopy = $7f79cc0a934ae117$exports.definition;
$7f79cc0a934ae117$exports.prefix = $7f79cc0a934ae117$var$prefix;
$7f79cc0a934ae117$exports.iconName = $7f79cc0a934ae117$var$iconName;
$7f79cc0a934ae117$exports.width = $7f79cc0a934ae117$var$width;
$7f79cc0a934ae117$exports.height = $7f79cc0a934ae117$var$height;
$7f79cc0a934ae117$exports.ligatures = $7f79cc0a934ae117$var$aliases;
$7f79cc0a934ae117$exports.unicode = $7f79cc0a934ae117$var$unicode;
$7f79cc0a934ae117$exports.svgPathData = $7f79cc0a934ae117$var$svgPathData;
$7f79cc0a934ae117$exports.aliases = $7f79cc0a934ae117$var$aliases;


var $5aa79799bc179db8$exports = {};
'use strict';
Object.defineProperty($5aa79799bc179db8$exports, '__esModule', {
    value: true
});
var $5aa79799bc179db8$var$prefix = 'fas';
var $5aa79799bc179db8$var$iconName = 'envelope';
var $5aa79799bc179db8$var$width = 512;
var $5aa79799bc179db8$var$height = 512;
var $5aa79799bc179db8$var$aliases = [
    128386,
    9993,
    61443
];
var $5aa79799bc179db8$var$unicode = 'f0e0';
var $5aa79799bc179db8$var$svgPathData = 'M48 64c-26.5 0-48 21.5-48 48 0 15.1 7.1 29.3 19.2 38.4l208 156c17.1 12.8 40.5 12.8 57.6 0l208-156c12.1-9.1 19.2-23.3 19.2-38.4 0-26.5-21.5-48-48-48L48 64zM0 196L0 384c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-188-198.4 148.8c-34.1 25.6-81.1 25.6-115.2 0L0 196z';
$5aa79799bc179db8$exports.definition = {
    prefix: $5aa79799bc179db8$var$prefix,
    iconName: $5aa79799bc179db8$var$iconName,
    icon: [
        $5aa79799bc179db8$var$width,
        $5aa79799bc179db8$var$height,
        $5aa79799bc179db8$var$aliases,
        $5aa79799bc179db8$var$unicode,
        $5aa79799bc179db8$var$svgPathData
    ]
};
$5aa79799bc179db8$exports.faEnvelope = $5aa79799bc179db8$exports.definition;
$5aa79799bc179db8$exports.prefix = $5aa79799bc179db8$var$prefix;
$5aa79799bc179db8$exports.iconName = $5aa79799bc179db8$var$iconName;
$5aa79799bc179db8$exports.width = $5aa79799bc179db8$var$width;
$5aa79799bc179db8$exports.height = $5aa79799bc179db8$var$height;
$5aa79799bc179db8$exports.ligatures = $5aa79799bc179db8$var$aliases;
$5aa79799bc179db8$exports.unicode = $5aa79799bc179db8$var$unicode;
$5aa79799bc179db8$exports.svgPathData = $5aa79799bc179db8$var$svgPathData;
$5aa79799bc179db8$exports.aliases = $5aa79799bc179db8$var$aliases;


var $38e96a2b42b175e8$exports = {};
'use strict';
Object.defineProperty($38e96a2b42b175e8$exports, '__esModule', {
    value: true
});
var $8c651f8f2944f6f7$exports = {};
'use strict';
Object.defineProperty($8c651f8f2944f6f7$exports, '__esModule', {
    value: true
});
var $8c651f8f2944f6f7$var$prefix = 'fas';
var $8c651f8f2944f6f7$var$iconName = 'up-right-from-square';
var $8c651f8f2944f6f7$var$width = 512;
var $8c651f8f2944f6f7$var$height = 512;
var $8c651f8f2944f6f7$var$aliases = [
    "external-link-alt"
];
var $8c651f8f2944f6f7$var$unicode = 'f35d';
var $8c651f8f2944f6f7$var$svgPathData = 'M290.4 19.8C295.4 7.8 307.1 0 320 0L480 0c17.7 0 32 14.3 32 32l0 160c0 12.9-7.8 24.6-19.8 29.6s-25.7 2.2-34.9-6.9L400 157.3 246.6 310.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L354.7 112 297.4 54.6c-9.2-9.2-11.9-22.9-6.9-34.9zM0 176c0-44.2 35.8-80 80-80l80 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-80 0c-8.8 0-16 7.2-16 16l0 256c0 8.8 7.2 16 16 16l256 0c8.8 0 16-7.2 16-16l0-80c0-17.7 14.3-32 32-32s32 14.3 32 32l0 80c0 44.2-35.8 80-80 80L80 512c-44.2 0-80-35.8-80-80L0 176z';
$8c651f8f2944f6f7$exports.definition = {
    prefix: $8c651f8f2944f6f7$var$prefix,
    iconName: $8c651f8f2944f6f7$var$iconName,
    icon: [
        $8c651f8f2944f6f7$var$width,
        $8c651f8f2944f6f7$var$height,
        $8c651f8f2944f6f7$var$aliases,
        $8c651f8f2944f6f7$var$unicode,
        $8c651f8f2944f6f7$var$svgPathData
    ]
};
$8c651f8f2944f6f7$exports.faUpRightFromSquare = $8c651f8f2944f6f7$exports.definition;
$8c651f8f2944f6f7$exports.prefix = $8c651f8f2944f6f7$var$prefix;
$8c651f8f2944f6f7$exports.iconName = $8c651f8f2944f6f7$var$iconName;
$8c651f8f2944f6f7$exports.width = $8c651f8f2944f6f7$var$width;
$8c651f8f2944f6f7$exports.height = $8c651f8f2944f6f7$var$height;
$8c651f8f2944f6f7$exports.ligatures = $8c651f8f2944f6f7$var$aliases;
$8c651f8f2944f6f7$exports.unicode = $8c651f8f2944f6f7$var$unicode;
$8c651f8f2944f6f7$exports.svgPathData = $8c651f8f2944f6f7$var$svgPathData;
$8c651f8f2944f6f7$exports.aliases = $8c651f8f2944f6f7$var$aliases;


$38e96a2b42b175e8$exports.definition = {
    prefix: $8c651f8f2944f6f7$exports.prefix,
    iconName: $8c651f8f2944f6f7$exports.iconName,
    icon: [
        $8c651f8f2944f6f7$exports.width,
        $8c651f8f2944f6f7$exports.height,
        $8c651f8f2944f6f7$exports.aliases,
        $8c651f8f2944f6f7$exports.unicode,
        $8c651f8f2944f6f7$exports.svgPathData
    ]
};
$38e96a2b42b175e8$exports.faExternalLinkAlt = $38e96a2b42b175e8$exports.definition;
$38e96a2b42b175e8$exports.prefix = $8c651f8f2944f6f7$exports.prefix;
$38e96a2b42b175e8$exports.iconName = $8c651f8f2944f6f7$exports.iconName;
$38e96a2b42b175e8$exports.width = $8c651f8f2944f6f7$exports.width;
$38e96a2b42b175e8$exports.height = $8c651f8f2944f6f7$exports.height;
$38e96a2b42b175e8$exports.ligatures = $8c651f8f2944f6f7$exports.aliases;
$38e96a2b42b175e8$exports.unicode = $8c651f8f2944f6f7$exports.unicode;
$38e96a2b42b175e8$exports.svgPathData = $8c651f8f2944f6f7$exports.svgPathData;
$38e96a2b42b175e8$exports.aliases = $8c651f8f2944f6f7$exports.aliases;


var $5a270b3b7e6b7fa8$exports = {};
'use strict';
Object.defineProperty($5a270b3b7e6b7fa8$exports, '__esModule', {
    value: true
});
var $5a270b3b7e6b7fa8$var$prefix = 'fas';
var $5a270b3b7e6b7fa8$var$iconName = 'key';
var $5a270b3b7e6b7fa8$var$width = 512;
var $5a270b3b7e6b7fa8$var$height = 512;
var $5a270b3b7e6b7fa8$var$aliases = [
    128273
];
var $5a270b3b7e6b7fa8$var$unicode = 'f084';
var $5a270b3b7e6b7fa8$var$svgPathData = 'M336 352c97.2 0 176-78.8 176-176S433.2 0 336 0 160 78.8 160 176c0 18.7 2.9 36.8 8.3 53.7L7 391c-4.5 4.5-7 10.6-7 17l0 80c0 13.3 10.7 24 24 24l80 0c13.3 0 24-10.7 24-24l0-40 40 0c13.3 0 24-10.7 24-24l0-40 40 0c6.4 0 12.5-2.5 17-7l33.3-33.3c16.9 5.4 35 8.3 53.7 8.3zM376 96a40 40 0 1 1 0 80 40 40 0 1 1 0-80z';
$5a270b3b7e6b7fa8$exports.definition = {
    prefix: $5a270b3b7e6b7fa8$var$prefix,
    iconName: $5a270b3b7e6b7fa8$var$iconName,
    icon: [
        $5a270b3b7e6b7fa8$var$width,
        $5a270b3b7e6b7fa8$var$height,
        $5a270b3b7e6b7fa8$var$aliases,
        $5a270b3b7e6b7fa8$var$unicode,
        $5a270b3b7e6b7fa8$var$svgPathData
    ]
};
$5a270b3b7e6b7fa8$exports.faKey = $5a270b3b7e6b7fa8$exports.definition;
$5a270b3b7e6b7fa8$exports.prefix = $5a270b3b7e6b7fa8$var$prefix;
$5a270b3b7e6b7fa8$exports.iconName = $5a270b3b7e6b7fa8$var$iconName;
$5a270b3b7e6b7fa8$exports.width = $5a270b3b7e6b7fa8$var$width;
$5a270b3b7e6b7fa8$exports.height = $5a270b3b7e6b7fa8$var$height;
$5a270b3b7e6b7fa8$exports.ligatures = $5a270b3b7e6b7fa8$var$aliases;
$5a270b3b7e6b7fa8$exports.unicode = $5a270b3b7e6b7fa8$var$unicode;
$5a270b3b7e6b7fa8$exports.svgPathData = $5a270b3b7e6b7fa8$var$svgPathData;
$5a270b3b7e6b7fa8$exports.aliases = $5a270b3b7e6b7fa8$var$aliases;


var $3d54bd244f4653d3$exports = {};
'use strict';
Object.defineProperty($3d54bd244f4653d3$exports, '__esModule', {
    value: true
});
var $ca60dd235af7334a$exports = {};
'use strict';
Object.defineProperty($ca60dd235af7334a$exports, '__esModule', {
    value: true
});
var $ca60dd235af7334a$var$prefix = 'fas';
var $ca60dd235af7334a$var$iconName = 'magnifying-glass';
var $ca60dd235af7334a$var$width = 512;
var $ca60dd235af7334a$var$height = 512;
var $ca60dd235af7334a$var$aliases = [
    128269,
    "search"
];
var $ca60dd235af7334a$var$unicode = 'f002';
var $ca60dd235af7334a$var$svgPathData = 'M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376C296.3 401.1 253.9 416 208 416 93.1 416 0 322.9 0 208S93.1 0 208 0 416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z';
$ca60dd235af7334a$exports.definition = {
    prefix: $ca60dd235af7334a$var$prefix,
    iconName: $ca60dd235af7334a$var$iconName,
    icon: [
        $ca60dd235af7334a$var$width,
        $ca60dd235af7334a$var$height,
        $ca60dd235af7334a$var$aliases,
        $ca60dd235af7334a$var$unicode,
        $ca60dd235af7334a$var$svgPathData
    ]
};
$ca60dd235af7334a$exports.faMagnifyingGlass = $ca60dd235af7334a$exports.definition;
$ca60dd235af7334a$exports.prefix = $ca60dd235af7334a$var$prefix;
$ca60dd235af7334a$exports.iconName = $ca60dd235af7334a$var$iconName;
$ca60dd235af7334a$exports.width = $ca60dd235af7334a$var$width;
$ca60dd235af7334a$exports.height = $ca60dd235af7334a$var$height;
$ca60dd235af7334a$exports.ligatures = $ca60dd235af7334a$var$aliases;
$ca60dd235af7334a$exports.unicode = $ca60dd235af7334a$var$unicode;
$ca60dd235af7334a$exports.svgPathData = $ca60dd235af7334a$var$svgPathData;
$ca60dd235af7334a$exports.aliases = $ca60dd235af7334a$var$aliases;


$3d54bd244f4653d3$exports.definition = {
    prefix: $ca60dd235af7334a$exports.prefix,
    iconName: $ca60dd235af7334a$exports.iconName,
    icon: [
        $ca60dd235af7334a$exports.width,
        $ca60dd235af7334a$exports.height,
        $ca60dd235af7334a$exports.aliases,
        $ca60dd235af7334a$exports.unicode,
        $ca60dd235af7334a$exports.svgPathData
    ]
};
$3d54bd244f4653d3$exports.faSearch = $3d54bd244f4653d3$exports.definition;
$3d54bd244f4653d3$exports.prefix = $ca60dd235af7334a$exports.prefix;
$3d54bd244f4653d3$exports.iconName = $ca60dd235af7334a$exports.iconName;
$3d54bd244f4653d3$exports.width = $ca60dd235af7334a$exports.width;
$3d54bd244f4653d3$exports.height = $ca60dd235af7334a$exports.height;
$3d54bd244f4653d3$exports.ligatures = $ca60dd235af7334a$exports.aliases;
$3d54bd244f4653d3$exports.unicode = $ca60dd235af7334a$exports.unicode;
$3d54bd244f4653d3$exports.svgPathData = $ca60dd235af7334a$exports.svgPathData;
$3d54bd244f4653d3$exports.aliases = $ca60dd235af7334a$exports.aliases;


var $5f3a6b596119c825$exports = {};
'use strict';
Object.defineProperty($5f3a6b596119c825$exports, '__esModule', {
    value: true
});
var $19ec3707a0f446bb$exports = {};
'use strict';
Object.defineProperty($19ec3707a0f446bb$exports, '__esModule', {
    value: true
});
var $19ec3707a0f446bb$var$prefix = 'fas';
var $19ec3707a0f446bb$var$iconName = 'share-nodes';
var $19ec3707a0f446bb$var$width = 512;
var $19ec3707a0f446bb$var$height = 512;
var $19ec3707a0f446bb$var$aliases = [
    "share-alt"
];
var $19ec3707a0f446bb$var$unicode = 'f1e0';
var $19ec3707a0f446bb$var$svgPathData = 'M384 192c53 0 96-43 96-96s-43-96-96-96-96 43-96 96c0 5.4 .5 10.8 1.3 16L159.6 184.1c-16.9-15-39.2-24.1-63.6-24.1-53 0-96 43-96 96s43 96 96 96c24.4 0 46.6-9.1 63.6-24.1L289.3 400c-.9 5.2-1.3 10.5-1.3 16 0 53 43 96 96 96s96-43 96-96-43-96-96-96c-24.4 0-46.6 9.1-63.6 24.1L190.7 272c.9-5.2 1.3-10.5 1.3-16s-.5-10.8-1.3-16l129.7-72.1c16.9 15 39.2 24.1 63.6 24.1z';
$19ec3707a0f446bb$exports.definition = {
    prefix: $19ec3707a0f446bb$var$prefix,
    iconName: $19ec3707a0f446bb$var$iconName,
    icon: [
        $19ec3707a0f446bb$var$width,
        $19ec3707a0f446bb$var$height,
        $19ec3707a0f446bb$var$aliases,
        $19ec3707a0f446bb$var$unicode,
        $19ec3707a0f446bb$var$svgPathData
    ]
};
$19ec3707a0f446bb$exports.faShareNodes = $19ec3707a0f446bb$exports.definition;
$19ec3707a0f446bb$exports.prefix = $19ec3707a0f446bb$var$prefix;
$19ec3707a0f446bb$exports.iconName = $19ec3707a0f446bb$var$iconName;
$19ec3707a0f446bb$exports.width = $19ec3707a0f446bb$var$width;
$19ec3707a0f446bb$exports.height = $19ec3707a0f446bb$var$height;
$19ec3707a0f446bb$exports.ligatures = $19ec3707a0f446bb$var$aliases;
$19ec3707a0f446bb$exports.unicode = $19ec3707a0f446bb$var$unicode;
$19ec3707a0f446bb$exports.svgPathData = $19ec3707a0f446bb$var$svgPathData;
$19ec3707a0f446bb$exports.aliases = $19ec3707a0f446bb$var$aliases;


$5f3a6b596119c825$exports.definition = {
    prefix: $19ec3707a0f446bb$exports.prefix,
    iconName: $19ec3707a0f446bb$exports.iconName,
    icon: [
        $19ec3707a0f446bb$exports.width,
        $19ec3707a0f446bb$exports.height,
        $19ec3707a0f446bb$exports.aliases,
        $19ec3707a0f446bb$exports.unicode,
        $19ec3707a0f446bb$exports.svgPathData
    ]
};
$5f3a6b596119c825$exports.faShareAlt = $5f3a6b596119c825$exports.definition;
$5f3a6b596119c825$exports.prefix = $19ec3707a0f446bb$exports.prefix;
$5f3a6b596119c825$exports.iconName = $19ec3707a0f446bb$exports.iconName;
$5f3a6b596119c825$exports.width = $19ec3707a0f446bb$exports.width;
$5f3a6b596119c825$exports.height = $19ec3707a0f446bb$exports.height;
$5f3a6b596119c825$exports.ligatures = $19ec3707a0f446bb$exports.aliases;
$5f3a6b596119c825$exports.unicode = $19ec3707a0f446bb$exports.unicode;
$5f3a6b596119c825$exports.svgPathData = $19ec3707a0f446bb$exports.svgPathData;
$5f3a6b596119c825$exports.aliases = $19ec3707a0f446bb$exports.aliases;


var $17ddfe677f5b40f7$exports = {};
'use strict';
Object.defineProperty($17ddfe677f5b40f7$exports, '__esModule', {
    value: true
});
var $35b4a6ca5cd59a8e$exports = {};
'use strict';
Object.defineProperty($35b4a6ca5cd59a8e$exports, '__esModule', {
    value: true
});
var $35b4a6ca5cd59a8e$var$prefix = 'fas';
var $35b4a6ca5cd59a8e$var$iconName = 'right-from-bracket';
var $35b4a6ca5cd59a8e$var$width = 512;
var $35b4a6ca5cd59a8e$var$height = 512;
var $35b4a6ca5cd59a8e$var$aliases = [
    "sign-out-alt"
];
var $35b4a6ca5cd59a8e$var$unicode = 'f2f5';
var $35b4a6ca5cd59a8e$var$svgPathData = 'M505 273c9.4-9.4 9.4-24.6 0-33.9L361 95c-6.9-6.9-17.2-8.9-26.2-5.2S320 102.3 320 112l0 80-112 0c-26.5 0-48 21.5-48 48l0 32c0 26.5 21.5 48 48 48l112 0 0 80c0 9.7 5.8 18.5 14.8 22.2s19.3 1.7 26.2-5.2L505 273zM160 96c17.7 0 32-14.3 32-32s-14.3-32-32-32L96 32C43 32 0 75 0 128L0 384c0 53 43 96 96 96l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-64 0c-17.7 0-32-14.3-32-32l0-256c0-17.7 14.3-32 32-32l64 0z';
$35b4a6ca5cd59a8e$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$var$prefix,
    iconName: $35b4a6ca5cd59a8e$var$iconName,
    icon: [
        $35b4a6ca5cd59a8e$var$width,
        $35b4a6ca5cd59a8e$var$height,
        $35b4a6ca5cd59a8e$var$aliases,
        $35b4a6ca5cd59a8e$var$unicode,
        $35b4a6ca5cd59a8e$var$svgPathData
    ]
};
$35b4a6ca5cd59a8e$exports.faRightFromBracket = $35b4a6ca5cd59a8e$exports.definition;
$35b4a6ca5cd59a8e$exports.prefix = $35b4a6ca5cd59a8e$var$prefix;
$35b4a6ca5cd59a8e$exports.iconName = $35b4a6ca5cd59a8e$var$iconName;
$35b4a6ca5cd59a8e$exports.width = $35b4a6ca5cd59a8e$var$width;
$35b4a6ca5cd59a8e$exports.height = $35b4a6ca5cd59a8e$var$height;
$35b4a6ca5cd59a8e$exports.ligatures = $35b4a6ca5cd59a8e$var$aliases;
$35b4a6ca5cd59a8e$exports.unicode = $35b4a6ca5cd59a8e$var$unicode;
$35b4a6ca5cd59a8e$exports.svgPathData = $35b4a6ca5cd59a8e$var$svgPathData;
$35b4a6ca5cd59a8e$exports.aliases = $35b4a6ca5cd59a8e$var$aliases;


$17ddfe677f5b40f7$exports.definition = {
    prefix: $35b4a6ca5cd59a8e$exports.prefix,
    iconName: $35b4a6ca5cd59a8e$exports.iconName,
    icon: [
        $35b4a6ca5cd59a8e$exports.width,
        $35b4a6ca5cd59a8e$exports.height,
        $35b4a6ca5cd59a8e$exports.aliases,
        $35b4a6ca5cd59a8e$exports.unicode,
        $35b4a6ca5cd59a8e$exports.svgPathData
    ]
};
$17ddfe677f5b40f7$exports.faSignOutAlt = $17ddfe677f5b40f7$exports.definition;
$17ddfe677f5b40f7$exports.prefix = $35b4a6ca5cd59a8e$exports.prefix;
$17ddfe677f5b40f7$exports.iconName = $35b4a6ca5cd59a8e$exports.iconName;
$17ddfe677f5b40f7$exports.width = $35b4a6ca5cd59a8e$exports.width;
$17ddfe677f5b40f7$exports.height = $35b4a6ca5cd59a8e$exports.height;
$17ddfe677f5b40f7$exports.ligatures = $35b4a6ca5cd59a8e$exports.aliases;
$17ddfe677f5b40f7$exports.unicode = $35b4a6ca5cd59a8e$exports.unicode;
$17ddfe677f5b40f7$exports.svgPathData = $35b4a6ca5cd59a8e$exports.svgPathData;
$17ddfe677f5b40f7$exports.aliases = $35b4a6ca5cd59a8e$exports.aliases;


var $c0ffe79f8008445d$exports = {};
'use strict';
Object.defineProperty($c0ffe79f8008445d$exports, '__esModule', {
    value: true
});
var $c0ffe79f8008445d$var$prefix = 'fas';
var $c0ffe79f8008445d$var$iconName = 'slash';
var $c0ffe79f8008445d$var$width = 576;
var $c0ffe79f8008445d$var$height = 512;
var $c0ffe79f8008445d$var$aliases = [];
var $c0ffe79f8008445d$var$unicode = 'f715';
var $c0ffe79f8008445d$var$svgPathData = 'M7-25c9.4-9.4 24.6-9.4 33.9 0L569 503c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0L7 9C-2.3-.4-2.3-15.6 7-25z';
$c0ffe79f8008445d$exports.definition = {
    prefix: $c0ffe79f8008445d$var$prefix,
    iconName: $c0ffe79f8008445d$var$iconName,
    icon: [
        $c0ffe79f8008445d$var$width,
        $c0ffe79f8008445d$var$height,
        $c0ffe79f8008445d$var$aliases,
        $c0ffe79f8008445d$var$unicode,
        $c0ffe79f8008445d$var$svgPathData
    ]
};
$c0ffe79f8008445d$exports.faSlash = $c0ffe79f8008445d$exports.definition;
$c0ffe79f8008445d$exports.prefix = $c0ffe79f8008445d$var$prefix;
$c0ffe79f8008445d$exports.iconName = $c0ffe79f8008445d$var$iconName;
$c0ffe79f8008445d$exports.width = $c0ffe79f8008445d$var$width;
$c0ffe79f8008445d$exports.height = $c0ffe79f8008445d$var$height;
$c0ffe79f8008445d$exports.ligatures = $c0ffe79f8008445d$var$aliases;
$c0ffe79f8008445d$exports.unicode = $c0ffe79f8008445d$var$unicode;
$c0ffe79f8008445d$exports.svgPathData = $c0ffe79f8008445d$var$svgPathData;
$c0ffe79f8008445d$exports.aliases = $c0ffe79f8008445d$var$aliases;


var $d85e0c7e91e2ddfe$exports = {};
'use strict';
Object.defineProperty($d85e0c7e91e2ddfe$exports, '__esModule', {
    value: true
});
var $d85e0c7e91e2ddfe$var$prefix = 'fas';
var $d85e0c7e91e2ddfe$var$iconName = 'spinner';
var $d85e0c7e91e2ddfe$var$width = 512;
var $d85e0c7e91e2ddfe$var$height = 512;
var $d85e0c7e91e2ddfe$var$aliases = [];
var $d85e0c7e91e2ddfe$var$unicode = 'f110';
var $d85e0c7e91e2ddfe$var$svgPathData = 'M208 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zm0 416a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM48 208a48 48 0 1 1 0 96 48 48 0 1 1 0-96zm368 48a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM75 369.1A48 48 0 1 1 142.9 437 48 48 0 1 1 75 369.1zM75 75A48 48 0 1 1 142.9 142.9 48 48 0 1 1 75 75zM437 369.1A48 48 0 1 1 369.1 437 48 48 0 1 1 437 369.1z';
$d85e0c7e91e2ddfe$exports.definition = {
    prefix: $d85e0c7e91e2ddfe$var$prefix,
    iconName: $d85e0c7e91e2ddfe$var$iconName,
    icon: [
        $d85e0c7e91e2ddfe$var$width,
        $d85e0c7e91e2ddfe$var$height,
        $d85e0c7e91e2ddfe$var$aliases,
        $d85e0c7e91e2ddfe$var$unicode,
        $d85e0c7e91e2ddfe$var$svgPathData
    ]
};
$d85e0c7e91e2ddfe$exports.faSpinner = $d85e0c7e91e2ddfe$exports.definition;
$d85e0c7e91e2ddfe$exports.prefix = $d85e0c7e91e2ddfe$var$prefix;
$d85e0c7e91e2ddfe$exports.iconName = $d85e0c7e91e2ddfe$var$iconName;
$d85e0c7e91e2ddfe$exports.width = $d85e0c7e91e2ddfe$var$width;
$d85e0c7e91e2ddfe$exports.height = $d85e0c7e91e2ddfe$var$height;
$d85e0c7e91e2ddfe$exports.ligatures = $d85e0c7e91e2ddfe$var$aliases;
$d85e0c7e91e2ddfe$exports.unicode = $d85e0c7e91e2ddfe$var$unicode;
$d85e0c7e91e2ddfe$exports.svgPathData = $d85e0c7e91e2ddfe$var$svgPathData;
$d85e0c7e91e2ddfe$exports.aliases = $d85e0c7e91e2ddfe$var$aliases;


var $4e5ab4d00c078f68$exports = {};
'use strict';
Object.defineProperty($4e5ab4d00c078f68$exports, '__esModule', {
    value: true
});
var $4e5ab4d00c078f68$var$prefix = 'fas';
var $4e5ab4d00c078f68$var$iconName = 'star';
var $4e5ab4d00c078f68$var$width = 576;
var $4e5ab4d00c078f68$var$height = 512;
var $4e5ab4d00c078f68$var$aliases = [
    11088,
    61446
];
var $4e5ab4d00c078f68$var$unicode = 'f005';
var $4e5ab4d00c078f68$var$svgPathData = 'M309.5-18.9c-4.1-8-12.4-13.1-21.4-13.1s-17.3 5.1-21.4 13.1L193.1 125.3 33.2 150.7c-8.9 1.4-16.3 7.7-19.1 16.3s-.5 18 5.8 24.4l114.4 114.5-25.2 159.9c-1.4 8.9 2.3 17.9 9.6 23.2s16.9 6.1 25 2L288.1 417.6 432.4 491c8 4.1 17.7 3.3 25-2s11-14.2 9.6-23.2L441.7 305.9 556.1 191.4c6.4-6.4 8.6-15.8 5.8-24.4s-10.1-14.9-19.1-16.3L383 125.3 309.5-18.9z';
$4e5ab4d00c078f68$exports.definition = {
    prefix: $4e5ab4d00c078f68$var$prefix,
    iconName: $4e5ab4d00c078f68$var$iconName,
    icon: [
        $4e5ab4d00c078f68$var$width,
        $4e5ab4d00c078f68$var$height,
        $4e5ab4d00c078f68$var$aliases,
        $4e5ab4d00c078f68$var$unicode,
        $4e5ab4d00c078f68$var$svgPathData
    ]
};
$4e5ab4d00c078f68$exports.faStar = $4e5ab4d00c078f68$exports.definition;
$4e5ab4d00c078f68$exports.prefix = $4e5ab4d00c078f68$var$prefix;
$4e5ab4d00c078f68$exports.iconName = $4e5ab4d00c078f68$var$iconName;
$4e5ab4d00c078f68$exports.width = $4e5ab4d00c078f68$var$width;
$4e5ab4d00c078f68$exports.height = $4e5ab4d00c078f68$var$height;
$4e5ab4d00c078f68$exports.ligatures = $4e5ab4d00c078f68$var$aliases;
$4e5ab4d00c078f68$exports.unicode = $4e5ab4d00c078f68$var$unicode;
$4e5ab4d00c078f68$exports.svgPathData = $4e5ab4d00c078f68$var$svgPathData;
$4e5ab4d00c078f68$exports.aliases = $4e5ab4d00c078f68$var$aliases;


var $468e6f5287149412$exports = {};
'use strict';
Object.defineProperty($468e6f5287149412$exports, '__esModule', {
    value: true
});
var $6f224e40d9413106$exports = {};
'use strict';
Object.defineProperty($6f224e40d9413106$exports, '__esModule', {
    value: true
});
var $6f224e40d9413106$var$prefix = 'fas';
var $6f224e40d9413106$var$iconName = 'rotate';
var $6f224e40d9413106$var$width = 512;
var $6f224e40d9413106$var$height = 512;
var $6f224e40d9413106$var$aliases = [
    128260,
    "sync-alt"
];
var $6f224e40d9413106$var$unicode = 'f2f1';
var $6f224e40d9413106$var$svgPathData = 'M480.1 192l7.9 0c13.3 0 24-10.7 24-24l0-144c0-9.7-5.8-18.5-14.8-22.2S477.9 .2 471 7L419.3 58.8C375 22.1 318 0 256 0 127 0 20.3 95.4 2.6 219.5 .1 237 12.2 253.2 29.7 255.7s33.7-9.7 36.2-27.1C79.2 135.5 159.3 64 256 64 300.4 64 341.2 79 373.7 104.3L327 151c-6.9 6.9-8.9 17.2-5.2 26.2S334.3 192 344 192l136.1 0zm29.4 100.5c2.5-17.5-9.7-33.7-27.1-36.2s-33.7 9.7-36.2 27.1c-13.3 93-93.4 164.5-190.1 164.5-44.4 0-85.2-15-117.7-40.3L185 361c6.9-6.9 8.9-17.2 5.2-26.2S177.7 320 168 320L24 320c-13.3 0-24 10.7-24 24L0 488c0 9.7 5.8 18.5 14.8 22.2S34.1 511.8 41 505l51.8-51.8C137 489.9 194 512 256 512 385 512 491.7 416.6 509.4 292.5z';
$6f224e40d9413106$exports.definition = {
    prefix: $6f224e40d9413106$var$prefix,
    iconName: $6f224e40d9413106$var$iconName,
    icon: [
        $6f224e40d9413106$var$width,
        $6f224e40d9413106$var$height,
        $6f224e40d9413106$var$aliases,
        $6f224e40d9413106$var$unicode,
        $6f224e40d9413106$var$svgPathData
    ]
};
$6f224e40d9413106$exports.faRotate = $6f224e40d9413106$exports.definition;
$6f224e40d9413106$exports.prefix = $6f224e40d9413106$var$prefix;
$6f224e40d9413106$exports.iconName = $6f224e40d9413106$var$iconName;
$6f224e40d9413106$exports.width = $6f224e40d9413106$var$width;
$6f224e40d9413106$exports.height = $6f224e40d9413106$var$height;
$6f224e40d9413106$exports.ligatures = $6f224e40d9413106$var$aliases;
$6f224e40d9413106$exports.unicode = $6f224e40d9413106$var$unicode;
$6f224e40d9413106$exports.svgPathData = $6f224e40d9413106$var$svgPathData;
$6f224e40d9413106$exports.aliases = $6f224e40d9413106$var$aliases;


$468e6f5287149412$exports.definition = {
    prefix: $6f224e40d9413106$exports.prefix,
    iconName: $6f224e40d9413106$exports.iconName,
    icon: [
        $6f224e40d9413106$exports.width,
        $6f224e40d9413106$exports.height,
        $6f224e40d9413106$exports.aliases,
        $6f224e40d9413106$exports.unicode,
        $6f224e40d9413106$exports.svgPathData
    ]
};
$468e6f5287149412$exports.faSyncAlt = $468e6f5287149412$exports.definition;
$468e6f5287149412$exports.prefix = $6f224e40d9413106$exports.prefix;
$468e6f5287149412$exports.iconName = $6f224e40d9413106$exports.iconName;
$468e6f5287149412$exports.width = $6f224e40d9413106$exports.width;
$468e6f5287149412$exports.height = $6f224e40d9413106$exports.height;
$468e6f5287149412$exports.ligatures = $6f224e40d9413106$exports.aliases;
$468e6f5287149412$exports.unicode = $6f224e40d9413106$exports.unicode;
$468e6f5287149412$exports.svgPathData = $6f224e40d9413106$exports.svgPathData;
$468e6f5287149412$exports.aliases = $6f224e40d9413106$exports.aliases;


var $6c06a95c587730ec$exports = {};
'use strict';
Object.defineProperty($6c06a95c587730ec$exports, '__esModule', {
    value: true
});
var $9e310623eda7f0ec$exports = {};
'use strict';
Object.defineProperty($9e310623eda7f0ec$exports, '__esModule', {
    value: true
});
var $9e310623eda7f0ec$var$prefix = 'fas';
var $9e310623eda7f0ec$var$iconName = 'xmark';
var $9e310623eda7f0ec$var$width = 384;
var $9e310623eda7f0ec$var$height = 512;
var $9e310623eda7f0ec$var$aliases = [
    128473,
    10005,
    10006,
    10060,
    215,
    "close",
    "multiply",
    "remove",
    "times"
];
var $9e310623eda7f0ec$var$unicode = 'f00d';
var $9e310623eda7f0ec$var$svgPathData = 'M55.1 73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L147.2 256 9.9 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192.5 301.3 329.9 438.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.8 256 375.1 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192.5 210.7 55.1 73.4z';
$9e310623eda7f0ec$exports.definition = {
    prefix: $9e310623eda7f0ec$var$prefix,
    iconName: $9e310623eda7f0ec$var$iconName,
    icon: [
        $9e310623eda7f0ec$var$width,
        $9e310623eda7f0ec$var$height,
        $9e310623eda7f0ec$var$aliases,
        $9e310623eda7f0ec$var$unicode,
        $9e310623eda7f0ec$var$svgPathData
    ]
};
$9e310623eda7f0ec$exports.faXmark = $9e310623eda7f0ec$exports.definition;
$9e310623eda7f0ec$exports.prefix = $9e310623eda7f0ec$var$prefix;
$9e310623eda7f0ec$exports.iconName = $9e310623eda7f0ec$var$iconName;
$9e310623eda7f0ec$exports.width = $9e310623eda7f0ec$var$width;
$9e310623eda7f0ec$exports.height = $9e310623eda7f0ec$var$height;
$9e310623eda7f0ec$exports.ligatures = $9e310623eda7f0ec$var$aliases;
$9e310623eda7f0ec$exports.unicode = $9e310623eda7f0ec$var$unicode;
$9e310623eda7f0ec$exports.svgPathData = $9e310623eda7f0ec$var$svgPathData;
$9e310623eda7f0ec$exports.aliases = $9e310623eda7f0ec$var$aliases;


$6c06a95c587730ec$exports.definition = {
    prefix: $9e310623eda7f0ec$exports.prefix,
    iconName: $9e310623eda7f0ec$exports.iconName,
    icon: [
        $9e310623eda7f0ec$exports.width,
        $9e310623eda7f0ec$exports.height,
        $9e310623eda7f0ec$exports.aliases,
        $9e310623eda7f0ec$exports.unicode,
        $9e310623eda7f0ec$exports.svgPathData
    ]
};
$6c06a95c587730ec$exports.faTimes = $6c06a95c587730ec$exports.definition;
$6c06a95c587730ec$exports.prefix = $9e310623eda7f0ec$exports.prefix;
$6c06a95c587730ec$exports.iconName = $9e310623eda7f0ec$exports.iconName;
$6c06a95c587730ec$exports.width = $9e310623eda7f0ec$exports.width;
$6c06a95c587730ec$exports.height = $9e310623eda7f0ec$exports.height;
$6c06a95c587730ec$exports.ligatures = $9e310623eda7f0ec$exports.aliases;
$6c06a95c587730ec$exports.unicode = $9e310623eda7f0ec$exports.unicode;
$6c06a95c587730ec$exports.svgPathData = $9e310623eda7f0ec$exports.svgPathData;
$6c06a95c587730ec$exports.aliases = $9e310623eda7f0ec$exports.aliases;


var $37a500ad1dcc914a$exports = {};
'use strict';
Object.defineProperty($37a500ad1dcc914a$exports, '__esModule', {
    value: true
});
var $37a500ad1dcc914a$var$prefix = 'fas';
var $37a500ad1dcc914a$var$iconName = 'wifi';
var $37a500ad1dcc914a$var$width = 576;
var $37a500ad1dcc914a$var$height = 512;
var $37a500ad1dcc914a$var$aliases = [
    "wifi-3",
    "wifi-strong"
];
var $37a500ad1dcc914a$var$unicode = 'f1eb';
var $37a500ad1dcc914a$var$svgPathData = 'M288 96c-90.9 0-173.2 36-233.7 94.6-12.7 12.3-33 12-45.2-.7s-12-33 .7-45.2C81.7 74.9 179.9 32 288 32S494.3 74.9 566.3 144.7c12.7 12.3 13 32.6 .7 45.2s-32.6 13-45.2 .7C461.2 132 378.9 96 288 96zM240 432a48 48 0 1 1 96 0 48 48 0 1 1 -96 0zM168 326.2c-11.7 13.3-31.9 14.5-45.2 2.8s-14.5-31.9-2.8-45.2C161 237.4 221.1 208 288 208s127 29.4 168 75.8c11.7 13.3 10.4 33.5-2.8 45.2s-33.5 10.4-45.2-2.8C378.6 292.9 335.8 272 288 272s-90.6 20.9-120 54.2z';
$37a500ad1dcc914a$exports.definition = {
    prefix: $37a500ad1dcc914a$var$prefix,
    iconName: $37a500ad1dcc914a$var$iconName,
    icon: [
        $37a500ad1dcc914a$var$width,
        $37a500ad1dcc914a$var$height,
        $37a500ad1dcc914a$var$aliases,
        $37a500ad1dcc914a$var$unicode,
        $37a500ad1dcc914a$var$svgPathData
    ]
};
$37a500ad1dcc914a$exports.faWifi = $37a500ad1dcc914a$exports.definition;
$37a500ad1dcc914a$exports.prefix = $37a500ad1dcc914a$var$prefix;
$37a500ad1dcc914a$exports.iconName = $37a500ad1dcc914a$var$iconName;
$37a500ad1dcc914a$exports.width = $37a500ad1dcc914a$var$width;
$37a500ad1dcc914a$exports.height = $37a500ad1dcc914a$var$height;
$37a500ad1dcc914a$exports.ligatures = $37a500ad1dcc914a$var$aliases;
$37a500ad1dcc914a$exports.unicode = $37a500ad1dcc914a$var$unicode;
$37a500ad1dcc914a$exports.svgPathData = $37a500ad1dcc914a$var$svgPathData;
$37a500ad1dcc914a$exports.aliases = $37a500ad1dcc914a$var$aliases;


var $d010209656ae0f57$var$WALLABAG_ICON = [
    124.155,
    133.529,
    [],
    '',
    // wallabag.svg: Free Art License 1.3 https://github.com/wallabag/logo
    'M108.69.004c-.241-.026-.512.083-.777.299-.572.465-5.551 1.614-8.504 3.917-4.768 3.72-7.707 10.796-9.04 14.708-.024.06-.205.603-.265.79-.62 1.499-1.857 1.495-1.857 1.495v.002c-.6-.065-1.202-.102-1.809-.102-.54 0-1.078.03-1.615.082-.012.002-.02 0-.031 0-1.581.233-2.451-1.696-2.633-2.156C80.312 13.735 75.342 3.277 64.174.463c0 0-2.028-1.554-1.41 1.074.588 2.51 1.805 5.048 1.535 8.74-.124 1.704-1.18 10.442 6.85 14.99.763.432 1.44.796 2.05 1.102-4.041 3.235-7.715 7.739-10.858 12.852 1.597-.981 10.206-5.557 24.097.177 14.29 5.897 23.155.777 24.254.08-3.454-5.678-7.561-10.62-12.103-13.943.303-.083.612-.168.939-.264 6.023-1.742 7.553-6.84 7.875-11.209.364-4.954.615-5.029 1.691-9.486.774-3.21.32-4.495-.404-4.572zM86.774 50.228a4.677 4.677 0 00-1.652.256 6.555 6.555 0 00-1.332.615 3.879 3.879 0 00-1.094.985c-.322.432-.486.901-.486 1.396v16.307c0 2.158-.362 3.75-1.078 4.73-.688.94-1.85 1.397-3.55 1.397-1.704 0-2.876-.46-3.583-1.402-.734-.98-1.108-2.57-1.108-4.725V53.73c0-.908-.383-1.727-1.144-2.437-.751-.702-1.75-1.059-2.973-1.059-1.258 0-2.297.352-3.086 1.045-.81.71-1.22 1.536-1.22 2.451v15.807c0 1.988.193 3.869.574 5.588.393 1.758 1.077 3.3 2.035 4.586.968 1.299 2.282 2.322 3.906 3.049 1.607.716 3.617 1.08 5.975 1.08 2.457 0 4.515-.457 6.115-1.356a10.678 10.678 0 003.371-2.95 10.256 10.256 0 003.295 2.95c1.58.9 3.669 1.354 6.21 1.354 2.358 0 4.358-.363 5.946-1.08 1.601-.726 2.903-1.752 3.873-3.05.96-1.29 1.644-2.832 2.033-4.585.381-1.72.577-3.6.577-5.588V53.73c0-.91-.398-1.733-1.184-2.445-.767-.697-1.82-1.05-3.121-1.05-1.181 0-2.161.356-2.912 1.058-.76.71-1.145 1.53-1.145 2.437v16.057c0 2.154-.381 3.742-1.134 4.72-.728.947-1.891 1.407-3.555 1.407-1.703 0-2.863-.458-3.549-1.397-.716-.979-1.078-2.57-1.078-4.73v-16.12c0-1.097-.501-1.997-1.45-2.597-.805-.507-1.607-.81-2.476-.842zM51.796 82.363a31.2 31.2 0 001.865 5.742c.666 3.745 1.561 12.563-2.674 20.282-3.731 6.8-22.15 16.069-49.484 10.748 0 0-1.096-.765-1.428-.135-.491.932 1.516 1.684 3.582 2.228 19.03 5.04 47.756 2.989 56.777-4.443 4.116-3.388 5.705-7.953 6.108-12.865l.002.008s.11-1.288 1.718-.32c.461.276 2.126 1.36 2.391 2.585.232 1.743.248 3.884-.652 5.383-1.287 2.144-1.302 2.45.392 3.66 1.04.742 5.289 3.865 11.2 7.416.015.01.022.02.037.028 1.25.753 2.988 2.595 2.988 2.595 2.662 3.08 8.45 9.277 10.97 8.11 1.19-.551-.05-3.033-.05-3.033s1.98 2.572 3.043 1.695c.809-.668-.473-3.23-.473-3.23s1.73 1.5 2.758.945c1.258-.68-.188-4.614-10.08-10.627-9.896-6.018-12.579-6.941-12.815-9.627 0 0-.004-.134.004-.365.077-.593.416-1.848 1.854-1.713 2.14.346 4.347.53 6.607.53 2.587 0 5.106-.236 7.535-.689l.002.002.164-.029c.284-.036.838-.019.84.67-.09.873-.331 1.752-.845 2.52-1.447 2.168-.971 2.466.54 3.859.934.859 5.212 4.622 11.07 8.264.013.009.016.016.03.023 1.25.752 3.41 2.814 3.41 2.814 2.428 2.466 6.895 6.595 9.328 6.346 1.646-.168.305-3.002.305-3.002s2.079 2.006 3.1 1.416c1.142-.659-.475-2.754-.475-2.754s1.338.708 2.283.473c.948-.236 1.187-2.643-8.654-8.736-9.842-6.098-13.154-8.244-12.947-10.577 0 0 .003-.379.1-.957.238-1.236.994-3.346 3.406-4.55.079-.04.147-.084.209-.13 7.668-4.45 13.27-11.614 15.246-20.56-1.99 4.941-16.737 8.78-34.647 8.78-17.903 0-32.65-3.839-34.64-8.78z'
];
var $d010209656ae0f57$export$2e2bcd8739ae039 = $d010209656ae0f57$var$WALLABAG_ICON;


'use strict';
var $ad1c54c45e1481e9$export$a67558cb68d63c7e = {
    prefix: 'fac',
    iconName: 'wallabag',
    icon: (0, $d010209656ae0f57$export$2e2bcd8739ae039)
};


function $ca3d48d4950424d8$export$7f7cbe89f1eacd2(props) {
    var label = props.label, size = props.size;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                icon: $d85e0c7e91e2ddfe$exports.faSpinner,
                size: size,
                spin: true,
                "aria-hidden": "true",
                title: label
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "visually-hidden",
                role: "alert",
                children: label
            })
        ]
    });
}
function $ca3d48d4950424d8$export$84dbad74efe95918(props) {
    var label = props.label;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "spinner-big",
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($ca3d48d4950424d8$export$7f7cbe89f1eacd2, {
            size: "10x",
            label: label
        })
    });
}





var $eHaBZ = parcelRequire("eHaBZ");
function $f2be1a5bddfb7605$export$e51161e9fbfde80e(translated, params) {
    var formatted = '';
    var curChar;
    var buffer = '';
    var state = 'out';
    var placeholder;
    var plural;
    var pluralKeyword;
    var pluralValue;
    for(var i = 0, len = translated.length; i < len; i++){
        curChar = translated.charAt(i);
        switch(curChar){
            case '{':
                if (placeholder) {
                    if (state === 'plural') {
                        var kw = buffer.trim();
                        if (kw === 'zero' || kw === 'one' || kw === 'other') {
                            pluralKeyword = kw;
                            buffer = '';
                        } else pluralKeyword = undefined;
                    }
                } else {
                    formatted = formatted + buffer;
                    buffer = '';
                    placeholder = {};
                    state = 'index';
                }
                break;
            case '}':
            case ',':
                if (placeholder) {
                    if (state === 'index') {
                        placeholder.index = buffer.trim();
                        placeholder.value = params[placeholder.index];
                        buffer = '';
                    } else if (state === 'type') {
                        placeholder.type = buffer.trim();
                        buffer = '';
                        if (placeholder.type === 'plural') {
                            plural = {};
                            state = 'plural';
                        }
                    }
                    if (curChar === '}') {
                        if (state === 'plural' && pluralKeyword) {
                            plural[pluralKeyword] = buffer;
                            buffer = '';
                            pluralKeyword = undefined;
                        } else if (plural) {
                            if ('zero' in plural && placeholder.value === 0) pluralValue = plural.zero;
                            else if ('one' in plural && placeholder.value === 1) pluralValue = plural.one;
                            else pluralValue = plural.other;
                            formatted = formatted + pluralValue.replace('#', placeholder.value.toString());
                            plural = undefined;
                            placeholder = undefined;
                            state = 'out';
                        } else {
                            formatted = formatted + placeholder.value;
                            placeholder = undefined;
                            state = 'out';
                        }
                    } else if (curChar === ',' && state === 'index') state = 'type';
                }
                break;
            default:
                buffer = buffer + curChar;
                break;
        }
    }
    if (state != 'out') return "Error formatting '" + translated + "', bug report?";
    formatted = formatted + buffer;
    return formatted;
}
var $f2be1a5bddfb7605$export$51216bcc3983e55d = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).createContext(function() {
    throw new Error('Missing l10n context');
});



var $eHaBZ = parcelRequire("eHaBZ");
var $3218aa08983fdbc5$export$326f6d1b69f1c06e = (0, $eHaBZ.createContext)(undefined);


function $7c130f6079f220d1$var$handleLogIn(_0) {
    return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function(param) {
        var configuration, navigate, username, password, enableOffline, returnLocation, _, err, message;
        return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
            switch(_state.label){
                case 0:
                    configuration = param.configuration, navigate = param.navigate, username = param.username, password = param.password, enableOffline = param.enableOffline, returnLocation = param.returnLocation, _ = param._;
                    _state.label = 1;
                case 1:
                    _state.trys.push([
                        1,
                        3,
                        ,
                        4
                    ]);
                    return [
                        4,
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).login({
                            configuration: configuration,
                            username: username,
                            password: password,
                            enableOffline: enableOffline
                        })
                    ];
                case 2:
                    _state.sent();
                    navigate(returnLocation);
                    return [
                        3,
                        4
                    ];
                case 3:
                    err = _state.sent();
                    message = err instanceof (0, $d78024f502d9a257$export$5e64a9683d127ef6) ? _('login_invalid_credentials') : _('login_error_generic', {
                        errorMessage: err instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) ? "HTTP ".concat(err.response.status, " ").concat(err.message) : err.message
                    });
                    navigate('/sign/in', {
                        replace: true,
                        state: {
                            error: message
                        }
                    });
                    return [
                        3,
                        4
                    ];
                case 4:
                    return [
                        2
                    ];
            }
        });
    }).apply(this, arguments);
}
function $7c130f6079f220d1$export$2e2bcd8739ae039(props) {
    var _location_state, _location_state1;
    var offlineEnabled = props.offlineEnabled;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var configuration = (0, $eHaBZ.use)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e));
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var error = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.error;
    var _location_state_returnLocation;
    var returnLocation = (_location_state_returnLocation = location === null || location === void 0 ? void 0 : (_location_state1 = location.state) === null || _location_state1 === void 0 ? void 0 : _location_state1.returnLocation) !== null && _location_state_returnLocation !== void 0 ? _location_state_returnLocation : '/';
    var _useActionState = (0, $21h22._)((0, $eHaBZ.useActionState)(function(_previousState, formData) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var username, password, enableOffline;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        username = formData.get('username');
                        password = formData.get('password');
                        enableOffline = formData.get('enableoffline') === 'on';
                        return [
                            4,
                            $7c130f6079f220d1$var$handleLogIn({
                                configuration: configuration,
                                navigate: navigate,
                                username: username,
                                password: password,
                                enableOffline: enableOffline,
                                returnLocation: returnLocation,
                                _: _
                            })
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    }, undefined), 3), submitAction = _useActionState[1], loading = _useActionState[2];
    var formOnSubmit = (0, $eHaBZ.useCallback)(function(event) {
        // Unlike `action` prop, `onSubmit` avoids clearing the form on submit.
        // https://github.com/facebook/react/issues/29034#issuecomment-2143595195
        event.preventDefault();
        var formData = new (0, $3cd9a930e9e44820$export$5300a9e19ff2767e)(event.currentTarget);
        (0, $eHaBZ.startTransition)(function() {
            return submitAction(formData);
        });
    }, []);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            loading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$84dbad74efe95918), {
                label: _('login_in_progress')
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
                action: "",
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    loading: loading
                }),
                method: "post",
                onSubmit: formOnSubmit,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "login",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("h1", {
                                children: [
                                    configuration.htmlTitle,
                                    " login"
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "username",
                                    children: _('login_username')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "text",
                                    name: "username",
                                    id: "username",
                                    accessKey: "u",
                                    autoComplete: "username",
                                    autoFocus: true,
                                    required: true
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "password",
                                    children: _('login_password')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "password",
                                    name: "password",
                                    id: "password",
                                    accessKey: "p",
                                    autoComplete: "current-password"
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    htmlFor: "enableoffline",
                                    children: _('login_offline')
                                }),
                                ' ',
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("label", {
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                            type: "checkbox",
                                            name: "enableoffline",
                                            id: "enableoffline",
                                            accessKey: "o",
                                            defaultChecked: offlineEnabled
                                        }),
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                            className: "badge-experimental",
                                            children: _('experimental')
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            className: "error",
                            "aria-live": "assertive",
                            children: error
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                            className: "button",
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                                    children: "\xa0"
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                                    type: "submit",
                                    accessKey: "l",
                                    value: _('login')
                                })
                            ]
                        })
                    ]
                })
            })
        ]
    });
}




var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");



var $eHaBZ = parcelRequire("eHaBZ");




var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $eHaBZ = parcelRequire("eHaBZ");

var $bVPm2 = parcelRequire("bVPm2");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $bVPm2 = parcelRequire("bVPm2");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $eHaBZ = parcelRequire("eHaBZ");


var $eHaBZ = parcelRequire("eHaBZ");
var $f6b66376b7c99589$export$7ae630fe844fbd1f = function(param) {
    var block = param.block, element = param.element, modifiers = param.modifiers, className = param.className;
    return (0, $eHaBZ.useMemo)(function() {
        var blockElement = element ? "".concat(block, "__").concat(element) : block;
        var classString = blockElement;
        modifiers && Object.keys(modifiers).forEach(function(name) {
            var value = modifiers[name];
            if (value) classString += " ".concat(blockElement, "--").concat(value === true ? name : "".concat(name, "-").concat(value));
        });
        var expandedClassName = typeof className === 'function' ? className(modifiers) : className;
        if (typeof expandedClassName === 'string') {
            expandedClassName = expandedClassName.trim();
            if (expandedClassName) classString += " ".concat(expandedClassName);
        }
        return classString;
    }, [
        block,
        element,
        modifiers,
        className
    ]);
};



var $eHaBZ = parcelRequire("eHaBZ");
var $58c87f0a382883df$export$ccf052fa53df1929 = 'szh-menu-container';
var $58c87f0a382883df$export$832250593589325a = 'szh-menu';
var $58c87f0a382883df$export$b3d82f113f746a0 = 'szh-menu-button';
var $58c87f0a382883df$export$3b35f0f35c840df9 = 'arrow';
var $58c87f0a382883df$export$b5a3c9a9995a8c24 = 'item';
var $58c87f0a382883df$export$10b42530e0558a83 = 'divider';
var $58c87f0a382883df$export$29e3fcfc61abbafd = 'header';
var $58c87f0a382883df$export$e4f8e9b9e6d790ae = 'group';
var $58c87f0a382883df$export$3b437b9ab85faa03 = 'submenu';
var $58c87f0a382883df$export$d6766e4ef63d0cb0 = 'radio-group';
var $58c87f0a382883df$export$15c1690330cd94e = /*#__PURE__*/ (0, $eHaBZ.createContext)();
var $58c87f0a382883df$export$7cb023214e4bda1e = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$1c2bdfb4407fdacf = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$ee9f2ec6c8119c2a = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$a79eda4ff50e30b6 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$8fa45c82eddfe270 = /*#__PURE__*/ (0, $eHaBZ.createContext)({});
var $58c87f0a382883df$export$4b0075e5ea5e1f26 = /*#__PURE__*/ Object.freeze({
    ENTER: 'Enter',
    ESC: 'Escape',
    SPACE: ' ',
    HOME: 'Home',
    END: 'End',
    LEFT: 'ArrowLeft',
    RIGHT: 'ArrowRight',
    UP: 'ArrowUp',
    DOWN: 'ArrowDown'
});
var $58c87f0a382883df$export$6db955af9e6f8fcd = /*#__PURE__*/ Object.freeze({
    RESET: 0,
    SET: 1,
    UNSET: 2,
    INCREASE: 3,
    DECREASE: 4,
    FIRST: 5,
    LAST: 6,
    SET_INDEX: 7
});
var $58c87f0a382883df$export$8fd8df51a9b835e6 = /*#__PURE__*/ Object.freeze({
    CLICK: 'click',
    CANCEL: 'cancel',
    BLUR: 'blur',
    SCROLL: 'scroll'
});
var $58c87f0a382883df$export$8c6ccba1b6ce32e9 = /*#__PURE__*/ Object.freeze({
    FIRST: 'first',
    LAST: 'last'
});
var $58c87f0a382883df$export$be1d8b0328ba66b6 = /*#__PURE__*/ Object.freeze({
    entering: 'opening',
    entered: 'open',
    exiting: 'closing',
    exited: 'closed'
});
var $58c87f0a382883df$export$f8d144aafbd3a470 = 'absolute';
var $58c87f0a382883df$export$a5a9d7469a9cc520 = 'none';
var $58c87f0a382883df$export$3e982710469daaf = 'menuitem';
var $58c87f0a382883df$export$42466afb37c6c021 = {
    preventScroll: true
};



var $6zk1M = parcelRequire("6zk1M");

var $bVPm2 = parcelRequire("bVPm2");
var $26d9d16241653294$export$30c2dce1a652e248 = function(state) {
    return !!state && state[0] === 'o';
};
var $26d9d16241653294$export$3e3e6d241f8feb60 = (0, $bVPm2.unstable_batchedUpdates);
var $26d9d16241653294$export$d5639c01d489b0c = function(transition, name) {
    return transition === true || !!(transition && transition[name]);
};
var $26d9d16241653294$export$175e60bb96229ece = function(fn, arg) {
    return typeof fn === 'function' ? fn(arg) : fn;
};
var $26d9d16241653294$var$internalKey = '_szhsinMenu';
var $26d9d16241653294$export$7d9f7e9c1c02b41e = function(component) {
    return component[$26d9d16241653294$var$internalKey];
};
var $26d9d16241653294$export$4c4bf90f1b4d3105 = function(name, component) {
    return Object.defineProperty(component, $26d9d16241653294$var$internalKey, {
        value: name
    });
};
var $26d9d16241653294$export$9d1611c77c2fe928 = function(target, source) {
    source && Object.keys(source).forEach(function(key) {
        var targetProp = target[key];
        var sourceProp = source[key];
        if (typeof sourceProp === 'function' && targetProp) target[key] = function() {
            for(var _len = arguments.length, arg = new Array(_len), _key = 0; _key < _len; _key++){
                arg[_key] = arguments[_key];
            }
            sourceProp.apply(void 0, (0, $6zk1M._)(arg));
            targetProp.apply(void 0, (0, $6zk1M._)(arg));
        };
        else target[key] = sourceProp;
    });
    return target;
};
var $26d9d16241653294$export$4bc3c325941e6f67 = function(paddingStr) {
    if (typeof paddingStr !== 'string') return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
    var padding = paddingStr.trim().split(/\s+/, 4).map(parseFloat);
    var top = !isNaN(padding[0]) ? padding[0] : 0;
    var right = !isNaN(padding[1]) ? padding[1] : top;
    return {
        top: top,
        right: right,
        bottom: !isNaN(padding[2]) ? padding[2] : top,
        left: !isNaN(padding[3]) ? padding[3] : right
    };
};
var $26d9d16241653294$export$7414735161c19437 = function(node) {
    while(node){
        node = node.parentNode;
        if (!node || node === document.body || !node.parentNode) return;
        var _getComputedStyle = getComputedStyle(node), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
        if (/auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX)) return node;
    }
};
function $26d9d16241653294$export$ffb2d5922287e12(isDisabled, isHovering) {
    return {
        'aria-disabled': isDisabled || undefined,
        tabIndex: isHovering ? 0 : -1
    };
}
function $26d9d16241653294$export$a12bd5aaf0b59fa0(nodeList, node) {
    for(var i = 0; i < nodeList.length; i++){
        if (nodeList[i] === node) return i;
    }
    return -1;
}


var $e4ff2b7984f354ae$export$b286f91cddfedb5a = function(param) {
    var className = param.className, containerRef = param.containerRef, containerProps = param.containerProps, children = param.children, isOpen = param.isOpen, theming = param.theming, transition = param.transition, onClose = param.onClose;
    var itemTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'item');
    var onKeyDown = function(param) {
        var key = param.key;
        switch(key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).ESC:
                (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CANCEL
                });
                break;
        }
    };
    var onBlur = function(e) {
        if (isOpen && !e.currentTarget.contains(e.relatedTarget)) (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
            reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).BLUR
        });
    };
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", (0, $9Jpjh._)((0, $lvTkn._)({}, (0, $26d9d16241653294$export$9d1611c77c2fe928)({
        onKeyDown: onKeyDown,
        onBlur: onBlur
    }, containerProps)), {
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$ccf052fa53df1929),
            modifiers: (0, $eHaBZ.useMemo)(function() {
                return {
                    theme: theming,
                    itemTransition: itemTransition
                };
            }, [
                theming,
                itemTransition
            ]),
            className: className
        }),
        style: (0, $lvTkn._)({
            position: 'absolute'
        }, containerProps === null || containerProps === void 0 ? void 0 : containerProps.style),
        ref: containerRef,
        children: children
    }));
};



var $ac38d8c87becf7c6$export$fd76cd1ffdc0d698 = function() {
    var timer, count = 0;
    return {
        toggle: function(isOpen) {
            isOpen ? count++ : count--;
            count = Math.max(count, 0);
        },
        on: function(closeDelay, pending, settled) {
            if (count) {
                if (!timer) timer = setTimeout(function() {
                    timer = 0;
                    pending();
                }, closeDelay);
            } else settled === null || settled === void 0 ? void 0 : settled();
        },
        off: function() {
            if (timer) {
                clearTimeout(timer);
                timer = 0;
            }
        }
    };
};




var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");


var $6e2879dc867be080$export$7bfdd97581ca93c = function(menuRef) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(), 2), hoverItem = _useState[0], setHoverItem = _useState[1];
    var stateRef = (0, $eHaBZ.useRef)({
        items: [],
        hoverIndex: -1,
        sorted: false
    });
    var mutableState = stateRef.current;
    var updateItems = (0, $eHaBZ.useCallback)(function(item, isMounted) {
        var items = mutableState.items;
        if (!item) mutableState.items = [];
        else if (isMounted) items.push(item);
        else {
            var index = items.indexOf(item);
            if (index > -1) {
                items.splice(index, 1);
                if (item.contains(document.activeElement)) {
                    menuRef.current.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
                    setHoverItem();
                }
            }
        }
        mutableState.hoverIndex = -1;
        mutableState.sorted = false;
    }, [
        mutableState,
        menuRef
    ]);
    var dispatch = (0, $eHaBZ.useCallback)(function(actionType, item, nextIndex) {
        var items = mutableState.items, hoverIndex = mutableState.hoverIndex;
        var sortItems = function() {
            if (mutableState.sorted) return;
            var orderedNodes = menuRef.current.querySelectorAll('.szh-menu__item');
            items.sort(function(a, b) {
                return (0, $26d9d16241653294$export$a12bd5aaf0b59fa0)(orderedNodes, a) - (0, $26d9d16241653294$export$a12bd5aaf0b59fa0)(orderedNodes, b);
            });
            mutableState.sorted = true;
        };
        var index = -1, newItem = undefined;
        switch(actionType){
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET:
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET:
                newItem = item;
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).UNSET:
                newItem = function(prevItem) {
                    return prevItem === item ? undefined : prevItem;
                };
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST:
                sortItems();
                index = 0;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST:
                sortItems();
                index = items.length - 1;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET_INDEX:
                sortItems();
                index = nextIndex;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).INCREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index++;
                if (index >= items.length) index = 0;
                newItem = items[index];
                break;
            case (0, $58c87f0a382883df$export$6db955af9e6f8fcd).DECREASE:
                sortItems();
                index = hoverIndex;
                if (index < 0) index = items.indexOf(item);
                index--;
                if (index < 0) index = items.length - 1;
                newItem = items[index];
                break;
            default:
        }
        if (!newItem) index = -1;
        setHoverItem(newItem);
        mutableState.hoverIndex = index;
    }, [
        menuRef,
        mutableState
    ]);
    return {
        hoverItem: hoverItem,
        dispatch: dispatch,
        updateItems: updateItems
    };
};



var $2afa6911bbba886b$var$getNativeDimension = function(transformed, untransformed) {
    return Math.round(transformed) === untransformed ? transformed : untransformed;
};
var $2afa6911bbba886b$export$e34ab37ec351e6cb = function(element) {
    var rect = element.getBoundingClientRect();
    rect.width = $2afa6911bbba886b$var$getNativeDimension(rect.width, element.offsetWidth);
    rect.height = $2afa6911bbba886b$var$getNativeDimension(rect.height, element.offsetHeight);
    return rect;
};



var $8b929ad358cfd9d4$export$62e2806a96b09d4 = function(containerElt, menuElt, menuScroll, boundingBoxPadding) {
    var menuRect = (0, $2afa6911bbba886b$export$e34ab37ec351e6cb)(menuElt);
    var containerRect = containerElt.getBoundingClientRect();
    var boundingRect = menuScroll === window ? {
        left: 0,
        top: 0,
        right: document.documentElement.clientWidth,
        bottom: window.innerHeight
    } : menuScroll.getBoundingClientRect();
    var padding = (0, $26d9d16241653294$export$4bc3c325941e6f67)(boundingBoxPadding);
    var getLeftOverflow = function(x) {
        return x + containerRect.left - boundingRect.left - padding.left;
    };
    var getRightOverflow = function(x) {
        return x + containerRect.left + menuRect.width - boundingRect.right + padding.right;
    };
    var getTopOverflow = function(y) {
        return y + containerRect.top - boundingRect.top - padding.top;
    };
    var getBottomOverflow = function(y) {
        return y + containerRect.top + menuRect.height - boundingRect.bottom + padding.bottom;
    };
    var confineHorizontally = function(x) {
        var leftOverflow = getLeftOverflow(x);
        if (leftOverflow < 0) x -= leftOverflow;
        else {
            var rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                x -= rightOverflow;
                leftOverflow = getLeftOverflow(x);
                if (leftOverflow < 0) x -= leftOverflow;
            }
        }
        return x;
    };
    var confineVertically = function(y) {
        var topOverflow = getTopOverflow(y);
        if (topOverflow < 0) y -= topOverflow;
        else {
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                y -= bottomOverflow;
                topOverflow = getTopOverflow(y);
                if (topOverflow < 0) y -= topOverflow;
            }
        }
        return y;
    };
    return {
        menuRect: menuRect,
        containerRect: containerRect,
        getLeftOverflow: getLeftOverflow,
        getRightOverflow: getRightOverflow,
        getTopOverflow: getTopOverflow,
        getBottomOverflow: getBottomOverflow,
        confineHorizontally: confineHorizontally,
        confineVertically: confineVertically
    };
};



var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");
var $05310a17ea2b2524$export$95257ec7631d2e00 = function(param) {
    var arrowRef = param.arrowRef, menuY = param.menuY, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var y = anchorRect.top - containerRect.top - menuY + anchorRect.height / 2;
    var offset = arrowRef.current.offsetHeight * 1.25;
    y = Math.max(offset, y);
    y = Math.min(y, menuRect.height - offset);
    return y;
};


var $76059ea6fcd093dd$export$f768fc0fa8f5878e = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeLeftorRightY = param.placeLeftorRightY, placeLeftX = param.placeLeftX, placeRightX = param.placeRightX, getLeftOverflow = param.getLeftOverflow, getRightOverflow = param.getRightOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction;
    var y = placeLeftorRightY;
    if (position !== 'initial') {
        y = confineVertically(y);
        if (position === 'anchor') {
            y = Math.min(y, anchorRect.bottom - containerRect.top);
            y = Math.max(y, anchorRect.top - containerRect.top - menuRect.height);
        }
    }
    var x, leftOverflow, rightOverflow;
    if (computedDirection === 'left') {
        x = placeLeftX;
        if (position !== 'initial') {
            leftOverflow = getLeftOverflow(x);
            if (leftOverflow < 0) {
                rightOverflow = getRightOverflow(placeRightX);
                if (rightOverflow <= 0 || -leftOverflow > rightOverflow) {
                    x = placeRightX;
                    computedDirection = 'right';
                }
            }
        }
    } else {
        x = placeRightX;
        if (position !== 'initial') {
            rightOverflow = getRightOverflow(x);
            if (rightOverflow > 0) {
                leftOverflow = getLeftOverflow(placeLeftX);
                if (leftOverflow >= 0 || -leftOverflow < rightOverflow) {
                    x = placeLeftX;
                    computedDirection = 'left';
                }
            }
        }
    }
    if (position === 'auto') x = confineHorizontally(x);
    var arrowY = arrow ? (0, $05310a17ea2b2524$export$95257ec7631d2e00)({
        menuY: y,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowY: arrowY,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $9e8efa3f2dacf21c$export$4c9b3bcc0c46b8d3 = function(param) {
    var arrowRef = param.arrowRef, menuX = param.menuX, anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect;
    var x = anchorRect.left - containerRect.left - menuX + anchorRect.width / 2;
    var offset = arrowRef.current.offsetWidth * 1.25;
    x = Math.max(offset, x);
    x = Math.min(x, menuRect.width - offset);
    return x;
};


var $52c9fde4ec5d16c9$export$65848579d307fa3f = function(param) {
    var anchorRect = param.anchorRect, containerRect = param.containerRect, menuRect = param.menuRect, placeToporBottomX = param.placeToporBottomX, placeTopY = param.placeTopY, placeBottomY = param.placeBottomY, getTopOverflow = param.getTopOverflow, getBottomOverflow = param.getBottomOverflow, confineHorizontally = param.confineHorizontally, confineVertically = param.confineVertically, arrowRef = param.arrowRef, arrow = param.arrow, direction = param.direction, position = param.position;
    var computedDirection = direction === 'top' ? 'top' : 'bottom';
    var x = placeToporBottomX;
    if (position !== 'initial') {
        x = confineHorizontally(x);
        if (position === 'anchor') {
            x = Math.min(x, anchorRect.right - containerRect.left);
            x = Math.max(x, anchorRect.left - containerRect.left - menuRect.width);
        }
    }
    var y, topOverflow, bottomOverflow;
    if (computedDirection === 'top') {
        y = placeTopY;
        if (position !== 'initial') {
            topOverflow = getTopOverflow(y);
            if (topOverflow < 0) {
                bottomOverflow = getBottomOverflow(placeBottomY);
                if (bottomOverflow <= 0 || -topOverflow > bottomOverflow) {
                    y = placeBottomY;
                    computedDirection = 'bottom';
                }
            }
        }
    } else {
        y = placeBottomY;
        if (position !== 'initial') {
            bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                topOverflow = getTopOverflow(placeTopY);
                if (topOverflow >= 0 || -topOverflow < bottomOverflow) {
                    y = placeTopY;
                    computedDirection = 'top';
                }
            }
        }
    }
    if (position === 'auto') y = confineVertically(y);
    var arrowX = arrow ? (0, $9e8efa3f2dacf21c$export$4c9b3bcc0c46b8d3)({
        menuX: x,
        arrowRef: arrowRef,
        anchorRect: anchorRect,
        containerRect: containerRect,
        menuRect: menuRect
    }) : undefined;
    return {
        arrowX: arrowX,
        x: x,
        y: y,
        computedDirection: computedDirection
    };
};


var $b0de1945e2f0216b$export$5a6e2d3543ff3d7e = function(param) {
    var arrow = param.arrow, align = param.align, direction = param.direction, gap = param.gap, shift = param.shift, position = param.position, anchorRect = param.anchorRect, arrowRef = param.arrowRef, positionHelpers = param.positionHelpers;
    var menuRect = positionHelpers.menuRect, containerRect = positionHelpers.containerRect;
    var isHorizontal = direction === 'left' || direction === 'right';
    var horizontalOffset = isHorizontal ? gap : shift;
    var verticalOffset = isHorizontal ? shift : gap;
    if (arrow) {
        var arrowElt = arrowRef.current;
        if (isHorizontal) horizontalOffset += arrowElt.offsetWidth;
        else verticalOffset += arrowElt.offsetHeight;
    }
    var placeLeftX = anchorRect.left - containerRect.left - menuRect.width - horizontalOffset;
    var placeRightX = anchorRect.right - containerRect.left + horizontalOffset;
    var placeTopY = anchorRect.top - containerRect.top - menuRect.height - verticalOffset;
    var placeBottomY = anchorRect.bottom - containerRect.top + verticalOffset;
    var placeToporBottomX, placeLeftorRightY;
    if (align === 'end') {
        placeToporBottomX = anchorRect.right - containerRect.left - menuRect.width;
        placeLeftorRightY = anchorRect.bottom - containerRect.top - menuRect.height;
    } else if (align === 'center') {
        placeToporBottomX = anchorRect.left - containerRect.left - (menuRect.width - anchorRect.width) / 2;
        placeLeftorRightY = anchorRect.top - containerRect.top - (menuRect.height - anchorRect.height) / 2;
    } else {
        placeToporBottomX = anchorRect.left - containerRect.left;
        placeLeftorRightY = anchorRect.top - containerRect.top;
    }
    placeToporBottomX += horizontalOffset;
    placeLeftorRightY += verticalOffset;
    var options = (0, $9Jpjh._)((0, $lvTkn._)({}, positionHelpers), {
        anchorRect: anchorRect,
        placeLeftX: placeLeftX,
        placeRightX: placeRightX,
        placeLeftorRightY: placeLeftorRightY,
        placeTopY: placeTopY,
        placeBottomY: placeBottomY,
        placeToporBottomX: placeToporBottomX,
        arrowRef: arrowRef,
        arrow: arrow,
        direction: direction,
        position: position
    });
    switch(direction){
        case 'left':
        case 'right':
            return (0, $76059ea6fcd093dd$export$f768fc0fa8f5878e)(options);
        case 'top':
        case 'bottom':
        default:
            return (0, $52c9fde4ec5d16c9$export$65848579d307fa3f)(options);
    }
};



var $eHaBZ = parcelRequire("eHaBZ");
var $af284c5d86eb6f52$export$e5c5a5f917a5871c = typeof window !== 'undefined' && typeof window.document !== 'undefined' && typeof window.document.createElement !== 'undefined' ? (0, $eHaBZ.useLayoutEffect) : (0, $eHaBZ.useEffect);




var $eHaBZ = parcelRequire("eHaBZ");
function $f957e19c95cd0d58$var$setRef(ref, instance) {
    typeof ref === 'function' ? ref(instance) : ref.current = instance;
}
var $f957e19c95cd0d58$export$2d8be4568b07be94 = function(refA, refB) {
    return (0, $eHaBZ.useMemo)(function() {
        if (!refA) return refB;
        if (!refB) return refA;
        return function(instance) {
            $f957e19c95cd0d58$var$setRef(refA, instance);
            $f957e19c95cd0d58$var$setRef(refB, instance);
        };
    }, [
        refA,
        refB
    ]);
};


var $ae383b9f4118cf3a$var$offScreen = -9999;
var $ae383b9f4118cf3a$export$d4c4e98c5044dc8 = function(_param) {
    var ariaLabel = _param.ariaLabel, menuClassName = _param.menuClassName, menuStyle = _param.menuStyle, arrow = _param.arrow, _param_arrowProps = _param.arrowProps, arrowProps = _param_arrowProps === void 0 ? {} : _param_arrowProps, anchorPoint = _param.anchorPoint, anchorRef = _param.anchorRef, containerRef = _param.containerRef, containerProps = _param.containerProps, externalRef = _param.externalRef, parentScrollingRef = _param.parentScrollingRef, _param_align = _param.align, align = _param_align === void 0 ? 'start' : _param_align, _param_direction = _param.direction, direction = _param_direction === void 0 ? 'bottom' : _param_direction, _param_position = _param.position, position = _param_position === void 0 ? 'auto' : _param_position, _param_overflow = _param.overflow, overflow = _param_overflow === void 0 ? 'visible' : _param_overflow, setDownOverflow = _param.setDownOverflow, repositionFlag = _param.repositionFlag, _param_captureFocus = _param.captureFocus, captureFocus = _param_captureFocus === void 0 ? true : _param_captureFocus, state = _param.state, endTransition = _param.endTransition, isDisabled = _param.isDisabled, menuItemFocus = _param.menuItemFocus, _param_gap = _param.gap, gap = _param_gap === void 0 ? 0 : _param_gap, _param_shift = _param.shift, shift = _param_shift === void 0 ? 0 : _param_shift, children = _param.children, onClose = _param.onClose, _1 = _param.focusProps, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "ariaLabel",
        "menuClassName",
        "menuStyle",
        "arrow",
        "arrowProps",
        "anchorPoint",
        "anchorRef",
        "containerRef",
        "containerProps",
        "externalRef",
        "parentScrollingRef",
        "align",
        "direction",
        "position",
        "overflow",
        "setDownOverflow",
        "repositionFlag",
        "captureFocus",
        "state",
        "endTransition",
        "isDisabled",
        "menuItemFocus",
        "gap",
        "shift",
        "children",
        "onClose",
        "focusProps"
    ]);
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)({
        x: $ae383b9f4118cf3a$var$offScreen,
        y: $ae383b9f4118cf3a$var$offScreen
    }), 2), menuPosition = _useState[0], setMenuPosition = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), arrowPosition = _useState1[0], setArrowPosition = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(), 2), overflowData = _useState2[0], setOverflowData = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(direction), 2), expandedDirection = _useState3[0], setExpandedDirection = _useState3[1];
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)((0, $ac38d8c87becf7c6$export$fd76cd1ffdc0d698)), 1), submenuCtx = _useState4[0];
    var _useReducer = (0, $21h22._)((0, $eHaBZ.useReducer)(function(c) {
        return c + 1;
    }, 1), 2), reposSubmenu = _useReducer[0], forceReposSubmenu = _useReducer[1];
    var _useContext = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$8fa45c82eddfe270)), transition = _useContext.transition, boundingBoxRef = _useContext.boundingBoxRef, boundingBoxPadding = _useContext.boundingBoxPadding, rootMenuRef = _useContext.rootMenuRef, rootAnchorRef = _useContext.rootAnchorRef, scrollNodesRef = _useContext.scrollNodesRef, reposition = _useContext.reposition, viewScroll = _useContext.viewScroll, submenuCloseDelay = _useContext.submenuCloseDelay;
    var _useContext1 = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$1c2bdfb4407fdacf)), parentSubmenuCtx = _useContext1.submenuCtx, tmp = _useContext1.reposSubmenu, reposFlag = tmp === void 0 ? repositionFlag : tmp;
    var menuRef = (0, $eHaBZ.useRef)();
    var arrowRef = (0, $eHaBZ.useRef)();
    var prevOpen = (0, $eHaBZ.useRef)(false);
    var _useItems = (0, $6e2879dc867be080$export$7bfdd97581ca93c)(menuRef), hoverItem = _useItems.hoverItem, dispatch = _useItems.dispatch, updateItems = _useItems.updateItems;
    var isOpen = (0, $26d9d16241653294$export$30c2dce1a652e248)(state);
    var openTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'open');
    var closeTransition = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'close');
    var scrollNodes = scrollNodesRef.current;
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).HOME:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).END:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).UP:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).DECREASE, hoverItem);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).DOWN:
                dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).INCREASE, hoverItem);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE:
                if (e.target && e.target.className.indexOf((0, $58c87f0a382883df$export$832250593589325a)) !== -1) e.preventDefault();
                return;
            default:
                return;
        }
        e.preventDefault();
        e.stopPropagation();
    };
    var onAnimationEnd = function() {
        if (state === 'closing') setOverflowData();
        (0, $26d9d16241653294$export$175e60bb96229ece)(endTransition);
    };
    var onPointerMove = function(e) {
        e.stopPropagation();
        submenuCtx.on(submenuCloseDelay, function() {
            dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET);
            menuRef.current.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
        });
    };
    var onPointerLeave = function(e) {
        if (e.target === e.currentTarget) submenuCtx.off();
    };
    var handlePosition = (0, $eHaBZ.useCallback)(function(noOverflowCheck) {
        var _anchorRef_current;
        var menuElt = menuRef.current;
        var containerElt = containerRef.current;
        if (!menuElt || !containerElt) return;
        var anchorRect = anchorRef ? (_anchorRef_current = anchorRef.current) === null || _anchorRef_current === void 0 ? void 0 : _anchorRef_current.getBoundingClientRect() : anchorPoint ? {
            left: anchorPoint.x,
            right: anchorPoint.x,
            top: anchorPoint.y,
            bottom: anchorPoint.y,
            width: 0,
            height: 0
        } : null;
        if (!anchorRect) return;
        if (!scrollNodes.menu) scrollNodes.menu = (boundingBoxRef ? boundingBoxRef.current : (0, $26d9d16241653294$export$7414735161c19437)(rootMenuRef.current)) || window;
        var positionHelpers = (0, $8b929ad358cfd9d4$export$62e2806a96b09d4)(containerElt, menuElt, scrollNodes.menu, boundingBoxPadding);
        var _positionMenu = (0, $b0de1945e2f0216b$export$5a6e2d3543ff3d7e)({
            arrow: arrow,
            align: align,
            direction: direction,
            gap: gap,
            shift: shift,
            position: position,
            anchorRect: anchorRect,
            arrowRef: arrowRef,
            positionHelpers: positionHelpers
        }), arrowX = _positionMenu.arrowX, arrowY = _positionMenu.arrowY, x = _positionMenu.x, y = _positionMenu.y, computedDirection = _positionMenu.computedDirection;
        var menuRect = positionHelpers.menuRect;
        var menuHeight = menuRect.height;
        if (!noOverflowCheck && overflow !== 'visible') {
            var getTopOverflow = positionHelpers.getTopOverflow, getBottomOverflow = positionHelpers.getBottomOverflow;
            var height, overflowAmt;
            var bottomOverflow = getBottomOverflow(y);
            if (bottomOverflow > 0) {
                height = menuHeight - bottomOverflow;
                overflowAmt = bottomOverflow;
            } else {
                var topOverflow = getTopOverflow(y);
                if (topOverflow < 0) {
                    height = menuHeight + topOverflow;
                    overflowAmt = 0 - topOverflow;
                    if (height >= 0) y -= topOverflow;
                }
            }
            if (height >= 0) setOverflowData({
                height: height,
                overflowAmt: overflowAmt
            });
        }
        if (arrow) setArrowPosition({
            x: arrowX,
            y: arrowY
        });
        setMenuPosition({
            x: x,
            y: y
        });
        setExpandedDirection(computedDirection);
    }, [
        arrow,
        align,
        boundingBoxPadding,
        direction,
        gap,
        shift,
        position,
        overflow,
        anchorPoint,
        anchorRef,
        containerRef,
        boundingBoxRef,
        rootMenuRef,
        scrollNodes
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (isOpen) {
            handlePosition();
            if (prevOpen.current) forceReposSubmenu();
        }
        prevOpen.current = isOpen;
    }, [
        isOpen,
        handlePosition,
        reposFlag
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (overflowData && !setDownOverflow) menuRef.current.scrollTop = 0;
    }, [
        overflowData,
        setDownOverflow
    ]);
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        return updateItems;
    }, [
        updateItems
    ]);
    (0, $eHaBZ.useEffect)(function() {
        var menuScroll = scrollNodes.menu;
        if (!isOpen || !menuScroll) return;
        menuScroll = menuScroll.addEventListener ? menuScroll : window;
        if (!scrollNodes.anchors) {
            scrollNodes.anchors = [];
            var anchorScroll = (0, $26d9d16241653294$export$7414735161c19437)(rootAnchorRef && rootAnchorRef.current);
            while(anchorScroll && anchorScroll !== menuScroll){
                scrollNodes.anchors.push(anchorScroll);
                anchorScroll = (0, $26d9d16241653294$export$7414735161c19437)(anchorScroll);
            }
        }
        var scroll = viewScroll;
        if (scrollNodes.anchors.length && scroll === 'initial') scroll = 'auto';
        if (scroll === 'initial') return;
        var handleScroll = function() {
            if (scroll === 'auto') (0, $26d9d16241653294$export$3e3e6d241f8feb60)(function() {
                return handlePosition(true);
            });
            else (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).SCROLL
            });
        };
        var scrollObservers = scrollNodes.anchors.concat(viewScroll !== 'initial' ? menuScroll : []);
        scrollObservers.forEach(function(o) {
            return o.addEventListener('scroll', handleScroll);
        });
        return function() {
            return scrollObservers.forEach(function(o) {
                return o.removeEventListener('scroll', handleScroll);
            });
        };
    }, [
        rootAnchorRef,
        scrollNodes,
        isOpen,
        onClose,
        viewScroll,
        handlePosition
    ]);
    var hasOverflow = !!overflowData && overflowData.overflowAmt > 0;
    (0, $eHaBZ.useEffect)(function() {
        if (hasOverflow || !isOpen || !parentScrollingRef) return;
        var handleScroll = function() {
            return (0, $26d9d16241653294$export$3e3e6d241f8feb60)(handlePosition);
        };
        var parentScroll = parentScrollingRef.current;
        parentScroll.addEventListener('scroll', handleScroll);
        return function() {
            return parentScroll.removeEventListener('scroll', handleScroll);
        };
    }, [
        isOpen,
        hasOverflow,
        parentScrollingRef,
        handlePosition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isOpen || typeof ResizeObserver !== 'function' || reposition === 'initial') return;
        var targetList = [];
        var resizeObserver = new ResizeObserver(function(entries) {
            return entries.forEach(function(param) {
                var target = param.target;
                if (targetList.indexOf(target) < 0) targetList.push(target);
                else if (target.offsetWidth && target.offsetHeight) (0, $bVPm2.flushSync)(function() {
                    handlePosition();
                    forceReposSubmenu();
                });
            });
        });
        var resizeObserverOptions = {
            box: 'border-box'
        };
        resizeObserver.observe(menuRef.current, resizeObserverOptions);
        var anchor = anchorRef === null || anchorRef === void 0 ? void 0 : anchorRef.current;
        anchor && resizeObserver.observe(anchor, resizeObserverOptions);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        isOpen,
        reposition,
        anchorRef,
        handlePosition
    ]);
    (0, $eHaBZ.useEffect)(function() {
        if (!isOpen) {
            dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).RESET);
            if (!closeTransition) setOverflowData();
            return;
        }
        var _ref = menuItemFocus || {}, position = _ref.position, alwaysUpdate = _ref.alwaysUpdate;
        var setItemFocus = function() {
            if (position === (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).FIRST);
            else if (position === (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).LAST) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).LAST);
            else if (position >= -1) dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET_INDEX, undefined, position);
        };
        if (alwaysUpdate) setItemFocus();
        else if (captureFocus) {
            var id = setTimeout(function() {
                var menuElt = menuRef.current;
                if (menuElt && !menuElt.contains(document.activeElement)) {
                    menuElt.focus((0, $58c87f0a382883df$export$42466afb37c6c021));
                    setItemFocus();
                }
            }, openTransition ? 170 : 100);
            return function() {
                return clearTimeout(id);
            };
        }
    }, [
        isOpen,
        openTransition,
        closeTransition,
        captureFocus,
        menuItemFocus,
        dispatch
    ]);
    var itemContext = (0, $eHaBZ.useMemo)(function() {
        return {
            isParentOpen: isOpen,
            submenuCtx: submenuCtx,
            dispatch: dispatch,
            updateItems: updateItems
        };
    }, [
        isOpen,
        submenuCtx,
        dispatch,
        updateItems
    ]);
    var maxHeight, overflowAmt;
    if (overflowData) setDownOverflow ? overflowAmt = overflowData.overflowAmt : maxHeight = overflowData.height;
    var listContext = (0, $eHaBZ.useMemo)(function() {
        return {
            reposSubmenu: reposSubmenu,
            submenuCtx: submenuCtx,
            overflow: overflow,
            overflowAmt: overflowAmt,
            parentMenuRef: menuRef,
            parentDir: expandedDirection
        };
    }, [
        reposSubmenu,
        submenuCtx,
        overflow,
        overflowAmt,
        expandedDirection
    ]);
    var overflowStyle = maxHeight >= 0 ? {
        maxHeight: maxHeight,
        overflow: overflow
    } : undefined;
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            state: state,
            align: align,
            dir: expandedDirection
        };
    }, [
        state,
        align,
        expandedDirection
    ]);
    var arrowModifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            dir: expandedDirection
        };
    }, [
        expandedDirection
    ]);
    var _arrowClassName = (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
        block: (0, $58c87f0a382883df$export$832250593589325a),
        element: (0, $58c87f0a382883df$export$3b35f0f35c840df9),
        modifiers: arrowModifiers,
        className: arrowProps.className
    });
    var menu = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", (0, $9Jpjh._)((0, $lvTkn._)({
        role: "menu",
        "aria-label": ariaLabel
    }, (0, $26d9d16241653294$export$ffb2d5922287e12)(isDisabled), (0, $26d9d16241653294$export$9d1611c77c2fe928)({
        onPointerEnter: parentSubmenuCtx === null || parentSubmenuCtx === void 0 ? void 0 : parentSubmenuCtx.off,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave,
        onKeyDown: onKeyDown,
        onAnimationEnd: onAnimationEnd
    }, restProps)), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)(externalRef, menuRef),
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$832250593589325a),
            modifiers: modifiers,
            className: menuClassName
        }),
        style: (0, $9Jpjh._)((0, $lvTkn._)({}, menuStyle, overflowStyle), {
            margin: 0,
            display: state === 'closed' ? 'none' : undefined,
            position: (0, $58c87f0a382883df$export$f8d144aafbd3a470),
            left: menuPosition.x,
            top: menuPosition.y
        }),
        children: [
            arrow && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $9Jpjh._)((0, $lvTkn._)({
                "aria-hidden": true
            }, arrowProps), {
                className: _arrowClassName,
                style: (0, $lvTkn._)({
                    display: 'block',
                    position: (0, $58c87f0a382883df$export$f8d144aafbd3a470),
                    left: arrowPosition.x,
                    top: arrowPosition.y
                }, arrowProps.style),
                ref: arrowRef
            })),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$1c2bdfb4407fdacf).Provider, {
                value: listContext,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$7cb023214e4bda1e).Provider, {
                    value: itemContext,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$15c1690330cd94e).Provider, {
                        value: hoverItem,
                        children: (0, $26d9d16241653294$export$175e60bb96229ece)(children, modifiers)
                    })
                })
            })
        ]
    }));
    return containerProps ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e4ff2b7984f354ae$export$b286f91cddfedb5a), (0, $9Jpjh._)((0, $lvTkn._)({}, containerProps), {
        isOpen: isOpen,
        children: menu
    })) : menu;
};





var $d50ef49fb283cf3d$export$a5a70f2f059d02ee = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function ControlledMenu(_param, externalRef) {
    var ariaLabel = _param['aria-label'], className = _param.className, containerProps = _param.containerProps, initialMounted = _param.initialMounted, unmountOnClose = _param.unmountOnClose, transition = _param.transition, transitionTimeout = _param.transitionTimeout, boundingBoxRef = _param.boundingBoxRef, boundingBoxPadding = _param.boundingBoxPadding, _param_reposition = _param.reposition, reposition = _param_reposition === void 0 ? 'auto' : _param_reposition, _param_submenuOpenDelay = _param.submenuOpenDelay, submenuOpenDelay = _param_submenuOpenDelay === void 0 ? 300 : _param_submenuOpenDelay, _param_submenuCloseDelay = _param.submenuCloseDelay, submenuCloseDelay = _param_submenuCloseDelay === void 0 ? 150 : _param_submenuCloseDelay, _param_viewScroll = _param.viewScroll, viewScroll = _param_viewScroll === void 0 ? 'initial' : _param_viewScroll, portal = _param.portal, theming = _param.theming, onItemClick = _param.onItemClick, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        'aria-label',
        "className",
        "containerProps",
        "initialMounted",
        "unmountOnClose",
        "transition",
        "transitionTimeout",
        "boundingBoxRef",
        "boundingBoxPadding",
        "reposition",
        "submenuOpenDelay",
        "submenuCloseDelay",
        "viewScroll",
        "portal",
        "theming",
        "onItemClick"
    ]);
    var containerRef = (0, $eHaBZ.useRef)(null);
    var scrollNodesRef = (0, $eHaBZ.useRef)({});
    var anchorRef = restProps.anchorRef, state = restProps.state, onClose = restProps.onClose;
    var settings = (0, $eHaBZ.useMemo)(function() {
        return {
            initialMounted: initialMounted,
            unmountOnClose: unmountOnClose,
            transition: transition,
            transitionTimeout: transitionTimeout,
            boundingBoxRef: boundingBoxRef,
            boundingBoxPadding: boundingBoxPadding,
            rootMenuRef: containerRef,
            rootAnchorRef: anchorRef,
            scrollNodesRef: scrollNodesRef,
            reposition: reposition,
            viewScroll: viewScroll,
            submenuOpenDelay: submenuOpenDelay,
            submenuCloseDelay: submenuCloseDelay
        };
    }, [
        initialMounted,
        unmountOnClose,
        transition,
        transitionTimeout,
        anchorRef,
        boundingBoxRef,
        boundingBoxPadding,
        reposition,
        viewScroll,
        submenuOpenDelay,
        submenuCloseDelay
    ]);
    var eventHandlers = (0, $eHaBZ.useMemo)(function() {
        return {
            handleClick: function(event, isCheckorRadio) {
                if (!event.stopPropagation) (0, $26d9d16241653294$export$175e60bb96229ece)(onItemClick, event);
                var keepOpen = event.keepOpen;
                if (keepOpen === undefined) keepOpen = isCheckorRadio && event.key === (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE;
                if (!keepOpen) (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    value: event.value,
                    key: event.key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CLICK
                });
            },
            handleClose: function(key) {
                (0, $26d9d16241653294$export$175e60bb96229ece)(onClose, {
                    key: key,
                    reason: (0, $58c87f0a382883df$export$8fd8df51a9b835e6).CLICK
                });
            }
        };
    }, [
        onItemClick,
        onClose
    ]);
    if (!state) return null;
    var menuList = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$8fa45c82eddfe270).Provider, {
        value: settings,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $58c87f0a382883df$export$ee9f2ec6c8119c2a).Provider, {
            value: eventHandlers,
            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ae383b9f4118cf3a$export$d4c4e98c5044dc8), (0, $9Jpjh._)((0, $lvTkn._)({}, restProps), {
                ariaLabel: ariaLabel || 'Menu',
                externalRef: externalRef,
                containerRef: containerRef,
                containerProps: {
                    className: className,
                    containerRef: containerRef,
                    containerProps: containerProps,
                    theming: theming,
                    transition: transition,
                    onClose: onClose
                }
            }))
        })
    });
    if (portal === true && typeof document !== 'undefined') return /*#__PURE__*/ (0, $bVPm2.createPortal)(menuList, document.body);
    else if (portal) return portal.target ? /*#__PURE__*/ (0, $bVPm2.createPortal)(menuList, portal.target) : portal.stablePosition ? null : menuList;
    return menuList;
});




var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $21h22 = parcelRequire("21h22");

var $2bfPH = parcelRequire("2bfPH");
var $b6ff00eb3954efc9$var$STATUS = [
    "preEnter",
    "entering",
    "entered",
    "preExit",
    "exiting",
    "exited",
    "unmounted"
];
var $b6ff00eb3954efc9$export$50fdfeece43146fd = function(status) {
    return {
        $: status,
        status: $b6ff00eb3954efc9$var$STATUS[status],
        isEnter: status < 3,
        isMounted: status !== 6,
        isResolved: status === 2 || status > 4
    };
};
var $b6ff00eb3954efc9$export$eb0971344425f03e = function(unmounted) {
    return unmounted ? 6 : 5;
};
var $b6ff00eb3954efc9$export$c9efa50dd559122e = function(status, unmountOnExit) {
    switch(status){
        case 1:
        case 0:
            return 2;
        case 4:
        case 3:
            return $b6ff00eb3954efc9$export$eb0971344425f03e(unmountOnExit);
    }
};
var $b6ff00eb3954efc9$export$d2e3f47e67110e3a = function(timeout) {
    return (typeof timeout === "undefined" ? "undefined" : (0, $2bfPH._)(timeout)) === "object" ? [
        timeout.enter,
        timeout.exit
    ] : [
        timeout,
        timeout
    ];
};
var $b6ff00eb3954efc9$export$bdd553fddd433dcb = function(callback, config) {
    config.r = requestAnimationFrame(function() {
        config.r = requestAnimationFrame(callback);
    });
};



var $eHaBZ = parcelRequire("eHaBZ");
//#region src/useTransitionState.ts
var $c30e7c0eaa7addef$var$updateState = function(status, setState, ref, onChange) {
    clearTimeout(ref.t);
    cancelAnimationFrame(ref.r);
    var state = (0, $b6ff00eb3954efc9$export$50fdfeece43146fd)(status);
    setState(state);
    ref.s = state;
    onChange === null || onChange === void 0 ? void 0 : onChange({
        current: state
    });
};
var $c30e7c0eaa7addef$export$d2a0a1bc267c90f6 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_enter = _ref.enter, enter = _ref_enter === void 0 ? true : _ref_enter, _ref_exit = _ref.exit, exit = _ref_exit === void 0 ? true : _ref_exit, preEnter = _ref.preEnter, preExit = _ref.preExit, timeout = _ref.timeout, initialEntered = _ref.initialEntered, mountOnEnter = _ref.mountOnEnter, unmountOnExit = _ref.unmountOnExit, onChange = _ref.onStateChange;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return (0, $b6ff00eb3954efc9$export$50fdfeece43146fd)(initialEntered ? 2 : (0, $b6ff00eb3954efc9$export$eb0971344425f03e)(mountOnEnter));
    }), 2), state = _useState[0], setState = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)({
        s: state,
        r: 0
    }), 1), ref = _useState1[0];
    var _getTimeout = (0, $21h22._)((0, $b6ff00eb3954efc9$export$d2e3f47e67110e3a)(timeout), 2), enterTimeout = _getTimeout[0], exitTimeout = _getTimeout[1];
    var endTransition = (0, $eHaBZ.useCallback)(function() {
        var status = (0, $b6ff00eb3954efc9$export$c9efa50dd559122e)(ref.s.$, unmountOnExit);
        if (status) $c30e7c0eaa7addef$var$updateState(status, setState, ref, onChange);
    }, [
        onChange,
        unmountOnExit,
        ref
    ]);
    return [
        state,
        (0, $eHaBZ.useCallback)(function(toEnter) {
            var transitState = function(status) {
                $c30e7c0eaa7addef$var$updateState(status, setState, ref, onChange);
                switch(status){
                    case 1:
                        if (enterTimeout >= 0) ref.t = setTimeout(endTransition, enterTimeout);
                        break;
                    case 4:
                        if (exitTimeout >= 0) ref.t = setTimeout(endTransition, exitTimeout);
                        break;
                    case 0:
                    case 3:
                        (0, $b6ff00eb3954efc9$export$bdd553fddd433dcb)(function() {
                            return transitState(status + 1);
                        }, ref);
                        break;
                }
            };
            var enterStage = ref.s.isEnter;
            if (typeof toEnter !== "boolean") toEnter = !enterStage;
            if (toEnter) !enterStage && transitState(enter ? preEnter ? 0 : 1 : 2);
            else enterStage && transitState(exit ? preExit ? 3 : 4 : (0, $b6ff00eb3954efc9$export$eb0971344425f03e)(unmountOnExit));
        }, [
            ref,
            endTransition,
            onChange,
            enter,
            exit,
            preEnter,
            preExit,
            enterTimeout,
            exitTimeout,
            unmountOnExit
        ]),
        endTransition
    ];
};




var $30e9b4b14afc2f63$export$8091e3849c182a6 = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, initialOpen = _ref.initialOpen, initialMounted = _ref.initialMounted, unmountOnClose = _ref.unmountOnClose, transition = _ref.transition, _ref_transitionTimeout = _ref.transitionTimeout, transitionTimeout = _ref_transitionTimeout === void 0 ? 500 : _ref_transitionTimeout, onMenuChange = _ref.onMenuChange;
    var enter = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'open');
    var exit = (0, $26d9d16241653294$export$d5639c01d489b0c)(transition, 'close');
    var _useTransitionState = (0, $21h22._)((0, $c30e7c0eaa7addef$export$d2a0a1bc267c90f6)({
        initialEntered: initialOpen,
        mountOnEnter: !initialMounted,
        unmountOnExit: unmountOnClose,
        timeout: transitionTimeout,
        enter: enter,
        exit: exit,
        onStateChange: (0, $eHaBZ.useCallback)(function(param) {
            var _param_current = param.current, isEnter = _param_current.isEnter, isResolved = _param_current.isResolved;
            if (!onMenuChange || isEnter && enter && isResolved || !isEnter && exit && isResolved) return;
            onMenuChange({
                open: isEnter
            });
        }, [
            onMenuChange,
            enter,
            exit
        ])
    }), 3), status = _useTransitionState[0].status, toggleMenu = _useTransitionState[1], endTransition = _useTransitionState[2];
    return [
        {
            state: (0, $58c87f0a382883df$export$be1d8b0328ba66b6)[status],
            endTransition: endTransition
        },
        toggleMenu
    ];
};


var $d0d1673bf8b7f4ca$export$1668883ac2d8e856 = function(options) {
    var _useMenuState = (0, $21h22._)((0, $30e9b4b14afc2f63$export$8091e3849c182a6)(options), 2), menuProps = _useMenuState[0], toggleMenu = _useMenuState[1];
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(), 2), menuItemFocus = _useState[0], setMenuItemFocus = _useState[1];
    var openMenu = function(position, alwaysUpdate) {
        setMenuItemFocus({
            position: position,
            alwaysUpdate: alwaysUpdate
        });
        toggleMenu(true);
    };
    return [
        (0, $lvTkn._)({
            menuItemFocus: menuItemFocus
        }, menuProps),
        toggleMenu,
        openMenu
    ];
};



var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");
var $8bc7c70fc0c0157f$export$98524f11226063fc = function(state, onToggle) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)({}), 1), skipOpen = _useState[0];
    return {
        onMouseDown: function() {
            skipOpen.v = state && state !== 'closed';
        },
        onClick: function(e) {
            return skipOpen.v ? skipOpen.v = false : onToggle(true, e);
        }
    };
};





var $afcad17a77b29a48$var$isLegacyReact = parseInt((0, $eHaBZ.version)) < 19;
var $afcad17a77b29a48$export$d9b273488cd8ce6f = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function Menu(_param, externalRef) {
    var ariaLabel = _param['aria-label'], _ = _param.captureFocus, _1 = _param.initialOpen, menuButton = _param.menuButton, instanceRef = _param.instanceRef, onMenuChange = _param.onMenuChange, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        'aria-label',
        "captureFocus",
        "initialOpen",
        "menuButton",
        "instanceRef",
        "onMenuChange"
    ]);
    var _useMenuStateAndFocus = (0, $21h22._)((0, $d0d1673bf8b7f4ca$export$1668883ac2d8e856)((0, $9Jpjh._)((0, $lvTkn._)({}, restProps), {
        onMenuChange: onMenuChange
    })), 3), stateProps = _useMenuStateAndFocus[0], toggleMenu = _useMenuStateAndFocus[1], openMenu = _useMenuStateAndFocus[2];
    var state = stateProps.state;
    var isOpen = (0, $26d9d16241653294$export$30c2dce1a652e248)(state);
    var buttonRef = (0, $eHaBZ.useRef)(null);
    var anchorProps = (0, $8bc7c70fc0c0157f$export$98524f11226063fc)(state, function(_, e) {
        return openMenu(!e.detail ? (0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST : undefined);
    });
    var handleClose = (0, $eHaBZ.useCallback)(function(e) {
        toggleMenu(false);
        if (e.key) buttonRef.current.focus();
    }, [
        toggleMenu
    ]);
    var onKeyDown = function(e) {
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).UP:
                openMenu((0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).LAST);
                break;
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).DOWN:
                openMenu((0, $58c87f0a382883df$export$8c6ccba1b6ce32e9).FIRST);
                break;
            default:
                return;
        }
        e.preventDefault();
    };
    var button = (0, $26d9d16241653294$export$175e60bb96229ece)(menuButton, {
        open: isOpen
    });
    if (!button || !button.type) throw new Error('Menu requires a menuButton prop.');
    var buttonProps = (0, $9Jpjh._)((0, $lvTkn._)({}, (0, $26d9d16241653294$export$9d1611c77c2fe928)((0, $lvTkn._)({
        onKeyDown: onKeyDown
    }, anchorProps), button.props)), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)($afcad17a77b29a48$var$isLegacyReact ? button.ref : button.props.ref, buttonRef)
    });
    if ((0, $26d9d16241653294$export$7d9f7e9c1c02b41e)(button.type) === 'MenuButton') buttonProps.isOpen = isOpen;
    var renderButton = /*#__PURE__*/ (0, $eHaBZ.cloneElement)(button, buttonProps);
    (0, $eHaBZ.useImperativeHandle)(instanceRef, function() {
        return {
            openMenu: openMenu,
            closeMenu: function() {
                return toggleMenu(false);
            }
        };
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $eHaBZ.Fragment), {
        children: [
            renderButton,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d50ef49fb283cf3d$export$a5a70f2f059d02ee), (0, $9Jpjh._)((0, $lvTkn._)({}, restProps, stateProps), {
                "aria-label": ariaLabel || (typeof button.props.children === 'string' ? button.props.children : 'Menu'),
                anchorRef: buttonRef,
                ref: externalRef,
                onClose: handleClose
            }))
        ]
    });
});


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $eHaBZ = parcelRequire("eHaBZ");




var $7a4ada20cb42c4ac$export$266a769812832828 = /*#__PURE__*/ (0, $26d9d16241653294$export$4c4bf90f1b4d3105)('MenuButton', /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function MenuButton(_param, ref) {
    var className = _param.className, isOpen = _param.isOpen, disabled = _param.disabled, children = _param.children, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "className",
        "isOpen",
        "disabled",
        "children"
    ]);
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            open: isOpen
        };
    }, [
        isOpen
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", (0, $9Jpjh._)((0, $lvTkn._)({
        "aria-haspopup": true,
        "aria-expanded": isOpen,
        "aria-disabled": disabled || undefined,
        type: "button",
        disabled: disabled
    }, restProps), {
        ref: ref,
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$b3d82f113f746a0),
            modifiers: modifiers,
            className: className
        }),
        children: children
    }));
}));


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $eHaBZ = parcelRequire("eHaBZ");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $eHaBZ = parcelRequire("eHaBZ");


var $aba9cdbf0183030f$export$9f154fa70a6daa25 = function(name, WrappedComponent) {
    var Component = /*#__PURE__*/ (0, $eHaBZ.memo)(WrappedComponent);
    var WithHovering = /*#__PURE__*/ (0, $eHaBZ.forwardRef)(function(props, ref) {
        var itemRef = (0, $eHaBZ.useRef)(null);
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)(Component, (0, $9Jpjh._)((0, $lvTkn._)({}, props), {
            itemRef: itemRef,
            externalRef: ref,
            isHovering: (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$15c1690330cd94e)) === itemRef.current
        }));
    });
    WithHovering.displayName = "WithHovering(".concat(name, ")");
    return WithHovering;
};



var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");

var $1a1689b7e04c7524$export$68b1d6ee802c4a06 = function(isDisabled, itemRef, updateItems) {
    (0, $af284c5d86eb6f52$export$e5c5a5f917a5871c)(function() {
        if (isDisabled) return;
        var item = itemRef.current;
        updateItems(item, true);
        return function() {
            updateItems(item);
        };
    }, [
        isDisabled,
        itemRef,
        updateItems
    ]);
};



var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");
var $a2c76f66dfdb0454$export$77d6bee280bb6d2 = function(isHovering) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), mouseOver = _useState[0], setMouseOver = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        !isHovering && setMouseOver(false);
    }, [
        isHovering
    ]);
    return [
        mouseOver,
        function() {
            return !mouseOver && setMouseOver(true);
        },
        function() {
            return setMouseOver(false);
        }
    ];
};



var $973c1de5fd19589d$export$c75b31607cdc621e = function(itemRef, focusRef, isHovering, isDisabled) {
    var _useMouseOver = (0, $21h22._)((0, $a2c76f66dfdb0454$export$77d6bee280bb6d2)(isHovering), 3), mouseOver = _useMouseOver[0], mouseOverStart = _useMouseOver[1], mouseOverEnd = _useMouseOver[2];
    var submenuCloseDelay = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$8fa45c82eddfe270)).submenuCloseDelay;
    var _useContext = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$7cb023214e4bda1e)), isParentOpen = _useContext.isParentOpen, submenuCtx = _useContext.submenuCtx, dispatch = _useContext.dispatch, updateItems = _useContext.updateItems;
    var setHover = function() {
        !isHovering && !isDisabled && dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).SET, itemRef.current);
    };
    var unsetHover = function() {
        !isDisabled && dispatch((0, $58c87f0a382883df$export$6db955af9e6f8fcd).UNSET, itemRef.current);
    };
    var onBlur = function(e) {
        if (isHovering && !e.currentTarget.contains(e.relatedTarget)) unsetHover();
    };
    var onPointerMove = function(e) {
        if (!isDisabled) {
            e.stopPropagation();
            mouseOverStart();
            submenuCtx.on(submenuCloseDelay, setHover, setHover);
        }
    };
    var onPointerLeave = function(_, keepHover) {
        mouseOverEnd();
        submenuCtx.off();
        !keepHover && unsetHover();
    };
    (0, $1a1689b7e04c7524$export$68b1d6ee802c4a06)(isDisabled, itemRef, updateItems);
    (0, $eHaBZ.useEffect)(function() {
        if (isHovering && isParentOpen) focusRef.current && focusRef.current.focus();
    }, [
        focusRef,
        isHovering,
        isParentOpen
    ]);
    return {
        mouseOver: mouseOver,
        setHover: setHover,
        onBlur: onBlur,
        onPointerMove: onPointerMove,
        onPointerLeave: onPointerLeave
    };
};






var $196651884997e353$export$2ce376c2cc3355c8 = /*#__PURE__*/ (0, $aba9cdbf0183030f$export$9f154fa70a6daa25)('MenuItem', function MenuItem(_param) {
    var className = _param.className, value = _param.value, href = _param.href, type = _param.type, checked = _param.checked, disabled = _param.disabled, children = _param.children, onClick = _param.onClick, isHovering = _param.isHovering, itemRef = _param.itemRef, externalRef = _param.externalRef, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "className",
        "value",
        "href",
        "type",
        "checked",
        "disabled",
        "children",
        "onClick",
        "isHovering",
        "itemRef",
        "externalRef"
    ]);
    var isDisabled = !!disabled;
    var _useItemState = (0, $973c1de5fd19589d$export$c75b31607cdc621e)(itemRef, itemRef, isHovering, isDisabled), mouseOver = _useItemState.mouseOver, setHover = _useItemState.setHover, restStateProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_useItemState, [
        "mouseOver",
        "setHover"
    ]);
    var eventHandlers = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$ee9f2ec6c8119c2a));
    var radioGroup = (0, $eHaBZ.useContext)((0, $58c87f0a382883df$export$a79eda4ff50e30b6));
    var isRadio = type === 'radio';
    var isCheckBox = type === 'checkbox';
    var isAnchor = !!href && !isDisabled && !isRadio && !isCheckBox;
    var isChecked = isRadio ? radioGroup.value === value : isCheckBox ? !!checked : false;
    var handleClick = function(e) {
        if (isDisabled) {
            e.stopPropagation();
            e.preventDefault();
            return;
        }
        var event = {
            value: value,
            syntheticEvent: e
        };
        if (e.key !== undefined) event.key = e.key;
        if (isCheckBox) event.checked = !isChecked;
        if (isRadio) event.name = radioGroup.name;
        (0, $26d9d16241653294$export$175e60bb96229ece)(onClick, event);
        if (isRadio) (0, $26d9d16241653294$export$175e60bb96229ece)(radioGroup.onRadioChange, event);
        eventHandlers.handleClick(event, isCheckBox || isRadio);
    };
    var handleKeyDown = function(e) {
        if (!isHovering) return;
        switch(e.key){
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).ENTER:
                e.preventDefault();
            case (0, $58c87f0a382883df$export$4b0075e5ea5e1f26).SPACE:
                isAnchor ? itemRef.current.click() : handleClick(e);
        }
    };
    var modifiers = (0, $eHaBZ.useMemo)(function() {
        return {
            type: type,
            disabled: isDisabled,
            hover: mouseOver || isHovering,
            checked: isChecked,
            anchor: isAnchor
        };
    }, [
        type,
        isDisabled,
        mouseOver,
        isHovering,
        isChecked,
        isAnchor
    ]);
    var mergedProps = (0, $26d9d16241653294$export$9d1611c77c2fe928)((0, $9Jpjh._)((0, $lvTkn._)({}, restStateProps), {
        onPointerDown: setHover,
        onKeyDown: handleKeyDown,
        onClick: handleClick
    }), restProps);
    var menuItemProps = (0, $9Jpjh._)((0, $lvTkn._)({
        role: isRadio ? 'menuitemradio' : isCheckBox ? 'menuitemcheckbox' : (0, $58c87f0a382883df$export$3e982710469daaf),
        'aria-checked': isRadio || isCheckBox ? isChecked : undefined
    }, (0, $26d9d16241653294$export$ffb2d5922287e12)(isDisabled, isHovering), mergedProps), {
        ref: (0, $f957e19c95cd0d58$export$2d8be4568b07be94)(externalRef, itemRef),
        className: (0, $f6b66376b7c99589$export$7ae630fe844fbd1f)({
            block: (0, $58c87f0a382883df$export$832250593589325a),
            element: (0, $58c87f0a382883df$export$b5a3c9a9995a8c24),
            modifiers: modifiers,
            className: className
        }),
        children: (0, $eHaBZ.useMemo)(function() {
            return (0, $26d9d16241653294$export$175e60bb96229ece)(children, modifiers);
        }, [
            children,
            modifiers
        ])
    });
    return isAnchor ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        role: (0, $58c87f0a382883df$export$a5a9d7469a9cc520),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", (0, $lvTkn._)({
            href: href
        }, menuItemProps))
    }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", (0, $lvTkn._)({}, menuItemProps));
});



/**
 * @callback completeCallback
 */ /**
 * @typedef {Object} Options
 * @property {number} [duration]
 * @property {string} [easing]
 * @property {completeCallback} [complete]
 */ /**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$fadeComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.opacity) element.style.opacity = properties.opacity;
    else element.style.removeProperty('opacity');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$82e6205b15e6c637(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 0;
    element.style.removeProperty('display');
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 1;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$c091916f1530334c(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        opacity: element.style.opacity || undefined
    };
    // styles necessary for the animation
    if (!element.style.opacity) element.style.opacity = 1;
    element.style.transition = "opacity ".concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        element.style.opacity = 0;
    });
    setTimeout(function() {
        element.style.display = 'none';
        $7ef98d8c594793a5$var$fadeComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$75d3d2c72ecccf9b(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$82e6205b15e6c637(element, options);
    else $7ef98d8c594793a5$export$c091916f1530334c(element, options);
}
/**
 * @param {Options} options
 * @return {Options}
 */ function $7ef98d8c594793a5$var$getOptions(options) {
    return {
        duration: options.duration || 400,
        easing: options.easing || "ease-out",
        complete: options.complete || undefined
    };
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$fe8985bb6374093c(element) {
    element.style.display = 'none';
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$57bf213be019eeb0(element) {
    element.style.removeProperty('display');
}
/**
 * @param {Element} element
 * @param {Object.<string, string>} properties
 * @param {completeCallback} complete
 */ function $7ef98d8c594793a5$var$slideComplete(element, properties, complete) {
    if (properties.transition) element.style.transition = properties.transition;
    else element.style.removeProperty('transition');
    if (properties.overflowY) element.style.overflowY = properties.overflowY;
    else element.style.removeProperty('overflow-y');
    if (properties.marginTop) element.style.marginTop = properties.marginTop;
    else element.style.removeProperty('margin-top');
    if (properties.marginBottom) element.style.marginBottom = properties.marginBottom;
    else element.style.removeProperty('margin-bottom');
    if (properties.paddingTop) element.style.paddingTop = properties.paddingTop;
    else element.style.removeProperty('padding-top');
    if (properties.paddingBottom) element.style.paddingBottom = properties.paddingBottom;
    else element.style.removeProperty('padding-bottom');
    if (properties.height) element.style.height = properties.height;
    else element.style.removeProperty('height');
    if (complete) complete();
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$abdd11a06a163232(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    if (!element.style.height) element.style.height = '0px';
    element.style.marginTop = '0px';
    element.style.marginBottom = '0px';
    element.style.paddingTop = '0px';
    element.style.paddingBottom = '0px';
    element.style.overflowY = 'hidden';
    element.style.removeProperty('display');
    element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
    requestAnimationFrame(function() {
        var height = element.scrollHeight;
        if (cs.getPropertyValue("box-sizing") == "border-box") height += parseFloat(paddingTop) + parseFloat(paddingBottom);
        element.style.height = "".concat(height, "px");
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
    });
    setTimeout(function() {
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$715de50cedc228a8(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$abdd11a06a163232(element, options);
    else $7ef98d8c594793a5$export$deed561b1a0ff1ea(element, options);
}
/**
 * @param {Element} element
 * @param {Options} [options]
 */ function $7ef98d8c594793a5$export$deed561b1a0ff1ea(element) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var o = $7ef98d8c594793a5$var$getOptions(options);
    var properties = {
        transition: element.style.transition || undefined,
        overflowY: element.style.overflowY || undefined,
        marginTop: element.style.marginTop || undefined,
        marginBottom: element.style.marginBottom || undefined,
        paddingTop: element.style.paddingTop || undefined,
        paddingBottom: element.style.paddingBottom || undefined,
        heigth: element.style.height || undefined
    };
    var cs = window.getComputedStyle(element);
    var marginTop = cs.getPropertyValue("margin-top");
    var marginBottom = cs.getPropertyValue("margin-bottom");
    var paddingTop = cs.getPropertyValue("padding-top");
    var paddingBottom = cs.getPropertyValue("padding-bottom");
    // styles necessary for the animation
    requestAnimationFrame(function() {
        if (!element.style.height) {
            var height = element.scrollHeight;
            if (cs.getPropertyValue("box-sizing") == "content-box") height -= parseFloat(paddingTop) + parseFloat(paddingBottom);
            element.style.height = "".concat(height, "px");
        }
        element.style.marginTop = marginTop;
        element.style.marginBottom = marginBottom;
        element.style.paddingTop = paddingTop;
        element.style.paddingBottom = paddingBottom;
        element.style.overflowY = 'hidden';
        element.style.transition = "height ".concat(o.duration / 1000, "s ").concat(o.easing, ", margin ").concat(o.duration / 1000, "s ").concat(o.easing, ", padding ").concat(o.duration / 1000, "s ").concat(o.easing);
        requestAnimationFrame(function() {
            element.style.height = '0px';
            element.style.marginTop = '0px';
            element.style.marginBottom = '0px';
            element.style.paddingTop = '0px';
            element.style.paddingBottom = '0px';
        });
    });
    setTimeout(function() {
        element.style.display = 'none';
        $7ef98d8c594793a5$var$slideComplete(element, properties, o.complete);
    }, o.duration);
}
/**
 * @param {Element} element
 */ function $7ef98d8c594793a5$export$e03c1c3201ee8bb7(element) {
    var display = element.style.display || undefined;
    if (display == 'none') $7ef98d8c594793a5$export$57bf213be019eeb0(element);
    else $7ef98d8c594793a5$export$fe8985bb6374093c(element);
}



/**
 * Copyright (C) 2017-present by Andrea Giammarchi - @WebReflection
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */ var $4c0cf5d996e33977$var$replace = ''.replace;
// escape
var $4c0cf5d996e33977$var$es = /&(?:amp|#38|lt|#60|gt|#62|apos|#39|quot|#34);/g;
var $4c0cf5d996e33977$var$ca = /[&<>'"]/g;
var $4c0cf5d996e33977$var$esca = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    "'": '&#39;',
    '"': '&quot;'
};
var $4c0cf5d996e33977$var$pe = function(m) {
    return $4c0cf5d996e33977$var$esca[m];
};
var $4c0cf5d996e33977$export$4e7f196112fea3c5 = function(es) {
    return $4c0cf5d996e33977$var$replace.call(es, $4c0cf5d996e33977$var$ca, $4c0cf5d996e33977$var$pe);
};
// unescape
var $4c0cf5d996e33977$var$unes = {
    '&amp;': '&',
    '&#38;': '&',
    '&lt;': '<',
    '&#60;': '<',
    '&gt;': '>',
    '&#62;': '>',
    '&apos;': "'",
    '&#39;': "'",
    '&quot;': '"',
    '&#34;': '"'
};
var $4c0cf5d996e33977$var$cape = function(m) {
    return $4c0cf5d996e33977$var$unes[m];
};
var $4c0cf5d996e33977$export$e8bacd2802a88316 = function(un) {
    return $4c0cf5d996e33977$var$replace.call(un, $4c0cf5d996e33977$var$es, $4c0cf5d996e33977$var$cape);
};



/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */ var $3a0ba9181dd26b01$var$isArray = Array.isArray;
var $3a0ba9181dd26b01$export$2e2bcd8739ae039 = $3a0ba9181dd26b01$var$isArray;



var $2bfPH = parcelRequire("2bfPH");


var $2bfPH = parcelRequire("2bfPH");

var $2bfPH = parcelRequire("2bfPH");
/** Detect free variable `global` from Node.js. */ 
var $2bfPH = parcelRequire("2bfPH");
var $0f93244b35cdbbe6$var$freeGlobal = (typeof $parcel$global === "undefined" ? "undefined" : (0, $2bfPH._)($parcel$global)) == 'object' && $parcel$global && $parcel$global.Object === Object && $parcel$global;
var $0f93244b35cdbbe6$export$2e2bcd8739ae039 = $0f93244b35cdbbe6$var$freeGlobal;


/** Detect free variable `self`. */ var $1fae29a71cc2d4a9$var$freeSelf = (typeof self === "undefined" ? "undefined" : (0, $2bfPH._)(self)) == 'object' && self && self.Object === Object && self;
/** Used as a reference to the global object. */ var $1fae29a71cc2d4a9$var$root = (0, $0f93244b35cdbbe6$export$2e2bcd8739ae039) || $1fae29a71cc2d4a9$var$freeSelf || Function('return this')();
var $1fae29a71cc2d4a9$export$2e2bcd8739ae039 = $1fae29a71cc2d4a9$var$root;


/** Built-in value references. */ var $de766450d8859b45$var$Symbol = (0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039).Symbol;
var $de766450d8859b45$export$2e2bcd8739ae039 = $de766450d8859b45$var$Symbol;



/** Used for built-in method references. */ var $bba9ae3e89cf7880$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $bba9ae3e89cf7880$var$hasOwnProperty = $bba9ae3e89cf7880$var$objectProto.hasOwnProperty;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $bba9ae3e89cf7880$var$nativeObjectToString = $bba9ae3e89cf7880$var$objectProto.toString;
/** Built-in value references. */ var $bba9ae3e89cf7880$var$symToStringTag = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */ function $bba9ae3e89cf7880$var$getRawTag(value) {
    var isOwn = $bba9ae3e89cf7880$var$hasOwnProperty.call(value, $bba9ae3e89cf7880$var$symToStringTag), tag = value[$bba9ae3e89cf7880$var$symToStringTag];
    try {
        value[$bba9ae3e89cf7880$var$symToStringTag] = undefined;
        var unmasked = true;
    } catch (e) {}
    var result = $bba9ae3e89cf7880$var$nativeObjectToString.call(value);
    if (unmasked) {
        if (isOwn) value[$bba9ae3e89cf7880$var$symToStringTag] = tag;
        else delete value[$bba9ae3e89cf7880$var$symToStringTag];
    }
    return result;
}
var $bba9ae3e89cf7880$export$2e2bcd8739ae039 = $bba9ae3e89cf7880$var$getRawTag;


/** Used for built-in method references. */ var $18b8dc93d673f987$var$objectProto = Object.prototype;
/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */ var $18b8dc93d673f987$var$nativeObjectToString = $18b8dc93d673f987$var$objectProto.toString;
/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */ function $18b8dc93d673f987$var$objectToString(value) {
    return $18b8dc93d673f987$var$nativeObjectToString.call(value);
}
var $18b8dc93d673f987$export$2e2bcd8739ae039 = $18b8dc93d673f987$var$objectToString;


/** `Object#toString` result references. */ var $327986fe46142e6d$var$nullTag = '[object Null]', $327986fe46142e6d$var$undefinedTag = '[object Undefined]';
/** Built-in value references. */ var $327986fe46142e6d$var$symToStringTag = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).toStringTag : undefined;
/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */ function $327986fe46142e6d$var$baseGetTag(value) {
    if (value == null) return value === undefined ? $327986fe46142e6d$var$undefinedTag : $327986fe46142e6d$var$nullTag;
    return $327986fe46142e6d$var$symToStringTag && $327986fe46142e6d$var$symToStringTag in Object(value) ? (0, $bba9ae3e89cf7880$export$2e2bcd8739ae039)(value) : (0, $18b8dc93d673f987$export$2e2bcd8739ae039)(value);
}
var $327986fe46142e6d$export$2e2bcd8739ae039 = $327986fe46142e6d$var$baseGetTag;


/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $d918f235875ebac8$var$isObjectLike(value) {
    return value != null && (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'object';
}
var $d918f235875ebac8$export$2e2bcd8739ae039 = $d918f235875ebac8$var$isObjectLike;


/** `Object#toString` result references. */ var $d08c66e304cbe5be$var$symbolTag = '[object Symbol]';
/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */ function $d08c66e304cbe5be$var$isSymbol(value) {
    return (typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value)) == 'symbol' || (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value) == $d08c66e304cbe5be$var$symbolTag;
}
var $d08c66e304cbe5be$export$2e2bcd8739ae039 = $d08c66e304cbe5be$var$isSymbol;


/** Used to match property names within property paths. */ var $692761996cdc4c09$var$reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/, $692761996cdc4c09$var$reIsPlainProp = /^\w*$/;
/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */ function $692761996cdc4c09$var$isKey(value, object) {
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) return false;
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || (0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return true;
    return $692761996cdc4c09$var$reIsPlainProp.test(value) || !$692761996cdc4c09$var$reIsDeepProp.test(value) || object != null && value in Object(object);
}
var $692761996cdc4c09$export$2e2bcd8739ae039 = $692761996cdc4c09$var$isKey;



/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $1d53ac6aee0c3479$var$isObject(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return value != null && (type == 'object' || type == 'function');
}
var $1d53ac6aee0c3479$export$2e2bcd8739ae039 = $1d53ac6aee0c3479$var$isObject;


/** `Object#toString` result references. */ var $b469d2f28a46ee34$var$asyncTag = '[object AsyncFunction]', $b469d2f28a46ee34$var$funcTag = '[object Function]', $b469d2f28a46ee34$var$genTag = '[object GeneratorFunction]', $b469d2f28a46ee34$var$proxyTag = '[object Proxy]';
/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */ function $b469d2f28a46ee34$var$isFunction(value) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(value)) return false;
    // The use of `Object#toString` avoids issues with the `typeof` operator
    // in Safari 9 which returns 'object' for typed arrays and other constructors.
    var tag = (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value);
    return tag == $b469d2f28a46ee34$var$funcTag || tag == $b469d2f28a46ee34$var$genTag || tag == $b469d2f28a46ee34$var$asyncTag || tag == $b469d2f28a46ee34$var$proxyTag;
}
var $b469d2f28a46ee34$export$2e2bcd8739ae039 = $b469d2f28a46ee34$var$isFunction;



/** Used to detect overreaching core-js shims. */ var $25ddc5fd1bf81599$var$coreJsData = (0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039)['__core-js_shared__'];
var $25ddc5fd1bf81599$export$2e2bcd8739ae039 = $25ddc5fd1bf81599$var$coreJsData;


/** Used to detect methods masquerading as native. */ var $6195b02856eb6bbc$var$maskSrcKey = function() {
    var uid = /[^.]+$/.exec((0, $25ddc5fd1bf81599$export$2e2bcd8739ae039) && (0, $25ddc5fd1bf81599$export$2e2bcd8739ae039).keys && (0, $25ddc5fd1bf81599$export$2e2bcd8739ae039).keys.IE_PROTO || '');
    return uid ? 'Symbol(src)_1.' + uid : '';
}();
/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */ function $6195b02856eb6bbc$var$isMasked(func) {
    return !!$6195b02856eb6bbc$var$maskSrcKey && $6195b02856eb6bbc$var$maskSrcKey in func;
}
var $6195b02856eb6bbc$export$2e2bcd8739ae039 = $6195b02856eb6bbc$var$isMasked;



/** Used for built-in method references. */ var $eb61e83a6934f7ee$var$funcProto = Function.prototype;
/** Used to resolve the decompiled source of functions. */ var $eb61e83a6934f7ee$var$funcToString = $eb61e83a6934f7ee$var$funcProto.toString;
/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */ function $eb61e83a6934f7ee$var$toSource(func) {
    if (func != null) {
        try {
            return $eb61e83a6934f7ee$var$funcToString.call(func);
        } catch (e) {}
        try {
            return func + '';
        } catch (e) {}
    }
    return '';
}
var $eb61e83a6934f7ee$export$2e2bcd8739ae039 = $eb61e83a6934f7ee$var$toSource;


/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */ var $768375469bcf40b6$var$reRegExpChar = /[\\^$.*+?()[\]{}|]/g;
/** Used to detect host constructors (Safari). */ var $768375469bcf40b6$var$reIsHostCtor = /^\[object .+?Constructor\]$/;
/** Used for built-in method references. */ var $768375469bcf40b6$var$funcProto = Function.prototype, $768375469bcf40b6$var$objectProto = Object.prototype;
/** Used to resolve the decompiled source of functions. */ var $768375469bcf40b6$var$funcToString = $768375469bcf40b6$var$funcProto.toString;
/** Used to check objects for own properties. */ var $768375469bcf40b6$var$hasOwnProperty = $768375469bcf40b6$var$objectProto.hasOwnProperty;
/** Used to detect if a method is native. */ var $768375469bcf40b6$var$reIsNative = RegExp('^' + $768375469bcf40b6$var$funcToString.call($768375469bcf40b6$var$hasOwnProperty).replace($768375469bcf40b6$var$reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');
/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */ function $768375469bcf40b6$var$baseIsNative(value) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(value) || (0, $6195b02856eb6bbc$export$2e2bcd8739ae039)(value)) return false;
    var pattern = (0, $b469d2f28a46ee34$export$2e2bcd8739ae039)(value) ? $768375469bcf40b6$var$reIsNative : $768375469bcf40b6$var$reIsHostCtor;
    return pattern.test((0, $eb61e83a6934f7ee$export$2e2bcd8739ae039)(value));
}
var $768375469bcf40b6$export$2e2bcd8739ae039 = $768375469bcf40b6$var$baseIsNative;


/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */ function $6cc89eccfb443b42$var$getValue(object, key) {
    return object == null ? undefined : object[key];
}
var $6cc89eccfb443b42$export$2e2bcd8739ae039 = $6cc89eccfb443b42$var$getValue;


/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */ function $59eaa6cbec0d3fc3$var$getNative(object, key) {
    var value = (0, $6cc89eccfb443b42$export$2e2bcd8739ae039)(object, key);
    return (0, $768375469bcf40b6$export$2e2bcd8739ae039)(value) ? value : undefined;
}
var $59eaa6cbec0d3fc3$export$2e2bcd8739ae039 = $59eaa6cbec0d3fc3$var$getNative;


/* Built-in method references that are verified to be native. */ var $dd3b8033df9987aa$var$nativeCreate = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)(Object, 'create');
var $dd3b8033df9987aa$export$2e2bcd8739ae039 = $dd3b8033df9987aa$var$nativeCreate;


/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */ function $00ac8f260e855625$var$hashClear() {
    this.__data__ = (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) ? (0, $dd3b8033df9987aa$export$2e2bcd8739ae039)(null) : {};
    this.size = 0;
}
var $00ac8f260e855625$export$2e2bcd8739ae039 = $00ac8f260e855625$var$hashClear;


/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $56d393fbe9a45007$var$hashDelete(key) {
    var result = this.has(key) && delete this.__data__[key];
    this.size -= result ? 1 : 0;
    return result;
}
var $56d393fbe9a45007$export$2e2bcd8739ae039 = $56d393fbe9a45007$var$hashDelete;



/** Used to stand-in for `undefined` hash values. */ var $4385544e1f1ed34e$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/** Used for built-in method references. */ var $4385544e1f1ed34e$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $4385544e1f1ed34e$var$hasOwnProperty = $4385544e1f1ed34e$var$objectProto.hasOwnProperty;
/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $4385544e1f1ed34e$var$hashGet(key) {
    var data = this.__data__;
    if (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) {
        var result = data[key];
        return result === $4385544e1f1ed34e$var$HASH_UNDEFINED ? undefined : result;
    }
    return $4385544e1f1ed34e$var$hasOwnProperty.call(data, key) ? data[key] : undefined;
}
var $4385544e1f1ed34e$export$2e2bcd8739ae039 = $4385544e1f1ed34e$var$hashGet;



/** Used for built-in method references. */ var $e312d2d13c617aa4$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $e312d2d13c617aa4$var$hasOwnProperty = $e312d2d13c617aa4$var$objectProto.hasOwnProperty;
/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $e312d2d13c617aa4$var$hashHas(key) {
    var data = this.__data__;
    return (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) ? data[key] !== undefined : $e312d2d13c617aa4$var$hasOwnProperty.call(data, key);
}
var $e312d2d13c617aa4$export$2e2bcd8739ae039 = $e312d2d13c617aa4$var$hashHas;



/** Used to stand-in for `undefined` hash values. */ var $16bd1337d2ecc79c$var$HASH_UNDEFINED = '__lodash_hash_undefined__';
/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */ function $16bd1337d2ecc79c$var$hashSet(key, value) {
    var data = this.__data__;
    this.size += this.has(key) ? 0 : 1;
    data[key] = (0, $dd3b8033df9987aa$export$2e2bcd8739ae039) && value === undefined ? $16bd1337d2ecc79c$var$HASH_UNDEFINED : value;
    return this;
}
var $16bd1337d2ecc79c$export$2e2bcd8739ae039 = $16bd1337d2ecc79c$var$hashSet;


/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $af8d3fa22e27a279$var$Hash(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `Hash`.
$af8d3fa22e27a279$var$Hash.prototype.clear = (0, $00ac8f260e855625$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype['delete'] = (0, $56d393fbe9a45007$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.get = (0, $4385544e1f1ed34e$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.has = (0, $e312d2d13c617aa4$export$2e2bcd8739ae039);
$af8d3fa22e27a279$var$Hash.prototype.set = (0, $16bd1337d2ecc79c$export$2e2bcd8739ae039);
var $af8d3fa22e27a279$export$2e2bcd8739ae039 = $af8d3fa22e27a279$var$Hash;


/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */ function $170523c0b5de32c0$var$listCacheClear() {
    this.__data__ = [];
    this.size = 0;
}
var $170523c0b5de32c0$export$2e2bcd8739ae039 = $170523c0b5de32c0$var$listCacheClear;


/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */ function $816c5a4323d3d01d$var$eq(value, other) {
    return value === other || value !== value && other !== other;
}
var $816c5a4323d3d01d$export$2e2bcd8739ae039 = $816c5a4323d3d01d$var$eq;


/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */ function $2bdb4002f43f913b$var$assocIndexOf(array, key) {
    var length = array.length;
    while(length--){
        if ((0, $816c5a4323d3d01d$export$2e2bcd8739ae039)(array[length][0], key)) return length;
    }
    return -1;
}
var $2bdb4002f43f913b$export$2e2bcd8739ae039 = $2bdb4002f43f913b$var$assocIndexOf;


/** Used for built-in method references. */ var $ddd93fccea1551bf$var$arrayProto = Array.prototype;
/** Built-in value references. */ var $ddd93fccea1551bf$var$splice = $ddd93fccea1551bf$var$arrayProto.splice;
/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $ddd93fccea1551bf$var$listCacheDelete(key) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    if (index < 0) return false;
    var lastIndex = data.length - 1;
    if (index == lastIndex) data.pop();
    else $ddd93fccea1551bf$var$splice.call(data, index, 1);
    --this.size;
    return true;
}
var $ddd93fccea1551bf$export$2e2bcd8739ae039 = $ddd93fccea1551bf$var$listCacheDelete;



/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $69389e2fb23bebb5$var$listCacheGet(key) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    return index < 0 ? undefined : data[index][1];
}
var $69389e2fb23bebb5$export$2e2bcd8739ae039 = $69389e2fb23bebb5$var$listCacheGet;



/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $7b248c4c05d82799$var$listCacheHas(key) {
    return (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(this.__data__, key) > -1;
}
var $7b248c4c05d82799$export$2e2bcd8739ae039 = $7b248c4c05d82799$var$listCacheHas;



/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */ function $44855652e533aee1$var$listCacheSet(key, value) {
    var data = this.__data__, index = (0, $2bdb4002f43f913b$export$2e2bcd8739ae039)(data, key);
    if (index < 0) {
        ++this.size;
        data.push([
            key,
            value
        ]);
    } else data[index][1] = value;
    return this;
}
var $44855652e533aee1$export$2e2bcd8739ae039 = $44855652e533aee1$var$listCacheSet;


/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a7f8cba9ad3b5764$var$ListCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `ListCache`.
$a7f8cba9ad3b5764$var$ListCache.prototype.clear = (0, $170523c0b5de32c0$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype['delete'] = (0, $ddd93fccea1551bf$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.get = (0, $69389e2fb23bebb5$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.has = (0, $7b248c4c05d82799$export$2e2bcd8739ae039);
$a7f8cba9ad3b5764$var$ListCache.prototype.set = (0, $44855652e533aee1$export$2e2bcd8739ae039);
var $a7f8cba9ad3b5764$export$2e2bcd8739ae039 = $a7f8cba9ad3b5764$var$ListCache;




/* Built-in method references that are verified to be native. */ var $b5fa763546003260$var$Map = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)((0, $1fae29a71cc2d4a9$export$2e2bcd8739ae039), 'Map');
var $b5fa763546003260$export$2e2bcd8739ae039 = $b5fa763546003260$var$Map;


/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */ function $b4b8146b8ee5b362$var$mapCacheClear() {
    this.size = 0;
    this.__data__ = {
        'hash': new (0, $af8d3fa22e27a279$export$2e2bcd8739ae039),
        'map': new ((0, $b5fa763546003260$export$2e2bcd8739ae039) || (0, $a7f8cba9ad3b5764$export$2e2bcd8739ae039)),
        'string': new (0, $af8d3fa22e27a279$export$2e2bcd8739ae039)
    };
}
var $b4b8146b8ee5b362$export$2e2bcd8739ae039 = $b4b8146b8ee5b362$var$mapCacheClear;


/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */ 
var $2bfPH = parcelRequire("2bfPH");
function $bfbbc72f6631c665$var$isKeyable(value) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
}
var $bfbbc72f6631c665$export$2e2bcd8739ae039 = $bfbbc72f6631c665$var$isKeyable;


/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */ function $9ac8f027c9b6dd2b$var$getMapData(map, key) {
    var data = map.__data__;
    return (0, $bfbbc72f6631c665$export$2e2bcd8739ae039)(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
}
var $9ac8f027c9b6dd2b$export$2e2bcd8739ae039 = $9ac8f027c9b6dd2b$var$getMapData;


/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */ function $f7f65e35c34ca3cf$var$mapCacheDelete(key) {
    var result = (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key)['delete'](key);
    this.size -= result ? 1 : 0;
    return result;
}
var $f7f65e35c34ca3cf$export$2e2bcd8739ae039 = $f7f65e35c34ca3cf$var$mapCacheDelete;



/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */ function $f24c706a451a4356$var$mapCacheGet(key) {
    return (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key).get(key);
}
var $f24c706a451a4356$export$2e2bcd8739ae039 = $f24c706a451a4356$var$mapCacheGet;



/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */ function $c7f44b8791ffdc9b$var$mapCacheHas(key) {
    return (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key).has(key);
}
var $c7f44b8791ffdc9b$export$2e2bcd8739ae039 = $c7f44b8791ffdc9b$var$mapCacheHas;



/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */ function $2f513f45f8c0366f$var$mapCacheSet(key, value) {
    var data = (0, $9ac8f027c9b6dd2b$export$2e2bcd8739ae039)(this, key), size = data.size;
    data.set(key, value);
    this.size += data.size == size ? 0 : 1;
    return this;
}
var $2f513f45f8c0366f$export$2e2bcd8739ae039 = $2f513f45f8c0366f$var$mapCacheSet;


/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */ function $a2a8638ae47ec5ba$var$MapCache(entries) {
    var index = -1, length = entries == null ? 0 : entries.length;
    this.clear();
    while(++index < length){
        var entry = entries[index];
        this.set(entry[0], entry[1]);
    }
}
// Add methods to `MapCache`.
$a2a8638ae47ec5ba$var$MapCache.prototype.clear = (0, $b4b8146b8ee5b362$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype['delete'] = (0, $f7f65e35c34ca3cf$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.get = (0, $f24c706a451a4356$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.has = (0, $c7f44b8791ffdc9b$export$2e2bcd8739ae039);
$a2a8638ae47ec5ba$var$MapCache.prototype.set = (0, $2f513f45f8c0366f$export$2e2bcd8739ae039);
var $a2a8638ae47ec5ba$export$2e2bcd8739ae039 = $a2a8638ae47ec5ba$var$MapCache;


/** Error message constants. */ var $5948d35389e2ef10$var$FUNC_ERROR_TEXT = 'Expected a function';
/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */ function $5948d35389e2ef10$var$memoize(func, resolver) {
    if (typeof func != 'function' || resolver != null && typeof resolver != 'function') throw new TypeError($5948d35389e2ef10$var$FUNC_ERROR_TEXT);
    var memoized = function memoized1() {
        var args = arguments, key = resolver ? resolver.apply(this, args) : args[0], cache = memoized.cache;
        if (cache.has(key)) return cache.get(key);
        var result = func.apply(this, args);
        memoized.cache = cache.set(key, result) || cache;
        return result;
    };
    memoized.cache = new ($5948d35389e2ef10$var$memoize.Cache || (0, $a2a8638ae47ec5ba$export$2e2bcd8739ae039));
    return memoized;
}
// Expose `MapCache`.
$5948d35389e2ef10$var$memoize.Cache = (0, $a2a8638ae47ec5ba$export$2e2bcd8739ae039);
var $5948d35389e2ef10$export$2e2bcd8739ae039 = $5948d35389e2ef10$var$memoize;


/** Used as the maximum memoize cache size. */ var $19f3dce5adf9ec90$var$MAX_MEMOIZE_SIZE = 500;
/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */ function $19f3dce5adf9ec90$var$memoizeCapped(func) {
    var result = (0, $5948d35389e2ef10$export$2e2bcd8739ae039)(func, function(key) {
        if (cache.size === $19f3dce5adf9ec90$var$MAX_MEMOIZE_SIZE) cache.clear();
        return key;
    });
    var cache = result.cache;
    return result;
}
var $19f3dce5adf9ec90$export$2e2bcd8739ae039 = $19f3dce5adf9ec90$var$memoizeCapped;


/** Used to match property names within property paths. */ var $23067043d0575069$var$rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;
/** Used to match backslashes in property paths. */ var $23067043d0575069$var$reEscapeChar = /\\(\\)?/g;
/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */ var $23067043d0575069$var$stringToPath = (0, $19f3dce5adf9ec90$export$2e2bcd8739ae039)(function(string) {
    var result = [];
    if (string.charCodeAt(0) === 46 /* . */ ) result.push('');
    string.replace($23067043d0575069$var$rePropName, function(match, number, quote, subString) {
        result.push(quote ? subString.replace($23067043d0575069$var$reEscapeChar, '$1') : number || match);
    });
    return result;
});
var $23067043d0575069$export$2e2bcd8739ae039 = $23067043d0575069$var$stringToPath;



/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */ function $e30383e00aa0d71c$var$arrayMap(array, iteratee) {
    var index = -1, length = array == null ? 0 : array.length, result = Array(length);
    while(++index < length)result[index] = iteratee(array[index], index, array);
    return result;
}
var $e30383e00aa0d71c$export$2e2bcd8739ae039 = $e30383e00aa0d71c$var$arrayMap;




/** Used as references for various `Number` constants. */ var $ee9044ce1b52066f$var$INFINITY = 1 / 0;
/** Used to convert symbols to primitives and strings. */ var $ee9044ce1b52066f$var$symbolProto = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).prototype : undefined, $ee9044ce1b52066f$var$symbolToString = $ee9044ce1b52066f$var$symbolProto ? $ee9044ce1b52066f$var$symbolProto.toString : undefined;
/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */ function $ee9044ce1b52066f$var$baseToString(value) {
    // Exit early for strings to avoid a performance hit in some environments.
    if (typeof value == 'string') return value;
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) // Recursively convert values (susceptible to call stack limits).
    return (0, $e30383e00aa0d71c$export$2e2bcd8739ae039)(value, $ee9044ce1b52066f$var$baseToString) + '';
    if ((0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return $ee9044ce1b52066f$var$symbolToString ? $ee9044ce1b52066f$var$symbolToString.call(value) : '';
    var result = value + '';
    return result == '0' && 1 / value == -$ee9044ce1b52066f$var$INFINITY ? '-0' : result;
}
var $ee9044ce1b52066f$export$2e2bcd8739ae039 = $ee9044ce1b52066f$var$baseToString;


/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */ function $c64e646827cd6466$var$toString(value) {
    return value == null ? '' : (0, $ee9044ce1b52066f$export$2e2bcd8739ae039)(value);
}
var $c64e646827cd6466$export$2e2bcd8739ae039 = $c64e646827cd6466$var$toString;


/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */ function $a16ace4c8189c160$var$castPath(value, object) {
    if ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value)) return value;
    return (0, $692761996cdc4c09$export$2e2bcd8739ae039)(value, object) ? [
        value
    ] : (0, $23067043d0575069$export$2e2bcd8739ae039)((0, $c64e646827cd6466$export$2e2bcd8739ae039)(value));
}
var $a16ace4c8189c160$export$2e2bcd8739ae039 = $a16ace4c8189c160$var$castPath;



/** Used as references for various `Number` constants. */ var $75b8732e1e1646c2$var$INFINITY = 1 / 0;
/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */ function $75b8732e1e1646c2$var$toKey(value) {
    if (typeof value == 'string' || (0, $d08c66e304cbe5be$export$2e2bcd8739ae039)(value)) return value;
    var result = value + '';
    return result == '0' && 1 / value == -$75b8732e1e1646c2$var$INFINITY ? '-0' : result;
}
var $75b8732e1e1646c2$export$2e2bcd8739ae039 = $75b8732e1e1646c2$var$toKey;


/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */ function $840c55ae586509c7$var$baseGet(object, path) {
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = 0, length = path.length;
    while(object != null && index < length)object = object[(0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index++])];
    return index && index == length ? object : undefined;
}
var $840c55ae586509c7$export$2e2bcd8739ae039 = $840c55ae586509c7$var$baseGet;



var $518283c44f0c1802$var$defineProperty = function() {
    try {
        var func = (0, $59eaa6cbec0d3fc3$export$2e2bcd8739ae039)(Object, 'defineProperty');
        func({}, '', {});
        return func;
    } catch (e) {}
}();
var $518283c44f0c1802$export$2e2bcd8739ae039 = $518283c44f0c1802$var$defineProperty;


/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $390f7f5614c77bb9$var$baseAssignValue(object, key, value) {
    if (key == '__proto__' && (0, $518283c44f0c1802$export$2e2bcd8739ae039)) (0, $518283c44f0c1802$export$2e2bcd8739ae039)(object, key, {
        'configurable': true,
        'enumerable': true,
        'value': value,
        'writable': true
    });
    else object[key] = value;
}
var $390f7f5614c77bb9$export$2e2bcd8739ae039 = $390f7f5614c77bb9$var$baseAssignValue;



/** Used for built-in method references. */ var $d1616e614d60f271$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d1616e614d60f271$var$hasOwnProperty = $d1616e614d60f271$var$objectProto.hasOwnProperty;
/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */ function $d1616e614d60f271$var$assignValue(object, key, value) {
    var objValue = object[key];
    if (!($d1616e614d60f271$var$hasOwnProperty.call(object, key) && (0, $816c5a4323d3d01d$export$2e2bcd8739ae039)(objValue, value)) || value === undefined && !(key in object)) (0, $390f7f5614c77bb9$export$2e2bcd8739ae039)(object, key, value);
}
var $d1616e614d60f271$export$2e2bcd8739ae039 = $d1616e614d60f271$var$assignValue;



/** Used as references for various `Number` constants. */ 
var $2bfPH = parcelRequire("2bfPH");
var $d829662a7af045c8$var$MAX_SAFE_INTEGER = 9007199254740991;
/** Used to detect unsigned integer values. */ var $d829662a7af045c8$var$reIsUint = /^(?:0|[1-9]\d*)$/;
/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */ function $d829662a7af045c8$var$isIndex(value, length) {
    var type = typeof value === "undefined" ? "undefined" : (0, $2bfPH._)(value);
    length = length == null ? $d829662a7af045c8$var$MAX_SAFE_INTEGER : length;
    return !!length && (type == 'number' || type != 'symbol' && $d829662a7af045c8$var$reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
}
var $d829662a7af045c8$export$2e2bcd8739ae039 = $d829662a7af045c8$var$isIndex;




/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */ function $f8f83f7fff8a5166$var$baseSet(object, path, value, customizer) {
    if (!(0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(object)) return object;
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, lastIndex = length - 1, nested = object;
    while(nested != null && ++index < length){
        var key = (0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index]), newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') return object;
        if (index != lastIndex) {
            var objValue = nested[key];
            newValue = customizer ? customizer(objValue, key, nested) : undefined;
            if (newValue === undefined) newValue = (0, $1d53ac6aee0c3479$export$2e2bcd8739ae039)(objValue) ? objValue : (0, $d829662a7af045c8$export$2e2bcd8739ae039)(path[index + 1]) ? [] : {};
        }
        (0, $d1616e614d60f271$export$2e2bcd8739ae039)(nested, key, newValue);
        nested = nested[key];
    }
    return object;
}
var $f8f83f7fff8a5166$export$2e2bcd8739ae039 = $f8f83f7fff8a5166$var$baseSet;



/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */ function $eda4d1e9dceb41ab$var$basePickBy(object, paths, predicate) {
    var index = -1, length = paths.length, result = {};
    while(++index < length){
        var path = paths[index], value = (0, $840c55ae586509c7$export$2e2bcd8739ae039)(object, path);
        if (predicate(value, path)) (0, $f8f83f7fff8a5166$export$2e2bcd8739ae039)(result, (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object), value);
    }
    return result;
}
var $eda4d1e9dceb41ab$export$2e2bcd8739ae039 = $eda4d1e9dceb41ab$var$basePickBy;


/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */ function $06f8e3cebab0da01$var$baseHasIn(object, key) {
    return object != null && key in Object(object);
}
var $06f8e3cebab0da01$export$2e2bcd8739ae039 = $06f8e3cebab0da01$var$baseHasIn;





/** `Object#toString` result references. */ var $68df74354ba9582d$var$argsTag = '[object Arguments]';
/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */ function $68df74354ba9582d$var$baseIsArguments(value) {
    return (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && (0, $327986fe46142e6d$export$2e2bcd8739ae039)(value) == $68df74354ba9582d$var$argsTag;
}
var $68df74354ba9582d$export$2e2bcd8739ae039 = $68df74354ba9582d$var$baseIsArguments;



/** Used for built-in method references. */ var $d933a4585efacd94$var$objectProto = Object.prototype;
/** Used to check objects for own properties. */ var $d933a4585efacd94$var$hasOwnProperty = $d933a4585efacd94$var$objectProto.hasOwnProperty;
/** Built-in value references. */ var $d933a4585efacd94$var$propertyIsEnumerable = $d933a4585efacd94$var$objectProto.propertyIsEnumerable;
/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */ var $d933a4585efacd94$var$isArguments = (0, $68df74354ba9582d$export$2e2bcd8739ae039)(function() {
    return arguments;
}()) ? (0, $68df74354ba9582d$export$2e2bcd8739ae039) : function isArguments(value) {
    return (0, $d918f235875ebac8$export$2e2bcd8739ae039)(value) && $d933a4585efacd94$var$hasOwnProperty.call(value, 'callee') && !$d933a4585efacd94$var$propertyIsEnumerable.call(value, 'callee');
};
var $d933a4585efacd94$export$2e2bcd8739ae039 = $d933a4585efacd94$var$isArguments;




/** Used as references for various `Number` constants. */ var $52c9488c28cfc0b3$var$MAX_SAFE_INTEGER = 9007199254740991;
/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */ function $52c9488c28cfc0b3$var$isLength(value) {
    return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= $52c9488c28cfc0b3$var$MAX_SAFE_INTEGER;
}
var $52c9488c28cfc0b3$export$2e2bcd8739ae039 = $52c9488c28cfc0b3$var$isLength;



/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */ function $47c784b0500cafd2$var$hasPath(object, path, hasFunc) {
    path = (0, $a16ace4c8189c160$export$2e2bcd8739ae039)(path, object);
    var index = -1, length = path.length, result = false;
    while(++index < length){
        var key = (0, $75b8732e1e1646c2$export$2e2bcd8739ae039)(path[index]);
        if (!(result = object != null && hasFunc(object, key))) break;
        object = object[key];
    }
    if (result || ++index != length) return result;
    length = object == null ? 0 : object.length;
    return !!length && (0, $52c9488c28cfc0b3$export$2e2bcd8739ae039)(length) && (0, $d829662a7af045c8$export$2e2bcd8739ae039)(key, length) && ((0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(object) || (0, $d933a4585efacd94$export$2e2bcd8739ae039)(object));
}
var $47c784b0500cafd2$export$2e2bcd8739ae039 = $47c784b0500cafd2$var$hasPath;


/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */ function $e0c5aae4b3458c3e$var$hasIn(object, path) {
    return object != null && (0, $47c784b0500cafd2$export$2e2bcd8739ae039)(object, path, (0, $06f8e3cebab0da01$export$2e2bcd8739ae039));
}
var $e0c5aae4b3458c3e$export$2e2bcd8739ae039 = $e0c5aae4b3458c3e$var$hasIn;


/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */ function $220198508e8e10e2$var$basePick(object, paths) {
    return (0, $eda4d1e9dceb41ab$export$2e2bcd8739ae039)(object, paths, function(value, path) {
        return (0, $e0c5aae4b3458c3e$export$2e2bcd8739ae039)(object, path);
    });
}
var $220198508e8e10e2$export$2e2bcd8739ae039 = $220198508e8e10e2$var$basePick;


/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */ function $4a7b1485b8d687d6$var$arrayPush(array, values) {
    var index = -1, length = values.length, offset = array.length;
    while(++index < length)array[offset + index] = values[index];
    return array;
}
var $4a7b1485b8d687d6$export$2e2bcd8739ae039 = $4a7b1485b8d687d6$var$arrayPush;





/** Built-in value references. */ var $8319a1c13d04ace2$var$spreadableSymbol = (0, $de766450d8859b45$export$2e2bcd8739ae039) ? (0, $de766450d8859b45$export$2e2bcd8739ae039).isConcatSpreadable : undefined;
/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */ function $8319a1c13d04ace2$var$isFlattenable(value) {
    return (0, $3a0ba9181dd26b01$export$2e2bcd8739ae039)(value) || (0, $d933a4585efacd94$export$2e2bcd8739ae039)(value) || !!($8319a1c13d04ace2$var$spreadableSymbol && value && value[$8319a1c13d04ace2$var$spreadableSymbol]);
}
var $8319a1c13d04ace2$export$2e2bcd8739ae039 = $8319a1c13d04ace2$var$isFlattenable;


/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */ function $6990cf1083772c77$var$baseFlatten(array, depth, predicate, isStrict, result) {
    var index = -1, length = array.length;
    predicate || (predicate = (0, $8319a1c13d04ace2$export$2e2bcd8739ae039));
    result || (result = []);
    while(++index < length){
        var value = array[index];
        if (depth > 0 && predicate(value)) {
            if (depth > 1) // Recursively flatten arrays (susceptible to call stack limits).
            $6990cf1083772c77$var$baseFlatten(value, depth - 1, predicate, isStrict, result);
            else (0, $4a7b1485b8d687d6$export$2e2bcd8739ae039)(result, value);
        } else if (!isStrict) result[result.length] = value;
    }
    return result;
}
var $6990cf1083772c77$export$2e2bcd8739ae039 = $6990cf1083772c77$var$baseFlatten;


/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */ function $f3e296f6897581bd$var$flatten(array) {
    var length = array == null ? 0 : array.length;
    return length ? (0, $6990cf1083772c77$export$2e2bcd8739ae039)(array, 1) : [];
}
var $f3e296f6897581bd$export$2e2bcd8739ae039 = $f3e296f6897581bd$var$flatten;


/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */ function $8a60073bb4ff63ab$var$apply(func, thisArg, args) {
    switch(args.length){
        case 0:
            return func.call(thisArg);
        case 1:
            return func.call(thisArg, args[0]);
        case 2:
            return func.call(thisArg, args[0], args[1]);
        case 3:
            return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
}
var $8a60073bb4ff63ab$export$2e2bcd8739ae039 = $8a60073bb4ff63ab$var$apply;


/* Built-in method references for those with the same name as other `lodash` methods. */ var $699693d6a2a97eac$var$nativeMax = Math.max;
/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */ function $699693d6a2a97eac$var$overRest(func, start, transform) {
    start = $699693d6a2a97eac$var$nativeMax(start === undefined ? func.length - 1 : start, 0);
    return function() {
        var args = arguments, index = -1, length = $699693d6a2a97eac$var$nativeMax(args.length - start, 0), array = Array(length);
        while(++index < length)array[index] = args[start + index];
        index = -1;
        var otherArgs = Array(start + 1);
        while(++index < start)otherArgs[index] = args[index];
        otherArgs[start] = transform(array);
        return (0, $8a60073bb4ff63ab$export$2e2bcd8739ae039)(func, this, otherArgs);
    };
}
var $699693d6a2a97eac$export$2e2bcd8739ae039 = $699693d6a2a97eac$var$overRest;


/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */ function $457b93e422a0a25d$var$constant(value) {
    return function() {
        return value;
    };
}
var $457b93e422a0a25d$export$2e2bcd8739ae039 = $457b93e422a0a25d$var$constant;



/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */ function $e6cf5f6047124b05$var$identity(value) {
    return value;
}
var $e6cf5f6047124b05$export$2e2bcd8739ae039 = $e6cf5f6047124b05$var$identity;


/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $b2ff5bbbdc5713b5$var$baseSetToString = !(0, $518283c44f0c1802$export$2e2bcd8739ae039) ? (0, $e6cf5f6047124b05$export$2e2bcd8739ae039) : function baseSetToString(func, string) {
    return (0, $518283c44f0c1802$export$2e2bcd8739ae039)(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': (0, $457b93e422a0a25d$export$2e2bcd8739ae039)(string),
        'writable': true
    });
};
var $b2ff5bbbdc5713b5$export$2e2bcd8739ae039 = $b2ff5bbbdc5713b5$var$baseSetToString;


/** Used to detect hot functions by number of calls within a span of milliseconds. */ var $d5f7c15b7dced041$var$HOT_COUNT = 800, $d5f7c15b7dced041$var$HOT_SPAN = 16;
/* Built-in method references for those with the same name as other `lodash` methods. */ var $d5f7c15b7dced041$var$nativeNow = Date.now;
/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */ function $d5f7c15b7dced041$var$shortOut(func) {
    var count = 0, lastCalled = 0;
    return function() {
        var stamp = $d5f7c15b7dced041$var$nativeNow(), remaining = $d5f7c15b7dced041$var$HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
            if (++count >= $d5f7c15b7dced041$var$HOT_COUNT) return arguments[0];
        } else count = 0;
        return func.apply(undefined, arguments);
    };
}
var $d5f7c15b7dced041$export$2e2bcd8739ae039 = $d5f7c15b7dced041$var$shortOut;


/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */ var $4c665559ed128371$var$setToString = (0, $d5f7c15b7dced041$export$2e2bcd8739ae039)((0, $b2ff5bbbdc5713b5$export$2e2bcd8739ae039));
var $4c665559ed128371$export$2e2bcd8739ae039 = $4c665559ed128371$var$setToString;


/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */ function $d2b21c57bfdbd300$var$flatRest(func) {
    return (0, $4c665559ed128371$export$2e2bcd8739ae039)((0, $699693d6a2a97eac$export$2e2bcd8739ae039)(func, undefined, (0, $f3e296f6897581bd$export$2e2bcd8739ae039)), func + '');
}
var $d2b21c57bfdbd300$export$2e2bcd8739ae039 = $d2b21c57bfdbd300$var$flatRest;


/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */ var $2b2b00f45dc8a6fe$var$pick = (0, $d2b21c57bfdbd300$export$2e2bcd8739ae039)(function(object, paths) {
    return object == null ? {} : (0, $220198508e8e10e2$export$2e2bcd8739ae039)(object, paths);
});
var $2b2b00f45dc8a6fe$export$2e2bcd8739ae039 = $2b2b00f45dc8a6fe$var$pick;




var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");

function $75572ed2b6539c59$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue) {
    setDirty(true);
    setEditedSource(function(_param) {
        var params = _param.params, restSource = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
            "params"
        ]);
        return (0, $9Jpjh._)((0, $lvTkn._)({}, restSource), {
            params: (0, $9Jpjh._)((0, $lvTkn._)({}, params), (0, $khBmn._)({}, spoutParamName, newValue))
        });
    });
}
function $75572ed2b6539c59$export$2e2bcd8739ae039(props) {
    var spoutParamName = props.spoutParamName, spoutParam = props.spoutParam, _props_params = props.params, params = _props_params === void 0 ? {} : _props_params, sourceErrors = props.sourceErrors, sourceId = props.sourceId, setEditedSource = props.setEditedSource, setDirty = props.setDirty;
    var updateSourceParam = (0, $eHaBZ.useCallback)(function(event) {
        var newValue = event.currentTarget.value;
        $75572ed2b6539c59$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue);
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    var updateSourceParamBool = (0, $eHaBZ.useCallback)(function(event) {
        var newValue = event.currentTarget.checked ? '1' : undefined;
        $75572ed2b6539c59$var$setFieldValue(setDirty, setEditedSource, spoutParamName, newValue);
    }, [
        setEditedSource,
        setDirty,
        spoutParamName
    ]);
    var value = spoutParamName in params ? params[spoutParamName] : spoutParam.default;
    var control = null;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    if ([
        'text',
        'checkbox',
        'url'
    ].includes(spoutParam.type)) {
        var checked;
        if (spoutParam.type === 'checkbox') {
            checked = value == '1';
            // Value always has to be 1 since HTML sends [name]=[value] when a checkbox is checked
            // and omits the field altogether from HTTP request when not checked.
            value = '1';
        }
        control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
            id: "".concat(spoutParamName, "-").concat(sourceId),
            type: spoutParam.type,
            name: spoutParamName,
            value: value,
            checked: checked,
            onChange: spoutParam.type !== 'checkbox' ? updateSourceParam : updateSourceParamBool
        });
    } else if (spoutParam.type === 'password') control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        type: spoutParam.type,
        name: spoutParamName,
        placeholder: _('source_pwd_placeholder'),
        onChange: updateSourceParam
    });
    else if (spoutParam.type === 'select') control = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("select", {
        id: "".concat(spoutParamName, "-").concat(sourceId),
        name: spoutParamName,
        size: 1,
        value: value,
        onChange: updateSourceParam,
        children: Object.entries(spoutParam.values).map(function(param) {
            var _param = (0, $21h22._)(param, 2), optionName = _param[0], optionTitle = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                value: optionName,
                children: optionTitle
            }, optionName);
        })
    });
    else return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                htmlFor: "".concat(spoutParamName, "-").concat(sourceId),
                children: spoutParam.title
            }),
            control,
            sourceErrors[spoutParamName] ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "error",
                children: sourceErrors[spoutParamName]
            }) : null
        ]
    });
}




function $c937d70a1b132a36$export$722fbec263ad908a(id, values) {
    return $8b420386626a2c2e$export$299ba2dee77727e9("source/".concat(id), {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(values),
        failOnHttpErrors: false
    }).promise.then($8b420386626a2c2e$export$8d90b058a02656d9(function(response) {
        return response.ok || response.status === 400;
    })).then(function(response) {
        return response.json().then(function(json) {
            return response.ok ? json : {
                success: false,
                errors: json
            };
        });
    });
}
function $c937d70a1b132a36$export$c1f8f7c408fa54a(id) {
    return $8b420386626a2c2e$export$299ba2dee77727e9('source/' + id + '/update', {
        timeout: 0
    }).promise;
}
function $c937d70a1b132a36$export$c5eb18431f66026b() {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('update', {
        headers: {
            Accept: 'text/event-stream'
        },
        timeout: 0
    }).promise.then(function(response) {
        return response.text();
    });
}
function $c937d70a1b132a36$export$cd7f480d6b8286c3(id) {
    return $8b420386626a2c2e$export$38dab5a9fea42f39("source/".concat(id)).promise.then(function(response) {
        return response.json();
    });
}
var $c937d70a1b132a36$var$SpoutParameterTypePlain = /*#__PURE__*/ function(SpoutParameterTypePlain) {
    SpoutParameterTypePlain["Text"] = "text";
    SpoutParameterTypePlain["Url"] = "url";
    SpoutParameterTypePlain["Password"] = "password";
    SpoutParameterTypePlain["Checkbox"] = "checkbox";
    return SpoutParameterTypePlain;
}($c937d70a1b132a36$var$SpoutParameterTypePlain || {});
var $c937d70a1b132a36$var$SpoutParameterTypeSelect = /*#__PURE__*/ function(SpoutParameterTypeSelect) {
    SpoutParameterTypeSelect["Select"] = "select";
    return SpoutParameterTypeSelect;
}($c937d70a1b132a36$var$SpoutParameterTypeSelect || {});
var $c937d70a1b132a36$var$SpoutParameterValidation = /*#__PURE__*/ function(SpoutParameterValidation) {
    SpoutParameterValidation["Alpha"] = "alpha";
    SpoutParameterValidation["Email"] = "email";
    SpoutParameterValidation["Numeric"] = "numeric";
    SpoutParameterValidation["Int"] = "int";
    SpoutParameterValidation["Alphanumeric"] = "alnum";
    SpoutParameterValidation["NonEmpty"] = "notempty";
    return SpoutParameterValidation;
}($c937d70a1b132a36$var$SpoutParameterValidation || {});
function $c937d70a1b132a36$export$316f19f1ddc6b34e(abortController) {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('sources', {
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    });
}
function $c937d70a1b132a36$export$ba43f46f09336c84() {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('sources/spouts').promise.then(function(response) {
        return response.json();
    });
}
function $c937d70a1b132a36$export$d72d2378a998c10c(spoutClass) {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('source/params', {
        body: $8b420386626a2c2e$export$92871f7982deaf9f({
            spout: spoutClass
        })
    }).promise.then(function(res) {
        return res.json();
    });
}
function $c937d70a1b132a36$export$432f698644f45d1() {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('sources/stats').promise.then(function(response) {
        return response.json();
    });
}




var $b17ad773b592c4c7$var$FAST_DURATION_MS = 200;
// cancel source editing
function $b17ad773b592c4c7$var$handleCancel(args) {
    var source = args.source, sourceElem = args.sourceElem, setSources = args.setSources, setEditedSource = args.setEditedSource;
    var id = source.id;
    if (id.toString().startsWith('new-')) (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
        duration: $b17ad773b592c4c7$var$FAST_DURATION_MS,
        complete: function() {
            // Remove the source from this page’s model.
            setSources(function(sources) {
                return sources.filter(function(source) {
                    return source.id !== id;
                });
            });
        }
    });
    else // Hide the input form.
    setEditedSource(null);
}
// save source
function $b17ad773b592c4c7$var$handleSave(args) {
    var event = args.event, setSources = args.setSources, source = args.source, setEditedSource = args.setEditedSource, setSourceActionLoading = args.setSourceActionLoading, setJustSavedTimeout = args.setJustSavedTimeout, setSourceErrors = args.setSourceErrors, isNew = args.isNew, setNewIds = args.setNewIds, showError = args.showError, _ = args._;
    event.preventDefault();
    // remove old errors
    setSourceErrors({});
    setSourceActionLoading(true);
    var newSource = source;
    var id = source.id, tags = source.tags, filter = source.filter, params = source.params, restSource = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(source, [
        "id",
        "tags",
        "filter",
        "params"
    ]);
    // Make tags into a list.
    var tagsList = tags ? tags.split(',').map(function(tag) {
        return tag.trim();
    }).filter(function(tag) {
        return tag !== '';
    }) : [];
    var values = (0, $9Jpjh._)((0, $lvTkn._)({}, restSource, params), {
        tags: tagsList,
        filter: filter || null
    });
    var idString = isNew ? "new-".concat(id) : "".concat(id);
    $c937d70a1b132a36$export$722fbec263ad908a(idString, values).then(function(response) {
        if (response.success === false) setSourceErrors(response.errors);
        else {
            // Set justSavedTimeout state variable to a timeout.
            // The view will show “saved” text while the timeout runs.
            setJustSavedTimeout(function(oldTimeout) {
                // Only keep the most recent timeout.
                if (oldTimeout !== null) clearTimeout(oldTimeout);
                return window.setTimeout(function() {
                    setJustSavedTimeout(null);
                }, 10000);
            });
            setNewIds(function(newIds) {
                var s = new Set(newIds);
                s.delete(id);
                return s;
            });
            // Hide the input form.
            setEditedSource(null);
            // Update tags and sources for navigation.
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTags(response.tags);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSources(response.sources);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSourcesState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
            // Update sources in this page’s model.
            setSources(function(sources) {
                return sources.map(function(source) {
                    if (source.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, newSource), {
                        id: response.id,
                        tags: tagsList,
                        // Use fetched title.
                        title: response.title,
                        icon: null,
                        lastentry: null,
                        error: null
                    });
                    else return source;
                });
            });
        }
    }).catch(function(error) {
        showError(_('error_edit_source') + ' ' + error.message);
    }).finally(function() {
        setSourceActionLoading(false);
    });
}
// delete source
function $b17ad773b592c4c7$var$handleDelete(args) {
    var source = args.source, sourceElem = args.sourceElem, setSources = args.setSources, setSourceBeingDeleted = args.setSourceBeingDeleted, setDirty = args.setDirty, showError = args.showError, _ = args._;
    var answer = confirm(_('source_warn'));
    if (answer == false) return;
    // get id
    var id = source.id;
    setDirty(false);
    // show loading
    setSourceBeingDeleted(true);
    // delete on server
    $c937d70a1b132a36$export$cd7f480d6b8286c3(id).then(function() {
        (0, $7ef98d8c594793a5$export$c091916f1530334c)(sourceElem.current, {
            duration: $b17ad773b592c4c7$var$FAST_DURATION_MS,
            complete: function() {
                // Remove the source from this page’s model.
                setSources(function(sources) {
                    return sources.filter(function(source) {
                        return source.id !== id;
                    });
                });
            }
        });
        // Reload tags and remove source from navigation.
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).reloadTags();
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSources(function(sources) {
            return sources.filter(function(source) {
                return source.id !== id;
            });
        });
    }).catch(function(error) {
        setSourceBeingDeleted(false);
        showError(_('error_delete_source') + ' ' + error.message);
    });
}
// start editing
function $b17ad773b592c4c7$var$handleEdit(args) {
    var event = args.event, source = args.source, setEditedSource = args.setEditedSource;
    event.preventDefault();
    var id = source.id, title = source.title, tags = source.tags, filter = source.filter, spout = source.spout, params = source.params;
    setEditedSource({
        id: id,
        title: title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(title) : '',
        tags: tags ? tags.map((0, $4c0cf5d996e33977$export$e8bacd2802a88316)).join(',') : '',
        filter: filter,
        spout: spout,
        params: params
    });
}
// select new source spout type
function $b17ad773b592c4c7$var$handleSpoutChange(args) {
    var event = args.event, setSpouts = args.setSpouts, updateEditedSource = args.updateEditedSource, setSourceParamsLoading = args.setSourceParamsLoading, setSourceParamsError = args.setSourceParamsError;
    var spoutClass = event.currentTarget.value;
    updateEditedSource({
        spout: spoutClass
    });
    if (spoutClass.trim().length === 0) return;
    setSourceParamsLoading(true);
    $c937d70a1b132a36$export$d72d2378a998c10c(spoutClass).then(function(param) {
        var spout = param.spout;
        setSourceParamsLoading(false);
        setSpouts(function(spouts) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, spouts), (0, $khBmn._)({}, spoutClass, spout));
        });
        var defaults = Object.fromEntries(Object.entries(spout.params).map(function(param) {
            var _param = (0, $21h22._)(param, 2), _$param = _param[0], props = _param[1];
            var _props_default;
            return [
                _$param,
                (_props_default = props.default) !== null && _props_default !== void 0 ? _props_default : ''
            ];
        }));
        updateEditedSource(function(source) {
            var oldCompatibleParams = (0, $2b2b00f45dc8a6fe$export$2e2bcd8739ae039)(source.params, Object.keys(spout.params));
            return {
                params: (0, $lvTkn._)({}, defaults, oldCompatibleParams)
            };
        });
    }).catch(function(error) {
        setSourceParamsLoading(false);
        setSourceParamsError(error.message);
    });
}
// Taken from https://stackoverflow.com/a/15289883/160386
var $b17ad773b592c4c7$var$MS_PER_DAY = 86400000;
function $b17ad773b592c4c7$var$daysAgo(date) {
    // Get number of days between now and when the last entry was seen
    // Note: The time of the two dates is set to midnight
    // to get the difference of the two dates in calendar days
    // instead of a day equaling any 24 hour period which makes it
    // impossible to distinguish today and yesterday.
    var now = new Date();
    var today = Date.UTC(now.getFullYear(), now.getMonth(), now.getDate());
    var old = Date.UTC(date.getFullYear(), date.getMonth(), date.getDate());
    return Math.floor((today - old) / $b17ad773b592c4c7$var$MS_PER_DAY);
}
function $b17ad773b592c4c7$var$SourceEditForm(props) {
    var source = props.source, sourceElem = props.sourceElem, sourceError = props.sourceError, setSources = props.setSources, spouts = props.spouts, setSpouts = props.setSpouts, setEditedSource = props.setEditedSource, sourceActionLoading = props.sourceActionLoading, setSourceActionLoading = props.setSourceActionLoading, sourceParamsLoading = props.sourceParamsLoading, setSourceParamsLoading = props.setSourceParamsLoading, sourceParamsError = props.sourceParamsError, setSourceParamsError = props.setSourceParamsError, setJustSavedTimeout = props.setJustSavedTimeout, sourceErrors = props.sourceErrors, setSourceErrors = props.setSourceErrors, dirty = props.dirty, setDirty = props.setDirty, isNew = props.isNew, setNewIds = props.setNewIds, showError = props.showError;
    var _ = (0, $eHaBZ.useContext)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var sourceId = source.id;
    var updateEditedSource = (0, $eHaBZ.useCallback)(function(changes) {
        setDirty(true);
        if (typeof changes === 'function') setEditedSource(function(source) {
            return (0, $lvTkn._)({}, source, changes(source));
        });
        else setEditedSource(function(source) {
            return (0, $lvTkn._)({}, source, changes);
        });
    }, [
        setEditedSource,
        setDirty
    ]);
    var titleOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            title: event.currentTarget.value
        });
    }, [
        updateEditedSource
    ]);
    var tagsOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            tags: event.currentTarget.value
        });
    }, [
        updateEditedSource
    ]);
    var filterOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return updateEditedSource({
            filter: event.currentTarget.value
        });
    }, [
        updateEditedSource
    ]);
    var spoutOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return $b17ad773b592c4c7$var$handleSpoutChange({
            event: event,
            setSpouts: setSpouts,
            updateEditedSource: updateEditedSource,
            setSourceParamsLoading: setSourceParamsLoading,
            setSourceParamsError: setSourceParamsError
        });
    }, [
        setSpouts,
        updateEditedSource,
        setSourceParamsLoading,
        setSourceParamsError
    ]);
    var saveOnClick = (0, $eHaBZ.useCallback)(function(event) {
        setDirty(false);
        $b17ad773b592c4c7$var$handleSave({
            event: event,
            setSources: setSources,
            source: source,
            setEditedSource: setEditedSource,
            setSourceActionLoading: setSourceActionLoading,
            setJustSavedTimeout: setJustSavedTimeout,
            setSourceErrors: setSourceErrors,
            isNew: isNew,
            setNewIds: setNewIds,
            showError: showError,
            _: _
        });
    }, [
        setSources,
        source,
        setEditedSource,
        setSourceActionLoading,
        setJustSavedTimeout,
        setSourceErrors,
        setDirty,
        isNew,
        setNewIds,
        showError,
        _
    ]);
    var cancelOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        if (dirty) {
            var answer = confirm(_('source_warn_cancel_dirty'));
            if (answer === false) return;
        }
        setDirty(false);
        $b17ad773b592c4c7$var$handleCancel({
            event: event,
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        sourceElem,
        setSources,
        setEditedSource,
        dirty,
        setDirty,
        _
    ]);
    var sourceParamsContent = sourceParamsLoading ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$7f7cbe89f1eacd2), {
        size: "3x",
        label: _('source_params_loading')
    }) : sourceParamsError !== null && sourceParamsError !== void 0 ? sourceParamsError : Object.keys(spouts).includes(source.spout) && Object.keys(spouts[source.spout].params).length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
        children: Object.entries(spouts[source.spout].params).map(function(param) {
            var _param = (0, $21h22._)(param, 2), spoutParamName = _param[0], spoutParam = _param[1];
            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $75572ed2b6539c59$export$2e2bcd8739ae039), {
                params: source.params,
                spoutParamName: spoutParamName,
                spoutParam: spoutParam,
                sourceErrors: sourceErrors,
                sourceId: sourceId,
                setEditedSource: setEditedSource,
                setDirty: setDirty
            }, spoutParamName);
        })
    }) : null;
    var _source_title, _source_tags, _source_filter;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("form", {
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
            className: "source-edit-form",
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "title-".concat(sourceId),
                            children: _('source_title')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "title-".concat(sourceId),
                            type: "text",
                            name: "title",
                            accessKey: "t",
                            value: (_source_title = source.title) !== null && _source_title !== void 0 ? _source_title : '',
                            placeholder: _('source_autotitle_hint'),
                            onChange: titleOnChange,
                            autoFocus: true
                        }),
                        sourceErrors.title ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.title
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "tags-".concat(sourceId),
                            children: _('source_tags')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "tags-".concat(sourceId),
                            type: "text",
                            name: "tags",
                            accessKey: "g",
                            value: (_source_tags = source.tags) !== null && _source_tags !== void 0 ? _source_tags : '',
                            onChange: tagsOnChange
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                            className: "source-edit-form-help",
                            children: [
                                ' ',
                                _('source_comma')
                            ]
                        }),
                        sourceErrors.tags ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.tags
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "filter-".concat(sourceId),
                            children: _('source_filter')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                            id: "filter-".concat(sourceId),
                            type: "text",
                            name: "filter",
                            accessKey: "f",
                            value: (_source_filter = source.filter) !== null && _source_filter !== void 0 ? _source_filter : '',
                            onChange: filterOnChange
                        }),
                        sourceErrors.filter ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.filter
                        }) : null
                    ]
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("label", {
                            htmlFor: "type-".concat(sourceId),
                            children: _('source_type')
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("select", {
                            id: "type-".concat(sourceId),
                            className: "source-spout",
                            name: "spout",
                            accessKey: "y",
                            onChange: spoutOnChange,
                            value: source.spout,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                    value: "",
                                    children: _('source_select')
                                }),
                                Object.entries(spouts).map(function(param) {
                                    var _param = (0, $21h22._)(param, 2), spouttype = _param[0], spout = _param[1];
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("option", {
                                        title: spout.description,
                                        value: spouttype,
                                        children: spout.name
                                    }, spouttype);
                                })
                            ]
                        }),
                        sourceErrors.spout ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            className: "error",
                            children: sourceErrors.spout
                        }) : null
                    ]
                }),
                sourceParamsContent ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-params",
                    children: sourceParamsContent
                }) : null,
                sourceError ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                    className: "source-error",
                    "aria-live": "assertive",
                    children: sourceError
                }) : null,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
                    className: "source-action",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "submit",
                            className: "source-save",
                            accessKey: "s",
                            onClick: saveOnClick,
                            children: [
                                _('source_save'),
                                sourceActionLoading && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$7f7cbe89f1eacd2), {
                                            label: _('source_saving')
                                        })
                                    ]
                                })
                            ]
                        }),
                        " \u2022 ",
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                            type: "submit",
                            className: "source-cancel",
                            accessKey: "c",
                            onClick: cancelOnClick,
                            children: _('source_cancel')
                        })
                    ]
                })
            ]
        })
    });
}
function $b17ad773b592c4c7$export$2e2bcd8739ae039(props) {
    var source = props.source, isNew = props.isNew, setSources = props.setSources, spouts = props.spouts, setSpouts = props.setSpouts, dirty = props.dirty, setDirtySources = props.setDirtySources, setNewIds = props.setNewIds, showError = props.showError;
    var _ = (0, $eHaBZ.useContext)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var classes = {
        source: true,
        'source-new': isNew,
        error: source.error && source.error.length > 0
    };
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(isNew ? {
        id: source.id,
        title: source.title,
        spout: source.spout,
        tags: source.tags.join(', '),
        filter: source.filter,
        params: source.params
    } : null), 2), editedSource = _useState[0], setEditedSource = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceActionLoading = _useState1[0], setSourceActionLoading = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceBeingDeleted = _useState2[0], setSourceBeingDeleted = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), sourceParamsLoading = _useState3[0], setSourceParamsLoading = _useState3[1];
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), justSavedTimeout = _useState4[0], setJustSavedTimeout = _useState4[1];
    var _useState5 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), sourceParamsError = _useState5[0], setSourceParamsError = _useState5[1];
    var _useState6 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), sourceErrors = _useState6[0], setSourceErrors = _useState6[1];
    (0, $eHaBZ.useEffect)(function() {
        // Prevent timeout from trying to update state after unmount.
        var oldTimeout = justSavedTimeout;
        return function() {
            if (oldTimeout !== null) clearTimeout(oldTimeout);
        };
    }, [
        justSavedTimeout
    ]);
    var editOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $b17ad773b592c4c7$var$handleEdit({
            event: event,
            source: source,
            setEditedSource: setEditedSource
        });
    }, [
        source,
        setEditedSource
    ]);
    var setDirty = (0, $eHaBZ.useCallback)(function(dirty) {
        setDirtySources(function(dirtySources) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, dirtySources), (0, $khBmn._)({}, source.id, dirty));
        });
    }, [
        source.id,
        setDirtySources
    ]);
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var sourceElem = (0, $eHaBZ.useRef)(null);
    var extraMenuOnSelection = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        if (value === 'delete') $b17ad773b592c4c7$var$handleDelete({
            source: source,
            sourceElem: sourceElem,
            setSources: setSources,
            setSourceBeingDeleted: setSourceBeingDeleted,
            setDirty: setDirty,
            showError: showError,
            _: _
        });
        else if (value === 'browse') navigate((0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id)
        }));
    }, [
        source,
        sourceElem,
        setSources,
        setDirty,
        location,
        navigate,
        showError,
        _
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))(classes),
        "data-id": source.id,
        id: "source-".concat(source.id),
        ref: sourceElem,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-icon",
                children: source.icon && source.icon != '0' ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(source.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                className: "source-title",
                children: source.title ? (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title) : _('source_new')
            }),
            ' ',
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: "source-edit-delete",
                children: [
                    !editedSource && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                type: "button",
                                accessKey: "e",
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'source-showparams': true,
                                    saved: justSavedTimeout !== null
                                }),
                                onClick: editOnClick,
                                "aria-expanded": !!editedSource,
                                children: _(justSavedTimeout !== null ? 'source_saved' : 'source_edit')
                            }),
                            " \u2022 "
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $afcad17a77b29a48$export$d9b273488cd8ce6f), {
                        onItemClick: extraMenuOnSelection,
                        menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7a4ada20cb42c4ac$export$266a769812832828), {
                            className: "source-menu-button",
                            children: [
                                _('source_menu'),
                                sourceBeingDeleted && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                                    children: [
                                        ' ',
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$7f7cbe89f1eacd2), {
                                            label: _('source_deleting')
                                        })
                                    ]
                                })
                            ]
                        }),
                        menuClassName: "popup-menu",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-browse",
                                value: "browse",
                                children: _('source_browse')
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
                                accessKey: "d",
                                className: "popup-menu-item source-delete",
                                value: "delete",
                                children: _('source_delete')
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "source-days",
                children: source.lastentry ? " \u2022 ".concat(_('source_last_post'), " ").concat(_('days', {
                    '0': $b17ad773b592c4c7$var$daysAgo(new Date(source.lastentry * 1000))
                })) : null
            }),
            editedSource ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($b17ad773b592c4c7$var$SourceEditForm, {
                setSources: setSources,
                spouts: spouts,
                setSpouts: setSpouts,
                setEditedSource: setEditedSource,
                sourceActionLoading: sourceActionLoading,
                setSourceActionLoading: setSourceActionLoading,
                sourceParamsLoading: sourceParamsLoading,
                setSourceParamsLoading: setSourceParamsLoading,
                sourceParamsError: sourceParamsError,
                setSourceParamsError: setSourceParamsError,
                setJustSavedTimeout: setJustSavedTimeout,
                sourceErrors: sourceErrors,
                setSourceErrors: setSourceErrors,
                dirty: dirty,
                setDirty: setDirty,
                isNew: isNew,
                setNewIds: setNewIds,
                sourceElem: sourceElem,
                showError: showError,
                sourceError: source.error,
                source: editedSource
            }) : null
        ]
    });
}






var $21h22 = parcelRequire("21h22");

var $eHaBZ = parcelRequire("eHaBZ");



function $74ba0882e4d762a0$export$7bcdf1c247ef07b1() {
    var _location_state;
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var forceReload = location === null || location === void 0 ? void 0 : (_location_state = location.state) === null || _location_state === void 0 ? void 0 : _location_state.forceReload;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(forceReload), 2), oldForceReload = _useState[0], setOldForceReload = _useState[1];
    if (oldForceReload !== forceReload) setOldForceReload(forceReload);
    // The location state is not persisted during navigation
    // so forceReload would change to undefined on successive navigation,
    // triggering an unwanter reload.
    // We use a separate counter to prevent that.
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(0), 2), reloadCounter = _useState1[0], setReloadCounter = _useState1[1];
    if (forceReload !== undefined && forceReload !== oldForceReload) {
        var newReloadCounter = reloadCounter + 1;
        setReloadCounter(newReloadCounter);
        return newReloadCounter;
    }
    return reloadCounter;
}
function $74ba0882e4d762a0$export$443718c44347a6b3() {
    return (0, $c020e53fc27b31fb$export$b1eecdc553bff745)('(max-width: 641px)');
}
function $74ba0882e4d762a0$export$96b5b894afc1d2e3(valueListenable) {
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(valueListenable.value), 2), value = _useState[0], setValue = _useState[1];
    (0, $eHaBZ.useEffect)(function() {
        var listener = function(event) {
            setValue(event.value);
        };
        // It might happen that values change between creating the component and setting up the event handlers.
        listener(new (0, $3b90563ec4c37361$export$5521c47db270880f)(valueListenable.value));
        valueListenable.addEventListener('change', listener);
        return function() {
            valueListenable.removeEventListener('change', listener);
        };
    }, [
        valueListenable
    ]);
    return value;
}




function $3e9307fdfcc7e06c$var$rand() {
    // https://www.php.net/manual/en/function.mt-getrandmax.php#117620
    return Math.floor(Math.random() * 2147483647);
}
function $3e9307fdfcc7e06c$var$handleAddSource(args) {
    var _args_event = args.event, event = _args_event === void 0 ? null : _args_event, setSources = args.setSources, setSpouts = args.setSpouts, setNewIds = args.setNewIds, _args_extraInitialData = args.extraInitialData, extraInitialData = _args_extraInitialData === void 0 ? {} : _args_extraInitialData;
    if (event) event.preventDefault();
    var id = $3e9307fdfcc7e06c$var$rand();
    setNewIds(function(newIds) {
        return new Set([
            id
        ].concat((0, $6zk1M._)(newIds)));
    });
    // Add new empty source.
    setSources(function(sources) {
        return [
            (0, $lvTkn._)({
                id: id,
                title: '',
                tags: [],
                spout: '',
                params: {},
                filter: null,
                error: null,
                lastentry: null,
                icon: null
            }, extraInitialData)
        ].concat((0, $6zk1M._)(sources));
    });
    // Refresh the spout datea
    $c937d70a1b132a36$export$ba43f46f09336c84().then(function(spouts) {
        // Update spout data.
        setSpouts(spouts);
    }).catch(function() {
        console.error('Unable to update spouts, falling back to previously fetched list.');
    });
}
// load sources
function $3e9307fdfcc7e06c$var$loadSources(args) {
    var abortController = args.abortController, location = args.location, navigate = args.navigate, setSpouts = args.setSpouts, setSources = args.setSources, setLoadingState = args.setLoadingState, showError = args.showError, _ = args._;
    if (abortController.signal.aborted) return Promise.resolve();
    setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
    return (0, $c937d70a1b132a36$export$316f19f1ddc6b34e)(abortController).then(function(param) {
        var sources = param.sources, spouts = param.spouts;
        if (abortController.signal.aborted) return;
        setSpouts(spouts);
        setSources(sources);
        setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
        if (location.hash.startsWith('#source-')) {
            var source = document.querySelector('.source[data-id="'.concat(location.hash.replace(/^#source-/, ''), '"]'));
            if (!source) return;
            // needs to be delayed for some reason
            requestAnimationFrame(function() {
                source.scrollIntoView();
            });
        }
    }).catch(function(error) {
        if (error.name === 'AbortError' || abortController.signal.aborted) return;
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error, false).catch(function(error) {
            if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: _('error_session_expired')
                    }
                });
                return;
            }
            showError(_('error_loading') + ' ' + error.message);
        });
        setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE);
    });
}
function $3e9307fdfcc7e06c$export$2e2bcd8739ae039(props) {
    var showError = props.showError;
    var _ = (0, $eHaBZ.useContext)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), spouts = _useState[0], setSpouts = _useState[1];
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), sources = _useState1[0], setSources = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return new Set();
    }), 2), newIds = _useState2[0], setNewIds = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)((0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL), 2), loadingState = _useState3[0], setLoadingState = _useState3[1];
    var forceReload = (0, $74ba0882e4d762a0$export$7bcdf1c247ef07b1)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var isAdding = (0, $0386ffc241ff4f20$export$6c330e8992e8a295)('/manage/sources/add');
    var reloader = (0, $eHaBZ.useEffectEvent)(function(abortController) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var params, _params_get;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        return [
                            4,
                            $3e9307fdfcc7e06c$var$loadSources({
                                abortController: abortController,
                                location: location,
                                navigate: navigate,
                                setSpouts: setSpouts,
                                setSources: setSources,
                                setLoadingState: setLoadingState,
                                showError: showError,
                                _: _
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (isAdding) {
                            params = new URLSearchParams(location.search);
                            ;
                            $3e9307fdfcc7e06c$var$handleAddSource({
                                setSources: setSources,
                                setSpouts: setSpouts,
                                setNewIds: setNewIds,
                                extraInitialData: {
                                    spout: 'spouts\\rss\\feed',
                                    params: {
                                        url: (_params_get = params.get('url')) !== null && _params_get !== void 0 ? _params_get : ''
                                    }
                                }
                            });
                            // Clear the value from the state so it does not bug us forever.
                            navigate('/manage/sources', {
                                replace: true
                            });
                        }
                        return [
                            2
                        ];
                }
            });
        })();
    });
    (0, $eHaBZ.useEffect)(function() {
        var abortController = new AbortController();
        reloader(abortController);
        return function() {
            abortController.abort();
        };
    }, [
        forceReload
    ]);
    var addOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $3e9307fdfcc7e06c$var$handleAddSource({
            event: event,
            setSources: setSources,
            setSpouts: setSpouts,
            setNewIds: setNewIds
        });
    }, []);
    var _useState4 = (0, $21h22._)((0, $eHaBZ.useState)({}), 2), dirtySources = _useState4[0], setDirtySources = _useState4[1];
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    var isDirty = (0, $eHaBZ.useMemo)(function() {
        return Object.values(dirtySources).includes(true);
    }, [
        dirtySources
    ]);
    // TODO: Error: useBlocker must be used within a data router.  See https://reactrouter.com/v6/routers/picking-a-router.
    // usePrompt({
    //     when: isDirty,
    //     message: _('sources_leaving_unsaved_prompt'),
    // });
    if (loadingState === (0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$84dbad74efe95918), {
        label: _('sources_loading')
    });
    if (loadingState !== (0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS) return null;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                className: "source-add",
                onClick: addOnClick,
                children: _('source_add')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                className: "source-export",
                href: "opmlexport",
                children: _('source_export')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                className: "source-opml",
                to: "/opml",
                children: _('source_opml')
            }),
            sources ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                children: sources.map(function(source) {
                    var _dirtySources_source_id;
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $b17ad773b592c4c7$export$2e2bcd8739ae039), {
                        isNew: newIds.has(source.id),
                        dirty: (_dirtySources_source_id = dirtySources[source.id]) !== null && _dirtySources_source_id !== void 0 ? _dirtySources_source_id : false,
                        source: source,
                        setSources: setSources,
                        spouts: spouts,
                        setSpouts: setSpouts,
                        setDirtySources: setDirtySources,
                        setNewIds: setNewIds,
                        showError: showError
                    }, source.id);
                })
            }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                children: _('no_sources')
            })
        ]
    });
}





var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");


var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");

var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");



var $eHaBZ = parcelRequire("eHaBZ");


var $52218fae2790199f$exports = {};
"use strict";
Object.defineProperty($52218fae2790199f$exports, "__esModule", {
    value: true
});
$52218fae2790199f$exports.useStateWithDeps = $52218fae2790199f$var$useStateWithDeps;

var $eHaBZ = parcelRequire("eHaBZ");
var $686edff819e0378d$exports = {};
"use strict";
Object.defineProperty($686edff819e0378d$exports, "__esModule", {
    value: true
});
$686edff819e0378d$exports.depsAreEqual = $686edff819e0378d$var$depsAreEqual;
function $686edff819e0378d$var$depsAreEqual(prevDeps, deps) {
    return prevDeps.length === deps.length && deps.every(function(dep, index) {
        return Object.is(dep, prevDeps[index]);
    });
}


var $77b0cc4e4744fb64$exports = {};
"use strict";
Object.defineProperty($77b0cc4e4744fb64$exports, "__esModule", {
    value: true
});
$77b0cc4e4744fb64$exports.isFunction = $77b0cc4e4744fb64$var$isFunction;
// eslint-disable-next-line @typescript-eslint/no-unsafe-function-type
function $77b0cc4e4744fb64$var$isFunction(input) {
    return typeof input === "function";
}


function $52218fae2790199f$var$_slicedToArray(r, e) {
    return $52218fae2790199f$var$_arrayWithHoles(r) || $52218fae2790199f$var$_iterableToArrayLimit(r, e) || $52218fae2790199f$var$_unsupportedIterableToArray(r, e) || $52218fae2790199f$var$_nonIterableRest();
}
function $52218fae2790199f$var$_nonIterableRest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $52218fae2790199f$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $52218fae2790199f$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $52218fae2790199f$var$_arrayLikeToArray(r, a) : void 0;
    }
}
function $52218fae2790199f$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $52218fae2790199f$var$_iterableToArrayLimit(r, l) {
    var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (null != t) {
        var e, n, i, u, a = [], f = !0, o = !1;
        try {
            if (i = (t = t.call(r)).next, 0 === l) {
                if (Object(t) !== t) return;
                f = !1;
            } else for(; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
        } catch (r) {
            o = !0, n = r;
        } finally{
            try {
                if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return;
            } finally{
                if (o) throw n;
            }
        }
        return a;
    }
}
function $52218fae2790199f$var$_arrayWithHoles(r) {
    if (Array.isArray(r)) return r;
}
/**
 * `useState` hook with an additional dependency array that resets
 * the state to the `initialState` param when the dependencies passed
 * in the `deps` array change.
 *
 * @param initialState
 * The state that will be set when the component mounts or the
 * dependencies change.
 *
 * It can also be a function which resolves to the state. If the state
 * is reset due to a change of dependencies, this function will be called with the previous
 * state (`undefined` for the first call upon mount).
 * @param deps Dependencies for this hook that resets the state to `initialState`
 */ function $52218fae2790199f$var$useStateWithDeps(initialState, deps) {
    var _useState = (0, $eHaBZ.useState)(function() {
        var state = (0, $77b0cc4e4744fb64$exports.isFunction)(initialState) ? initialState(undefined) : initialState;
        return {
            state: state,
            deps: deps
        };
    }), _useState2 = $52218fae2790199f$var$_slicedToArray(_useState, 2), stateAndDeps = _useState2[0], setStateAndDeps = _useState2[1];
    // Use the prevState pattern to detect dependency changes during rendering.
    // Calling setState during render (without refs) is the React-approved approach
    // for adjusting state based on changing inputs, and correctly supports
    // concurrent features like useTransition and useDeferredValue.
    var currentState = stateAndDeps.state;
    if (!(0, $686edff819e0378d$exports.depsAreEqual)(stateAndDeps.deps, deps)) {
        var nextState = (0, $77b0cc4e4744fb64$exports.isFunction)(initialState) ? initialState(stateAndDeps.state) : initialState;
        currentState = nextState;
        setStateAndDeps({
            state: nextState,
            deps: deps
        });
    }
    var updateState = (0, $eHaBZ.useCallback)(function updateState(newState) {
        setStateAndDeps(function(prev) {
            var nextState = (0, $77b0cc4e4744fb64$exports.isFunction)(newState) ? newState(prev.state) : newState;
            if (Object.is(prev.state, nextState)) return prev;
            return {
                state: nextState,
                deps: prev.deps
            };
        });
    }, []);
    return [
        currentState,
        updateState
    ];
}




var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");



/*!
* focus-trap 8.2.2
* @license MIT, https://github.com/focus-trap/focus-trap/blob/master/LICENSE
*/ 
var $2bfPH = parcelRequire("2bfPH");
/*!
* tabbable 6.5.0
* @license MIT, https://github.com/focus-trap/tabbable/blob/master/LICENSE
*/ // NOTE: separate `:not()` selectors has broader browser support than the newer
//  `:not([inert], [inert] *)` (Feb 2023)
var $863eb30dd7d7e7a9$var$candidateSelectors = [
    'input:not([inert]):not([inert] *)',
    'select:not([inert]):not([inert] *)',
    'textarea:not([inert]):not([inert] *)',
    'a[href]:not([inert]):not([inert] *)',
    'area[href]:not([inert]):not([inert] *)',
    'button:not([inert]):not([inert] *)',
    '[tabindex]:not(slot):not([inert]):not([inert] *)',
    'audio[controls]:not([inert]):not([inert] *)',
    'video[controls]:not([inert]):not([inert] *)',
    '[contenteditable]:not([contenteditable="false"]):not([inert]):not([inert] *)',
    'details>summary:first-of-type:not([inert]):not([inert] *)',
    'details:not([inert]):not([inert] *)'
];
var $863eb30dd7d7e7a9$var$candidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.join(',');
var $863eb30dd7d7e7a9$var$NoElement = typeof Element === 'undefined';
var $863eb30dd7d7e7a9$var$matches = $863eb30dd7d7e7a9$var$NoElement ? function matches() {} : Element.prototype.matches || Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector;
var $863eb30dd7d7e7a9$var$getRootNode = !$863eb30dd7d7e7a9$var$NoElement && Element.prototype.getRootNode ? function getRootNode(element) {
    var _element$getRootNode;
    return element === null || element === void 0 ? void 0 : (_element$getRootNode = element.getRootNode) === null || _element$getRootNode === void 0 ? void 0 : _element$getRootNode.call(element);
} : function(element) {
    return element === null || element === void 0 ? void 0 : element.ownerDocument;
};
/**
 * Determines if a node is inert or in an inert ancestor.
 * @param {Node} [node]
 * @param {boolean} [lookUp] If true and `node` is not inert, looks up at ancestors to
 *  see if any of them are inert. If false, only `node` itself is considered.
 * @returns {boolean} True if inert itself or by way of being in an inert ancestor.
 *  False if `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$_isInert = function isInert(node, lookUp) {
    var _node$getAttribute;
    if (lookUp === void 0) lookUp = true;
    // CAREFUL: JSDom does not support inert at all, so we can't use the `HTMLElement.inert`
    //  JS API property; we have to check the attribute, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's an active element
    var inertAtt = node === null || node === void 0 ? void 0 : (_node$getAttribute = node.getAttribute) === null || _node$getAttribute === void 0 ? void 0 : _node$getAttribute.call(node, 'inert');
    var inert = inertAtt === '' || inertAtt === 'true';
    // NOTE: this could also be handled with `node.matches('[inert], :is([inert] *)')`
    //  if it weren't for `matches()` not being a function on shadow roots; the following
    //  code works for any kind of node
    var result = inert || lookUp && node && // closest does not exist on shadow roots, so we fall back to a manual
    // lookup upward, in case it is not defined.
    (typeof node.closest === 'function' ? node.closest('[inert]') : $863eb30dd7d7e7a9$var$_isInert(node.parentNode));
    return result;
};
/**
 * Determines if a node's content is editable.
 * @param {Element} [node]
 * @returns True if it's content-editable; false if it's not or `node` is falsy.
 */ var $863eb30dd7d7e7a9$var$isContentEditable = function isContentEditable(node) {
    var _node$getAttribute2;
    // CAREFUL: JSDom does not support the `HTMLElement.isContentEditable` API so we have
    //  to use the attribute directly to check for this, which can either be empty or 'true';
    //  if it's `null` (not specified) or 'false', it's a non-editable element
    var attValue = node === null || node === void 0 ? void 0 : (_node$getAttribute2 = node.getAttribute) === null || _node$getAttribute2 === void 0 ? void 0 : _node$getAttribute2.call(node, 'contenteditable');
    return attValue === '' || attValue === 'true';
};
/**
 * @param {Element} el container to check in
 * @param {boolean} includeContainer add container to check
 * @param {(node: Element) => boolean} filter filter candidates
 * @returns {Element[]}
 */ var $863eb30dd7d7e7a9$var$getCandidates = function getCandidates(el, includeContainer, filter) {
    // even if `includeContainer=false`, we still have to check it for inertness because
    //  if it's inert (either by itself or via its parent), then all its children are inert
    if ($863eb30dd7d7e7a9$var$_isInert(el)) return [];
    var candidates = Array.prototype.slice.apply(el.querySelectorAll($863eb30dd7d7e7a9$var$candidateSelector));
    if (includeContainer && $863eb30dd7d7e7a9$var$matches.call(el, $863eb30dd7d7e7a9$var$candidateSelector)) candidates.unshift(el);
    candidates = candidates.filter(filter);
    return candidates;
};
/**
 * @callback GetShadowRoot
 * @param {Element} element to check for shadow root
 * @returns {ShadowRoot|boolean} ShadowRoot if available or boolean indicating if a shadowRoot is attached but not available.
 */ /**
 * @callback ShadowRootFilter
 * @param {Element} shadowHostNode the element which contains shadow content
 * @returns {boolean} true if a shadow root could potentially contain valid candidates.
 */ /**
 * @typedef {Object} CandidateScope
 * @property {Element} scopeParent contains inner candidates
 * @property {Element[]} candidates list of candidates found in the scope parent
 */ /**
 * @typedef {Object} IterativeOptions
 * @property {GetShadowRoot|boolean} getShadowRoot true if shadow support is enabled; falsy if not;
 *  if a function, implies shadow support is enabled and either returns the shadow root of an element
 *  or a boolean stating if it has an undisclosed shadow root
 * @property {(node: Element) => boolean} filter filter candidates
 * @property {boolean} flatten if true then result will flatten any CandidateScope into the returned list
 * @property {ShadowRootFilter} shadowRootFilter filter shadow roots;
 */ /**
 * @param {Element[]} elements list of element containers to match candidates from
 * @param {boolean} includeContainer add container list to check
 * @param {IterativeOptions} options
 * @returns {Array.<Element|CandidateScope>}
 */ var $863eb30dd7d7e7a9$var$_getCandidatesIteratively = function getCandidatesIteratively(elements, includeContainer, options) {
    var candidates = [];
    var elementsToCheck = Array.from(elements);
    while(elementsToCheck.length){
        var element = elementsToCheck.shift();
        if ($863eb30dd7d7e7a9$var$_isInert(element, false)) continue;
        if (element.tagName === 'SLOT') {
            // add shadow dom slot scope (slot itself cannot be focusable)
            var assigned = element.assignedElements();
            var content = assigned.length ? assigned : element.children;
            var nestedCandidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively(content, true, options);
            if (options.flatten) candidates.push.apply(candidates, nestedCandidates);
            else candidates.push({
                scopeParent: element,
                candidates: nestedCandidates
            });
        } else {
            // check candidate element
            var validCandidate = $863eb30dd7d7e7a9$var$matches.call(element, $863eb30dd7d7e7a9$var$candidateSelector);
            if (validCandidate && options.filter(element) && (includeContainer || !elements.includes(element))) candidates.push(element);
            // iterate over shadow content if possible
            var shadowRoot = element.shadowRoot || // check for an undisclosed shadow
            typeof options.getShadowRoot === 'function' && options.getShadowRoot(element);
            // no inert look up because we're already drilling down and checking for inertness
            //  on the way down, so all containers to this root node should have already been
            //  vetted as non-inert
            var validShadowRoot = !$863eb30dd7d7e7a9$var$_isInert(shadowRoot, false) && (!options.shadowRootFilter || options.shadowRootFilter(element));
            if (shadowRoot && validShadowRoot) {
                // add shadow dom scope IIF a shadow root node was given; otherwise, an undisclosed
                //  shadow exists, so look at light dom children as fallback BUT create a scope for any
                //  child candidates found because they're likely slotted elements (elements that are
                //  children of the web component element (which has the shadow), in the light dom, but
                //  slotted somewhere _inside_ the undisclosed shadow) -- the scope is created below,
                //  _after_ we return from this recursive call
                var _nestedCandidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively(shadowRoot === true ? element.children : shadowRoot.children, true, options);
                if (options.flatten) candidates.push.apply(candidates, _nestedCandidates);
                else candidates.push({
                    scopeParent: element,
                    candidates: _nestedCandidates
                });
            } else // there's not shadow so just dig into the element's (light dom) children
            //  __without__ giving the element special scope treatment
            elementsToCheck.unshift.apply(elementsToCheck, element.children);
        }
    }
    return candidates;
};
/**
 * @private
 * Determines if the node has an explicitly specified `tabindex` attribute.
 * @param {HTMLElement} node
 * @returns {boolean} True if so; false if not.
 */ var $863eb30dd7d7e7a9$var$hasTabIndex = function hasTabIndex(node) {
    return !isNaN(parseInt(node.getAttribute('tabindex'), 10));
};
/**
 * Determine the tab index of a given node.
 * @param {HTMLElement} node
 * @returns {number} Tab order (negative, 0, or positive number).
 * @throws {Error} If `node` is falsy.
 */ var $863eb30dd7d7e7a9$export$a4672efddb4181b8 = function getTabIndex(node) {
    if (!node) throw new Error('No node provided');
    if (node.tabIndex < 0) {
        // in Chrome, <details/>, <audio controls/> and <video controls/> elements get a default
        // `tabIndex` of -1 when the 'tabindex' attribute isn't specified in the DOM,
        // yet they are still part of the regular tab order; in FF, they get a default
        // `tabIndex` of 0; since Chrome still puts those elements in the regular tab
        // order, consider their tab index to be 0.
        // Also browsers do not return `tabIndex` correctly for contentEditable nodes;
        // so if they don't have a tabindex attribute specifically set, assume it's 0.
        if ((/^(AUDIO|VIDEO|DETAILS)$/.test(node.tagName) || $863eb30dd7d7e7a9$var$isContentEditable(node)) && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    }
    return node.tabIndex;
};
/**
 * Determine the tab index of a given node __for sort order purposes__.
 * @param {HTMLElement} node
 * @param {boolean} [isScope] True for a custom element with shadow root or slot that, by default,
 *  has tabIndex -1, but needs to be sorted by document order in order for its content to be
 *  inserted into the correct sort position.
 * @returns {number} Tab order (negative, 0, or positive number).
 */ var $863eb30dd7d7e7a9$var$getSortOrderTabIndex = function getSortOrderTabIndex(node, isScope) {
    var tabIndex = $863eb30dd7d7e7a9$export$a4672efddb4181b8(node);
    if (tabIndex < 0 && isScope && !$863eb30dd7d7e7a9$var$hasTabIndex(node)) return 0;
    return tabIndex;
};
var $863eb30dd7d7e7a9$var$sortOrderedTabbables = function sortOrderedTabbables(a, b) {
    return a.tabIndex === b.tabIndex ? a.documentOrder - b.documentOrder : a.tabIndex - b.tabIndex;
};
var $863eb30dd7d7e7a9$var$isInput = function isInput(node) {
    return node.tagName === 'INPUT';
};
var $863eb30dd7d7e7a9$var$isHiddenInput = function isHiddenInput(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === 'hidden';
};
var $863eb30dd7d7e7a9$var$isDetailsWithSummary = function isDetailsWithSummary(node) {
    var r = node.tagName === 'DETAILS' && Array.prototype.slice.apply(node.children).some(function(child) {
        return child.tagName === 'SUMMARY';
    });
    return r;
};
var $863eb30dd7d7e7a9$var$getCheckedRadio = function getCheckedRadio(nodes, form) {
    for(var i = 0; i < nodes.length; i++){
        if (nodes[i].checked && nodes[i].form === form) return nodes[i];
    }
};
var $863eb30dd7d7e7a9$var$isTabbableRadio = function isTabbableRadio(node) {
    if (!node.name) return true;
    var radioScope = node.form || $863eb30dd7d7e7a9$var$getRootNode(node);
    var queryRadios = function queryRadios(name) {
        return radioScope.querySelectorAll('input[type="radio"][name="' + name + '"]');
    };
    var radioSet;
    if (typeof window !== 'undefined' && typeof window.CSS !== 'undefined' && typeof window.CSS.escape === 'function') radioSet = queryRadios(window.CSS.escape(node.name));
    else try {
        radioSet = queryRadios(node.name);
    } catch (err) {
        // eslint-disable-next-line no-console
        console.error('Looks like you have a radio button with a name attribute containing invalid CSS selector characters and need the CSS.escape polyfill: %s', err.message);
        return false;
    }
    var checked = $863eb30dd7d7e7a9$var$getCheckedRadio(radioSet, node.form);
    return !checked || checked === node;
};
var $863eb30dd7d7e7a9$var$isRadio = function isRadio(node) {
    return $863eb30dd7d7e7a9$var$isInput(node) && node.type === 'radio';
};
var $863eb30dd7d7e7a9$var$isNonTabbableRadio = function isNonTabbableRadio(node) {
    return $863eb30dd7d7e7a9$var$isRadio(node) && !$863eb30dd7d7e7a9$var$isTabbableRadio(node);
};
// determines if a node is ultimately attached to the window's document
var $863eb30dd7d7e7a9$var$isNodeAttached = function isNodeAttached(node) {
    var _nodeRoot;
    // The root node is the shadow root if the node is in a shadow DOM; some document otherwise
    //  (but NOT _the_ document; see second 'If' comment below for more).
    // If rootNode is shadow root, it'll have a host, which is the element to which the shadow
    //  is attached, and the one we need to check if it's in the document or not (because the
    //  shadow, and all nodes it contains, is never considered in the document since shadows
    //  behave like self-contained DOMs; but if the shadow's HOST, which is part of the document,
    //  is hidden, or is not in the document itself but is detached, it will affect the shadow's
    //  visibility, including all the nodes it contains). The host could be any normal node,
    //  or a custom element (i.e. web component). Either way, that's the one that is considered
    //  part of the document, not the shadow root, nor any of its children (i.e. the node being
    //  tested).
    // To further complicate things, we have to look all the way up until we find a shadow HOST
    //  that is attached (or find none) because the node might be in nested shadows...
    // If rootNode is not a shadow root, it won't have a host, and so rootNode should be the
    //  document (per the docs) and while it's a Document-type object, that document does not
    //  appear to be the same as the node's `ownerDocument` for some reason, so it's safer
    //  to ignore the rootNode at this point, and use `node.ownerDocument`. Otherwise,
    //  using `rootNode.contains(node)` will _always_ be true we'll get false-positives when
    //  node is actually detached.
    // NOTE: If `nodeRootHost` or `node` happens to be the `document` itself (which is possible
    //  if a tabbable/focusable node was quickly added to the DOM, focused, and then removed
    //  from the DOM as in https://github.com/focus-trap/focus-trap-react/issues/905), then
    //  `ownerDocument` will be `null`, hence the optional chaining on it.
    var nodeRoot = node && $863eb30dd7d7e7a9$var$getRootNode(node);
    var nodeRootHost = (_nodeRoot = nodeRoot) === null || _nodeRoot === void 0 ? void 0 : _nodeRoot.host;
    // in some cases, a detached node will return itself as the root instead of a document or
    //  shadow root object, in which case, we shouldn't try to look further up the host chain
    var attached = false;
    if (nodeRoot && nodeRoot !== node) {
        var _nodeRootHost, _nodeRootHost$ownerDo, _node$ownerDocument;
        attached = !!((_nodeRootHost = nodeRootHost) !== null && _nodeRootHost !== void 0 && (_nodeRootHost$ownerDo = _nodeRootHost.ownerDocument) !== null && _nodeRootHost$ownerDo !== void 0 && _nodeRootHost$ownerDo.contains(nodeRootHost) || node !== null && node !== void 0 && (_node$ownerDocument = node.ownerDocument) !== null && _node$ownerDocument !== void 0 && _node$ownerDocument.contains(node));
        while(!attached && nodeRootHost){
            var _nodeRoot2, _nodeRootHost2, _nodeRootHost2$ownerD;
            // since it's not attached and we have a root host, the node MUST be in a nested shadow DOM,
            //  which means we need to get the host's host and check if that parent host is contained
            //  in (i.e. attached to) the document
            nodeRoot = $863eb30dd7d7e7a9$var$getRootNode(nodeRootHost);
            nodeRootHost = (_nodeRoot2 = nodeRoot) === null || _nodeRoot2 === void 0 ? void 0 : _nodeRoot2.host;
            attached = !!((_nodeRootHost2 = nodeRootHost) !== null && _nodeRootHost2 !== void 0 && (_nodeRootHost2$ownerD = _nodeRootHost2.ownerDocument) !== null && _nodeRootHost2$ownerD !== void 0 && _nodeRootHost2$ownerD.contains(nodeRootHost));
        }
    }
    return attached;
};
var $863eb30dd7d7e7a9$var$isZeroArea = function isZeroArea(node) {
    var _node$getBoundingClie = node.getBoundingClientRect(), width = _node$getBoundingClie.width, height = _node$getBoundingClie.height;
    return width === 0 && height === 0;
};
var $863eb30dd7d7e7a9$var$isHidden = function isHidden(node, _ref) {
    var displayCheck = _ref.displayCheck, getShadowRoot = _ref.getShadowRoot;
    if (displayCheck === 'full-native') {
        if ('checkVisibility' in node) {
            // Chrome >= 105, Edge >= 105, Firefox >= 106, Safari >= 17.4
            // @see https://developer.mozilla.org/en-US/docs/Web/API/Element/checkVisibility#browser_compatibility
            var visible = node.checkVisibility({
                // Checking opacity might be desirable for some use cases, but natively,
                // opacity zero elements _are_ focusable and tabbable.
                checkOpacity: false,
                opacityProperty: false,
                contentVisibilityAuto: true,
                visibilityProperty: true,
                // This is an alias for `visibilityProperty`. Contemporary browsers
                // support both. However, this alias has wider browser support (Chrome
                // >= 105 and Firefox >= 106, vs. Chrome >= 121 and Firefox >= 122), so
                // we include it anyway.
                checkVisibilityCSS: true
            });
            return !visible;
        }
    }
    // NOTE: visibility will be `undefined` if node is detached from the document
    //  (see notes about this further down), which means we will consider it visible
    //  (this is legacy behavior from a very long way back)
    // NOTE: we check this regardless of `displayCheck="none"` because this is a
    //  _visibility_ check, not a _display_ check
    var _getComputedStyle = getComputedStyle(node), visibility = _getComputedStyle.visibility;
    if (visibility === 'hidden' || visibility === 'collapse') return true;
    var isDirectSummary = $863eb30dd7d7e7a9$var$matches.call(node, 'details>summary:first-of-type');
    var nodeUnderDetails = isDirectSummary ? node.parentElement : node;
    if ($863eb30dd7d7e7a9$var$matches.call(nodeUnderDetails, 'details:not([open]) *')) return true;
    if (!displayCheck || displayCheck === 'full' || // full-native can run this branch when it falls through in case
    // Element#checkVisibility is unsupported
    displayCheck === 'full-native' || displayCheck === 'legacy-full') {
        if (typeof getShadowRoot === 'function') {
            // figure out if we should consider the node to be in an undisclosed shadow and use the
            //  'non-zero-area' fallback
            var originalNode = node;
            while(node){
                var parentElement = node.parentElement;
                var rootNode = $863eb30dd7d7e7a9$var$getRootNode(node);
                if (parentElement && !parentElement.shadowRoot && getShadowRoot(parentElement) === true // check if there's an undisclosed shadow
                ) // node has an undisclosed shadow which means we can only treat it as a black box, so we
                //  fall back to a non-zero-area test
                return $863eb30dd7d7e7a9$var$isZeroArea(node);
                else if (node.assignedSlot) // iterate up slot
                node = node.assignedSlot;
                else if (!parentElement && rootNode !== node.ownerDocument) // cross shadow boundary
                node = rootNode.host;
                else // iterate up normal dom
                node = parentElement;
            }
            node = originalNode;
        }
        // else, `getShadowRoot` might be true, but all that does is enable shadow DOM support
        //  (i.e. it does not also presume that all nodes might have undisclosed shadows); or
        //  it might be a falsy value, which means shadow DOM support is disabled
        // Since we didn't find it sitting in an undisclosed shadow (or shadows are disabled)
        //  now we can just test to see if it would normally be visible or not, provided it's
        //  attached to the main document.
        // NOTE: We must consider case where node is inside a shadow DOM and given directly to
        //  `isTabbable()` or `isFocusable()` -- regardless of `getShadowRoot` option setting.
        if ($863eb30dd7d7e7a9$var$isNodeAttached(node)) // this works wherever the node is: if there's at least one client rect, it's
        //  somehow displayed; it also covers the CSS 'display: contents' case where the
        //  node itself is hidden in place of its contents; and there's no need to search
        //  up the hierarchy either
        return !node.getClientRects().length;
        // Else, the node isn't attached to the document, which means the `getClientRects()`
        //  API will __always__ return zero rects (this can happen, for example, if React
        //  is used to render nodes onto a detached tree, as confirmed in this thread:
        //  https://github.com/facebook/react/issues/9117#issuecomment-284228870)
        //
        // It also means that even window.getComputedStyle(node).display will return `undefined`
        //  because styles are only computed for nodes that are in the document.
        //
        // NOTE: THIS HAS BEEN THE CASE FOR YEARS. It is not new, nor is it caused by tabbable
        //  somehow. Though it was never stated officially, anyone who has ever used tabbable
        //  APIs on nodes in detached containers has actually implicitly used tabbable in what
        //  was later (as of v5.2.0 on Apr 9, 2021) called `displayCheck="none"` mode -- essentially
        //  considering __everything__ to be visible because of the innability to determine styles.
        //
        // v6.0.0: As of this major release, the default 'full' option __no longer treats detached
        //  nodes as visible with the 'none' fallback.__
        if (displayCheck !== 'legacy-full') return true; // hidden
    // else, fallback to 'none' mode and consider the node visible
    } else if (displayCheck === 'non-zero-area') // NOTE: Even though this tests that the node's client rect is non-zero to determine
    //  whether it's displayed, and that a detached node will __always__ have a zero-area
    //  client rect, we don't special-case for whether the node is attached or not. In
    //  this mode, we do want to consider nodes that have a zero area to be hidden at all
    //  times, and that includes attached or not.
    return $863eb30dd7d7e7a9$var$isZeroArea(node);
    // visible, as far as we can tell, or per current `displayCheck=none` mode, we assume
    //  it's visible
    return false;
};
// form fields (nested) inside a disabled fieldset are not focusable/tabbable
//  unless they are in the _first_ <legend> element of the top-most disabled
//  fieldset
var $863eb30dd7d7e7a9$var$isDisabledFromFieldset = function isDisabledFromFieldset(node) {
    if (/^(INPUT|BUTTON|SELECT|TEXTAREA)$/.test(node.tagName)) {
        var parentNode = node.parentElement;
        // check if `node` is contained in a disabled <fieldset>
        while(parentNode){
            if (parentNode.tagName === 'FIELDSET' && parentNode.disabled) {
                // look for the first <legend> among the children of the disabled <fieldset>
                for(var i = 0; i < parentNode.children.length; i++){
                    var child = parentNode.children.item(i);
                    // when the first <legend> (in document order) is found
                    if (child.tagName === 'LEGEND') // if its parent <fieldset> is not nested in another disabled <fieldset>,
                    // return whether `node` is a descendant of its first <legend>
                    return $863eb30dd7d7e7a9$var$matches.call(parentNode, 'fieldset[disabled] *') ? true : !child.contains(node);
                }
                // the disabled <fieldset> containing `node` has no <legend>
                return true;
            }
            parentNode = parentNode.parentElement;
        }
    }
    // else, node's tabbable/focusable state should not be affected by a fieldset's
    //  enabled/disabled state
    return false;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable = function isNodeMatchingSelectorFocusable(options, node) {
    if (node.disabled || $863eb30dd7d7e7a9$var$isHiddenInput(node) || $863eb30dd7d7e7a9$var$isHidden(node, options) || // For a details element with a summary, the summary element gets the focus
    $863eb30dd7d7e7a9$var$isDetailsWithSummary(node) || $863eb30dd7d7e7a9$var$isDisabledFromFieldset(node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable = function isNodeMatchingSelectorTabbable(options, node) {
    if ($863eb30dd7d7e7a9$var$isNonTabbableRadio(node) || $863eb30dd7d7e7a9$export$a4672efddb4181b8(node) < 0 || !$863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node)) return false;
    return true;
};
var $863eb30dd7d7e7a9$var$isShadowRootTabbable = function isShadowRootTabbable(shadowHostNode) {
    var tabIndex = parseInt(shadowHostNode.getAttribute('tabindex'), 10);
    if (isNaN(tabIndex) || tabIndex >= 0) return true;
    // If a custom element has an explicit negative tabindex,
    // browsers will not allow tab targeting said element's children.
    return false;
};
/**
 * @param {Array.<Element|CandidateScope>} candidates
 * @returns Element[]
 */ var $863eb30dd7d7e7a9$var$_sortByOrder = function sortByOrder(candidates) {
    var regularTabbables = [];
    var orderedTabbables = [];
    candidates.forEach(function(item, i) {
        var isScope = !!item.scopeParent;
        var element = isScope ? item.scopeParent : item;
        var candidateTabindex = $863eb30dd7d7e7a9$var$getSortOrderTabIndex(element, isScope);
        var elements = isScope ? $863eb30dd7d7e7a9$var$_sortByOrder(item.candidates) : element;
        if (candidateTabindex === 0) isScope ? regularTabbables.push.apply(regularTabbables, elements) : regularTabbables.push(element);
        else orderedTabbables.push({
            documentOrder: i,
            tabIndex: candidateTabindex,
            item: item,
            isScope: isScope,
            content: elements
        });
    });
    return orderedTabbables.sort($863eb30dd7d7e7a9$var$sortOrderedTabbables).reduce(function(acc, sortable) {
        sortable.isScope ? acc.push.apply(acc, sortable.content) : acc.push(sortable.content);
        return acc;
    }, []).concat(regularTabbables);
};
var $863eb30dd7d7e7a9$export$17100aea90429aa7 = function tabbable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options),
        flatten: false,
        getShadowRoot: options.getShadowRoot,
        shadowRootFilter: $863eb30dd7d7e7a9$var$isShadowRootTabbable
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable.bind(null, options));
    return $863eb30dd7d7e7a9$var$_sortByOrder(candidates);
};
var $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700 = function focusable(container, options) {
    options = options || {};
    var candidates;
    if (options.getShadowRoot) candidates = $863eb30dd7d7e7a9$var$_getCandidatesIteratively([
        container
    ], options.includeContainer, {
        filter: $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options),
        flatten: true,
        getShadowRoot: options.getShadowRoot
    });
    else candidates = $863eb30dd7d7e7a9$var$getCandidates(container, options.includeContainer, $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable.bind(null, options));
    return candidates;
};
var $863eb30dd7d7e7a9$export$bebd5a1431fec25d = function isTabbable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$candidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorTabbable(options, node);
};
var $863eb30dd7d7e7a9$var$focusableCandidateSelector = /* #__PURE__ */ $863eb30dd7d7e7a9$var$candidateSelectors.concat('iframe:not([inert]):not([inert] *)').join(',');
var $863eb30dd7d7e7a9$export$4c063cf1350e6fed = function isFocusable(node, options) {
    options = options || {};
    if (!node) throw new Error('No node provided');
    if ($863eb30dd7d7e7a9$var$matches.call(node, $863eb30dd7d7e7a9$var$focusableCandidateSelector) === false) return false;
    return $863eb30dd7d7e7a9$var$isNodeMatchingSelectorFocusable(options, node);
};


function $197853feae65c1a7$var$_arrayLikeToArray(r, a) {
    (null == a || a > r.length) && (a = r.length);
    for(var e = 0, n = Array(a); e < a; e++)n[e] = r[e];
    return n;
}
function $197853feae65c1a7$var$_arrayWithoutHoles(r) {
    if (Array.isArray(r)) return $197853feae65c1a7$var$_arrayLikeToArray(r);
}
function $197853feae65c1a7$var$_createForOfIteratorHelper(r, e) {
    var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
    if (!t) {
        if (Array.isArray(r) || (t = $197853feae65c1a7$var$_unsupportedIterableToArray(r)) || e) {
            t && (r = t);
            var n = 0, F = function F() {};
            return {
                s: F,
                n: function n1() {
                    return n >= r.length ? {
                        done: true
                    } : {
                        done: false,
                        value: r[n++]
                    };
                },
                e: function e(r) {
                    throw r;
                },
                f: F
            };
        }
        throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
    }
    var o, a = true, u = false;
    return {
        s: function s() {
            t = t.call(r);
        },
        n: function n() {
            var _$r = t.next();
            return a = _$r.done, _$r;
        },
        e: function e(r) {
            u = true, o = r;
        },
        f: function f() {
            try {
                a || null == t.return || t.return();
            } finally{
                if (u) throw o;
            }
        }
    };
}
function $197853feae65c1a7$var$_defineProperty(e, r, t) {
    return (r = $197853feae65c1a7$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: true,
        configurable: true,
        writable: true
    }) : e[r] = t, e;
}
function $197853feae65c1a7$var$_iterableToArray(r) {
    if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}
function $197853feae65c1a7$var$_nonIterableSpread() {
    throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $197853feae65c1a7$var$ownKeys(e, r) {
    var t = Object.keys(e);
    if (Object.getOwnPropertySymbols) {
        var o = Object.getOwnPropertySymbols(e);
        r && (o = o.filter(function(r) {
            return Object.getOwnPropertyDescriptor(e, r).enumerable;
        })), t.push.apply(t, o);
    }
    return t;
}
function $197853feae65c1a7$var$_objectSpread2(e) {
    for(var r = 1; r < arguments.length; r++){
        var t = null != arguments[r] ? arguments[r] : {};
        r % 2 ? $197853feae65c1a7$var$ownKeys(Object(t), true).forEach(function(r) {
            $197853feae65c1a7$var$_defineProperty(e, r, t[r]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : $197853feae65c1a7$var$ownKeys(Object(t)).forEach(function(r) {
            Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
        });
    }
    return e;
}
function $197853feae65c1a7$var$_toConsumableArray(r) {
    return $197853feae65c1a7$var$_arrayWithoutHoles(r) || $197853feae65c1a7$var$_iterableToArray(r) || $197853feae65c1a7$var$_unsupportedIterableToArray(r) || $197853feae65c1a7$var$_nonIterableSpread();
}
function $197853feae65c1a7$var$_toPrimitive(t, r) {
    if ("object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r);
        if ("object" != (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i))) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
function $197853feae65c1a7$var$_toPropertyKey(t) {
    var i = $197853feae65c1a7$var$_toPrimitive(t, "string");
    return "symbol" == (typeof i === "undefined" ? "undefined" : (0, $2bfPH._)(i)) ? i : i + "";
}
function $197853feae65c1a7$var$_unsupportedIterableToArray(r, a) {
    if (r) {
        if ("string" == typeof r) return $197853feae65c1a7$var$_arrayLikeToArray(r, a);
        var t = ({}).toString.call(r).slice(8, -1);
        return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? $197853feae65c1a7$var$_arrayLikeToArray(r, a) : void 0;
    }
}
var $197853feae65c1a7$var$activeFocusTraps = {
    // Returns the trap from the top of the stack.
    getActiveTrap: function getActiveTrap(trapStack) {
        if ((trapStack === null || trapStack === void 0 ? void 0 : trapStack.length) > 0) return trapStack[trapStack.length - 1];
        return null;
    },
    // Pauses the currently active trap, then adds a new trap to the stack.
    activateTrap: function activateTrap(trapStack, trap) {
        var activeTrap = $197853feae65c1a7$var$activeFocusTraps.getActiveTrap(trapStack);
        if (trap !== activeTrap) $197853feae65c1a7$var$activeFocusTraps.pauseTrap(trapStack);
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex === -1) trapStack.push(trap);
        else {
            // move this existing trap to the front of the queue
            trapStack.splice(trapIndex, 1);
            trapStack.push(trap);
        }
    },
    // Removes the trap from the top of the stack, then unpauses the next trap down.
    deactivateTrap: function deactivateTrap(trapStack, trap) {
        var trapIndex = trapStack.indexOf(trap);
        if (trapIndex !== -1) trapStack.splice(trapIndex, 1);
        $197853feae65c1a7$var$activeFocusTraps.unpauseTrap(trapStack);
    },
    // Pauses the trap at the top of the stack.
    pauseTrap: function pauseTrap(trapStack) {
        var activeTrap = $197853feae65c1a7$var$activeFocusTraps.getActiveTrap(trapStack);
        activeTrap === null || activeTrap === void 0 || activeTrap._setPausedState(true);
    },
    // Unpauses the trap at the top of the stack.
    unpauseTrap: function unpauseTrap(trapStack) {
        var activeTrap = $197853feae65c1a7$var$activeFocusTraps.getActiveTrap(trapStack);
        if (activeTrap && !activeTrap._isManuallyPaused()) activeTrap._setPausedState(false);
    }
};
var $197853feae65c1a7$var$isSelectableInput = function isSelectableInput(node) {
    return node.tagName && node.tagName.toLowerCase() === 'input' && typeof node.select === 'function';
};
var $197853feae65c1a7$var$isEscapeEvent = function isEscapeEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Escape' || (e === null || e === void 0 ? void 0 : e.key) === 'Esc' || (e === null || e === void 0 ? void 0 : e.keyCode) === 27;
};
var $197853feae65c1a7$var$isTabEvent = function isTabEvent(e) {
    return (e === null || e === void 0 ? void 0 : e.key) === 'Tab' || (e === null || e === void 0 ? void 0 : e.keyCode) === 9;
};
// checks for TAB by default
var $197853feae65c1a7$var$isKeyForward = function isKeyForward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && !e.shiftKey;
};
// checks for SHIFT+TAB by default
var $197853feae65c1a7$var$isKeyBackward = function isKeyBackward(e) {
    return $197853feae65c1a7$var$isTabEvent(e) && e.shiftKey;
};
var $197853feae65c1a7$var$delay = function delay(fn) {
    return setTimeout(fn, 0);
};
/**
 * Get an option's value when it could be a plain value, or a handler that provides
 *  the value.
 * @param {*} value Option's value to check.
 * @param {...*} [params] Any parameters to pass to the handler, if `value` is a function.
 * @returns {*} The `value`, or the handler's returned value.
 */ var $197853feae65c1a7$var$valueOrHandler = function valueOrHandler(value) {
    for(var _len = arguments.length, params = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)params[_key - 1] = arguments[_key];
    return typeof value === 'function' ? value.apply(void 0, params) : value;
};
var $197853feae65c1a7$var$getActualTarget = function getActualTarget(event) {
    // NOTE: If the trap is _inside_ a shadow DOM, event.target will always be the
    //  shadow host. However, event.target.composedPath() will be an array of
    //  nodes "clicked" from inner-most (the actual element inside the shadow) to
    //  outer-most (the host HTML document). If we have access to composedPath(),
    //  then use its first element; otherwise, fall back to event.target (and
    //  this only works for an _open_ shadow DOM; otherwise,
    //  composedPath()[0] === event.target always).
    return event.target.shadowRoot && typeof event.composedPath === 'function' ? event.composedPath()[0] : event.target;
};
// NOTE: this must be _outside_ `createFocusTrap()` to make sure all traps in this
//  current instance use the same stack if `userOptions.trapStack` isn't specified
var $197853feae65c1a7$var$internalTrapStack = [];
var $197853feae65c1a7$export$360440dfcba94c00 = function createFocusTrap(elements, userOptions) {
    // SSR: a live trap shouldn't be created in this type of environment so this
    //  should be safe code to execute if the `document` option isn't specified
    var doc = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.document) || document;
    var trapStack = (userOptions === null || userOptions === void 0 ? void 0 : userOptions.trapStack) || $197853feae65c1a7$var$internalTrapStack;
    var config = $197853feae65c1a7$var$_objectSpread2({
        returnFocusOnDeactivate: true,
        escapeDeactivates: true,
        delayInitialFocus: true,
        delayReturnFocus: true,
        isolateSubtrees: false,
        isKeyForward: $197853feae65c1a7$var$isKeyForward,
        isKeyBackward: $197853feae65c1a7$var$isKeyBackward
    }, userOptions);
    var state = {
        // containers given to createFocusTrap()
        /** @type {Array<HTMLElement>} */ containers: [],
        // list of objects identifying tabbable nodes in `containers` in the trap
        // NOTE: it's possible that a group has no tabbable nodes if nodes get removed while the trap
        //  is active, but the trap should never get to a state where there isn't at least one group
        //  with at least one tabbable node in it (that would lead to an error condition that would
        //  result in an error being thrown)
        /** @type {Array<{
     *    container: HTMLElement,
     *    tabbableNodes: Array<HTMLElement>, // empty if none
     *    focusableNodes: Array<HTMLElement>, // empty if none
     *    posTabIndexesFound: boolean,
     *    firstTabbableNode: HTMLElement|undefined,
     *    lastTabbableNode: HTMLElement|undefined,
     *    firstDomTabbableNode: HTMLElement|undefined,
     *    lastDomTabbableNode: HTMLElement|undefined,
     *    nextTabbableNode: (node: HTMLElement, forward: boolean) => HTMLElement|undefined
     *  }>}
     */ containerGroups: [],
        // same order/length as `containers` list
        // references to objects in `containerGroups`, but only those that actually have
        //  tabbable nodes in them
        // NOTE: same order as `containers` and `containerGroups`, but __not necessarily__
        //  the same length
        tabbableGroups: [],
        // references to nodes that are siblings to the ancestors of this trap's containers.
        /** @type {Set<HTMLElement>} */ adjacentElements: new Set(),
        // references to nodes that were inert or aria-hidden before the trap was activated.
        /** @type {Set<HTMLElement>} */ alreadySilent: new Set(),
        nodeFocusedBeforeActivation: null,
        mostRecentlyFocusedNode: null,
        active: false,
        paused: false,
        manuallyPaused: false,
        // timer ID for when delayInitialFocus is true and initial focus in this trap
        //  has been delayed during activation
        delayInitialFocusTimer: undefined,
        // the most recent KeyboardEvent for the configured nav key (typically [SHIFT+]TAB), if any
        recentNavEvent: undefined
    };
    var trap; // eslint-disable-line prefer-const -- some private functions reference it, and its methods reference private functions, so we must declare here and define later
    /**
   * Gets a configuration option value.
   * @param {Object|undefined} configOverrideOptions If true, and option is defined in this set,
   *  value will be taken from this object. Otherwise, value will be taken from base configuration.
   * @param {string} optionName Name of the option whose value is sought.
   * @param {string|undefined} [configOptionName] Name of option to use __instead of__ `optionName`
   *  IIF `configOverrideOptions` is not defined. Otherwise, `optionName` is used.
   */ var getOption = function getOption(configOverrideOptions, optionName, configOptionName) {
        return configOverrideOptions && configOverrideOptions[optionName] !== undefined ? configOverrideOptions[optionName] : config[configOptionName || optionName];
    };
    /**
   * Finds the index of the container that contains the element.
   * @param {HTMLElement} element
   * @param {Event} [event] If available, and `element` isn't directly found in any container,
   *  the event's composed path is used to see if includes any known trap containers in the
   *  case where the element is inside a Shadow DOM.
   * @returns {number} Index of the container in either `state.containers` or
   *  `state.containerGroups` (the order/length of these lists are the same); -1
   *  if the element isn't found.
   */ var findContainerIndex = function findContainerIndex(element, event) {
        var composedPath = typeof (event === null || event === void 0 ? void 0 : event.composedPath) === 'function' ? event.composedPath() : undefined;
        // NOTE: search `containerGroups` because it's possible a group contains no tabbable
        //  nodes, but still contains focusable nodes (e.g. if they all have `tabindex=-1`)
        //  and we still need to find the element in there
        return state.containerGroups.findIndex(function(_ref) {
            var container = _ref.container, tabbableNodes = _ref.tabbableNodes;
            return container.contains(element) || //  web components if the `tabbableOptions.getShadowRoot` option was used for
            //  the trap, enabling shadow DOM support in tabbable (`Node.contains()` doesn't
            //  look inside web components even if open)
            (composedPath === null || composedPath === void 0 ? void 0 : composedPath.includes(container)) || tabbableNodes.find(function(node) {
                return node === element;
            });
        });
    };
    /**
   * Gets the node for the given option, which is expected to be an option that
   *  can be either a DOM node, a string that is a selector to get a node, `false`
   *  (if a node is explicitly NOT given), or a function that returns any of these
   *  values.
   * @param {string} optionName
   * @param {Object} options
   * @param {boolean} [options.hasFallback] True if the option could be a selector string
   *  and the option allows for a fallback scenario in the case where the selector is
   *  valid but does not match a node (i.e. the queried node doesn't exist in the DOM).
   * @param {Array} [options.params] Params to pass to the option if it's a function.
   * @returns {undefined | null | false | HTMLElement | SVGElement} Returns
   *  `undefined` if the option is not specified; `null` if the option didn't resolve
   *  to a node but `options.hasFallback=true`, `false` if the option resolved to `false`
   *  (node explicitly not given); otherwise, the resolved DOM node.
   * @throws {Error} If the option is set, not `false`, and is not, or does not
   *  resolve to a node, unless the option is a selector string and `options.hasFallback=true`.
   */ var getNodeForOption = function getNodeForOption(optionName) {
        var _ref2 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {}, _ref2$hasFallback = _ref2.hasFallback, hasFallback = _ref2$hasFallback === void 0 ? false : _ref2$hasFallback, _ref2$params = _ref2.params, params = _ref2$params === void 0 ? [] : _ref2$params;
        var optionValue = config[optionName];
        if (typeof optionValue === 'function') optionValue = optionValue.apply(void 0, $197853feae65c1a7$var$_toConsumableArray(params));
        if (optionValue === true) optionValue = undefined; // use default value
        if (!optionValue) {
            if (optionValue === undefined || optionValue === false) return optionValue;
            // else, empty string (invalid), null (invalid), 0 (invalid)
            throw new Error("`".concat(optionName, "` was specified but was not a node, or did not return a node"));
        }
        var node = optionValue; // could be HTMLElement, SVGElement, or non-empty string at this point
        if (typeof optionValue === 'string') {
            try {
                node = doc.querySelector(optionValue); // resolve to node, or null if fails
            } catch (err) {
                throw new Error("`".concat(optionName, "` appears to be an invalid selector; error=\"").concat(err.message, "\""));
            }
            if (!node) {
                if (!hasFallback) throw new Error("`".concat(optionName, "` as selector refers to no known node"));
            // else, `node` MUST be `null` because that's what `Document.querySelector()` returns
            //  if the selector is valid but doesn't match anything
            }
        }
        return node;
    };
    /**
   * Gets the current activeElement. If it's a web-component and has open shadow-root
   * it will recursively search inside shadow roots for the "true" activeElement.
   *
   * @param {Document | ShadowRoot} el
   *
   * @returns {HTMLElement|null} The element that currently has the focus. `null` if a focused element isn't found.
   **/ var _getActiveElement = function getActiveElement(el) {
        var activeElement = el.activeElement;
        if (!activeElement) return null;
        if (activeElement.shadowRoot && activeElement.shadowRoot.activeElement !== null) return _getActiveElement(activeElement.shadowRoot);
        return activeElement;
    };
    var getInitialFocusNode = function getInitialFocusNode() {
        var node = getNodeForOption('initialFocus', {
            hasFallback: true
        });
        // false explicitly indicates we want no initialFocus at all
        if (node === false) return false;
        if (node === undefined || node && !(0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(node, config.tabbableOptions)) {
            var activeElement = _getActiveElement(doc);
            // option not specified nor focusable: use fallback options
            if (findContainerIndex(activeElement) >= 0) node = activeElement;
            else {
                var firstTabbableGroup = state.tabbableGroups[0];
                var firstTabbableNode = firstTabbableGroup && firstTabbableGroup.firstTabbableNode;
                // NOTE: `fallbackFocus` option function cannot return `false` (not supported)
                node = firstTabbableNode || getNodeForOption('fallbackFocus');
            }
        } else if (node === null) // option is a VALID selector string that doesn't yield a node: use the `fallbackFocus`
        //  option instead of the default behavior when the option isn't specified at all
        node = getNodeForOption('fallbackFocus');
        if (!node) throw new Error('Your focus-trap needs to have at least one focusable element');
        return node;
    };
    var updateTabbableNodes = function updateTabbableNodes() {
        state.containerGroups = state.containers.map(function(container) {
            var tabbableNodes = (0, $863eb30dd7d7e7a9$export$17100aea90429aa7)(container, config.tabbableOptions);
            // NOTE: if we have tabbable nodes, we must have focusable nodes; focusable nodes
            //  are a superset of tabbable nodes since nodes with negative `tabindex` attributes
            //  are focusable but not tabbable
            var focusableNodes = (0, $863eb30dd7d7e7a9$export$ecc6d1fcdff4f700)(container, config.tabbableOptions);
            var firstTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[0] : undefined;
            var lastTabbableNode = tabbableNodes.length > 0 ? tabbableNodes[tabbableNodes.length - 1] : undefined;
            var firstDomTabbableNode = focusableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var lastDomTabbableNode = focusableNodes.slice().reverse().find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(node);
            });
            var posTabIndexesFound = !!tabbableNodes.find(function(node) {
                return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(node) > 0;
            });
            return {
                container: container,
                tabbableNodes: tabbableNodes,
                focusableNodes: focusableNodes,
                /** True if at least one node with positive `tabindex` was found in this container. */ posTabIndexesFound: posTabIndexesFound,
                /** First tabbable node in container, __tabindex__ order; `undefined` if none. */ firstTabbableNode: firstTabbableNode,
                /** Last tabbable node in container, __tabindex__ order; `undefined` if none. */ lastTabbableNode: lastTabbableNode,
                // NOTE: DOM order is NOT NECESSARILY "document position" order, but figuring that out
                //  would require more than just https://developer.mozilla.org/en-US/docs/Web/API/Node/compareDocumentPosition
                //  because that API doesn't work with Shadow DOM as well as it should (@see
                //  https://github.com/whatwg/dom/issues/320) and since this first/last is only needed, so far,
                //  to address an edge case related to positive tabindex support, this seems like a much easier,
                //  "close enough most of the time" alternative for positive tabindexes which should generally
                //  be avoided anyway...
                /** First tabbable node in container, __DOM__ order; `undefined` if none. */ firstDomTabbableNode: firstDomTabbableNode,
                /** Last tabbable node in container, __DOM__ order; `undefined` if none. */ lastDomTabbableNode: lastDomTabbableNode,
                /**
         * Finds the __tabbable__ node that follows the given node in the specified direction,
         *  in this container, if any.
         * @param {HTMLElement} node
         * @param {boolean} [forward] True if going in forward tab order; false if going
         *  in reverse.
         * @returns {HTMLElement|undefined} The next tabbable node, if any.
         */ nextTabbableNode: function nextTabbableNode(node) {
                    var forward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;
                    var nodeIdx = tabbableNodes.indexOf(node);
                    if (nodeIdx < 0) {
                        // either not tabbable nor focusable, or was focused but not tabbable (negative tabindex):
                        //  since `node` should at least have been focusable, we assume that's the case and mimic
                        //  what browsers do, which is set focus to the next node in __document position order__,
                        //  regardless of positive tabindexes, if any -- and for reasons explained in the NOTE
                        //  above related to `firstDomTabbable` and `lastDomTabbable` properties, we fall back to
                        //  basic DOM order
                        if (forward) return focusableNodes.slice(focusableNodes.indexOf(node) + 1).find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                        return focusableNodes.slice(0, focusableNodes.indexOf(node)).reverse().find(function(el) {
                            return (0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(el);
                        });
                    }
                    return tabbableNodes[nodeIdx + (forward ? 1 : -1)];
                }
            };
        });
        state.tabbableGroups = state.containerGroups.filter(function(group) {
            return group.tabbableNodes.length > 0;
        });
        // throw if no groups have tabbable nodes and we don't have a fallback focus node either
        if (state.tabbableGroups.length <= 0 && !getNodeForOption('fallbackFocus') // returning false not supported for this option
        ) throw new Error('Your focus-trap must have at least one container with at least one tabbable node in it at all times');
        // NOTE: Positive tabindexes are only properly supported in single-container traps because
        //  doing it across multiple containers where tabindexes could be all over the place
        //  would require Tabbable to support multiple containers, would require additional
        //  specialized Shadow DOM support, and would require Tabbable's multi-container support
        //  to look at those containers in document position order rather than user-provided
        //  order (as they are treated in Focus-trap, for legacy reasons). See discussion on
        //  https://github.com/focus-trap/focus-trap/issues/375 for more details.
        if (state.containerGroups.find(function(g) {
            return g.posTabIndexesFound;
        }) && state.containerGroups.length > 1) throw new Error("At least one node with a positive tabindex was found in one of your focus-trap's multiple containers. Positive tabindexes are only supported in single-container focus-traps.");
    };
    var _tryFocus = function tryFocus(node) {
        if (node === false) return;
        if (node === _getActiveElement(document)) return;
        if (!node || !node.focus) {
            _tryFocus(getInitialFocusNode());
            return;
        }
        node.focus({
            preventScroll: !!config.preventScroll
        });
        // NOTE: focus() API does not trigger focusIn event so set MRU node manually
        state.mostRecentlyFocusedNode = node;
        if ($197853feae65c1a7$var$isSelectableInput(node)) node.select();
    };
    var getReturnFocusNode = function getReturnFocusNode(previousActiveElement) {
        var node = getNodeForOption('setReturnFocus', {
            params: [
                previousActiveElement
            ]
        });
        return node ? node : node === false ? false : previousActiveElement;
    };
    /**
   * Finds the next node (in either direction) where focus should move according to a
   *  keyboard focus-in event.
   * @param {Object} params
   * @param {Node} [params.target] Known target __from which__ to navigate, if any.
   * @param {KeyboardEvent|FocusEvent} [params.event] Event to use if `target` isn't known (event
   *  will be used to determine the `target`). Ignored if `target` is specified.
   * @param {boolean} [params.isBackward] True if focus should move backward.
   * @returns {Node|undefined} The next node, or `undefined` if a next node couldn't be
   *  determined given the current state of the trap.
   */ var findNextNavNode = function findNextNavNode(_ref3) {
        var target = _ref3.target, event = _ref3.event, _ref3$isBackward = _ref3.isBackward, isBackward = _ref3$isBackward === void 0 ? false : _ref3$isBackward;
        target = target || $197853feae65c1a7$var$getActualTarget(event);
        updateTabbableNodes();
        var destinationNode = null;
        if (state.tabbableGroups.length > 0) {
            // make sure the target is actually contained in a group
            // NOTE: the target may also be the container itself if it's focusable
            //  with tabIndex='-1' and was given initial focus
            var containerIndex = findContainerIndex(target, event);
            var containerGroup = containerIndex >= 0 ? state.containerGroups[containerIndex] : undefined;
            if (containerIndex < 0) {
                // target not found in any group: quite possible focus has escaped the trap,
                //  so bring it back into...
                if (isBackward) // ...the last node in the last group
                destinationNode = state.tabbableGroups[state.tabbableGroups.length - 1].lastTabbableNode;
                else // ...the first node in the first group
                destinationNode = state.tabbableGroups[0].firstTabbableNode;
            } else if (isBackward) {
                // REVERSE
                // is the target the first tabbable node in a group?
                var startOfGroupIndex = state.tabbableGroups.findIndex(function(_ref4) {
                    var firstTabbableNode = _ref4.firstTabbableNode;
                    return target === firstTabbableNode;
                });
                if (startOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target, false))) // an exception case where the target is either the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle shift+tab as if focus were on the container's
                //  first tabbable node, and go to the last tabbable node of the LAST group
                startOfGroupIndex = containerIndex;
                if (startOfGroupIndex >= 0) {
                    // YES: then shift+tab should go to the last tabbable node in the
                    //  previous group (and wrap around to the last tabbable node of
                    //  the LAST group if it's the first tabbable node of the FIRST group)
                    var destinationGroupIndex = startOfGroupIndex === 0 ? state.tabbableGroups.length - 1 : startOfGroupIndex - 1;
                    var destinationGroup = state.tabbableGroups[destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? destinationGroup.lastTabbableNode : destinationGroup.lastDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target, false);
            } else {
                // FORWARD
                // is the target the last tabbable node in a group?
                var lastOfGroupIndex = state.tabbableGroups.findIndex(function(_ref5) {
                    var lastTabbableNode = _ref5.lastTabbableNode;
                    return target === lastTabbableNode;
                });
                if (lastOfGroupIndex < 0 && (containerGroup.container === target || (0, $863eb30dd7d7e7a9$export$4c063cf1350e6fed)(target, config.tabbableOptions) && !(0, $863eb30dd7d7e7a9$export$bebd5a1431fec25d)(target, config.tabbableOptions) && !containerGroup.nextTabbableNode(target))) // an exception case where the target is the container itself, or
                //  a non-tabbable node that was given focus (i.e. tabindex is negative
                //  and user clicked on it or node was programmatically given focus)
                //  and is not followed by any other tabbable node, in which
                //  case, we should handle tab as if focus were on the container's
                //  last tabbable node, and go to the first tabbable node of the FIRST group
                lastOfGroupIndex = containerIndex;
                if (lastOfGroupIndex >= 0) {
                    // YES: then tab should go to the first tabbable node in the next
                    //  group (and wrap around to the first tabbable node of the FIRST
                    //  group if it's the last tabbable node of the LAST group)
                    var _destinationGroupIndex = lastOfGroupIndex === state.tabbableGroups.length - 1 ? 0 : lastOfGroupIndex + 1;
                    var _destinationGroup = state.tabbableGroups[_destinationGroupIndex];
                    destinationNode = (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(target) >= 0 ? _destinationGroup.firstTabbableNode : _destinationGroup.firstDomTabbableNode;
                } else if (!$197853feae65c1a7$var$isTabEvent(event)) // user must have customized the nav keys so we have to move focus manually _within_
                //  the active group: do this based on the order determined by tabbable()
                destinationNode = containerGroup.nextTabbableNode(target);
            }
        } else // no groups available
        // NOTE: the fallbackFocus option does not support returning false to opt-out
        destinationNode = getNodeForOption('fallbackFocus');
        return destinationNode;
    };
    // This needs to be done on mousedown and touchstart instead of click
    // so that it precedes the focus event.
    var checkPointerDown = function checkPointerDown(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) // allow the click since it occurred inside the trap
        return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) {
            // immediately deactivate the trap
            trap.deactivate({
                // NOTE: by setting `returnFocus: false`, deactivate() will do nothing,
                //  which will result in the outside click setting focus to the node
                //  that was clicked (and if not focusable, to "nothing"); by setting
                //  `returnFocus: true`, we'll attempt to re-focus the node originally-focused
                //  on activation (or the configured `setReturnFocus` node), whether the
                //  outside click was on a focusable node or not
                returnFocus: config.returnFocusOnDeactivate
            });
            return;
        }
        // This is needed for mobile devices.
        // (If we'll only let `click` events through,
        // then on mobile they will be blocked anyways if `touchstart` is blocked.)
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) // allow the click outside the trap to take place
        return;
        // otherwise, prevent the click
        e.preventDefault();
    };
    // In case focus escapes the trap for some strange reason, pull it back in.
    // NOTE: the focusIn event is NOT cancelable, so if focus escapes, it may cause unexpected
    //  scrolling if the node that got focused was out of view; there's nothing we can do to
    //  prevent that from happening by the time we discover that focus escaped
    var checkFocusIn = function checkFocusIn(event) {
        var target = $197853feae65c1a7$var$getActualTarget(event);
        var targetContained = findContainerIndex(target, event) >= 0;
        // In Firefox when you Tab out of an iframe the Document is briefly focused.
        if (targetContained || target instanceof Document) {
            if (targetContained) state.mostRecentlyFocusedNode = target;
        } else {
            // escaped! pull it back in to where it just left
            event.stopImmediatePropagation();
            // focus will escape if the MRU node had a positive tab index and user tried to nav forward;
            //  it will also escape if the MRU node had a 0 tab index and user tried to nav backward
            //  toward a node with a positive tab index
            var nextNode; // next node to focus, if we find one
            var navAcrossContainers = true;
            if (state.mostRecentlyFocusedNode) {
                if ((0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(state.mostRecentlyFocusedNode) > 0) {
                    // MRU container index must be >=0 otherwise we wouldn't have it as an MRU node...
                    var mruContainerIdx = findContainerIndex(state.mostRecentlyFocusedNode);
                    // there MAY not be any tabbable nodes in the container if there are at least 2 containers
                    //  and the MRU node is focusable but not tabbable (focus-trap requires at least 1 container
                    //  with at least one tabbable node in order to function, so this could be the other container
                    //  with nothing tabbable in it)
                    var tabbableNodes = state.containerGroups[mruContainerIdx].tabbableNodes;
                    if (tabbableNodes.length > 0) {
                        // MRU tab index MAY not be found if the MRU node is focusable but not tabbable
                        var mruTabIdx = tabbableNodes.findIndex(function(node) {
                            return node === state.mostRecentlyFocusedNode;
                        });
                        if (mruTabIdx >= 0) {
                            if (config.isKeyForward(state.recentNavEvent)) {
                                if (mruTabIdx + 1 < tabbableNodes.length) {
                                    nextNode = tabbableNodes[mruTabIdx + 1];
                                    navAcrossContainers = false;
                                }
                            } else if (mruTabIdx - 1 >= 0) {
                                nextNode = tabbableNodes[mruTabIdx - 1];
                                navAcrossContainers = false;
                            }
                        // else, don't find in container order without considering direction too
                        }
                    }
                // else, no tabbable nodes in that container (which means we must have at least one other
                //  container with at least one tabbable node in it, otherwise focus-trap would've thrown
                //  an error the last time updateTabbableNodes() was run): find next node among all known
                //  containers
                } else // check to see if there's at least one tabbable node with a positive tab index inside
                //  the trap because focus seems to escape when navigating backward from a tabbable node
                //  with tabindex=0 when this is the case (instead of wrapping to the tabbable node with
                //  the greatest positive tab index like it should)
                if (!state.containerGroups.some(function(g) {
                    return g.tabbableNodes.some(function(n) {
                        return (0, $863eb30dd7d7e7a9$export$a4672efddb4181b8)(n) > 0;
                    });
                })) // no containers with tabbable nodes with positive tab indexes which means the focus
                //  escaped for some other reason and we should just execute the fallback to the
                //  MRU node or initial focus node, if any
                navAcrossContainers = false;
            } else // no MRU node means we're likely in some initial condition when the trap has just
            //  been activated and initial focus hasn't been given yet, in which case we should
            //  fall through to trying to focus the initial focus node, which is what should
            //  happen below at this point in the logic
            navAcrossContainers = false;
            if (navAcrossContainers) nextNode = findNextNavNode({
                // move FROM the MRU node, not event-related node (which will be the node that is
                //  outside the trap causing the focus escape we're trying to fix)
                target: state.mostRecentlyFocusedNode,
                isBackward: config.isKeyBackward(state.recentNavEvent)
            });
            if (nextNode) _tryFocus(nextNode);
            else _tryFocus(state.mostRecentlyFocusedNode || getInitialFocusNode());
        }
        state.recentNavEvent = undefined; // clear
    };
    // Hijack key nav events on the first and last focusable nodes of the trap,
    // in order to prevent focus from escaping. If it escapes for even a
    // moment it can end up scrolling the page and causing confusion so we
    // kind of need to capture the action at the keydown phase.
    var checkKeyNav = function checkKeyNav(event) {
        var isBackward = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
        state.recentNavEvent = event;
        var destinationNode = findNextNavNode({
            event: event,
            isBackward: isBackward
        });
        if (destinationNode) {
            if ($197853feae65c1a7$var$isTabEvent(event)) // since tab natively moves focus, we wouldn't have a destination node unless we
            //  were on the edge of a container and had to move to the next/previous edge, in
            //  which case we want to prevent default to keep the browser from moving focus
            //  to where it normally would
            event.preventDefault();
            _tryFocus(destinationNode);
        }
    // else, let the browser take care of [shift+]tab and move the focus
    };
    var checkTabKey = function checkTabKey(event) {
        if (config.isKeyForward(event) || config.isKeyBackward(event)) checkKeyNav(event, config.isKeyBackward(event));
    };
    // we use a different event phase for the Escape key to allow canceling the event and checking for this in escapeDeactivates
    var checkEscapeKey = function checkEscapeKey(event) {
        if ($197853feae65c1a7$var$isEscapeEvent(event) && $197853feae65c1a7$var$valueOrHandler(config.escapeDeactivates, event) !== false) {
            event.preventDefault();
            trap.deactivate();
        }
    };
    var checkClick = function checkClick(e) {
        var target = $197853feae65c1a7$var$getActualTarget(e);
        if (findContainerIndex(target, e) >= 0) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.clickOutsideDeactivates, e)) return;
        if ($197853feae65c1a7$var$valueOrHandler(config.allowOutsideClick, e)) return;
        e.preventDefault();
        e.stopImmediatePropagation();
    };
    //
    // EVENT LISTENERS
    //
    /**
   * Adds listeners to the document necessary for trapping focus and attempts to set focus
   *  to the configured initial focus node. Does nothing if the trap isn't active.
   * @returns {Promise<void> | undefined} A promise resolved once the initial focus node has
   *  been focused when `delayInitialFocus=true`; `undefined` when focus is set synchronously
   *  or the trap isn't active.
   */ var addListeners = function addListeners() {
        if (!state.active) return;
        // There can be only one listening focus trap at a time
        $197853feae65c1a7$var$activeFocusTraps.activateTrap(trapStack, trap);
        // Delay ensures that the focused element doesn't capture the event
        // that caused the focus trap activation.
        /** @type {Promise<void> | undefined} */ var promise;
        if (config.delayInitialFocus) // NOTE: Promise constructor callback is called synchronously, which is what we want
        //  since we need to capture the timer ID immediately
        promise = new Promise(function(resolve) {
            state.delayInitialFocusTimer = $197853feae65c1a7$var$delay(function() {
                _tryFocus(getInitialFocusNode());
                resolve();
            });
        });
        else _tryFocus(getInitialFocusNode());
        doc.addEventListener('focusin', checkFocusIn, true);
        doc.addEventListener('mousedown', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('touchstart', checkPointerDown, {
            capture: true,
            passive: false
        });
        doc.addEventListener('click', checkClick, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkTabKey, {
            capture: true,
            passive: false
        });
        doc.addEventListener('keydown', checkEscapeKey);
        return promise;
    };
    /**
   * Traverses up the DOM from each of `containers`, collecting references to
   * the elements that are siblings to `container` or an ancestor of `container`.
   * @param {Array<HTMLElement>} containers
   */ var collectAdjacentElements = function collectAdjacentElements(containers) {
        // Re-activate all adjacent elements & clear previous collection.
        if (state.active && !state.paused) trap._setSubtreeIsolation(false);
        state.adjacentElements.clear();
        state.alreadySilent.clear();
        // Collect all ancestors of all containers to avoid redundant processing.
        var containerAncestors = new Set();
        var adjacentElements = new Set();
        // Compile all elements adjacent to the focus trap containers & lineage.
        var _iterator = $197853feae65c1a7$var$_createForOfIteratorHelper(containers), _step;
        try {
            for(_iterator.s(); !(_step = _iterator.n()).done;){
                var container = _step.value;
                containerAncestors.add(container);
                var insideShadowRoot = typeof ShadowRoot !== 'undefined' && container.getRootNode() instanceof ShadowRoot;
                var current = container;
                while(current){
                    containerAncestors.add(current);
                    var parent = current.parentElement;
                    var siblings = [];
                    if (parent) siblings = parent.children;
                    else if (!parent && insideShadowRoot) {
                        siblings = current.getRootNode().children;
                        parent = current.getRootNode().host;
                        insideShadowRoot = typeof ShadowRoot !== 'undefined' && parent.getRootNode() instanceof ShadowRoot;
                    }
                    // Add all the children, we'll remove container lineage later.
                    var _iterator2 = $197853feae65c1a7$var$_createForOfIteratorHelper(siblings), _step2;
                    try {
                        for(_iterator2.s(); !(_step2 = _iterator2.n()).done;){
                            var child = _step2.value;
                            adjacentElements.add(child);
                        }
                    } catch (err) {
                        _iterator2.e(err);
                    } finally{
                        _iterator2.f();
                    }
                    current = parent;
                }
            }
        // Multi-container traps may overlap.
        // Remove elements within container lineages.
        } catch (err) {
            _iterator.e(err);
        } finally{
            _iterator.f();
        }
        containerAncestors.forEach(function(el) {
            adjacentElements["delete"](el);
        });
        state.adjacentElements = adjacentElements;
    };
    var removeListeners = function removeListeners() {
        if (!state.active) return;
        doc.removeEventListener('focusin', checkFocusIn, true);
        doc.removeEventListener('mousedown', checkPointerDown, true);
        doc.removeEventListener('touchstart', checkPointerDown, true);
        doc.removeEventListener('click', checkClick, true);
        doc.removeEventListener('keydown', checkTabKey, true);
        doc.removeEventListener('keydown', checkEscapeKey);
        return trap;
    };
    //
    // MUTATION OBSERVER
    //
    var checkDomRemoval = function checkDomRemoval(mutations) {
        var focusedNode = state.mostRecentlyFocusedNode;
        if (!focusedNode) return;
        var isFocusedNodeRemoved = mutations.some(function(mutation) {
            var removedNodes = Array.from(mutation.removedNodes);
            return removedNodes.some(function(node) {
                return node === focusedNode || typeof node.contains === 'function' && node.contains(focusedNode);
            });
        });
        // If the currently focused node is removed then browsers will move focus to the
        // <body> element. If this happens, try to move focus back into the trap.
        if (isFocusedNodeRemoved && state.containers.some(function(container) {
            return container === null || container === void 0 ? void 0 : container.isConnected;
        })) {
            // Refresh tabbable state before resolving initial focus because
            // getInitialFocusNode() may fall back to the first tabbable node in the trap.
            updateTabbableNodes();
            var initialFocusNode = getInitialFocusNode();
            _tryFocus(initialFocusNode);
        }
    };
    // Use MutationObserver - if supported - to detect if focused node is removed
    // from the DOM.
    var mutationObserver = typeof window !== 'undefined' && 'MutationObserver' in window ? new MutationObserver(checkDomRemoval) : undefined;
    var updateObservedNodes = function updateObservedNodes() {
        if (!mutationObserver) return;
        mutationObserver.disconnect();
        if (state.active && !state.paused) state.containers.map(function(container) {
            mutationObserver.observe(container, {
                subtree: true,
                childList: true
            });
        });
    };
    //
    // TRAP DEFINITION
    //
    trap = {
        get active () {
            return state.active;
        },
        get paused () {
            return state.paused;
        },
        activate: function activate(activateOptions) {
            if (state.active) return this;
            var onActivate = getOption(activateOptions, 'onActivate');
            var onPostActivate = getOption(activateOptions, 'onPostActivate');
            var checkCanFocusTrap = getOption(activateOptions, 'checkCanFocusTrap');
            // If a currently-active trap is isolating its subtree, we need to remove
            // that isolation to allow the new trap to find tabbable nodes.
            var preexistingTrap = $197853feae65c1a7$var$activeFocusTraps.getActiveTrap(trapStack);
            var revertState = false;
            if (preexistingTrap && !preexistingTrap.paused) {
                var _preexistingTrap$_set;
                // [#1729] method MAY not exist if using `trapStack` option to share stack with older
                //  versions of Focus-trap in the same DOM so use optional chaining here just in case
                //  since this is a trap we may not have created from this instance of the library
                (_preexistingTrap$_set = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set === void 0 || _preexistingTrap$_set.call(preexistingTrap, false);
                revertState = true;
            }
            try {
                if (!checkCanFocusTrap) updateTabbableNodes();
                state.active = true;
                state.paused = false;
                state.nodeFocusedBeforeActivation = _getActiveElement(doc);
                onActivate === null || onActivate === void 0 || onActivate({
                    trap: trap
                });
                var finishActivation = function finishActivation() {
                    if (checkCanFocusTrap) updateTabbableNodes();
                    var afterListeners = function afterListeners() {
                        trap._setSubtreeIsolation(true);
                        updateObservedNodes();
                        onPostActivate === null || onPostActivate === void 0 || onPostActivate({
                            trap: trap
                        });
                    };
                    // NOTE: wait for initial focus node to get focused (whether activation is fully,
                    //  partially, or not asynchronous) before we potentially isolate the subtrees
                    //  with aria-hidden while focus is still in some other subtree and not yet in
                    //  the trap, resulting in some browsers (e.g. Chrome) logging to the console that
                    //  they, "Blocked aria-hidden on an element because its descendant retained focus..."
                    var listenersPromise = addListeners();
                    if (listenersPromise) listenersPromise.then(afterListeners);
                    else afterListeners();
                };
                if (checkCanFocusTrap) {
                    checkCanFocusTrap(state.containers.concat()).then(finishActivation, finishActivation);
                    return this;
                }
                finishActivation();
            } catch (error) {
                // If our activation throws an exception and the stack hasn't changed,
                // we need to re-enable the prior trap's subtree isolation.
                if (preexistingTrap === $197853feae65c1a7$var$activeFocusTraps.getActiveTrap(trapStack) && revertState) {
                    var _preexistingTrap$_set2;
                    // [#1729] method MAY not exist if using `trapStack` option to share stack with older
                    //  versions of Focus-trap in the same DOM so use optional chaining here just in case
                    //  since this is a trap we may not have created from this instance of the library
                    (_preexistingTrap$_set2 = preexistingTrap._setSubtreeIsolation) === null || _preexistingTrap$_set2 === void 0 || _preexistingTrap$_set2.call(preexistingTrap, true);
                }
                throw error;
            }
            return this;
        },
        deactivate: function deactivate(deactivateOptions) {
            if (!state.active) return this;
            var options = $197853feae65c1a7$var$_objectSpread2({
                onDeactivate: config.onDeactivate,
                onPostDeactivate: config.onPostDeactivate,
                checkCanReturnFocus: config.checkCanReturnFocus
            }, deactivateOptions);
            clearTimeout(state.delayInitialFocusTimer); // noop if undefined
            state.delayInitialFocusTimer = undefined;
            // Prior to removing this trap from the trapStack, we need to remove any applications of `inert`.
            // This allows the next trap down to update its tabbable nodes properly.
            //
            // If this trap is not top of the stack, don't change any current isolation.
            if (!state.paused) trap._setSubtreeIsolation(false);
            state.alreadySilent.clear();
            removeListeners();
            state.active = false;
            state.paused = false;
            updateObservedNodes();
            $197853feae65c1a7$var$activeFocusTraps.deactivateTrap(trapStack, trap);
            var onDeactivate = getOption(options, 'onDeactivate');
            var onPostDeactivate = getOption(options, 'onPostDeactivate');
            var checkCanReturnFocus = getOption(options, 'checkCanReturnFocus');
            var delayReturnFocus = getOption(options, 'delayReturnFocus');
            var returnFocus = getOption(options, 'returnFocus', 'returnFocusOnDeactivate');
            onDeactivate === null || onDeactivate === void 0 || onDeactivate({
                trap: trap
            });
            var completeDeactivation = function completeDeactivation() {
                if (returnFocus) _tryFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation));
                onPostDeactivate === null || onPostDeactivate === void 0 || onPostDeactivate({
                    trap: trap
                });
            };
            var finishDeactivation = function finishDeactivation() {
                if (delayReturnFocus && returnFocus) $197853feae65c1a7$var$delay(completeDeactivation);
                else completeDeactivation();
            };
            if (returnFocus && checkCanReturnFocus) {
                checkCanReturnFocus(getReturnFocusNode(state.nodeFocusedBeforeActivation)).then(finishDeactivation, finishDeactivation);
                return this;
            }
            finishDeactivation();
            return this;
        },
        pause: function pause(pauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = true;
            return this._setPausedState(true, pauseOptions);
        },
        unpause: function unpause(unpauseOptions) {
            if (!state.active) return this;
            state.manuallyPaused = false;
            if (trapStack[trapStack.length - 1] !== this) return this;
            return this._setPausedState(false, unpauseOptions);
        },
        updateContainerElements: function updateContainerElements(containerElements) {
            var elementsAsArray = [].concat(containerElements).filter(Boolean);
            state.containers = elementsAsArray.map(function(element) {
                return typeof element === 'string' ? doc.querySelector(element) : element;
            });
            if (config.isolateSubtrees) collectAdjacentElements(state.containers);
            if (state.active) {
                updateTabbableNodes();
                if (!state.paused) trap._setSubtreeIsolation(true);
            }
            updateObservedNodes();
            return this;
        }
    };
    Object.defineProperties(trap, {
        _isManuallyPaused: {
            value: function value() {
                return state.manuallyPaused;
            }
        },
        _setPausedState: {
            value: function value(paused, options) {
                if (state.paused === paused) return this;
                state.paused = paused;
                if (paused) {
                    var onPause = getOption(options, 'onPause');
                    var onPostPause = getOption(options, 'onPostPause');
                    onPause === null || onPause === void 0 || onPause({
                        trap: trap
                    });
                    removeListeners();
                    trap._setSubtreeIsolation(false);
                    updateObservedNodes();
                    onPostPause === null || onPostPause === void 0 || onPostPause({
                        trap: trap
                    });
                } else {
                    var onUnpause = getOption(options, 'onUnpause');
                    var onPostUnpause = getOption(options, 'onPostUnpause');
                    onUnpause === null || onUnpause === void 0 || onUnpause({
                        trap: trap
                    });
                    var finishUnpause = function finishUnpause() {
                        updateTabbableNodes();
                        var afterListeners = function afterListeners() {
                            trap._setSubtreeIsolation(true);
                            updateObservedNodes();
                            onPostUnpause === null || onPostUnpause === void 0 || onPostUnpause({
                                trap: trap
                            });
                        };
                        // NOTE: wait for initial focus node to get focused (whether activation is fully,
                        //  partially, or not asynchronous) before we potentially isolate the subtrees
                        //  with aria-hidden while focus is still in some other subtree and not yet in
                        //  the trap, resulting in some browsers (e.g. Chrome) logging to the console that
                        //  they, "Blocked aria-hidden on an element because its descendant retained focus..."
                        var listenersPromise = addListeners();
                        if (listenersPromise) listenersPromise.then(afterListeners);
                        else afterListeners();
                    };
                    finishUnpause();
                }
                return this;
            }
        },
        _setSubtreeIsolation: {
            value: function value(isEnabled) {
                if (config.isolateSubtrees) state.adjacentElements.forEach(function(el) {
                    var _el$getAttribute;
                    if (isEnabled) switch(config.isolateSubtrees){
                        case 'aria-hidden':
                            // check both attribute and property to ensure initial state is captured
                            // correctly across different browsers and test environments (like JSDOM)
                            if (el.ariaHidden === 'true' || ((_el$getAttribute = el.getAttribute('aria-hidden')) === null || _el$getAttribute === void 0 ? void 0 : _el$getAttribute.toLowerCase()) === 'true') state.alreadySilent.add(el);
                            el.setAttribute('aria-hidden', 'true');
                            break;
                        default:
                            // check both attribute and property to ensure initial state is captured
                            // correctly across different browsers and test environments (like JSDOM)
                            if (el.inert || el.hasAttribute('inert')) state.alreadySilent.add(el);
                            el.setAttribute('inert', true);
                            break;
                    }
                    else {
                        if (state.alreadySilent.has(el)) ;
                        else switch(config.isolateSubtrees){
                            case 'aria-hidden':
                                el.removeAttribute('aria-hidden');
                                break;
                            default:
                                el.removeAttribute('inert');
                                break;
                        }
                    }
                });
            }
        }
    });
    // initialize container elements
    trap.updateContainerElements(elements);
    return trap;
};





var $eHaBZ = parcelRequire("eHaBZ");

function $afaa653977073dac$export$3b062b02b4537682() {
    return (0, $74ba0882e4d762a0$export$96b5b894afc1d2e3)((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).loggedin);
}
function $afaa653977073dac$export$f5bdb3b3cec7f803() {
    var loggedIn = $afaa653977073dac$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToRead();
    }, [
        loggedIn
    ]);
}
function $afaa653977073dac$export$683005ba76038aff() {
    var loggedIn = $afaa653977073dac$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToUpdate();
    }, [
        loggedIn
    ]);
}
function $afaa653977073dac$export$b416b77cd328c02f() {
    var loggedIn = $afaa653977073dac$export$3b062b02b4537682();
    return (0, $eHaBZ.useMemo)(function() {
        return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToWrite();
    }, [
        loggedIn
    ]);
}





var $fc181d02c22cdede$export$cacd6541cfeeb6c1 = /*#__PURE__*/ function(Direction) {
    Direction["PREV"] = "prev";
    Direction["NEXT"] = "next";
    return Direction;
}({});
function $fc181d02c22cdede$export$d976747ecb966cea(target) {
    var viewportHeight = document.body.clientHeight;
    var viewportScrollTop = window.scrollY;
    var targetBb = target.getBoundingClientRect();
    var targetTop = window.scrollY + targetBb.top;
    var targetHeight = targetBb.height;
    // scroll down
    if (viewportScrollTop + viewportHeight < targetTop + targetHeight + 80) {
        if (targetHeight > viewportHeight) window.scrollTo({
            top: targetTop
        });
        else {
            var marginTop = (viewportHeight - targetHeight) / 2;
            var scrollTop = targetTop - marginTop;
            window.scrollTo({
                top: scrollTop
            });
        }
    }
    // scroll up
    if (targetTop <= viewportScrollTop) window.scrollTo({
        top: targetTop
    });
}




var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $eHaBZ = parcelRequire("eHaBZ");

var $419292d15b74e6e0$exports = {};
var $ef4a30588310d5d7$exports = {};
function $ef4a30588310d5d7$var$_arrayReduce(reducer, acc, list) {
    var index = 0;
    var length = list.length;
    while(index < length){
        acc = reducer(acc, list[index]);
        index += 1;
    }
    return acc;
}
$ef4a30588310d5d7$exports = $ef4a30588310d5d7$var$_arrayReduce;



var $f4091c18d79168b1$exports = {};

var $b1373d49cfb8ba69$exports = {};
function $b1373d49cfb8ba69$var$_isTransformer(obj) {
    return obj != null && typeof obj['@@transducer/step'] === 'function';
}
$b1373d49cfb8ba69$exports = $b1373d49cfb8ba69$var$_isTransformer;


/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */ function $f4091c18d79168b1$var$_dispatchable(methodNames, transducerCreator, fn) {
    return function() {
        if (arguments.length === 0) return fn();
        var obj = arguments[arguments.length - 1];
        if (!$73fb5ea04d9dead1$exports(obj)) {
            var idx = 0;
            while(idx < methodNames.length){
                if (typeof obj[methodNames[idx]] === 'function') return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
                idx += 1;
            }
            if ($b1373d49cfb8ba69$exports(obj)) {
                var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
                return transducer(obj);
            }
        }
        return fn.apply(this, arguments);
    };
}
$f4091c18d79168b1$exports = $f4091c18d79168b1$var$_dispatchable;


var $8b790a9e48f0992d$exports = {};
function $8b790a9e48f0992d$var$_map(fn, functor) {
    var idx = 0;
    var len = functor.length;
    var result = Array(len);
    while(idx < len){
        result[idx] = fn(functor[idx]);
        idx += 1;
    }
    return result;
}
$8b790a9e48f0992d$exports = $8b790a9e48f0992d$var$_map;


var $2f7cea74d4afd9d8$exports = {};
var $8ad75158a6dee908$exports = {};
$8ad75158a6dee908$exports = {
    init: function init() {
        return this.xf['@@transducer/init']();
    },
    result: function result(_result) {
        return this.xf['@@transducer/result'](_result);
    }
};


var $2f7cea74d4afd9d8$var$XMap = /*#__PURE__*/ function() {
    function XMap(f, xf) {
        this.xf = xf;
        this.f = f;
    }
    XMap.prototype['@@transducer/init'] = $8ad75158a6dee908$exports.init;
    XMap.prototype['@@transducer/result'] = $8ad75158a6dee908$exports.result;
    XMap.prototype['@@transducer/step'] = function(result, input) {
        return this.xf['@@transducer/step'](result, this.f(input));
    };
    return XMap;
}();
var $2f7cea74d4afd9d8$var$_xmap = function _xmap(f) {
    return function(xf) {
        return new $2f7cea74d4afd9d8$var$XMap(f, xf);
    };
};
$2f7cea74d4afd9d8$exports = $2f7cea74d4afd9d8$var$_xmap;


var $76af6f4bdc955f60$exports = {};



var $d7d932f9cbe80b4e$exports = {};


/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */ function $d7d932f9cbe80b4e$var$_curryN(length, received, fn) {
    return function() {
        var combined = [];
        var argsIdx = 0;
        var left = length;
        var combinedIdx = 0;
        var hasPlaceholder = false;
        while(combinedIdx < received.length || argsIdx < arguments.length){
            var result;
            if (combinedIdx < received.length && (!$f6709ecef4b253a2$exports(received[combinedIdx]) || argsIdx >= arguments.length)) result = received[combinedIdx];
            else {
                result = arguments[argsIdx];
                argsIdx += 1;
            }
            combined[combinedIdx] = result;
            if (!$f6709ecef4b253a2$exports(result)) left -= 1;
            else hasPlaceholder = true;
            combinedIdx += 1;
        }
        return !hasPlaceholder && left <= 0 ? fn.apply(this, combined) : $7629ad89266bbe6b$exports(Math.max(0, left), $d7d932f9cbe80b4e$var$_curryN(length, combined, fn));
    };
}
$d7d932f9cbe80b4e$exports = $d7d932f9cbe80b4e$var$_curryN;


/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */ var $76af6f4bdc955f60$var$curryN = /*#__PURE__*/ $16cdbc498258dabf$exports(function curryN(length, fn) {
    if (length === 1) return $7e9ffa7fa815703c$exports(fn);
    return $7629ad89266bbe6b$exports(length, $d7d932f9cbe80b4e$exports(length, [], fn));
});
$76af6f4bdc955f60$exports = $76af6f4bdc955f60$var$curryN;


var $a97e5ea9fcd3c823$exports = {};


var $69a5e3c09611504c$exports = {};

var $69a5e3c09611504c$var$toString = Object.prototype.toString;
var $69a5e3c09611504c$var$_isArguments = /*#__PURE__*/ function() {
    return $69a5e3c09611504c$var$toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
        return $69a5e3c09611504c$var$toString.call(x) === '[object Arguments]';
    } : function _isArguments(x) {
        return $8659c368bdbba7be$exports('callee', x);
    };
}();
$69a5e3c09611504c$exports = $69a5e3c09611504c$var$_isArguments;


var $a97e5ea9fcd3c823$var$hasEnumBug = !/*#__PURE__*/ ({
    toString: null
}).propertyIsEnumerable('toString');
var $a97e5ea9fcd3c823$var$nonEnumerableProps = [
    'constructor',
    'valueOf',
    'isPrototypeOf',
    'toString',
    'propertyIsEnumerable',
    'hasOwnProperty',
    'toLocaleString'
];
// Safari bug
var $a97e5ea9fcd3c823$var$hasArgsEnumBug = /*#__PURE__*/ function() {
    'use strict';
    return arguments.propertyIsEnumerable('length');
}();
var $a97e5ea9fcd3c823$var$contains = function contains(list, item) {
    var idx = 0;
    while(idx < list.length){
        if (list[idx] === item) return true;
        idx += 1;
    }
    return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */ var $a97e5ea9fcd3c823$var$keys = typeof Object.keys === 'function' && !$a97e5ea9fcd3c823$var$hasArgsEnumBug ? /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/ $7e9ffa7fa815703c$exports(function keys(obj) {
    if (Object(obj) !== obj) return [];
    var prop, nIdx;
    var ks = [];
    var checkArgsLength = $a97e5ea9fcd3c823$var$hasArgsEnumBug && $69a5e3c09611504c$exports(obj);
    for(prop in obj)if ($8659c368bdbba7be$exports(prop, obj) && (!checkArgsLength || prop !== 'length')) ks[ks.length] = prop;
    if ($a97e5ea9fcd3c823$var$hasEnumBug) {
        nIdx = $a97e5ea9fcd3c823$var$nonEnumerableProps.length - 1;
        while(nIdx >= 0){
            prop = $a97e5ea9fcd3c823$var$nonEnumerableProps[nIdx];
            if ($8659c368bdbba7be$exports(prop, obj) && !$a97e5ea9fcd3c823$var$contains(ks, prop)) ks[ks.length] = prop;
            nIdx -= 1;
        }
    }
    return ks;
});
$a97e5ea9fcd3c823$exports = $a97e5ea9fcd3c823$var$keys;


/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */ var $419292d15b74e6e0$var$map = /*#__PURE__*/ $16cdbc498258dabf$exports(/*#__PURE__*/ $f4091c18d79168b1$exports([
    'fantasy-land/map',
    'map'
], $2f7cea74d4afd9d8$exports, function map(fn, functor) {
    switch(Object.prototype.toString.call(functor)){
        case '[object Function]':
            return $76af6f4bdc955f60$exports(functor.length, function() {
                return fn.call(this, functor.apply(this, arguments));
            });
        case '[object Object]':
            return $ef4a30588310d5d7$exports(function(acc, key) {
                acc[key] = fn(functor[key]);
                return acc;
            }, {}, $a97e5ea9fcd3c823$exports(functor));
        default:
            return $8b790a9e48f0992d$exports(fn, functor);
    }
}));
$419292d15b74e6e0$exports = $419292d15b74e6e0$var$map;




function $94837e40a3fa9211$var$materializeSharerIcon(sharer) {
    var icon = sharer.icon;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, sharer), {
        // We want to allow people to use <svg> or <img> in user.js
        icon: typeof icon === 'string' && icon.includes('<') ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            dangerouslySetInnerHTML: {
                __html: icon
            }
        }) : icon
    });
}
function $94837e40a3fa9211$export$aebedbd51beb48eb(args) {
    var configuration = args.configuration, showError = args.showError, _ = args._;
    return (0, $eHaBZ.useMemo)(function() {
        var _selfoss_customSharers;
        var availableSharers = (0, $lvTkn._)({
            a: {
                label: _('share_native_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $5f3a6b596119c825$exports.faShareAlt
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    navigator.share({
                        title: title,
                        url: url
                    }).catch(function(e) {
                        if (e.name === 'AbortError') showError(_('error_share_native_abort'));
                        else showError(_('error_share_native'));
                    });
                },
                available: 'share' in navigator
            },
            d: {
                label: _('share_diaspora_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $8216ee54ed5c099f$exports.faDiaspora
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://share.diasporafoundation.org/?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            t: {
                label: _('share_twitter_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $11826e5bf54ad532$exports.faTwitter
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://twitter.com/intent/tweet?source=webclient&text=' + encodeURIComponent(title) + ' ' + encodeURIComponent(url), undefined, 'noreferrer');
                }
            },
            f: {
                label: _('share_facebook_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $a5565bc5d7aa9135$exports.faFacebookSquare
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://www.facebook.com/sharer/sharer.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            m: {
                label: _('share_mastodon_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $b92068b2b2ac161b$exports.faMastodon
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.mastodon + '/share?text=' + encodeURIComponent('"' + title + '"\n' + url), undefined, 'noreferrer');
                },
                available: configuration.mastodon !== null
            },
            p: {
                label: _('share_pocket_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $acd52ab24d9744ba$exports.faGetPocket
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open('https://getpocket.com/save?url=' + encodeURIComponent(url) + '&title=' + encodeURIComponent(title), undefined, 'noreferrer');
                }
            },
            w: {
                label: _('share_wallabag_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $ad1c54c45e1481e9$export$a67558cb68d63c7e
                }),
                action: function(param) {
                    var url = param.url;
                    if (configuration.wallabag.version === 2) window.open(configuration.wallabag.url + '/bookmarklet?url=' + encodeURIComponent(url), undefined, 'noreferrer');
                    else window.open(configuration.wallabag.url + '/?action=add&url=' + btoa(url), undefined, 'noreferrer');
                },
                available: configuration.wallabag !== null
            },
            s: {
                label: _('share_wordpress_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $8ebe08a4e3d0a860$exports.faWordpressSimple
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    window.open(configuration.wordpress + '/wp-admin/press-this.php?u=' + encodeURIComponent(url) + '&t=' + encodeURIComponent(title), undefined, 'noreferrer');
                },
                available: configuration.wordpress !== null
            },
            e: {
                label: _('share_mail_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $5aa79799bc179db8$exports.faEnvelope
                }),
                action: function(param) {
                    var url = param.url, title = param.title;
                    document.location.href = 'mailto:?body=' + encodeURIComponent(url) + '&subject=' + encodeURIComponent(title);
                }
            },
            c: {
                label: _('share_copy_label'),
                icon: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $7f79cc0a934ae117$exports.faCopy
                }),
                action: function(param) {
                    var url = param.url;
                    navigator.clipboard.writeText(url).then(function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.showMessage(_('info_url_copied'));
                    });
                }
            }
        }, (0, (/*@__PURE__*/$parcel$interopDefault($419292d15b74e6e0$exports)))($94837e40a3fa9211$var$materializeSharerIcon, (_selfoss_customSharers = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).customSharers) !== null && _selfoss_customSharers !== void 0 ? _selfoss_customSharers : {}));
        var enabledSharers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = configuration.share[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var letter = _step.value;
                var sharer = availableSharers[letter];
                var _sharer_available;
                if (sharer !== undefined && ((_sharer_available = sharer.available) !== null && _sharer_available !== void 0 ? _sharer_available : true)) {
                    var label = sharer.label, icon = sharer.icon, action = sharer.action;
                    enabledSharers.push({
                        key: letter,
                        label: label,
                        icon: icon,
                        action: action
                    });
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return enabledSharers;
    }, [
        configuration,
        showError,
        _
    ]);
}



var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


var $21h22 = parcelRequire("21h22");

var $6zk1M = parcelRequire("6zk1M");

var $eHaBZ = parcelRequire("eHaBZ");
var $b17a7fd270a24b50$export$83fe3bee12eb51bb = "carousel";
var $b17a7fd270a24b50$export$b861c6f4d58b4c2f = "controller";
var $b17a7fd270a24b50$export$607ce719f0ec9b98 = "navigation";
var $b17a7fd270a24b50$export$52cbc29cf5406ba8 = "no-scroll";
var $b17a7fd270a24b50$export$9d2e4856063e1a22 = "portal";
var $b17a7fd270a24b50$export$62f3c66ae8dab8a3 = "root";
var $b17a7fd270a24b50$export$5414719b40b8294f = "toolbar";
var $b17a7fd270a24b50$export$a23b14c1465897d = "captions";
var $b17a7fd270a24b50$export$8ae0dbe553798d04 = "counter";
var $b17a7fd270a24b50$export$ace9d67c0f2290af = "download";
var $b17a7fd270a24b50$export$4792108761b262a9 = "fullscreen";
var $b17a7fd270a24b50$export$c21ea5a712f18fb6 = "inline";
var $b17a7fd270a24b50$export$6bbdc870e6ef9c88 = "share";
var $b17a7fd270a24b50$export$be7dc72e63e6ef2e = "slideshow";
var $b17a7fd270a24b50$export$6bf9d56640f46f01 = "thumbnails";
var $b17a7fd270a24b50$export$929980e2a2c57ecf = "zoom";
var $b17a7fd270a24b50$export$554a1415841c52a8 = "loading";
var $b17a7fd270a24b50$export$38ce62e512432ebb = "playing";
var $b17a7fd270a24b50$export$2ed3c80dbc178d91 = "error";
var $b17a7fd270a24b50$export$a195e517d37aaa33 = "complete";
var $b17a7fd270a24b50$export$e51f1c6d74b54a13 = "placeholder";
var $b17a7fd270a24b50$export$6751782e799f6445 = function(status) {
    return "active-slide-".concat(status);
};
var $b17a7fd270a24b50$export$7ab73e7383503259 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$554a1415841c52a8);
var $b17a7fd270a24b50$export$ccb5eb0b2db52ae8 = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$38ce62e512432ebb);
var $b17a7fd270a24b50$export$817be438d1d0e4cf = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$2ed3c80dbc178d91);
var $b17a7fd270a24b50$export$2ec1d32caeb97dfe = $b17a7fd270a24b50$export$6751782e799f6445($b17a7fd270a24b50$export$a195e517d37aaa33);
var $b17a7fd270a24b50$export$37b171d829eeeaa2 = "fullsize";
var $b17a7fd270a24b50$export$974a68ef150451f5 = "flex_center";
var $b17a7fd270a24b50$export$b6426a00c33a0175 = "no_scroll";
var $b17a7fd270a24b50$export$651541414233b476 = "no_scroll_padding";
var $b17a7fd270a24b50$export$8d922915837a38d3 = "slide";
var $b17a7fd270a24b50$export$ac396c284080b10c = "slide_wrapper";
var $b17a7fd270a24b50$export$bb41c4fe76dce9db = "slide_wrapper_interactive";
var $b17a7fd270a24b50$export$a007161537026955 = "prev";
var $b17a7fd270a24b50$export$f1d7a854db833ed4 = "next";
var $b17a7fd270a24b50$export$c43bd1a4101c4078 = "swipe";
var $b17a7fd270a24b50$export$493a596486210a21 = "close";
var $b17a7fd270a24b50$export$e15fc153f45a963d = "onPointerDown";
var $b17a7fd270a24b50$export$1f8863949fbdd7e5 = "onPointerMove";
var $b17a7fd270a24b50$export$2d868b67a5791b8a = "onPointerUp";
var $b17a7fd270a24b50$export$526cafa85592f1a5 = "onPointerLeave";
var $b17a7fd270a24b50$export$22151cee048c4be9 = "onPointerCancel";
var $b17a7fd270a24b50$export$1aba4f3521686ca9 = "onKeyDown";
var $b17a7fd270a24b50$export$bdb9f99d61a6879b = "onKeyUp";
var $b17a7fd270a24b50$export$5635dc9d647242c7 = "onWheel";
var $b17a7fd270a24b50$export$e8d60d9b5ceff7c0 = "Escape";
var $b17a7fd270a24b50$export$17dec1da9b0e2eb3 = "ArrowLeft";
var $b17a7fd270a24b50$export$91898c0e7e48903 = "ArrowRight";
var $b17a7fd270a24b50$export$d62fb7722b07f2f3 = "button";
var $b17a7fd270a24b50$export$c5f5ca1963fed141 = "icon";
var $b17a7fd270a24b50$export$eff7fe5eefd707ad = "contain";
var $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f = "cover";
var $b17a7fd270a24b50$export$b149fc25cb186fec = "Unknown action type";



var $bVPm2 = parcelRequire("bVPm2");
"use client";
var $2e545d666ef3112d$var$cssPrefix$3 = "yarl__";
function $2e545d666ef3112d$export$4f5d2d50c9deca37() {
    for(var _len = arguments.length, classes = new Array(_len), _key = 0; _key < _len; _key++){
        classes[_key] = arguments[_key];
    }
    return classes.filter(Boolean).join(" ");
}
function $2e545d666ef3112d$export$1283875077dc8f0a(name) {
    return "".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
}
function $2e545d666ef3112d$export$8b4981022bd80a4e(name) {
    return "--".concat($2e545d666ef3112d$var$cssPrefix$3).concat(name);
}
function $2e545d666ef3112d$export$195c4126907dde97(base, prefix) {
    return "".concat(base).concat(prefix ? "_".concat(prefix) : "");
}
function $2e545d666ef3112d$export$3e7cd27eed1727c(base) {
    return function(prefix) {
        return $2e545d666ef3112d$export$195c4126907dde97(base, prefix);
    };
}
function $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, defaultLabel) {
    var _a;
    return (_a = labels === null || labels === void 0 ? void 0 : labels[defaultLabel]) !== null && _a !== void 0 ? _a : defaultLabel;
}
function $2e545d666ef3112d$export$1237798dc640739a(labels, defaultLabel) {
    return $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, defaultLabel);
}
function $2e545d666ef3112d$export$77152303d9076b8(labels, slides, index) {
    return $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "{index} of {total}").replace(/\{index}/g, "".concat($2e545d666ef3112d$export$501611100333094a(index, slides.length) + 1)).replace(/\{total}/g, "".concat(slides.length));
}
function $2e545d666ef3112d$export$de863c629cb9919d() {
    for(var _len = arguments.length, cleaners = new Array(_len), _key = 0; _key < _len; _key++){
        cleaners[_key] = arguments[_key];
    }
    return function() {
        cleaners.forEach(function(cleaner) {
            cleaner();
        });
    };
}
function $2e545d666ef3112d$export$aac3e49c3c8b5cb0(name, contextName, context) {
    return function() {
        var ctx = $eHaBZ.useContext(context);
        if (!ctx) throw new Error("".concat(name, " must be used within a ").concat(contextName, ".Provider"));
        return ctx;
    };
}
function $2e545d666ef3112d$export$fef62134eea24008() {
    return typeof window !== "undefined";
}
function $2e545d666ef3112d$export$2077e0241d6afd3c(value) {
    var decimals = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
    var factor = Math.pow(10, decimals);
    return Math.round((value + Number.EPSILON) * factor) / factor;
}
function $2e545d666ef3112d$export$55ec18c411514c07(slide) {
    return slide.type === undefined || slide.type === "image";
}
function $2e545d666ef3112d$export$f5ba2f5b3fd12e6e(image, imageFit) {
    return image.imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f) || image.imageFit !== (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad) && imageFit === (0, $b17a7fd270a24b50$export$9a9f12fc3f1c1e4f);
}
function $2e545d666ef3112d$export$5f87784a266e50a4(value) {
    return typeof value === "string" ? Number.parseInt(value, 10) : value;
}
function $2e545d666ef3112d$export$7871fb532d320d99(input) {
    if (typeof input === "number") return {
        pixel: input
    };
    if (typeof input === "string") {
        var value = $2e545d666ef3112d$export$5f87784a266e50a4(input);
        return input.endsWith("%") ? {
            percent: value
        } : {
            pixel: value
        };
    }
    return {
        pixel: 0
    };
}
function $2e545d666ef3112d$export$7ff571008bce9900(containerRect, padding) {
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(padding);
    var paddingPixels = paddingValue.percent !== undefined ? containerRect.width / 100 * paddingValue.percent : paddingValue.pixel;
    return {
        width: Math.max(containerRect.width - 2 * paddingPixels, 0),
        height: Math.max(containerRect.height - 2 * paddingPixels, 0)
    };
}
function $2e545d666ef3112d$export$508f096bfcdaac40() {
    return ($2e545d666ef3112d$export$fef62134eea24008() ? window === null || window === void 0 ? void 0 : window.devicePixelRatio : undefined) || 1;
}
function $2e545d666ef3112d$export$501611100333094a(index, slidesCount) {
    return slidesCount > 0 ? (index % slidesCount + slidesCount) % slidesCount : 0;
}
function $2e545d666ef3112d$export$883ece934910f98d(slides) {
    return slides.length > 0;
}
function $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index) {
    return slides[$2e545d666ef3112d$export$501611100333094a(index, slides.length)];
}
function $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, index) {
    return $2e545d666ef3112d$export$883ece934910f98d(slides) ? $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index) : undefined;
}
function $2e545d666ef3112d$export$b2184449b7659b5a(slide) {
    return $2e545d666ef3112d$export$55ec18c411514c07(slide) ? slide.src : undefined;
}
function $2e545d666ef3112d$export$34ce6a408311d810(toolbar, key, button) {
    if (!button) return toolbar;
    var buttons = toolbar.buttons, restToolbar = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(toolbar, [
        "buttons"
    ]);
    var index = buttons.findIndex(function(item) {
        return item === key;
    });
    var buttonWithKey = $eHaBZ.isValidElement(button) ? $eHaBZ.cloneElement(button, {
        key: key
    }, null) : button;
    if (index >= 0) {
        var result = (0, $6zk1M._)(buttons);
        result.splice(index, 1, buttonWithKey);
        return (0, $lvTkn._)({
            buttons: result
        }, restToolbar);
    }
    return (0, $lvTkn._)({
        buttons: [
            buttonWithKey
        ].concat((0, $6zk1M._)(buttons))
    }, restToolbar);
}
function $2e545d666ef3112d$export$e88693bab67822d1() {
    var stopPropagation = function(event) {
        event.stopPropagation();
    };
    return {
        onPointerDown: stopPropagation,
        onKeyDown: stopPropagation,
        onWheel: stopPropagation
    };
}
function $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides) {
    var minimum = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0;
    return Math.min(carousel.preload, Math.max(carousel.finite ? slides.length - 1 : Math.floor(slides.length / 2), minimum));
}
var $2e545d666ef3112d$var$isReact19 = Number($eHaBZ.version.split(".")[0]) >= 19;
function $2e545d666ef3112d$export$9c64d01b28c1f747(condition) {
    var legacyValue = condition ? "" : undefined;
    return {
        inert: $2e545d666ef3112d$var$isReact19 ? condition : legacyValue
    };
}
function $2e545d666ef3112d$export$b7a864e1eaef9de5(node) {
    node.scrollTop;
}
var $2e545d666ef3112d$export$d626463445cef3e9 = {
    open: false,
    close: function() {},
    index: 0,
    slides: [],
    render: {},
    plugins: [],
    toolbar: {
        buttons: [
            (0, $b17a7fd270a24b50$export$493a596486210a21)
        ]
    },
    labels: {},
    animation: {
        fade: 250,
        swipe: 500,
        easing: {
            fade: "ease",
            swipe: "ease-out",
            navigation: "ease-in-out"
        }
    },
    carousel: {
        finite: false,
        preload: 2,
        padding: "16px",
        spacing: "30%",
        imageFit: (0, $b17a7fd270a24b50$export$eff7fe5eefd707ad),
        imageProps: {}
    },
    controller: {
        ref: null,
        focus: true,
        aria: false,
        touchAction: "none",
        closeOnPullUp: false,
        closeOnPullDown: false,
        closeOnBackdropClick: false,
        closeOnEscape: true,
        preventDefaultWheelX: true,
        preventDefaultWheelY: false,
        disableSwipeNavigation: false
    },
    portal: {},
    noScroll: {
        disabled: false
    },
    on: {},
    styles: {},
    className: ""
};
function $2e545d666ef3112d$export$c5ba3739ffba980d(name, component) {
    return {
        name: name,
        component: component
    };
}
function $2e545d666ef3112d$export$270e7ba5936d3c48(module, children) {
    return {
        module: module,
        children: children
    };
}
function $2e545d666ef3112d$var$traverseNode(node, target, apply) {
    if (node.module.name === target) return apply(node);
    if (node.children) return [
        $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, node.children.flatMap(function(n) {
            var _a;
            return (_a = $2e545d666ef3112d$var$traverseNode(n, target, apply)) !== null && _a !== void 0 ? _a : [];
        }))
    ];
    return [
        node
    ];
}
function $2e545d666ef3112d$var$traverse(nodes, target, apply) {
    return nodes.flatMap(function(node) {
        var _a;
        return (_a = $2e545d666ef3112d$var$traverseNode(node, target, apply)) !== null && _a !== void 0 ? _a : [];
    });
}
function $2e545d666ef3112d$export$bc996c07eb970c78(root) {
    var plugins = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], augmentations = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : [];
    var config = root;
    var contains = function(target) {
        var nodes = (0, $6zk1M._)(config);
        while(nodes.length > 0){
            var _nodes;
            var node = nodes.pop();
            if ((node === null || node === void 0 ? void 0 : node.module.name) === target) return true;
            if (node === null || node === void 0 ? void 0 : node.children) (_nodes = nodes).push.apply(_nodes, (0, $6zk1M._)(node.children));
        }
        return false;
    };
    var addParent = function(target, module) {
        if (target === "") {
            config = [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, config)
            ];
            return;
        }
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, [
                    node
                ])
            ];
        });
    };
    var append = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
                ])
            ];
        });
    };
    var addChild = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            var _a;
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(node.module, (0, $6zk1M._)(precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : []).concat((0, $6zk1M._)((_a = node.children) !== null && _a !== void 0 ? _a : []), (0, $6zk1M._)(!precede ? [
                    $2e545d666ef3112d$export$270e7ba5936d3c48(module)
                ] : [])))
            ];
        });
    };
    var addSibling = function(target, module, precede) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return (0, $6zk1M._)(precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []).concat([
                node
            ], (0, $6zk1M._)(!precede ? [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module)
            ] : []));
        });
    };
    var addModule = function(module) {
        append((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), module);
    };
    var replace = function(target, module) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return [
                $2e545d666ef3112d$export$270e7ba5936d3c48(module, node.children)
            ];
        });
    };
    var remove = function(target) {
        config = $2e545d666ef3112d$var$traverse(config, target, function(node) {
            return node.children;
        });
    };
    var augment = function(augmentation) {
        augmentations.push(augmentation);
    };
    plugins.forEach(function(plugin) {
        plugin({
            contains: contains,
            addParent: addParent,
            append: append,
            addChild: addChild,
            addSibling: addSibling,
            addModule: addModule,
            replace: replace,
            remove: remove,
            augment: augment
        });
    });
    return {
        config: config,
        augmentation: function(props) {
            return augmentations.reduce(function(acc, augmentation) {
                return augmentation(acc);
            }, props);
        }
    };
}
var $2e545d666ef3112d$export$bec71e4205979323 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$3992c64d261ded5a = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useA11yContext", "A11yContext", $2e545d666ef3112d$export$bec71e4205979323);
function $2e545d666ef3112d$export$e41a845d3e53ea09(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), focusWithin = _React_useState[0], setFocusWithin = _React_useState[1];
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), autoPlaying = _React_useState1[0], setAutoPlaying = _React_useState1[1];
    var context = $eHaBZ.useMemo(function() {
        var trackFocusWithin = function(onFocus, onBlur) {
            var trackAndDelegate = function(focusWithinValue) {
                return function(event) {
                    var _a;
                    if (!event.currentTarget.contains(event.relatedTarget)) setFocusWithin(focusWithinValue);
                    (_a = focusWithinValue ? onFocus : onBlur) === null || _a === void 0 || _a(event);
                };
            };
            return {
                onFocus: trackAndDelegate(true),
                onBlur: trackAndDelegate(false)
            };
        };
        return {
            focusWithin: focusWithin,
            trackFocusWithin: trackFocusWithin,
            autoPlaying: autoPlaying,
            setAutoPlaying: setAutoPlaying
        };
    }, [
        focusWithin,
        autoPlaying
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$bec71e4205979323.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$41b6c5189865fe72 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$c199d36c2862b6ed = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useDocument", "DocumentContext", $2e545d666ef3112d$export$41b6c5189865fe72);
function $2e545d666ef3112d$export$30e869153d18a2e6(param) {
    var nodeRef = param.nodeRef, children = param.children;
    var context = $eHaBZ.useMemo(function() {
        var getOwnerDocument = function(node) {
            var _a;
            return ((_a = node || nodeRef.current) === null || _a === void 0 ? void 0 : _a.ownerDocument) || document;
        };
        var getOwnerWindow = function(node) {
            var _a;
            return ((_a = getOwnerDocument(node)) === null || _a === void 0 ? void 0 : _a.defaultView) || window;
        };
        return {
            getOwnerDocument: getOwnerDocument,
            getOwnerWindow: getOwnerWindow
        };
    }, [
        nodeRef
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$41b6c5189865fe72.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$f4208dae105d4d3 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$91a992459f6e0f07 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useEvents", "EventsContext", $2e545d666ef3112d$export$f4208dae105d4d3);
function $2e545d666ef3112d$export$686accdd53ac150f(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState({}), 1), subscriptions = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            Object.keys(subscriptions).forEach(function(topic) {
                return delete subscriptions[topic];
            });
        };
    }, [
        subscriptions
    ]);
    var context = $eHaBZ.useMemo(function() {
        var unsubscribe = function(topic, callback) {
            var _a;
            var _a1;
            (_a1 = subscriptions[topic]) === null || _a1 === void 0 || (_a = _a1).splice.apply(_a, [
                0,
                subscriptions[topic].length
            ].concat((0, $6zk1M._)(subscriptions[topic].filter(function(cb) {
                return cb !== callback;
            }))));
        };
        var subscribe = function(topic, callback) {
            if (!subscriptions[topic]) subscriptions[topic] = [];
            subscriptions[topic].push(callback);
            return function() {
                return unsubscribe(topic, callback);
            };
        };
        var publish = function() {
            for(var _len = arguments.length, _tmp = new Array(_len), _key = 0; _key < _len; _key++){
                _tmp[_key] = arguments[_key];
            }
            var _tmp1 = (0, $21h22._)(_tmp, 2), topic = _tmp1[0], event = _tmp1[1];
            var _a;
            (_a = subscriptions[topic]) === null || _a === void 0 || _a.forEach(function(callback) {
                return callback(event);
            });
        };
        return {
            publish: publish,
            subscribe: subscribe,
            unsubscribe: unsubscribe
        };
    }, [
        subscriptions
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$f4208dae105d4d3.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$9f6b9cbf1d54cc28 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$d930f3536e1c64f6 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxProps", "LightboxPropsContext", $2e545d666ef3112d$export$9f6b9cbf1d54cc28);
function $2e545d666ef3112d$export$7141a340a3dea601(_param) {
    var children = _param.children, props = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "children"
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$9f6b9cbf1d54cc28.Provider, {
        value: props
    }, children);
}
var $2e545d666ef3112d$export$c24db94cf7704d3a = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$566121e2bbc52eec = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxState", "LightboxStateContext", $2e545d666ef3112d$export$c24db94cf7704d3a);
var $2e545d666ef3112d$export$42eb31c6c0f01c10 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$9463bb14d6ba055e = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useLightboxDispatch", "LightboxDispatchContext", $2e545d666ef3112d$export$42eb31c6c0f01c10);
function $2e545d666ef3112d$var$reducer(state, action) {
    switch(action.type){
        case "swipe":
            {
                var slides = state.slides;
                var increment = (action === null || action === void 0 ? void 0 : action.increment) || 0;
                var globalIndex = state.globalIndex + increment;
                var currentIndex = $2e545d666ef3112d$export$501611100333094a(globalIndex, slides.length);
                var currentSlide = $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, currentIndex);
                var animation = increment || action.duration !== undefined ? {
                    increment: increment,
                    duration: action.duration,
                    easing: action.easing
                } : undefined;
                return {
                    slides: slides,
                    currentIndex: currentIndex,
                    globalIndex: globalIndex,
                    currentSlide: currentSlide,
                    animation: animation
                };
            }
        case "update":
            if (action.slides !== state.slides || action.index !== state.currentIndex) return {
                slides: action.slides,
                currentIndex: action.index,
                globalIndex: action.index,
                currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(action.slides, action.index)
            };
            return state;
        default:
            throw new Error((0, $b17a7fd270a24b50$export$b149fc25cb186fec));
    }
}
function $2e545d666ef3112d$export$62d2e1d2e7609988(param) {
    var slides = param.slides, index = param.index, children = param.children;
    var _React_useReducer = (0, $21h22._)($eHaBZ.useReducer($2e545d666ef3112d$var$reducer, {
        slides: slides,
        currentIndex: index,
        globalIndex: index,
        currentSlide: $2e545d666ef3112d$export$9f2f3fed4fdffdfc(slides, index)
    }), 2), state = _React_useReducer[0], dispatch = _React_useReducer[1];
    var _React_useState = (0, $21h22._)($eHaBZ.useState(slides), 2), prevSlides = _React_useState[0], setPrevSlides = _React_useState[1];
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState(index), 2), prevIndex = _React_useState1[0], setPrevIndex = _React_useState1[1];
    if (slides !== prevSlides || index !== prevIndex) {
        setPrevSlides(slides);
        setPrevIndex(index);
        dispatch({
            type: "update",
            slides: slides,
            index: index
        });
    }
    var context = $eHaBZ.useMemo(function() {
        return (0, $9Jpjh._)((0, $lvTkn._)({}, state), {
            state: state,
            dispatch: dispatch
        });
    }, [
        state,
        dispatch
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$42eb31c6c0f01c10.Provider, {
        value: dispatch
    }, $eHaBZ.createElement($2e545d666ef3112d$export$c24db94cf7704d3a.Provider, {
        value: context
    }, children));
}
var $2e545d666ef3112d$export$e96e3cec40decff1 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$57c05a83b72fe7b = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useRTLContext", "RTLContext", $2e545d666ef3112d$export$e96e3cec40decff1);
function $2e545d666ef3112d$export$625eb40e2215f320(param) {
    var isRTL = param.isRTL, children = param.children;
    var context = $eHaBZ.useMemo(function() {
        return {
            isRTL: isRTL
        };
    }, [
        isRTL
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$e96e3cec40decff1.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$e338b1178a56544e = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$1bc7162631c81b3f = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useTimeouts", "TimeoutsContext", $2e545d666ef3112d$export$e338b1178a56544e);
function $2e545d666ef3112d$export$9d9954f5885fa393(param) {
    var children = param.children;
    var _React_useState = (0, $21h22._)($eHaBZ.useState([]), 1), timeouts = _React_useState[0];
    $eHaBZ.useEffect(function() {
        return function() {
            timeouts.forEach(function(tid) {
                return window.clearTimeout(tid);
            });
            timeouts.splice(0, timeouts.length);
        };
    }, [
        timeouts
    ]);
    var context = $eHaBZ.useMemo(function() {
        var removeTimeout = function(id) {
            var _timeouts;
            (_timeouts = timeouts).splice.apply(_timeouts, [
                0,
                timeouts.length
            ].concat((0, $6zk1M._)(timeouts.filter(function(tid) {
                return tid !== id;
            }))));
        };
        var setTimeout = function(fn, delay) {
            var id = window.setTimeout(function() {
                removeTimeout(id);
                fn();
            }, delay);
            timeouts.push(id);
            return id;
        };
        var clearTimeout = function(id) {
            if (id !== undefined) {
                removeTimeout(id);
                window.clearTimeout(id);
            }
        };
        return {
            setTimeout: setTimeout,
            clearTimeout: clearTimeout
        };
    }, [
        timeouts
    ]);
    return $eHaBZ.createElement($2e545d666ef3112d$export$e338b1178a56544e.Provider, {
        value: context
    }, children);
}
var $2e545d666ef3112d$export$c25acd513dcc8062 = $eHaBZ.forwardRef(function IconButton(_param, ref) {
    var label = _param.label, className = _param.className, Icon = _param.icon, renderIcon = _param.renderIcon, onClick = _param.onClick, style = _param.style, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "label",
        "className",
        "icon",
        "renderIcon",
        "onClick",
        "style"
    ]);
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), styles = _useLightboxProps.styles, labels = _useLightboxProps.labels;
    var buttonLabel = $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, label);
    return $eHaBZ.createElement("button", (0, $lvTkn._)({
        ref: ref,
        type: "button",
        title: buttonLabel,
        "aria-label": buttonLabel,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$d62fb7722b07f2f3)), className),
        onClick: onClick,
        style: (0, $lvTkn._)({}, style, styles.button)
    }, rest), renderIcon ? renderIcon() : $eHaBZ.createElement(Icon, {
        className: $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)),
        style: styles.icon
    }));
});
function $2e545d666ef3112d$var$svgIcon(name, children) {
    var icon = function(props) {
        return $eHaBZ.createElement("svg", (0, $lvTkn._)({
            xmlns: "http://www.w3.org/2000/svg",
            viewBox: "0 0 24 24",
            width: "24",
            height: "24",
            "aria-hidden": "true",
            focusable: "false"
        }, props), children);
    };
    icon.displayName = name;
    return icon;
}
function $2e545d666ef3112d$export$274edc73af1ae9c8(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement("g", {
        fill: "currentColor"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph));
}
function $2e545d666ef3112d$export$6b1fd58c1dc933ec(name, glyph) {
    return $2e545d666ef3112d$var$svgIcon(name, $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("defs", null, $eHaBZ.createElement("mask", {
        id: "strike"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "white"
    }), $eHaBZ.createElement("path", {
        d: "M0 0L24 24",
        stroke: "black",
        strokeWidth: 4
    }))), $eHaBZ.createElement("path", {
        d: "M0.70707 2.121320L21.878680 23.292883",
        stroke: "currentColor",
        strokeWidth: 2
    }), $eHaBZ.createElement("g", {
        fill: "currentColor",
        mask: "url(#strike)"
    }, $eHaBZ.createElement("path", {
        d: "M0 0h24v24H0z",
        fill: "none"
    }), glyph)));
}
var $2e545d666ef3112d$export$cae179f078f4b4a4 = $2e545d666ef3112d$export$274edc73af1ae9c8("Close", $eHaBZ.createElement("path", {
    d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
}));
var $2e545d666ef3112d$export$d05925e1c7f3f136 = $2e545d666ef3112d$export$274edc73af1ae9c8("Previous", $eHaBZ.createElement("path", {
    d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}));
var $2e545d666ef3112d$export$3da0e0ec94bd4ce1 = $2e545d666ef3112d$export$274edc73af1ae9c8("Next", $eHaBZ.createElement("path", {
    d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}));
var $2e545d666ef3112d$export$b936c55164dcf1db = $2e545d666ef3112d$export$274edc73af1ae9c8("Loading", $eHaBZ.createElement($eHaBZ.Fragment, null, Array.from({
    length: 8
}).map(function(_, index, array) {
    return $eHaBZ.createElement("line", {
        key: index,
        x1: "12",
        y1: "6.5",
        x2: "12",
        y2: "1.8",
        strokeLinecap: "round",
        strokeWidth: "2.6",
        stroke: "currentColor",
        strokeOpacity: 1 / array.length * (index + 1),
        transform: "rotate(".concat(360 / array.length * index, ", 12, 12)")
    });
})));
var $2e545d666ef3112d$export$19bc16ee58e19b3d = $2e545d666ef3112d$export$274edc73af1ae9c8("Error", $eHaBZ.createElement("path", {
    d: "M21.9,21.9l-8.49-8.49l0,0L3.59,3.59l0,0L2.1,2.1L0.69,3.51L3,5.83V19c0,1.1,0.9,2,2,2h13.17l2.31,2.31L21.9,21.9z M5,18 l3.5-4.5l2.5,3.01L12.17,15l3,3H5z M21,18.17L5.83,3H19c1.1,0,2,0.9,2,2V18.17z"
}));
var $2e545d666ef3112d$export$e5c5a5f917a5871c = $2e545d666ef3112d$export$fef62134eea24008() ? $eHaBZ.useLayoutEffect : $eHaBZ.useEffect;
function $2e545d666ef3112d$export$f3e625e1b2b31d60() {
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), reduceMotion = _React_useState[0], setReduceMotion = _React_useState[1];
    $eHaBZ.useEffect(function() {
        var _a, _b;
        var mediaQuery = (_a = window.matchMedia) === null || _a === void 0 ? void 0 : _a.call(window, "(prefers-reduced-motion: reduce)");
        setReduceMotion(mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.matches);
        var listener = function(event) {
            return setReduceMotion(event.matches);
        };
        (_b = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.addEventListener) === null || _b === void 0 || _b.call(mediaQuery, "change", listener);
        return function() {
            var _a;
            return (_a = mediaQuery === null || mediaQuery === void 0 ? void 0 : mediaQuery.removeEventListener) === null || _a === void 0 ? void 0 : _a.call(mediaQuery, "change", listener);
        };
    }, []);
    return reduceMotion;
}
function $2e545d666ef3112d$var$currentTransformation(node) {
    var x = 0;
    var y = 0;
    var z = 0;
    var matrix = window.getComputedStyle(node).transform;
    var matcher = matrix.match(/matrix.*\((.+)\)/);
    if (matcher) {
        var values = matcher[1].split(",").map($2e545d666ef3112d$export$5f87784a266e50a4);
        if (values.length === 6) {
            x = values[4];
            y = values[5];
        } else if (values.length === 16) {
            x = values[12];
            y = values[13];
            z = values[14];
        }
    }
    return {
        x: x,
        y: y,
        z: z
    };
}
function $2e545d666ef3112d$export$9e2608686d4ad846(nodeRef, computeAnimation) {
    var snapshot = $eHaBZ.useRef(undefined);
    var animation = $eHaBZ.useRef(undefined);
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        var _a, _b, _c;
        if (nodeRef.current && snapshot.current !== undefined && !reduceMotion) {
            var _ref = computeAnimation(snapshot.current, nodeRef.current.getBoundingClientRect(), $2e545d666ef3112d$var$currentTransformation(nodeRef.current)) || {}, keyframes = _ref.keyframes, duration = _ref.duration, easing = _ref.easing, onfinish = _ref.onfinish;
            if (keyframes && duration) {
                (_a = animation.current) === null || _a === void 0 || _a.cancel();
                animation.current = undefined;
                try {
                    animation.current = (_c = (_b = nodeRef.current).animate) === null || _c === void 0 ? void 0 : _c.call(_b, keyframes, {
                        duration: duration,
                        easing: easing
                    });
                } catch (err) {
                    console.error(err);
                }
                if (animation.current) animation.current.onfinish = function() {
                    animation.current = undefined;
                    onfinish === null || onfinish === void 0 || onfinish();
                };
            }
        }
        snapshot.current = undefined;
    });
    return {
        prepareAnimation: function(currentSnapshot) {
            snapshot.current = currentSnapshot;
        },
        isAnimationPlaying: function() {
            var _a;
            return ((_a = animation.current) === null || _a === void 0 ? void 0 : _a.playState) === "running";
        }
    };
}
function $2e545d666ef3112d$export$b1d85de58d38d09d() {
    var containerRef = $eHaBZ.useRef(null);
    var observerRef = $eHaBZ.useRef(undefined);
    var _React_useState = (0, $21h22._)($eHaBZ.useState(), 2), containerRect = _React_useState[0], setContainerRect = _React_useState[1];
    var setContainerRef = $eHaBZ.useCallback(function(node) {
        containerRef.current = node;
        if (observerRef.current) {
            observerRef.current.disconnect();
            observerRef.current = undefined;
        }
        var updateContainerRect = function() {
            if (node) {
                var styles = window.getComputedStyle(node);
                var parse = function(value) {
                    return parseFloat(value) || 0;
                };
                setContainerRect({
                    width: Math.round(node.clientWidth - parse(styles.paddingLeft) - parse(styles.paddingRight)),
                    height: Math.round(node.clientHeight - parse(styles.paddingTop) - parse(styles.paddingBottom))
                });
            } else setContainerRect(undefined);
        };
        updateContainerRect();
        if (node && typeof ResizeObserver !== "undefined") {
            observerRef.current = new ResizeObserver(updateContainerRect);
            observerRef.current.observe(node);
        }
    }, []);
    return {
        setContainerRef: setContainerRef,
        containerRef: containerRef,
        containerRect: containerRect
    };
}
function $2e545d666ef3112d$export$69f38700ea0cb3b9() {
    var timeoutId = $eHaBZ.useRef(undefined);
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    return $eHaBZ.useCallback(function(callback, delay) {
        clearTimeout(timeoutId.current);
        timeoutId.current = setTimeout(callback, delay > 0 ? delay : 0);
    }, [
        setTimeout,
        clearTimeout
    ]);
}
function $2e545d666ef3112d$export$ee5b5d04074a389e(fn) {
    var ref = $eHaBZ.useRef(fn);
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        ref.current = fn;
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        var _a;
        var _a1;
        return (_a1 = ref.current) === null || _a1 === void 0 ? void 0 : (_a = _a1).call.apply(_a, [
            ref
        ].concat((0, $6zk1M._)(args)));
    }, []);
}
function $2e545d666ef3112d$export$4bb192c7cacf928f(ref, value) {
    if (typeof ref === "function") ref(value);
    else if (ref) ref.current = value;
}
function $2e545d666ef3112d$export$ebc1e1560c2dffa5(refA, refB) {
    return $eHaBZ.useMemo(function() {
        return refA == null && refB == null ? null : function(refValue) {
            $2e545d666ef3112d$export$4bb192c7cacf928f(refA, refValue);
            $2e545d666ef3112d$export$4bb192c7cacf928f(refB, refValue);
        };
    }, [
        refA,
        refB
    ]);
}
function $2e545d666ef3112d$export$2bd1c19440b9235c(focus) {
    var disabled = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
    var focused = $eHaBZ.useRef(false);
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        if (disabled && focused.current) {
            focused.current = false;
            focus();
        }
    }, [
        disabled,
        focus
    ]);
    var onFocus = $eHaBZ.useCallback(function() {
        focused.current = true;
    }, []);
    var onBlur = $eHaBZ.useCallback(function() {
        focused.current = false;
    }, []);
    return {
        onFocus: onFocus,
        onBlur: onBlur
    };
}
function $2e545d666ef3112d$export$81f015b3ec5d61cf() {
    return $2e545d666ef3112d$export$57c05a83b72fe7b().isRTL;
}
function $2e545d666ef3112d$export$19012f58216d597f() {
    var _React_useState = (0, $21h22._)($eHaBZ.useState({}), 1), subscribers = _React_useState[0];
    var notifySubscribers = $eHaBZ.useCallback(function(type, event) {
        var _a;
        (_a = subscribers[type]) === null || _a === void 0 || _a.forEach(function(listener) {
            if (!event.isPropagationStopped()) listener(event);
        });
    }, [
        subscribers
    ]);
    var registerSensors = $eHaBZ.useMemo(function() {
        return {
            onPointerDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$e15fc153f45a963d), event);
            },
            onPointerMove: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), event);
            },
            onPointerUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), event);
            },
            onPointerLeave: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$526cafa85592f1a5), event);
            },
            onPointerCancel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$22151cee048c4be9), event);
            },
            onKeyDown: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), event);
            },
            onKeyUp: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$bdb9f99d61a6879b), event);
            },
            onWheel: function(event) {
                return notifySubscribers((0, $b17a7fd270a24b50$export$5635dc9d647242c7), event);
            }
        };
    }, [
        notifySubscribers
    ]);
    var subscribeSensors = $eHaBZ.useCallback(function(type, callback) {
        if (!subscribers[type]) subscribers[type] = [];
        subscribers[type].unshift(callback);
        return function() {
            var _listeners;
            var listeners = subscribers[type];
            if (listeners) (_listeners = listeners).splice.apply(_listeners, [
                0,
                listeners.length
            ].concat((0, $6zk1M._)(listeners.filter(function(el) {
                return el !== callback;
            }))));
        };
    }, [
        subscribers
    ]);
    return {
        registerSensors: registerSensors,
        subscribeSensors: subscribeSensors
    };
}
function $2e545d666ef3112d$export$8b7b9481d6186f21(callback, delay) {
    var lastCallbackTime = $eHaBZ.useRef(0);
    var delayCallback = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var executeCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        lastCallbackTime.current = Date.now();
        callback.apply(void 0, (0, $6zk1M._)(args));
    });
    return $eHaBZ.useCallback(function() {
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++){
            args[_key] = arguments[_key];
        }
        delayCallback(function() {
            executeCallback.apply(void 0, (0, $6zk1M._)(args));
        }, delay - (Date.now() - lastCallbackTime.current));
    }, [
        delay,
        executeCallback,
        delayCallback
    ]);
}
var $2e545d666ef3112d$var$slidePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide");
var $2e545d666ef3112d$var$slideImagePrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("slide_image");
function $2e545d666ef3112d$export$ef86b1d52c77b27b(param) {
    var image = param.slide, offset = param.offset, render = param.render, rect = param.rect, imageFit = param.imageFit, imageProps = param.imageProps, onClick = param.onClick, onLoad = param.onLoad, onError = param.onError, style = param.style;
    var _Math, _Math1;
    var _a, _b, _c, _d, _e, _f, _g, _h;
    var _React_useState = (0, $21h22._)($eHaBZ.useState((0, $b17a7fd270a24b50$export$554a1415841c52a8)), 2), status = _React_useState[0], setStatus = _React_useState[1];
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var imageRef = $eHaBZ.useRef(null);
    $eHaBZ.useEffect(function() {
        if (offset === 0) publish((0, $b17a7fd270a24b50$export$6751782e799f6445)(status));
    }, [
        offset,
        status,
        publish
    ]);
    var handleLoading = $2e545d666ef3112d$export$ee5b5d04074a389e(function(img) {
        ("decode" in img ? img.decode() : Promise.resolve()).catch(function() {}).then(function() {
            if (!img.parentNode) return;
            setStatus((0, $b17a7fd270a24b50$export$a195e517d37aaa33));
            setTimeout(function() {
                onLoad === null || onLoad === void 0 || onLoad(img);
            }, 0);
        });
    });
    var setImageRef = $eHaBZ.useCallback(function(img) {
        imageRef.current = img;
        if (img === null || img === void 0 ? void 0 : img.complete) handleLoading(img);
    }, [
        handleLoading
    ]);
    var handleOnLoad = $eHaBZ.useCallback(function(event) {
        handleLoading(event.currentTarget);
    }, [
        handleLoading
    ]);
    var handleOnError = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        setStatus((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91));
        onError === null || onError === void 0 || onError();
    });
    var cover = $2e545d666ef3112d$export$f5ba2f5b3fd12e6e(image, imageFit);
    var nonInfinite = function(value, fallback) {
        return Number.isFinite(value) ? value : fallback;
    };
    var maxWidth = nonInfinite((_Math = Math).max.apply(_Math, (0, $6zk1M._)(((_b = (_a = image.srcSet) === null || _a === void 0 ? void 0 : _a.map(function(x) {
        return x.width;
    })) !== null && _b !== void 0 ? _b : []).concat(image.width ? [
        image.width
    ] : []).filter(Boolean))), ((_c = imageRef.current) === null || _c === void 0 ? void 0 : _c.naturalWidth) || 0);
    var maxHeight = nonInfinite((_Math1 = Math).max.apply(_Math1, (0, $6zk1M._)(((_e = (_d = image.srcSet) === null || _d === void 0 ? void 0 : _d.map(function(x) {
        return x.height;
    })) !== null && _e !== void 0 ? _e : []).concat(image.height ? [
        image.height
    ] : []).filter(Boolean))), ((_f = imageRef.current) === null || _f === void 0 ? void 0 : _f.naturalHeight) || 0);
    var defaultStyle = maxWidth && maxHeight ? {
        maxWidth: "min(".concat(maxWidth, "px, 100%)"),
        maxHeight: "min(".concat(maxHeight, "px, 100%)")
    } : {
        maxWidth: "100%",
        maxHeight: "100%"
    };
    var srcSet = (_g = image.srcSet) === null || _g === void 0 ? void 0 : _g.slice().sort(function(a, b) {
        return a.width - b.width;
    }).map(function(item) {
        return "".concat(item.src, " ").concat(item.width, "w");
    }).join(", ");
    var estimateActualWidth = function() {
        return rect && !cover && image.width && image.height ? rect.height / image.height * image.width : Number.MAX_VALUE;
    };
    var sizes = srcSet && rect && $2e545d666ef3112d$export$fef62134eea24008() ? "".concat(Math.round(Math.min(estimateActualWidth(), rect.width)), "px") : undefined;
    var _ref = (typeof imageProps === "function" ? imageProps(image) : imageProps) || {}, imagePropsStyle = _ref.style, imagePropsClassName = _ref.className, restImageProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_ref, [
        "style",
        "className"
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, $eHaBZ.createElement("img", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: setImageRef,
        onLoad: handleOnLoad,
        onError: handleOnError,
        onClick: onClick,
        draggable: false,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix()), cover && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("cover")), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slideImagePrefix("loading")), imagePropsClassName),
        style: (0, $lvTkn._)({}, defaultStyle, style, imagePropsStyle)
    }, restImageProps), {
        alt: (_h = image.alt) !== null && _h !== void 0 ? _h : "",
        sizes: sizes,
        srcSet: srcSet,
        src: image.src
    })), status !== (0, $b17a7fd270a24b50$export$a195e517d37aaa33) && $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$e51f1c6d74b54a13)))
    }, status === (0, $b17a7fd270a24b50$export$554a1415841c52a8) && ((render === null || render === void 0 ? void 0 : render.iconLoading) ? render.iconLoading() : $eHaBZ.createElement($2e545d666ef3112d$export$b936c55164dcf1db, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$554a1415841c52a8))))
    })), status === (0, $b17a7fd270a24b50$export$2ed3c80dbc178d91) && ((render === null || render === void 0 ? void 0 : render.iconError) ? render.iconError() : $eHaBZ.createElement($2e545d666ef3112d$export$19bc16ee58e19b3d, {
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$c5f5ca1963fed141)), $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$slidePrefix((0, $b17a7fd270a24b50$export$2ed3c80dbc178d91))))
    }))));
}
var $2e545d666ef3112d$export$597a6f74cf288f82 = $eHaBZ.forwardRef(function LightboxRoot(_param, ref) {
    var className = _param.className, children = _param.children, onFocus = _param.onFocus, onBlur = _param.onBlur, rest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "className",
        "children",
        "onFocus",
        "onBlur"
    ]);
    var nodeRef = $eHaBZ.useRef(null);
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), isRTL = _React_useState[0], setIsRTL = _React_useState[1];
    var trackFocusWithin = $2e545d666ef3112d$export$3992c64d261ded5a().trackFocusWithin;
    var detectRTL = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (nodeRef.current) {
            var rtl = window.getComputedStyle(nodeRef.current).direction === "rtl";
            if (rtl !== isRTL) setIsRTL(rtl);
        }
    });
    $eHaBZ.useEffect(detectRTL);
    return $eHaBZ.createElement($2e545d666ef3112d$export$30e869153d18a2e6, {
        nodeRef: nodeRef
    }, $eHaBZ.createElement($2e545d666ef3112d$export$625eb40e2215f320, {
        isRTL: isRTL
    }, $eHaBZ.createElement("div", (0, $lvTkn._)({
        ref: $2e545d666ef3112d$export$ebc1e1560c2dffa5(ref, nodeRef),
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a("root"), className)
    }, trackFocusWithin(onFocus, onBlur), rest), children)));
});
var $2e545d666ef3112d$export$59f0048f451fc458;
(function(SwipeState) {
    SwipeState[SwipeState["NONE"] = 0] = "NONE";
    SwipeState[SwipeState["SWIPE"] = 1] = "SWIPE";
    SwipeState[SwipeState["PULL"] = 2] = "PULL";
    SwipeState[SwipeState["ANIMATION"] = 3] = "ANIMATION";
})($2e545d666ef3112d$export$59f0048f451fc458 || ($2e545d666ef3112d$export$59f0048f451fc458 = {}));
function $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp, disabled) {
    $eHaBZ.useEffect(function() {
        return !disabled ? $2e545d666ef3112d$export$de863c629cb9919d(subscribeSensors((0, $b17a7fd270a24b50$export$e15fc153f45a963d), onPointerDown), subscribeSensors((0, $b17a7fd270a24b50$export$1f8863949fbdd7e5), onPointerMove), subscribeSensors((0, $b17a7fd270a24b50$export$2d868b67a5791b8a), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$526cafa85592f1a5), onPointerUp), subscribeSensors((0, $b17a7fd270a24b50$export$22151cee048c4be9), onPointerUp)) : function() {};
    }, [
        subscribeSensors,
        onPointerDown,
        onPointerMove,
        onPointerUp,
        disabled
    ]);
}
var $2e545d666ef3112d$var$Gesture;
(function(Gesture) {
    Gesture[Gesture["NONE"] = 0] = "NONE";
    Gesture[Gesture["SWIPE"] = 1] = "SWIPE";
    Gesture[Gesture["PULL"] = 2] = "PULL";
})($2e545d666ef3112d$var$Gesture || ($2e545d666ef3112d$var$Gesture = {}));
var $2e545d666ef3112d$var$SWIPE_THRESHOLD = 30;
function $2e545d666ef3112d$export$abaee32ee49963c1(param, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel, pullUpEnabled, pullDownEnabled, onPullStart, onPullProgress, onPullFinish, onPullCancel, onClose) {
    var disableSwipeNavigation = param.disableSwipeNavigation, closeOnBackdropClick = param.closeOnBackdropClick;
    var offset = $eHaBZ.useRef(0);
    var pointers = $eHaBZ.useRef([]);
    var activePointer = $eHaBZ.useRef(undefined);
    var startTime = $eHaBZ.useRef(0);
    var gesture = $eHaBZ.useRef($2e545d666ef3112d$var$Gesture.NONE);
    var clearPointer = $eHaBZ.useCallback(function(event) {
        var _currentPointers;
        if (activePointer.current === event.pointerId) {
            activePointer.current = undefined;
            gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
        }
        var currentPointers = pointers.current;
        (_currentPointers = currentPointers).splice.apply(_currentPointers, [
            0,
            currentPointers.length
        ].concat((0, $6zk1M._)(currentPointers.filter(function(p) {
            return p.pointerId !== event.pointerId;
        }))));
    }, []);
    var addPointer = $eHaBZ.useCallback(function(event) {
        clearPointer(event);
        event.persist();
        pointers.current.push(event);
    }, [
        clearPointer
    ]);
    var lookupPointer = $eHaBZ.useCallback(function(event) {
        return pointers.current.find(function(param) {
            var pointerId = param.pointerId;
            return event.pointerId === pointerId;
        });
    }, []);
    var onPointerDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        addPointer(event);
    });
    var exceedsPullThreshold = function(value, threshold) {
        return pullDownEnabled && value > threshold || pullUpEnabled && value < -threshold;
    };
    var onPointerUp = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var pointer = lookupPointer(event);
        if (pointer) {
            if (activePointer.current === event.pointerId) {
                var duration = Date.now() - startTime.current;
                var currentOffset = offset.current;
                if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                    if (Math.abs(currentOffset) > 0.3 * containerWidth || Math.abs(currentOffset) > 5 && duration < swipeAnimationDuration) onSwipeFinish(currentOffset, duration);
                    else onSwipeCancel(currentOffset);
                } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL) {
                    if (exceedsPullThreshold(currentOffset, 2 * $2e545d666ef3112d$var$SWIPE_THRESHOLD)) onPullFinish(currentOffset, duration);
                    else onPullCancel(currentOffset);
                }
                offset.current = 0;
                gesture.current = $2e545d666ef3112d$var$Gesture.NONE;
            } else {
                var target = event.target;
                if (closeOnBackdropClick && target instanceof HTMLElement && target === pointer.target && (target.classList.contains($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$8d922915837a38d3))) || target.classList.contains($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$ac396c284080b10c))))) onClose();
            }
        }
        clearPointer(event);
    });
    var onPointerMove = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var pointer = lookupPointer(event);
        if (pointer) {
            var isCurrentPointer = activePointer.current === event.pointerId;
            if (event.buttons === 0) {
                if (isCurrentPointer && offset.current !== 0) onPointerUp(event);
                else clearPointer(pointer);
                return;
            }
            var deltaX = event.clientX - pointer.clientX;
            var deltaY = event.clientY - pointer.clientY;
            if (activePointer.current === undefined) {
                var startGesture = function(newGesture) {
                    addPointer(event);
                    activePointer.current = event.pointerId;
                    startTime.current = Date.now();
                    gesture.current = newGesture;
                };
                if (Math.abs(deltaX) > Math.abs(deltaY) && Math.abs(deltaX) > $2e545d666ef3112d$var$SWIPE_THRESHOLD && isSwipeValid(deltaX)) {
                    if (!disableSwipeNavigation) {
                        startGesture($2e545d666ef3112d$var$Gesture.SWIPE);
                        onSwipeStart();
                    }
                } else if (Math.abs(deltaY) > Math.abs(deltaX) && exceedsPullThreshold(deltaY, $2e545d666ef3112d$var$SWIPE_THRESHOLD)) {
                    startGesture($2e545d666ef3112d$var$Gesture.PULL);
                    onPullStart();
                }
            } else if (isCurrentPointer) {
                if (gesture.current === $2e545d666ef3112d$var$Gesture.SWIPE) {
                    offset.current = deltaX;
                    onSwipeProgress(deltaX);
                } else if (gesture.current === $2e545d666ef3112d$var$Gesture.PULL) {
                    offset.current = deltaY;
                    onPullProgress(deltaY);
                }
            }
        }
    });
    $2e545d666ef3112d$export$69c48c1cbbd6dc69(subscribeSensors, onPointerDown, onPointerMove, onPointerUp);
}
function $2e545d666ef3112d$export$145fefb2d7286388(param) {
    var preventDefaultWheelX = param.preventDefaultWheelX, preventDefaultWheelY = param.preventDefaultWheelY;
    var ref = $eHaBZ.useRef(null);
    var listener = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        var horizontal = Math.abs(event.deltaX) > Math.abs(event.deltaY);
        if (horizontal && preventDefaultWheelX || !horizontal && preventDefaultWheelY || event.ctrlKey) event.preventDefault();
    });
    return $eHaBZ.useCallback(function(node) {
        var _a;
        if (node) node.addEventListener("wheel", listener, {
            passive: false
        });
        else (_a = ref.current) === null || _a === void 0 || _a.removeEventListener("wheel", listener);
        ref.current = node;
    }, [
        listener
    ]);
}
function $2e545d666ef3112d$export$10506de8b6841445(swipeState, subscribeSensors, isSwipeValid, containerWidth, swipeAnimationDuration, onSwipeStart, onSwipeProgress, onSwipeFinish, onSwipeCancel) {
    var offset = $eHaBZ.useRef(0);
    var intent = $eHaBZ.useRef(0);
    var intentCleanup = $eHaBZ.useRef(undefined);
    var resetCleanup = $eHaBZ.useRef(undefined);
    var wheelInertia = $eHaBZ.useRef(0);
    var wheelInertiaCleanup = $eHaBZ.useRef(undefined);
    var startTime = $eHaBZ.useRef(0);
    var _useTimeouts = $2e545d666ef3112d$export$1bc7162631c81b3f(), setTimeout = _useTimeouts.setTimeout, clearTimeout = _useTimeouts.clearTimeout;
    var cancelSwipeIntentCleanup = $eHaBZ.useCallback(function() {
        if (intentCleanup.current) {
            clearTimeout(intentCleanup.current);
            intentCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var cancelSwipeResetCleanup = $eHaBZ.useCallback(function() {
        if (resetCleanup.current) {
            clearTimeout(resetCleanup.current);
            resetCleanup.current = undefined;
        }
    }, [
        clearTimeout
    ]);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (swipeState !== $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            offset.current = 0;
            startTime.current = 0;
            cancelSwipeIntentCleanup();
            cancelSwipeResetCleanup();
        }
    });
    $eHaBZ.useEffect(handleCleanup, [
        swipeState,
        handleCleanup
    ]);
    var handleCancelSwipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(currentSwipeOffset) {
        resetCleanup.current = undefined;
        if (offset.current === currentSwipeOffset) onSwipeCancel(offset.current);
    });
    var onWheel = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        if (event.ctrlKey) return;
        if (Math.abs(event.deltaY) > Math.abs(event.deltaX)) return;
        var setWheelInertia = function(inertia) {
            wheelInertia.current = inertia;
            clearTimeout(wheelInertiaCleanup.current);
            wheelInertiaCleanup.current = inertia > 0 ? setTimeout(function() {
                wheelInertia.current = 0;
                wheelInertiaCleanup.current = undefined;
            }, 300) : undefined;
        };
        if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.NONE) {
            if (Math.abs(event.deltaX) <= 1.2 * Math.abs(wheelInertia.current)) {
                setWheelInertia(event.deltaX);
                return;
            }
            if (!isSwipeValid(-event.deltaX)) return;
            intent.current += event.deltaX;
            cancelSwipeIntentCleanup();
            if (Math.abs(intent.current) > 30) {
                intent.current = 0;
                setWheelInertia(0);
                startTime.current = Date.now();
                onSwipeStart();
            } else {
                var currentSwipeIntent = intent.current;
                intentCleanup.current = setTimeout(function() {
                    intentCleanup.current = undefined;
                    if (currentSwipeIntent === intent.current) intent.current = 0;
                }, swipeAnimationDuration);
            }
        } else if (swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE) {
            var newSwipeOffset = offset.current - event.deltaX;
            newSwipeOffset = Math.min(Math.abs(newSwipeOffset), containerWidth) * Math.sign(newSwipeOffset);
            offset.current = newSwipeOffset;
            onSwipeProgress(newSwipeOffset);
            cancelSwipeResetCleanup();
            if (Math.abs(newSwipeOffset) > 0.2 * containerWidth) {
                setWheelInertia(event.deltaX);
                onSwipeFinish(newSwipeOffset, Date.now() - startTime.current);
                return;
            }
            resetCleanup.current = setTimeout(function() {
                return handleCancelSwipe(newSwipeOffset);
            }, 2 * swipeAnimationDuration);
        } else setWheelInertia(event.deltaX);
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$5635dc9d647242c7), onWheel);
    }, [
        subscribeSensors,
        onWheel
    ]);
}
var $2e545d666ef3112d$var$cssContainerPrefix = $2e545d666ef3112d$export$3e7cd27eed1727c("container");
var $2e545d666ef3112d$export$e92ff191b0c59550 = $eHaBZ.createContext(null);
var $2e545d666ef3112d$export$e8c786024a2b0a79 = $2e545d666ef3112d$export$aac3e49c3c8b5cb0("useController", "ControllerContext", $2e545d666ef3112d$export$e92ff191b0c59550);
function $2e545d666ef3112d$export$bd0bf19f25da8474(_param) {
    var children = _param.children, props = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "children"
    ]);
    var _a;
    var carousel = props.carousel, animation = props.animation, controller = props.controller, on = props.on, styles = props.styles, render = props.render;
    var closeOnPullUp = controller.closeOnPullUp, closeOnPullDown = controller.closeOnPullDown, preventDefaultWheelX = controller.preventDefaultWheelX, preventDefaultWheelY = controller.preventDefaultWheelY;
    var _React_useState = (0, $21h22._)($eHaBZ.useState(), 2), toolbarWidth = _React_useState[0], setToolbarWidth = _React_useState[1];
    var state = $2e545d666ef3112d$export$566121e2bbc52eec();
    var dispatch = $2e545d666ef3112d$export$9463bb14d6ba055e();
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState($2e545d666ef3112d$export$59f0048f451fc458.NONE), 2), swipeState = _React_useState1[0], setSwipeState = _React_useState1[1];
    var swipeOffset = $eHaBZ.useRef(0);
    var pullOffset = $eHaBZ.useRef(0);
    var pullOpacity = $eHaBZ.useRef(1);
    var _useSensors = $2e545d666ef3112d$export$19012f58216d597f(), registerSensors = _useSensors.registerSensors, subscribeSensors = _useSensors.subscribeSensors;
    var _useEvents = $2e545d666ef3112d$export$91a992459f6e0f07(), subscribe = _useEvents.subscribe, publish = _useEvents.publish;
    var cleanupAnimationIncrement = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupSwipeOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var cleanupPullOffset = $2e545d666ef3112d$export$69f38700ea0cb3b9();
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), containerRef = _useContainerRect.containerRef, setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    var handleContainerRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5($2e545d666ef3112d$export$145fefb2d7286388({
        preventDefaultWheelX: preventDefaultWheelX,
        preventDefaultWheelY: preventDefaultWheelY
    }), setContainerRef);
    var carouselRef = $eHaBZ.useRef(null);
    var setCarouselRef = $2e545d666ef3112d$export$ebc1e1560c2dffa5(carouselRef, undefined);
    var getOwnerDocument = $2e545d666ef3112d$export$c199d36c2862b6ed().getOwnerDocument;
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var rtl = function(value) {
        return (isRTL ? -1 : 1) * (typeof value === "number" ? value : 1);
    };
    var focus = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        return (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    });
    var getLightboxProps = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return props;
    });
    var getLightboxState = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        return state;
    });
    var prev = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955), params);
    }, [
        publish
    ]);
    var next = $eHaBZ.useCallback(function(params) {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), params);
    }, [
        publish
    ]);
    var close = $eHaBZ.useCallback(function() {
        return publish((0, $b17a7fd270a24b50$export$493a596486210a21));
    }, [
        publish
    ]);
    var isSwipeValid = function(offset) {
        return !(carousel.finite && (rtl(offset) > 0 && state.currentIndex === 0 || rtl(offset) < 0 && state.currentIndex === state.slides.length - 1));
    };
    var setSwipeOffset = function(offset) {
        var _a;
        swipeOffset.current = offset;
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(offset), "px"));
    };
    var setPullOffset = function(offset) {
        var _a, _b;
        pullOffset.current = offset;
        pullOpacity.current = function() {
            var threshold = 60;
            var minOpacity = 0.5;
            var offsetValue = function() {
                if (closeOnPullDown && offset > 0) return offset;
                if (closeOnPullUp && offset < 0) return -offset;
                return 0;
            }();
            return Math.min(Math.max($2e545d666ef3112d$export$2077e0241d6afd3c(1 - offsetValue / threshold * (1 - minOpacity), 2), minOpacity), 1);
        }();
        (_a = containerRef.current) === null || _a === void 0 || _a.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_offset"), "".concat(Math.round(offset), "px"));
        (_b = containerRef.current) === null || _b === void 0 || _b.style.setProperty($2e545d666ef3112d$export$8b4981022bd80a4e("pull_opacity"), "".concat(pullOpacity.current));
    };
    var _useAnimation = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        if (carouselRef.current && containerRect) return {
            keyframes: [
                {
                    transform: "translate(0, ".concat(snapshot.rect.y - rect.y + translate.y, "px)"),
                    opacity: snapshot.opacity
                },
                {
                    transform: "translate(0, 0)",
                    opacity: 1
                }
            ],
            duration: snapshot.duration,
            easing: animation.easing.fade
        };
        return undefined;
    }), preparePullAnimation = _useAnimation.prepareAnimation;
    var pull = function(offset, cancel) {
        if (closeOnPullUp || closeOnPullDown) {
            setPullOffset(offset);
            var duration = 0;
            if (carouselRef.current) {
                duration = animation.fade * (cancel ? 2 : 1);
                preparePullAnimation({
                    rect: carouselRef.current.getBoundingClientRect(),
                    opacity: pullOpacity.current,
                    duration: duration
                });
            }
            cleanupPullOffset(function() {
                setPullOffset(0);
                setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
            }, duration);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.ANIMATION);
            if (!cancel) close();
        }
    };
    var _useAnimation1 = $2e545d666ef3112d$export$9e2608686d4ad846(carouselRef, function(snapshot, rect, translate) {
        var _a;
        if (carouselRef.current && containerRect && ((_a = state.animation) === null || _a === void 0 ? void 0 : _a.duration)) {
            var parsedSpacing = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
            var spacingValue = (parsedSpacing.percent ? parsedSpacing.percent * containerRect.width / 100 : parsedSpacing.pixel) || 0;
            return {
                keyframes: [
                    {
                        transform: "translate(".concat(rtl(state.globalIndex - snapshot.index) * (containerRect.width + spacingValue) + snapshot.rect.x - rect.x + translate.x, "px, 0)")
                    },
                    {
                        transform: "translate(0, 0)"
                    }
                ],
                duration: state.animation.duration,
                easing: state.animation.easing
            };
        }
        return undefined;
    }), prepareAnimation = _useAnimation1.prepareAnimation, isAnimationPlaying = _useAnimation1.isAnimationPlaying;
    var swipe = $2e545d666ef3112d$export$ee5b5d04074a389e(function(action) {
        var _a, _b;
        var currentSwipeOffset = action.offset || 0;
        var swipeDuration = !currentSwipeOffset ? (_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe : animation.swipe;
        var swipeEasing = !currentSwipeOffset && !isAnimationPlaying() ? animation.easing.navigation : animation.easing.swipe;
        var direction = action.direction;
        var count = (_b = action.count) !== null && _b !== void 0 ? _b : 1;
        var newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.ANIMATION;
        var newSwipeAnimationDuration = swipeDuration * count;
        if (!direction) {
            var containerWidth = containerRect === null || containerRect === void 0 ? void 0 : containerRect.width;
            var elapsedTime = action.duration || 0;
            var expectedTime = containerWidth ? swipeDuration / containerWidth * Math.abs(currentSwipeOffset) : swipeDuration;
            if (count !== 0) {
                if (elapsedTime < expectedTime) newSwipeAnimationDuration = newSwipeAnimationDuration / expectedTime * Math.max(elapsedTime, expectedTime / 5);
                else if (containerWidth) newSwipeAnimationDuration = swipeDuration / containerWidth * (containerWidth - Math.abs(currentSwipeOffset));
                direction = rtl(currentSwipeOffset) > 0 ? (0, $b17a7fd270a24b50$export$a007161537026955) : (0, $b17a7fd270a24b50$export$f1d7a854db833ed4);
            } else newSwipeAnimationDuration = swipeDuration / 2;
        }
        var increment = 0;
        if (direction === (0, $b17a7fd270a24b50$export$a007161537026955)) {
            if (isSwipeValid(rtl(1))) increment = -count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        } else if (direction === (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)) {
            if (isSwipeValid(rtl(-1))) increment = count;
            else {
                newSwipeState = $2e545d666ef3112d$export$59f0048f451fc458.NONE;
                newSwipeAnimationDuration = swipeDuration;
            }
        }
        newSwipeAnimationDuration = Math.round(newSwipeAnimationDuration);
        cleanupSwipeOffset(function() {
            setSwipeOffset(0);
            setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.NONE);
        }, newSwipeAnimationDuration);
        if (carouselRef.current) prepareAnimation({
            rect: carouselRef.current.getBoundingClientRect(),
            index: state.globalIndex
        });
        setSwipeState(newSwipeState);
        publish((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), {
            type: "swipe",
            increment: increment,
            duration: newSwipeAnimationDuration,
            easing: swipeEasing
        });
    });
    $eHaBZ.useEffect(function() {
        var _a, _b;
        if (((_a = state.animation) === null || _a === void 0 ? void 0 : _a.increment) && ((_b = state.animation) === null || _b === void 0 ? void 0 : _b.duration)) cleanupAnimationIncrement(function() {
            return dispatch({
                type: "swipe",
                increment: 0
            });
        }, state.animation.duration);
    }, [
        state.animation,
        dispatch,
        cleanupAnimationIncrement
    ]);
    var swipeParams = [
        subscribeSensors,
        isSwipeValid,
        (containerRect === null || containerRect === void 0 ? void 0 : containerRect.width) || 0,
        animation.swipe,
        function() {
            return setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.SWIPE);
        },
        function(offset) {
            return setSwipeOffset(offset);
        },
        function(offset, duration) {
            return swipe({
                offset: offset,
                duration: duration,
                count: 1
            });
        },
        function(offset) {
            return swipe({
                offset: offset,
                count: 0
            });
        }
    ];
    var pullParams = [
        function() {
            if (closeOnPullDown) setSwipeState($2e545d666ef3112d$export$59f0048f451fc458.PULL);
        },
        function(offset) {
            return setPullOffset(offset);
        },
        function(offset) {
            return pull(offset);
        },
        function(offset) {
            return pull(offset, true);
        }
    ];
    $2e545d666ef3112d$export$abaee32ee49963c1.apply(void 0, [
        controller
    ].concat((0, $6zk1M._)(swipeParams), [
        closeOnPullUp,
        closeOnPullDown
    ], (0, $6zk1M._)(pullParams), [
        close
    ]));
    $2e545d666ef3112d$export$10506de8b6841445.apply(void 0, [
        swipeState
    ].concat((0, $6zk1M._)(swipeParams)));
    var focusOnMount = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        if (controller.focus && getOwnerDocument().querySelector(".".concat($2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$9d2e4856063e1a22)), " .").concat($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix())))) focus();
    });
    $eHaBZ.useEffect(focusOnMount, [
        focusOnMount
    ]);
    var onViewCallback = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        (_a = on.view) === null || _a === void 0 || _a.call(on, {
            index: state.currentIndex
        });
    });
    $eHaBZ.useEffect(onViewCallback, [
        state.globalIndex,
        onViewCallback
    ]);
    $eHaBZ.useEffect(function() {
        return $2e545d666ef3112d$export$de863c629cb9919d(subscribe((0, $b17a7fd270a24b50$export$a007161537026955), function(action) {
            return swipe((0, $lvTkn._)({
                direction: (0, $b17a7fd270a24b50$export$a007161537026955)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$f1d7a854db833ed4), function(action) {
            return swipe((0, $lvTkn._)({
                direction: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4)
            }, action));
        }), subscribe((0, $b17a7fd270a24b50$export$c43bd1a4101c4078), function(action) {
            return dispatch(action);
        }));
    }, [
        subscribe,
        swipe,
        dispatch
    ]);
    var context = $eHaBZ.useMemo(function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            slideRect: containerRect ? $2e545d666ef3112d$export$7ff571008bce9900(containerRect, carousel.padding) : {
                width: 0,
                height: 0
            },
            containerRect: containerRect || {
                width: 0,
                height: 0
            },
            subscribeSensors: subscribeSensors,
            containerRef: containerRef,
            setCarouselRef: setCarouselRef,
            toolbarWidth: toolbarWidth,
            setToolbarWidth: setToolbarWidth
        };
    }, [
        prev,
        next,
        close,
        focus,
        subscribeSensors,
        containerRect,
        containerRef,
        setCarouselRef,
        toolbarWidth,
        setToolbarWidth,
        carousel.padding
    ]);
    $eHaBZ.useImperativeHandle(controller.ref, function() {
        return {
            prev: prev,
            next: next,
            close: close,
            focus: focus,
            getLightboxProps: getLightboxProps,
            getLightboxState: getLightboxState
        };
    }, [
        prev,
        next,
        close,
        focus,
        getLightboxProps,
        getLightboxState
    ]);
    var _obj;
    return $eHaBZ.createElement("div", (0, $lvTkn._)({
        ref: handleContainerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssContainerPrefix()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5))),
        style: (0, $lvTkn._)({}, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.SWIPE ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("swipe_offset"), "".concat(Math.round(swipeOffset.current), "px")) : null, swipeState === $2e545d666ef3112d$export$59f0048f451fc458.PULL ? (_obj = {}, (0, $khBmn._)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_offset"), "".concat(Math.round(pullOffset.current), "px")), (0, $khBmn._)(_obj, $2e545d666ef3112d$export$8b4981022bd80a4e("pull_opacity"), "".concat(pullOpacity.current)), _obj) : null, controller.touchAction !== "none" ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("controller_touch_action"), controller.touchAction) : null, styles.container),
        tabIndex: -1
    }, registerSensors), containerRect && $eHaBZ.createElement($2e545d666ef3112d$export$e92ff191b0c59550.Provider, {
        value: context
    }, children, (_a = render.controls) === null || _a === void 0 ? void 0 : _a.call(render)));
}
var $2e545d666ef3112d$export$be59d34228c8ec8a = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$b861c6f4d58b4c2f), $2e545d666ef3112d$export$bd0bf19f25da8474);
function $2e545d666ef3112d$var$cssPrefix$2(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), value);
}
function $2e545d666ef3112d$var$cssSlidePrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$8d922915837a38d3), value);
}
function $2e545d666ef3112d$var$CarouselSlide(param) {
    var slide = param.slide, offset = param.offset;
    var containerRef = $eHaBZ.useRef(null);
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), currentIndex = _useLightboxState.currentIndex, slides = _useLightboxState.slides;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), slideRect = _useController.slideRect, focus = _useController.focus;
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), render = _useLightboxProps.render, _useLightboxProps_carousel = _useLightboxProps.carousel, imageFit = _useLightboxProps_carousel.imageFit, imageProps = _useLightboxProps_carousel.imageProps, _useLightboxProps_on = _useLightboxProps.on, onClick = _useLightboxProps_on.click, _useLightboxProps_styles = _useLightboxProps.styles, style = _useLightboxProps_styles.slide, labels = _useLightboxProps.labels;
    var getOwnerDocument = $2e545d666ef3112d$export$c199d36c2862b6ed().getOwnerDocument;
    var offscreen = offset !== 0;
    $eHaBZ.useEffect(function() {
        var _a;
        if (offscreen && ((_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.contains(getOwnerDocument().activeElement))) focus();
    }, [
        offscreen,
        focus,
        getOwnerDocument
    ]);
    var renderSlide = function() {
        var _a, _b, _c, _d;
        var rendered = (_a = render.slide) === null || _a === void 0 ? void 0 : _a.call(render, {
            slide: slide,
            offset: offset,
            rect: slideRect
        });
        if (!rendered && $2e545d666ef3112d$export$55ec18c411514c07(slide)) rendered = $eHaBZ.createElement($2e545d666ef3112d$export$ef86b1d52c77b27b, {
            slide: slide,
            offset: offset,
            render: render,
            rect: slideRect,
            imageFit: imageFit,
            imageProps: imageProps,
            onClick: !offscreen ? function() {
                return onClick === null || onClick === void 0 ? void 0 : onClick({
                    index: currentIndex
                });
            } : undefined
        });
        return rendered ? $eHaBZ.createElement($eHaBZ.Fragment, null, (_b = render.slideHeader) === null || _b === void 0 ? void 0 : _b.call(render, {
            slide: slide
        }), ((_c = render.slideContainer) !== null && _c !== void 0 ? _c : function(param) {
            var children = param.children;
            return children;
        })({
            slide: slide,
            children: rendered
        }), (_d = render.slideFooter) === null || _d === void 0 ? void 0 : _d.call(render, {
            slide: slide
        })) : null;
    };
    return $eHaBZ.createElement("div", (0, $9Jpjh._)((0, $lvTkn._)({
        ref: containerRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix()), !offscreen && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssSlidePrefix("current")), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$974a68ef150451f5)))
    }, $2e545d666ef3112d$export$9c64d01b28c1f747(offscreen)), {
        style: style,
        role: "group",
        "aria-roledescription": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Slide"),
        "aria-label": $2e545d666ef3112d$export$77152303d9076b8(labels, slides, currentIndex + offset)
    }), renderSlide());
}
function $2e545d666ef3112d$var$Placeholder() {
    var style = $2e545d666ef3112d$export$d930f3536e1c64f6().styles.slide;
    return $eHaBZ.createElement("div", {
        className: $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$8d922915837a38d3)),
        style: style
    });
}
function $2e545d666ef3112d$export$144901db2ea8e967(param) {
    var carousel = param.carousel, labels = param.labels;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex, globalIndex = _useLightboxState.globalIndex;
    var setCarouselRef = $2e545d666ef3112d$export$e8c786024a2b0a79().setCarouselRef;
    var _useA11yContext = $2e545d666ef3112d$export$3992c64d261ded5a(), autoPlaying = _useA11yContext.autoPlaying, focusWithin = _useA11yContext.focusWithin;
    var spacingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.spacing);
    var paddingValue = $2e545d666ef3112d$export$7871fb532d320d99(carousel.padding);
    var preload = $2e545d666ef3112d$export$aab7f3145c728301(carousel, slides, 1);
    var items = [];
    if ($2e545d666ef3112d$export$883ece934910f98d(slides)) for(var index = currentIndex - preload; index <= currentIndex + preload; index += 1){
        var slide = $2e545d666ef3112d$export$cdfb855c5eb3bc84(slides, index);
        var key = globalIndex - currentIndex + index;
        var placeholder = carousel.finite && (index < 0 || index > slides.length - 1);
        items.push(!placeholder ? {
            key: [
                "".concat(key),
                $2e545d666ef3112d$export$b2184449b7659b5a(slide)
            ].filter(Boolean).join("|"),
            offset: index - currentIndex,
            slide: slide
        } : {
            key: key
        });
    }
    var _obj;
    return $eHaBZ.createElement("div", {
        ref: setCarouselRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37($2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2()), items.length > 0 && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$2("with_slides"))),
        style: (_obj = {}, (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("slides_count"))), items.length), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_px"))), spacingValue.pixel || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("spacing_percent"))), spacingValue.percent || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_px"))), paddingValue.pixel || 0), (0, $khBmn._)(_obj, "".concat($2e545d666ef3112d$export$8b4981022bd80a4e($2e545d666ef3112d$var$cssPrefix$2("padding_percent"))), paddingValue.percent || 0), _obj),
        role: "region",
        "aria-live": autoPlaying && !focusWithin ? "off" : "polite",
        "aria-roledescription": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Carousel"),
        "aria-label": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Photo gallery")
    }, items.map(function(param) {
        var key = param.key, slide = param.slide, offset = param.offset;
        return slide ? $eHaBZ.createElement($2e545d666ef3112d$var$CarouselSlide, {
            key: key,
            slide: slide,
            offset: offset
        }) : $eHaBZ.createElement($2e545d666ef3112d$var$Placeholder, {
            key: key
        });
    }));
}
var $2e545d666ef3112d$export$9c087759a323a56c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$83fe3bee12eb51bb), $2e545d666ef3112d$export$144901db2ea8e967);
function $2e545d666ef3112d$export$e482f4662aebc4a0() {
    var carousel = $2e545d666ef3112d$export$d930f3536e1c64f6().carousel;
    var _useLightboxState = $2e545d666ef3112d$export$566121e2bbc52eec(), slides = _useLightboxState.slides, currentIndex = _useLightboxState.currentIndex;
    var prevDisabled = slides.length === 0 || carousel.finite && currentIndex === 0;
    var nextDisabled = slides.length === 0 || carousel.finite && currentIndex === slides.length - 1;
    return {
        prevDisabled: prevDisabled,
        nextDisabled: nextDisabled
    };
}
function $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors) {
    var _a;
    var isRTL = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var publish = $2e545d666ef3112d$export$91a992459f6e0f07().publish;
    var _useLightboxProps = $2e545d666ef3112d$export$d930f3536e1c64f6(), animation = _useLightboxProps.animation, controller = _useLightboxProps.controller;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    var throttle = ((_a = animation.navigation) !== null && _a !== void 0 ? _a : animation.swipe) / 2;
    var prev = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$a007161537026955));
    }, throttle);
    var next = $2e545d666ef3112d$export$8b7b9481d6186f21(function() {
        return publish((0, $b17a7fd270a24b50$export$f1d7a854db833ed4));
    }, throttle);
    var handleKeyDown = $2e545d666ef3112d$export$ee5b5d04074a389e(function(event) {
        switch(event.key){
            case 0, $b17a7fd270a24b50$export$e8d60d9b5ceff7c0:
                if (!controller.closeOnEscape) return;
                publish((0, $b17a7fd270a24b50$export$493a596486210a21));
                break;
            case 0, $b17a7fd270a24b50$export$17dec1da9b0e2eb3:
                if (!(isRTL ? nextDisabled : prevDisabled)) (isRTL ? next : prev)();
                break;
            case 0, $b17a7fd270a24b50$export$91898c0e7e48903:
                if (!(isRTL ? prevDisabled : nextDisabled)) (isRTL ? prev : next)();
                break;
            default:
                return;
        }
        event.stopPropagation();
    });
    $eHaBZ.useEffect(function() {
        return subscribeSensors((0, $b17a7fd270a24b50$export$1aba4f3521686ca9), handleKeyDown);
    }, [
        subscribeSensors,
        handleKeyDown
    ]);
}
function $2e545d666ef3112d$export$e2d1bd910e689283(param) {
    var label = param.label, icon = param.icon, renderIcon = param.renderIcon, action = param.action, onClick = param.onClick, disabled = param.disabled, style = param.style;
    return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, (0, $lvTkn._)({
        label: label,
        icon: icon,
        renderIcon: renderIcon,
        className: $2e545d666ef3112d$export$1283875077dc8f0a("navigation_".concat(action)),
        disabled: disabled,
        onClick: onClick,
        style: style
    }, $2e545d666ef3112d$export$2bd1c19440b9235c($2e545d666ef3112d$export$e8c786024a2b0a79().focus, disabled)));
}
function $2e545d666ef3112d$export$b8a61e5c71402559(param) {
    var _param_render = param.render, buttonPrev = _param_render.buttonPrev, buttonNext = _param_render.buttonNext, iconPrev = _param_render.iconPrev, iconNext = _param_render.iconNext, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), prev = _useController.prev, next = _useController.next, subscribeSensors = _useController.subscribeSensors;
    var _useNavigationState = $2e545d666ef3112d$export$e482f4662aebc4a0(), prevDisabled = _useNavigationState.prevDisabled, nextDisabled = _useNavigationState.nextDisabled;
    $2e545d666ef3112d$export$4da28cf324280418(subscribeSensors);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, buttonPrev ? buttonPrev() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Previous",
        action: (0, $b17a7fd270a24b50$export$a007161537026955),
        icon: $2e545d666ef3112d$export$d05925e1c7f3f136,
        renderIcon: iconPrev,
        style: styles.navigationPrev,
        disabled: prevDisabled,
        onClick: prev
    }), buttonNext ? buttonNext() : $eHaBZ.createElement($2e545d666ef3112d$export$e2d1bd910e689283, {
        label: "Next",
        action: (0, $b17a7fd270a24b50$export$f1d7a854db833ed4),
        icon: $2e545d666ef3112d$export$3da0e0ec94bd4ce1,
        renderIcon: iconNext,
        style: styles.navigationNext,
        disabled: nextDisabled,
        onClick: next
    }));
}
var $2e545d666ef3112d$export$6c16e1ac15089858 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$607ce719f0ec9b98), $2e545d666ef3112d$export$b8a61e5c71402559);
var $2e545d666ef3112d$var$noScroll = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$b6426a00c33a0175));
var $2e545d666ef3112d$var$noScrollPadding = $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476));
function $2e545d666ef3112d$var$isHTMLElement(element) {
    return "style" in element;
}
function $2e545d666ef3112d$var$padScrollbar(element, padding, rtl) {
    var styles = window.getComputedStyle(element);
    var property = rtl ? "padding-left" : "padding-right";
    var computedValue = rtl ? styles.paddingLeft : styles.paddingRight;
    var originalValue = element.style.getPropertyValue(property);
    element.style.setProperty(property, "".concat(($2e545d666ef3112d$export$5f87784a266e50a4(computedValue) || 0) + padding, "px"));
    return function() {
        if (originalValue) element.style.setProperty(property, originalValue);
        else element.style.removeProperty(property);
    };
}
function $2e545d666ef3112d$export$bbae9e931237726f(param) {
    var disabled = param.noScroll.disabled, children = param.children;
    var rtl = $2e545d666ef3112d$export$81f015b3ec5d61cf();
    var _useDocumentContext = $2e545d666ef3112d$export$c199d36c2862b6ed(), getOwnerDocument = _useDocumentContext.getOwnerDocument, getOwnerWindow = _useDocumentContext.getOwnerWindow;
    $eHaBZ.useEffect(function() {
        if (disabled) return function() {};
        var cleanup = [];
        var ownerWindow = getOwnerWindow();
        var _getOwnerDocument = getOwnerDocument(), body = _getOwnerDocument.body, documentElement = _getOwnerDocument.documentElement;
        var scrollbar = Math.round(ownerWindow.innerWidth - documentElement.clientWidth);
        if (scrollbar > 0) {
            cleanup.push($2e545d666ef3112d$var$padScrollbar(body, scrollbar, rtl));
            var elements = body.getElementsByTagName("*");
            for(var i = 0; i < elements.length; i += 1){
                var element = elements[i];
                if ($2e545d666ef3112d$var$isHTMLElement(element) && ownerWindow.getComputedStyle(element).getPropertyValue("position") === "fixed" && !element.classList.contains($2e545d666ef3112d$var$noScrollPadding)) cleanup.push($2e545d666ef3112d$var$padScrollbar(element, scrollbar, rtl));
            }
        }
        body.classList.add($2e545d666ef3112d$var$noScroll);
        return function() {
            body.classList.remove($2e545d666ef3112d$var$noScroll);
            cleanup.forEach(function(clean) {
                return clean();
            });
        };
    }, [
        rtl,
        disabled,
        getOwnerDocument,
        getOwnerWindow
    ]);
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$7ded5f1cd4840ad = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$52cbc29cf5406ba8), $2e545d666ef3112d$export$bbae9e931237726f);
function $2e545d666ef3112d$var$cssPrefix$1(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), value);
}
function $2e545d666ef3112d$var$setAttribute(element, attribute, value) {
    var previousValue = element.getAttribute(attribute);
    element.setAttribute(attribute, value);
    return function() {
        if (previousValue) element.setAttribute(attribute, previousValue);
        else element.removeAttribute(attribute);
    };
}
function $2e545d666ef3112d$export$602eac185826482c(_param) {
    var _param_portal = _param.portal, root = _param_portal.root, tmp = _param_portal.container, _ref = tmp === void 0 ? {} : tmp, containerClassName = _ref.className, containerStyle = _ref.style, animation = _param.animation, styles = _param.styles, className = _param.className, on = _param.on, close = _param.close, labels = _param.labels, children = _param.children, containerRest = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param.portal.container, [
        "className",
        "style"
    ]);
    var _React_useState = (0, $21h22._)($eHaBZ.useState(false), 2), mounted = _React_useState[0], setMounted = _React_useState[1];
    var _React_useState1 = (0, $21h22._)($eHaBZ.useState(false), 2), visible = _React_useState1[0], setVisible = _React_useState1[1];
    var cleanup = $eHaBZ.useRef([]);
    var restoreFocus = $eHaBZ.useRef(null);
    var setTimeout = $2e545d666ef3112d$export$1bc7162631c81b3f().setTimeout;
    var subscribe = $2e545d666ef3112d$export$91a992459f6e0f07().subscribe;
    var reduceMotion = $2e545d666ef3112d$export$f3e625e1b2b31d60();
    var animationDuration = !reduceMotion ? animation.fade : 0;
    $eHaBZ.useEffect(function() {
        setMounted(true);
        return function() {
            setMounted(false);
            setVisible(false);
        };
    }, []);
    var handleCleanup = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        cleanup.current.forEach(function(clean) {
            return clean();
        });
        cleanup.current = [];
    });
    var handleClose = $2e545d666ef3112d$export$ee5b5d04074a389e(function() {
        var _a;
        setVisible(false);
        handleCleanup();
        (_a = on.exiting) === null || _a === void 0 || _a.call(on);
        setTimeout(function() {
            var _a;
            (_a = on.exited) === null || _a === void 0 || _a.call(on);
            close();
        }, animationDuration);
    });
    $eHaBZ.useEffect(function() {
        return subscribe((0, $b17a7fd270a24b50$export$493a596486210a21), handleClose);
    }, [
        subscribe,
        handleClose
    ]);
    var handleEnter = $2e545d666ef3112d$export$ee5b5d04074a389e(function(node) {
        var _a, _b, _c;
        $2e545d666ef3112d$export$b7a864e1eaef9de5(node);
        setVisible(true);
        (_a = on.entering) === null || _a === void 0 || _a.call(on);
        var elements = (_c = (_b = node.parentNode) === null || _b === void 0 ? void 0 : _b.children) !== null && _c !== void 0 ? _c : [];
        for(var i = 0; i < elements.length; i += 1){
            var element = elements[i];
            if ([
                "TEMPLATE",
                "SCRIPT",
                "STYLE"
            ].indexOf(element.tagName) === -1 && element !== node) {
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "inert", ""));
                cleanup.current.push($2e545d666ef3112d$var$setAttribute(element, "aria-hidden", "true"));
            }
        }
        cleanup.current.push(function() {
            var _a, _b;
            (_b = (_a = restoreFocus.current) === null || _a === void 0 ? void 0 : _a.focus) === null || _b === void 0 || _b.call(_a);
        });
        setTimeout(function() {
            var _a;
            (_a = on.entered) === null || _a === void 0 || _a.call(on);
        }, animationDuration);
    });
    var handleRef = $eHaBZ.useCallback(function(node) {
        if (node) handleEnter(node);
        else handleCleanup();
    }, [
        handleEnter,
        handleCleanup
    ]);
    return mounted ? (0, $bVPm2.createPortal)($eHaBZ.createElement($2e545d666ef3112d$export$597a6f74cf288f82, (0, $lvTkn._)({
        ref: handleRef,
        className: $2e545d666ef3112d$export$4f5d2d50c9deca37(className, containerClassName, $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1()), $2e545d666ef3112d$export$1283875077dc8f0a((0, $b17a7fd270a24b50$export$651541414233b476)), visible && $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix$1("open"))),
        "aria-modal": true,
        role: "dialog",
        "aria-label": $2e545d666ef3112d$export$1c4d965eb6f65dfa(labels, "Lightbox"),
        style: (0, $lvTkn._)({}, animation.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.fade ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_duration"), "".concat(animationDuration, "ms")) : null, animation.easing.fade !== $2e545d666ef3112d$export$d626463445cef3e9.animation.easing.fade ? (0, $khBmn._)({}, $2e545d666ef3112d$export$8b4981022bd80a4e("fade_animation_timing_function"), animation.easing.fade) : null, styles.root, containerStyle),
        onFocus: function(event) {
            if (!restoreFocus.current) restoreFocus.current = event.relatedTarget;
        }
    }, containerRest), children), (typeof root === "function" ? root() : root) || document.body) : null;
}
var $2e545d666ef3112d$export$f2a0761442face5c = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$9d2e4856063e1a22), $2e545d666ef3112d$export$602eac185826482c);
function $2e545d666ef3112d$export$be92b6f5f03c0fe9(param) {
    var children = param.children;
    return $eHaBZ.createElement($eHaBZ.Fragment, null, children);
}
var $2e545d666ef3112d$export$fa1081225b99a9f2 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$62f3c66ae8dab8a3), $2e545d666ef3112d$export$be92b6f5f03c0fe9);
function $2e545d666ef3112d$var$cssPrefix(value) {
    return $2e545d666ef3112d$export$195c4126907dde97((0, $b17a7fd270a24b50$export$5414719b40b8294f), value);
}
function $2e545d666ef3112d$export$4c260019440d418f(param) {
    var buttons = param.toolbar.buttons, _param_render = param.render, buttonClose = _param_render.buttonClose, iconClose = _param_render.iconClose, styles = param.styles;
    var _useController = $2e545d666ef3112d$export$e8c786024a2b0a79(), close = _useController.close, setToolbarWidth = _useController.setToolbarWidth;
    var _useContainerRect = $2e545d666ef3112d$export$b1d85de58d38d09d(), setContainerRef = _useContainerRect.setContainerRef, containerRect = _useContainerRect.containerRect;
    $2e545d666ef3112d$export$e5c5a5f917a5871c(function() {
        setToolbarWidth(containerRect === null || containerRect === void 0 ? void 0 : containerRect.width);
    }, [
        setToolbarWidth,
        containerRect === null || containerRect === void 0 ? void 0 : containerRect.width
    ]);
    var renderCloseButton = function() {
        if (buttonClose) return buttonClose();
        return $eHaBZ.createElement($2e545d666ef3112d$export$c25acd513dcc8062, {
            key: (0, $b17a7fd270a24b50$export$493a596486210a21),
            label: "Close",
            icon: $2e545d666ef3112d$export$cae179f078f4b4a4,
            renderIcon: iconClose,
            onClick: close
        });
    };
    return $eHaBZ.createElement("div", {
        ref: setContainerRef,
        style: styles.toolbar,
        className: $2e545d666ef3112d$export$1283875077dc8f0a($2e545d666ef3112d$var$cssPrefix())
    }, buttons === null || buttons === void 0 ? void 0 : buttons.map(function(button) {
        return button === (0, $b17a7fd270a24b50$export$493a596486210a21) ? renderCloseButton() : button;
    }));
}
var $2e545d666ef3112d$export$d0a9743c06e42ce8 = $2e545d666ef3112d$export$c5ba3739ffba980d((0, $b17a7fd270a24b50$export$5414719b40b8294f), $2e545d666ef3112d$export$4c260019440d418f);
function $2e545d666ef3112d$var$renderNode(node, props) {
    var _a;
    return $eHaBZ.createElement(node.module.component, (0, $lvTkn._)({
        key: node.module.name
    }, props), (_a = node.children) === null || _a === void 0 ? void 0 : _a.map(function(child) {
        return $2e545d666ef3112d$var$renderNode(child, props);
    }));
}
function $2e545d666ef3112d$var$mergeAnimation(defaultAnimation) {
    var animation = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var defaultAnimationEasing = defaultAnimation.easing, restDefaultAnimation = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(defaultAnimation, [
        "easing"
    ]);
    var easing = animation.easing, restAnimation = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(animation, [
        "easing"
    ]);
    return (0, $lvTkn._)({
        easing: (0, $lvTkn._)({}, defaultAnimationEasing, easing)
    }, restDefaultAnimation, restAnimation);
}
function $2e545d666ef3112d$export$7d2670a66155874b(_param) {
    var carousel = _param.carousel, animation = _param.animation, render = _param.render, toolbar = _param.toolbar, controller = _param.controller, noScroll = _param.noScroll, on = _param.on, plugins = _param.plugins, slides = _param.slides, index = _param.index, restProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)(_param, [
        "carousel",
        "animation",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "plugins",
        "slides",
        "index"
    ]);
    var defaultAnimation = $2e545d666ef3112d$export$d626463445cef3e9.animation, defaultCarousel = $2e545d666ef3112d$export$d626463445cef3e9.carousel, defaultRender = $2e545d666ef3112d$export$d626463445cef3e9.render, defaultToolbar = $2e545d666ef3112d$export$d626463445cef3e9.toolbar, defaultController = $2e545d666ef3112d$export$d626463445cef3e9.controller, defaultNoScroll = $2e545d666ef3112d$export$d626463445cef3e9.noScroll, defaultOn = $2e545d666ef3112d$export$d626463445cef3e9.on, defaultSlides = $2e545d666ef3112d$export$d626463445cef3e9.slides, defaultIndex = $2e545d666ef3112d$export$d626463445cef3e9.index, defaultPlugins = $2e545d666ef3112d$export$d626463445cef3e9.plugins, restDefaultProps = (0, $7e86f5813bbb0f77$export$71511d61b312f219)($2e545d666ef3112d$export$d626463445cef3e9, [
        "animation",
        "carousel",
        "render",
        "toolbar",
        "controller",
        "noScroll",
        "on",
        "slides",
        "index",
        "plugins"
    ]);
    var _withPlugins = $2e545d666ef3112d$export$bc996c07eb970c78([
        $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$f2a0761442face5c, [
            $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$7ded5f1cd4840ad, [
                $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$be59d34228c8ec8a, [
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$9c087759a323a56c),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$d0a9743c06e42ce8),
                    $2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$6c16e1ac15089858)
                ])
            ])
        ])
    ], plugins || defaultPlugins), config = _withPlugins.config, augmentation = _withPlugins.augmentation;
    var props = augmentation((0, $lvTkn._)({
        animation: $2e545d666ef3112d$var$mergeAnimation(defaultAnimation, animation),
        carousel: (0, $lvTkn._)({}, defaultCarousel, carousel),
        render: (0, $lvTkn._)({}, defaultRender, render),
        toolbar: (0, $lvTkn._)({}, defaultToolbar, toolbar),
        controller: (0, $lvTkn._)({}, defaultController, controller),
        noScroll: (0, $lvTkn._)({}, defaultNoScroll, noScroll),
        on: (0, $lvTkn._)({}, defaultOn, on)
    }, restDefaultProps, restProps));
    if (!props.open) return null;
    return $eHaBZ.createElement($2e545d666ef3112d$export$7141a340a3dea601, (0, $lvTkn._)({}, props), $eHaBZ.createElement($2e545d666ef3112d$export$62d2e1d2e7609988, {
        slides: slides || defaultSlides,
        index: $2e545d666ef3112d$export$5f87784a266e50a4(index || defaultIndex)
    }, $eHaBZ.createElement($2e545d666ef3112d$export$9d9954f5885fa393, null, $eHaBZ.createElement($2e545d666ef3112d$export$686accdd53ac150f, null, $eHaBZ.createElement($2e545d666ef3112d$export$e41a845d3e53ea09, null, $2e545d666ef3112d$var$renderNode($2e545d666ef3112d$export$270e7ba5936d3c48($2e545d666ef3112d$export$fa1081225b99a9f2, config), props))))));
}


// TODO: do the search highlights client-side
function $4c7e00084d6d58aa$var$reHighlight(text) {
    return text.split(/<span class="found">(.+?)<\/span>/).map(function(n, i) {
        return i % 2 == 0 ? n : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
            className: "found",
            children: n
        }, i);
    });
}
function $4c7e00084d6d58aa$var$setupLightbox(param) {
    var element = param.element, setSlides = param.setSlides, setSelectedPhotoIndex = param.setSelectedPhotoIndex;
    var images = element.querySelectorAll('a[href$=".jpg"], a[href$=".jpeg"], a[href$=".png"], a[href$=".gif"], a[href$=".jpg:large"], a[href$=".jpeg:large"], a[href$=".png:large"], a[href$=".gif:large"]');
    setSlides(Array.from(images).map(function(link, index) {
        link.addEventListener('click', function(event) {
            event.preventDefault();
            setSelectedPhotoIndex(index);
        });
        return {
            src: link.getAttribute('href')
        };
    }));
}
function $4c7e00084d6d58aa$var$stopPropagation(event) {
    event.stopPropagation();
}
function $4c7e00084d6d58aa$var$forceLoadImages(content) {
    content.querySelectorAll('img').forEach(function(img) {
        img.setAttribute('src', img.getAttribute('data-selfoss-src'));
    });
}
// React will prevent the default action when it bubbles to our callbacks.
// Let’s stop bubbling for links.
// https://medium.com/peloton-engineering/onclick-wat-51331718ba9
function $4c7e00084d6d58aa$var$fixLinkBubbling(content) {
    content.querySelectorAll('a').forEach(function(a) {
        a.addEventListener('click', function(event) {
            event.stopPropagation();
        });
    });
}
// Prevent passing referrer info when opening a link.
function $4c7e00084d6d58aa$var$sanitizeContent(content) {
    content.querySelectorAll('a').forEach(function(a) {
        var oldRel = a.getAttribute('rel');
        a.setAttribute('rel', 'noreferrer' + (oldRel ? ' ' + oldRel : ''));
        // Ensure links inside item content are opened in new tab/window.
        a.setAttribute('target', '_blank');
    });
}
function $4c7e00084d6d58aa$var$handleKeyUp(event) {
    // emulate clicking when using keyboard
    if (event.keyCode === 13) {
        // ENTER key
        event.currentTarget.click();
        event.preventDefault();
        event.stopPropagation();
    }
}
function $4c7e00084d6d58aa$var$preventDefaultOnSmartphone(event) {
    // We want to use the whole title as action for opening/closing items
    // and smartphones have separate buttons for opening the article anyway.
    if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isSmartphone()) event.preventDefault();
}
// Handle closing fullscreen on mobile
function $4c7e00084d6d58aa$var$closeFullScreen(param) {
    var event = param.event, navigate = param.navigate, location = param.location, entryId = param.entryId;
    event.preventDefault();
    event.stopPropagation();
    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setEntryExpanded(entryId, false);
    navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
        id: null
    }), {
        replace: true
    });
}
// show/hide entry
function $4c7e00084d6d58aa$var$handleClick(param) {
    var event = param.event, navigate = param.navigate, location = param.location, expanded = param.expanded, id = param.id, target = param.target;
    var expected = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isMobile() ? '.entry' : '.entry-title';
    if (target !== expected) return;
    event.preventDefault();
    event.stopPropagation();
    if (expanded) {
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setSelectedEntry(id);
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.deactivateEntry(id);
        navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
            id: null
        }), {
            replace: true
        });
    } else {
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.activateEntry(id);
        navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
            id: id.toString()
        }), {
            replace: true
        });
    }
}
// load images
function $4c7e00084d6d58aa$var$loadImages(param) {
    var event = param.event, setImagesLoaded = param.setImagesLoaded, contentBlock = param.contentBlock;
    event.preventDefault();
    event.stopPropagation();
    $4c7e00084d6d58aa$var$forceLoadImages(contentBlock.current);
    setImagesLoaded(true);
}
// next item on tablet and smartphone
function $4c7e00084d6d58aa$var$openNext(event) {
    event.preventDefault();
    event.stopPropagation();
    // TODO: Figure out why it does not work when run immediately.
    requestAnimationFrame(function() {
        var _selfoss_entriesPage;
        (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT, true);
    });
}
function $4c7e00084d6d58aa$var$ShareButton(props) {
    var label = props.label, icon = props.icon, item = props.item, action = props.action, _props_showLabel = props.showLabel, showLabel = _props_showLabel === void 0 ? true : _props_showLabel;
    var shareOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        action({
            id: item.id,
            url: item.link,
            // TODO: remove HTML
            title: item.title
        });
    }, [
        item,
        action
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
        type: "button",
        className: "entry-share",
        title: label,
        "aria-label": label,
        onClick: shareOnClick,
        children: [
            icon,
            " ",
            showLabel ? label : null
        ]
    });
}
function $4c7e00084d6d58aa$var$ItemTag(props) {
    var tag = props.tag, color = props.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            color: color.foreColor,
            backgroundColor: color.backColor
        };
    }, [
        color
    ]);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            category: "tag-".concat(tag),
            id: null
        });
    }, [
        tag,
        location
    ]);
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
        className: "entry-tags-tag",
        style: style,
        to: link,
        onClick: $4c7e00084d6d58aa$var$preventDefaultOnSmartphone,
        state: forceReload,
        children: tag
    });
}
/**
 * Converts Date to a relative string.
 * When the date is too old, null is returned instead.
 * @return {?String} relative time reference
 */ function $4c7e00084d6d58aa$var$datetimeRelative(currentTime, datetime, _) {
    var ageInseconds = (currentTime.getTime() - datetime.getTime()) / 1000;
    var ageInMinutes = ageInseconds / 60;
    var ageInHours = ageInMinutes / 60;
    var ageInDays = ageInHours / 24;
    if (ageInHours < 1) return _('minutes', {
        '0': Math.round(ageInMinutes).toString()
    });
    else if (ageInDays < 1) return _('hours', {
        '0': Math.round(ageInHours).toString()
    });
    else return null;
}
function $4c7e00084d6d58aa$export$2e2bcd8739ae039(props) {
    var currentTime = props.currentTime, item = props.item, selected = props.selected, expanded = props.expanded, setNavExpanded = props.setNavExpanded, showError = props.showError;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var title = item.title, author = item.author, sourcetitle = item.sourcetitle;
    var configuration = (0, $eHaBZ.use)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e));
    var shouldAutoLoadImages = !(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isMobile() || configuration.loadImagesOnMobile;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(shouldAutoLoadImages), 2), imagesLoaded = _useState[0], setImagesLoaded = _useState[1];
    var contentBlock = (0, $eHaBZ.useRef)(null);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var relDate = (0, $eHaBZ.useMemo)(function() {
        return $4c7e00084d6d58aa$var$datetimeRelative(currentTime, item.datetime, _);
    }, [
        currentTime,
        item.datetime,
        _
    ]);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)([]), 2), slides = _useState1[0], setSlides = _useState1[1];
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), selectedPhotoIndex = _useState2[0], setSelectedPhotoIndex = _useState2[1];
    var fullScreenTrap = (0, $eHaBZ.useRef)(null);
    // This should match scenarios where fullScreenTrap is set.
    var usingFocusTrap = expanded && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isSmartphone();
    var setExpanded = (0, $eHaBZ.useEffectEvent)(function(expanded) {
        // Handle entry becoming/ceasing to be expanded.
        var parent = document.querySelector('.entry[data-entry-id="'.concat(item.id, '"]'));
        if (expanded) {
            var firstExpansion = contentBlock.current.childElementCount === 0;
            if (firstExpansion) {
                contentBlock.current.innerHTML = item.content;
                $4c7e00084d6d58aa$var$sanitizeContent(contentBlock.current);
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).extensionPoints.processItemContents(contentBlock.current);
                // load images not on mobile devices
                if (shouldAutoLoadImages) $4c7e00084d6d58aa$var$forceLoadImages(contentBlock.current);
            }
            if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isSmartphone()) {
                // save scroll position
                var scrollTop = window.scrollY;
                setNavExpanded(function(expanded) {
                    // hide nav
                    if (expanded) {
                        scrollTop = scrollTop - document.querySelector('#nav').getBoundingClientRect().height;
                        scrollTop = scrollTop < 0 ? 0 : scrollTop;
                        window.scrollTo({
                            top: scrollTop
                        });
                        return false;
                    }
                    return expanded;
                });
                // show fullscreen
                document.body.classList.add('fullscreen-mode');
                var trap = (0, $197853feae65c1a7$export$360440dfcba94c00)(parent);
                fullScreenTrap.current = trap;
                trap.activate();
                if (firstExpansion) $4c7e00084d6d58aa$var$fixLinkBubbling(contentBlock.current);
            } else {
                if (firstExpansion) // setup fancyBox image viewer
                $4c7e00084d6d58aa$var$setupLightbox({
                    element: contentBlock.current,
                    setSlides: setSlides,
                    setSelectedPhotoIndex: setSelectedPhotoIndex
                });
                // scroll to article header
                if (configuration.scrollToArticleHeader) parent.scrollIntoView();
                if (firstExpansion) // turn of column view if entry is too long
                requestAnimationFrame(function() {
                    // Delayed into next frame so that the entry is expanded when the height is being determined.
                    if (contentBlock.current.getBoundingClientRect().height > document.body.clientHeight) {
                        var entryContent = contentBlock.current.parentNode;
                        entryContent.classList.add('entry-content-nocolumns');
                    }
                });
            }
        } else {
            // No longer expanded.
            if (fullScreenTrap.current !== null) {
                fullScreenTrap.current.deactivate();
                fullScreenTrap.current = null;
            }
            document.body.classList.remove('fullscreen-mode');
            // Handle autoHideReadOnMobile setting.
            if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isSmartphone()) {
                var autoHideReadOnMobile = configuration.autoHideReadOnMobile && item.unread;
                if (autoHideReadOnMobile && !item.unread) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setEntries(function(entries) {
                    return entries.filter(function(param) {
                        var id = param.id;
                        return id !== item.id;
                    });
                });
            }
        }
    });
    (0, $eHaBZ.useEffect)(function() {
        setExpanded(expanded);
    }, [
        expanded
    ]);
    var entryOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $4c7e00084d6d58aa$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry'
        });
    }, [
        navigate,
        location,
        expanded,
        item.id
    ]);
    var titleOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $4c7e00084d6d58aa$var$handleClick({
            event: event,
            navigate: navigate,
            location: location,
            expanded: expanded,
            id: item.id,
            target: '.entry-title'
        });
    }, [
        navigate,
        location,
        expanded,
        item.id
    ]);
    var starOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.markEntryStarred(item.id, !item.starred);
    }, [
        item
    ]);
    var markReadOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        event.stopPropagation();
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.markEntryRead(item.id, item.unread);
    }, [
        item
    ]);
    var loadImagesOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $4c7e00084d6d58aa$var$loadImages({
            event: event,
            setImagesLoaded: setImagesLoaded,
            contentBlock: contentBlock
        });
    }, []);
    var closeOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $4c7e00084d6d58aa$var$closeFullScreen({
            event: event,
            navigate: navigate,
            location: location,
            entryId: item.id
        });
    }, [
        navigate,
        location,
        item.id
    ]);
    var titleHtml = (0, $eHaBZ.useMemo)(function() {
        return {
            __html: title ? title : _('no_title')
        };
    }, [
        title,
        _
    ]);
    var sourceLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(item.source),
            id: null
        });
    }, [
        item.source,
        location
    ]);
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    var canWrite = (0, $afaa653977073dac$export$b416b77cd328c02f)();
    var sharers = (0, $94837e40a3fa9211$export$aebedbd51beb48eb)({
        configuration: configuration,
        showError: showError,
        _: _
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        "data-entry-id": item.id,
        "data-entry-source": item.source,
        "data-entry-url": item.link,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            entry: true,
            unread: item.unread,
            expanded: expanded,
            selected: selected
        }),
        role: "article",
        "aria-modal": usingFocusTrap,
        onClick: entryOnClick,
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: "entry-icon",
                tabIndex: -1,
                rel: "noreferrer",
                "aria-hidden": "true",
                onClick: $4c7e00084d6d58aa$var$preventDefaultOnSmartphone,
                children: item.icon !== null && item.icon.trim().length > 0 && item.icon != '0' ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                    src: "favicons/".concat(item.icon),
                    "aria-hidden": "true",
                    alt: ""
                }) : null
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h3", {
                className: "entry-title",
                onClick: titleOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "entry-title-link",
                    "aria-expanded": expanded,
                    "aria-current": selected,
                    role: "link",
                    tabIndex: 0,
                    onKeyUp: $4c7e00084d6d58aa$var$handleKeyUp,
                    dangerouslySetInnerHTML: titleHtml
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-tags",
                children: Object.entries(item.tags).map(function(param) {
                    var _param = (0, $21h22._)(param, 2), tag = _param[0], color = _param[1];
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($4c7e00084d6d58aa$var$ItemTag, {
                        tag: tag,
                        color: color
                    }, tag);
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                className: "entry-source",
                to: sourceLink,
                onClick: $4c7e00084d6d58aa$var$preventDefaultOnSmartphone,
                state: forceReload,
                children: $4c7e00084d6d58aa$var$reHighlight(sourcetitle)
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                className: "entry-separator",
                children: "\u2022"
            }),
            author !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-author",
                        children: author
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    })
                ]
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                href: item.link,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-datetime': true,
                    timestamped: relDate === null
                }),
                target: "_blank",
                rel: "noreferrer",
                onClick: $4c7e00084d6d58aa$var$preventDefaultOnSmartphone,
                children: relDate !== null ? relDate : item.datetime.toLocaleString()
            }),
            configuration.readingSpeed !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-separator",
                        children: "\u2022"
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "entry-readtime",
                        children: _('article_reading_time', {
                            '0': Math.round(item.wordCount / configuration.readingSpeed)
                        })
                    })
                ]
            }) : null,
            item.thumbnail && item.thumbnail.trim().length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-thumbnail': true,
                    'entry-thumbnail-always-visible': configuration.showThumbnails
                }),
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("a", {
                    href: item.link,
                    target: "_blank",
                    rel: "noreferrer",
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("img", {
                        src: "thumbnails/".concat(item.thumbnail),
                        alt: item.strippedTitle
                    })
                })
            }) : null,
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'entry-content': true,
                    'entry-content-nocolumns': item.lengthWithoutTags < 500
                }),
                children: [
                    slides.length !== 0 && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $2e545d666ef3112d$export$7d2670a66155874b), {
                        open: selectedPhotoIndex !== null,
                        index: selectedPhotoIndex,
                        close: function() {
                            return setSelectedPhotoIndex(null);
                        },
                        carousel: {
                            finite: true
                        },
                        controller: {
                            closeOnBackdropClick: true
                        },
                        on: {
                            entered: function() {
                                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).lightboxActive.update(true);
                            },
                            exited: function() {
                                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).lightboxActive.update(false);
                            }
                        },
                        slides: slides
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        ref: contentBlock
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                        className: "entry-smartphone-share",
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                            "aria-label": _('article_actions'),
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                                        href: item.link,
                                        className: "entry-newwindow",
                                        target: "_blank",
                                        rel: "noreferrer",
                                        accessKey: "o",
                                        onClick: $4c7e00084d6d58aa$var$stopPropagation,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                                icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                            }),
                                            ' ',
                                            _('open_window')
                                        ]
                                    })
                                }),
                                sharers.map(function(param) {
                                    var key = param.key, label = param.label, icon = param.icon, action = param.action;
                                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($4c7e00084d6d58aa$var$ShareButton, {
                                            label: label,
                                            icon: icon,
                                            item: item,
                                            action: action
                                        })
                                    }, key);
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                                        type: "button",
                                        accessKey: "n",
                                        className: "entry-next",
                                        onClick: $4c7e00084d6d58aa$var$openNext,
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                                icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                            }),
                                            ' ',
                                            _('next')
                                        ]
                                    })
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                "aria-label": _('article_actions'),
                className: "entry-toolbar",
                children: [
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "a",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                'entry-starr': true,
                                active: item.starred
                            }),
                            onClick: starOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: item.starred ? $4e5ab4d00c078f68$exports.faStar : $de3818063bbfedbe$exports.faStar
                                }),
                                ' ',
                                item.starred ? _('unstar') : _('star')
                            ]
                        })
                    }),
                    canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "u",
                            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                'entry-unread': true,
                                active: item.unread
                            }),
                            onClick: markReadOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: item.unread ? $7214b407105f2291$exports.faCheckCircle : $60c3775e24ebf896$exports.faCheckCircle
                                }),
                                ' ',
                                item.unread ? _('mark') : _('unmark')
                            ]
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("a", {
                            href: item.link,
                            className: "entry-newwindow",
                            target: "_blank",
                            rel: "noreferrer",
                            accessKey: "o",
                            onClick: $4c7e00084d6d58aa$var$stopPropagation,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: $38e96a2b42b175e8$exports.faExternalLinkAlt
                                }),
                                ' ',
                                _('open_window')
                            ]
                        })
                    }),
                    !imagesLoaded ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            className: "entry-loadimages",
                            onClick: loadImagesOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: $7417e626c64fb3c5$exports.faArrowAltCircleDown
                                }),
                                ' ',
                                _('load_img')
                            ]
                        })
                    }) : null,
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            type: "button",
                            accessKey: "n",
                            className: "entry-next",
                            onClick: $4c7e00084d6d58aa$var$openNext,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: $67e9658d0f6c3ae3$exports.faArrowRight
                                }),
                                " ",
                                _('next')
                            ]
                        })
                    }),
                    sharers.map(function(param) {
                        var key = param.key, label = param.label, icon = param.icon, action = param.action;
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($4c7e00084d6d58aa$var$ShareButton, {
                                label: label,
                                icon: icon,
                                item: item,
                                action: action,
                                showLabel: false
                            })
                        }, key);
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                            accessKey: "c",
                            className: "entry-close",
                            onClick: closeOnClick,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                    icon: $ea95ad8a568dd277$exports.faTimesCircle
                                }),
                                ' ',
                                _('close_entry')
                            ]
                        })
                    })
                ]
            })
        ]
    });
}




var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");


function $8af27e6da99b5030$var$safeDate(datetimeString) {
    var date = new Date(datetimeString);
    if (isNaN(date.valueOf())) throw new Error("Invalid date detected: \u201C".concat(datetimeString, "\u201D"));
    else return date;
}
function $8af27e6da99b5030$export$8ce663b0c6b2535e(ids) {
    return $8b420386626a2c2e$export$299ba2dee77727e9('mark', {
        headers: {
            'content-type': 'application/json; charset=utf-8'
        },
        body: JSON.stringify(ids)
    }).promise.then(function(response) {
        return response.json();
    });
}
function $8af27e6da99b5030$export$d11ee7cd6d3f95d4(id, starr) {
    return $8b420386626a2c2e$export$299ba2dee77727e9("".concat(starr ? 'starr' : 'unstarr', "/").concat(id)).promise.then(function(response) {
        return response.json();
    });
}
function $8af27e6da99b5030$export$bf7f2fce5c1cf636(id, read) {
    return $8b420386626a2c2e$export$299ba2dee77727e9("".concat(read ? 'unmark' : 'mark', "/").concat(id)).promise.then(function(response) {
        return response.json();
    });
}
/**
 * Converts some values like dates in an entry into a objects.
 */ function $8af27e6da99b5030$var$enrichItem(entry) {
    return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
        link: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(entry.link),
        datetime: $8af27e6da99b5030$var$safeDate(entry.datetime),
        updatetime: entry.updatetime !== null ? $8af27e6da99b5030$var$safeDate(entry.updatetime) : null
    });
}
/**
 * Converts some values like dates in response into a objects.
 */ function $8af27e6da99b5030$var$enrichItemsResponse(data) {
    return (0, $9Jpjh._)((0, $lvTkn._)({}, data), {
        lastUpdate: data.lastUpdate !== null ? $8af27e6da99b5030$var$safeDate(data.lastUpdate) : null,
        entries: data.entries.map($8af27e6da99b5030$var$enrichItem)
    });
}
function $8af27e6da99b5030$export$d2f92acf417bbf5d(filter, abortController) {
    return $8b420386626a2c2e$export$3988ae62b71be9a3('', {
        body: $8b420386626a2c2e$export$92871f7982deaf9f((0, $9Jpjh._)((0, $lvTkn._)({}, filter), {
            fromDatetime: filter.fromDatetime ? filter.fromDatetime.toISOString() : filter.fromDatetime
        })),
        abortController: abortController
    }).promise.then(function(response) {
        return response.json();
    }).then($8af27e6da99b5030$var$enrichItemsResponse);
}
/**
 * Converts some values like dates in response into a objects.
 */ function $8af27e6da99b5030$var$enrichSyncResponse(data) {
    var _data_newItems;
    return (0, $9Jpjh._)((0, $lvTkn._)({}, data), {
        lastUpdate: data.lastUpdate !== null ? $8af27e6da99b5030$var$safeDate(data.lastUpdate) : null,
        newItems: (_data_newItems = data.newItems) === null || _data_newItems === void 0 ? void 0 : _data_newItems.map($8af27e6da99b5030$var$enrichItem)
    });
}
function $8af27e6da99b5030$export$92d6409d68f0739a(updatedStatuses, syncParams) {
    var params = (0, $9Jpjh._)((0, $lvTkn._)({}, syncParams), {
        updatedStatuses: syncParams.updatedStatuses ? syncParams.updatedStatuses.map(function(status) {
            return (0, $9Jpjh._)((0, $lvTkn._)({}, status), {
                datetime: status.datetime.toISOString()
            });
        }) : syncParams.updatedStatuses,
        since: 'since' in syncParams ? syncParams.since.toISOString() : undefined,
        itemsNotBefore: 'itemsNotBefore' in syncParams ? syncParams.itemsNotBefore.toISOString() : undefined
    });
    var _ajax_fetch = $8b420386626a2c2e$export$e7aa7bc5c1b3cfb3('items/sync', {
        method: updatedStatuses ? 'POST' : 'GET',
        body: $8b420386626a2c2e$export$92871f7982deaf9f(params)
    }), controller = _ajax_fetch.controller, promise = _ajax_fetch.promise;
    return {
        controller: controller,
        promise: promise.then(function(response) {
            return response.json();
        }).then($8af27e6da99b5030$var$enrichSyncResponse)
    };
}













function $ac2cb81ab85428fa$var$reloadList(param) {
    var fetchParams = param.fetchParams, abortController = param.abortController, navigate = param.navigate, _param_append = param.append, append = _param_append === void 0 ? false : _param_append, _param_waitForSync = param.waitForSync, waitForSync = _param_waitForSync === void 0 ? true : _param_waitForSync, configuration = param.configuration, _param_entryId = param.entryId, entryId = _param_entryId === void 0 ? null : _param_entryId, setLoadingState = param.setLoadingState, showError = param.showError, _ = param._;
    if (abortController.signal.aborted) return Promise.resolve();
    if (entryId && fetchParams.fromId === undefined) fetchParams = (0, $9Jpjh._)((0, $lvTkn._)({}, fetchParams), {
        extraIds: (0, $6zk1M._)(fetchParams.extraIds).concat([
            entryId
        ])
    });
    if (!append || fetchParams.type !== (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).NEWEST) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline = false;
    setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
    var reload = function() {
        if (abortController.signal.aborted) return Promise.resolve();
        var forceLoadOnline = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.olderEntriesOnline || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline;
        // tag, source and search filtering not supported offline (yet?)
        var shouldFetch = fetchParams.tag || fetchParams.source || fetchParams.search || !(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isOnline() && forceLoadOnline;
        var reloader = shouldFetch ? (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.getEntries(fetchParams, abortController) : (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
        // Clean state when not just adding items.
        if (!append) {
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setHasMore(false);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setExpandedEntries({});
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setEntries([]);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setSelectedEntry(null);
        }
        setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
        return reloader.then(function(param) {
            var entries = param.entries, hasMore = param.hasMore;
            if (abortController.signal.aborted) return;
            setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setHasMore(hasMore);
            if (append) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.appendEntries(entries);
            else {
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setExpandedEntries({});
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setEntries(entries);
                // open selected entry only if entry was requested (i.e. if not streaming
                // more)
                if (entryId && fetchParams.fromId === undefined) {
                    var entry = document.querySelector('.entry[data-entry-id="'.concat(entryId, '"]'));
                    if (!entry) return;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.activateEntry(entryId);
                    // ensure scrolling to requested entry even if scrolling to article
                    // header is disabled
                    if (!configuration.scrollToArticleHeader) // needs to be delayed for some reason
                    requestAnimationFrame(function() {
                        entry.scrollIntoView();
                    });
                } else window.scrollTo({
                    top: 0
                });
            }
        }).catch(function(error) {
            if (abortController.signal.aborted) return;
            if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                navigate('/sign/in', {
                    state: {
                        error: _('error_session_expired')
                    }
                });
                return;
            }
            setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE);
            showError(_('error_loading') + ' ' + error.message);
        });
    };
    if (waitForSync && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.syncing.promise) {
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.userWaiting = true;
        return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.syncing.promise.finally(reload);
    } else return reload();
}
/**
 * Try to open the selected article using the preferred method.
 */ function $ac2cb81ab85428fa$var$openSelectedArticle(selected) {
    var link = document.querySelector('.entry[data-entry-id="'.concat(selected, '"] .entry-datetime'));
    if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.openInBackgroundTab) {
        // In Chromium, this will just cause the tab to open in the foreground.
        // Appears to be disallowed by the pop-under prevention:
        // https://crbug.com/431335
        // https://crbug.com/487919
        var event = new MouseEvent('click', {
            ctrlKey: true
        });
        link.dispatchEvent(event);
    } else // open item in new window
    link.click();
}
// updates a source
function $ac2cb81ab85428fa$var$handleRefreshSource(param) {
    var event = param.event, source = param.source, setLoadingState = param.setLoadingState, setNavExpanded = param.setNavExpanded, reload = param.reload, _ = param._;
    event.preventDefault();
    // show loading
    setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
    return $c937d70a1b132a36$export$c1f8f7c408fa54a(source).then(function() {
        // hide nav on smartphone
        setNavExpanded(false);
        // Fetch the new items and reload the list.
        // Will also clear the loading status.
        reload();
    }).catch(function(error) {
        setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE);
        alert(_('error_refreshing_source') + ' ' + error.message);
    });
}
function $ac2cb81ab85428fa$export$66d62ccfdff1c843(props) {
    var _params_category, _params_category1;
    var entries = props.entries, hasMore = props.hasMore, loadingState = props.loadingState, setLoadingState = props.setLoadingState, selectedEntry = props.selectedEntry, expandedEntries = props.expandedEntries, setNavExpanded = props.setNavExpanded, navSourcesExpanded = props.navSourcesExpanded, reload = props.reload, setGlobalUnreadCount = props.setGlobalUnreadCount, unreadItemsCount = props.unreadItemsCount, showError = props.showError;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var allowedToUpdate = (0, $afaa653977073dac$export$683005ba76038aff)();
    var allowedToWrite = (0, $afaa653977073dac$export$b416b77cd328c02f)();
    var configuration = (0, $eHaBZ.use)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e));
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var forceReload = (0, $74ba0882e4d762a0$export$7bcdf1c247ef07b1)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    }, [
        location.search
    ]);
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    var currentTag = ((_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('tag-')) ? params.category.replace(/^tag-/, '') : null;
    var currentSource = ((_params_category1 = params.category) === null || _params_category1 === void 0 ? void 0 : _params_category1.startsWith('source-')) ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    // The offsets for pagination.
    // Clear them when URL changes, except for when only id changes since that happens when reading.
    var _useStateWithDeps = (0, $21h22._)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromDatetime = _useStateWithDeps[0], setFromDatetime = _useStateWithDeps[1];
    var _useStateWithDeps1 = (0, $21h22._)((0, $52218fae2790199f$exports.useStateWithDeps)(undefined, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]), 2), fromId = _useStateWithDeps1[0], setFromId = _useStateWithDeps1[1];
    // Cache the item id from initial URL so that we can fetch it
    // but do not re-fetch when the id in the URI changes later
    // since that happens when reading.
    var initialItemId = (0, $eHaBZ.useMemo)(function() {
        return params.id;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText,
        forceReload
    ]);
    // Same for the state of navigation being expanded.
    // It is only passed to the API request as a part of optimization scheme
    // so there is no need for it to trigger refresh of the entries.
    var initialNavSourcesExpanded = (0, $eHaBZ.useMemo)(function() {
        return navSourcesExpanded;
    }, [
        params.filter,
        currentTag,
        currentSource,
        searchText
    ]);
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)((0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL), 2), moreLoadingState = _useState[0], setMoreLoadingState = _useState[1];
    var reloader = (0, $eHaBZ.useEffectEvent)(function(fetchParams, abortController) {
        return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
            var append;
            return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                switch(_state.label){
                    case 0:
                        append = fetchParams.fromId !== undefined || fetchParams.fromDatetime !== undefined;
                        return [
                            4,
                            $ac2cb81ab85428fa$var$reloadList({
                                // Object with parameters for GET /items and similar API calls
                                // based on the current location.
                                fetchParams: fetchParams,
                                abortController: abortController,
                                navigate: navigate,
                                append: append,
                                configuration: configuration,
                                // We do not want to focus the entry on successive loads.
                                entryId: append ? undefined : initialItemId,
                                setLoadingState: append ? setMoreLoadingState : setLoadingState,
                                showError: showError,
                                _: _
                            })
                        ];
                    case 1:
                        _state.sent();
                        if (currentTag !== null && !(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.isValidTag(currentTag)) showError(_('error_unknown_tag') + ' ' + currentTag);
                        if (currentSource !== null && !(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.isValidSource(currentSource)) showError(_('error_unknown_source') + ' ' + currentSource);
                        return [
                            2
                        ];
                }
            });
        })();
    });
    // Perform the scheduled reload.
    (0, $eHaBZ.useEffect)(function() {
        var abortController = new AbortController();
        var fetchParams = {
            type: params.filter,
            tag: currentTag,
            source: currentSource,
            extraIds: [],
            sourcesNav: initialNavSourcesExpanded,
            search: searchText,
            fromDatetime: fromDatetime,
            fromId: fromId
        };
        reloader(fetchParams, abortController);
        return function() {
            abortController.abort();
        };
    }, [
        params.filter,
        currentTag,
        currentSource,
        initialNavSourcesExpanded,
        searchText,
        fromDatetime,
        fromId,
        forceReload
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // scroll load more
        var onScroll = function() {
            var streamMoreButton = document.querySelector('.stream-more');
            if (streamMoreButton === null) return;
            var streamMoreButtonTop = window.scrollY + streamMoreButton.getBoundingClientRect().top;
            // When “More” button appears on the screen, click it.
            if (streamMoreButtonTop < document.body.clientHeight + window.scrollY) streamMoreButton.click();
        };
        if (hasMore && moreLoadingState !== (0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING && configuration.autoStreamMore) {
            window.addEventListener('scroll', onScroll);
            return function() {
                window.removeEventListener('scroll', onScroll);
            };
        }
    }, [
        configuration,
        hasMore,
        moreLoadingState
    ]);
    (0, $eHaBZ.useEffect)(function() {
        // setup periodic server status sync
        var interval = window.setInterval((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.sync, 60000);
        return function() {
            window.clearInterval(interval);
        };
    }, []);
    (0, $eHaBZ.useEffect)(function() {
        setGlobalUnreadCount(unreadItemsCount);
        return function() {
            setGlobalUnreadCount(null);
        };
    }, [
        setGlobalUnreadCount,
        unreadItemsCount
    ]);
    var isOnline = (0, $c020e53fc27b31fb$export$6feb6ada280bcdab)();
    var refreshOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $ac2cb81ab85428fa$var$handleRefreshSource({
            event: event,
            source: currentSource,
            setLoadingState: setLoadingState,
            setNavExpanded: setNavExpanded,
            reload: reload,
            _: _
        });
    }, [
        currentSource,
        setLoadingState,
        setNavExpanded,
        reload,
        _
    ]);
    var moreOnClick = (0, $eHaBZ.useCallback)(function(event) {
        event.preventDefault();
        var lastEntry = entries[entries.length - 1];
        // Calculate offset.
        setFromDatetime(lastEntry ? lastEntry.datetime : undefined);
        setFromId(lastEntry ? lastEntry.id : undefined);
    }, [
        entries,
        setFromDatetime,
        setFromId
    ]);
    // Current time for calculating relative dates in items.
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(function() {
        return new Date();
    }), 2), currentTime = _useState1[0], setCurrentTime = _useState1[1];
    (0, $eHaBZ.useEffect)(function() {
        var tick = window.setInterval(function() {
            setCurrentTime(new Date());
        }, 60000);
        return function() {
            clearInterval(tick);
        };
    }, []);
    if (loadingState === (0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$84dbad74efe95918), {
        label: _('entries_loading')
    });
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            currentSource !== null && allowedToUpdate && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                type: "button",
                className: "refresh-source",
                onClick: refreshOnClick,
                children: _('source_refresh')
            }) : null,
            currentSource !== null && allowedToWrite && isOnline ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                to: {
                    pathname: '/manage/sources',
                    hash: "#source-".concat(currentSource)
                },
                className: "entries-go-to-settings",
                children: _('source_go_to_settings')
            }) : null,
            entries.map(function(entry) {
                var _expandedEntries_entry_id;
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $4c7e00084d6d58aa$export$2e2bcd8739ae039), {
                    item: entry,
                    currentTime: currentTime,
                    selected: selectedEntry == entry.id,
                    expanded: (_expandedEntries_entry_id = expandedEntries[entry.id]) !== null && _expandedEntries_entry_id !== void 0 ? _expandedEntries_entry_id : false,
                    setNavExpanded: setNavExpanded,
                    showError: showError
                }, entry.id);
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                id: "stream-buttons",
                children: [
                    loadingState === (0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS && entries.length === 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        "aria-live": "assertive",
                        className: "stream-empty",
                        children: _('no_entries')
                    }) : null,
                    hasMore ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                            'stream-button': true,
                            'stream-more': true
                        }),
                        accessKey: "m",
                        "aria-label": _('more'),
                        onClick: moreLoadingState !== (0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING ? moreOnClick : null,
                        children: moreLoadingState !== (0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _('more')
                        }) : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ca3d48d4950424d8$export$7f7cbe89f1eacd2), {
                            size: "3x",
                            label: _('entries_loading')
                        })
                    }) : null,
                    entries.length > 0 ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button mark-these-read",
                        "aria-label": _('markread'),
                        onClick: (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.markVisibleRead,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: _('markread')
                        })
                    }) : null,
                    loadingState == (0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                        className: "stream-button stream-error",
                        "aria-live": "assertive",
                        "aria-label": _('streamerror'),
                        onClick: reload,
                        children: _('streamerror')
                    }) : null
                ]
            })
        ]
    });
}
var $ac2cb81ab85428fa$var$initialState = {
    entries: [],
    hasMore: false,
    selectedEntry: null,
    expandedEntries: {},
    loadingState: (0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL
};
var $ac2cb81ab85428fa$export$9c61909d8ed47595 = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(StateHolder, _React_Component);
    function StateHolder(props) {
        (0, $gd0sY._)(this, StateHolder);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, StateHolder, [
            props
        ]);
        _this.state = $ac2cb81ab85428fa$var$initialState;
        _this.reload = _this.reload.bind(_this);
        _this.setLoadingState = _this.setLoadingState.bind(_this);
        _this.activateEntry = _this.activateEntry.bind(_this);
        _this.deactivateEntry = _this.deactivateEntry.bind(_this);
        _this.markVisibleRead = _this.markVisibleRead.bind(_this);
        _this.markEntryRead = _this.markEntryRead.bind(_this);
        _this.markEntryStarred = _this.markEntryStarred.bind(_this);
        _this.nextPrev = _this.nextPrev.bind(_this);
        _this.entryNav = _this.entryNav.bind(_this);
        _this.jumpToNext = _this.jumpToNext.bind(_this);
        _this.toggleSelectedStarred = _this.toggleSelectedStarred.bind(_this);
        _this.toggleSelectedRead = _this.toggleSelectedRead.bind(_this);
        _this.toggleSelectedExpanded = _this.toggleSelectedExpanded.bind(_this);
        _this.openSelectedTarget = _this.openSelectedTarget.bind(_this);
        _this.openSelectedTargetAndMarkRead = _this.openSelectedTargetAndMarkRead.bind(_this);
        _this.throw = _this.throw.bind(_this);
        return _this;
    }
    (0, $7cSld._)(StateHolder, [
        {
            key: "setEntries",
            value: function setEntries(entries) {
                if (typeof entries === 'function') this.setState(function(state) {
                    return {
                        entries: entries(state.entries)
                    };
                });
                else this.setState({
                    entries: entries
                });
            }
        },
        {
            key: "appendEntries",
            value: function appendEntries(extraEntries) {
                this.setEntries(function(entries) {
                    return (0, $6zk1M._)(entries).concat((0, $6zk1M._)(extraEntries));
                });
            }
        },
        {
            /**
     * Make the given entry currently selected one.
     */ key: "setSelectedEntry",
            value: function setSelectedEntry(selectedEntry) {
                if (typeof selectedEntry === 'function') this.setState(function(state) {
                    return {
                        selectedEntry: selectedEntry(state.selectedEntry)
                    };
                });
                else this.setState({
                    selectedEntry: selectedEntry
                });
            }
        },
        {
            /**
     * Get the currently selected entry.
     */ key: "getSelectedEntry",
            value: function getSelectedEntry() {
                return this.state.selectedEntry;
            }
        },
        {
            key: "setExpandedEntries",
            value: function setExpandedEntries(expandedEntries) {
                if (typeof expandedEntries === 'function') this.setState(function(state) {
                    return {
                        expandedEntries: expandedEntries(state.expandedEntries)
                    };
                });
                else this.setState({
                    expandedEntries: expandedEntries
                });
            }
        },
        {
            key: "setEntryExpanded",
            value: function setEntryExpanded(id, expand) {
                if (typeof expand === 'function') this.setExpandedEntries(function(oldEntries) {
                    var _oldEntries_id;
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, oldEntries), (0, $khBmn._)({}, id, expand((_oldEntries_id = oldEntries[id]) !== null && _oldEntries_id !== void 0 ? _oldEntries_id : false)));
                });
                else this.setExpandedEntries(function(oldEntries) {
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, oldEntries), (0, $khBmn._)({}, id, expand));
                });
            }
        },
        {
            /**
     * Collapse all expanded entries.
     */ key: "collapseAllEntries",
            value: function collapseAllEntries() {
                this.setExpandedEntries({});
            }
        },
        {
            /**
     * Is entry with given id expanded?
     */ key: "isEntryExpanded",
            value: function isEntryExpanded(id) {
                var _this_state_expandedEntries_id;
                return (_this_state_expandedEntries_id = this.state.expandedEntries[id]) !== null && _this_state_expandedEntries_id !== void 0 ? _this_state_expandedEntries_id : false;
            }
        },
        {
            /**
     * Toggle expanded state of entry with given id.
     */ key: "toggleEntryExpanded",
            value: function toggleEntryExpanded(id) {
                if (!id) return;
                this.setEntryExpanded(id, function(expanded) {
                    return !(expanded !== null && expanded !== void 0 ? expanded : false);
                });
            }
        },
        {
            /**
     * Activate entry as if it were clicked.
     * This will open it, focus it and based on the settings, mark it as read.
     */ key: "activateEntry",
            value: function activateEntry(id) {
                if (this.props.configuration.autoCollapse) this.collapseAllEntries();
                this.setSelectedEntry(id);
                // show/hide (with toolbar)
                this.setEntryExpanded(id, true);
                // automark as read
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                var autoMarkAsRead = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToWrite() && this.props.configuration.autoMarkAsRead && entry.unread;
                if (autoMarkAsRead) this.markEntryRead(id, true);
            }
        },
        {
            /**
     * Deactivate entry, as if it were clicked.
     * This will close it and maybe something more.
     */ key: "deactivateEntry",
            value: function deactivateEntry(id) {
                this.setEntryExpanded(id, false);
            }
        },
        {
            key: "starEntryInView",
            value: function starEntryInView(id, starred) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                            starred: starred
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "markEntryInView",
            value: function markEntryInView(id, unread) {
                this.setEntries(function(entries) {
                    return entries.map(function(entry) {
                        if (entry.id === id) return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                            unread: unread
                        });
                        else return entry;
                    });
                });
            }
        },
        {
            key: "refreshEntryStatuses",
            value: function refreshEntryStatuses(entryStatuses) {
                var _this = this;
                this.state.entries.forEach(function(entry) {
                    var id = entry.id;
                    var newStatus = entryStatuses.find(function(entryStatus) {
                        return entryStatus.id == id;
                    });
                    if (newStatus) {
                        _this.starEntryInView(id, newStatus.starred);
                        _this.markEntryInView(id, newStatus.unread);
                    }
                });
            }
        },
        {
            key: "setHasMore",
            value: function setHasMore(hasMore) {
                if (typeof hasMore === 'function') this.setState(function(state) {
                    return {
                        hasMore: hasMore(state.hasMore)
                    };
                });
                else this.setState({
                    hasMore: hasMore
                });
            }
        },
        {
            key: "setLoadingState",
            value: function setLoadingState(loadingState) {
                if (typeof loadingState === 'function') this.setState(function(state) {
                    return {
                        loadingState: loadingState(state.loadingState)
                    };
                });
                else this.setState({
                    loadingState: loadingState
                });
            }
        },
        {
            key: "getActiveTag",
            value: function getActiveTag() {
                var _this_props_params;
                var category = (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.category;
                if (!category) return null;
                return category.startsWith('tag-') ? category.replace(/^tag-/, '') : null;
            }
        },
        {
            key: "getActiveSource",
            value: function getActiveSource() {
                var _this_props_params;
                var category = (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.category;
                if (!category) return null;
                return category.startsWith('source-') ? parseInt(category.replace(/^source-/, ''), 10) : null;
            }
        },
        {
            key: "getActiveFilter",
            value: function getActiveFilter() {
                var _this_props_params;
                return (_this_props_params = this.props.params) === null || _this_props_params === void 0 ? void 0 : _this_props_params.filter;
            }
        },
        {
            /**
     * Mark all visible items as read
     */ key: "markVisibleRead",
            value: function markVisibleRead() {
                var _this = this;
                var ids = [];
                var tagUnreadDiff = {};
                var sourceUnreadDiff = {};
                var markedEntries = this.state.entries.map(function(entry) {
                    if (!entry.unread) return entry;
                    ids.push(entry.id);
                    Object.keys(entry.tags).forEach(function(tag) {
                        if (Object.keys(tagUnreadDiff).includes(tag)) tagUnreadDiff[tag] += -1;
                        else tagUnreadDiff[tag] = -1;
                    });
                    var source = entry.source;
                    if (Object.keys(sourceUnreadDiff).includes(source.toString())) sourceUnreadDiff[source] += -1;
                    else sourceUnreadDiff[source] = -1;
                    return (0, $9Jpjh._)((0, $lvTkn._)({}, entry), {
                        unread: false
                    });
                });
                var oldEntries = this.state.entries;
                var hadMore = this.state.hasMore;
                // close opened entry and list
                this.setExpandedEntries({});
                this.props.setNavExpanded(false);
                if (this.props.params.filter === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD) markedEntries = [];
                this.setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
                this.setEntries(markedEntries);
                // update statistics in main menu
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).refreshUnread(unreadstats + diff * ids.length);
                    // update unread on tags and sources
                    if (markRead) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.refreshTagSourceUnread(tagUnreadDiff, sourceUnreadDiff);
                    else // Diffs are negative by default.
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.refreshTagSourceUnread(Object.fromEntries(Object.entries(tagUnreadDiff).map(function(param) {
                        var _param = (0, $21h22._)(param, 2), tag = _param[0], diff = _param[1];
                        return [
                            tag,
                            -1 * diff
                        ];
                    })), Object.fromEntries(Object.entries(sourceUnreadDiff).map(function(param) {
                        var _param = (0, $21h22._)(param, 2), source = _param[0], diff = _param[1];
                        return [
                            source,
                            -1 * diff
                        ];
                    })));
                };
                updateStats(true);
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.entriesMark(ids, false);
                $8af27e6da99b5030$export$8ce663b0c6b2535e(ids).then(function() {
                    _this.setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                }).catch(function(error) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                        var statusName = 'unread';
                        var statuses = ids.map(function(id) {
                            return {
                                entryId: id,
                                name: statusName,
                                value: false
                            };
                        });
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.enqueueStatuses(statuses);
                    }).catch(function(error) {
                        if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: _this.props._('error_session_expired')
                                }
                            });
                            return;
                        }
                        _this.setLoadingState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                        _this.setEntries(oldEntries);
                        updateStats(false);
                        _this.setHasMore(hadMore);
                        _this.props.showError(_this.props._('error_mark_items') + ' ' + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked read/unread in the model.
     */ key: "markEntryRead",
            value: function markEntryRead(id, markRead) {
                var _this = this;
                // only loggedin users
                if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToWrite()) {
                    console.log('User not allowed to mark an entry (un)read.');
                    return;
                }
                var entry = this.state.entries.find(function(entry) {
                    return id === entry.id;
                });
                var newReadState = markRead === 'toggle' ? entry.unread : markRead;
                this.markEntryInView(id, !newReadState);
                // update statistics in main menue and the currently active tag
                var updateStats = function(markRead) {
                    // update all unread counters
                    var unreadstats = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                    var diff = markRead ? -1 : 1;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).refreshUnread(unreadstats + diff);
                    // update unread on tags and sources
                    // Only a single instance of each tag per entry so we can just assign.
                    var entryTags = Object.fromEntries(Object.keys(entry.tags).map(function(tag) {
                        return [
                            tag,
                            diff
                        ];
                    }));
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.refreshTagSourceUnread(entryTags, (0, $khBmn._)({}, entry.source, diff));
                };
                updateStats(newReadState);
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.entryMark(id, !newReadState);
                $8af27e6da99b5030$export$bf7f2fce5c1cf636(id, !newReadState).then(function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.setOnline();
                }).catch(function(error) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.enqueueStatus(id, 'unread', !newReadState);
                    }).catch(function(error) {
                        if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: _this.props._('error_session_expired')
                                }
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.markEntryInView(id, newReadState);
                        updateStats(!newReadState);
                        _this.props.showError(_this.props._('error_mark_item') + ' ' + error.message);
                    });
                });
            }
        },
        {
            /**
     * Requests for an entry to be marked (un)starred in the model.
     */ key: "markEntryStarred",
            value: function markEntryStarred(id, markStarred) {
                var _this = this;
                // only loggedin users
                if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToWrite()) {
                    console.log('User not allowed to (un)star an entry.');
                    return;
                }
                var newStarredState;
                if (markStarred === 'toggle') {
                    var entry = this.state.entries.find(function(entry) {
                        return id === entry.id;
                    });
                    newStarredState = !entry.starred;
                } else newStarredState = markStarred;
                this.starEntryInView(id, newStarredState);
                // update statistics in main menu
                var updateStats = function(markStarred) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setStarredItemsCount(function(starred) {
                        return starred + (markStarred ? 1 : -1);
                    });
                };
                updateStats(newStarredState);
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.entryStar(id, newStarredState);
                $8af27e6da99b5030$export$d11ee7cd6d3f95d4(id, newStarredState).then(function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.setOnline();
                }).catch(function(error) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.enqueueStatus(id, 'starred', newStarredState);
                    }).catch(function(error) {
                        if (error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) && error.response.status === 403) {
                            _this.props.navigate('/sign/in', {
                                state: {
                                    error: _this.props._('error_session_expired')
                                }
                            });
                            return;
                        }
                        // rollback ui changes
                        _this.starEntryInView(id, !newStarredState);
                        updateStats(!newStarredState);
                        _this.props.showError(_this.props._('error_star_item') + ' ' + error.message);
                    });
                });
            }
        },
        {
            key: "reload",
            value: function reload() {
                /**
         * HACK: A counter that is increased every time reload action (r key) is triggered.
         */ this.props.navigate((0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(this.props.location, {
                    id: null
                }), {
                    replace: true,
                    state: (0, $3d1fd3a25027abce$export$e64cf1b9b4b3aa56)(this.props.location)
                });
            }
        },
        {
            /**
     * get next/prev item
     */ key: "nextPrev",
            value: function nextPrev(direction) {
                var open = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (direction != (0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT && direction != (0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
                // when there are no entries
                if (this.state.entries.length == 0) return;
                // select current
                var old = this.getSelectedEntry();
                var oldIndex = old !== null ? this.state.entries.findIndex(function(param) {
                    var id = param.id;
                    return id === old;
                }) : null;
                var current = null;
                // select next/prev entry and save it to "current"
                // if we would overflow, we stay on the old one
                if (direction == (0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT) {
                    if (old === null) current = this.state.entries[0].id;
                    else {
                        var nextIndex = oldIndex + 1;
                        if (nextIndex >= this.state.entries.length) {
                            var // attempt to load more
                            _document_querySelector;
                            current = old;
                            (_document_querySelector = document.querySelector('.stream-more')) === null || _document_querySelector === void 0 ? void 0 : _document_querySelector.click();
                        } else current = this.state.entries[nextIndex].id;
                    }
                } else {
                    if (old === null) return;
                    else if (oldIndex <= 0) current = old;
                    else current = this.state.entries[oldIndex - 1].id;
                }
                if (old !== current) {
                    // remove active
                    this.deactivateEntry(old);
                    if (open) this.activateEntry(current);
                    else this.setSelectedEntry(current);
                    var currentElement = document.querySelector('.entry[data-entry-id="'.concat(current, '"]'));
                    // scroll to element
                    (0, $fc181d02c22cdede$export$d976747ecb966cea)(currentElement);
                    // focus the title link for better keyboard navigation
                    currentElement.querySelector('.entry-title-link').focus();
                }
            }
        },
        {
            /**
     * entry navigation (next/prev) with keys
     */ key: "entryNav",
            value: function entryNav(direction) {
                if (direction != (0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT && direction != (0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV) throw new Error('direction must be one of Direction.{PREV,NEXT}');
                var open = this.isEntryExpanded(this.getSelectedEntry());
                this.nextPrev(direction, open);
            }
        },
        {
            key: "jumpToNext",
            value: function jumpToNext() {
                var selected = this.getSelectedEntry();
                if (selected !== null && !this.isEntryExpanded(selected)) this.activateEntry(selected);
                else this.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT, true);
            }
        },
        {
            key: "toggleSelectedStarred",
            value: function toggleSelectedStarred() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryStarred(selected, 'toggle');
            }
        },
        {
            key: "toggleSelectedRead",
            value: function toggleSelectedRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, 'toggle');
            }
        },
        {
            key: "toggleSelectedExpanded",
            value: function toggleSelectedExpanded() {
                this.toggleEntryExpanded(this.getSelectedEntry());
            }
        },
        {
            key: "openSelectedTarget",
            value: function openSelectedTarget() {
                var selected = this.getSelectedEntry();
                if (selected !== null) $ac2cb81ab85428fa$var$openSelectedArticle(selected);
            }
        },
        {
            key: "openSelectedTargetAndMarkRead",
            value: function openSelectedTargetAndMarkRead() {
                var selected = this.getSelectedEntry();
                if (selected !== null) {
                    this.markEntryRead(selected, true);
                    $ac2cb81ab85428fa$var$openSelectedArticle(selected);
                }
            }
        },
        {
            key: "throw",
            value: function _throw(direction) {
                var selected = this.getSelectedEntry();
                if (selected !== null) this.markEntryRead(selected, true);
                this.nextPrev(direction, true);
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($ac2cb81ab85428fa$export$66d62ccfdff1c843, {
                    entries: this.state.entries,
                    selectedEntry: this.state.selectedEntry,
                    expandedEntries: this.state.expandedEntries,
                    hasMore: this.state.hasMore,
                    loadingState: this.state.loadingState,
                    setLoadingState: this.setLoadingState,
                    setNavExpanded: this.props.setNavExpanded,
                    navSourcesExpanded: this.props.navSourcesExpanded,
                    reload: this.reload,
                    setGlobalUnreadCount: this.props.setGlobalUnreadCount,
                    unreadItemsCount: this.props.unreadItemsCount,
                    showError: this.props.showError
                });
            }
        }
    ]);
    return StateHolder;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
function $ac2cb81ab85428fa$export$f3fcbed2d1eb5db9(props) {
    var configuration = props.configuration, setNavExpanded = props.setNavExpanded, navSourcesExpanded = props.navSourcesExpanded, setGlobalUnreadCount = props.setGlobalUnreadCount, unreadItemsCount = props.unreadItemsCount, showError = props.showError, ref = props.ref;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($ac2cb81ab85428fa$export$9c61909d8ed47595, {
        ref: ref,
        location: location,
        navigate: navigate,
        params: params,
        configuration: configuration,
        setNavExpanded: setNavExpanded,
        navSourcesExpanded: navSourcesExpanded,
        setGlobalUnreadCount: setGlobalUnreadCount,
        unreadItemsCount: unreadItemsCount,
        showError: showError,
        _: _
    });
}
var $ac2cb81ab85428fa$export$2e2bcd8739ae039 = $ac2cb81ab85428fa$export$f3fcbed2d1eb5db9;




var $eHaBZ = parcelRequire("eHaBZ");


var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");








function $1f901eab4509cd0f$export$2e2bcd8739ae039(props) {
    var setNavExpanded = props.setNavExpanded, offlineState = props.offlineState, allItemsCount = props.allItemsCount, allItemsOfflineCount = props.allItemsOfflineCount, unreadItemsCount = props.unreadItemsCount, unreadItemsOfflineCount = props.unreadItemsOfflineCount, starredItemsCount = props.starredItemsCount, starredItemsOfflineCount = props.starredItemsOfflineCount;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var newestLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            filter: (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).NEWEST,
            id: null
        });
    }, [
        location
    ]);
    var unreadLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            filter: (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD,
            id: null
        });
    }, [
        location
    ]);
    var starredLink = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            filter: (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED,
            id: null
        });
    }, [
        location
    ]);
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "nav-filter-wrapper",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-filter-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-filter-collapsed': !expanded,
                        'nav-filter-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('filter')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-filter",
                    "aria-labelledby": "nav-filter-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-newest",
                                to: newestLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-newest': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).NEWEST
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('newest'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: allItemsCount !== allItemsOfflineCount && allItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: allItemsOfflineCount > 0 ? allItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: allItemsCount > 0 ? allItemsCount : ''
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-unread",
                                to: unreadLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-unread': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('unread'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'unread-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            unread: unreadItemsCount > 0
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    'offline-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                }),
                                                title: _('offline_count'),
                                                children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                            }),
                                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                className: "count",
                                                title: _('online_count'),
                                                children: unreadItemsCount > 0 ? unreadItemsCount : ''
                                            })
                                        ]
                                    })
                                ]
                            })
                        }),
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                                id: "nav-filter-starred",
                                to: starredLink,
                                state: forceReload,
                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                    'nav-filter-starred': true,
                                    active: (params === null || params === void 0 ? void 0 : params.filter) === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED
                                }),
                                onClick: collapseNav,
                                children: [
                                    _('starred'),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                            'offline-count': true,
                                            offline: offlineState,
                                            online: !offlineState,
                                            diff: starredItemsCount !== starredItemsOfflineCount && starredItemsOfflineCount
                                        }),
                                        title: _('offline_count'),
                                        children: starredItemsOfflineCount > 0 ? starredItemsOfflineCount : ''
                                    }),
                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                        className: "count",
                                        title: _('online_count'),
                                        children: starredItemsCount > 0 ? starredItemsCount : ''
                                    })
                                ]
                            })
                        })
                    ]
                })
            })
        ]
    });
}




var $eHaBZ = parcelRequire("eHaBZ");












function $22ff3a11d092d484$var$handleTitleClick(param) {
    var setExpanded = param.setExpanded, sourcesState = param.sourcesState, setSourcesState = param.setSourcesState, setSources = param.setSources, _ = param._, showError = param.showError;
    if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isOnline()) {
        console.log('Cannot toggle, not online.');
        return;
    }
    setExpanded(function(expanded) {
        if (!expanded && sourcesState === (0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL) $c937d70a1b132a36$export$432f698644f45d1().then(function(data) {
            setSources(data);
            setSourcesState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
        }).catch(function(error) {
            setSourcesState((0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE);
            showError(_('error_loading_stats') + ' ' + error.message);
        });
        return !expanded;
    });
}
function $22ff3a11d092d484$var$Source(props) {
    var source = props.source, active = props.active, collapseNav = props.collapseNav;
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            category: "source-".concat(source.id),
            id: null
        });
    }, [
        source.id,
        location
    ]);
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: source.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                active: active,
                unread: source.unread > 0
            }),
            onClick: collapseNav,
            state: forceReload,
            children: [
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "nav-source",
                    children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(source.title)
                }),
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                    className: "unread",
                    children: source.unread > 0 ? source.unread : ''
                })
            ]
        })
    });
}
function $22ff3a11d092d484$export$2e2bcd8739ae039(props) {
    var _params_category;
    var setNavExpanded = props.setNavExpanded, navSourcesExpanded = props.navSourcesExpanded, setNavSourcesExpanded = props.setNavSourcesExpanded, sourcesState = props.sourcesState, setSourcesState = props.setSourcesState, sources = props.sources, setSources = props.setSources, showError = props.showError;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var reallyExpanded = navSourcesExpanded && sourcesState === (0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS;
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    var currentSource = (params === null || params === void 0 ? void 0 : (_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('source-')) ? parseInt(params.category.replace(/^source-/, ''), 10) : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return $22ff3a11d092d484$var$handleTitleClick({
            setExpanded: setNavSourcesExpanded,
            sourcesState: sourcesState,
            setSourcesState: setSourcesState,
            setSources: setSources,
            showError: showError,
            _: _
        });
    }, [
        setNavSourcesExpanded,
        sourcesState,
        setSourcesState,
        setSources,
        showError,
        _
    ]);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var previousSourcesState = (0, $c020e53fc27b31fb$export$f6f3f74729fdd0b7)(sourcesState);
    (0, $eHaBZ.useEffect)(function() {
        if (previousSourcesState === (0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL && sourcesState === (0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS) setNavSourcesExpanded(true);
    }, [
        previousSourcesState,
        sourcesState,
        setNavSourcesExpanded
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-sources-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-sources-collapsed': !reallyExpanded,
                        'nav-sources-expanded': reallyExpanded
                    }),
                    "aria-expanded": reallyExpanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                            icon: navSourcesExpanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('sources')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: reallyExpanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                    id: "nav-sources",
                    "aria-labelledby": "nav-sources-title",
                    children: sources.map(function(source) {
                        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($22ff3a11d092d484$var$Source, {
                            source: source,
                            active: currentSource === source.id,
                            collapseNav: collapseNav
                        }, source.id);
                    })
                })
            })
        ]
    });
}



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");







// search button shows search input or executes search
function $cb22cb1150729cae$var$handleSubmit(param) {
    var active = param.active, setActive = param.setActive, searchField = param.searchField, searchText = param.searchText, navigate = param.navigate, location = param.location, setNavExpanded = param.setNavExpanded;
    if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isSmartphone() && !active) {
        setActive(true);
        searchField.current.focus();
        searchField.current.select();
        return;
    }
    navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
        search: searchText,
        id: null
    }));
    setActive(false);
    searchField.current.blur();
    setNavExpanded(false);
}
function $cb22cb1150729cae$var$handleFieldKeyUp(param) {
    var event = param.event, searchButton = param.searchButton, searchRemoveButton = param.searchRemoveButton;
    // keypress enter in search inputfield
    if (event.which == 13) searchButton.current.click();
    if (event.keyCode == 27) searchRemoveButton.current.click();
}
// remove button of search
function $cb22cb1150729cae$var$handleRemove(param) {
    var setActive = param.setActive, searchField = param.searchField, navigate = param.navigate, location = param.location;
    var queryString = new URLSearchParams(location.search);
    var oldTerm = queryString.get('search');
    setActive(false);
    if (oldTerm == '') {
        searchField.current.blur();
        return;
    }
    navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
        search: '',
        id: null
    }));
}
function $cb22cb1150729cae$export$2e2bcd8739ae039(props) {
    var setNavExpanded = props.setNavExpanded, offlineState = props.offlineState, initialSearchText = props.initialSearchText;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), active = _useState[0], setActive = _useState[1];
    var searchField = (0, $eHaBZ.useRef)(null);
    var searchButton = (0, $eHaBZ.useRef)(null);
    var searchRemoveButton = (0, $eHaBZ.useRef)(null);
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(initialSearchText), 2), searchText = _useState1[0], setSearchText = _useState1[1];
    var termOnKeyUp = (0, $eHaBZ.useCallback)(function(event) {
        return $cb22cb1150729cae$var$handleFieldKeyUp({
            event: event,
            searchButton: searchButton,
            searchRemoveButton: searchRemoveButton
        });
    }, []);
    var termOnChange = (0, $eHaBZ.useCallback)(function(event) {
        return setSearchText(event.currentTarget.value);
    }, []);
    var removeOnClick = (0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).useCallback(function() {
        return $cb22cb1150729cae$var$handleRemove({
            setActive: setActive,
            searchField: searchField,
            navigate: navigate,
            location: location
        });
    }, [
        navigate,
        location
    ]);
    var searchOnClick = (0, $eHaBZ.useCallback)(function() {
        return $cb22cb1150729cae$var$handleSubmit({
            active: active,
            setActive: setActive,
            searchField: searchField,
            searchText: searchText,
            navigate: navigate,
            location: location,
            setNavExpanded: setNavExpanded
        });
    }, [
        active,
        searchText,
        navigate,
        location,
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "search",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            offline: offlineState,
            online: !offlineState,
            active: active
        }),
        role: "search",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("input", {
                "aria-label": _('search_label'),
                type: "search",
                id: "search-term",
                accessKey: "s",
                ref: searchField,
                value: searchText,
                onKeyUp: termOnKeyUp,
                onChange: termOnChange
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "search-remove",
                title: _('searchremove'),
                accessKey: "h",
                "aria-label": _('searchremove'),
                onClick: removeOnClick,
                ref: searchRemoveButton,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $6c06a95c587730ec$exports.faTimes
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                id: "search-button",
                title: _('searchbutton'),
                "aria-label": _('searchbutton'),
                accessKey: "e",
                onClick: searchOnClick,
                ref: searchButton,
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                        icon: $3d54bd244f4653d3$exports.faSearch
                    }),
                    ' ',
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "search-button-label",
                        children: _('searchbutton')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
        ]
    });
}



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");







var $eHaBZ = parcelRequire("eHaBZ");


/**
 * Get dark OR bright color depending the color contrast.
 *
 * @param hexColor color (hex) value
 * @param darkColor dark color value
 * @param brightColor bright color value
 *
 * @return dark OR bright color value
 *
 * @see https://24ways.org/2010/calculating-color-contrast/
 */ function $9a87f1f6f0584f3c$export$97e1e2675ab19423(hexColor) {
    var darkColor = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : '#555', brightColor = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : '#EEE';
    // Strip hash sign.
    var color = hexColor.substr(1);
    var r = parseInt(color.substr(0, 2), 16);
    var g = parseInt(color.substr(2, 2), 16);
    var b = parseInt(color.substr(4, 2), 16);
    var yiq = (r * 299 + g * 587 + b * 114) / 1000;
    return yiq >= 128 ? darkColor : brightColor;
}




var $bbb16a994e9968fe$var$palette = [
    '#ffccc9',
    '#ffce93',
    '#fffc9e',
    '#ffffc7',
    '#9aff99',
    '#96fffb',
    '#cdffff',
    '#cbcefb',
    '#fffe65',
    '#cfcfcf',
    '#fd6864',
    '#fe996b',
    '#fcff2f',
    '#67fd9a',
    '#38fff8',
    '#68fdff',
    '#9698ed',
    '#c0c0c0',
    '#fe0000',
    '#f8a102',
    '#ffcc67',
    '#f8ff00',
    '#34ff34',
    '#68cbd0',
    '#34cdf9',
    '#6665cd',
    '#9b9b9b',
    '#cb0000',
    '#f56b00',
    '#ffcb2f',
    '#ffc702',
    '#32cb00',
    '#00d2cb',
    '#3166ff',
    '#6434fc',
    '#656565',
    '#9a0000',
    '#ce6301',
    '#cd9934',
    '#999903',
    '#009901',
    '#329a9d',
    '#3531ff',
    '#6200c9',
    '#343434',
    '#680100',
    '#963400',
    '#986536',
    '#646809',
    '#036400',
    '#34696d',
    '#00009b',
    '#303498',
    '#000000',
    '#330001',
    '#643403',
    '#663234',
    '#343300',
    '#013300',
    '#003532',
    '#010066',
    '#340096'
];
function $bbb16a994e9968fe$var$ColorButton(props) {
    var tag = props.tag, color = props.color;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: color,
            color: (0, $9a87f1f6f0584f3c$export$97e1e2675ab19423)(color)
        };
    }, [
        color
    ]);
    var selected = color === tag.color;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $196651884997e353$export$2ce376c2cc3355c8), {
        className: "popup-menu-item",
        value: color,
        style: style,
        children: selected ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
            icon: $0c96aa001209cff1$exports.faCheck
        }) : ' '
    });
}
var $bbb16a994e9968fe$var$preventDefault = function(event) {
    event.preventDefault();
    // Prevent closing navigation on mobile.
    event.stopPropagation();
};
function $bbb16a994e9968fe$export$2e2bcd8739ae039(props) {
    var tag = props.tag, onChange = props.onChange;
    var style = (0, $eHaBZ.useMemo)(function() {
        return {
            backgroundColor: tag.color
        };
    }, [
        tag.color
    ]);
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
        className: "color",
        onClick: $bbb16a994e9968fe$var$preventDefault,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $afcad17a77b29a48$export$d9b273488cd8ce6f), {
            menuButton: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $7a4ada20cb42c4ac$export$266a769812832828), {
                className: "color-chooser-button",
                title: _('tag_change_color_button_title'),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "color-box",
                        style: style
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "visually-hidden",
                        children: _('tag_change_color_button_title')
                    })
                ]
            }),
            menuClassName: "color-chooser popup-menu",
            onItemClick: onChange,
            viewScroll: "auto",
            portal: true,
            children: [
                $bbb16a994e9968fe$var$palette.map(function(color) {
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bbb16a994e9968fe$var$ColorButton, {
                        color: color,
                        tag: tag
                    }, color);
                }),
                !$bbb16a994e9968fe$var$palette.includes(tag.color) && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($bbb16a994e9968fe$var$ColorButton, {
                    color: tag.color,
                    tag: tag
                }, "custom")
            ]
        })
    });
}







function $e4b2796b76a042de$var$Tag(props) {
    var tag = props.tag, active = props.active, collapseNav = props.collapseNav, showError = props.showError;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var tagName = tag !== null ? tag.tag : null;
    var colorChanged = (0, $eHaBZ.useCallback)(function(param) {
        var value = param.value;
        (0, $133470f46785be8b$export$6f3c7c74c4b252bb)(tagName, value).then(function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }).catch(function(error) {
            showError(_('error_saving_color') + ' ' + error.message);
        });
    }, [
        tagName,
        showError,
        _
    ]);
    var category = tag === null ? 'all' : "tag-".concat(tag.tag);
    var location = (0, $0386ffc241ff4f20$export$45d76561a5302f2b)();
    var link = (0, $eHaBZ.useMemo)(function() {
        return (0, $3d1fd3a25027abce$export$d0bb2ab5375d1521)(location, {
            category: category,
            id: null
        });
    }, [
        category,
        location
    ]);
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("li", {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            read: tag !== null && tag.unread === 0
        }),
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
            to: link,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                'nav-tags-all': tag === null,
                active: active
            }),
            onClick: collapseNav,
            state: forceReload,
            children: tag === null ? _('alltags') : /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "tag",
                        children: (0, $4c0cf5d996e33977$export$e8bacd2802a88316)(tag.tag)
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                        className: "unread",
                        children: tag.unread > 0 ? tag.unread : ''
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $bbb16a994e9968fe$export$2e2bcd8739ae039), {
                        tag: tag,
                        onChange: colorChanged
                    })
                ]
            })
        })
    });
}
function $e4b2796b76a042de$export$2e2bcd8739ae039(props) {
    var _params_category;
    var setNavExpanded = props.setNavExpanded, tags = props.tags, showError = props.showError;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(true), 2), expanded = _useState[0], setExpanded = _useState[1];
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    var currentAllTags = (params === null || params === void 0 ? void 0 : params.category) === 'all';
    var currentTag = (params === null || params === void 0 ? void 0 : (_params_category = params.category) === null || _params_category === void 0 ? void 0 : _params_category.startsWith('tag-')) ? params.category.replace(/^tag-/, '') : null;
    var toggleExpanded = (0, $eHaBZ.useCallback)(function() {
        return setExpanded(function(expanded) {
            return !expanded;
        });
    }, []);
    var collapseNav = (0, $eHaBZ.useCallback)(function() {
        return setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("button", {
                    type: "button",
                    id: "nav-tags-title",
                    className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                        'nav-section-toggle': true,
                        'nav-tags-collapsed': !expanded,
                        'nav-tags-expanded': expanded
                    }),
                    "aria-expanded": expanded,
                    onClick: toggleExpanded,
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                            icon: expanded ? $843ec70749747e2a$exports.faCaretDown : $809575f3b9653d01$exports.faCaretRight,
                            size: "lg",
                            fixedWidth: true
                        }),
                        ' ',
                        _('tags')
                    ]
                })
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                isOpen: expanded,
                className: "collapse-css-transition",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("ul", {
                    id: "nav-tags",
                    "aria-labelledby": "nav-tags-title",
                    children: [
                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e4b2796b76a042de$var$Tag, {
                            tag: null,
                            active: currentAllTags,
                            collapseNav: collapseNav,
                            showError: showError
                        }),
                        tags.map(function(tag) {
                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($e4b2796b76a042de$var$Tag, {
                                tag: tag,
                                active: currentTag === tag.tag,
                                collapseNav: collapseNav,
                                showError: showError
                            }, tag.tag);
                        })
                    ]
                })
            })
        ]
    });
}



var $21h22 = parcelRequire("21h22");


var $eHaBZ = parcelRequire("eHaBZ");








function $8aeda117ea69d02c$var$handleReloadAll(param) {
    var reloadAll = param.reloadAll, setReloading = param.setReloading, setNavExpanded = param.setNavExpanded;
    setReloading(true);
    reloadAll().finally(function() {
        setNavExpanded(false);
        setReloading(false);
    });
}
function $8aeda117ea69d02c$var$handleLogOut(param) {
    var setNavExpanded = param.setNavExpanded;
    // only loggedin users
    if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).hasSession() || !(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isOnline()) return;
    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.clear();
    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).logout();
    setNavExpanded(false);
}
function $8aeda117ea69d02c$export$2e2bcd8739ae039(props) {
    var reloadAll = props.reloadAll, setNavExpanded = props.setNavExpanded;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), reloading = _useState[0], setReloading = _useState[1];
    var forceReload = (0, $3d1fd3a25027abce$export$6bccca1b7088ecd7)();
    var refreshOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8aeda117ea69d02c$var$handleReloadAll({
            reloadAll: reloadAll,
            setReloading: setReloading,
            setNavExpanded: setNavExpanded
        });
    }, [
        reloadAll,
        setNavExpanded
    ]);
    var settingsOnClick = (0, $eHaBZ.useCallback)(function() {
        setNavExpanded(false);
    }, [
        setNavExpanded
    ]);
    var logoutOnClick = (0, $eHaBZ.useCallback)(function() {
        return $8aeda117ea69d02c$var$handleLogOut({
            setNavExpanded: setNavExpanded
        });
    }, [
        setNavExpanded
    ]);
    var isLoggedIn = (0, $afaa653977073dac$export$3b062b02b4537682)();
    var canRefreshAll = (0, $afaa653977073dac$export$683005ba76038aff)();
    var canVisitSettings = (0, $afaa653977073dac$export$b416b77cd328c02f)();
    var canLogOut = isLoggedIn;
    var configuration = (0, $eHaBZ.use)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e));
    var canLogIn = !isLoggedIn && configuration.authEnabled;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        className: "nav-toolbar",
        children: [
            canRefreshAll && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-refresh",
                title: _('refreshbutton'),
                "aria-label": _('refreshbutton'),
                accessKey: "r",
                onClick: refreshOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $468e6f5287149412$exports.faSyncAlt,
                    fixedWidth: true,
                    spin: reloading
                })
            }),
            canVisitSettings && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                id: "nav-settings",
                title: _('settingsbutton'),
                "aria-label": _('settingsbutton'),
                accessKey: "t",
                to: "/manage/sources",
                onClick: settingsOnClick,
                state: forceReload,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $78546ca20d789f8c$exports.faCloudUploadAlt,
                    fixedWidth: true
                })
            }),
            canLogOut && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                id: "nav-logout",
                title: _('logoutbutton'),
                "aria-label": _('logoutbutton'),
                accessKey: "l",
                onClick: logoutOnClick,
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $17ddfe677f5b40f7$exports.faSignOutAlt,
                    fixedWidth: true
                })
            }),
            canLogIn && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                id: "nav-login",
                title: _('loginbutton'),
                "aria-label": _('loginbutton'),
                accessKey: "l",
                to: "/sign/in",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $5a270b3b7e6b7fa8$exports.faKey,
                    fixedWidth: true
                })
            })
        ]
    });
}







function $b2eaf2bd11c6300f$export$2e2bcd8739ae039(props) {
    var entriesPage = props.entriesPage, setNavExpanded = props.setNavExpanded, navSourcesExpanded = props.navSourcesExpanded, setNavSourcesExpanded = props.setNavSourcesExpanded, offlineState = props.offlineState, allItemsCount = props.allItemsCount, allItemsOfflineCount = props.allItemsOfflineCount, unreadItemsCount = props.unreadItemsCount, unreadItemsOfflineCount = props.unreadItemsOfflineCount, starredItemsCount = props.starredItemsCount, starredItemsOfflineCount = props.starredItemsOfflineCount, sourcesState = props.sourcesState, setSourcesState = props.setSourcesState, sources = props.sources, setSources = props.setSources, tags = props.tags, reloadAll = props.reloadAll, showError = props.showError;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var canWrite = (0, $afaa653977073dac$export$b416b77cd328c02f)();
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var queryString = new URLSearchParams(location.search);
    var _queryString_get;
    var initialSearchText = (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                id: "nav-logo"
            }),
            canWrite && /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                accessKey: "a",
                id: "nav-mark",
                onClick: entriesPage !== null ? entriesPage.markVisibleRead : null,
                disabled: entriesPage === null,
                children: _('markread')
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $1f901eab4509cd0f$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                allItemsCount: allItemsCount,
                allItemsOfflineCount: allItemsOfflineCount,
                unreadItemsCount: unreadItemsCount,
                unreadItemsOfflineCount: unreadItemsOfflineCount,
                starredItemsCount: starredItemsCount,
                starredItemsOfflineCount: starredItemsOfflineCount
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'nav-ts-wrapper': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e4b2796b76a042de$export$2e2bcd8739ae039), {
                        tags: tags,
                        setNavExpanded: setNavExpanded,
                        showError: showError
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $22ff3a11d092d484$export$2e2bcd8739ae039), {
                        setNavExpanded: setNavExpanded,
                        navSourcesExpanded: navSourcesExpanded,
                        setNavSourcesExpanded: setNavSourcesExpanded,
                        sourcesState: sourcesState,
                        setSourcesState: setSourcesState,
                        sources: sources,
                        setSources: setSources,
                        showError: showError
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                    'nav-unavailable': true,
                    offline: offlineState,
                    online: !offlineState
                }),
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("span", {
                        className: "fa-layers fa-2x",
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                icon: $37a500ad1dcc914a$exports.faWifi
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                icon: $c0ffe79f8008445d$exports.faSlash
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
                        children: _('offline_navigation_unavailable')
                    })
                ]
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                className: "separator",
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("hr", {})
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $cb22cb1150729cae$export$2e2bcd8739ae039), {
                setNavExpanded: setNavExpanded,
                offlineState: offlineState,
                initialSearchText: initialSearchText
            }, initialSearchText),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8aeda117ea69d02c$export$2e2bcd8739ae039), {
                reloadAll: reloadAll,
                setNavExpanded: setNavExpanded
            })
        ]
    });
}




var $eHaBZ = parcelRequire("eHaBZ");





function $d7222e1328a07ffe$var$splitTerm(term) {
    if (term == '') return [];
    else if (term.match(/^\/.+\/$/)) return [
        term
    ];
    var words = term.match(/"[^"]+"|\S+/g);
    for(var i = 0; i < words.length; i++)words[i] = words[i].replace(/"/g, '');
    return words;
}
function $d7222e1328a07ffe$var$joinTerm(words) {
    if (!words || words.length <= 0) return '';
    for(var i = 0; i < words.length; i++)if (words[i].indexOf(' ') >= 0) words[i] = '"' + words[i] + '"';
    return words.join(' ');
}
// remove search term
function $d7222e1328a07ffe$var$handleRemove(param) {
    var index = param.index, location = param.location, navigate = param.navigate, regexSearch = param.regexSearch;
    var newterm;
    if (regexSearch) newterm = '';
    else {
        var queryString = new URLSearchParams(location.search);
        var oldTerm = queryString.get('search');
        var termArray = $d7222e1328a07ffe$var$splitTerm(oldTerm);
        termArray.splice(index, 1);
        newterm = $d7222e1328a07ffe$var$joinTerm(termArray);
    }
    navigate((0, $3d1fd3a25027abce$export$7f0beea2aa79e4fa)(location, {
        search: newterm,
        id: null
    }));
}
function $d7222e1328a07ffe$var$SearchWord(props) {
    var regexSearch = props.regexSearch, index = props.index, item = props.item;
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var removeOnClick = (0, $eHaBZ.useCallback)(function() {
        return $d7222e1328a07ffe$var$handleRemove({
            index: index,
            location: location,
            navigate: navigate,
            regexSearch: regexSearch
        });
    }, [
        index,
        location,
        navigate,
        regexSearch
    ]);
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("li", {
        onClick: removeOnClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            'regex-search-term': regexSearch
        }),
        children: [
            item,
            " ",
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                icon: $6c06a95c587730ec$exports.faTimes
            })
        ]
    });
}
function $d7222e1328a07ffe$export$2e2bcd8739ae039() {
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var searchText = (0, $eHaBZ.useMemo)(function() {
        var queryString = new URLSearchParams(location.search);
        var _queryString_get;
        return (_queryString_get = queryString.get('search')) !== null && _queryString_get !== void 0 ? _queryString_get : '';
    }, [
        location.search
    ]);
    var regexSearch = searchText.match(/^\/.+\/$/) !== null;
    var terms = regexSearch ? [
        searchText
    ] : $d7222e1328a07ffe$var$splitTerm(searchText);
    return terms.map(function(item, index) {
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($d7222e1328a07ffe$var$SearchWord, {
            index: index,
            item: item,
            regexSearch: regexSearch
        }, index);
    });
}



var $21h22 = parcelRequire("21h22");
//#region src/tinykeys.ts
/**
* These are the modifier keys that change the meaning of keybindings.
*
* Note: Ignoring "AltGraph" because it is covered by the others.
*/ 
var $21h22 = parcelRequire("21h22");

var $ggKxj = parcelRequire("ggKxj");

var $2bfPH = parcelRequire("2bfPH");
var $3ef3f1ab55e45c99$var$KEYBINDING_MODIFIER_KEYS = [
    "Shift",
    "Meta",
    "Alt",
    "Control"
];
/**
* Keybinding sequences should timeout if individual key presses are more than
* 1s apart by default.
*/ var $3ef3f1ab55e45c99$var$DEFAULT_TIMEOUT = 1e3;
/**
* Keybinding sequences should bind to this event by default.
*/ var $3ef3f1ab55e45c99$var$DEFAULT_EVENT = "keydown";
/**
* Platform detection code.
* @see https://github.com/jamiebuilds/tinykeys/issues/184
*/ var $3ef3f1ab55e45c99$var$PLATFORM = (typeof navigator === "undefined" ? "undefined" : (0, $2bfPH._)(navigator)) === "object" ? navigator.platform : "";
/**
* An alias for creating platform-specific keybinding aliases.
*/ var $3ef3f1ab55e45c99$var$MOD = /Mac|iPod|iPhone|iPad/.test($3ef3f1ab55e45c99$var$PLATFORM) ? "Meta" : "Control";
/**
* Meaning of `AltGraph`, from MDN:
* - Windows: Both Alt and Ctrl keys are pressed, or AltGr key is pressed
* - Mac: ⌥ Option key pressed
* - Linux: Level 3 Shift key (or Level 5 Shift key) pressed
* - Android: Not supported
* @see https://github.com/jamiebuilds/tinykeys/issues/185
*/ var $3ef3f1ab55e45c99$var$ALT_GRAPH_ALIASES = $3ef3f1ab55e45c99$var$PLATFORM === "Win32" ? [
    "Control",
    "Alt"
] : [
    "Alt"
];
/**
* Ensure and stop any event that isn't a full keyboard event.
* Autocomplete option navigation and selection would fire an Event,
* instead of the expected KeyboardEvent
*/ function $3ef3f1ab55e45c99$var$isKeyboardEvent(event) {
    return !!(event.key && event.code && event.getModifierState);
}
/**
* Ignores keyboard events from contenteditable and form elements unless they
* are the current target.
*/ function $3ef3f1ab55e45c99$export$9539c749efdac4b5(event) {
    var target = event.target;
    return event.repeat || event.isComposing || target !== event.currentTarget && target.matches("[contenteditable],input,select,textarea");
}
/**
* There's a bug in Chrome that causes event.getModifierState not to exist on
* KeyboardEvent's for F1/F2/etc keys.
*/ function $3ef3f1ab55e45c99$var$getModifierState(event, mod) {
    return typeof event.getModifierState === "function" ? event.getModifierState(mod) || $3ef3f1ab55e45c99$var$ALT_GRAPH_ALIASES.includes(mod) && event.getModifierState("AltGraph") : false;
}
/**
* Parses a keybinding string into its parts.
*
* ```
* grammar    = `<sequence>`
* <sequence> = `<press> <press> <press> ...`
* <press>    = `<key>` or `<mods>+<key>`
* <mods>     = `<mod>+<mod>+...`
* <mod>      = `<modifier>` (required) or `[<modifier>]` (optional)
* <key>      = `<KeyboardEvent.key>` or `<KeyboardEvent.code>` (case-insensitive)
* <key>      = `(<regex>)` -> `/^(?:<regex>)$/iy` (case-insensitive)
* ```
*/ function $3ef3f1ab55e45c99$export$d0b30d424c95c5e9(str) {
    return str.trim().split(" ").map(function(press) {
        var parts = press.split(RegExp("(?<=\\w|\\])\\+"));
        var last = parts.pop();
        var regex = last.match(/^\((.+)\)$/);
        var key = regex ? new RegExp("^(?:".concat(regex[1], ")$"), "iv") : last;
        var requiredModifiers = [];
        var optionalModifiers = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = parts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var part = _step.value;
                var optional = part.match(/^\[(.*)\]$/);
                var _optional_;
                var mod = (_optional_ = optional === null || optional === void 0 ? void 0 : optional[1]) !== null && _optional_ !== void 0 ? _optional_ : part;
                mod = mod === "$mod" ? $3ef3f1ab55e45c99$var$MOD : mod;
                if (optional) optionalModifiers.push(mod);
                else requiredModifiers.push(mod);
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        return [
            requiredModifiers,
            optionalModifiers,
            key
        ];
    });
}
/**
* This tells us if a single keyboard event matches a single keybinding press.
*/ function $3ef3f1ab55e45c99$export$4bb3a1fe83138634(event, param) {
    var _param = (0, $21h22._)(param, 3), requiredModifiers = _param[0], optionalModifiers = _param[1], key = _param[2];
    var hasAltGraph = requiredModifiers.includes("AltGraph");
    return !((key instanceof RegExp ? !(key.test(event.key) || key.test(event.code)) : key.toUpperCase() !== event.key.toUpperCase() && key !== event.code) || requiredModifiers.find(function(mod) {
        return !$3ef3f1ab55e45c99$var$getModifierState(event, mod);
    }) || $3ef3f1ab55e45c99$var$KEYBINDING_MODIFIER_KEYS.find(function(mod) {
        return !requiredModifiers.includes(mod) && !optionalModifiers.includes(mod) && key !== mod && $3ef3f1ab55e45c99$var$getModifierState(event, mod) && !(hasAltGraph && $3ef3f1ab55e45c99$var$ALT_GRAPH_ALIASES.includes(mod));
    }));
}
/**
* Creates an event listener for handling keybindings.
*
* @example
* ```js
* import { createKeybindingsHandler } from "../src/keybindings"
*
* let handler = createKeybindingsHandler({
* 	"Shift+d": () => {
* 		alert("The 'Shift' and 'd' keys were pressed at the same time")
* 	},
* 	"y e e t": () => {
* 		alert("The keys 'y', 'e', 'e', and 't' were pressed in order")
* 	},
* 	"$mod+d": () => {
* 		alert("Either 'Control+d' or 'Meta+d' were pressed")
* 	},
* })
*
* window.addEventListener("keydown", handler)
* ```
*/ function $3ef3f1ab55e45c99$export$a3db0ee43d16bb47(keybindingsMap) {
    var options = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    var _options_timeout;
    var timeout = (_options_timeout = options.timeout) !== null && _options_timeout !== void 0 ? _options_timeout : $3ef3f1ab55e45c99$var$DEFAULT_TIMEOUT;
    var _options_ignore;
    var ignore = (_options_ignore = options.ignore) !== null && _options_ignore !== void 0 ? _options_ignore : $3ef3f1ab55e45c99$export$9539c749efdac4b5;
    var keybindings = Object.keys(keybindingsMap).map(function(input) {
        return [
            input,
            $3ef3f1ab55e45c99$export$d0b30d424c95c5e9(input),
            keybindingsMap[input]
        ];
    });
    var pending = /* @__PURE__ */ new Map();
    var timer = null;
    return function(event) {
        if (!$3ef3f1ab55e45c99$var$isKeyboardEvent(event) || ignore(event)) return;
        var conflicts = [];
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = keybindings[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var _step_value = (0, $21h22._)(_step.value, 3), input = _step_value[0], sequence = _step_value[1], handler = _step_value[2];
                var prev = pending.get(input);
                var _ref = (0, $ggKxj._)(prev ? prev : sequence), current = _ref[0], rest = _ref.slice(1);
                if (!$3ef3f1ab55e45c99$export$4bb3a1fe83138634(event, current)) {
                    if (!$3ef3f1ab55e45c99$var$getModifierState(event, event.key)) pending.delete(input);
                } else if (rest.length > 0) {
                    pending.set(input, rest);
                    conflicts.push(input);
                } else {
                    pending.delete(input);
                    if (conflicts.length) console.warn('tinykeys: Conflict found, "'.concat(input, '" did not fire, waiting for:'), conflicts);
                    else {
                        handler(event);
                        break;
                    }
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
        if (timer) clearTimeout(timer);
        timer = setTimeout(function() {
            return pending.clear();
        }, timeout);
    };
}
/**
* Subscribes to keybindings.
*
* Returns an unsubscribe method.
*
* @example
* ```js
* import { tinykeys } from "../src/tinykeys"
*
* tinykeys(window, {
* 	"Shift+d": () => {
* 		alert("The 'Shift' and 'd' keys were pressed at the same time")
* 	},
* 	"y e e t": () => {
* 		alert("The keys 'y', 'e', 'e', and 't' were pressed in order")
* 	},
* 	"$mod+d": () => {
* 		alert("Either 'Control+d' or 'Meta+d' were pressed")
* 	},
* })
* ```
*/ function $3ef3f1ab55e45c99$export$6fc42dca60e28416(target, keybindingMap) {
    var options = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {};
    var _options_event;
    var event = (_options_event = options.event) !== null && _options_event !== void 0 ? _options_event : $3ef3f1ab55e45c99$var$DEFAULT_EVENT;
    var onKeyEvent = $3ef3f1ab55e45c99$export$a3db0ee43d16bb47(keybindingMap, options);
    target.addEventListener(event, onKeyEvent, options.capture);
    return function() {
        target.removeEventListener(event, onKeyEvent, options.capture);
    };
}




/**
 * Decorates an event handler so that it only runs
 * when not interacting with an input field or lightbox.
 */ function $7b7d7b033768f390$var$ignoreWhenInteracting(handler, ignoreDialog) {
    return function(event) {
        if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).lightboxActive.value) return;
        else if (ignoreDialog && ignoreDialog.current.open) return;
        handler(event);
    };
}
var $7b7d7b033768f390$export$9784374fba94ce79 = {
    Space: {
        description: 'select and open next entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.jumpToNext();
        }
    },
    n: {
        description: 'select next entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT, false);
        }
    },
    Arrowright: {
        readableName: "\u2192",
        description: 'select next entry (and open it when the current is open)',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT);
        }
    },
    j: {
        description: 'select and open next entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT, true);
        }
    },
    'Shift+Space': {
        description: 'select and open previous entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV, true);
        }
    },
    p: {
        description: 'select previous entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV, false);
        }
    },
    ArrowLeft: {
        readableName: "\u2190",
        description: 'select previous entry (and open it when the current is open)',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.entryNav((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV);
        }
    },
    k: {
        description: 'select and open previous entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.nextPrev((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV, true);
        }
    },
    s: {
        description: 'mark and unmark current selected entry as starred/unstarred',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedStarred();
        }
    },
    m: {
        description: 'mark and unmark current selected entry as read/unread',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedRead();
        }
    },
    'Control+m': {
        description: 'mark all as read',
        action: function() {
            document.querySelector('#nav-mark').click();
        }
    },
    o: {
        description: 'open / close current entry',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.toggleSelectedExpanded();
        }
    },
    'Shift+o': {
        description: 'close all open entries',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.collapseAllEntries();
        }
    },
    v: {
        description: 'open url of current entry in new tab/window',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTarget();
        }
    },
    'Shift+v': {
        description: 'open url of current entry in new tab/window and mark read',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.openSelectedTargetAndMarkRead();
        }
    },
    r: {
        description: 'reload the list',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
        }
    },
    'Shift+r': {
        description: 'refresh sources',
        action: function() {
            document.querySelector('#nav-refresh').click();
        }
    },
    t: {
        description: 'throw current entry to next (mark as read & open next)',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).NEXT);
        }
    },
    'Shift+t': {
        description: 'throw current entry to previous (mark as read & open previous)',
        action: function() {
            var _selfoss_entriesPage;
            (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.throw((0, $fc181d02c22cdede$export$cacd6541cfeeb6c1).PREV);
        }
    },
    'Shift+n': {
        description: 'open newest entries page',
        action: function() {
            document.querySelector('#nav-filter-newest').click();
        }
    },
    'Shift+u': {
        description: 'open unread entries page',
        action: function() {
            document.querySelector('#nav-filter-unread').click();
        }
    },
    'Shift+s': {
        description: 'open starred entries page',
        action: function() {
            document.querySelector('#nav-filter-starred').click();
        }
    },
    '[Shift]+?': {
        readableName: '?',
        description: 'show help',
        action: function() {}
    }
};
function $7b7d7b033768f390$var$makeKeybindingsMap(shortcutsDialog) {
    var shortcuts = Object.entries($7b7d7b033768f390$export$9784374fba94ce79);
    var keybindingsMap = {};
    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
    try {
        var _loop = function() {
            var _step_value = (0, $21h22._)(_step.value, 2), keycombo = _step_value[0], keybind = _step_value[1];
            if (keycombo === '[Shift]+?') keybindingsMap[keycombo] = $7b7d7b033768f390$var$ignoreWhenInteracting(function(event) {
                event.preventDefault();
                if (shortcutsDialog.current.open) shortcutsDialog.current.close();
                else shortcutsDialog.current.showModal();
            });
            else keybindingsMap[keycombo] = $7b7d7b033768f390$var$ignoreWhenInteracting(function(event) {
                event.preventDefault();
                keybind.action(event);
            }, shortcutsDialog);
        };
        for(var _iterator = shortcuts[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
    } catch (err) {
        _didIteratorError = true;
        _iteratorError = err;
    } finally{
        try {
            if (!_iteratorNormalCompletion && _iterator.return != null) {
                _iterator.return();
            }
        } finally{
            if (_didIteratorError) {
                throw _iteratorError;
            }
        }
    }
    return keybindingsMap;
}
function $7b7d7b033768f390$export$2e2bcd8739ae039(shortcutsDialog) {
    return (0, $3ef3f1ab55e45c99$export$6fc42dca60e28416)(window, $7b7d7b033768f390$var$makeKeybindingsMap(shortcutsDialog));
}









// Unfortunately we need to declare everything manually for Parcel to pick those up.
var $3109e67d2d012138$exports = {};
$3109e67d2d012138$exports = JSON.parse('{"markread":"Marca com llegit","filter":"Filtre","newest":"Nous","unread":"Per llegir","starred":"Preferits","online_count":"Elements disponibles al servidor","offline_count":"Elements disponibles localment","tags":"Etiquetes","alltags":"Totes les etiquetes","timestamp":"{0,date} {0,time}","hours":"fa {0,plural,one {1 hora},other {# hores}}","minutes":"fa {0,plural,one {1 minut},other {# minuts}}","seconds":"fa {0,plural,one {1 segon},other {# segons}}","days":"{0,plural,zero {avui},one {ahir},other {fa # dies}}","star":"Preferit","unstar":"Ja no ho prefereixo","mark":"Marca com llegit","unmark":"Marca com no llegit","load_img":"Mostra les imatges","open_window":"Obre","next":"Seg\xfcent","searchbutton":"Cerca","searchremove":"Amaga la cerca","refreshbutton":"Actualitza les fonts","settingsbutton":"Configuraci\xf3","logoutbutton":"Finalitza la sessi\xf3","loginbutton":"Inicia una sessi\xf3","sources":"Fonts","source_add":"Afegeix una font","source_opml":"o importa des d\'un fitxer opml o des del Google Reader (fins al 15 de juliol de 2013)","source_export":"Exporta les fonts","source_edit":"Edita","source_filter":"Filtra","source_delete":"Esborra","source_warn":"Segur que voleu esborrar la font?","source_new":"Nova font per desar","source_title":"T\xedtol","source_autotitle_hint":"Deixa en blanc per a obtindre el t\xedtol","source_tags":"Etiquetes","source_pwd_placeholder":"No ha canviat","source_comma":"Separat per comes","source_select":"Seleccioneu una font","source_type":"Tipus","source_save":"Desa","source_cancel":"Cancel\xb7la","source_saved":"Desat","source_last_post":"\xdaltima entrada vista","source_refresh":"Actualitza aquesta font","no_entries":"No es van trobar entrades","more":"M\xe9s","login":"Inicia una sessi\xf3","login_username":"Nom d\'usuari","login_password":"Contrasenya","login_invalid_credentials":"Nom d\'usuari o contrasenya incorrectes","login_offline":"Emmagatzematge fora de l\xednia","no_title":"Sense t\xedtol","error":"S\'ha produ\xeft un error","streamerror":"No hi ha cap element carregat. Es recarrega?","reload_list":"Recarrega la llista","sources_refreshed":"S\'han actualitzat les fonts","app_update":"selfoss s\'ha actualitzat, torneu a carregar","app_reload":"Recarrega","error_session_expired":"La sessi\xf3 ha expirat","error_add_source":"No s\'ha pogut afegir la font:","error_delete_source":"No s\'ha pogut esborrar la font:","error_load_tags":"No s\'han pogut carregar les etiquetes:","error_unknown_tag":"Etiqueta desconeguda:","error_unknown_source":"Id de font desconeguda:","error_mark_items":"No s\'han pogut marcar tots els elements visibles:","error_mark_item":"No s\'ha pogut marcar/desmarcar element:","error_star_item":"No s\'ha pogut preferir/despreferir l\'element:","error_logout":"No s\'ha pogut finalitzar la sessi\xf3:","error_loading":"Error de c\xe0rrega:","error_loading_stats":"No s\'han pogut carregar les estad\xedstiques de navegaci\xf3:","error_saving_color":"No s\'ha pogut desar el nou color:","error_refreshing_source":"No s\'han pogut refrescar fonts:","error_sync":"No s\'han pogut sincronitzar els \xfaltims canvis del servidor:","error_offline_storage":"Error d\'emmagatzematge fora de l\xednia: {0}. Recarregar pot ajudar. Es desactiva l\'\xfas fora de l\xednia per ara.","error_invalid_subsection":"Subsecci\xf3 inv\xe0lida:","search_label":"Terme de cerca","article_actions":"Accions","error_configuration":"No es pot carregar la configuraci\xf3.","info_url_copied":"S\'ha copiat l\'URL al portaretalls.","share_native_label":"Comparteix","share_diaspora_label":"Comparteix a Diaspora","share_twitter_label":"Comparteix al Twitter","share_facebook_label":"Comparteix al Facebook","share_pocket_label":"Desa a Pocket","share_wallabag_label":"Desa a Wallabag","share_wordpress_label":"Comparteix a WordPress","share_mail_label":"Comparteix per correu electr\xf2nic","share_copy_label":"Copia l\'enlla\xe7 al portaretalls","error_share_native_abort":"No es pot compartir l\'element\u2014o no hi ha destinacions de compartici\xf3, o ho heu cancel\xb7lat.","error_share_native":"No es pot compartir l\'element.","close_entry":"Tanca","error_unwritable_logs":"No es poden escriure els registres.","error_check_system_logs":"S\'ha produ\xeft un error. Comproveu els registres del sistema.","error_check_log_file":"S\'ha produ\xeft un error. Comprova el fitxer de registre \u201C{0}\u201D.","offline_navigation_unavailable":"Canviar etiquetes i fonts no \xe9s disponible en el mode fora de l\xednia.","error_offline_storage_not_available":"Emmagatzematge fora de l\xednia no disponible. Assegureu-vos que el navegador {0}suporta IndexedDB API{1}. Si utilitzeu un navegador basat en Google Chrome, que no estigueu utilitzant selfoss en mode inc\xf2gnit.","error_edit_source":"No es pot desar els canvis a les fonts:","article_reading_time":"{0} min lectura","experimental":"Experimental","source_menu":"M\xe9s accions","source_browse":"Navega","sources_leaving_unsaved_prompt":"Voleu deixar la configuraci\xf3 amb els canvis de font no desats?","source_warn_cancel_dirty":"Vols descartar els canvis no desats?","tag_change_color_button_title":"Canvia el color","sources_loading":"S\'estan carregant les fonts\u2026","source_deleting":"S\'est\xe0 suprimint la font\u2026","source_params_loading":"S\'estan carregant els par\xe0metres\u2026","no_sources":"No hi ha fonts configurades.","source_saving":"S\'estan desant els canvis a la font\u2026","source_go_to_settings":"Obre a la configuraci\xf3","entries_loading":"S\'estan carregant les entrades\u2026","login_in_progress":"S\'est\xe0 intentant iniciar sessi\xf3\u2026","login_error_generic":"No s\'ha pogut iniciar sessi\xf3: {errorMessage}","error_unauthorized":"Si us plau, {link_begin}inicieu sessi\xf3{link_end} per a continuar.","share_mastodon_label":"Comparteix a Mastodon"}');


var $3f89fcb2517a5831$exports = {};
$3f89fcb2517a5831$exports = JSON.parse('{"markread":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","filter":"Zobrazovat","newest":"Nejnov\u011Bj\u0161\xed","unread":"Nep\u0159e\u010Dten\xe9","starred":"Ozna\u010Den\xe9","tags":"\u0160t\xedtky","alltags":"V\u0161echny \u0161t\xedtky","timestamp":"{0,date} {0,time}","hours":"p\u0159ed {0,plural,one {1 hodinou},other {# hodinami}}","minutes":"p\u0159ed {0,plural,one {1 minutou},other {# minutami}}","seconds":"p\u0159ed {0,plural,one {chv\xedl\xed},other {# sekundami}}","days":"{0,plural,zero {dnes},one {v\u010Dera},other {p\u0159ed # dny}}","star":"Ozna\u010Dit","unstar":"Odzna\u010Dit","mark":"Ozna\u010Dit jako p\u0159e\u010Dten\xe9","unmark":"Ozna\u010Dit jako nep\u0159e\u010Dten\xe9","load_img":"Zobrazit obr\xe1zky","open_window":"Otev\u0159\xedt","next":"Dal\u0161\xed","search_label":"Vyhled\xe1van\xfd text","searchbutton":"Hledat","searchremove":"Skr\xfdt hled\xe1n\xed","refreshbutton":"Obnovit zdroje","settingsbutton":"Nastaven\xed","logoutbutton":"Odhl\xe1sit se","loginbutton":"P\u0159ihl\xe1sit se","sources":"Zdroje","sources_loading":"Na\u010D\xedt\xe1n\xed zdroj\u016F\u2026","no_sources":"Nejsou nastaveny \u017E\xe1dn\xe9 zdroje.","source_add":"P\u0159idat zdroj","source_opml":"nebo nahr\xe1t opml soubor","source_export":"Export zdroj\u016F","source_edit":"Upravit","source_filter":"Filtr","source_menu":"V\xedce akc\xed","source_browse":"Prohl\xed\u017Eet","source_delete":"Smazat","source_warn":"Opravdu chcete tento zdroj smazat?","source_deleting":"Maz\xe1n\xed zdroje\u2026","source_warn_cancel_dirty":"Opravdu chcete zahodit neulo\u017Een\xe9 zm\u011Bny?","source_new":"Nov\xfd neulo\u017Een\xfd zdroj","source_title":"N\xe1zev","source_autotitle_hint":"Pro automatick\xe9 vypln\u011Bn\xed ponechte pr\xe1zdn\xe9","source_tags":"\u0160t\xedtky","source_pwd_placeholder":"Beze zm\u011Bny","source_comma":"Odd\u011Blen\xe9 \u010D\xe1rkou","source_select":"Vyberte pros\xedm zdroj","source_params_loading":"Na\u010D\xedt\xe1n\xed parametr\u016F\u2026","source_type":"Typ","source_save":"Ulo\u017Eit","source_cancel":"Zru\u0161it","source_saving":"Ukl\xe1d\xe1n\xed zm\u011Bn zdroje\u2026","source_saved":"Ulo\u017Eeno","source_last_post":"Posledn\xed p\u0159\xedsp\u011Bvek spat\u0159en","source_refresh":"Obnovit tento zdroj","source_go_to_settings":"Otev\u0159\xedt v\xa0nastaven\xed","sources_leaving_unsaved_prompt":"Na str\xe1nce jsou neulo\u017Een\xe9 zm\u011Bny. Opravdu chcete opustit nastaven\xed?","tag_change_color_button_title":"Zm\u011Bnit barvu","entries_loading":"Na\u010D\xedt\xe1n\xed z\xe1znam\u016F\u2026","no_entries":"\u017D\xe1dn\xfd z\xe1znam","more":"V\xedce","login":"P\u0159ihl\xe1sit","login_in_progress":"P\u0159ihla\u0161ov\xe1n\xed\u2026","login_username":"Jm\xe9no","login_password":"Heslo","login_invalid_credentials":"\u0160patn\xe9 jm\xe9no nebo heslo","login_error_generic":"Pokus o p\u0159ihl\xe1\u0161en\xed selhal: {errorMessage}","no_title":"Bez titulku","error":"Nastala chyba","error_unauthorized":"Pro pokra\u010Dov\xe1n\xed se pros\xedm {link_begin}p\u0159ihlaste{link_end}.","error_check_log_file":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0souboru \u201E{0}\u201C.","error_check_system_logs":"Nastala chyba, zkontrolujte pros\xedm z\xe1znamy v\xa0opera\u010Dn\xedm syst\xe9mu.","error_unwritable_logs":"Nebylo mo\u017En\xe9 zaznamenat chybu.","streamerror":"Nena\u010Dteny \u017E\xe1dn\xe9 polo\u017Eky, zkusit znovu?","reload_list":"Znovu na\u010D\xedst seznam","sources_refreshed":"Zdroje byly obnoveny","error_session_expired":"Va\u0161e sezen\xed vypr\u0161elo","error_add_source":"Zdroj nemohl b\xfdt p\u0159id\xe1n:","error_delete_source":"Zdroj nemohl b\xfdt smaz\xe1n:","error_load_tags":"\u0160t\xedtky nemohly b\xfdt na\u010Dteny:","error_unknown_tag":"Nezn\xe1m\xfd \u0161t\xedtek:","error_unknown_source":"Nezn\xe1m\xe9 id zdroje:","error_mark_items":"Nelze ozna\u010Dit v\u0161echny viditeln\xe9 zdroje:","error_mark_item":"Nelze ozna\u010Dit polo\u017Eku za (ne)p\u0159e\u010Dtenou:","error_star_item":"Nelze o(d)zna\u010Dit polo\u017Eku hv\u011Bzdi\u010Dkou:","error_logout":"Odhl\xe1\u0161en\xed se nezda\u0159ilo:","error_loading":"Chyba na\u010D\xedt\xe1n\xed:","error_loading_stats":"Na\u010D\xedt\xe1n\xed statistik se nezda\u0159ilo:","error_saving_color":"Nelze zm\u011Bnit barvu:","error_refreshing_source":"Nelze obnovit zdroje:","error_sync":"Synchronizace zm\u011Bn ze serveru selhala:","error_invalid_subsection":"Podsekce neexistuje:","online_count":"Polo\u017Eky dostupn\xe9 na serveru","offline_count":"Polo\u017Eky jsou dostupn\xe9 v prohl\xed\u017Ee\u010Di","offline_navigation_unavailable":"Offline re\u017Eim zat\xedm neumo\u017E\u0148uje p\u0159ep\xednat mezi \u0161t\xedtky a zdroji.","login_offline":"Ukl\xe1dat data v prohl\xed\u017Ee\u010Di","app_update":"selfoss byl aktualizov\xe1n, pros\xedm znovu na\u010Dt\u011Bte str\xe1nku","app_reload":"Znovu na\u010D\xedst","error_offline_storage":"Chyba lok\xe1ln\xedho \xfalo\u017Ei\u0161t\u011B: {0}. Mo\u017En\xe1 pom\u016F\u017Ee znovuna\u010Dten\xed str\xe1nky. Prozat\xedm bude ukl\xe1d\xe1n\xed vypnuto.","article_actions":"Akce","error_configuration":"Nelze na\u010D\xedst konfiguraci.","share_native_label":"Sd\xedlet","share_diaspora_label":"Sd\xedlet na Diaspo\u0159e","share_twitter_label":"Sd\xedlet na Twitteru","share_facebook_label":"Sd\xedlet na Facebooku","share_pocket_label":"Ulo\u017Eit do Pocketu","share_wallabag_label":"Ulo\u017Eit do Wallabagu","share_wordpress_label":"Sd\xedlet na WordPressu","share_mail_label":"Sd\xedlet e-mailem","share_copy_label":"Zkop\xedrovat odkaz do schr\xe1nky","info_url_copied":"URL zkop\xedrov\xe1na do schr\xe1nky.","error_share_native_abort":"Nelze sd\xedlet polo\u017Eku: bu\u010F v\xe1\u0161 prohl\xed\u017Ee\u010D nepodporuje sd\xedlen\xed odkaz\u016F, nebo jste sd\xedlen\xed zru\u0161ili.","error_share_native":"Nelze sd\xedlet polo\u017Eku.","close_dialog":"Zav\u0159\xedt","close_entry":"Zav\u0159\xedt","article_reading_time":"{0} min \u010Dten\xed","error_offline_storage_not_available":"Offline \xfalo\u017Ei\u0161t\u011B nen\xed dostupn\xe9. Ujist\u011Bte se, \u017Ee v\xe1\u0161 prohl\xed\u017Ee\u010D {0}podporuje rozhran\xed IndexedDB{1} a, pokud pou\u017E\xedv\xe1te prohl\xed\u017Ee\u010D zalo\u017Een\xfd na Google Chrome, \u017Ee nespou\u0161t\xedte selfoss v re\u017Eimu anonymn\xedho prohl\xed\u017Een\xed.","error_edit_source":"Nelze ulo\u017Eit zm\u011Bny zdroje:","experimental":"Experiment"}');


var $efc21f73bdbf3d30$exports = {};
$efc21f73bdbf3d30$exports = JSON.parse('{"markread":"Alles gelesen","newest":"Neueste","unread":"Ungelesen","starred":"Favoriten","tags":"Markierungen","alltags":"Alle Markierungen","timestamp":"{0,date} {0,time}","hours":"vor {0,plural,one {1 Stunde},other {# Stunden}}","minutes":"vor {0,plural,one {1 Minute},other {# Minuten}}","seconds":"{0,plural,one {Jetzt gerade},other {vor # Sekunden}}","days":"{0,plural,zero {heute},one {gestern},other {vor # Tagen}}","star":"behalten","unstar":"vergessen","mark":"als gelesen markieren","unmark":"als ungelesen markieren","load_img":"Zeige Bilder","open_window":"\xf6ffnen","next":"weiter","searchbutton":"suchen","refreshbutton":"Quellen aktualisieren","settingsbutton":"Einstellungen","logoutbutton":"Abmelden","loginbutton":"Anmelden","sources":"Quellen","source_add":"Quelle hinzuf\xfcgen","source_opml":"oder OPML-Datei oder Google Reader importieren","source_export":"Quellen exportieren","source_edit":"bearbeiten","source_filter":"Filter","source_delete":"l\xf6schen","source_warn":"Wirklich diesen Feed entfernen?","source_new":"Neue ungespeicherte Quelle","source_title":"Titel","source_autotitle_hint":"Leer lassen um automatisch Titel zu setzen","source_tags":"Markierungen","source_pwd_placeholder":"Nicht ge\xe4ndert","source_comma":"Komma getrennt","source_select":"Quelle ausw\xe4hlen","source_type":"Typ","source_save":"speichern","source_cancel":"abbrechen","source_saved":"gespeichert","source_last_post":"Letzter gesehener Beitrag","no_entries":"keine Eintr\xe4ge gefunden","more":"mehr","login":"Anmelden","login_username":"Benutzername","login_password":"Passwort","no_title":"kein Titel","error":"Ein Fehler ist aufgetreten","filter":"Filter","online_count":"Auf dem Server verf\xfcgbare Elemente","offline_count":"Lokal verf\xfcgbare Artikel","searchremove":"Suche ausblenden","source_refresh":"Diese Quelle aktualisieren","login_invalid_credentials":"Falscher Benutzername/Passwort","login_offline":"Offline-Speicherung","streamerror":"Keine Artikel geladen, neu laden?","reload_list":"Liste neu laden","sources_refreshed":"Quellen aktualisiert","app_update":"selfoss wurde aktualisiert, bitte neu laden","app_reload":"Neu laden","error_session_expired":"Session abgelaufen","error_add_source":"Die Quelle konnte nicht hinzugef\xfcgt werden:","error_delete_source":"Die Quelle konnte nicht gel\xf6scht werden:","error_load_tags":"Konnte Markierungen nicht laden:","error_unknown_tag":"Unbekannte Markierung:","error_unknown_source":"Unbekannte Quell-ID:","error_mark_items":"Es k\xf6nnen nicht alle sichtbaren Elemente markiert werden:","error_mark_item":"Das Markieren/Deaktivieren von Elementen ist nicht m\xf6glich:","error_star_item":"Artikel kann nicht ge-sternt oder ent-sternt werden:","error_logout":"Konnte nicht ausloggen:","error_loading":"Ladefehler:","error_loading_stats":"Nav-Statistiken k\xf6nnen nicht geladen werden:","error_saving_color":"Neue Farbe kann nicht gespeichert werden:","error_refreshing_source":"Quellen k\xf6nnen nicht aktualisiert werden:","error_sync":"Letzte \xc4nderungen vom Server konnten nicht synchronisiert werden:","error_offline_storage":"Offline-Speicherfehler: {0}. Neu laden k\xf6nnte helfen. Deaktiviere offline vorerst.","error_invalid_subsection":"Ung\xfcltiger Unterabschnitt:","search_label":"Suchbegriff","article_actions":"Aktionen","error_configuration":"Nicht m\xf6glich die Konfiguration zu laden.","info_url_copied":"URL in die Zwischenablage kopiert.","share_native_label":"teilen","share_diaspora_label":"auf Diaspora teilen","share_twitter_label":"auf Twitter teilen","share_facebook_label":"auf Facebook teilen","share_mastodon_label":"auf Mastodon teilen","share_pocket_label":"in Pocket speichern","share_wallabag_label":"in Wallabag speichern","share_wordpress_label":"teile auf WordPress","share_mail_label":"per E-Mail teilen","share_copy_label":"Link in die Zwischenablage kopieren","error_share_native_abort":"Es ist nicht m\xf6glich das Objekt zu teilen\u202F\u2013\u202Fentweder gibt es keine Ziele zum Teilen oder die Aktion wurde abgebrochen.","error_share_native":"Es ist nicht m\xf6glich das Objekt zu teilen.","close_entry":"Schlie\xdfen","error_offline_storage_not_available":"Offline-Speicherung ist nicht verf\xfcgbar. Stelle sicher, dass dein Browser die {0}IndexedDB-API unterst\xfctzt{1} und, falls du einen Browser auf Grundlage von Google Chrome benutzt, dass du selfoss nicht im Incognito-Modus ausf\xfchrst.","error_edit_source":"Konnte die \xc4nderungen an den Quellen nicht speichern:","error_unwritable_logs":"Logdateien konnten nicht geschrieben werden.","error_check_system_logs":"Ein Fehler ist aufgetreten, bitte die Systemlogs pr\xfcfen.","error_check_log_file":"Es ist ein Fehler aufgetreten, bitte Protokolldatei \u201E{0}\u201C pr\xfcfen.","offline_navigation_unavailable":"Markierungen und Quellen zu wechseln wird derzeit im Offline-Modus nicht unterst\xfctzt."}');


var $e8fba7b0a3114fd9$exports = {};
$e8fba7b0a3114fd9$exports = JSON.parse('{"markread":"Mark as read","filter":"Filter","newest":"Newest","unread":"Unread","starred":"Starred","online_count":"Items available on the server","offline_count":"Items available locally","offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","tags":"Tags","alltags":"All tags","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 hour},other {# hours}} ago","minutes":"{0,plural,one {1 minute},other {# minutes}} ago","seconds":"{0,plural,one {1 second},other {# seconds}} ago","days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","star":"Star","unstar":"Unstar","mark":"Mark as read","unmark":"Mark as unread","load_img":"Show images","open_window":"Open","next":"Next","share_native_label":"Share","share_diaspora_label":"Share on Diaspora","share_twitter_label":"Share on Twitter","share_facebook_label":"Share on Facebook","share_mastodon_label":"Share on Mastodon","share_pocket_label":"Save to Pocket","share_wallabag_label":"Save to Wallabag","share_wordpress_label":"Share on WordPress","share_mail_label":"Share using e-mail","share_copy_label":"Copy link to clipboard","search_label":"Search term","searchbutton":"Search","searchremove":"Hide search","refreshbutton":"Refresh sources","settingsbutton":"Settings","logoutbutton":"Log out","loginbutton":"Log in","sources":"Sources","sources_loading":"Loading sources\u2026","no_sources":"No sources configured.","source_add":"Add source","source_opml":"or import an OPML file","source_export":"Export sources","source_edit":"Edit","source_filter":"Filter","source_menu":"More actions","source_browse":"Browse","source_delete":"Delete","source_warn":"Really delete this source?","source_deleting":"Deleting source\u2026","source_warn_cancel_dirty":"Discard unsaved changes?","source_new":"New unsaved source","source_title":"Title","source_autotitle_hint":"Leave empty to fetch title","source_tags":"Tags","source_pwd_placeholder":"Not changed","source_comma":"Comma separated","source_select":"Please select source","source_params_loading":"Loading parameters\u2026","source_type":"Type","source_save":"Save","source_cancel":"Cancel","source_saving":"Saving source changes\u2026","source_saved":"Saved","source_last_post":"Last post seen","source_refresh":"Refresh this source","source_go_to_settings":"Open in settings","sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","tag_change_color_button_title":"Change color","entries_loading":"Loading entries\u2026","no_entries":"No entries found","more":"More","login":"Log in","login_in_progress":"Trying to log in\u2026","login_username":"Username","login_password":"Password","login_invalid_credentials":"Wrong username/password","login_error_generic":"Could not log in: {errorMessage}","login_offline":"Offline storage","no_title":"No title","experimental":"Experimental","error":"An error occurred","error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","error_check_log_file":"An error occured, please check the log file \u201C{0}\u201D.","error_check_system_logs":"An error occured, please check your system logs.","error_unwritable_logs":"Unable to write logs.","streamerror":"No items loaded, reload?","reload_list":"Reload list","sources_refreshed":"Sources refreshed","app_update":"selfoss has been updated, please reload","app_reload":"Reload","error_session_expired":"Session expired","error_add_source":"Could not add source:","error_edit_source":"Could not save source changes:","error_delete_source":"Could not delete source:","error_load_tags":"Could not load tags:","error_unknown_tag":"Unknown tag:","error_unknown_source":"Unknown source ID:","error_mark_items":"Cannot mark all visible items:","error_mark_item":"Cannot mark/unmark item:","error_star_item":"Cannot star/unstar item:","error_logout":"Could not log out:","error_loading":"Loading error:","error_loading_stats":"Cannot load nav stats:","error_saving_color":"Cannot save new color:","error_refreshing_source":"Cannot refresh sources:","error_sync":"Could not sync last changes from server:","error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","error_invalid_subsection":"Invalid subsection:","error_configuration":"Unable to load configuration.","error_share_native_abort":"Unable to share item\u2014either there are no share targets, or you cancelled it.","error_share_native":"Unable to share item.","info_url_copied":"URL copied to clipboard.","close_dialog":"Close","close_entry":"Close","article_actions":"Actions","article_reading_time":"{0} min read"}');


var $9bb1025262b0fb39$exports = {};
$9bb1025262b0fb39$exports = JSON.parse('{"error_share_native_abort":"Unable to share item\u202F\u2013\u202Feither there are no share targets, or you cancelled it.","error_saving_color":"Cannot save new colour:","close_entry":"Close","error_share_native":"Unable to share item.","share_copy_label":"Copy link to clipboard","share_mail_label":"Share using e-mail","share_wordpress_label":"Share on WordPress","share_wallabag_label":"Save to Wallabag","share_pocket_label":"Save to Pocket","share_facebook_label":"Share on Facebook","share_twitter_label":"Share on Twitter","share_diaspora_label":"Share on Diaspora","share_native_label":"Share","info_url_copied":"URL copied to clipboard.","close_dialog":"Close","error_configuration":"Unable to load configuration.","article_actions":"Actions","search_label":"Search term","error_invalid_subsection":"Invalid subsection:","error_offline_storage":"Offline storage error: {0}. Reloading may help. Disabling offline for now.","error_sync":"Could not sync last changes from server:","error_refreshing_source":"Cannot refresh sources:","error_loading_stats":"Cannot load nav stats:","error_loading":"Loading error:","error_logout":"Could not log out:","error_star_item":"Cannot star/unstar item:","error_mark_item":"Cannot mark/unmark item:","error_mark_items":"Cannot mark all visible items:","error_unknown_source":"Unknown source ID:","error_unknown_tag":"Unknown tag:","error_load_tags":"Could not load tags:","error_delete_source":"Could not delete source:","error_add_source":"Could not add source:","error_session_expired":"Session expired","app_reload":"Reload","app_update":"selfoss has been updated, please reload","sources_refreshed":"Sources refreshed","reload_list":"Reload list","streamerror":"No items loaded, reload?","error":"An error occurred","no_title":"No title","login_offline":"Offline storage","login_invalid_credentials":"Wrong username/password","login_password":"Password","login_username":"Username","login":"Log in","more":"More","no_entries":"No entries found","source_refresh":"Refresh this source","source_last_post":"Last post seen","source_saved":"Saved","source_cancel":"Cancel","source_save":"Save","source_type":"Type","source_select":"Please select source","source_comma":"Comma separated","source_pwd_placeholder":"Not changed","source_tags":"Tags","source_autotitle_hint":"Leave empty to fetch title","source_title":"Title","source_new":"New unsaved source","source_warn":"Really delete this source?","source_delete":"Delete","source_filter":"Filter","source_edit":"Edit","source_export":"Export sources","source_opml":"or import an OPML file","source_add":"Add source","sources":"Sources","loginbutton":"Log in","logoutbutton":"Log out","settingsbutton":"Settings","refreshbutton":"Refresh sources","searchremove":"Hide search","searchbutton":"Search","next":"Next","open_window":"Open","load_img":"Show images","unmark":"Mark as unread","mark":"Mark as read","unstar":"Unstar","star":"Star","days":"{0,plural,zero {today},one {yesterday},other {# days ago}}","seconds":"{0,plural,one {1 second},other {# seconds}} ago","minutes":"{0,plural,one {1 minute},other {# minutes}} ago","hours":"{0,plural,one {1 hour},other {# hours}} ago","timestamp":"{0,date} {0,time}","alltags":"All tags","tags":"Tags","offline_count":"Items available locally","online_count":"Items available on the server","starred":"Starred","unread":"Unread","newest":"Newest","filter":"Filter","markread":"Mark as read","error_offline_storage_not_available":"Offline storage is not available. Make sure your web browser {0}supports IndexedDB API{1} and, if you are using Google Chrome based browser, that you are not running selfoss in incognito mode.","error_edit_source":"Could not save source changes:","error_unwritable_logs":"Unable to write logs.","error_check_system_logs":"An error occured, please check your system logs.","error_check_log_file":"An error occured, please check the log file \u2018{0}\u2019.","offline_navigation_unavailable":"Switching tags and sources is currently not available in offline mode.","experimental":"Experimental","entries_loading":"Loading entries\u2026","login_in_progress":"Trying to log in\u2026","login_error_generic":"Could not log in: {errorMessage}","error_unauthorized":"Please {link_begin}sign in{link_end} to continue.","no_sources":"No sources configured.","source_menu":"More actions","source_browse":"Browse","source_params_loading":"Loading parameters\u2026","sources_loading":"Loading sources\u2026","source_deleting":"Deleting source\u2026","source_saving":"Saving source changes\u2026","source_go_to_settings":"Open in settings","source_warn_cancel_dirty":"Discard unsaved changes?","sources_leaving_unsaved_prompt":"Leave settings with unsaved source changes?","tag_change_color_button_title":"Change colour","article_reading_time":"{0} min read","share_mastodon_label":"Share on Mastodon"}');


var $8ae9bc6f67c8887e$exports = {};
$8ae9bc6f67c8887e$exports = JSON.parse('{"markread":"marcar como le\xeddo","filter":"filtro","newest":"nuevos","unread":"no le\xeddos","starred":"preferidos","online_count":"Elementos disponibles en el servidor","offline_count":"Elementos disponibles localmente","tags":"Etiquetas","alltags":"todas las etiquetas","timestamp":"{0,date} {0,time}","hours":"hace {0,plural,one {1 hora},other {# horas}}","minutes":"hace {0,plural,one {1 minuto},other {# minutos}}","seconds":"hace {0,plural,one {1 segundo},other {# segundos}}","days":"{0,plural,zero {hoy},one {ayer},other {hace # d\xedas}}","star":"preferido","unstar":"ya no lo prefiero","mark":"marcar como le\xeddo","unmark":"marcar como no le\xeddo","load_img":"cargar Im\xe1genes","open_window":"abrir","next":"siguiente","searchbutton":"buscar","searchremove":"ocultar b\xfasqueda","refreshbutton":"actualizar fuentes","settingsbutton":"configuraci\xf3n","logoutbutton":"cerrar sesi\xf3n","loginbutton":"iniciar sesi\xf3n","sources":"Fuentes","source_add":"agregar fuente","source_opml":"o importar desde un archivo opml o desde Google Reader (Hasta el 15 de Julio de 2013)","source_export":"exportar fuentes","source_edit":"editar","source_filter":"Filtrar","source_delete":"borrar","source_warn":"realmente desea borrar esta fuente?","source_new":"nueva fuente sin guardar","source_title":"Titulo","source_autotitle_hint":"Dejar en blanco para obtener t\xedtulo","source_tags":"Etiquetas","source_pwd_placeholder":"no ha cambiado","source_comma":"separado por comas","source_select":"por favor seleccione una fuente","source_type":"Tipo","source_save":"Guardar","source_cancel":"cancelar","source_saved":"Guardado","source_last_post":"\xdaltima entrada vista","source_refresh":"Actualizar esta fuente","no_entries":"No se encontraron entradas","more":"m\xe1s","login":"iniciar sesi\xf3n","login_username":"usuario","login_password":"contrase\xf1a","login_invalid_credentials":"usuario/contrase\xf1a incorrectos","login_offline":"Almacenaje fuera de l\xednea","no_title":"sin t\xedtulo","error":"ha ocurrido un error","streamerror":"Ning\xfan elemento cargado, \xbfrecargar?","reload_list":"Recargar lista","sources_refreshed":"Las fuentes han sido refrescadas","app_update":"selfoss ha sido actualizado, recargue","app_reload":"Recargar","error_session_expired":"La sesi\xf3n ha expirado","error_add_source":"Error a\xf1adiendo fuente:","error_delete_source":"Error borrando fuente:","error_load_tags":"Error cargando etiquetas:","error_unknown_tag":"Etiqueta desconocida:","error_unknown_source":"Id de fuente desconocido:","error_mark_items":"No se pudo marcar todos los elementos visibles:","error_mark_item":"No se pudo marcar/desmarcar elemento:","error_star_item":"No se pudo preferir/despreferir elemento:","error_logout":"No se pudo registrar:","error_loading":"Error cargando:","error_loading_stats":"No se pudo cargar estad\xedsticas de navegaci\xf3n:","error_saving_color":"No se pudo cargar nuevo color:","error_refreshing_source":"No se pudo refrescar fuentes:","error_sync":"No se pudo sincronizar los \xfaltimos cambios del servidor:","error_offline_storage":"Error de almacenaje fuera de l\xednea: {0}. Recargar puede ayudar. Desactivando uso fuera de l\xednea por ahora.","error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","search_label":"Buscar t\xe9rmino","article_actions":"Acciones","error_configuration":"Imposible cargar configuraci\xf3n.","info_url_copied":"URL copiada al portapapeles.","share_native_label":"Compartir","share_diaspora_label":"Compartir en Diaspora","share_twitter_label":"Compartir en Twitter","share_facebook_label":"Compartir en Facebook","share_pocket_label":"Guardar en Pocket","share_wallabag_label":"Guardar en Wallabag","share_wordpress_label":"Compartir en WordPress","share_mail_label":"Compartir por e-mail","share_copy_label":"Copiar enlace al portapapeles","error_share_native_abort":"Imposible compartir \xedtem-no hay objetivos que compartir, o has cancelado.","error_share_native":"Imposible compartir \xedtem.","close_entry":"Cerrar","error_unwritable_logs":"Imposible escribir logs.","error_check_system_logs":"Un error ha ocurido, por favor comprueba tus logs de sistema.","error_check_log_file":"Un error ha ocurrido, por favor comprueba el fichero de log \u201C{0}\u201D.","offline_navigation_unavailable":"Cambiar etiquetas y fuentes no est\xe1 disponible en el modo fuera de l\xednea.","error_offline_storage_not_available":"Almacenaje fuera de l\xednea no est\xe1 disponible. Aseg\xfarese que su navegador {0}soporta IndexedDB API{1} y, si est\xe1 utilizando un navegador basado en Google Chrome, que no est\xe1 usando selfoss en modo inc\xf3gnito.","error_edit_source":"No se pudo guardar los cambios en las fuentes:","experimental":"Experimental","article_reading_time":"{0} min lectura","sources_loading":"Cargando fuentes\u2026","source_warn_cancel_dirty":"\xbfDescartar los cambios no guardados?","error_unauthorized":"Por favor, {link_begin}firme{link_end} para continuar.","no_sources":"No hay fuentes configuradas.","source_menu":"M\xe1s acciones","source_browse":"Navegar","source_deleting":"Borrando fuente\u2026","source_params_loading":"Cargando par\xe1metros\u2026","login_in_progress":"Intentando iniciar sesi\xf3n\u2026","source_saving":"Guardando cambios en la fuente\u2026","source_go_to_settings":"Abrir en los ajustes","tag_change_color_button_title":"Cambiar el color","entries_loading":"Cargando las entradas\u2026","login_error_generic":"No se ha podido iniciar la sesi\xf3n: {errorMessage}","sources_leaving_unsaved_prompt":"\xbfDejar la configuraci\xf3n con los cambios sin guardar?","share_mastodon_label":"Compartir en Mastodon"}');


var $d225499964bebf2a$exports = {};
$d225499964bebf2a$exports = JSON.parse('{"markread":"M\xe4rgi loetuks","newest":"Uued","unread":"Mitteloetud","starred":"T\xe4rniga","tags":"Sildid","alltags":"K\xf5ik sildid","timestamp":"lisatud {0,date} kell {0,time}","hours":"lisatud {0,plural,one {1 tund},other {# tundi}} tagasi","minutes":"lisatud {0,plural,one {1 minut},other {# minutit}} tagasi","seconds":"lisatud {0,plural,one {1 sekund},other {# sekundit}} tagasi","star":"Lisa t\xe4rn","unstar":"Eemalda t\xe4rn","mark":"M\xe4rgi loetuks","unmark":"M\xe4rgi mitteloetuks","load_img":"Laadi pildid","open_window":"Ava","searchbutton":"Otsi","sources":"Tellimused","source_add":"Lisa tellimus","source_opml":"v\xf5i impordi opml-fail v\xf5i Google Reader","source_export":"ekspordi tellimused","source_edit":"Muuda","source_delete":"Kustuta","source_warn":"Kas t\xf5esti kustutame tellimuse?","source_new":"Uus salvestamata tellimus","source_title":"Nimi","source_tags":"Sildid","source_comma":"komaga eraldatud","source_select":"Tellimuse allika liik","source_type":"Liik","source_save":"Salvesta","source_cancel":"Loobu","source_saved":"Salvestatud","no_entries":"\xdchtki s\xfcndmust ei leitud","more":"rohkem","login":"Logi sisse","login_username":"Kasutajanimi","login_password":"Salas\xf5na","no_title":"Nimeta","settingsbutton":"Seadistused","filter":"Filtreeri","share_diaspora_label":"Jaga Diaspora vahendusel","logoutbutton":"Logi v\xe4lja","streamerror":"\xdchtegi kirjet pole laaditud, kas laadime uuesti?","share_mastodon_label":"Jaga Mastodoni v\xf5rgus","share_wordpress_label":"Jaga WordPressis","share_native_label":"Jaga","offline_navigation_unavailable":"Vallasre\u017Eiimis ei saa hetkel silte ja tellimusi vahetada.","source_deleting":"Kustutame tellimuse\u2026","error_edit_source":"Tellimuse muudatuste salvestamine ei \xf5nnestunud:","login_in_progress":"Proovime sisselogida\u2026","error_mark_items":"K\xf5ikide n\xe4htavate kirjete m\xe4rkimine ei \xf5nnestu:","error_session_expired":"Sessioon on aegunud","error_load_tags":"Siltide laadimine ei \xf5nnestunud:","error_sync":"Viimaste muudatuste s\xfcnkroniseerimine serverist ei \xf5nnestu:","error_share_native":"Kirje jagamine ei \xf5nnestu.","close_entry":"Sulge","sources_refreshed":"Tellimus on v\xe4rskendatud","experimental":"Katselised seadistused","reload_list":"Laadi loend uuesti","error_add_source":"Tellimuse lisamine ei \xf5nnestunud:","share_facebook_label":"Jaga Facebookis","next":"J\xe4rgmine","loginbutton":"Logi sisse","share_wallabag_label":"Salvesta Wallabagi","error_offline_storage_not_available":"Vallasre\u017Eiimis andmehoidla pole saadaval. Palun kontrolli, et sinu veebibrauser {0}toetab IndexedDB APIt{1} ja kui sa kasutad Google Chrome brauserit, siis sa ei vaata selfoss saiti privaatses re\u017Eiimis.","error_invalid_subsection":"Vigane alaml\xf5ik:","error_configuration":"Seadistuste laadimine ei \xf5nnestu.","info_url_copied":"Aadress on kopeeritud l\xf5ikelauale.","article_actions":"Tegevused","article_reading_time":"Lugemiseks kulub {0} minutit","online_count":"Serveris leidub kirjeid","offline_count":"Kohalikus s\xfcsteemis leidub kirjeid","searchremove":"Peida otsing","source_filter":"Filtreeri","source_autotitle_hint":"Nime automaatseks tuvastamiseks j\xe4ta t\xfchjaks","source_pwd_placeholder":"Pole muudetud","login_invalid_credentials":"Vale kasutajanimi ja/v\xf5i salas\xf5na","refreshbutton":"V\xe4rskenda tellimusi","source_last_post":"Viimane n\xe4htud postitus","source_refresh":"V\xe4rskenda see tellimus","login_offline":"Vallasre\u017Eiimis andmehoidla","error":"Tekkis viga","days":"lisatud {0,plural,zero {t\xe4na},one {eile},other {# p\xe4eva tagasi}}","share_mail_label":"Jaga e-kirjaga","share_copy_label":"Kopeeri link l\xf5ikelauale","share_pocket_label":"Salvesta Pocketisse","share_twitter_label":"Jaga Twitteris/X\'is","search_label":"Otsingus\xf5na","source_menu":"T\xe4iendavad toimingud","source_browse":"Sirvi","source_warn_cancel_dirty":"Kas j\xe4tame muudatused salvestamata?","source_params_loading":"Laadime parameetreid\u2026","source_saving":"Salvestame tellimuse muudatusi\u2026","sources_loading":"Laadime tellimustest andmeid\u2026","no_sources":"\xdchtegi tellimust pole seadistatud.","source_go_to_settings":"Ava seadistustes","sources_leaving_unsaved_prompt":"Kas soovid lahkuda seadistustest ja j\xe4tta tellimuse muudatused salvestamata?","error_delete_source":"Tellimuse kustutamine ei \xf5nnestunud:","error_unknown_source":"Tellimuse teadmata tunnus:","error_refreshing_source":"Tellimuste v\xe4rskendamine ei \xf5nnestunud:","tag_change_color_button_title":"Muuda v\xe4rvi","entries_loading":"Laadime kirjeid\u2026","login_error_generic":"Sisselogimine ei \xf5nnestunud: {errorMessage}","error_unauthorized":"J\xe4tkamiseks palun {link_begin}logi sisse{link_end}.","error_check_log_file":"Tekkis viga, palun vaata logifaili \u201E{0}\u201C.","error_check_system_logs":"Tekkis viga, palun vaata s\xfcsteemi logifaile.","error_unwritable_logs":"Logide salvestamine ei \xf5nnestu.","app_update":"selfoss on uuendatud, palun laadi uuesti","app_reload":"Laadi uuesti","error_unknown_tag":"Tundmatu silt:","error_mark_item":"Kirje m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","error_star_item":"Kirje t\xe4rniga m\xe4rkimine v\xf5i m\xe4rkimise eemaldamine ei \xf5nnestu:","error_logout":"V\xe4ljalogimine ei \xf5nnestunud:","error_loading":"Viga laadimisel:","error_loading_stats":"Statistika laadimine ei \xf5nnestu:","error_saving_color":"Uue v\xe4rvi salvestamine ei \xf5nnestu:","error_offline_storage":"Vallasre\u017Eiimis andmehoidla viga: {0}. Uuesti laadimine v\xf5ib viga parandada. L\xfclitame vallasre\u017Eiimi esialgu v\xe4lja.","error_share_native_abort":"Kirje jagamine ei \xf5nnestu - kas brauseris pole \xfchtegi jagamisviisi seadistatud v\xf5i katkestasid jagamise."}');


var $d319fa7db54d8a5e$exports = {};
$d319fa7db54d8a5e$exports = JSON.parse('{"markread":"merkitse luetuiksi","newest":"uusimmat","unread":"lukemattomat","starred":"t&auml;hdelliset","tags":"Avainsanat","alltags":"kaikki avainsanat","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 tunti},other {# tuntia}} sitten","minutes":"{0,plural,one {1 minuutti},other {# minuuttia}} sitten","seconds":"{0,plural,one {1 sekunti},other {# sekuntia}} sitten","star":"t&auml;hti","unstar":"t&auml;hti pois","mark":"luetuksi","unmark":"lukemattomaksi","load_img":"lataa kuvat","open_window":"avaa","searchbutton":"etsi","sources":"L&auml;hteet","source_add":"lis&auml;&auml; l&auml;hde","source_opml":"tai tuo opml-tiedosto tai google reader","source_export":"vie l&auml;hteet","source_edit":"muokkaa","source_delete":"poista","source_warn":"Haluatko varmasti poistaa t&auml;m&auml;n l&auml;hteen?","source_new":"uusi tallentamaton l&auml;hde","source_title":"Nimi","source_tags":"Avainsanat","source_comma":"avainsanat erotetaan pilkulla","source_select":"valitse l&auml;hde","source_type":"Tyyppi","source_save":"tallenna","source_cancel":"peruuta","source_saved":"tallennettu","no_entries":"merkint&ouml;j&auml; ei l&ouml;ydetty","more":"lis&auml;&auml;","login":"kirjaudu sis&auml;&auml;n","login_username":"k&auml;ytt&auml;j&auml;tunnus","login_password":"salasana","no_title":"ei otsikkoa","error_share_native_abort":"Kohteen jakaminen ep\xe4onnistui \u2013 joko jakamiskohteita ei ole tai peruutat sen.","close_entry":"Sulje","login_invalid_credentials":"V\xe4\xe4r\xe4 k\xe4ytt\xe4j\xe4nimi/salasana","share_mail_label":"Jaa s\xe4hk\xf6postitse","sources_refreshed":"L\xe4hteet virkistetty","error_refreshing_source":"L\xe4hteit\xe4 ei voi virkist\xe4\xe4:","source_refresh":"Virkist\xe4 t\xe4m\xe4 l\xe4hde","refreshbutton":"Virkist\xe4 l\xe4hteet"}');


var $d0be492086bdc65a$exports = {};
$d0be492086bdc65a$exports = JSON.parse('{"markread":"Marquer comme lu","filter":"Filtrer","newest":"Le plus r\xe9cent","unread":"Non lu","starred":"Favoris","online_count":"Sur le serveur","offline_count":"En local","tags":"\xc9tiquettes","alltags":"Toutes les \xe9tiquettes","timestamp":"{0,date} {0,time}","hours":"il y a {0,plural,one {1 heure},other {# heures}}","minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","star":"Ajouter aux favoris","unstar":"Supprimer des favoris","mark":"Marquer comme lu","unmark":"Marquer comme non lu","load_img":"Afficher les images","open_window":"Ouvrir","next":"Suivant","searchbutton":"Rechercher","searchremove":"Masquer le champ de recherche","refreshbutton":"Actualiser les sources","settingsbutton":"Param\xe8tres","logoutbutton":"Se d\xe9connecter","loginbutton":"Se connecter","sources":"Sources","source_add":"Ajouter une source","source_opml":"ou importer un fichier OPML ou Google Reader","source_export":"Exporter les sources","source_edit":"Modifier","source_filter":"Filtre","source_delete":"Supprimer","source_warn":"Voulez-vous vraiment supprimer cette source ?","source_new":"Nouvelle source non sauvegard\xe9e","source_title":"Titre","source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","source_tags":"\xc9tiquettes","source_pwd_placeholder":"Mot de passe inchang\xe9","source_comma":"S\xe9par\xe9s par une virgule","source_select":"Veuillez s\xe9lectionner une source","source_type":"Type","source_save":"Enregistrer","source_cancel":"Annuler","source_saved":"Enregistr\xe9","source_last_post":"Dernier \xe9l\xe9ment vu","source_refresh":"Rafra\xeechir cette source","no_entries":"Aucun article \xe0 consulter","more":"Plus","login":"Connexion","login_username":"Identifiant","login_password":"Mot de passe","login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","login_offline":"Stockage hors-ligne","no_title":"Sans titre","error":"Une erreur est survenue","streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau\xa0?","reload_list":"Recharger la liste","sources_refreshed":"Sources actualis\xe9es","app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","app_reload":"Recharger","error_session_expired":"Session expir\xe9e","error_add_source":"Impossible d\'ajouter la source\xa0:","error_delete_source":"Impossible de supprimer la source :","error_load_tags":"Impossible de charger les \xe9tiquettes :","error_unknown_tag":"Tag inconnu\xa0:","error_unknown_source":"Identifiant de source inconnu\xa0:","error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","error_logout":"Impossible de se d\xe9connecter\xa0:","error_loading":"Erreur de chargement\xa0:","error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","error_invalid_subsection":"Sous-section erron\xe9e :","search_label":"Terme de recherche","article_actions":"Actions","error_configuration":"Impossible de charger la configuration.","info_url_copied":"URL copi\xe9e dans le presse-papiers.","share_native_label":"Partager","share_diaspora_label":"Partager sur Diaspora","share_twitter_label":"Partager sur Twitter","share_facebook_label":"Partager sur Facebook","share_pocket_label":"Enregistrer dans Pocket","share_wallabag_label":"Enregistrer dans Wallabag","share_wordpress_label":"Partager sur WordPress","share_mail_label":"Partager par courriel","share_copy_label":"Copier le lien dans le presse-papiers","error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","close_entry":"Fermer","error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0} \xbb.","offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment.","error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","error_edit_source":"Impossible d\'enregistrer les modifications de la source\xa0:","source_browse":"Naviguer","no_sources":"Aucune source configur\xe9es.","source_warn_cancel_dirty":"Annuler les changements non sauvegard\xe9s ?","source_deleting":"Suppression de la source\u2026","source_saving":"Sauvegarde des changements de la source\u2026","entries_loading":"Chargement des entr\xe9es\u2026","source_menu":"Plus d\'actions","tag_change_color_button_title":"Changer la couleur","sources_loading":"Chargement des sources\u2026","source_go_to_settings":"Ouvrir dans les param\xe8tres","sources_leaving_unsaved_prompt":"Quitter les param\xe8tres avec des changements sur la source non sauvegard\xe9s ?","source_params_loading":"Chargement des param\xe8tres\u2026","experimental":"Exp\xe9rimentale","article_reading_time":"{0} min de lecture","login_in_progress":"Tentative de connexion\u2026","login_error_generic":"Connexion impossible : {errorMessage}","error_unauthorized":"S\'il vous pla\xeet {link_begin}connectez-vous{link_end} pour continuer."}');


var $bb896106aaedaee8$exports = {};
$bb896106aaedaee8$exports = JSON.parse('{"error_add_source":"Impossible d\'ajouter la source\u202F:","streamerror":"Une erreur s\u2019est produite lors du chargement de la liste, essayer \xe0 nouveau?","source_warn":"Voulez-vous vraiment supprimer cette source?","sources":"Sources","timestamp":"{0,date} {0,time}","close_entry":"Fermer","error_share_native":"Impossible de partager l\'\xe9l\xe9ment.","error_share_native_abort":"Impossible de partager l\'\xe9l\xe9ment, soit il n\'y a pas de cible, soit vous avez annul\xe9 le partage.","share_copy_label":"Copier le lien dans le presse-papiers","share_mail_label":"Partager par courriel","share_wordpress_label":"Partager sur WordPress","share_wallabag_label":"Enregistrer dans Wallabag","share_pocket_label":"Enregistrer dans Pocket","share_facebook_label":"Partager sur Facebook","share_twitter_label":"Partager sur Twitter","share_diaspora_label":"Partager sur Diaspora","share_native_label":"Partager","info_url_copied":"URL copi\xe9e dans le presse-papiers.","error_configuration":"Impossible de charger la configuration.","article_actions":"Actions","search_label":"Terme de recherche","error_invalid_subsection":"Sous-section erron\xe9e :","error_offline_storage":"Erreur stockage hors-ligne : {0}. Recharger la page pourrait aider. Le mode hors-ligne est d\xe9sactiv\xe9 pour le moment.","error_sync":"Impossible de synchroniser les derni\xe8res modifications du serveur\xa0:","error_refreshing_source":"Impossible de rafra\xeechir les sources\xa0:","error_saving_color":"Impossible de sauvegarder une nouvelle couleur\xa0:","error_loading_stats":"Impossible de charger les statistiques de navigation\xa0:","error_loading":"Erreur de chargement\xa0:","error_logout":"Impossible de se d\xe9connecter\xa0:","error_star_item":"Erreur lors de l\u2019ajouter/suppression du favori\xa0:","error_mark_item":"Erreur lors du marquage lu/non lu\xa0:","error_mark_items":"Impossible de marquer tous les \xe9l\xe9ments visibles\xa0:","error_unknown_source":"Identifiant de source inconnu\xa0:","error_unknown_tag":"Tag inconnu\xa0:","error_load_tags":"Impossible de charger les \xe9tiquettes :","error_delete_source":"Impossible de supprimer la source :","error_session_expired":"Session expir\xe9e","app_reload":"Recharger","app_update":"selfoss a \xe9t\xe9 mis \xe0 jour, merci de recharger","sources_refreshed":"Sources actualis\xe9es","reload_list":"Recharger la liste","error":"Une erreur est survenue","no_title":"Sans titre","login_offline":"Stockage hors-ligne","login_invalid_credentials":"Nom d\u2019utilisateur/Mot de passe incorrect","login_password":"Mot de passe","login_username":"Identifiant","login":"Connexion","more":"Plus","no_entries":"Aucun article \xe0 consulter","source_refresh":"Rafra\xeechir cette source","source_last_post":"Dernier \xe9l\xe9ment vu","source_saved":"Enregistr\xe9","source_cancel":"Annuler","source_save":"Enregistrer","source_type":"Type","source_select":"Veuillez s\xe9lectionner une source","source_comma":"S\xe9par\xe9s par une virgule","source_pwd_placeholder":"Mot de passe inchang\xe9","source_tags":"\xc9tiquettes","source_autotitle_hint":"Laisser vide pour r\xe9cup\xe9rer le titre","source_title":"Titre","source_new":"Nouvelle source non sauvegard\xe9e","source_delete":"Supprimer","source_filter":"Filtre","source_edit":"Modifier","source_export":"Exporter les sources","source_opml":"ou importer un fichier OPML ou Google Reader","source_add":"Ajouter une source","loginbutton":"Se connecter","logoutbutton":"Se d\xe9connecter","settingsbutton":"Param\xe8tres","refreshbutton":"Actualiser les sources","searchremove":"Masquer le champ de recherche","searchbutton":"Rechercher","next":"Suivant","open_window":"Ouvrir","load_img":"Afficher les images","unmark":"Marquer comme non lu","mark":"Marquer comme lu","unstar":"Supprimer des favoris","star":"Ajouter aux favoris","days":"{0,plural,zero {aujourd\u2019hui},one {hier},other {il y a # jours}}","seconds":"il y a {0,plural,one {1 seconde},other {# secondes}}","minutes":"il y a {0,plural,one {1 minute},other {# minutes}}","hours":"il y a {0,plural,one {1 heure},other {# heures}}","alltags":"Toutes les \xe9tiquettes","tags":"\xc9tiquettes","offline_count":"En local","online_count":"Sur le serveur","starred":"Favoris","unread":"Non lu","newest":"Le plus r\xe9cent","filter":"Filtrer","markread":"Marquer comme lu","error_offline_storage_not_available":"Le stockage hors ligne n\u2019est pas disponible. Assurez-vous que votre navigateur Web {0}prend en charge l\u2019API IndexedDB{1} et, si vous utilisez un navigateur bas\xe9 sur Google Chrome, que vous n\u2019ex\xe9cutez pas selfoss en mode de navigation priv\xe9e.","error_edit_source":"Impossible d\'enregistrer les modifications de la source :","error_unwritable_logs":"Impossible d\'\xe9crire les fichiers de journalisation.","error_check_system_logs":"Une erreur est survenue. Veuillez consulter votre journalisation syst\xe8me.","error_check_log_file":"Une erreur est survenue. Veuillez consulter le fichier \xab {0}\xa0\xbb.","offline_navigation_unavailable":"Modifier les \xe9tiquettes et les sources n\'est pas possible hors ligne pour le moment."}');


var $acbbfcabee63ed13$exports = {};
$acbbfcabee63ed13$exports = JSON.parse('{"tags":"Etiquetas","days":"{0,plural,zero {hoxe},one {onte},other {fai # d\xedas}}","unmark":"Marcar como non lido","share_pocket_label":"Gardar en Pocket","no_entries":"Non se atoparon rexistros","more":"M\xe1is","filter":"Filtro","online_count":"Elementos dispo\xf1ibles no servidor","offline_count":"Elementos dispo\xf1ibles localmente","timestamp":"{0,date} {0,time}","hours":"fai {0,plural,one {1 hora},other {# horas}}","minutes":"fai {0,plural,one {1 minuto},other {# minutos}}","seconds":"fai {0,plural,one {1 segundo},other {# segundos}}","share_wallabag_label":"Gardar en Wallabag","share_wordpress_label":"Compartir en WordPress","share_mail_label":"Compartir por email","share_copy_label":"Copiar ligaz\xf3n o portapap\xe9is","search_label":"Buscar termo","searchbutton":"Procurar","searchremove":"Agochar b\xfasqueda","refreshbutton":"Actualizar as fontes","settingsbutton":"Configuraci\xf3n","logoutbutton":"Fechar a sesi\xf3n","loginbutton":"Iniciar sesi\xf3n","sources":"Fontes","sources_loading":"Cargando as fontes\u2026","no_sources":"Non hai fontes configuradas.","source_add":"Engadir fonte","source_opml":"ou importa dende un ficheiro OPML","source_export":"Exportar fontes","source_edit":"Editar","source_filter":"Filtro","source_menu":"M\xe1is acci\xf3ns","source_browse":"Navegar","source_delete":"Borrar","source_warn":"Realmente queres borrar esta fonte?","source_deleting":"Borrando a fonte\u2026","source_warn_cancel_dirty":"Queres descargar os cambios non gardados?","source_new":"Nova fonte sen gardar","source_title":"T\xedtulo","source_autotitle_hint":"Deixar en branco pra obter t\xedtulo","source_type":"Tipo","source_save":"Gardar","source_cancel":"Cancelar","source_saving":"Gardando cambios da fonte\u2026","source_last_post":"\xdaltima entrada vista","error_session_expired":"A sesi\xf3n expirou","error_add_source":"Non se puido engadira a fonte:","error_edit_source":"Non se puideron gardar os cambios as fontes:","error_delete_source":"Erro borrando a fonte:","error_load_tags":"Non se puideron cargar as etiquetas:","error_unknown_tag":"Etiqueta desco\xf1ecida:","error_unknown_source":"Id de fonte desco\xf1ecida:","error_mark_items":"Non se puideron marcar todos os elementos visib\xe9is:","error_mark_item":"Non se puido marcar/desmarcar elemento:","error_star_item":"Non se puido marcar/desmarcar a estrela no elemento:","error_logout":"Non se puido fechar a sesi\xf3n:","error_loading":"Error cargando:","error_loading_stats":"Non se puideron cargar as estat\xedsticas de navegaci\xf3n:","error_saving_color":"Non se puido cargar a nova cor:","error_refreshing_source":"Non se puideron refrescar as fontes:","error_sync":"Non se puideron sincronizar os \xfaltimos cambios do servidor:","error_offline_storage":"Error do almacenamento fora de li\xf1a: {0}. Recargar pode axudar. Desactivando uso fora de li\xf1a polo momento.","share_twitter_label":"Compartir en Twitter","error_offline_storage_not_available":"Almacenamento fora de li\xf1a non dispo\xf1\xedbel. Asegurase de que o seu navegador {0} soporta IndexedDB API{1} e, se est\xe1 utilizando un navegador baseado en Google Chrome, que non est\xe9 usando selfoss en modo inc\xf3gnito.","error_invalid_subsection":"Subsecci\xf3n inv\xe1lida:","error_configuration":"Non se puido cargar a configuraci\xf3n.","error_share_native_abort":"Non se puido compartir o elemento, non tes onde compartilo ou cancel\xe1chelo.","error_share_native":"Non se puido compartir o elemento.","info_url_copied":"Copiouse a URL o portapap\xe9is.","close_entry":"Fechar","article_actions":"Acci\xf3ns","article_reading_time":"{0} min lectura","unread":"Non lidos","offline_navigation_unavailable":"Cambiar etiquetas e fontes non est\xe1 dispo\xf1ible no modo fora de li\xf1a.","source_go_to_settings":"Abrir a configuraci\xf3n","login_in_progress":"Intentando iniciar sesi\xf3n\u2026","markread":"Marcar como lido","newest":"Novos","alltags":"Todas as etiquetas","source_saved":"Gardado","source_refresh":"Actualizar esta fonte","tag_change_color_button_title":"Cambiar a cor","login":"Iniciar sesi\xf3n","login_password":"Contrasinal","sources_refreshed":"Actualizaronse as fontes","star":"Marcar con estrela","starred":"Con estrela","unstar":"Quitar a estrela","next":"Seguinte","share_native_label":"Compartir","share_diaspora_label":"Compartir en Diaspora","share_facebook_label":"Compartir en Facebook","source_comma":"Separado por comas","mark":"Marcar como lido","open_window":"Abrir","load_img":"Cargar imaxes","login_invalid_credentials":"Usuario/contrasinal incorrectos","source_tags":"Etiquetas","source_select":"Por favor, escolle unha fonte","source_pwd_placeholder":"Non cambiou","source_params_loading":"Estanse cargando os par\xe1metros\u2026","sources_leaving_unsaved_prompt":"Queres deixar a configuraci\xf3n con cambios de fonte non gardados?","login_username":"Usuario","entries_loading":"Estanse cargando as entradas\u2026","login_offline":"Almacenamento fora de li\xf1a","error":"Ocurriu un erro","error_check_system_logs":"Ocurriu un erro, por favor comproba os rexistros do sistema.","error_unwritable_logs":"Non se puideron escribir os rexistros.","no_title":"Sen t\xedtulo","experimental":"Experimental","error_check_log_file":"Produciuse un erro, por favor comproba o ficheiro de rexistro \\"{0}\\".","streamerror":"Non hai elementos cargados, recargar?","reload_list":"Recargar lista","app_update":"Selfoss actualizouse, recargue","app_reload":"Recargar","error_unauthorized":"{link_begin}inicia sesi\xf3n{link_end} para continuar.","login_error_generic":"Non se puido iniciar sesi\xf3n: {errorMessage}","share_mastodon_label":"Comparte en Mastodon"}');


var $b6d92725827c8d30$exports = {};
$b6d92725827c8d30$exports = JSON.parse('{"error_offline_storage_not_available":"\u05D4\u05D0\u05D7\u05E1\u05D5\u05DF \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05D0\u05D9\u05E0\u05D5 \u05D6\u05DE\u05D9\u05DF. \u05E0\u05D0 \u05DC\u05D5\u05D5\u05D3\u05D0 \u05E9\u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DC\u05DA {0}\u05EA\u05D5\u05DE\u05DA \u05D1\u05BEAPI \u05DE\u05E1\u05D5\u05D2 IndexedDB{1} \u05D5\u05D2\u05DD, \u05D0\u05DD \u05D4\u05D3\u05E4\u05D3\u05E4\u05DF \u05E9\u05DE\u05E9\u05DE\u05E9 \u05D0\u05D5\u05EA\u05DA \u05DE\u05D1\u05D5\u05E1\u05E1 Google Chrome, \u05E9\u05D6\u05D0\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D2\u05DC\u05D9\u05E9\u05D4 \u05D1\u05E1\u05EA\u05E8.","error_invalid_subsection":"\u05EA\u05EA\u05BE\u05E1\u05E2\u05D9\u05E3 \u05E9\u05D2\u05D5\u05D9:","error_offline_storage":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF: {0}. \u05D0\u05D5\u05DC\u05D9 \u05E8\u05E2\u05E0\u05D5\u05DF \u05D9\u05E2\u05D6\u05D5\u05E8. \u05D4\u05DE\u05E6\u05D1 \u05D4\u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF \u05DE\u05D5\u05E9\u05D1\u05EA \u05DB\u05E8\u05D2\u05E2.","error_share_native_abort":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8 - \u05D0\u05D5 \u05E9\u05D0\u05D9\u05DF \u05D9\u05E2\u05D3 \u05DC\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D0\u05D5 \u05E9\u05D1\u05D9\u05D8\u05DC\u05EA.","error_configuration":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05D4\u05D2\u05D3\u05E8\u05D5\u05EA.","error_share_native":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05EA\u05E3 \u05E4\u05E8\u05D9\u05D8.","article_actions":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA","close_entry":"\u05E1\u05D2\u05D9\u05E8\u05D4","info_url_copied":"\u05D4\u05DB\u05EA\u05D5\u05D1\u05EA \u05D4\u05D5\u05E2\u05EA\u05E7\u05D4 \u05DC\u05DC\u05D5\u05D7 \u05D4\u05D2\u05D6\u05D9\u05E8\u05D9\u05DD.","error_sync":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05E0\u05DB\u05E8\u05DF \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D9\u05DD \u05DE\u05D4\u05E9\u05E8\u05EA:","error_refreshing_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA:","error_saving_color":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05E6\u05D1\u05E2 \u05D7\u05D3\u05E9:","error_loading_stats":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05E1\u05D8\u05D8\u05D9\u05E1\u05D8\u05D9\u05E7\u05EA \u05E0\u05D9\u05D5\u05D5\u05D8:","error_loading":"\u05E9\u05D2\u05D9\u05D0\u05EA \u05D8\u05E2\u05D9\u05E0\u05D4:","error_logout":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E6\u05D0\u05EA:","error_star_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1/\u05DC\u05D1\u05D8\u05DC \u05DB\u05D5\u05DB\u05D1 \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","error_mark_item":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF/\u05DC\u05D1\u05D8\u05DC \u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC \u05E4\u05E8\u05D9\u05D8:","error_mark_items":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E1\u05DE\u05DF \u05D0\u05EA \u05DB\u05DC \u05D4\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D4\u05D2\u05DC\u05D5\u05D9\u05D9\u05DD:","error_unknown_source":"\u05DE\u05D6\u05D4\u05D4 \u05D4\u05DE\u05E7\u05D5\u05E8 \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2:","error_unknown_tag":"\u05EA\u05D2\u05D9\u05EA \u05DC\u05D0 \u05D9\u05D3\u05D5\u05E2\u05D4:","error_load_tags":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D8\u05E2\u05D5\u05DF \u05EA\u05D2\u05D9\u05D5\u05EA:","error_delete_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DE\u05D7\u05D5\u05E7 \u05DE\u05E7\u05D5\u05E8:","error_edit_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05E9\u05DE\u05D5\u05E8 \u05D0\u05EA \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9 \u05D4\u05DE\u05E7\u05D5\u05E8:","error_add_source":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D5\u05E1\u05D9\u05E3 \u05DE\u05E7\u05D5\u05E8:","error_session_expired":"\u05EA\u05D5\u05E7\u05E3 \u05D4\u05D4\u05E4\u05E2\u05DC\u05D4 \u05E4\u05D2","app_reload":"\u05E8\u05E2\u05E0\u05D5\u05DF","app_update":"selfoss \u05D4\u05EA\u05E2\u05D3\u05DB\u05DF, \u05E0\u05D0 \u05DC\u05E8\u05E2\u05E0\u05DF","sources_refreshed":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D4\u05EA\u05E8\u05E2\u05E0\u05E0\u05D5","reload_list":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05E8\u05E9\u05D9\u05DE\u05D4","streamerror":"\u05DC\u05D0 \u05E0\u05D8\u05E2\u05E0\u05D5 \u05E4\u05E8\u05D9\u05D8\u05D9\u05DD, \u05DC\u05E8\u05E2\u05E0\u05DF?","error_unwritable_logs":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05DB\u05EA\u05D5\u05D1 \u05D9\u05D5\u05DE\u05E0\u05D9\u05DD.","error_check_system_logs":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05D9\u05D5\u05DE\u05E0\u05D9 \u05D4\u05DE\u05E2\u05E8\u05DB\u05EA \u05E9\u05DC\u05DA.","error_check_log_file":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4, \u05E0\u05D0 \u05DC\u05E2\u05D9\u05D9\u05DF \u05D1\u05E7\u05D5\u05D1\u05E5 \u05D4\u05D9\u05D5\u05DE\u05DF \u201E{0}\u201D.","error":"\u05D0\u05D9\u05E8\u05E2\u05D4 \u05E9\u05D2\u05D9\u05D0\u05D4","no_title":"\u05D0\u05D9\u05DF \u05DB\u05D5\u05EA\u05E8\u05EA","login_offline":"\u05D0\u05D7\u05E1\u05D5\u05DF \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF","login_invalid_credentials":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9/\u05E1\u05E1\u05DE\u05D4 \u05E9\u05D2\u05D5\u05D9\u05D9\u05DD","login_password":"\u05E1\u05E1\u05DE\u05D4","login_username":"\u05E9\u05DD \u05DE\u05E9\u05EA\u05DE\u05E9","login":"\u05DB\u05E0\u05D9\u05E1\u05D4","more":"\u05E2\u05D5\u05D3","no_entries":"\u05DC\u05D0 \u05E0\u05DE\u05E6\u05D0\u05D5 \u05E8\u05E9\u05D5\u05DE\u05D5\u05EA","source_refresh":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4","source_last_post":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D4 \u05D4\u05D0\u05D7\u05E8\u05D5\u05E0\u05D4 \u05E9\u05E0\u05E8\u05D0\u05EA\u05D4","source_saved":"\u05E0\u05E9\u05DE\u05E8","source_cancel":"\u05D1\u05D9\u05D8\u05D5\u05DC","source_save":"\u05E9\u05DE\u05D9\u05E8\u05D4","source_type":"\u05E1\u05D5\u05D2","source_select":"\u05E0\u05D0 \u05DC\u05D1\u05D7\u05D5\u05E8 \u05DE\u05E7\u05D5\u05E8","source_comma":"\u05E2\u05DD \u05D4\u05E4\u05E8\u05D3\u05D4 \u05D1\u05E4\u05E1\u05D9\u05E7\u05D9\u05DD","source_pwd_placeholder":"\u05DC\u05D0 \u05D4\u05E9\u05EA\u05E0\u05D4","source_tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","source_autotitle_hint":"\u05D9\u05E9 \u05DC\u05D4\u05E9\u05D0\u05D9\u05E8 \u05E8\u05D9\u05E7 \u05DB\u05D3\u05D9 \u05DC\u05E7\u05D1\u05DC \u05D0\u05EA \u05D4\u05DB\u05D5\u05EA\u05E8\u05EA","source_title":"\u05DB\u05D5\u05EA\u05E8\u05EA","source_new":"\u05DE\u05E7\u05D5\u05E8 \u05D7\u05D3\u05E9 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8","source_warn":"\u05DC\u05DE\u05D7\u05D5\u05E7 \u05D0\u05EA \u05D4\u05DE\u05E7\u05D5\u05E8 \u05D4\u05D6\u05D4?","source_delete":"\u05DE\u05D7\u05D9\u05E7\u05D4","source_filter":"\u05DE\u05E1\u05E0\u05DF","source_edit":"\u05E2\u05E8\u05D9\u05DB\u05D4","source_export":"\u05D9\u05D9\u05E6\u05D5\u05D0 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","source_opml":"\u05D0\u05D5 \u05DC\u05D9\u05D9\u05D1\u05D0 \u05E7\u05D5\u05D1\u05E5 OPML","source_add":"\u05D4\u05D5\u05E1\u05E4\u05EA \u05DE\u05E7\u05D5\u05E8","sources":"\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","loginbutton":"\u05DB\u05E0\u05D9\u05E1\u05D4","logoutbutton":"\u05D9\u05E6\u05D9\u05D0\u05D4","settingsbutton":"\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","refreshbutton":"\u05DC\u05E8\u05E2\u05E0\u05DF \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA","searchremove":"\u05D4\u05E1\u05EA\u05E8\u05EA \u05D7\u05D9\u05E4\u05D5\u05E9","searchbutton":"\u05D7\u05D9\u05E4\u05D5\u05E9","search_label":"\u05D1\u05D9\u05D8\u05D5\u05D9 \u05DC\u05D7\u05D9\u05E4\u05D5\u05E9","share_copy_label":"\u05D4\u05E2\u05EA\u05E7\u05EA \u05E7\u05D9\u05E9\u05D5\u05E8 \u05DC\u05DC\u05D5\u05D7 \u05D2\u05D6\u05D9\u05E8\u05D9\u05DD","share_mail_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D3\u05D5\u05D0\u05F4\u05DC","share_wordpress_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D5\u05D5\u05E8\u05D3\u05E4\u05E8\u05E1","share_wallabag_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEWallabag","share_pocket_label":"\u05E9\u05DE\u05D9\u05E8\u05D4 \u05D1\u05BEPocket","share_facebook_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05E4\u05D9\u05D9\u05E1\u05D1\u05D5\u05E7","share_twitter_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05D8\u05D5\u05D5\u05D9\u05D8\u05E8","share_diaspora_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEDiaspora","share_native_label":"\u05E9\u05D9\u05EA\u05D5\u05E3","next":"\u05D4\u05D1\u05D0","open_window":"\u05E4\u05EA\u05D9\u05D7\u05D4","load_img":"\u05D4\u05E6\u05D2\u05EA \u05EA\u05DE\u05D5\u05E0\u05D5\u05EA","unmark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","mark":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","unstar":"\u05D1\u05D9\u05D8\u05D5\u05DC \u05DB\u05D5\u05DB\u05D1","star":"\u05DC\u05E1\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","days":"{0,plural,zero {\u05D4\u05D9\u05D5\u05DD},one {\u05D0\u05EA\u05DE\u05D5\u05DC},two {\u05E9\u05DC\u05E9\u05D5\u05DD},other {\u05DC\u05E4\u05E0\u05D9 # \u05D9\u05DE\u05D9\u05DD}}","seconds":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E0\u05D9\u05D9\u05D4},other {# \u05E9\u05E0\u05D9\u05D5\u05EA}}","minutes":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05D3\u05E7\u05D4},other {# \u05D3\u05E7\u05D5\u05EA}}","hours":"\u05DC\u05E4\u05E0\u05D9 {0,plural,one {\u05E9\u05E2\u05D4},two {\u05E9\u05E2\u05EA\u05D9\u05D9\u05DD},other {# \u05E9\u05E2\u05D5\u05EA}}","timestamp":"\u200E{0,date} {0,time}","alltags":"\u05DB\u05DC \u05D4\u05EA\u05D2\u05D9\u05D5\u05EA","tags":"\u05EA\u05D2\u05D9\u05D5\u05EA","offline_navigation_unavailable":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05EA\u05D2\u05D9\u05D5\u05EA \u05D5\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05D0\u05D9\u05E0\u05D4 \u05D6\u05DE\u05D9\u05E0\u05D4 \u05DB\u05E8\u05D2\u05E2 \u05D1\u05DE\u05E6\u05D1 \u05D1\u05DC\u05EA\u05D9 \u05DE\u05E7\u05D5\u05D5\u05DF.","offline_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05DE\u05E7\u05D5\u05DE\u05D9\u05EA","online_count":"\u05E4\u05E8\u05D9\u05D8\u05D9\u05DD \u05D6\u05DE\u05D9\u05E0\u05D9\u05DD \u05D1\u05E9\u05E8\u05EA","starred":"\u05DE\u05E1\u05D5\u05DE\u05DF \u05D1\u05DB\u05D5\u05DB\u05D1","unread":"\u05DC\u05D0 \u05E0\u05E7\u05E8\u05D0","newest":"\u05D4\u05D7\u05D3\u05E9 \u05D1\u05D9\u05D5\u05EA\u05E8","filter":"\u05DE\u05E1\u05E0\u05DF","markread":"\u05E1\u05D9\u05DE\u05D5\u05DF \u05E9\u05E0\u05E7\u05E8\u05D0","article_reading_time":"{0} \u05D3\u05E7\u05D5\u05EA \u05E7\u05E8\u05D9\u05D0\u05D4","experimental":"\u05E0\u05D9\u05E1\u05D9\u05D5\u05E0\u05D9","source_warn_cancel_dirty":"\u05DC\u05D4\u05E9\u05DC\u05D9\u05DA \u05D0\u05EA \u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","sources_leaving_unsaved_prompt":"\u05DC\u05E6\u05D0\u05EA \u05DE\u05D4\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA \u05E2\u05DD \u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05D1\u05DE\u05E7\u05D5\u05E8 \u05E9\u05DC\u05D0 \u05E0\u05E9\u05DE\u05E8\u05D5?","source_browse":"\u05E2\u05D9\u05D5\u05DF","source_menu":"\u05E4\u05E2\u05D5\u05DC\u05D5\u05EA \u05E0\u05D5\u05E1\u05E4\u05D5\u05EA","tag_change_color_button_title":"\u05D4\u05D7\u05DC\u05E4\u05EA \u05E6\u05D1\u05E2","source_go_to_settings":"\u05E4\u05EA\u05D9\u05D7\u05D4 \u05D1\u05D4\u05D2\u05D3\u05E8\u05D5\u05EA","sources_loading":"\u05D4\u05DE\u05E7\u05D5\u05E8\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","no_sources":"\u05DC\u05D0 \u05D4\u05D5\u05D2\u05D3\u05E8\u05D5 \u05DE\u05E7\u05D5\u05E8\u05D5\u05EA.","source_deleting":"\u05D4\u05DE\u05E7\u05D5\u05E8 \u05E0\u05DE\u05D7\u05E7\u2026","source_params_loading":"\u05D4\u05DE\u05E9\u05EA\u05E0\u05D9\u05DD \u05E0\u05D8\u05E2\u05E0\u05D9\u05DD\u2026","source_saving":"\u05D4\u05E9\u05D9\u05E0\u05D5\u05D9\u05D9\u05DD \u05DC\u05DE\u05E7\u05D5\u05E8 \u05E0\u05E9\u05DE\u05E8\u05D9\u05DD\u2026","entries_loading":"\u05D4\u05E8\u05E9\u05D5\u05DE\u05D5\u05EA \u05E0\u05D8\u05E2\u05E0\u05D5\u05EA\u2026","login_in_progress":"\u05DE\u05EA\u05D1\u05E6\u05E2 \u05E0\u05D9\u05E1\u05D9\u05D5\u05DF \u05DB\u05E0\u05D9\u05E1\u05D4\u2026","error_unauthorized":"\u05E0\u05D0 {link_begin}\u05DC\u05D4\u05D9\u05DB\u05E0\u05E1{link_end} \u05DB\u05D3\u05D9 \u05DC\u05D4\u05DE\u05E9\u05D9\u05DA.","login_error_generic":"\u05DC\u05D0 \u05E0\u05D9\u05EA\u05DF \u05DC\u05D4\u05D9\u05DB\u05E0\u05E1: {errorMessage}","share_mastodon_label":"\u05E9\u05D9\u05EA\u05D5\u05E3 \u05D1\u05BEMastodon"}');


var $a93f0f568ed4bbb3$exports = {};
$a93f0f568ed4bbb3$exports = JSON.parse('{"markread":"Mindet olvastam","newest":"Legfrissebb","unread":"Olvasatlan","starred":"Megjel\xf6lt","tags":"C\xedmk\xe9k","alltags":"\xd6sszes c\xedmke","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \xf3r\xe1ja},other {# \xf3r\xe1ja}}","minutes":"{0,plural,one {1 perce},other {# perce}}","seconds":"{0,plural,one {1 m\xe1sodperce},other {# m\xe1sodperce}}","star":"Megjel\xf6lt","unstar":"Jel\xf6letlen","mark":"Olvasott","unmark":"Olvasatlan","load_img":"K\xe9pbet\xf6lt\xe9s","open_window":"Megnyit\xe1s","searchbutton":"Keres\xe9s","sources":"H\xedrforr\xe1sok","source_add":"\xdaj h\xedrforr\xe1s","source_opml":"OPML-f\xe1jl import\xe1l\xe1sa","source_export":"H\xedrforr\xe1sok export\xe1l\xe1sa","source_edit":"M\xf3dos\xedt\xe1s","source_delete":"T\xf6rl\xe9s","source_warn":"Biztos t\xf6r\xf6lhet\u0151 a h\xedrforr\xe1s?","source_new":"\xdaj h\xedrforr\xe1s","source_title":"C\xedm","source_tags":"C\xedmk\xe9k","source_comma":"(vessz\u0151vel tagolva)","source_select":"A t\xedpus kiv\xe1laszt\xe1sa","source_type":"T\xedpus","source_save":"Ment\xe9s","source_cancel":"M\xe9gsem","source_saved":"Mentve","no_entries":"Nincs megjelen\xedthet\u0151 h\xedr.","more":"Tov\xe1bbiak","login":"Bejelentkez\xe9s","login_username":"Felhaszn\xe1l\xf3n\xe9v","login_password":"Jelsz\xf3","no_title":"Nincs c\xedm","filter":"Sz\u0171r\u0151","online_count":"A kiszolg\xe1l\xf3n l\xe9v\u0151 h\xedrek sz\xe1ma","offline_count":"A helyben t\xe1rolt h\xedrek sz\xe1ma","error_session_expired":"A munkamenet lej\xe1rt.","app_reload":"\xdajrat\xf6lt\xe9s","sources_refreshed":"Az \xfaj h\xedrek keres\xe9se k\xe9sz.","reload_list":"\xdajrat\xf6lt\xe9s","error_unwritable_logs":"A napl\xf3 nem \xedrhat\xf3.","error":"Hiba t\xf6rt\xe9nt","source_pwd_placeholder":"V\xe1ltozatlan","source_filter":"Sz\u0171r\u0151","loginbutton":"Bejelentkez\xe9s","logoutbutton":"Kijelentkez\xe9s","close_entry":"Bez\xe1r\xe1s","share_native_label":"Megoszt\xe1s","error_load_tags":"Nem siker\xfclt bet\xf6lteni a c\xedmk\xe9ket:","searchremove":"Keres\u0151panel elrejt\xe9se","next":"K\xf6vetkez\u0151","app_update":"A selfoss friss\xedtve lett, \xfajra kell t\xf6lteni az oldalt.","error_offline_storage":"T\xe1rol\xf3hiba kapcsolat n\xe9lk\xfcli m\xf3dban: {0}. Az \xfajrat\xf6lt\xe9s seg\xedthet. A kapcsolat n\xe9lk\xfcli m\xf3d mostant\xf3l ki van kapcsolva.","error_star_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr megjel\xf6lts\xe9g\xe9t:","days":"{0,plural,zero {ma},one {tegnap},other {# napja}}","share_twitter_label":"Twitter-megoszt\xe1s","share_mail_label":"Megoszt\xe1s e-mailben","settingsbutton":"Be\xe1ll\xedt\xe1sok","sources_loading":"H\xedrforr\xe1sok bet\xf6lt\xe9se\u2026","tag_change_color_button_title":"Sz\xedn cser\xe9je","entries_loading":"Bet\xf6lt\xe9s\u2026","login_invalid_credentials":"Hib\xe1s felhaszn\xe1l\xf3n\xe9v vagy jelsz\xf3","login_error_generic":"Sikertelen bejelentkez\xe9s: {errorMessage}","login_offline":"Kapcsolat n\xe9lk\xfcli t\xe1rol\xf3","experimental":"K\xeds\xe9rleti funkci\xf3","error_saving_color":"Nem siker\xfclt menteni az \xfaj sz\xednt:","error_sync":"Nem siker\xfclt szinkroniz\xe1lni a kiszolg\xe1l\xf3val:","error_configuration":"Nem siker\xfclt beolvasni a be\xe1ll\xedt\xe1sokat.","error_share_native_abort":"Nem siker\xfclt megosztani a h\xedrt \u2013 vagy nincsenek megoszt\xe1si c\xe9lok, vagy a m\u0171velet t\xf6r\xf6lve lett.","error_refreshing_source":"Nem siker\xfclt \xfaj h\xedreket keresni:","info_url_copied":"Az URL a v\xe1g\xf3lapra lett m\xe1solva.","article_actions":"M\u0171veletek","article_reading_time":"~{0} perc","share_diaspora_label":"Diaspora-megoszt\xe1s","share_facebook_label":"Facebook-megoszt\xe1s","offline_navigation_unavailable":"A c\xedmk\xe9k \xe9s h\xedrforr\xe1sok m\xf3dos\xedt\xe1sa kapcsolat n\xe9lk\xfcli m\xf3dban jelenleg nem t\xe1mogatott.","source_last_post":"Legut\xf3bbi h\xedr","source_refresh":"\xdaj h\xedrek keres\xe9se","source_go_to_settings":"Be\xe1ll\xedt\xe1sok","sources_leaving_unsaved_prompt":"Nem minden v\xe1ltoz\xe1s lett elmentve. Biztos bez\xe1rhat\xf3 be\xe1ll\xedt\xf3fel\xfclet?","error_share_native":"Nem siker\xfclt megosztani a h\xedrt.","share_mastodon_label":"Mastodon-megoszt\xe1s","share_pocket_label":"Pocket-ment\xe9s","share_wallabag_label":"Wallabag-ment\xe9s","share_wordpress_label":"WordPress-megoszt\xe1s","share_copy_label":"Hivatkoz\xe1s m\xe1sol\xe1sa","search_label":"Keres\u0151kifejez\xe9s","refreshbutton":"\xdaj h\xedrek keres\xe9se","no_sources":"Nincsenek megadva h\xedrforr\xe1sok.","source_menu":"Tov\xe1bbi m\u0171veletek","source_browse":"Megtekint\xe9s","source_deleting":"A h\xedrforr\xe1s t\xf6rl\xe9se\u2026","source_warn_cancel_dirty":"Bez\xe1r\xe1s ment\xe9s n\xe9lk\xfcl?","source_autotitle_hint":"\xdcresen hagyva automatikus kit\xf6lt\xe9s","source_params_loading":"Param\xe9terek bet\xf6lt\xe9se\u2026","source_saving":"A v\xe1ltoz\xe1sok ment\xe9se\u2026","login_in_progress":"Bejelentkez\xe9s\u2026","error_unauthorized":"A folytat\xe1shoz {link_begin}bejelentkez\xe9s{link_end} sz\xfcks\xe9ges.","error_check_log_file":"Hiba t\xf6rt\xe9nt, r\xe9szletek a napl\xf3f\xe1jlban: \u201E{0}\u201D.","error_check_system_logs":"Hiba t\xf6rt\xe9nt, r\xe9szletek a rendszernapl\xf3ban.","streamerror":"Nem t\xf6lt\u0151d\xf6tt le h\xedr. \xdajrat\xf6lt\xe9s?","error_add_source":"Nem siker\xfclt hozz\xe1adni a h\xedrforr\xe1st:","error_edit_source":"Nem siker\xfclt menteni a h\xedrforr\xe1s v\xe1ltoz\xe1sait:","error_delete_source":"Nem siker\xfclt t\xf6r\xf6lni a h\xedrforr\xe1st:","error_mark_items":"Nem siker\xfclt olvasottra \xe1ll\xedtani a megjelen\xedtett h\xedreket:","error_unknown_tag":"Ismeretlen c\xedmke:","error_unknown_source":"Ismeretlen h\xedrforr\xe1s-azonos\xedt\xf3:","error_mark_item":"Nem siker\xfclt m\xf3dos\xedtani a h\xedr olvasotts\xe1g\xe1t:","error_logout":"Nem siker\xfclt kijelentkezni:","error_loading":"Bet\xf6lt\xe9si hiba:","error_loading_stats":"Nem siker\xfclt bet\xf6lteni a b\xf6ng\xe9sz\xe9si statisztik\xe1t:","error_offline_storage_not_available":"Nem \xe1ll rendelkez\xe9sre t\xe1rol\xf3 a kapcsolat n\xe9lk\xfcli m\xf3dhoz. Ellen\u0151rizni kell, hogy a b\xf6ng\xe9sz\u0151 t\xe1mogatja-e az {0}IndexedDB API{1}-t, illetve Google Chrome alap\xfa b\xf6ng\xe9sz\u0151ben a selfoss nem haszn\xe1lhat\xf3 inkognit\xf3 m\xf3dban.","error_invalid_subsection":"\xc9rv\xe9nytelen aloldal:"}');


var $e1a0d6c367542bd9$exports = {};
$e1a0d6c367542bd9$exports = JSON.parse('{"timestamp":"{0,date} {0,time}","article_reading_time":"bacaan {0} menit","article_actions":"Tindakan","close_entry":"Tutup","info_url_copied":"Alamat URL disalin ke papanklip.","error_share_native":"Tidak dapat membagikan item.","error_share_native_abort":"Tidak dapat membagikan item\u2014kemungkinan disana tidak ada target untuk dibagikan, atau Anda membatalkan hal tersebut.","error_configuration":"Tidak dapat memuat konfigurasi.","error_invalid_subsection":"Subbagian tidak valid:","error_offline_storage_not_available":"Penyimpanan offline tidak tersedia. Pastikan peramban web Anda {0} mendukung DB API yang Terindeks {1} dan, jika Anda menggunakan peramban web Goggle Chrome, pastikan Anda tidak menjalankan selfoss di dalam mode incognito (rahasia).","error_offline_storage":"Kesalahan penyimpanan offline: {0}. Memuat ulang mungkin dapat membantu. Menonaktifkan offline untuk saat ini.","error_sync":"Tidak dapat mengsinkronisasi perubahan terakhir dari server:","error_refreshing_source":"Tidak dapat menyegarkan sumber:","error_saving_color":"Tidak dapat menyimpan warna baru:","error_loading_stats":"Tidak dapat memuat statistik navigasi:","error_loading":"Kesalahan dalam memuat:","error_logout":"Tidak dapat keluar:","error_star_item":"Tidak dapat bintangi/batal bintangi item:","error_mark_item":"Tidak dapat menandai/hapus tanda item:","error_mark_items":"Tidak dapat menandai semua item yang terlihat:","error_unknown_source":"ID sumber tidak diketahui:","error_unknown_tag":"Tag yang tidak diketahui:","error_load_tags":"Tidak dapat memuat tag:","error_delete_source":"Tidak dapat menghapus sumber:","error_edit_source":"Tidak dapat menyimpan perubahan sumber:","error_add_source":"Tidak dapat menambahkan sumber:","error_session_expired":"Sesi kadaluarsa","app_reload":"Muat ulang","app_update":"selfoss telah diperbarui, silahkan muat ulang","sources_refreshed":"Sumber telah disegarkan","reload_list":"Muat ulang daftar","streamerror":"Tidak ada item yang dimuat, muat ulang?","error_unwritable_logs":"Tidak dapat menulis log.","error_check_system_logs":"Sebuah kesalahan terjadi, silahkan periksa log sistem Anda.","error_check_log_file":"Sebuah kesalahan terjadi, silahkan periksa berkas log \\"{0}\\".","error":"Sebuah kesalahan terjadi","experimental":"Eksperimental","no_title":"Tidak ada judul","login_offline":"Penyimpanan offline","login_invalid_credentials":"Nama pengguna/kata sandi salah","login_password":"Kata sandi","login_username":"Nama pengguna","login":"Masuk","more":"Lebih banyak","no_entries":"Tidak ada entri ditemukan","source_refresh":"Segarkan sumber ini","source_last_post":"Postingan terakhir yang dilihat","source_cancel":"Batal","source_saved":"Disimpan","source_save":"Simpan","source_type":"Jenis","source_select":"Silahkan pilih sumber","source_comma":"Dipisahkan oleh koma","source_pwd_placeholder":"Tidak diubah","source_tags":"Tag","source_autotitle_hint":"Biarkan kosong untuk mengambil judul","source_title":"Judul","source_new":"Sumber baru yang belum disimpan","source_warn":"Yakin ingin menghapus sumber ini?","source_delete":"Hapus","source_filter":"Saring","source_edit":"Sunting","source_export":"Ekspor sumber","source_opml":"atau import sebuah berkas OPML","source_add":"Tambahkan sumber","sources":"Sumber","loginbutton":"Masuk","logoutbutton":"Keluar","settingsbutton":"Pengaturan","refreshbutton":"Segarkan sumber","searchremove":"Sembunyikan pencarian","searchbutton":"Cari","search_label":"Cari istilah","share_copy_label":"Salin tautan ke papanklip","share_mail_label":"Bagikan menggunakan email","share_wordpress_label":"Bagikan di WordPress","share_wallabag_label":"Simpan ke Wallabag","share_pocket_label":"Simpan ke Pocket","share_facebook_label":"Bagikan di Facebook","share_twitter_label":"Bagikan di Twitter","share_diaspora_label":"Bagikan di Diaspora","share_native_label":"Bagikan","load_img":"Tampilkan gambar","open_window":"Buka","next":"Selanjutnya","unmark":"Tandai sebagai belum dibaca","mark":"Tandai sebagai telah dibaca","unstar":"Batal Bintangi","star":"Bintangi","days":"{0,plural,zero {today},satu {yesterday},lainnya {# days ago}}","seconds":"{0,plural,one {1 second},lainnya {# seconds}} lalu","minutes":"{0,plural,one {1 minute},lainnya {# minutes}} lalu","hours":"{0,plural,one {1 hour},lainnya {# hours}} lalu","alltags":"Semua tag","tags":"Tag","offline_navigation_unavailable":"Menukar tag dan sumber saat ini tidak tersedia dalam mode offline.","offline_count":"Item tersedia secara lokal","online_count":"Item tersedia di server","starred":"Dilihat","unread":"Belum Dibaca","newest":"Terbaru","filter":"Saring","markread":"Tandai sebagai telah dibaca","entries_loading":"Memuat entri\u2026","source_deleting":"Menghapus sumber\u2026","source_saving":"Menyimpan perubahan sumber\u2026","sources_leaving_unsaved_prompt":"Tinggalkan setelan dengan perubahan sumber yang belum disimpan?","source_go_to_settings":"Buka pengaturan","source_menu":"Tindakan lainnya","login_in_progress":"Mencoba masuk\u2026","source_browse":"Telusuri","login_error_generic":"Tidak bisa masuk: {errorMessage}","source_params_loading":"Memuat parameter\u2026","share_mastodon_label":"Bagikan di Mastodon","sources_loading":"Memuat sumber\u2026","no_sources":"Tidak ada sumber yang dikonfigurasi.","error_unauthorized":"Silakan {link_begin}masuk{link_end} untuk melanjutkan.","source_warn_cancel_dirty":"Buang perubahan yang belum disimpan?","tag_change_color_button_title":"Ubah warna"}');


var $d48d8cf661c7528d$exports = {};
$d48d8cf661c7528d$exports = JSON.parse('{"markread":"Tutte lette","newest":"Recenti","unread":"Non lette","starred":"Contrassegnate","tags":"Etichette","alltags":"Tutte le etichette","timestamp":"{0,date} {0,time}","days":"{0,plural,one {1 ora},other {# ore}} fa","minutes":"{0,plural,one {1 minuto},other {# minuti}} fa","seconds":"{0,plural,one {1 secondo},other {# secondi}} fa","star":"Contrassegna","unstar":"Togli contrassegno","mark":"Segna come letta","unmark":"Segna come non letta","load_img":"Caricare le immagini","open_window":"Apri","searchbutton":"Ricerca","sources":"Fonti","source_add":"Aggiungi una fonte","source_opml":"o importa un file OPML / Google reader","source_export":"Esporta fonti","source_edit":"modifica","source_delete":"cancella","source_warn":"Vuoi veramente eliminare questa fonte?","source_new":"Nuova fonte","source_title":"Titolo","source_tags":"Etichette","source_comma":"separate da una virgola","source_select":"seleziona il tipo di fonte","source_type":"Tipo","source_save":"salva","source_cancel":"annulla","no_entries":"Nessuna pubblicazione","more":"Caricare altre pubblicazioni","login":"Accedi","login_username":"Nome utente","login_password":"Password","no_title":"Senza titolo","error_star_item":"Non \xe8 possibile contrassegnare/togliere il contrassegno per l\'elemento:","error_mark_item":"Impossibile segnare l\'elemento come letto/non letto:","article_actions":"Azioni","close_entry":"Chiudi","info_url_copied":"URL copiato negli appunti.","error_share_native":"Impossibile condividere l\'elemento.","error_share_native_abort":"Impossibile condividere l\'articolo\u202F\u2013\u202Fnon ci sono obiettivi di condivisione o l\'hai cancellato.","error_configuration":"Impossibile caricare la configurazione.","error_invalid_subsection":"Sottosezione non valida:","error_offline_storage":"Errore di archiviazione offline: {0}. Il ricaricamento pu\xf2 aiutare. Disabilitazione la modalit\xe0 offline per ora.","error_sync":"Impossibile sincronizzare le ultime modifiche dal server:","error_refreshing_source":"Impossibile aggiornare le fonti:","error_saving_color":"Impossibile salvare un nuovo colore:","error_loading_stats":"Impossibile caricare le statistiche di navigazione:","error_loading":"Errore di caricamento:","error_logout":"Impossibile uscire:","error_mark_items":"Impossibile contrassegnare tutti gli elementi visibili:","error_unknown_source":"Identificazione della fonte sconosciuta:","error_unknown_tag":"Etichetta sconosciuta:","error_load_tags":"Impossibile caricare le etichette:","error_delete_source":"Impossibile eliminare l\'origine:","error_add_source":"Impossibile aggiungere la fonte:","error_session_expired":"Sessione scaduta","app_reload":"Ricarica","app_update":"selfoss \xe8 stato aggiornato, si prega di ricaricare","sources_refreshed":"Fonti aggiornate","reload_list":"Ricarica l\'elenco","streamerror":"Nessun elemento caricato, ricaricare?","error":"Si \xe8 verificato un errore","source_refresh":"Aggiorna questa fonte","source_last_post":"Ultimo elemento visto","source_saved":"Salvato","source_pwd_placeholder":"Non cambiato","source_autotitle_hint":"Lascia vuoto per recuperare il titolo","source_filter":"Filtro","loginbutton":"Accedi","logoutbutton":"Esci","settingsbutton":"Impostazioni","refreshbutton":"Aggiorna le fonti","searchremove":"Nascondi la ricerca","search_label":"Termine di ricerca","share_copy_label":"Copia il collegamento negli appunti","share_wordpress_label":"Condividi su WordPress","share_wallabag_label":"Salva in Wallabag","share_pocket_label":"Salva in Pocket","share_facebook_label":"Condividi su Facebook","share_twitter_label":"Condividi su Twitter","share_diaspora_label":"Condividi su Diaspora","share_native_label":"Condividi","next":"Avanti","hours":"{0,plural,one {1 ora},other {# ore}} fa","offline_count":"Elementi disponibili localmente","online_count":"Articoli disponibili sul server","filter":"Filtra","share_mail_label":"Condividi via posta elettronica","login_offline":"Archiviazione offline","login_invalid_credentials":"Nome utente o password errato","error_offline_storage_not_available":"Non \xe8 disponibile memoria offline. Assicurati che il tuo browser web {0} supporti IdexedDB API {1} e che tu non stia utilizzando la modalit\xe0 incognito su browser basati su Google Chrome.","error_edit_source":"Impossibile salvare le modifiche alla fonte:","error_unwritable_logs":"Impossibile scrivere i log.","error_check_system_logs":"Si \xe8 verificato un errore, controlla i tuoi log di sistema.","error_check_log_file":"Si \xe8 verificato un errore, controlla il file di log \xab{0}\xbb.","offline_navigation_unavailable":"Al momento non \xe8 possibile modificare etichette e fonti nella modalit\xe0 fuori linea.","article_reading_time":"{0} min letti","experimental":"Sperimentale","source_go_to_settings":"Apri nelle impostazioni","sources_loading":"Caricamento delle fonti\u2026","source_deleting":"Eliminazione della fonte\u2026","source_browse":"Sfoglia","source_params_loading":"Caricamento dei parametri\u2026","no_sources":"Nessuna fonte configurata.","source_warn_cancel_dirty":"Scartare le modifiche non salvate?","source_menu":"Pi\xf9 azioni","sources_leaving_unsaved_prompt":"Esci dalle impostazioni con delle modifiche della fonte non salvate?","tag_change_color_button_title":"Cambia il colore","entries_loading":"Caricamento delle pubblicazioni\u2026","source_saving":"Salvataggio delle modifiche alla fonte\u2026","error_unauthorized":"Per favore {link_begin} connettiti{link_end} per continuare.","login_in_progress":"Tentativo di connessione\u2026","login_error_generic":"Connessione impossibile: {errorMessage}"}');


var $f0732a5d7f7054ed$exports = {};
$f0732a5d7f7054ed$exports = JSON.parse('{"markread":"\u65E2\u8AAD\u306B\u3059\u308B","filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","newest":"\u65B0\u7740","unread":"\u672A\u8AAD","starred":"\u30B9\u30BF\u30FC","tags":"\u30BF\u30B0","alltags":"\u5168\u3066\u306E\u30BF\u30B0","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u6642\u9593},other {# \u6642\u9593}}\u524D","minutes":"{0,plural,one {1 \u5206},other {# \u5206}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u65E5},one {\u6628\u65E5},other {# \u65E5\u524D}}","star":"\u30B9\u30BF\u30FC\u3092\u3064\u3051\u308B","unstar":"\u30B9\u30BF\u30FC\u3092\u5916\u3059","mark":"\u65E2\u8AAD\u306B\u3059\u308B","unmark":"\u672A\u8AAD\u306B\u3059\u308B","load_img":"\u753B\u50CF\u3092\u8868\u793A","open_window":"\u958B\u304F","next":"\u6B21\u3078","searchbutton":"\u691C\u7D22","searchremove":"\u691C\u7D22\u3092\u975E\u8868\u793A","refreshbutton":"\u30BD\u30FC\u30B9\u306E\u66F4\u65B0","settingsbutton":"\u8A2D\u5B9A","logoutbutton":"\u30ED\u30B0\u30A2\u30A6\u30C8","loginbutton":"\u30ED\u30B0\u30A4\u30F3","sources":"\u30BD\u30FC\u30B9","source_add":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0","source_opml":"\u307E\u305F\u306F OPML \u30D5\u30A1\u30A4\u30EB\u3092\u30A4\u30F3\u30DD\u30FC\u30C8","source_export":"\u30BD\u30FC\u30B9\u3092\u30A8\u30AF\u30B9\u30DD\u30FC\u30C8","source_edit":"\u7DE8\u96C6","source_filter":"\u30D5\u30A3\u30EB\u30BF\u30FC","source_delete":"\u524A\u9664","source_warn":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3057\u307E\u3059\u304B\uFF1F","source_new":"\u65B0\u3057\u3044\u672A\u4FDD\u5B58\u306E\u30BD\u30FC\u30B9","source_title":"\u30BF\u30A4\u30C8\u30EB","source_tags":"\u30BF\u30B0","source_pwd_placeholder":"\u5909\u66F4\u3055\u308C\u3066\u3044\u307E\u305B\u3093","source_comma":"\u30AB\u30F3\u30DE(,)\u533A\u5207\u308A","source_select":"\u30BD\u30FC\u30B9\u3092\u9078\u629E\u3057\u3066\u304F\u3060\u3055\u3044","source_type":"\u30BF\u30A4\u30D7","source_save":"\u4FDD\u5B58","source_cancel":"\u30AD\u30E3\u30F3\u30BB\u30EB","source_saved":"\u4FDD\u5B58\u3055\u308C\u307E\u3057\u305F","source_last_post":"\u6700\u7D42\u53C2\u7167\u65E5","source_refresh":"\u3053\u306E\u30BD\u30FC\u30B9\u3092\u66F4\u65B0","no_entries":"\u8A18\u4E8B\u304C\u3042\u308A\u307E\u305B\u3093","more":"\u3082\u3063\u3068\u898B\u308B","login":"\u30ED\u30B0\u30A4\u30F3","login_username":"\u30E6\u30FC\u30B6\u30FC\u540D","login_password":"\u30D1\u30B9\u30EF\u30FC\u30C9","no_title":"\u30BF\u30A4\u30C8\u30EB\u306A\u3057","error":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F","streamerror":"\u8A18\u4E8B\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3067\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u307E\u3059\u304B\uFF1F","source_autotitle_hint":"\u7A7A\u306E\u307E\u307E\u306B\u3059\u308B\u3068\u30BF\u30A4\u30C8\u30EB\u3092\u53D6\u5F97\u3057\u307E\u3059","login_invalid_credentials":"\u30E6\u30FC\u30B6\u30FC\u540D/\u30D1\u30B9\u30EF\u30FC\u30C9\u304C\u9593\u9055\u3063\u3066\u3044\u307E\u3059","reload_list":"\u4E00\u89A7\u3092\u518D\u8AAD\u307F\u8FBC\u307F","sources_refreshed":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3057\u307E\u3057\u305F","error_session_expired":"\u30BB\u30C3\u30B7\u30E7\u30F3\u304C\u671F\u9650\u5207\u308C\u3067\u3059","error_add_source":"\u30BD\u30FC\u30B9\u3092\u8FFD\u52A0\u3067\u304D\u307E\u305B\u3093:","error_delete_source":"\u30BD\u30FC\u30B9\u3092\u524A\u9664\u3067\u304D\u307E\u305B\u3093:","error_load_tags":"\u30BF\u30B0\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","error_unknown_tag":"\u4E0D\u660E\u306A\u30BF\u30B0:","error_unknown_source":"\u4E0D\u660E\u306A\u30BD\u30FC\u30B9ID:","error_mark_items":"\u3059\u3079\u3066\u306E\u8868\u793A\u9805\u76EE\u3092\u30DE\u30FC\u30AF\u3067\u304D\u307E\u305B\u3093:","error_mark_item":"\u9805\u76EE\u3092\u30DE\u30FC\u30AF/\u30DE\u30FC\u30AF\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","error_star_item":"\u9805\u76EE\u3092\u30B9\u30BF\u30FC/\u30B9\u30BF\u30FC\u89E3\u9664\u3067\u304D\u307E\u305B\u3093:","error_logout":"\u30ED\u30B0\u30A2\u30A6\u30C8\u3067\u304D\u307E\u305B\u3093:","error_loading":"\u8AAD\u307F\u8FBC\u307F\u30A8\u30E9\u30FC:","error_loading_stats":"NAV\u7D71\u8A08\u3092\u8AAD\u307F\u8FBC\u307F\u3067\u304D\u307E\u305B\u3093:","error_saving_color":"\u65B0\u3057\u3044\u8272\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093:","error_refreshing_source":"\u30BD\u30FC\u30B9\u3092\u66F4\u65B0\u3067\u304D\u307E\u305B\u3093:","error_sync":"\u30B5\u30FC\u30D0\u304B\u3089\u6700\u5F8C\u306E\u5909\u66F4\u3092\u540C\u671F\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F:","error_invalid_subsection":"\u4E0D\u6B63\u306A\u30B5\u30D6\u30BB\u30AF\u30B7\u30E7\u30F3:","online_count":"\u30B5\u30FC\u30D0\u30FC\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","offline_count":"\u30ED\u30FC\u30AB\u30EB\u3067\u5229\u7528\u53EF\u80FD\u306A\u9805\u76EE","login_offline":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8","app_update":"selfoss \u304C\u66F4\u65B0\u3055\u308C\u307E\u3057\u305F\u3002\u518D\u8AAD\u307F\u8FBC\u307F\u3057\u3066\u304F\u3060\u3055\u3044","app_reload":"\u518D\u8AAD\u307F\u8FBC\u307F","error_offline_storage":"\u30AA\u30D5\u30E9\u30A4\u30F3 \u30B9\u30C8\u30EC\u30FC\u30B8 \u30A8\u30E9\u30FC: {0}\u3002 \u518D\u8AAD\u307F\u8FBC\u307F\u304C\u5F79\u7ACB\u3064\u3053\u3068\u304C\u3042\u308A\u307E\u3059\u3002\u4ECA\u306E\u3068\u3053\u308D\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u3092\u7121\u52B9\u306B\u3057\u307E\u3059\u3002","search_label":"\u691C\u7D22\u6761\u4EF6","article_actions":"\u30A2\u30AF\u30B7\u30E7\u30F3","error_configuration":"\u8A2D\u5B9A\u3092\u8AAD\u307F\u8FBC\u3081\u307E\u305B\u3093\u3002","info_url_copied":"URL\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC\u3057\u307E\u3057\u305F\u3002","article_reading_time":"{0} \u5206 \u8AAD\u307F\u307E\u3057\u305F","source_menu":"\u305D\u306E\u4ED6\u306E\u30A2\u30AF\u30B7\u30E7\u30F3","source_browse":"\u691C\u7D22","source_warn_cancel_dirty":"\u4FDD\u5B58\u3055\u308C\u3066\u3044\u306A\u3044\u5909\u66F4\u3092\u7834\u68C4\u3057\u307E\u3059\u304B\uFF1F","sources_leaving_unsaved_prompt":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u305B\u305A\u306B\u8A2D\u5B9A\u3092\u6B8B\u3057\u307E\u3059\u304B\uFF1F","experimental":"\u8A66\u9A13\u7684","error_check_system_logs":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30B7\u30B9\u30C6\u30E0\u30ED\u30B0\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error_edit_source":"\u30BD\u30FC\u30B9\u306E\u5909\u66F4\u3092\u4FDD\u5B58\u3067\u304D\u307E\u305B\u3093\u3067\u3057\u305F\uFF1A","error_share_native":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u3002","error_share_native_abort":"\u30A2\u30A4\u30C6\u30E0\u3092\u5171\u6709\u3067\u304D\u307E\u305B\u3093\u2014\u5171\u6709\u5148\u304C\u306A\u3044\u304B\u3001\u30AD\u30E3\u30F3\u30BB\u30EB\u3057\u307E\u3057\u305F\u3002","share_pocket_label":"Pocket \u306B\u4FDD\u5B58","share_twitter_label":"Twitter \u3067\u30B7\u30A7\u30A2","close_entry":"\u9589\u3058\u308B","share_facebook_label":"Facebook \u3067\u30B7\u30A7\u30A2","offline_navigation_unavailable":"\u73FE\u5728\u3001\u30AA\u30D5\u30E9\u30A4\u30F3\u30E2\u30FC\u30C9\u3067\u306F\u30BF\u30B0\u3068\u30BD\u30FC\u30B9\u306E\u5207\u308A\u66FF\u3048\u304C\u3067\u304D\u307E\u305B\u3093\u3002","share_diaspora_label":"Diaspora \u3067\u30B7\u30A7\u30A2","share_wallabag_label":"Wallabag \u306B\u4FDD\u5B58","share_copy_label":"\u30EA\u30F3\u30AF\u3092\u30AF\u30EA\u30C3\u30D7\u30DC\u30FC\u30C9\u306B\u30B3\u30D4\u30FC","error_check_log_file":"\u30A8\u30E9\u30FC\u304C\u767A\u751F\u3057\u307E\u3057\u305F\u3002\u30ED\u30B0\u30D5\u30A1\u30A4\u30EB\u300C{0}\u300D\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","error_unwritable_logs":"\u30ED\u30B0\u3092\u66F8\u304D\u8FBC\u3081\u307E\u305B\u3093\u3002","share_mail_label":"\u30E1\u30FC\u30EB\u3092\u4F7F\u7528\u3057\u3066\u5171\u6709","share_native_label":"\u5171\u6709","share_wordpress_label":"WordPress \u3067\u30B7\u30A7\u30A2","error_offline_storage_not_available":"\u30AA\u30D5\u30E9\u30A4\u30F3\u30B9\u30C8\u30EC\u30FC\u30B8\u306F\u5229\u7528\u3067\u304D\u307E\u305B\u3093\u3002 Web\u30D6\u30E9\u30A6\u30B6 {0} \u304CIndexedDBAPI {1} \u3092\u30B5\u30DD\u30FC\u30C8\u3057\u3066\u3044\u308B\u3053\u3068\u3001\u304A\u3088\u3073 Google Chrome \u30D9\u30FC\u30B9\u306E\u30D6\u30E9\u30A6\u30B6\u3092\u4F7F\u7528\u3057\u3066\u3044\u308B\u5834\u5408\u306F\u3001\u30B7\u30FC\u30AF\u30EC\u30C3\u30C8\u30E2\u30FC\u30C9\u3067 selfoss \u3092\u5B9F\u884C\u3057\u3066\u3044\u306A\u3044\u3053\u3068\u3092\u78BA\u8A8D\u3057\u3066\u304F\u3060\u3055\u3044\u3002","share_mastodon_label":"Mastodon \u3067\u30B7\u30A7\u30A2"}');


var $5170287447d26972$exports = {};
$5170287447d26972$exports = JSON.parse('{"markread":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","filter":"filtrs","newest":"jaun\u0101kais","unread":"neizlas\u012Bts","starred":"ar zvaigzn\u012Bt\u0113m","tags":"Birkas","alltags":"visas birkas","timestamp":"{0,date} {0,time}","hours":"pirms {0,plural,one {1 stundas},other {# stund\u0101m}}","minutes":"pirms {0,plural,one {1 min\u016Btes},other {# min\u016Bt\u0113m}}","seconds":"pirms {0,plural,one {1 sekundes},other {# sekund\u0113m}}","days":"{0,plural,zero {\u0161odien},one {vakardien},other {pirms # dien\u0101m}}","star":"pievienot zvaigzn\u012Bti","unstar":"no\u0146emt zvaigzn\u012Bti","mark":"atz\u012Bm\u0113t k\u0101 izlas\u012Btu","unmark":"atz\u012Bm\u0113t k\u0101 neizlas\u012Btu","load_img":"iel\u0101d\u0113t bildes","open_window":"atv\u0113rt","next":"n\u0101kamais","searchbutton":"mekl\u0113t","searchremove":"sl\u0113pt mekl\u0113\u0161anu","refreshbutton":"atsvaidzin\u0101t avotus","settingsbutton":"iestat\u012Bjumi","logoutbutton":"iziet","loginbutton":"ieiet","sources":"Avoti","source_add":"pievienot avotu","source_opml":"vai import\u0113t opml failu, vai google las\u012Bt\u0101ju","source_export":"eksport\u0113t avotus","source_edit":"labot","source_filter":"Filtrs","source_delete":"dz\u0113st","source_warn":"Vai tie\u0161\u0101m v\u0113laties dz\u0113st \u0161o avotu?","source_new":"nesaglab\u0101ts avots","source_title":"Nosaukums","source_tags":"Birkas","source_pwd_placeholder":"nav main\u012Bjies","source_comma":"atdal\u012Bt ar komatu","source_select":"l\u016Bdzu izv\u0113lieties avotu","source_type":"Tips","source_save":"saglab\u0101t","source_cancel":"atcelt","source_saved":"saglab\u0101ts","source_last_post":"P\u0113d\u0113j\u0101 zi\u0146a redz\u0113ta","no_entries":"nav ierakstu","more":"v\u0113l","login":"ien\u0101kt","login_username":"Lietot\u0101jv\u0101rds","login_password":"Parole","no_title":"nav nosaukuma","error":"k\u013C\u016Bda","streamerror":"Zi\u0146as nav iel\u0101d\u0113tas, p\u0101rl\u0101d\u0113t?"}');


var $7058dfe60927e7af$exports = {};
$7058dfe60927e7af$exports = JSON.parse('{"markread":"Marker som lest","newest":"Nyeste","unread":"Ulest","starred":"Stjernemerket","tags":"Etiketter","alltags":"Alle etiketter","timestamp":"{0,date} {0,time}","hours":"for {0,plural,one {\xe9n time},other {# timer}} ago","minutes":"for {0,plural,one {ett minutt},other {# minutter}} ago","seconds":"for {0,plural,one {ett sekund},other {# sekunder}} siden","star":"Stjernemerk","unstar":"Fjern stjerne","mark":"Marker som lest","unmark":"Marker som ulest","load_img":"Vis bilder","open_window":"\xc5pne","searchbutton":"S\xf8k","sources":"Kilder","source_add":"Legg til kilde","source_opml":"eller importer en OPML-fil","source_export":"Eksporter kilder","source_edit":"Endre","source_delete":"Slett","source_warn":"Vil du virkelig fjerne denne kilden?","source_new":"Ny ulagret kilde","source_title":"Tittel","source_tags":"Etiketter","source_comma":"Kommainndelt","source_select":"Velg kilde","source_type":"Type","source_save":"Lagre","source_cancel":"Avbryt","source_saved":"Lagret","no_entries":"Ingen data funnet","more":"Mer","login":"Logg inn","login_username":"Brukernavn","login_password":"Passord","filter":"Filtrer","days":"{0,plural,zero {i dag},one {i g\xe5r},other {# dager siden}}","next":"Neste","searchremove":"Skjul s\xf8k","refreshbutton":"Gjenoppfrisk kilder","settingsbutton":"Innstillinger","logoutbutton":"Logg ut","loginbutton":"Logg inn","source_filter":"Filter","source_autotitle_hint":"La st\xe5 tom for \xe5 hente tittel","source_pwd_placeholder":"Ikke endret","source_last_post":"Siste post sett","source_refresh":"Gjenoppfrisk denne kilden","login_invalid_credentials":"Feil brukernavn/passord","no_title":"Ingen tittel","error":"En feil inntraff","streamerror":"Ingen elementer ble lastet inn, gjeninnlast?","reload_list":"Gjeninnlast liste","sources_refreshed":"Kilder gjeninnlastet","error_session_expired":"\xd8kt utl\xf8pt","error_add_source":"Kunne ikke legge til kilde:","error_delete_source":"Kunne ikke slette kilde:","error_load_tags":"Kunne ikke laste inn etiketter:","error_unknown_tag":"Ukjent etikett:","error_unknown_source":"Ukjent kilde-ID:","error_mark_items":"Kan ikke merke alle synlige elementer:","error_mark_item":"Kan ikke merke/oppheve merking av element:","error_star_item":"Kan ikke stjernemerke/oppheve stjernemerking av element:","error_logout":"Kunne ikke logge ut:","error_loading":"Innlastingsfeil:","error_loading_stats":"Kan ikke laste navigeringsstatistikk:","error_saving_color":"Kan ikke lagre ny farge:","error_refreshing_source":"Kan ikke gjenoppfriske kilder:","error_sync":"Kunne ikke synkronisere siste endringer fra tjener:","error_invalid_subsection":"Ugyldig underdel:","online_count":"Elementer tilgjengelige p\xe5 tjeneren","offline_count":"Elementer tilgjengelige lokalt","login_offline":"Frakoblet lagring","app_update":"selfoss har blitt oppdatert, last inn p\xe5 ny","app_reload":"Gjeninnlast","error_offline_storage":"Lagringsfeil for frakoblet lagring: {0}. Gjeninnlasting kan hjelpe. Skrur av frakoblet imens.","search_label":"S\xf8ketekst","article_actions":"Handlinger","error_configuration":"Kunne ikke laste inn oppsett.","info_url_copied":"Nettadresse kopiert til utklippstavle.","share_native_label":"Del","share_diaspora_label":"Del p\xe5 Diaspora","share_twitter_label":"Del p\xe5 Twitter","share_facebook_label":"Del p\xe5 Facebook","share_pocket_label":"Del til Pocket","share_wallabag_label":"Lagre p\xe5 Wallabag","share_wordpress_label":"Lagre p\xe5 WordPress","share_mail_label":"Del ved bruk av e-post","share_copy_label":"Kopier lenke til utklippstavle","error_share_native_abort":"Kunne ikke dele element, enten finnes det ingen delingsm\xe5l, eller du har avbrutt deling.","error_share_native":"Kunne ikke dele element.","close_entry":"Lukk","error_unwritable_logs":"Kunne ikke loggf\xf8re.","error_check_log_file":"En feil inntraff, sjekk loggfilen \u201C{0}\u201D.","error_check_system_logs":"En feil inntraff, sjekk systemloggene dine.","offline_navigation_unavailable":"\xc5 bytte etiketter og kilder st\xf8ttes forel\xf8pig ikke i frakoblet modus.","error_offline_storage_not_available":"Frakoblet lager ikke tilgjengelig. S\xf8rg for at din nettleser {0}st\xf8tter IndexedDB-API-et{1}, samt at du ikke bruker incognito-modus i en Chrome-basert nettleser.","error_edit_source":"Kunne ikke lagre kildeendringer:","article_reading_time":"{0} min \xe5 lese","experimental":"Eksperimentell","sources_leaving_unsaved_prompt":"Forlat innstillinger med ulagrede kildeendringer?","source_warn_cancel_dirty":"Forkast ulagrede endringer?"}');


var $51d8b37b1373d182$exports = {};
$51d8b37b1373d182$exports = JSON.parse("{\"markread\":\"markeer gelezen\",\"newest\":\"nieuwste\",\"unread\":\"ongelezen\",\"starred\":\"met ster\",\"tags\":\"Tags\",\"alltags\":\"alle tags\",\"timestamp\":\"{0,date} {0,time}\",\"hours\":\"{0,plural,one {1 hour},other {# uren}} geleden\",\"minutes\":\"{0,plural,one {1 minute},other {# minuten}} geleden\",\"seconds\":\"{0,plural,one {1 second},other {# seconden}} geleden\",\"days\":\"{0,plural,zero {vandaag},one {gisteren},other {# dagen geleden}}\",\"star\":\"ster\",\"unstar\":\"ster verwijderen\",\"mark\":\"gelezen\",\"unmark\":\"ongelezen\",\"load_img\":\"afbeeldingen tonen\",\"open_window\":\"open\",\"searchbutton\":\"zoeken\",\"sources\":\"Bron\",\"source_add\":\"bron toevoegen\",\"source_opml\":\"of importeer opml bestand of google reader\",\"source_export\":\"exporteer bronnen\",\"source_edit\":\"wijzig\",\"source_delete\":\"verwijder\",\"source_warn\":\"bron echt verwijderen?\",\"source_new\":\"nieuwe bron\",\"source_title\":\"Titel\",\"source_tags\":\"Tags\",\"source_comma\":\"komma gescheiden\",\"source_select\":\"selecteer een bron\",\"source_type\":\"Soort\",\"source_save\":\"opslaan\",\"source_cancel\":\"annuleren\",\"source_saved\":\"opgeslagen\",\"source_last_post\":\"Meest recente artikel is gevonden\",\"no_entries\":\"geen items gevonden\",\"more\":\"meer\",\"login\":\"inloggen\",\"login_username\":\"gebruikersnaam\",\"login_password\":\"wachtwoord\",\"no_title\":\"geen titel\"}");


var $3d25a85d30cd5367$exports = {};
$3d25a85d30cd5367$exports = JSON.parse('{"markread":"oznacz jako przeczytane","filter":"filtr","newest":"najnowsze","unread":"nieprzeczytane","starred":"z gwiazdk\u0105","tags":"Tagi","alltags":"wszystkie","timestamp":"{0,date} {0,time}","hours":"przed {0,plural,one {godzin\u0105},other {# godzinami}}","minutes":"przed {0,plural,one {minut\u0105},other {# minutami}}","seconds":"przed {0,plural,one {chwil\u0105},other {# sekundami}}","days":"{0,plural,zero {dzisiaj},one {wczoraj},other {przejrzany # dni temu}}","star":"oznacz gwiazdk\u0105","unstar":"usu\u0144 gwiazdk\u0119","mark":"oznacz jako przeczytane","unmark":"oznacz jako nieprzeczytane","load_img":"pobierz obrazy","open_window":"otw\xf3rz","next":"nast\u0119pny","searchbutton":"szukaj","searchremove":"ukryj wyszukiwanie","refreshbutton":"od\u015Bwie\u017C","settingsbutton":"opcje","logoutbutton":"wyloguj","loginbutton":"zaloguj","sources":"\u0179r\xf3d\u0142a","source_add":"dodaj \u017Ar\xf3d\u0142o","source_opml":"lub zaimportuj plik OPML z Google Reader","source_export":"eksportuj \u017Ar\xf3d\u0142a","source_edit":"edytuj","source_filter":"Filtr","source_delete":"usu\u0144","source_warn":"Czy na pewno chcesz usun\u0105\u0107 to \u017Ar\xf3d\u0142o?","source_new":"nowe niezapisane \u017Ar\xf3d\u0142o","source_title":"Tytu\u0142","source_autotitle_hint":"Pozostaw puste, aby uzupe\u0142ni\u0107 automatycznie","source_tags":"Tagi","source_pwd_placeholder":"bez zmian","source_comma":"rozdzielone przecinkami","source_select":"prosz\u0119 wybra\u0107 typ \u017Ar\xf3d\u0142a","source_type":"Typ","source_save":"zapisz","source_cancel":"anuluj","source_saved":"zapisano","source_last_post":"Ostatni artyku\u0142 zosta\u0142 przejrzany ","source_refresh":"Od\u015Bwie\u017C to \u017Ar\xf3d\u0142o","no_entries":"brak wpis\xf3w","more":"wi\u0119cej","login":"zaloguj","login_username":"u\u017Cytkownik","login_password":"has\u0142o","login_invalid_credentials":"nieprawid\u0142owy login lub has\u0142o.","no_title":"bez tytu\u0142u","error":"wyst\u0105pi\u0142 b\u0142\u0105d","streamerror":"Nie za\u0142adowano \u017Cadnych element\xf3w, od\u015Bwie\u017Cy\u0107?","error_loading":"B\u0142\u0105d podczas \u0142adowania:","experimental":"Eksperymentalny","article_actions":"Dzia\u0142ania","share_native_label":"Udost\u0119pnij","source_browse":"Przegl\u0105daj","app_reload":"Za\u0142aduj ponownie","error_session_expired":"Sesja wygas\u0142a","close_entry":"Zamknij","sources_refreshed":"Od\u015Bwie\u017Cono \u017Ar\xf3d\u0142a","error_unknown_tag":"Nieznany tag:"}');


var $b01b1dfd07b9091e$exports = {};
$b01b1dfd07b9091e$exports = JSON.parse('{"share_mail_label":"Compartilhar usando correio eletr\xf4nico","error":"um erro ocorreu","no_title":"sem t\xedtulo","login_password":"palavra-passe","login_username":"utilizador","login":"entrar","more":"mais","no_entries":"nenhum registo encontrado","source_saved":"gravado","source_cancel":"cancelar","source_save":"gravar","source_type":"Tipo","source_select":"por favor, selecione a fonte","source_comma":"separado por v\xedrgula","source_tags":"Marcadores","source_title":"T\xedtulo","source_new":"nova fonte (n\xe3o salva)","source_warn":"realmente deletar esta fonte?","source_delete":"deletar","source_filter":"Filtro","source_edit":"editar","source_export":"exportar fontes","source_opml":"ou importar ficheiro opml ou google reader","source_add":"adicionar fonte","sources":"Fontes","loginbutton":"entrar","logoutbutton":"sair","settingsbutton":"configura\xe7\xf5es","refreshbutton":"atualizar fontes","searchbutton":"procurar","next":"pr\xf3ximo","open_window":"abrir","load_img":"carregar Imagens","unmark":"marcar como n\xe3o lido","mark":"marcar como lido","unstar":"remover estrela","star":"marcar com estrela","seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","timestamp":"{0,date} {0,time}","alltags":"todos os marcadores","tags":"Marcadores","starred":"com estrela","unread":"n\xe3o lidos","newest":"novos","markread":"marcar como lido","source_last_post":"\xdaltima postagem vista","source_menu":"Mais a\xe7\xf5es","offline_navigation_unavailable":"A troca de etiquetas e fontes n\xe3o est\xe1 atualmente dispon\xedvel em modo offline.","offline_count":"Artigos dispon\xedveis localmente","searchremove":"Ocultar busca","share_diaspora_label":"Compartilhar na Di\xe1spora","share_facebook_label":"Compartilhar no Facebook","share_pocket_label":"Salvar no Pocket","share_wallabag_label":"Salvar no Wallabag","share_copy_label":"Copiar link para a \xe1rea de transfer\xeancia","source_refresh":"Atualizar esta fonte","share_native_label":"Compartilhar","search_label":"Termo de pesquisa","sources_leaving_unsaved_prompt":"Deixar configura\xe7\xf5es com altera\xe7\xf5es de fonte n\xe3o salvas?","online_count":"Itens dispon\xedveis no servidor","share_wordpress_label":"Compartilhar no WordPress","source_autotitle_hint":"Deixe vazio para buscar t\xedtulo","source_browse":"Navegar","source_warn_cancel_dirty":"Descartar altera\xe7\xf5es n\xe3o salvas?","filter":"Filtro","share_twitter_label":"Compartilhe no Twitter","tag_change_color_button_title":"Alterar a cor","sources_loading":"Carregando fontes\u2026","no_sources":"Nenhuma fonte configurada.","source_deleting":"Excluindo fonte\u2026","source_pwd_placeholder":"N\xe3o alterado","source_params_loading":"Carregando par\xe2metros\u2026","source_saving":"Salvar mudan\xe7as de fonte\u2026","source_go_to_settings":"Abrir nas configura\xe7\xf5es","entries_loading":"Carregando entradas\u2026","login_in_progress":"Tentando fazer login\u2026"}');


var $f7917dde3df00ba4$exports = {};
$f7917dde3df00ba4$exports = JSON.parse('{"markread":"marcar como lido","newest":"novos","unread":"n\xe3o lidos","starred":"com estrela","tags":"Marcadores","alltags":"todos os marcadores","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 hora},other {# horas}} atr\xe1s","minutes":"{0,plural,one {1 minuto},other {# minutos}} atr\xe1s","seconds":"{0,plural,one {1 segundo},other {# segundos}} atr\xe1s","star":"marcar com estrela","unstar":"remover estrela","mark":"marcar como lido","unmark":"marcar como n\xe3o lido","load_img":"carregar Imagens","open_window":"abrir","next":"pr\xf3ximo","searchbutton":"procurar","refreshbutton":"atualizar fontes","settingsbutton":"configura\xe7\xf5es","logoutbutton":"sair","loginbutton":"entrar","sources":"Fontes","source_add":"adicionar fonte","source_opml":"ou importar arquivo opml ou google reader","source_export":"exportar fontes","source_edit":"editar","source_filter":"Filtro","source_delete":"deletar","source_warn":"realmente deletar esta fonte?","source_new":"nova fonte (n\xe3o salva)","source_title":"T\xedtulo","source_tags":"Marcadores","source_comma":"separado por v\xedrgula","source_select":"por favor, selecione a fonte","source_type":"Tipo","source_save":"salvar","source_cancel":"cancelar","source_saved":"salvo","no_entries":"nenhum registro encontrado","more":"mais","login":"entrar","login_username":"usu\xe1rio","login_password":"senha","no_title":"sem t\xedtulo","error":"um erro ocorreu","share_mail_label":"Compartilhar usando correio eletr\xf4nico"}');


var $3e02282570dcf5ad$exports = {};
$3e02282570dcf5ad$exports = JSON.parse('{"markread":"marcar sco leg\xec","newest":"pli novas","unread":"nunleg\xec","starred":"cun staila","tags":"Etichettas","alltags":"tut las etichettas","timestamp":"{0,date} {0,time}","hours":"Avant {0,plural,one {1 ura},other {# uras}}","minutes":"Avant {0,plural,one {1 minuta},other {# minutas}}","seconds":"Avant {0,plural,one {1 secunda},other {# secundas}}","star":"agiuntar staila","unstar":"allontanar staila","mark":"marcar sco leg\xec","unmark":"marcar sco nunleg\xec","load_img":"chargiar maletgs","open_window":"avrir","searchbutton":"tschertgar","sources":"Funtaunas","source_add":"agiuntar funtauna","source_opml":"u importar ina datoteca opml u da google reader","source_export":"exportar las funtaunas","source_edit":"modifitgar","source_delete":"stizzar","source_warn":"propi stizzar questa funtauna?","source_new":"nova funtauna betg memorisada","source_title":"Titel","source_tags":"Etichettas","source_comma":"seper\xe0 entras commas","source_select":"tscherna p.pl. la funtauna","source_type":"Tip","source_save":"memorisar","source_cancel":"interrumper","source_saved":"memoris\xe0","no_entries":"chatt\xe0 naginas endataziuns","more":"dapli","login":"s\'annunziar","login_username":"num d\'utilisader","login_password":"pled-clav","no_title":"nagin titel"}');


var $ee2b610e60c3d44b$exports = {};
$ee2b610e60c3d44b$exports = JSON.parse('{"markread":"\u043F\u043E\u043C\u0435\u0442\u0438\u0442\u044C \u043A\u0430\u043A \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","newest":"\u0441\u0432\u0435\u0436\u0438\u0435","unread":"\u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043D\u044B\u0435","starred":"\u043E\u0442\u043C\u0435\u0447\u0435\u043D\u043D\u044B\u0435","tags":"\u041C\u0435\u0442\u043A\u0438","alltags":"\u0432\u0441\u0435 \u043C\u0435\u0442\u043A\u0438","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u0447\u0430\u0441},other {# \u0447\u0430\u0441\u043E\u0432}} \u043D\u0430\u0437\u0430\u0434","minutes":"{0,plural,one {1 \u043C\u0438\u043D\u0443\u0442\u0443},other {# \u043C\u0438\u043D\u0443\u0442}} \u043D\u0430\u0437\u0430\u0434","seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434}} \u043D\u0430\u0437\u0430\u0434","star":"\u043E\u0442\u043C\u0435\u0442\u0438\u0442\u044C","unstar":"\u0441\u043D\u044F\u0442\u044C \u043E\u0442\u043C\u0435\u0442\u043A\u0443","mark":"\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","unmark":"\u043D\u0435 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u043E","load_img":"\u0437\u0430\u0433\u0440\u0443\u0437\u0438\u0442\u044C \u0438\u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u0438\u044F","open_window":"\u043E\u0442\u043A\u0440\u044B\u0442\u044C","searchbutton":"\u041F\u043E\u0438\u0441\u043A","sources":"\u0418\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0438","source_add":"\u0434\u043E\u0431\u0430\u0432\u0438\u0442\u044C \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","source_opml":"\u0438\u043B\u0438 \u0438\u043C\u043F\u043E\u0440\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0444\u0430\u0439\u043B OPML, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0438\u0437 Google Reader","source_export":"\u044D\u043A\u0441\u043F\u043E\u0440\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u043E\u0432","source_edit":"\u043F\u0440\u0430\u0432\u0438\u0442\u044C","source_delete":"\u0443\u0434\u0430\u043B\u0438\u0442\u044C","source_warn":"\u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u044D\u0442\u043E\u0442 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A?","source_new":"\u043D\u043E\u0432\u044B\u0439 \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A","source_title":"\u041D\u0430\u0437\u0432\u0430\u043D\u0438\u0435","source_tags":"\u041C\u0435\u0442\u043A\u0438","source_comma":"\u0440\u0430\u0434\u0435\u043B\u044F\u0439\u0442\u0435 \u0437\u0430\u043F\u044F\u0442\u043E\u0439","source_select":"\u0432\u044B\u0431\u0435\u0440\u0438\u0442\u0435 \u0442\u0438\u043F \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0430","source_type":"\u0422\u0438\u043F","source_save":"\u0441\u043E\u0445\u0440\u0430\u043D\u0438\u0442\u044C","source_cancel":"\u043E\u0442\u043C\u0435\u043D\u0430","source_saved":"\u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043E","no_entries":"\u0437\u0430\u043F\u0438\u0441\u0435\u0439 \u043D\u0435 \u043D\u0430\u0439\u0434\u0435\u043D\u043E","more":"\u0435\u0449\u0435","login":"\u0432\u0445\u043E\u0434","login_username":"\u0438\u043C\u044F","login_password":"\u043F\u0430\u0440\u043E\u043B\u044C","no_title":"\u0431\u0435\u0437 \u043D\u0430\u0437\u0432\u0430\u043D\u0438\u044F","searchremove":"\u0421\u043A\u0440\u044B\u0442\u044C \u043F\u043E\u0438\u0441\u043A"}');


var $430ac65b39f56697$exports = {};
$430ac65b39f56697$exports = JSON.parse('{"markread":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","filter":"Zobrazova\u0165","newest":"najnov\u0161ie","unread":"nepre\u010D\xedtan\xe9","starred":"ozna\u010Den\xe9","tags":"Tagy","alltags":"v\u0161etky tagy","timestamp":"{0,date} {0,time}","hours":"pred {0,plural,one {1 hodinou},other {# hodinami}}","minutes":"pred {0,plural,one {1 min\xfatou},other {# min\xfatami}}","seconds":"pred {0,plural,one {chv\xed\u013Eou},other {# sekundami}}","star":"ozna\u010Di\u0165","unstar":"odzna\u010Di\u0165","mark":"ozna\u010Di\u0165 ako pre\u010D\xedtan\xe9","unmark":"ozna\u010Di\u0165 ako nepr\u010D\xedtan\xe9","load_img":"nahra\u0165 obr\xe1zky","open_window":"otvori\u0165","next":"\u010Fal\u0161ie","searchbutton":"vyh\u013Eada\u0165","searchremove":"skry\u0165 vyh\u013Ead\xe1vanie","refreshbutton":"obnovi\u0165 zdroje","settingsbutton":"nastavenia","logoutbutton":"odhl\xe1si\u0165 sa","loginbutton":"prihl\xe1si\u0165 sa","sources":"Zdroje","source_add":"prida\u0165 zdroj","source_opml":"alebo nahra\u0165 opml s\xfabor","source_export":"export zdrojov","source_edit":"upravi\u0165","source_filter":"Filter","source_delete":"zmaza\u0165","source_warn":"Naozaj chcete tento zdroj zmaza\u0165?","source_new":"nov\xfd neulo\u017Een\xfd zdroj","source_title":"N\xe1zov","source_tags":"Tagy","source_comma":"oddelen\xe9 \u010Diarkou","source_select":"vyberte pros\xedm zdroj","source_type":"Typ","source_save":"ulo\u017Ei\u0165","source_cancel":"zru\u0161i\u0165","source_saved":"ulo\u017Een\xe9","no_entries":"\u017Eiadny z\xe1znam","more":"v\xedac","login":"prihl\xe1si\u0165","login_username":"meno","login_password":"heslo","no_title":"Bez titulku","error":"nastala chyba"}');


var $7b91bdeeaf0bdb85$exports = {};
$7b91bdeeaf0bdb85$exports = JSON.parse('{"markread":"Markera som l\xe4st","newest":"Nyast","unread":"Ol\xe4st","starred":"Stj\xe4rnm\xe4rkta","tags":"Taggar","alltags":"Alla taggar","timestamp":"{0,date} {0,time}","hours":"f\xf6r {0,plural,one {1 timme},other {# timmar}} sedan","minutes":"f\xf6r {0,plural,one {1 minut},other {# minuter}} sedan","seconds":"f\xf6r {0,plural,one {1 sekund},other {# sekunder}} sedan","days":"{0,plural,zero {idag},one {ig\xe5r},other {f\xf6r # dagar sedan}}","star":"Stj\xe4rnm\xe4rk","unstar":"Ta bort stj\xe4rnm\xe4rkning","mark":"Markera som l\xe4st","unmark":"Markera som ol\xe4st","load_img":"L\xe4s in bilder","open_window":"\xd6ppna i nytt f\xf6nster","searchbutton":"S\xf6k","sources":"K\xe4llor","source_add":"L\xe4gg till k\xe4lla","source_opml":"eller importera fr\xe5n en OPML-fil eller Google Reader","source_edit":"Redigera","source_delete":"Ta bort","source_warn":"Vill du verkligen ta bort k\xe4llan?","source_new":"Ny k\xe4lla","source_title":"Titel","source_tags":"Taggar","source_comma":"Kommaseparerade","source_select":"V\xe4lj k\xe4lla","source_type":"Typ","source_save":"Spara","source_cancel":"Avbryt","source_saved":"K\xe4llan har sparats","no_entries":"Inga inl\xe4gg hittades","more":"Fler","login":"Logga in","login_username":"Anv\xe4ndarnamn","login_password":"L\xf6senord","source_last_post":"Senaste inl\xe4gg","filter":"Filter","online_count":"Inl\xe4gg tillg\xe4ngliga p\xe5 servern","offline_count":"Inl\xe4gg tillg\xe4ngliga lokalt","next":"N\xe4sta","searchremove":"D\xf6lj s\xf6kningen","refreshbutton":"Uppdatera k\xe4llorna","settingsbutton":"Inst\xe4llningar","logoutbutton":"Logga ut","loginbutton":"Logga in","source_export":"Exportera k\xe4llor","source_filter":"Filter","source_autotitle_hint":"L\xe4mna tomt f\xf6r att h\xe4mta titeln","source_pwd_placeholder":"Of\xf6r\xe4ndrat","source_refresh":"Uppdatera k\xe4llan","login_invalid_credentials":"Felaktigt anv\xe4ndarnamn eller l\xf6senord","login_offline":"Offlinelagring","no_title":"Ingen titel","error":"Ett fel uppstod","streamerror":"Inga inl\xe4gg l\xe4stes in. L\xe4sa in igen?","reload_list":"Ladda om listan","sources_refreshed":"K\xe4llorna har uppdaterats","app_update":"selfoss har uppdaterats. L\xe4s in sidan igen.","app_reload":"Ladda om","error_session_expired":"Sessionen har g\xe5tt ut","error_add_source":"Det gick inte att l\xe4gga till k\xe4llan:","error_delete_source":"Det gick inte att ta bort k\xe4llan:","error_load_tags":"Det gick inte att l\xe4sa in taggarna:","error_unknown_tag":"Ok\xe4nd tagg:","error_unknown_source":"Ok\xe4nt k\xe4ll-ID:","error_mark_items":"Det gick inte att markera alla synliga inl\xe4gg:","error_mark_item":"Det gick inte att markera eller avmarkera inl\xe4gget:","error_star_item":"Det gick inte att stj\xe4rnm\xe4rka inl\xe4gget eller ta bort dess stj\xe4rnm\xe4rkning:","error_logout":"Det gick inte att logga ut:","error_loading":"Fel vid inl\xe4sning:","error_loading_stats":"Det gick inte att l\xe4sa in navigeringsstatistiken:","error_saving_color":"Det gick inte att spara den nya f\xe4rgen:","error_refreshing_source":"Det gick inte att uppdatera k\xe4llan:","error_sync":"Det gick inte att synkronisera de senaste \xe4ndringarna fr\xe5n servern:","error_offline_storage":"Fel i offlinelagringen: {0}. Det kan hj\xe4lpa att l\xe4sa in sidan igen. Offlinel\xe4get inaktiveras tillf\xe4lligt.","error_invalid_subsection":"Ogiltigt underavsnitt:","search_label":"S\xf6kterm","article_actions":"\xc5tg\xe4rder","error_configuration":"Det gick inte att l\xe4sa in konfigurationen.","info_url_copied":"URL:en har kopierats till urklipp.","share_native_label":"Dela","share_diaspora_label":"Dela p\xe5 diaspora*","share_twitter_label":"Dela p\xe5 Twitter","share_facebook_label":"Dela p\xe5 Facebook","share_pocket_label":"Spara i Pocket","share_wallabag_label":"Spara i wallabag","share_wordpress_label":"Dela p\xe5 WordPress","share_mail_label":"Dela via e-post","share_copy_label":"Kopiera l\xe4nk till urklipp","error_share_native_abort":"Det gick inte att dela inl\xe4gget \u2013 det finns inga delningsm\xe5l eller s\xe5 avbr\xf6ts delningen.","error_share_native":"Det gick inte att dela inl\xe4gget.","close_entry":"St\xe4ng inl\xe4gget","experimental":"Experimentellt","error_unwritable_logs":"Det gick inte att skriva till loggarna.","error_check_system_logs":"Ett fel uppstod. Kontrollera systemloggarna.","error_check_log_file":"Ett fel uppstod. Kontrollera loggfilen \u201C{0}\u201D.","source_browse":"Bl\xe4ddra","tag_change_color_button_title":"\xc4ndra f\xe4rg","source_warn_cancel_dirty":"Kasta osparade \xe4ndringar?","offline_navigation_unavailable":"Det g\xe5r f\xf6r n\xe4rvarande inte att byta tagg eller k\xe4lla i offlinel\xe4ge.","sources_leaving_unsaved_prompt":"Vill du l\xe4mna inst\xe4llningarna trots osparade \xe4ndringar i k\xe4llorna?","error_offline_storage_not_available":"Offlinelagring \xe4r inte tillg\xe4nglig. Kontrollera att webbl\xe4saren {0}st\xf6der IndexedDB-API:t{1} och, om du anv\xe4nder en Chromium-baserad webbl\xe4sare, att selfoss inte k\xf6rs i inkognitol\xe4ge.","error_edit_source":"Det gick inte att spara \xe4ndringarna i k\xe4llan:","source_menu":"Fler \xe5tg\xe4rder","no_sources":"Inga k\xe4llor har konfigurerats.","source_deleting":"Tar bort k\xe4llan\u2026","login_error_generic":"Det gick inte att logga in: {errorMessage}","sources_loading":"L\xe4ser in k\xe4llor\u2026","source_params_loading":"L\xe4ser in parametrar\u2026","source_saving":"Sparar \xe4ndringar i k\xe4llan\u2026","source_go_to_settings":"\xd6ppna i inst\xe4llningarna","entries_loading":"L\xe4ser in inl\xe4gg\u2026","login_in_progress":"Loggar in\u2026","error_unauthorized":"{link_begin}Logga in{link_end} f\xf6r att forts\xe4tta.","article_reading_time":"L\xe4stid: {0} min","share_mastodon_label":"Dela p\xe5 Mastodon"}');


var $4bf6b321c83cc414$exports = {};
$4bf6b321c83cc414$exports = JSON.parse('{"offline_count":"\u0B89\u0BB3\u0BCD\u0BB3\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","offline_navigation_unavailable":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BCD \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0BA4\u0BB1\u0BCD\u0BAA\u0BCB\u0BA4\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","alltags":"\u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD","timestamp":"{0,date}-{0,time}","days":"{0,plural,zero {\u0B87\u0BA9\u0BCD\u0BB1\u0BC1},one {\u0BA8\u0BC7\u0BB1\u0BCD\u0BB1\u0BC1},other {# \u0BA8\u0BBE\u0B9F\u0BCD\u0B95\u0BB3\u0BC1\u0B95\u0BCD\u0B95\u0BC1 \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1}}","star":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BC1","unstar":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","mark":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","unmark":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1 \u0B8E\u0BA9\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF","load_img":"\u0BAA\u0B9F\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B95\u0BCD \u0B95\u0BBE\u0B9F\u0BCD\u0B9F\u0BC1","open_window":"\u0BA4\u0BBF\u0BB1","next":"\u0B85\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","share_native_label":"\u0BAA\u0B99\u0BCD\u0B95\u0BC1","share_diaspora_label":"\u0BAA\u0BC1\u0BB2\u0BAE\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BCB\u0BB0\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_twitter_label":"\u0B95\u0BC0\u0B9A\u0BCD\u0B9A\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_facebook_label":"\u0BAE\u0BC1\u0B95\u0BA8\u0BC2\u0BB2\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_mastodon_label":"\u0B95\u0BC1\u0B9F\u0BCD\u0B9F\u0BC8\u0BAA\u0BCD \u0BAA\u0BB0\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_pocket_label":"\u0BAA\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","share_wallabag_label":"\u0BB5\u0BBE\u0BB2\u0BAA\u0BBE\u0B95\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF","share_wordpress_label":"\u0B9A\u0BCA\u0BB2\u0BCD\u0B85\u0BB4\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_mail_label":"\u0BAE\u0BBF\u0BA9\u0BCD\u0BA9\u0B9E\u0BCD\u0B9A\u0BB2\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF \u0BAA\u0B95\u0BBF\u0BB0\u0BCD","share_copy_label":"\u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1","search_label":"\u0BA4\u0BC7\u0B9F\u0BAE\u0BCD \u0B9A\u0BCA\u0BB2\u0BCD","searchbutton":"\u0BA4\u0BC7\u0B9F\u0BC1","searchremove":"\u0BA4\u0BC7\u0B9F\u0BB2\u0BC8 \u0BAE\u0BB1\u0BC8","refreshbutton":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","settingsbutton":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BCD","logoutbutton":"\u0BB5\u0BBF\u0B9F\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","loginbutton":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","sources":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","sources_loading":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","no_sources":"\u0B8E\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0BAE\u0BCD \u0B95\u0B9F\u0BCD\u0B9F\u0BAE\u0BC8\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","source_add":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD","source_opml":"\u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0B92\u0BAA\u0BBF\u0B8E\u0BAE\u0BCD\u0B8E\u0BB2\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B87\u0BB1\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BA4\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD","source_export":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BA4\u0BBF \u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD","source_edit":"\u0BA4\u0BC6\u0BBE\u0B95\u0BC1","source_filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","source_menu":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","source_browse":"\u0B89\u0BB2\u0BBE\u0BB5\u0BC1","source_delete":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1","source_warn":"\u0B89\u0BA3\u0BCD\u0BAE\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","source_deleting":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BC1\u0BA4\u0BB2\u0BCD\u2026","source_warn_cancel_dirty":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0BA8\u0BBF\u0BB0\u0BBE\u0B95\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BB5\u0BBE?","source_new":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2","source_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1","source_autotitle_hint":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC8\u0BAA\u0BCD \u0BAA\u0BC6\u0BB1 \u0B95\u0BBE\u0BB2\u0BBF\u0BAF\u0BBE\u0B95 \u0BB5\u0BBF\u0B9F\u0BC1","source_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BC6\u0BBE\u0BB1\u0BCD\u0B95\u0BB3\u0BCD","source_pwd_placeholder":"\u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","source_comma":"\u0B95\u0BBE\u0BB1\u0BCD\u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BAF\u0BBE\u0BB2\u0BCD \u0BAA\u0BBF\u0BB0\u0BBF\u0BA8\u0BCD\u0BA4\u0BA4\u0BC1","source_select":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BC7\u0BB0\u0BCD\u0BA8\u0BCD\u0BA4\u0BC6\u0B9F\u0BC1","source_params_loading":"\u0B85\u0BB3\u0BB5\u0BC1\u0BB0\u0BC1\u0B95\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","source_type":"\u0BB5\u0B95\u0BC8","source_save":"\u0B9A\u0BC7\u0BAE\u0BBF","source_cancel":"\u0BA8\u0BC0\u0B95\u0BCD\u0B95\u0BB1\u0BB2\u0BCD","source_saving":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","source_saved":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","source_last_post":"\u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0B87\u0B9F\u0BC1\u0B95\u0BC8 \u0BAA\u0BBE\u0BB0\u0BCD\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1","source_refresh":"\u0B87\u0BA8\u0BCD\u0BA4 \u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF","source_go_to_settings":"\u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BBF\u0BB2\u0BCD \u0BA4\u0BBF\u0BB1","sources_leaving_unsaved_prompt":"\u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC1\u0B9F\u0BA9\u0BCD \u0B85\u0BAE\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1\u0B95\u0BB3\u0BC8 \u0BB5\u0BBF\u0B9F\u0BB2\u0BBE\u0BAE\u0BBE?","tag_change_color_button_title":"\u0BA8\u0BBF\u0BB1\u0BA4\u0BCD\u0BA4\u0BC8 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0BC1","entries_loading":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","no_entries":"\u0B89\u0BB3\u0BCD\u0BB3\u0BC0\u0B9F\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BA4\u0BC1\u0BB5\u0BC1\u0BAE\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8","login_error_generic":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8: {errorMessage}","error_check_log_file":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u201C{0}\u201D \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BCD \u0B95\u0BCB\u0BAA\u0BCD\u0BAA\u0BC8 \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","error_check_system_logs":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1, \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BA3\u0BBF\u0BA9\u0BBF \u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BB0\u0BBF\u0BAA\u0BBE\u0BB0\u0BCD.","error_unwritable_logs":"\u0BAA\u0BA4\u0BBF\u0BB5\u0BC1\u0B95\u0BB3\u0BCD \u0B8E\u0BB4\u0BC1\u0BA4 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","streamerror":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BAA\u0BCD\u0BAA\u0B9F\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8, \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BAE\u0BBE?","reload_list":"\u0BAA\u0B9F\u0BCD\u0B9F\u0BBF\u0BAF\u0BB2\u0BCD \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","sources_refreshed":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","error_session_expired":"\u0B85\u0BAE\u0BB0\u0BCD\u0BB5\u0BC1 \u0B95\u0BBE\u0BB2\u0BBE\u0BB5\u0BA4\u0BBF\u0BAF\u0BBE\u0BA9\u0BA4\u0BC1","error_add_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BB0\u0BCD\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_edit_source":"\u0BAE\u0BC2\u0BB2 \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_delete_source":"\u0BAE\u0BC2\u0BB2\u0BA4\u0BCD\u0BA4\u0BC8 \u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_load_tags":"\u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB1\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_unknown_tag":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0B95\u0BC1\u0BB1\u0BBF\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD:","error_sync":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BBF\u0BB0\u0BC1\u0BA8\u0BCD\u0BA4\u0BC1 \u0B95\u0B9F\u0BC8\u0B9A\u0BBF \u0BAE\u0BBE\u0BB1\u0BCD\u0BB1\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B92\u0BA4\u0BCD\u0BA4\u0BBF\u0B9A\u0BC8\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_offline_storage":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0B95 \u0BAA\u0BBF\u0BB4\u0BC8: {0}. \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BB5\u0BA4\u0BC1 \u0B89\u0BA4\u0BB5\u0B95\u0BCD\u0B95\u0BC2\u0B9F\u0BC1\u0BAE\u0BCD. \u0B87\u0BAA\u0BCD\u0BAA\u0BCB\u0BA4\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4\u0BA4\u0BC8 \u0BAE\u0BC1\u0B9F\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BBF\u0BB1\u0BA4\u0BC1.","markread":"\u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BAA\u0B9F\u0BBF \u0B95\u0BC1\u0BB1\u0BBF","filter":"\u0BB5\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0BBF","newest":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF\u0BA4\u0BC1","unread":"\u0BAA\u0B9F\u0BBF\u0B95\u0BCD\u0B95\u0BBE\u0BA4\u0BA4\u0BC1","starred":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","online_count":"\u0B9A\u0BC7\u0BB5\u0BC8\u0BAF\u0B95\u0BA4\u0BCD\u0BA4\u0BBF\u0BB2\u0BCD \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BC1\u0BAE\u0BCD \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD","hours":"{0,plural,one {1 \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0BAE\u0BCD},other {# \u0BAE\u0BA3\u0BBF\u0BA8\u0BC7\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","minutes":"{0,plural,one {1 \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD},other {# \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0B99\u0BCD\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","seconds":"{0,plural,one {1 \u0BA8\u0BCA\u0B9F\u0BBF},other {# \u0BA8\u0BCA\u0B9F\u0BBF\u0B95\u0BB3\u0BCD}} \u0BAE\u0BC1\u0BA9\u0BCD\u0BAA\u0BC1","more":"\u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD","login":"\u0BAA\u0BC1\u0B95\u0BC1\u0BAA\u0BA4\u0BBF\u0B95\u0BC8","login_in_progress":"\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0BAF \u0BAE\u0BC1\u0BAF\u0BB1\u0BCD\u0B9A\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1\u2026","login_username":"\u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD","login_password":"\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","login_invalid_credentials":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BAA\u0BAF\u0BA9\u0BB0\u0BCD\u0BAA\u0BC6\u0BAF\u0BB0\u0BCD/\u0B95\u0B9F\u0BB5\u0BC1\u0B9A\u0BCD\u0B9A\u0BCA\u0BB2\u0BCD","login_offline":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1","no_title":"\u0BA4\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BC1 \u0B87\u0BB2\u0BCD\u0BB2\u0BC8","experimental":"\u0B9A\u0BCB\u0BA4\u0BA9\u0BC8","error":"\u0BAA\u0BBF\u0BB4\u0BC8 \u0B8F\u0BB1\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1","error_unauthorized":"\u0BA4\u0BCA\u0B9F\u0BB0 {link_begin}\u0B89\u0BB3\u0BCD\u0BA8\u0BC1\u0BB4\u0BC8\u0B95{link_end}.","app_update":"\u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BC1\u0BB3\u0BCD\u0BB3\u0BA4\u0BC1, \u0BA4\u0BAF\u0BB5\u0BC1\u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC1 \u0BAE\u0BC0\u0BA3\u0BCD\u0B9F\u0BC1\u0BAE\u0BCD \u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","app_reload":"\u0BAE\u0BB1\u0BC1\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1","error_unknown_source":"\u0BA4\u0BC6\u0BB0\u0BBF\u0BAF\u0BBE\u0BA4 \u0BAE\u0BC2\u0BB2 \u0B85\u0B9F\u0BC8\u0BAF\u0BBE\u0BB3\u0BAE\u0BCD:","error_mark_items":"\u0BAA\u0BC1\u0BB2\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BAE\u0BCD \u0B85\u0BA9\u0BC8\u0BA4\u0BCD\u0BA4\u0BC1 \u0BAA\u0BCA\u0BB0\u0BC1\u0B9F\u0BCD\u0B95\u0BB3\u0BC8\u0BAF\u0BC1\u0BAE\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_mark_item":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0B95\u0BCD \u0B95\u0BC1\u0BB1\u0BBF\u0B95\u0BCD\u0B95/\u0B95\u0BC1\u0BB1\u0BBF\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_star_item":"\u0BB5\u0BBF\u0BA3\u0BCD\u0BAE\u0BC0\u0BA9\u0BCD \u0B87\u0B9F/\u0BA8\u0BC0\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4 \u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF:","error_logout":"\u0BB5\u0BC6\u0BB3\u0BBF\u0BAF\u0BC7\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8:","error_loading":"\u0B8F\u0BB1\u0BCD\u0BB1\u0BC1\u0BA4\u0BB2\u0BCD \u0BAA\u0BBF\u0BB4\u0BC8:","error_loading_stats":"\u0BB5\u0BB4\u0BBF\u0B9A\u0BC6\u0BB2\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0BAF \u0BAA\u0BC1\u0BB3\u0BCD\u0BB3\u0BBF\u0BB5\u0BBF\u0BB5\u0BB0\u0B99\u0BCD\u0B95\u0BB3\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_saving_color":"\u0BAA\u0BC1\u0BA4\u0BBF\u0BAF \u0BB5\u0BA3\u0BCD\u0BA3\u0BA4\u0BCD\u0BA4\u0BC8\u0B9A\u0BCD \u0B9A\u0BC7\u0BAE\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_refreshing_source":"\u0BAE\u0BC2\u0BB2\u0B99\u0BCD\u0B95\u0BB3\u0BC8\u0BAA\u0BCD \u0BAA\u0BC1\u0BA4\u0BC1\u0BAA\u0BCD\u0BAA\u0BBF\u0B95\u0BCD\u0B95 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BBE\u0BA4\u0BC1:","error_invalid_subsection":"\u0BA4\u0BB5\u0BB1\u0BBE\u0BA9 \u0BA4\u0BC1\u0BA3\u0BC8\u0BAA\u0B95\u0BC1\u0BA4\u0BBF:","error_configuration":"\u0B89\u0BB3\u0BCD\u0BB3\u0BAE\u0BC8\u0BB5\u0BC8 \u0B8F\u0BB1\u0BCD\u0BB1 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","error_share_native_abort":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 -\u0BAA\u0B99\u0BCD\u0B95\u0BC1 \u0B87\u0BB2\u0B95\u0BCD\u0B95\u0BC1\u0B95\u0BB3\u0BCD \u0B87\u0BB2\u0BCD\u0BB2\u0BC8, \u0B85\u0BB2\u0BCD\u0BB2\u0BA4\u0BC1 \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B85\u0BA4\u0BC8\u0BA4\u0BCD \u0BA4\u0BB3\u0BCD\u0BB3\u0BC1\u0BAA\u0B9F\u0BBF \u0B9A\u0BC6\u0BAF\u0BCD\u0BA4\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD.","close_entry":"\u0BAE\u0BC2\u0B9F\u0BC1","error_offline_storage_not_available":"\u0B87\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0BBF\u0BB2\u0BCD\u0BB2\u0BBE\u0BA4 \u0B9A\u0BC7\u0BAE\u0BBF\u0BAA\u0BCD\u0BAA\u0BC1 \u0B95\u0BBF\u0B9F\u0BC8\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8. \u0B89\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BB5\u0BB2\u0BC8 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF {0} \u0B85\u0B9F\u0BCD\u0B9F\u0BB5\u0BA3\u0BC8\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F \u0BA4\u0BB0\u0BB5\u0BC1\u0BA4\u0BCD\u0BA4\u0BB3\u0BAE\u0BCD \u0BAA\u0BA8\u0BBF\u0B87 {1} \u0B90 \u0B86\u0BA4\u0BB0\u0BBF\u0B95\u0BCD\u0B95\u0BBF\u0BB1\u0BA4\u0BC1 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BBF\u0B95\u0BCD \u0B95\u0BCA\u0BB3\u0BCD\u0BB3\u0BC1\u0B99\u0BCD\u0B95\u0BB3\u0BCD, \u0BAE\u0BC7\u0BB2\u0BC1\u0BAE\u0BCD \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0B95\u0BC2\u0B95\u0BBF\u0BB3\u0BCD \u0BA8\u0BBF\u0BB1\u0BAE\u0BBF \u0B85\u0B9F\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC8\u0BAF\u0BBF\u0BB2\u0BBE\u0BA9 \u0B89\u0BB2\u0BBE\u0BB5\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0BAF\u0BA9\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BC1\u0B95\u0BBF\u0BB1\u0BC0\u0BB0\u0BCD\u0B95\u0BB3\u0BCD \u0B8E\u0BA9\u0BCD\u0BB1\u0BBE\u0BB2\u0BCD, \u0BA8\u0BC0\u0B99\u0BCD\u0B95\u0BB3\u0BCD \u0BAE\u0BB1\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8 \u0BAA\u0BAF\u0BA9\u0BCD\u0BAE\u0BC1\u0BB1\u0BC8\u0BAF\u0BBF\u0BB2\u0BCD \u0B9A\u0BC6\u0BB2\u0BCD\u0BAA\u0BCB\u0B9A\u0BC8 \u0B87\u0BAF\u0B95\u0BCD\u0B95\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8 \u0B8E\u0BA9\u0BCD\u0BAA\u0BA4\u0BC8 \u0B89\u0BB1\u0BC1\u0BA4\u0BBF\u0BAA\u0BCD\u0BAA\u0B9F\u0BC1\u0BA4\u0BCD\u0BA4\u0BB5\u0BC1\u0BAE\u0BCD.","error_share_native":"\u0B89\u0BB0\u0BC1\u0BAA\u0BCD\u0BAA\u0B9F\u0BBF\u0BAF\u0BC8\u0BAA\u0BCD \u0BAA\u0B95\u0BBF\u0BB0 \u0BAE\u0BC1\u0B9F\u0BBF\u0BAF\u0BB5\u0BBF\u0BB2\u0BCD\u0BB2\u0BC8.","info_url_copied":"\u0BAE\u0BC1\u0B95\u0BB5\u0BB0\u0BBF \u0B87\u0B9F\u0BC8\u0BA8\u0BBF\u0BB2\u0BC8\u0BAA\u0BCD\u0BAA\u0BB2\u0B95\u0BC8\u0B95\u0BCD\u0B95\u0BC1 \u0BA8\u0B95\u0BB2\u0BC6\u0B9F\u0BC1\u0B95\u0BCD\u0B95\u0BAA\u0BCD\u0BAA\u0B9F\u0BCD\u0B9F\u0BA4\u0BC1.","article_actions":"\u0B9A\u0BC6\u0BAF\u0BB2\u0BCD\u0B95\u0BB3\u0BCD","article_reading_time":"{0} \u0BA8\u0BBF\u0BAE\u0BC8\u0BAF\u0BAE\u0BCD \u0BAA\u0B9F\u0BBF\u0BA4\u0BCD\u0BA4\u0BA4\u0BC1"}');


var $64a33f7e6e987d4f$exports = {};
$64a33f7e6e987d4f$exports = JSON.parse('{"markread":"Okundu olarak i\u015Faretle","newest":"En yeni","unread":"Okunmayan","starred":"Y\u0131ld\u0131zlanan","tags":"Etiketler","alltags":"T\xfcm etiketler","timestamp":"{0,date} {0,time}","hours":"{0, plural,other {#}} saat \xf6nce","minutes":"{0, plural,other {#}} dakika \xf6nce","seconds":"{0, plural,other {#}} saniye \xf6nce","star":"Y\u0131ld\u0131z ekle","unstar":"Y\u0131ld\u0131z kald\u0131r","mark":"Okundu olarak i\u015Faretle","unmark":"Okunmad\u0131 olarak i\u015Faretle","load_img":"Resimleri g\xf6ster","open_window":"A\xe7","searchbutton":"Ara","sources":"Kaynaklar","source_add":"Kaynak ekle","source_opml":"veya bir OPML dosyas\u0131n\u0131 i\xe7e aktar","source_export":"Kaynaklar\u0131 d\u0131\u015Fa aktar","source_edit":"D\xfczenle","source_delete":"Sil","source_warn":"Bu kaynak ger\xe7ekten silinsin mi?","source_new":"Yeni kaydedilmemi\u015F kaynak","source_title":"Ba\u015Fl\u0131k","source_tags":"Etiketler","source_comma":"Virg\xfclle ayr\u0131lm\u0131\u015F","source_select":"L\xfctfen kaynak se\xe7in","source_type":"T\xfcr","source_save":"Kaydet","source_cancel":"\u0130ptal","source_saved":"Kaydedildi","no_entries":"Yay\u0131n bulunmad\u0131","more":"Daha fazla","login":"Oturum a\xe7","login_username":"Kullan\u0131c\u0131 ad\u0131","login_password":"Parola","no_title":"Ba\u015Fl\u0131k yok","article_actions":"Eylemler","close_entry":"Kapat","info_url_copied":"URL panoya kopyaland\u0131.","error_share_native":"\xd6ge payla\u015F\u0131lam\u0131yor.","error_share_native_abort":"\xd6ge payla\u015F\u0131lam\u0131yor \u2014 ya hi\xe7 payla\u015F\u0131m hedefi yok ya da siz iptal ettiniz.","error_configuration":"Yap\u0131land\u0131rma y\xfcklenemiyor.","error_invalid_subsection":"Ge\xe7ersiz alt b\xf6l\xfcm:","error_offline_storage_not_available":"\xc7evrim d\u0131\u015F\u0131 depolama kullan\u0131lam\u0131yor. Web taray\u0131c\u0131n\u0131z\u0131n {0}IndexedDB API\'sini{1} destekledi\u011Finden ve Google Chrome tabanl\u0131 bir taray\u0131c\u0131 kullan\u0131yorsan\u0131z selfoss\'u gizli modda \xe7al\u0131\u015Ft\u0131rmad\u0131\u011F\u0131n\u0131zdan emin olun.","error_offline_storage":"\xc7evrim d\u0131\u015F\u0131 depolama hatas\u0131: {0}. Yeniden y\xfcklemek yard\u0131mc\u0131 olabilir. \xc7evrim d\u0131\u015F\u0131 \u015Fimdilik devre d\u0131\u015F\u0131 b\u0131rak\u0131l\u0131yor.","error_sync":"Sunucudan son de\u011Fi\u015Fiklikler e\u015Fzamanlanamad\u0131:","error_refreshing_source":"Kaynaklar yenilenemiyor:","error_saving_color":"Yeni renk kaydedilemiyor:","error_loading_stats":"G\xf6z atma istatistikleri y\xfcklenemiyor:","error_loading":"Y\xfckleme hatas\u0131:","error_logout":"Oturum kapat\u0131lamad\u0131:","error_star_item":"\xd6geye y\u0131ld\u0131z eklenemiyor/y\u0131ld\u0131z\u0131 kald\u0131r\u0131lam\u0131yor:","error_mark_item":"\xd6ge i\u015Faretlenemiyor/i\u015Fareti kald\u0131r\u0131lam\u0131yor:","error_mark_items":"T\xfcm g\xf6r\xfcn\xfcr \xf6geler i\u015Faretlenemiyor:","error_unknown_source":"Bilinmeyen kaynak kimli\u011Fi:","error_unknown_tag":"Bilinmeyen etiket:","error_load_tags":"Etiketler y\xfcklenemedi:","error_delete_source":"Kaynak silinemedi:","error_edit_source":"Kaynak de\u011Fi\u015Fiklikleri kaydedilemedi:","error_add_source":"Kaynak eklenemedi:","error_session_expired":"Oturumun s\xfcresi doldu","app_reload":"Yeniden y\xfckle","app_update":"selfoss g\xfcncellendi, l\xfctfen yeniden y\xfckleyin","sources_refreshed":"Kaynaklar yenilendi","reload_list":"Listeyi yeniden y\xfckle","streamerror":"Hi\xe7bir \xf6ge y\xfcklenmedi, yeniden y\xfcklensin mi?","error_unwritable_logs":"G\xfcnl\xfck yaz\u0131lam\u0131yor.","error_check_system_logs":"Bir hata olu\u015Ftu, l\xfctfen sistem g\xfcnl\xfcklerinize bak\u0131n.","error_check_log_file":"Bir hata olu\u015Ftu, l\xfctfen g\xfcnl\xfck dosyas\u0131na bak\u0131n \u201C{0}\u201D.","error":"Bir hata olu\u015Ftu","login_offline":"\xc7evrim d\u0131\u015F\u0131 depolama","login_invalid_credentials":"Yanl\u0131\u015F kullan\u0131c\u0131 ad\u0131/parola","source_refresh":"Bu kayna\u011F\u0131 yenile","source_last_post":"G\xf6r\xfclen son g\xf6nderi","source_pwd_placeholder":"De\u011Fi\u015Fmedi","source_autotitle_hint":"Ba\u015Fl\u0131\u011F\u0131 almak i\xe7in bo\u015F b\u0131rak\u0131n","source_filter":"Filtrele","loginbutton":"Oturum a\xe7","logoutbutton":"Oturumu kapat","settingsbutton":"Ayarlar","refreshbutton":"Kaynaklar\u0131 yenile","searchremove":"Aramay\u0131 gizle","search_label":"Arama terimi","share_copy_label":"Ba\u011Flant\u0131y\u0131 panoya kopyala","share_mail_label":"E-posta ile payla\u015F","share_wordpress_label":"WordPress\'te payla\u015F","share_wallabag_label":"Wallabag\'e kaydet","share_pocket_label":"Pocket\'a kaydet","share_facebook_label":"Facebook\'ta payla\u015F","share_twitter_label":"Twitter\'da payla\u015F","share_diaspora_label":"Diaspora\'da payla\u015F","share_native_label":"Payla\u015F","next":"Sonraki","days":"{0,plural,zero {bug\xfcn},one {d\xfcn},other {# g\xfcn \xf6nce}}","offline_navigation_unavailable":"Etiketleri ve kaynaklar\u0131 de\u011Fi\u015Ftirmek \u015Fu anda \xe7evrim d\u0131\u015F\u0131 modda kullan\u0131lam\u0131yor.","offline_count":"Yerel olarak kullan\u0131labilen \xf6geler","online_count":"Sunucuda bulunan \xf6geler","filter":"Filtrele","article_reading_time":"{0} dakika okuma","experimental":"Deneysel","source_warn_cancel_dirty":"Kaydedilmemi\u015F de\u011Fi\u015Fiklikler at\u0131ls\u0131n m\u0131?","sources_leaving_unsaved_prompt":"Kaydedilmemi\u015F kaynak de\u011Fi\u015Fiklikleri olmas\u0131na ra\u011Fmen ayarlardan \xe7\u0131k\u0131ls\u0131n m\u0131?","source_browse":"G\xf6z at","source_menu":"Daha fazla eylem","tag_change_color_button_title":"Rengi de\u011Fi\u015Ftir","source_go_to_settings":"Ayarlarda a\xe7","sources_loading":"Kaynaklar y\xfckleniyor\u2026","no_sources":"Yap\u0131land\u0131r\u0131lan kaynak yok.","entries_loading":"Yay\u0131nlar y\xfckleniyor\u2026","source_deleting":"Kaynak siliniyor\u2026","login_in_progress":"Oturum a\xe7maya \xe7al\u0131\u015F\u0131l\u0131yor\u2026","source_params_loading":"Parametreler y\xfckleniyor\u2026","source_saving":"Kaynak de\u011Fi\u015Fiklikleri kaydediliyor\u2026","error_unauthorized":"Devam etmek i\xe7in l\xfctfen {link_begin}oturum a\xe7\u0131n{link_end}.","login_error_generic":"Oturum a\xe7\u0131lamad\u0131: {errorMessage}","share_mastodon_label":"Mastodon\'da payla\u015F"}');


var $563d7fbeeac49c6b$exports = {};
$563d7fbeeac49c6b$exports = JSON.parse('{"markread":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","newest":"\u041D\u0430\u0439\u043D\u043E\u0432\u0456\u0448\u0456","unread":"\u041D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0456","starred":"\u041F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u0456","tags":"\u041C\u0456\u0442\u043A\u0438","alltags":"\u0423\u0441\u0456 \u043C\u0456\u0442\u043A\u0438","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u0433\u043E\u0434\u0438\u043D\u0443},other {# \u0433\u043E\u0434\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","minutes":"{0,plural,one {1 \u0445\u0432\u0438\u043B\u0438\u043D\u0443},other {# \u0445\u0432\u0438\u043B\u0438\u043D\u0438}} \u0442\u043E\u043C\u0443","seconds":"{0,plural,one {1 \u0441\u0435\u043A\u0443\u043D\u0434\u0443},other {# \u0441\u0435\u043A\u0443\u043D\u0434\u0438}} \u0442\u043E\u043C\u0443","star":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438","unstar":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044F","mark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","unmark":"\u041F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u043D\u0435\u043F\u0440\u043E\u0447\u0438\u0442\u0430\u043D\u0438\u043C","load_img":"\u041F\u043E\u043A\u0430\u0437\u0430\u0442\u0438 \u0437\u043E\u0431\u0440\u0430\u0436\u0435\u043D\u043D\u044F","open_window":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438","searchbutton":"\u041F\u043E\u0448\u0443\u043A","sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430","source_add":"\u0414\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_opml":"\u0430\u0431\u043E \u0456\u043C\u043F\u043E\u0440\u0442\u0443\u0432\u0430\u0442\u0438 \u0437 OPML-\u0444\u0430\u0439\u043B\u0443","source_export":"\u0435\u043A\u0441\u043F\u043E\u0440\u0442 \u0434\u0436\u0435\u0440\u0435\u043B","source_edit":"\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438","source_delete":"\u0412\u0438\u0434\u0430\u043B\u0438\u0442\u0438","source_warn":"\u0414\u0456\u0439\u0441\u043D\u043E \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E?","source_new":"\u041D\u043E\u0432\u0435 \u043D\u0435 \u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_title":"\u041D\u0430\u0437\u0432\u0430","source_tags":"\u041C\u0456\u0442\u043A\u0438","source_comma":"\u0420\u043E\u0437\u0434\u0456\u043B\u0435\u043D\u0456 \u043A\u043E\u043C\u043E\u044E","source_select":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044C \u0442\u0438\u043F \u0434\u0436\u0435\u0440\u0435\u043B\u0430","source_type":"\u0422\u0438\u043F","source_save":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438","source_cancel":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438","source_saved":"\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043E","no_entries":"\u0417\u0430\u043F\u0438\u0441\u0456\u0432 \u043D\u0435 \u0437\u043D\u0430\u0439\u0434\u0435\u043D\u043E","more":"\u0429\u0435","login":"\u0412\u0445\u0456\u0434","login_username":"\u0406\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430","login_password":"\u041F\u0430\u0440\u043E\u043B\u044C","no_title":"\u0411\u0435\u0437 \u043D\u0430\u0437\u0432\u0438","filter":"\u0424\u0456\u043B\u044C\u0442\u0440","online_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043D\u0430 \u0441\u0435\u0440\u0432\u0435\u0440\u0456","offline_count":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0456 \u043B\u043E\u043A\u0430\u043B\u044C\u043D\u043E","source_browse":"\u041E\u0433\u043B\u044F\u0434","share_facebook_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Facebook","error_check_log_file":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0444\u0430\u0439\u043B \u0436\u0443\u0440\u043D\u0430\u043B\u0443 \\"{0}\\".","error_check_system_logs":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430, \u043F\u0435\u0440\u0435\u0432\u0456\u0440\u0442\u0435 \u0441\u0438\u0441\u0442\u0435\u043C\u043D\u0456 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","error_unwritable_logs":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u0437\u0430\u043F\u0438\u0441\u0430\u0442\u0438 \u0436\u0443\u0440\u043D\u0430\u043B\u0438.","streamerror":"\u0415\u043B\u0435\u043C\u0435\u043D\u0442\u0438 \u043D\u0435 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u0456, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438?","error_edit_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043C\u0456\u043D\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_mark_items":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0432\u0441\u0456 \u0432\u0438\u0434\u0438\u043C\u0456 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0438:","error_star_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438 \u0430\u0431\u043E \u0437\u043D\u044F\u0442\u0438 \u0437\u0456\u0440\u043E\u0447\u043A\u0443:","error_logout":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0439\u0442\u0438:","error_saving_color":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043D\u043E\u0432\u0438\u0439 \u043A\u043E\u043B\u0456\u0440:","error_sync":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0441\u0438\u043D\u0445\u0440\u043E\u043D\u0456\u0437\u0443\u0432\u0430\u0442\u0438 \u043E\u0441\u0442\u0430\u043D\u043D\u0456 \u0437\u043C\u0456\u043D\u0438 \u0437 \u0441\u0435\u0440\u0432\u0435\u0440\u0430:","error_unknown_source":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0438\u0439 ID \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_load_tags":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043C\u0456\u0442\u043A\u0438:","error_unknown_tag":"\u041D\u0435\u0432\u0456\u0434\u043E\u043C\u0430 \u043C\u0456\u0442\u043A\u0430:","error_refreshing_source":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430:","error_mark_item":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0437\u043D\u0430\u0447\u0438\u0442\u0438/\u0437\u043D\u044F\u0442\u0438 \u043F\u043E\u0437\u043D\u0430\u0447\u043A\u0443 \u0437 \u0435\u043B\u0435\u043C\u0435\u043D\u0442\u0430:","error_offline_storage":"\u041F\u043E\u043C\u0438\u043B\u043A\u0430 \u0432 \u043E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0456: {0}. \u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u043C\u043E\u0436\u0435 \u0434\u043E\u043F\u043E\u043C\u043E\u0433\u0442\u0438. \u041D\u0430\u0440\u0430\u0437\u0456 \u0432\u0438\u043C\u0438\u043A\u0430\u0454\u0442\u044C\u0441\u044F \u043E\u0444\u043B\u0430\u0439\u043D.","days":"{0,plural,zero {\u0441\u044C\u043E\u0433\u043E\u0434\u043D\u0456},one {\u0432\u0447\u043E\u0440\u0430},other {# \u0434\u043D\u0456\u0432 \u0442\u043E\u043C\u0443}}","error_unauthorized":"\u0411\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, {link_begin}\u0443\u0432\u0456\u0439\u0434\u0456\u0442\u044C{link_end}, \u0449\u043E\u0431 \u043F\u0440\u043E\u0434\u043E\u0432\u0436\u0438\u0442\u0438.","share_native_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F","share_twitter_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u0432 Twitter","share_mastodon_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Mastodon","source_deleting":"\u0412\u0438\u0434\u0430\u043B\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","share_wordpress_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 WordPress","share_copy_label":"\u0421\u043A\u043E\u043F\u0456\u044E\u0432\u0430\u0442\u0438 \u043F\u043E\u0441\u0438\u043B\u0430\u043D\u043D\u044F \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443","search_label":"\u041F\u043E\u0448\u0443\u043A\u043E\u0432\u0438\u0439 \u0437\u0430\u043F\u0438\u0442","share_mail_label":"\u041D\u0430\u0434\u0456\u0441\u043B\u0430\u0442\u0438 \u0435-\u043F\u043E\u0448\u0442\u043E\u044E","searchremove":"\u0421\u0445\u043E\u0432\u0430\u0442\u0438 \u043F\u043E\u0448\u0443\u043A","logoutbutton":"\u0412\u0438\u0439\u0442\u0438","settingsbutton":"\u041D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F","loginbutton":"\u0423\u0432\u0456\u0439\u0442\u0438","no_sources":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043D\u0435 \u043D\u0430\u043B\u0430\u0448\u0442\u043E\u0432\u0430\u043D\u0456.","source_filter":"\u0424\u0456\u043B\u044C\u0442\u0440","error_loading_stats":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043D\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0439\u043D\u0443 \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043A\u0443:","source_menu":"\u0414\u043E\u0434\u0430\u0442\u043A\u043E\u0432\u0456 \u0434\u0456\u0457","sources_leaving_unsaved_prompt":"\u041F\u043E\u043A\u0438\u043D\u0443\u0442\u0438 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F \u0437 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0438\u043C\u0438 \u0437\u043C\u0456\u043D\u0430\u043C\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430?","login_error_generic":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0443\u0432\u0456\u0439\u0442\u0438: {errorMessage}","experimental":"\u0415\u043A\u0441\u043F\u0435\u0440\u0438\u043C\u0435\u043D\u0442\u0430\u043B\u044C\u043D\u0456","tag_change_color_button_title":"\u0417\u043C\u0456\u043D\u0438\u0442\u0438 \u043A\u043E\u043B\u0456\u0440","login_in_progress":"\u0421\u043F\u0440\u043E\u0431\u0430 \u0443\u0432\u0456\u0439\u0442\u0438\u2026","sources_refreshed":"\u0414\u0436\u0435\u0440\u0435\u043B\u0430 \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u0456","error":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430","sources_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0434\u0436\u0435\u0440\u0435\u043B\u2026","login_invalid_credentials":"\u041D\u0435\u043F\u0440\u0430\u0432\u0438\u043B\u044C\u043D\u0435 \u0456\u043C\'\u044F \u043A\u043E\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430/\u043F\u0430\u0440\u043E\u043B\u044C","error_loading":"\u0412\u0438\u043D\u0438\u043A\u043B\u0430 \u043F\u043E\u043C\u0438\u043B\u043A\u0430 \u043F\u0440\u0438 \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u0456:","source_last_post":"\u041E\u0441\u0442\u0430\u043D\u043D\u0456\u0439 \u043F\u043E\u0431\u0430\u0447\u0435\u043D\u0438\u0439 \u0434\u043E\u043F\u0438\u0441","refreshbutton":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u0430","share_diaspora_label":"\u041F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F \u043D\u0430 Diaspora","share_wallabag_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0443 Wallabag","next":"\u041D\u0430\u0441\u0442\u0443\u043F\u043D\u0438\u0439","source_saving":"\u0417\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u043D\u044F \u0437\u043C\u0456\u043D \u0434\u0436\u0435\u0440\u0435\u043B\u0430\u2026","entries_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0435\u043D\u043D\u044F \u0437\u0430\u043F\u0438\u0441\u0456\u0432\u2026","reload_list":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0441\u043F\u0438\u0441\u043E\u043A","share_pocket_label":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0432 Pocket","info_url_copied":"URL \u0441\u043A\u043E\u043F\u0456\u0439\u043E\u0432\u0430\u043D\u043E \u0432 \u0431\u0443\u0444\u0435\u0440 \u043E\u0431\u043C\u0456\u043D\u0443.","offline_navigation_unavailable":"\u041F\u0435\u0440\u0435\u043C\u0438\u043A\u0430\u043D\u043D\u044F \u043C\u0456\u0442\u043E\u043A \u0456 \u0434\u0436\u0435\u0440\u0435\u043B \u043D\u0430\u0440\u0430\u0437\u0456 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435 \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u043E\u0444\u043B\u0430\u0439\u043D.","source_warn_cancel_dirty":"\u0421\u043A\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u043D\u0435\u0437\u0431\u0435\u0440\u0435\u0436\u0435\u043D\u0456 \u0437\u043C\u0456\u043D\u0438?","error_offline_storage_not_available":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435 \u043D\u0435\u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0435. \u041F\u0435\u0440\u0435\u043A\u043E\u043D\u0430\u0439\u0442\u0435\u0441\u044F, \u0449\u043E \u0432\u0430\u0448 \u0432\u0435\u0431\u0431\u0440\u0430\u0443\u0437\u0435\u0440 {0} \u043F\u0456\u0434\u0442\u0440\u0438\u043C\u0443\u0454 API IndexedDB{1} \u0456, \u044F\u043A\u0449\u043E \u0432\u0438 \u0432\u0438\u043A\u043E\u0440\u0438\u0441\u0442\u043E\u0432\u0443\u0454\u0442\u0435 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043D\u0430 \u0431\u0430\u0437\u0456 Google Chrome, \u0442\u043E \u0432\u0438 \u043D\u0435 \u0437\u0430\u0441\u0442\u043E\u0441\u043E\u0432\u0443\u0454\u0442\u0435 selfoss \u0432 \u0440\u0435\u0436\u0438\u043C\u0456 \u0456\u043D\u043A\u043E\u0433\u043D\u0456\u0442\u043E.","error_invalid_subsection":"\u041D\u0435\u0434\u0456\u0439\u0441\u043D\u0438\u0439 \u043F\u0456\u0434\u0440\u043E\u0437\u0434\u0456\u043B:","error_configuration":"\u041D\u0435 \u0432\u0434\u0430\u0454\u0442\u044C\u0441\u044F \u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438 \u043A\u043E\u043D\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044E.","error_share_native_abort":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F - \u0430\u0431\u043E \u043D\u0435\u043C\u0430\u0454 \u0446\u0456\u043B\u0435\u0439, \u0430\u0431\u043E \u0432\u0438 \u0457\u0445 \u0441\u043A\u0430\u0441\u0443\u0432\u0430\u043B\u0438.","error_share_native":"\u041D\u0435\u043C\u043E\u0436\u043B\u0438\u0432\u043E \u043F\u043E\u0434\u0456\u043B\u0438\u0442\u0438\u0441\u044F.","close_entry":"\u0417\u0430\u043A\u0440\u0438\u0442\u0438","article_actions":"\u0414\u0456\u0457","article_reading_time":"{0} \u0445\u0432 \u0447\u0438\u0442\u0430\u043D\u043D\u044F","source_autotitle_hint":"\u0417\u0430\u043B\u0438\u0448\u0442\u0435 \u043F\u043E\u0440\u043E\u0436\u043D\u0456\u043C, \u0449\u043E\u0431 \u043E\u0442\u0440\u0438\u043C\u0430\u0442\u0438 \u043D\u0430\u0437\u0432\u0443","source_pwd_placeholder":"\u0411\u0435\u0437 \u0437\u043C\u0456\u043D","source_params_loading":"\u0417\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0443\u0454\u043C\u043E \u043F\u0430\u0440\u0430\u043C\u0435\u0442\u0440\u0438\u2026","source_refresh":"\u041E\u043D\u043E\u0432\u0438\u0442\u0438 \u0446\u0435 \u0434\u0436\u0435\u0440\u0435\u043B\u043E","source_go_to_settings":"\u0412\u0456\u0434\u043A\u0440\u0438\u0442\u0438 \u0432 \u043D\u0430\u043B\u0430\u0448\u0442\u0443\u0432\u0430\u043D\u043D\u044F\u0445","login_offline":"\u041E\u0444\u043B\u0430\u0439\u043D-\u0441\u0445\u043E\u0432\u0438\u0449\u0435","app_update":"selfoss \u043E\u043D\u043E\u0432\u043B\u0435\u043D\u043E, \u0431\u0443\u0434\u044C \u043B\u0430\u0441\u043A\u0430, \u043F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0442\u0435","app_reload":"\u041F\u0435\u0440\u0435\u0437\u0430\u0432\u0430\u043D\u0442\u0430\u0436\u0438\u0442\u0438","error_session_expired":"\u0421\u0435\u0430\u043D\u0441 \u0443\u0436\u0435 \u0437\u0430\u043A\u0456\u043D\u0447\u0438\u0432\u0441\u044F","error_add_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0434\u043E\u0434\u0430\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:","error_delete_source":"\u041D\u0435 \u0432\u0434\u0430\u043B\u043E\u0441\u044F \u0432\u0438\u0434\u0430\u043B\u0438\u0442\u0438 \u0434\u0436\u0435\u0440\u0435\u043B\u043E:"}');


var $94f63a341744b7b8$exports = {};
$94f63a341744b7b8$exports = JSON.parse('{"markread":"\u5168\u90E8\u6807\u8BB0\u4E3A\u5DF2\u8BFB","newest":"\u6700\u65B0\u6761\u76EE","unread":"\u672A\u8BFB\u6761\u76EE","starred":"\u52A0\u661F\u6807\u7684\u6761\u76EE","tags":"\u6807\u7B7E","alltags":"\u6240\u6709\u6807\u7B7E","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u5C0F\u65F6},other {# \u5C0F\u65F6}}\u524D","minutes":"{0,plural,one {1 \u5206\u949F},other {# \u5206\u949F}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","star":"\u52A0\u661F\u6807","unstar":"\u53D6\u6D88\u661F\u6807","mark":"\u6807\u8BB0\u4E3A\u5DF2\u8BFB","unmark":"\u6807\u8BB0\u4E3A\u672A\u8BFB","load_img":"\u52A0\u8F7D\u56FE\u7247","open_window":"\u6253\u5F00","searchbutton":"\u641C\u7D22","sources":"\u6E90","source_add":"\u6DFB\u52A0\u6E90","source_opml":"\u6216\u5BFC\u5165 OPML \u6587\u4EF6/Google \u9605\u8BFB\u5668\u8BA2\u9605","source_export":"\u5BFC\u51FA\u6E90","source_edit":"\u7F16\u8F91","source_delete":"\u5220\u9664","source_warn":"\u786E\u8BA4\u8981\u5220\u9664\u8BE5\u6E90?","source_new":"\u65B0\u7684\u6E90","source_title":"\u6807\u9898","source_tags":"\u6807\u7B7E","source_comma":"\u4EE5\u9017\u53F7\u5206\u9694","source_select":"\u8BF7\u9009\u62E9\u6E90","source_type":"\u7C7B\u578B","source_save":"\u4FDD\u5B58","source_cancel":"\u53D6\u6D88","source_saved":"\u5DF2\u4FDD\u5B58","source_last_post":"\u66F4\u65B0\u4E8E","no_entries":"\u6CA1\u6709\u6761\u76EE","more":"\u66F4\u591A","login":"\u767B\u5F55","login_username":"\u7528\u6237\u540D","login_password":"\u5BC6\u7801","no_title":"\u65E0\u6807\u9898","logoutbutton":"\u767B\u51FA","loginbutton":"\u767B\u5F55","error_logout":"\u4E0D\u80FD\u767B\u51FA\uFF1A","settingsbutton":"\u8BBE\u7F6E","app_reload":"\u518D\u542F\u52A8","error_session_expired":"\u4F1A\u8BDD\u5DF2\u8FC7\u671F","close_entry":"\u5173\u95ED","error_sync":"\u65E0\u6CD5\u4ECE\u670D\u52A1\u5668\u540C\u6B65\u65B0\u7684\u66F4\u6539\uFF1A","share_pocket_label":"\u4FDD\u5B58\u5230 Pocket","searchremove":"\u9690\u85CF\u641C\u7D22","error_share_native_abort":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE - \u53EF\u80FD\u662F\u7F3A\u5C11\u5206\u4EAB\u5BF9\u8C61\u6216\u60A8\u5DF2\u53D6\u6D88\u5206\u4EAB\u3002","error_mark_items":"\u65E0\u6CD5\u6807\u8BB0\u6240\u6709\u53EF\u89C1\u9879\u76EE\uFF1A","share_twitter_label":"\u5206\u4EAB\u5230 Twitter","share_wallabag_label":"\u4FDD\u5B58\u5230 Wallabag","filter":"\u7B5B\u9009","online_count":"\u670D\u52A1\u5668\u53EF\u7528\u7684\u6761\u76EE","offline_navigation_unavailable":"\u79BB\u7EBF\u6A21\u5F0F\u4E0B\u6682\u65F6\u4E0D\u80FD\u5207\u6362\u6807\u7B7E\u548C\u6765\u6E90\u3002","source_menu":"\u66F4\u591A\u64CD\u4F5C","source_browse":"\u6D4F\u89C8","offline_count":"\u672C\u5730\u53EF\u7528\u7684\u6761\u76EE","next":"\u4E0B\u4E00\u4E2A","share_native_label":"\u5206\u4EAB","refreshbutton":"\u66F4\u65B0\u6570\u636E\u6E90","share_diaspora_label":"\u5206\u4EAB\u5230 Diaspora","share_wordpress_label":"\u5206\u4EAB\u5230 WordPress","search_label":"\u641C\u7D22\u8BCD","share_mail_label":"\u901A\u8FC7\u90AE\u4EF6\u5206\u4EAB","source_warn_cancel_dirty":"\u4E22\u5F03\u672A\u4FDD\u5B58\u7684\u66F4\u6539\uFF1F","share_copy_label":"\u590D\u5236\u94FE\u63A5\u5230\u526A\u5207\u677F","source_filter":"\u7B5B\u9009","share_facebook_label":"\u5206\u4EAB\u5230 Facebook","tag_change_color_button_title":"\u66F4\u6539\u989C\u8272","experimental":"\u8BD5\u9A8C\u6027\u7684","login_invalid_credentials":"\u9519\u8BEF\u7684\u7528\u6237\u540D\u6216\u5BC6\u7801","error_check_log_file":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u65E5\u5FD7\u6587\u4EF6 \u201C{0}\u201D\u3002","login_offline":"\u79BB\u7EBF\u5B58\u50A8","error_unknown_source":"\u672A\u77E5\u6765\u6E90 ID\uFF1A","error_mark_item":"\u65E0\u6CD5\u6807\u8BB0\u6216\u53D6\u6D88\u6807\u8BB0\uFF1A","error_star_item":"\u65E0\u6CD5\u661F\u6807\u6216\u53D6\u6D88\u661F\u6807\uFF1A","error_loading":"\u52A0\u8F7D\u9519\u8BEF\uFF1A","article_reading_time":"{0} \u5206\u949F\u9605\u8BFB\u65F6\u957F","sources_loading":"\u6570\u636E\u6E90\u52A0\u8F7D\u4E2D\u2026","no_sources":"\u6570\u636E\u6E90\u672A\u914D\u7F6E\u3002","source_deleting":"\u6B63\u5728\u5220\u9664\u6570\u636E\u6E90\u2026","source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52A8\u586B\u5145\u6807\u9898","source_pwd_placeholder":"\u6CA1\u6709\u6539\u53D8","source_params_loading":"\u6B63\u5728\u52A0\u8F7D\u53C2\u6570\u2026","source_saving":"\u6B63\u5728\u4FDD\u5B58\u6570\u636E\u6E90\u66F4\u6539\u2026","source_refresh":"\u5237\u65B0\u6B64\u6570\u636E\u6E90","source_go_to_settings":"\u5728\u8BBE\u7F6E\u4E2D\u6253\u5F00","sources_leaving_unsaved_prompt":"\u4FDD\u7559\u672A\u4FDD\u5B58\u7684\u6570\u636E\u6E90\u66F4\u6539\uFF1F","entries_loading":"\u52A0\u8F7D\u6761\u76EE\u4E2D\u2026","login_in_progress":"\u5C1D\u8BD5\u767B\u5F55\u4E2D\u2026","error":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF","error_check_system_logs":"\u53D1\u751F\u4E86\u4E00\u4E2A\u9519\u8BEF\uFF0C\u8BF7\u68C0\u67E5\u4F60\u7684\u7CFB\u7EDF\u65E5\u5FD7\u3002","error_unwritable_logs":"\u65E0\u6CD5\u5199\u5165\u65E5\u5FD7\u3002","streamerror":"\u6CA1\u6709\u52A0\u8F7D\u5230\u6761\u76EE\uFF0C\u91CD\u65B0\u52A0\u8F7D\uFF1F","sources_refreshed":"\u6570\u636E\u6E90\u5DF2\u5237\u65B0","app_update":"selfoss \u5DF2\u88AB\u66F4\u65B0\uFF0C\u8BF7\u91CD\u65B0\u52A0\u8F7D","error_add_source":"\u65E0\u6CD5\u6DFB\u52A0\u6E90\uFF1A","error_edit_source":"\u65E0\u6CD5\u4FDD\u5B58\u6E90\u66F4\u6539\uFF1A","error_delete_source":"\u65E0\u6CD5\u5220\u9664\u6E90\uFF1A","error_load_tags":"\u65E0\u6CD5\u52A0\u8F7D\u6807\u7B7E\uFF1A","error_unknown_tag":"\u672A\u77E5\u7684\u6807\u7B7E\uFF1A","error_loading_stats":"\u65E0\u6CD5\u52A0\u8F7D\u7EDF\u8BA1\u4FE1\u606F\uFF1A","error_saving_color":"\u65E0\u6CD5\u4FDD\u5B58\u65B0\u989C\u8272\uFF1A","error_refreshing_source":"\u65E0\u6CD5\u5237\u65B0\u6570\u636E\u6E90\uFF1A","error_offline_storage":"\u79BB\u7EBF\u5B58\u50A8\u51FA\u9519\uFF1A{0} \uFF0C\u8BF7\u5C1D\u8BD5\u91CD\u65B0\u52A0\u8F7D\u3002\u79BB\u7EBF\u6A21\u5F0F\u5DF2\u88AB\u4E34\u65F6\u7981\u7528\u3002","error_offline_storage_not_available":"\u79BB\u7EBF\u5B58\u50A8\u4E0D\u53EF\u7528\u3002\u786E\u4FDD\u60A8\u7684\u7F51\u7EDC\u6D4F\u89C8\u5668 {0} \u652F\u6301 IndexedDB API{1}\uFF0C\u5982\u679C\u60A8\u4F7F\u7528\u7684\u662F\u57FA\u4E8E Google Chrome \u7684\u6D4F\u89C8\u5668\uFF0C\u8BF7\u786E\u4FDD\u60A8\u6CA1\u6709\u5728\u9690\u8EAB\u6A21\u5F0F\u4E0B\u8FD0\u884C selfoss\u3002","error_invalid_subsection":"\u65E0\u6548\u7684\u5C0F\u8282\uFF1A","error_configuration":"\u65E0\u6CD5\u52A0\u8F7D\u914D\u7F6E\u3002","info_url_copied":"URL \u5DF2\u590D\u5236\u5230\u526A\u8D34\u677F\u3002","error_share_native":"\u65E0\u6CD5\u5206\u4EAB\u6761\u76EE\u3002","article_actions":"\u52A8\u4F5C","reload_list":"\u91CD\u65B0\u52A0\u8F7D\u5217\u8868","login_error_generic":"\u65E0\u6CD5\u767B\u5F55: {errorMessage}","error_unauthorized":"\u8BF7 {link_begin}\u767B\u5F55{link_end} \u4EE5\u7EE7\u7EED\u3002","share_mastodon_label":"\u5728 Mastodon \u4E0A\u5206\u4EAB"}');


var $d97043994cabe9e3$exports = {};
$d97043994cabe9e3$exports = JSON.parse('{"markread":"\u6A19\u8A18\u70BA\u5DF2\u8B80","newest":"\u6700\u65B0","unread":"\u672A\u8B80","starred":"\u5DF2\u52A0\u661F\u6A19","tags":"\u6A19\u7C64","alltags":"\u6240\u6709\u6A19\u7C64","timestamp":"{0,date} {0,time}","hours":"{0,plural,one {1 \u5C0F\u6642},other {# \u5C0F\u6642}}\u524D","minutes":"{0,plural,one {1 \u5206\u9418},other {# \u5206\u9418}}\u524D","seconds":"{0,plural,one {1 \u79D2},other {# \u79D2}}\u524D","days":"{0,plural,zero {\u4ECA\u5929},one {\u6628\u5929},other {# \u5929\u524D}}","star":"\u52A0\u661F\u6A19","unstar":"\u53D6\u6D88\u661F\u6A19","mark":"\u6A19\u8A18\u70BA\u5DF2\u8B80","unmark":"\u6A19\u8A18\u70BA\u672A\u8B80","load_img":"\u986F\u793A\u5716\u7247","open_window":"\u958B\u555F","searchbutton":"\u641C\u5C0B","sources":"\u4F86\u6E90","source_add":"\u65B0\u589E\u4F86\u6E90","source_opml":"\u6216\u532F\u5165\u4E00\u500B OPML \u6A94\u6848","source_export":"\u532F\u51FA\u4F86\u6E90","source_edit":"\u7DE8\u8F2F","source_delete":"\u522A\u9664","source_warn":"\u771F\u7684\u522A\u9664\u9019\u500B\u4F86\u6E90\u55CE\uFF1F","source_new":"\u65B0\u7684\u672A\u5132\u5B58\u4F86\u6E90","source_title":"\u6A19\u984C","source_tags":"\u6A19\u7C64","source_comma":"\u4EE5\u9017\u865F\u5206\u9694","source_select":"\u8ACB\u9078\u64C7\u4F86\u6E90","source_type":"\u985E\u578B","source_save":"\u5132\u5B58","source_cancel":"\u53D6\u6D88","source_saved":"\u5DF2\u5132\u5B58","source_last_post":"\u66F4\u65B0\u65BC","no_entries":"\u627E\u4E0D\u5230\u689D\u76EE","more":"\u66F4\u591A","login":"\u767B\u5165","login_username":"\u4F7F\u7528\u8005\u540D\u7A31","login_password":"\u5BC6\u78BC","no_title":"\u7121\u6A19\u984C","error_saving_color":"\u7121\u6CD5\u5132\u5B58\u65B0\u984F\u8272\uFF1A","error_share_native_abort":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u2014\u6C92\u6709\u5206\u4EAB\u76EE\u6A19\uFF0C\u6216\u8005\u4F60\u5DF2\u53D6\u6D88\u5B83\u3002","article_actions":"\u52D5\u4F5C","error_check_log_file":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u65E5\u8A8C\u6A94\u6848\u300C{0}\u300D\u3002","filter":"\u904E\u6FFE\u5668","share_diaspora_label":"\u5728 Diaspora \u4E0A\u5206\u4EAB","error_add_source":"\u7121\u6CD5\u65B0\u589E\u4F86\u6E90\uFF1A","share_copy_label":"\u8907\u88FD\u9023\u7D50\u81F3\u526A\u8CBC\u7C3F","sources_refreshed":"\u4F86\u6E90\u5DF2\u91CD\u65B0\u6574\u7406","app_reload":"\u91CD\u65B0\u8F09\u5165","error_unknown_source":"\u672A\u77E5\u7684\u4F86\u6E90 ID\uFF1A","error_mark_item":"\u7121\u6CD5\u6A19\u8A18\uFF0F\u53D6\u6D88\u6A19\u8A18\u9805\u76EE\uFF1A","error_refreshing_source":"\u7121\u6CD5\u91CD\u65B0\u6574\u7406\u4F86\u6E90\uFF1A","error_sync":"\u7121\u6CD5\u5F9E\u4F3A\u670D\u5668\u540C\u6B65\u6700\u5F8C\u7684\u8B8A\u66F4\uFF1A","error_offline_storage_not_available":"\u96E2\u7DDA\u5132\u5B58\u4E0D\u53EF\u7528\u3002\u78BA\u4FDD\u4F60\u7684\u7DB2\u9801\u700F\u89BD\u5668{0}\u652F\u63F4 IndexedDB API{1}\uFF0C\u4E26\u4E14\u5982\u679C\u4F60\u6B63\u5728\u4F7F\u7528\u7684\u662F\u57FA\u65BC Google Chrome \u7684\u700F\u89BD\u5668\uFF0C\u8ACB\u78BA\u4FDD\u4F60\u6C92\u6709\u5728\u7121\u75D5\u6A21\u5F0F\u4E0B\u57F7\u884C selfoss\u3002","error_invalid_subsection":"\u7121\u6548\u7684\u5C0F\u7BC0\uFF1A","error_configuration":"\u7121\u6CD5\u8F09\u5165\u914D\u7F6E\u3002","error_share_native":"\u7121\u6CD5\u5206\u4EAB\u9805\u76EE\u3002","info_url_copied":"\u7DB2\u5740\u5DF2\u8907\u88FD\u81F3\u526A\u8CBC\u7C3F\u3002","close_entry":"\u95DC\u9589","online_count":"\u4F3A\u670D\u5668\u4E0A\u53EF\u7528\u7684\u9805\u76EE","searchremove":"\u96B1\u85CF\u641C\u5C0B","offline_count":"\u672C\u5730\u53EF\u7528\u7684\u9805\u76EE","offline_navigation_unavailable":"\u76EE\u524D\u5728\u96E2\u7DDA\u6A21\u5F0F\u4E0B\u7121\u6CD5\u5207\u63DB\u6A19\u7C64\u548C\u4F86\u6E90\u3002","settingsbutton":"\u8A2D\u5B9A","logoutbutton":"\u767B\u51FA","source_filter":"\u904E\u6FFE\u5668","share_twitter_label":"\u5728 Twitter \u4E0A\u5206\u4EAB","share_facebook_label":"\u5728 Facebook \u4E0A\u5206\u4EAB","next":"\u4E0B\u4E00\u500B","share_mastodon_label":"\u5728 Mastodon \u4E0A\u5206\u4EAB","share_pocket_label":"\u5132\u5B58\u81F3 Pocket","refreshbutton":"\u91CD\u65B0\u6574\u7406\u4F86\u6E90","share_wallabag_label":"\u5132\u5B58\u81F3 Wallabag","share_wordpress_label":"\u5728 WordPress \u4E0A\u5206\u4EAB","share_mail_label":"\u4F7F\u7528\u96FB\u5B50\u90F5\u4EF6\u5206\u4EAB","loginbutton":"\u767B\u5165","source_autotitle_hint":"\u7559\u7A7A\u4EE5\u81EA\u52D5\u7372\u53D6\u6A19\u984C","source_saving":"\u6B63\u5728\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\u2026","source_pwd_placeholder":"\u6C92\u6709\u8B8A\u66F4","source_go_to_settings":"\u5728\u8A2D\u5B9A\u4E2D\u958B\u555F","source_refresh":"\u91CD\u65B0\u6574\u7406\u9019\u500B\u4F86\u6E90","error_edit_source":"\u7121\u6CD5\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF1A","search_label":"\u641C\u5C0B\u8A5E\u8A9E","login_invalid_credentials":"\u932F\u8AA4\u7684\u4F7F\u7528\u8005\u540D\u7A31\uFF0F\u5BC6\u78BC","login_offline":"\u96E2\u7DDA\u5132\u5B58","error":"\u767C\u751F\u932F\u8AA4","streamerror":"\u6C92\u6709\u8F09\u5165\u4EFB\u4F55\u9805\u76EE\uFF0C\u91CD\u65B0\u8F09\u5165\u55CE\uFF1F","reload_list":"\u91CD\u65B0\u8F09\u5165\u5217\u8868","app_update":"selfoss \u5DF2\u66F4\u65B0\uFF0C\u8ACB\u91CD\u65B0\u8F09\u5165","error_session_expired":"\u5DE5\u4F5C\u968E\u6BB5\u5DF2\u904E\u671F","error_delete_source":"\u7121\u6CD5\u522A\u9664\u4F86\u6E90\uFF1A","error_load_tags":"\u7121\u6CD5\u8F09\u5165\u6A19\u7C64\uFF1A","error_unknown_tag":"\u672A\u77E5\u7684\u6A19\u7C64\uFF1A","error_mark_items":"\u7121\u6CD5\u6A19\u8A18\u6240\u6709\u53EF\u898B\u9805\u76EE\uFF1A","error_star_item":"\u7121\u6CD5\u52A0\u661F\u6A19\uFF0F\u53D6\u6D88\u661F\u6A19\u9805\u76EE\uFF1A","error_logout":"\u7121\u6CD5\u767B\u51FA\uFF1A","error_loading":"\u8F09\u5165\u932F\u8AA4\uFF1A","error_loading_stats":"\u7121\u6CD5\u8F09\u5165\u5C0E\u822A\u7D71\u8A08\u8CC7\u6599\uFF1A","error_offline_storage":"\u96E2\u7DDA\u5132\u5B58\u932F\u8AA4\uFF1A{0}\u3002\u91CD\u65B0\u8F09\u5165\u53EF\u80FD\u6703\u6709\u6240\u5E6B\u52A9\u3002\u66AB\u6642\u505C\u7528\u96E2\u7DDA\u529F\u80FD\u3002","share_native_label":"\u5206\u4EAB","sources_loading":"\u6B63\u5728\u8F09\u5165\u4F86\u6E90\u2026","no_sources":"\u6C92\u6709\u5DF2\u914D\u7F6E\u7684\u4F86\u6E90\u3002","source_menu":"\u66F4\u591A\u52D5\u4F5C","source_browse":"\u700F\u89BD","source_deleting":"\u6B63\u5728\u522A\u9664\u4F86\u6E90\u2026","source_warn_cancel_dirty":"\u653E\u68C4\u672A\u5132\u5B58\u7684\u8B8A\u66F4\uFF1F","source_params_loading":"\u6B63\u5728\u8F09\u5165\u53C3\u6578\u2026","tag_change_color_button_title":"\u8B8A\u66F4\u984F\u8272","entries_loading":"\u6B63\u5728\u8F09\u5165\u689D\u76EE\u2026","login_in_progress":"\u6B63\u5728\u5617\u8A66\u767B\u5165\u2026","login_error_generic":"\u7121\u6CD5\u767B\u5165\uFF1A{errorMessage}","experimental":"\u5BE6\u9A57\u6027","error_unauthorized":"\u8ACB{link_begin}\u767B\u5165{link_end}\u4EE5\u7E7C\u7E8C\u3002","error_check_system_logs":"\u767C\u751F\u932F\u8AA4\uFF0C\u8ACB\u6AA2\u67E5\u4F60\u7684\u7CFB\u7D71\u65E5\u8A8C\u3002","error_unwritable_logs":"\u7121\u6CD5\u5BEB\u5165\u65E5\u8A8C\u3002","article_reading_time":"{0} \u5206\u9418\u95B1\u8B80","sources_leaving_unsaved_prompt":"\u672A\u5132\u5B58\u4F86\u6E90\u8B8A\u66F4\uFF0C\u96E2\u958B\u8A2D\u5B9A\uFF1F"}');


var $c2dceddc4852359f$var$locales_ = {
    ca: (0, (/*@__PURE__*/$parcel$interopDefault($3109e67d2d012138$exports))),
    cs: (0, (/*@__PURE__*/$parcel$interopDefault($3f89fcb2517a5831$exports))),
    de: (0, (/*@__PURE__*/$parcel$interopDefault($efc21f73bdbf3d30$exports))),
    en: (0, (/*@__PURE__*/$parcel$interopDefault($e8fba7b0a3114fd9$exports))),
    'en-GB': (0, (/*@__PURE__*/$parcel$interopDefault($9bb1025262b0fb39$exports))),
    es: (0, (/*@__PURE__*/$parcel$interopDefault($8ae9bc6f67c8887e$exports))),
    et: (0, (/*@__PURE__*/$parcel$interopDefault($d225499964bebf2a$exports))),
    fi: (0, (/*@__PURE__*/$parcel$interopDefault($d319fa7db54d8a5e$exports))),
    fr: (0, (/*@__PURE__*/$parcel$interopDefault($d0be492086bdc65a$exports))),
    'fr-CA': (0, (/*@__PURE__*/$parcel$interopDefault($bb896106aaedaee8$exports))),
    gl: (0, (/*@__PURE__*/$parcel$interopDefault($acbbfcabee63ed13$exports))),
    he: (0, (/*@__PURE__*/$parcel$interopDefault($b6d92725827c8d30$exports))),
    hu: (0, (/*@__PURE__*/$parcel$interopDefault($a93f0f568ed4bbb3$exports))),
    id: (0, (/*@__PURE__*/$parcel$interopDefault($e1a0d6c367542bd9$exports))),
    it: (0, (/*@__PURE__*/$parcel$interopDefault($d48d8cf661c7528d$exports))),
    ja: (0, (/*@__PURE__*/$parcel$interopDefault($f0732a5d7f7054ed$exports))),
    lv: (0, (/*@__PURE__*/$parcel$interopDefault($5170287447d26972$exports))),
    nb: (0, (/*@__PURE__*/$parcel$interopDefault($7058dfe60927e7af$exports))),
    nl: (0, (/*@__PURE__*/$parcel$interopDefault($51d8b37b1373d182$exports))),
    pl: (0, (/*@__PURE__*/$parcel$interopDefault($3d25a85d30cd5367$exports))),
    pt: (0, (/*@__PURE__*/$parcel$interopDefault($b01b1dfd07b9091e$exports))),
    'pt-BR': (0, (/*@__PURE__*/$parcel$interopDefault($f7917dde3df00ba4$exports))),
    rm: (0, (/*@__PURE__*/$parcel$interopDefault($3e02282570dcf5ad$exports))),
    ru: (0, (/*@__PURE__*/$parcel$interopDefault($ee2b610e60c3d44b$exports))),
    sk: (0, (/*@__PURE__*/$parcel$interopDefault($430ac65b39f56697$exports))),
    sv: (0, (/*@__PURE__*/$parcel$interopDefault($7b91bdeeaf0bdb85$exports))),
    ta: (0, (/*@__PURE__*/$parcel$interopDefault($4bf6b321c83cc414$exports))),
    tr: (0, (/*@__PURE__*/$parcel$interopDefault($64a33f7e6e987d4f$exports))),
    uk: (0, (/*@__PURE__*/$parcel$interopDefault($563d7fbeeac49c6b$exports))),
    'zh-CN': (0, (/*@__PURE__*/$parcel$interopDefault($94f63a341744b7b8$exports))),
    'zh-TW': (0, (/*@__PURE__*/$parcel$interopDefault($d97043994cabe9e3$exports)))
};
var $c2dceddc4852359f$var$localeKeys = new Set(Object.keys($c2dceddc4852359f$var$locales_));
var $c2dceddc4852359f$var$locales = $c2dceddc4852359f$var$locales_;
var $c2dceddc4852359f$export$2e2bcd8739ae039 = $c2dceddc4852359f$var$locales;
function $c2dceddc4852359f$export$b7c662043e31af59(lang) {
    return $c2dceddc4852359f$var$localeKeys.has(lang);
}





var $eHaBZ = parcelRequire("eHaBZ");



function $5aca81ca228d94ac$export$2e2bcd8739ae039(props) {
    var ref = props.ref, children = props.children;
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("dialog", {
        ref: ref,
        onClick: function(param) {
            var target = param.target, currentTarget = param.currentTarget;
            if (target === currentTarget) ref.current.close();
        },
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                "aria-label": _('close_dialog'),
                className: "close",
                onClick: function() {
                    ref.current.close();
                },
                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                    icon: $ea95ad8a568dd277$exports.faTimesCircle
                })
            }),
            children
        ]
    });
}



var $21h22 = parcelRequire("21h22");

parcelRequire("eHaBZ");

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */ var $55b19a74a5c7b055$export$2e2bcd8739ae039 = Array.isArray || function _isArray(val) {
    return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};


function $5e1e9de64a52ce83$export$2e2bcd8739ae039(methodname, fn) {
    return function() {
        var length = arguments.length;
        if (length === 0) return fn();
        var obj = arguments[length - 1];
        return (0, $55b19a74a5c7b055$export$2e2bcd8739ae039)(obj) || typeof obj[methodname] !== 'function' ? fn.apply(this, arguments) : obj[methodname].apply(obj, Array.prototype.slice.call(arguments, 0, length - 1));
    };
}



var $2bfPH = parcelRequire("2bfPH");
function $364dc95bb401516c$export$2e2bcd8739ae039(a) {
    return a != null && (typeof a === "undefined" ? "undefined" : (0, $2bfPH._)(a)) === 'object' && a['@@functional/placeholder'] === true;
}


function $b9e99a9b1f3f0b20$export$2e2bcd8739ae039(fn) {
    return function f1(a) {
        if (arguments.length === 0 || (0, $364dc95bb401516c$export$2e2bcd8739ae039)(a)) return f1;
        else return fn.apply(this, arguments);
    };
}



function $bb1b9d2d1afb3140$export$2e2bcd8739ae039(fn) {
    return function f2(a, b) {
        switch(arguments.length){
            case 0:
                return f2;
            case 1:
                return (0, $364dc95bb401516c$export$2e2bcd8739ae039)(a) ? f2 : (0, $b9e99a9b1f3f0b20$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                });
            default:
                return (0, $364dc95bb401516c$export$2e2bcd8739ae039)(a) && (0, $364dc95bb401516c$export$2e2bcd8739ae039)(b) ? f2 : (0, $364dc95bb401516c$export$2e2bcd8739ae039)(a) ? (0, $b9e99a9b1f3f0b20$export$2e2bcd8739ae039)(function(_a) {
                    return fn(_a, b);
                }) : (0, $364dc95bb401516c$export$2e2bcd8739ae039)(b) ? (0, $b9e99a9b1f3f0b20$export$2e2bcd8739ae039)(function(_b) {
                    return fn(a, _b);
                }) : fn(a, b);
        }
    };
}


/**
 * Creates a new list with the separator interposed between elements.
 *
 * Dispatches to the `intersperse` method of the second argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.14.0
 * @category List
 * @sig a -> [a] -> [a]
 * @param {*} separator The element to add to the list.
 * @param {Array} list The list to be interposed.
 * @return {Array} The new list.
 * @example
 *
 *      R.intersperse('a', ['b', 'n', 'n', 's']); //=> ['b', 'a', 'n', 'a', 'n', 'a', 's']
 */ var $2b11e9cddac1e48b$var$intersperse = /*#__PURE__*/ (0, $bb1b9d2d1afb3140$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $5e1e9de64a52ce83$export$2e2bcd8739ae039)('intersperse', function _intersperse(separator, list) {
    var length = list.length;
    if (length === 0) return [];
    var out = Array(length * 2 - 1);
    var idx = 0;
    while(idx < length){
        var i = idx * 2;
        if (idx === length - 1) out[i] = list[idx];
        else {
            out[i] = list[idx];
            out[i + 1] = separator;
        }
        idx += 1;
    }
    return out;
}));
var $2b11e9cddac1e48b$export$2e2bcd8739ae039 = $2b11e9cddac1e48b$var$intersperse;


function $9f47a8e9e5987627$export$2e2bcd8739ae039() {
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("section", {
        className: "shortcuts",
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("h2", {
                children: "Keybindings"
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("dl", {
                children: Object.entries((0, $7b7d7b033768f390$export$9784374fba94ce79)).map(function(param) {
                    var _param = (0, $21h22._)(param, 2), keycombo = _param[0], keybinding = _param[1];
                    var readableKeycombo;
                    if (keybinding.readableName) readableKeycombo = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("kbd", {
                        children: keybinding.readableName
                    });
                    else if (keycombo.includes('+')) {
                        var keys = keycombo.split('+') // key={key} required for TS
                        .map(function(key) {
                            return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("kbd", {
                                children: key
                            }, key);
                        });
                        readableKeycombo = (0, $2b11e9cddac1e48b$export$2e2bcd8739ae039)(/*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                            children: "+"
                        }), keys);
                    } else readableKeycombo = /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("kbd", {
                        children: keycombo
                    });
                    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $f171543c027e46e7$exports.Fragment), {
                        children: [
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("dt", {
                                children: readableKeycombo
                            }),
                            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("dd", {
                                children: keybinding.description
                            })
                        ]
                    });
                })
            })
        ]
    });
}


function $533545e730c06947$var$handleNavToggle(args) {
    var event = args.event, setNavExpanded = args.setNavExpanded;
    event.preventDefault();
    // show hide navigation for mobile version
    setNavExpanded(function(expanded) {
        return !expanded;
    });
    window.scrollTo({
        top: 0
    });
}
function $533545e730c06947$var$dismissMessage(event) {
    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setGlobalMessage(null);
    event.stopPropagation();
}
/**
 * Global message bar for showing errors/information at the top of the page.
 * It watches globalMessage and updates/shows/hides itself as necessary
 * when the value changes.
 */ function $533545e730c06947$var$Message(props) {
    var message = props.message;
    // Whenever message changes, dismiss it after 15 seconds.
    (0, $eHaBZ.useEffect)(function() {
        if (message !== null) {
            var dismissTimeout = window.setTimeout(function() {
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setGlobalMessage(null);
            }, 15000);
            return function() {
                // Destory previous timeout.
                window.clearTimeout(dismissTimeout);
            };
        }
    }, [
        message
    ]);
    return message !== null ? /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
        id: "message",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
            error: message.isError
        }),
        onClick: $533545e730c06947$var$dismissMessage,
        children: [
            message.message,
            message.actions.map(function(param, index) {
                var label = param.label, callback = param.callback;
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                    type: "button",
                    onClick: callback,
                    children: label
                }, index);
            })
        ]
    }) : null;
}
function $533545e730c06947$var$NotFound() {
    var location = (0, $3d1fd3a25027abce$export$45d76561a5302f2b)();
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("p", {
        children: _('error_invalid_subsection') + location.pathname
    });
}
function $533545e730c06947$var$CheckAuthorization(props) {
    var isAllowed = props.isAllowed, returnLocation = props.returnLocation, _ = props._, children = props.children;
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    var redirect = (0, $eHaBZ.useEffectEvent)(function() {
        navigate('/sign/in', {
            state: {
                returnLocation: returnLocation
            }
        });
    });
    (0, $eHaBZ.useEffect)(function() {
        if (!isAllowed) redirect();
    }, [
        isAllowed
    ]);
    if (!isAllowed) {
        var __split = (0, $21h22._)(_('error_unauthorized').split(/\{(?:link_begin|link_end)\}/), 3), preLink = __split[0], inLink = __split[1], postLink = __split[2];
        return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("p", {
            children: [
                preLink,
                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$a6c7ac8248d6e38a), {
                    to: "/sign/in",
                    children: inLink
                }),
                postLink
            ]
        });
    } else return children;
}
// Work around for regex patterns not being supported
// https://github.com/remix-run/react-router/issues/8254
function $533545e730c06947$var$EntriesFilter(props) {
    var entriesRef = props.entriesRef, setNavExpanded = props.setNavExpanded, configuration = props.configuration, navSourcesExpanded = props.navSourcesExpanded, unreadItemsCount = props.unreadItemsCount, setGlobalUnreadCount = props.setGlobalUnreadCount, showError = props.showError;
    var params = (0, $3d1fd3a25027abce$export$216385125ee84ae7)();
    if (params === null) return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$NotFound, {});
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $ac2cb81ab85428fa$export$2e2bcd8739ae039), {
        ref: entriesRef,
        setNavExpanded: setNavExpanded,
        configuration: configuration,
        navSourcesExpanded: navSourcesExpanded,
        unreadItemsCount: unreadItemsCount,
        setGlobalUnreadCount: setGlobalUnreadCount,
        showError: showError
    });
}
function $533545e730c06947$var$PureApp(props) {
    var navSourcesExpanded = props.navSourcesExpanded, setNavSourcesExpanded = props.setNavSourcesExpanded, offlineState = props.offlineState, allItemsCount = props.allItemsCount, allItemsOfflineCount = props.allItemsOfflineCount, unreadItemsCount = props.unreadItemsCount, unreadItemsOfflineCount = props.unreadItemsOfflineCount, starredItemsCount = props.starredItemsCount, starredItemsOfflineCount = props.starredItemsOfflineCount, globalMessage = props.globalMessage, sourcesState = props.sourcesState, setSourcesState = props.setSourcesState, sources = props.sources, setSources = props.setSources, tags = props.tags, reloadAll = props.reloadAll, showError = props.showError;
    var _useState = (0, $21h22._)((0, $eHaBZ.useState)(false), 2), navExpanded = _useState[0], setNavExpanded = _useState[1];
    var shortcutsDialog = (0, $eHaBZ.useRef)(null);
    var smartphone = (0, $74ba0882e4d762a0$export$443718c44347a6b3)();
    var offlineEnabled = (0, $74ba0882e4d762a0$export$96b5b894afc1d2e3)((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline);
    var _useState1 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), entriesPage = _useState1[0], setEntriesPage = _useState1[1];
    var configuration = (0, $eHaBZ.use)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e));
    (0, $eHaBZ.useEffect)(function() {
        // init shortcut handler
        var destroyShortcuts = (0, $7b7d7b033768f390$export$2e2bcd8739ae039)(shortcutsDialog);
        return function() {
            destroyShortcuts();
        };
    }, []);
    // TODO: move stuff that depends on this to the App.
    var navigate = (0, $0386ffc241ff4f20$export$9770f232ac06a008)();
    (0, $eHaBZ.useEffect)(function() {
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).navigate = navigate;
    }, [
        navigate
    ]);
    // Prepare path of the homepage for redirecting from /
    var homePagePath = configuration.homepage.split('/');
    if (!homePagePath[1]) homePagePath.push('all');
    var menuButtonOnClick = (0, $eHaBZ.useCallback)(function(event) {
        return $533545e730c06947$var$handleNavToggle({
            event: event,
            setNavExpanded: setNavExpanded
        });
    }, []);
    var entriesRef = (0, $eHaBZ.useCallback)(function(entriesPage) {
        setEntriesPage(entriesPage);
        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage = entriesPage;
        return function() {
            setEntriesPage(null);
            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage = null;
        };
    }, []);
    var _useState2 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), title = _useState2[0], setTitle = _useState2[1];
    var _useState3 = (0, $21h22._)((0, $eHaBZ.useState)(null), 2), globalUnreadCount = _useState3[0], setGlobalUnreadCount = _useState3[1];
    var titleText = (0, $eHaBZ.useMemo)(function() {
        return (title !== null && title !== void 0 ? title : configuration.htmlTitle) + ((globalUnreadCount !== null && globalUnreadCount !== void 0 ? globalUnreadCount : 0) > 0 ? " (".concat(globalUnreadCount, ")") : '');
    }, [
        configuration,
        title,
        globalUnreadCount
    ]);
    var _ = (0, $eHaBZ.use)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d));
    var isAllowedToRead = (0, $afaa653977073dac$export$f5bdb3b3cec7f803)();
    var isAllowedToWrite = (0, $afaa653977073dac$export$b416b77cd328c02f)();
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).StrictMode, {
        children: [
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("title", {
                children: titleText
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$Message, {
                message: globalMessage
            }),
            /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $d6e338e05ac94550$export$3565eb3d00ca5a74), {
                children: [
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                        path: "/sign/in",
                        element: /* menu open for smartphone */ /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                            id: "loginform",
                            role: "main",
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $7c130f6079f220d1$export$2e2bcd8739ae039), {
                                offlineEnabled: offlineEnabled
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                        path: "/password",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/password",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                id: "hashpasswordbody",
                                role: "main",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8c215e0b3d175d5e$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                        path: "/opml",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$CheckAuthorization, {
                            isAllowed: isAllowedToWrite,
                            returnLocation: "/opml",
                            _: _,
                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("main", {
                                id: "opmlbody",
                                children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $78e4b177702c1375$export$2e2bcd8739ae039), {
                                    setTitle: setTitle
                                })
                            })
                        })
                    }),
                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                        path: "*",
                        element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)($533545e730c06947$var$CheckAuthorization, {
                            isAllowed: isAllowedToRead,
                            _: _,
                            children: [
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                    id: "nav-mobile",
                                    role: "navigation",
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                            id: "nav-mobile-logo",
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                                id: "nav-mobile-count",
                                                className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                    'unread-count': true,
                                                    offline: offlineState,
                                                    online: !offlineState,
                                                    unread: unreadItemsCount > 0
                                                }),
                                                children: [
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: (0, (/*@__PURE__*/$parcel$interopDefault($c31009cc66f4e9b8$exports)))({
                                                            'offline-count': true,
                                                            offline: offlineState,
                                                            online: !offlineState,
                                                            diff: unreadItemsCount !== unreadItemsOfflineCount && unreadItemsOfflineCount
                                                        }),
                                                        children: unreadItemsOfflineCount > 0 ? unreadItemsOfflineCount : ''
                                                    }),
                                                    /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("span", {
                                                        className: "count",
                                                        children: unreadItemsCount
                                                    })
                                                ]
                                            })
                                        }),
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("button", {
                                            id: "nav-mobile-settings",
                                            accessKey: "t",
                                            "aria-label": _('settingsbutton'),
                                            onClick: menuButtonOnClick,
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $a50446a11289d212$export$2b9260d4a45c8710), {
                                                icon: $18f640b80ac26745$exports.faCog,
                                                size: "2x"
                                            })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $8929b96d30942b2d$export$78768a9af065a7b), {
                                    isOpen: !smartphone || navExpanded,
                                    className: "collapse-css-transition",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("div", {
                                        id: "nav",
                                        role: "navigation",
                                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $b2eaf2bd11c6300f$export$2e2bcd8739ae039), {
                                            entriesPage: entriesPage,
                                            setNavExpanded: setNavExpanded,
                                            navSourcesExpanded: navSourcesExpanded,
                                            setNavSourcesExpanded: setNavSourcesExpanded,
                                            offlineState: offlineState,
                                            allItemsCount: allItemsCount,
                                            allItemsOfflineCount: allItemsOfflineCount,
                                            unreadItemsCount: unreadItemsCount,
                                            unreadItemsOfflineCount: unreadItemsOfflineCount,
                                            starredItemsCount: starredItemsCount,
                                            starredItemsOfflineCount: starredItemsOfflineCount,
                                            sourcesState: sourcesState,
                                            setSourcesState: setSourcesState,
                                            sources: sources,
                                            setSources: setSources,
                                            tags: tags,
                                            reloadAll: reloadAll,
                                            showError: showError
                                        })
                                    })
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)("ul", {
                                    id: "search-list",
                                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d7222e1328a07ffe$export$2e2bcd8739ae039), {})
                                }),
                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)("div", {
                                    id: "content",
                                    role: "main",
                                    children: [
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsxs)((0, $d6e338e05ac94550$export$3565eb3d00ca5a74), {
                                            children: [
                                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                                                    path: "/",
                                                    element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$444b3ab0cb9aec40), {
                                                        to: "/".concat(homePagePath.join('/')),
                                                        replace: true
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                                                    path: "/:filter/:category/:id?",
                                                    element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$EntriesFilter, {
                                                        entriesRef: entriesRef,
                                                        setNavExpanded: setNavExpanded,
                                                        configuration: configuration,
                                                        navSourcesExpanded: navSourcesExpanded,
                                                        unreadItemsCount: unreadItemsCount,
                                                        setGlobalUnreadCount: setGlobalUnreadCount,
                                                        showError: showError
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                                                    path: "/manage/sources/add?",
                                                    element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $3e9307fdfcc7e06c$export$2e2bcd8739ae039), {
                                                        showError: showError
                                                    })
                                                }),
                                                /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $d6e338e05ac94550$export$e7b0ac011bb776c6), {
                                                    path: "*",
                                                    element: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$NotFound, {})
                                                })
                                            ]
                                        }),
                                        /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $5aca81ca228d94ac$export$2e2bcd8739ae039), {
                                            ref: shortcutsDialog,
                                            children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $9f47a8e9e5987627$export$2e2bcd8739ae039), {})
                                        })
                                    ]
                                })
                            ]
                        })
                    })
                ]
            })
        ]
    });
}
var $533545e730c06947$export$86fbec116b87613f = /*#__PURE__*/ function(_React_Component) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(App, _React_Component);
    function App(props) {
        (0, $gd0sY._)(this, App);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, App, [
            props
        ]);
        _this.state = {
            tags: [],
            tagsState: (0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL,
            sources: [],
            sourcesState: (0, $51c68a66a52c2555$export$62aa48085237e36f).INITIAL,
            navSourcesExpanded: false,
            offlineState: false,
            unreadItemsCount: 0,
            unreadItemsOfflineCount: 0,
            starredItemsCount: 0,
            starredItemsOfflineCount: 0,
            allItemsCount: 0,
            allItemsOfflineCount: 0,
            globalMessage: null
        };
        _this._ = _this._.bind(_this);
        _this.setTags = _this.setTags.bind(_this);
        _this.setTagsState = _this.setTagsState.bind(_this);
        _this.setSources = _this.setSources.bind(_this);
        _this.setSourcesState = _this.setSourcesState.bind(_this);
        _this.setOfflineState = _this.setOfflineState.bind(_this);
        _this.setNavSourcesExpanded = _this.setNavSourcesExpanded.bind(_this);
        _this.setUnreadItemsCount = _this.setUnreadItemsCount.bind(_this);
        _this.setUnreadItemsOfflineCount = _this.setUnreadItemsOfflineCount.bind(_this);
        _this.setStarredItemsCount = _this.setStarredItemsCount.bind(_this);
        _this.setStarredItemsOfflineCount = _this.setStarredItemsOfflineCount.bind(_this);
        _this.setAllItemsCount = _this.setAllItemsCount.bind(_this);
        _this.setAllItemsOfflineCount = _this.setAllItemsOfflineCount.bind(_this);
        _this.setGlobalMessage = _this.setGlobalMessage.bind(_this);
        _this.showError = _this.showError.bind(_this);
        _this.reloadAll = _this.reloadAll.bind(_this);
        var ref;
        ref = (0, $21h22._)(App.setupLocales(props.configuration.language), 2), _this.primaryLocale = ref[0], _this.fallbackLocale = ref[1], ref;
        return _this;
    }
    (0, $7cSld._)(App, [
        {
            key: "setTags",
            value: function setTags(tags) {
                if (typeof tags === 'function') this.setState(function(state) {
                    return {
                        tags: tags(state.tags)
                    };
                });
                else this.setState({
                    tags: tags
                });
            }
        },
        {
            key: "setTagsState",
            value: function setTagsState(tagsState) {
                if (typeof tagsState === 'function') this.setState(function(state) {
                    return {
                        tagsState: tagsState(state.tagsState)
                    };
                });
                else this.setState({
                    tagsState: tagsState
                });
            }
        },
        {
            key: "setSources",
            value: function setSources(sources) {
                if (typeof sources === 'function') this.setState(function(state) {
                    return {
                        sources: sources(state.sources)
                    };
                });
                else this.setState({
                    sources: sources
                });
            }
        },
        {
            key: "setSourcesState",
            value: function setSourcesState(sourcesState) {
                if (typeof sourcesState === 'function') this.setState(function(state) {
                    return {
                        sourcesState: sourcesState(state.sourcesState)
                    };
                });
                else this.setState({
                    sourcesState: sourcesState
                });
            }
        },
        {
            key: "setOfflineState",
            value: function setOfflineState(offlineState) {
                if (typeof offlineState === 'function') this.setState(function(state) {
                    return {
                        offlineState: offlineState(state.offlineState)
                    };
                });
                else this.setState({
                    offlineState: offlineState
                });
            }
        },
        {
            key: "setNavSourcesExpanded",
            value: function setNavSourcesExpanded(navSourcesExpanded) {
                if (typeof navSourcesExpanded === 'function') this.setState(function(state) {
                    return {
                        navSourcesExpanded: navSourcesExpanded(state.navSourcesExpanded)
                    };
                });
                else this.setState({
                    navSourcesExpanded: navSourcesExpanded
                });
            }
        },
        {
            key: "setUnreadItemsCount",
            value: function setUnreadItemsCount(unreadItemsCount) {
                if (typeof unreadItemsCount === 'function') this.setState(function(state) {
                    return {
                        unreadItemsCount: unreadItemsCount(state.unreadItemsCount)
                    };
                });
                else this.setState({
                    unreadItemsCount: unreadItemsCount
                });
            }
        },
        {
            key: "setUnreadItemsOfflineCount",
            value: function setUnreadItemsOfflineCount(unreadItemsOfflineCount) {
                if (typeof unreadItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        unreadItemsOfflineCount: unreadItemsOfflineCount(state.unreadItemsOfflineCount)
                    };
                });
                else this.setState({
                    unreadItemsOfflineCount: unreadItemsOfflineCount
                });
            }
        },
        {
            key: "setStarredItemsCount",
            value: function setStarredItemsCount(starredItemsCount) {
                if (typeof starredItemsCount === 'function') this.setState(function(state) {
                    return {
                        starredItemsCount: starredItemsCount(state.starredItemsCount)
                    };
                });
                else this.setState({
                    starredItemsCount: starredItemsCount
                });
            }
        },
        {
            key: "setStarredItemsOfflineCount",
            value: function setStarredItemsOfflineCount(starredItemsOfflineCount) {
                if (typeof starredItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        starredItemsOfflineCount: starredItemsOfflineCount(state.starredItemsOfflineCount)
                    };
                });
                else this.setState({
                    starredItemsOfflineCount: starredItemsOfflineCount
                });
            }
        },
        {
            key: "setAllItemsCount",
            value: function setAllItemsCount(allItemsCount) {
                if (typeof allItemsCount === 'function') this.setState(function(state) {
                    return {
                        allItemsCount: allItemsCount(state.allItemsCount)
                    };
                });
                else this.setState({
                    allItemsCount: allItemsCount
                });
            }
        },
        {
            key: "setAllItemsOfflineCount",
            value: function setAllItemsOfflineCount(allItemsOfflineCount) {
                if (typeof allItemsOfflineCount === 'function') this.setState(function(state) {
                    return {
                        allItemsOfflineCount: allItemsOfflineCount(state.allItemsOfflineCount)
                    };
                });
                else this.setState({
                    allItemsOfflineCount: allItemsOfflineCount
                });
            }
        },
        {
            key: "setGlobalMessage",
            value: function setGlobalMessage(globalMessage) {
                if (typeof globalMessage === 'function') this.setState(function(state) {
                    return {
                        globalMessage: globalMessage(state.globalMessage)
                    };
                });
                else this.setState({
                    globalMessage: globalMessage
                });
            }
        },
        {
            /**
     * Triggers fetching news from all sources.
     */ key: "reloadAll",
            value: function reloadAll() {
                var _this = this;
                if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isOnline()) return Promise.resolve();
                return $c937d70a1b132a36$export$c5eb18431f66026b().then(function() {
                    // probe stats and prompt reload to the user
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.sync().then(function() {
                        if (_this.state.unreadItemsCount > 0) _this.showMessage(_this._('sources_refreshed'), [
                            {
                                label: _this._('reload_list'),
                                callback: function() {
                                    document.querySelector('#nav-filter-unread').click();
                                }
                            }
                        ]);
                    });
                }).catch(function(error) {
                    _this.showError(_this._('error_refreshing_source') + ' ' + error.message);
                });
            }
        },
        {
            /**
     * Obtain a localized message for given key, substituting placeholders for values, when given.
     */ key: "_",
            value: function _(identifier, params) {
                var translated = this.primaryLocale[identifier] || this.fallbackLocale[identifier];
                if (params) translated = (0, $f2be1a5bddfb7605$export$e51161e9fbfde80e)(translated, params);
                return translated;
            }
        },
        {
            /**
     * Show error message in the message bar in the UI.
     */ key: "showError",
            value: function showError(message) {
                this.showMessage(message, [], true);
            }
        },
        {
            /**
     * Show message in the message bar in the UI.
     */ key: "showMessage",
            value: function showMessage(message) {
                var actions = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [], isError = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
                this.setGlobalMessage({
                    message: message,
                    actions: actions,
                    isError: isError
                });
            }
        },
        {
            key: "notifyNewVersion",
            value: function notifyNewVersion(cb) {
                if (!cb) cb = function() {
                    window.location.reload();
                };
                this.showMessage(this._('app_update'), [
                    {
                        label: this._('app_reload'),
                        callback: cb
                    }
                ]);
            }
        },
        {
            key: "refreshTagSourceUnread",
            value: function refreshTagSourceUnread(tagCounts, sourceCounts) {
                var diff = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                this.setTags(function(tags) {
                    return tags.map(function(tag) {
                        if (!(tag.tag in tagCounts)) return tag;
                        var unread;
                        if (diff) unread = tag.unread + tagCounts[tag.tag];
                        else unread = tagCounts[tag.tag];
                        return (0, $9Jpjh._)((0, $lvTkn._)({}, tag), {
                            unread: unread
                        });
                    });
                });
                this.setSources(function(sources) {
                    return sources.map(function(source) {
                        if (!(source.id in sourceCounts)) return source;
                        var unread;
                        if (diff) unread = source.unread + sourceCounts[source.id];
                        else unread = sourceCounts[source.id];
                        return (0, $9Jpjh._)((0, $lvTkn._)({}, source), {
                            unread: unread
                        });
                    });
                });
            }
        },
        {
            key: "refreshOfflineCounts",
            value: function refreshOfflineCounts(offlineCounts) {
                var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                try {
                    for(var _iterator = Object.entries(offlineCounts)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                        var _step_value = (0, $21h22._)(_step.value, 2), kind = _step_value[0], newCount = _step_value[1];
                        if (newCount === 'keep') continue;
                        if (kind === 'unread') this.setUnreadItemsOfflineCount(newCount);
                        else if (kind === 'starred') this.setStarredItemsOfflineCount(newCount);
                        else if (kind === 'newest') this.setAllItemsOfflineCount(newCount);
                    }
                } catch (err) {
                    _didIteratorError = true;
                    _iteratorError = err;
                } finally{
                    try {
                        if (!_iteratorNormalCompletion && _iterator.return != null) {
                            _iterator.return();
                        }
                    } finally{
                        if (_didIteratorError) {
                            throw _iteratorError;
                        }
                    }
                }
            }
        },
        {
            key: "render",
            value: function render() {
                return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $3218aa08983fdbc5$export$326f6d1b69f1c06e), {
                    value: this.props.configuration,
                    children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $f2be1a5bddfb7605$export$51216bcc3983e55d), {
                        value: this._,
                        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$var$PureApp, {
                            navSourcesExpanded: this.state.navSourcesExpanded,
                            setNavSourcesExpanded: this.setNavSourcesExpanded,
                            offlineState: this.state.offlineState,
                            allItemsCount: this.state.allItemsCount,
                            allItemsOfflineCount: this.state.allItemsOfflineCount,
                            unreadItemsCount: this.state.unreadItemsCount,
                            unreadItemsOfflineCount: this.state.unreadItemsOfflineCount,
                            starredItemsCount: this.state.starredItemsCount,
                            starredItemsOfflineCount: this.state.starredItemsOfflineCount,
                            globalMessage: this.state.globalMessage,
                            sourcesState: this.state.sourcesState,
                            setSourcesState: this.setSourcesState,
                            sources: this.state.sources,
                            setSources: this.setSources,
                            tags: this.state.tags,
                            reloadAll: this.reloadAll,
                            showError: this.showError
                        })
                    })
                });
            }
        }
    ], [
        {
            key: "setupLocales",
            value: function setupLocales(configuredLanguage) {
                var fallbackLanguage = 'en';
                var preferredLanguage;
                // locale auto-detection
                if (configuredLanguage === null) {
                    if ('languages' in navigator) preferredLanguage = navigator.languages.find((0, $c2dceddc4852359f$export$b7c662043e31af59));
                } else if ((0, $c2dceddc4852359f$export$b7c662043e31af59)(configuredLanguage)) preferredLanguage = configuredLanguage;
                if (preferredLanguage === undefined) preferredLanguage = fallbackLanguage;
                return [
                    (0, $c2dceddc4852359f$export$2e2bcd8739ae039)[preferredLanguage],
                    (0, $c2dceddc4852359f$export$2e2bcd8739ae039)[fallbackLanguage]
                ];
            }
        }
    ]);
    return App;
}((0, (/*@__PURE__*/$parcel$interopDefault($eHaBZ))).Component);
function $533545e730c06947$export$4e373c34abfa8c68(args) {
    var basePath = args.basePath, appRef = args.appRef, configuration = args.configuration;
    return /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)((0, $e19387da9012a331$export$9ba4e89fdfa1fc54), {
        basename: basePath,
        children: /*#__PURE__*/ (0, $f171543c027e46e7$exports.jsx)($533545e730c06947$export$86fbec116b87613f, {
            ref: appRef,
            configuration: configuration
        })
    });
}



var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $lvTkn = parcelRequire("lvTkn");

var $9Jpjh = parcelRequire("9Jpjh");




var $ff223f7787ec6ae0$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function DbOnline() {
        (0, $gd0sY._)(this, DbOnline);
        this.syncing = {
            promise: null,
            request: null,
            resolve: null,
            reject: null
        };
        this.statsDirty = false;
        this.firstSync = true;
    }
    (0, $7cSld._)(DbOnline, [
        {
            key: "_syncBegin",
            value: function _syncBegin() {
                var _this = this;
                if (!this.syncing.promise) {
                    this.syncing.promise = new Promise(function(resolve, reject) {
                        _this.syncing.resolve = resolve;
                        _this.syncing.reject = reject;
                        var monitor = window.setInterval(function() {
                            var stopChecking = false;
                            if (_this.syncing.promise) {
                                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.userWaiting) {
                                    // reject if user has been waiting for more than 10s,
                                    // this means that connectivity is bad: user will get
                                    // local content and server request will continue in
                                    // the background.
                                    reject();
                                    stopChecking = true;
                                }
                            } else stopChecking = true;
                            if (stopChecking) window.clearInterval(monitor);
                        }, 10000);
                    });
                    this.syncing.promise.finally(function() {
                        _this.syncing.promise = null;
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.userWaiting = false;
                    });
                }
                return this.syncing.promise;
            }
        },
        {
            key: "_syncDone",
            value: function _syncDone() {
                var success = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
                if (this.syncing.promise) {
                    if (success) this.syncing.resolve();
                    else {
                        var request = this.syncing.request;
                        this.syncing.reject();
                        if (request) request.controller.abort();
                    }
                }
            }
        },
        {
            /**
     * sync server status.
     */ key: "sync",
            value: function sync(updatedStatuses) {
                var _this = this;
                var chained = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
                if (this.syncing.promise && !chained) {
                    if (updatedStatuses) // Ensure the status queue is not cleared and gets sync'ed at
                    // next sync.
                    return Promise.reject();
                    else return this.syncing.promise;
                }
                var syncing = this._syncBegin();
                var getStatuses = true;
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate === null || this.firstSync) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate = new Date(0);
                    getStatuses = undefined;
                }
                var syncParams = {
                    since: (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate,
                    tags: true,
                    sources: (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.navSourcesExpanded || undefined,
                    itemsStatuses: getStatuses
                };
                if (updatedStatuses && updatedStatuses.length > 0) syncParams.updatedStatuses = updatedStatuses;
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) {
                    syncParams.itemsSinceId = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.lastItemId;
                    syncParams.itemsNotBefore = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.newestGCedEntry;
                    syncParams.itemsHowMany = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.itemsPerPage;
                }
                this.statsDirty = false;
                this.syncing.request = $8af27e6da99b5030$export$92d6409d68f0739a(updatedStatuses, syncParams);
                this.syncing.request.promise.then(function(data) {
                    var _selfoss_entriesPage;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.setOnline();
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastSync = Date.now();
                    _this.firstSync = false;
                    var dataDate = data.lastUpdate;
                    var storing = false;
                    if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) {
                        if ('newItems' in data) {
                            var maxId = 0;
                            data.newItems.forEach(function(item) {
                                maxId = Math.max(item.id, maxId);
                            });
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing = 'lastId' in data && data.lastId > (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.lastItemId && data.lastId > maxId;
                            storing = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing;
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.shouldLoadEntriesOnline = 'lastId' in data && data.lastId - (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.lastItemId > 2 * (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.itemsPerPage;
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.storeEntries(data.newItems).then(function() {
                                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                                _this._syncDone();
                            });
                        }
                        if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.newerEntriesMissing || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.needsSync) // There are still new items to fetch
                        // or statuses to send
                        syncing.then(function() {
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                        });
                        if ('itemUpdates' in data) // refresh entry statuses in db and dequeue queued
                        // statuses but do not calculate stats as they are taken
                        // directly from the server as provided.
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.storeEntryStatuses(data.itemUpdates, true, false).then(function() {
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.storeLastUpdate(dataDate);
                        });
                        if ('stats' in data) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.storeStats(data.stats);
                    }
                    if (!_this.statsDirty && 'stats' in data) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).refreshStats(data.stats.total, data.stats.unread, data.stats.starred);
                    if ('tags' in data) {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTags(data.tags);
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                    }
                    if ('sources' in data) {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSources(data.sources);
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSourcesState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                    }
                    if ('stats' in data && data.stats.unread > 0 && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage && ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.state.entries.length === 0 || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.state.loadingState === (0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE)) (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
                    else {
                        if ('itemUpdates' in data) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.refreshEntryStatuses(data.itemUpdates);
                        if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.getActiveFilter() === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD) {
                            var unreadCount = 'stats' in data ? data.stats.unread : (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.unreadItemsCount;
                            if (unreadCount > (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.state.entries.filter(function(param) {
                                var unread = param.unread;
                                return unread;
                            }).length) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage.setHasMore(true);
                        }
                    }
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate = dataDate;
                    if (!storing) _this._syncDone();
                }).catch(function(error) {
                    _this._syncDone(false);
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error).catch(function(error) {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.showError((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app._('error_sync') + ' ' + error.message);
                    });
                }).finally(function() {
                    if (_this.syncing.promise) _this.syncing.request = null;
                });
                return syncing;
            }
        },
        {
            /**
     * refresh current items.
     */ key: "getEntries",
            value: function getEntries(fetchParams, abortController) {
                return $8af27e6da99b5030$export$d2f92acf417bbf5d((0, $9Jpjh._)((0, $lvTkn._)({}, fetchParams), {
                    itemsPerPage: (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.itemsPerPage
                }), abortController).then(function(data) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.setOnline();
                    if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value) {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastSync = Date.now();
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate = data.lastUpdate;
                    }
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).refreshStats(data.all, data.unread, data.starred);
                    // update tags
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTags(data.tags);
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                    if (typeof data.sources !== 'undefined' && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.navSourcesExpanded) {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSources(data.sources);
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setSourcesState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                    }
                    return {
                        entries: data.entries,
                        hasMore: data.hasMore
                    };
                }).catch(function(error) {
                    if (error.name === 'AbortError') return;
                    return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).handleAjaxError(error).then(function() {
                        return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.getEntries(fetchParams);
                    });
                });
            }
        }
    ]);
    return DbOnline;
}();



var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");

var $khBmn = parcelRequire("khBmn");

var $lvTkn = parcelRequire("lvTkn");

var $21h22 = parcelRequire("21h22");


// Making the module version consumable via require - to prohibit
// multiple occurrancies of the same module in the same app
// (dual package hazard, https://nodejs.org/api/packages.html#dual-package-hazard)
var $6200b20324ada281$exports = {};

var $2bfPH = parcelRequire("2bfPH");
(function(e, t) {
    $6200b20324ada281$exports = t();
})(undefined, function() {
    var B = function B1(e, t) {
        return (B = Object.setPrototypeOf || (({
            __proto__: []
        }) instanceof Array ? function(e, t) {
            e.__proto__ = t;
        } : function(e, t) {
            for(var n in t)Object.prototype.hasOwnProperty.call(t, n) && (e[n] = t[n]);
        }))(e, t);
    };
    var _ = function _1() {
        return (_ = Object.assign || function(e) {
            for(var t, n = 1, _$r = arguments.length; n < _$r; n++)for(var _$i in t = arguments[n])Object.prototype.hasOwnProperty.call(t, _$i) && (e[_$i] = t[_$i]);
            return e;
        }).apply(this, arguments);
    };
    function R(e, t, n) {
        if (n || 2 === arguments.length) for(var _$r, _$i = 0, o = t.length; _$i < o; _$i++)!_$r && _$i in t || ((_$r = _$r || Array.prototype.slice.call(t, 0, _$i))[_$i] = t[_$i]);
        return e.concat(_$r || Array.prototype.slice.call(t));
    }
    var f = "undefined" != typeof globalThis ? globalThis : "undefined" != typeof self ? self : "undefined" != typeof window ? window : $parcel$global, O = Object.keys, x = Array.isArray;
    function a(t, n) {
        return "object" == (typeof n === "undefined" ? "undefined" : (0, $2bfPH._)(n)) && O(n).forEach(function(e) {
            t[e] = n[e];
        }), t;
    }
    "undefined" == typeof Promise || f.Promise || (f.Promise = Promise);
    var F = Object.getPrototypeOf, N = {}.hasOwnProperty;
    function m(e, t) {
        return N.call(e, t);
    }
    function M(t, n) {
        "function" == typeof n && (n = n(F(t))), ("undefined" == typeof Reflect ? O : Reflect.ownKeys)(n).forEach(function(e) {
            u(t, e, n[e]);
        });
    }
    var L = Object.defineProperty;
    function u(e, t, n, r) {
        L(e, t, a(n && m(n, "get") && "function" == typeof n.get ? {
            get: n.get,
            set: n.set,
            configurable: !0
        } : {
            value: n,
            configurable: !0,
            writable: !0
        }, r));
    }
    function U(t) {
        return {
            from: function from(e) {
                return t.prototype = Object.create(e.prototype), u(t.prototype, "constructor", t), {
                    extend: M.bind(null, t.prototype)
                };
            }
        };
    }
    var z = Object.getOwnPropertyDescriptor;
    var V = [].slice;
    function W(e, t, n) {
        return V.call(e, t, n);
    }
    function Y(e, t) {
        return t(e);
    }
    function $(e) {
        if (!e) throw new Error("Assertion Failed");
    }
    function Q(e) {
        f.setImmediate ? setImmediate(e) : setTimeout(e, 0);
    }
    function c(e, t) {
        if ("string" == typeof t && m(e, t)) return e[t];
        if (!t) return e;
        if ("string" != typeof t) {
            for(var n = [], _$r = 0, _$i = t.length; _$r < _$i; ++_$r){
                var o = c(e, t[_$r]);
                n.push(o);
            }
            return n;
        }
        var _$a, _$u = t.indexOf(".");
        return -1 === _$u || null == (_$a = e[t.substr(0, _$u)]) ? void 0 : c(_$a, t.substr(_$u + 1));
    }
    function b(e, t, n) {
        if (e && void 0 !== t && !("isFrozen" in Object && Object.isFrozen(e))) {
            if ("string" != typeof t && "length" in t) {
                $("string" != typeof n && "length" in n);
                for(var _$r = 0, _$i = t.length; _$r < _$i; ++_$r)b(e, t[_$r], n[_$r]);
            } else {
                var o = t.indexOf(".");
                if (-1 !== o) {
                    var _$a = t.substr(0, o), o = t.substr(o + 1);
                    if ("" === o) void 0 === n ? x(e) && !isNaN(parseInt(_$a)) ? e.splice(_$a, 1) : delete e[_$a] : e[_$a] = n;
                    else {
                        var _$u = e[_$a];
                        if (!_$u || !m(e, _$a)) {
                            if (void 0 === n) return;
                            _$u = e[_$a] = {};
                        }
                        b(_$u, o, n);
                    }
                } else void 0 === n ? x(e) && !isNaN(parseInt(t)) ? e.splice(t, 1) : delete e[t] : e[t] = n;
            }
        }
    }
    function G(e) {
        var t, n = {};
        for(t in e)m(e, t) && (n[t] = e[t]);
        return n;
    }
    var X = [].concat;
    function H(e) {
        return X.apply([], e);
    }
    var e = "BigUint64Array,BigInt64Array,Array,Boolean,String,Date,RegExp,Blob,File,FileList,FileSystemFileHandle,FileSystemDirectoryHandle,ArrayBuffer,DataView,Uint8ClampedArray,ImageBitmap,ImageData,Map,Set,CryptoKey".split(",").concat(H([
        8,
        16,
        32,
        64
    ].map(function(t) {
        return [
            "Int",
            "Uint",
            "Float"
        ].map(function(e) {
            return e + t + "Array";
        });
    }))).filter(function(e) {
        return f[e];
    }), J = new Set(e.map(function(e) {
        return f[e];
    }));
    var Z = null;
    function ee(e) {
        Z = new WeakMap;
        e = function e(t) {
            if (!t || "object" != (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t))) return t;
            var n = Z.get(t);
            if (n) return n;
            if (x(t)) {
                n = [], Z.set(t, n);
                for(var _$r = 0, _$i = t.length; _$r < _$i; ++_$r)n.push(e(t[_$r]));
            } else if (J.has(t.constructor)) n = t;
            else {
                var o, _$a = F(t);
                for(o in n = _$a === Object.prototype ? {} : Object.create(_$a), Z.set(t, n), t)m(t, o) && (n[o] = e(t[o]));
            }
            return n;
        }(e);
        return Z = null, e;
    }
    var te = {}.toString;
    function ne(e) {
        return te.call(e).slice(8, -1);
    }
    var re = "undefined" != typeof Symbol ? Symbol.iterator : "@@iterator", ie = "symbol" == (typeof re === "undefined" ? "undefined" : (0, $2bfPH._)(re)) ? function ie(e) {
        var t;
        return null != e && (t = e[re]) && t.apply(e);
    } : function() {
        return null;
    };
    function oe(e, t) {
        t = e.indexOf(t);
        0 <= t && e.splice(t, 1);
    }
    var ae = {};
    function n(e) {
        var t, n, _$r, _$i;
        if (1 === arguments.length) {
            if (x(e)) return e.slice();
            if (this === ae && "string" == typeof e) return [
                e
            ];
            if (_$i = ie(e)) for(n = []; !(_$r = _$i.next()).done;)n.push(_$r.value);
            else {
                if (null == e) return [
                    e
                ];
                if ("number" != typeof (t = e.length)) return [
                    e
                ];
                for(n = new Array(t); t--;)n[t] = e[t];
            }
        } else for(t = arguments.length, n = new Array(t); t--;)n[t] = arguments[t];
        return n;
    }
    var ue = "undefined" != typeof Symbol ? function ue(e) {
        return "AsyncFunction" === e[Symbol.toStringTag];
    } : function() {
        return !1;
    }, e = [
        "Unknown",
        "Constraint",
        "Data",
        "TransactionInactive",
        "ReadOnly",
        "Version",
        "NotFound",
        "InvalidState",
        "InvalidAccess",
        "Abort",
        "Timeout",
        "QuotaExceeded",
        "Syntax",
        "DataClone"
    ], t = [
        "Modify",
        "Bulk",
        "OpenFailed",
        "VersionChange",
        "Schema",
        "Upgrade",
        "InvalidTable",
        "MissingAPI",
        "NoSuchDatabase",
        "InvalidArgument",
        "SubTransaction",
        "Unsupported",
        "Internal",
        "DatabaseClosed",
        "PrematureCommit",
        "ForeignAwait"
    ].concat(e), se = {
        VersionChanged: "Database version changed by other database connection",
        DatabaseClosed: "Database has been closed",
        Abort: "Transaction aborted",
        TransactionInactive: "Transaction has already completed or failed",
        MissingAPI: "IndexedDB API missing. Please visit https://tinyurl.com/y2uuvskb"
    };
    function ce(e, t) {
        this.name = e, this.message = t;
    }
    function le(e, t) {
        return e + ". Errors: " + Object.keys(t).map(function(e) {
            return t[e].toString();
        }).filter(function(e, t, n) {
            return n.indexOf(e) === t;
        }).join("\n");
    }
    function fe(e, t, n, r) {
        this.failures = t, this.failedKeys = r, this.successCount = n, this.message = le(e, t);
    }
    function he(e, t) {
        this.name = "BulkError", this.failures = Object.keys(t).map(function(e) {
            return t[e];
        }), this.failuresByPos = t, this.message = le(e, this.failures);
    }
    U(ce).from(Error).extend({
        toString: function toString() {
            return this.name + ": " + this.message;
        }
    }), U(fe).from(ce), U(he).from(ce);
    var de = t.reduce(function(e, t) {
        return e[t] = t + "Error", e;
    }, {}), pe = ce, k = t.reduce(function(e, n) {
        var _$r = n + "Error";
        function t(e, t) {
            this.name = _$r, e ? "string" == typeof e ? (this.message = "".concat(e).concat(t ? "\n " + t : ""), this.inner = t || null) : "object" == (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)) && (this.message = "".concat(e.name, " ").concat(e.message), this.inner = e) : (this.message = se[n] || _$r, this.inner = null);
        }
        return U(t).from(pe), e[n] = t, e;
    }, {}), ye = (k.Syntax = SyntaxError, k.Type = TypeError, k.Range = RangeError, e.reduce(function(e, t) {
        return e[t + "Error"] = k[t], e;
    }, {}));
    e = t.reduce(function(e, t) {
        return -1 === [
            "Syntax",
            "Type",
            "Range"
        ].indexOf(t) && (e[t + "Error"] = k[t]), e;
    }, {});
    function g() {}
    function ve(e) {
        return e;
    }
    function me(t, n) {
        return null == t || t === ve ? n : function(e) {
            return n(t(e));
        };
    }
    function be(e, t) {
        return function() {
            e.apply(this, arguments), t.apply(this, arguments);
        };
    }
    function ge(i, o) {
        return i === g ? o : function() {
            var e = i.apply(this, arguments), t = (void 0 !== e && (arguments[0] = e), this.onsuccess), n = this.onerror, _$r = (this.onsuccess = null, this.onerror = null, o.apply(this, arguments));
            return t && (this.onsuccess = this.onsuccess ? be(t, this.onsuccess) : t), n && (this.onerror = this.onerror ? be(n, this.onerror) : n), void 0 !== _$r ? _$r : e;
        };
    }
    function we(n, r) {
        return n === g ? r : function() {
            n.apply(this, arguments);
            var e = this.onsuccess, t = this.onerror;
            this.onsuccess = this.onerror = null, r.apply(this, arguments), e && (this.onsuccess = this.onsuccess ? be(e, this.onsuccess) : e), t && (this.onerror = this.onerror ? be(t, this.onerror) : t);
        };
    }
    function _e(i, o) {
        return i === g ? o : function(e) {
            var t = i.apply(this, arguments), e = (a(e, t), this.onsuccess), n = this.onerror, _$r = (this.onsuccess = null, this.onerror = null, o.apply(this, arguments));
            return e && (this.onsuccess = this.onsuccess ? be(e, this.onsuccess) : e), n && (this.onerror = this.onerror ? be(n, this.onerror) : n), void 0 === t ? void 0 === _$r ? void 0 : _$r : a(t, _$r);
        };
    }
    function xe(e, t) {
        return e === g ? t : function() {
            return !1 !== t.apply(this, arguments) && e.apply(this, arguments);
        };
    }
    function ke(i, o) {
        return i === g ? o : function() {
            var e = i.apply(this, arguments);
            if (e && "function" == typeof e.then) {
                for(var t = this, n = arguments.length, _$r = new Array(n); n--;)_$r[n] = arguments[n];
                return e.then(function() {
                    return o.apply(t, _$r);
                });
            }
            return o.apply(this, arguments);
        };
    }
    e.ModifyError = fe, e.DexieError = ce, e.BulkError = he;
    var l = "undefined" != typeof location && /^(http|https):\/\/(localhost|127\.0\.0\.1)/.test(location.href);
    function Oe(e) {
        l = e;
    }
    var Pe = {}, Ke = 100, Ee = "undefined" == typeof Promise ? [] : (t = Promise.resolve(), "undefined" != typeof crypto && crypto.subtle ? [
        Ee = crypto.subtle.digest("SHA-512", new Uint8Array([
            0
        ])),
        F(Ee),
        t
    ] : [
        t,
        F(t),
        t
    ]), t = Ee[0], Se = Ee[1], Se = Se && Se.then, Ae = t && t.constructor, je = !!Ee[2];
    var Ce = function Ce(e, t) {
        Re.push([
            e,
            t
        ]), Ie && (queueMicrotask(Ye), Ie = !1);
    }, Te = !0, Ie = !0, qe = [], De = [], Be = ve, s = {
        id: "global",
        global: !0,
        ref: 0,
        unhandleds: [],
        onunhandled: g,
        pgp: !1,
        env: {},
        finalize: g
    }, P = s, Re = [], Fe = 0, Ne = [];
    function K(e) {
        if ("object" != (0, $2bfPH._)(this)) throw new TypeError("Promises must be constructed via new");
        this._listeners = [], this._lib = !1;
        var t = this._PSD = P;
        if ("function" != typeof e) {
            if (e !== Pe) throw new TypeError("Not a function");
            this._state = arguments[1], this._value = arguments[2], !1 === this._state && Ue(this, this._value);
        } else this._state = null, this._value = null, ++t.ref, function t(r, e) {
            try {
                e(function(n) {
                    if (null === r._state) {
                        if (n === r) throw new TypeError("A promise cannot be resolved with itself.");
                        var _$e = r._lib && $e();
                        n && "function" == typeof n.then ? t(r, function(e, t) {
                            n instanceof K ? n._then(e, t) : n.then(e, t);
                        }) : (r._state = !0, r._value = n, ze(r)), _$e && Qe();
                    }
                }, Ue.bind(null, r));
            } catch (e) {
                Ue(r, e);
            }
        }(this, e);
    }
    var Me = {
        get: function get() {
            var _$u = P, t = et;
            function e(n, r) {
                var _$i = this, o = !_$u.global && (_$u !== P || t !== et), _$a = o && !w(), _$e = new K(function(e, t) {
                    Ve(_$i, new Le(ut(n, _$u, o, _$a), ut(r, _$u, o, _$a), e, t, _$u));
                });
                return this._consoleTask && (_$e._consoleTask = this._consoleTask), _$e;
            }
            return e.prototype = Pe, e;
        },
        set: function set(e) {
            u(this, "then", e && e.prototype === Pe ? Me : {
                get: function get() {
                    return e;
                },
                set: Me.set
            });
        }
    };
    function Le(e, t, n, r, i) {
        this.onFulfilled = "function" == typeof e ? e : null, this.onRejected = "function" == typeof t ? t : null, this.resolve = n, this.reject = r, this.psd = i;
    }
    function Ue(e, t) {
        var n, _$r;
        De.push(t), null === e._state && (n = e._lib && $e(), t = Be(t), e._state = !1, e._value = t, _$r = e, qe.some(function(e) {
            return e._value === _$r._value;
        }) || qe.push(_$r), ze(e), n) && Qe();
    }
    function ze(e) {
        var t = e._listeners;
        e._listeners = [];
        for(var n = 0, _$r = t.length; n < _$r; ++n)Ve(e, t[n]);
        var _$i = e._PSD;
        --_$i.ref || _$i.finalize(), 0 === Fe && (++Fe, Ce(function() {
            0 == --Fe && Ge();
        }, []));
    }
    function Ve(e, t) {
        if (null === e._state) e._listeners.push(t);
        else {
            var n = e._state ? t.onFulfilled : t.onRejected;
            if (null === n) return (e._state ? t.resolve : t.reject)(e._value);
            ++t.psd.ref, ++Fe, Ce(We, [
                n,
                e,
                t
            ]);
        }
    }
    function We(e, t, n) {
        try {
            var _$r, _$i = t._value;
            !t._state && De.length && (De = []), _$r = l && t._consoleTask ? t._consoleTask.run(function() {
                return e(_$i);
            }) : e(_$i), t._state || -1 !== De.indexOf(_$i) || function(e) {
                for(var _$t = qe.length; _$t;)if (qe[--_$t]._value === e._value) return qe.splice(_$t, 1);
            }(t), n.resolve(_$r);
        } catch (e) {
            n.reject(e);
        } finally{
            0 == --Fe && Ge(), --n.psd.ref || n.psd.finalize();
        }
    }
    function Ye() {
        at(s, function() {
            $e() && Qe();
        });
    }
    function $e() {
        var e = Te;
        return Ie = Te = !1, e;
    }
    function Qe() {
        var e, t, n;
        do {
            for(; 0 < Re.length;)for(e = Re, Re = [], n = e.length, t = 0; t < n; ++t){
                var _$r = e[t];
                _$r[0].apply(null, _$r[1]);
            }
        }while (0 < Re.length);
        Ie = Te = !0;
    }
    function Ge() {
        for(var e = qe, t = (qe = [], e.forEach(function(e) {
            e._PSD.onunhandled.call(null, e._value, e);
        }), Ne.slice(0)), n = t.length; n;)t[--n]();
    }
    function Xe(e) {
        return new K(Pe, !1, e);
    }
    function E(n, r) {
        var _$i = P;
        return function() {
            var _$e = $e(), t = P;
            try {
                return h(_$i, !0), n.apply(this, arguments);
            } catch (e) {
                r && r(e);
            } finally{
                h(t, !1), _$e && Qe();
            }
        };
    }
    M(K.prototype, {
        then: Me,
        _then: function _then(e, t) {
            Ve(this, new Le(null, null, e, t, P));
        },
        catch: function _catch(e) {
            var t, n;
            return 1 === arguments.length ? this.then(null, e) : (t = e, n = arguments[1], "function" == typeof t ? this.then(null, function(e) {
                return (e instanceof t ? n : Xe)(e);
            }) : this.then(null, function(e) {
                return (e && e.name === t ? n : Xe)(e);
            }));
        },
        finally: function _finally(t) {
            return this.then(function(e) {
                return K.resolve(t()).then(function() {
                    return e;
                });
            }, function(e) {
                return K.resolve(t()).then(function() {
                    return Xe(e);
                });
            });
        },
        timeout: function timeout(r, i) {
            var o = this;
            return r < 1 / 0 ? new K(function(e, t) {
                var n = setTimeout(function() {
                    return t(new k.Timeout(i));
                }, r);
                o.then(e, t).finally(clearTimeout.bind(null, n));
            }) : this;
        }
    }), "undefined" != typeof Symbol && Symbol.toStringTag && u(K.prototype, Symbol.toStringTag, "Dexie.Promise"), s.env = ot(), M(K, {
        all: function all() {
            var o = n.apply(null, arguments).map(rt);
            return new K(function(n, r) {
                0 === o.length && n([]);
                var _$i = o.length;
                o.forEach(function(e, t) {
                    return K.resolve(e).then(function(e) {
                        o[t] = e, --_$i || n(o);
                    }, r);
                });
            });
        },
        resolve: function resolve(n) {
            return n instanceof K ? n : n && "function" == typeof n.then ? new K(function(e, t) {
                n.then(e, t);
            }) : new K(Pe, !0, n);
        },
        reject: Xe,
        race: function race() {
            var e = n.apply(null, arguments).map(rt);
            return new K(function(t, n) {
                e.map(function(e) {
                    return K.resolve(e).then(t, n);
                });
            });
        },
        PSD: {
            get: function get() {
                return P;
            },
            set: function set(e) {
                return P = e;
            }
        },
        totalEchoes: {
            get: function get() {
                return et;
            }
        },
        newPSD: v,
        usePSD: at,
        scheduler: {
            get: function get() {
                return Ce;
            },
            set: function set(e) {
                Ce = e;
            }
        },
        rejectionMapper: {
            get: function get() {
                return Be;
            },
            set: function set(e) {
                Be = e;
            }
        },
        follow: function follow(i, n) {
            return new K(function(e, t) {
                return v(function(n, r) {
                    var _$e = P;
                    _$e.unhandleds = [], _$e.onunhandled = r, _$e.finalize = be(function() {
                        var _$t, _$e = this;
                        _$t = function t() {
                            0 === _$e.unhandleds.length ? n() : r(_$e.unhandleds[0]);
                        }, Ne.push(function e() {
                            _$t(), Ne.splice(Ne.indexOf(e), 1);
                        }), ++Fe, Ce(function() {
                            0 == --Fe && Ge();
                        }, []);
                    }, _$e.finalize), i();
                }, n, e, t);
            });
        }
    }), Ae && (Ae.allSettled && u(K, "allSettled", function() {
        var e = n.apply(null, arguments).map(rt);
        return new K(function(n) {
            0 === e.length && n([]);
            var _$r = e.length, _$i = new Array(_$r);
            e.forEach(function(e, t) {
                return K.resolve(e).then(function(e) {
                    return _$i[t] = {
                        status: "fulfilled",
                        value: e
                    };
                }, function(e) {
                    return _$i[t] = {
                        status: "rejected",
                        reason: e
                    };
                }).then(function() {
                    return --_$r || n(_$i);
                });
            });
        });
    }), Ae.any && "undefined" != typeof AggregateError && u(K, "any", function() {
        var e = n.apply(null, arguments).map(rt);
        return new K(function(n, r) {
            0 === e.length && r(new AggregateError([]));
            var _$i = e.length, o = new Array(_$i);
            e.forEach(function(e, t) {
                return K.resolve(e).then(function(e) {
                    return n(e);
                }, function(e) {
                    o[t] = e, --_$i || r(new AggregateError(o));
                });
            });
        });
    }), Ae.withResolvers) && (K.withResolvers = Ae.withResolvers);
    var o = {
        awaits: 0,
        echoes: 0,
        id: 0
    }, He = 0, Je = [], Ze = 0, et = 0, tt = 0;
    function v(e, t, n, r) {
        var _$i = P, o = Object.create(_$i), t = (o.parent = _$i, o.ref = 0, o.global = !1, o.id = ++tt, s.env, o.env = je ? {
            Promise: K,
            PromiseProp: {
                value: K,
                configurable: !0,
                writable: !0
            },
            all: K.all,
            race: K.race,
            allSettled: K.allSettled,
            any: K.any,
            resolve: K.resolve,
            reject: K.reject
        } : {}, t && a(o, t), ++_$i.ref, o.finalize = function t() {
            --this.parent.ref || this.parent.finalize();
        }, at(o, e, n, r));
        return 0 === o.ref && o.finalize(), t;
    }
    function nt() {
        return o.id || (o.id = ++He), ++o.awaits, o.echoes += Ke, o.id;
    }
    function w() {
        return !!o.awaits && (0 == --o.awaits && (o.id = 0), o.echoes = o.awaits * Ke, !0);
    }
    function rt(e) {
        return o.echoes && e && e.constructor === Ae ? (nt(), e.then(function(e) {
            return w(), e;
        }, function(e) {
            return w(), S(e);
        })) : e;
    }
    function it() {
        var e = Je[Je.length - 1];
        Je.pop(), h(e, !1);
    }
    function h(e, t) {
        var n, _$r, _$i = P;
        (t ? !o.echoes || Ze++ && e === P : !Ze || --Ze && e === P) || queueMicrotask(t ? (function(e) {
            ++et, o.echoes && 0 != --o.echoes || (o.echoes = o.awaits = o.id = 0), Je.push(P), h(e, !0);
        }).bind(null, e) : it), e !== P && (P = e, _$i === s && (s.env = ot()), je) && (n = s.env.Promise, _$r = e.env, _$i.global || e.global) && (Object.defineProperty(f, "Promise", _$r.PromiseProp), n.all = _$r.all, n.race = _$r.race, n.resolve = _$r.resolve, n.reject = _$r.reject, _$r.allSettled && (n.allSettled = _$r.allSettled), _$r.any) && (n.any = _$r.any);
    }
    function ot() {
        var e = f.Promise;
        return je ? {
            Promise: e,
            PromiseProp: Object.getOwnPropertyDescriptor(f, "Promise"),
            all: e.all,
            race: e.race,
            allSettled: e.allSettled,
            any: e.any,
            resolve: e.resolve,
            reject: e.reject
        } : {};
    }
    function at(e, t, n, r, i) {
        var o = P;
        try {
            return h(e, !0), t(n, r, i);
        } finally{
            h(o, !1);
        }
    }
    function ut(t, n, r, i) {
        return "function" != typeof t ? t : function() {
            var e = P;
            r && nt(), h(n, !0);
            try {
                return t.apply(this, arguments);
            } finally{
                h(e, !1), i && queueMicrotask(w);
            }
        };
    }
    function st(e) {
        Promise === Ae && 0 === o.echoes ? 0 === Ze ? e() : enqueueNativeMicroTask(e) : setTimeout(e, 0);
    }
    -1 === ("" + Se).indexOf("[native code]") && (nt = w = g);
    var S = K.reject;
    var ct = String.fromCharCode(65535), A = "Invalid key provided. Keys must be of type string, number, Date or Array<string | number | Date>.", lt = "String expected.", ft = "__dbnames", ht = "readonly", dt = "readwrite";
    function pt(e, t) {
        return e ? t ? function() {
            return e.apply(this, arguments) && t.apply(this, arguments);
        } : e : t;
    }
    var yt = {
        type: 3,
        lower: -1 / 0,
        lowerOpen: !1,
        upper: [
            []
        ],
        upperOpen: !1
    };
    function vt(t) {
        return "string" != typeof t || /\./.test(t) ? function(e) {
            return e;
        } : function(e) {
            return void 0 === e[t] && t in e && delete (e = ee(e))[t], e;
        };
    }
    function mt() {
        throw k.Type("Entity instances must never be new:ed. Instances are generated by the framework bypassing the constructor.");
    }
    function j(e, t) {
        try {
            var n = bt(e), _$r = bt(t);
            if (n !== _$r) return "Array" === n ? 1 : "Array" === _$r ? -1 : "binary" === n ? 1 : "binary" === _$r ? -1 : "string" === n ? 1 : "string" === _$r ? -1 : "Date" === n ? 1 : "Date" !== _$r ? NaN : -1;
            switch(n){
                case "number":
                case "Date":
                case "string":
                    return t < e ? 1 : e < t ? -1 : 0;
                case "binary":
                    for(var _$i = gt(e), o = gt(t), _$a = _$i.length, _$u = o.length, s = _$a < _$u ? _$a : _$u, _$c = 0; _$c < s; ++_$c)if (_$i[_$c] !== o[_$c]) return _$i[_$c] < o[_$c] ? -1 : 1;
                    return _$a === _$u ? 0 : _$a < _$u ? -1 : 1;
                case "Array":
                    for(var l = e, f = t, h = l.length, _$d = f.length, _$p = h < _$d ? h : _$d, y = 0; y < _$p; ++y){
                        var _$v = j(l[y], f[y]);
                        if (0 !== _$v) return _$v;
                    }
                    return h === _$d ? 0 : h < _$d ? -1 : 1;
            }
        } catch (e) {}
        return NaN;
    }
    function bt(e) {
        var t = typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e);
        return "object" == t && (ArrayBuffer.isView(e) || "ArrayBuffer" === (t = ne(e))) ? "binary" : t;
    }
    function gt(e) {
        return e instanceof Uint8Array ? e : ArrayBuffer.isView(e) ? new Uint8Array(e.buffer, e.byteOffset, e.byteLength) : new Uint8Array(e);
    }
    function wt(t, n, r) {
        var e = t.schema.yProps;
        return e ? (n && 0 < r.numFailures && (n = n.filter(function(e, t) {
            return !r.failures[t];
        })), Promise.all(e.map(function(e) {
            e = e.updatesTable;
            return n ? t.db.table(e).where("k").anyOf(n).delete() : t.db.table(e).clear();
        })).then(function() {
            return r;
        })) : r;
    }
    xt.prototype.execute = function(e) {
        var t = this["@@propmod"];
        if (void 0 !== t.add) {
            var n = t.add;
            if (x(n)) return R(R([], x(e) ? e : [], !0), n, !0).sort();
            if ("number" == typeof n) return (Number(e) || 0) + n;
            if ("bigint" == (typeof n === "undefined" ? "undefined" : (0, $2bfPH._)(n))) try {
                return BigInt(e) + n;
            } catch (e) {
                return BigInt(0) + n;
            }
            throw new TypeError("Invalid term ".concat(n));
        }
        if (void 0 !== t.remove) {
            var _$r = t.remove;
            if (x(_$r)) return x(e) ? e.filter(function(e) {
                return !_$r.includes(e);
            }).sort() : [];
            if ("number" == typeof _$r) return Number(e) - _$r;
            if ("bigint" == (typeof _$r === "undefined" ? "undefined" : (0, $2bfPH._)(_$r))) try {
                return BigInt(e) - _$r;
            } catch (e) {
                return BigInt(0) - _$r;
            }
            throw new TypeError("Invalid subtrahend ".concat(_$r));
        }
        n = null == (n = t.replacePrefix) ? void 0 : n[0];
        return n && "string" == typeof e && e.startsWith(n) ? t.replacePrefix[1] + e.substring(n.length) : e;
    };
    var _t = xt;
    function xt(e) {
        this["@@propmod"] = e;
    }
    function kt(e, t) {
        for(var n = O(t), _$r = n.length, _$i = !1, o = 0; o < _$r; ++o){
            var _$a = n[o], _$u = t[_$a], s = c(e, _$a);
            _$u instanceof _t ? (b(e, _$a, _$u.execute(s)), _$i = !0) : s !== _$u && (b(e, _$a, _$u), _$i = !0);
        }
        return _$i;
    }
    r.prototype._trans = function(e, r, t) {
        var n = this._tx || P.trans, _$i = this.name, o = l && "undefined" != typeof console && console.createTask && console.createTask("Dexie: ".concat("readonly" === e ? "read" : "write", " ").concat(this.name));
        function a(e, t, n) {
            if (n.schema[_$i]) return r(n.idbtrans, n);
            throw new k.NotFound("Table " + _$i + " not part of transaction");
        }
        var _$u = $e();
        try {
            var s = n && n.db._novip === this.db._novip ? n === P.trans ? n._promise(e, a, t) : v(function() {
                return n._promise(e, a, t);
            }, {
                trans: n,
                transless: P.transless || P
            }) : function t(n, r, i, o) {
                if (n.idbdb && (n._state.openComplete || P.letThrough || n._vip)) {
                    var _$a = n._createTransaction(r, i, n._dbSchema);
                    try {
                        _$a.create(), n._state.PR1398_maxLoop = 3;
                    } catch (e) {
                        return e.name === de.InvalidState && n.isOpen() && 0 < --n._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), n.close({
                            disableAutoOpen: !1
                        }), n.open().then(function() {
                            return t(n, r, i, o);
                        })) : S(e);
                    }
                    return _$a._promise(r, function(e, t) {
                        return v(function() {
                            return P.trans = _$a, o(e, t, _$a);
                        });
                    }).then(function(e) {
                        if ("readwrite" === r) try {
                            _$a.idbtrans.commit();
                        } catch (e) {}
                        return "readonly" === r ? e : _$a._completion.then(function() {
                            return e;
                        });
                    });
                }
                if (n._state.openComplete) return S(new k.DatabaseClosed(n._state.dbOpenError));
                if (!n._state.isBeingOpened) {
                    if (!n._state.autoOpen) return S(new k.DatabaseClosed);
                    n.open().catch(g);
                }
                return n._state.dbReadyPromise.then(function() {
                    return t(n, r, i, o);
                });
            }(this.db, e, [
                this.name
            ], a);
            return o && (s._consoleTask = o, s = s.catch(function(e) {
                return console.trace(e), S(e);
            })), s;
        } finally{
            _$u && Qe();
        }
    }, r.prototype.get = function(t, e) {
        var n = this;
        return t && t.constructor === Object ? this.where(t).first(e) : null == t ? S(new k.Type("Invalid argument to Table.get()")) : this._trans("readonly", function(e) {
            return n.core.get({
                trans: e,
                key: t
            }).then(function(e) {
                return n.hook.reading.fire(e);
            });
        }).then(e);
    }, r.prototype.where = function(o) {
        if ("string" == typeof o) return new this.db.WhereClause(this, o);
        if (x(o)) return new this.db.WhereClause(this, "[".concat(o.join("+"), "]"));
        var n = O(o);
        if (1 === n.length) return this.where(n[0]).equals(o[n[0]]);
        var e = this.schema.indexes.concat(this.schema.primKey).filter(function(t) {
            if (t.compound && n.every(function(e) {
                return 0 <= t.keyPath.indexOf(e);
            })) {
                for(var e = 0; e < n.length; ++e)if (-1 === n.indexOf(t.keyPath[e])) return !1;
                return !0;
            }
            return !1;
        }).sort(function(e, t) {
            return e.keyPath.length - t.keyPath.length;
        })[0];
        if (e && this.db._maxKey !== ct) return t = e.keyPath.slice(0, n.length), this.where(t).equals(t.map(function(e) {
            return o[e];
        }));
        !e && l && console.warn("The query ".concat(JSON.stringify(o), " on ").concat(this.name, " would benefit from a ") + "compound index [".concat(n.join("+"), "]"));
        var _$a = this.schema.idxByName;
        function u(e, t) {
            return 0 === j(e, t);
        }
        var t = n.reduce(function(e, t) {
            var n = e[0], e = e[1], _$r = _$a[t], _$i = o[t];
            return [
                n || _$r,
                n || !_$r ? pt(e, _$r && _$r.multi ? function(e) {
                    e = c(e, t);
                    return x(e) && e.some(function(e) {
                        return u(_$i, e);
                    });
                } : function(e) {
                    return u(_$i, c(e, t));
                }) : e
            ];
        }, [
            null,
            null
        ]), _$r = t[0], t = t[1];
        return _$r ? this.where(_$r.name).equals(o[_$r.keyPath]).filter(t) : e ? this.filter(t) : this.where(n).equals("");
    }, r.prototype.filter = function(e) {
        return this.toCollection().and(e);
    }, r.prototype.count = function(e) {
        return this.toCollection().count(e);
    }, r.prototype.offset = function(e) {
        return this.toCollection().offset(e);
    }, r.prototype.limit = function(e) {
        return this.toCollection().limit(e);
    }, r.prototype.each = function(e) {
        return this.toCollection().each(e);
    }, r.prototype.toArray = function(e) {
        return this.toCollection().toArray(e);
    }, r.prototype.toCollection = function() {
        return new this.db.Collection(new this.db.WhereClause(this));
    }, r.prototype.orderBy = function(e) {
        return new this.db.Collection(new this.db.WhereClause(this, x(e) ? "[".concat(e.join("+"), "]") : e));
    }, r.prototype.reverse = function() {
        return this.toCollection().reverse();
    }, r.prototype.mapToClass = function(r) {
        for(var o = this.db, _$a = this.name, _$i = ((this.schema.mappedClass = r).prototype instanceof mt && (r = function(e) {
            var _$r = function _$r() {
                this.constructor = _$t;
            };
            var _$i = function _$i() {
                return null !== e && e.apply(this, arguments) || this;
            };
            var _$t = _$i, n = e;
            if ("function" != typeof n && null !== n) throw new TypeError("Class extends value " + String(n) + " is not a constructor or null");
            return B(_$t, n), _$t.prototype = null === n ? Object.create(n) : (_$r.prototype = n.prototype, new _$r), Object.defineProperty(_$i.prototype, "db", {
                get: function get() {
                    return o;
                },
                enumerable: !1,
                configurable: !0
            }), _$i.prototype.table = function() {
                return _$a;
            }, _$i;
        }(r)), new Set), e = r.prototype; e; e = F(e))Object.getOwnPropertyNames(e).forEach(function(e) {
            return _$i.add(e);
        });
        function t(e) {
            if (!e) return e;
            var _$t, n = Object.create(r.prototype);
            for(_$t in e)if (!_$i.has(_$t)) try {
                n[_$t] = e[_$t];
            } catch (e) {}
            return n;
        }
        return this.schema.readHook && this.hook.reading.unsubscribe(this.schema.readHook), this.schema.readHook = t, this.hook("reading", t), r;
    }, r.prototype.defineClass = function() {
        return this.mapToClass(function(e) {
            a(this, e);
        });
    }, r.prototype.add = function(t, n) {
        var _$r = this, e = this.schema.primKey, _$i = e.auto, o = e.keyPath, _$a = t;
        return o && _$i && (_$a = vt(o)(t)), this._trans("readwrite", function(e) {
            return _$r.core.mutate({
                trans: e,
                type: "add",
                keys: null != n ? [
                    n
                ] : null,
                values: [
                    _$a
                ]
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : e.lastResult;
        }).then(function(e) {
            if (o) try {
                b(t, o, e);
            } catch (e) {}
            return e;
        });
    }, r.prototype.upsert = function(r, i) {
        var o = this, _$a = this.schema.primKey.keyPath;
        return this._trans("readwrite", function(n) {
            return o.core.get({
                trans: n,
                key: r
            }).then(function(t) {
                var e = null != t ? t : {};
                return kt(e, i), _$a && b(e, _$a, r), o.core.mutate({
                    trans: n,
                    type: "put",
                    values: [
                        e
                    ],
                    keys: [
                        r
                    ],
                    upsert: !0,
                    updates: {
                        keys: [
                            r
                        ],
                        changeSpecs: [
                            i
                        ]
                    }
                }).then(function(e) {
                    return e.numFailures ? K.reject(e.failures[0]) : !!t;
                });
            });
        });
    }, r.prototype.update = function(e, t) {
        return "object" != (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)) || x(e) ? this.where(":id").equals(e).modify(t) : void 0 === (e = c(e, this.schema.primKey.keyPath)) ? S(new k.InvalidArgument("Given object does not contain its primary key")) : this.where(":id").equals(e).modify(t);
    }, r.prototype.put = function(t, n) {
        var _$r = this, e = this.schema.primKey, _$i = e.auto, o = e.keyPath, _$a = t;
        return o && _$i && (_$a = vt(o)(t)), this._trans("readwrite", function(e) {
            return _$r.core.mutate({
                trans: e,
                type: "put",
                values: [
                    _$a
                ],
                keys: null != n ? [
                    n
                ] : null
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : e.lastResult;
        }).then(function(e) {
            if (o) try {
                b(t, o, e);
            } catch (e) {}
            return e;
        });
    }, r.prototype.delete = function(t) {
        var n = this;
        return this._trans("readwrite", function(e) {
            return n.core.mutate({
                trans: e,
                type: "delete",
                keys: [
                    t
                ]
            }).then(function(e) {
                return wt(n, [
                    t
                ], e);
            }).then(function(e) {
                return e.numFailures ? K.reject(e.failures[0]) : void 0;
            });
        });
    }, r.prototype.clear = function() {
        var t = this;
        return this._trans("readwrite", function(e) {
            return t.core.mutate({
                trans: e,
                type: "deleteRange",
                range: yt
            }).then(function(e) {
                return wt(t, null, e);
            });
        }).then(function(e) {
            return e.numFailures ? K.reject(e.failures[0]) : void 0;
        });
    }, r.prototype.bulkGet = function(t) {
        var n = this;
        return this._trans("readonly", function(e) {
            return n.core.getMany({
                keys: t,
                trans: e
            }).then(function(e) {
                return e.map(function(e) {
                    return n.hook.reading.fire(e);
                });
            });
        });
    }, r.prototype.bulkAdd = function(i, e, t) {
        var o = this, _$a = Array.isArray(e) ? e : void 0, _$u = (t = t || (_$a ? void 0 : e)) ? t.allKeys : void 0;
        return this._trans("readwrite", function(e) {
            var _$t = o.schema.primKey, n = _$t.auto, _$t = _$t.keyPath;
            if (_$t && _$a) throw new k.InvalidArgument("bulkAdd(): keys argument invalid on tables with inbound keys");
            if (_$a && _$a.length !== i.length) throw new k.InvalidArgument("Arguments objects and keys must have the same length");
            var _$r = i.length, n = _$t && n ? i.map(vt(_$t)) : i;
            return o.core.mutate({
                trans: e,
                type: "add",
                keys: _$a,
                values: n,
                wantResults: _$u
            }).then(function(e) {
                var _$t = e.numFailures, n = e.failures;
                if (0 === _$t) return _$u ? e.results : e.lastResult;
                throw new he("".concat(o.name, ".bulkAdd(): ").concat(_$t, " of ").concat(_$r, " operations failed"), n);
            });
        });
    }, r.prototype.bulkPut = function(i, e, t) {
        var o = this, _$a = Array.isArray(e) ? e : void 0, _$u = (t = t || (_$a ? void 0 : e)) ? t.allKeys : void 0;
        return this._trans("readwrite", function(e) {
            var _$t = o.schema.primKey, n = _$t.auto, _$t = _$t.keyPath;
            if (_$t && _$a) throw new k.InvalidArgument("bulkPut(): keys argument invalid on tables with inbound keys");
            if (_$a && _$a.length !== i.length) throw new k.InvalidArgument("Arguments objects and keys must have the same length");
            var _$r = i.length, n = _$t && n ? i.map(vt(_$t)) : i;
            return o.core.mutate({
                trans: e,
                type: "put",
                keys: _$a,
                values: n,
                wantResults: _$u
            }).then(function(e) {
                var _$t = e.numFailures, n = e.failures;
                if (0 === _$t) return _$u ? e.results : e.lastResult;
                throw new he("".concat(o.name, ".bulkPut(): ").concat(_$t, " of ").concat(_$r, " operations failed"), n);
            });
        });
    }, r.prototype.bulkUpdate = function(t) {
        var h = this, n = this.core, _$r = t.map(function(e) {
            return e.key;
        }), _$i = t.map(function(e) {
            return e.changes;
        }), _$d = [];
        return this._trans("readwrite", function(e) {
            return n.getMany({
                trans: e,
                keys: _$r,
                cache: "clone"
            }).then(function(c) {
                var l = [], f = [], s = (t.forEach(function(e, t) {
                    var n = e.key, _$r = e.changes, _$i = c[t];
                    if (_$i) {
                        for(var o = 0, _$a = Object.keys(_$r); o < _$a.length; o++){
                            var _$u = _$a[o], s = _$r[_$u];
                            if (_$u === h.schema.primKey.keyPath) {
                                if (0 !== j(s, n)) throw new k.Constraint("Cannot update primary key in bulkUpdate()");
                            } else b(_$i, _$u, s);
                        }
                        _$d.push(t), l.push(n), f.push(_$i);
                    }
                }), l.length);
                return n.mutate({
                    trans: e,
                    type: "put",
                    keys: l,
                    values: f,
                    updates: {
                        keys: _$r,
                        changeSpecs: _$i
                    }
                }).then(function(e) {
                    var _$t = e.numFailures, n = e.failures;
                    if (0 === _$t) return s;
                    for(var _$r = 0, _$i = Object.keys(n); _$r < _$i.length; _$r++){
                        var o, _$a = _$i[_$r], _$u = _$d[Number(_$a)];
                        null != _$u && (o = n[_$a], delete n[_$a], n[_$u] = o);
                    }
                    throw new he("".concat(h.name, ".bulkUpdate(): ").concat(_$t, " of ").concat(s, " operations failed"), n);
                });
            });
        });
    }, r.prototype.bulkDelete = function(t) {
        var _$r = this, _$i = t.length;
        return this._trans("readwrite", function(e) {
            return _$r.core.mutate({
                trans: e,
                type: "delete",
                keys: t
            }).then(function(e) {
                return wt(_$r, t, e);
            });
        }).then(function(e) {
            var _$t = e.numFailures, n = e.failures;
            if (0 === _$t) return e.lastResult;
            throw new he("".concat(_$r.name, ".bulkDelete(): ").concat(_$t, " of ").concat(_$i, " operations failed"), n);
        });
    };
    var Ot = r;
    function r() {}
    function Pt(i) {
        function t(e, t) {
            if (t) {
                for(var n = arguments.length, _$r = new Array(n - 1); --n;)_$r[n - 1] = arguments[n];
                return _$a[e].subscribe.apply(null, _$r), i;
            }
            if ("string" == typeof e) return _$a[e];
        }
        var _$a = {};
        t.addEventType = u;
        for(var e = 1, n = arguments.length; e < n; ++e)u(arguments[e]);
        return t;
        function u(e, n, r) {
            var _$i, o;
            if ("object" != (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e))) return n = n || xe, o = {
                subscribers: [],
                fire: r = r || g,
                subscribe: function subscribe(e) {
                    -1 === o.subscribers.indexOf(e) && (o.subscribers.push(e), o.fire = n(o.fire, e));
                },
                unsubscribe: function unsubscribe(t) {
                    o.subscribers = o.subscribers.filter(function(e) {
                        return e !== t;
                    }), o.fire = o.subscribers.reduce(n, r);
                }
            }, _$a[e] = t[e] = o;
            O(_$i = e).forEach(function(e) {
                var _$t = _$i[e];
                if (x(_$t)) u(e, _$i[e][0], _$i[e][1]);
                else {
                    if ("asap" !== _$t) throw new k.InvalidArgument("Invalid event config");
                    var _$n = u(e, ve, function() {
                        for(var _$e = arguments.length, _$t = new Array(_$e); _$e--;)_$t[_$e] = arguments[_$e];
                        _$n.subscribers.forEach(function(e) {
                            Q(function() {
                                e.apply(null, _$t);
                            });
                        });
                    });
                }
            });
        }
    }
    function Kt(e, t) {
        return U(t).from({
            prototype: e
        }), t;
    }
    function Et(e, t) {
        return !(e.filter || e.algorithm || e.or) && (t ? e.justLimit : !e.replayFilter);
    }
    function St(e, t) {
        e.filter = pt(e.filter, t);
    }
    function At(e, t, n) {
        var _$r = e.replayFilter;
        e.replayFilter = _$r ? function() {
            return pt(_$r(), t());
        } : t, e.justLimit = n && !_$r;
    }
    function jt(e, t) {
        if (e.isPrimKey) return t.primaryKey;
        var n = t.getIndexByKeyPath(e.index);
        if (n) return n;
        throw new k.Schema("KeyPath " + e.index + " on object store " + t.name + " is not indexed");
    }
    function Ct(e, t, n) {
        var _$r = jt(e, t.schema);
        return t.openCursor({
            trans: n,
            values: !e.keysOnly,
            reverse: "prev" === e.dir,
            unique: !!e.unique,
            query: {
                index: _$r,
                range: e.range
            }
        });
    }
    function Tt(e, o, t, n) {
        var _$a, _$r, _$u = e.replayFilter ? pt(e.filter, e.replayFilter()) : e.filter;
        return e.or ? (_$a = {}, _$r = function r(e, t, n) {
            var _$r, _$i;
            _$u && !_$u(t, n, function(e) {
                return t.stop(e);
            }, function(e) {
                return t.fail(e);
            }) || ("[object ArrayBuffer]" === (_$i = "" + (_$r = t.primaryKey)) && (_$i = "" + new Uint8Array(_$r)), m(_$a, _$i)) || (_$a[_$i] = !0, o(e, t, n));
        }, Promise.all([
            e.or._iterate(_$r, t),
            It(Ct(e, n, t), e.algorithm, _$r, !e.keysOnly && e.valueMapper)
        ])) : It(Ct(e, n, t), pt(e.algorithm, _$u), o, !e.keysOnly && e.valueMapper);
    }
    function It(e, r, i, o) {
        var _$a = E(o ? function(e, t, n) {
            return i(o(e), t, n);
        } : i);
        return e.then(function(n) {
            if (n) return n.start(function() {
                var t = function t() {
                    return n.continue();
                };
                r && !r(n, function(e) {
                    return t = e;
                }, function(e) {
                    n.stop(e), t = g;
                }, function(e) {
                    n.fail(e), t = g;
                }) || _$a(n.value, n, function(e) {
                    return t = e;
                }), t();
            });
        });
    }
    i.prototype._read = function(e, t) {
        var n = this._ctx;
        return n.error ? n.table._trans(null, S.bind(null, n.error)) : n.table._trans("readonly", e).then(t);
    }, i.prototype._write = function(e) {
        var t = this._ctx;
        return t.error ? t.table._trans(null, S.bind(null, t.error)) : t.table._trans("readwrite", e, "locked");
    }, i.prototype._addAlgorithm = function(e) {
        var t = this._ctx;
        t.algorithm = pt(t.algorithm, e);
    }, i.prototype._iterate = function(e, t) {
        return Tt(this._ctx, e, t, this._ctx.table.core);
    }, i.prototype.clone = function(e) {
        var t = Object.create(this.constructor.prototype), n = Object.create(this._ctx);
        return e && a(n, e), t._ctx = n, t;
    }, i.prototype.raw = function() {
        return this._ctx.valueMapper = null, this;
    }, i.prototype.each = function(t) {
        var n = this._ctx;
        return this._read(function(e) {
            return Tt(n, t, e, n.table.core);
        });
    }, i.prototype.count = function(e) {
        var _$i = this;
        return this._read(function(e) {
            var t, n = _$i._ctx, _$r = n.table.core;
            return Et(n, !0) ? _$r.count({
                trans: e,
                query: {
                    index: jt(n, _$r.schema),
                    range: n.range
                }
            }).then(function(e) {
                return Math.min(e, n.limit);
            }) : (t = 0, Tt(n, function() {
                return ++t, !1;
            }, e, _$r).then(function() {
                return t;
            }));
        }).then(e);
    }, i.prototype.sortBy = function(e, t) {
        var n = e.split(".").reverse(), _$r = n[0], _$i = n.length - 1;
        function o(e, t) {
            return t ? o(e[n[t]], t - 1) : e[_$r];
        }
        var _$a = "next" === this._ctx.dir ? 1 : -1;
        function u(e, t) {
            return j(o(e, _$i), o(t, _$i)) * _$a;
        }
        return this.toArray(function(e) {
            return e.slice().sort(u);
        }).then(t);
    }, i.prototype.toArray = function(e) {
        var o = this;
        return this._read(function(e) {
            var t, n, _$r, _$i = o._ctx;
            return Et(_$i, !0) && 0 < _$i.limit ? (t = _$i.valueMapper, n = jt(_$i, _$i.table.core.schema), _$i.table.core.query({
                trans: e,
                limit: _$i.limit,
                values: !0,
                direction: "prev" === _$i.dir ? "prev" : void 0,
                query: {
                    index: n,
                    range: _$i.range
                }
            }).then(function(e) {
                e = e.result;
                return t ? e.map(t) : e;
            })) : (_$r = [], Tt(_$i, function(e) {
                return _$r.push(e);
            }, e, _$i.table.core).then(function() {
                return _$r;
            }));
        }, e);
    }, i.prototype.offset = function(t) {
        var e = this._ctx;
        return t <= 0 || (e.offset += t, Et(e) ? At(e, function() {
            var n = t;
            return function(e, t) {
                return 0 === n || (1 === n ? --n : t(function() {
                    e.advance(n), n = 0;
                }), !1);
            };
        }) : At(e, function() {
            var e = t;
            return function() {
                return --e < 0;
            };
        })), this;
    }, i.prototype.limit = function(e) {
        return this._ctx.limit = Math.min(this._ctx.limit, e), At(this._ctx, function() {
            var _$r = e;
            return function(e, t, n) {
                return --_$r <= 0 && t(n), 0 <= _$r;
            };
        }, !0), this;
    }, i.prototype.until = function(r, i) {
        return St(this._ctx, function(e, t, n) {
            return !r(e.value) || (t(n), i);
        }), this;
    }, i.prototype.first = function(e) {
        return this.limit(1).toArray(function(e) {
            return e[0];
        }).then(e);
    }, i.prototype.last = function(e) {
        return this.reverse().first(e);
    }, i.prototype.filter = function(t) {
        var e;
        return St(this._ctx, function(e) {
            return t(e.value);
        }), (e = this._ctx).isMatch = pt(e.isMatch, t), this;
    }, i.prototype.and = function(e) {
        return this.filter(e);
    }, i.prototype.or = function(e) {
        return new this.db.WhereClause(this._ctx.table, e, this);
    }, i.prototype.reverse = function() {
        return this._ctx.dir = "prev" === this._ctx.dir ? "next" : "prev", this._ondirectionchange && this._ondirectionchange(this._ctx.dir), this;
    }, i.prototype.desc = function() {
        return this.reverse();
    }, i.prototype.eachKey = function(n) {
        var e = this._ctx;
        return e.keysOnly = !e.isMatch, this.each(function(e, t) {
            n(t.key, t);
        });
    }, i.prototype.eachUniqueKey = function(e) {
        return this._ctx.unique = "unique", this.eachKey(e);
    }, i.prototype.eachPrimaryKey = function(n) {
        var e = this._ctx;
        return e.keysOnly = !e.isMatch, this.each(function(e, t) {
            n(t.primaryKey, t);
        });
    }, i.prototype.keys = function(e) {
        var t = this._ctx, n = (t.keysOnly = !t.isMatch, []);
        return this.each(function(e, t) {
            n.push(t.key);
        }).then(function() {
            return n;
        }).then(e);
    }, i.prototype.primaryKeys = function(e) {
        var n = this._ctx;
        if (Et(n, !0) && 0 < n.limit) return this._read(function(e) {
            var t = jt(n, n.table.core.schema);
            return n.table.core.query({
                trans: e,
                values: !1,
                limit: n.limit,
                direction: "prev" === n.dir ? "prev" : void 0,
                query: {
                    index: t,
                    range: n.range
                }
            });
        }).then(function(e) {
            return e.result;
        }).then(e);
        n.keysOnly = !n.isMatch;
        var _$r = [];
        return this.each(function(e, t) {
            _$r.push(t.primaryKey);
        }).then(function() {
            return _$r;
        }).then(e);
    }, i.prototype.uniqueKeys = function(e) {
        return this._ctx.unique = "unique", this.keys(e);
    }, i.prototype.firstKey = function(e) {
        return this.limit(1).keys(function(e) {
            return e[0];
        }).then(e);
    }, i.prototype.lastKey = function(e) {
        return this.reverse().firstKey(e);
    }, i.prototype.distinct = function() {
        var n, e = this._ctx, e = e.index && e.table.schema.idxByName[e.index];
        return e && e.multi && (n = {}, St(this._ctx, function(e) {
            var e = e.primaryKey.toString(), t = m(n, e);
            return n[e] = !0, !t;
        })), this;
    }, i.prototype.modify = function(x) {
        var n = this, k = this._ctx;
        return this._write(function(p) {
            function y(e, t) {
                var n = t.failures;
                _$u += e - t.numFailures;
                for(var _$r = 0, _$i = O(n); _$r < _$i.length; _$r++){
                    var o = _$i[_$r];
                    _$a.push(n[o]);
                }
            }
            var _$v = "function" == typeof x ? x : function v(e) {
                return kt(e, x);
            }, m = k.table.core, e = m.schema.primaryKey, _$b = e.outbound, _$g = e.extractKey, _$w = 200, e = n.db._options.modifyChunkSize, _$a = (e && (_$w = "object" == (typeof e === "undefined" ? "undefined" : (0, $2bfPH._)(e)) ? e[m.name] || e["*"] || 200 : e), []), _$u = 0, t = [], _ = x === Dt;
            return n.clone().primaryKeys().then(function(f) {
                function h(s) {
                    var _$c = Math.min(_$w, f.length - s), l = f.slice(s, s + _$c);
                    return (_ ? Promise.resolve([]) : m.getMany({
                        trans: p,
                        keys: l,
                        cache: "immutable"
                    })).then(function(e) {
                        var n = [], t = [], _$r = _$b ? [] : null, _$i = _ ? l : [];
                        if (!_) for(var o = 0; o < _$c; ++o){
                            var _$a = e[o], _$u = {
                                value: ee(_$a),
                                primKey: f[s + o]
                            };
                            !1 !== _$v.call(_$u, _$u.value, _$u) && (null == _$u.value ? _$i.push(f[s + o]) : _$b || 0 === j(_$g(_$a), _$g(_$u.value)) ? (t.push(_$u.value), _$b && _$r.push(f[s + o])) : (_$i.push(f[s + o]), n.push(_$u.value)));
                        }
                        return Promise.resolve(0 < n.length && m.mutate({
                            trans: p,
                            type: "add",
                            values: n
                        }).then(function(e) {
                            for(var t in e.failures)_$i.splice(parseInt(t), 1);
                            y(n.length, e);
                        })).then(function() {
                            return (0 < t.length || _$d && "object" == (typeof x === "undefined" ? "undefined" : (0, $2bfPH._)(x))) && m.mutate({
                                trans: p,
                                type: "put",
                                keys: _$r,
                                values: t,
                                criteria: _$d,
                                changeSpec: "function" != typeof x && x,
                                isAdditionalChunk: 0 < s
                            }).then(function(e) {
                                return y(t.length, e);
                            });
                        }).then(function() {
                            return (0 < _$i.length || _$d && _) && m.mutate({
                                trans: p,
                                type: "delete",
                                keys: _$i,
                                criteria: _$d,
                                isAdditionalChunk: 0 < s
                            }).then(function(e) {
                                return wt(k.table, _$i, e);
                            }).then(function(e) {
                                return y(_$i.length, e);
                            });
                        }).then(function() {
                            return f.length > s + _$c && h(s + _$w);
                        });
                    });
                }
                var _$d = Et(k) && k.limit === 1 / 0 && ("function" != typeof x || _) && {
                    index: k.index,
                    range: k.range
                };
                return h(0).then(function() {
                    if (0 < _$a.length) throw new fe("Error modifying one or more objects", _$a, _$u, t);
                    return f.length;
                });
            });
        });
    }, i.prototype.delete = function() {
        var _$i = this._ctx, n = _$i.range;
        return !Et(_$i) || _$i.table.schema.yProps || !_$i.isPrimKey && 3 !== n.type ? this.modify(Dt) : this._write(function(e) {
            var t = _$i.table.core.schema.primaryKey, _$r = n;
            return _$i.table.core.count({
                trans: e,
                query: {
                    index: t,
                    range: _$r
                }
            }).then(function(n) {
                return _$i.table.core.mutate({
                    trans: e,
                    type: "deleteRange",
                    range: _$r
                }).then(function(_$e) {
                    var t = _$e.failures, _$e = _$e.numFailures;
                    if (_$e) throw new fe("Could not delete some values", Object.keys(t).map(function(e) {
                        return t[e];
                    }), n - _$e);
                    return n - _$e;
                });
            });
        });
    };
    var qt = i;
    function i() {}
    var Dt = function Dt(e, t) {
        return t.value = null;
    };
    function Bt(e, t) {
        return e < t ? -1 : e === t ? 0 : 1;
    }
    function Rt(e, t) {
        return t < e ? -1 : e === t ? 0 : 1;
    }
    function C(e, t, n) {
        e = e instanceof Lt ? new e.Collection(e) : e;
        return e._ctx.error = new (n || TypeError)(t), e;
    }
    function Ft(e) {
        return new e.Collection(e, function() {
            return Mt("");
        }).limit(0);
    }
    function Nt(e, s, n, r) {
        var _$i, _$c, l, f, h, _$d, _$p, y = n.length;
        if (!n.every(function(e) {
            return "string" == typeof e;
        })) return C(e, lt);
        function t(e) {
            _$i = "next" === e ? function i(e) {
                return e.toUpperCase();
            } : function(e) {
                return e.toLowerCase();
            }, _$c = "next" === e ? function c(e) {
                return e.toLowerCase();
            } : function(e) {
                return e.toUpperCase();
            }, l = "next" === e ? Bt : Rt;
            var _$t = n.map(function(e) {
                return {
                    lower: _$c(e),
                    upper: _$i(e)
                };
            }).sort(function(e, t) {
                return l(e.lower, t.lower);
            });
            f = _$t.map(function(e) {
                return e.upper;
            }), h = _$t.map(function(e) {
                return e.lower;
            }), _$p = "next" === (_$d = e) ? "" : r;
        }
        t("next");
        var e = new e.Collection(e, function() {
            return T(f[0], h[y - 1] + r);
        }), _$v = (e._ondirectionchange = function v(e) {
            t(e);
        }, 0);
        return e._addAlgorithm(function(e, t, n) {
            var _$r = e.key;
            if ("string" == typeof _$r) {
                var _$i = _$c(_$r);
                if (s(_$i, h, _$v)) return !0;
                for(var o = null, _$a = _$v; _$a < y; ++_$a){
                    var _$u = function(e, t, n, r, i, o) {
                        for(var _$a = Math.min(e.length, r.length), _$u = -1, _$s = 0; _$s < _$a; ++_$s){
                            var _$c = t[_$s];
                            if (_$c !== r[_$s]) return i(e[_$s], n[_$s]) < 0 ? e.substr(0, _$s) + n[_$s] + n.substr(_$s + 1) : i(e[_$s], r[_$s]) < 0 ? e.substr(0, _$s) + r[_$s] + n.substr(_$s + 1) : 0 <= _$u ? e.substr(0, _$u) + t[_$u] + n.substr(_$u + 1) : null;
                            i(e[_$s], _$c) < 0 && (_$u = _$s);
                        }
                        return _$a < r.length && "next" === o ? e + n.substr(e.length) : _$a < e.length && "prev" === o ? e.substr(0, n.length) : _$u < 0 ? null : e.substr(0, _$u) + r[_$u] + n.substr(_$u + 1);
                    }(_$r, _$i, f[_$a], h[_$a], l, _$d);
                    null === _$u && null === o ? _$v = _$a + 1 : (null === o || 0 < l(o, _$u)) && (o = _$u);
                }
                t(null !== o ? function() {
                    e.continue(o + _$p);
                } : n);
            }
            return !1;
        }), e;
    }
    function T(e, t, n, r) {
        return {
            type: 2,
            lower: e,
            upper: t,
            lowerOpen: n,
            upperOpen: r
        };
    }
    function Mt(e) {
        return {
            type: 1,
            lower: e,
            upper: e
        };
    }
    Object.defineProperty(d.prototype, "Collection", {
        get: function get() {
            return this._ctx.table.db.Collection;
        },
        enumerable: !1,
        configurable: !0
    }), d.prototype.between = function(e, t, n, r) {
        n = !1 !== n, r = !0 === r;
        try {
            return 0 < this._cmp(e, t) || 0 === this._cmp(e, t) && (n || r) && (!n || !r) ? Ft(this) : new this.Collection(this, function() {
                return T(e, t, !n, !r);
            });
        } catch (e) {
            return C(this, A);
        }
    }, d.prototype.equals = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return Mt(e);
        });
    }, d.prototype.above = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(e, void 0, !0);
        });
    }, d.prototype.aboveOrEqual = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(e, void 0, !1);
        });
    }, d.prototype.below = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(void 0, e, !1, !0);
        });
    }, d.prototype.belowOrEqual = function(e) {
        return null == e ? C(this, A) : new this.Collection(this, function() {
            return T(void 0, e);
        });
    }, d.prototype.startsWith = function(e) {
        return "string" != typeof e ? C(this, lt) : this.between(e, e + ct, !0, !0);
    }, d.prototype.startsWithIgnoreCase = function(e) {
        return "" === e ? this.startsWith(e) : Nt(this, function(e, t) {
            return 0 === e.indexOf(t[0]);
        }, [
            e
        ], ct);
    }, d.prototype.equalsIgnoreCase = function(e) {
        return Nt(this, function(e, t) {
            return e === t[0];
        }, [
            e
        ], "");
    }, d.prototype.anyOfIgnoreCase = function() {
        var e = n.apply(ae, arguments);
        return 0 === e.length ? Ft(this) : Nt(this, function(e, t) {
            return -1 !== t.indexOf(e);
        }, e, "");
    }, d.prototype.startsWithAnyOfIgnoreCase = function() {
        var e = n.apply(ae, arguments);
        return 0 === e.length ? Ft(this) : Nt(this, function(t, e) {
            return e.some(function(e) {
                return 0 === t.indexOf(e);
            });
        }, e, ct);
    }, d.prototype.anyOf = function() {
        var e, _$i, t = this, o = n.apply(ae, arguments), _$a = this._cmp;
        try {
            o.sort(_$a);
        } catch (e) {
            return C(this, A);
        }
        return 0 === o.length ? Ft(this) : ((e = new this.Collection(this, function() {
            return T(o[0], o[o.length - 1]);
        }))._ondirectionchange = function(e) {
            _$a = "next" === e ? t._ascending : t._descending, o.sort(_$a);
        }, _$i = 0, e._addAlgorithm(function(e, t, n) {
            for(var _$r = e.key; 0 < _$a(_$r, o[_$i]);)if (++_$i === o.length) return t(n), !1;
            return 0 === _$a(_$r, o[_$i]) || (t(function() {
                e.continue(o[_$i]);
            }), !1);
        }), e);
    }, d.prototype.notEqual = function(e) {
        return this.inAnyRange([
            [
                -1 / 0,
                e
            ],
            [
                e,
                this.db._maxKey
            ]
        ], {
            includeLowers: !1,
            includeUppers: !1
        });
    }, d.prototype.noneOf = function() {
        var e = n.apply(ae, arguments);
        if (0 === e.length) return new this.Collection(this);
        try {
            e.sort(this._ascending);
        } catch (e) {
            return C(this, A);
        }
        var t = e.reduce(function(e, t) {
            return e ? e.concat([
                [
                    e[e.length - 1][1],
                    t
                ]
            ]) : [
                [
                    -1 / 0,
                    t
                ]
            ];
        }, null);
        return t.push([
            e[e.length - 1],
            this.db._maxKey
        ]), this.inAnyRange(t, {
            includeLowers: !1,
            includeUppers: !1
        });
    }, d.prototype.inAnyRange = function(e, t) {
        var o = this, _$a = this._cmp, _$u = this._ascending, n = this._descending, s = this._min, _$c = this._max;
        if (0 === e.length) return Ft(this);
        if (!e.every(function(e) {
            return void 0 !== e[0] && void 0 !== e[1] && _$u(e[0], e[1]) <= 0;
        })) return C(this, "First argument to inAnyRange() must be an Array of two-value Arrays [lower,upper] where upper must not be lower than lower", k.InvalidArgument);
        var _$r = !t || !1 !== t.includeLowers, _$i = t && !0 === t.includeUppers;
        var l, f = _$u;
        function h(e, t) {
            return f(e[0], t[0]);
        }
        try {
            (l = e.reduce(function(e, t) {
                for(var n = 0, _$r = e.length; n < _$r; ++n){
                    var _$i = e[n];
                    if (_$a(t[0], _$i[1]) < 0 && 0 < _$a(t[1], _$i[0])) {
                        _$i[0] = s(_$i[0], t[0]), _$i[1] = _$c(_$i[1], t[1]);
                        break;
                    }
                }
                return n === _$r && e.push(t), e;
            }, [])).sort(h);
        } catch (e) {
            return C(this, A);
        }
        var _$d = 0, _$p = _$i ? function p(e) {
            return 0 < _$u(e, l[_$d][1]);
        } : function(e) {
            return 0 <= _$u(e, l[_$d][1]);
        }, y = _$r ? function y(e) {
            return 0 < n(e, l[_$d][0]);
        } : function(e) {
            return 0 <= n(e, l[_$d][0]);
        };
        var _$v = _$p, t = new this.Collection(this, function() {
            return T(l[0][0], l[l.length - 1][1], !_$r, !_$i);
        });
        return t._ondirectionchange = function(e) {
            f = "next" === e ? (_$v = _$p, _$u) : (_$v = y, n), l.sort(h);
        }, t._addAlgorithm(function(e, t, n) {
            for(var _$r, _$i = e.key; _$v(_$i);)if (++_$d === l.length) return t(n), !1;
            return !_$p(_$r = _$i) && !y(_$r) || (0 === o._cmp(_$i, l[_$d][1]) || 0 === o._cmp(_$i, l[_$d][0]) || t(function() {
                f === _$u ? e.continue(l[_$d][0]) : e.continue(l[_$d][1]);
            }), !1);
        }), t;
    }, d.prototype.startsWithAnyOf = function() {
        var e = n.apply(ae, arguments);
        return e.every(function(e) {
            return "string" == typeof e;
        }) ? 0 === e.length ? Ft(this) : this.inAnyRange(e.map(function(e) {
            return [
                e,
                e + ct
            ];
        })) : C(this, "startsWithAnyOf() only works with strings");
    };
    var Lt = d;
    function d() {}
    function I(t) {
        return E(function(e) {
            return Ut(e), t(e.target.error), !1;
        });
    }
    function Ut(e) {
        e.stopPropagation && e.stopPropagation(), e.preventDefault && e.preventDefault();
    }
    var zt = "storagemutated", Vt = "x-storagemutated-1", Wt = Pt(null, zt), Yt = (p.prototype._lock = function Yt() {
        return $(!P.global), ++this._reculock, 1 !== this._reculock || P.global || (P.lockOwnerFor = this), this;
    }, p.prototype._unlock = function() {
        if ($(!P.global), 0 == --this._reculock) for(P.global || (P.lockOwnerFor = null); 0 < this._blockedFuncs.length && !this._locked();){
            var e = this._blockedFuncs.shift();
            try {
                at(e[1], e[0]);
            } catch (e) {}
        }
        return this;
    }, p.prototype._locked = function() {
        return this._reculock && P.lockOwnerFor !== this;
    }, p.prototype.create = function(t) {
        var n = this;
        if (this.mode) {
            var e = this.db.idbdb, _$r = this.db._state.dbOpenError;
            if ($(!this.idbtrans), !t && !e) switch(_$r && _$r.name){
                case "DatabaseClosedError":
                    throw new k.DatabaseClosed(_$r);
                case "MissingAPIError":
                    throw new k.MissingAPI(_$r.message, _$r);
                default:
                    throw new k.OpenFailed(_$r);
            }
            if (!this.active) throw new k.TransactionInactive;
            $(null === this._completion._state), (t = this.idbtrans = t || (this.db.core || e).transaction(this.storeNames, this.mode, {
                durability: this.chromeTransactionDurability
            })).onerror = E(function(e) {
                Ut(e), n._reject(t.error);
            }), t.onabort = E(function(e) {
                Ut(e), n.active && n._reject(new k.Abort(t.error)), n.active = !1, n.on("abort").fire(e);
            }), t.oncomplete = E(function() {
                n.active = !1, n._resolve(), "mutatedParts" in t && Wt.storagemutated.fire(t.mutatedParts);
            });
        }
        return this;
    }, p.prototype._promise = function(n, r, i) {
        var e, o = this;
        return "readwrite" === n && "readwrite" !== this.mode ? S(new k.ReadOnly("Transaction is readonly")) : this.active ? this._locked() ? new K(function(e, t) {
            o._blockedFuncs.push([
                function() {
                    o._promise(n, r, i).then(e, t);
                },
                P
            ]);
        }) : i ? v(function() {
            var e = new K(function(e, t) {
                o._lock();
                var _$n = r(e, t, o);
                _$n && _$n.then && _$n.then(e, t);
            });
            return e.finally(function() {
                return o._unlock();
            }), e._lib = !0, e;
        }) : ((e = new K(function(e, t) {
            var _$n = r(e, t, o);
            _$n && _$n.then && _$n.then(e, t);
        }))._lib = !0, e) : S(new k.TransactionInactive);
    }, p.prototype._root = function() {
        return this.parent ? this.parent._root() : this;
    }, p.prototype.waitFor = function(e) {
        var t, _$r = this._root(), _$i = K.resolve(e), o = (_$r._waitingFor ? _$r._waitingFor = _$r._waitingFor.then(function() {
            return _$i;
        }) : (_$r._waitingFor = _$i, _$r._waitingQueue = [], t = _$r.idbtrans.objectStore(_$r.storeNames[0]), function e() {
            for(++_$r._spinCount; _$r._waitingQueue.length;)_$r._waitingQueue.shift()();
            _$r._waitingFor && (t.get(-1 / 0).onsuccess = e);
        }()), _$r._waitingFor);
        return new K(function(t, n) {
            _$i.then(function(e) {
                return _$r._waitingQueue.push(E(t.bind(null, e)));
            }, function(e) {
                return _$r._waitingQueue.push(E(n.bind(null, e)));
            }).finally(function() {
                _$r._waitingFor === o && (_$r._waitingFor = null);
            });
        });
    }, p.prototype.abort = function() {
        this.active && (this.active = !1, this.idbtrans && this.idbtrans.abort(), this._reject(new k.Abort));
    }, p.prototype.table = function(e) {
        var t = this._memoizedTables || (this._memoizedTables = {});
        if (m(t, e)) return t[e];
        var n = this.schema[e];
        if (n) return (n = new this.db.Table(e, n, this)).core = this.db.core.table(e), t[e] = n;
        throw new k.NotFound("Table " + e + " not part of transaction");
    }, p);
    function p() {}
    function $t(e, t, n, r, i, o, a, u) {
        return {
            name: e,
            keyPath: t,
            unique: n,
            multi: r,
            auto: i,
            compound: o,
            src: (n && !a ? "&" : "") + (r ? "*" : "") + (i ? "++" : "") + Qt(t),
            type: u
        };
    }
    function Qt(e) {
        return "string" == typeof e ? e : e ? "[" + [].join.call(e, "+") + "]" : "";
    }
    function Gt(e, t, n) {
        var _$r;
        return {
            name: e,
            primKey: t,
            indexes: n,
            mappedClass: null,
            idxByName: (_$r = function r(e) {
                return [
                    e.name,
                    e
                ];
            }, n.reduce(function(e, t, n) {
                t = _$r(t, n);
                return t && (e[t[0]] = t[1]), e;
            }, {}))
        };
    }
    var Xt = function Xt1(e) {
        try {
            return e.only([
                []
            ]), Xt = function Xt() {
                return [
                    []
                ];
            }, [
                []
            ];
        } catch (e) {
            return Xt = function Xt() {
                return ct;
            }, ct;
        }
    };
    function Ht(t) {
        var n;
        return null == t ? function() {} : "string" == typeof t ? 1 === (n = t).split(".").length ? function(e) {
            return e[n];
        } : function(e) {
            return c(e, n);
        } : function(e) {
            return c(e, t);
        };
    }
    function Jt(e) {
        return [].slice.call(e);
    }
    var Zt = 0;
    function en(e) {
        return null == e ? ":id" : "string" == typeof e ? e : "[".concat(e.join("+"), "]");
    }
    function tn(e, i, t) {
        function _(_$e) {
            if (3 === _$e.type) return null;
            if (4 === _$e.type) throw new Error("Cannot convert never type to IDBKeyRange");
            var t = _$e.lower, _$n = _$e.upper, _$r = _$e.lowerOpen, _$e = _$e.upperOpen;
            return void 0 === t ? void 0 === _$n ? null : i.upperBound(_$n, !!_$e) : void 0 === _$n ? i.lowerBound(t, !!_$r) : i.bound(t, _$n, !!_$r, !!_$e);
        }
        function n(e) {
            var _$p, y, _$w = e.name;
            return {
                name: _$w,
                schema: e,
                mutate: function mutate(e) {
                    var y = e.trans, _$v = e.type, m = e.keys, _$b = e.values, _$g = e.range;
                    return new Promise(function(t, e) {
                        t = E(t);
                        var _$n = y.objectStore(_$w), _$r = null == _$n.keyPath, _$i = "put" === _$v || "add" === _$v;
                        if (!_$i && "delete" !== _$v && "deleteRange" !== _$v) throw new Error("Invalid operation type: " + _$v);
                        var o, _$a = (m || _$b || {
                            length: 1
                        }).length;
                        if (m && _$b && m.length !== _$b.length) throw new Error("Given keys array must have same length as given values array.");
                        if (0 === _$a) return t({
                            numFailures: 0,
                            failures: {},
                            results: [],
                            lastResult: void 0
                        });
                        function u(e) {
                            ++l, Ut(e);
                        }
                        var s = [], _$c = [], l = 0;
                        if ("deleteRange" === _$v) {
                            if (4 === _$g.type) return t({
                                numFailures: l,
                                failures: _$c,
                                results: [],
                                lastResult: void 0
                            });
                            3 === _$g.type ? s.push(o = _$n.clear()) : s.push(o = _$n.delete(_(_$g)));
                        } else {
                            var _$r = _$i ? _$r ? [
                                _$b,
                                m
                            ] : [
                                _$b,
                                null
                            ] : [
                                m,
                                null
                            ], f = _$r[0], h = _$r[1];
                            if (_$i) for(var _$d = 0; _$d < _$a; ++_$d)s.push(o = h && void 0 !== h[_$d] ? _$n[_$v](f[_$d], h[_$d]) : _$n[_$v](f[_$d])), o.onerror = u;
                            else for(_$d = 0; _$d < _$a; ++_$d)s.push(o = _$n[_$v](f[_$d])), o.onerror = u;
                        }
                        function p(e) {
                            e = e.target.result, s.forEach(function(e, t) {
                                return null != e.error && (_$c[t] = e.error);
                            }), t({
                                numFailures: l,
                                failures: _$c,
                                results: "delete" === _$v ? m : s.map(function(e) {
                                    return e.result;
                                }),
                                lastResult: e
                            });
                        }
                        o.onerror = function(e) {
                            u(e), p(e);
                        }, o.onsuccess = p;
                    });
                },
                getMany: function getMany(e) {
                    var f = e.trans, h = e.keys;
                    return new Promise(function(t, e) {
                        t = E(t);
                        for(var _$n, _$r = f.objectStore(_$w), _$i = h.length, o = new Array(_$i), _$a = 0, _$u = 0, s = function s(e) {
                            e = e.target;
                            o[e._pos] = e.result, ++_$u === _$a && t(o);
                        }, _$c = I(e), l = 0; l < _$i; ++l)null != h[l] && ((_$n = _$r.get(h[l]))._pos = l, _$n.onsuccess = s, _$n.onerror = _$c, ++_$a);
                        0 === _$a && t(o);
                    });
                },
                get: function get(e) {
                    var _$r = e.trans, _$i = e.key;
                    return new Promise(function(t, e) {
                        t = E(t);
                        var _$n = _$r.objectStore(_$w).get(_$i);
                        _$n.onsuccess = function(e) {
                            return t(e.target.result);
                        }, _$n.onerror = I(e);
                    });
                },
                query: (_$p = _$a, y = _$u, function(d) {
                    return new Promise(function(t, e) {
                        t = E(t);
                        var _$n, _$r, _$i, o, _$a = d.trans, _$u = d.values, s = d.limit, _$c = d.query, l = null != (l = d.direction) ? l : "next", f = s === 1 / 0 ? void 0 : s, h = _$c.index, _$c = _$c.range, _$a = _$a.objectStore(_$w), _$a = h.isPrimaryKey ? _$a : _$a.index(h.name), h = _(_$c);
                        if (0 === s) return t({
                            result: []
                        });
                        y ? (_$c = {
                            query: h,
                            count: f,
                            direction: l
                        }, (_$n = _$u ? _$a.getAll(_$c) : _$a.getAllKeys(_$c)).onsuccess = function(e) {
                            return t({
                                result: e.target.result
                            });
                        }, _$n.onerror = I(e)) : _$p && "next" === l ? ((_$n = _$u ? _$a.getAll(h, f) : _$a.getAllKeys(h, f)).onsuccess = function(e) {
                            return t({
                                result: e.target.result
                            });
                        }, _$n.onerror = I(e)) : (_$r = 0, _$i = !_$u && "openKeyCursor" in _$a ? _$a.openKeyCursor(h, l) : _$a.openCursor(h, l), o = [], _$i.onsuccess = function() {
                            var _$e = _$i.result;
                            return !_$e || (o.push(_$u ? _$e.value : _$e.primaryKey), ++_$r === s) ? t({
                                result: o
                            }) : void _$e.continue();
                        }, _$i.onerror = I(e));
                    });
                }),
                openCursor: function openCursor(e) {
                    var _$c = e.trans, o = e.values, _$a = e.query, _$u = e.reverse, l = e.unique;
                    return new Promise(function(t, n) {
                        t = E(t);
                        var _$e = _$a.index, _$r = _$a.range, _$i = _$c.objectStore(_$w), _$i = _$e.isPrimaryKey ? _$i : _$i.index(_$e.name), _$e = _$u ? l ? "prevunique" : "prev" : l ? "nextunique" : "next", s = !o && "openKeyCursor" in _$i ? _$i.openKeyCursor(_(_$r), _$e) : _$i.openCursor(_(_$r), _$e);
                        s.onerror = I(n), s.onsuccess = E(function(e) {
                            var _$r, _$i, o, _$a, _$u = s.result;
                            _$u ? (_$u.___id = ++Zt, _$u.done = !1, _$r = _$u.continue.bind(_$u), _$i = (_$i = _$u.continuePrimaryKey) && _$i.bind(_$u), o = _$u.advance.bind(_$u), _$a = function a() {
                                throw new Error("Cursor not stopped");
                            }, _$u.trans = _$c, _$u.stop = _$u.continue = _$u.continuePrimaryKey = _$u.advance = function() {
                                throw new Error("Cursor not started");
                            }, _$u.fail = E(n), _$u.next = function() {
                                var _$e = this, _$t = 1;
                                return this.start(function() {
                                    return _$t-- ? _$e.continue() : _$e.stop();
                                }).then(function() {
                                    return _$e;
                                });
                            }, _$u.start = function(e) {
                                function t() {
                                    if (s.result) try {
                                        e();
                                    } catch (e) {
                                        _$u.fail(e);
                                    }
                                    else _$u.done = !0, _$u.start = function() {
                                        throw new Error("Cursor behind last entry");
                                    }, _$u.stop();
                                }
                                var _$n = new Promise(function(t, e) {
                                    t = E(t), s.onerror = I(e), _$u.fail = e, _$u.stop = function(e) {
                                        _$u.stop = _$u.continue = _$u.continuePrimaryKey = _$u.advance = _$a, t(e);
                                    };
                                });
                                return s.onsuccess = E(function(e) {
                                    s.onsuccess = t, t();
                                }), _$u.continue = _$r, _$u.continuePrimaryKey = _$i, _$u.advance = o, t(), _$n;
                            }, t(_$u)) : t(null);
                        }, n);
                    });
                },
                count: function count(e) {
                    var t = e.query, _$i = e.trans, o = t.index, _$a = t.range;
                    return new Promise(function(t, e) {
                        var _$n = _$i.objectStore(_$w), _$n = o.isPrimaryKey ? _$n : _$n.index(o.name), _$r = _(_$a), _$r = _$r ? _$n.count(_$r) : _$n.count();
                        _$r.onsuccess = E(function(e) {
                            return t(e.target.result);
                        }), _$r.onerror = I(e);
                    });
                }
            };
        }
        _$r = t, o = Jt((t = e).objectStoreNames), s = 0 < o.length ? _$r.objectStore(o[0]) : {};
        var _$r, t = {
            schema: {
                name: t.name,
                tables: o.map(function(e) {
                    return _$r.objectStore(e);
                }).map(function(t) {
                    var _$e = t.keyPath, _$n = t.autoIncrement, _$r = x(_$e), _$i = {}, _$r = {
                        name: t.name,
                        primaryKey: {
                            name: null,
                            isPrimaryKey: !0,
                            outbound: null == _$e,
                            compound: _$r,
                            keyPath: _$e,
                            autoIncrement: _$n,
                            unique: !0,
                            extractKey: Ht(_$e)
                        },
                        indexes: Jt(t.indexNames).map(function(e) {
                            return t.index(e);
                        }).map(function(_$e) {
                            var _$t = _$e.name, _$n = _$e.unique, _$r = _$e.multiEntry, _$e = _$e.keyPath, _$t = {
                                name: _$t,
                                compound: x(_$e),
                                keyPath: _$e,
                                unique: _$n,
                                multiEntry: _$r,
                                extractKey: Ht(_$e)
                            };
                            return _$i[en(_$e)] = _$t;
                        }),
                        getIndexByKeyPath: function getIndexByKeyPath(e) {
                            return _$i[en(e)];
                        }
                    };
                    return _$i[":id"] = _$r.primaryKey, null != _$e && (_$i[en(_$e)] = _$r.primaryKey), _$r;
                })
            },
            hasGetAll: 0 < o.length && "getAll" in s && !("undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604),
            hasIdb3Features: "getAllRecords" in s
        }, o = t.schema, _$a = t.hasGetAll, _$u = t.hasIdb3Features, s = o.tables.map(n), _$c = {};
        return s.forEach(function(e) {
            return _$c[e.name] = e;
        }), {
            stack: "dbcore",
            transaction: e.transaction.bind(e),
            table: function table(e) {
                if (_$c[e]) return _$c[e];
                throw new Error("Table '".concat(e, "' not found"));
            },
            MIN_KEY: -1 / 0,
            MAX_KEY: Xt(i),
            schema: o
        };
    }
    function nn(e, t, n, r) {
        n = n.IDBKeyRange;
        return t = tn(t, n, r), {
            dbcore: e.dbcore.reduce(function(e, t) {
                t = t.create;
                return _(_({}, e), t(e));
            }, t)
        };
    }
    function rn(n, e) {
        var t = e.db, t = nn(n._middlewares, t, n._deps, e);
        n.core = t.dbcore, n.tables.forEach(function(e) {
            var t = e.name;
            n.core.schema.tables.some(function(e) {
                return e.name === t;
            }) && (e.core = n.core.table(t), n[t] instanceof n.Table) && (n[t].core = e.core);
        });
    }
    function on(i, e, t, o) {
        t.forEach(function(n) {
            var _$r = o[n];
            e.forEach(function(e) {
                var _$t = function e(t, n) {
                    return z(t, n) || (t = F(t)) && e(t, n);
                }(e, n);
                (!_$t || "value" in _$t && void 0 === _$t.value) && (e === i.Transaction.prototype || e instanceof i.Transaction ? u(e, n, {
                    get: function get() {
                        return this.table(n);
                    },
                    set: function set(e) {
                        L(this, n, {
                            value: e,
                            writable: !0,
                            configurable: !0,
                            enumerable: !0
                        });
                    }
                }) : e[n] = new i.Table(n, _$r));
            });
        });
    }
    function an(n, e) {
        e.forEach(function(e) {
            for(var t in e)e[t] instanceof n.Table && delete e[t];
        });
    }
    function un(e, t) {
        return e._cfg.version - t._cfg.version;
    }
    function sn(n, r, i, e) {
        var o = n._dbSchema, _$a = (i.objectStoreNames.contains("$meta") && !o.$meta && (o.$meta = Gt("$meta", vn("")[0], []), n._storeNames.push("$meta")), n._createTransaction("readwrite", n._storeNames, o)), _$u = (_$a.create(i), _$a._completion.catch(e), _$a._reject.bind(_$a)), s = P.transless || P;
        v(function() {
            if (P.trans = _$a, P.transless = s, 0 !== r) return rn(n, i), t = r, ((_$e = _$a).storeNames.includes("$meta") ? _$e.table("$meta").get("version").then(function(e) {
                return null != e ? e : t;
            }) : K.resolve(t)).then(function(_$e) {
                var s = n, _$c = _$e, l = _$a, f = i, t = [], _$e = s._versions, h = s._dbSchema = pn(0, s.idbdb, f);
                return 0 === (_$e = _$e.filter(function(e) {
                    return e._cfg.version >= _$c;
                })).length ? K.resolve() : (_$e.forEach(function(u) {
                    t.push(function() {
                        var t, _$n, _$r, _$i = h, _$e = u._cfg.dbschema, o = (yn(s, _$i, f), yn(s, _$e, f), h = s._dbSchema = _$e, ln(_$i, _$e)), _$a = (o.add.forEach(function(e) {
                            fn(f, e[0], e[1].primKey, e[1].indexes);
                        }), o.change.forEach(function(e) {
                            if (e.recreate) throw new k.Upgrade("Not yet support for changing primary key");
                            var t = f.objectStore(e.name);
                            e.add.forEach(function(e) {
                                return dn(t, e);
                            }), e.change.forEach(function(e) {
                                t.deleteIndex(e.name), dn(t, e);
                            }), e.del.forEach(function(e) {
                                return t.deleteIndex(e);
                            });
                        }), u._cfg.contentUpgrade);
                        if (_$a && u._cfg.version > _$c) return rn(s, f), l._memoizedTables = {}, t = G(_$e), o.del.forEach(function(e) {
                            t[e] = _$i[e];
                        }), an(s, [
                            s.Transaction.prototype
                        ]), on(s, [
                            s.Transaction.prototype
                        ], O(t), t), l.schema = t, (_$n = ue(_$a)) && nt(), _$e = K.follow(function() {
                            var _$e;
                            (_$r = _$a(l)) && _$n && (_$e = w.bind(null, null), _$r.then(_$e, _$e));
                        }), _$r && "function" == typeof _$r.then ? K.resolve(_$r) : _$e.then(function() {
                            return _$r;
                        });
                    }), t.push(function(e) {
                        var t, _$n, _$r = u._cfg.dbschema;
                        t = _$r, _$n = e, [].slice.call(_$n.db.objectStoreNames).forEach(function(e) {
                            return null == t[e] && _$n.db.deleteObjectStore(e);
                        }), an(s, [
                            s.Transaction.prototype
                        ]), on(s, [
                            s.Transaction.prototype
                        ], s._storeNames, s._dbSchema), l.schema = s._dbSchema;
                    }), t.push(function(e) {
                        s.idbdb.objectStoreNames.contains("$meta") && (Math.ceil(s.idbdb.version / 10) === u._cfg.version ? (s.idbdb.deleteObjectStore("$meta"), delete s._dbSchema.$meta, s._storeNames = s._storeNames.filter(function(e) {
                            return "$meta" !== e;
                        })) : e.objectStore("$meta").put(u._cfg.version, "version"));
                    });
                }), (function e() {
                    return t.length ? K.resolve(t.shift()(l.idbtrans)).then(e) : K.resolve();
                })().then(function() {
                    hn(h, f);
                }));
            }).catch(_$u);
            var _$e, t;
            O(o).forEach(function(e) {
                fn(i, e, o[e].primKey, o[e].indexes);
            }), rn(n, i), K.follow(function() {
                return n.on.populate.fire(_$a);
            }).catch(_$u);
        });
    }
    function cn(e, r) {
        hn(e._dbSchema, r), r.db.version % 10 != 0 || r.objectStoreNames.contains("$meta") || r.db.createObjectStore("$meta").add(Math.ceil(r.db.version / 10 - 1), "version");
        var t = pn(0, e.idbdb, r);
        yn(e, e._dbSchema, r);
        for(var n = 0, _$i = ln(t, e._dbSchema).change; n < _$i.length; n++){
            var o = function(t) {
                if (t.change.length || t.recreate) return console.warn("Unable to patch indexes of table ".concat(t.name, " because it has changes on the type of index or primary key.")), {
                    value: void 0
                };
                var n = r.objectStore(t.name);
                t.add.forEach(function(e) {
                    l && console.debug("Dexie upgrade patch: Creating missing index ".concat(t.name, ".").concat(e.src)), dn(n, e);
                });
            }(_$i[n]);
            if ("object" == (typeof o === "undefined" ? "undefined" : (0, $2bfPH._)(o))) return o.value;
        }
    }
    function ln(e, t) {
        var n, _$r = {
            del: [],
            add: [],
            change: []
        };
        for(n in e)t[n] || _$r.del.push(n);
        for(n in t){
            var _$i = e[n], o = t[n];
            if (_$i) {
                var _$a = {
                    name: n,
                    def: o,
                    recreate: !1,
                    del: [],
                    add: [],
                    change: []
                };
                if ("" + (_$i.primKey.keyPath || "") != "" + (o.primKey.keyPath || "") || _$i.primKey.auto !== o.primKey.auto) _$a.recreate = !0, _$r.change.push(_$a);
                else {
                    var _$u = _$i.idxByName, s = o.idxByName, _$c = void 0;
                    for(_$c in _$u)s[_$c] || _$a.del.push(_$c);
                    for(_$c in s){
                        var l = _$u[_$c], f = s[_$c];
                        l ? l.src !== f.src && _$a.change.push(f) : _$a.add.push(f);
                    }
                    (0 < _$a.del.length || 0 < _$a.add.length || 0 < _$a.change.length) && _$r.change.push(_$a);
                }
            } else _$r.add.push([
                n,
                o
            ]);
        }
        return _$r;
    }
    function fn(e, t, n, r) {
        var _$i = e.db.createObjectStore(t, n.keyPath ? {
            keyPath: n.keyPath,
            autoIncrement: n.auto
        } : {
            autoIncrement: n.auto
        });
        r.forEach(function(e) {
            return dn(_$i, e);
        });
    }
    function hn(t, n) {
        O(t).forEach(function(e) {
            n.db.objectStoreNames.contains(e) || (l && console.debug("Dexie: Creating missing table", e), fn(n, e, t[e].primKey, t[e].indexes));
        });
    }
    function dn(e, t) {
        e.createIndex(t.name, t.keyPath, {
            unique: t.unique,
            multiEntry: t.multi
        });
    }
    function pn(e, t, u) {
        var s = {};
        return W(t.objectStoreNames, 0).forEach(function(e) {
            for(var _$t = u.objectStore(e), n = $t(Qt(_$a = _$t.keyPath), _$a || "", !0, !1, !!_$t.autoIncrement, _$a && "string" != typeof _$a, !0), _$r = [], _$i = 0; _$i < _$t.indexNames.length; ++_$i){
                var o = _$t.index(_$t.indexNames[_$i]), _$a = o.keyPath, o = $t(o.name, _$a, !!o.unique, !!o.multiEntry, !1, _$a && "string" != typeof _$a, !1);
                _$r.push(o);
            }
            s[e] = Gt(e, n, _$r);
        }), s;
    }
    function yn(e, t, n) {
        for(var _$r = n.db.objectStoreNames, _$i = 0; _$i < _$r.length; ++_$i){
            var o = _$r[_$i], _$a = n.objectStore(o);
            e._hasGetAll = "getAll" in _$a;
            for(var _$u = 0; _$u < _$a.indexNames.length; ++_$u){
                var s, _$c = _$a.indexNames[_$u], l = _$a.index(_$c).keyPath, l = "string" == typeof l ? l : "[" + W(l).join("+") + "]";
                t[o] && (s = t[o].idxByName[l]) && (s.name = _$c, delete t[o].idxByName[l], t[o].idxByName[_$c] = s);
            }
        }
        "undefined" != typeof navigator && /Safari/.test(navigator.userAgent) && !/(Chrome\/|Edge\/)/.test(navigator.userAgent) && f.WorkerGlobalScope && f instanceof f.WorkerGlobalScope && [].concat(navigator.userAgent.match(/Safari\/(\d*)/))[1] < 604 && (e._hasGetAll = !1);
    }
    function vn(e) {
        return e.split(",").map(function(e, t) {
            var n = e.split(":"), _$r = null == (_$r = n[1]) ? void 0 : _$r.trim(), n = (e = n[0].trim()).replace(/([&*]|\+\+)/g, ""), _$i = /^\[/.test(n) ? n.match(/^\[(.*)\]$/)[1].split("+") : n;
            return $t(n, _$i || null, /\&/.test(e), /\*/.test(e), /\+\+/.test(e), x(_$i), 0 === t, _$r);
        });
    }
    bn.prototype._createTableSchema = Gt, bn.prototype._parseIndexSyntax = vn, bn.prototype._parseStoresSpec = function(r, i) {
        var o = this;
        O(r).forEach(function(e) {
            if (null !== r[e]) {
                var t = o._parseIndexSyntax(r[e]), n = t.shift();
                if (!n) throw new k.Schema("Invalid schema for table " + e + ": " + r[e]);
                if (n.unique = !0, n.multi) throw new k.Schema("Primary key cannot be multiEntry*");
                t.forEach(function(e) {
                    if (e.auto) throw new k.Schema("Only primary key can be marked as autoIncrement (++)");
                    if (!e.keyPath) throw new k.Schema("Index must have a name and cannot be an empty string");
                });
                n = o._createTableSchema(e, n, t);
                i[e] = n;
            }
        });
    }, bn.prototype.stores = function(e) {
        var t = this.db, e = (this._cfg.storesSource = this._cfg.storesSource ? a(this._cfg.storesSource, e) : e, t._versions), n = {}, _$r = {};
        return e.forEach(function(e) {
            a(n, e._cfg.storesSource), _$r = e._cfg.dbschema = {}, e._parseStoresSpec(n, _$r);
        }), t._dbSchema = _$r, an(t, [
            t._allTables,
            t,
            t.Transaction.prototype
        ]), on(t, [
            t._allTables,
            t,
            t.Transaction.prototype,
            this._cfg.tables
        ], O(_$r), _$r), t._storeNames = O(_$r), this;
    }, bn.prototype.upgrade = function(e) {
        return this._cfg.contentUpgrade = ke(this._cfg.contentUpgrade || g, e), this;
    };
    var mn = bn;
    function bn() {}
    var gn = function() {
        var _$i, o, t;
        return "undefined" != typeof FinalizationRegistry && "undefined" != typeof WeakRef ? (_$i = new Set, o = new FinalizationRegistry(function(e) {
            _$i.delete(e);
        }), {
            toArray: function toArray() {
                return Array.from(_$i).map(function(e) {
                    return e.deref();
                }).filter(function(e) {
                    return void 0 !== e;
                });
            },
            add: function add(e) {
                var t = new WeakRef(e._novip);
                _$i.add(t), o.register(e._novip, t, t), _$i.size > e._options.maxConnections && (t = _$i.values().next().value, _$i.delete(t), o.unregister(t));
            },
            remove: function remove(e) {
                if (e) for(var t = _$i.values(), n = t.next(); !n.done;){
                    var _$r = n.value;
                    if (_$r.deref() === e._novip) return _$i.delete(_$r), void o.unregister(_$r);
                    n = t.next();
                }
            }
        }) : (t = [], {
            toArray: function toArray() {
                return t;
            },
            add: function add(e) {
                t.push(e._novip);
            },
            remove: function remove(e) {
                e && -1 !== (e = t.indexOf(e._novip)) && t.splice(e, 1);
            }
        });
    }();
    function wn(e, t) {
        var n = e._dbNamesDB;
        return n || (n = e._dbNamesDB = new y(ft, {
            addons: [],
            indexedDB: e,
            IDBKeyRange: t
        })).version(1).stores({
            dbnames: "name"
        }), n.table("dbnames");
    }
    function _n(e) {
        return e && "function" == typeof e.databases;
    }
    function xn(e) {
        return v(function() {
            return P.letThrough = !0, e();
        });
    }
    function kn(e) {
        return !("from" in e);
    }
    var q = function q1(e, t) {
        var n;
        if (!this) return n = new q, e && "d" in e && a(n, e), n;
        a(this, arguments.length ? {
            d: 1,
            from: e,
            to: 1 < arguments.length ? t : e
        } : {
            d: 0
        });
    };
    function On(e, t, n) {
        var _$r = j(t, n);
        if (!isNaN(_$r)) {
            if (0 < _$r) throw RangeError();
            if (kn(e)) return a(e, {
                from: t,
                to: n,
                d: 1
            });
            var _$r = e.l, _$i = e.r;
            if (j(n, e.from) < 0) return _$r ? On(_$r, t, n) : e.l = {
                from: t,
                to: n,
                d: 1,
                l: null,
                r: null
            }, Sn(e);
            if (0 < j(t, e.to)) return _$i ? On(_$i, t, n) : e.r = {
                from: t,
                to: n,
                d: 1,
                l: null,
                r: null
            }, Sn(e);
            j(t, e.from) < 0 && (e.from = t, e.l = null, e.d = _$i ? _$i.d + 1 : 1), 0 < j(n, e.to) && (e.to = n, e.r = null, e.d = e.l ? e.l.d + 1 : 1);
            t = !e.r;
            _$r && !e.l && Pn(e, _$r), _$i && t && Pn(e, _$i);
        }
    }
    function Pn(e, t) {
        kn(t) || function e(t, n) {
            var _$r = n.from, _$i = n.l, o = n.r;
            On(t, _$r, n.to), _$i && e(t, _$i), o && e(t, o);
        }(e, t);
    }
    function Kn(e, t) {
        var n = En(t), _$r = n.next();
        if (!_$r.done) for(var _$i = _$r.value, o = En(e), _$a = o.next(_$i.from), _$u = _$a.value; !_$r.done && !_$a.done;){
            if (j(_$u.from, _$i.to) <= 0 && 0 <= j(_$u.to, _$i.from)) return !0;
            j(_$i.from, _$u.from) < 0 ? _$i = (_$r = n.next(_$u.from)).value : _$u = (_$a = o.next(_$i.from)).value;
        }
        return !1;
    }
    function En(e) {
        var n = kn(e) ? null : {
            s: 0,
            n: e
        };
        return {
            next: function next(e) {
                for(var t = 0 < arguments.length; n;)switch(n.s){
                    case 0:
                        if (n.s = 1, t) for(; n.n.l && j(e, n.n.from) < 0;)n = {
                            up: n,
                            n: n.n.l,
                            s: 1
                        };
                        else for(; n.n.l;)n = {
                            up: n,
                            n: n.n.l,
                            s: 1
                        };
                    case 1:
                        if (n.s = 2, !t || j(e, n.n.to) <= 0) return {
                            value: n.n,
                            done: !1
                        };
                    case 2:
                        if (n.n.r) {
                            n.s = 3, n = {
                                up: n,
                                n: n.n.r,
                                s: 0
                            };
                            continue;
                        }
                    case 3:
                        n = n.up;
                }
                return {
                    done: !0
                };
            }
        };
    }
    function Sn(e) {
        var t, n, _$r, _$i = ((null == (_$i = e.r) ? void 0 : _$i.d) || 0) - ((null == (_$i = e.l) ? void 0 : _$i.d) || 0), _$i = 1 < _$i ? "r" : _$i < -1 ? "l" : "";
        _$i && (t = "r" == _$i ? "l" : "r", n = _({}, e), _$r = e[_$i], e.from = _$r.from, e.to = _$r.to, e[_$i] = _$r[_$i], n[_$i] = _$r[t], (e[t] = n).d = An(n)), e.d = An(e);
    }
    function An(e) {
        var t = e.r, e = e.l;
        return (t ? e ? Math.max(t.d, e.d) : t.d : e ? e.d : 0) + 1;
    }
    function jn(t, n) {
        return O(n).forEach(function(e) {
            t[e] ? Pn(t[e], n[e]) : t[e] = function e(t) {
                var _$n, _$r, _$i = {};
                for(_$n in t)m(t, _$n) && (_$r = t[_$n], _$i[_$n] = !_$r || "object" != (typeof _$r === "undefined" ? "undefined" : (0, $2bfPH._)(_$r)) || J.has(_$r.constructor) ? _$r : e(_$r));
                return _$i;
            }(n[e]);
        }), t;
    }
    function Cn(t, n) {
        return t.all || n.all || Object.keys(t).some(function(e) {
            return n[e] && Kn(n[e], t[e]);
        });
    }
    M(q.prototype, ((t = {
        add: function add(e) {
            return Pn(this, e), this;
        },
        addKey: function addKey(e) {
            return On(this, e, e), this;
        },
        addKeys: function addKeys(e) {
            var t = this;
            return e.forEach(function(e) {
                return On(t, e, e);
            }), this;
        },
        hasKey: function hasKey(e) {
            var t = En(this).next(e).value;
            return t && j(t.from, e) <= 0 && 0 <= j(t.to, e);
        }
    })[re] = function() {
        return En(this);
    }, t));
    var Tn = {}, In = {}, qn = !1;
    function Dn(e) {
        jn(In, e), qn || (qn = !0, setTimeout(function() {
            qn = !1, Bn(In, (In = {}, false));
        }, 0));
    }
    function Bn(e, t) {
        void 0 === t && (t = !1);
        var n = new Set;
        if (e.all) for(var _$r = 0, _$i = Object.values(Tn); _$r < _$i.length; _$r++)Rn(_$u = _$i[_$r], e, n, t);
        else for(var o in e){
            var _$a, _$u, o = /^idb\:\/\/(.*)\/(.*)\//.exec(o);
            o && (_$a = o[1], o = o[2], _$u = Tn["idb://".concat(_$a, "/").concat(o)]) && Rn(_$u, e, n, t);
        }
        n.forEach(function(e) {
            return e();
        });
    }
    function Rn(e, t, n, r) {
        for(var _$i = [], o = 0, _$a = Object.entries(e.queries.query); o < _$a.length; o++){
            for(var _$u = _$a[o], s = _$u[0], _$c = [], l = 0, f = _$u[1]; l < f.length; l++){
                var h = f[l];
                Cn(t, h.obsSet) ? h.subscribers.forEach(function(e) {
                    return n.add(e);
                }) : r && _$c.push(h);
            }
            r && _$i.push([
                s,
                _$c
            ]);
        }
        if (r) for(var _$d = 0, _$p = _$i; _$d < _$p.length; _$d++){
            var y = _$p[_$d], s = y[0], _$c = y[1];
            e.queries.query[s] = _$c;
        }
    }
    function Fn(h) {
        var _$d = h._state, _$r = h._deps.indexedDB;
        if (_$d.isBeingOpened || h.idbdb) return _$d.dbReadyPromise.then(function() {
            return _$d.dbOpenError ? S(_$d.dbOpenError) : h;
        });
        _$d.isBeingOpened = !0, _$d.dbOpenError = null, _$d.openComplete = !1;
        var t = _$d.openCanceller, _$p = Math.round(10 * h.verno), y = !1;
        function e() {
            if (_$d.openCanceller !== t) throw new k.DatabaseClosed("db.open() was cancelled");
        }
        function v() {
            return new K(function(c, n) {
                if (e(), !_$r) throw new k.MissingAPI;
                var l = h.name, f = _$d.autoSchema || !_$p ? _$r.open(l) : _$r.open(l, _$p);
                if (!f) throw new k.MissingAPI;
                f.onerror = I(n), f.onblocked = E(h._fireOnBlocked), f.onupgradeneeded = E(function(e) {
                    var t;
                    m = f.transaction, _$d.autoSchema && !h._options.allowEmptyDB ? (f.onerror = Ut, m.abort(), f.result.close(), (t = _$r.deleteDatabase(l)).onsuccess = t.onerror = E(function() {
                        n(new k.NoSuchDatabase("Database ".concat(l, " doesnt exist")));
                    })) : (m.onerror = I(n), t = e.oldVersion > Math.pow(2, 62) ? 0 : e.oldVersion, _$b = t < 1, h.idbdb = f.result, y && cn(h, m), sn(h, t / 10, m, n));
                }, n), f.onsuccess = E(function() {
                    m = null;
                    var _$e, t, _$n, _$r, _$i, o, _$a = h.idbdb = f.result, _$u = W(_$a.objectStoreNames);
                    if (0 < _$u.length) try {
                        var s = _$a.transaction(1 === (_$i = _$u).length ? _$i[0] : _$i, "readonly");
                        if (_$d.autoSchema) o = _$a, _$r = s, (_$n = h).verno = o.version / 10, _$r = _$n._dbSchema = pn(0, o, _$r), _$n._storeNames = W(o.objectStoreNames, 0), on(_$n, [
                            _$n._allTables
                        ], O(_$r), _$r);
                        else if (yn(h, h._dbSchema, s), t = s, ((t = ln(pn(0, (_$e = h).idbdb, t), _$e._dbSchema)).add.length || t.change.some(function(e) {
                            return e.add.length || e.change.length;
                        })) && !y) return console.warn("Dexie SchemaDiff: Schema was extended without increasing the number passed to db.version(). Dexie will add missing parts and increment native version number to workaround this."), _$a.close(), _$p = _$a.version + 1, y = !0, c(v());
                        rn(h, s);
                    } catch (e) {}
                    gn.add(h), _$a.onversionchange = E(function(e) {
                        _$d.vcFired = !0, h.on("versionchange").fire(e);
                    }), _$a.onclose = E(function() {
                        h.close({
                            disableAutoOpen: !1
                        });
                    }), _$b && (_$u = h._deps, _$i = l, _n(o = _$u.indexedDB) || _$i === ft || wn(o, _$u.IDBKeyRange).put({
                        name: _$i
                    }).catch(g)), c();
                }, n);
            }).catch(function(e) {
                switch(null == e ? void 0 : e.name){
                    case "UnknownError":
                        if (0 < _$d.PR1398_maxLoop) return _$d.PR1398_maxLoop--, console.warn("Dexie: Workaround for Chrome UnknownError on open()"), v();
                        break;
                    case "VersionError":
                        if (0 < _$p) return _$p = 0, v();
                }
                return K.reject(e);
            });
        }
        var n, _$i = _$d.dbReadyResolve, m = null, _$b = !1;
        return K.race([
            t,
            ("undefined" == typeof navigator ? K.resolve() : !navigator.userAgentData && /Safari\//.test(navigator.userAgent) && !/Chrom(e|ium)\//.test(navigator.userAgent) && indexedDB.databases ? new Promise(function(e) {
                function t() {
                    return indexedDB.databases().finally(e);
                }
                n = setInterval(t, 100), t();
            }).finally(function() {
                return clearInterval(n);
            }) : Promise.resolve()).then(v)
        ]).then(function() {
            return e(), _$d.onReadyBeingFired = [], K.resolve(xn(function() {
                return h.on.ready.fire(h.vip);
            })).then(function e() {
                var t;
                if (0 < _$d.onReadyBeingFired.length) return t = _$d.onReadyBeingFired.reduce(ke, g), _$d.onReadyBeingFired = [], K.resolve(xn(function() {
                    return t(h.vip);
                })).then(e);
            });
        }).finally(function() {
            _$d.openCanceller === t && (_$d.onReadyBeingFired = null, _$d.isBeingOpened = !1);
        }).catch(function(e) {
            _$d.dbOpenError = e;
            try {
                m && m.abort();
            } catch (e) {}
            return t === _$d.openCanceller && h._close(), S(e);
        }).finally(function() {
            _$d.openComplete = !0, _$i();
        }).then(function() {
            var n;
            return _$b && (n = {}, h.tables.forEach(function(t) {
                t.schema.indexes.forEach(function(e) {
                    e.name && (n["idb://".concat(h.name, "/").concat(t.name, "/").concat(e.name)] = new q(-1 / 0, [
                        [
                            []
                        ]
                    ]));
                }), n["idb://".concat(h.name, "/").concat(t.name, "/")] = n["idb://".concat(h.name, "/").concat(t.name, "/:dels")] = new q(-1 / 0, [
                    [
                        []
                    ]
                ]);
            }), Wt(zt).fire(n), Bn(n, !0)), h;
        });
    }
    function Nn(t) {
        function e(e) {
            return t.next(e);
        }
        var _$r = n(e), _$i = n(function(e) {
            return t.throw(e);
        });
        function n(n) {
            return function(_$e) {
                var _$e = n(_$e), t = _$e.value;
                return _$e.done ? t : t && "function" == typeof t.then ? t.then(_$r, _$i) : x(t) ? Promise.all(t).then(_$r, _$i) : _$r(t);
            };
        }
        return n(e)();
    }
    function Mn(e, t, n) {
        for(var _$r = x(e) ? e.slice() : [
            e
        ], _$i = 0; _$i < n; ++_$i)_$r.push(t);
        return _$r;
    }
    var Ln = {
        stack: "dbcore",
        name: "VirtualIndexMiddleware",
        level: 1,
        create: function create(l) {
            return _(_({}, l), {
                table: function table(e) {
                    var o = l.table(e), e = o.schema, _$u = Object.create(null), s = [];
                    function c(e, t, n) {
                        var _$r = en(e), _$i = _$u[_$r] = _$u[_$r] || [], o = null == e ? 0 : "string" == typeof e ? 1 : e.length, _$a = 0 < t, _$r = _(_({}, n), {
                            name: _$a ? "".concat(_$r, "(virtual-from:").concat(n.name, ")") : n.name,
                            lowLevelIndex: n,
                            isVirtual: _$a,
                            keyTail: t,
                            keyLength: o,
                            extractKey: Ht(e),
                            unique: !_$a && n.unique
                        });
                        return _$i.push(_$r), _$r.isPrimaryKey || s.push(_$r), 1 < o && c(2 === o ? e[0] : e.slice(0, o - 1), t + 1, n), _$i.sort(function(e, t) {
                            return e.keyTail - t.keyTail;
                        }), _$r;
                    }
                    var t = c(e.primaryKey.keyPath, 0, e.primaryKey);
                    _$u[":id"] = [
                        t
                    ];
                    for(var n = 0, _$r = e.indexes; n < _$r.length; n++){
                        var _$i = _$r[n];
                        c(_$i.keyPath, 0, _$i);
                    }
                    function a(e) {
                        var t, n = e.query.index;
                        return n.isVirtual ? _(_({}, e), {
                            query: {
                                index: n.lowLevelIndex,
                                range: (t = e.query.range, n = n.keyTail, {
                                    type: 1 === t.type ? 2 : t.type,
                                    lower: Mn(t.lower, t.lowerOpen ? l.MAX_KEY : l.MIN_KEY, n),
                                    lowerOpen: !0,
                                    upper: Mn(t.upper, t.upperOpen ? l.MIN_KEY : l.MAX_KEY, n),
                                    upperOpen: !0
                                })
                            }
                        }) : e;
                    }
                    return _(_({}, o), {
                        schema: _(_({}, e), {
                            primaryKey: t,
                            indexes: s,
                            getIndexByKeyPath: function getIndexByKeyPath(e) {
                                return (e = _$u[en(e)]) && e[0];
                            }
                        }),
                        count: function count(e) {
                            return o.count(a(e));
                        },
                        query: function query(e) {
                            return o.query(a(e));
                        },
                        openCursor: function openCursor(t) {
                            var e = t.query.index, _$r = e.keyTail, _$i = e.keyLength;
                            return e.isVirtual ? o.openCursor(a(t)).then(function(e) {
                                return e && n(e);
                            }) : o.openCursor(t);
                            function n(n) {
                                return Object.create(n, {
                                    continue: {
                                        value: function value(e) {
                                            null != e ? n.continue(Mn(e, t.reverse ? l.MAX_KEY : l.MIN_KEY, _$r)) : t.unique ? n.continue(n.key.slice(0, _$i).concat(t.reverse ? l.MIN_KEY : l.MAX_KEY, _$r)) : n.continue();
                                        }
                                    },
                                    continuePrimaryKey: {
                                        value: function value(e, t) {
                                            n.continuePrimaryKey(Mn(e, l.MAX_KEY, _$r), t);
                                        }
                                    },
                                    primaryKey: {
                                        get: function get() {
                                            return n.primaryKey;
                                        }
                                    },
                                    key: {
                                        get: function get() {
                                            var e = n.key;
                                            return 1 === _$i ? e[0] : e.slice(0, _$i);
                                        }
                                    },
                                    value: {
                                        get: function get() {
                                            return n.value;
                                        }
                                    }
                                });
                            }
                        }
                    });
                }
            });
        }
    };
    function Un(i, o, a, u) {
        return a = a || {}, u = u || "", O(i).forEach(function(e) {
            var t, n, _$r;
            m(o, e) ? (t = i[e], n = o[e], "object" == (typeof t === "undefined" ? "undefined" : (0, $2bfPH._)(t)) && "object" == (typeof n === "undefined" ? "undefined" : (0, $2bfPH._)(n)) && t && n ? (_$r = ne(t)) !== ne(n) ? a[u + e] = o[e] : "Object" === _$r ? Un(t, n, a, u + e + ".") : t !== n && (a[u + e] = o[e]) : t !== n && (a[u + e] = o[e])) : a[u + e] = void 0;
        }), O(o).forEach(function(e) {
            m(i, e) || (a[u + e] = o[e]);
        }), a;
    }
    function zn(e, t) {
        return "delete" === t.type ? t.keys : t.keys || t.values.map(e.extractKey);
    }
    var Vn = {
        stack: "dbcore",
        name: "HooksMiddleware",
        level: 2,
        create: function create(e) {
            return _(_({}, e), {
                table: function table(r) {
                    var y = e.table(r), _$v = y.schema.primaryKey;
                    return _(_({}, y), {
                        mutate: function mutate(e) {
                            var t = P.trans, n = t.table(r).hook, h = n.deleting, _$d = n.creating, _$p = n.updating;
                            switch(e.type){
                                case "add":
                                    if (_$d.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "put":
                                    if (_$d.fire === g && _$p.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "delete":
                                    if (h.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return a(e);
                                    }, !0);
                                case "deleteRange":
                                    if (h.fire === g) break;
                                    return t._promise("readwrite", function() {
                                        return function n(r, i, o) {
                                            return y.query({
                                                trans: r,
                                                values: !1,
                                                query: {
                                                    index: _$v,
                                                    range: i
                                                },
                                                limit: o
                                            }).then(function(e) {
                                                var t = e.result;
                                                return a({
                                                    type: "delete",
                                                    keys: t,
                                                    trans: r
                                                }).then(function(e) {
                                                    return 0 < e.numFailures ? Promise.reject(e.failures[0]) : t.length < o ? {
                                                        failures: [],
                                                        numFailures: 0,
                                                        lastResult: void 0
                                                    } : n(r, _(_({}, i), {
                                                        lower: t[t.length - 1],
                                                        lowerOpen: !0
                                                    }), o);
                                                });
                                            });
                                        }(e.trans, e.range, 1e4);
                                    }, !0);
                            }
                            return y.mutate(e);
                            function a(c) {
                                var _$e, t, n, l = P.trans, f = c.keys || zn(_$v, c);
                                if (f) return "delete" !== (c = "add" === c.type || "put" === c.type ? _(_({}, c), {
                                    keys: f
                                }) : _({}, c)).type && (c.values = R([], c.values, !0)), c.keys && (c.keys = R([], c.keys, !0)), _$e = y, n = f, ("add" === (t = c).type ? Promise.resolve([]) : _$e.getMany({
                                    trans: t.trans,
                                    keys: n,
                                    cache: "immutable"
                                })).then(function(u) {
                                    var s = f.map(function(e, t) {
                                        var n, _$r, _$i, o = u[t], _$a = {
                                            onerror: null,
                                            onsuccess: null
                                        };
                                        return "delete" === c.type ? h.fire.call(_$a, e, o, l) : "add" === c.type || void 0 === o ? (n = _$d.fire.call(_$a, e, c.values[t], l), null == e && null != n && (c.keys[t] = e = n, _$v.outbound || b(c.values[t], _$v.keyPath, e))) : (n = Un(o, c.values[t]), (_$r = _$p.fire.call(_$a, n, e, o, l)) && (_$i = c.values[t], Object.keys(_$r).forEach(function(e) {
                                            m(_$i, e) ? _$i[e] = _$r[e] : b(_$i, e, _$r[e]);
                                        }))), _$a;
                                    });
                                    return y.mutate(c).then(function(_$e) {
                                        for(var t = _$e.failures, n = _$e.results, _$r = _$e.numFailures, _$e = _$e.lastResult, _$i = 0; _$i < f.length; ++_$i){
                                            var o = (n || f)[_$i], _$a = s[_$i];
                                            null == o ? _$a.onerror && _$a.onerror(t[_$i]) : _$a.onsuccess && _$a.onsuccess("put" === c.type && u[_$i] ? c.values[_$i] : o);
                                        }
                                        return {
                                            failures: t,
                                            results: n,
                                            numFailures: _$r,
                                            lastResult: _$e
                                        };
                                    }).catch(function(t) {
                                        return s.forEach(function(e) {
                                            return e.onerror && e.onerror(t);
                                        }), Promise.reject(t);
                                    });
                                });
                                throw new Error("Keys missing");
                            }
                        }
                    });
                }
            });
        }
    };
    function Wn(e, t, n) {
        try {
            if (!t) return null;
            if (t.keys.length < e.length) return null;
            for(var _$r = [], _$i = 0, o = 0; _$i < t.keys.length && o < e.length; ++_$i)0 === j(t.keys[_$i], e[o]) && (_$r.push(n ? ee(t.values[_$i]) : t.values[_$i]), ++o);
            return _$r.length === e.length ? _$r : null;
        } catch (e) {
            return null;
        }
    }
    var Yn = {
        stack: "dbcore",
        level: -1,
        create: function create(t) {
            return {
                table: function table(e) {
                    var n = t.table(e);
                    return _(_({}, n), {
                        getMany: function getMany(t) {
                            var _$e;
                            return t.cache ? (_$e = Wn(t.keys, t.trans._cache, "clone" === t.cache)) ? K.resolve(_$e) : n.getMany(t).then(function(e) {
                                return t.trans._cache = {
                                    keys: t.keys,
                                    values: "clone" === t.cache ? ee(e) : e
                                }, e;
                            }) : n.getMany(t);
                        },
                        mutate: function mutate(e) {
                            return "add" !== e.type && (e.trans._cache = null), n.mutate(e);
                        }
                    });
                }
            };
        }
    };
    function $n(e, t) {
        return "readonly" === e.trans.mode && !!e.subscr && !e.trans.explicit && "disabled" !== e.trans.db._options.cache && !t.schema.primaryKey.outbound;
    }
    function Qn(e, t) {
        switch(e){
            case "query":
                return t.values && !t.unique;
            case "get":
            case "getMany":
            case "count":
            case "openCursor":
                return !1;
        }
    }
    var Gn = {
        stack: "dbcore",
        level: 0,
        name: "Observability",
        create: function create(b) {
            var _$g = b.schema.name, _$w = new q(b.MIN_KEY, b.MAX_KEY);
            return _(_({}, b), {
                transaction: function transaction(e, t, n) {
                    if (P.subscr && "readonly" !== t) throw new k.ReadOnly("Readwrite transaction in liveQuery context. Querier source: ".concat(P.querier));
                    return b.transaction(e, t, n);
                },
                table: function table(d) {
                    function e(_$e) {
                        var t, _$e = _$e.query;
                        return [
                            t = _$e.index,
                            new q(null != (t = (_$e = _$e.range).lower) ? t : b.MIN_KEY, null != (t = _$e.upper) ? t : b.MAX_KEY)
                        ];
                    }
                    var _$p = b.table(d), y = _$p.schema, _$v = y.primaryKey, t = y.indexes, _$c = _$v.extractKey, l = _$v.outbound, m = _$v.autoIncrement && t.filter(function(e) {
                        return e.compound && e.keyPath.includes(_$v.keyPath);
                    }), n = _(_({}, _$p), {
                        mutate: function mutate(a) {
                            function u(e) {
                                return e = "idb://".concat(_$g, "/").concat(d, "/").concat(e), n[e] || (n[e] = new q);
                            }
                            var _$e, o, s, t = a.trans, n = a.mutatedParts || (a.mutatedParts = {}), _$r = u(""), _$i = u(":dels"), _$c = a.type, l = "deleteRange" === a.type ? [
                                a.range
                            ] : "delete" === a.type ? [
                                a.keys
                            ] : a.values.length < 50 ? [
                                zn(_$v, a).filter(function(e) {
                                    return e;
                                }),
                                a.values
                            ] : [], f = l[0], l = l[1], h = a.trans._cache;
                            return x(f) ? (_$r.addKeys(f), (_$c = "delete" === _$c || f.length === l.length ? Wn(f, h) : null) || _$i.addKeys(f), (_$c || l) && (_$e = u, o = _$c, s = l, y.indexes.forEach(function(t) {
                                var n = _$e(t.name || "");
                                function r(e) {
                                    return null != e ? t.extractKey(e) : null;
                                }
                                function i(e) {
                                    t.multiEntry && x(e) ? e.forEach(function(e) {
                                        return n.addKey(e);
                                    }) : n.addKey(e);
                                }
                                (o || s).forEach(function(e, _$t) {
                                    var n = o && r(o[_$t]), _$t = s && r(s[_$t]);
                                    0 !== j(n, _$t) && (null != n && i(n), null != _$t) && i(_$t);
                                });
                            }))) : f ? (l = {
                                from: null != (h = f.lower) ? h : b.MIN_KEY,
                                to: null != (_$c = f.upper) ? _$c : b.MAX_KEY
                            }, _$i.add(l), _$r.add(l)) : (_$r.add(_$w), _$i.add(_$w), y.indexes.forEach(function(e) {
                                return u(e.name).add(_$w);
                            })), _$p.mutate(a).then(function(o) {
                                return !f || "add" !== a.type && "put" !== a.type || (_$r.addKeys(o.results), m && m.forEach(function(t) {
                                    for(var _$e = a.values.map(function(e) {
                                        return t.extractKey(e);
                                    }), n = t.keyPath.findIndex(function(e) {
                                        return e === _$v.keyPath;
                                    }), _$r = 0, _$i = o.results.length; _$r < _$i; ++_$r)_$e[_$r][n] = o.results[_$r];
                                    u(t.name).addKeys(_$e);
                                })), t.mutatedParts = jn(t.mutatedParts || {}, n), o;
                            });
                        }
                    }), f = {
                        get: function get(e) {
                            return [
                                _$v,
                                new q(e.key)
                            ];
                        },
                        getMany: function getMany(e) {
                            return [
                                _$v,
                                (new q).addKeys(e.keys)
                            ];
                        },
                        count: e,
                        query: e,
                        openCursor: e
                    };
                    return O(f).forEach(function(s) {
                        n[s] = function(i) {
                            var _$e = P.subscr, t = !!_$e, n = $n(P, _$p) && Qn(s, i) ? i.obsSet = {} : _$e;
                            if (t) {
                                var o, _$e = function e(_e1) {
                                    _e1 = "idb://".concat(_$g, "/").concat(d, "/").concat(_e1);
                                    return n[_e1] || (n[_e1] = new q);
                                }, _$a = _$e(""), _$u = _$e(":dels"), t = f[s](i), _$r = t[0], t = t[1];
                                if (("query" === s && _$r.isPrimaryKey && !i.values ? _$u : _$e(_$r.name || "")).add(t), !_$r.isPrimaryKey) {
                                    if ("count" !== s) return o = "query" === s && l && i.values && _$p.query(_(_({}, i), {
                                        values: !1
                                    })), _$p[s].apply(this, arguments).then(function(t) {
                                        if ("query" === s) {
                                            if (l && i.values) return o.then(function(e) {
                                                e = e.result;
                                                return _$a.addKeys(e), t;
                                            });
                                            var _$e = i.values ? t.result.map(_$c) : t.result;
                                            (i.values ? _$a : _$u).addKeys(_$e);
                                        } else {
                                            var n, _$r;
                                            if ("openCursor" === s) return _$r = i.values, (n = t) && Object.create(n, {
                                                key: {
                                                    get: function get() {
                                                        return _$u.addKey(n.primaryKey), n.key;
                                                    }
                                                },
                                                primaryKey: {
                                                    get: function get() {
                                                        var _$e = n.primaryKey;
                                                        return _$u.addKey(_$e), _$e;
                                                    }
                                                },
                                                value: {
                                                    get: function get() {
                                                        return _$r && _$a.addKey(n.primaryKey), n.value;
                                                    }
                                                }
                                            });
                                        }
                                        return t;
                                    });
                                    _$u.add(_$w);
                                }
                            }
                            return _$p[s].apply(this, arguments);
                        };
                    }), n;
                }
            });
        }
    };
    function Xn(e, t, n) {
        var _$r;
        return 0 === n.numFailures ? t : "deleteRange" === t.type || (_$r = t.keys ? t.keys.length : "values" in t && t.values ? t.values.length : 1, n.numFailures === _$r) ? null : (_$r = _({}, t), x(_$r.keys) && (_$r.keys = _$r.keys.filter(function(e, t) {
            return !(t in n.failures);
        })), "values" in _$r && x(_$r.values) && (_$r.values = _$r.values.filter(function(e, t) {
            return !(t in n.failures);
        })), _$r);
    }
    function Hn(e, t) {
        var n, _$r;
        return n = e, (void 0 === (_$r = t).lower || (_$r.lowerOpen ? 0 < j(n, _$r.lower) : 0 <= j(n, _$r.lower))) && (n = e, void 0 === (_$r = t).upper || (_$r.upperOpen ? j(n, _$r.upper) < 0 : j(n, _$r.upper) <= 0));
    }
    function Jn(e, d, t, n, r, i) {
        var o, _$p, y, _$v, m, _$a, _$u;
        return !t || 0 === t.length || (o = d.query.index, _$p = o.multiEntry, y = d.query.range, _$v = n.schema.primaryKey.extractKey, m = o.extractKey, _$a = (o.lowLevelIndex || o).extractKey, (n = t.reduce(function(e, t) {
            var _$n = e, _$r = [];
            if ("add" === t.type || "put" === t.type) for(var _$i = new q, o = t.values.length - 1; 0 <= o; --o){
                var _$a, _$u = t.values[o], s = _$v(_$u);
                !_$i.hasKey(s) && (_$a = m(_$u), _$p && x(_$a) ? _$a.some(function(e) {
                    return Hn(e, y);
                }) : Hn(_$a, y)) && (_$i.addKey(s), _$r.push(_$u));
            }
            switch(t.type){
                case "add":
                    var _$c = (new q).addKeys(d.values ? e.map(function(e) {
                        return _$v(e);
                    }) : e), _$n = e.concat(d.values ? _$r.filter(function(e) {
                        e = _$v(e);
                        return !_$c.hasKey(e) && (_$c.addKey(e), !0);
                    }) : _$r.map(function(e) {
                        return _$v(e);
                    }).filter(function(e) {
                        return !_$c.hasKey(e) && (_$c.addKey(e), !0);
                    }));
                    break;
                case "put":
                    var l = (new q).addKeys(t.values.map(function(e) {
                        return _$v(e);
                    }));
                    _$n = e.filter(function(e) {
                        return !l.hasKey(d.values ? _$v(e) : e);
                    }).concat(d.values ? _$r : _$r.map(function(e) {
                        return _$v(e);
                    }));
                    break;
                case "delete":
                    var f = (new q).addKeys(t.keys);
                    _$n = e.filter(function(e) {
                        return !f.hasKey(d.values ? _$v(e) : e);
                    });
                    break;
                case "deleteRange":
                    var h = t.range;
                    _$n = e.filter(function(e) {
                        return !Hn(_$v(e), h);
                    });
            }
            return _$n;
        }, e)) === e) ? e : (_$u = function u(e, t) {
            return j(_$a(e), _$a(t)) || j(_$v(e), _$v(t));
        }, n.sort("prev" === d.direction || "prevunique" === d.direction ? function(e, t) {
            return _$u(t, e);
        } : _$u), d.limit && d.limit < 1 / 0 && (n.length > d.limit ? n.length = d.limit : e.length === d.limit && n.length < d.limit && (r.dirty = !0)), i ? Object.freeze(n) : n);
    }
    function Zn(e, t) {
        return 0 === j(e.lower, t.lower) && 0 === j(e.upper, t.upper) && !!e.lowerOpen == !!t.lowerOpen && !!e.upperOpen == !!t.upperOpen;
    }
    function er(e, t) {
        return function(e, t, n, r) {
            if (void 0 === e) return void 0 !== t ? -1 : 0;
            if (void 0 === t) return 1;
            if (0 === (e = j(e, t))) {
                if (n && r) return 0;
                if (n) return 1;
                if (r) return -1;
            }
            return e;
        }(e.lower, t.lower, e.lowerOpen, t.lowerOpen) <= 0 && 0 <= function(e, t, n, r) {
            if (void 0 === e) return void 0 !== t ? 1 : 0;
            if (void 0 === t) return -1;
            if (0 === (e = j(e, t))) {
                if (n && r) return 0;
                if (n) return -1;
                if (r) return 1;
            }
            return e;
        }(e.upper, t.upper, e.upperOpen, t.upperOpen);
    }
    function tr(n, r, i, e) {
        n.subscribers.add(i), e.addEventListener("abort", function() {
            var _$e, t;
            n.subscribers.delete(i), 0 === n.subscribers.size && (_$e = n, t = r, setTimeout(function() {
                0 === _$e.subscribers.size && oe(t, _$e);
            }, 3e3));
        });
    }
    var nr = {
        stack: "dbcore",
        level: 0,
        name: "Cache",
        create: function create(k) {
            var O = k.schema.name;
            return _(_({}, k), {
                transaction: function transaction(g, w, e) {
                    var _, t, x = k.transaction(g, w, e);
                    return "readwrite" === w && (e = (_ = new AbortController).signal, x.addEventListener("abort", (t = function t(b) {
                        return function() {
                            if (_.abort(), "readwrite" === w) {
                                for(var t = new Set, _$e = 0, n = g; _$e < n.length; _$e++){
                                    var _$r = n[_$e], _$i = Tn["idb://".concat(O, "/").concat(_$r)];
                                    if (_$i) {
                                        var o = k.table(_$r), _$a = _$i.optimisticOps.filter(function(e) {
                                            return e.trans === x;
                                        });
                                        if (x._explicit && b && x.mutatedParts) for(var _$u = 0, s = Object.values(_$i.queries.query); _$u < s.length; _$u++)for(var _$c = 0, l = (_$d = s[_$u]).slice(); _$c < l.length; _$c++)Cn((_$p = l[_$c]).obsSet, x.mutatedParts) && (oe(_$d, _$p), _$p.subscribers.forEach(function(e) {
                                            return t.add(e);
                                        }));
                                        else if (0 < _$a.length) {
                                            _$i.optimisticOps = _$i.optimisticOps.filter(function(e) {
                                                return e.trans !== x;
                                            });
                                            for(var f = 0, h = Object.values(_$i.queries.query); f < h.length; f++)for(var _$d, _$p, y, _$v = 0, m = (_$d = h[f]).slice(); _$v < m.length; _$v++)null != (_$p = m[_$v]).res && x.mutatedParts && (b && !_$p.dirty ? (y = Object.isFrozen(_$p.res), y = Jn(_$p.res, _$p.req, _$a, o, _$p, y), _$p.dirty ? (oe(_$d, _$p), _$p.subscribers.forEach(function(e) {
                                                return t.add(e);
                                            })) : y !== _$p.res && (_$p.res = y, _$p.promise = K.resolve({
                                                result: y
                                            }))) : (_$p.dirty && oe(_$d, _$p), _$p.subscribers.forEach(function(e) {
                                                return t.add(e);
                                            })));
                                        }
                                    }
                                }
                                t.forEach(function(e) {
                                    return e();
                                });
                            }
                        };
                    })(!1), {
                        signal: e
                    }), x.addEventListener("error", t(!1), {
                        signal: e
                    }), x.addEventListener("complete", t(!0), {
                        signal: e
                    })), x;
                },
                table: function table(s) {
                    var _$c = k.table(s), _$i = _$c.schema.primaryKey;
                    return _(_({}, _$c), {
                        mutate: function mutate(t) {
                            var n, e = P.trans;
                            return !_$i.outbound && "disabled" !== e.db._options.cache && !e.explicit && "readwrite" === e.idbtrans.mode && (n = Tn["idb://".concat(O, "/").concat(s)]) ? (e = _$c.mutate(t), "add" !== t.type && "put" !== t.type || !(50 <= t.values.length || zn(_$i, t).some(function(e) {
                                return null == e;
                            })) ? (n.optimisticOps.push(t), t.mutatedParts && Dn(t.mutatedParts), e.then(function(e) {
                                0 < e.numFailures && (oe(n.optimisticOps, t), (e = Xn(0, t, e)) && n.optimisticOps.push(e), t.mutatedParts) && Dn(t.mutatedParts);
                            }), e.catch(function() {
                                oe(n.optimisticOps, t), t.mutatedParts && Dn(t.mutatedParts);
                            })) : e.then(function(r) {
                                var e = Xn(0, _(_({}, t), {
                                    values: t.values.map(function(e, t) {
                                        var n;
                                        return r.failures[t] ? e : (b(n = null != (n = _$i.keyPath) && n.includes(".") ? ee(e) : _({}, e), _$i.keyPath, r.results[t]), n);
                                    })
                                }), r);
                                n.optimisticOps.push(e), queueMicrotask(function() {
                                    return t.mutatedParts && Dn(t.mutatedParts);
                                });
                            }), e) : _$c.mutate(t);
                        },
                        query: function query(t) {
                            var _$i, e, n, _$r, o, _$a, _$u;
                            return $n(P, _$c) && Qn("query", t) ? (_$i = "immutable" === (null == (n = P.trans) ? void 0 : n.db._options.cache), e = (n = P).requery, n = n.signal, _$a = function(e, t, n, r) {
                                var _$i = Tn["idb://".concat(e, "/").concat(t)];
                                if (!_$i) return [];
                                if (!(e = _$i.queries[n])) return [
                                    null,
                                    !1,
                                    _$i,
                                    null
                                ];
                                var o = e[(r.query ? r.query.index.name : null) || ""];
                                if (!o) return [
                                    null,
                                    !1,
                                    _$i,
                                    null
                                ];
                                switch(n){
                                    case "query":
                                        var _$a = null != (_$u = r.direction) ? _$u : "next", _$u = o.find(function(e) {
                                            var _$t;
                                            return e.req.limit === r.limit && e.req.values === r.values && (null != (_$t = e.req.direction) ? _$t : "next") === _$a && Zn(e.req.query.range, r.query.range);
                                        });
                                        return _$u ? [
                                            _$u,
                                            !0,
                                            _$i,
                                            o
                                        ] : [
                                            o.find(function(e) {
                                                var _$t;
                                                return ("limit" in e.req ? e.req.limit : 1 / 0) >= r.limit && (null != (_$t = e.req.direction) ? _$t : "next") === _$a && (!r.values || e.req.values) && er(e.req.query.range, r.query.range);
                                            }),
                                            !1,
                                            _$i,
                                            o
                                        ];
                                    case "count":
                                        _$u = o.find(function(e) {
                                            return Zn(e.req.query.range, r.query.range);
                                        });
                                        return [
                                            _$u,
                                            !!_$u,
                                            _$i,
                                            o
                                        ];
                                }
                            }(O, s, "query", t), _$u = _$a[0], _$r = _$a[2], o = _$a[3], _$u && _$a[1] ? _$u.obsSet = t.obsSet : (_$a = _$c.query(t).then(function(e) {
                                var _$t = e.result;
                                if (_$u && (_$u.res = _$t), _$i) {
                                    for(var n = 0, _$r = _$t.length; n < _$r; ++n)Object.freeze(_$t[n]);
                                    Object.freeze(_$t);
                                }
                                return e;
                            }).catch(function(e) {
                                return o && _$u && oe(o, _$u), Promise.reject(e);
                            }), _$u = {
                                obsSet: t.obsSet,
                                promise: _$a,
                                subscribers: new Set,
                                type: "query",
                                req: t,
                                dirty: !1
                            }, o ? o.push(_$u) : (o = [
                                _$u
                            ], (_$r = _$r || (Tn["idb://".concat(O, "/").concat(s)] = {
                                queries: {
                                    query: {},
                                    count: {}
                                },
                                objs: new Map,
                                optimisticOps: [],
                                unsignaledParts: {}
                            })).queries.query[t.query.index.name || ""] = o)), tr(_$u, o, e, n), _$u.promise.then(function(e) {
                                e = Jn(e.result, t, null == _$r ? void 0 : _$r.optimisticOps, _$c, _$u, _$i);
                                return {
                                    result: _$i ? e : ee(e)
                                };
                            })) : _$c.query(t);
                        }
                    });
                }
            });
        }
    };
    function rr(e, r) {
        return new Proxy(e, {
            get: function get(e, t, n) {
                return "db" === t ? r : Reflect.get(e, t, n);
            }
        });
    }
    D.prototype.version = function(t) {
        if (isNaN(t) || t < .1) throw new k.Type("Given version is not a positive number");
        if (t = Math.round(10 * t) / 10, this.idbdb || this._state.isBeingOpened) throw new k.Schema("Cannot add version when database is open");
        this.verno = Math.max(this.verno, t);
        var e = this._versions, n = e.filter(function(e) {
            return e._cfg.version === t;
        })[0];
        return n || (n = new this.Version(t), e.push(n), e.sort(un), n.stores({}), this._state.autoSchema = !1), n;
    }, D.prototype._whenReady = function(e) {
        var n = this;
        return this.idbdb && (this._state.openComplete || P.letThrough || this._vip) ? e() : new K(function(e, t) {
            if (n._state.openComplete) return t(new k.DatabaseClosed(n._state.dbOpenError));
            if (!n._state.isBeingOpened) {
                if (!n._state.autoOpen) return void t(new k.DatabaseClosed);
                n.open().catch(g);
            }
            n._state.dbReadyPromise.then(e, t);
        }).then(e);
    }, D.prototype.use = function(e) {
        var t = e.stack, n = e.create, _$r = e.level, e = e.name, _$i = (e && this.unuse({
            stack: t,
            name: e
        }), this._middlewares[t] || (this._middlewares[t] = []));
        return _$i.push({
            stack: t,
            create: n,
            level: null == _$r ? 10 : _$r,
            name: e
        }), _$i.sort(function(e, t) {
            return e.level - t.level;
        }), this;
    }, D.prototype.unuse = function(e) {
        var t = e.stack, n = e.name, _$r = e.create;
        return t && this._middlewares[t] && (this._middlewares[t] = this._middlewares[t].filter(function(e) {
            return _$r ? e.create !== _$r : !!n && e.name !== n;
        })), this;
    }, D.prototype.open = function() {
        var e = this;
        return at(s, function() {
            return Fn(e);
        });
    }, D.prototype._close = function() {
        this.on.close.fire(new CustomEvent("close"));
        var n = this._state;
        if (gn.remove(this), this.idbdb) {
            try {
                this.idbdb.close();
            } catch (e) {}
            this.idbdb = null;
        }
        n.isBeingOpened || (n.dbReadyPromise = new K(function(e) {
            n.dbReadyResolve = e;
        }), n.openCanceller = new K(function(e, t) {
            n.cancelOpen = t;
        }));
    }, D.prototype.close = function(e) {
        var e = (void 0 === e ? {
            disableAutoOpen: !0
        } : e).disableAutoOpen, t = this._state;
        e ? (t.isBeingOpened && t.cancelOpen(new k.DatabaseClosed), this._close(), t.autoOpen = !1, t.dbOpenError = new k.DatabaseClosed) : (this._close(), t.autoOpen = this._options.autoOpen || t.isBeingOpened, t.openComplete = !1, t.dbOpenError = null);
    }, D.prototype.delete = function(n) {
        var _$i = this, o = (void 0 === n && (n = {
            disableAutoOpen: !0
        }), 0 < arguments.length && "object" != (0, $2bfPH._)(arguments[0])), _$a = this._state;
        return new K(function(r, t) {
            function e() {
                _$i.close(n);
                var _$e = _$i._deps.indexedDB.deleteDatabase(_$i.name);
                _$e.onsuccess = E(function() {
                    var _$e, _$t, _$n;
                    _$e = _$i._deps, _$t = _$i.name, _n(_$n = _$e.indexedDB) || _$t === ft || wn(_$n, _$e.IDBKeyRange).delete(_$t).catch(g), r();
                }), _$e.onerror = I(t), _$e.onblocked = _$i._fireOnBlocked;
            }
            if (o) throw new k.InvalidArgument("Invalid closeOptions argument to db.delete()");
            _$a.isBeingOpened ? _$a.dbReadyPromise.then(e) : e();
        });
    }, D.prototype.backendDB = function() {
        return this.idbdb;
    }, D.prototype.isOpen = function() {
        return null !== this.idbdb;
    }, D.prototype.hasBeenClosed = function() {
        var e = this._state.dbOpenError;
        return e && "DatabaseClosed" === e.name;
    }, D.prototype.hasFailed = function() {
        return null !== this._state.dbOpenError;
    }, D.prototype.dynamicallyOpened = function() {
        return this._state.autoSchema;
    }, Object.defineProperty(D.prototype, "tables", {
        get: function get() {
            var t = this;
            return O(this._allTables).map(function(e) {
                return t._allTables[e];
            });
        },
        enumerable: !1,
        configurable: !0
    }), D.prototype.transaction = function() {
        var e = (function(e, t, n) {
            var _$r = arguments.length;
            if (_$r < 2) throw new k.InvalidArgument("Too few arguments");
            for(var _$i = new Array(_$r - 1); --_$r;)_$i[_$r - 1] = arguments[_$r];
            return n = _$i.pop(), [
                e,
                H(_$i),
                n
            ];
        }).apply(this, arguments);
        return this._transaction.apply(this, e);
    }, D.prototype._transaction = function(e, t, n) {
        var _$r, _$i, o = this, _$a = P.trans, _$u = (_$a && _$a.db === this && -1 === e.indexOf("!") || (_$a = null), -1 !== e.indexOf("?"));
        e = e.replace("!", "").replace("?", "");
        try {
            if (_$i = t.map(function(e) {
                e = e instanceof o.Table ? e.name : e;
                if ("string" != typeof e) throw new TypeError("Invalid table argument to Dexie.transaction(). Only Table or String are allowed");
                return e;
            }), "r" == e || e === ht) _$r = ht;
            else {
                if ("rw" != e && e != dt) throw new k.InvalidArgument("Invalid transaction mode: " + e);
                _$r = dt;
            }
            if (_$a) {
                if (_$a.mode === ht && _$r === dt) {
                    if (!_$u) throw new k.SubTransaction("Cannot enter a sub-transaction with READWRITE mode when parent transaction is READONLY");
                    _$a = null;
                }
                _$a && _$i.forEach(function(e) {
                    if (_$a && -1 === _$a.storeNames.indexOf(e)) {
                        if (!_$u) throw new k.SubTransaction("Table " + e + " not included in parent transaction.");
                        _$a = null;
                    }
                }), _$u && _$a && !_$a.active && (_$a = null);
            }
        } catch (n) {
            return _$a ? _$a._promise(null, function(e, t) {
                t(n);
            }) : S(n);
        }
        var s = (function i(o, a, u, s, c) {
            return K.resolve().then(function() {
                var _$e = P.transless || P, _$t = o._createTransaction(a, u, o._dbSchema, s), _$e = (_$t.explicit = !0, {
                    trans: _$t,
                    transless: _$e
                });
                if (s) _$t.idbtrans = s.idbtrans;
                else try {
                    _$t.create(), _$t.idbtrans._explicit = !0, o._state.PR1398_maxLoop = 3;
                } catch (e) {
                    return e.name === de.InvalidState && o.isOpen() && 0 < --o._state.PR1398_maxLoop ? (console.warn("Dexie: Need to reopen db"), o.close({
                        disableAutoOpen: !1
                    }), o.open().then(function() {
                        return i(o, a, u, null, c);
                    })) : S(e);
                }
                var _$n, _$r = ue(c), _$e = (_$r && nt(), K.follow(function() {
                    var _$e;
                    (_$n = c.call(_$t, _$t)) && (_$r ? (_$e = w.bind(null, null), _$n.then(_$e, _$e)) : "function" == typeof _$n.next && "function" == typeof _$n.throw && (_$n = Nn(_$n)));
                }, _$e));
                return (_$n && "function" == typeof _$n.then ? K.resolve(_$n).then(function(e) {
                    return _$t.active ? e : S(new k.PrematureCommit("Transaction committed too early. See http://bit.ly/2kdckMn"));
                }) : _$e.then(function() {
                    return _$n;
                })).then(function(e) {
                    return s && _$t._resolve(), _$t._completion.then(function() {
                        return e;
                    });
                }).catch(function(e) {
                    return _$t._reject(e), S(e);
                });
            });
        }).bind(null, this, _$r, _$i, _$a, n);
        return _$a ? _$a._promise(_$r, s, "lock") : P.trans ? at(P.transless, function() {
            return o._whenReady(s);
        }) : this._whenReady(s);
    }, D.prototype.table = function(e) {
        if (m(this._allTables, e)) return this._allTables[e];
        throw new k.InvalidTable("Table ".concat(e, " does not exist"));
    };
    var y = D;
    function D(e, t) {
        var o, _$r, _$a, n, _$i, _$u = this, s = (this._middlewares = {}, this.verno = 0, D.dependencies), s = (this._options = t = _({
            addons: D.addons,
            autoOpen: !0,
            indexedDB: s.indexedDB,
            IDBKeyRange: s.IDBKeyRange,
            cache: "cloned",
            maxConnections: 1e3
        }, t), this._deps = {
            indexedDB: t.indexedDB,
            IDBKeyRange: t.IDBKeyRange
        }, t.addons), _$c = (this._dbSchema = {}, this._versions = [], this._storeNames = [], this._allTables = {}, this.idbdb = null, this._novip = this, {
            dbOpenError: null,
            isBeingOpened: !1,
            onReadyBeingFired: null,
            openComplete: !1,
            dbReadyResolve: g,
            dbReadyPromise: null,
            cancelOpen: g,
            openCanceller: null,
            autoSchema: !0,
            PR1398_maxLoop: 3,
            autoOpen: t.autoOpen
        }), l = (_$c.dbReadyPromise = new K(function(e) {
            _$c.dbReadyResolve = e;
        }), _$c.openCanceller = new K(function(e, t) {
            _$c.cancelOpen = t;
        }), this._state = _$c, this.name = e, this.on = Pt(this, "populate", "blocked", "versionchange", "close", {
            ready: [
                ke,
                g
            ]
        }), this.once = function l(n, r) {
            var _$i = function i() {
                for(var _$e = [], _$t = 0; _$t < arguments.length; _$t++)_$e[_$t] = arguments[_$t];
                _$u.on(n).unsubscribe(_$i), r.apply(_$u, _$e);
            };
            return _$u.on(n, _$i);
        }, this.on.ready.subscribe = Y(this.on.ready.subscribe, function(i) {
            return function(n, r) {
                D.vip(function() {
                    var _$t, _$e = _$u._state;
                    _$e.openComplete ? (_$e.dbOpenError || K.resolve().then(n), r && i(n)) : _$e.onReadyBeingFired ? (_$e.onReadyBeingFired.push(n), r && i(n)) : (i(n), _$t = _$u, r || i(function e() {
                        _$t.on.ready.unsubscribe(n), _$t.on.ready.unsubscribe(e);
                    }));
                });
            };
        }), this.Collection = (o = this, Kt(qt.prototype, function(_$e, _$t) {
            this.db = o;
            var n = yt, _$r = null;
            if (_$t) try {
                n = _$t();
            } catch (e) {
                _$r = e;
            }
            var _$t = _$e._ctx, _$e = _$t.table, _$i = _$e.hook.reading.fire;
            this._ctx = {
                table: _$e,
                index: _$t.index,
                isPrimKey: !_$t.index || _$e.schema.primKey.keyPath && _$t.index === _$e.schema.primKey.name,
                range: n,
                keysOnly: !1,
                dir: "next",
                unique: "",
                algorithm: null,
                filter: null,
                replayFilter: null,
                justLimit: !0,
                isMatch: null,
                offset: 0,
                limit: 1 / 0,
                error: _$r,
                or: _$t.or,
                valueMapper: _$i !== ve ? _$i : null
            };
        })), this.Table = (_$r = this, Kt(Ot.prototype, function(e, t, n) {
            this.db = _$r, this._tx = n, this.name = e, this.schema = t, this.hook = _$r._allTables[e] ? _$r._allTables[e].hook : Pt(null, {
                creating: [
                    ge,
                    g
                ],
                reading: [
                    me,
                    ve
                ],
                updating: [
                    _e,
                    g
                ],
                deleting: [
                    we,
                    g
                ]
            });
        })), this.Transaction = (_$a = this, Kt(Yt.prototype, function(e, t, n, r, i) {
            var o = this;
            "readonly" !== e && t.forEach(function(e) {
                e = null == (e = n[e]) ? void 0 : e.yProps;
                e && (t = t.concat(e.map(function(e) {
                    return e.updatesTable;
                })));
            }), this.db = _$a, this.mode = e, this.storeNames = t, this.schema = n, this.chromeTransactionDurability = r, this.idbtrans = null, this.on = Pt(this, "complete", "error", "abort"), this.parent = i || null, this.active = !0, this._reculock = 0, this._blockedFuncs = [], this._resolve = null, this._reject = null, this._waitingFor = null, this._waitingQueue = null, this._spinCount = 0, this._completion = new K(function(e, t) {
                o._resolve = e, o._reject = t;
            }), this._completion.then(function() {
                o.active = !1, o.on.complete.fire();
            }, function(e) {
                var _$t = o.active;
                return o.active = !1, o.on.error.fire(e), o.parent ? o.parent._reject(e) : _$t && o.idbtrans && o.idbtrans.abort(), S(e);
            });
        })), this.Version = (n = this, Kt(mn.prototype, function(e) {
            this.db = n, this._cfg = {
                version: e,
                storesSource: null,
                dbschema: {},
                tables: {},
                contentUpgrade: null
            };
        })), this.WhereClause = (_$i = this, Kt(Lt.prototype, function(e, t, n) {
            if (this.db = _$i, this._ctx = {
                table: e,
                index: ":id" === t ? null : t,
                or: n
            }, this._cmp = this._ascending = j, this._descending = function(e, t) {
                return j(t, e);
            }, this._max = function(e, t) {
                return 0 < j(e, t) ? e : t;
            }, this._min = function(e, t) {
                return j(e, t) < 0 ? e : t;
            }, this._IDBKeyRange = _$i._deps.IDBKeyRange, !this._IDBKeyRange) throw new k.MissingAPI;
        })), this.on("versionchange", function(e) {
            0 < e.newVersion ? console.warn("Another connection wants to upgrade database '".concat(_$u.name, "'. Closing db now to resume the upgrade.")) : console.warn("Another connection wants to delete database '".concat(_$u.name, "'. Closing db now to resume the delete request.")), _$u.close({
                disableAutoOpen: !1
            });
        }), this.on("blocked", function(e) {
            !e.newVersion || e.newVersion < e.oldVersion ? console.warn("Dexie.delete('".concat(_$u.name, "') was blocked")) : console.warn("Upgrade '".concat(_$u.name, "' blocked by other connection holding version ").concat(e.oldVersion / 10));
        }), this._maxKey = Xt(t.IDBKeyRange), this._createTransaction = function(e, t, n, r) {
            return new _$u.Transaction(e, t, n, _$u._options.chromeTransactionDurability, r);
        }, this._fireOnBlocked = function(t) {
            _$u.on("blocked").fire(t), gn.toArray().filter(function(e) {
                return e.name === _$u.name && e !== _$u && !e._state.vcFired;
            }).map(function(e) {
                return e.on("versionchange").fire(t);
            });
        }, this.use(Yn), this.use(nr), this.use(Gn), this.use(Ln), this.use(Vn), new Proxy(this, {
            get: function get(e, t, n) {
                var _$r;
                return "_vip" === t || ("table" === t ? function(e) {
                    return rr(_$u.table(e), l);
                } : (_$r = Reflect.get(e, t, n)) instanceof Ot ? rr(_$r, l) : "tables" === t ? _$r.map(function(e) {
                    return rr(e, l);
                }) : "_createTransaction" === t ? function() {
                    return rr(_$r.apply(this, arguments), l);
                } : _$r);
            }
        }));
        this.vip = l, s.forEach(function(e) {
            return e(_$u);
        });
    }
    var ir, Se = "undefined" != typeof Symbol && "observable" in Symbol ? Symbol.observable : "@@observable", or = (ar.prototype.subscribe = function or(e, t, n) {
        return this._subscribe(e && "function" != typeof e ? e : {
            next: e,
            error: t,
            complete: n
        });
    }, ar.prototype[Se] = function() {
        return this;
    }, ar);
    function ar(e) {
        this._subscribe = e;
    }
    try {
        ir = {
            indexedDB: f.indexedDB || f.mozIndexedDB || f.webkitIndexedDB || f.msIndexedDB,
            IDBKeyRange: f.IDBKeyRange || f.webkitIDBKeyRange
        };
    } catch (e) {
        ir = {
            indexedDB: null,
            IDBKeyRange: null
        };
    }
    function ur(d) {
        var _$p, y = !1, e = new or(function(r) {
            var _$i = ue(d);
            var o, _$a = !1, _$u = {}, s = {}, e = {
                get closed () {
                    return _$a;
                },
                unsubscribe: function unsubscribe() {
                    _$a || (_$a = !0, o && o.abort(), _$c && Wt.storagemutated.unsubscribe(h));
                }
            }, _$c = (r.start && r.start(e), !1), l = function l() {
                return st(t);
            };
            function f() {
                return Cn(s, _$u);
            }
            var h = function h(e) {
                jn(_$u, e), f() && l();
            }, t = function t() {
                var t, n, e;
                !_$a && ir.indexedDB && (_$u = {}, t = {}, o && o.abort(), o = new AbortController, e = function(e) {
                    var t = $e();
                    try {
                        _$i && nt();
                        var n = v(d, e);
                        return n = _$i ? n.finally(w) : n;
                    } finally{
                        t && Qe();
                    }
                }(n = {
                    subscr: t,
                    signal: o.signal,
                    requery: l,
                    querier: d,
                    trans: null
                }), _$c || (Wt.storagemutated.subscribe(h), _$c = !0), Promise.resolve(e).then(function(e) {
                    y = !0, _$p = e, _$a || n.signal.aborted || (f() || (s = t, f()) ? l() : (_$u = {}, st(function() {
                        return !_$a && r.next && r.next(e);
                    })));
                }, function(e) {
                    y = !1, [
                        "DatabaseClosedError",
                        "AbortError"
                    ].includes(null == e ? void 0 : e.name) || _$a || st(function() {
                        _$a || r.error && r.error(e);
                    });
                }));
            };
            return setTimeout(l, 0), e;
        });
        return e.hasValue = function() {
            return y;
        }, e.getValue = function() {
            return _$p;
        }, e;
    }
    var sr = y;
    function cr(e) {
        var t = fr;
        try {
            fr = !0, Wt.storagemutated.fire(e), Bn(e, !0);
        } finally{
            fr = t;
        }
    }
    M(sr, _(_({}, e), {
        delete: function _delete(e) {
            return new sr(e, {
                addons: []
            }).delete();
        },
        exists: function exists(e) {
            return new sr(e, {
                addons: []
            }).open().then(function(e) {
                return e.close(), !0;
            }).catch("NoSuchDatabaseError", function() {
                return !1;
            });
        },
        getDatabaseNames: function getDatabaseNames(e) {
            try {
                return t = sr.dependencies, n = t.indexedDB, t = t.IDBKeyRange, (_n(n) ? Promise.resolve(n.databases()).then(function(e) {
                    return e.map(function(e) {
                        return e.name;
                    }).filter(function(e) {
                        return e !== ft;
                    });
                }) : wn(n, t).toCollection().primaryKeys()).then(e);
            } catch (e) {
                return S(new k.MissingAPI);
            }
            var t, n;
        },
        defineClass: function defineClass() {
            return function(e) {
                a(this, e);
            };
        },
        ignoreTransaction: function ignoreTransaction(e) {
            return P.trans ? at(P.transless || s, e) : e();
        },
        vip: xn,
        async: function async(t) {
            return function() {
                try {
                    var _$e = Nn(t.apply(this, arguments));
                    return _$e && "function" == typeof _$e.then ? _$e : K.resolve(_$e);
                } catch (e) {
                    return S(e);
                }
            };
        },
        spawn: function spawn(e, t, n) {
            try {
                var _$r = Nn(e.apply(n, t || []));
                return _$r && "function" == typeof _$r.then ? _$r : K.resolve(_$r);
            } catch (e) {
                return S(e);
            }
        },
        currentTransaction: {
            get: function get() {
                return P.trans || null;
            }
        },
        waitFor: function waitFor(e, t) {
            e = K.resolve("function" == typeof e ? sr.ignoreTransaction(e) : e).timeout(t || 6e4);
            return P.trans ? P.trans.waitFor(e) : e;
        },
        Promise: K,
        debug: {
            get: function get() {
                return l;
            },
            set: function set(e) {
                Oe(e);
            }
        },
        derive: U,
        extend: a,
        props: M,
        override: Y,
        Events: Pt,
        on: Wt,
        liveQuery: ur,
        extendObservabilitySet: jn,
        getByKeyPath: c,
        setByKeyPath: b,
        delByKeyPath: function delByKeyPath(t, e) {
            "string" == typeof e ? b(t, e, void 0) : "length" in e && [].map.call(e, function(e) {
                b(t, e, void 0);
            });
        },
        shallowClone: G,
        deepClone: ee,
        getObjectDiff: Un,
        cmp: j,
        asap: Q,
        minKey: -1 / 0,
        addons: [],
        connections: {
            get: gn.toArray
        },
        errnames: de,
        dependencies: ir,
        cache: Tn,
        semVer: "4.4.5",
        version: "4.4.5".split(".").map(function(e) {
            return parseInt(e);
        }).reduce(function(e, t, n) {
            return e + t / Math.pow(10, 2 * n);
        })
    })), sr.maxKey = Xt(sr.dependencies.IDBKeyRange), "undefined" != typeof dispatchEvent && "undefined" != typeof addEventListener && (Wt(zt, function(e) {
        fr || (e = new CustomEvent(Vt, {
            detail: e
        }), fr = !0, dispatchEvent(e), fr = !1);
    }), addEventListener(Vt, function(e) {
        e = e.detail;
        fr || cr(e);
    }));
    var lr, fr = !1, hr = function hr() {};
    return "undefined" != typeof BroadcastChannel && ((hr = function hr() {
        (lr = new BroadcastChannel(Vt)).onmessage = function(e) {
            return e.data && cr(e.data);
        };
    })(), "function" == typeof lr.unref && lr.unref(), Wt(zt, function(e) {
        fr || lr.postMessage(e);
    })), "undefined" != typeof addEventListener && (addEventListener("pagehide", function(e) {
        if (!y.disableBfCache && e.persisted) {
            l && console.debug("Dexie: handling persisted pagehide"), null != lr && lr.close();
            for(var t = 0, n = gn.toArray(); t < n.length; t++)n[t].close({
                disableAutoOpen: !1
            });
        }
    }), addEventListener("pageshow", function(e) {
        !y.disableBfCache && e.persisted && (l && console.debug("Dexie: handling persisted pageshow"), hr(), cr({
            all: new q(-1 / 0, [
                []
            ])
        }));
    })), K.rejectionMapper = function(e, t) {
        return !e || e instanceof ce || e instanceof TypeError || e instanceof SyntaxError || !e.name || !ye[e.name] ? e : (t = new ye[e.name](t || e.message, e), "stack" in e && u(t, "stack", {
            get: function get() {
                return this.inner.stack;
            }
        }), t);
    }, Oe(l), _(y, Object.freeze({
        __proto__: null,
        DEFAULT_MAX_CONNECTIONS: 1e3,
        Dexie: y,
        Entity: mt,
        PropModification: _t,
        RangeSet: q,
        add: function add(e) {
            return new _t({
                add: e
            });
        },
        cmp: j,
        default: y,
        liveQuery: ur,
        mergeRanges: Pn,
        rangesOverlap: Kn,
        remove: function remove(e) {
            return new _t({
                remove: e
            });
        },
        replacePrefix: function replacePrefix(e, t) {
            return new _t({
                replacePrefix: [
                    e,
                    t
                ]
            });
        }
    }), {
        default: y
    }), y;
});


var $aa50f4dbe3c4b3e8$var$DexieSymbol = Symbol.for("Dexie");
var $aa50f4dbe3c4b3e8$export$4ece27d405df7279 = globalThis[$aa50f4dbe3c4b3e8$var$DexieSymbol] || (globalThis[$aa50f4dbe3c4b3e8$var$DexieSymbol] = (0, (/*@__PURE__*/$parcel$interopDefault($6200b20324ada281$exports))));
if ((0, (/*@__PURE__*/$parcel$interopDefault($6200b20324ada281$exports))).semVer !== $aa50f4dbe3c4b3e8$export$4ece27d405df7279.semVer) throw new Error("Two different versions of Dexie loaded in the same app: ".concat((0, (/*@__PURE__*/$parcel$interopDefault($6200b20324ada281$exports))).semVer, " and ").concat($aa50f4dbe3c4b3e8$export$4ece27d405df7279.semVer));
var $aa50f4dbe3c4b3e8$export$6a9705d8f6f38796 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.liveQuery, $aa50f4dbe3c4b3e8$export$4876cc3130d3f820 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.mergeRanges, $aa50f4dbe3c4b3e8$export$8f43b23b5d8de905 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.rangesOverlap, $aa50f4dbe3c4b3e8$export$34cb5241245008dd = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.RangeSet, $aa50f4dbe3c4b3e8$export$6154dcdb7d23e37b = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.cmp, $aa50f4dbe3c4b3e8$export$bc644a473284d944 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.Entity, $aa50f4dbe3c4b3e8$export$4118fdb20badc28d = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.PropModification, $aa50f4dbe3c4b3e8$export$22ef8700548ec20 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.replacePrefix, $aa50f4dbe3c4b3e8$export$e16d8520af44a096 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.add, $aa50f4dbe3c4b3e8$export$cd7f480d6b8286c3 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.remove, $aa50f4dbe3c4b3e8$export$562c52a428f04e31 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279.DexieYProvider;
var $aa50f4dbe3c4b3e8$export$2e2bcd8739ae039 = $aa50f4dbe3c4b3e8$export$4ece27d405df7279;




var $gd0sY = parcelRequire("gd0sY");


var $d88638f0c6e244c2$export$ccf5caea584f47fd = /*#__PURE__*/ function(Dexie) {
    "use strict";
    (0, $0951870dac564cbc$export$71511d61b312f219)(OfflineDb, Dexie);
    function OfflineDb() {
        (0, $gd0sY._)(this, OfflineDb);
        var _this;
        _this = (0, $638732d3362fdd56$export$71511d61b312f219)(this, OfflineDb, [
            'selfoss'
        ]);
        _this.version(1).stores({
            entries: '&id,*datetime,[datetime+id]',
            statusq: '++id,*entryId',
            stamps: '&name,datetime',
            stats: '&name',
            tags: '&name',
            sources: '&id'
        });
        return _this;
    }
    return OfflineDb;
}((0, $aa50f4dbe3c4b3e8$export$2e2bcd8739ae039));



function $e35c971d5a393bb6$var$statToNumber(stat) {
    return stat === undefined ? 0 : stat ? 1 : -1;
}
var $e35c971d5a393bb6$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function DbOffline() {
        (0, $gd0sY._)(this, DbOffline);
        /** @var Date the datetime of the newest garbage collected entry, i.e. deleted because not of interest. */ this.newestGCedEntry = null;
        this.offlineDays = 10;
        this.lastItemId = null;
        this.newerEntriesMissing = false;
        this.shouldLoadEntriesOnline = false;
        this.olderEntriesOnline = false;
    }
    (0, $7cSld._)(DbOffline, [
        {
            key: "_tr",
            value: function _tr(mode, tables, scope) {
                var _this = this;
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.transaction(mode, tables, scope).catch(function(error) {
                    var _selfoss_entriesPage;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.showError((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app._('error_offline_storage', {
                        '0': error.message
                    }));
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.broken = true;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.update(false);
                    (_selfoss_entriesPage = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).entriesPage) === null || _selfoss_entriesPage === void 0 ? void 0 : _selfoss_entriesPage.reload();
                    // If this is a QuotaExceededError, garbage collect more
                    // entries and hope it helps.
                    if (error.name === (0, $aa50f4dbe3c4b3e8$export$2e2bcd8739ae039).errnames.QuotaExceeded) _this.GCEntries(true);
                    return Promise.reject(error);
                });
            }
        },
        {
            key: "init",
            value: function init() {
                var _this = this;
                if (!(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.value || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage) return;
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.broken = false;
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage = new (0, $d88638f0c6e244c2$export$ccf5caea584f47fd)();
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.on('populate', function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.add({
                        name: 'unread',
                        value: 0
                    });
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.add({
                        name: 'starred',
                        value: 0
                    });
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.add({
                        name: 'total',
                        value: 0
                    });
                });
                // retrieve last update stats in offline db
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline._tr('r', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries,
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps
                ], function() {
                    _this._memLastItemId();
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps.get('lastItemsUpdate', function(stamp) {
                        if (stamp) {
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.lastUpdate = stamp.datetime;
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.firstSync = false;
                        } else _this.shouldLoadEntriesOnline = true;
                    });
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps.get('newestGCedEntry', function(stamp) {
                        if (stamp) _this.newestGCedEntry = stamp.datetime;
                        var limit = new Date(Date.now() - 259200000);
                        if (!stamp || _this.newestGCedEntry < limit) _this.newestGCedEntry = new Date(Date.now() - 86400000);
                    });
                }).then(function() {
                    var offlineDays = window.localStorage.getItem('offlineDays');
                    if (offlineDays !== null) _this.offlineDays = parseInt(offlineDays);
                    // The newest garbage collected entry is either what's already
                    // in the offline db or if more recent the entry older than
                    // offlineDays ago.
                    _this.newestGCedEntry = new Date(Math.max(+_this.newestGCedEntry, Date.now() - _this.offlineDays * 86400000));
                    window.addEventListener('online', function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.tryOnline();
                    });
                    window.addEventListener('offline', function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.setOffline().catch(function(error) {
                            if (error instanceof (0, $d78024f502d9a257$export$1871035840b7f83a)) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.showError((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app._('error_offline_storage_not_available', {
                                '0': '<a href="https://caniuse.com/#feat=indexeddb">',
                                '1': '</a>'
                            }));
                            else throw error;
                        });
                    });
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setOfflineState(false);
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.tryOnline().then(function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).reloadTags();
                    });
                    _this.reloadOnlineStats();
                    _this.refreshStats();
                }).catch(function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.broken = true;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.enableOffline.update(false);
                });
            }
        },
        {
            key: "_memLastItemId",
            value: function _memLastItemId() {
                var _this = this;
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.orderBy('id').reverse().first(function(entry) {
                    if (entry) _this.lastItemId = entry.id;
                    else _this.lastItemId = 0;
                });
            }
        },
        {
            key: "storeEntries",
            value: function storeEntries(entries) {
                var _this = this;
                return this._tr('rw', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries,
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps
                ], function() {
                    _this.GCEntries();
                    // store entries offline
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.bulkPut(entries).then(function() {
                        _this._memLastItemId();
                        _this.refreshStats();
                    });
                });
            }
        },
        {
            key: "GCEntries",
            value: function GCEntries() {
                var _this = this;
                var more = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                if (more) {
                    // We need to garbage collect more, as the browser storage limit
                    // seems to be exceeded: decrease the amount of days entries are
                    // kept offline.
                    var keptDays = Math.floor((Date.now() - +this.newestGCedEntry) / 86400000);
                    this.offlineDays = Math.max(Math.min(keptDays - 1, this.offlineDays - 1), 0);
                    window.localStorage.setItem('offlineDays', this.offlineDays.toString());
                }
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.transaction('rw', (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries, (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps, function() {
                    // cleanup and remember when
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps.get('lastCleanup', function(stamp) {
                        // Cleanup once a day or once after db reset
                        if (!stamp || more || stamp && Date.now() - +stamp.datetime > 86400000) {
                            // Cleanup items older than offlineDays days, not of
                            // interest.
                            var limit = new Date(Date.now() - _this.offlineDays * 86400000);
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.where('datetime').below(limit).filter(function(entry) {
                                return !entry.unread && !entry.starred;
                            }).each(function(entry) {
                                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.delete(entry.id);
                                if (_this.newestGCedEntry < entry.datetime) _this.newestGCedEntry = entry.datetime;
                            }).then(function() {
                                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps.bulkPut([
                                    {
                                        name: 'lastCleanup',
                                        datetime: new Date()
                                    },
                                    {
                                        name: 'newestGCedEntry',
                                        datetime: _this.newestGCedEntry
                                    }
                                ]);
                            });
                        }
                    });
                });
            }
        },
        {
            key: "storeStats",
            value: function storeStats(stats) {
                return this._tr('rw', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats
                ], function() {
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    try {
                        for(var _iterator = Object.entries(stats)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                            var _step_value = (0, $21h22._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.put({
                                name: name,
                                value: value
                            });
                        }
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                });
            }
        },
        {
            key: "storeLastUpdate",
            value: function storeLastUpdate(lastUpdate) {
                return this._tr('rw', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps
                ], function() {
                    if (lastUpdate) (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stamps.put({
                        name: 'lastItemsUpdate',
                        datetime: lastUpdate
                    });
                });
            }
        },
        {
            key: "getEntries",
            value: function getEntries(fetchParams) {
                var _this = this;
                var hasMore = false;
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline._tr('r', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries
                ], function() {
                    var howMany = 0;
                    var ascOrder = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.unreadOrder === 'asc' && fetchParams.type === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD;
                    var entries = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.orderBy('[datetime+id]');
                    if (!ascOrder) entries = entries.reverse();
                    var fromDatetime = fetchParams.fromDatetime;
                    var fromId = fetchParams.fromId;
                    var seek = fromDatetime && fromId;
                    var alwaysInDb = fetchParams.type === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED || fetchParams.type === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD;
                    return entries.filter(function(entry) {
                        var keepEntry = false;
                        if (fetchParams.extraIds.includes(entry.id)) return true;
                        if (fetchParams.type === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).STARRED) keepEntry = entry.starred;
                        else if (fetchParams.type === (0, $6ccbaa1864c958ec$export$c67e46de1ec7dfa6).UNREAD) keepEntry = entry.unread;
                        else keepEntry = true;
                        // seek pagination
                        if (seek) {
                            if (ascOrder) keepEntry && (keepEntry = entry.datetime > fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id > fromId);
                            else keepEntry && (keepEntry = entry.datetime < fromDatetime || entry.datetime.getTime() == fromDatetime.getTime() && entry.id < fromId);
                        }
                        return keepEntry;
                    }).until(function(entry) {
                        howMany += 1;
                        if (!ascOrder && !alwaysInDb && entry.datetime < _this.newestGCedEntry) {
                            // the offline db is missing older entries, the next
                            // seek will have to find them online.
                            _this.olderEntriesOnline = true;
                            hasMore = true;
                            return true; // stop iteration
                        }
                        // stop iteration if enough entries have been shown
                        // go one further to assess if has more
                        if (howMany >= (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).config.itemsPerPage + 1) {
                            hasMore = true;
                            return true;
                        }
                        return false;
                    });
                }).then(function(entriesCollection) {
                    return entriesCollection.toArray();
                }).then(function(entries) {
                    return {
                        entries: entries,
                        hasMore: hasMore
                    };
                });
            }
        },
        {
            key: "reloadOnlineStats",
            value: function reloadOnlineStats() {
                return this._tr('r', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats
                ], function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.toArray(function(stats) {
                        var newStats = {
                            unread: 0,
                            starred: 0,
                            total: 0
                        };
                        stats.forEach(function(stat) {
                            newStats[stat.name] = stat.value;
                        });
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).refreshStats(newStats.total, newStats.unread, newStats.starred);
                    });
                });
            }
        },
        {
            key: "refreshStats",
            value: function refreshStats() {
                return this._tr('r', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries
                ], function() {
                    var offlineCounts = {
                        newest: 0,
                        unread: 0,
                        starred: 0
                    };
                    // IDBKeyRange does not support boolean indexes, so we need to
                    // iterate over all the entries.
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.each(function(entry) {
                        offlineCounts.newest = offlineCounts.newest + 1;
                        if (entry.unread) offlineCounts.unread = offlineCounts.unread + 1;
                        if (entry.starred) offlineCounts.starred = offlineCounts.starred + 1;
                    }).then(function() {
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.refreshOfflineCounts(offlineCounts);
                    });
                });
            }
        },
        {
            key: "enqueueStatuses",
            value: function enqueueStatuses(statuses) {
                if (statuses) this.needsSync = true;
                var d = new Date();
                var newQueuedStatuses = statuses.map(function(newStatus) {
                    return {
                        entryId: newStatus.entryId,
                        name: newStatus.name,
                        value: newStatus.value,
                        datetime: d
                    };
                });
                return this._tr('rw', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.statusq
                ], function() {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.statusq.bulkAdd(newQueuedStatuses);
                });
            }
        },
        {
            key: "enqueueStatus",
            value: function enqueueStatus(entryId, statusName, statusValue) {
                return this.enqueueStatuses([
                    {
                        entryId: entryId,
                        name: statusName,
                        value: statusValue
                    }
                ]);
            }
        },
        {
            key: "sendNewStatuses",
            value: function sendNewStatuses() {
                var _this = this;
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.statusq.toArray().then(function(statuses) {
                    return statuses.map(function(s) {
                        var statusUpdate = (0, $khBmn._)({
                            id: s.entryId,
                            datetime: s.datetime
                        }, s.name, s.value);
                        return statusUpdate;
                    });
                }).then(function(statuses) {
                    var s = statuses.length > 0 ? statuses : undefined;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.sync(s, true).then(function() {
                        _this.needsSync = false;
                    });
                });
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline._syncBegin();
            }
        },
        {
            /**
     * Update `unread` and `starred` statuses of items in the offline database.
     *
     * @param dequee - also clear the local status updates queued to upload to server
     * @param updateStats - also update local statistics
     *
     * Note: Do not use `updateStats` with `itemStatuses` obtained from the server.
     * The server report cannot distinguish which of the status fields was changed
     * so both will be considered changed.
     */ key: "storeEntryStatuses",
            value: function storeEntryStatuses(itemStatuses) {
                var _this = this;
                var dequeue = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false, updateStats = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : true;
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline._tr('rw', [
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries,
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats,
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.statusq
                ], function() {
                    var statsDiff = {
                        unread: 0,
                        starred: 0
                    };
                    // update entries statuses
                    itemStatuses.forEach(function(itemStatus) {
                        var newStatus = (0, $lvTkn._)({}, 'unread' in itemStatus && {
                            unread: itemStatus.unread
                        }, 'starred' in itemStatus && {
                            starred: itemStatus.starred
                        });
                        if (updateStats) {
                            statsDiff.unread += $e35c971d5a393bb6$var$statToNumber(itemStatus.unread);
                            statsDiff.starred += $e35c971d5a393bb6$var$statToNumber(itemStatus.starred);
                        }
                        var id = itemStatus.id;
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.get(id).then(function() {
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.entries.update(id, newStatus);
                        }, function() {
                            // the key was not found, the status of an entry
                            // missing in db was updated, request sync.
                            _this.needsSync = true;
                        });
                        if (dequeue) // status update from server, remove from status queue
                        (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.statusq.where('entryId').equals(id).delete();
                    });
                    var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
                    if (updateStats) try {
                        var _loop = function() {
                            var _step_value = (0, $21h22._)(_step.value, 2), name = _step_value[0], value = _step_value[1];
                            (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.get(name, function(stat) {
                                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).db.storage.stats.put({
                                    name: name,
                                    value: stat.value + value
                                });
                            });
                        };
                        for(var _iterator = Object.entries(statsDiff)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true)_loop();
                    } catch (err) {
                        _didIteratorError = true;
                        _iteratorError = err;
                    } finally{
                        try {
                            if (!_iteratorNormalCompletion && _iterator.return != null) {
                                _iterator.return();
                            }
                        } finally{
                            if (_didIteratorError) {
                                throw _iteratorError;
                            }
                        }
                    }
                }).then(this.refreshStats);
            }
        },
        {
            key: "entriesMark",
            value: function entriesMark(itemIds, unread) {
                (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.statsDirty = true;
                var newStatuses = itemIds.map(function(itemId) {
                    return {
                        id: itemId,
                        unread: unread
                    };
                });
                return this.storeEntryStatuses(newStatuses);
            }
        },
        {
            key: "entryMark",
            value: function entryMark(itemId, unread) {
                return this.entriesMark([
                    itemId
                ], unread);
            }
        },
        {
            key: "entryStar",
            value: function entryStar(itemId, starred) {
                return this.storeEntryStatuses([
                    {
                        id: itemId,
                        starred: starred
                    }
                ]);
            }
        }
    ]);
    return DbOffline;
}();


/**
 * db functions: client data repository (and offline storage)
 *
 * db is a dispatcher class and holds the logic for deciding whether selfoss
 * is running online with access to the server or offline.
 *
 * dbOnline contains AJAX calls that provide access to the server db.
 *
 * dbOffline is the entry point for the offline database held in the client.
 */ 
var $gd0sY = parcelRequire("gd0sY");

var $7cSld = parcelRequire("7cSld");



var $9c7eb13abe4da9c3$export$2e2bcd8739ae039 = /*#__PURE__*/ function() {
    "use strict";
    function Db() {
        (0, $gd0sY._)(this, Db);
        /** When an error occurs we disable the offline mode and mark the database as broken so it can be retried. */ this.broken = false;
        this.storage = null;
        this.online = true;
        this.enableOffline = new (0, $3b90563ec4c37361$export$8fa6ce44b7b131e9)(window.localStorage.getItem('enableOffline') === 'true');
        this.userWaiting = true;
        /**
     * last db timestamp known client side
     */ this.lastUpdate = null;
        this.lastSync = null;
    }
    (0, $7cSld._)(Db, [
        {
            key: "setOnline",
            value: function setOnline() {
                if (!this.online) {
                    this.online = true;
                    this.sync();
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).reloadTags();
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setOfflineState(false);
                }
            }
        },
        {
            key: "tryOnline",
            value: function tryOnline() {
                return this.sync(true);
            }
        },
        {
            key: "setOffline",
            value: function setOffline() {
                if (this.storage && !this.broken) {
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline._syncDone(false);
                    this.online = false;
                    (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.setOfflineState(true);
                    return Promise.resolve();
                } else {
                    var err = new (0, $d78024f502d9a257$export$1871035840b7f83a)();
                    return Promise.reject(err);
                }
            }
        },
        {
            key: "clear",
            value: function clear() {
                if (this.storage) {
                    window.localStorage.removeItem('offlineDays');
                    var clearing = this.storage.delete();
                    this.storage = null;
                    this.lastUpdate = null;
                    return clearing;
                } else return Promise.resolve();
            }
        },
        {
            key: "isValidTag",
            value: function isValidTag(name) {
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.tags.length === 0 || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.tags.find(function(tag) {
                    return tag.tag === name;
                }) !== undefined;
            }
        },
        {
            key: "isValidSource",
            value: function isValidSource(id) {
                return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.sources.length === 0 || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).app.state.sources.find(function(source) {
                    return source.id === id;
                }) !== undefined;
            }
        },
        {
            key: "sync",
            value: function sync() {
                var force = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : false;
                var lastUpdateIsOld = this.lastUpdate === null || this.lastSync === null || Date.now() - this.lastSync > 300000;
                var shouldSync = force || (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.needsSync || lastUpdateIsOld;
                if ((0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isAllowedToRead() && (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).isOnline() && shouldSync) {
                    if (this.enableOffline.value) return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOffline.sendNewStatuses();
                    else return (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).dbOnline.sync();
                } else return Promise.resolve(); // ensure any chained function runs
            }
        }
    ]);
    return Db;
}();


var $0c106e5ea3ceaced$exports = {};
$0c106e5ea3ceaced$exports = $parcel$resolve("inoyv");


/**
 * base javascript application
 *
 * @package    public_js
 * @copyright  Copyright (c) Tobias Zeising (http://www.aditu.de)
 * @license    GPLv3 (https://www.gnu.org/licenses/gpl-3.0.html)
 */ var $8cc3f8c2e8c3b6e2$var$selfoss = /*#__PURE__*/ function() {
    "use strict";
    function selfoss() {
        (0, $gd0sY._)(this, selfoss);
    }
    (0, $7cSld._)(selfoss, null, [
        {
            key: "init",
            value: /**
     * initialize application
     */ function init() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var storedConfig, oldConfiguration, configurationToUse, configuration;
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                // Load off-line mode enabledness.
                                this.db.enableOffline.update(window.localStorage.getItem('enableOffline') === 'true');
                                // Ignore stored config when off-line mode is disabled, since it is likely stale.
                                storedConfig = this.db.enableOffline.value ? localStorage.getItem('configuration') : null;
                                oldConfiguration = null;
                                try {
                                    oldConfiguration = storedConfig !== null ? JSON.parse(storedConfig) : null;
                                } catch (e) {
                                // We will try to obtain a new configuration anyway.
                                }
                                // Fall back to the last cached config on failure.
                                configurationToUse = oldConfiguration;
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    ,
                                    7,
                                    11
                                ]);
                                return [
                                    4,
                                    (0, $4f5da2ef0a8f061c$export$1d2e6bc0307ffd89)()
                                ];
                            case 2:
                                configuration = _state.sent().configuration;
                                configurationToUse = configuration;
                                if (!('caches' in window && 'serviceWorker' in navigator)) return [
                                    3,
                                    6
                                ];
                                if (!(oldConfiguration === null || oldConfiguration.userCss !== configuration.userCss)) return [
                                    3,
                                    4
                                ];
                                return [
                                    4,
                                    caches.delete('userCss')
                                ];
                            case 3:
                                _state.sent();
                                _state.label = 4;
                            case 4:
                                if (!(oldConfiguration === null || oldConfiguration.userJs !== configuration.userJs)) return [
                                    3,
                                    6
                                ];
                                return [
                                    4,
                                    caches.delete('userJs')
                                ];
                            case 5:
                                _state.sent();
                                _state.label = 6;
                            case 6:
                                return [
                                    3,
                                    11
                                ];
                            case 7:
                                if (!configurationToUse) return [
                                    3,
                                    9
                                ];
                                return [
                                    4,
                                    this.initMain(configurationToUse)
                                ];
                            case 8:
                                _state.sent();
                                return [
                                    3,
                                    10
                                ];
                            case 9:
                                // TODO: Add a more proper error page
                                document.body.innerHTML = this.app._('error_configuration');
                                _state.label = 10;
                            case 10:
                                return [
                                    7
                                ];
                            case 11:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "initMain",
            value: function initMain(configuration) {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var feedLink, link, script;
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        this.config = configuration;
                        if (this.db.enableOffline.value) this.setupServiceWorker();
                        if (configuration.language !== null) document.documentElement.setAttribute('lang', configuration.language);
                        document.querySelector('meta[name="application-name"]').setAttribute('content', configuration.htmlTitle);
                        feedLink = document.createElement('link');
                        feedLink.setAttribute('rel', 'alternate');
                        feedLink.setAttribute('type', 'application/rss+xml');
                        feedLink.setAttribute('title', 'RSS Feed');
                        feedLink.setAttribute('href', 'feed');
                        document.head.appendChild(feedLink);
                        if (configuration.userCss !== null) {
                            link = document.createElement('link');
                            link.setAttribute('rel', 'stylesheet');
                            link.setAttribute('href', "user.css?v=".concat(configuration.userCss));
                            document.head.appendChild(link);
                        }
                        if (configuration.userJs !== null) {
                            script = document.createElement('script');
                            script.setAttribute('src', "user.js?v=".concat(configuration.userJs));
                            document.body.appendChild(script);
                        }
                        // init offline if supported
                        this.dbOffline.init();
                        if (configuration.authEnabled) this.loggedin.update(window.localStorage.getItem('onlineSession') == 'true');
                        this.attachApp(configuration);
                        return [
                            2
                        ];
                    });
                }).call(this);
            }
        },
        {
            key: "attachApp",
            value: /**
     * Create basic DOM structure of the page.
     */ function attachApp(configuration) {
                var _this = this;
                var _document_getElementById;
                (_document_getElementById = document.getElementById('js-loading-message')) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.remove();
                var mainUi = document.createElement('div');
                document.body.appendChild(mainUi);
                mainUi.classList.add('app-toplevel');
                // BrowserRouter expects no slash at the end.
                var basePath = new URL(document.baseURI).pathname.replace(/\/$/, '');
                var root = (0, $59e7dcc9c52865c1$exports.createRoot)(mainUi);
                root.render((0, $533545e730c06947$export$4e373c34abfa8c68)({
                    basePath: basePath,
                    appRef: function(app) {
                        _this.app = app;
                        return function() {
                            _this.app = null;
                        };
                    },
                    configuration: configuration
                }));
            }
        },
        {
            key: "setSession",
            value: function setSession() {
                window.localStorage.setItem('onlineSession', 'true');
                this.loggedin.update(true);
            }
        },
        {
            key: "clearSession",
            value: function clearSession() {
                window.localStorage.removeItem('onlineSession');
                this.loggedin.update(false);
            }
        },
        {
            key: "hasSession",
            value: function hasSession() {
                return this.loggedin.value;
            }
        },
        {
            key: "login",
            value: /**
     * Try to log in using given credentials
     */ function login1(props) {
                var _this = this;
                var configuration = props.configuration, username = props.username, password = props.password, enableOffline = props.enableOffline;
                this.db.enableOffline.update(enableOffline);
                window.localStorage.setItem('enableOffline', this.db.enableOffline.value.toString());
                if (!this.db.enableOffline.value) this.db.clear();
                var credentials = {
                    username: username,
                    password: password
                };
                return (0, $4f5da2ef0a8f061c$export$596d806903d1f59e)(credentials).then(function() {
                    _this.setSession();
                    // init offline if supported and not inited yet
                    _this.dbOffline.init();
                    if ((!_this.db.storage || _this.db.broken) && _this.db.enableOffline.value) {
                        // Initialize database in offline mode when it has not been initialized yet or it got broken.
                        _this.dbOffline.init();
                        // Store config for off-line use.
                        localStorage.setItem('configuration', JSON.stringify(configuration));
                        // Cache user files manually since service worker is not aware of them.
                        if ('caches' in window && 'serviceWorker' in navigator) {
                            caches.open('userCss').then(function(cache) {
                                return cache.add("user.css?v=".concat(configuration.userCss));
                            });
                            caches.open('userJs').then(function(cache) {
                                return cache.add("user.js?v=".concat(configuration.userJs));
                            });
                        }
                        _this.setupServiceWorker();
                    }
                });
            }
        },
        {
            key: "setupServiceWorker",
            value: function setupServiceWorker() {
                var _this = this;
                if (!('serviceWorker' in navigator) || this.serviceWorkerInitialized) return;
                this.serviceWorkerInitialized = true;
                navigator.serviceWorker.addEventListener('controllerchange', function() {
                    window.location.reload();
                });
                navigator.serviceWorker.register($0c106e5ea3ceaced$exports).then(function(reg) {
                    _this.listenWaitingSW(reg, function(reg) {
                        _this.app.notifyNewVersion(function() {
                            if (reg.waiting) reg.waiting.postMessage('skipWaiting');
                        });
                    });
                });
            }
        },
        {
            key: "logout",
            value: function logout1() {
                return (/*#__PURE__*/ 0, /*#__PURE__*/ $14c571840e589f0e$export$71511d61b312f219)(function() {
                    var error;
                    return (0, $daac50d2f5864f61$export$71511d61b312f219)(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                this.clearSession();
                                this.db.clear(); // will not work after a failure, since storage is nulled
                                window.localStorage.clear();
                                if ('serviceWorker' in navigator) {
                                    if ('caches' in window) caches.keys().then(function(keys) {
                                        return keys.forEach(function(key) {
                                            return caches.delete(key);
                                        });
                                    });
                                    navigator.serviceWorker.getRegistrations().then(function(registrations) {
                                        registrations.forEach(function(reg) {
                                            reg.unregister();
                                        });
                                    });
                                    this.serviceWorkerInitialized = false;
                                }
                                _state.label = 1;
                            case 1:
                                _state.trys.push([
                                    1,
                                    3,
                                    ,
                                    4
                                ]);
                                return [
                                    4,
                                    (0, $4f5da2ef0a8f061c$export$a0973bcfe11b05c9)()
                                ];
                            case 2:
                                _state.sent();
                                if (!this.config.publicMode) selfoss.navigate('/sign/in');
                                return [
                                    3,
                                    4
                                ];
                            case 3:
                                error = _state.sent();
                                this.app.showError(this.app._('error_logout') + ' ' + error.message);
                                return [
                                    3,
                                    4
                                ];
                            case 4:
                                return [
                                    2
                                ];
                        }
                    });
                }).call(this);
            }
        },
        {
            key: "isAllowedToRead",
            value: /**
     * Checks whether the current user is allowed to perform read operations.
     */ function isAllowedToRead() {
                return this.hasSession() || !this.config.authEnabled || this.config.publicMode;
            }
        },
        {
            key: "isAllowedToUpdate",
            value: /**
     * Checks whether the current user is allowed to perform update-tier operations.
     */ function isAllowedToUpdate() {
                return this.hasSession() || !this.config.authEnabled || this.config.allowPublicUpdate;
            }
        },
        {
            key: "isAllowedToWrite",
            value: /**
     * Checks whether the current user is allowed to perform write operations.
     */ function isAllowedToWrite() {
                return this.hasSession() || !this.config.authEnabled;
            }
        },
        {
            key: "isOnline",
            value: /**
     * Checks whether the current user is allowed to perform write operations.
     */ function isOnline() {
                return this.db.online;
            }
        },
        {
            key: "isMobile",
            value: /**
     * indicates whether a mobile device is host
     *
     * @return true if device resolution smaller equals 1024
     */ function isMobile() {
                // first check useragent
                if (/iPhone|iPod|iPad|Android|BlackBerry/.test(navigator.userAgent)) return true;
                // otherwise check resolution
                return this.isTablet() || this.isSmartphone();
            }
        },
        {
            key: "isTablet",
            value: /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ function isTablet() {
                if (document.body.clientWidth <= 1024) return true;
                return false;
            }
        },
        {
            key: "isSmartphone",
            value: /**
     * indicates whether a tablet is the device or not
     *
     * @return true if device resolution smaller equals 1024
     */ function isSmartphone() {
                if (document.body.clientWidth <= 640) return true;
                return false;
            }
        },
        {
            key: "refreshStats",
            value: /**
     * refresh stats.
     *
     * @param all new all stats
     * @param unread new unread stats
     * @param starred new starred stats
     */ function refreshStats(all, unread, starred) {
                this.app.setAllItemsCount(all);
                this.app.setStarredItemsCount(starred);
                this.refreshUnread(unread);
            }
        },
        {
            key: "refreshUnread",
            value: /**
     * refresh unread stats.
     *
     * @param unread new unread stats
     */ function refreshUnread(unread) {
                this.app.setUnreadItemsCount(unread);
            }
        },
        {
            key: "reloadTags",
            value: /**
     * refresh current tags.
     */ function reloadTags() {
                var _this = this;
                this.app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).LOADING);
                (0, $133470f46785be8b$export$c36f611d5eb39a7)().then(function(data) {
                    _this.app.setTags(data);
                    _this.app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).SUCCESS);
                }).catch(function(error) {
                    _this.app.setTagsState((0, $51c68a66a52c2555$export$62aa48085237e36f).FAILURE);
                    _this.app.showError(_this.app._('error_load_tags') + ' ' + error.message);
                });
            }
        },
        {
            key: "handleAjaxError",
            value: function handleAjaxError(error) {
                var tryOffline = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
                if (!(error instanceof (0, $d78024f502d9a257$export$65bd6083489bd8bb) || error instanceof (0, $d78024f502d9a257$export$66d311bf29d5c89c))) return Promise.reject(error);
                var httpCode = 'response' in error ? error.response.status : 0;
                if (tryOffline && httpCode != 403) return this.db.setOffline();
                else return Promise.reject(error);
            }
        },
        {
            key: "listenWaitingSW",
            value: function listenWaitingSW(reg, callback) {
                var awaitStateChange = function() {
                    reg.installing.addEventListener('statechange', function(event) {
                        // https://github.com/microsoft/TypeScript/issues/37842
                        var sw = event.currentTarget;
                        if (sw.state === 'installed') callback(reg);
                    });
                };
                if (!reg) return;
                else if (reg.waiting) return callback(reg);
                else if (reg.installing) {
                    awaitStateChange();
                    reg.addEventListener('updatefound', awaitStateChange);
                }
            }
        }
    ]);
    return selfoss;
}();
/**
     * The main App component.
     */ $8cc3f8c2e8c3b6e2$var$selfoss.app = null;
/**
     * React component for entries page.
     */ $8cc3f8c2e8c3b6e2$var$selfoss.entriesPage = null;
$8cc3f8c2e8c3b6e2$var$selfoss.serviceWorkerInitialized = false;
/**
     * Whether lightbox is open.
     */ $8cc3f8c2e8c3b6e2$var$selfoss.lightboxActive = new (0, $3b90563ec4c37361$export$8fa6ce44b7b131e9)(false);
$8cc3f8c2e8c3b6e2$var$selfoss.db = new (0, $9c7eb13abe4da9c3$export$2e2bcd8739ae039)();
$8cc3f8c2e8c3b6e2$var$selfoss.dbOnline = new (0, $ff223f7787ec6ae0$export$2e2bcd8739ae039)();
$8cc3f8c2e8c3b6e2$var$selfoss.dbOffline = new (0, $e35c971d5a393bb6$export$2e2bcd8739ae039)();
$8cc3f8c2e8c3b6e2$var$selfoss.navigate = undefined;
$8cc3f8c2e8c3b6e2$var$selfoss.loggedin = new (0, $3b90563ec4c37361$export$8fa6ce44b7b131e9)(false);
/**
     * Override these functions to customize selfoss behaviour.
     */ $8cc3f8c2e8c3b6e2$var$selfoss.extensionPoints = {
    /**
         * Called when an article is first expanded.
         * @param _contents HTML element containing the article contents
         */ // eslint-disable-next-line @typescript-eslint/no-unused-vars
    processItemContents: function(_contents) {}
};
// Include helpers for user scripts.
$8cc3f8c2e8c3b6e2$var$selfoss.ajax = $8b420386626a2c2e$exports;
var $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039 = $8cc3f8c2e8c3b6e2$var$selfoss;


(0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039).init();
// make selfoss available in console for debugging
window.selfoss = (0, $8cc3f8c2e8c3b6e2$export$2e2bcd8739ae039);

})();
//# sourceMappingURL=client.2a0139e1.js.map
